/* with love from shopstory */
Object.defineProperty(exports, '__esModule', { value: true });

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var react = {exports: {}};

var react_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$t = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty$t.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols$1) {
      symbols = getOwnPropertySymbols$1(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l$3 = objectAssign,
    n$4 = 60103,
    p$3 = 60106;

react_production_min.Fragment = 60107;
react_production_min.StrictMode = 60108;
react_production_min.Profiler = 60114;
var q$4 = 60109,
    r$5 = 60110,
    t$2 = 60112;
react_production_min.Suspense = 60113;
var u$2 = 60115,
    v$4 = 60116;

if ("function" === typeof Symbol && Symbol["for"]) {
  var w$4 = Symbol["for"];
  n$4 = w$4("react.element");
  p$3 = w$4("react.portal");
  react_production_min.Fragment = w$4("react.fragment");
  react_production_min.StrictMode = w$4("react.strict_mode");
  react_production_min.Profiler = w$4("react.profiler");
  q$4 = w$4("react.provider");
  r$5 = w$4("react.context");
  t$2 = w$4("react.forward_ref");
  react_production_min.Suspense = w$4("react.suspense");
  u$2 = w$4("react.memo");
  v$4 = w$4("react.lazy");
}

var x$4 = "function" === typeof Symbol && Symbol.iterator;

function y$4(a) {
  if (null === a || "object" !== typeof a) return null;
  a = x$4 && a[x$4] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}

function z$4(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
    b += "&args[]=" + encodeURIComponent(arguments[c]);
  }

  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}

var A$4 = {
  isMounted: function isMounted() {
    return !1;
  },
  enqueueForceUpdate: function enqueueForceUpdate() {},
  enqueueReplaceState: function enqueueReplaceState() {},
  enqueueSetState: function enqueueSetState() {}
},
    B$4 = {};

function C$1(a, b, c) {
  this.props = a;
  this.context = b;
  this.refs = B$4;
  this.updater = c || A$4;
}

C$1.prototype.isReactComponent = {};

C$1.prototype.setState = function (a, b) {
  if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(z$4(85));
  this.updater.enqueueSetState(this, a, b, "setState");
};

C$1.prototype.forceUpdate = function (a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};

function D$3() {}

D$3.prototype = C$1.prototype;

function E$4(a, b, c) {
  this.props = a;
  this.context = b;
  this.refs = B$4;
  this.updater = c || A$4;
}

var F$3 = E$4.prototype = new D$3();
F$3.constructor = E$4;
l$3(F$3, C$1.prototype);
F$3.isPureReactComponent = !0;
var G$4 = {
  current: null
},
    H$4 = Object.prototype.hasOwnProperty,
    I$4 = {
  key: !0,
  ref: !0,
  __self: !0,
  __source: !0
};

function J$1(a, b, c) {
  var e,
      d = {},
      k = null,
      h = null;
  if (null != b) for (e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b) {
    H$4.call(b, e) && !I$4.hasOwnProperty(e) && (d[e] = b[e]);
  }
  var g = arguments.length - 2;
  if (1 === g) d.children = c;else if (1 < g) {
    for (var f = Array(g), m = 0; m < g; m++) {
      f[m] = arguments[m + 2];
    }

    d.children = f;
  }
  if (a && a.defaultProps) for (e in g = a.defaultProps, g) {
    void 0 === d[e] && (d[e] = g[e]);
  }
  return {
    $$typeof: n$4,
    type: a,
    key: k,
    ref: h,
    props: d,
    _owner: G$4.current
  };
}

function K$1(a, b) {
  return {
    $$typeof: n$4,
    type: a.type,
    key: b,
    ref: a.ref,
    props: a.props,
    _owner: a._owner
  };
}

function L$2(a) {
  return "object" === typeof a && null !== a && a.$$typeof === n$4;
}

function escape$2(a) {
  var b = {
    "=": "=0",
    ":": "=2"
  };
  return "$" + a.replace(/[=:]/g, function (a) {
    return b[a];
  });
}

var M$3 = /\/+/g;

function N$3(a, b) {
  return "object" === typeof a && null !== a && null != a.key ? escape$2("" + a.key) : b.toString(36);
}

function O$3(a, b, c, e, d) {
  var k = typeof a;
  if ("undefined" === k || "boolean" === k) a = null;
  var h = !1;
  if (null === a) h = !0;else switch (k) {
    case "string":
    case "number":
      h = !0;
      break;

    case "object":
      switch (a.$$typeof) {
        case n$4:
        case p$3:
          h = !0;
      }

  }
  if (h) return h = a, d = d(h), a = "" === e ? "." + N$3(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace(M$3, "$&/") + "/"), O$3(d, b, c, "", function (a) {
    return a;
  })) : null != d && (L$2(d) && (d = K$1(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace(M$3, "$&/") + "/") + a)), b.push(d)), 1;
  h = 0;
  e = "" === e ? "." : e + ":";
  if (Array.isArray(a)) for (var g = 0; g < a.length; g++) {
    k = a[g];
    var f = e + N$3(k, g);
    h += O$3(k, b, c, f, d);
  } else if (f = y$4(a), "function" === typeof f) for (a = f.call(a), g = 0; !(k = a.next()).done;) {
    k = k.value, f = e + N$3(k, g++), h += O$3(k, b, c, f, d);
  } else if ("object" === k) throw b = "" + a, Error(z$4(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
  return h;
}

function P$3(a, b, c) {
  if (null == a) return a;
  var e = [],
      d = 0;
  O$3(a, e, "", "", function (a) {
    return b.call(c, a, d++);
  });
  return e;
}

function Q$2(a) {
  if (-1 === a._status) {
    var b = a._result;
    b = b();
    a._status = 0;
    a._result = b;
    b.then(function (b) {
      0 === a._status && (b = b["default"], a._status = 1, a._result = b);
    }, function (b) {
      0 === a._status && (a._status = 2, a._result = b);
    });
  }

  if (1 === a._status) return a._result;
  throw a._result;
}

var R$2 = {
  current: null
};

function S$3() {
  var a = R$2.current;
  if (null === a) throw Error(z$4(321));
  return a;
}

var T$2 = {
  ReactCurrentDispatcher: R$2,
  ReactCurrentBatchConfig: {
    transition: 0
  },
  ReactCurrentOwner: G$4,
  IsSomeRendererActing: {
    current: !1
  },
  assign: l$3
};
react_production_min.Children = {
  map: P$3,
  forEach: function forEach(a, b, c) {
    P$3(a, function () {
      b.apply(this, arguments);
    }, c);
  },
  count: function count(a) {
    var b = 0;
    P$3(a, function () {
      b++;
    });
    return b;
  },
  toArray: function toArray(a) {
    return P$3(a, function (a) {
      return a;
    }) || [];
  },
  only: function only(a) {
    if (!L$2(a)) throw Error(z$4(143));
    return a;
  }
};
react_production_min.Component = C$1;
react_production_min.PureComponent = E$4;
react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = T$2;

react_production_min.cloneElement = function (a, b, c) {
  if (null === a || void 0 === a) throw Error(z$4(267, a));
  var e = l$3({}, a.props),
      d = a.key,
      k = a.ref,
      h = a._owner;

  if (null != b) {
    void 0 !== b.ref && (k = b.ref, h = G$4.current);
    void 0 !== b.key && (d = "" + b.key);
    if (a.type && a.type.defaultProps) var g = a.type.defaultProps;

    for (f in b) {
      H$4.call(b, f) && !I$4.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
  }

  var f = arguments.length - 2;
  if (1 === f) e.children = c;else if (1 < f) {
    g = Array(f);

    for (var m = 0; m < f; m++) {
      g[m] = arguments[m + 2];
    }

    e.children = g;
  }
  return {
    $$typeof: n$4,
    type: a.type,
    key: d,
    ref: k,
    props: e,
    _owner: h
  };
};

react_production_min.createContext = function (a, b) {
  void 0 === b && (b = null);
  a = {
    $$typeof: r$5,
    _calculateChangedBits: b,
    _currentValue: a,
    _currentValue2: a,
    _threadCount: 0,
    Provider: null,
    Consumer: null
  };
  a.Provider = {
    $$typeof: q$4,
    _context: a
  };
  return a.Consumer = a;
};

react_production_min.createElement = J$1;

react_production_min.createFactory = function (a) {
  var b = J$1.bind(null, a);
  b.type = a;
  return b;
};

react_production_min.createRef = function () {
  return {
    current: null
  };
};

react_production_min.forwardRef = function (a) {
  return {
    $$typeof: t$2,
    render: a
  };
};

react_production_min.isValidElement = L$2;

react_production_min.lazy = function (a) {
  return {
    $$typeof: v$4,
    _payload: {
      _status: -1,
      _result: a
    },
    _init: Q$2
  };
};

react_production_min.memo = function (a, b) {
  return {
    $$typeof: u$2,
    type: a,
    compare: void 0 === b ? null : b
  };
};

react_production_min.useCallback = function (a, b) {
  return S$3().useCallback(a, b);
};

react_production_min.useContext = function (a, b) {
  return S$3().useContext(a, b);
};

react_production_min.useDebugValue = function () {};

react_production_min.useEffect = function (a, b) {
  return S$3().useEffect(a, b);
};

react_production_min.useImperativeHandle = function (a, b, c) {
  return S$3().useImperativeHandle(a, b, c);
};

react_production_min.useLayoutEffect = function (a, b) {
  return S$3().useLayoutEffect(a, b);
};

react_production_min.useMemo = function (a, b) {
  return S$3().useMemo(a, b);
};

react_production_min.useReducer = function (a, b, c) {
  return S$3().useReducer(a, b, c);
};

react_production_min.useRef = function (a) {
  return S$3().useRef(a);
};

react_production_min.useState = function (a) {
  return S$3().useState(a);
};

react_production_min.version = "17.0.2";

{
  react.exports = react_production_min;
}

var React = react.exports;

var reactDom = {exports: {}};

var reactDom_production_min = {};

var scheduler = {exports: {}};

var scheduler_production_min = {};

/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {

var _f, g, h, k;

if ("object" === typeof performance && "function" === typeof performance.now) {
  var l = performance;

  exports.unstable_now = function () {
    return l.now();
  };
} else {
  var p = Date,
      q = p.now();

  exports.unstable_now = function () {
    return p.now() - q;
  };
}

if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
  var t = null,
      u = null,
      w = function w() {
    if (null !== t) try {
      var a = exports.unstable_now();
      t(!0, a);
      t = null;
    } catch (b) {
      throw setTimeout(w, 0), b;
    }
  };

  _f = function f(a) {
    null !== t ? setTimeout(_f, 0, a) : (t = a, setTimeout(w, 0));
  };

  g = function g(a, b) {
    u = setTimeout(a, b);
  };

  h = function h() {
    clearTimeout(u);
  };

  exports.unstable_shouldYield = function () {
    return !1;
  };

  k = exports.unstable_forceFrameRate = function () {};
} else {
  var x = window.setTimeout,
      y = window.clearTimeout;

  if ("undefined" !== typeof console) {
    var z = window.cancelAnimationFrame;
    "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    "function" !== typeof z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
  }

  var A = !1,
      B = null,
      C = -1,
      D = 5,
      E = 0;

  exports.unstable_shouldYield = function () {
    return exports.unstable_now() >= E;
  };

  k = function k() {};

  exports.unstable_forceFrameRate = function (a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < a ? Math.floor(1E3 / a) : 5;
  };

  var F = new MessageChannel(),
      G = F.port2;

  F.port1.onmessage = function () {
    if (null !== B) {
      var a = exports.unstable_now();
      E = a + D;

      try {
        B(!0, a) ? G.postMessage(null) : (A = !1, B = null);
      } catch (b) {
        throw G.postMessage(null), b;
      }
    } else A = !1;
  };

  _f = function _f(a) {
    B = a;
    A || (A = !0, G.postMessage(null));
  };

  g = function g(a, b) {
    C = x(function () {
      a(exports.unstable_now());
    }, b);
  };

  h = function h() {
    y(C);
    C = -1;
  };
}

function H(a, b) {
  var c = a.length;
  a.push(b);

  a: for (;;) {
    var d = c - 1 >>> 1,
        e = a[d];
    if (void 0 !== e && 0 < I(e, b)) a[d] = b, a[c] = e, c = d;else break a;
  }
}

function J(a) {
  a = a[0];
  return void 0 === a ? null : a;
}

function K(a) {
  var b = a[0];

  if (void 0 !== b) {
    var c = a.pop();

    if (c !== b) {
      a[0] = c;

      a: for (var d = 0, e = a.length; d < e;) {
        var m = 2 * (d + 1) - 1,
            n = a[m],
            v = m + 1,
            r = a[v];
        if (void 0 !== n && 0 > I(n, c)) void 0 !== r && 0 > I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);else if (void 0 !== r && 0 > I(r, c)) a[d] = r, a[v] = c, d = v;else break a;
      }
    }

    return b;
  }

  return null;
}

function I(a, b) {
  var c = a.sortIndex - b.sortIndex;
  return 0 !== c ? c : a.id - b.id;
}

var L = [],
    M = [],
    N = 1,
    O = null,
    P = 3,
    Q = !1,
    R = !1,
    S = !1;

function T(a) {
  for (var b = J(M); null !== b;) {
    if (null === b.callback) K(M);else if (b.startTime <= a) K(M), b.sortIndex = b.expirationTime, H(L, b);else break;
    b = J(M);
  }
}

function U(a) {
  S = !1;
  T(a);
  if (!R) if (null !== J(L)) R = !0, _f(V);else {
    var b = J(M);
    null !== b && g(U, b.startTime - a);
  }
}

function V(a, b) {
  R = !1;
  S && (S = !1, h());
  Q = !0;
  var c = P;

  try {
    T(b);

    for (O = J(L); null !== O && (!(O.expirationTime > b) || a && !exports.unstable_shouldYield());) {
      var d = O.callback;

      if ("function" === typeof d) {
        O.callback = null;
        P = O.priorityLevel;
        var e = d(O.expirationTime <= b);
        b = exports.unstable_now();
        "function" === typeof e ? O.callback = e : O === J(L) && K(L);
        T(b);
      } else K(L);

      O = J(L);
    }

    if (null !== O) var m = !0;else {
      var n = J(M);
      null !== n && g(U, n.startTime - b);
      m = !1;
    }
    return m;
  } finally {
    O = null, P = c, Q = !1;
  }
}

var W = k;
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;

exports.unstable_cancelCallback = function (a) {
  a.callback = null;
};

exports.unstable_continueExecution = function () {
  R || Q || (R = !0, _f(V));
};

exports.unstable_getCurrentPriorityLevel = function () {
  return P;
};

exports.unstable_getFirstCallbackNode = function () {
  return J(L);
};

exports.unstable_next = function (a) {
  switch (P) {
    case 1:
    case 2:
    case 3:
      var b = 3;
      break;

    default:
      b = P;
  }

  var c = P;
  P = b;

  try {
    return a();
  } finally {
    P = c;
  }
};

exports.unstable_pauseExecution = function () {};

exports.unstable_requestPaint = W;

exports.unstable_runWithPriority = function (a, b) {
  switch (a) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      break;

    default:
      a = 3;
  }

  var c = P;
  P = a;

  try {
    return b();
  } finally {
    P = c;
  }
};

exports.unstable_scheduleCallback = function (a, b, c) {
  var d = exports.unstable_now();
  "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;

  switch (a) {
    case 1:
      var e = -1;
      break;

    case 2:
      e = 250;
      break;

    case 5:
      e = 1073741823;
      break;

    case 4:
      e = 1E4;
      break;

    default:
      e = 5E3;
  }

  e = c + e;
  a = {
    id: N++,
    callback: b,
    priorityLevel: a,
    startTime: c,
    expirationTime: e,
    sortIndex: -1
  };
  c > d ? (a.sortIndex = c, H(M, a), null === J(L) && a === J(M) && (S ? h() : S = !0, g(U, c - d))) : (a.sortIndex = e, H(L, a), R || Q || (R = !0, _f(V)));
  return a;
};

exports.unstable_wrapCallback = function (a) {
  var b = P;
  return function () {
    var c = P;
    P = b;

    try {
      return a.apply(this, arguments);
    } finally {
      P = c;
    }
  };
};
}(scheduler_production_min));

{
  scheduler.exports = scheduler_production_min;
}

/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var aa = react.exports,
    m$2 = objectAssign,
    r$4 = scheduler.exports;

function y$3(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
    b += "&args[]=" + encodeURIComponent(arguments[c]);
  }

  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}

if (!aa) throw Error(y$3(227));
var ba = new Set(),
    ca = {};

function da(a, b) {
  ea(a, b);
  ea(a + "Capture", b);
}

function ea(a, b) {
  ca[a] = b;

  for (a = 0; a < b.length; a++) {
    ba.add(b[a]);
  }
}

var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement),
    ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    ia = Object.prototype.hasOwnProperty,
    ja = {},
    ka = {};

function la(a) {
  if (ia.call(ka, a)) return !0;
  if (ia.call(ja, a)) return !1;
  if (ha.test(a)) return ka[a] = !0;
  ja[a] = !0;
  return !1;
}

function ma(a, b, c, d) {
  if (null !== c && 0 === c.type) return !1;

  switch (typeof b) {
    case "function":
    case "symbol":
      return !0;

    case "boolean":
      if (d) return !1;
      if (null !== c) return !c.acceptsBooleans;
      a = a.toLowerCase().slice(0, 5);
      return "data-" !== a && "aria-" !== a;

    default:
      return !1;
  }
}

function na(a, b, c, d) {
  if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
  if (d) return !1;
  if (null !== c) switch (c.type) {
    case 3:
      return !b;

    case 4:
      return !1 === b;

    case 5:
      return isNaN(b);

    case 6:
      return isNaN(b) || 1 > b;
  }
  return !1;
}

function B$3(a, b, c, d, e, f, g) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = d;
  this.attributeNamespace = e;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = f;
  this.removeEmptyString = g;
}

var D$2 = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  D$2[a] = new B$3(a, 0, !1, a, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];
  D$2[b] = new B$3(b, 1, !1, a[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  D$2[a] = new B$3(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  D$2[a] = new B$3(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  D$2[a] = new B$3(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function (a) {
  D$2[a] = new B$3(a, 3, !0, a, null, !1, !1);
});
["capture", "download"].forEach(function (a) {
  D$2[a] = new B$3(a, 4, !1, a, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function (a) {
  D$2[a] = new B$3(a, 6, !1, a, null, !1, !1);
});
["rowSpan", "start"].forEach(function (a) {
  D$2[a] = new B$3(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;

function pa(a) {
  return a[1].toUpperCase();
}

"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(oa, pa);
  D$2[b] = new B$3(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(oa, pa);
  D$2[b] = new B$3(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(oa, pa);
  D$2[b] = new B$3(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function (a) {
  D$2[a] = new B$3(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D$2.xlinkHref = new B$3("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function (a) {
  D$2[a] = new B$3(a, 1, !1, a.toLowerCase(), null, !0, !0);
});

function qa(a, b, c, d) {
  var e = D$2.hasOwnProperty(b) ? D$2[b] : null;
  var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
  f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}

var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    sa = 60103,
    ta = 60106,
    ua = 60107,
    wa = 60108,
    xa = 60114,
    ya = 60109,
    za = 60110,
    Aa = 60112,
    Ba = 60113,
    Ca = 60120,
    Da = 60115,
    Ea = 60116,
    Fa = 60121,
    Ga = 60128,
    Ha = 60129,
    Ia = 60130,
    Ja = 60131;

if ("function" === typeof Symbol && Symbol["for"]) {
  var E$3 = Symbol["for"];
  sa = E$3("react.element");
  ta = E$3("react.portal");
  ua = E$3("react.fragment");
  wa = E$3("react.strict_mode");
  xa = E$3("react.profiler");
  ya = E$3("react.provider");
  za = E$3("react.context");
  Aa = E$3("react.forward_ref");
  Ba = E$3("react.suspense");
  Ca = E$3("react.suspense_list");
  Da = E$3("react.memo");
  Ea = E$3("react.lazy");
  Fa = E$3("react.block");
  E$3("react.scope");
  Ga = E$3("react.opaque.id");
  Ha = E$3("react.debug_trace_mode");
  Ia = E$3("react.offscreen");
  Ja = E$3("react.legacy_hidden");
}

var Ka = "function" === typeof Symbol && Symbol.iterator;

function La(a) {
  if (null === a || "object" !== typeof a) return null;
  a = Ka && a[Ka] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}

var Ma;

function Na(a) {
  if (void 0 === Ma) try {
    throw Error();
  } catch (c) {
    var b = c.stack.trim().match(/\n( *(at )?)/);
    Ma = b && b[1] || "";
  }
  return "\n" + Ma + a;
}

var Oa = !1;

function Pa(a, b) {
  if (!a || Oa) return "";
  Oa = !0;
  var c = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;

  try {
    if (b) {
      if (b = function b() {
        throw Error();
      }, Object.defineProperty(b.prototype, "props", {
        set: function set() {
          throw Error();
        }
      }), "object" === typeof Reflect && Reflect.construct) {
        try {
          Reflect.construct(b, []);
        } catch (k) {
          var d = k;
        }

        Reflect.construct(a, [], b);
      } else {
        try {
          b.call();
        } catch (k) {
          d = k;
        }

        a.call(b.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (k) {
        d = k;
      }

      a();
    }
  } catch (k) {
    if (k && d && "string" === typeof k.stack) {
      for (var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];) {
        h--;
      }

      for (; 1 <= g && 0 <= h; g--, h--) {
        if (e[g] !== f[h]) {
          if (1 !== g || 1 !== h) {
            do {
              if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
            } while (1 <= g && 0 <= h);
          }

          break;
        }
      }
    }
  } finally {
    Oa = !1, Error.prepareStackTrace = c;
  }

  return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}

function Qa(a) {
  switch (a.tag) {
    case 5:
      return Na(a.type);

    case 16:
      return Na("Lazy");

    case 13:
      return Na("Suspense");

    case 19:
      return Na("SuspenseList");

    case 0:
    case 2:
    case 15:
      return a = Pa(a.type, !1), a;

    case 11:
      return a = Pa(a.type.render, !1), a;

    case 22:
      return a = Pa(a.type._render, !1), a;

    case 1:
      return a = Pa(a.type, !0), a;

    default:
      return "";
  }
}

function Ra(a) {
  if (null == a) return null;
  if ("function" === typeof a) return a.displayName || a.name || null;
  if ("string" === typeof a) return a;

  switch (a) {
    case ua:
      return "Fragment";

    case ta:
      return "Portal";

    case xa:
      return "Profiler";

    case wa:
      return "StrictMode";

    case Ba:
      return "Suspense";

    case Ca:
      return "SuspenseList";
  }

  if ("object" === typeof a) switch (a.$$typeof) {
    case za:
      return (a.displayName || "Context") + ".Consumer";

    case ya:
      return (a._context.displayName || "Context") + ".Provider";

    case Aa:
      var b = a.render;
      b = b.displayName || b.name || "";
      return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");

    case Da:
      return Ra(a.type);

    case Fa:
      return Ra(a._render);

    case Ea:
      b = a._payload;
      a = a._init;

      try {
        return Ra(a(b));
      } catch (c) {}

  }
  return null;
}

function Sa(a) {
  switch (typeof a) {
    case "boolean":
    case "number":
    case "object":
    case "string":
    case "undefined":
      return a;

    default:
      return "";
  }
}

function Ta(a) {
  var b = a.type;
  return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}

function Ua(a) {
  var b = Ta(a) ? "checked" : "value",
      c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
      d = "" + a[b];

  if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
    var e = c.get,
        f = c.set;
    Object.defineProperty(a, b, {
      configurable: !0,
      get: function get() {
        return e.call(this);
      },
      set: function set(a) {
        d = "" + a;
        f.call(this, a);
      }
    });
    Object.defineProperty(a, b, {
      enumerable: c.enumerable
    });
    return {
      getValue: function getValue() {
        return d;
      },
      setValue: function setValue(a) {
        d = "" + a;
      },
      stopTracking: function stopTracking() {
        a._valueTracker = null;
        delete a[b];
      }
    };
  }
}

function Va(a) {
  a._valueTracker || (a._valueTracker = Ua(a));
}

function Wa(a) {
  if (!a) return !1;
  var b = a._valueTracker;
  if (!b) return !0;
  var c = b.getValue();
  var d = "";
  a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
  a = d;
  return a !== c ? (b.setValue(a), !0) : !1;
}

function Xa(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);
  if ("undefined" === typeof a) return null;

  try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}

function Ya(a, b) {
  var c = b.checked;
  return m$2({}, b, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: null != c ? c : a._wrapperState.initialChecked
  });
}

function Za(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue,
      d = null != b.checked ? b.checked : b.defaultChecked;
  c = Sa(null != b.value ? b.value : c);
  a._wrapperState = {
    initialChecked: d,
    initialValue: c,
    controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
  };
}

function $a(a, b) {
  b = b.checked;
  null != b && qa(a, "checked", b, !1);
}

function ab(a, b) {
  $a(a, b);
  var c = Sa(b.value),
      d = b.type;
  if (null != c) {
    if ("number" === d) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
  } else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");
    return;
  }
  b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
  null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}

function cb(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d = b.type;
    if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
    b = "" + a._wrapperState.initialValue;
    c || b === a.value || (a.value = b);
    a.defaultValue = b;
  }

  c = a.name;
  "" !== c && (a.name = "");
  a.defaultChecked = !!a._wrapperState.initialChecked;
  "" !== c && (a.name = c);
}

function bb(a, b, c) {
  if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}

function db(a) {
  var b = "";
  aa.Children.forEach(a, function (a) {
    null != a && (b += a);
  });
  return b;
}

function eb(a, b) {
  a = m$2({
    children: void 0
  }, b);
  if (b = db(b.children)) a.children = b;
  return a;
}

function fb(a, b, c, d) {
  a = a.options;

  if (b) {
    b = {};

    for (var e = 0; e < c.length; e++) {
      b["$" + c[e]] = !0;
    }

    for (c = 0; c < a.length; c++) {
      e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    }
  } else {
    c = "" + Sa(c);
    b = null;

    for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = !0;
        d && (a[e].defaultSelected = !0);
        return;
      }

      null !== b || a[e].disabled || (b = a[e]);
    }

    null !== b && (b.selected = !0);
  }
}

function gb(a, b) {
  if (null != b.dangerouslySetInnerHTML) throw Error(y$3(91));
  return m$2({}, b, {
    value: void 0,
    defaultValue: void 0,
    children: "" + a._wrapperState.initialValue
  });
}

function hb(a, b) {
  var c = b.value;

  if (null == c) {
    c = b.children;
    b = b.defaultValue;

    if (null != c) {
      if (null != b) throw Error(y$3(92));

      if (Array.isArray(c)) {
        if (!(1 >= c.length)) throw Error(y$3(93));
        c = c[0];
      }

      b = c;
    }

    null == b && (b = "");
    c = b;
  }

  a._wrapperState = {
    initialValue: Sa(c)
  };
}

function ib(a, b) {
  var c = Sa(b.value),
      d = Sa(b.defaultValue);
  null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
  null != d && (a.defaultValue = "" + d);
}

function jb(a) {
  var b = a.textContent;
  b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}

var kb = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg"
};

function lb(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";

    case "math":
      return "http://www.w3.org/1998/Math/MathML";

    default:
      return "http://www.w3.org/1999/xhtml";
  }
}

function mb(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}

var nb,
    ob = function (a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function () {
      return a(b, c, d, e);
    });
  } : a;
}(function (a, b) {
  if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;else {
    nb = nb || document.createElement("div");
    nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";

    for (b = nb.firstChild; a.firstChild;) {
      a.removeChild(a.firstChild);
    }

    for (; b.firstChild;) {
      a.appendChild(b.firstChild);
    }
  }
});

function pb(a, b) {
  if (b) {
    var c = a.firstChild;

    if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;
      return;
    }
  }

  a.textContent = b;
}

var qb = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
},
    rb = ["Webkit", "ms", "Moz", "O"];
Object.keys(qb).forEach(function (a) {
  rb.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    qb[b] = qb[a];
  });
});

function sb(a, b, c) {
  return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}

function tb(a, b) {
  a = a.style;

  for (var c in b) {
    if (b.hasOwnProperty(c)) {
      var d = 0 === c.indexOf("--"),
          e = sb(c, b[c], d);
      "float" === c && (c = "cssFloat");
      d ? a.setProperty(c, e) : a[c] = e;
    }
  }
}

var ub = m$2({
  menuitem: !0
}, {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
});

function vb(a, b) {
  if (b) {
    if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y$3(137, a));

    if (null != b.dangerouslySetInnerHTML) {
      if (null != b.children) throw Error(y$3(60));
      if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y$3(61));
    }

    if (null != b.style && "object" !== typeof b.style) throw Error(y$3(62));
  }
}

function wb(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;

  switch (a) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;

    default:
      return !0;
  }
}

function xb(a) {
  a = a.target || a.srcElement || window;
  a.correspondingUseElement && (a = a.correspondingUseElement);
  return 3 === a.nodeType ? a.parentNode : a;
}

var yb = null,
    zb = null,
    Ab = null;

function Bb(a) {
  if (a = Cb(a)) {
    if ("function" !== typeof yb) throw Error(y$3(280));
    var b = a.stateNode;
    b && (b = Db(b), yb(a.stateNode, a.type, b));
  }
}

function Eb(a) {
  zb ? Ab ? Ab.push(a) : Ab = [a] : zb = a;
}

function Fb() {
  if (zb) {
    var a = zb,
        b = Ab;
    Ab = zb = null;
    Bb(a);
    if (b) for (a = 0; a < b.length; a++) {
      Bb(b[a]);
    }
  }
}

function Gb(a, b) {
  return a(b);
}

function Hb(a, b, c, d, e) {
  return a(b, c, d, e);
}

function Ib() {}

var Jb = Gb,
    Kb = !1,
    Lb = !1;

function Mb() {
  if (null !== zb || null !== Ab) Ib(), Fb();
}

function Nb(a, b, c) {
  if (Lb) return a(b, c);
  Lb = !0;

  try {
    return Jb(a, b, c);
  } finally {
    Lb = !1, Mb();
  }
}

function Ob(a, b) {
  var c = a.stateNode;
  if (null === c) return null;
  var d = Db(c);
  if (null === d) return null;
  c = d[b];

  a: switch (b) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
      a = !d;
      break a;

    default:
      a = !1;
  }

  if (a) return null;
  if (c && "function" !== typeof c) throw Error(y$3(231, b, typeof c));
  return c;
}

var Pb = !1;
if (fa) try {
  var Qb = {};
  Object.defineProperty(Qb, "passive", {
    get: function get() {
      Pb = !0;
    }
  });
  window.addEventListener("test", Qb, Qb);
  window.removeEventListener("test", Qb, Qb);
} catch (a) {
  Pb = !1;
}

function Rb(a, b, c, d, e, f, g, h, k) {
  var l = Array.prototype.slice.call(arguments, 3);

  try {
    b.apply(c, l);
  } catch (n) {
    this.onError(n);
  }
}

var Sb = !1,
    Tb = null,
    Ub = !1,
    Vb = null,
    Wb = {
  onError: function onError(a) {
    Sb = !0;
    Tb = a;
  }
};

function Xb(a, b, c, d, e, f, g, h, k) {
  Sb = !1;
  Tb = null;
  Rb.apply(Wb, arguments);
}

function Yb(a, b, c, d, e, f, g, h, k) {
  Xb.apply(this, arguments);

  if (Sb) {
    if (Sb) {
      var l = Tb;
      Sb = !1;
      Tb = null;
    } else throw Error(y$3(198));

    Ub || (Ub = !0, Vb = l);
  }
}

function Zb(a) {
  var b = a,
      c = a;
  if (a.alternate) for (; b["return"];) {
    b = b["return"];
  } else {
    a = b;

    do {
      b = a, 0 !== (b.flags & 1026) && (c = b["return"]), a = b["return"];
    } while (a);
  }
  return 3 === b.tag ? c : null;
}

function $b(a) {
  if (13 === a.tag) {
    var b = a.memoizedState;
    null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
    if (null !== b) return b.dehydrated;
  }

  return null;
}

function ac(a) {
  if (Zb(a) !== a) throw Error(y$3(188));
}

function bc(a) {
  var b = a.alternate;

  if (!b) {
    b = Zb(a);
    if (null === b) throw Error(y$3(188));
    return b !== a ? null : a;
  }

  for (var c = a, d = b;;) {
    var e = c["return"];
    if (null === e) break;
    var f = e.alternate;

    if (null === f) {
      d = e["return"];

      if (null !== d) {
        c = d;
        continue;
      }

      break;
    }

    if (e.child === f.child) {
      for (f = e.child; f;) {
        if (f === c) return ac(e), a;
        if (f === d) return ac(e), b;
        f = f.sibling;
      }

      throw Error(y$3(188));
    }

    if (c["return"] !== d["return"]) c = e, d = f;else {
      for (var g = !1, h = e.child; h;) {
        if (h === c) {
          g = !0;
          c = e;
          d = f;
          break;
        }

        if (h === d) {
          g = !0;
          d = e;
          c = f;
          break;
        }

        h = h.sibling;
      }

      if (!g) {
        for (h = f.child; h;) {
          if (h === c) {
            g = !0;
            c = f;
            d = e;
            break;
          }

          if (h === d) {
            g = !0;
            d = f;
            c = e;
            break;
          }

          h = h.sibling;
        }

        if (!g) throw Error(y$3(189));
      }
    }
    if (c.alternate !== d) throw Error(y$3(190));
  }

  if (3 !== c.tag) throw Error(y$3(188));
  return c.stateNode.current === c ? a : b;
}

function cc(a) {
  a = bc(a);
  if (!a) return null;

  for (var b = a;;) {
    if (5 === b.tag || 6 === b.tag) return b;
    if (b.child) b.child["return"] = b, b = b.child;else {
      if (b === a) break;

      for (; !b.sibling;) {
        if (!b["return"] || b["return"] === a) return null;
        b = b["return"];
      }

      b.sibling["return"] = b["return"];
      b = b.sibling;
    }
  }

  return null;
}

function dc(a, b) {
  for (var c = a.alternate; null !== b;) {
    if (b === a || b === c) return !0;
    b = b["return"];
  }

  return !1;
}

var ec,
    fc,
    gc,
    hc,
    ic = !1,
    jc = [],
    kc = null,
    lc = null,
    mc = null,
    nc = new Map(),
    oc = new Map(),
    pc = [],
    qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");

function rc(a, b, c, d, e) {
  return {
    blockedOn: a,
    domEventName: b,
    eventSystemFlags: c | 16,
    nativeEvent: e,
    targetContainers: [d]
  };
}

function sc(a, b) {
  switch (a) {
    case "focusin":
    case "focusout":
      kc = null;
      break;

    case "dragenter":
    case "dragleave":
      lc = null;
      break;

    case "mouseover":
    case "mouseout":
      mc = null;
      break;

    case "pointerover":
    case "pointerout":
      nc["delete"](b.pointerId);
      break;

    case "gotpointercapture":
    case "lostpointercapture":
      oc["delete"](b.pointerId);
  }
}

function tc(a, b, c, d, e, f) {
  if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
  a.eventSystemFlags |= d;
  b = a.targetContainers;
  null !== e && -1 === b.indexOf(e) && b.push(e);
  return a;
}

function uc(a, b, c, d, e) {
  switch (b) {
    case "focusin":
      return kc = tc(kc, a, b, c, d, e), !0;

    case "dragenter":
      return lc = tc(lc, a, b, c, d, e), !0;

    case "mouseover":
      return mc = tc(mc, a, b, c, d, e), !0;

    case "pointerover":
      var f = e.pointerId;
      nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
      return !0;

    case "gotpointercapture":
      return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
  }

  return !1;
}

function vc(a) {
  var b = wc(a.target);

  if (null !== b) {
    var c = Zb(b);
    if (null !== c) if (b = c.tag, 13 === b) {
      if (b = $b(c), null !== b) {
        a.blockedOn = b;
        hc(a.lanePriority, function () {
          r$4.unstable_runWithPriority(a.priority, function () {
            gc(c);
          });
        });
        return;
      }
    } else if (3 === b && c.stateNode.hydrate) {
      a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
      return;
    }
  }

  a.blockedOn = null;
}

function xc(a) {
  if (null !== a.blockedOn) return !1;

  for (var b = a.targetContainers; 0 < b.length;) {
    var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
    if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
    b.shift();
  }

  return !0;
}

function zc(a, b, c) {
  xc(a) && c["delete"](b);
}

function Ac() {
  for (ic = !1; 0 < jc.length;) {
    var a = jc[0];

    if (null !== a.blockedOn) {
      a = Cb(a.blockedOn);
      null !== a && ec(a);
      break;
    }

    for (var b = a.targetContainers; 0 < b.length;) {
      var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);

      if (null !== c) {
        a.blockedOn = c;
        break;
      }

      b.shift();
    }

    null === a.blockedOn && jc.shift();
  }

  null !== kc && xc(kc) && (kc = null);
  null !== lc && xc(lc) && (lc = null);
  null !== mc && xc(mc) && (mc = null);
  nc.forEach(zc);
  oc.forEach(zc);
}

function Bc(a, b) {
  a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, r$4.unstable_scheduleCallback(r$4.unstable_NormalPriority, Ac)));
}

function Cc(a) {
  function b(b) {
    return Bc(b, a);
  }

  if (0 < jc.length) {
    Bc(jc[0], a);

    for (var c = 1; c < jc.length; c++) {
      var d = jc[c];
      d.blockedOn === a && (d.blockedOn = null);
    }
  }

  null !== kc && Bc(kc, a);
  null !== lc && Bc(lc, a);
  null !== mc && Bc(mc, a);
  nc.forEach(b);
  oc.forEach(b);

  for (c = 0; c < pc.length; c++) {
    d = pc[c], d.blockedOn === a && (d.blockedOn = null);
  }

  for (; 0 < pc.length && (c = pc[0], null === c.blockedOn);) {
    vc(c), null === c.blockedOn && pc.shift();
  }
}

function Dc(a, b) {
  var c = {};
  c[a.toLowerCase()] = b.toLowerCase();
  c["Webkit" + a] = "webkit" + b;
  c["Moz" + a] = "moz" + b;
  return c;
}

var Ec = {
  animationend: Dc("Animation", "AnimationEnd"),
  animationiteration: Dc("Animation", "AnimationIteration"),
  animationstart: Dc("Animation", "AnimationStart"),
  transitionend: Dc("Transition", "TransitionEnd")
},
    Fc = {},
    Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);

function Hc(a) {
  if (Fc[a]) return Fc[a];
  if (!Ec[a]) return a;
  var b = Ec[a],
      c;

  for (c in b) {
    if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
  }

  return a;
}

var Ic = Hc("animationend"),
    Jc = Hc("animationiteration"),
    Kc = Hc("animationstart"),
    Lc = Hc("transitionend"),
    Mc = new Map(),
    Nc = new Map(),
    Oc = ["abort", "abort", Ic, "animationEnd", Jc, "animationIteration", Kc, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", Lc, "transitionEnd", "waiting", "waiting"];

function Pc(a, b) {
  for (var c = 0; c < a.length; c += 2) {
    var d = a[c],
        e = a[c + 1];
    e = "on" + (e[0].toUpperCase() + e.slice(1));
    Nc.set(d, b);
    Mc.set(d, e);
    da(e, [d]);
  }
}

var Qc = r$4.unstable_now;
Qc();
var F$2 = 8;

function Rc(a) {
  if (0 !== (1 & a)) return F$2 = 15, 1;
  if (0 !== (2 & a)) return F$2 = 14, 2;
  if (0 !== (4 & a)) return F$2 = 13, 4;
  var b = 24 & a;
  if (0 !== b) return F$2 = 12, b;
  if (0 !== (a & 32)) return F$2 = 11, 32;
  b = 192 & a;
  if (0 !== b) return F$2 = 10, b;
  if (0 !== (a & 256)) return F$2 = 9, 256;
  b = 3584 & a;
  if (0 !== b) return F$2 = 8, b;
  if (0 !== (a & 4096)) return F$2 = 7, 4096;
  b = 4186112 & a;
  if (0 !== b) return F$2 = 6, b;
  b = 62914560 & a;
  if (0 !== b) return F$2 = 5, b;
  if (a & 67108864) return F$2 = 4, 67108864;
  if (0 !== (a & 134217728)) return F$2 = 3, 134217728;
  b = 805306368 & a;
  if (0 !== b) return F$2 = 2, b;
  if (0 !== (1073741824 & a)) return F$2 = 1, 1073741824;
  F$2 = 8;
  return a;
}

function Sc(a) {
  switch (a) {
    case 99:
      return 15;

    case 98:
      return 10;

    case 97:
    case 96:
      return 8;

    case 95:
      return 2;

    default:
      return 0;
  }
}

function Tc(a) {
  switch (a) {
    case 15:
    case 14:
      return 99;

    case 13:
    case 12:
    case 11:
    case 10:
      return 98;

    case 9:
    case 8:
    case 7:
    case 6:
    case 4:
    case 5:
      return 97;

    case 3:
    case 2:
    case 1:
      return 95;

    case 0:
      return 90;

    default:
      throw Error(y$3(358, a));
  }
}

function Uc(a, b) {
  var c = a.pendingLanes;
  if (0 === c) return F$2 = 0;
  var d = 0,
      e = 0,
      f = a.expiredLanes,
      g = a.suspendedLanes,
      h = a.pingedLanes;
  if (0 !== f) d = f, e = F$2 = 15;else if (f = c & 134217727, 0 !== f) {
    var k = f & ~g;
    0 !== k ? (d = Rc(k), e = F$2) : (h &= f, 0 !== h && (d = Rc(h), e = F$2));
  } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F$2) : 0 !== h && (d = Rc(h), e = F$2);
  if (0 === d) return 0;
  d = 31 - Vc(d);
  d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;

  if (0 !== b && b !== d && 0 === (b & g)) {
    Rc(b);
    if (e <= F$2) return b;
    F$2 = e;
  }

  b = a.entangledLanes;
  if (0 !== b) for (a = a.entanglements, b &= d; 0 < b;) {
    c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
  }
  return d;
}

function Wc(a) {
  a = a.pendingLanes & -1073741825;
  return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}

function Xc(a, b) {
  switch (a) {
    case 15:
      return 1;

    case 14:
      return 2;

    case 12:
      return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;

    case 10:
      return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;

    case 8:
      return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;

    case 2:
      return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
  }

  throw Error(y$3(358, a));
}

function Yc(a) {
  return a & -a;
}

function Zc(a) {
  for (var b = [], c = 0; 31 > c; c++) {
    b.push(a);
  }

  return b;
}

function $c(a, b, c) {
  a.pendingLanes |= b;
  var d = b - 1;
  a.suspendedLanes &= d;
  a.pingedLanes &= d;
  a = a.eventTimes;
  b = 31 - Vc(b);
  a[b] = c;
}

var Vc = Math.clz32 ? Math.clz32 : ad,
    bd = Math.log,
    cd = Math.LN2;

function ad(a) {
  return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}

var dd = r$4.unstable_UserBlockingPriority,
    ed = r$4.unstable_runWithPriority,
    fd = !0;

function gd(a, b, c, d) {
  Kb || Ib();
  var e = hd,
      f = Kb;
  Kb = !0;

  try {
    Hb(e, a, b, c, d);
  } finally {
    (Kb = f) || Mb();
  }
}

function id(a, b, c, d) {
  ed(dd, hd.bind(null, a, b, c, d));
}

function hd(a, b, c, d) {
  if (fd) {
    var e;
    if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);else {
      var f = yc(a, b, c, d);
      if (null === f) e && sc(a, d);else {
        if (e) {
          if (-1 < qc.indexOf(a)) {
            a = rc(f, a, b, c, d);
            jc.push(a);
            return;
          }

          if (uc(f, a, b, c, d)) return;
          sc(a, d);
        }

        jd(a, b, d, null, c);
      }
    }
  }
}

function yc(a, b, c, d) {
  var e = xb(d);
  e = wc(e);

  if (null !== e) {
    var f = Zb(e);
    if (null === f) e = null;else {
      var g = f.tag;

      if (13 === g) {
        e = $b(f);
        if (null !== e) return e;
        e = null;
      } else if (3 === g) {
        if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
        e = null;
      } else f !== e && (e = null);
    }
  }

  jd(a, b, d, e, c);
  return null;
}

var kd = null,
    ld = null,
    md = null;

function nd() {
  if (md) return md;
  var a,
      b = ld,
      c = b.length,
      d,
      e = "value" in kd ? kd.value : kd.textContent,
      f = e.length;

  for (a = 0; a < c && b[a] === e[a]; a++) {
  }

  var g = c - a;

  for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {
  }

  return md = e.slice(a, 1 < d ? 1 - d : void 0);
}

function od(a) {
  var b = a.keyCode;
  "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
  10 === a && (a = 13);
  return 32 <= a || 13 === a ? a : 0;
}

function pd() {
  return !0;
}

function qd() {
  return !1;
}

function rd(a) {
  function b(b, d, e, f, g) {
    this._reactName = b;
    this._targetInst = e;
    this.type = d;
    this.nativeEvent = f;
    this.target = g;
    this.currentTarget = null;

    for (var c in a) {
      a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
    }

    this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
    this.isPropagationStopped = qd;
    return this;
  }

  m$2(b.prototype, {
    preventDefault: function preventDefault() {
      this.defaultPrevented = !0;
      var a = this.nativeEvent;
      a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
    },
    stopPropagation: function stopPropagation() {
      var a = this.nativeEvent;
      a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
    },
    persist: function persist() {},
    isPersistent: pd
  });
  return b;
}

var sd = {
  eventPhase: 0,
  bubbles: 0,
  cancelable: 0,
  timeStamp: function timeStamp(a) {
    return a.timeStamp || Date.now();
  },
  defaultPrevented: 0,
  isTrusted: 0
},
    td = rd(sd),
    ud = m$2({}, sd, {
  view: 0,
  detail: 0
}),
    vd = rd(ud),
    wd,
    xd,
    yd,
    Ad = m$2({}, ud, {
  screenX: 0,
  screenY: 0,
  clientX: 0,
  clientY: 0,
  pageX: 0,
  pageY: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  getModifierState: zd,
  button: 0,
  buttons: 0,
  relatedTarget: function relatedTarget(a) {
    return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
  },
  movementX: function movementX(a) {
    if ("movementX" in a) return a.movementX;
    a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
    return wd;
  },
  movementY: function movementY(a) {
    return "movementY" in a ? a.movementY : xd;
  }
}),
    Bd = rd(Ad),
    Cd = m$2({}, Ad, {
  dataTransfer: 0
}),
    Dd = rd(Cd),
    Ed = m$2({}, ud, {
  relatedTarget: 0
}),
    Fd = rd(Ed),
    Gd = m$2({}, sd, {
  animationName: 0,
  elapsedTime: 0,
  pseudoElement: 0
}),
    Hd = rd(Gd),
    Id = m$2({}, sd, {
  clipboardData: function clipboardData(a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  }
}),
    Jd = rd(Id),
    Kd = m$2({}, sd, {
  data: 0
}),
    Ld = rd(Kd),
    Md = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
},
    Nd = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
},
    Od = {
  Alt: "altKey",
  Control: "ctrlKey",
  Meta: "metaKey",
  Shift: "shiftKey"
};

function Pd(a) {
  var b = this.nativeEvent;
  return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}

function zd() {
  return Pd;
}

var Qd = m$2({}, ud, {
  key: function key(a) {
    if (a.key) {
      var b = Md[a.key] || a.key;
      if ("Unidentified" !== b) return b;
    }

    return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
  },
  code: 0,
  location: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  repeat: 0,
  locale: 0,
  getModifierState: zd,
  charCode: function charCode(a) {
    return "keypress" === a.type ? od(a) : 0;
  },
  keyCode: function keyCode(a) {
    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  },
  which: function which(a) {
    return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  }
}),
    Rd = rd(Qd),
    Sd = m$2({}, Ad, {
  pointerId: 0,
  width: 0,
  height: 0,
  pressure: 0,
  tangentialPressure: 0,
  tiltX: 0,
  tiltY: 0,
  twist: 0,
  pointerType: 0,
  isPrimary: 0
}),
    Td = rd(Sd),
    Ud = m$2({}, ud, {
  touches: 0,
  targetTouches: 0,
  changedTouches: 0,
  altKey: 0,
  metaKey: 0,
  ctrlKey: 0,
  shiftKey: 0,
  getModifierState: zd
}),
    Vd = rd(Ud),
    Wd = m$2({}, sd, {
  propertyName: 0,
  elapsedTime: 0,
  pseudoElement: 0
}),
    Xd = rd(Wd),
    Yd = m$2({}, Ad, {
  deltaX: function deltaX(a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  },
  deltaY: function deltaY(a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}),
    Zd = rd(Yd),
    $d = [9, 13, 27, 32],
    ae$1 = fa && "CompositionEvent" in window,
    be$1 = null;
fa && "documentMode" in document && (be$1 = document.documentMode);
var ce$1 = fa && "TextEvent" in window && !be$1,
    de$1 = fa && (!ae$1 || be$1 && 8 < be$1 && 11 >= be$1),
    ee$1 = String.fromCharCode(32),
    fe$1 = !1;

function ge$1(a, b) {
  switch (a) {
    case "keyup":
      return -1 !== $d.indexOf(b.keyCode);

    case "keydown":
      return 229 !== b.keyCode;

    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;

    default:
      return !1;
  }
}

function he$1(a) {
  a = a.detail;
  return "object" === typeof a && "data" in a ? a.data : null;
}

var ie$1 = !1;

function je$1(a, b) {
  switch (a) {
    case "compositionend":
      return he$1(b);

    case "keypress":
      if (32 !== b.which) return null;
      fe$1 = !0;
      return ee$1;

    case "textInput":
      return a = b.data, a === ee$1 && fe$1 ? null : a;

    default:
      return null;
  }
}

function ke$1(a, b) {
  if (ie$1) return "compositionend" === a || !ae$1 && ge$1(a, b) ? (a = nd(), md = ld = kd = null, ie$1 = !1, a) : null;

  switch (a) {
    case "paste":
      return null;

    case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b["char"] && 1 < b["char"].length) return b["char"];
        if (b.which) return String.fromCharCode(b.which);
      }

      return null;

    case "compositionend":
      return de$1 && "ko" !== b.locale ? null : b.data;

    default:
      return null;
  }
}

var le = {
  color: !0,
  date: !0,
  datetime: !0,
  "datetime-local": !0,
  email: !0,
  month: !0,
  number: !0,
  password: !0,
  range: !0,
  search: !0,
  tel: !0,
  text: !0,
  time: !0,
  url: !0,
  week: !0
};

function me$1(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}

function ne$1(a, b, c, d) {
  Eb(d);
  b = oe$1(b, "onChange");
  0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
    event: c,
    listeners: b
  }));
}

var pe$1 = null,
    qe$1 = null;

function re$1(a) {
  se$1(a, 0);
}

function te$1(a) {
  var b = ue$1(a);
  if (Wa(b)) return a;
}

function ve$1(a, b) {
  if ("change" === a) return b;
}

var we$1 = !1;

if (fa) {
  var xe$1;

  if (fa) {
    var ye$1 = ("oninput" in document);

    if (!ye$1) {
      var ze$1 = document.createElement("div");
      ze$1.setAttribute("oninput", "return;");
      ye$1 = "function" === typeof ze$1.oninput;
    }

    xe$1 = ye$1;
  } else xe$1 = !1;

  we$1 = xe$1 && (!document.documentMode || 9 < document.documentMode);
}

function Ae$1() {
  pe$1 && (pe$1.detachEvent("onpropertychange", Be$1), qe$1 = pe$1 = null);
}

function Be$1(a) {
  if ("value" === a.propertyName && te$1(qe$1)) {
    var b = [];
    ne$1(b, qe$1, a, xb(a));
    a = re$1;
    if (Kb) a(b);else {
      Kb = !0;

      try {
        Gb(a, b);
      } finally {
        Kb = !1, Mb();
      }
    }
  }
}

function Ce$1(a, b, c) {
  "focusin" === a ? (Ae$1(), pe$1 = b, qe$1 = c, pe$1.attachEvent("onpropertychange", Be$1)) : "focusout" === a && Ae$1();
}

function De$1(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te$1(qe$1);
}

function Ee$1(a, b) {
  if ("click" === a) return te$1(b);
}

function Fe(a, b) {
  if ("input" === a || "change" === a) return te$1(b);
}

function Ge$1(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}

var He$1 = "function" === typeof Object.is ? Object.is : Ge$1,
    Ie = Object.prototype.hasOwnProperty;

function Je(a, b) {
  if (He$1(a, b)) return !0;
  if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
  var c = Object.keys(a),
      d = Object.keys(b);
  if (c.length !== d.length) return !1;

  for (d = 0; d < c.length; d++) {
    if (!Ie.call(b, c[d]) || !He$1(a[c[d]], b[c[d]])) return !1;
  }

  return !0;
}

function Ke(a) {
  for (; a && a.firstChild;) {
    a = a.firstChild;
  }

  return a;
}

function Le(a, b) {
  var c = Ke(a);
  a = 0;

  for (var d; c;) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;
      if (a <= b && d >= b) return {
        node: c,
        offset: b - a
      };
      a = d;
    }

    a: {
      for (; c;) {
        if (c.nextSibling) {
          c = c.nextSibling;
          break a;
        }

        c = c.parentNode;
      }

      c = void 0;
    }

    c = Ke(c);
  }
}

function Me$1(a, b) {
  return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me$1(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}

function Ne$1() {
  for (var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;) {
    try {
      var c = "string" === typeof b.contentWindow.location.href;
    } catch (d) {
      c = !1;
    }

    if (c) a = b.contentWindow;else break;
    b = Xa(a.document);
  }

  return b;
}

function Oe(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}

var Pe = fa && "documentMode" in document && 11 >= document.documentMode,
    Qe = null,
    Re$1 = null,
    Se$1 = null,
    Te$1 = !1;

function Ue$1(a, b, c) {
  var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
  Te$1 || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
    start: d.selectionStart,
    end: d.selectionEnd
  } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
    anchorNode: d.anchorNode,
    anchorOffset: d.anchorOffset,
    focusNode: d.focusNode,
    focusOffset: d.focusOffset
  }), Se$1 && Je(Se$1, d) || (Se$1 = d, d = oe$1(Re$1, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
    event: b,
    listeners: d
  }), b.target = Qe)));
}

Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);

for (var Ve$1 = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We$1 = 0; We$1 < Ve$1.length; We$1++) {
  Nc.set(Ve$1[We$1], 0);
}

ea("onMouseEnter", ["mouseout", "mouseover"]);
ea("onMouseLeave", ["mouseout", "mouseover"]);
ea("onPointerEnter", ["pointerout", "pointerover"]);
ea("onPointerLeave", ["pointerout", "pointerover"]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    Ye$1 = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));

function Ze(a, b, c) {
  var d = a.type || "unknown-event";
  a.currentTarget = c;
  Yb(d, b, void 0, a);
  a.currentTarget = null;
}

function se$1(a, b) {
  b = 0 !== (b & 4);

  for (var c = 0; c < a.length; c++) {
    var d = a[c],
        e = d.event;
    d = d.listeners;

    a: {
      var f = void 0;
      if (b) for (var g = d.length - 1; 0 <= g; g--) {
        var h = d[g],
            k = h.instance,
            l = h.currentTarget;
        h = h.listener;
        if (k !== f && e.isPropagationStopped()) break a;
        Ze(e, h, l);
        f = k;
      } else for (g = 0; g < d.length; g++) {
        h = d[g];
        k = h.instance;
        l = h.currentTarget;
        h = h.listener;
        if (k !== f && e.isPropagationStopped()) break a;
        Ze(e, h, l);
        f = k;
      }
    }
  }

  if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}

function G$3(a, b) {
  var c = $e$1(b),
      d = a + "__bubble";
  c.has(d) || (af(b, a, 2, !1), c.add(d));
}

var bf = "_reactListening" + Math.random().toString(36).slice(2);

function cf(a) {
  a[bf] || (a[bf] = !0, ba.forEach(function (b) {
    Ye$1.has(b) || df(b, !1, a, null);
    df(b, !0, a, null);
  }));
}

function df(a, b, c, d) {
  var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0,
      f = c;
  "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);

  if (null !== d && !b && Ye$1.has(a)) {
    if ("scroll" !== a) return;
    e |= 2;
    f = d;
  }

  var g = $e$1(f),
      h = a + "__" + (b ? "capture" : "bubble");
  g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}

function af(a, b, c, d) {
  var e = Nc.get(b);

  switch (void 0 === e ? 2 : e) {
    case 0:
      e = gd;
      break;

    case 1:
      e = id;
      break;

    default:
      e = hd;
  }

  c = e.bind(null, b, c, a);
  e = void 0;
  !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
  d ? void 0 !== e ? a.addEventListener(b, c, {
    capture: !0,
    passive: e
  }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
    passive: e
  }) : a.addEventListener(b, c, !1);
}

function jd(a, b, c, d, e) {
  var f = d;
  if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for (;;) {
    if (null === d) return;
    var g = d.tag;

    if (3 === g || 4 === g) {
      var h = d.stateNode.containerInfo;
      if (h === e || 8 === h.nodeType && h.parentNode === e) break;
      if (4 === g) for (g = d["return"]; null !== g;) {
        var k = g.tag;
        if (3 === k || 4 === k) if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
        g = g["return"];
      }

      for (; null !== h;) {
        g = wc(h);
        if (null === g) return;
        k = g.tag;

        if (5 === k || 6 === k) {
          d = f = g;
          continue a;
        }

        h = h.parentNode;
      }
    }

    d = d["return"];
  }
  Nb(function () {
    var d = f,
        e = xb(c),
        g = [];

    a: {
      var h = Mc.get(a);

      if (void 0 !== h) {
        var k = td,
            x = a;

        switch (a) {
          case "keypress":
            if (0 === od(c)) break a;

          case "keydown":
          case "keyup":
            k = Rd;
            break;

          case "focusin":
            x = "focus";
            k = Fd;
            break;

          case "focusout":
            x = "blur";
            k = Fd;
            break;

          case "beforeblur":
          case "afterblur":
            k = Fd;
            break;

          case "click":
            if (2 === c.button) break a;

          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            k = Bd;
            break;

          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            k = Dd;
            break;

          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            k = Vd;
            break;

          case Ic:
          case Jc:
          case Kc:
            k = Hd;
            break;

          case Lc:
            k = Xd;
            break;

          case "scroll":
            k = vd;
            break;

          case "wheel":
            k = Zd;
            break;

          case "copy":
          case "cut":
          case "paste":
            k = Jd;
            break;

          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            k = Td;
        }

        var w = 0 !== (b & 4),
            z = !w && "scroll" === a,
            u = w ? null !== h ? h + "Capture" : null : h;
        w = [];

        for (var t = d, q; null !== t;) {
          q = t;
          var v = q.stateNode;
          5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
          if (z) break;
          t = t["return"];
        }

        0 < w.length && (h = new k(h, x, null, c, e), g.push({
          event: h,
          listeners: w
        }));
      }
    }

    if (0 === (b & 7)) {
      a: {
        h = "mouseover" === a || "pointerover" === a;
        k = "mouseout" === a || "pointerout" === a;
        if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;

        if (k || h) {
          h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;

          if (k) {
            if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
          } else k = null, x = d;

          if (k !== x) {
            w = Bd;
            v = "onMouseLeave";
            u = "onMouseEnter";
            t = "mouse";
            if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
            z = null == k ? h : ue$1(k);
            q = null == x ? h : ue$1(x);
            h = new w(v, t + "leave", k, c, e);
            h.target = z;
            h.relatedTarget = q;
            v = null;
            wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
            z = v;
            if (k && x) b: {
              w = k;
              u = x;
              t = 0;

              for (q = w; q; q = gf(q)) {
                t++;
              }

              q = 0;

              for (v = u; v; v = gf(v)) {
                q++;
              }

              for (; 0 < t - q;) {
                w = gf(w), t--;
              }

              for (; 0 < q - t;) {
                u = gf(u), q--;
              }

              for (; t--;) {
                if (w === u || null !== u && w === u.alternate) break b;
                w = gf(w);
                u = gf(u);
              }

              w = null;
            } else w = null;
            null !== k && hf(g, h, k, w, !1);
            null !== x && null !== z && hf(g, z, x, w, !0);
          }
        }
      }

      a: {
        h = d ? ue$1(d) : window;
        k = h.nodeName && h.nodeName.toLowerCase();
        if ("select" === k || "input" === k && "file" === h.type) var J = ve$1;else if (me$1(h)) {
          if (we$1) J = Fe;else {
            J = De$1;
            var K = Ce$1;
          }
        } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee$1);

        if (J && (J = J(a, d))) {
          ne$1(g, J, c, e);
          break a;
        }

        K && K(a, h, d);
        "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
      }

      K = d ? ue$1(d) : window;

      switch (a) {
        case "focusin":
          if (me$1(K) || "true" === K.contentEditable) Qe = K, Re$1 = d, Se$1 = null;
          break;

        case "focusout":
          Se$1 = Re$1 = Qe = null;
          break;

        case "mousedown":
          Te$1 = !0;
          break;

        case "contextmenu":
        case "mouseup":
        case "dragend":
          Te$1 = !1;
          Ue$1(g, c, e);
          break;

        case "selectionchange":
          if (Pe) break;

        case "keydown":
        case "keyup":
          Ue$1(g, c, e);
      }

      var Q;
      if (ae$1) b: {
        switch (a) {
          case "compositionstart":
            var L = "onCompositionStart";
            break b;

          case "compositionend":
            L = "onCompositionEnd";
            break b;

          case "compositionupdate":
            L = "onCompositionUpdate";
            break b;
        }

        L = void 0;
      } else ie$1 ? ge$1(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
      L && (de$1 && "ko" !== c.locale && (ie$1 || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie$1 && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie$1 = !0)), K = oe$1(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
        event: L,
        listeners: K
      }), Q ? L.data = Q : (Q = he$1(c), null !== Q && (L.data = Q))));
      if (Q = ce$1 ? je$1(a, c) : ke$1(a, c)) d = oe$1(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
        event: e,
        listeners: d
      }), e.data = Q);
    }

    se$1(g, b);
  });
}

function ef(a, b, c) {
  return {
    instance: a,
    listener: b,
    currentTarget: c
  };
}

function oe$1(a, b) {
  for (var c = b + "Capture", d = []; null !== a;) {
    var e = a,
        f = e.stateNode;
    5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
    a = a["return"];
  }

  return d;
}

function gf(a) {
  if (null === a) return null;

  do {
    a = a["return"];
  } while (a && 5 !== a.tag);

  return a ? a : null;
}

function hf(a, b, c, d, e) {
  for (var f = b._reactName, g = []; null !== c && c !== d;) {
    var h = c,
        k = h.alternate,
        l = h.stateNode;
    if (null !== k && k === d) break;
    5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
    c = c["return"];
  }

  0 !== g.length && a.push({
    event: b,
    listeners: g
  });
}

function jf() {}

var kf = null,
    lf = null;

function mf(a, b) {
  switch (a) {
    case "button":
    case "input":
    case "select":
    case "textarea":
      return !!b.autoFocus;
  }

  return !1;
}

function nf(a, b) {
  return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}

var of = "function" === typeof setTimeout ? setTimeout : void 0,
    pf = "function" === typeof clearTimeout ? clearTimeout : void 0;

function qf(a) {
  1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}

function rf(a) {
  for (; null != a; a = a.nextSibling) {
    var b = a.nodeType;
    if (1 === b || 3 === b) break;
  }

  return a;
}

function sf(a) {
  a = a.previousSibling;

  for (var b = 0; a;) {
    if (8 === a.nodeType) {
      var c = a.data;

      if ("$" === c || "$!" === c || "$?" === c) {
        if (0 === b) return a;
        b--;
      } else "/$" === c && b++;
    }

    a = a.previousSibling;
  }

  return null;
}

var tf = 0;

function uf(a) {
  return {
    $$typeof: Ga,
    toString: a,
    valueOf: a
  };
}

var vf = Math.random().toString(36).slice(2),
    wf = "__reactFiber$" + vf,
    xf = "__reactProps$" + vf,
    ff = "__reactContainer$" + vf,
    yf = "__reactEvents$" + vf;

function wc(a) {
  var b = a[wf];
  if (b) return b;

  for (var c = a.parentNode; c;) {
    if (b = c[ff] || c[wf]) {
      c = b.alternate;
      if (null !== b.child || null !== c && null !== c.child) for (a = sf(a); null !== a;) {
        if (c = a[wf]) return c;
        a = sf(a);
      }
      return b;
    }

    a = c;
    c = a.parentNode;
  }

  return null;
}

function Cb(a) {
  a = a[wf] || a[ff];
  return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}

function ue$1(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;
  throw Error(y$3(33));
}

function Db(a) {
  return a[xf] || null;
}

function $e$1(a) {
  var b = a[yf];
  void 0 === b && (b = a[yf] = new Set());
  return b;
}

var zf = [],
    Af = -1;

function Bf(a) {
  return {
    current: a
  };
}

function H$3(a) {
  0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}

function I$3(a, b) {
  Af++;
  zf[Af] = a.current;
  a.current = b;
}

var Cf = {},
    M$2 = Bf(Cf),
    N$2 = Bf(!1),
    Df = Cf;

function Ef(a, b) {
  var c = a.type.contextTypes;
  if (!c) return Cf;
  var d = a.stateNode;
  if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
  var e = {},
      f;

  for (f in c) {
    e[f] = b[f];
  }

  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
  return e;
}

function Ff(a) {
  a = a.childContextTypes;
  return null !== a && void 0 !== a;
}

function Gf() {
  H$3(N$2);
  H$3(M$2);
}

function Hf(a, b, c) {
  if (M$2.current !== Cf) throw Error(y$3(168));
  I$3(M$2, b);
  I$3(N$2, c);
}

function If(a, b, c) {
  var d = a.stateNode;
  a = b.childContextTypes;
  if ("function" !== typeof d.getChildContext) return c;
  d = d.getChildContext();

  for (var e in d) {
    if (!(e in a)) throw Error(y$3(108, Ra(b) || "Unknown", e));
  }

  return m$2({}, c, d);
}

function Jf(a) {
  a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
  Df = M$2.current;
  I$3(M$2, a);
  I$3(N$2, N$2.current);
  return !0;
}

function Kf(a, b, c) {
  var d = a.stateNode;
  if (!d) throw Error(y$3(169));
  c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H$3(N$2), H$3(M$2), I$3(M$2, a)) : H$3(N$2);
  I$3(N$2, c);
}

var Lf = null,
    Mf = null,
    Nf = r$4.unstable_runWithPriority,
    Of = r$4.unstable_scheduleCallback,
    Pf = r$4.unstable_cancelCallback,
    Qf = r$4.unstable_shouldYield,
    Rf = r$4.unstable_requestPaint,
    Sf = r$4.unstable_now,
    Tf = r$4.unstable_getCurrentPriorityLevel,
    Uf = r$4.unstable_ImmediatePriority,
    Vf = r$4.unstable_UserBlockingPriority,
    Wf = r$4.unstable_NormalPriority,
    Xf = r$4.unstable_LowPriority,
    Yf = r$4.unstable_IdlePriority,
    Zf = {},
    $f = void 0 !== Rf ? Rf : function () {},
    ag = null,
    bg = null,
    cg = !1,
    dg = Sf(),
    O$2 = 1E4 > dg ? Sf : function () {
  return Sf() - dg;
};

function eg() {
  switch (Tf()) {
    case Uf:
      return 99;

    case Vf:
      return 98;

    case Wf:
      return 97;

    case Xf:
      return 96;

    case Yf:
      return 95;

    default:
      throw Error(y$3(332));
  }
}

function fg(a) {
  switch (a) {
    case 99:
      return Uf;

    case 98:
      return Vf;

    case 97:
      return Wf;

    case 96:
      return Xf;

    case 95:
      return Yf;

    default:
      throw Error(y$3(332));
  }
}

function gg(a, b) {
  a = fg(a);
  return Nf(a, b);
}

function hg(a, b, c) {
  a = fg(a);
  return Of(a, b, c);
}

function ig() {
  if (null !== bg) {
    var a = bg;
    bg = null;
    Pf(a);
  }

  jg();
}

function jg() {
  if (!cg && null !== ag) {
    cg = !0;
    var a = 0;

    try {
      var b = ag;
      gg(99, function () {
        for (; a < b.length; a++) {
          var c = b[a];

          do {
            c = c(!0);
          } while (null !== c);
        }
      });
      ag = null;
    } catch (c) {
      throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
    } finally {
      cg = !1;
    }
  }
}

var kg = ra.ReactCurrentBatchConfig;

function lg(a, b) {
  if (a && a.defaultProps) {
    b = m$2({}, b);
    a = a.defaultProps;

    for (var c in a) {
      void 0 === b[c] && (b[c] = a[c]);
    }

    return b;
  }

  return b;
}

var mg = Bf(null),
    ng = null,
    og = null,
    pg = null;

function qg() {
  pg = og = ng = null;
}

function rg(a) {
  var b = mg.current;
  H$3(mg);
  a.type._context._currentValue = b;
}

function sg(a, b) {
  for (; null !== a;) {
    var c = a.alternate;
    if ((a.childLanes & b) === b) {
      if (null === c || (c.childLanes & b) === b) break;else c.childLanes |= b;
    } else a.childLanes |= b, null !== c && (c.childLanes |= b);
    a = a["return"];
  }
}

function tg(a, b) {
  ng = a;
  pg = og = null;
  a = a.dependencies;
  null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}

function vg(a, b) {
  if (pg !== a && !1 !== b && 0 !== b) {
    if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
    b = {
      context: a,
      observedBits: b,
      next: null
    };

    if (null === og) {
      if (null === ng) throw Error(y$3(308));
      og = b;
      ng.dependencies = {
        lanes: 0,
        firstContext: b,
        responders: null
      };
    } else og = og.next = b;
  }

  return a._currentValue;
}

var wg = !1;

function xg(a) {
  a.updateQueue = {
    baseState: a.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: {
      pending: null
    },
    effects: null
  };
}

function yg(a, b) {
  a = a.updateQueue;
  b.updateQueue === a && (b.updateQueue = {
    baseState: a.baseState,
    firstBaseUpdate: a.firstBaseUpdate,
    lastBaseUpdate: a.lastBaseUpdate,
    shared: a.shared,
    effects: a.effects
  });
}

function zg(a, b) {
  return {
    eventTime: a,
    lane: b,
    tag: 0,
    payload: null,
    callback: null,
    next: null
  };
}

function Ag(a, b) {
  a = a.updateQueue;

  if (null !== a) {
    a = a.shared;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
  }
}

function Bg(a, b) {
  var c = a.updateQueue,
      d = a.alternate;

  if (null !== d && (d = d.updateQueue, c === d)) {
    var e = null,
        f = null;
    c = c.firstBaseUpdate;

    if (null !== c) {
      do {
        var g = {
          eventTime: c.eventTime,
          lane: c.lane,
          tag: c.tag,
          payload: c.payload,
          callback: c.callback,
          next: null
        };
        null === f ? e = f = g : f = f.next = g;
        c = c.next;
      } while (null !== c);

      null === f ? e = f = b : f = f.next = b;
    } else e = f = b;

    c = {
      baseState: d.baseState,
      firstBaseUpdate: e,
      lastBaseUpdate: f,
      shared: d.shared,
      effects: d.effects
    };
    a.updateQueue = c;
    return;
  }

  a = c.lastBaseUpdate;
  null === a ? c.firstBaseUpdate = b : a.next = b;
  c.lastBaseUpdate = b;
}

function Cg(a, b, c, d) {
  var e = a.updateQueue;
  wg = !1;
  var f = e.firstBaseUpdate,
      g = e.lastBaseUpdate,
      h = e.shared.pending;

  if (null !== h) {
    e.shared.pending = null;
    var k = h,
        l = k.next;
    k.next = null;
    null === g ? f = l : g.next = l;
    g = k;
    var n = a.alternate;

    if (null !== n) {
      n = n.updateQueue;
      var A = n.lastBaseUpdate;
      A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
    }
  }

  if (null !== f) {
    A = e.baseState;
    g = 0;
    n = l = k = null;

    do {
      h = f.lane;
      var p = f.eventTime;

      if ((d & h) === h) {
        null !== n && (n = n.next = {
          eventTime: p,
          lane: 0,
          tag: f.tag,
          payload: f.payload,
          callback: f.callback,
          next: null
        });

        a: {
          var C = a,
              x = f;
          h = b;
          p = c;

          switch (x.tag) {
            case 1:
              C = x.payload;

              if ("function" === typeof C) {
                A = C.call(p, A, h);
                break a;
              }

              A = C;
              break a;

            case 3:
              C.flags = C.flags & -4097 | 64;

            case 0:
              C = x.payload;
              h = "function" === typeof C ? C.call(p, A, h) : C;
              if (null === h || void 0 === h) break a;
              A = m$2({}, A, h);
              break a;

            case 2:
              wg = !0;
          }
        }

        null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [f] : h.push(f));
      } else p = {
        eventTime: p,
        lane: h,
        tag: f.tag,
        payload: f.payload,
        callback: f.callback,
        next: null
      }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;

      f = f.next;
      if (null === f) if (h = e.shared.pending, null === h) break;else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
    } while (1);

    null === n && (k = A);
    e.baseState = k;
    e.firstBaseUpdate = l;
    e.lastBaseUpdate = n;
    Dg |= g;
    a.lanes = g;
    a.memoizedState = A;
  }
}

function Eg(a, b, c) {
  a = b.effects;
  b.effects = null;
  if (null !== a) for (b = 0; b < a.length; b++) {
    var d = a[b],
        e = d.callback;

    if (null !== e) {
      d.callback = null;
      d = c;
      if ("function" !== typeof e) throw Error(y$3(191, e));
      e.call(d);
    }
  }
}

var Fg = new aa.Component().refs;

function Gg(a, b, c, d) {
  b = a.memoizedState;
  c = c(d, b);
  c = null === c || void 0 === c ? b : m$2({}, b, c);
  a.memoizedState = c;
  0 === a.lanes && (a.updateQueue.baseState = c);
}

var Kg = {
  isMounted: function isMounted(a) {
    return (a = a._reactInternals) ? Zb(a) === a : !1;
  },
  enqueueSetState: function enqueueSetState(a, b, c) {
    a = a._reactInternals;
    var d = Hg(),
        e = Ig(a),
        f = zg(d, e);
    f.payload = b;
    void 0 !== c && null !== c && (f.callback = c);
    Ag(a, f);
    Jg(a, e, d);
  },
  enqueueReplaceState: function enqueueReplaceState(a, b, c) {
    a = a._reactInternals;
    var d = Hg(),
        e = Ig(a),
        f = zg(d, e);
    f.tag = 1;
    f.payload = b;
    void 0 !== c && null !== c && (f.callback = c);
    Ag(a, f);
    Jg(a, e, d);
  },
  enqueueForceUpdate: function enqueueForceUpdate(a, b) {
    a = a._reactInternals;
    var c = Hg(),
        d = Ig(a),
        e = zg(c, d);
    e.tag = 2;
    void 0 !== b && null !== b && (e.callback = b);
    Ag(a, e);
    Jg(a, d, c);
  }
};

function Lg(a, b, c, d, e, f, g) {
  a = a.stateNode;
  return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}

function Mg(a, b, c) {
  var d = !1,
      e = Cf;
  var f = b.contextType;
  "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M$2.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
  b = new b(c, f);
  a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
  b.updater = Kg;
  a.stateNode = b;
  b._reactInternals = a;
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
  return b;
}

function Ng(a, b, c, d) {
  a = b.state;
  "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
  "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
  b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}

function Og(a, b, c, d) {
  var e = a.stateNode;
  e.props = c;
  e.state = a.memoizedState;
  e.refs = Fg;
  xg(a);
  var f = b.contextType;
  "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M$2.current, e.context = Ef(a, f));
  Cg(a, c, e, d);
  e.state = a.memoizedState;
  f = b.getDerivedStateFromProps;
  "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
  "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
  "function" === typeof e.componentDidMount && (a.flags |= 4);
}

var Pg = Array.isArray;

function Qg(a, b, c) {
  a = c.ref;

  if (null !== a && "function" !== typeof a && "object" !== typeof a) {
    if (c._owner) {
      c = c._owner;

      if (c) {
        if (1 !== c.tag) throw Error(y$3(309));
        var d = c.stateNode;
      }

      if (!d) throw Error(y$3(147, a));
      var e = "" + a;
      if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;

      b = function b(a) {
        var b = d.refs;
        b === Fg && (b = d.refs = {});
        null === a ? delete b[e] : b[e] = a;
      };

      b._stringRef = e;
      return b;
    }

    if ("string" !== typeof a) throw Error(y$3(284));
    if (!c._owner) throw Error(y$3(290, a));
  }

  return a;
}

function Rg(a, b) {
  if ("textarea" !== a.type) throw Error(y$3(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}

function Sg(a) {
  function b(b, c) {
    if (a) {
      var d = b.lastEffect;
      null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
      c.nextEffect = null;
      c.flags = 8;
    }
  }

  function c(c, d) {
    if (!a) return null;

    for (; null !== d;) {
      b(c, d), d = d.sibling;
    }

    return null;
  }

  function d(a, b) {
    for (a = new Map(); null !== b;) {
      null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
    }

    return a;
  }

  function e(a, b) {
    a = Tg(a, b);
    a.index = 0;
    a.sibling = null;
    return a;
  }

  function f(b, c, d) {
    b.index = d;
    if (!a) return c;
    d = b.alternate;
    if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
    b.flags = 2;
    return c;
  }

  function g(b) {
    a && null === b.alternate && (b.flags = 2);
    return b;
  }

  function h(a, b, c, d) {
    if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b["return"] = a, b;
    b = e(b, c);
    b["return"] = a;
    return b;
  }

  function k(a, b, c, d) {
    if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d["return"] = a, d;
    d = Vg(c.type, c.key, c.props, null, a.mode, d);
    d.ref = Qg(a, b, c);
    d["return"] = a;
    return d;
  }

  function l(a, b, c, d) {
    if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b["return"] = a, b;
    b = e(b, c.children || []);
    b["return"] = a;
    return b;
  }

  function n(a, b, c, d, f) {
    if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b["return"] = a, b;
    b = e(b, c);
    b["return"] = a;
    return b;
  }

  function A(a, b, c) {
    if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b["return"] = a, b;

    if ("object" === typeof b && null !== b) {
      switch (b.$$typeof) {
        case sa:
          return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c["return"] = a, c;

        case ta:
          return b = Wg(b, a.mode, c), b["return"] = a, b;
      }

      if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b["return"] = a, b;
      Rg(a, b);
    }

    return null;
  }

  function p(a, b, c, d) {
    var e = null !== b ? b.key : null;
    if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);

    if ("object" === typeof c && null !== c) {
      switch (c.$$typeof) {
        case sa:
          return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;

        case ta:
          return c.key === e ? l(a, b, c, d) : null;
      }

      if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
      Rg(a, c);
    }

    return null;
  }

  function C(a, b, c, d, e) {
    if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);

    if ("object" === typeof d && null !== d) {
      switch (d.$$typeof) {
        case sa:
          return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);

        case ta:
          return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
      }

      if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
      Rg(b, d);
    }

    return null;
  }

  function x(e, g, h, k) {
    for (var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++) {
      u.index > z ? (q = u, u = null) : q = u.sibling;
      var n = p(e, u, h[z], k);

      if (null === n) {
        null === u && (u = q);
        break;
      }

      a && u && null === n.alternate && b(e, u);
      g = f(n, g, z);
      null === t ? l = n : t.sibling = n;
      t = n;
      u = q;
    }

    if (z === h.length) return c(e, u), l;

    if (null === u) {
      for (; z < h.length; z++) {
        u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
      }

      return l;
    }

    for (u = d(e, u); z < h.length; z++) {
      q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u["delete"](null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
    }

    a && u.forEach(function (a) {
      return b(e, a);
    });
    return l;
  }

  function w(e, g, h, k) {
    var l = La(h);
    if ("function" !== typeof l) throw Error(y$3(150));
    h = l.call(h);
    if (null == h) throw Error(y$3(151));

    for (var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()) {
      u.index > z ? (q = u, u = null) : q = u.sibling;
      var w = p(e, u, n.value, k);

      if (null === w) {
        null === u && (u = q);
        break;
      }

      a && u && null === w.alternate && b(e, u);
      g = f(w, g, z);
      null === t ? l = w : t.sibling = w;
      t = w;
      u = q;
    }

    if (n.done) return c(e, u), l;

    if (null === u) {
      for (; !n.done; z++, n = h.next()) {
        n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
      }

      return l;
    }

    for (u = d(e, u); !n.done; z++, n = h.next()) {
      n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u["delete"](null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
    }

    a && u.forEach(function (a) {
      return b(e, a);
    });
    return l;
  }

  return function (a, d, f, h) {
    var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
    k && (f = f.props.children);
    var l = "object" === typeof f && null !== f;
    if (l) switch (f.$$typeof) {
      case sa:
        a: {
          l = f.key;

          for (k = d; null !== k;) {
            if (k.key === l) {
              switch (k.tag) {
                case 7:
                  if (f.type === ua) {
                    c(a, k.sibling);
                    d = e(k, f.props.children);
                    d["return"] = a;
                    a = d;
                    break a;
                  }

                  break;

                default:
                  if (k.elementType === f.type) {
                    c(a, k.sibling);
                    d = e(k, f.props);
                    d.ref = Qg(a, k, f);
                    d["return"] = a;
                    a = d;
                    break a;
                  }

              }

              c(a, k);
              break;
            } else b(a, k);

            k = k.sibling;
          }

          f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d["return"] = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h["return"] = a, a = h);
        }

        return g(a);

      case ta:
        a: {
          for (k = f.key; null !== d;) {
            if (d.key === k) {
              if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                c(a, d.sibling);
                d = e(d, f.children || []);
                d["return"] = a;
                a = d;
                break a;
              } else {
                c(a, d);
                break;
              }
            } else b(a, d);
            d = d.sibling;
          }

          d = Wg(f, a.mode, h);
          d["return"] = a;
          a = d;
        }

        return g(a);
    }
    if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d["return"] = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d["return"] = a, a = d), g(a);
    if (Pg(f)) return x(a, d, f, h);
    if (La(f)) return w(a, d, f, h);
    l && Rg(a, f);
    if ("undefined" === typeof f && !k) switch (a.tag) {
      case 1:
      case 22:
      case 0:
      case 11:
      case 15:
        throw Error(y$3(152, Ra(a.type) || "Component"));
    }
    return c(a, d);
  };
}

var Yg = Sg(!0),
    Zg = Sg(!1),
    $g = {},
    ah = Bf($g),
    bh = Bf($g),
    ch = Bf($g);

function dh(a) {
  if (a === $g) throw Error(y$3(174));
  return a;
}

function eh(a, b) {
  I$3(ch, b);
  I$3(bh, a);
  I$3(ah, $g);
  a = b.nodeType;

  switch (a) {
    case 9:
    case 11:
      b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
      break;

    default:
      a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
  }

  H$3(ah);
  I$3(ah, b);
}

function fh() {
  H$3(ah);
  H$3(bh);
  H$3(ch);
}

function gh(a) {
  dh(ch.current);
  var b = dh(ah.current);
  var c = mb(b, a.type);
  b !== c && (I$3(bh, a), I$3(ah, c));
}

function hh(a) {
  bh.current === a && (H$3(ah), H$3(bh));
}

var P$2 = Bf(0);

function ih(a) {
  for (var b = a; null !== b;) {
    if (13 === b.tag) {
      var c = b.memoizedState;
      if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
    } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
      if (0 !== (b.flags & 64)) return b;
    } else if (null !== b.child) {
      b.child["return"] = b;
      b = b.child;
      continue;
    }

    if (b === a) break;

    for (; null === b.sibling;) {
      if (null === b["return"] || b["return"] === a) return null;
      b = b["return"];
    }

    b.sibling["return"] = b["return"];
    b = b.sibling;
  }

  return null;
}

var jh = null,
    kh = null,
    lh = !1;

function mh(a, b) {
  var c = nh(5, null, null, 0);
  c.elementType = "DELETED";
  c.type = "DELETED";
  c.stateNode = b;
  c["return"] = a;
  c.flags = 8;
  null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}

function oh(a, b) {
  switch (a.tag) {
    case 5:
      var c = a.type;
      b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
      return null !== b ? (a.stateNode = b, !0) : !1;

    case 6:
      return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;

    case 13:
      return !1;

    default:
      return !1;
  }
}

function ph(a) {
  if (lh) {
    var b = kh;

    if (b) {
      var c = b;

      if (!oh(a, b)) {
        b = rf(c.nextSibling);

        if (!b || !oh(a, b)) {
          a.flags = a.flags & -1025 | 2;
          lh = !1;
          jh = a;
          return;
        }

        mh(jh, c);
      }

      jh = a;
      kh = rf(b.firstChild);
    } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
  }
}

function qh(a) {
  for (a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;) {
    a = a["return"];
  }

  jh = a;
}

function rh(a) {
  if (a !== jh) return !1;
  if (!lh) return qh(a), lh = !0, !1;
  var b = a.type;
  if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for (b = kh; b;) {
    mh(a, b), b = rf(b.nextSibling);
  }
  qh(a);

  if (13 === a.tag) {
    a = a.memoizedState;
    a = null !== a ? a.dehydrated : null;
    if (!a) throw Error(y$3(317));

    a: {
      a = a.nextSibling;

      for (b = 0; a;) {
        if (8 === a.nodeType) {
          var c = a.data;

          if ("/$" === c) {
            if (0 === b) {
              kh = rf(a.nextSibling);
              break a;
            }

            b--;
          } else "$" !== c && "$!" !== c && "$?" !== c || b++;
        }

        a = a.nextSibling;
      }

      kh = null;
    }
  } else kh = jh ? rf(a.stateNode.nextSibling) : null;

  return !0;
}

function sh() {
  kh = jh = null;
  lh = !1;
}

var th = [];

function uh() {
  for (var a = 0; a < th.length; a++) {
    th[a]._workInProgressVersionPrimary = null;
  }

  th.length = 0;
}

var vh = ra.ReactCurrentDispatcher,
    wh = ra.ReactCurrentBatchConfig,
    xh = 0,
    R$1 = null,
    S$2 = null,
    T$1 = null,
    yh = !1,
    zh = !1;

function Ah() {
  throw Error(y$3(321));
}

function Bh(a, b) {
  if (null === b) return !1;

  for (var c = 0; c < b.length && c < a.length; c++) {
    if (!He$1(a[c], b[c])) return !1;
  }

  return !0;
}

function Ch(a, b, c, d, e, f) {
  xh = f;
  R$1 = b;
  b.memoizedState = null;
  b.updateQueue = null;
  b.lanes = 0;
  vh.current = null === a || null === a.memoizedState ? Dh : Eh;
  a = c(d, e);

  if (zh) {
    f = 0;

    do {
      zh = !1;
      if (!(25 > f)) throw Error(y$3(301));
      f += 1;
      T$1 = S$2 = null;
      b.updateQueue = null;
      vh.current = Fh;
      a = c(d, e);
    } while (zh);
  }

  vh.current = Gh;
  b = null !== S$2 && null !== S$2.next;
  xh = 0;
  T$1 = S$2 = R$1 = null;
  yh = !1;
  if (b) throw Error(y$3(300));
  return a;
}

function Hh() {
  var a = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };
  null === T$1 ? R$1.memoizedState = T$1 = a : T$1 = T$1.next = a;
  return T$1;
}

function Ih() {
  if (null === S$2) {
    var a = R$1.alternate;
    a = null !== a ? a.memoizedState : null;
  } else a = S$2.next;

  var b = null === T$1 ? R$1.memoizedState : T$1.next;
  if (null !== b) T$1 = b, S$2 = a;else {
    if (null === a) throw Error(y$3(310));
    S$2 = a;
    a = {
      memoizedState: S$2.memoizedState,
      baseState: S$2.baseState,
      baseQueue: S$2.baseQueue,
      queue: S$2.queue,
      next: null
    };
    null === T$1 ? R$1.memoizedState = T$1 = a : T$1 = T$1.next = a;
  }
  return T$1;
}

function Jh(a, b) {
  return "function" === typeof b ? b(a) : b;
}

function Kh(a) {
  var b = Ih(),
      c = b.queue;
  if (null === c) throw Error(y$3(311));
  c.lastRenderedReducer = a;
  var d = S$2,
      e = d.baseQueue,
      f = c.pending;

  if (null !== f) {
    if (null !== e) {
      var g = e.next;
      e.next = f.next;
      f.next = g;
    }

    d.baseQueue = e = f;
    c.pending = null;
  }

  if (null !== e) {
    e = e.next;
    d = d.baseState;
    var h = g = f = null,
        k = e;

    do {
      var l = k.lane;
      if ((xh & l) === l) null !== h && (h = h.next = {
        lane: 0,
        action: k.action,
        eagerReducer: k.eagerReducer,
        eagerState: k.eagerState,
        next: null
      }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);else {
        var n = {
          lane: l,
          action: k.action,
          eagerReducer: k.eagerReducer,
          eagerState: k.eagerState,
          next: null
        };
        null === h ? (g = h = n, f = d) : h = h.next = n;
        R$1.lanes |= l;
        Dg |= l;
      }
      k = k.next;
    } while (null !== k && k !== e);

    null === h ? f = d : h.next = g;
    He$1(d, b.memoizedState) || (ug = !0);
    b.memoizedState = d;
    b.baseState = f;
    b.baseQueue = h;
    c.lastRenderedState = d;
  }

  return [b.memoizedState, c.dispatch];
}

function Lh(a) {
  var b = Ih(),
      c = b.queue;
  if (null === c) throw Error(y$3(311));
  c.lastRenderedReducer = a;
  var d = c.dispatch,
      e = c.pending,
      f = b.memoizedState;

  if (null !== e) {
    c.pending = null;
    var g = e = e.next;

    do {
      f = a(f, g.action), g = g.next;
    } while (g !== e);

    He$1(f, b.memoizedState) || (ug = !0);
    b.memoizedState = f;
    null === b.baseQueue && (b.baseState = f);
    c.lastRenderedState = f;
  }

  return [f, d];
}

function Mh(a, b, c) {
  var d = b._getVersion;
  d = d(b._source);
  var e = b._workInProgressVersionPrimary;
  if (null !== e) a = e === d;else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
  if (a) return c(b._source);
  th.push(b);
  throw Error(y$3(350));
}

function Nh(a, b, c, d) {
  var e = U$2;
  if (null === e) throw Error(y$3(349));
  var f = b._getVersion,
      g = f(b._source),
      h = vh.current,
      k = h.useState(function () {
    return Mh(e, b, c);
  }),
      l = k[1],
      n = k[0];
  k = T$1;
  var A = a.memoizedState,
      p = A.refs,
      C = p.getSnapshot,
      x = A.source;
  A = A.subscribe;
  var w = R$1;
  a.memoizedState = {
    refs: p,
    source: b,
    subscribe: d
  };
  h.useEffect(function () {
    p.getSnapshot = c;
    p.setSnapshot = l;
    var a = f(b._source);

    if (!He$1(g, a)) {
      a = c(b._source);
      He$1(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
      a = e.mutableReadLanes;
      e.entangledLanes |= a;

      for (var d = e.entanglements, h = a; 0 < h;) {
        var k = 31 - Vc(h),
            v = 1 << k;
        d[k] |= a;
        h &= ~v;
      }
    }
  }, [c, b, d]);
  h.useEffect(function () {
    return d(b._source, function () {
      var a = p.getSnapshot,
          c = p.setSnapshot;

      try {
        c(a(b._source));
        var d = Ig(w);
        e.mutableReadLanes |= d & e.pendingLanes;
      } catch (q) {
        c(function () {
          throw q;
        });
      }
    });
  }, [b, d]);
  He$1(C, c) && He$1(x, b) && He$1(A, d) || (a = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: Jh,
    lastRenderedState: n
  }, a.dispatch = l = Oh.bind(null, R$1, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
  return n;
}

function Ph(a, b, c) {
  var d = Ih();
  return Nh(d, a, b, c);
}

function Qh(a) {
  var b = Hh();
  "function" === typeof a && (a = a());
  b.memoizedState = b.baseState = a;
  a = b.queue = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: Jh,
    lastRenderedState: a
  };
  a = a.dispatch = Oh.bind(null, R$1, a);
  return [b.memoizedState, a];
}

function Rh(a, b, c, d) {
  a = {
    tag: a,
    create: b,
    destroy: c,
    deps: d,
    next: null
  };
  b = R$1.updateQueue;
  null === b ? (b = {
    lastEffect: null
  }, R$1.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
  return a;
}

function Sh(a) {
  var b = Hh();
  a = {
    current: a
  };
  return b.memoizedState = a;
}

function Th() {
  return Ih().memoizedState;
}

function Uh(a, b, c, d) {
  var e = Hh();
  R$1.flags |= a;
  e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}

function Vh(a, b, c, d) {
  var e = Ih();
  d = void 0 === d ? null : d;
  var f = void 0;

  if (null !== S$2) {
    var g = S$2.memoizedState;
    f = g.destroy;

    if (null !== d && Bh(d, g.deps)) {
      Rh(b, c, f, d);
      return;
    }
  }

  R$1.flags |= a;
  e.memoizedState = Rh(1 | b, c, f, d);
}

function Wh(a, b) {
  return Uh(516, 4, a, b);
}

function Xh(a, b) {
  return Vh(516, 4, a, b);
}

function Yh(a, b) {
  return Vh(4, 2, a, b);
}

function Zh(a, b) {
  if ("function" === typeof b) return a = a(), b(a), function () {
    b(null);
  };
  if (null !== b && void 0 !== b) return a = a(), b.current = a, function () {
    b.current = null;
  };
}

function $h(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;
  return Vh(4, 2, Zh.bind(null, b, a), c);
}

function ai() {}

function bi(a, b) {
  var c = Ih();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Bh(b, d[1])) return d[0];
  c.memoizedState = [a, b];
  return a;
}

function ci(a, b) {
  var c = Ih();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Bh(b, d[1])) return d[0];
  a = a();
  c.memoizedState = [a, b];
  return a;
}

function di(a, b) {
  var c = eg();
  gg(98 > c ? 98 : c, function () {
    a(!0);
  });
  gg(97 < c ? 97 : c, function () {
    var c = wh.transition;
    wh.transition = 1;

    try {
      a(!1), b();
    } finally {
      wh.transition = c;
    }
  });
}

function Oh(a, b, c) {
  var d = Hg(),
      e = Ig(a),
      f = {
    lane: e,
    action: c,
    eagerReducer: null,
    eagerState: null,
    next: null
  },
      g = b.pending;
  null === g ? f.next = f : (f.next = g.next, g.next = f);
  b.pending = f;
  g = a.alternate;
  if (a === R$1 || null !== g && g === R$1) zh = yh = !0;else {
    if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
      var h = b.lastRenderedState,
          k = g(h, c);
      f.eagerReducer = g;
      f.eagerState = k;
      if (He$1(k, h)) return;
    } catch (l) {} finally {}
    Jg(a, e, d);
  }
}

var Gh = {
  readContext: vg,
  useCallback: Ah,
  useContext: Ah,
  useEffect: Ah,
  useImperativeHandle: Ah,
  useLayoutEffect: Ah,
  useMemo: Ah,
  useReducer: Ah,
  useRef: Ah,
  useState: Ah,
  useDebugValue: Ah,
  useDeferredValue: Ah,
  useTransition: Ah,
  useMutableSource: Ah,
  useOpaqueIdentifier: Ah,
  unstable_isNewReconciler: !1
},
    Dh = {
  readContext: vg,
  useCallback: function useCallback(a, b) {
    Hh().memoizedState = [a, void 0 === b ? null : b];
    return a;
  },
  useContext: vg,
  useEffect: Wh,
  useImperativeHandle: function useImperativeHandle(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;
    return Uh(4, 2, Zh.bind(null, b, a), c);
  },
  useLayoutEffect: function useLayoutEffect(a, b) {
    return Uh(4, 2, a, b);
  },
  useMemo: function useMemo(a, b) {
    var c = Hh();
    b = void 0 === b ? null : b;
    a = a();
    c.memoizedState = [a, b];
    return a;
  },
  useReducer: function useReducer(a, b, c) {
    var d = Hh();
    b = void 0 !== c ? c(b) : b;
    d.memoizedState = d.baseState = b;
    a = d.queue = {
      pending: null,
      dispatch: null,
      lastRenderedReducer: a,
      lastRenderedState: b
    };
    a = a.dispatch = Oh.bind(null, R$1, a);
    return [d.memoizedState, a];
  },
  useRef: Sh,
  useState: Qh,
  useDebugValue: ai,
  useDeferredValue: function useDeferredValue(a) {
    var b = Qh(a),
        c = b[0],
        d = b[1];
    Wh(function () {
      var b = wh.transition;
      wh.transition = 1;

      try {
        d(a);
      } finally {
        wh.transition = b;
      }
    }, [a]);
    return c;
  },
  useTransition: function useTransition() {
    var a = Qh(!1),
        b = a[0];
    a = di.bind(null, a[1]);
    Sh(a);
    return [a, b];
  },
  useMutableSource: function useMutableSource(a, b, c) {
    var d = Hh();
    d.memoizedState = {
      refs: {
        getSnapshot: b,
        setSnapshot: null
      },
      source: a,
      subscribe: c
    };
    return Nh(d, a, b, c);
  },
  useOpaqueIdentifier: function useOpaqueIdentifier() {
    if (lh) {
      var a = !1,
          b = uf(function () {
        a || (a = !0, c("r:" + (tf++).toString(36)));
        throw Error(y$3(355));
      }),
          c = Qh(b)[1];
      0 === (R$1.mode & 2) && (R$1.flags |= 516, Rh(5, function () {
        c("r:" + (tf++).toString(36));
      }, void 0, null));
      return b;
    }

    b = "r:" + (tf++).toString(36);
    Qh(b);
    return b;
  },
  unstable_isNewReconciler: !1
},
    Eh = {
  readContext: vg,
  useCallback: bi,
  useContext: vg,
  useEffect: Xh,
  useImperativeHandle: $h,
  useLayoutEffect: Yh,
  useMemo: ci,
  useReducer: Kh,
  useRef: Th,
  useState: function useState() {
    return Kh(Jh);
  },
  useDebugValue: ai,
  useDeferredValue: function useDeferredValue(a) {
    var b = Kh(Jh),
        c = b[0],
        d = b[1];
    Xh(function () {
      var b = wh.transition;
      wh.transition = 1;

      try {
        d(a);
      } finally {
        wh.transition = b;
      }
    }, [a]);
    return c;
  },
  useTransition: function useTransition() {
    var a = Kh(Jh)[0];
    return [Th().current, a];
  },
  useMutableSource: Ph,
  useOpaqueIdentifier: function useOpaqueIdentifier() {
    return Kh(Jh)[0];
  },
  unstable_isNewReconciler: !1
},
    Fh = {
  readContext: vg,
  useCallback: bi,
  useContext: vg,
  useEffect: Xh,
  useImperativeHandle: $h,
  useLayoutEffect: Yh,
  useMemo: ci,
  useReducer: Lh,
  useRef: Th,
  useState: function useState() {
    return Lh(Jh);
  },
  useDebugValue: ai,
  useDeferredValue: function useDeferredValue(a) {
    var b = Lh(Jh),
        c = b[0],
        d = b[1];
    Xh(function () {
      var b = wh.transition;
      wh.transition = 1;

      try {
        d(a);
      } finally {
        wh.transition = b;
      }
    }, [a]);
    return c;
  },
  useTransition: function useTransition() {
    var a = Lh(Jh)[0];
    return [Th().current, a];
  },
  useMutableSource: Ph,
  useOpaqueIdentifier: function useOpaqueIdentifier() {
    return Lh(Jh)[0];
  },
  unstable_isNewReconciler: !1
},
    ei = ra.ReactCurrentOwner,
    ug = !1;

function fi(a, b, c, d) {
  b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}

function gi(a, b, c, d, e) {
  c = c.render;
  var f = b.ref;
  tg(b, e);
  d = Ch(a, b, c, d, f, e);
  if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
  b.flags |= 1;
  fi(a, b, d, e);
  return b.child;
}

function ii(a, b, c, d, e, f) {
  if (null === a) {
    var g = c.type;
    if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
    a = Vg(c.type, null, d, b, b.mode, f);
    a.ref = b.ref;
    a["return"] = b;
    return b.child = a;
  }

  g = a.child;
  if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
  b.flags |= 1;
  a = Tg(g, d);
  a.ref = b.ref;
  a["return"] = b;
  return b.child = a;
}

function ki(a, b, c, d, e, f) {
  if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);else return b.lanes = a.lanes, hi(a, b, f);
  return li(a, b, c, d, f);
}

function mi(a, b, c) {
  var d = b.pendingProps,
      e = d.children,
      f = null !== a ? a.memoizedState : null;
  if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
    if (0 === (b.mode & 4)) b.memoizedState = {
      baseLanes: 0
    }, ni(b, c);else if (0 !== (c & 1073741824)) b.memoizedState = {
      baseLanes: 0
    }, ni(b, null !== f ? f.baseLanes : c);else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
      baseLanes: a
    }, ni(b, a), null;
  } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
  fi(a, b, e, c);
  return b.child;
}

function oi(a, b) {
  var c = b.ref;
  if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}

function li(a, b, c, d, e) {
  var f = Ff(c) ? Df : M$2.current;
  f = Ef(b, f);
  tg(b, e);
  c = Ch(a, b, c, d, f, e);
  if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
  b.flags |= 1;
  fi(a, b, c, e);
  return b.child;
}

function pi(a, b, c, d, e) {
  if (Ff(c)) {
    var f = !0;
    Jf(b);
  } else f = !1;

  tg(b, e);
  if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;else if (null === a) {
    var g = b.stateNode,
        h = b.memoizedProps;
    g.props = h;
    var k = g.context,
        l = c.contextType;
    "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M$2.current, l = Ef(b, l));
    var n = c.getDerivedStateFromProps,
        A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
    A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
    wg = !1;
    var p = b.memoizedState;
    g.state = p;
    Cg(b, d, g, e);
    k = b.memoizedState;
    h !== d || p !== k || N$2.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
  } else {
    g = b.stateNode;
    yg(a, b);
    h = b.memoizedProps;
    l = b.type === b.elementType ? h : lg(b.type, h);
    g.props = l;
    A = b.pendingProps;
    p = g.context;
    k = c.contextType;
    "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M$2.current, k = Ef(b, k));
    var C = c.getDerivedStateFromProps;
    (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
    wg = !1;
    p = b.memoizedState;
    g.state = p;
    Cg(b, d, g, e);
    var x = b.memoizedState;
    h !== A || p !== x || N$2.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
  }
  return qi(a, b, c, d, f, e);
}

function qi(a, b, c, d, e, f) {
  oi(a, b);
  var g = 0 !== (b.flags & 64);
  if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
  d = b.stateNode;
  ei.current = b;
  var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
  b.flags |= 1;
  null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
  b.memoizedState = d.state;
  e && Kf(b, c, !0);
  return b.child;
}

function ri(a) {
  var b = a.stateNode;
  b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
  eh(a, b.containerInfo);
}

var si = {
  dehydrated: null,
  retryLane: 0
};

function ti(a, b, c) {
  var d = b.pendingProps,
      e = P$2.current,
      f = !1,
      g;
  (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
  g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
  I$3(P$2, e & 1);

  if (null === a) {
    void 0 !== d.fallback && ph(b);
    a = d.children;
    e = d.fallback;
    if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
      baseLanes: c
    }, b.memoizedState = si, a;
    if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
      baseLanes: c
    }, b.memoizedState = si, b.lanes = 33554432, a;
    c = vi({
      mode: "visible",
      children: a
    }, b.mode, c, null);
    c["return"] = b;
    return b.child = c;
  }

  if (null !== a.memoizedState) {
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
      baseLanes: c
    } : {
      baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
  }

  if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
    baseLanes: c
  } : {
    baseLanes: e.baseLanes | c
  }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
  c = xi(a, b, d.children, c);
  b.memoizedState = null;
  return c;
}

function ui(a, b, c, d) {
  var e = a.mode,
      f = a.child;
  b = {
    mode: "hidden",
    children: b
  };
  0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
  c = Xg(c, e, d, null);
  f["return"] = a;
  c["return"] = a;
  f.sibling = c;
  a.child = f;
  return c;
}

function xi(a, b, c, d) {
  var e = a.child;
  a = e.sibling;
  c = Tg(e, {
    mode: "visible",
    children: c
  });
  0 === (b.mode & 2) && (c.lanes = d);
  c["return"] = b;
  c.sibling = null;
  null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
  return b.child = c;
}

function wi(a, b, c, d, e) {
  var f = b.mode,
      g = a.child;
  a = g.sibling;
  var h = {
    mode: "hidden",
    children: c
  };
  0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
  null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
  d["return"] = b;
  c["return"] = b;
  c.sibling = d;
  b.child = c;
  return d;
}

function yi(a, b) {
  a.lanes |= b;
  var c = a.alternate;
  null !== c && (c.lanes |= b);
  sg(a["return"], b);
}

function zi(a, b, c, d, e, f) {
  var g = a.memoizedState;
  null === g ? a.memoizedState = {
    isBackwards: b,
    rendering: null,
    renderingStartTime: 0,
    last: d,
    tail: c,
    tailMode: e,
    lastEffect: f
  } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}

function Ai(a, b, c) {
  var d = b.pendingProps,
      e = d.revealOrder,
      f = d.tail;
  fi(a, b, d.children, c);
  d = P$2.current;
  if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;else {
    if (null !== a && 0 !== (a.flags & 64)) a: for (a = b.child; null !== a;) {
      if (13 === a.tag) null !== a.memoizedState && yi(a, c);else if (19 === a.tag) yi(a, c);else if (null !== a.child) {
        a.child["return"] = a;
        a = a.child;
        continue;
      }
      if (a === b) break a;

      for (; null === a.sibling;) {
        if (null === a["return"] || a["return"] === b) break a;
        a = a["return"];
      }

      a.sibling["return"] = a["return"];
      a = a.sibling;
    }
    d &= 1;
  }
  I$3(P$2, d);
  if (0 === (b.mode & 2)) b.memoizedState = null;else switch (e) {
    case "forwards":
      c = b.child;

      for (e = null; null !== c;) {
        a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
      }

      c = e;
      null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
      zi(b, !1, e, c, f, b.lastEffect);
      break;

    case "backwards":
      c = null;
      e = b.child;

      for (b.child = null; null !== e;) {
        a = e.alternate;

        if (null !== a && null === ih(a)) {
          b.child = e;
          break;
        }

        a = e.sibling;
        e.sibling = c;
        c = e;
        e = a;
      }

      zi(b, !0, c, null, f, b.lastEffect);
      break;

    case "together":
      zi(b, !1, null, null, void 0, b.lastEffect);
      break;

    default:
      b.memoizedState = null;
  }
  return b.child;
}

function hi(a, b, c) {
  null !== a && (b.dependencies = a.dependencies);
  Dg |= b.lanes;

  if (0 !== (c & b.childLanes)) {
    if (null !== a && b.child !== a.child) throw Error(y$3(153));

    if (null !== b.child) {
      a = b.child;
      c = Tg(a, a.pendingProps);
      b.child = c;

      for (c["return"] = b; null !== a.sibling;) {
        a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c["return"] = b;
      }

      c.sibling = null;
    }

    return b.child;
  }

  return null;
}

var Bi, Ci, Di, Ei;

Bi = function Bi(a, b) {
  for (var c = b.child; null !== c;) {
    if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);else if (4 !== c.tag && null !== c.child) {
      c.child["return"] = c;
      c = c.child;
      continue;
    }
    if (c === b) break;

    for (; null === c.sibling;) {
      if (null === c["return"] || c["return"] === b) return;
      c = c["return"];
    }

    c.sibling["return"] = c["return"];
    c = c.sibling;
  }
};

Ci = function Ci() {};

Di = function Di(a, b, c, d) {
  var e = a.memoizedProps;

  if (e !== d) {
    a = b.stateNode;
    dh(ah.current);
    var f = null;

    switch (c) {
      case "input":
        e = Ya(a, e);
        d = Ya(a, d);
        f = [];
        break;

      case "option":
        e = eb(a, e);
        d = eb(a, d);
        f = [];
        break;

      case "select":
        e = m$2({}, e, {
          value: void 0
        });
        d = m$2({}, d, {
          value: void 0
        });
        f = [];
        break;

      case "textarea":
        e = gb(a, e);
        d = gb(a, d);
        f = [];
        break;

      default:
        "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
    }

    vb(c, d);
    var g;
    c = null;

    for (l in e) {
      if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) if ("style" === l) {
        var h = e[l];

        for (g in h) {
          h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
        }
      } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
    }

    for (l in d) {
      var k = d[l];
      h = null != e ? e[l] : void 0;
      if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) if ("style" === l) {
        if (h) {
          for (g in h) {
            !h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
          }

          for (g in k) {
            k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
          }
        } else c || (f || (f = []), f.push(l, c)), c = k;
      } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G$3("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
    }

    c && (f = f || []).push("style", c);
    var l = f;
    if (b.updateQueue = l) b.flags |= 4;
  }
};

Ei = function Ei(a, b, c, d) {
  c !== d && (b.flags |= 4);
};

function Fi(a, b) {
  if (!lh) switch (a.tailMode) {
    case "hidden":
      b = a.tail;

      for (var c = null; null !== b;) {
        null !== b.alternate && (c = b), b = b.sibling;
      }

      null === c ? a.tail = null : c.sibling = null;
      break;

    case "collapsed":
      c = a.tail;

      for (var d = null; null !== c;) {
        null !== c.alternate && (d = c), c = c.sibling;
      }

      null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
  }
}

function Gi(a, b, c) {
  var d = b.pendingProps;

  switch (b.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return null;

    case 1:
      return Ff(b.type) && Gf(), null;

    case 3:
      fh();
      H$3(N$2);
      H$3(M$2);
      uh();
      d = b.stateNode;
      d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
      if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
      Ci(b);
      return null;

    case 5:
      hh(b);
      var e = dh(ch.current);
      c = b.type;
      if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);else {
        if (!d) {
          if (null === b.stateNode) throw Error(y$3(166));
          return null;
        }

        a = dh(ah.current);

        if (rh(b)) {
          d = b.stateNode;
          c = b.type;
          var f = b.memoizedProps;
          d[wf] = b;
          d[xf] = f;

          switch (c) {
            case "dialog":
              G$3("cancel", d);
              G$3("close", d);
              break;

            case "iframe":
            case "object":
            case "embed":
              G$3("load", d);
              break;

            case "video":
            case "audio":
              for (a = 0; a < Xe.length; a++) {
                G$3(Xe[a], d);
              }

              break;

            case "source":
              G$3("error", d);
              break;

            case "img":
            case "image":
            case "link":
              G$3("error", d);
              G$3("load", d);
              break;

            case "details":
              G$3("toggle", d);
              break;

            case "input":
              Za(d, f);
              G$3("invalid", d);
              break;

            case "select":
              d._wrapperState = {
                wasMultiple: !!f.multiple
              };
              G$3("invalid", d);
              break;

            case "textarea":
              hb(d, f), G$3("invalid", d);
          }

          vb(c, f);
          a = null;

          for (var g in f) {
            f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = ["children", e]) : "number" === typeof e && d.textContent !== "" + e && (a = ["children", "" + e]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G$3("scroll", d));
          }

          switch (c) {
            case "input":
              Va(d);
              cb(d, f, !0);
              break;

            case "textarea":
              Va(d);
              jb(d);
              break;

            case "select":
            case "option":
              break;

            default:
              "function" === typeof f.onClick && (d.onclick = jf);
          }

          d = a;
          b.updateQueue = d;
          null !== d && (b.flags |= 4);
        } else {
          g = 9 === e.nodeType ? e : e.ownerDocument;
          a === kb.html && (a = lb(c));
          a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
            is: d.is
          }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
          a[wf] = b;
          a[xf] = d;
          Bi(a, b, !1, !1);
          b.stateNode = a;
          g = wb(c, d);

          switch (c) {
            case "dialog":
              G$3("cancel", a);
              G$3("close", a);
              e = d;
              break;

            case "iframe":
            case "object":
            case "embed":
              G$3("load", a);
              e = d;
              break;

            case "video":
            case "audio":
              for (e = 0; e < Xe.length; e++) {
                G$3(Xe[e], a);
              }

              e = d;
              break;

            case "source":
              G$3("error", a);
              e = d;
              break;

            case "img":
            case "image":
            case "link":
              G$3("error", a);
              G$3("load", a);
              e = d;
              break;

            case "details":
              G$3("toggle", a);
              e = d;
              break;

            case "input":
              Za(a, d);
              e = Ya(a, d);
              G$3("invalid", a);
              break;

            case "option":
              e = eb(a, d);
              break;

            case "select":
              a._wrapperState = {
                wasMultiple: !!d.multiple
              };
              e = m$2({}, d, {
                value: void 0
              });
              G$3("invalid", a);
              break;

            case "textarea":
              hb(a, d);
              e = gb(a, d);
              G$3("invalid", a);
              break;

            default:
              e = d;
          }

          vb(c, e);
          var h = e;

          for (f in h) {
            if (h.hasOwnProperty(f)) {
              var k = h[f];
              "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G$3("scroll", a) : null != k && qa(a, f, k, g));
            }
          }

          switch (c) {
            case "input":
              Va(a);
              cb(a, d, !1);
              break;

            case "textarea":
              Va(a);
              jb(a);
              break;

            case "option":
              null != d.value && a.setAttribute("value", "" + Sa(d.value));
              break;

            case "select":
              a.multiple = !!d.multiple;
              f = d.value;
              null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
              break;

            default:
              "function" === typeof e.onClick && (a.onclick = jf);
          }

          mf(c, d) && (b.flags |= 4);
        }

        null !== b.ref && (b.flags |= 128);
      }
      return null;

    case 6:
      if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);else {
        if ("string" !== typeof d && null === b.stateNode) throw Error(y$3(166));
        c = dh(ch.current);
        dh(ah.current);
        rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
      }
      return null;

    case 13:
      H$3(P$2);
      d = b.memoizedState;
      if (0 !== (b.flags & 64)) return b.lanes = c, b;
      d = null !== d;
      c = !1;
      null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
      if (d && !c && 0 !== (b.mode & 2)) if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P$2.current & 1)) 0 === V$1 && (V$1 = 3);else {
        if (0 === V$1 || 3 === V$1) V$1 = 4;
        null === U$2 || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U$2, W$2);
      }
      if (d || c) b.flags |= 4;
      return null;

    case 4:
      return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;

    case 10:
      return rg(b), null;

    case 17:
      return Ff(b.type) && Gf(), null;

    case 19:
      H$3(P$2);
      d = b.memoizedState;
      if (null === d) return null;
      f = 0 !== (b.flags & 64);
      g = d.rendering;
      if (null === g) {
        if (f) Fi(d, !1);else {
          if (0 !== V$1 || null !== a && 0 !== (a.flags & 64)) for (a = b.child; null !== a;) {
            g = ih(a);

            if (null !== g) {
              b.flags |= 64;
              Fi(d, !1);
              f = g.updateQueue;
              null !== f && (b.updateQueue = f, b.flags |= 4);
              null === d.lastEffect && (b.firstEffect = null);
              b.lastEffect = d.lastEffect;
              d = c;

              for (c = b.child; null !== c;) {
                f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                  lanes: a.lanes,
                  firstContext: a.firstContext
                }), c = c.sibling;
              }

              I$3(P$2, P$2.current & 1 | 2);
              return b.child;
            }

            a = a.sibling;
          }
          null !== d.tail && O$2() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
        }
      } else {
        if (!f) if (a = ih(g), null !== a) {
          if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
        } else 2 * O$2() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
        d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
      }
      return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O$2(), c.sibling = null, b = P$2.current, I$3(P$2, f ? b & 1 | 2 : b & 1), c) : null;

    case 23:
    case 24:
      return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
  }

  throw Error(y$3(156, b.tag));
}

function Li(a) {
  switch (a.tag) {
    case 1:
      Ff(a.type) && Gf();
      var b = a.flags;
      return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;

    case 3:
      fh();
      H$3(N$2);
      H$3(M$2);
      uh();
      b = a.flags;
      if (0 !== (b & 64)) throw Error(y$3(285));
      a.flags = b & -4097 | 64;
      return a;

    case 5:
      return hh(a), null;

    case 13:
      return H$3(P$2), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;

    case 19:
      return H$3(P$2), null;

    case 4:
      return fh(), null;

    case 10:
      return rg(a), null;

    case 23:
    case 24:
      return Ki(), null;

    default:
      return null;
  }
}

function Mi(a, b) {
  try {
    var c = "",
        d = b;

    do {
      c += Qa(d), d = d["return"];
    } while (d);

    var e = c;
  } catch (f) {
    e = "\nError generating stack: " + f.message + "\n" + f.stack;
  }

  return {
    value: a,
    source: b,
    stack: e
  };
}

function Ni(a, b) {
  try {
    console.error(b.value);
  } catch (c) {
    setTimeout(function () {
      throw c;
    });
  }
}

var Oi = "function" === typeof WeakMap ? WeakMap : Map;

function Pi(a, b, c) {
  c = zg(-1, c);
  c.tag = 3;
  c.payload = {
    element: null
  };
  var d = b.value;

  c.callback = function () {
    Qi || (Qi = !0, Ri = d);
    Ni(a, b);
  };

  return c;
}

function Si(a, b, c) {
  c = zg(-1, c);
  c.tag = 3;
  var d = a.type.getDerivedStateFromError;

  if ("function" === typeof d) {
    var e = b.value;

    c.payload = function () {
      Ni(a, b);
      return d(e);
    };
  }

  var f = a.stateNode;
  null !== f && "function" === typeof f.componentDidCatch && (c.callback = function () {
    "function" !== typeof d && (null === Ti ? Ti = new Set([this]) : Ti.add(this), Ni(a, b));
    var c = b.stack;
    this.componentDidCatch(b.value, {
      componentStack: null !== c ? c : ""
    });
  });
  return c;
}

var Ui = "function" === typeof WeakSet ? WeakSet : Set;

function Vi(a) {
  var b = a.ref;
  if (null !== b) if ("function" === typeof b) try {
    b(null);
  } catch (c) {
    Wi(a, c);
  } else b.current = null;
}

function Xi(a, b) {
  switch (b.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      return;

    case 1:
      if (b.flags & 256 && null !== a) {
        var c = a.memoizedProps,
            d = a.memoizedState;
        a = b.stateNode;
        b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
        a.__reactInternalSnapshotBeforeUpdate = b;
      }

      return;

    case 3:
      b.flags & 256 && qf(b.stateNode.containerInfo);
      return;

    case 5:
    case 6:
    case 4:
    case 17:
      return;
  }

  throw Error(y$3(163));
}

function Yi(a, b, c) {
  switch (c.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      b = c.updateQueue;
      b = null !== b ? b.lastEffect : null;

      if (null !== b) {
        a = b = b.next;

        do {
          if (3 === (a.tag & 3)) {
            var d = a.create;
            a.destroy = d();
          }

          a = a.next;
        } while (a !== b);
      }

      b = c.updateQueue;
      b = null !== b ? b.lastEffect : null;

      if (null !== b) {
        a = b = b.next;

        do {
          var e = a;
          d = e.next;
          e = e.tag;
          0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
          a = d;
        } while (a !== b);
      }

      return;

    case 1:
      a = c.stateNode;
      c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
      b = c.updateQueue;
      null !== b && Eg(c, b, a);
      return;

    case 3:
      b = c.updateQueue;

      if (null !== b) {
        a = null;
        if (null !== c.child) switch (c.child.tag) {
          case 5:
            a = c.child.stateNode;
            break;

          case 1:
            a = c.child.stateNode;
        }
        Eg(c, b, a);
      }

      return;

    case 5:
      a = c.stateNode;
      null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
      return;

    case 6:
      return;

    case 4:
      return;

    case 12:
      return;

    case 13:
      null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
      return;

    case 19:
    case 17:
    case 20:
    case 21:
    case 23:
    case 24:
      return;
  }

  throw Error(y$3(163));
}

function aj(a, b) {
  for (var c = a;;) {
    if (5 === c.tag) {
      var d = c.stateNode;
      if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";else {
        d = c.stateNode;
        var e = c.memoizedProps.style;
        e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
        d.style.display = sb("display", e);
      }
    } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
      c.child["return"] = c;
      c = c.child;
      continue;
    }

    if (c === a) break;

    for (; null === c.sibling;) {
      if (null === c["return"] || c["return"] === a) return;
      c = c["return"];
    }

    c.sibling["return"] = c["return"];
    c = c.sibling;
  }
}

function bj(a, b) {
  if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
    Mf.onCommitFiberUnmount(Lf, b);
  } catch (f) {}

  switch (b.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      a = b.updateQueue;

      if (null !== a && (a = a.lastEffect, null !== a)) {
        var c = a = a.next;

        do {
          var d = c,
              e = d.destroy;
          d = d.tag;
          if (void 0 !== e) if (0 !== (d & 4)) Zi(b, c);else {
            d = b;

            try {
              e();
            } catch (f) {
              Wi(d, f);
            }
          }
          c = c.next;
        } while (c !== a);
      }

      break;

    case 1:
      Vi(b);
      a = b.stateNode;
      if ("function" === typeof a.componentWillUnmount) try {
        a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
      } catch (f) {
        Wi(b, f);
      }
      break;

    case 5:
      Vi(b);
      break;

    case 4:
      cj(a, b);
  }
}

function dj(a) {
  a.alternate = null;
  a.child = null;
  a.dependencies = null;
  a.firstEffect = null;
  a.lastEffect = null;
  a.memoizedProps = null;
  a.memoizedState = null;
  a.pendingProps = null;
  a["return"] = null;
  a.updateQueue = null;
}

function ej(a) {
  return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}

function fj(a) {
  a: {
    for (var b = a["return"]; null !== b;) {
      if (ej(b)) break a;
      b = b["return"];
    }

    throw Error(y$3(160));
  }

  var c = b;
  b = c.stateNode;

  switch (c.tag) {
    case 5:
      var d = !1;
      break;

    case 3:
      b = b.containerInfo;
      d = !0;
      break;

    case 4:
      b = b.containerInfo;
      d = !0;
      break;

    default:
      throw Error(y$3(161));
  }

  c.flags & 16 && (pb(b, ""), c.flags &= -17);

  a: b: for (c = a;;) {
    for (; null === c.sibling;) {
      if (null === c["return"] || ej(c["return"])) {
        c = null;
        break a;
      }

      c = c["return"];
    }

    c.sibling["return"] = c["return"];

    for (c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;) {
      if (c.flags & 2) continue b;
      if (null === c.child || 4 === c.tag) continue b;else c.child["return"] = c, c = c.child;
    }

    if (!(c.flags & 2)) {
      c = c.stateNode;
      break a;
    }
  }

  d ? gj(a, c, b) : hj(a, c, b);
}

function gj(a, b, c) {
  var d = a.tag,
      e = 5 === d || 6 === d;
  if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));else if (4 !== d && (a = a.child, null !== a)) for (gj(a, b, c), a = a.sibling; null !== a;) {
    gj(a, b, c), a = a.sibling;
  }
}

function hj(a, b, c) {
  var d = a.tag,
      e = 5 === d || 6 === d;
  if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);else if (4 !== d && (a = a.child, null !== a)) for (hj(a, b, c), a = a.sibling; null !== a;) {
    hj(a, b, c), a = a.sibling;
  }
}

function cj(a, b) {
  for (var c = b, d = !1, e, f;;) {
    if (!d) {
      d = c["return"];

      a: for (;;) {
        if (null === d) throw Error(y$3(160));
        e = d.stateNode;

        switch (d.tag) {
          case 5:
            f = !1;
            break a;

          case 3:
            e = e.containerInfo;
            f = !0;
            break a;

          case 4:
            e = e.containerInfo;
            f = !0;
            break a;
        }

        d = d["return"];
      }

      d = !0;
    }

    if (5 === c.tag || 6 === c.tag) {
      a: for (var g = a, h = c, k = h;;) {
        if (bj(g, k), null !== k.child && 4 !== k.tag) k.child["return"] = k, k = k.child;else {
          if (k === h) break a;

          for (; null === k.sibling;) {
            if (null === k["return"] || k["return"] === h) break a;
            k = k["return"];
          }

          k.sibling["return"] = k["return"];
          k = k.sibling;
        }
      }

      f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
    } else if (4 === c.tag) {
      if (null !== c.child) {
        e = c.stateNode.containerInfo;
        f = !0;
        c.child["return"] = c;
        c = c.child;
        continue;
      }
    } else if (bj(a, c), null !== c.child) {
      c.child["return"] = c;
      c = c.child;
      continue;
    }

    if (c === b) break;

    for (; null === c.sibling;) {
      if (null === c["return"] || c["return"] === b) return;
      c = c["return"];
      4 === c.tag && (d = !1);
    }

    c.sibling["return"] = c["return"];
    c = c.sibling;
  }
}

function ij(a, b) {
  switch (b.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      var c = b.updateQueue;
      c = null !== c ? c.lastEffect : null;

      if (null !== c) {
        var d = c = c.next;

        do {
          3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
        } while (d !== c);
      }

      return;

    case 1:
      return;

    case 5:
      c = b.stateNode;

      if (null != c) {
        d = b.memoizedProps;
        var e = null !== a ? a.memoizedProps : d;
        a = b.type;
        var f = b.updateQueue;
        b.updateQueue = null;

        if (null !== f) {
          c[xf] = d;
          "input" === a && "radio" === d.type && null != d.name && $a(c, d);
          wb(a, e);
          b = wb(a, d);

          for (e = 0; e < f.length; e += 2) {
            var g = f[e],
                h = f[e + 1];
            "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
          }

          switch (a) {
            case "input":
              ab(c, d);
              break;

            case "textarea":
              ib(c, d);
              break;

            case "select":
              a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
          }
        }
      }

      return;

    case 6:
      if (null === b.stateNode) throw Error(y$3(162));
      b.stateNode.nodeValue = b.memoizedProps;
      return;

    case 3:
      c = b.stateNode;
      c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
      return;

    case 12:
      return;

    case 13:
      null !== b.memoizedState && (jj = O$2(), aj(b.child, !0));
      kj(b);
      return;

    case 19:
      kj(b);
      return;

    case 17:
      return;

    case 23:
    case 24:
      aj(b, null !== b.memoizedState);
      return;
  }

  throw Error(y$3(163));
}

function kj(a) {
  var b = a.updateQueue;

  if (null !== b) {
    a.updateQueue = null;
    var c = a.stateNode;
    null === c && (c = a.stateNode = new Ui());
    b.forEach(function (b) {
      var d = lj.bind(null, a, b);
      c.has(b) || (c.add(b), b.then(d, d));
    });
  }
}

function mj(a, b) {
  return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}

var nj = Math.ceil,
    oj = ra.ReactCurrentDispatcher,
    pj = ra.ReactCurrentOwner,
    X$2 = 0,
    U$2 = null,
    Y$1 = null,
    W$2 = 0,
    qj = 0,
    rj = Bf(0),
    V$1 = 0,
    sj = null,
    tj = 0,
    Dg = 0,
    Hi = 0,
    uj = 0,
    vj = null,
    jj = 0,
    Ji = Infinity;

function wj() {
  Ji = O$2() + 500;
}

var Z$2 = null,
    Qi = !1,
    Ri = null,
    Ti = null,
    xj = !1,
    yj = null,
    zj = 90,
    Aj = [],
    Bj = [],
    Cj = null,
    Dj = 0,
    Ej = null,
    Fj = -1,
    Gj = 0,
    Hj = 0,
    Ij = null,
    Jj = !1;

function Hg() {
  return 0 !== (X$2 & 48) ? O$2() : -1 !== Fj ? Fj : Fj = O$2();
}

function Ig(a) {
  a = a.mode;
  if (0 === (a & 2)) return 1;
  if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
  0 === Gj && (Gj = tj);

  if (0 !== kg.transition) {
    0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
    a = Gj;
    var b = 4186112 & ~Hj;
    b &= -b;
    0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
    return b;
  }

  a = eg();
  0 !== (X$2 & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
  return a;
}

function Jg(a, b, c) {
  if (50 < Dj) throw Dj = 0, Ej = null, Error(y$3(185));
  a = Kj(a, b);
  if (null === a) return null;
  $c(a, b, c);
  a === U$2 && (Hi |= b, 4 === V$1 && Ii(a, W$2));
  var d = eg();
  1 === b ? 0 !== (X$2 & 8) && 0 === (X$2 & 48) ? Lj(a) : (Mj(a, c), 0 === X$2 && (wj(), ig())) : (0 === (X$2 & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([a]) : Cj.add(a)), Mj(a, c));
  vj = a;
}

function Kj(a, b) {
  a.lanes |= b;
  var c = a.alternate;
  null !== c && (c.lanes |= b);
  c = a;

  for (a = a["return"]; null !== a;) {
    a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a["return"];
  }

  return 3 === c.tag ? c.stateNode : null;
}

function Mj(a, b) {
  for (var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;) {
    var h = 31 - Vc(g),
        k = 1 << h,
        l = f[h];

    if (-1 === l) {
      if (0 === (k & d) || 0 !== (k & e)) {
        l = b;
        Rc(k);
        var n = F$2;
        f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
      }
    } else l <= b && (a.expiredLanes |= k);

    g &= ~k;
  }

  d = Uc(a, a === U$2 ? W$2 : 0);
  b = F$2;
  if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);else {
    if (null !== c) {
      if (a.callbackPriority === b) return;
      c !== Zf && Pf(c);
    }

    15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [c], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
    a.callbackPriority = b;
    a.callbackNode = c;
  }
}

function Nj(a) {
  Fj = -1;
  Hj = Gj = 0;
  if (0 !== (X$2 & 48)) throw Error(y$3(327));
  var b = a.callbackNode;
  if (Oj() && a.callbackNode !== b) return null;
  var c = Uc(a, a === U$2 ? W$2 : 0);
  if (0 === c) return null;
  var d = c;
  var e = X$2;
  X$2 |= 16;
  var f = Pj();
  if (U$2 !== a || W$2 !== d) wj(), Qj(a, d);

  do {
    try {
      Rj();
      break;
    } catch (h) {
      Sj(a, h);
    }
  } while (1);

  qg();
  oj.current = f;
  X$2 = e;
  null !== Y$1 ? d = 0 : (U$2 = null, W$2 = 0, d = V$1);
  if (0 !== (tj & Hi)) Qj(a, 0);else if (0 !== d) {
    2 === d && (X$2 |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
    if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O$2()), b;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = c;

    switch (d) {
      case 0:
      case 1:
        throw Error(y$3(345));

      case 2:
        Uj(a);
        break;

      case 3:
        Ii(a, c);

        if ((c & 62914560) === c && (d = jj + 500 - O$2(), 10 < d)) {
          if (0 !== Uc(a, 0)) break;
          e = a.suspendedLanes;

          if ((e & c) !== c) {
            Hg();
            a.pingedLanes |= a.suspendedLanes & e;
            break;
          }

          a.timeoutHandle = of(Uj.bind(null, a), d);
          break;
        }

        Uj(a);
        break;

      case 4:
        Ii(a, c);
        if ((c & 4186112) === c) break;
        d = a.eventTimes;

        for (e = -1; 0 < c;) {
          var g = 31 - Vc(c);
          f = 1 << g;
          g = d[g];
          g > e && (e = g);
          c &= ~f;
        }

        c = e;
        c = O$2() - c;
        c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;

        if (10 < c) {
          a.timeoutHandle = of(Uj.bind(null, a), c);
          break;
        }

        Uj(a);
        break;

      case 5:
        Uj(a);
        break;

      default:
        throw Error(y$3(329));
    }
  }
  Mj(a, O$2());
  return a.callbackNode === b ? Nj.bind(null, a) : null;
}

function Ii(a, b) {
  b &= ~uj;
  b &= ~Hi;
  a.suspendedLanes |= b;
  a.pingedLanes &= ~b;

  for (a = a.expirationTimes; 0 < b;) {
    var c = 31 - Vc(b),
        d = 1 << c;
    a[c] = -1;
    b &= ~d;
  }
}

function Lj(a) {
  if (0 !== (X$2 & 48)) throw Error(y$3(327));
  Oj();

  if (a === U$2 && 0 !== (a.expiredLanes & W$2)) {
    var b = W$2;
    var c = Tj(a, b);
    0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
  } else b = Uc(a, 0), c = Tj(a, b);

  0 !== a.tag && 2 === c && (X$2 |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
  if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O$2()), c;
  a.finishedWork = a.current.alternate;
  a.finishedLanes = b;
  Uj(a);
  Mj(a, O$2());
  return null;
}

function Vj() {
  if (null !== Cj) {
    var a = Cj;
    Cj = null;
    a.forEach(function (a) {
      a.expiredLanes |= 24 & a.pendingLanes;
      Mj(a, O$2());
    });
  }

  ig();
}

function Wj(a, b) {
  var c = X$2;
  X$2 |= 1;

  try {
    return a(b);
  } finally {
    X$2 = c, 0 === X$2 && (wj(), ig());
  }
}

function Xj(a, b) {
  var c = X$2;
  X$2 &= -2;
  X$2 |= 8;

  try {
    return a(b);
  } finally {
    X$2 = c, 0 === X$2 && (wj(), ig());
  }
}

function ni(a, b) {
  I$3(rj, qj);
  qj |= b;
  tj |= b;
}

function Ki() {
  qj = rj.current;
  H$3(rj);
}

function Qj(a, b) {
  a.finishedWork = null;
  a.finishedLanes = 0;
  var c = a.timeoutHandle;
  -1 !== c && (a.timeoutHandle = -1, pf(c));
  if (null !== Y$1) for (c = Y$1["return"]; null !== c;) {
    var d = c;

    switch (d.tag) {
      case 1:
        d = d.type.childContextTypes;
        null !== d && void 0 !== d && Gf();
        break;

      case 3:
        fh();
        H$3(N$2);
        H$3(M$2);
        uh();
        break;

      case 5:
        hh(d);
        break;

      case 4:
        fh();
        break;

      case 13:
        H$3(P$2);
        break;

      case 19:
        H$3(P$2);
        break;

      case 10:
        rg(d);
        break;

      case 23:
      case 24:
        Ki();
    }

    c = c["return"];
  }
  U$2 = a;
  Y$1 = Tg(a.current, null);
  W$2 = qj = tj = b;
  V$1 = 0;
  sj = null;
  uj = Hi = Dg = 0;
}

function Sj(a, b) {
  do {
    var c = Y$1;

    try {
      qg();
      vh.current = Gh;

      if (yh) {
        for (var d = R$1.memoizedState; null !== d;) {
          var e = d.queue;
          null !== e && (e.pending = null);
          d = d.next;
        }

        yh = !1;
      }

      xh = 0;
      T$1 = S$2 = R$1 = null;
      zh = !1;
      pj.current = null;

      if (null === c || null === c["return"]) {
        V$1 = 1;
        sj = b;
        Y$1 = null;
        break;
      }

      a: {
        var f = a,
            g = c["return"],
            h = c,
            k = b;
        b = W$2;
        h.flags |= 2048;
        h.firstEffect = h.lastEffect = null;

        if (null !== k && "object" === typeof k && "function" === typeof k.then) {
          var l = k;

          if (0 === (h.mode & 2)) {
            var n = h.alternate;
            n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
          }

          var A = 0 !== (P$2.current & 1),
              p = g;

          do {
            var C;

            if (C = 13 === p.tag) {
              var x = p.memoizedState;
              if (null !== x) C = null !== x.dehydrated ? !0 : !1;else {
                var w = p.memoizedProps;
                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
              }
            }

            if (C) {
              var z = p.updateQueue;

              if (null === z) {
                var u = new Set();
                u.add(l);
                p.updateQueue = u;
              } else z.add(l);

              if (0 === (p.mode & 2)) {
                p.flags |= 64;
                h.flags |= 16384;
                h.flags &= -2981;
                if (1 === h.tag) if (null === h.alternate) h.tag = 17;else {
                  var t = zg(-1, 1);
                  t.tag = 2;
                  Ag(h, t);
                }
                h.lanes |= 1;
                break a;
              }

              k = void 0;
              h = b;
              var q = f.pingCache;
              null === q ? (q = f.pingCache = new Oi(), k = new Set(), q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set(), q.set(l, k)));

              if (!k.has(h)) {
                k.add(h);
                var v = Yj.bind(null, f, l, h);
                l.then(v, v);
              }

              p.flags |= 4096;
              p.lanes = b;
              break a;
            }

            p = p["return"];
          } while (null !== p);

          k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
        }

        5 !== V$1 && (V$1 = 2);
        k = Mi(k, h);
        p = g;

        do {
          switch (p.tag) {
            case 3:
              f = k;
              p.flags |= 4096;
              b &= -b;
              p.lanes |= b;
              var J = Pi(p, f, b);
              Bg(p, J);
              break a;

            case 1:
              f = k;
              var K = p.type,
                  Q = p.stateNode;

              if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                p.flags |= 4096;
                b &= -b;
                p.lanes |= b;
                var L = Si(p, f, b);
                Bg(p, L);
                break a;
              }

          }

          p = p["return"];
        } while (null !== p);
      }

      Zj(c);
    } catch (va) {
      b = va;
      Y$1 === c && null !== c && (Y$1 = c = c["return"]);
      continue;
    }

    break;
  } while (1);
}

function Pj() {
  var a = oj.current;
  oj.current = Gh;
  return null === a ? Gh : a;
}

function Tj(a, b) {
  var c = X$2;
  X$2 |= 16;
  var d = Pj();
  U$2 === a && W$2 === b || Qj(a, b);

  do {
    try {
      ak();
      break;
    } catch (e) {
      Sj(a, e);
    }
  } while (1);

  qg();
  X$2 = c;
  oj.current = d;
  if (null !== Y$1) throw Error(y$3(261));
  U$2 = null;
  W$2 = 0;
  return V$1;
}

function ak() {
  for (; null !== Y$1;) {
    bk(Y$1);
  }
}

function Rj() {
  for (; null !== Y$1 && !Qf();) {
    bk(Y$1);
  }
}

function bk(a) {
  var b = ck(a.alternate, a, qj);
  a.memoizedProps = a.pendingProps;
  null === b ? Zj(a) : Y$1 = b;
  pj.current = null;
}

function Zj(a) {
  var b = a;

  do {
    var c = b.alternate;
    a = b["return"];

    if (0 === (b.flags & 2048)) {
      c = Gi(c, b, qj);

      if (null !== c) {
        Y$1 = c;
        return;
      }

      c = b;

      if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
        for (var d = 0, e = c.child; null !== e;) {
          d |= e.lanes | e.childLanes, e = e.sibling;
        }

        c.childLanes = d;
      }

      null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
    } else {
      c = Li(b);

      if (null !== c) {
        c.flags &= 2047;
        Y$1 = c;
        return;
      }

      null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
    }

    b = b.sibling;

    if (null !== b) {
      Y$1 = b;
      return;
    }

    Y$1 = b = a;
  } while (null !== b);

  0 === V$1 && (V$1 = 5);
}

function Uj(a) {
  var b = eg();
  gg(99, dk.bind(null, a, b));
  return null;
}

function dk(a, b) {
  do {
    Oj();
  } while (null !== yj);

  if (0 !== (X$2 & 48)) throw Error(y$3(327));
  var c = a.finishedWork;
  if (null === c) return null;
  a.finishedWork = null;
  a.finishedLanes = 0;
  if (c === a.current) throw Error(y$3(177));
  a.callbackNode = null;
  var d = c.lanes | c.childLanes,
      e = d,
      f = a.pendingLanes & ~e;
  a.pendingLanes = e;
  a.suspendedLanes = 0;
  a.pingedLanes = 0;
  a.expiredLanes &= e;
  a.mutableReadLanes &= e;
  a.entangledLanes &= e;
  e = a.entanglements;

  for (var g = a.eventTimes, h = a.expirationTimes; 0 < f;) {
    var k = 31 - Vc(f),
        l = 1 << k;
    e[k] = 0;
    g[k] = -1;
    h[k] = -1;
    f &= ~l;
  }

  null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj["delete"](a);
  a === U$2 && (Y$1 = U$2 = null, W$2 = 0);
  1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;

  if (null !== d) {
    e = X$2;
    X$2 |= 32;
    pj.current = null;
    kf = fd;
    g = Ne$1();

    if (Oe(g)) {
      if ("selectionStart" in g) h = {
        start: g.selectionStart,
        end: g.selectionEnd
      };else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
        h = l.anchorNode;
        f = l.anchorOffset;
        k = l.focusNode;
        l = l.focusOffset;

        try {
          h.nodeType, k.nodeType;
        } catch (va) {
          h = null;
          break a;
        }

        var n = 0,
            A = -1,
            p = -1,
            C = 0,
            x = 0,
            w = g,
            z = null;

        b: for (;;) {
          for (var u;;) {
            w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
            w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
            3 === w.nodeType && (n += w.nodeValue.length);
            if (null === (u = w.firstChild)) break;
            z = w;
            w = u;
          }

          for (;;) {
            if (w === g) break b;
            z === h && ++C === f && (A = n);
            z === k && ++x === l && (p = n);
            if (null !== (u = w.nextSibling)) break;
            w = z;
            z = w.parentNode;
          }

          w = u;
        }

        h = -1 === A || -1 === p ? null : {
          start: A,
          end: p
        };
      } else h = null;
      h = h || {
        start: 0,
        end: 0
      };
    } else h = null;

    lf = {
      focusedElem: g,
      selectionRange: h
    };
    fd = !1;
    Ij = null;
    Jj = !1;
    Z$2 = d;

    do {
      try {
        ek();
      } catch (va) {
        if (null === Z$2) throw Error(y$3(330));
        Wi(Z$2, va);
        Z$2 = Z$2.nextEffect;
      }
    } while (null !== Z$2);

    Ij = null;
    Z$2 = d;

    do {
      try {
        for (g = a; null !== Z$2;) {
          var t = Z$2.flags;
          t & 16 && pb(Z$2.stateNode, "");

          if (t & 128) {
            var q = Z$2.alternate;

            if (null !== q) {
              var v = q.ref;
              null !== v && ("function" === typeof v ? v(null) : v.current = null);
            }
          }

          switch (t & 1038) {
            case 2:
              fj(Z$2);
              Z$2.flags &= -3;
              break;

            case 6:
              fj(Z$2);
              Z$2.flags &= -3;
              ij(Z$2.alternate, Z$2);
              break;

            case 1024:
              Z$2.flags &= -1025;
              break;

            case 1028:
              Z$2.flags &= -1025;
              ij(Z$2.alternate, Z$2);
              break;

            case 4:
              ij(Z$2.alternate, Z$2);
              break;

            case 8:
              h = Z$2;
              cj(g, h);
              var J = h.alternate;
              dj(h);
              null !== J && dj(J);
          }

          Z$2 = Z$2.nextEffect;
        }
      } catch (va) {
        if (null === Z$2) throw Error(y$3(330));
        Wi(Z$2, va);
        Z$2 = Z$2.nextEffect;
      }
    } while (null !== Z$2);

    v = lf;
    q = Ne$1();
    t = v.focusedElem;
    g = v.selectionRange;

    if (q !== t && t && t.ownerDocument && Me$1(t.ownerDocument.documentElement, t)) {
      null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
      q = [];

      for (v = t; v = v.parentNode;) {
        1 === v.nodeType && q.push({
          element: v,
          left: v.scrollLeft,
          top: v.scrollTop
        });
      }

      "function" === typeof t.focus && t.focus();

      for (t = 0; t < q.length; t++) {
        v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
      }
    }

    fd = !!kf;
    lf = kf = null;
    a.current = c;
    Z$2 = d;

    do {
      try {
        for (t = a; null !== Z$2;) {
          var K = Z$2.flags;
          K & 36 && Yi(t, Z$2.alternate, Z$2);

          if (K & 128) {
            q = void 0;
            var Q = Z$2.ref;

            if (null !== Q) {
              var L = Z$2.stateNode;

              switch (Z$2.tag) {
                case 5:
                  q = L;
                  break;

                default:
                  q = L;
              }

              "function" === typeof Q ? Q(q) : Q.current = q;
            }
          }

          Z$2 = Z$2.nextEffect;
        }
      } catch (va) {
        if (null === Z$2) throw Error(y$3(330));
        Wi(Z$2, va);
        Z$2 = Z$2.nextEffect;
      }
    } while (null !== Z$2);

    Z$2 = null;
    $f();
    X$2 = e;
  } else a.current = c;

  if (xj) xj = !1, yj = a, zj = b;else for (Z$2 = d; null !== Z$2;) {
    b = Z$2.nextEffect, Z$2.nextEffect = null, Z$2.flags & 8 && (K = Z$2, K.sibling = null, K.stateNode = null), Z$2 = b;
  }
  d = a.pendingLanes;
  0 === d && (Ti = null);
  1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
  c = c.stateNode;
  if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
    Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
  } catch (va) {}
  Mj(a, O$2());
  if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
  if (0 !== (X$2 & 8)) return null;
  ig();
  return null;
}

function ek() {
  for (; null !== Z$2;) {
    var a = Z$2.alternate;
    Jj || null === Ij || (0 !== (Z$2.flags & 8) ? dc(Z$2, Ij) && (Jj = !0) : 13 === Z$2.tag && mj(a, Z$2) && dc(Z$2, Ij) && (Jj = !0));
    var b = Z$2.flags;
    0 !== (b & 256) && Xi(a, Z$2);
    0 === (b & 512) || xj || (xj = !0, hg(97, function () {
      Oj();
      return null;
    }));
    Z$2 = Z$2.nextEffect;
  }
}

function Oj() {
  if (90 !== zj) {
    var a = 97 < zj ? 97 : zj;
    zj = 90;
    return gg(a, fk);
  }

  return !1;
}

function $i(a, b) {
  Aj.push(b, a);
  xj || (xj = !0, hg(97, function () {
    Oj();
    return null;
  }));
}

function Zi(a, b) {
  Bj.push(b, a);
  xj || (xj = !0, hg(97, function () {
    Oj();
    return null;
  }));
}

function fk() {
  if (null === yj) return !1;
  var a = yj;
  yj = null;
  if (0 !== (X$2 & 48)) throw Error(y$3(331));
  var b = X$2;
  X$2 |= 32;
  var c = Bj;
  Bj = [];

  for (var d = 0; d < c.length; d += 2) {
    var e = c[d],
        f = c[d + 1],
        g = e.destroy;
    e.destroy = void 0;
    if ("function" === typeof g) try {
      g();
    } catch (k) {
      if (null === f) throw Error(y$3(330));
      Wi(f, k);
    }
  }

  c = Aj;
  Aj = [];

  for (d = 0; d < c.length; d += 2) {
    e = c[d];
    f = c[d + 1];

    try {
      var h = e.create;
      e.destroy = h();
    } catch (k) {
      if (null === f) throw Error(y$3(330));
      Wi(f, k);
    }
  }

  for (h = a.current.firstEffect; null !== h;) {
    a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
  }

  X$2 = b;
  ig();
  return !0;
}

function gk(a, b, c) {
  b = Mi(c, b);
  b = Pi(a, b, 1);
  Ag(a, b);
  b = Hg();
  a = Kj(a, 1);
  null !== a && ($c(a, 1, b), Mj(a, b));
}

function Wi(a, b) {
  if (3 === a.tag) gk(a, a, b);else for (var c = a["return"]; null !== c;) {
    if (3 === c.tag) {
      gk(c, a, b);
      break;
    } else if (1 === c.tag) {
      var d = c.stateNode;

      if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
        a = Mi(b, a);
        var e = Si(c, a, 1);
        Ag(c, e);
        e = Hg();
        c = Kj(c, 1);
        if (null !== c) $c(c, 1, e), Mj(c, e);else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
          d.componentDidCatch(b, a);
        } catch (f) {}
        break;
      }
    }

    c = c["return"];
  }
}

function Yj(a, b, c) {
  var d = a.pingCache;
  null !== d && d["delete"](b);
  b = Hg();
  a.pingedLanes |= a.suspendedLanes & c;
  U$2 === a && (W$2 & c) === c && (4 === V$1 || 3 === V$1 && (W$2 & 62914560) === W$2 && 500 > O$2() - jj ? Qj(a, 0) : uj |= c);
  Mj(a, b);
}

function lj(a, b) {
  var c = a.stateNode;
  null !== c && c["delete"](b);
  b = 0;
  0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
  c = Hg();
  a = Kj(a, b);
  null !== a && ($c(a, b, c), Mj(a, c));
}

var ck;

ck = function ck(a, b, c) {
  var d = b.lanes;
  if (null !== a) {
    if (a.memoizedProps !== b.pendingProps || N$2.current) ug = !0;else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;else {
      ug = !1;

      switch (b.tag) {
        case 3:
          ri(b);
          sh();
          break;

        case 5:
          gh(b);
          break;

        case 1:
          Ff(b.type) && Jf(b);
          break;

        case 4:
          eh(b, b.stateNode.containerInfo);
          break;

        case 10:
          d = b.memoizedProps.value;
          var e = b.type._context;
          I$3(mg, e._currentValue);
          e._currentValue = d;
          break;

        case 13:
          if (null !== b.memoizedState) {
            if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
            I$3(P$2, P$2.current & 1);
            b = hi(a, b, c);
            return null !== b ? b.sibling : null;
          }

          I$3(P$2, P$2.current & 1);
          break;

        case 19:
          d = 0 !== (c & b.childLanes);

          if (0 !== (a.flags & 64)) {
            if (d) return Ai(a, b, c);
            b.flags |= 64;
          }

          e = b.memoizedState;
          null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
          I$3(P$2, P$2.current);
          if (d) break;else return null;

        case 23:
        case 24:
          return b.lanes = 0, mi(a, b, c);
      }

      return hi(a, b, c);
    }
  } else ug = !1;
  b.lanes = 0;

  switch (b.tag) {
    case 2:
      d = b.type;
      null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
      a = b.pendingProps;
      e = Ef(b, M$2.current);
      tg(b, c);
      e = Ch(null, b, d, a, e, c);
      b.flags |= 1;

      if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
        b.tag = 1;
        b.memoizedState = null;
        b.updateQueue = null;

        if (Ff(d)) {
          var f = !0;
          Jf(b);
        } else f = !1;

        b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
        xg(b);
        var g = d.getDerivedStateFromProps;
        "function" === typeof g && Gg(b, d, g, a);
        e.updater = Kg;
        b.stateNode = e;
        e._reactInternals = b;
        Og(b, d, a, c);
        b = qi(null, b, d, !0, f, c);
      } else b.tag = 0, fi(null, b, e, c), b = b.child;

      return b;

    case 16:
      e = b.elementType;

      a: {
        null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
        a = b.pendingProps;
        f = e._init;
        e = f(e._payload);
        b.type = e;
        f = b.tag = hk(e);
        a = lg(e, a);

        switch (f) {
          case 0:
            b = li(null, b, e, a, c);
            break a;

          case 1:
            b = pi(null, b, e, a, c);
            break a;

          case 11:
            b = gi(null, b, e, a, c);
            break a;

          case 14:
            b = ii(null, b, e, lg(e.type, a), d, c);
            break a;
        }

        throw Error(y$3(306, e, ""));
      }

      return b;

    case 0:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);

    case 1:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);

    case 3:
      ri(b);
      d = b.updateQueue;
      if (null === a || null === d) throw Error(y$3(282));
      d = b.pendingProps;
      e = b.memoizedState;
      e = null !== e ? e.element : null;
      yg(a, b);
      Cg(b, d, null, c);
      d = b.memoizedState.element;
      if (d === e) sh(), b = hi(a, b, c);else {
        e = b.stateNode;
        if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;

        if (f) {
          a = e.mutableSourceEagerHydrationData;
          if (null != a) for (e = 0; e < a.length; e += 2) {
            f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
          }
          c = Zg(b, null, d, c);

          for (b.child = c; c;) {
            c.flags = c.flags & -3 | 1024, c = c.sibling;
          }
        } else fi(a, b, d, c), sh();

        b = b.child;
      }
      return b;

    case 5:
      return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;

    case 6:
      return null === a && ph(b), null;

    case 13:
      return ti(a, b, c);

    case 4:
      return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;

    case 11:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);

    case 7:
      return fi(a, b, b.pendingProps, c), b.child;

    case 8:
      return fi(a, b, b.pendingProps.children, c), b.child;

    case 12:
      return fi(a, b, b.pendingProps.children, c), b.child;

    case 10:
      a: {
        d = b.type._context;
        e = b.pendingProps;
        g = b.memoizedProps;
        f = e.value;
        var h = b.type._context;
        I$3(mg, h._currentValue);
        h._currentValue = f;
        if (null !== g) if (h = g.value, f = He$1(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
          if (g.children === e.children && !N$2.current) {
            b = hi(a, b, c);
            break a;
          }
        } else for (h = b.child, null !== h && (h["return"] = b); null !== h;) {
          var k = h.dependencies;

          if (null !== k) {
            g = h.child;

            for (var l = k.firstContext; null !== l;) {
              if (l.context === d && 0 !== (l.observedBits & f)) {
                1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                h.lanes |= c;
                l = h.alternate;
                null !== l && (l.lanes |= c);
                sg(h["return"], c);
                k.lanes |= c;
                break;
              }

              l = l.next;
            }
          } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;

          if (null !== g) g["return"] = h;else for (g = h; null !== g;) {
            if (g === b) {
              g = null;
              break;
            }

            h = g.sibling;

            if (null !== h) {
              h["return"] = g["return"];
              g = h;
              break;
            }

            g = g["return"];
          }
          h = g;
        }
        fi(a, b, e.children, c);
        b = b.child;
      }

      return b;

    case 9:
      return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;

    case 14:
      return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);

    case 15:
      return ki(a, b, b.type, b.pendingProps, d, c);

    case 17:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);

    case 19:
      return Ai(a, b, c);

    case 23:
      return mi(a, b, c);

    case 24:
      return mi(a, b, c);
  }

  throw Error(y$3(156, b.tag));
};

function ik(a, b, c, d) {
  this.tag = a;
  this.key = c;
  this.sibling = this.child = this["return"] = this.stateNode = this.type = this.elementType = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = b;
  this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
  this.mode = d;
  this.flags = 0;
  this.lastEffect = this.firstEffect = this.nextEffect = null;
  this.childLanes = this.lanes = 0;
  this.alternate = null;
}

function nh(a, b, c, d) {
  return new ik(a, b, c, d);
}

function ji(a) {
  a = a.prototype;
  return !(!a || !a.isReactComponent);
}

function hk(a) {
  if ("function" === typeof a) return ji(a) ? 1 : 0;

  if (void 0 !== a && null !== a) {
    a = a.$$typeof;
    if (a === Aa) return 11;
    if (a === Da) return 14;
  }

  return 2;
}

function Tg(a, b) {
  var c = a.alternate;
  null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
  c.childLanes = a.childLanes;
  c.lanes = a.lanes;
  c.child = a.child;
  c.memoizedProps = a.memoizedProps;
  c.memoizedState = a.memoizedState;
  c.updateQueue = a.updateQueue;
  b = a.dependencies;
  c.dependencies = null === b ? null : {
    lanes: b.lanes,
    firstContext: b.firstContext
  };
  c.sibling = a.sibling;
  c.index = a.index;
  c.ref = a.ref;
  return c;
}

function Vg(a, b, c, d, e, f) {
  var g = 2;
  d = a;
  if ("function" === typeof a) ji(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {
    case ua:
      return Xg(c.children, e, f, b);

    case Ha:
      g = 8;
      e |= 16;
      break;

    case wa:
      g = 8;
      e |= 1;
      break;

    case xa:
      return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;

    case Ba:
      return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;

    case Ca:
      return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;

    case Ia:
      return vi(c, e, f, b);

    case Ja:
      return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;

    default:
      if ("object" === typeof a && null !== a) switch (a.$$typeof) {
        case ya:
          g = 10;
          break a;

        case za:
          g = 9;
          break a;

        case Aa:
          g = 11;
          break a;

        case Da:
          g = 14;
          break a;

        case Ea:
          g = 16;
          d = null;
          break a;

        case Fa:
          g = 22;
          break a;
      }
      throw Error(y$3(130, null == a ? a : typeof a, ""));
  }
  b = nh(g, c, b, e);
  b.elementType = a;
  b.type = d;
  b.lanes = f;
  return b;
}

function Xg(a, b, c, d) {
  a = nh(7, a, d, b);
  a.lanes = c;
  return a;
}

function vi(a, b, c, d) {
  a = nh(23, a, d, b);
  a.elementType = Ia;
  a.lanes = c;
  return a;
}

function Ug(a, b, c) {
  a = nh(6, a, null, b);
  a.lanes = c;
  return a;
}

function Wg(a, b, c) {
  b = nh(4, null !== a.children ? a.children : [], a.key, b);
  b.lanes = c;
  b.stateNode = {
    containerInfo: a.containerInfo,
    pendingChildren: null,
    implementation: a.implementation
  };
  return b;
}

function jk(a, b, c) {
  this.tag = b;
  this.containerInfo = a;
  this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
  this.timeoutHandle = -1;
  this.pendingContext = this.context = null;
  this.hydrate = c;
  this.callbackNode = null;
  this.callbackPriority = 0;
  this.eventTimes = Zc(0);
  this.expirationTimes = Zc(-1);
  this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
  this.entanglements = Zc(0);
  this.mutableSourceEagerHydrationData = null;
}

function kk(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
  return {
    $$typeof: ta,
    key: null == d ? null : "" + d,
    children: a,
    containerInfo: b,
    implementation: c
  };
}

function lk(a, b, c, d) {
  var e = b.current,
      f = Hg(),
      g = Ig(e);

  a: if (c) {
    c = c._reactInternals;

    b: {
      if (Zb(c) !== c || 1 !== c.tag) throw Error(y$3(170));
      var h = c;

      do {
        switch (h.tag) {
          case 3:
            h = h.stateNode.context;
            break b;

          case 1:
            if (Ff(h.type)) {
              h = h.stateNode.__reactInternalMemoizedMergedChildContext;
              break b;
            }

        }

        h = h["return"];
      } while (null !== h);

      throw Error(y$3(171));
    }

    if (1 === c.tag) {
      var k = c.type;

      if (Ff(k)) {
        c = If(c, k, h);
        break a;
      }
    }

    c = h;
  } else c = Cf;

  null === b.context ? b.context = c : b.pendingContext = c;
  b = zg(f, g);
  b.payload = {
    element: a
  };
  d = void 0 === d ? null : d;
  null !== d && (b.callback = d);
  Ag(e, b);
  Jg(e, g, f);
  return g;
}

function mk(a) {
  a = a.current;
  if (!a.child) return null;

  switch (a.child.tag) {
    case 5:
      return a.child.stateNode;

    default:
      return a.child.stateNode;
  }
}

function nk(a, b) {
  a = a.memoizedState;

  if (null !== a && null !== a.dehydrated) {
    var c = a.retryLane;
    a.retryLane = 0 !== c && c < b ? c : b;
  }
}

function ok(a, b) {
  nk(a, b);
  (a = a.alternate) && nk(a, b);
}

function pk() {
  return null;
}

function qk(a, b, c) {
  var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
  c = new jk(a, b, null != c && !0 === c.hydrate);
  b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
  c.current = b;
  b.stateNode = c;
  xg(b);
  a[ff] = c.current;
  cf(8 === a.nodeType ? a.parentNode : a);
  if (d) for (a = 0; a < d.length; a++) {
    b = d[a];
    var e = b._getVersion;
    e = e(b._source);
    null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [b, e] : c.mutableSourceEagerHydrationData.push(b, e);
  }
  this._internalRoot = c;
}

qk.prototype.render = function (a) {
  lk(a, this._internalRoot, null, null);
};

qk.prototype.unmount = function () {
  var a = this._internalRoot,
      b = a.containerInfo;
  lk(null, a, null, function () {
    b[ff] = null;
  });
};

function rk(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}

function sk(a, b) {
  b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
  if (!b) for (var c; c = a.lastChild;) {
    a.removeChild(c);
  }
  return new qk(a, 0, b ? {
    hydrate: !0
  } : void 0);
}

function tk(a, b, c, d, e) {
  var f = c._reactRootContainer;

  if (f) {
    var g = f._internalRoot;

    if ("function" === typeof e) {
      var h = e;

      e = function e() {
        var a = mk(g);
        h.call(a);
      };
    }

    lk(b, g, a, e);
  } else {
    f = c._reactRootContainer = sk(c, d);
    g = f._internalRoot;

    if ("function" === typeof e) {
      var k = e;

      e = function e() {
        var a = mk(g);
        k.call(a);
      };
    }

    Xj(function () {
      lk(b, g, a, e);
    });
  }

  return mk(g);
}

ec = function ec(a) {
  if (13 === a.tag) {
    var b = Hg();
    Jg(a, 4, b);
    ok(a, 4);
  }
};

fc = function fc(a) {
  if (13 === a.tag) {
    var b = Hg();
    Jg(a, 67108864, b);
    ok(a, 67108864);
  }
};

gc = function gc(a) {
  if (13 === a.tag) {
    var b = Hg(),
        c = Ig(a);
    Jg(a, c, b);
    ok(a, c);
  }
};

hc = function hc(a, b) {
  return b();
};

yb = function yb(a, b, c) {
  switch (b) {
    case "input":
      ab(a, c);
      b = c.name;

      if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode;) {
          c = c.parentNode;
        }

        c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');

        for (b = 0; b < c.length; b++) {
          var d = c[b];

          if (d !== a && d.form === a.form) {
            var e = Db(d);
            if (!e) throw Error(y$3(90));
            Wa(d);
            ab(d, e);
          }
        }
      }

      break;

    case "textarea":
      ib(a, c);
      break;

    case "select":
      b = c.value, null != b && fb(a, !!c.multiple, b, !1);
  }
};

Gb = Wj;

Hb = function Hb(a, b, c, d, e) {
  var f = X$2;
  X$2 |= 4;

  try {
    return gg(98, a.bind(null, b, c, d, e));
  } finally {
    X$2 = f, 0 === X$2 && (wj(), ig());
  }
};

Ib = function Ib() {
  0 === (X$2 & 49) && (Vj(), Oj());
};

Jb = function Jb(a, b) {
  var c = X$2;
  X$2 |= 2;

  try {
    return a(b);
  } finally {
    X$2 = c, 0 === X$2 && (wj(), ig());
  }
};

function uk(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
  if (!rk(b)) throw Error(y$3(200));
  return kk(a, b, null, c);
}

var vk = {
  Events: [Cb, ue$1, Db, Eb, Fb, Oj, {
    current: !1
  }]
},
    wk = {
  findFiberByHostInstance: wc,
  bundleType: 0,
  version: "17.0.2",
  rendererPackageName: "react-dom"
};
var xk = {
  bundleType: wk.bundleType,
  version: wk.version,
  rendererPackageName: wk.rendererPackageName,
  rendererConfig: wk.rendererConfig,
  overrideHookState: null,
  overrideHookStateDeletePath: null,
  overrideHookStateRenamePath: null,
  overrideProps: null,
  overridePropsDeletePath: null,
  overridePropsRenamePath: null,
  setSuspenseHandler: null,
  scheduleUpdate: null,
  currentDispatcherRef: ra.ReactCurrentDispatcher,
  findHostInstanceByFiber: function findHostInstanceByFiber(a) {
    a = cc(a);
    return null === a ? null : a.stateNode;
  },
  findFiberByHostInstance: wk.findFiberByHostInstance || pk,
  findHostInstancesForRefresh: null,
  scheduleRefresh: null,
  scheduleRoot: null,
  setRefreshHandler: null,
  getCurrentFiber: null
};

if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
  var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!yk.isDisabled && yk.supportsFiber) try {
    Lf = yk.inject(xk), Mf = yk;
  } catch (a) {}
}

reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
reactDom_production_min.createPortal = uk;

reactDom_production_min.findDOMNode = function (a) {
  if (null == a) return null;
  if (1 === a.nodeType) return a;
  var b = a._reactInternals;

  if (void 0 === b) {
    if ("function" === typeof a.render) throw Error(y$3(188));
    throw Error(y$3(268, Object.keys(a)));
  }

  a = cc(b);
  a = null === a ? null : a.stateNode;
  return a;
};

reactDom_production_min.flushSync = function (a, b) {
  var c = X$2;
  if (0 !== (c & 48)) return a(b);
  X$2 |= 1;

  try {
    if (a) return gg(99, a.bind(null, b));
  } finally {
    X$2 = c, ig();
  }
};

reactDom_production_min.hydrate = function (a, b, c) {
  if (!rk(b)) throw Error(y$3(200));
  return tk(null, a, b, !0, c);
};

reactDom_production_min.render = function (a, b, c) {
  if (!rk(b)) throw Error(y$3(200));
  return tk(null, a, b, !1, c);
};

reactDom_production_min.unmountComponentAtNode = function (a) {
  if (!rk(a)) throw Error(y$3(40));
  return a._reactRootContainer ? (Xj(function () {
    tk(null, null, a, !1, function () {
      a._reactRootContainer = null;
      a[ff] = null;
    });
  }), !0) : !1;
};

reactDom_production_min.unstable_batchedUpdates = Wj;

reactDom_production_min.unstable_createPortal = function (a, b) {
  return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};

reactDom_production_min.unstable_renderSubtreeIntoContainer = function (a, b, c, d) {
  if (!rk(c)) throw Error(y$3(200));
  if (null == a || void 0 === a._reactInternals) throw Error(y$3(38));
  return tk(a, b, c, !1, d);
};

reactDom_production_min.version = "17.0.2";

function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
    return;
  }

  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

{
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  reactDom.exports = reactDom_production_min;
}

var ReactDOM = reactDom.exports;

function _defineProperty$g(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _arrayLikeToArray$8(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$8(arr);
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray$8(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$8(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$8(arr) || _nonIterableSpread$1();
}

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$2(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$8(arr, i) || _nonIterableRest$2();
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$3(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

var runtime = {exports: {}};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (module) {
var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
}(runtime));

var regenerator = runtime.exports;

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$2(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var reactIs$2 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b$3 = "function" === typeof Symbol && Symbol["for"],
    c$2 = b$3 ? Symbol["for"]("react.element") : 60103,
    d$2 = b$3 ? Symbol["for"]("react.portal") : 60106,
    e$1 = b$3 ? Symbol["for"]("react.fragment") : 60107,
    f$2 = b$3 ? Symbol["for"]("react.strict_mode") : 60108,
    g$3 = b$3 ? Symbol["for"]("react.profiler") : 60114,
    h$2 = b$3 ? Symbol["for"]("react.provider") : 60109,
    k$3 = b$3 ? Symbol["for"]("react.context") : 60110,
    l$2 = b$3 ? Symbol["for"]("react.async_mode") : 60111,
    m$1 = b$3 ? Symbol["for"]("react.concurrent_mode") : 60111,
    n$3 = b$3 ? Symbol["for"]("react.forward_ref") : 60112,
    p$2 = b$3 ? Symbol["for"]("react.suspense") : 60113,
    q$3 = b$3 ? Symbol["for"]("react.suspense_list") : 60120,
    r$3 = b$3 ? Symbol["for"]("react.memo") : 60115,
    t$1 = b$3 ? Symbol["for"]("react.lazy") : 60116,
    v$3 = b$3 ? Symbol["for"]("react.block") : 60121,
    w$3 = b$3 ? Symbol["for"]("react.fundamental") : 60117,
    x$3 = b$3 ? Symbol["for"]("react.responder") : 60118,
    y$2 = b$3 ? Symbol["for"]("react.scope") : 60119;

function z$3(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c$2:
        switch (a = a.type, a) {
          case l$2:
          case m$1:
          case e$1:
          case g$3:
          case f$2:
          case p$2:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k$3:
              case n$3:
              case t$1:
              case r$3:
              case h$2:
                return a;

              default:
                return u;
            }

        }

      case d$2:
        return u;
    }
  }
}

function A$3(a) {
  return z$3(a) === m$1;
}

reactIs_production_min$1.AsyncMode = l$2;
reactIs_production_min$1.ConcurrentMode = m$1;
reactIs_production_min$1.ContextConsumer = k$3;
reactIs_production_min$1.ContextProvider = h$2;
reactIs_production_min$1.Element = c$2;
reactIs_production_min$1.ForwardRef = n$3;
reactIs_production_min$1.Fragment = e$1;
reactIs_production_min$1.Lazy = t$1;
reactIs_production_min$1.Memo = r$3;
reactIs_production_min$1.Portal = d$2;
reactIs_production_min$1.Profiler = g$3;
reactIs_production_min$1.StrictMode = f$2;
reactIs_production_min$1.Suspense = p$2;

reactIs_production_min$1.isAsyncMode = function (a) {
  return A$3(a) || z$3(a) === l$2;
};

reactIs_production_min$1.isConcurrentMode = A$3;

reactIs_production_min$1.isContextConsumer = function (a) {
  return z$3(a) === k$3;
};

reactIs_production_min$1.isContextProvider = function (a) {
  return z$3(a) === h$2;
};

reactIs_production_min$1.isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$2;
};

reactIs_production_min$1.isForwardRef = function (a) {
  return z$3(a) === n$3;
};

reactIs_production_min$1.isFragment = function (a) {
  return z$3(a) === e$1;
};

reactIs_production_min$1.isLazy = function (a) {
  return z$3(a) === t$1;
};

reactIs_production_min$1.isMemo = function (a) {
  return z$3(a) === r$3;
};

reactIs_production_min$1.isPortal = function (a) {
  return z$3(a) === d$2;
};

reactIs_production_min$1.isProfiler = function (a) {
  return z$3(a) === g$3;
};

reactIs_production_min$1.isStrictMode = function (a) {
  return z$3(a) === f$2;
};

reactIs_production_min$1.isSuspense = function (a) {
  return z$3(a) === p$2;
};

reactIs_production_min$1.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$1 || a === g$3 || a === f$2 || a === p$2 || a === q$3 || "object" === typeof a && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$3 || a.$$typeof === h$2 || a.$$typeof === k$3 || a.$$typeof === n$3 || a.$$typeof === w$3 || a.$$typeof === x$3 || a.$$typeof === y$2 || a.$$typeof === v$3);
};

reactIs_production_min$1.typeOf = z$3;

{
  reactIs$2.exports = reactIs_production_min$1;
}

//
var shallowequal = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];
    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
};

function stylis_min(W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {}

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize$4(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index$2 = memoize$4(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var reactIs$1 = reactIs$2.exports;
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs$1.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$6 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf$2 = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf$2(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$6(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function v$2() {
  return (v$2 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var g$2 = function g(e, t) {
  for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1) {
    n.push(t[r], e[r + 1]);
  }

  return n;
},
    S$1 = function S(t) {
  return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !reactIs$2.exports.typeOf(t);
},
    w$2 = Object.freeze([]),
    E$2 = Object.freeze({});

function b$2(e) {
  return "function" == typeof e;
}

function _$1(e) {
  return e.displayName || e.name || "Component";
}

function N$1(e) {
  return e && "string" == typeof e.styledComponentId;
}

var A$2 = "undefined" != typeof process && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled",
    I$2 = "undefined" != typeof window && "HTMLElement" in window,
    P$1 = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY ? "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY : "production" !== "production"),
    O$1 = {};

function j$1(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
    n[r - 1] = arguments[r];
  }

  throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : "")) ;
}

var T = function () {
  function e(e) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
  }

  var t = e.prototype;
  return t.indexOfGroup = function (e) {
    for (var t = 0, n = 0; n < e; n++) {
      t += this.groupSizes[n];
    }

    return t;
  }, t.insertRules = function (e, t) {
    if (e >= this.groupSizes.length) {
      for (var n = this.groupSizes, r = n.length, o = r; e >= o;) {
        (o <<= 1) < 0 && j$1(16, "" + e);
      }

      this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;

      for (var s = r; s < o; s++) {
        this.groupSizes[s] = 0;
      }
    }

    for (var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++) {
      this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }
  }, t.clearGroup = function (e) {
    if (e < this.length) {
      var t = this.groupSizes[e],
          n = this.indexOfGroup(e),
          r = n + t;
      this.groupSizes[e] = 0;

      for (var o = n; o < r; o++) {
        this.tag.deleteRule(n);
      }
    }
  }, t.getGroup = function (e) {
    var t = "";
    if (e >= this.length || 0 === this.groupSizes[e]) return t;

    for (var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++) {
      t += this.tag.getRule(s) + "/*!sc*/\n";
    }

    return t;
  }, e;
}(),
    x$2 = new Map(),
    k$2 = new Map(),
    V = 1,
    B$2 = function B(e) {
  if (x$2.has(e)) return x$2.get(e);

  for (; k$2.has(V);) {
    V++;
  }

  var t = V++;
  return x$2.set(e, t), k$2.set(t, e), t;
},
    z$2 = function z(e) {
  return k$2.get(e);
},
    M$1 = function M(e, t) {
  t >= V && (V = t + 1), x$2.set(e, t), k$2.set(t, e);
},
    G$2 = "style[" + A$2 + '][data-styled-version="5.3.3"]',
    L$1 = new RegExp("^" + A$2 + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),
    F$1 = function F(e, t, n) {
  for (var r, o = n.split(","), s = 0, i = o.length; s < i; s++) {
    (r = o[s]) && e.registerName(t, r);
  }
},
    Y = function Y(e, t) {
  for (var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++) {
    var i = n[o].trim();

    if (i) {
      var a = i.match(L$1);

      if (a) {
        var c = 0 | parseInt(a[1], 10),
            u = a[2];
        0 !== c && (M$1(u, c), F$1(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
      } else r.push(i);
    }
  }
},
    q$2 = function q() {
  return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
},
    H$2 = function H(e) {
  var t = document.head,
      n = e || t,
      r = document.createElement("style"),
      o = function (e) {
    for (var t = e.childNodes, n = t.length; n >= 0; n--) {
      var r = t[n];
      if (r && 1 === r.nodeType && r.hasAttribute(A$2)) return r;
    }
  }(n),
      s = void 0 !== o ? o.nextSibling : null;

  r.setAttribute(A$2, "active"), r.setAttribute("data-styled-version", "5.3.3");
  var i = q$2();
  return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
},
    $ = function () {
  function e(e) {
    var t = this.element = H$2(e);
    t.appendChild(document.createTextNode("")), this.sheet = function (e) {
      if (e.sheet) return e.sheet;

      for (var t = document.styleSheets, n = 0, r = t.length; n < r; n++) {
        var o = t[n];
        if (o.ownerNode === e) return o;
      }

      j$1(17);
    }(t), this.length = 0;
  }

  var t = e.prototype;
  return t.insertRule = function (e, t) {
    try {
      return this.sheet.insertRule(t, e), this.length++, !0;
    } catch (e) {
      return !1;
    }
  }, t.deleteRule = function (e) {
    this.sheet.deleteRule(e), this.length--;
  }, t.getRule = function (e) {
    var t = this.sheet.cssRules[e];
    return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
  }, e;
}(),
    W$1 = function () {
  function e(e) {
    var t = this.element = H$2(e);
    this.nodes = t.childNodes, this.length = 0;
  }

  var t = e.prototype;
  return t.insertRule = function (e, t) {
    if (e <= this.length && e >= 0) {
      var n = document.createTextNode(t),
          r = this.nodes[e];
      return this.element.insertBefore(n, r || null), this.length++, !0;
    }

    return !1;
  }, t.deleteRule = function (e) {
    this.element.removeChild(this.nodes[e]), this.length--;
  }, t.getRule = function (e) {
    return e < this.length ? this.nodes[e].textContent : "";
  }, e;
}(),
    U$1 = function () {
  function e(e) {
    this.rules = [], this.length = 0;
  }

  var t = e.prototype;
  return t.insertRule = function (e, t) {
    return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
  }, t.deleteRule = function (e) {
    this.rules.splice(e, 1), this.length--;
  }, t.getRule = function (e) {
    return e < this.length ? this.rules[e] : "";
  }, e;
}(),
    J = I$2,
    X$1 = {
  isServer: !I$2,
  useCSSOMInjection: !P$1
},
    Z$1 = function () {
  function e(e, t, n) {
    void 0 === e && (e = E$2), void 0 === t && (t = {}), this.options = v$2({}, X$1, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && I$2 && J && (J = !1, function (e) {
      for (var t = document.querySelectorAll(G$2), n = 0, r = t.length; n < r; n++) {
        var o = t[n];
        o && "active" !== o.getAttribute(A$2) && (Y(e, o), o.parentNode && o.parentNode.removeChild(o));
      }
    }(this));
  }

  e.registerId = function (e) {
    return B$2(e);
  };

  var t = e.prototype;
  return t.reconstructWithOptions = function (t, n) {
    return void 0 === n && (n = !0), new e(v$2({}, this.options, {}, t), this.gs, n && this.names || void 0);
  }, t.allocateGSInstance = function (e) {
    return this.gs[e] = (this.gs[e] || 0) + 1;
  }, t.getTag = function () {
    return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new U$1(o) : r ? new $(o) : new W$1(o), new T(e)));
    var e, t, n, r, o;
  }, t.hasNameForId = function (e, t) {
    return this.names.has(e) && this.names.get(e).has(t);
  }, t.registerName = function (e, t) {
    if (B$2(e), this.names.has(e)) this.names.get(e).add(t);else {
      var n = new Set();
      n.add(t), this.names.set(e, n);
    }
  }, t.insertRules = function (e, t, n) {
    this.registerName(e, t), this.getTag().insertRules(B$2(e), n);
  }, t.clearNames = function (e) {
    this.names.has(e) && this.names.get(e).clear();
  }, t.clearRules = function (e) {
    this.getTag().clearGroup(B$2(e)), this.clearNames(e);
  }, t.clearTag = function () {
    this.tag = void 0;
  }, t.toString = function () {
    return function (e) {
      for (var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++) {
        var s = z$2(o);

        if (void 0 !== s) {
          var i = e.names.get(s),
              a = t.getGroup(o);

          if (i && a && i.size) {
            var c = A$2 + ".g" + o + '[id="' + s + '"]',
                u = "";
            void 0 !== i && i.forEach(function (e) {
              e.length > 0 && (u += e + ",");
            }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
          }
        }
      }

      return r;
    }(this);
  }, e;
}(),
    K = /(a)(d)/gi,
    Q$1 = function Q(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};

function ee(e) {
  var t,
      n = "";

  for (t = Math.abs(e); t > 52; t = t / 52 | 0) {
    n = Q$1(t % 52) + n;
  }

  return (Q$1(t % 52) + n).replace(K, "$1-$2");
}

var te = function te(e, t) {
  for (var n = t.length; n;) {
    e = 33 * e ^ t.charCodeAt(--n);
  }

  return e;
},
    ne = function ne(e) {
  return te(5381, e);
};

function re(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (b$2(n) && !N$1(n)) return !1;
  }

  return !0;
}

var oe = ne("5.3.3"),
    se = function () {
  function e(e, t, n) {
    this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && re(e), this.componentId = t, this.baseHash = te(oe, t), this.baseStyle = n, Z$1.registerId(t);
  }

  return e.prototype.generateAndInjectStyles = function (e, t, n) {
    var r = this.componentId,
        o = [];
    if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
      if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);else {
        var s = Ne(this.rules, e, t, n).join(""),
            i = ee(te(this.baseHash, s) >>> 0);

        if (!t.hasNameForId(r, i)) {
          var a = n(s, "." + i, void 0, r);
          t.insertRules(r, i, a);
        }

        o.push(i), this.staticRulesId = i;
      }
    } else {
      for (var c = this.rules.length, u = te(this.baseHash, n.hash), l = "", d = 0; d < c; d++) {
        var h = this.rules[d];
        if ("string" == typeof h) l += h;else if (h) {
          var p = Ne(h, e, t, n),
              f = Array.isArray(p) ? p.join("") : p;
          u = te(u, f + d), l += f;
        }
      }

      if (l) {
        var m = ee(u >>> 0);

        if (!t.hasNameForId(r, m)) {
          var y = n(l, "." + m, void 0, r);
          t.insertRules(r, m, y);
        }

        o.push(m);
      }
    }
    return o.join(" ");
  }, e;
}(),
    ie = /^\s*\/\/.*$/gm,
    ae = [":", "[", ".", "#"];

function ce(e) {
  var t,
      n,
      r,
      o,
      s = void 0 === e ? E$2 : e,
      i = s.options,
      a = void 0 === i ? E$2 : i,
      c = s.plugins,
      u = void 0 === c ? w$2 : c,
      l = new stylis_min(a),
      d = [],
      h = function (e) {
    function t(t) {
      if (t) try {
        e(t + "}");
      } catch (e) {}
    }

    return function (n, r, o, s, i, a, c, u, l, d) {
      switch (n) {
        case 1:
          if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
          break;

        case 2:
          if (0 === u) return r + "/*|*/";
          break;

        case 3:
          switch (u) {
            case 102:
            case 112:
              return e(o[0] + r), "";

            default:
              return r + (0 === d ? "/*|*/" : "");
          }

        case -2:
          r.split("/*|*/}").forEach(t);
      }
    };
  }(function (e) {
    d.push(e);
  }),
      f = function f(e, r, s) {
    return 0 === r && -1 !== ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
  };

  function m(e, s, i, a) {
    void 0 === a && (a = "&");
    var c = e.replace(ie, ""),
        u = s && i ? i + " " + s + " { " + c + " }" : c;
    return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
  }

  return l.use([].concat(u, [function (e, t, o) {
    2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
  }, h, function (e) {
    if (-2 === e) {
      var t = d;
      return d = [], t;
    }
  }])), m.hash = u.length ? u.reduce(function (e, t) {
    return t.name || j$1(15), te(e, t.name);
  }, 5381).toString() : "", m;
}

var ue = /*#__PURE__*/React.createContext();
    ue.Consumer;
    var de = /*#__PURE__*/React.createContext(),
    he = (de.Consumer, new Z$1()),
    pe = ce();

function fe() {
  return react.exports.useContext(ue) || he;
}

function me() {
  return react.exports.useContext(de) || pe;
}

function ye(e) {
  var t = react.exports.useState(e.stylisPlugins),
      n = t[0],
      s = t[1],
      c = fe(),
      u = react.exports.useMemo(function () {
    var t = c;
    return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
      target: e.target
    }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
      useCSSOMInjection: !1
    })), t;
  }, [e.disableCSSOMInjection, e.sheet, e.target]),
      l = react.exports.useMemo(function () {
    return ce({
      options: {
        prefix: !e.disableVendorPrefixes
      },
      plugins: n
    });
  }, [e.disableVendorPrefixes, n]);
  return react.exports.useEffect(function () {
    shallowequal(n, e.stylisPlugins) || s(e.stylisPlugins);
  }, [e.stylisPlugins]), /*#__PURE__*/React.createElement(ue.Provider, {
    value: u
  }, /*#__PURE__*/React.createElement(de.Provider, {
    value: l
  }, e.children));
}

var ve = function () {
  function e(e, t) {
    var n = this;
    this.inject = function (e, t) {
      void 0 === t && (t = pe);
      var r = n.name + t.hash;
      e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
    }, this.toString = function () {
      return j$1(12, String(n.name));
    }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
  }

  return e.prototype.getName = function (e) {
    return void 0 === e && (e = pe), this.name + e.hash;
  }, e;
}(),
    ge = /([A-Z])/,
    Se = /([A-Z])/g,
    we = /^ms-/,
    Ee = function Ee(e) {
  return "-" + e.toLowerCase();
};

function be(e) {
  return ge.test(e) ? e.replace(Se, Ee).replace(we, "-ms-") : e;
}

var _e = function _e(e) {
  return null == e || !1 === e || "" === e;
};

function Ne(e, n, r, o) {
  if (Array.isArray(e)) {
    for (var s, i = [], a = 0, c = e.length; a < c; a += 1) {
      "" !== (s = Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
    }

    return i;
  }

  if (_e(e)) return "";
  if (N$1(e)) return "." + e.styledComponentId;

  if (b$2(e)) {
    if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
    var u = e(n);
    return Ne(u, n, r, o);
  }

  var l;
  return e instanceof ve ? r ? (e.inject(r, o), e.getName(o)) : e : S$1(e) ? function e(t, n) {
    var r,
        o,
        s = [];

    for (var i in t) {
      t.hasOwnProperty(i) && !_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || b$2(t[i]) ? s.push(be(i) + ":", t[i], ";") : S$1(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push(be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in unitlessKeys ? String(o).trim() : o + "px") + ";"));
    }

    return n ? [n + " {"].concat(s, ["}"]) : s;
  }(e) : e.toString();
}

var Ae = function Ae(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};

function Ce(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
    n[r - 1] = arguments[r];
  }

  return b$2(e) || S$1(e) ? Ae(Ne(g$2(w$2, [e].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : Ae(Ne(g$2(e, n)));
}

var Re = function Re(e, t, n) {
  return void 0 === n && (n = E$2), e.theme !== n.theme && e.theme || t || n.theme;
},
    De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
    je = /(^-|-$)/g;

function Te(e) {
  return e.replace(De, "-").replace(je, "");
}

var xe = function xe(e) {
  return ee(ne(e) >>> 0);
};

function ke(e) {
  return "string" == typeof e && ("production" === "production" );
}

var Ve = function Ve(e) {
  return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
},
    Be = function Be(e) {
  return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};

function ze(e, t, n) {
  var r = e[n];
  Ve(t) && Ve(r) ? Me(r, t) : e[n] = t;
}

function Me(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
    n[r - 1] = arguments[r];
  }

  for (var o = 0, s = n; o < s.length; o++) {
    var i = s[o];
    if (Ve(i)) for (var a in i) {
      Be(a) && ze(e, i[a], a);
    }
  }

  return e;
}

var Ge = /*#__PURE__*/React.createContext();
    Ge.Consumer;

var Ye = {};

function qe(e, t, n) {
  var o = N$1(e),
      i = !ke(e),
      a = t.attrs,
      c = void 0 === a ? w$2 : a,
      d = t.componentId,
      h = void 0 === d ? function (e, t) {
    var n = "string" != typeof e ? "sc" : Te(e);
    Ye[n] = (Ye[n] || 0) + 1;
    var r = n + "-" + xe("5.3.3" + n + Ye[n]);
    return t ? t + "-" + r : r;
  }(t.displayName, t.parentComponentId) : d,
      p = t.displayName,
      f = void 0 === p ? function (e) {
    return ke(e) ? "styled." + e : "Styled(" + _$1(e) + ")";
  }(e) : p,
      g = t.displayName && t.componentId ? Te(t.displayName) + "-" + t.componentId : t.componentId || h,
      S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c,
      A = t.shouldForwardProp;
  o && e.shouldForwardProp && (A = t.shouldForwardProp ? function (n, r, o) {
    return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
  } : e.shouldForwardProp);

  var C,
      I = new se(n, g, o ? e.componentStyle : void 0),
      P = I.isStatic && 0 === c.length,
      O = function O(e, t) {
    return function (e, t, n, r) {
      var o = e.attrs,
          i = e.componentStyle,
          a = e.defaultProps,
          c = e.foldedComponentIds,
          d = e.shouldForwardProp,
          h = e.styledComponentId,
          p = e.target;

      var f = function (e, t, n) {
        void 0 === e && (e = E$2);
        var r = v$2({}, t, {
          theme: e
        }),
            o = {};
        return n.forEach(function (e) {
          var t,
              n,
              s,
              i = e;

          for (t in b$2(i) && (i = i(r)), i) {
            r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
          }
        }), [r, o];
      }(Re(t, react.exports.useContext(Ge), a) || E$2, t, o),
          y = f[0],
          g = f[1],
          S = function (e, t, n, r) {
        var o = fe(),
            s = me(),
            i = t ? e.generateAndInjectStyles(E$2, o, s) : e.generateAndInjectStyles(n, o, s);
        return i;
      }(i, r, y),
          w = n,
          _ = g.$as || t.$as || g.as || t.as || p,
          N = ke(_),
          A = g !== t ? v$2({}, t, {}, g) : t,
          C = {};

      for (var I in A) {
        "$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, index$2, _) : !N || index$2(I)) && (C[I] = A[I]));
      }

      return t.style && g.style !== t.style && (C.style = v$2({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, /*#__PURE__*/react.exports.createElement(_, C);
    }(C, e, t, P);
  };

  return O.displayName = f, (C = /*#__PURE__*/React.forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : w$2, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function (e) {
    var r = t.componentId,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          s = Object.keys(e);

      for (r = 0; r < s.length; r++) {
        n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(t, ["componentId"]),
        s = r && r + "-" + (ke(e) ? e : Te(_$1(e)));

    return qe(e, v$2({}, o, {
      attrs: S,
      componentId: s
    }), n);
  }, Object.defineProperty(C, "defaultProps", {
    get: function get() {
      return this._foldedDefaultProps;
    },
    set: function set(t) {
      this._foldedDefaultProps = o ? Me({}, e.defaultProps, t) : t;
    }
  }), C.toString = function () {
    return "." + C.styledComponentId;
  }, i && hoistNonReactStatics_cjs(C, e, {
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), C;
}

var He = function He(e) {
  return function e(t, r, o) {
    if (void 0 === o && (o = E$2), !reactIs$2.exports.isValidElementType(r)) return j$1(1, String(r));

    var s = function s() {
      return t(r, o, Ce.apply(void 0, arguments));
    };

    return s.withConfig = function (n) {
      return e(t, r, v$2({}, o, {}, n));
    }, s.attrs = function (n) {
      return e(t, r, v$2({}, o, {
        attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
      }));
    }, s;
  }(qe, e);
};

["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function (e) {
  He[e] = He(e);
});

var $e = function () {
  function e(e, t) {
    this.rules = e, this.componentId = t, this.isStatic = re(e), Z$1.registerId(this.componentId + 1);
  }

  var t = e.prototype;
  return t.createStyles = function (e, t, n, r) {
    var o = r(Ne(this.rules, t, n, r).join(""), ""),
        s = this.componentId + e;
    n.insertRules(s, s, o);
  }, t.removeStyles = function (e, t) {
    t.clearRules(this.componentId + e);
  }, t.renderStyles = function (e, t, n, r) {
    e > 2 && Z$1.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
  }, e;
}();

function We(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) {
    n[o - 1] = arguments[o];
  }

  var i = Ce.apply(void 0, [e].concat(n)),
      a = "sc-global-" + xe(JSON.stringify(i)),
      u = new $e(i, a);

  function l(e) {
    var t = fe(),
        n = me(),
        o = react.exports.useContext(Ge),
        l = react.exports.useRef(t.allocateGSInstance(a)).current;
    return t.server && h(l, e, t, o, n), react.exports.useLayoutEffect(function () {
      if (!t.server) return h(l, e, t, o, n), function () {
        return u.removeStyles(l, t);
      };
    }, [l, e, t, o, n]), null;
  }

  function h(e, t, n, r, o) {
    if (u.isStatic) u.renderStyles(e, O$1, n, o);else {
      var s = v$2({}, t, {
        theme: Re(t, r, l.defaultProps)
      });
      u.renderStyles(e, s, n, o);
    }
  }

  return /*#__PURE__*/React.memo(l);
}

function Ue(e) {

  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
    n[r - 1] = arguments[r];
  }

  var o = Ce.apply(void 0, [e].concat(n)).join(""),
      s = xe(o);
  return new ve(s, o);
}
var styled = He;

/**

Copyright 2019 Forestry.io Inc


Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
// import * as React from 'react'

/**
 * SHOPSTORY MODIFICATION!
 *
 * This is commented out. It's because we're bundling entire Tina with Rollup and it doesnt' handle well dynamic requires.
 */
function FontLoader() {
  // const [fontLoaded, setFontLoaded] = React.useState(false)
  //
  // const WebFontConfig = {
  //   google: {
  //     families: ['Inter:400,600'],
  //   },
  //   loading: () => {
  //     setFontLoaded(true)
  //   },
  // }
  //
  // React.useEffect(() => {
  //   if (!fontLoaded) {
  //     const WebFont = require('webfontloader')
  //     return WebFont.load(WebFontConfig)
  //   }
  // }, [])
  return null;
}

var __jsx$$ = react.exports.createElement;
function Theme() {
  return __jsx$$(react.exports.Fragment, null, __jsx$$(FontLoader, null), __jsx$$(GlobalStyles, null));
}
var theme = Ce([":root{--tina-color-primary-light:#2296fe;--tina-color-primary:#2296fe;--tina-color-primary-dark:#0574e4;--tina-color-error-light:#eb6337;--tina-color-error:#ec4815;--tina-color-error-dark:#dc4419;--tina-color-warning-light:#f5e06e;--tina-color-warning:#e9d050;--tina-color-warning-dark:#d3ba38;--tina-color-success-light:#57c355;--tina-color-success:#3cad3a;--tina-color-success-dark:#249a21;--tina-color-grey-0:#ffffff;--tina-color-grey-1:#f6f6f9;--tina-color-grey-2:#edecf3;--tina-color-grey-3:#e1ddec;--tina-color-grey-4:#b2adbe;--tina-color-grey-5:#918c9e;--tina-color-grey-6:#716c7f;--tina-color-grey-7:#565165;--tina-color-grey-8:#433e52;--tina-color-grey-9:#363145;--tina-color-grey-10:#282828;--tina-radius-small:5px;--tina-radius-big:24px;--tina-padding-small:12px;--tina-padding-big:20px;--tina-font-size-0:12px;--tina-font-size-1:13px;--tina-font-size-2:15px;--tina-font-size-3:16px;--tina-font-size-4:18px;--tina-font-size-5:20px;--tina-font-size-6:22px;--tina-font-size-7:26px;--tina-font-size-8:32px;--tina-font-family:\"Inter\",sans-serif;--tina-font-weight-regular:400;--tina-font-weight-bold:600;--tina-shadow-big:0px 2px 3px rgba(0,0,0,0.05),0 4px 12px rgba(0,0,0,0.1);--tina-shadow-small:0px 2px 3px rgba(0,0,0,0.12);--tina-timing-short:85ms;--tina-timing-medium:150ms;--tina-timing-long:250ms;--tina-z-index-0:500;--tina-z-index-1:1000;--tina-z-index-2:1500;--tina-z-index-3:2000;--tina-z-index-4:2500;--tina-z-index-5:3000;--tina-sidebar-width:340px;--tina-sidebar-header-height:60px;--tina-toolbar-height:62px;}"]);
var GlobalStyles = We(["", ";"], theme);
var tina_reset_styles = Ce(["*{font-family:\"Inter\",sans-serif;&::-webkit-scrollbar{width:8px;}::-webkit-scrollbar-track{background:transparent;border-left:1px solid var(--tina-color-grey-2);}&::-webkit-scrollbar-thumb{background-color:var(--tina-color-grey-3);border-radius:0;border:none;}}*,*:before,*:after{box-sizing:border-box;}hr{border-color:var(--tina-color-grey-2);color:var(--tina-color-grey-2);margin-bottom:var(--tina-padding-big);margin-left:calc(var(--tina-padding-big) * -1);margin-right:calc(var(--tina-padding-big) * -1);border-top:1px solid var(--tina-color-grey-2);border-bottom:none;height:0;box-sizing:content-box;}h1,h2,h3,h4,h5,h6,p{:not([class]){font-family:\"Inter\",sans-serif;&:first-child{margin-top:0;}&:last-child{margin-bottom:0;}}}td,th{padding:0;width:auto;height:auto;border:inherit;margin:0;}h1,h2,h3,h4,h5,h6{:not([class]){font-weight:var(--tina-font-weight-bold);}}h1:not([class]){font-size:var(--tina-font-size-8);}h2:not([class]){font-size:var(--tina-font-size-7);}h3:not([class]){font-size:var(--tina-font-size-5);}h4:not([class]){font-size:var(--tina-font-size-4);}h5:not([class]){font-size:var(--tina-font-size-3);}h6:not([class]){font-size:var(--tina-font-size-2);}"]);
var StyleReset = styled.div.withConfig({
  displayName: "Styles__StyleReset",
  componentId: "sc-cxr2xf-0"
})(["", ""], tina_reset_styles);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var Button = styled.button.withConfig({
  displayName: "Button",
  componentId: "sc-xnba7t-0"
})(["text-align:center;border:0;border-radius:var(--tina-radius-big);box-shadow:var(--tina-shadow-small);background-color:var(--tina-color-grey-0);border:1px solid var(--tina-color-grey-2);color:var(--tina-color-primary);fill:var(--tina-color-primary);font-weight:var(--tina-font-weight-regular);cursor:pointer;font-size:var(--tina-font-size-1);height:40px;padding:0 var(--tina-padding-big);transition:all 85ms ease-out;&:hover{background-color:var(--tina-color-grey-1);}&:active{background-color:var(--tina-color-grey-2);outline:none;}", ";", ";", ";", ";", ";", ";"], function (p) {
  return p.disabled && Ce(["opacity:0.3;pointer:not-allowed;pointer-events:none;"]);
}, function (p) {
  return p.primary && Ce(["background-color:var(--tina-color-primary);color:var(--tina-color-grey-0);fill:var(--tina-color-grey-0);border:none;&:hover{background-color:var(--tina-color-primary-light);}&:active{background-color:var(--tina-color-primary-dark);}"]);
}, function (p) {
  return p.small && Ce(["height:32px;font-size:var(--tina-font-size-0);padding:0 var(--tina-padding-big);"]);
}, function (p) {
  return p.margin && Ce(["&:not(:first-child){margin-left:8px;}"]);
}, function (p) {
  return p.grow && Ce(["flex-grow:1;"]);
}, function (p) {
  return p.busy && Ce(["cursor:wait;"]);
});
var ICON_BUTTON_SIZE = 28;
var IconButton$2 = styled(Button).withConfig({
  displayName: "Button__IconButton",
  componentId: "sc-xnba7t-1"
})(["padding:0;width:", "px;height:", "px;margin:0;position:relative;transform-origin:50% 50%;transition:all 150ms ease-out;padding:0;display:flex;flex-shrink:0;justify-content:center;align-items:center;svg{width:26px;height:26px;transition:all 150ms ease-out;}", ";", ";"], ICON_BUTTON_SIZE, ICON_BUTTON_SIZE, function (p) {
  return p.small && Ce(["width:28px;height:28px;padding:0;svg{width:24px;height:24px;}"]);
}, function (props) {
  return props.open && Ce(["background-color:var(--tina-color-grey-0);border-color:var(--tina-color-grey-2);outline:none;fill:var(--tina-color-primary);svg{transform:rotate(45deg);}&:hover{background-color:var(--tina-color-grey-1);}&:active{background-color:var(--tina-color-grey-2);}"]);
});

var ERROR_MISSING_CMS = "useCMS could not find an instance of CMS";
var CMSContext = /*#__PURE__*/react.exports.createContext(null);
function useCMS() {
  var cms = react.exports.useContext(CMSContext);

  if (!cms) {
    throw new Error(ERROR_MISSING_CMS);
  }

  var _React$useState = react.exports.useState(cms.enabled),
      _React$useState2 = _slicedToArray$2(_React$useState, 2),
      setEnabled = _React$useState2[1];

  react.exports.useEffect(function () {
    return cms.events.subscribe("cms", function () {
      setEnabled(cms.enabled);
    });
  }, [cms]);
  return cms;
}

function _classCallCheck$d(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$b(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
} //      


function copyField(oldFields, oldKey, newFields, newKey) {
  newFields[newKey] = _extends$a({}, oldFields[oldKey], {
    name: newKey,
    // prevent functions from being overwritten
    // if the newFields[newKey] does not exist, it will be created
    // when that field gets registered, with its own change/blur/focus callbacks
    change: oldFields[newKey] && oldFields[newKey].change,
    blur: oldFields[newKey] && oldFields[newKey].blur,
    focus: oldFields[newKey] && oldFields[newKey].focus,
    lastFieldState: undefined // clearing lastFieldState forces renotification

  });

  if (!newFields[newKey].change) {
    delete newFields[newKey].change;
  }

  if (!newFields[newKey].blur) {
    delete newFields[newKey].blur;
  }

  if (!newFields[newKey].focus) {
    delete newFields[newKey].focus;
  }
} //      
// From MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping


var escapeRegexTokens = function escapeRegexTokens(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}; // $& means the whole matched string
//      


var insert = function insert(_ref, state, _ref2) {
  var name = _ref[0],
      index = _ref[1],
      value = _ref[2];
  var changeValue = _ref2.changeValue;
  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    copy.splice(index, 0, value);
    return copy;
  }); // now we have increment any higher indexes

  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
  var newFields = {};
  Object.keys(state.fields).forEach(function (key) {
    var tokens = pattern.exec(key);

    if (tokens) {
      var fieldIndex = Number(tokens[1]);

      if (fieldIndex >= index) {
        // Shift all higher indices up
        var incrementedKey = name + "[" + (fieldIndex + 1) + "]" + tokens[2];
        copyField(state.fields, key, newFields, incrementedKey);
        return;
      }
    } // Keep this field that does not match the name,
    // or has index smaller than what is being inserted


    newFields[key] = state.fields[key];
  });
  state.fields = newFields;
}; //      


var concat$1 = function concat(_ref, state, _ref2) {
  var name = _ref[0],
      value = _ref[1];
  var changeValue = _ref2.changeValue;
  changeValue(state, name, function (array) {
    return array ? [].concat(array, value) : value;
  });
}; //      


var move$1 = function move(_ref, state, _ref2) {
  var name = _ref[0],
      from = _ref[1],
      to = _ref[2];
  var changeValue = _ref2.changeValue;

  if (from === to) {
    return;
  }

  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
  });
  var newFields = {};
  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
  var lowest;
  var highest;
  var increment;

  if (from > to) {
    lowest = to;
    highest = from;
    increment = 1;
  } else {
    lowest = from;
    highest = to;
    increment = -1;
  }

  Object.keys(state.fields).forEach(function (key) {
    var tokens = pattern.exec(key);

    if (tokens) {
      var fieldIndex = Number(tokens[1]);

      if (fieldIndex === from) {
        var newKey = name + "[" + to + "]" + tokens[2];
        copyField(state.fields, key, newFields, newKey);
        return;
      }

      if (lowest <= fieldIndex && fieldIndex <= highest) {
        // Shift all indices
        var _newKey = name + "[" + (fieldIndex + increment) + "]" + tokens[2];

        copyField(state.fields, key, newFields, _newKey);
        return;
      }
    } // Keep this field that does not match the name,
    // or has index smaller or larger than affected range


    newFields[key] = state.fields[key];
  });
  state.fields = newFields;
}; //      


var remove = function remove(_ref, state, _ref2) {
  var name = _ref[0],
      index = _ref[1];
  var changeValue = _ref2.changeValue,
      getIn = _ref2.getIn,
      setIn = _ref2.setIn;
  var returnValue;
  changeValue(state, name, function (array) {
    if (!array) {
      return array;
    }

    var copy = [].concat(array);
    returnValue = copy[index];
    copy.splice(index, 1);
    return copy.length > 0 ? copy : undefined;
  }); // now we have to remove any subfields for our index,
  // and decrement all higher indexes.

  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
  var newFields = {};
  Object.keys(state.fields).forEach(function (key) {
    var tokens = pattern.exec(key);

    if (tokens) {
      var fieldIndex = Number(tokens[1]);

      if (fieldIndex === index) {
        // delete any submitErrors for this array item
        // if the root key of the delete index
        if (key === name + "[" + index + "]") {
          var path = "formState.submitErrors." + name;
          var submitErrors = getIn(state, path); // if has submitErrors for array

          if (Array.isArray(submitErrors)) {
            submitErrors.splice(index, 1);
            state = setIn(state, path, submitErrors);
          }
        }

        return;
      }

      if (fieldIndex > index) {
        // Shift all higher indices down
        var decrementedKey = name + "[" + (fieldIndex - 1) + "]" + tokens[2];
        copyField(state.fields, key, newFields, decrementedKey);
        return;
      }
    } // Keep this field that does not match the name,
    // or has index smaller than what is being removed


    newFields[key] = state.fields[key];
  });
  state.fields = newFields;
  return returnValue;
}; //      


var pop = function pop(_ref, state, tools) {
  var name = _ref[0];
  var getIn = tools.getIn;
  var array = getIn(state.formState.values, name);
  return array && array.length > 0 ? remove([name, array.length - 1], state, tools) : undefined;
}; //      


var push$1 = function push(_ref, state, _ref2) {
  var name = _ref[0],
      value = _ref[1];
  var changeValue = _ref2.changeValue;
  changeValue(state, name, function (array) {
    return array ? [].concat(array, [value]) : [value];
  });
}; //      


var binarySearch = function binarySearch(list, value) {
  // This algorithm assumes the items in list is unique
  var first = 0;
  var last = list.length - 1;
  var middle = 0;

  while (first <= last) {
    middle = Math.floor((first + last) / 2);

    if (list[middle] === value) {
      return middle;
    }

    if (list[middle] > value) {
      last = middle - 1;
    } else {
      first = middle + 1;
    }
  }

  return ~first;
};

var removeBatch = function removeBatch(_ref, state, _ref2) {
  var name = _ref[0],
      indexes = _ref[1];
  var changeValue = _ref2.changeValue;

  if (indexes.length === 0) {
    return [];
  }

  var sortedIndexes = [].concat(indexes);
  sortedIndexes.sort(); // Remove duplicates

  for (var i = sortedIndexes.length - 1; i > 0; i -= 1) {
    if (sortedIndexes[i] === sortedIndexes[i - 1]) {
      sortedIndexes.splice(i, 1);
    }
  }

  var returnValue = [];
  changeValue(state, name, function (array) {
    // use original order of indexes for return value
    returnValue = indexes.map(function (index) {
      return array && array[index];
    });

    if (!array) {
      return array;
    }

    var copy = [].concat(array);

    for (var _i = sortedIndexes.length - 1; _i >= 0; _i -= 1) {
      var index = sortedIndexes[_i];
      copy.splice(index, 1);
    }

    return copy.length > 0 ? copy : undefined;
  }); // now we have to remove any subfields for our indexes,
  // and decrement all higher indexes.

  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
  var newFields = {};
  Object.keys(state.fields).forEach(function (key) {
    var tokens = pattern.exec(key);

    if (tokens) {
      var fieldIndex = Number(tokens[1]);
      var indexOfFieldIndex = binarySearch(sortedIndexes, fieldIndex);

      if (indexOfFieldIndex >= 0) {
        // One of the removed indices
        return;
      }

      if (fieldIndex > sortedIndexes[0]) {
        // Shift all higher indices down
        var decrementedKey = name + "[" + (fieldIndex - ~indexOfFieldIndex) + "]" + tokens[2];
        copyField(state.fields, key, newFields, decrementedKey);
        return;
      }
    } // Keep this field that does not match the name,
    // or has index smaller than what is being removed


    newFields[key] = state.fields[key];
  });
  state.fields = newFields;
  return returnValue;
}; //      


var shift$1 = function shift(_ref, state, tools) {
  var name = _ref[0];
  return remove([name, 0], state, tools);
}; //      


var swap = function swap(_ref, state, _ref2) {
  var name = _ref[0],
      indexA = _ref[1],
      indexB = _ref[2];
  var changeValue = _ref2.changeValue;

  if (indexA === indexB) {
    return;
  }

  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
  }); // swap all field state that begin with "name[indexA]" with that under "name[indexB]"

  var aPrefix = name + "[" + indexA + "]";
  var bPrefix = name + "[" + indexB + "]";
  var newFields = {};
  Object.keys(state.fields).forEach(function (key) {
    if (key.substring(0, aPrefix.length) === aPrefix) {
      var suffix = key.substring(aPrefix.length);
      var newKey = bPrefix + suffix;
      copyField(state.fields, key, newFields, newKey);
    } else if (key.substring(0, bPrefix.length) === bPrefix) {
      var _suffix = key.substring(bPrefix.length);

      var _newKey = aPrefix + _suffix;

      copyField(state.fields, key, newFields, _newKey);
    } else {
      // Keep this field that does not match the name
      newFields[key] = state.fields[key];
    }
  });
  state.fields = newFields;
}; //      


var unshift = function unshift(_ref, state, tools) {
  var name = _ref[0],
      value = _ref[1];
  return insert([name, 0, value], state, tools);
}; //      


var update$1 = function update(_ref, state, _ref2) {
  var name = _ref[0],
      index = _ref[1],
      value = _ref[2];
  var changeValue = _ref2.changeValue;
  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    copy.splice(index, 1, value);
    return copy;
  });
}; //      


var mutators = {
  insert: insert,
  concat: concat$1,
  move: move$1,
  pop: pop,
  push: push$1,
  remove: remove,
  removeBatch: removeBatch,
  shift: shift$1,
  swap: swap,
  unshift: unshift,
  update: update$1
};

function _extends$9() {
  _extends$9 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$9.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var charCodeOfDot = ".".charCodeAt(0);
var reEscapeChar$3 = /\\(\\)?/g;
var rePropName$3 = RegExp( // Match anything that isn't a dot or bracket.
"[^.[\\]]+" + "|" + // Or match property names within brackets.
"\\[(?:" + // Match a non-string expression.
"([^\"'][^[]*)" + "|" + // Or match strings (supports escaping characters).
"([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2" + ")\\]" + "|" + // Or match "" as the space between consecutive dots or empty brackets.
"(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath$5 = function stringToPath(string) {
  var result = [];

  if (string.charCodeAt(0) === charCodeOfDot) {
    result.push("");
  }

  string.replace(rePropName$3, function (match, expression, quote, subString) {
    var key = match;

    if (quote) {
      key = subString.replace(reEscapeChar$3, "$1");
    } else if (expression) {
      key = expression.trim();
    }

    result.push(key);
  });
  return result;
};

var keysCache = {};
var keysRegex = /[.[\]]+/;

var toPath = function toPath(key) {
  if (key === null || key === undefined || !key.length) {
    return [];
  }

  if (typeof key !== "string") {
    throw new Error("toPath() expects a string");
  }

  if (keysCache[key] == null) {
    /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */
    if (key.endsWith("[]")) {
      // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
      keysCache[key] = key.split(keysRegex).filter(Boolean);
    } else {
      // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
      keysCache[key] = stringToPath$5(key);
    }
  }

  return keysCache[key];
}; //      


var getIn = function getIn(state, complexKey) {
  // Intentionally using iteration rather than recursion
  var path = toPath(complexKey);
  var current = state;

  for (var i = 0; i < path.length; i++) {
    var key = path[i];

    if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) {
      return undefined;
    }

    current = current[key];
  }

  return current;
};

function _toPropertyKey$5(arg) {
  var key = _toPrimitive$5(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive$5(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

var setInRecursor = function setInRecursor(current, index, path, value, destroyArrays) {
  if (index >= path.length) {
    // end of recursion
    return value;
  }

  var key = path[index]; // determine type of key

  if (isNaN(key)) {
    var _extends2; // object set


    if (current === undefined || current === null) {
      var _ref; // recurse


      var _result2 = setInRecursor(undefined, index + 1, path, value, destroyArrays); // delete or create an object


      return _result2 === undefined ? undefined : (_ref = {}, _ref[key] = _result2, _ref);
    }

    if (Array.isArray(current)) {
      throw new Error("Cannot set a non-numeric property on an array");
    } // current exists, so make a copy of all its values, and add/update the new one


    var _result = setInRecursor(current[key], index + 1, path, value, destroyArrays);

    if (_result === undefined) {
      var numKeys = Object.keys(current).length;

      if (current[key] === undefined && numKeys === 0) {
        // object was already empty
        return undefined;
      }

      if (current[key] !== undefined && numKeys <= 1) {
        // only key we had was the one we are deleting
        if (!isNaN(path[index - 1]) && !destroyArrays) {
          // we are in an array, so return an empty object
          return {};
        } else {
          return undefined;
        }
      }

      current[key];

      var _final = _objectWithoutPropertiesLoose$2(current, [key].map(_toPropertyKey$5));

      return _final;
    } // set result in key


    return _extends$9({}, current, (_extends2 = {}, _extends2[key] = _result, _extends2));
  } // array set


  var numericKey = Number(key);

  if (current === undefined || current === null) {
    // recurse
    var _result3 = setInRecursor(undefined, index + 1, path, value, destroyArrays); // if nothing returned, delete it


    if (_result3 === undefined) {
      return undefined;
    } // create an array


    var _array = [];
    _array[numericKey] = _result3;
    return _array;
  }

  if (!Array.isArray(current)) {
    throw new Error("Cannot set a numeric property on an object");
  } // recurse


  var existingValue = current[numericKey];
  var result = setInRecursor(existingValue, index + 1, path, value, destroyArrays); // current exists, so make a copy of all its values, and add/update the new one

  var array = [].concat(current);

  if (destroyArrays && result === undefined) {
    array.splice(numericKey, 1);

    if (array.length === 0) {
      return undefined;
    }
  } else {
    array[numericKey] = result;
  }

  return array;
};

var setIn = function setIn(state, key, value, destroyArrays) {
  if (destroyArrays === void 0) {
    destroyArrays = false;
  }

  if (state === undefined || state === null) {
    throw new Error("Cannot call setIn() with " + String(state) + " state");
  }

  if (key === undefined || key === null) {
    throw new Error("Cannot call setIn() with " + String(key) + " key");
  } // Recursive function needs to accept and return State, but public API should
  // only deal with Objects


  return setInRecursor(state, 0, toPath(key), value, destroyArrays);
};

var FORM_ERROR = "FINAL_FORM/form-error";
var ARRAY_ERROR = "FINAL_FORM/array-error"; //      

/**
 * Converts internal field state to published field state
 */

function publishFieldState(formState, field) {
  var errors = formState.errors,
      initialValues = formState.initialValues,
      lastSubmittedValues = formState.lastSubmittedValues,
      submitErrors = formState.submitErrors,
      submitFailed = formState.submitFailed,
      submitSucceeded = formState.submitSucceeded,
      submitting = formState.submitting,
      values = formState.values;
  var active = field.active,
      blur = field.blur,
      change = field.change,
      data = field.data,
      focus = field.focus,
      modified = field.modified,
      modifiedSinceLastSubmit = field.modifiedSinceLastSubmit,
      name = field.name,
      touched = field.touched,
      validating = field.validating,
      visited = field.visited;
  var value = getIn(values, name);
  var error = getIn(errors, name);

  if (error && error[ARRAY_ERROR]) {
    error = error[ARRAY_ERROR];
  }

  var submitError = submitErrors && getIn(submitErrors, name);
  var initial = initialValues && getIn(initialValues, name);
  var pristine = field.isEqual(initial, value);
  var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual(getIn(lastSubmittedValues, name), value));
  var valid = !error && !submitError;
  return {
    active: active,
    blur: blur,
    change: change,
    data: data,
    dirty: !pristine,
    dirtySinceLastSubmit: dirtySinceLastSubmit,
    error: error,
    focus: focus,
    initial: initial,
    invalid: !valid,
    length: Array.isArray(value) ? value.length : undefined,
    modified: modified,
    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
    name: name,
    pristine: pristine,
    submitError: submitError,
    submitFailed: submitFailed,
    submitSucceeded: submitSucceeded,
    submitting: submitting,
    touched: touched,
    valid: valid,
    value: value,
    visited: visited,
    validating: validating
  };
} //      


var fieldSubscriptionItems = ["active", "data", "dirty", "dirtySinceLastSubmit", "error", "initial", "invalid", "length", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "value", "visited", "validating"]; //      

var shallowEqual$1 = function shallowEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== "object" || !a || typeof b !== "object" || !b) {
    return false;
  }

  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key) || a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}; //      


function subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
  var different = false;
  keys.forEach(function (key) {
    if (subscription[key]) {
      dest[key] = src[key];

      if (!previous || (~shallowEqualKeys.indexOf(key) ? !shallowEqual$1(src[key], previous[key]) : src[key] !== previous[key])) {
        different = true;
      }
    }
  });
  return different;
} //      


var shallowEqualKeys$1 = ["data"];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */

var filterFieldState = function filterFieldState(state, previousState, subscription, force) {
  var result = {
    blur: state.blur,
    change: state.change,
    focus: state.focus,
    name: state.name
  };
  var different = subscriptionFilter(result, state, previousState, subscription, fieldSubscriptionItems, shallowEqualKeys$1) || !previousState;
  return different || force ? result : undefined;
}; //      


var formSubscriptionItems = ["active", "dirty", "dirtyFields", "dirtyFieldsSinceLastSubmit", "dirtySinceLastSubmit", "error", "errors", "hasSubmitErrors", "hasValidationErrors", "initialValues", "invalid", "modified", "modifiedSinceLastSubmit", "pristine", "submitting", "submitError", "submitErrors", "submitFailed", "submitSucceeded", "touched", "valid", "validating", "values", "visited"]; //      

var shallowEqualKeys = ["touched", "visited"];
/**
 * Filters items in a FormState based on a FormSubscription
 */

function filterFormState(state, previousState, subscription, force) {
  var result = {};
  var different = subscriptionFilter(result, state, previousState, subscription, formSubscriptionItems, shallowEqualKeys) || !previousState;
  return different || force ? result : undefined;
} //      


var memoize$3 = function memoize(fn) {
  var lastArgs;
  var lastResult;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!lastArgs || args.length !== lastArgs.length || args.some(function (arg, index) {
      return !shallowEqual$1(lastArgs[index], arg);
    })) {
      lastArgs = args;
      lastResult = fn.apply(void 0, args);
    }

    return lastResult;
  };
};

var isPromise = function isPromise(obj) {
  return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};

var tripleEquals = function tripleEquals(a, b) {
  return a === b;
};

var hasAnyError = function hasAnyError(errors) {
  return Object.keys(errors).some(function (key) {
    var value = errors[key];

    if (value && typeof value === "object" && !(value instanceof Error)) {
      return hasAnyError(value);
    }

    return typeof value !== "undefined";
  });
};

function convertToExternalFormState(_ref) {
  var active = _ref.active,
      dirtySinceLastSubmit = _ref.dirtySinceLastSubmit,
      modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit,
      error = _ref.error,
      errors = _ref.errors,
      initialValues = _ref.initialValues,
      pristine = _ref.pristine,
      submitting = _ref.submitting,
      submitFailed = _ref.submitFailed,
      submitSucceeded = _ref.submitSucceeded,
      submitError = _ref.submitError,
      submitErrors = _ref.submitErrors,
      valid = _ref.valid,
      validating = _ref.validating,
      values = _ref.values;
  return {
    active: active,
    dirty: !pristine,
    dirtySinceLastSubmit: dirtySinceLastSubmit,
    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
    error: error,
    errors: errors,
    hasSubmitErrors: !!(submitError || submitErrors && hasAnyError(submitErrors)),
    hasValidationErrors: !!(error || hasAnyError(errors)),
    invalid: !valid,
    initialValues: initialValues,
    pristine: pristine,
    submitting: submitting,
    submitFailed: submitFailed,
    submitSucceeded: submitSucceeded,
    submitError: submitError,
    submitErrors: submitErrors,
    valid: valid,
    validating: validating > 0,
    values: values
  };
}

function notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
  var notification = filter(state, lastState, subscription, force);

  if (notification) {
    subscriber(notification);
    return true;
  }

  return false;
}

function notify(_ref2, state, lastState, filter, force) {
  var entries = _ref2.entries;
  Object.keys(entries).forEach(function (key) {
    var entry = entries[Number(key)]; // istanbul ignore next

    if (entry) {
      var subscription = entry.subscription,
          subscriber = entry.subscriber,
          notified = entry.notified;

      if (notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) {
        entry.notified = true;
      }
    }
  });
}

function createForm$1(config) {
  if (!config) {
    throw new Error("No config specified");
  }

  var debug = config.debug,
      destroyOnUnregister = config.destroyOnUnregister,
      keepDirtyOnReinitialize = config.keepDirtyOnReinitialize,
      initialValues = config.initialValues,
      mutators = config.mutators,
      onSubmit = config.onSubmit,
      validate = config.validate,
      validateOnBlur = config.validateOnBlur;

  if (!onSubmit) {
    throw new Error("No onSubmit function specified");
  }

  var state = {
    subscribers: {
      index: 0,
      entries: {}
    },
    fieldSubscribers: {},
    fields: {},
    formState: {
      asyncErrors: {},
      dirtySinceLastSubmit: false,
      modifiedSinceLastSubmit: false,
      errors: {},
      initialValues: initialValues && _extends$9({}, initialValues),
      invalid: false,
      pristine: true,
      submitting: false,
      submitFailed: false,
      submitSucceeded: false,
      resetWhileSubmitting: false,
      valid: true,
      validating: 0,
      values: initialValues ? _extends$9({}, initialValues) : {}
    },
    lastFormState: undefined
  };
  var inBatch = 0;
  var validationPaused = false;
  var validationBlocked = false;
  var preventNotificationWhileValidationPaused = false;
  var nextAsyncValidationKey = 0;
  var asyncValidationPromises = {};

  var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
    return function (result) {
      delete asyncValidationPromises[key];
      return result;
    };
  };

  var changeValue = function changeValue(state, name, mutate) {
    var before = getIn(state.formState.values, name);
    var after = mutate(before);
    state.formState.values = setIn(state.formState.values, name, after) || {};
  };

  var renameField = function renameField(state, from, to) {
    if (state.fields[from]) {
      var _extends2, _extends3;

      state.fields = _extends$9({}, state.fields, (_extends2 = {}, _extends2[to] = _extends$9({}, state.fields[from], {
        name: to,
        // rebind event handlers
        blur: function blur() {
          return api.blur(to);
        },
        change: function change(value) {
          return api.change(to, value);
        },
        focus: function focus() {
          return api.focus(to);
        },
        lastFieldState: undefined
      }), _extends2));
      delete state.fields[from];
      state.fieldSubscribers = _extends$9({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
      delete state.fieldSubscribers[from];
      var value = getIn(state.formState.values, from);
      state.formState.values = setIn(state.formState.values, from, undefined) || {};
      state.formState.values = setIn(state.formState.values, to, value);
      delete state.lastFormState;
    }
  }; // bind state to mutators


  var getMutatorApi = function getMutatorApi(key) {
    return function () {
      // istanbul ignore next
      if (mutators) {
        // ^^ causes branch coverage warning, but needed to appease the Flow gods
        var mutatableState = {
          formState: state.formState,
          fields: state.fields,
          fieldSubscribers: state.fieldSubscribers,
          lastFormState: state.lastFormState
        };

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var returnValue = mutators[key](args, mutatableState, {
          changeValue: changeValue,
          getIn: getIn,
          renameField: renameField,
          resetFieldState: api.resetFieldState,
          setIn: setIn,
          shallowEqual: shallowEqual$1
        });
        state.formState = mutatableState.formState;
        state.fields = mutatableState.fields;
        state.fieldSubscribers = mutatableState.fieldSubscribers;
        state.lastFormState = mutatableState.lastFormState;
        runValidation(undefined, function () {
          notifyFieldListeners();
          notifyFormListeners();
        });
        return returnValue;
      }
    };
  };

  var mutatorsApi = mutators ? Object.keys(mutators).reduce(function (result, key) {
    result[key] = getMutatorApi(key);
    return result;
  }, {}) : {};

  var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
    var promises = [];

    if (validate) {
      var errorsOrPromise = validate(_extends$9({}, state.formState.values)); // clone to avoid writing

      if (isPromise(errorsOrPromise)) {
        promises.push(errorsOrPromise.then(function (errors) {
          return setErrors(errors, true);
        }));
      } else {
        setErrors(errorsOrPromise, false);
      }
    }

    return promises;
  };

  var getValidators = function getValidators(field) {
    return Object.keys(field.validators).reduce(function (result, index) {
      var validator = field.validators[Number(index)]();

      if (validator) {
        result.push(validator);
      }

      return result;
    }, []);
  };

  var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
    var promises = [];
    var validators = getValidators(field);

    if (validators.length) {
      var error;
      validators.forEach(function (validator) {
        var errorOrPromise = validator(getIn(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? publishFieldState(state.formState, state.fields[field.name]) : undefined);

        if (errorOrPromise && isPromise(errorOrPromise)) {
          field.validating = true;
          var promise = errorOrPromise.then(function (error) {
            if (state.fields[field.name]) {
              state.fields[field.name].validating = false;
              setError(error);
            }
          }); // errors must be resolved, not rejected

          promises.push(promise);
        } else if (!error) {
          // first registered validator wins
          error = errorOrPromise;
        }
      });
      setError(error);
    }

    return promises;
  };

  var runValidation = function runValidation(fieldChanged, callback) {
    if (validationPaused) {
      validationBlocked = true;
      callback();
      return;
    }

    var fields = state.fields,
        formState = state.formState;

    var safeFields = _extends$9({}, fields);

    var fieldKeys = Object.keys(safeFields);

    if (!validate && !fieldKeys.some(function (key) {
      return getValidators(safeFields[key]).length;
    })) {
      callback();
      return; // no validation rules
    } // pare down field keys to actually validate


    var limitedFieldLevelValidation = false;

    if (fieldChanged) {
      var changedField = safeFields[fieldChanged];

      if (changedField) {
        var validateFields = changedField.validateFields;

        if (validateFields) {
          limitedFieldLevelValidation = true;
          fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [fieldChanged];
        }
      }
    }

    var recordLevelErrors = {};
    var asyncRecordLevelErrors = {};
    var fieldLevelErrors = {};
    var promises = [].concat(runRecordLevelValidation(function (errors, wasAsync) {
      if (wasAsync) {
        asyncRecordLevelErrors = errors || {};
      } else {
        recordLevelErrors = errors || {};
      }
    }), fieldKeys.reduce(function (result, name) {
      return result.concat(runFieldLevelValidation(fields[name], function (error) {
        fieldLevelErrors[name] = error;
      }));
    }, []));
    var hasAsyncValidations = promises.length > 0;
    var asyncValidationPromiseKey = ++nextAsyncValidationKey;
    var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey)); // backwards-compat: add promise to submit-blocking promises iff there are any promises to await

    if (hasAsyncValidations) {
      asyncValidationPromises[asyncValidationPromiseKey] = promise;
    }

    var processErrors = function processErrors(afterAsync) {
      var merged = _extends$9({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
      : formState.asyncErrors);

      var forEachError = function forEachError(fn) {
        fieldKeys.forEach(function (name) {
          if (fields[name]) {
            // make sure field is still registered
            // field-level errors take precedent over record-level errors
            var recordLevelError = getIn(recordLevelErrors, name);
            var errorFromParent = getIn(merged, name);
            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
            var fieldLevelError = fieldLevelErrors[name];
            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
          }
        });
      };

      forEachError(function (name, error) {
        merged = setIn(merged, name, error) || {};
      });
      forEachError(function (name, error) {
        if (error && error[ARRAY_ERROR]) {
          var existing = getIn(merged, name);
          var copy = [].concat(existing);
          copy[ARRAY_ERROR] = error[ARRAY_ERROR];
          merged = setIn(merged, name, copy);
        }
      });

      if (!shallowEqual$1(formState.errors, merged)) {
        formState.errors = merged;
      }

      if (afterAsync) {
        formState.asyncErrors = asyncRecordLevelErrors;
      }

      formState.error = recordLevelErrors[FORM_ERROR];
    };

    if (hasAsyncValidations) {
      // async validations are running, ensure validating is true before notifying
      state.formState.validating++;
      callback();
    } // process sync errors


    processErrors(false); // sync errors have been set. notify listeners while we wait for others

    callback();

    if (hasAsyncValidations) {
      var afterPromise = function afterPromise() {
        state.formState.validating--;
        callback();
      };

      promise.then(function () {
        if (nextAsyncValidationKey > asyncValidationPromiseKey) {
          // if this async validator has been superseded by another, ignore its results
          return;
        }

        processErrors(true);
      }).then(afterPromise, afterPromise);
    }
  };

  var notifyFieldListeners = function notifyFieldListeners(name) {
    if (inBatch) {
      return;
    }

    var fields = state.fields,
        fieldSubscribers = state.fieldSubscribers,
        formState = state.formState;

    var safeFields = _extends$9({}, fields);

    var notifyField = function notifyField(name) {
      var field = safeFields[name];
      var fieldState = publishFieldState(formState, field);
      var lastFieldState = field.lastFieldState;
      field.lastFieldState = fieldState;
      var fieldSubscriber = fieldSubscribers[name];

      if (fieldSubscriber) {
        notify(fieldSubscriber, fieldState, lastFieldState, filterFieldState, lastFieldState === undefined);
      }
    };

    if (name) {
      notifyField(name);
    } else {
      Object.keys(safeFields).forEach(notifyField);
    }
  };

  var markAllFieldsTouched = function markAllFieldsTouched() {
    Object.keys(state.fields).forEach(function (key) {
      state.fields[key].touched = true;
    });
  };

  var hasSyncErrors = function hasSyncErrors() {
    return !!(state.formState.error || hasAnyError(state.formState.errors));
  };

  var calculateNextFormState = function calculateNextFormState() {
    var fields = state.fields,
        formState = state.formState,
        lastFormState = state.lastFormState;

    var safeFields = _extends$9({}, fields);

    var safeFieldKeys = Object.keys(safeFields); // calculate dirty/pristine

    var foundDirty = false;
    var dirtyFields = safeFieldKeys.reduce(function (result, key) {
      var dirty = !safeFields[key].isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));

      if (dirty) {
        foundDirty = true;
        result[key] = true;
      }

      return result;
    }, {});
    var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function (result, key) {
      // istanbul ignore next
      var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint

      if (!safeFields[key].isEqual(getIn(formState.values, key), getIn(nonNullLastSubmittedValues, key))) {
        result[key] = true;
      }

      return result;
    }, {});
    formState.pristine = !foundDirty;
    formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function (value) {
      return value;
    }));
    formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
    Object.keys(safeFields).some(function (value) {
      return safeFields[value].modifiedSinceLastSubmit;
    }));
    formState.valid = !formState.error && !formState.submitError && !hasAnyError(formState.errors) && !(formState.submitErrors && hasAnyError(formState.submitErrors));
    var nextFormState = convertToExternalFormState(formState);

    var _safeFieldKeys$reduce = safeFieldKeys.reduce(function (result, key) {
      result.modified[key] = safeFields[key].modified;
      result.touched[key] = safeFields[key].touched;
      result.visited[key] = safeFields[key].visited;
      return result;
    }, {
      modified: {},
      touched: {},
      visited: {}
    }),
        modified = _safeFieldKeys$reduce.modified,
        touched = _safeFieldKeys$reduce.touched,
        visited = _safeFieldKeys$reduce.visited;

    nextFormState.dirtyFields = lastFormState && shallowEqual$1(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
    nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && shallowEqual$1(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
    nextFormState.modified = lastFormState && shallowEqual$1(lastFormState.modified, modified) ? lastFormState.modified : modified;
    nextFormState.touched = lastFormState && shallowEqual$1(lastFormState.touched, touched) ? lastFormState.touched : touched;
    nextFormState.visited = lastFormState && shallowEqual$1(lastFormState.visited, visited) ? lastFormState.visited : visited;
    return lastFormState && shallowEqual$1(lastFormState, nextFormState) ? lastFormState : nextFormState;
  };

  var callDebug = function callDebug() {
    return debug && "development" !== "production" && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function (result, key) {
      result[key] = state.fields[key];
      return result;
    }, {}));
  };

  var notifying = false;
  var scheduleNotification = false;

  var notifyFormListeners = function notifyFormListeners() {
    if (notifying) {
      scheduleNotification = true;
    } else {
      notifying = true;
      callDebug();

      if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
        var lastFormState = state.lastFormState;
        var nextFormState = calculateNextFormState();

        if (nextFormState !== lastFormState) {
          state.lastFormState = nextFormState;
          notify(state.subscribers, nextFormState, lastFormState, filterFormState);
        }
      }

      notifying = false;

      if (scheduleNotification) {
        scheduleNotification = false;
        notifyFormListeners();
      }
    }
  };

  var beforeSubmit = function beforeSubmit() {
    return Object.keys(state.fields).some(function (name) {
      return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
    });
  };

  var afterSubmit = function afterSubmit() {
    return Object.keys(state.fields).forEach(function (name) {
      return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
    });
  };

  var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
    return Object.keys(state.fields).forEach(function (key) {
      return state.fields[key].modifiedSinceLastSubmit = false;
    });
  }; // generate initial errors


  runValidation(undefined, function () {
    notifyFormListeners();
  });
  var api = {
    batch: function batch(fn) {
      inBatch++;
      fn();
      inBatch--;
      notifyFieldListeners();
      notifyFormListeners();
    },
    blur: function blur(name) {
      var fields = state.fields,
          formState = state.formState;
      var previous = fields[name];

      if (previous) {
        // can only blur registered fields
        delete formState.active;
        fields[name] = _extends$9({}, previous, {
          active: false,
          touched: true
        });

        if (validateOnBlur) {
          runValidation(name, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
        } else {
          notifyFieldListeners();
          notifyFormListeners();
        }
      }
    },
    change: function change(name, value) {
      var fields = state.fields,
          formState = state.formState;

      if (getIn(formState.values, name) !== value) {
        changeValue(state, name, function () {
          return value;
        });
        var previous = fields[name];

        if (previous) {
          // only track modified for registered fields
          fields[name] = _extends$9({}, previous, {
            modified: true,
            modifiedSinceLastSubmit: !!formState.lastSubmittedValues
          });
        }

        if (validateOnBlur) {
          notifyFieldListeners();
          notifyFormListeners();
        } else {
          runValidation(name, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
        }
      }
    },

    get destroyOnUnregister() {
      return !!destroyOnUnregister;
    },

    set destroyOnUnregister(value) {
      destroyOnUnregister = value;
    },

    focus: function focus(name) {
      var field = state.fields[name];

      if (field && !field.active) {
        state.formState.active = name;
        field.active = true;
        field.visited = true;
        notifyFieldListeners();
        notifyFormListeners();
      }
    },
    mutators: mutatorsApi,
    getFieldState: function getFieldState(name) {
      var field = state.fields[name];
      return field && field.lastFieldState;
    },
    getRegisteredFields: function getRegisteredFields() {
      return Object.keys(state.fields);
    },
    getState: function getState() {
      return calculateNextFormState();
    },
    initialize: function initialize(data) {
      var fields = state.fields,
          formState = state.formState;

      var safeFields = _extends$9({}, fields);

      var values = typeof data === "function" ? data(formState.values) : data;

      if (!keepDirtyOnReinitialize) {
        formState.values = values;
      }
      /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */
      // save dirty values


      var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function (result, key) {
        var field = safeFields[key];
        var pristine = field.isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));

        if (!pristine) {
          result[key] = getIn(formState.values, key);
        }

        return result;
      }, {}) : {}; // update initalValues and values

      formState.initialValues = values;
      formState.values = values; // restore the dirty values

      Object.keys(savedDirtyValues).forEach(function (key) {
        formState.values = setIn(formState.values, key, savedDirtyValues[key]) || {};
      });
      runValidation(undefined, function () {
        notifyFieldListeners();
        notifyFormListeners();
      });
    },
    isValidationPaused: function isValidationPaused() {
      return validationPaused;
    },
    pauseValidation: function pauseValidation(preventNotification) {
      if (preventNotification === void 0) {
        preventNotification = true;
      }

      validationPaused = true;
      preventNotificationWhileValidationPaused = preventNotification;
    },
    registerField: function registerField(name, subscriber, subscription, fieldConfig) {
      if (subscription === void 0) {
        subscription = {};
      }

      if (!state.fieldSubscribers[name]) {
        state.fieldSubscribers[name] = {
          index: 0,
          entries: {}
        };
      }

      var index = state.fieldSubscribers[name].index++; // save field subscriber callback

      state.fieldSubscribers[name].entries[index] = {
        subscriber: memoize$3(subscriber),
        subscription: subscription,
        notified: false
      }; // create initial field state if not exists

      var field = state.fields[name] || {
        active: false,
        afterSubmit: fieldConfig && fieldConfig.afterSubmit,
        beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
        data: fieldConfig && fieldConfig.data || {},
        isEqual: fieldConfig && fieldConfig.isEqual || tripleEquals,
        lastFieldState: undefined,
        modified: false,
        modifiedSinceLastSubmit: false,
        name: name,
        touched: false,
        valid: true,
        validateFields: fieldConfig && fieldConfig.validateFields,
        validators: {},
        validating: false,
        visited: false
      }; // Mutators can create a field in order to keep the field states
      // We must update this field when registerField is called afterwards

      field.blur = field.blur || function () {
        return api.blur(name);
      };

      field.change = field.change || function (value) {
        return api.change(name, value);
      };

      field.focus = field.focus || function () {
        return api.focus(name);
      };

      state.fields[name] = field;
      var haveValidator = false;
      var silent = fieldConfig && fieldConfig.silent;

      var notify = function notify() {
        if (silent) {
          notifyFieldListeners(name);
        } else {
          notifyFormListeners();
          notifyFieldListeners();
        }
      };

      if (fieldConfig) {
        haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());

        if (fieldConfig.getValidator) {
          state.fields[name].validators[index] = fieldConfig.getValidator;
        }

        var noValueInFormState = getIn(state.formState.values, name) === undefined;

        if (fieldConfig.initialValue !== undefined && (noValueInFormState || getIn(state.formState.values, name) === getIn(state.formState.initialValues, name)) // only initialize if we don't yet have any value for this field
        ) {
          state.formState.initialValues = setIn(state.formState.initialValues || {}, name, fieldConfig.initialValue);
          state.formState.values = setIn(state.formState.values, name, fieldConfig.initialValue);
          runValidation(undefined, notify);
        } // only use defaultValue if we don't yet have any value for this field


        if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && getIn(state.formState.initialValues, name) === undefined && noValueInFormState) {
          state.formState.values = setIn(state.formState.values, name, fieldConfig.defaultValue);
        }
      }

      if (haveValidator) {
        runValidation(undefined, notify);
      } else {
        notify();
      }

      return function () {
        var validatorRemoved = false; // istanbul ignore next

        if (state.fields[name]) {
          // state.fields[name] may have been removed by a mutator
          validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
          delete state.fields[name].validators[index];
        }

        var hasFieldSubscribers = !!state.fieldSubscribers[name];

        if (hasFieldSubscribers) {
          // state.fieldSubscribers[name] may have been removed by a mutator
          delete state.fieldSubscribers[name].entries[index];
        }

        var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;

        if (lastOne) {
          delete state.fieldSubscribers[name];
          delete state.fields[name];

          if (validatorRemoved) {
            state.formState.errors = setIn(state.formState.errors, name, undefined) || {};
          }

          if (destroyOnUnregister) {
            state.formState.values = setIn(state.formState.values, name, undefined, true) || {};
          }
        }

        if (!silent) {
          if (validatorRemoved) {
            runValidation(undefined, function () {
              notifyFormListeners();
              notifyFieldListeners();
            });
          } else if (lastOne) {
            // values or errors may have changed
            notifyFormListeners();
          }
        }
      };
    },
    reset: function reset(initialValues) {
      if (initialValues === void 0) {
        initialValues = state.formState.initialValues;
      }

      if (state.formState.submitting) {
        state.formState.resetWhileSubmitting = true;
      }

      state.formState.submitFailed = false;
      state.formState.submitSucceeded = false;
      delete state.formState.submitError;
      delete state.formState.submitErrors;
      delete state.formState.lastSubmittedValues;
      api.initialize(initialValues || {});
    },

    /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */
    resetFieldState: function resetFieldState(name) {
      state.fields[name] = _extends$9({}, state.fields[name], {
        active: false,
        lastFieldState: undefined,
        modified: false,
        touched: false,
        valid: true,
        validating: false,
        visited: false
      });
      runValidation(undefined, function () {
        notifyFieldListeners();
        notifyFormListeners();
      });
    },

    /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */
    restart: function restart(initialValues) {
      if (initialValues === void 0) {
        initialValues = state.formState.initialValues;
      }

      api.batch(function () {
        for (var name in state.fields) {
          api.resetFieldState(name);
          state.fields[name] = _extends$9({}, state.fields[name], {
            active: false,
            lastFieldState: undefined,
            modified: false,
            modifiedSinceLastSubmit: false,
            touched: false,
            valid: true,
            validating: false,
            visited: false
          });
        }

        api.reset(initialValues);
      });
    },
    resumeValidation: function resumeValidation() {
      validationPaused = false;
      preventNotificationWhileValidationPaused = false;

      if (validationBlocked) {
        // validation was attempted while it was paused, so run it now
        runValidation(undefined, function () {
          notifyFieldListeners();
          notifyFormListeners();
        });
      }

      validationBlocked = false;
    },
    setConfig: function setConfig(name, value) {
      switch (name) {
        case "debug":
          debug = value;
          break;

        case "destroyOnUnregister":
          destroyOnUnregister = value;
          break;

        case "initialValues":
          api.initialize(value);
          break;

        case "keepDirtyOnReinitialize":
          keepDirtyOnReinitialize = value;
          break;

        case "mutators":
          mutators = value;

          if (value) {
            Object.keys(mutatorsApi).forEach(function (key) {
              if (!(key in value)) {
                delete mutatorsApi[key];
              }
            });
            Object.keys(value).forEach(function (key) {
              mutatorsApi[key] = getMutatorApi(key);
            });
          } else {
            Object.keys(mutatorsApi).forEach(function (key) {
              delete mutatorsApi[key];
            });
          }

          break;

        case "onSubmit":
          onSubmit = value;
          break;

        case "validate":
          validate = value;
          runValidation(undefined, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
          break;

        case "validateOnBlur":
          validateOnBlur = value;
          break;

        default:
          throw new Error("Unrecognised option " + name);
      }
    },
    submit: function submit() {
      var formState = state.formState;

      if (formState.submitting) {
        return;
      }

      delete formState.submitErrors;
      delete formState.submitError;
      formState.lastSubmittedValues = _extends$9({}, formState.values);

      if (hasSyncErrors()) {
        markAllFieldsTouched();
        resetModifiedAfterSubmit();
        state.formState.submitFailed = true;
        notifyFormListeners();
        notifyFieldListeners();
        return; // no submit for you!!
      }

      var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);

      if (asyncValidationPromisesKeys.length) {
        // still waiting on async validation to complete...
        Promise.all(asyncValidationPromisesKeys.map(function (key) {
          return asyncValidationPromises[Number(key)];
        })).then(api.submit, console.error);
        return;
      }

      var submitIsBlocked = beforeSubmit();

      if (submitIsBlocked) {
        return;
      }

      var resolvePromise;
      var completeCalled = false;

      var complete = function complete(errors) {
        formState.submitting = false;
        var resetWhileSubmitting = formState.resetWhileSubmitting;

        if (resetWhileSubmitting) {
          formState.resetWhileSubmitting = false;
        }

        if (errors && hasAnyError(errors)) {
          formState.submitFailed = true;
          formState.submitSucceeded = false;
          formState.submitErrors = errors;
          formState.submitError = errors[FORM_ERROR];
          markAllFieldsTouched();
        } else {
          if (!resetWhileSubmitting) {
            formState.submitFailed = false;
            formState.submitSucceeded = true;
          }

          afterSubmit();
        }

        notifyFormListeners();
        notifyFieldListeners();
        completeCalled = true;

        if (resolvePromise) {
          resolvePromise(errors);
        }

        return errors;
      };

      formState.submitting = true;
      formState.submitFailed = false;
      formState.submitSucceeded = false;
      formState.lastSubmittedValues = _extends$9({}, formState.values);
      resetModifiedAfterSubmit(); // onSubmit is either sync, callback or async with a Promise

      var result = onSubmit(formState.values, api, complete);

      if (!completeCalled) {
        if (result && isPromise(result)) {
          // onSubmit is async with a Promise
          notifyFormListeners(); // let everyone know we are submitting

          notifyFieldListeners(); // notify fields also

          return result.then(complete, function (error) {
            complete();
            throw error;
          });
        } else if (onSubmit.length >= 3) {
          // must be async, so we should return a Promise
          notifyFormListeners(); // let everyone know we are submitting

          notifyFieldListeners(); // notify fields also

          return new Promise(function (resolve) {
            resolvePromise = resolve;
          });
        } else {
          // onSubmit is sync
          complete(result);
        }
      }
    },
    subscribe: function subscribe(subscriber, subscription) {
      if (!subscriber) {
        throw new Error("No callback given.");
      }

      if (!subscription) {
        throw new Error("No subscription provided. What values do you want to listen to?");
      }

      var memoized = memoize$3(subscriber);
      var subscribers = state.subscribers;
      var index = subscribers.index++;
      subscribers.entries[index] = {
        subscriber: memoized,
        subscription: subscription,
        notified: false
      };
      var nextFormState = calculateNextFormState();
      notifySubscriber(memoized, subscription, nextFormState, nextFormState, filterFormState, true);
      return function () {
        delete subscribers.entries[index];
      };
    }
  };
  return api;
}

function dotNotationGet(obj, path) {
  if (path === "") {
    return obj;
  }

  return path.split(".").reduce(function (acc, curVal) {
    return acc && acc[curVal];
  }, obj);
}

function ownKeys$1d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1d(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Form = /*#__PURE__*/function () {
  function Form(_ref) {
    var _this = this;

    var id = _ref.id,
        label = _ref.label,
        fields = _ref.fields,
        actions = _ref.actions,
        buttons = _ref.buttons,
        reset = _ref.reset,
        loadInitialValues = _ref.loadInitialValues,
        onChange = _ref.onChange,
        _options = _objectWithoutProperties$2(_ref, ["id", "label", "fields", "actions", "buttons", "reset", "loadInitialValues", "onChange"]);

    _classCallCheck$d(this, Form);

    _defineProperty$g(this, "__type", void 0);

    _defineProperty$g(this, "id", void 0);

    _defineProperty$g(this, "label", void 0);

    _defineProperty$g(this, "fields", void 0);

    _defineProperty$g(this, "finalForm", void 0);

    _defineProperty$g(this, "actions", void 0);

    _defineProperty$g(this, "buttons", void 0);

    _defineProperty$g(this, "loading", false);

    _defineProperty$g(this, "subscribe", function (cb, options) {
      return _this.finalForm.subscribe(cb, options);
    });

    _defineProperty$g(this, "onSubmit", void 0);

    _defineProperty$g(this, "handleSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee(values, form, cb) {
        var response;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.onSubmit(values, form, cb);

              case 3:
                response = _context.sent;
                form.initialize(values);
                return _context.abrupt("return", response);

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", _defineProperty$g({}, FORM_ERROR, _context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty$g(this, "submit", function () {
      return _this.finalForm.submit();
    });

    var initialValues = _options.initialValues || {};
    this.__type = _options.__type || "form";
    this.id = id;
    this.label = label;
    this.fields = fields || [];
    this.onSubmit = _options.onSubmit;
    this.finalForm = createForm$1(_objectSpread$1c(_objectSpread$1c({}, _options), {}, {
      initialValues: initialValues,
      onSubmit: this.handleSubmit,
      mutators: _objectSpread$1c(_objectSpread$1c({}, mutators), _options.mutators)
    }));
    this._reset = reset;
    this.actions = actions || [];
    this.buttons = buttons || {
      save: "Save",
      reset: "Reset"
    };
    this.updateFields(this.fields);

    if (loadInitialValues) {
      this.loading = true;
      loadInitialValues().then(function (initialValues) {
        _this.updateInitialValues(initialValues);
      })["finally"](function () {
        _this.loading = false;
      });
    }

    if (onChange) {
      var firstUpdate = true;
      this.subscribe(function (formState) {
        if (firstUpdate) {
          firstUpdate = false;
        } else {
          onChange(formState);
        }
      }, {
        values: true
      });
    }
  }
  /**
   * A unique identifier for Forms.
   *
   * @alias id
   */


  _createClass$b(Form, [{
    key: "reset",

    /**
     * Resets the values back to the initial values the form was initialized with.
     * Or empties all the values if the form was not initialized.
     */
    value: function () {
      var _reset2 = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._reset) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this._reset();

              case 3:
                this.finalForm.reset();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function reset() {
        return _reset2.apply(this, arguments);
      }

      return reset;
    }()
    /**
     * @deprecated Unnecessary indirection
     */

  }, {
    key: "updateFields",
    value: function updateFields(fields) {
      this.fields = fields;
    }
    /**
     * Subscribes to changes to the form. The subscriber will only be called when
     * values specified in subscription change. A form can have many subscribers.
     */

  }, {
    key: "change",

    /**
     * Changes the value of the given field.
     *
     * @param name
     * @param value
     */
    value: function change(name, value) {

      return this.finalForm.change(name, value);
    }
  }, {
    key: "updateValues",

    /**
     * Updates multiple fields in the form.
     *
     * The updates are batched so that it only triggers one `onChange` event.
     *
     * In order to prevent disruptions to the user's editing experience this
     * function will _not_ update the value of any field that is currently
     * being edited.
     *
     * @param values
     */
    value: function updateValues(values) {
      var _this2 = this;

      this.finalForm.batch(function () {
        var activePath = _this2.finalForm.getState().active;

        if (!activePath) {
          updateEverything(_this2.finalForm, values);
        } else {
          updateSelectively(_this2.finalForm, values);
        }
      });
    }
    /**
     * Replaces the initialValues of the form without deleting the current values.
     *
     * This function is helpful when the initialValues are loaded asynchronously.
     *
     * @param initialValues
     */

  }, {
    key: "updateInitialValues",
    value: function updateInitialValues(initialValues) {
      var _this3 = this;

      this.finalForm.batch(function () {
        var values = _this3.values || {};

        _this3.finalForm.initialize(initialValues);

        var activePath = _this3.finalForm.getState().active;

        if (!activePath) {
          updateEverything(_this3.finalForm, values);
        } else {
          updateSelectively(_this3.finalForm, values);
        }
      });
    }
  }, {
    key: "name",
    get: function get() {
      return this.id;
    }
    /**
     * Returns the current values of the form.
     *
     * if the form is still loading it returns `undefined`.
     */

  }, {
    key: "values",
    get: function get() {
      if (this.loading) {
        return undefined;
      }

      return this.finalForm.getState().values || this.initialValues;
    }
    /**
     * The values the form was initialized with.
     */

  }, {
    key: "initialValues",
    get: function get() {
      return this.finalForm.getState().initialValues;
    }
  }, {
    key: "pristine",
    get: function get() {
      return this.finalForm.getState().pristine;
    }
  }, {
    key: "dirty",
    get: function get() {
      return this.finalForm.getState().dirty;
    }
  }, {
    key: "submitting",
    get: function get() {
      return this.finalForm.getState().submitting;
    }
  }, {
    key: "valid",
    get: function get() {
      return this.finalForm.getState().valid;
    }
  }, {
    key: "mutators",
    get: function get() {
      return this.finalForm.mutators;
    }
  }]);

  return Form;
}();

function updateEverything(form, values) {
  Object.entries(values).forEach(function (_ref4) {
    var _ref5 = _slicedToArray$2(_ref4, 2),
        path = _ref5[0],
        value = _ref5[1];

    form.change(path, value);
  });
}

function updateSelectively(form, values, prefix) {
  var activePath = form.getState().active;
  Object.entries(values).forEach(function (_ref6) {
    var _ref7 = _slicedToArray$2(_ref6, 2),
        name = _ref7[0],
        value = _ref7[1];

    var path = prefix ? "".concat(prefix, ".").concat(name) : name;

    if (typeof value === "object") {
      if (activePath.startsWith(path)) {
        updateSelectively(form, value, path);
      } else {
        form.change(path, value);
      }
    } else if (path !== activePath) {
      form.change(path, value);
    }
  });
}

/**
 * A React Hook for adding Plugins to the CMS.
 *
 * @alias usePlugins
 */

var usePlugin = usePlugins;
/**
 *
 * @alias usePlugin
 */

function usePlugins(plugins) {
  var cms = useCMS();
  var pluginArray;

  if (Array.isArray(plugins)) {
    pluginArray = plugins;
  } else {
    pluginArray = [plugins];
  }

  react.exports.useEffect(function () {
    pluginArray.forEach(function (plugin) {
      if (plugin) {
        cms.plugins.add(plugin);
      }
    });
    return function () {
      pluginArray.forEach(function (plugin) {
        if (plugin) {
          cms.plugins.remove(plugin);
        }
      });
    };
  }, [cms.plugins].concat(_toConsumableArray$2(pluginArray)));
}

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
function useCMSEvent(event, callback, deps) {
  var cms = useCMS();
  react.exports.useEffect(function () {
    return cms.events.subscribe(event, callback);
  }, deps);
}

/**
 * A hook that creates a form and updates it's watched properties.
 */

function useForm(_ref) {
  var watch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var loadInitialValues = _ref.loadInitialValues,
      options = _objectWithoutProperties$2(_ref, ["loadInitialValues"]);

  /**
   * `initialValues` will be usually be undefined if `loadInitialValues` is used.
   *
   * If the form helper is using `watch.values`, which would contain
   * the current state of the form, then we set that to the `initialValues`
   * so the form is initialized with some state.
   *
   * This is beneficial for SSR and will hopefully not be noticeable
   * when editing the site as the actual `initialValues` will be set
   * behind the scenes.
   */
  options.initialValues = options.initialValues || watch.values;

  var _React$useState = react.exports.useState(options.initialValues),
      _React$useState2 = _slicedToArray$2(_React$useState, 2),
      setValues = _React$useState2[1];

  var _React$useState3 = react.exports.useState(function () {
    return createForm(options, function (form) {
      setValues(form.values);
    });
  }),
      _React$useState4 = _slicedToArray$2(_React$useState3, 2),
      form = _React$useState4[0],
      setForm = _React$useState4[1];

  react.exports.useEffect(function () {
    if (form.id === options.id) return;
    setForm(createForm(options, function (form) {
      setValues(form.values);
    }));
  }, [options.id]);

  var _React$useState5 = react.exports.useState(function () {
    return loadInitialValues ? true : false;
  }),
      _React$useState6 = _slicedToArray$2(_React$useState5, 2),
      formIsLoading = _React$useState6[0],
      setFormIsLoading = _React$useState6[1];

  var loadFormData = react.exports.useCallback( /*#__PURE__*/_asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee() {
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!loadInitialValues) {
              _context.next = 4;
              break;
            }

            setFormIsLoading(true);
            _context.next = 4;
            return loadInitialValues().then(function (values) {
              form.updateInitialValues(values);
            })["finally"](function () {
              setFormIsLoading(false);
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [form, setFormIsLoading]);
  react.exports.useEffect(function () {
    loadFormData();
  }, [form, loadFormData]);
  useCMSEvent("unstable:reload-form-data", /*#__PURE__*/_asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2() {
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return loadFormData();

          case 2:
            _context2.next = 4;
            return form.reset();

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [loadFormData, form]);
  useUpdateFormFields(form, watch.fields);
  useUpdateFormLabel(form, watch.label);
  useUpdateFormValues(form, watch.values);
  return [form ? form.values : options.initialValues, form, formIsLoading];
}

function createForm(options, handleChange) {
  var form = new Form(options);
  form.subscribe(handleChange, {
    values: true
  });
  return form;
}
/**
 * A React Hook that update's the `Form` if `fields` are changed.
 *
 * This hook is useful when dynamically creating fields, or updating
 * them via hot module replacement.
 */


function useUpdateFormFields(form, fields) {
  react.exports.useEffect(function () {
    if (typeof fields === "undefined") return;
    form.updateFields(fields);
  }, [form, fields]);
}
/**
 * A React Hook that update's the `Form` if the `label` is changed.
 *
 * This hook is useful when dynamically creating creating the label,
 * or updating it via hot module replacement.
 */


function useUpdateFormLabel(form, label) {
  react.exports.useEffect(function () {
    if (typeof label === "undefined") return;
    form.label = label;
  }, [form, label]);
}
/**
 * Updates the Form with new values.
 *
 * Only updates fields that are:
 *
 * 1. registered with the form
 * 2. not currently [active](https://final-form.org/docs/final-form/types/FieldState#active)
 *
 * This hook is useful when the form must be kept in sync with the data source.
 */


function useUpdateFormValues(form, values) {
  react.exports.useEffect(function () {
    if (typeof values === "undefined") return;
    form.updateValues(values);
  }, [form, values]);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$2(o);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf$2(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function _setPrototypeOf$3(o, p) {
  _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$3(o, p);
}

function _inherits$b(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$3(subClass, superClass);
}

function _typeof$7(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$7 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$7 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$7(obj);
}

function _possibleConstructorReturn$a(self, call) {
  if (call && (_typeof$7(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * This package defines the plugin system of TinaCMS.
 *
 * The management of plugins is a core part of a content
 * management system. The API for managing plugins in TinaCMS is quite
 * powerful, although the implementation is a bit awkward.
 *
 * [[Plugin|Plugins]] are objects used to extend and modify the
 * behaviour of the CMS. Each plugin has a `__type` field that is used
 * to group plugins by their purpose.
 *
 * The [[PluginType]] class is responsible for managing a collection of
 * plugins with the same `__type` value. Plugins can be added and removed from
 * the `PluginType` over the life of the application.
 *
 * A new [[CMS]] is not initialized with any `PluginTypes`.
 * Instead it has a single [[PluginTypeManager]] which is responsible for
 * creating and managing different `PluginType` instances.
 *
 * Although somewhat confusing from the maintainers perspective, this
 * structure results in a pretty easy to use interface for the clients.
 * The concept of `PluginType` and `PluginTypeManager` are not really
 * meant to be exposed to developers using TinaCMS in their projects.
 *
 * @packageDocumentation
 */

/**
 * An object used to extend or modify the behaviour of the content management system.
 */

/**
 * Manages all of the [[PluginType|PluginTypes]] on a [[CMS]].
 */
var PluginTypeManager = /*#__PURE__*/function () {
  /**
   * @ignore
   */
  function PluginTypeManager(events) {
    _classCallCheck$d(this, PluginTypeManager);

    this.events = events;

    _defineProperty$g(this, "plugins", {});
  }
  /**
   * Gets the [[PluginType|collection of plugins]] for the given type.
   *
   * #### Example: Basic Usage
   *
   * ```ts
   * const colorPlugins = cms.plugins.get("color")
   * ```
   *
   * #### Example: Advanced Types
   *
   * A type param can be added to specify the kind of Plugin
   * that is being listed.
   *
   * ```ts
   * const colorPlugins = cms.plugins.get<ColorPlugin>("color")
   * ```
   *
   * @param type The type of plugins to be retrieved
   * @typeparam P A subclass of Plugin. Optional.
   */


  _createClass$b(PluginTypeManager, [{
    key: "getType",
    value: function getType(type) {
      return this.plugins[type] = this.plugins[type] || new PluginType(type, this.events);
    }
    /**
     * An alias to [[get]]
     *
     * ### !DEPRECATED!
     *
     * This name is unnecessarily verbose and weird.
     */

  }, {
    key: "findOrCreateMap",
    value: function findOrCreateMap(type) {
      return this.getType(type);
    }
    /**
     * Adds a Plugin to the CMS.
     *
     * #### Example: Basic Usage
     *
     * ```js
     * cms.plugins.add({ __type: "color", name: "red" })
     * ```
     *
     * #### Example: Advanced Types
     *
     * ```ts
     * interface ColorPlugin extends Plugin {
     *   __type: "color"
     *   hex: string
     *   rgb: string
     * }
     *
     * cms.plugins.add<ColorPlugin>({
     *   __type: "color",
     *   name: "red",
     *   hex: "#FF0000",
     *   rgb: "RGBA(255, 0, 0, 1)"
     * })
     * ```
     *
     * @typeparam P A subclass of Plugin. Optional.
     * @param plugin
     * @todo Consider returning the plugin which was just added.
     */

  }, {
    key: "add",
    value: function add(plugin) {
      this.findOrCreateMap(plugin.__type).add(plugin);
    }
    /**
     * Removes the given plugin from the CMS.
     *
     * #### Example
     *
     * In this example a plugin is added to the CMS and removed
     * 5 seconds later.
     *
     * ```ts
     * const redPlugin = {
     *   __type: "color",
     *   name: "red",
     *   hex: "#FF0000",
     *   rgb: "RGBA(255, 0, 0, 1)"
     * }
     *
     * cms.plugins.add(redPlugin)
     *
     * setTimeout(() => {
     *   cms.plugins.remove(redPlugin)
     * }, 5000)
     * ```
     *
     * @typeparam P A subclass of Plugin. Optional.
     * @param plugin The plugin to be removed from the CMS.
     */

  }, {
    key: "remove",
    value: function remove(plugin) {
      this.findOrCreateMap(plugin.__type).remove(plugin);
    }
    /**
     * Returns a list of all the plugins of the given type.
     *
     * #### Example: Basic Usage
     *
     * ```ts
     * cms.plugins.all("color").forEach(color => {
     *   console.log(color.name)
     * })
     * ```
     *
     * #### Example: Advanced Types
     *
     * A generic can be added to specify the type of plugins
     * that are being retrieved.
     *
     * ```ts
     * cms.plugins.all<ColorPlugin>("color").forEach(color => {
     *   console.log(color.name, color.hex)
     * })
     * ```
     *
     * @typeparam P A subclass of Plugin. Optional.
     * @param type The name of the plugin
     * @returns An array of all plugins of the given type.
     */

  }, {
    key: "all",
    value: function all(type) {
      return this.findOrCreateMap(type).all();
    }
  }]);

  return PluginTypeManager;
}();
/**
 * @ignore
 */

/**
 * A collection of plugins with the same `__type` value.
 */
var PluginType = /*#__PURE__*/function () {
  /**
   * @ignore
   */

  /**
   *
   * @param __type The `__type` of plugin being managed.
   */
  function PluginType(__type, events) {
    _classCallCheck$d(this, PluginType);

    this.__type = __type;
    this.events = events;

    _defineProperty$g(this, "__plugins", {});
  }
  /**
   * Adds a new plugin to the collection.
   *
   * ### Example
   *
   * ```ts
   * interface ColorPlugin extends Plugin {
   *   hex: string
   * }
   *
   * const colorPlugins = new PluginType<ColorPlugin>("color")
   *
   * colorPlugins.add({ name: "red", hex: "#f00" })
   * ```
   *
   * @param plugin A new plugin. The `__type` is optional and will be added if it's missing.
   */


  _createClass$b(PluginType, [{
    key: "add",
    value: function add(plugin) {
      var p = plugin;

      if (!p.__type) {
        p.__type = this.__type;
      }

      this.__plugins[p.name] = p;
      this.events.dispatch({
        type: "plugin:add:".concat(this.__type)
      });
    }
  }, {
    key: "all",
    value: function all() {
      var _this = this;

      return Object.keys(this.__plugins).map(function (name) {
        return _this.__plugins[name];
      });
    }
    /**
     *
     * Looks up a plugin by it's `name`.
     *
     * ### Example
     *
     * ```ts
     * const colorPlugins = new PluginType<ColorPlugin>("color")
     *
     * colorPlugins.add({ name: "red", hex: "#f00" })
     *
     * colorPlugins.find("red")  // { __type: "color", name: "red", hex: "#f00" }
     * colorPlugin.find("large") // undefined
     * ```
     *
     * @param name The `name` of the plugin to be retrieved.
     */

  }, {
    key: "find",
    value: function find(name) {
      return this.__plugins[name];
    }
    /**
     * Pass this function a plugin or the `name` of a plugin to have
     * it be removed from the CMS.
     *
     * @param pluginOrName The `name` of a plugin, or the plugin itself.
     * @returns The plugin that was removed, or `undefined` if it was not found.
     */

  }, {
    key: "remove",
    value: function remove(pluginOrName) {
      var name = typeof pluginOrName === "string" ? pluginOrName : pluginOrName.name;
      var plugin = this.__plugins[name];
      delete this.__plugins[name];
      this.events.dispatch({
        type: "plugin:remove:".concat(this.__type)
      });
      return plugin;
    }
  }, {
    key: "subscribe",
    value: function subscribe(cb) {
      return this.events.subscribe("plugin:*:".concat(this.__type), cb);
    }
  }]);

  return PluginType;
}();

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var EventBus = function EventBus() {
  var _this = this;

  _classCallCheck$d(this, EventBus);

  _defineProperty$g(this, "listeners", new Set());

  _defineProperty$g(this, "subscribe", function (event, callback) {
    var events;

    if (typeof event === "string") {
      events = [event];
    } else {
      events = event;
    }

    var newListeners = events.map(function (event) {
      return new Listener(event, callback);
    });
    newListeners.forEach(function (newListener) {
      return _this.listeners.add(newListener);
    });
    return function () {
      newListeners.forEach(function (listener) {
        return _this.listeners["delete"](listener);
      });
    };
  });

  _defineProperty$g(this, "dispatch", function (event) {
    /**
     * If the `listener` Set is modified during the dispatch then
     * it can cause an infinite loop. Snapshot it and it's fine.
     */
    var listenerSnapshot = Array.from(_this.listeners.values());
    listenerSnapshot.forEach(function (listener) {
      return listener.handleEvent(event);
    });
  });
};
var Listener = /*#__PURE__*/function () {
  function Listener(eventPattern, callback) {
    _classCallCheck$d(this, Listener);

    this.eventPattern = eventPattern;
    this.callback = callback;
  }

  _createClass$b(Listener, [{
    key: "handleEvent",
    value: function handleEvent(event) {
      if (this.watchesEvent(event)) {
        this.callback(event);
        return true;
      }

      return false;
    }
  }, {
    key: "watchesEvent",
    value: function watchesEvent(currentEvent) {
      if (this.eventPattern === "*") return true;
      var eventParts = currentEvent.type.split(":");
      var patternParts = this.eventPattern.split(":");
      var index = 0;
      var ignoresEvent = false;

      while (!ignoresEvent && index < patternParts.length) {
        var wildcard = patternParts[index] === "*";
        var matchingParts = patternParts[index] === eventParts[index];
        ignoresEvent = !(wildcard || matchingParts);
        index++;
      }

      return !ignoresEvent;
    }
  }]);

  return Listener;
}();

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var DummyMediaStore = /*#__PURE__*/function () {
  function DummyMediaStore() {
    _classCallCheck$d(this, DummyMediaStore);

    _defineProperty$g(this, "accept", "*");
  }

  _createClass$b(DummyMediaStore, [{
    key: "persist",
    value: function () {
      var _persist = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee(files) {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", files.map(function (_ref) {
                  var directory = _ref.directory,
                      file = _ref.file;
                  return {
                    id: file.name,
                    type: "file",
                    directory: directory,
                    filename: file.name
                  };
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function persist(_x) {
        return _persist.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "previewSrc",
    value: function () {
      var _previewSrc = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2(filename) {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", filename);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function previewSrc(_x2) {
        return _previewSrc.apply(this, arguments);
      }

      return previewSrc;
    }()
  }, {
    key: "list",
    value: function () {
      var _list = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee3() {
        var items;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                items = [];
                return _context3.abrupt("return", {
                  items: items,
                  offset: 0,
                  limit: 10,
                  totalCount: 0
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function list() {
        return _list.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee4() {
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return DummyMediaStore;
}();

function ownKeys$1c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1c(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * The central object for all things media.
 *
 * Meant to be placed directly on the `cms`
 *
 * ```ts
 * cms.media = new MediaManager({
 *   accept: '*',
 *   async persist(files) {
 *     // do something
 *   }
 * })
 * ```
 */
var MediaManager = /*#__PURE__*/function () {
  function MediaManager(store, events) {
    var _this = this;

    _classCallCheck$d(this, MediaManager);

    this.store = store;
    this.events = events;

    _defineProperty$g(this, "previewSrc", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee(src) {
        var fieldName,
            formValues,
            url,
            _args = arguments;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fieldName = _args.length > 1 && _args[1] !== undefined ? _args[1] : "";
                formValues = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                _context.prev = 2;

                _this.events.dispatch({
                  type: "media:preview:start",
                  src: src,
                  fieldName: fieldName,
                  formValues: formValues
                });

                _context.next = 6;
                return _this.store.previewSrc(src, fieldName, formValues);

              case 6:
                url = _context.sent;

                _this.events.dispatch({
                  type: "media:preview:success",
                  src: src,
                  url: url,
                  fieldName: fieldName,
                  formValues: formValues
                });

                return _context.abrupt("return", url);

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);

                _this.events.dispatch({
                  type: "media:preview:failure",
                  src: src,
                  error: _context.t0,
                  fieldName: fieldName,
                  formValues: formValues
                });

                throw _context.t0;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 11]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }

  _createClass$b(MediaManager, [{
    key: "open",
    value: function open() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.events.dispatch(_objectSpread$1b({
        type: "media:open"
      }, options));
    }
  }, {
    key: "persist",
    value: function () {
      var _persist = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2(files) {
        var _media;

        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.events.dispatch({
                  type: "media:upload:start",
                  uploaded: files
                });
                _context2.next = 4;
                return this.store.persist(files);

              case 4:
                _media = _context2.sent;
                this.events.dispatch({
                  type: "media:upload:success",
                  uploaded: files,
                  media: _media
                });
                return _context2.abrupt("return", _media);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                this.events.dispatch({
                  type: "media:upload:failure",
                  uploaded: files,
                  error: _context2.t0
                });
                throw _context2.t0;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function persist(_x2) {
        return _persist.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee3(media) {
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                this.events.dispatch({
                  type: "media:delete:start",
                  media: media
                });
                _context3.next = 4;
                return this.store["delete"](media);

              case 4:
                this.events.dispatch({
                  type: "media:delete:success",
                  media: media
                });
                _context3.next = 11;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                this.events.dispatch({
                  type: "media:delete:failure",
                  media: media,
                  error: _context3.t0
                });
                throw _context3.t0;

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function _delete(_x3) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "list",
    value: function () {
      var _list = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee4(options) {
        var _media2;

        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                this.events.dispatch(_objectSpread$1b({
                  type: "media:list:start"
                }, options));
                _context4.next = 4;
                return this.store.list(options);

              case 4:
                _media2 = _context4.sent;
                this.events.dispatch(_objectSpread$1b(_objectSpread$1b({
                  type: "media:list:success"
                }, options), {}, {
                  media: _media2
                }));
                return _context4.abrupt("return", _media2);

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);
                this.events.dispatch(_objectSpread$1b(_objectSpread$1b({
                  type: "media:list:failure"
                }, options), {}, {
                  error: _context4.t0
                }));
                throw _context4.t0;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 9]]);
      }));

      function list(_x4) {
        return _list.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: "isConfigured",
    get: function get() {
      return !(this.store instanceof DummyMediaStore);
    }
  }, {
    key: "accept",
    get: function get() {
      return this.store.accept;
    }
  }]);

  return MediaManager;
}();

/**
 * A [[CMS]] is the core object of any content management system.
 *
 * The responsibility of the [[CMS]] keeps track of two broad types of objects:
 *
 * - [[Plugin|Plugins]] which extend or change the behaviour of the content management system..
 * - [[api|APIs]] which allow the CMS to integrate with third party services.
 * - [[EventBus|events]] which provide a way to communicate information about events happening
 *   between decoupled parts of the CMS.
 *
 * The name [[CMS]] is a bit misleading. This object knows nothing of the user
 * interface or the data storage layer. The purpose of a [[CMS]] instance is to
 * provide a common connection point for the various aspects of a content
 * management system. The [[CMS]] object effectively a vehicle for dependency injection.
 *
 * #### Creating a CMS
 *
 * ```ts
 * import { CMS } from "@tinacms/core"
 *
 * const cms = new CMS()
 * ```
 *
 * #### Extending the CMS
 *
 * The [[CMS]] class provides low-level interfaces for interacting with APIs and Plugins.
 * Creating a subclass is great way to facilitate these interactions:
 *
 * ```ts
 * import { CMS } from "@tinacms/core"
 *
 * class MyCMS extends CMS {
 *   get colors() {
 *     return this.plugins.findOrCreateMap("color")
 *   }
 * }
 *
 * const cms = new MyCMS()
 *
 * cms.colors.all()
 * ```
 */

var CMS = /*#__PURE__*/function () {
  /**
   * An object for managing CMSs plugins.
   *
   * [[Plugin|Plugins]] are used to extend or modify the CMSs feature set.
   *
   */

  /**
   * The set of APIs registered with the CMS.
   *
   * API objects are the preferred way to interact with external APIs over a network.
   *
   * The preferred way to register new APIs is through the [[registerApi]] method.
   *
   * #### Example: Fetching Data Through an API
   *
   * ```ts
   * import { CMS } from "@tinacms/core"
   * import { CoolApi } from "cool-api"
   *
   * const cms = new CMS()
   *
   * cms.registerApi("coolApi", new CoolApi())
   *
   * cms.api.coolApi.fetchCoolThings().then(coolThings => {
   *   console.log(coolThings)
   * })
   * ```
   *
   */

  /**
   * @hidden
   */
  function CMS() {
    var _this = this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck$d(this, CMS);

    _defineProperty$g(this, "_enabled", false);

    _defineProperty$g(this, "plugins", void 0);

    _defineProperty$g(this, "api", {});

    _defineProperty$g(this, "unsubscribeHooks", {});

    _defineProperty$g(this, "events", new EventBus());

    _defineProperty$g(this, "media", new MediaManager(new DummyMediaStore(), this.events));

    _defineProperty$g(this, "enable", function () {
      _this._enabled = true;

      _this.events.dispatch(CMS.ENABLED);
    });

    _defineProperty$g(this, "disable", function () {
      _this._enabled = false;

      _this.events.dispatch(CMS.DISABLED);
    });

    _defineProperty$g(this, "toggle", function () {
      if (_this.enabled) {
        _this.disable();
      } else {
        _this.enable();
      }
    });

    this.plugins = new PluginTypeManager(this.events);

    if (config.media) {
      this.media.store = config.media;
    }

    if (config.plugins) {
      config.plugins.forEach(function (plugin) {
        return _this.plugins.add(plugin);
      });
    }

    if (config.apis) {
      Object.entries(config.apis).forEach(function (_ref) {
        var _ref2 = _slicedToArray$2(_ref, 2),
            name = _ref2[0],
            api = _ref2[1];

        return _this.registerApi(name, api);
      });
    }

    if (config.enabled) {
      this.enable();
    }
  }
  /**
   * Registers a new external API with the CMS.
   *
   * #### Example
   *
   * ```ts
   * import { CoolApi } from "cool-api"
   *
   * cms.registerApi("coolApi", new CoolApi())
   * ```
   *
   * @param name The name used to lookup the external API.
   * @param api An object for interacting with an external API.
   *
   * ### Additional Resources
   *
   * * https://github.com/tinacms/rfcs/blob/master/0010-api-events.md
   */


  _createClass$b(CMS, [{
    key: "registerApi",
    value: function registerApi(name, api) {
      if (this.unsubscribeHooks[name]) {
        this.unsubscribeHooks[name]();
      }

      if (api.events instanceof EventBus) {
        this.unsubscribeHooks[name] = api.events.subscribe("*", this.events.dispatch);
      }

      this.api[name] = api;
    }
    /**
     * When `true` the CMS is enabled and content can be edited.
     */

  }, {
    key: "enabled",
    get: function get() {
      return this._enabled;
    }
    /**
     * When `true` the CMS is disabled and content cannot be edited.
     */

  }, {
    key: "disabled",
    get: function get() {
      return !this._enabled;
    }
    /**
     * Enable the CMS so content can be edited.
     */

  }]);

  return CMS;
}();

_defineProperty$g(CMS, "ENABLED", {
  type: "cms:enable"
});

_defineProperty$g(CMS, "DISABLED", {
  type: "cms:disable"
});

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var InputCss = Ce(["box-sizing:border-box;padding:var(--tina-padding-small);border-radius:var(--tina-radius-small);background:var(--tina-color-grey-0);font-size:var(--tina-font-size-2);line-height:1.35;position:relative;color:var(--tina-color-grey-10);background-color:var(--tina-color-grey-0);transition:all 85ms ease-out;border:1px solid var(--tina-color-grey-2);width:100%;margin:0;outline:none;box-shadow:0 0 0 2px ", ";&:hover{box-shadow:0 0 0 2px var(--tina-color-grey-3);}&:focus{box-shadow:0 0 0 2px ", ";}&::placeholder{font-size:var(--tina-font-size-2);color:var(--tina-color-grey-3);}", ";"], function (p) {
  return p.error ? "var(--tina-color-error)" : "transparent";
}, function (p) {
  return p.error ? "var(--tina-color-error)" : "var(--tina-color-primary)";
}, function (p) {
  return p.small && Ce(["font-size:var(--tina-font-size-1);padding:8px var(--tina-padding-small);"]);
});
styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-13t6aza-0"
})(["", ""], InputCss);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
styled.input.withConfig({
  displayName: "TextField__BaseTextField",
  componentId: "sc-1ifgwyb-0"
})(["", ""], InputCss);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var TextArea = styled.textarea.withConfig({
  displayName: "TextArea",
  componentId: "sc-e17qk6-0"
})(["", ";resize:vertical;height:160px;"], InputCss);

var build = {exports: {}};

(function (module, exports) {
!function (e, t) {
  t(exports, react.exports) ;
}(commonjsGlobal, function (e, d) {

  var _l = function l() {
    return (_l = Object.assign || function (e) {
      for (var t, n = 1, o = arguments.length; n < o; n++) {
        for (var i in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  function u(e) {
    var o = e.onDismiss,
        t = e.escape,
        i = void 0 !== t && t,
        n = e.click,
        r = void 0 !== n && n,
        c = e.disabled,
        a = void 0 !== c && c,
        s = e.allowClickPropagation,
        l = void 0 !== s && s,
        u = e.document,
        f = d.useRef();
    return d.useEffect(function () {
      function t(e) {
        a || f.current.contains(e.target) || (l || function (e) {
          e.stopPropagation(), e.stopImmediatePropagation(), e.preventDefault();
        }(e), o(e));
      }

      function n(e) {
        a || 27 === e.keyCode && (e.stopPropagation(), o(e));
      }

      var e = u ? [document, u] : [document];
      return r && e.forEach(function (e) {
        return e.body.addEventListener("click", t);
      }), i && e.forEach(function (e) {
        return e.addEventListener("keydown", n);
      }), function () {
        e.forEach(function (e) {
          e.body.removeEventListener("click", t), e.removeEventListener("keydown", n);
        });
      };
    }, [r, u, i, a, o]), f;
  }

  e.Dismissible = function (e) {
    var t = e.onDismiss,
        n = e.escape,
        o = e.click,
        i = e.disabled,
        r = e.allowClickPropagation,
        c = e.document,
        a = function (e, t) {
      var n = {};

      for (var o in e) {
        Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;

        for (o = Object.getOwnPropertySymbols(e); i < o.length; i++) {
          t.indexOf(o[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[i]) && (n[o[i]] = e[o[i]]);
        }
      }

      return n;
    }(e, ["onDismiss", "escape", "click", "disabled", "allowClickPropagation", "document"]),
        s = u({
      onDismiss: t,
      escape: n,
      click: o,
      disabled: i,
      allowClickPropagation: r,
      document: c
    });

    return d.createElement("div", _l({
      ref: s
    }, a));
  }, e.useDismissible = u, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});
}(build, build.exports));

var lib$4 = {};

var flattenNames = {};

/** Detect free variable `global` from Node.js. */

var freeGlobal$6 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$6;

var freeGlobal$5 = _freeGlobal;
/** Detect free variable `self`. */


var freeSelf$4 = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$d = freeGlobal$5 || freeSelf$4 || Function('return this')();
var _root = root$d;

var root$c = _root;
/** Built-in value references. */


var Symbol$9 = root$c.Symbol;
var _Symbol = Symbol$9;

var Symbol$8 = _Symbol;
/** Used for built-in method references. */


var objectProto$z = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$s = objectProto$z.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$3 = objectProto$z.toString;
/** Built-in value references. */

var symToStringTag$3 = Symbol$8 ? Symbol$8.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag$2(value) {
  var isOwn = hasOwnProperty$s.call(value, symToStringTag$3),
      tag = value[symToStringTag$3];

  try {
    value[symToStringTag$3] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$3.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag;
    } else {
      delete value[symToStringTag$3];
    }
  }

  return result;
}

var _getRawTag = getRawTag$2;

/** Used for built-in method references. */

var objectProto$y = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$2 = objectProto$y.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString$8(value) {
  return nativeObjectToString$2.call(value);
}

var _objectToString = objectToString$8;

var Symbol$7 = _Symbol,
    getRawTag$1 = _getRawTag,
    objectToString$7 = _objectToString;
/** `Object#toString` result references. */


var nullTag$1 = '[object Null]',
    undefinedTag$1 = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$2 = Symbol$7 ? Symbol$7.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag$8(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }

  return symToStringTag$2 && symToStringTag$2 in Object(value) ? getRawTag$1(value) : objectToString$7(value);
}

var _baseGetTag = baseGetTag$8;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$k = Array.isArray;
var isArray_1 = isArray$k;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$f(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$f;

var baseGetTag$7 = _baseGetTag,
    isArray$j = isArray_1,
    isObjectLike$e = isObjectLike_1;
/** `Object#toString` result references. */


var stringTag$7 = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */

function isString$4(value) {
  return typeof value == 'string' || !isArray$j(value) && isObjectLike$e(value) && baseGetTag$7(value) == stringTag$7;
}

var isString_1 = isString$4;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$2(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];

      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }

    return object;
  };
}

var _createBaseFor = createBaseFor$2;

var createBaseFor$1 = _createBaseFor;
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */


var baseFor$3 = createBaseFor$1();
var _baseFor = baseFor$3;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$2(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

var _baseTimes = baseTimes$2;

var baseGetTag$6 = _baseGetTag,
    isObjectLike$d = isObjectLike_1;
/** `Object#toString` result references. */


var argsTag$7 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments$2(value) {
  return isObjectLike$d(value) && baseGetTag$6(value) == argsTag$7;
}

var _baseIsArguments = baseIsArguments$2;

var baseIsArguments$1 = _baseIsArguments,
    isObjectLike$c = isObjectLike_1;
/** Used for built-in method references. */


var objectProto$x = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$r = objectProto$x.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable$4 = objectProto$x.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments$5 = baseIsArguments$1(function () {
  return arguments;
}()) ? baseIsArguments$1 : function (value) {
  return isObjectLike$c(value) && hasOwnProperty$r.call(value, 'callee') && !propertyIsEnumerable$4.call(value, 'callee');
};
var isArguments_1 = isArguments$5;

var isBuffer$7 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse$1() {
  return false;
}

var stubFalse_1 = stubFalse$1;

(function (module, exports) {
var root = _root,
    stubFalse = stubFalse_1;
/** Detect free variable `exports`. */


var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */

var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */

var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;
}(isBuffer$7, isBuffer$7.exports));

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$5 = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint$2 = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex$4(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$5 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint$2.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

var _isIndex = isIndex$4;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$4 = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength$5(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$4;
}

var isLength_1 = isLength$5;

var baseGetTag$5 = _baseGetTag,
    isLength$4 = isLength_1,
    isObjectLike$b = isObjectLike_1;
/** `Object#toString` result references. */


var argsTag$6 = '[object Arguments]',
    arrayTag$4 = '[object Array]',
    boolTag$5 = '[object Boolean]',
    dateTag$5 = '[object Date]',
    errorTag$4 = '[object Error]',
    funcTag$6 = '[object Function]',
    mapTag$8 = '[object Map]',
    numberTag$5 = '[object Number]',
    objectTag$9 = '[object Object]',
    regexpTag$5 = '[object RegExp]',
    setTag$8 = '[object Set]',
    stringTag$6 = '[object String]',
    weakMapTag$4 = '[object WeakMap]';
var arrayBufferTag$5 = '[object ArrayBuffer]',
    dataViewTag$7 = '[object DataView]',
    float32Tag$3 = '[object Float32Array]',
    float64Tag$3 = '[object Float64Array]',
    int8Tag$3 = '[object Int8Array]',
    int16Tag$3 = '[object Int16Array]',
    int32Tag$3 = '[object Int32Array]',
    uint8Tag$3 = '[object Uint8Array]',
    uint8ClampedTag$3 = '[object Uint8ClampedArray]',
    uint16Tag$3 = '[object Uint16Array]',
    uint32Tag$3 = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] = typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] = typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] = typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] = typedArrayTags$1[uint32Tag$3] = true;
typedArrayTags$1[argsTag$6] = typedArrayTags$1[arrayTag$4] = typedArrayTags$1[arrayBufferTag$5] = typedArrayTags$1[boolTag$5] = typedArrayTags$1[dataViewTag$7] = typedArrayTags$1[dateTag$5] = typedArrayTags$1[errorTag$4] = typedArrayTags$1[funcTag$6] = typedArrayTags$1[mapTag$8] = typedArrayTags$1[numberTag$5] = typedArrayTags$1[objectTag$9] = typedArrayTags$1[regexpTag$5] = typedArrayTags$1[setTag$8] = typedArrayTags$1[stringTag$6] = typedArrayTags$1[weakMapTag$4] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray$2(value) {
  return isObjectLike$b(value) && isLength$4(value.length) && !!typedArrayTags$1[baseGetTag$5(value)];
}

var _baseIsTypedArray = baseIsTypedArray$2;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$4(func) {
  return function (value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$4;

var _nodeUtil = {exports: {}};

(function (module, exports) {
var freeGlobal = _freeGlobal;
/** Detect free variable `exports`. */


var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */

var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */

var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    } // Legacy `process.binding('util')` for Node.js < 10.


    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
}(_nodeUtil, _nodeUtil.exports));

var baseIsTypedArray$1 = _baseIsTypedArray,
    baseUnary$3 = _baseUnary,
    nodeUtil$4 = _nodeUtil.exports;
/* Node.js helper references. */


var nodeIsTypedArray$1 = nodeUtil$4 && nodeUtil$4.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray$5 = nodeIsTypedArray$1 ? baseUnary$3(nodeIsTypedArray$1) : baseIsTypedArray$1;
var isTypedArray_1 = isTypedArray$5;

var baseTimes$1 = _baseTimes,
    isArguments$4 = isArguments_1,
    isArray$i = isArray_1,
    isBuffer$6 = isBuffer$7.exports,
    isIndex$3 = _isIndex,
    isTypedArray$4 = isTypedArray_1;
/** Used for built-in method references. */


var objectProto$w = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$q = objectProto$w.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys$3(value, inherited) {
  var isArr = isArray$i(value),
      isArg = !isArr && isArguments$4(value),
      isBuff = !isArr && !isArg && isBuffer$6(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$4(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes$1(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$q.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex$3(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

var _arrayLikeKeys = arrayLikeKeys$3;

/** Used for built-in method references. */

var objectProto$v = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype$4(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$v;
  return value === proto;
}

var _isPrototype = isPrototype$4;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$4(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$4;

var overArg$3 = _overArg;
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeKeys$3 = overArg$3(Object.keys, Object);
var _nativeKeys = nativeKeys$3;

var isPrototype$3 = _isPrototype,
    nativeKeys$2 = _nativeKeys;
/** Used for built-in method references. */


var objectProto$u = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$p = objectProto$u.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys$2(object) {
  if (!isPrototype$3(object)) {
    return nativeKeys$2(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$p.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

var _baseKeys = baseKeys$2;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$c(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$c;

var baseGetTag$4 = _baseGetTag,
    isObject$b = isObject_1;
/** `Object#toString` result references. */


var asyncTag$1 = '[object AsyncFunction]',
    funcTag$5 = '[object Function]',
    genTag$4 = '[object GeneratorFunction]',
    proxyTag$1 = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction$6(value) {
  if (!isObject$b(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag$4(value);
  return tag == funcTag$5 || tag == genTag$4 || tag == asyncTag$1 || tag == proxyTag$1;
}

var isFunction_1 = isFunction$6;

var isFunction$5 = isFunction_1,
    isLength$3 = isLength_1;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */


function isArrayLike$6(value) {
  return value != null && isLength$3(value.length) && !isFunction$5(value);
}

var isArrayLike_1 = isArrayLike$6;

var arrayLikeKeys$2 = _arrayLikeKeys,
    baseKeys$1 = _baseKeys,
    isArrayLike$5 = isArrayLike_1;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */


function keys$7(object) {
  return isArrayLike$5(object) ? arrayLikeKeys$2(object) : baseKeys$1(object);
}

var keys_1 = keys$7;

var baseFor$2 = _baseFor,
    keys$6 = keys_1;
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */


function baseForOwn$3(object, iteratee) {
  return object && baseFor$2(object, iteratee, keys$6);
}

var _baseForOwn = baseForOwn$3;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$4(value) {
  return value;
}

var identity_1 = identity$4;

var identity$3 = identity_1;
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */


function castFunction$2(value) {
  return typeof value == 'function' ? value : identity$3;
}

var _castFunction = castFunction$2;

var baseForOwn$2 = _baseForOwn,
    castFunction$1 = _castFunction;
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */


function forOwn(object, iteratee) {
  return object && baseForOwn$2(object, castFunction$1(iteratee));
}

var forOwn_1 = forOwn;

var overArg$2 = _overArg;
/** Built-in value references. */


var getPrototype$6 = overArg$2(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$6;

var baseGetTag$3 = _baseGetTag,
    getPrototype$5 = _getPrototype,
    isObjectLike$a = isObjectLike_1;
/** `Object#toString` result references. */


var objectTag$8 = '[object Object]';
/** Used for built-in method references. */

var funcProto$7 = Function.prototype,
    objectProto$t = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$7 = funcProto$7.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$o = objectProto$t.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString$2 = funcToString$7.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */

function isPlainObject$5(value) {
  if (!isObjectLike$a(value) || baseGetTag$3(value) != objectTag$8) {
    return false;
  }

  var proto = getPrototype$5(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty$o.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$7.call(Ctor) == objectCtorString$2;
}

var isPlainObject_1 = isPlainObject$5;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$3(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var _arrayMap = arrayMap$3;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$2() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$2;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$4(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq$4;

var eq$3 = eq_1;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function assocIndexOf$5(array, key) {
  var length = array.length;

  while (length--) {
    if (eq$3(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf$5;

var assocIndexOf$4 = _assocIndexOf;
/** Used for built-in method references. */


var arrayProto$1 = Array.prototype;
/** Built-in value references. */

var splice$1 = arrayProto$1.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete$2(key) {
  var data = this.__data__,
      index = assocIndexOf$4(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$2;

var assocIndexOf$3 = _assocIndexOf;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet$2(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);
  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$2;

var assocIndexOf$2 = _assocIndexOf;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas$2(key) {
  return assocIndexOf$2(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$2;

var assocIndexOf$1 = _assocIndexOf;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet$2(key, value) {
  var data = this.__data__,
      index = assocIndexOf$1(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet$2;

var listCacheClear$1 = _listCacheClear,
    listCacheDelete$1 = _listCacheDelete,
    listCacheGet$1 = _listCacheGet,
    listCacheHas$1 = _listCacheHas,
    listCacheSet$1 = _listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function ListCache$5(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache$5.prototype.clear = listCacheClear$1;
ListCache$5.prototype['delete'] = listCacheDelete$1;
ListCache$5.prototype.get = listCacheGet$1;
ListCache$5.prototype.has = listCacheHas$1;
ListCache$5.prototype.set = listCacheSet$1;
var _ListCache = ListCache$5;

var ListCache$4 = _ListCache;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */


function stackClear$2() {
  this.__data__ = new ListCache$4();
  this.size = 0;
}

var _stackClear = stackClear$2;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$2(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$2;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$2(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$2;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$2(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$2;

var root$b = _root;
/** Used to detect overreaching core-js shims. */


var coreJsData$4 = root$b['__core-js_shared__'];
var _coreJsData = coreJsData$4;

var coreJsData$3 = _coreJsData;
/** Used to detect methods masquerading as native. */


var maskSrcKey$2 = function () {
  var uid = /[^.]+$/.exec(coreJsData$3 && coreJsData$3.keys && coreJsData$3.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked$3(func) {
  return !!maskSrcKey$2 && maskSrcKey$2 in func;
}

var _isMasked = isMasked$3;

/** Used for built-in method references. */

var funcProto$6 = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$6 = funcProto$6.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource$4(func) {
  if (func != null) {
    try {
      return funcToString$6.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

var _toSource = toSource$4;

var isFunction$4 = isFunction_1,
    isMasked$2 = _isMasked,
    isObject$a = isObject_1,
    toSource$3 = _toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */


var reRegExpChar$2 = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor$2 = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$5 = Function.prototype,
    objectProto$s = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$5 = funcProto$5.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$n = objectProto$s.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative$2 = RegExp('^' + funcToString$5.call(hasOwnProperty$n).replace(reRegExpChar$2, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative$3(value) {
  if (!isObject$a(value) || isMasked$2(value)) {
    return false;
  }

  var pattern = isFunction$4(value) ? reIsNative$2 : reIsHostCtor$2;
  return pattern.test(toSource$3(value));
}

var _baseIsNative = baseIsNative$3;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$5(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$5;

var baseIsNative$2 = _baseIsNative,
    getValue$4 = _getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative$9(object, key) {
  var value = getValue$4(object, key);
  return baseIsNative$2(value) ? value : undefined;
}

var _getNative = getNative$9;

var getNative$8 = _getNative,
    root$a = _root;
/* Built-in method references that are verified to be native. */


var Map$6 = getNative$8(root$a, 'Map');
var _Map = Map$6;

var getNative$7 = _getNative;
/* Built-in method references that are verified to be native. */


var nativeCreate$6 = getNative$7(Object, 'create');
var _nativeCreate = nativeCreate$6;

var nativeCreate$5 = _nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */


function hashClear$2() {
  this.__data__ = nativeCreate$5 ? nativeCreate$5(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$2;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$2(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$2;

var nativeCreate$4 = _nativeCreate;
/** Used to stand-in for `undefined` hash values. */


var HASH_UNDEFINED$5 = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$r = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$m = objectProto$r.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet$2(key) {
  var data = this.__data__;

  if (nativeCreate$4) {
    var result = data[key];
    return result === HASH_UNDEFINED$5 ? undefined : result;
  }

  return hasOwnProperty$m.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$2;

var nativeCreate$3 = _nativeCreate;
/** Used for built-in method references. */


var objectProto$q = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$l = objectProto$q.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas$2(key) {
  var data = this.__data__;
  return nativeCreate$3 ? data[key] !== undefined : hasOwnProperty$l.call(data, key);
}

var _hashHas = hashHas$2;

var nativeCreate$2 = _nativeCreate;
/** Used to stand-in for `undefined` hash values. */


var HASH_UNDEFINED$4 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet$2(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$2 && value === undefined ? HASH_UNDEFINED$4 : value;
  return this;
}

var _hashSet = hashSet$2;

var hashClear$1 = _hashClear,
    hashDelete$1 = _hashDelete,
    hashGet$1 = _hashGet,
    hashHas$1 = _hashHas,
    hashSet$1 = _hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function Hash$2(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash$2.prototype.clear = hashClear$1;
Hash$2.prototype['delete'] = hashDelete$1;
Hash$2.prototype.get = hashGet$1;
Hash$2.prototype.has = hashHas$1;
Hash$2.prototype.set = hashSet$1;
var _Hash = Hash$2;

var Hash$1 = _Hash,
    ListCache$3 = _ListCache,
    Map$5 = _Map;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */


function mapCacheClear$2() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$1(),
    'map': new (Map$5 || ListCache$3)(),
    'string': new Hash$1()
  };
}

var _mapCacheClear = mapCacheClear$2;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$2(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

var _isKeyable = isKeyable$2;

var isKeyable$1 = _isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData$5(map, key) {
  var data = map.__data__;
  return isKeyable$1(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData$5;

var getMapData$4 = _getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete$2(key) {
  var result = getMapData$4(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$2;

var getMapData$3 = _getMapData;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet$2(key) {
  return getMapData$3(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$2;

var getMapData$2 = _getMapData;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas$2(key) {
  return getMapData$2(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$2;

var getMapData$1 = _getMapData;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet$2(key, value) {
  var data = getMapData$1(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$2;

var mapCacheClear$1 = _mapCacheClear,
    mapCacheDelete$1 = _mapCacheDelete,
    mapCacheGet$1 = _mapCacheGet,
    mapCacheHas$1 = _mapCacheHas,
    mapCacheSet$1 = _mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function MapCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache$4.prototype.clear = mapCacheClear$1;
MapCache$4.prototype['delete'] = mapCacheDelete$1;
MapCache$4.prototype.get = mapCacheGet$1;
MapCache$4.prototype.has = mapCacheHas$1;
MapCache$4.prototype.set = mapCacheSet$1;
var _MapCache = MapCache$4;

var ListCache$2 = _ListCache,
    Map$4 = _Map,
    MapCache$3 = _MapCache;
/** Used as the size to enable large array optimizations. */


var LARGE_ARRAY_SIZE$1 = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet$2(key, value) {
  var data = this.__data__;

  if (data instanceof ListCache$2) {
    var pairs = data.__data__;

    if (!Map$4 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new MapCache$3(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$2;

var ListCache$1 = _ListCache,
    stackClear$1 = _stackClear,
    stackDelete$1 = _stackDelete,
    stackGet$1 = _stackGet,
    stackHas$1 = _stackHas,
    stackSet$1 = _stackSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function Stack$4(entries) {
  var data = this.__data__ = new ListCache$1(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack$4.prototype.clear = stackClear$1;
Stack$4.prototype['delete'] = stackDelete$1;
Stack$4.prototype.get = stackGet$1;
Stack$4.prototype.has = stackHas$1;
Stack$4.prototype.set = stackSet$1;
var _Stack = Stack$4;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */

function setCacheAdd$2(value) {
  this.__data__.set(value, HASH_UNDEFINED$3);

  return this;
}

var _setCacheAdd = setCacheAdd$2;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$2(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$2;

var MapCache$2 = _MapCache,
    setCacheAdd$1 = _setCacheAdd,
    setCacheHas$1 = _setCacheHas;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */


function SetCache$2(values) {
  var index = -1,
      length = values == null ? 0 : values.length;
  this.__data__ = new MapCache$2();

  while (++index < length) {
    this.add(values[index]);
  }
} // Add methods to `SetCache`.


SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd$1;
SetCache$2.prototype.has = setCacheHas$1;
var _SetCache = SetCache$2;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }

  return false;
}

var _arraySome = arraySome$2;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$2(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$2;

var SetCache$1 = _SetCache,
    arraySome$1 = _arraySome,
    cacheHas$1 = _cacheHas;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$b = 1,
    COMPARE_UNORDERED_FLAG$7 = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */

function equalArrays$3(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$b,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  } // Check that cyclic values are equal.


  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);

  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }

  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG$7 ? new SetCache$1() : undefined;
  stack.set(array, other);
  stack.set(other, array); // Ignore non-index properties.

  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }

    if (compared !== undefined) {
      if (compared) {
        continue;
      }

      result = false;
      break;
    } // Recursively compare arrays (susceptible to call stack limits).


    if (seen) {
      if (!arraySome$1(other, function (othValue, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }

  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$3;

var root$9 = _root;
/** Built-in value references. */


var Uint8Array$5 = root$9.Uint8Array;
var _Uint8Array = Uint8Array$5;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$2(map) {
  var index = -1,
      result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$2;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$2(set) {
  var index = -1,
      result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$2;

var Symbol$6 = _Symbol,
    Uint8Array$4 = _Uint8Array,
    eq$2 = eq_1,
    equalArrays$2 = _equalArrays,
    mapToArray$1 = _mapToArray,
    setToArray$1 = _setToArray;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$a = 1,
    COMPARE_UNORDERED_FLAG$6 = 2;
/** `Object#toString` result references. */

var boolTag$4 = '[object Boolean]',
    dateTag$4 = '[object Date]',
    errorTag$3 = '[object Error]',
    mapTag$7 = '[object Map]',
    numberTag$4 = '[object Number]',
    regexpTag$4 = '[object RegExp]',
    setTag$7 = '[object Set]',
    stringTag$5 = '[object String]',
    symbolTag$7 = '[object Symbol]';
var arrayBufferTag$4 = '[object ArrayBuffer]',
    dataViewTag$6 = '[object DataView]';
/** Used to convert symbols to primitives and strings. */

var symbolProto$4 = Symbol$6 ? Symbol$6.prototype : undefined,
    symbolValueOf$2 = symbolProto$4 ? symbolProto$4.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalByTag$2(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$6:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }

      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$4:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$4(object), new Uint8Array$4(other))) {
        return false;
      }

      return true;

    case boolTag$4:
    case dateTag$4:
    case numberTag$4:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$2(+object, +other);

    case errorTag$3:
      return object.name == other.name && object.message == other.message;

    case regexpTag$4:
    case stringTag$5:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag$7:
      var convert = mapToArray$1;

    case setTag$7:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$a;
      convert || (convert = setToArray$1);

      if (object.size != other.size && !isPartial) {
        return false;
      } // Assume cyclic values are equal.


      var stacked = stack.get(object);

      if (stacked) {
        return stacked == other;
      }

      bitmask |= COMPARE_UNORDERED_FLAG$6; // Recursively compare objects (susceptible to call stack limits).

      stack.set(object, other);
      var result = equalArrays$2(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$7:
      if (symbolValueOf$2) {
        return symbolValueOf$2.call(object) == symbolValueOf$2.call(other);
      }

  }

  return false;
}

var _equalByTag = equalByTag$2;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$4(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

var _arrayPush = arrayPush$4;

var arrayPush$3 = _arrayPush,
    isArray$h = isArray_1;
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */


function baseGetAllKeys$3(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$h(object) ? result : arrayPush$3(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$3;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

var _arrayFilter = arrayFilter$2;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$3() {
  return [];
}

var stubArray_1 = stubArray$3;

var arrayFilter$1 = _arrayFilter,
    stubArray$2 = stubArray_1;
/** Used for built-in method references. */


var objectProto$p = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable$3 = objectProto$p.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols$2 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols$5 = !nativeGetSymbols$2 ? stubArray$2 : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$2(object), function (symbol) {
    return propertyIsEnumerable$3.call(object, symbol);
  });
};
var _getSymbols = getSymbols$5;

var baseGetAllKeys$2 = _baseGetAllKeys,
    getSymbols$4 = _getSymbols,
    keys$5 = keys_1;
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */


function getAllKeys$3(object) {
  return baseGetAllKeys$2(object, keys$5, getSymbols$4);
}

var _getAllKeys = getAllKeys$3;

var getAllKeys$2 = _getAllKeys;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$9 = 1;
/** Used for built-in method references. */

var objectProto$o = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$k = objectProto$o.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalObjects$2(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$9,
      objProps = getAllKeys$2(object),
      objLength = objProps.length,
      othProps = getAllKeys$2(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }

  var index = objLength;

  while (index--) {
    var key = objProps[index];

    if (!(isPartial ? key in other : hasOwnProperty$k.call(other, key))) {
      return false;
    }
  } // Check that cyclic values are equal.


  var objStacked = stack.get(object);
  var othStacked = stack.get(other);

  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }

  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;

  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    } // Recursively compare objects (susceptible to call stack limits).


    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }

    skipCtor || (skipCtor = key == 'constructor');
  }

  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }

  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$2;

var getNative$6 = _getNative,
    root$8 = _root;
/* Built-in method references that are verified to be native. */


var DataView$4 = getNative$6(root$8, 'DataView');
var _DataView = DataView$4;

var getNative$5 = _getNative,
    root$7 = _root;
/* Built-in method references that are verified to be native. */


var Promise$4 = getNative$5(root$7, 'Promise');
var _Promise = Promise$4;

var getNative$4 = _getNative,
    root$6 = _root;
/* Built-in method references that are verified to be native. */


var Set$4 = getNative$4(root$6, 'Set');
var _Set = Set$4;

var getNative$3 = _getNative,
    root$5 = _root;
/* Built-in method references that are verified to be native. */


var WeakMap$4 = getNative$3(root$5, 'WeakMap');
var _WeakMap = WeakMap$4;

var DataView$3 = _DataView,
    Map$3 = _Map,
    Promise$3 = _Promise,
    Set$3 = _Set,
    WeakMap$3 = _WeakMap,
    baseGetTag$2 = _baseGetTag,
    toSource$2 = _toSource;
/** `Object#toString` result references. */


var mapTag$6 = '[object Map]',
    objectTag$7 = '[object Object]',
    promiseTag$1 = '[object Promise]',
    setTag$6 = '[object Set]',
    weakMapTag$3 = '[object WeakMap]';
var dataViewTag$5 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString$1 = toSource$2(DataView$3),
    mapCtorString$1 = toSource$2(Map$3),
    promiseCtorString$1 = toSource$2(Promise$3),
    setCtorString$1 = toSource$2(Set$3),
    weakMapCtorString$1 = toSource$2(WeakMap$3);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

var getTag$6 = baseGetTag$2; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (DataView$3 && getTag$6(new DataView$3(new ArrayBuffer(1))) != dataViewTag$5 || Map$3 && getTag$6(new Map$3()) != mapTag$6 || Promise$3 && getTag$6(Promise$3.resolve()) != promiseTag$1 || Set$3 && getTag$6(new Set$3()) != setTag$6 || WeakMap$3 && getTag$6(new WeakMap$3()) != weakMapTag$3) {
  getTag$6 = function getTag(value) {
    var result = baseGetTag$2(value),
        Ctor = result == objectTag$7 ? value.constructor : undefined,
        ctorString = Ctor ? toSource$2(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1:
          return dataViewTag$5;

        case mapCtorString$1:
          return mapTag$6;

        case promiseCtorString$1:
          return promiseTag$1;

        case setCtorString$1:
          return setTag$6;

        case weakMapCtorString$1:
          return weakMapTag$3;
      }
    }

    return result;
  };
}

var _getTag = getTag$6;

var Stack$3 = _Stack,
    equalArrays$1 = _equalArrays,
    equalByTag$1 = _equalByTag,
    equalObjects$1 = _equalObjects,
    getTag$5 = _getTag,
    isArray$g = isArray_1,
    isBuffer$5 = isBuffer$7.exports,
    isTypedArray$3 = isTypedArray_1;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$8 = 1;
/** `Object#toString` result references. */

var argsTag$5 = '[object Arguments]',
    arrayTag$3 = '[object Array]',
    objectTag$6 = '[object Object]';
/** Used for built-in method references. */

var objectProto$n = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$j = objectProto$n.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function baseIsEqualDeep$2(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$g(object),
      othIsArr = isArray$g(other),
      objTag = objIsArr ? arrayTag$3 : getTag$5(object),
      othTag = othIsArr ? arrayTag$3 : getTag$5(other);
  objTag = objTag == argsTag$5 ? objectTag$6 : objTag;
  othTag = othTag == argsTag$5 ? objectTag$6 : othTag;
  var objIsObj = objTag == objectTag$6,
      othIsObj = othTag == objectTag$6,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$5(object)) {
    if (!isBuffer$5(other)) {
      return false;
    }

    objIsArr = true;
    objIsObj = false;
  }

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$3());
    return objIsArr || isTypedArray$3(object) ? equalArrays$1(object, other, bitmask, customizer, equalFunc, stack) : equalByTag$1(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }

  if (!(bitmask & COMPARE_PARTIAL_FLAG$8)) {
    var objIsWrapped = objIsObj && hasOwnProperty$j.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$j.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$3());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }

  if (!isSameTag) {
    return false;
  }

  stack || (stack = new Stack$3());
  return equalObjects$1(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$2;

var baseIsEqualDeep$1 = _baseIsEqualDeep,
    isObjectLike$9 = isObjectLike_1;
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */


function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }

  if (value == null || other == null || !isObjectLike$9(value) && !isObjectLike$9(other)) {
    return value !== value && other !== other;
  }

  return baseIsEqualDeep$1(value, other, bitmask, customizer, baseIsEqual$3, stack);
}

var _baseIsEqual = baseIsEqual$3;

var Stack$2 = _Stack,
    baseIsEqual$2 = _baseIsEqual;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$7 = 1,
    COMPARE_UNORDERED_FLAG$5 = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */

function baseIsMatch$2(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }

  object = Object(object);

  while (index--) {
    var data = matchData[index];

    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }

  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$2();

      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }

      if (!(result === undefined ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$7 | COMPARE_UNORDERED_FLAG$5, customizer, stack) : result)) {
        return false;
      }
    }
  }

  return true;
}

var _baseIsMatch = baseIsMatch$2;

var isObject$9 = isObject_1;
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */


function isStrictComparable$3(value) {
  return value === value && !isObject$9(value);
}

var _isStrictComparable = isStrictComparable$3;

var isStrictComparable$2 = _isStrictComparable,
    keys$4 = keys_1;
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */


function getMatchData$2(object) {
  var result = keys$4(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];
    result[length] = [key, value, isStrictComparable$2(value)];
  }

  return result;
}

var _getMatchData = getMatchData$2;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$3(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }

    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

var _matchesStrictComparable = matchesStrictComparable$3;

var baseIsMatch$1 = _baseIsMatch,
    getMatchData$1 = _getMatchData,
    matchesStrictComparable$2 = _matchesStrictComparable;
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */


function baseMatches$2(source) {
  var matchData = getMatchData$1(source);

  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$2(matchData[0][0], matchData[0][1]);
  }

  return function (object) {
    return object === source || baseIsMatch$1(object, source, matchData);
  };
}

var _baseMatches = baseMatches$2;

var baseGetTag$1 = _baseGetTag,
    isObjectLike$8 = isObjectLike_1;
/** `Object#toString` result references. */


var symbolTag$6 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol$7(value) {
  return typeof value == 'symbol' || isObjectLike$8(value) && baseGetTag$1(value) == symbolTag$6;
}

var isSymbol_1 = isSymbol$7;

var isArray$f = isArray_1,
    isSymbol$6 = isSymbol_1;
/** Used to match property names within property paths. */


var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp$1 = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey$4(value, object) {
  if (isArray$f(value)) {
    return false;
  }

  var type = typeof value;

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$6(value)) {
    return true;
  }

  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) || object != null && value in Object(object);
}

var _isKey = isKey$4;

var MapCache$1 = _MapCache;
/** Error message constants. */


var FUNC_ERROR_TEXT$6 = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize$2(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$6);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize$2.Cache || MapCache$1)();
  return memoized;
} // Expose `MapCache`.


memoize$2.Cache = MapCache$1;
var memoize_1 = memoize$2;

var memoize$1 = memoize_1;
/** Used as the maximum memoize cache size. */


var MAX_MEMOIZE_SIZE$1 = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped$2(func) {
  var result = memoize$1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE$1) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$2;

var memoizeCapped$1 = _memoizeCapped;
/** Used to match property names within property paths. */


var rePropName$2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar$2 = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath$4 = memoizeCapped$1(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
    result.push('');
  }

  string.replace(rePropName$2, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$2, '$1') : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$4;

var Symbol$5 = _Symbol,
    arrayMap$2 = _arrayMap,
    isArray$e = isArray_1,
    isSymbol$5 = isSymbol_1;
/** Used as references for various `Number` constants. */


var INFINITY$4 = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto$3 = Symbol$5 ? Symbol$5.prototype : undefined,
    symbolToString$1 = symbolProto$3 ? symbolProto$3.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString$2(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray$e(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$2(value, baseToString$2) + '';
  }

  if (isSymbol$5(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$4 ? '-0' : result;
}

var _baseToString = baseToString$2;

var baseToString$1 = _baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString$3(value) {
  return value == null ? '' : baseToString$1(value);
}

var toString_1 = toString$3;

var isArray$d = isArray_1,
    isKey$3 = _isKey,
    stringToPath$3 = _stringToPath,
    toString$2 = toString_1;
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */


function castPath$3(value, object) {
  if (isArray$d(value)) {
    return value;
  }

  return isKey$3(value, object) ? [value] : stringToPath$3(toString$2(value));
}

var _castPath = castPath$3;

var isSymbol$4 = isSymbol_1;
/** Used as references for various `Number` constants. */


var INFINITY$3 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$4(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$3 ? '-0' : result;
}

var _toKey = toKey$5;

var castPath$2 = _castPath,
    toKey$4 = _toKey;
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */


function baseGet$3(object, path) {
  path = castPath$2(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$4(path[index++])];
  }

  return index && index == length ? object : undefined;
}

var _baseGet = baseGet$3;

var baseGet$2 = _baseGet;
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */


function get$3(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$2(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$3;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$2(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$2;

var castPath$1 = _castPath,
    isArguments$3 = isArguments_1,
    isArray$c = isArray_1,
    isIndex$2 = _isIndex,
    isLength$2 = isLength_1,
    toKey$3 = _toKey;
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */


function hasPath$2(object, path, hasFunc) {
  path = castPath$1(path, object);
  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$3(path[index]);

    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }

    object = object[key];
  }

  if (result || ++index != length) {
    return result;
  }

  length = object == null ? 0 : object.length;
  return !!length && isLength$2(length) && isIndex$2(key, length) && (isArray$c(object) || isArguments$3(object));
}

var _hasPath = hasPath$2;

var baseHasIn$1 = _baseHasIn,
    hasPath$1 = _hasPath;
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */


function hasIn$2(object, path) {
  return object != null && hasPath$1(object, path, baseHasIn$1);
}

var hasIn_1 = hasIn$2;

var baseIsEqual$1 = _baseIsEqual,
    get$2 = get_1,
    hasIn$1 = hasIn_1,
    isKey$2 = _isKey,
    isStrictComparable$1 = _isStrictComparable,
    matchesStrictComparable$1 = _matchesStrictComparable,
    toKey$2 = _toKey;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$6 = 1,
    COMPARE_UNORDERED_FLAG$4 = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function baseMatchesProperty$2(path, srcValue) {
  if (isKey$2(path) && isStrictComparable$1(srcValue)) {
    return matchesStrictComparable$1(toKey$2(path), srcValue);
  }

  return function (object) {
    var objValue = get$2(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn$1(object, path) : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$6 | COMPARE_UNORDERED_FLAG$4);
  };
}

var _baseMatchesProperty = baseMatchesProperty$2;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$2(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$2;

var baseGet$1 = _baseGet;
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */


function basePropertyDeep$2(path) {
  return function (object) {
    return baseGet$1(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$2;

var baseProperty$1 = _baseProperty,
    basePropertyDeep$1 = _basePropertyDeep,
    isKey$1 = _isKey,
    toKey$1 = _toKey;
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */


function property$2(path) {
  return isKey$1(path) ? baseProperty$1(toKey$1(path)) : basePropertyDeep$1(path);
}

var property_1 = property$2;

var baseMatches$1 = _baseMatches,
    baseMatchesProperty$1 = _baseMatchesProperty,
    identity$2 = identity_1,
    isArray$b = isArray_1,
    property$1 = property_1;
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */


function baseIteratee$2(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }

  if (value == null) {
    return identity$2;
  }

  if (typeof value == 'object') {
    return isArray$b(value) ? baseMatchesProperty$1(value[0], value[1]) : baseMatches$1(value);
  }

  return property$1(value);
}

var _baseIteratee = baseIteratee$2;

var isArrayLike$4 = isArrayLike_1;
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */


function createBaseEach$2(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }

    if (!isArrayLike$4(collection)) {
      return eachFunc(collection, iteratee);
    }

    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }

    return collection;
  };
}

var _createBaseEach = createBaseEach$2;

var baseForOwn$1 = _baseForOwn,
    createBaseEach$1 = _createBaseEach;
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */


var baseEach$3 = createBaseEach$1(baseForOwn$1);
var _baseEach = baseEach$3;

var baseEach$2 = _baseEach,
    isArrayLike$3 = isArrayLike_1;
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */


function baseMap$2(collection, iteratee) {
  var index = -1,
      result = isArrayLike$3(collection) ? Array(collection.length) : [];
  baseEach$2(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$2;

var arrayMap$1 = _arrayMap,
    baseIteratee$1 = _baseIteratee,
    baseMap$1 = _baseMap,
    isArray$a = isArray_1;
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */


function map$1(collection, iteratee) {
  var func = isArray$a(collection) ? arrayMap$1 : baseMap$1;
  return func(collection, baseIteratee$1(iteratee));
}

var map_1 = map$1;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenNames = undefined;

var _isString2 = isString_1;

var _isString3 = _interopRequireDefault(_isString2);

var _forOwn2 = forOwn_1;

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _isPlainObject2 = isPlainObject_1;

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _map2 = map_1;

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var names = [];
  (0, _map3["default"])(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3["default"])(thing)) {
      (0, _forOwn3["default"])(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3["default"])(thing)) {
      names.push(thing);
    }
  });
  return names;
};

exports["default"] = flattenNames;
}(flattenNames));

var mergeClasses = {};

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$3(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

var _arrayEach = arrayEach$3;

var getNative$2 = _getNative;

var defineProperty$5 = function () {
  try {
    var func = getNative$2(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

var _defineProperty$f = defineProperty$5;

var defineProperty$4 = _defineProperty$f;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */


function baseAssignValue$3(object, key, value) {
  if (key == '__proto__' && defineProperty$4) {
    defineProperty$4(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$3;

var baseAssignValue$2 = _baseAssignValue,
    eq$1 = eq_1;
/** Used for built-in method references. */


var objectProto$m = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$i = objectProto$m.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue$3(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$i.call(object, key) && eq$1(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue$2(object, key, value);
  }
}

var _assignValue = assignValue$3;

var assignValue$2 = _assignValue,
    baseAssignValue$1 = _baseAssignValue;
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */


function copyObject$5(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      baseAssignValue$1(object, key, newValue);
    } else {
      assignValue$2(object, key, newValue);
    }
  }

  return object;
}

var _copyObject = copyObject$5;

var copyObject$4 = _copyObject,
    keys$3 = keys_1;
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */


function baseAssign$1(object, source) {
  return object && copyObject$4(source, keys$3(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$2(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

var _nativeKeysIn = nativeKeysIn$2;

var isObject$8 = isObject_1,
    isPrototype$2 = _isPrototype,
    nativeKeysIn$1 = _nativeKeysIn;
/** Used for built-in method references. */


var objectProto$l = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$h = objectProto$l.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn$2(object) {
  if (!isObject$8(object)) {
    return nativeKeysIn$1(object);
  }

  var isProto = isPrototype$2(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$h.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

var _baseKeysIn = baseKeysIn$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeysIn$1 = _baseKeysIn,
    isArrayLike$2 = isArrayLike_1;
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */


function keysIn$4(object) {
  return isArrayLike$2(object) ? arrayLikeKeys$1(object, true) : baseKeysIn$1(object);
}

var keysIn_1 = keysIn$4;

var copyObject$3 = _copyObject,
    keysIn$3 = keysIn_1;
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */


function baseAssignIn$1(object, source) {
  return object && copyObject$3(source, keysIn$3(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

(function (module, exports) {
var root = _root;
/** Detect free variable `exports`. */


var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */

var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */

function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }

  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
}(_cloneBuffer, _cloneBuffer.exports));

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$3(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

var _copyArray = copyArray$3;

var copyObject$2 = _copyObject,
    getSymbols$3 = _getSymbols;
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */


function copySymbols$1(source, object) {
  return copyObject$2(source, getSymbols$3(source), object);
}

var _copySymbols = copySymbols$1;

var arrayPush$2 = _arrayPush,
    getPrototype$4 = _getPrototype,
    getSymbols$2 = _getSymbols,
    stubArray$1 = stubArray_1;
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbolsIn$2 = !nativeGetSymbols$1 ? stubArray$1 : function (object) {
  var result = [];

  while (object) {
    arrayPush$2(result, getSymbols$2(object));
    object = getPrototype$4(object);
  }

  return result;
};
var _getSymbolsIn = getSymbolsIn$2;

var copyObject$1 = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */


function copySymbolsIn$1(source, object) {
  return copyObject$1(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$2 = keysIn_1;
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */


function getAllKeysIn$1(object) {
  return baseGetAllKeys$1(object, keysIn$2, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$1;

/** Used for built-in method references. */

var objectProto$k = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$g = objectProto$k.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */

function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

  if (length && typeof array[0] == 'string' && hasOwnProperty$g.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }

  return result;
}

var _initCloneArray = initCloneArray$1;

var Uint8Array$3 = _Uint8Array;
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */


function cloneArrayBuffer$4(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$3(result).set(new Uint8Array$3(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$4;

var cloneArrayBuffer$3 = _cloneArrayBuffer;
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */


function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$3(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */

function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$4 = _Symbol;
/** Used to convert symbols to primitives and strings. */


var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */

function cloneSymbol$1(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$2 = _cloneArrayBuffer;
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */


function cloneTypedArray$2(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$2;

var cloneArrayBuffer$1 = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray$1 = _cloneTypedArray;
/** `Object#toString` result references. */


var boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$4 = '[object String]',
    symbolTag$5 = '[object Symbol]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;

  switch (tag) {
    case arrayBufferTag$3:
      return cloneArrayBuffer$1(object);

    case boolTag$3:
    case dateTag$3:
      return new Ctor(+object);

    case dataViewTag$4:
      return cloneDataView(object, isDeep);

    case float32Tag$2:
    case float64Tag$2:
    case int8Tag$2:
    case int16Tag$2:
    case int32Tag$2:
    case uint8Tag$2:
    case uint8ClampedTag$2:
    case uint16Tag$2:
    case uint32Tag$2:
      return cloneTypedArray$1(object, isDeep);

    case mapTag$5:
      return new Ctor();

    case numberTag$3:
    case stringTag$4:
      return new Ctor(object);

    case regexpTag$3:
      return cloneRegExp(object);

    case setTag$5:
      return new Ctor();

    case symbolTag$5:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$7 = isObject_1;
/** Built-in value references. */


var objectCreate$2 = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate$4 = function () {
  function object() {}

  return function (proto) {
    if (!isObject$7(proto)) {
      return {};
    }

    if (objectCreate$2) {
      return objectCreate$2(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var _baseCreate = baseCreate$4;

var baseCreate$3 = _baseCreate,
    getPrototype$3 = _getPrototype,
    isPrototype$1 = _isPrototype;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */


function initCloneObject$2(object) {
  return typeof object.constructor == 'function' && !isPrototype$1(object) ? baseCreate$3(getPrototype$3(object)) : {};
}

var _initCloneObject = initCloneObject$2;

var getTag$4 = _getTag,
    isObjectLike$7 = isObjectLike_1;
/** `Object#toString` result references. */


var mapTag$4 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */

function baseIsMap$1(value) {
  return isObjectLike$7(value) && getTag$4(value) == mapTag$4;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$2 = _baseUnary,
    nodeUtil$3 = _nodeUtil.exports;
/* Node.js helper references. */


var nodeIsMap = nodeUtil$3 && nodeUtil$3.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */

var isMap$2 = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap;
var isMap_1 = isMap$2;

var getTag$3 = _getTag,
    isObjectLike$6 = isObjectLike_1;
/** `Object#toString` result references. */


var setTag$4 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */

function baseIsSet$1(value) {
  return isObjectLike$6(value) && getTag$3(value) == setTag$4;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary$1 = _baseUnary,
    nodeUtil$2 = _nodeUtil.exports;
/* Node.js helper references. */


var nodeIsSet = nodeUtil$2 && nodeUtil$2.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */

var isSet$2 = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet;
var isSet_1 = isSet$2;

var Stack$1 = _Stack,
    arrayEach$2 = _arrayEach,
    assignValue$1 = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer$1 = _cloneBuffer.exports,
    copyArray$2 = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys$1 = _getAllKeys,
    getAllKeysIn = _getAllKeysIn,
    getTag$2 = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject$1 = _initCloneObject,
    isArray$9 = isArray_1,
    isBuffer$4 = isBuffer$7.exports,
    isMap$1 = isMap_1,
    isObject$6 = isObject_1,
    isSet$1 = isSet_1,
    keys$2 = keys_1,
    keysIn$1 = keysIn_1;
/** Used to compose bitmasks for cloning. */


var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;
/** `Object#toString` result references. */

var argsTag$4 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$4 = '[object Function]',
    genTag$3 = '[object GeneratorFunction]',
    mapTag$3 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$5 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$4 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */

var cloneableTags = {};
cloneableTags[argsTag$4] = cloneableTags[arrayTag$2] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] = cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] = cloneableTags[int32Tag$1] = cloneableTags[mapTag$3] = cloneableTags[numberTag$2] = cloneableTags[objectTag$5] = cloneableTags[regexpTag$2] = cloneableTags[setTag$3] = cloneableTags[stringTag$3] = cloneableTags[symbolTag$4] = cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] = cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = true;
cloneableTags[errorTag$2] = cloneableTags[funcTag$4] = cloneableTags[weakMapTag$2] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */

function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }

  if (result !== undefined) {
    return result;
  }

  if (!isObject$6(value)) {
    return value;
  }

  var isArr = isArray$9(value);

  if (isArr) {
    result = initCloneArray(value);

    if (!isDeep) {
      return copyArray$2(value, result);
    }
  } else {
    var tag = getTag$2(value),
        isFunc = tag == funcTag$4 || tag == genTag$3;

    if (isBuffer$4(value)) {
      return cloneBuffer$1(value, isDeep);
    }

    if (tag == objectTag$5 || tag == argsTag$4 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject$1(value);

      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }

      result = initCloneByTag(value, tag, isDeep);
    }
  } // Check for circular references and return its corresponding clone.


  stack || (stack = new Stack$1());
  var stacked = stack.get(value);

  if (stacked) {
    return stacked;
  }

  stack.set(value, result);

  if (isSet$1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys$1 : isFlat ? keysIn$1 : keys$2;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach$2(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    } // Recursively populate clone (susceptible to call stack limits).


    assignValue$1(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

var baseClone = _baseClone;
/** Used to compose bitmasks for cloning. */


var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */

function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

var cloneDeep_1 = cloneDeep;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = undefined;

var _forOwn2 = forOwn_1;

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _cloneDeep2 = cloneDeep_1;

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var styles = classes["default"] && (0, _cloneDeep3["default"])(classes["default"]) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];

    if (toMerge) {
      (0, _forOwn3["default"])(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports["default"] = mergeClasses;
}(mergeClasses));

var autoprefix = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoprefix = undefined;

var _forOwn2 = forOwn_1;

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },
  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },
  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },
  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];

    if (otherStyle) {
      return otherStyle;
    }

    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3["default"])(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3["default"])(styles, function (value, key) {
      var transform = transforms[key];

      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports["default"] = autoprefix;
}(autoprefix));

var hover = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = react.exports;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        hover: false
      }, _this.handleMouseOver = function () {
        return _this.setState({
          hover: true
        });
      }, _this.handleMouseOut = function () {
        return _this.setState({
          hover: false
        });
      }, _this.render = function () {
        return _react2["default"].createElement(Span, {
          onMouseOver: _this.handleMouseOver,
          onMouseOut: _this.handleMouseOut
        }, _react2["default"].createElement(Component, _extends({}, _this.props, _this.state)));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2["default"].Component);
};

exports["default"] = hover;
}(hover));

var active = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = react.exports;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        active: false
      }, _this.handleMouseDown = function () {
        return _this.setState({
          active: true
        });
      }, _this.handleMouseUp = function () {
        return _this.setState({
          active: false
        });
      }, _this.render = function () {
        return _react2["default"].createElement(Span, {
          onMouseDown: _this.handleMouseDown,
          onMouseUp: _this.handleMouseUp
        }, _react2["default"].createElement(Component, _extends({}, _this.props, _this.state)));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2["default"].Component);
};

exports["default"] = active;
}(active));

var loop = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var loopable = function loopable(i, length) {
  var props = {};

  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);
  return props;
};

exports["default"] = loopable;
}(loop));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;

var _flattenNames = flattenNames;

var _flattenNames2 = _interopRequireDefault(_flattenNames);

var _mergeClasses = mergeClasses;

var _mergeClasses2 = _interopRequireDefault(_mergeClasses);

var _autoprefix = autoprefix;

var _autoprefix2 = _interopRequireDefault(_autoprefix);

var _hover2 = hover;

var _hover3 = _interopRequireDefault(_hover2);

var _active = active;

var _active2 = _interopRequireDefault(_active);

var _loop2 = loop;

var _loop3 = _interopRequireDefault(_loop2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports.hover = _hover3["default"];
exports.handleHover = _hover3["default"];
exports.handleActive = _active2["default"];
exports.loop = _loop3["default"];

var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2["default"])(activations);
  var merged = (0, _mergeClasses2["default"])(classes, activeNames);
  return (0, _autoprefix2["default"])(merged);
};

exports["default"] = ReactCSS;
}(lib$4));

var reactCSS = /*@__PURE__*/getDefaultExportFromCjs(lib$4);

var calculateChange$2 = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;

    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;

    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }

  return null;
};

var checkboardCache = {};
var render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }

  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');

  if (!ctx) {
    return null;
  } // If no context can be found, return early.


  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};
var get$1 = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      children = _ref.children;
  var styles = reactCSS({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + get$1(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return /*#__PURE__*/react.exports.isValidElement(children) ? /*#__PURE__*/React.cloneElement(children, _extends$8({}, children.props, {
    style: _extends$8({}, children.props.style, styles.grid)
  })) : /*#__PURE__*/React.createElement('div', {
    style: styles.grid
  });
};
Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass$a = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$c(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$9(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$a(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Alpha = function (_ref) {
  _inherits$a(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck$c(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$9(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = calculateChange$2(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);

      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn$9(_this, _ret);
  }

  _createClass$a(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = reactCSS({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends$7({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });
      return /*#__PURE__*/React.createElement('div', {
        style: styles.alpha
      }, /*#__PURE__*/React.createElement('div', {
        style: styles.checkboard
      }, /*#__PURE__*/React.createElement(Checkboard, {
        renderers: this.props.renderers
      })), /*#__PURE__*/React.createElement('div', {
        style: styles.gradient
      }), /*#__PURE__*/React.createElement('div', {
        style: styles.container,
        ref: function ref(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /*#__PURE__*/React.createElement('div', {
        style: styles.pointer
      }, this.props.pointer ? /*#__PURE__*/React.createElement(this.props.pointer, this.props) : /*#__PURE__*/React.createElement('div', {
        style: styles.slider
      }))));
    }
  }]);

  return Alpha;
}(react.exports.PureComponent || react.exports.Component);

var _createClass$9 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _defineProperty$e(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck$b(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$8(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$9(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var DEFAULT_ARROW_OFFSET = 1;
var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];

var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};

var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};

var idCounter = 1;
var EditableInput = function (_ref) {
  _inherits$9(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck$b(this, EditableInput);

    var _this = _possibleConstructorReturn$8(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({
          value: _this.state.blurValue,
          blurValue: null
        });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);

      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();

        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);

        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();

        _this.handleDrag(e);

        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    _this.inputId = 'rc-editable-input-' + idCounter++;
    return _this;
  }

  _createClass$9(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({
            blurValue: String(this.props.value).toUpperCase()
          });
        } else {
          this.setState({
            value: String(this.props.value).toUpperCase(),
            blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty$e({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);
      this.setState({
        value: value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = reactCSS({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);
      return /*#__PURE__*/React.createElement('div', {
        style: styles.wrap
      }, /*#__PURE__*/React.createElement('input', {
        id: this.inputId,
        style: styles.input,
        ref: function ref(input) {
          return _this2.input = input;
        },
        value: this.state.value,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        placeholder: this.props.placeholder,
        spellCheck: 'false'
      }), this.props.label && !this.props.hideLabel ? /*#__PURE__*/React.createElement('label', {
        htmlFor: this.inputId,
        style: styles.label,
        onMouseDown: this.handleMouseDown
      }, this.props.label) : null);
    }
  }]);

  return EditableInput;
}(react.exports.PureComponent || react.exports.Component);

var calculateChange$1 = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;

    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  } else {
    var _h = void 0;

    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;

      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  }

  return null;
};

var _createClass$8 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$a(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$7(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hue = function (_ref) {
  _inherits$8(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck$a(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$7(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = calculateChange$1(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);

      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn$7(_this, _ret);
  }

  _createClass$8(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;
      var styles = reactCSS({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, {
        vertical: direction === 'vertical'
      });
      return /*#__PURE__*/React.createElement('div', {
        style: styles.hue
      }, /*#__PURE__*/React.createElement('div', {
        className: 'hue-' + direction,
        style: styles.container,
        ref: function ref(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /*#__PURE__*/React.createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), /*#__PURE__*/React.createElement('div', {
        style: styles.pointer
      }, this.props.pointer ? /*#__PURE__*/React.createElement(this.props.pointer, this.props) : /*#__PURE__*/React.createElement('div', {
        style: styles.slider
      }))));
    }
  }]);

  return Hue;
}(react.exports.PureComponent || react.exports.Component);

var propTypes = {exports: {}};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

{
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */

function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Detect free variable `global` from Node.js. */
var freeGlobal$3 = typeof global == 'object' && global && global.Object === Object && global;
var freeGlobal$4 = freeGlobal$3;

/** Detect free variable `self`. */

var freeSelf$3 = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$3 = freeGlobal$4 || freeSelf$3 || Function('return this')();
var root$4 = root$3;

/** Built-in value references. */

var Symbol$2 = root$4.Symbol;
var Symbol$3 = Symbol$2;

/** Used for built-in method references. */

var objectProto$j = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$f = objectProto$j.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$j.toString;
/** Built-in value references. */

var symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty$f.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }

  return result;
}

/** Used for built-in method references. */
var objectProto$i = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto$i.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString$6(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString$6(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$5(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag$3 = '[object Function]',
    genTag$2 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction$3(value) {
  if (!isObject$5(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag(value);
  return tag == funcTag$3 || tag == genTag$2 || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */

var coreJsData$1 = root$4['__core-js_shared__'];
var coreJsData$2 = coreJsData$1;

/** Used to detect methods masquerading as native. */

var maskSrcKey$1 = function () {
  var uid = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked$1(func) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func;
}

/** Used for built-in method references. */
var funcProto$4 = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$4 = funcProto$4.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource$1(func) {
  if (func != null) {
    try {
      return funcToString$4.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$3 = Function.prototype,
    objectProto$h = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$3 = funcProto$3.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$e = objectProto$h.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative$1 = RegExp('^' + funcToString$3.call(hasOwnProperty$e).replace(reRegExpChar$1, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative$1(value) {
  if (!isObject$5(value) || isMasked$1(value)) {
    return false;
  }

  var pattern = isFunction$3(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$1(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$3(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative$1(object, key) {
  var value = getValue$3(object, key);
  return baseIsNative$1(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */

var Map$1 = getNative$1(root$4, 'Map');
var Map$2 = Map$1;

/* Built-in method references that are verified to be native. */

var nativeCreate = getNative$1(Object, 'create');
var nativeCreate$1 = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$g = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$d = objectProto$g.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }

  return hasOwnProperty$d.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */

var objectProto$f = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$c = objectProto$f.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$c.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$2 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet(key, value) {
  var data = this.__data__;

  if (data instanceof ListCache) {
    var pairs = data.__data__;

    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new MapCache(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

var defineProperty$2 = function () {
  try {
    var func = getNative$1(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

var defineProperty$3 = defineProperty$2;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$3) {
    defineProperty$3(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];

      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }

    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */

var baseFor = createBaseFor();
var baseFor$1 = baseFor;

/** Detect free variable `exports`. */

var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
/** Built-in value references. */

var Buffer$2 = moduleExports$2 ? root$4.Buffer : undefined,
    allocUnsafe = Buffer$2 ? Buffer$2.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */

function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }

  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/** Built-in value references. */

var Uint8Array$1 = root$4.Uint8Array;
var Uint8Array$2 = Uint8Array$1;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */

function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */

function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray$1(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

/** Built-in value references. */

var objectCreate$1 = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate$1 = function () {
  function object() {}

  return function (proto) {
    if (!isObject$5(proto)) {
      return {};
    }

    if (objectCreate$1) {
      return objectCreate$1(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var baseCreate$2 = baseCreate$1;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg$1(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/** Built-in value references. */

var getPrototype$1 = overArg$1(Object.getPrototypeOf, Object);
var getPrototype$2 = getPrototype$1;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$e;
  return value === proto;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate$2(getPrototype$2(object)) : {};
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$5(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */

var argsTag$3 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike$5(value) && baseGetTag(value) == argsTag$3;
}

/** Used for built-in method references. */

var objectProto$d = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$b = objectProto$d.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable$2 = objectProto$d.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments$1 = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike$5(value) && hasOwnProperty$b.call(value, 'callee') && !propertyIsEnumerable$2.call(value, 'callee');
};
var isArguments$2 = isArguments$1;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$7 = Array.isArray;
var isArray$8 = isArray$7;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$3 = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength$1(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$3;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike$1(value) {
  return value != null && isLength$1(value.length) && !isFunction$3(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */

function isArrayLikeObject$1(value) {
  return isObjectLike$5(value) && isArrayLike$1(value);
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */

var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
/** Built-in value references. */

var Buffer$1 = moduleExports$1 ? root$4.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */

var isBuffer$2 = nativeIsBuffer || stubFalse;
var isBuffer$3 = isBuffer$2;

/** `Object#toString` result references. */

var objectTag$4 = '[object Object]';
/** Used for built-in method references. */

var funcProto$2 = Function.prototype,
    objectProto$c = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$2 = funcProto$2.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$a = objectProto$c.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString$1 = funcToString$2.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */

function isPlainObject$4(value) {
  if (!isObjectLike$5(value) || baseGetTag(value) != objectTag$4) {
    return false;
  }

  var proto = getPrototype$2(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty$a.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString$1;
}

/** `Object#toString` result references. */

var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$2 = '[object Function]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$3 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$2] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$1] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike$5(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */

var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */

var freeProcess = moduleExports && freeGlobal$4.process;
/** Used to access faster Node.js helpers. */

var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    } // Legacy `process.binding('util')` for Node.js < 10.


    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

var nodeUtil$1 = nodeUtil;

/* Node.js helper references. */

var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray$1 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$2 = isTypedArray$1;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/** Used for built-in method references. */

var objectProto$b = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$9.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */

function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }

  return object;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$2 = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint$1 = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex$1(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$2 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint$1.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/** Used for built-in method references. */

var objectProto$a = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys(value, inherited) {
  var isArr = isArray$8(value),
      isArg = !isArr && isArguments$2(value),
      isBuff = !isArr && !isArg && isBuffer$3(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$2(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$8.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex$1(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

/** Used for built-in method references. */

var objectProto$9 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn(object) {
  if (!isObject$5(object)) {
    return nativeKeysIn(object);
  }

  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$7.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */

function keysIn(object) {
  return isArrayLike$1(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */

function toPlainObject$1(value) {
  return copyObject(value, keysIn(value));
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */

function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }

  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray$8(srcValue),
        isBuff = !isArr && isBuffer$3(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray$2(srcValue);
    newValue = srcValue;

    if (isArr || isBuff || isTyped) {
      if (isArray$8(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject$1(objValue)) {
        newValue = copyArray$1(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject$4(srcValue) || isArguments$2(srcValue)) {
      newValue = objValue;

      if (isArguments$2(objValue)) {
        newValue = toPlainObject$1(objValue);
      } else if (!isObject$5(objValue) || isFunction$3(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }

  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }

  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */

function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }

  baseFor$1(source, function (srcValue, key) {
    stack || (stack = new Stack());

    if (isObject$5(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }

      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity$1(value) {
  return value;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply$3(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$4 = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */

function overRest(func, start, transform) {
  start = nativeMax$4(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax$4(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = transform(array);
    return apply$3(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant$1(value) {
  return function () {
    return value;
  };
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var baseSetToString = !defineProperty$3 ? identity$1 : function (func, string) {
  return defineProperty$3(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant$1(string),
    'writable': true
  });
};
var baseSetToString$1 = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */

function shortOut(func) {
  var count = 0,
      lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;

    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }

    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var setToString = shortOut(baseSetToString$1);
var setToString$1 = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */

function baseRest$1(func, start) {
  return setToString$1(overRest(func, start, identity$1), func + '');
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */

function isIterateeCall(value, index, object) {
  if (!isObject$5(object)) {
    return false;
  }

  var type = typeof index;

  if (type == 'number' ? isArrayLike$1(object) && isIndex$1(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }

  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */

function createAssigner(assigner) {
  return baseRest$1(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;
    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }

    object = Object(object);

    while (++index < length) {
      var source = sources[index];

      if (source) {
        assigner(object, source, index, customizer);
      }
    }

    return object;
  });
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */

var merge$2 = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});
var merge$3 = merge$2;

var Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;
  var styles = reactCSS(merge$3({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },
    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), {
    'zDepth-1': zDepth === 1
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.wrap
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.bg
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.content
  }, children));
};
Raised.propTypes = {
  background: PropTypes.string,
  zDepth: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
  radius: PropTypes.number,
  styles: PropTypes.object
};
Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */

var now$1 = function now() {
  return root$4.Date.now();
};

var now$2 = now$1;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */

function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}

  return index;
}

/** Used to match leading whitespace. */

var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */

function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

/** `Object#toString` result references. */

var symbolTag$3 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol$3(value) {
  return typeof value == 'symbol' || isObjectLike$5(value) && baseGetTag(value) == symbolTag$3;
}

/** Used as references for various `Number` constants. */

var NAN$2 = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex$2 = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary$2 = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal$2 = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt$2 = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */

function toNumber$4(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol$3(value)) {
    return NAN$2;
  }

  if (isObject$5(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$5(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = baseTrim(value);
  var isBinary = reIsBinary$2.test(value);
  return isBinary || reIsOctal$2.test(value) ? freeParseInt$2(value.slice(2), isBinary ? 2 : 8) : reIsBadHex$2.test(value) ? NAN$2 : +value;
}

/** Error message constants. */

var FUNC_ERROR_TEXT$5 = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$3 = Math.max,
    nativeMin$2 = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */

function debounce$2(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$5);
  }

  wait = toNumber$4(wait) || 0;

  if (isObject$5(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$3(toNumber$4(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin$2(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now$2();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$2());
  }

  function debounced() {
    var time = now$2(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/** Error message constants. */

var FUNC_ERROR_TEXT$4 = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */

function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$4);
  }

  if (isObject$5(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  return debounce$2(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;
  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv'
  };
};

var _createClass$7 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$9(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$6(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Saturation = function (_ref) {
  _inherits$7(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck$9(this, Saturation);

    var _this = _possibleConstructorReturn$6(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, calculateChange(e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);

      var renderWindow = _this.getContainerRenderWindow();

      renderWindow.addEventListener('mousemove', _this.handleChange);
      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = throttle(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass$7(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'getContainerRenderWindow',
    value: function getContainerRenderWindow() {
      var container = this.container;
      var renderWindow = window;

      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }

      return renderWindow;
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener('mousemove', this.handleChange);
      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = reactCSS({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, {
        'custom': !!this.props.style
      });
      return /*#__PURE__*/React.createElement('div', {
        style: styles.color,
        ref: function ref(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /*#__PURE__*/React.createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), /*#__PURE__*/React.createElement('div', {
        style: styles.white,
        className: 'saturation-white'
      }, /*#__PURE__*/React.createElement('div', {
        style: styles.black,
        className: 'saturation-black'
      }), /*#__PURE__*/React.createElement('div', {
        style: styles.pointer
      }, this.props.pointer ? /*#__PURE__*/React.createElement(this.props.pointer, this.props) : /*#__PURE__*/React.createElement('div', {
        style: styles.circle
      }))));
    }
  }]);

  return Saturation;
}(react.exports.PureComponent || react.exports.Component);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys = overArg$1(Object.keys, Object);
var nativeKeys$1 = nativeKeys;

/** Used for built-in method references. */

var objectProto$8 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$6.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */

function keys$1(object) {
  return isArrayLike$1(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */

function baseForOwn(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys$1);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }

    if (!isArrayLike$1(collection)) {
      return eachFunc(collection, iteratee);
    }

    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }

    return collection;
  };
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */

var baseEach = createBaseEach(baseForOwn);
var baseEach$1 = baseEach;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */

function castFunction(value) {
  return typeof value == 'function' ? value : identity$1;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */

function forEach$1(collection, iteratee) {
  var func = isArray$8(collection) ? arrayEach$1 : baseEach$1;
  return func(collection, castFunction(iteratee));
}

// This file is autogenerated. It's used to publish ESM to npm.
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var trimLeft = /^\s+/;
var trimRight = /\s+$/;

function tinycolor(color, opts) {
  color = color ? color : "";
  opts = opts || {}; // If input is already a tinycolor, return itself

  if (color instanceof tinycolor) {
    return color;
  } // If we are called as a function, call using new instead


  if (!(this instanceof tinycolor)) {
    return new tinycolor(color, opts);
  }

  var rgb = inputToRGB(color);
  this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
  this._gradientType = opts.gradientType; // Don't let the range of [0,255] come back in [0,1].
  // Potentially lose a little bit of precision here, but will fix issues where
  // .5 gets interpreted as half of the total, instead of half of 1
  // If it was supposed to be 128, this was already taken care of by `inputToRgb`

  if (this._r < 1) this._r = Math.round(this._r);
  if (this._g < 1) this._g = Math.round(this._g);
  if (this._b < 1) this._b = Math.round(this._b);
  this._ok = rgb.ok;
}

tinycolor.prototype = {
  isDark: function isDark() {
    return this.getBrightness() < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  isValid: function isValid() {
    return this._ok;
  },
  getOriginalInput: function getOriginalInput() {
    return this._originalInput;
  },
  getFormat: function getFormat() {
    return this._format;
  },
  getAlpha: function getAlpha() {
    return this._a;
  },
  getBrightness: function getBrightness() {
    //http://www.w3.org/TR/AERT#color-contrast
    var rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
  },
  getLuminance: function getLuminance() {
    //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    var rgb = this.toRgb();
    var RsRGB, GsRGB, BsRGB, R, G, B;
    RsRGB = rgb.r / 255;
    GsRGB = rgb.g / 255;
    BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  },
  setAlpha: function setAlpha(value) {
    this._a = boundAlpha(value);
    this._roundA = Math.round(100 * this._a) / 100;
    return this;
  },
  toHsv: function toHsv() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    return {
      h: hsv.h * 360,
      s: hsv.s,
      v: hsv.v,
      a: this._a
    };
  },
  toHsvString: function toHsvString() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    var h = Math.round(hsv.h * 360),
        s = Math.round(hsv.s * 100),
        v = Math.round(hsv.v * 100);
    return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
  },
  toHsl: function toHsl() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    return {
      h: hsl.h * 360,
      s: hsl.s,
      l: hsl.l,
      a: this._a
    };
  },
  toHslString: function toHslString() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    var h = Math.round(hsl.h * 360),
        s = Math.round(hsl.s * 100),
        l = Math.round(hsl.l * 100);
    return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
  },
  toHex: function toHex(allow3Char) {
    return rgbToHex$1(this._r, this._g, this._b, allow3Char);
  },
  toHexString: function toHexString(allow3Char) {
    return "#" + this.toHex(allow3Char);
  },
  toHex8: function toHex8(allow4Char) {
    return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
  },
  toHex8String: function toHex8String(allow4Char) {
    return "#" + this.toHex8(allow4Char);
  },
  toRgb: function toRgb() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function toRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function toPercentageRgb() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function toPercentageRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function toName() {
    if (this._a === 0) {
      return "transparent";
    }

    if (this._a < 1) {
      return false;
    }

    return hexNames[rgbToHex$1(this._r, this._g, this._b, true)] || false;
  },
  toFilter: function toFilter(secondColor) {
    var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
    var secondHex8String = hex8String;
    var gradientType = this._gradientType ? "GradientType = 1, " : "";

    if (secondColor) {
      var s = tinycolor(secondColor);
      secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
    }

    return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
  },
  toString: function toString(format) {
    var formatSet = !!format;
    format = format || this._format;
    var formattedString = false;
    var hasAlpha = this._a < 1 && this._a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

    if (needsAlphaFormat) {
      // Special case for "transparent", all other non-alpha formats
      // will return rgba when there is transparency.
      if (format === "name" && this._a === 0) {
        return this.toName();
      }

      return this.toRgbString();
    }

    if (format === "rgb") {
      formattedString = this.toRgbString();
    }

    if (format === "prgb") {
      formattedString = this.toPercentageRgbString();
    }

    if (format === "hex" || format === "hex6") {
      formattedString = this.toHexString();
    }

    if (format === "hex3") {
      formattedString = this.toHexString(true);
    }

    if (format === "hex4") {
      formattedString = this.toHex8String(true);
    }

    if (format === "hex8") {
      formattedString = this.toHex8String();
    }

    if (format === "name") {
      formattedString = this.toName();
    }

    if (format === "hsl") {
      formattedString = this.toHslString();
    }

    if (format === "hsv") {
      formattedString = this.toHsvString();
    }

    return formattedString || this.toHexString();
  },
  clone: function clone() {
    return tinycolor(this.toString());
  },
  _applyModification: function _applyModification(fn, args) {
    var color = fn.apply(null, [this].concat([].slice.call(args)));
    this._r = color._r;
    this._g = color._g;
    this._b = color._b;
    this.setAlpha(color._a);
    return this;
  },
  lighten: function lighten() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function brighten() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function darken() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function desaturate() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function saturate() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function greyscale() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function spin() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function _applyCombination(fn, args) {
    return fn.apply(null, [this].concat([].slice.call(args)));
  },
  analogous: function analogous() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function complement() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function monochromatic() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function splitcomplement() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function triad() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function tetrad() {
    return this._applyCombination(polyad, [4]);
  }
}; // If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1

tinycolor.fromRatio = function (color, opts) {
  if (typeof color == "object") {
    var newColor = {};

    for (var i in color) {
      if (color.hasOwnProperty(i)) {
        if (i === "a") {
          newColor[i] = color[i];
        } else {
          newColor[i] = convertToPercentage(color[i]);
        }
      }
    }

    color = newColor;
  }

  return tinycolor(color, opts);
}; // Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//


function inputToRGB(color) {
  var rgb = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format = false;

  if (typeof color == "string") {
    color = stringInputToObject(color);
  }

  if (typeof color == "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s = convertToPercentage(color.s);
      v = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s, v);
      ok = true;
      format = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s = convertToPercentage(color.s);
      l = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s, l);
      ok = true;
      format = "hsl";
    }

    if (color.hasOwnProperty("a")) {
      a = color.a;
    }
  }

  a = boundAlpha(a);
  return {
    ok: ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a
  };
} // Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]


function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
} // `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]


function rgbToHsl(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
  var h,
      s,
      l = (max + min) / 2;

  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return {
    h: h,
    s: s,
    l: l
  };
} // `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]


function hslToRgb(h, s, l) {
  var r, g, b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);

  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }

  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
} // `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]


function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
  var h,
      s,
      v = max;
  var d = max - min;
  s = max === 0 ? 0 : d / max;

  if (max == min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return {
    h: h,
    s: s,
    v: v
  };
} // `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]


function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h),
      f = h - i,
      p = v * (1 - s),
      q = v * (1 - f * s),
      t = v * (1 - (1 - f) * s),
      mod = i % 6,
      r = [v, q, p, p, t, v][mod],
      g = [t, v, v, q, p, p][mod],
      b = [p, p, t, v, v, q][mod];
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
} // `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex


function rgbToHex$1(r, g, b, allow3Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))]; // Return a 3 character hex if possible

  if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }

  return hex.join("");
} // `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex


function rgbaToHex(r, g, b, a, allow4Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))]; // Return a 4 character hex if possible

  if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
  }

  return hex.join("");
} // `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"


function rgbaToArgbHex(r, g, b, a) {
  var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  return hex.join("");
} // `equals`
// Can be called with any tinycolor input


tinycolor.equals = function (color1, color2) {
  if (!color1 || !color2) return false;
  return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function () {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
}; // Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>


function _desaturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s -= amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}

function _saturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s += amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}

function _greyscale(color) {
  return tinycolor(color).desaturate(100);
}

function _lighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l += amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}

function _brighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb = tinycolor(color).toRgb();
  rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
  rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
  rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
  return tinycolor(rgb);
}

function _darken(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l -= amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
} // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.


function _spin(color, amount) {
  var hsl = tinycolor(color).toHsl();
  var hue = (hsl.h + amount) % 360;
  hsl.h = hue < 0 ? 360 + hue : hue;
  return tinycolor(hsl);
} // Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>


function _complement(color) {
  var hsl = tinycolor(color).toHsl();
  hsl.h = (hsl.h + 180) % 360;
  return tinycolor(hsl);
}

function polyad(color, number) {
  if (isNaN(number) || number <= 0) {
    throw new Error("Argument to polyad must be a positive number");
  }

  var hsl = tinycolor(color).toHsl();
  var result = [tinycolor(color)];
  var step = 360 / number;

  for (var i = 1; i < number; i++) {
    result.push(tinycolor({
      h: (hsl.h + i * step) % 360,
      s: hsl.s,
      l: hsl.l
    }));
  }

  return result;
}

function _splitcomplement(color) {
  var hsl = tinycolor(color).toHsl();
  var h = hsl.h;
  return [tinycolor(color), tinycolor({
    h: (h + 72) % 360,
    s: hsl.s,
    l: hsl.l
  }), tinycolor({
    h: (h + 216) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}

function _analogous(color, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl = tinycolor(color).toHsl();
  var part = 360 / slices;
  var ret = [tinycolor(color)];

  for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
    hsl.h = (hsl.h + part) % 360;
    ret.push(tinycolor(hsl));
  }

  return ret;
}

function _monochromatic(color, results) {
  results = results || 6;
  var hsv = tinycolor(color).toHsv();
  var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
  var ret = [];
  var modification = 1 / results;

  while (results--) {
    ret.push(tinycolor({
      h: h,
      s: s,
      v: v
    }));
    v = (v + modification) % 1;
  }

  return ret;
} // Utility Functions
// ---------------------


tinycolor.mix = function (color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = tinycolor(color1).toRgb();
  var rgb2 = tinycolor(color2).toRgb();
  var p = amount / 100;
  var rgba = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b,
    a: (rgb2.a - rgb1.a) * p + rgb1.a
  };
  return tinycolor(rgba);
}; // Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)


tinycolor.readability = function (color1, color2) {
  var c1 = tinycolor(color1);
  var c2 = tinycolor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
}; // `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false


tinycolor.isReadable = function (color1, color2, wcag2) {
  var readability = tinycolor.readability(color1, color2);
  var wcag2Parms, out;
  out = false;
  wcag2Parms = validateWCAG2Parms(wcag2);

  switch (wcag2Parms.level + wcag2Parms.size) {
    case "AAsmall":
    case "AAAlarge":
      out = readability >= 4.5;
      break;

    case "AAlarge":
      out = readability >= 3;
      break;

    case "AAAsmall":
      out = readability >= 7;
      break;
  }

  return out;
}; // `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"


tinycolor.mostReadable = function (baseColor, colorList, args) {
  var bestColor = null;
  var bestScore = 0;
  var readability;
  var includeFallbackColors, level, size;
  args = args || {};
  includeFallbackColors = args.includeFallbackColors;
  level = args.level;
  size = args.size;

  for (var i = 0; i < colorList.length; i++) {
    readability = tinycolor.readability(baseColor, colorList[i]);

    if (readability > bestScore) {
      bestScore = readability;
      bestColor = tinycolor(colorList[i]);
    }
  }

  if (tinycolor.isReadable(baseColor, bestColor, {
    level: level,
    size: size
  }) || !includeFallbackColors) {
    return bestColor;
  } else {
    args.includeFallbackColors = false;
    return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
  }
}; // Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>


var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}; // Make it easy to access colors via `hexNames[hex]`

var hexNames = tinycolor.hexNames = flip$2(names); // Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`

function flip$2(o) {
  var flipped = {};

  for (var i in o) {
    if (o.hasOwnProperty(i)) {
      flipped[o[i]] = i;
    }
  }

  return flipped;
} // Return a valid alpha value [0,1] with all invalid values being set to 1


function boundAlpha(a) {
  a = parseFloat(a);

  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }

  return a;
} // Take input from [0, n] and return it as [0, 1]


function bound01(n, max) {
  if (isOnePointZero(n)) n = "100%";
  var processPercent = isPercentage(n);
  n = Math.min(max, Math.max(0, parseFloat(n))); // Automatically convert percentage into number

  if (processPercent) {
    n = parseInt(n * max, 10) / 100;
  } // Handle floating point rounding errors


  if (Math.abs(n - max) < 0.000001) {
    return 1;
  } // Convert into [0, 1] range if it isn't already


  return n % max / parseFloat(max);
} // Force a number between 0 and 1


function clamp01(val) {
  return Math.min(1, Math.max(0, val));
} // Parse a base-16 hex value into a base-10 integer


function parseIntFromHex(val) {
  return parseInt(val, 16);
} // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>


function isOnePointZero(n) {
  return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
} // Check to see if string passed in is a percentage


function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") != -1;
} // Force a hex value to have 2 characters


function pad2(c) {
  return c.length == 1 ? "0" + c : "" + c;
} // Replace a decimal with it's percentage value


function convertToPercentage(n) {
  if (n <= 1) {
    n = n * 100 + "%";
  }

  return n;
} // Converts a decimal to a hex value


function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
} // Converts a hex value to a decimal


function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}

var matchers = function () {
  // <http://www.w3.org/TR/css3-values/#integers>
  var CSS_INTEGER = "[-\\+]?\\d+%?"; // <http://www.w3.org/TR/css3-values/#number-value>

  var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?"; // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.

  var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")"; // Actual matching.
  // Parentheses and commas are optional, but not required.
  // Whitespace can take the place of commas or opening paren

  var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}(); // `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).


function isValidCSSUnit(color) {
  return !!matchers.CSS_UNIT.exec(color);
} // `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`


function stringInputToObject(color) {
  color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var named = false;

  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color == "transparent") {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  } // Try to match string input using regular expressions.
  // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
  // Just return an object and let the conversion functions handle that.
  // This way the result will be the same whether the tinycolor is initialized with string or object.


  var match;

  if (match = matchers.rgb.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }

  if (match = matchers.rgba.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }

  if (match = matchers.hsl.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }

  if (match = matchers.hsla.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }

  if (match = matchers.hsv.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }

  if (match = matchers.hsva.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }

  if (match = matchers.hex8.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named ? "name" : "hex8"
    };
  }

  if (match = matchers.hex6.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named ? "name" : "hex"
    };
  }

  if (match = matchers.hex4.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      a: convertHexToDecimal(match[4] + "" + match[4]),
      format: named ? "name" : "hex8"
    };
  }

  if (match = matchers.hex3.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      format: named ? "name" : "hex"
    };
  }

  return false;
}

function validateWCAG2Parms(parms) {
  // return valid WCAG2 parms for isReadable.
  // If input parms are invalid, return {"level":"AA", "size":"small"}
  var level, size;
  parms = parms || {
    level: "AA",
    size: "small"
  };
  level = (parms.level || "AA").toUpperCase();
  size = (parms.size || "small").toLowerCase();

  if (level !== "AA" && level !== "AAA") {
    level = "AA";
  }

  if (size !== "small" && size !== "large") {
    size = "small";
  }

  return {
    level: level,
    size: size
  };
}

var simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  forEach$1(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;

      if (!isNaN(data[letter])) {
        passed += 1;
      }

      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;

        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};
var toState = function toState(data, oldHue) {
  var color = data.hex ? tinycolor(data.hex) : tinycolor(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();

  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }

  var transparent = hex === '000000' && rgb.a === 0;
  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};
var isValidHex = function isValidHex(hex) {
  if (hex === 'transparent') {
    return true;
  } // disable hex4 and hex8


  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && tinycolor(hex).isValid();
};
var getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }

  var col = toState(data);

  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }

  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};
var isvalidColorString = function isvalidColorString(string, type) {
  var stringWithoutDegree = string.replace('°', '');
  return tinycolor(type + ' (' + stringWithoutDegree + ')')._ok;
};

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass$6 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$5(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits$6(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck$8(this, ColorPicker);

      var _this = _possibleConstructorReturn$5(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = simpleCheckForValidColor(data);

        if (isValidColor) {
          var colors = toState(data, data.h || _this.state.oldHue);

          _this.setState(colors);

          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = simpleCheckForValidColor(data);

        if (isValidColor) {
          var colors = toState(data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends$6({}, toState(props.color, 0));
      _this.debounce = debounce$2(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass$6(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};

        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return /*#__PURE__*/React.createElement(Picker, _extends$6({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends$6({}, toState(nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(react.exports.PureComponent || react.exports.Component);

  ColorPicker.propTypes = _extends$6({}, Picker.propTypes);
  ColorPicker.defaultProps = _extends$6({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });
  return ColorPicker;
};

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass$5 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$4(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus$1 = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits$5(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$7(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$4(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        focus: false
      }, _this.handleFocus = function () {
        return _this.setState({
          focus: true
        });
      }, _this.handleBlur = function () {
        return _this.setState({
          focus: false
        });
      }, _temp), _possibleConstructorReturn$4(_this, _ret);
    }

    _createClass$5(Focus, [{
      key: 'render',
      value: function render() {
        return /*#__PURE__*/React.createElement(Span, {
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }, /*#__PURE__*/React.createElement(Component, _extends$5({}, this.props, this.state)));
      }
    }]);

    return Focus;
  }(React.Component);
};

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var ENTER = 13;
var Swatch$1 = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
  var transparent = color === 'transparent';
  var styles = reactCSS({
    "default": {
      swatch: _extends$4({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };

  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };

  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};

  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return /*#__PURE__*/React.createElement('div', _extends$4({
    style: styles.swatch,
    onClick: handleClick,
    title: title,
    tabIndex: 0,
    onKeyDown: handleKeyDown
  }, optionalEvents), children, transparent && /*#__PURE__*/React.createElement(Checkboard, {
    borderRadius: styles.swatch.borderRadius,
    boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
  }));
};
var Swatch$2 = handleFocus$1(Swatch$1);

var AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;
  var styles = reactCSS({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, {
    vertical: direction === 'vertical'
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker
  });
};

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker,
    className: 'alpha-picker ' + className
  }, /*#__PURE__*/React.createElement(Alpha, _extends$3({}, styles.alpha, {
    rgb: rgb,
    hsl: hsl,
    pointer: pointer,
    renderers: renderers,
    onChange: onChange,
    direction: direction
  })));
};
AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: AlphaPointer
};
ColorWrap(AlphaPicker);

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */

function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);

  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */

function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();

  while (++index < length) {
    this.add(values[index]);
  }
} // Add methods to `SetCache`.


SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }

  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */

function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  } // Check that cyclic values are equal.


  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);

  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }

  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array); // Ignore non-index properties.

  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }

    if (compared !== undefined) {
      if (compared) {
        continue;
      }

      result = false;
      break;
    } // Recursively compare arrays (susceptible to call stack limits).


    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }

  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;
/** `Object#toString` result references. */

var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$2 = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';
/** Used to convert symbols to primitives and strings. */

var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }

      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }

      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag$1:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag$1:
      var convert = mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      } // Assume cyclic values are equal.


      var stacked = stack.get(object);

      if (stacked) {
        return stacked == other;
      }

      bitmask |= COMPARE_UNORDERED_FLAG$2; // Recursively compare objects (susceptible to call stack limits).

      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$2:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }

  }

  return false;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush$1(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */

function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$8(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */

var objectProto$7 = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeys(object) {
  return baseGetAllKeys(object, keys$1, getSymbols$1);
}

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$3 = 1;
/** Used for built-in method references. */

var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }

  var index = objLength;

  while (index--) {
    var key = objProps[index];

    if (!(isPartial ? key in other : hasOwnProperty$5.call(other, key))) {
      return false;
    }
  } // Check that cyclic values are equal.


  var objStacked = stack.get(object);
  var othStacked = stack.get(other);

  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }

  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;

  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    } // Recursively compare objects (susceptible to call stack limits).


    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }

    skipCtor || (skipCtor = key == 'constructor');
  }

  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }

  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* Built-in method references that are verified to be native. */

var DataView$1 = getNative$1(root$4, 'DataView');
var DataView$2 = DataView$1;

/* Built-in method references that are verified to be native. */

var Promise$1 = getNative$1(root$4, 'Promise');
var Promise$2 = Promise$1;

/* Built-in method references that are verified to be native. */

var Set$1 = getNative$1(root$4, 'Set');
var Set$2 = Set$1;

/* Built-in method references that are verified to be native. */

var WeakMap$1 = getNative$1(root$4, 'WeakMap');
var WeakMap$2 = WeakMap$1;

/** `Object#toString` result references. */

var mapTag = '[object Map]',
    objectTag$2 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = toSource$1(DataView$2),
    mapCtorString = toSource$1(Map$2),
    promiseCtorString = toSource$1(Promise$2),
    setCtorString = toSource$1(Set$2),
    weakMapCtorString = toSource$1(WeakMap$2);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (DataView$2 && getTag(new DataView$2(new ArrayBuffer(1))) != dataViewTag || Map$2 && getTag(new Map$2()) != mapTag || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$2 ? value.constructor : undefined,
        ctorString = Ctor ? toSource$1(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;

        case mapCtorString:
          return mapTag;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag;

        case weakMapCtorString:
          return weakMapTag;
      }
    }

    return result;
  };
}

var getTag$1 = getTag;

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$2 = 1;
/** `Object#toString` result references. */

var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag$1 = '[object Object]';
/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$8(object),
      othIsArr = isArray$8(other),
      objTag = objIsArr ? arrayTag : getTag$1(object),
      othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag$1 ? objectTag$1 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$1 : othTag;
  var objIsObj = objTag == objectTag$1,
      othIsObj = othTag == objectTag$1,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$3(object)) {
    if (!isBuffer$3(other)) {
      return false;
    }

    objIsArr = true;
    objIsObj = false;
  }

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray$2(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }

  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$4.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$4.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }

  if (!isSameTag) {
    return false;
  }

  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */

function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }

  if (value == null || other == null || !isObjectLike$5(value) && !isObjectLike$5(other)) {
    return value !== value && other !== other;
  }

  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */

function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }

  object = Object(object);

  while (index--) {
    var data = matchData[index];

    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }

  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();

      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }

      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }

  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */

function isStrictComparable(value) {
  return value === value && !isObject$5(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */

function getMatchData(object) {
  var result = keys$1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }

  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }

    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */

function baseMatches(source) {
  var matchData = getMatchData(source);

  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }

  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey(value, object) {
  if (isArray$8(value)) {
    return false;
  }

  var type = typeof value;

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$3(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/** Error message constants. */

var FUNC_ERROR_TEXT$3 = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
} // Expose `MapCache`.


memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */

var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar$1 = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath$1 = memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
    result.push('');
  }

  string.replace(rePropName$1, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : number || match);
  });
  return result;
});
var stringToPath$2 = stringToPath$1;

/** Used as references for various `Number` constants. */

var INFINITY$2 = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray$8(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }

  if (isSymbol$3(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */

function castPath(value, object) {
  if (isArray$8(value)) {
    return value;
  }

  return isKey(value, object) ? [value] : stringToPath$2(toString$1(value));
}

/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol$3(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */

function baseGet(object, path) {
  path = castPath(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }

  return index && index == length ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */

function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */

function hasPath(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);

    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }

    object = object[key];
  }

  if (result || ++index != length) {
    return result;
  }

  length = object == null ? 0 : object.length;
  return !!length && isLength$1(length) && isIndex$1(key, length) && (isArray$8(object) || isArguments$2(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */

function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }

  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */

function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */

function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }

  if (value == null) {
    return identity$1;
  }

  if (typeof value == 'object') {
    return isArray$8(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }

  return property(value);
}

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike$1(collection) ? Array(collection.length) : [];
  baseEach$1(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */

function map(collection, iteratee) {
  var func = isArray$8(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee));
}

var BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;
  var styles = reactCSS({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        "float": 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.swatches
  }, map(colors, function (c) {
    return /*#__PURE__*/React.createElement(Swatch$2, {
      key: c,
      color: c,
      style: styles.swatch,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: '0 0 4px ' + c
      }
    });
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.clear
  }));
};

var Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var transparent = hex === 'transparent';

  var handleChange = function handleChange(hexCode, e) {
    isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = reactCSS(merge$3({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: getContrastingColor(hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide'
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.card,
    className: 'block-picker ' + className
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.triangle
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.head
  }, transparent && /*#__PURE__*/React.createElement(Checkboard, {
    borderRadius: '6px 6px 0 0'
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.label
  }, hex)), /*#__PURE__*/React.createElement('div', {
    style: styles.body
  }, /*#__PURE__*/React.createElement(BlockSwatches, {
    colors: colors,
    onClick: handleChange,
    onSwatchHover: onSwatchHover
  }), /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      input: styles.input
    },
    value: hex,
    onChange: handleChange
  })));
};
Block.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(['top', 'hide']),
  styles: PropTypes.object
};
Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top',
  styles: {}
};
var BlockPicker = ColorWrap(Block);

var red = {
  "50": "#ffebee",
  "100": "#ffcdd2",
  "200": "#ef9a9a",
  "300": "#e57373",
  "400": "#ef5350",
  "500": "#f44336",
  "600": "#e53935",
  "700": "#d32f2f",
  "800": "#c62828",
  "900": "#b71c1c",
  "a100": "#ff8a80",
  "a200": "#ff5252",
  "a400": "#ff1744",
  "a700": "#d50000"
};
var pink = {
  "50": "#fce4ec",
  "100": "#f8bbd0",
  "200": "#f48fb1",
  "300": "#f06292",
  "400": "#ec407a",
  "500": "#e91e63",
  "600": "#d81b60",
  "700": "#c2185b",
  "800": "#ad1457",
  "900": "#880e4f",
  "a100": "#ff80ab",
  "a200": "#ff4081",
  "a400": "#f50057",
  "a700": "#c51162"
};
var purple = {
  "50": "#f3e5f5",
  "100": "#e1bee7",
  "200": "#ce93d8",
  "300": "#ba68c8",
  "400": "#ab47bc",
  "500": "#9c27b0",
  "600": "#8e24aa",
  "700": "#7b1fa2",
  "800": "#6a1b9a",
  "900": "#4a148c",
  "a100": "#ea80fc",
  "a200": "#e040fb",
  "a400": "#d500f9",
  "a700": "#aa00ff"
};
var deepPurple = {
  "50": "#ede7f6",
  "100": "#d1c4e9",
  "200": "#b39ddb",
  "300": "#9575cd",
  "400": "#7e57c2",
  "500": "#673ab7",
  "600": "#5e35b1",
  "700": "#512da8",
  "800": "#4527a0",
  "900": "#311b92",
  "a100": "#b388ff",
  "a200": "#7c4dff",
  "a400": "#651fff",
  "a700": "#6200ea"
};
var indigo = {
  "50": "#e8eaf6",
  "100": "#c5cae9",
  "200": "#9fa8da",
  "300": "#7986cb",
  "400": "#5c6bc0",
  "500": "#3f51b5",
  "600": "#3949ab",
  "700": "#303f9f",
  "800": "#283593",
  "900": "#1a237e",
  "a100": "#8c9eff",
  "a200": "#536dfe",
  "a400": "#3d5afe",
  "a700": "#304ffe"
};
var blue = {
  "50": "#e3f2fd",
  "100": "#bbdefb",
  "200": "#90caf9",
  "300": "#64b5f6",
  "400": "#42a5f5",
  "500": "#2196f3",
  "600": "#1e88e5",
  "700": "#1976d2",
  "800": "#1565c0",
  "900": "#0d47a1",
  "a100": "#82b1ff",
  "a200": "#448aff",
  "a400": "#2979ff",
  "a700": "#2962ff"
};
var lightBlue = {
  "50": "#e1f5fe",
  "100": "#b3e5fc",
  "200": "#81d4fa",
  "300": "#4fc3f7",
  "400": "#29b6f6",
  "500": "#03a9f4",
  "600": "#039be5",
  "700": "#0288d1",
  "800": "#0277bd",
  "900": "#01579b",
  "a100": "#80d8ff",
  "a200": "#40c4ff",
  "a400": "#00b0ff",
  "a700": "#0091ea"
};
var cyan = {
  "50": "#e0f7fa",
  "100": "#b2ebf2",
  "200": "#80deea",
  "300": "#4dd0e1",
  "400": "#26c6da",
  "500": "#00bcd4",
  "600": "#00acc1",
  "700": "#0097a7",
  "800": "#00838f",
  "900": "#006064",
  "a100": "#84ffff",
  "a200": "#18ffff",
  "a400": "#00e5ff",
  "a700": "#00b8d4"
};
var teal = {
  "50": "#e0f2f1",
  "100": "#b2dfdb",
  "200": "#80cbc4",
  "300": "#4db6ac",
  "400": "#26a69a",
  "500": "#009688",
  "600": "#00897b",
  "700": "#00796b",
  "800": "#00695c",
  "900": "#004d40",
  "a100": "#a7ffeb",
  "a200": "#64ffda",
  "a400": "#1de9b6",
  "a700": "#00bfa5"
};
var green = {
  "50": "#e8f5e9",
  "100": "#c8e6c9",
  "200": "#a5d6a7",
  "300": "#81c784",
  "400": "#66bb6a",
  "500": "#4caf50",
  "600": "#43a047",
  "700": "#388e3c",
  "800": "#2e7d32",
  "900": "#1b5e20",
  "a100": "#b9f6ca",
  "a200": "#69f0ae",
  "a400": "#00e676",
  "a700": "#00c853"
};
var lightGreen = {
  "50": "#f1f8e9",
  "100": "#dcedc8",
  "200": "#c5e1a5",
  "300": "#aed581",
  "400": "#9ccc65",
  "500": "#8bc34a",
  "600": "#7cb342",
  "700": "#689f38",
  "800": "#558b2f",
  "900": "#33691e",
  "a100": "#ccff90",
  "a200": "#b2ff59",
  "a400": "#76ff03",
  "a700": "#64dd17"
};
var lime = {
  "50": "#f9fbe7",
  "100": "#f0f4c3",
  "200": "#e6ee9c",
  "300": "#dce775",
  "400": "#d4e157",
  "500": "#cddc39",
  "600": "#c0ca33",
  "700": "#afb42b",
  "800": "#9e9d24",
  "900": "#827717",
  "a100": "#f4ff81",
  "a200": "#eeff41",
  "a400": "#c6ff00",
  "a700": "#aeea00"
};
var yellow = {
  "50": "#fffde7",
  "100": "#fff9c4",
  "200": "#fff59d",
  "300": "#fff176",
  "400": "#ffee58",
  "500": "#ffeb3b",
  "600": "#fdd835",
  "700": "#fbc02d",
  "800": "#f9a825",
  "900": "#f57f17",
  "a100": "#ffff8d",
  "a200": "#ffff00",
  "a400": "#ffea00",
  "a700": "#ffd600"
};
var amber = {
  "50": "#fff8e1",
  "100": "#ffecb3",
  "200": "#ffe082",
  "300": "#ffd54f",
  "400": "#ffca28",
  "500": "#ffc107",
  "600": "#ffb300",
  "700": "#ffa000",
  "800": "#ff8f00",
  "900": "#ff6f00",
  "a100": "#ffe57f",
  "a200": "#ffd740",
  "a400": "#ffc400",
  "a700": "#ffab00"
};
var orange = {
  "50": "#fff3e0",
  "100": "#ffe0b2",
  "200": "#ffcc80",
  "300": "#ffb74d",
  "400": "#ffa726",
  "500": "#ff9800",
  "600": "#fb8c00",
  "700": "#f57c00",
  "800": "#ef6c00",
  "900": "#e65100",
  "a100": "#ffd180",
  "a200": "#ffab40",
  "a400": "#ff9100",
  "a700": "#ff6d00"
};
var deepOrange = {
  "50": "#fbe9e7",
  "100": "#ffccbc",
  "200": "#ffab91",
  "300": "#ff8a65",
  "400": "#ff7043",
  "500": "#ff5722",
  "600": "#f4511e",
  "700": "#e64a19",
  "800": "#d84315",
  "900": "#bf360c",
  "a100": "#ff9e80",
  "a200": "#ff6e40",
  "a400": "#ff3d00",
  "a700": "#dd2c00"
};
var brown = {
  "50": "#efebe9",
  "100": "#d7ccc8",
  "200": "#bcaaa4",
  "300": "#a1887f",
  "400": "#8d6e63",
  "500": "#795548",
  "600": "#6d4c41",
  "700": "#5d4037",
  "800": "#4e342e",
  "900": "#3e2723"
};
var blueGrey = {
  "50": "#eceff1",
  "100": "#cfd8dc",
  "200": "#b0bec5",
  "300": "#90a4ae",
  "400": "#78909c",
  "500": "#607d8b",
  "600": "#546e7a",
  "700": "#455a64",
  "800": "#37474f",
  "900": "#263238"
};

var CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;
  var styles = reactCSS({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, {
    hover: hover,
    active: active
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React.createElement(Swatch$2, {
    style: styles.Swatch,
    color: color,
    onClick: onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color
    }
  }));
};
CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
var CircleSwatch$1 = lib$4.handleHover(CircleSwatch);

var Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$3({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(hexCode, e) {
    return onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  return /*#__PURE__*/React.createElement('div', {
    style: styles.card,
    className: 'circle-picker ' + className
  }, map(colors, function (c) {
    return /*#__PURE__*/React.createElement(CircleSwatch$1, {
      key: c,
      color: c,
      onClick: handleChange,
      onSwatchHover: onSwatchHover,
      active: hex === c.toLowerCase(),
      circleSize: circleSize,
      circleSpacing: circleSpacing
    });
  }));
};
Circle.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  circleSize: PropTypes.number,
  circleSpacing: PropTypes.number,
  styles: PropTypes.object
};
Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [red['500'], pink['500'], purple['500'], deepPurple['500'], indigo['500'], blue['500'], lightBlue['500'], cyan['500'], teal['500'], green['500'], lightGreen['500'], lime['500'], yellow['500'], amber['500'], orange['500'], deepOrange['500'], brown['500'], blueGrey['500']],
  styles: {}
};
ColorWrap(Circle);

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined$1(value) {
  return value === undefined;
}

var UnfoldMoreHorizontalIcon$1 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = react.exports;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var DEFAULT_SIZE = 24;

exports["default"] = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2["default"].createElement('svg', _extends({
    viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
    style: _extends({
      fill: fill,
      width: width,
      height: height
    }, style)
  }, props), _react2["default"].createElement('path', {
    d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
  }));
};
}(UnfoldMoreHorizontalIcon$1));

var UnfoldMoreHorizontalIcon = /*@__PURE__*/getDefaultExportFromCjs(UnfoldMoreHorizontalIcon$1);

var _createClass$4 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$3(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChromeFields = function (_React$Component) {
  _inherits$4(ChromeFields, _React$Component);

  function ChromeFields(props) {
    _classCallCheck$6(this, ChromeFields);

    var _this = _possibleConstructorReturn$3(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

    _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({
          view: 'rgb'
        });
      } else if (_this.state.view === 'rgb') {
        _this.setState({
          view: 'hsl'
        });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({
            view: 'hex'
          });
        } else {
          _this.setState({
            view: 'rgb'
          });
        }
      }
    };

    _this.handleChange = function (data, e) {
      if (data.hex) {
        isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        // Remove any occurances of '%'.
        if (typeof data.s === 'string' && data.s.includes('%')) {
          data.s = data.s.replace('%', '');
        }

        if (typeof data.l === 'string' && data.l.includes('%')) {
          data.l = data.l.replace('%', '');
        } // We store HSL as a unit interval so we need to override the 1 input to 0.01


        if (data.s == 1) {
          data.s = 0.01;
        } else if (data.l == 1) {
          data.l = 0.01;
        }

        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(!isUndefined$1(data.s) ? data.s : _this.props.hsl.s),
          l: Number(!isUndefined$1(data.l) ? data.l : _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    };

    _this.showHighlight = function (e) {
      e.currentTarget.style.background = '#eee';
    };

    _this.hideHighlight = function (e) {
      e.currentTarget.style.background = 'transparent';
    };

    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }

    return _this;
  }

  _createClass$4(ChromeFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = reactCSS({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            fill: '#333',
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);
      var fields = void 0;

      if (this.state.view === 'hex') {
        fields = /*#__PURE__*/React.createElement('div', {
          style: styles.fields,
          className: 'flexbox-fix'
        }, /*#__PURE__*/React.createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React.createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'hex',
          value: this.props.hex,
          onChange: this.handleChange
        })));
      } else if (this.state.view === 'rgb') {
        fields = /*#__PURE__*/React.createElement('div', {
          style: styles.fields,
          className: 'flexbox-fix'
        }, /*#__PURE__*/React.createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React.createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'r',
          value: this.props.rgb.r,
          onChange: this.handleChange
        })), /*#__PURE__*/React.createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React.createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'g',
          value: this.props.rgb.g,
          onChange: this.handleChange
        })), /*#__PURE__*/React.createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React.createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'b',
          value: this.props.rgb.b,
          onChange: this.handleChange
        })), /*#__PURE__*/React.createElement('div', {
          style: styles.alpha
        }, /*#__PURE__*/React.createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'a',
          value: this.props.rgb.a,
          arrowOffset: 0.01,
          onChange: this.handleChange
        })));
      } else if (this.state.view === 'hsl') {
        fields = /*#__PURE__*/React.createElement('div', {
          style: styles.fields,
          className: 'flexbox-fix'
        }, /*#__PURE__*/React.createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React.createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'h',
          value: Math.round(this.props.hsl.h),
          onChange: this.handleChange
        })), /*#__PURE__*/React.createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React.createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 's',
          value: Math.round(this.props.hsl.s * 100) + '%',
          onChange: this.handleChange
        })), /*#__PURE__*/React.createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React.createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'l',
          value: Math.round(this.props.hsl.l * 100) + '%',
          onChange: this.handleChange
        })), /*#__PURE__*/React.createElement('div', {
          style: styles.alpha
        }, /*#__PURE__*/React.createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'a',
          value: this.props.hsl.a,
          arrowOffset: 0.01,
          onChange: this.handleChange
        })));
      }

      return /*#__PURE__*/React.createElement('div', {
        style: styles.wrap,
        className: 'flexbox-fix'
      }, fields, /*#__PURE__*/React.createElement('div', {
        style: styles.toggle
      }, /*#__PURE__*/React.createElement('div', {
        style: styles.icon,
        onClick: this.toggleViews,
        ref: function ref(icon) {
          return _this2.icon = icon;
        }
      }, /*#__PURE__*/React.createElement(UnfoldMoreHorizontalIcon, {
        style: styles.svg,
        onMouseOver: this.showHighlight,
        onMouseEnter: this.showHighlight,
        onMouseOut: this.hideHighlight
      }))));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
        return {
          view: 'rgb'
        };
      }

      return null;
    }
  }]);

  return ChromeFields;
}(React.Component);
ChromeFields.defaultProps = {
  view: "hex"
};

var ChromePointer = function ChromePointer() {
  var styles = reactCSS({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker
  });
};

var ChromePointerCircle = function ChromePointerCircle() {
  var styles = reactCSS({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker
  });
};

var Chrome = function Chrome(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      defaultView = _ref.defaultView;
  var styles = reactCSS(merge$3({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, passedStyles), {
    disableAlpha: disableAlpha
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker,
    className: 'chrome-picker ' + className
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.saturation
  }, /*#__PURE__*/React.createElement(Saturation, {
    style: styles.Saturation,
    hsl: hsl,
    hsv: hsv,
    pointer: ChromePointerCircle,
    onChange: onChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.body
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.controls,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.color
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.active
  }), /*#__PURE__*/React.createElement(Checkboard, {
    renderers: renderers
  }))), /*#__PURE__*/React.createElement('div', {
    style: styles.toggles
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.hue
  }, /*#__PURE__*/React.createElement(Hue, {
    style: styles.Hue,
    hsl: hsl,
    pointer: ChromePointer,
    onChange: onChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.alpha
  }, /*#__PURE__*/React.createElement(Alpha, {
    style: styles.Alpha,
    rgb: rgb,
    hsl: hsl,
    pointer: ChromePointer,
    renderers: renderers,
    onChange: onChange
  })))), /*#__PURE__*/React.createElement(ChromeFields, {
    rgb: rgb,
    hsl: hsl,
    hex: hex,
    view: defaultView,
    onChange: onChange,
    disableAlpha: disableAlpha
  })));
};
Chrome.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disableAlpha: PropTypes.bool,
  styles: PropTypes.object,
  defaultView: PropTypes.oneOf(["hex", "rgb", "hsl"])
};
Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};
ColorWrap(Chrome);

var CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;
  var styles = reactCSS({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        "float": 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: getContrastingColor(color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, {
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });
  return /*#__PURE__*/React.createElement(Swatch$2, {
    style: styles.color,
    color: color,
    onClick: onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: '0 0 4px ' + color
    }
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.dot
  }));
};

var CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;
  var styles = reactCSS({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return /*#__PURE__*/React.createElement('div', {
    style: styles.fields,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.active
  }), /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.HEXwrap,
      input: styles.HEXinput,
      label: styles.HEXlabel
    },
    label: 'hex',
    value: hex,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'r',
    value: rgb.r,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'g',
    value: rgb.g,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'b',
    value: rgb.b,
    onChange: handleChange
  }));
};

var Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$3({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return /*#__PURE__*/React.createElement(Raised, {
    style: styles.Compact,
    styles: passedStyles
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.compact,
    className: 'compact-picker ' + className
  }, /*#__PURE__*/React.createElement('div', null, map(colors, function (c) {
    return /*#__PURE__*/React.createElement(CompactColor, {
      key: c,
      color: c,
      active: c.toLowerCase() === hex,
      onClick: handleChange,
      onSwatchHover: onSwatchHover
    });
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.clear
  })), /*#__PURE__*/React.createElement(CompactFields, {
    hex: hex,
    rgb: rgb,
    onChange: handleChange
  })));
};
Compact.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
  styles: {}
};
ColorWrap(Compact);

var GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;
  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };
  var styles = reactCSS({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, {
    hover: hover
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React.createElement(Swatch$2, {
    color: color,
    onClick: onClick,
    onHover: onSwatchHover,
    focusStyle: hoverSwatch
  }));
};
var GithubSwatch$1 = lib$4.handleHover(GithubSwatch);

var Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$3({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle === 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return /*#__PURE__*/React.createElement('div', {
    style: styles.card,
    className: 'github-picker ' + className
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.triangleShadow
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.triangle
  }), map(colors, function (c) {
    return /*#__PURE__*/React.createElement(GithubSwatch$1, {
      color: c,
      key: c,
      onClick: handleChange,
      onSwatchHover: onSwatchHover
    });
  }));
};
Github.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
  styles: PropTypes.object
};
Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left',
  styles: {}
};
ColorWrap(Github);

var SliderPointer$1 = function SliderPointer(_ref) {
  var direction = _ref.direction;
  var styles = reactCSS({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, {
    vertical: direction === 'vertical'
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker
  });
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$3({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  }, passedStyles)); // Overwrite to provide pure hue color

  var handleChange = function handleChange(data) {
    return onChange({
      a: 1,
      h: data.h,
      l: 0.5,
      s: 1
    });
  };

  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker,
    className: 'hue-picker ' + className
  }, /*#__PURE__*/React.createElement(Hue, _extends$2({}, styles.hue, {
    hsl: hsl,
    pointer: pointer,
    onChange: handleChange,
    direction: direction
  })));
};
HuePicker.propTypes = {
  styles: PropTypes.object
};
HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: SliderPointer$1,
  styles: {}
};
ColorWrap(HuePicker);

var Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$3({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return /*#__PURE__*/React.createElement(Raised, {
    styles: passedStyles
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.material,
    className: 'material-picker ' + className
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.HEXwrap,
      input: styles.HEXinput,
      label: styles.HEXlabel
    },
    label: 'hex',
    value: hex,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.split,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.third
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'r',
    value: rgb.r,
    onChange: handleChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.third
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'g',
    value: rgb.g,
    onChange: handleChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.third
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'b',
    value: rgb.b,
    onChange: handleChange
  })))));
};
ColorWrap(Material);

var PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;
  var styles = reactCSS({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        top: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return /*#__PURE__*/React.createElement('div', {
    style: styles.fields
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'h',
    value: Math.round(hsv.h),
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 's',
    value: Math.round(hsv.s * 100),
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'v',
    value: Math.round(hsv.v * 100),
    onChange: handleChange
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.divider
  }), /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'r',
    value: rgb.r,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'g',
    value: rgb.g,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'b',
    value: rgb.b,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.divider
  }), /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      wrap: styles.HEXwrap,
      input: styles.HEXinput,
      label: styles.HEXlabel
    },
    label: '#',
    value: hex.replace('#', ''),
    onChange: handleChange
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.fieldSymbols
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.symbol
  }, '\xB0'), /*#__PURE__*/React.createElement('div', {
    style: styles.symbol
  }, '%'), /*#__PURE__*/React.createElement('div', {
    style: styles.symbol
  }, '%')));
};

var PhotoshopPointerCircle$1 = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;
  var styles = reactCSS({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, {
    'black-outline': hsl.l > 0.5
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker
  });
};

var PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = reactCSS({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },
      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },
      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.pointer
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.left
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.leftInside
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.right
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.rightInside
  })));
};

var PhotoshopButton = function PhotoshopButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;
  var styles = reactCSS({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, {
    active: active
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.button,
    onClick: onClick
  }, label || children);
};

var PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;
  var styles = reactCSS({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      "new": {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });
  return /*#__PURE__*/React.createElement('div', null, /*#__PURE__*/React.createElement('div', {
    style: styles.label
  }, 'new'), /*#__PURE__*/React.createElement('div', {
    style: styles.swatches
  }, /*#__PURE__*/React.createElement('div', {
    style: styles["new"]
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.current
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.label
  }, 'current'));
};

var _createClass$3 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$2(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Photoshop = function (_React$Component) {
  _inherits$3(Photoshop, _React$Component);

  function Photoshop(props) {
    _classCallCheck$5(this, Photoshop);

    var _this = _possibleConstructorReturn$2(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  _createClass$3(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$styles = _props.styles,
          passedStyles = _props$styles === undefined ? {} : _props$styles,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className;
      var styles = reactCSS(merge$3({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      }, passedStyles));
      return /*#__PURE__*/React.createElement('div', {
        style: styles.picker,
        className: 'photoshop-picker ' + className
      }, /*#__PURE__*/React.createElement('div', {
        style: styles.head
      }, this.props.header), /*#__PURE__*/React.createElement('div', {
        style: styles.body,
        className: 'flexbox-fix'
      }, /*#__PURE__*/React.createElement('div', {
        style: styles.saturation
      }, /*#__PURE__*/React.createElement(Saturation, {
        hsl: this.props.hsl,
        hsv: this.props.hsv,
        pointer: PhotoshopPointerCircle$1,
        onChange: this.props.onChange
      })), /*#__PURE__*/React.createElement('div', {
        style: styles.hue
      }, /*#__PURE__*/React.createElement(Hue, {
        direction: 'vertical',
        hsl: this.props.hsl,
        pointer: PhotoshopPointerCircle,
        onChange: this.props.onChange
      })), /*#__PURE__*/React.createElement('div', {
        style: styles.controls
      }, /*#__PURE__*/React.createElement('div', {
        style: styles.top,
        className: 'flexbox-fix'
      }, /*#__PURE__*/React.createElement('div', {
        style: styles.previews
      }, /*#__PURE__*/React.createElement(PhotoshopPreviews, {
        rgb: this.props.rgb,
        currentColor: this.state.currentColor
      })), /*#__PURE__*/React.createElement('div', {
        style: styles.actions
      }, /*#__PURE__*/React.createElement(PhotoshopButton, {
        label: 'OK',
        onClick: this.props.onAccept,
        active: true
      }), /*#__PURE__*/React.createElement(PhotoshopButton, {
        label: 'Cancel',
        onClick: this.props.onCancel
      }), /*#__PURE__*/React.createElement(PhotoshopPicker, {
        onChange: this.props.onChange,
        rgb: this.props.rgb,
        hsv: this.props.hsv,
        hex: this.props.hex
      }))))));
    }
  }]);

  return Photoshop;
}(React.Component);
Photoshop.propTypes = {
  header: PropTypes.string,
  styles: PropTypes.object
};
Photoshop.defaultProps = {
  header: 'Color Picker',
  styles: {}
};
ColorWrap(Photoshop);

/* eslint-disable no-param-reassign */
var SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;
  var styles = reactCSS({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      "double": {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, {
    disableAlpha: disableAlpha
  });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return /*#__PURE__*/React.createElement('div', {
    style: styles.fields,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React.createElement('div', {
    style: styles["double"]
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'hex',
    value: hex.replace('#', ''),
    onChange: handleChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'r',
    value: rgb.r,
    onChange: handleChange,
    dragLabel: 'true',
    dragMax: '255'
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'g',
    value: rgb.g,
    onChange: handleChange,
    dragLabel: 'true',
    dragMax: '255'
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'b',
    value: rgb.b,
    onChange: handleChange,
    dragLabel: 'true',
    dragMax: '255'
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.alpha
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'a',
    value: Math.round(rgb.a * 100),
    onChange: handleChange,
    dragLabel: 'true',
    dragMax: '100'
  })));
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;
  var styles = reactCSS({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return /*#__PURE__*/React.createElement('div', {
    style: styles.colors,
    className: 'flexbox-fix'
  }, colors.map(function (colorObjOrString) {
    var c = typeof colorObjOrString === 'string' ? {
      color: colorObjOrString
    } : colorObjOrString;
    var key = '' + c.color + (c.title || '');
    return /*#__PURE__*/React.createElement('div', {
      key: key,
      style: styles.swatchWrap
    }, /*#__PURE__*/React.createElement(Swatch$2, _extends$1({}, c, {
      style: styles.swatch,
      onClick: handleClick,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
      }
    })));
  }));
};
SketchPresetColors.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    color: PropTypes.string,
    title: PropTypes.string
  })])).isRequired
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$3({
    'default': _extends({
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    }, passedStyles),
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, passedStyles), {
    disableAlpha: disableAlpha
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker,
    className: 'sketch-picker ' + className
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.saturation
  }, /*#__PURE__*/React.createElement(Saturation, {
    style: styles.Saturation,
    hsl: hsl,
    hsv: hsv,
    onChange: onChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.controls,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.sliders
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.hue
  }, /*#__PURE__*/React.createElement(Hue, {
    style: styles.Hue,
    hsl: hsl,
    onChange: onChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.alpha
  }, /*#__PURE__*/React.createElement(Alpha, {
    style: styles.Alpha,
    rgb: rgb,
    hsl: hsl,
    renderers: renderers,
    onChange: onChange
  }))), /*#__PURE__*/React.createElement('div', {
    style: styles.color
  }, /*#__PURE__*/React.createElement(Checkboard, null), /*#__PURE__*/React.createElement('div', {
    style: styles.activeColor
  }))), /*#__PURE__*/React.createElement(SketchFields, {
    rgb: rgb,
    hsl: hsl,
    hex: hex,
    onChange: onChange,
    disableAlpha: disableAlpha
  }), /*#__PURE__*/React.createElement(SketchPresetColors, {
    colors: presetColors,
    onClick: onChange,
    onSwatchHover: onSwatchHover
  }));
};
Sketch.propTypes = {
  disableAlpha: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object
};
Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};
var SketchPicker = ColorWrap(Sketch);

var SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;
  var styles = reactCSS({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, {
    active: active,
    first: first,
    last: last
  });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return /*#__PURE__*/React.createElement('div', {
    style: styles.swatch,
    onClick: handleClick
  });
};

var SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;
  var styles = reactCSS({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        "float": 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  }); // Acceptible difference in floating point equality

  var epsilon = 0.1;
  return /*#__PURE__*/React.createElement('div', {
    style: styles.swatches
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React.createElement(SliderSwatch, {
    hsl: hsl,
    offset: '.80',
    active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick,
    first: true
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React.createElement(SliderSwatch, {
    hsl: hsl,
    offset: '.65',
    active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React.createElement(SliderSwatch, {
    hsl: hsl,
    offset: '.50',
    active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React.createElement(SliderSwatch, {
    hsl: hsl,
    offset: '.35',
    active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React.createElement(SliderSwatch, {
    hsl: hsl,
    offset: '.20',
    active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick,
    last: true
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.clear
  }));
};

var SliderPointer = function SliderPointer() {
  var styles = reactCSS({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker
  });
};

var Slider$1 = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$3({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));
  return /*#__PURE__*/React.createElement('div', {
    style: styles.wrap || {},
    className: 'slider-picker ' + className
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.hue
  }, /*#__PURE__*/React.createElement(Hue, {
    style: styles.Hue,
    hsl: hsl,
    pointer: pointer,
    onChange: onChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.swatches
  }, /*#__PURE__*/React.createElement(SliderSwatches, {
    hsl: hsl,
    onClick: onChange
  })));
};
Slider$1.propTypes = {
  styles: PropTypes.object
};
Slider$1.defaultProps = {
  pointer: SliderPointer,
  styles: {}
};
ColorWrap(Slider$1);

var CheckIcon$1 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = react.exports;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var DEFAULT_SIZE = 24;

exports["default"] = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2["default"].createElement('svg', _extends({
    viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
    style: _extends({
      fill: fill,
      width: width,
      height: height
    }, style)
  }, props), _react2["default"].createElement('path', {
    d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
  }));
};
}(CheckIcon$1));

var CheckIcon = /*@__PURE__*/getDefaultExportFromCjs(CheckIcon$1);

var SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;
  var styles = reactCSS({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        color: getContrastingColor(color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        color: '#333'
      }
    },
    'transparent': {
      check: {
        color: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });
  return /*#__PURE__*/React.createElement(Swatch$2, {
    color: color,
    style: styles.color,
    onClick: onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: '0 0 4px ' + color
    }
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.check
  }, /*#__PURE__*/React.createElement(CheckIcon, null)));
};

var SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;
  var styles = reactCSS({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        "float": 'left',
        marginRight: '10px'
      }
    }
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.group
  }, map(group, function (color, i) {
    return /*#__PURE__*/React.createElement(SwatchesColor, {
      key: color,
      color: color,
      active: color.toLowerCase() === active,
      first: i === 0,
      last: i === group.length - 1,
      onClick: onClick,
      onSwatchHover: onSwatchHover
    });
  }));
};

var Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$3({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    return onChange({
      hex: data,
      source: 'hex'
    }, e);
  };

  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker,
    className: 'swatches-picker ' + className
  }, /*#__PURE__*/React.createElement(Raised, null, /*#__PURE__*/React.createElement('div', {
    style: styles.overflow
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.body
  }, map(colors, function (group) {
    return /*#__PURE__*/React.createElement(SwatchesGroup, {
      key: group.toString(),
      group: group,
      active: hex,
      onClick: handleChange,
      onSwatchHover: onSwatchHover
    });
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.clear
  })))));
};
Swatches.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  styles: PropTypes.object
  /* eslint-disable max-len */

};
Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[red['900'], red['700'], red['500'], red['300'], red['100']], [pink['900'], pink['700'], pink['500'], pink['300'], pink['100']], [purple['900'], purple['700'], purple['500'], purple['300'], purple['100']], [deepPurple['900'], deepPurple['700'], deepPurple['500'], deepPurple['300'], deepPurple['100']], [indigo['900'], indigo['700'], indigo['500'], indigo['300'], indigo['100']], [blue['900'], blue['700'], blue['500'], blue['300'], blue['100']], [lightBlue['900'], lightBlue['700'], lightBlue['500'], lightBlue['300'], lightBlue['100']], [cyan['900'], cyan['700'], cyan['500'], cyan['300'], cyan['100']], [teal['900'], teal['700'], teal['500'], teal['300'], teal['100']], ['#194D33', green['700'], green['500'], green['300'], green['100']], [lightGreen['900'], lightGreen['700'], lightGreen['500'], lightGreen['300'], lightGreen['100']], [lime['900'], lime['700'], lime['500'], lime['300'], lime['100']], [yellow['900'], yellow['700'], yellow['500'], yellow['300'], yellow['100']], [amber['900'], amber['700'], amber['500'], amber['300'], amber['100']], [orange['900'], orange['700'], orange['500'], orange['300'], orange['100']], [deepOrange['900'], deepOrange['700'], deepOrange['500'], deepOrange['300'], deepOrange['100']], [brown['900'], brown['700'], brown['500'], brown['300'], brown['100']], [blueGrey['900'], blueGrey['700'], blueGrey['500'], blueGrey['300'], blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
  styles: {}
};
ColorWrap(Swatches);

var Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$3({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        "float": 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        "float": 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        "float": 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return /*#__PURE__*/React.createElement('div', {
    style: styles.card,
    className: 'twitter-picker ' + className
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.triangleShadow
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.triangle
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.body
  }, map(colors, function (c, i) {
    return /*#__PURE__*/React.createElement(Swatch$2, {
      key: i,
      color: c,
      hex: c,
      style: styles.swatch,
      onClick: handleChange,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: '0 0 4px ' + c
      }
    });
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.hash
  }, '#'), /*#__PURE__*/React.createElement(EditableInput, {
    label: null,
    style: {
      input: styles.input
    },
    value: hex.replace('#', ''),
    onChange: handleChange
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.clear
  })));
};
Twitter.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  triangle: PropTypes.oneOf(['hide', 'top-left', 'top-right']),
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left',
  styles: {}
};
ColorWrap(Twitter);

var GooglePointerCircle = function GooglePointerCircle(props) {
  var styles = reactCSS({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        border: '2px #fff solid',
        transform: 'translate(-12px, -13px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
      }
    }
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker
  });
};
GooglePointerCircle.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointerCircle.defaultProps = {
  hsl: {
    a: 1,
    h: 249.94,
    l: 0.2,
    s: 0.50
  }
};

var GooglePointer = function GooglePointer(props) {
  var styles = reactCSS({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        transform: 'translate(-10px, -7px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
        border: '2px white solid'
      }
    }
  });
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker
  });
};
GooglePointer.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointer.defaultProps = {
  hsl: {
    a: 1,
    h: 249.94,
    l: 0.2,
    s: 0.50
  }
};

var GoogleFields = function GoogleFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      hsv = _ref.hsv;

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.rgb) {
      var values = data.rgb.split(',');
      isvalidColorString(data.rgb, 'rgb') && onChange({
        r: values[0],
        g: values[1],
        b: values[2],
        a: 1,
        source: 'rgb'
      }, e);
    } else if (data.hsv) {
      var _values = data.hsv.split(',');

      if (isvalidColorString(data.hsv, 'hsv')) {
        _values[2] = _values[2].replace('%', '');
        _values[1] = _values[1].replace('%', '');
        _values[0] = _values[0].replace('°', '');

        if (_values[1] == 1) {
          _values[1] = 0.01;
        } else if (_values[2] == 1) {
          _values[2] = 0.01;
        }

        onChange({
          h: Number(_values[0]),
          s: Number(_values[1]),
          v: Number(_values[2]),
          source: 'hsv'
        }, e);
      }
    } else if (data.hsl) {
      var _values2 = data.hsl.split(',');

      if (isvalidColorString(data.hsl, 'hsl')) {
        _values2[2] = _values2[2].replace('%', '');
        _values2[1] = _values2[1].replace('%', '');
        _values2[0] = _values2[0].replace('°', '');

        if (hsvValue[1] == 1) {
          hsvValue[1] = 0.01;
        } else if (hsvValue[2] == 1) {
          hsvValue[2] = 0.01;
        }

        onChange({
          h: Number(_values2[0]),
          s: Number(_values2[1]),
          v: Number(_values2[2]),
          source: 'hsl'
        }, e);
      }
    }
  };

  var styles = reactCSS({
    'default': {
      wrap: {
        display: 'flex',
        height: '100px',
        marginTop: '4px'
      },
      fields: {
        width: '100%'
      },
      column: {
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'space-between'
      },
      "double": {
        padding: '0px 4.4px',
        boxSizing: 'border-box'
      },
      input: {
        width: '100%',
        height: '38px',
        boxSizing: 'border-box',
        padding: '4px 10% 3px',
        textAlign: 'center',
        border: '1px solid #dadce0',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      input2: {
        height: '38px',
        width: '100%',
        border: '1px solid #dadce0',
        boxSizing: 'border-box',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        paddingLeft: '10px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label: {
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '35px',
        top: '-6px',
        left: '0',
        right: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label2: {
        left: '10px',
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '32px',
        top: '-6px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      single: {
        flexGrow: '1',
        margin: '0px 4.4px'
      }
    }
  });
  var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
  var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
  var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
  return /*#__PURE__*/React.createElement('div', {
    style: styles.wrap,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.fields
  }, /*#__PURE__*/React.createElement('div', {
    style: styles["double"]
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'hex',
    value: hex,
    onChange: handleChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.column
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      input: styles.input2,
      label: styles.label2
    },
    label: 'rgb',
    value: rgbValue,
    onChange: handleChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      input: styles.input2,
      label: styles.label2
    },
    label: 'hsv',
    value: hsvValue,
    onChange: handleChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React.createElement(EditableInput, {
    style: {
      input: styles.input2,
      label: styles.label2
    },
    label: 'hsl',
    value: hslValue,
    onChange: handleChange
  })))));
};

var Google = function Google(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      header = _ref.header,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$3({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        border: '1px solid #dfe1e5',
        boxSizing: 'initial',
        display: 'flex',
        flexWrap: 'wrap',
        borderRadius: '8px 8px 0px 0px'
      },
      head: {
        height: '57px',
        width: '100%',
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: '16px',
        fontSize: '20px',
        boxSizing: 'border-box',
        fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
      },
      saturation: {
        width: '70%',
        padding: '0px',
        position: 'relative',
        overflow: 'hidden'
      },
      swatch: {
        width: '30%',
        height: '228px',
        padding: '0px',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
        position: 'relative',
        overflow: 'hidden'
      },
      body: {
        margin: 'auto',
        width: '95%'
      },
      controls: {
        display: 'flex',
        boxSizing: 'border-box',
        height: '52px',
        paddingTop: '22px'
      },
      color: {
        width: '32px'
      },
      hue: {
        height: '8px',
        position: 'relative',
        margin: '0px 16px 0px 16px',
        width: '100%'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));
  return /*#__PURE__*/React.createElement('div', {
    style: styles.picker,
    className: 'google-picker ' + className
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.head
  }, header), /*#__PURE__*/React.createElement('div', {
    style: styles.swatch
  }), /*#__PURE__*/React.createElement('div', {
    style: styles.saturation
  }, /*#__PURE__*/React.createElement(Saturation, {
    hsl: hsl,
    hsv: hsv,
    pointer: GooglePointerCircle,
    onChange: onChange
  })), /*#__PURE__*/React.createElement('div', {
    style: styles.body
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.controls,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React.createElement('div', {
    style: styles.hue
  }, /*#__PURE__*/React.createElement(Hue, {
    style: styles.Hue,
    hsl: hsl,
    radius: '4px',
    pointer: GooglePointer,
    onChange: onChange
  }))), /*#__PURE__*/React.createElement(GoogleFields, {
    rgb: rgb,
    hsl: hsl,
    hex: hex,
    hsv: hsv,
    onChange: onChange
  })));
};
Google.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object,
  header: PropTypes.string
};
Google.defaultProps = {
  width: 652,
  styles: {},
  header: 'Color picker'
};
ColorWrap(Google);

var colorString = {exports: {}};

var colorName = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};

var simpleSwizzle = {exports: {}};

var isArrayish$1 = function isArrayish(obj) {
  if (!obj || typeof obj === 'string') {
    return false;
  }

  return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};

var isArrayish = isArrayish$1;

var concat = Array.prototype.concat;
var slice$1 = Array.prototype.slice;

var swizzle$1 = simpleSwizzle.exports = function swizzle(args) {
  var results = [];

  for (var i = 0, len = args.length; i < len; i++) {
    var arg = args[i];

    if (isArrayish(arg)) {
      // http://jsperf.com/javascript-array-concat-vs-push/98
      results = concat.call(results, slice$1.call(arg));
    } else {
      results.push(arg);
    }
  }

  return results;
};

swizzle$1.wrap = function (fn) {
  return function () {
    return fn(swizzle$1(arguments));
  };
};

/* MIT license */

var colorNames = colorName;

var swizzle = simpleSwizzle.exports;

var hasOwnProperty$3 = Object.hasOwnProperty;
var reverseNames = Object.create(null); // create a list of reverse color names

for (var name in colorNames) {
  if (hasOwnProperty$3.call(colorNames, name)) {
    reverseNames[colorNames[name]] = name;
  }
}

var cs = colorString.exports = {
  to: {},
  get: {}
};

cs.get = function (string) {
  var prefix = string.substring(0, 3).toLowerCase();
  var val;
  var model;

  switch (prefix) {
    case 'hsl':
      val = cs.get.hsl(string);
      model = 'hsl';
      break;

    case 'hwb':
      val = cs.get.hwb(string);
      model = 'hwb';
      break;

    default:
      val = cs.get.rgb(string);
      model = 'rgb';
      break;
  }

  if (!val) {
    return null;
  }

  return {
    model: model,
    value: val
  };
};

cs.get.rgb = function (string) {
  if (!string) {
    return null;
  }

  var abbr = /^#([a-f0-9]{3,4})$/i;
  var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
  var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
  var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
  var keyword = /^(\w+)$/;
  var rgb = [0, 0, 0, 1];
  var match;
  var i;
  var hexAlpha;

  if (match = string.match(hex)) {
    hexAlpha = match[2];
    match = match[1];

    for (i = 0; i < 3; i++) {
      // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
      var i2 = i * 2;
      rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
    }

    if (hexAlpha) {
      rgb[3] = parseInt(hexAlpha, 16) / 255;
    }
  } else if (match = string.match(abbr)) {
    match = match[1];
    hexAlpha = match[3];

    for (i = 0; i < 3; i++) {
      rgb[i] = parseInt(match[i] + match[i], 16);
    }

    if (hexAlpha) {
      rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    }
  } else if (match = string.match(rgba)) {
    for (i = 0; i < 3; i++) {
      rgb[i] = parseInt(match[i + 1], 0);
    }

    if (match[4]) {
      if (match[5]) {
        rgb[3] = parseFloat(match[4]) * 0.01;
      } else {
        rgb[3] = parseFloat(match[4]);
      }
    }
  } else if (match = string.match(per)) {
    for (i = 0; i < 3; i++) {
      rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
    }

    if (match[4]) {
      if (match[5]) {
        rgb[3] = parseFloat(match[4]) * 0.01;
      } else {
        rgb[3] = parseFloat(match[4]);
      }
    }
  } else if (match = string.match(keyword)) {
    if (match[1] === 'transparent') {
      return [0, 0, 0, 0];
    }

    if (!hasOwnProperty$3.call(colorNames, match[1])) {
      return null;
    }

    rgb = colorNames[match[1]];
    rgb[3] = 1;
    return rgb;
  } else {
    return null;
  }

  for (i = 0; i < 3; i++) {
    rgb[i] = clamp(rgb[i], 0, 255);
  }

  rgb[3] = clamp(rgb[3], 0, 1);
  return rgb;
};

cs.get.hsl = function (string) {
  if (!string) {
    return null;
  }

  var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
  var match = string.match(hsl);

  if (match) {
    var alpha = parseFloat(match[4]);
    var h = (parseFloat(match[1]) % 360 + 360) % 360;
    var s = clamp(parseFloat(match[2]), 0, 100);
    var l = clamp(parseFloat(match[3]), 0, 100);
    var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, s, l, a];
  }

  return null;
};

cs.get.hwb = function (string) {
  if (!string) {
    return null;
  }

  var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
  var match = string.match(hwb);

  if (match) {
    var alpha = parseFloat(match[4]);
    var h = (parseFloat(match[1]) % 360 + 360) % 360;
    var w = clamp(parseFloat(match[2]), 0, 100);
    var b = clamp(parseFloat(match[3]), 0, 100);
    var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, w, b, a];
  }

  return null;
};

cs.to.hex = function () {
  var rgba = swizzle(arguments);
  return '#' + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : '');
};

cs.to.rgb = function () {
  var rgba = swizzle(arguments);
  return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};

cs.to.rgb.percent = function () {
  var rgba = swizzle(arguments);
  var r = Math.round(rgba[0] / 255 * 100);
  var g = Math.round(rgba[1] / 255 * 100);
  var b = Math.round(rgba[2] / 255 * 100);
  return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};

cs.to.hsl = function () {
  var hsla = swizzle(arguments);
  return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
}; // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)


cs.to.hwb = function () {
  var hwba = swizzle(arguments);
  var a = '';

  if (hwba.length >= 4 && hwba[3] !== 1) {
    a = ', ' + hwba[3];
  }

  return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};

cs.to.keyword = function (rgb) {
  return reverseNames[rgb.slice(0, 3)];
}; // helpers


function clamp(num, min, max) {
  return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = Math.round(num).toString(16).toUpperCase();
  return str.length < 2 ? '0' + str : str;
}

var _ColorFormatter;
var ColorFormat;

(function (ColorFormat) {
  ColorFormat["Hex"] = "hex";
  ColorFormat["RGB"] = "rgb";
})(ColorFormat || (ColorFormat = {}));

var rgbToHex = function rgbToHex(color) {
  return "#" + ((1 << 24) + (color.r << 16) + (color.g << 8) + color.b).toString(16).slice(1);
};

function ParseColorStr(color) {
  if (!color) {
    return null;
  }

  var colorDescriptor = colorString.exports.get(color);
  if (!colorDescriptor) return null;
  var colorVals = colorDescriptor.value;
  return {
    r: colorVals[0],
    g: colorVals[1],
    b: colorVals[2],
    a: colorVals[3]
  };
}

var ColorFormatter = (_ColorFormatter = {}, _defineProperty$g(_ColorFormatter, ColorFormat.RGB, {
  getLabel: function getLabel(color) {
    return "R".concat(color.r, " G").concat(color.g, " B").concat(color.b);
  },
  getValue: function getValue(color) {
    var colorVals = [color.r, color.g, color.b, color.a];
    return colorString.exports.to.rgb(colorVals);
  },
  parse: ParseColorStr
}), _defineProperty$g(_ColorFormatter, ColorFormat.Hex, {
  getLabel: function getLabel(color) {
    return rgbToHex(color);
  },
  getValue: function getValue(color) {
    var colorVals = [color.r, color.g, color.b, color.a];
    return colorString.exports.to.hex(colorVals);
  },
  parse: ParseColorStr
}), _ColorFormatter);

var __jsx$_ = react.exports.createElement;
var AddIcon = function AddIcon() {
  return __jsx$_("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx$_("path", {
    d: "M14.9524 4.89689L14.9524 26.8016H16.7461L16.7461 4.89689H14.9524Z"
  }), __jsx$_("path", {
    d: "M4.8969 16.7461H26.8016L26.8016 14.9523H4.89689L4.8969 16.7461Z"
  }));
};

var __jsx$Z = react.exports.createElement;
var CloseIcon = function CloseIcon() {
  return __jsx$Z("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx$Z("path", {
    d: "M5 6.2684L24.7316 26L26 24.7316L6.2684 5L5 6.2684Z"
  }), __jsx$Z("path", {
    d: "M6.2684 26L26 6.2684L24.7316 5L5 24.7316L6.2684 26Z"
  }));
};

var __jsx$Y = react.exports.createElement;
var EllipsisVerticalIcon = function EllipsisVerticalIcon() {
  return __jsx$Y("svg", {
    width: "4",
    height: "14",
    viewBox: "0 0 4 14",
    fill: "#828282",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx$Y("path", {
    d: "M2 5.5C1.5625 5.5 1.21875 5.65625 0.9375 5.9375C0.625 6.25 0.5 6.59375 0.5 7C0.5 7.4375 0.625 7.78125 0.9375 8.0625C1.21875 8.375 1.5625 8.5 2 8.5C2.40625 8.5 2.75 8.375 3.0625 8.0625C3.34375 7.78125 3.5 7.4375 3.5 7C3.5 6.59375 3.34375 6.25 3.0625 5.9375C2.75 5.65625 2.40625 5.5 2 5.5ZM0.5 2.25C0.5 1.84375 0.625 1.5 0.9375 1.1875C1.21875 0.90625 1.5625 0.75 2 0.75C2.40625 0.75 2.75 0.90625 3.0625 1.1875C3.34375 1.5 3.5 1.84375 3.5 2.25C3.5 2.6875 3.34375 3.03125 3.0625 3.3125C2.75 3.625 2.40625 3.75 2 3.75C1.5625 3.75 1.21875 3.625 0.9375 3.3125C0.625 3.03125 0.5 2.6875 0.5 2.25ZM0.5 11.75C0.5 11.3438 0.625 11 0.9375 10.6875C1.21875 10.4062 1.5625 10.25 2 10.25C2.40625 10.25 2.75 10.4062 3.0625 10.6875C3.34375 11 3.5 11.3438 3.5 11.75C3.5 12.1875 3.34375 12.5312 3.0625 12.8125C2.75 13.125 2.40625 13.25 2 13.25C1.5625 13.25 1.21875 13.125 0.9375 12.8125C0.625 12.5312 0.5 12.1875 0.5 11.75Z"
  }));
};

var __jsx$X = react.exports.createElement;
var TrashIcon = function TrashIcon() {
  return __jsx$X("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx$X("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9 4.2V6.9H25V8.7H7V6.9H15.1V4.2H16.9ZM7.77201 10.5H24.2279L22.4102 24.1332C22.2853 25.0698 21.4406 25.8 20.4977 25.8H11.5022C10.5561 25.8 9.71404 25.0653 9.58977 24.1332L7.77201 10.5ZM22.172 12.3H9.82791L11.3739 23.8953C11.3788 23.9318 11.4569 24 11.5022 24H20.4977C20.5432 24 20.6209 23.9328 20.6259 23.8953L22.172 12.3Z"
  }));
};

React.createElement;

React.createElement;

var __jsx$W = react.exports.createElement;
styled(function (p) {
  return __jsx$W("button", p, __jsx$W(EllipsisVerticalIcon, null));
}).withConfig({
  displayName: "FormActions__MoreActionsButton",
  componentId: "sc-1bbk0ov-0"
})(["height:64px;width:40px;align-self:stretch;background-color:transparent;background-position:center;background-size:auto 18px;background-repeat:no-repeat;border:0;margin:0 -16px 0 8px;outline:none;cursor:pointer;transition:opacity 85ms ease-out;display:flex;justify-content:center;align-items:center;&:hover{background-color:var(--tina-color-grey-1);fill:var(--tina-color-grey-8);}"]);
styled.div.withConfig({
  displayName: "FormActions__ActionsOverlay",
  componentId: "sc-1bbk0ov-1"
})(["min-width:192px;border-radius:var(--tina-radius-big);border:1px solid #efefef;display:block;position:absolute;bottom:var(--tina-padding-big);right:var(--tina-padding-big);transform:translate3d(0,0,0) scale3d(0.5,0.5,1);opacity:0;pointer-events:none;transition:all 85ms ease-out;transform-origin:100% 100%;box-shadow:var(--tina-shadow-big);background-color:white;overflow:hidden;z-index:var(--tina-z-index-1);", ";"], function (props) {
  return props.open && Ce(["opacity:1;pointer-events:all;transform:translate3d(0,-28px,0) scale3d(1,1,1);"]);
});
styled.button.withConfig({
  displayName: "FormActions__ActionButton",
  componentId: "sc-1bbk0ov-2"
})(["position:relative;text-align:center;font-size:var(--tina-font-size-1);padding:0 12px;height:40px;font-weight:var(--tina-font-weight-regular);width:100%;background:none;cursor:pointer;outline:none;border:0;transition:all var(--tina-timing-medium) ease-out;&:hover{color:var(--tina-color-primary);background-color:var(--tina-color-grey-1);}&:not(:last-child){border-bottom:1px solid var(--tina-color-grey-2);}"]);

var __jsx$V = react.exports.createElement;
var FormPortalContext = /*#__PURE__*/react.exports.createContext(function () {
  return null;
});
function useFormPortal() {
  return react.exports.useContext(FormPortalContext);
}
styled(function (_ref) {
  var children = _ref.children,
      styleProps = _objectWithoutProperties$2(_ref, ["children"]);

  var wrapperRef = react.exports.useRef(null);
  var FormPortal = react.exports.useCallback(function (props) {
    if (!wrapperRef.current) return null;
    return /*#__PURE__*/reactDom.exports.createPortal(props.children, wrapperRef.current);
  }, [wrapperRef.current]);
  return __jsx$V(FormPortalContext.Provider, {
    value: FormPortal
  }, __jsx$V("div", _extends$b({
    ref: wrapperRef
  }, styleProps), children));
}).withConfig({
  displayName: "FormPortal__FormPortalProvider",
  componentId: "sc-tpxiem-0"
})(["height:100%;scrollbar-width:none;"]);

formSubscriptionItems.reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});

fieldSubscriptionItems.reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});

function toArray$2(scalarOrCollection) {
  if (Array.isArray(scalarOrCollection)) {
    return scalarOrCollection;
  }

  return [scalarOrCollection];
}

var mainFont = "system-ui";
var fontVariationSettings = "'opsz' 21";
var SSFonts = {
  bodyLarge: {
    fontFamily: mainFont,
    fontVariationSettings: fontVariationSettings,
    fontSize: 18,
    fontWeight: 400,
    lineHeight: 1.2
  },
  body: {
    fontFamily: mainFont,
    fontVariationSettings: fontVariationSettings,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.15
  },
  body4: {
    fontFamily: mainFont,
    fontVariationSettings: fontVariationSettings,
    fontSize: 11,
    fontWeight: 400,
    lineHeight: 1.15
  },
  label: {
    fontFamily: mainFont,
    fontVariationSettings: fontVariationSettings,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1.15
  },
  label2: {
    fontFamily: mainFont,
    fontVariationSettings: fontVariationSettings,
    fontSize: 10,
    fontWeight: 600,
    lineHeight: 1.15
  },
  label3: {
    fontFamily: mainFont,
    fontVariationSettings: fontVariationSettings,
    fontSize: 9,
    fontWeight: 600,
    letterSpacing: "0.05em",
    lineHeight: 1.15
  }
};

var SSColors = {
  blue: "#3F76CD",
  focus: "#8EB2F1",
  purple: "#7B70F5",
  blue10: "#ECF5FE",
  blue20: "#DAEAFD",
  blue50: "#4597F6",
  blue60: "#0B75F0",
  blue70: "#0858B4",
  black5: "#F2F2F2",
  black10: "#E5E5E5",
  black20: "#CCCCCC",
  black40: "#999999"
};

var __jsx$U = React.createElement;
var IconContainer$1 = styled.div.withConfig({
  displayName: "icons__IconContainer",
  componentId: "sc-1omx03r-0"
})(["svg{width:", ";height:", ";display:block;}", ""], function (p) {
  return (p.size || 16) + "px";
}, function (p) {
  return (p.size || 16) + "px";
}, function (p) {
  return p.isStroke ? "\n    svg > [stroke] {\n      stroke: currentColor;\n    }\n    \n    svg > [fill] {\n      fill: none;\n    }\n    \n  " : "\n  \n    svg > [stroke] {\n      fill: none;\n    }\n    \n    svg > [fill] {\n      fill: currentColor;\n    }\n    \n  ";
});

function createIcon(svg) {
  var isStroke = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (props) {
    return __jsx$U(IconContainer$1, _extends$b({}, props, {
      isStroke: isStroke
    }), svg);
  };
}

var Dropdown = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M8.35355 10.0606L8.70711 9.70709L11.7071 6.70709L11 5.99998L8.35355 8.64643L5.70711 5.99998L5 6.70709L8 9.70709L8.35355 10.0606Z",
  fill: "black"
})));
var MaxHeight = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M14 2H2.5V1H14V2ZM8.54545 2.82172L8.88332 3.13142L11.0651 5.13142L10.3894 5.86858L9.04545 4.63662V10.8634L10.3894 9.63142L11.0651 10.3686L8.88332 12.3686L8.54545 12.6783L8.20759 12.3686L8.54545 12L8.20758 12.3686L8.20753 12.3685L8.20735 12.3684L8.20663 12.3677L8.20375 12.3651L8.19245 12.3547L8.14879 12.3147L7.9865 12.1659L7.4362 11.6615L6.02577 10.3686L6.7015 9.63142L8.04545 10.8634V4.63662L6.7015 5.86858L6.02577 5.13142L8.20759 3.13142L8.54545 2.82172ZM8.54545 15H2.5V14H8.54545H14V15H8.54545Z",
  fill: "black"
})));
var Add = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M8 2V14M2 8H14",
  stroke: "black"
})), true);
var AlignLeft = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M1 3H15V4H1V3ZM1 7H9V8H1V7ZM11 11H1V12H11V11Z",
  fill: "black"
})));
var AlignCenter = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M1 3H15V4H1V3ZM4 7H12V8H4V7ZM13 11H3V12H13V11Z",
  fill: "black"
})));
var AlignRight = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M1 3H15V4H1V3ZM7 7H15V8H7V7ZM15 11H5V12H15V11Z",
  fill: "black"
})));
var Close = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M7.76732 7.06025L12.2584 2.56918L12.9655 3.27629L8.47443 7.76735L12.9655 12.2584L12.2584 12.9655L7.76732 8.47446L3.2763 12.9655L2.56919 12.2584L7.06021 7.76735L2.56919 3.27637L3.2763 2.56926L7.76732 7.06025Z",
  fill: "black"
})));
var Desktop = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 13H6V12H10V13Z",
  fill: "black"
}), __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 3H2V10H14V3ZM1 2V11H15V2H1Z",
  fill: "black"
}), __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 13L5 13V12L11 12V13Z",
  fill: "black"
})));
var Mobile = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 2H6C5.44772 2 5 2.44772 5 3V13C5 13.5523 5.44772 14 6 14H10C10.5523 14 11 13.5523 11 13V3C11 2.44772 10.5523 2 10 2ZM6 1C4.89543 1 4 1.89543 4 3V13C4 14.1046 4.89543 15 6 15H10C11.1046 15 12 14.1046 12 13V3C12 1.89543 11.1046 1 10 1H6Z",
  fill: "black"
}), __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 13H6V12H10V13Z",
  fill: "black"
})));
var Drag = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 3H5V5H7V3ZM7 7H5V9H7V7ZM5 11H7V13H5V11ZM11 3H9V5H11V3ZM9 7H11V9H9V7ZM11 11H9V13H11V11Z",
  fill: "black",
  fillOpacity: "0.8"
})));
var ArrowDown = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M8 12L8 2.5M8 12L5 9M8 12L11 9",
  stroke: "black"
})), true);
var ArrowRight = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M12 8L2.5 8M12 8L9 11M12 8L9 5",
  stroke: "black"
})), true);
var Master = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M5.75417 5.29515L8.04931 3L10.3445 5.29515L8.04931 7.59029L5.75417 5.29515Z",
  fill: "black"
}), __jsx$U("path", {
  d: "M5.75417 10.8035L8.04931 8.50835L10.3445 10.8035L8.04931 13.0986L5.75417 10.8035Z",
  fill: "black"
}), __jsx$U("path", {
  d: "M3 8.04933L5.29515 5.75418L7.59029 8.04933L5.29515 10.3445L3 8.04933Z",
  fill: "black"
}), __jsx$U("path", {
  d: "M8.50835 8.04933L10.8035 5.75418L13.0986 8.04933L10.8035 10.3445L8.50835 8.04933Z",
  fill: "black"
})));
var Redo = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0858 6.35355L9.43934 9L10.1464 9.70711L13.6464 6.20711L14 5.85355L13.6464 5.5L10.1464 2L9.43934 2.70711L12.0858 5.35355H8.29289C4.71675 5.35355 1.79289 8.27741 1.79289 11.8536L1.79289 13.3536H2.79289L2.79289 11.8536C2.79289 8.8297 5.26904 6.35355 8.29289 6.35355H12.0858Z",
  fill: "black"
})));
var Undo = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.91421 6.35355L6.56066 9L5.85355 9.70711L2.35355 6.20711L2 5.85355L2.35355 5.5L5.85355 2L6.56066 2.70711L3.91421 5.35355H7.70711C11.2832 5.35355 14.2071 8.27741 14.2071 11.8536L14.2071 13.3536H13.2071L13.2071 11.8536C13.2071 8.8297 10.731 6.35355 7.70711 6.35355H3.91421Z",
  fill: "black"
})));
var Remove = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 8.5H2V7.5H14V8.5Z",
  fill: "black",
  fillOpacity: "0.8"
})));
var ChevronRight = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0607 8.64645L9.70711 8.29289L6.70711 5.29289L6 6L8.64645 8.64645L6 11.2929L6.70711 12L9.70711 9L10.0607 8.64645Z",
  fill: "black"
})));
var Back = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M10.5 3L6 7.5L10.5 12",
  stroke: "black"
})), true);
var Share = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.35355 0.646461L8 0.292908L7.64645 0.646461L4.64645 3.64646L5.35355 4.35357L7.5 2.20712L7.5 10.5H8.5L8.5 2.20712L10.6464 4.35357L11.3536 3.64646L8.35355 0.646461ZM3 5.50001C2.72386 5.50001 2.5 5.72387 2.5 6.00001V15C2.5 15.2762 2.72386 15.5 3 15.5H13C13.2761 15.5 13.5 15.2762 13.5 15V6.00001C13.5 5.72387 13.2761 5.50001 13 5.50001H10.5V6.50001H12.5V14.5H3.5V6.50001H5.5V5.50001H3Z",
  fill: "black"
})));
var Reset = createIcon(__jsx$U("svg", {
  width: "17",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("mask", {
  id: "a",
  fill: "#fff"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m1.751 6.349 2.287 2.858 3.381-2.255-.555-.832-2.618 1.746-1.714-2.142-.78.625Z"
}), __jsx$U("path", {
  d: "M13.858 8a4.56 4.56 0 0 1-4.56 4.56h-.042v1h.042A5.56 5.56 0 1 0 3.754 8.42c.039-.036.077-.079.115-.127l.876-.044A4.56 4.56 0 1 1 13.859 8Z"
})), __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m1.751 6.349 2.287 2.858 3.381-2.255-.555-.832-2.618 1.746-1.714-2.142-.78.625Z",
  fill: "#000"
}), __jsx$U("path", {
  d: "M13.858 8a4.56 4.56 0 0 1-4.56 4.56h-.042v1h.042A5.56 5.56 0 1 0 3.754 8.42c.039-.036.077-.079.115-.127l.876-.044A4.56 4.56 0 1 1 13.859 8Z",
  fill: "#000"
}), __jsx$U("path", {
  d: "m1.751 6.349-.624-.781-.781.625.624.78.781-.624Zm2.287 2.858-.781.624.572.716.763-.508-.554-.832Zm3.381-2.255.555.832.832-.554-.555-.832-.832.554Zm-.555-.832.832-.554-.554-.832-.832.554.554.832ZM4.246 7.866l-.781.625.573.716.762-.509-.554-.832ZM2.532 5.724l.781-.625-.625-.78-.78.624.624.781Zm6.724 6.836.01-1-1.01-.01v1.01h1Zm0 1h-1v.993l.993.007.007-1ZM3.754 8.42l-.998.074.154 2.06 1.52-1.398-.676-.736Zm.115-.127-.05-1-.46.024-.282.365.792.61Zm.876-.044.05.998 1.002-.05-.054-1.002-.998.054Zm1.287-1.573.555.832 1.664-1.11-.555-.831-1.664 1.109ZM4.8 8.698 7.42 6.952l-1.11-1.664-2.618 1.746 1.11 1.664Zm-3.049-2.35 1.714 2.143 1.562-1.25L3.313 5.1 1.751 6.35Zm.625.782.78-.625-1.249-1.562-.78.625L2.376 7.13Zm2.442 1.452L2.532 5.724.97 6.974 3.257 9.83l1.561-1.249ZM6.864 6.12 3.483 8.375l1.11 1.664 3.38-2.255L6.865 6.12Zm2.434 7.44A5.56 5.56 0 0 0 14.858 8h-2a3.56 3.56 0 0 1-3.56 3.56v2Zm-.051 0h.051v-2h-.033l-.018 2Zm1.01 0v-1h-2v1h2Zm-1.008 1h.05v-2h-.035l-.015 2Zm.05 0A6.56 6.56 0 0 0 15.858 8h-2a4.56 4.56 0 0 1-4.56 4.56v2ZM15.858 8a6.56 6.56 0 0 0-6.56-6.56v2A4.56 4.56 0 0 1 13.858 8h2Zm-6.56-6.56A6.56 6.56 0 0 0 2.738 8h2a4.56 4.56 0 0 1 4.56-4.56v-2ZM2.738 8c0 .166.005.33.017.493l1.995-.149A4.639 4.639 0 0 1 4.738 8h-2Zm.338-.319c-.007.009-.007.008 0 .001L4.43 9.155c.086-.079.162-.164.23-.253L3.078 7.681Zm1.617-.432-.875.044.1 1.997.876-.044-.1-1.997ZM3.738 8c0 .1.003.201.008.301l1.997-.107A3.629 3.629 0 0 1 5.738 8h-2Zm5.56-5.56A5.56 5.56 0 0 0 3.738 8h2a3.56 3.56 0 0 1 3.56-3.56v-2ZM14.858 8a5.56 5.56 0 0 0-5.56-5.56v2A3.56 3.56 0 0 1 12.858 8h2Z",
  fill: "#000",
  mask: "url(#a)"
})));
var Grid3x3 = createIcon(__jsx$U("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 3.34674H5V5.34674H3V3.34674ZM3 7.34674H5V9.34674H3V7.34674ZM5 11.3467H3V13.3467H5V11.3467ZM7 3.34674H9V5.34674H7V3.34674ZM9 7.34674H7V9.34674H9V7.34674ZM7 11.3467H9V13.3467H7V11.3467ZM13 3.34674H11V5.34674H13V3.34674ZM11 7.34674H13V9.34674H11V7.34674ZM13 11.3467H11V13.3467H13V11.3467Z",
  fill: "black"
})));
var ChevronLeft = createIcon(__jsx$U("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M10.5 3L6 7.5L10.5 12",
  stroke: "black"
})));
var Link = createIcon(__jsx$U("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 5.34674V6.63245H11V5.34674C11 3.68989 9.65685 2.34674 8 2.34674C6.34315 2.34674 5 3.68989 5 5.34674V6.63245H6V5.34674C6 4.24217 6.89543 3.34674 8 3.34674C9.10457 3.34674 10 4.24217 10 5.34674ZM10 10.061H11V11.3467C11 13.0036 9.65685 14.3467 8 14.3467C6.34315 14.3467 5 13.0036 5 11.3467V10.061H6V11.3467C6 12.4513 6.89543 13.3467 8 13.3467C9.10457 13.3467 10 12.4513 10 11.3467V10.061ZM7.5 5.77531V10.9182H8.5V5.77531H7.5Z",
  fill: "black"
})));
var MarginBottom = createIcon(__jsx$U("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 15.3467H2V14.3467H14V15.3467Z",
  fill: "black"
}), __jsx$U("rect", {
  x: "4.5",
  y: "4.84674",
  width: "7",
  height: "7",
  stroke: "black"
})));
var MarginHorizontal = createIcon(__jsx$U("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.999999 14.3467L1 2.34674L2 2.34674L2 14.3467L0.999999 14.3467Z",
  fill: "black"
}), __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 14.3467L14 2.34674L15 2.34674L15 14.3467L14 14.3467Z",
  fill: "black"
}), __jsx$U("rect", {
  x: "4.5",
  y: "4.84674",
  width: "7",
  height: "7",
  stroke: "black"
})));
var MarginTop = createIcon(__jsx$U("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 2.34674H2V1.34674H14V2.34674Z",
  fill: "black"
}), __jsx$U("rect", {
  x: "4.5",
  y: "4.84674",
  width: "7",
  height: "7",
  stroke: "black"
})));
var CornerRadius = createIcon(__jsx$U("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$U("path", {
  d: "M14 3.34674H10C6.13401 3.34674 3 6.48075 3 10.3467V14.3467H2V10.3467C2 5.92846 5.58172 2.34674 10 2.34674H14V3.34674Z",
  fill: "black"
})));
var SSIcons = {
  Dropdown: Dropdown,
  MaxHeight: MaxHeight,
  Add: Add,
  AlignLeft: AlignLeft,
  AlignRight: AlignRight,
  AlignCenter: AlignCenter,
  Close: Close,
  Desktop: Desktop,
  Mobile: Mobile,
  Drag: Drag,
  ArrowDown: ArrowDown,
  ArrowRight: ArrowRight,
  Master: Master,
  ChevronDown: Dropdown,
  ChevronRight: ChevronRight,
  ChevronLeft: ChevronLeft,
  Back: Back,
  Redo: Redo,
  Undo: Undo,
  Remove: Remove,
  Share: Share,
  Reset: Reset,
  Grid3x3: Grid3x3,
  Link: Link,
  MarginBottom: MarginBottom,
  MarginHorizontal: MarginHorizontal,
  MarginTop: MarginTop,
  CornerRadius: CornerRadius
};

var __jsx$T = React.createElement;

var sharedCSS = function sharedCSS(p) {
  return Ce(["", ";border:none;outline:none;height:", ";", " border-radius:6px;line-height:1;transition:all 0.1s;display:flex;flex-direction:row;gap:6px;justify-content:center;align-items:center;min-width:0;"], SSFonts.body, p.height !== undefined ? p.height : p.variant === "large" ? "36px" : p.variant === "tiny" ? "24px" : "28px", p.hideLabel ? "\n    width: ".concat(p.variant === "large" ? "36px" : p.variant === "tiny" ? "24px" : "28px", ";\n  ") : "\n    padding-left: ".concat(p.isGhost ? p.noPadding ? "0px" : "6px" : "10px", ";\n    padding-right: ").concat(p.isGhost ? p.noPadding ? "0px" : "6px" : "10px", ";\n  "));
};

var PrimaryButton = styled.button.withConfig({
  displayName: "buttons__PrimaryButton",
  componentId: "sc-9jijvt-0"
})(["", " background-color:", ";color:white;&:hover{background-color:", ";}&:focus-visible{box-shadow:0 0 0 2px ", ";}&:active{background-color:", ";}"], function (p) {
  return sharedCSS(p);
}, SSColors.blue50, SSColors.blue60, SSColors.blue60, SSColors.blue70);
var SecondaryButton = styled.button.withConfig({
  displayName: "buttons__SecondaryButton",
  componentId: "sc-9jijvt-1"
})(["", " background-color:", ";color:black;&:hover{background-color:", ";}&:focus-visible{box-shadow:0 0 0 2px ", ";}&:active{background-color:", ";}"], function (p) {
  return sharedCSS(p);
}, SSColors.black5, SSColors.black10, SSColors.blue50, SSColors.black40);
var GhostButton = styled.button.withConfig({
  displayName: "buttons__GhostButton",
  componentId: "sc-9jijvt-2"
})(["", " background-color:transparent;color:black;border:1px solid transparent;border-radius:2px;&:hover{border-color:#e5e5e5;}&:focus-visible{box-shadow:0 0 0 2px ", ";}&:active{background-color:", ";}"], function (p) {
  return sharedCSS(p);
}, SSColors.blue50, SSColors.black20);
var GhostColorButton = styled.button.withConfig({
  displayName: "buttons__GhostColorButton",
  componentId: "sc-9jijvt-3"
})(["", " background-color:transparent;color:", ";&:hover{background-color:", ";}&:focus-visible{box-shadow:0 0 0 2px ", ";}&:active{background-color:", ";}"], function (p) {
  return sharedCSS(p);
}, SSColors.blue50, SSColors.blue10, SSColors.blue50, SSColors.black20);
var EnhancerContainer = styled.div.withConfig({
  displayName: "buttons__EnhancerContainer",
  componentId: "sc-9jijvt-4"
})(["position:relative;width:", ";height:", ";overflow:hidden;flex-shrink:0;"], function (p) {
  return p.variant === "large" ? "24px" : "16px";
}, function (p) {
  return p.variant === "large" ? "24px" : "16px";
});

var SSButton = function SSButton(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties$2(_ref, ["className"]);

  var Icon = props.icon;
  var Button = props.Button;
  return __jsx$T(Button, _extends$b({
    className: className
  }, props), props.enhancer && __jsx$T(EnhancerContainer, props, props.enhancer), !props.enhancer && Icon && __jsx$T(Icon, null), !props.hideLabel && props.children);
};

var SSButtonPrimary = function SSButtonPrimary(props) {
  return __jsx$T(SSButton, _extends$b({}, props, {
    Button: PrimaryButton
  }));
};
var SSButtonSecondary = function SSButtonSecondary(props) {
  return __jsx$T(SSButton, _extends$b({}, props, {
    Button: SecondaryButton
  }));
};
var SSButtonGhost = function SSButtonGhost(props) {
  return __jsx$T(SSButton, _extends$b({}, props, {
    Button: GhostButton,
    isGhost: true,
    noPadding: props.noPadding
  }));
};
var SSButtonGhostColor = function SSButtonGhostColor(props) {
  return __jsx$T(SSButton, _extends$b({}, props, {
    Button: GhostColorButton,
    isGhost: true,
    noPadding: props.noPadding
  }));
};

var __jsx$S = React.createElement;

function sizing(p) {
  var height = p.size === "tiny" ? 24 : 28;
  var paddingHorizontal = p.size === "tiny" ? 4 : 6;
  var paddingIcon = paddingHorizontal + (p.icon ? 20 : 0);

  if (p.iconOnly) {
    paddingIcon = 0;
  }

  return {
    height: height + "px",
    width: p.size === "full-width" ? "100%" : p.iconOnly ? height + "px" : "auto",
    paddingHorizontal: paddingHorizontal + "px",
    paddingVertical: p.size === "tiny" ? "4px" : "6px",
    paddingIcon: paddingIcon + "px"
  };
}

var Root$5 = styled.div.withConfig({
  displayName: "ControlContainer__Root",
  componentId: "sc-1wrkz3e-0"
})(["position:relative;height:", ";width:", ";color:black;", " ", " transition:box-shadow 0.1s;border-radius:2px;display:inline-block;", ";"], function (p) {
  return sizing(p).height;
}, function (p) {
  return sizing(p).width;
}, function (p) {
  return p.disabled ? "\n    color: ".concat(SSColors.black40, ";\n  ") : "\n    &:hover {\n      box-shadow: 0 0 0 1px ".concat(SSColors.black10, ";\n      .ss-arrow {\n        color: black;\n      }\n    }\n    ");
}, function (p) {
  return (
    /*p.isFocused || SO FAR WE DISABLED FOCUS TEMPORARILY, only display focus for Input or other components with alwaysFocus flag */
    p.alwaysFocus ? "\n    &:focus-within {\n      box-shadow: 0 0 0 2px ".concat(SSColors.focus, ";\n      .ss-arrow {\n        color: black;\n      }\n    }\n    ") : ""
  );
}, SSFonts.body);
var IconContainer = styled.div.withConfig({
  displayName: "ControlContainer__IconContainer",
  componentId: "sc-1wrkz3e-1"
})(["color:", ";position:absolute;left:", ";top:", ";pointer-events:none;"], function (p) {
  return p.iconBlack ? "black" : SSColors.black40;
}, function (p) {
  return sizing(p).paddingHorizontal;
}, function (p) {
  return sizing(p).paddingVertical;
});
var ControlContainer = function ControlContainer(props) {
  var Icon = props.icon;
  var rootRef = react.exports.useRef(null);

  var _useState = react.exports.useState(false),
      isFocused = _useState[0],
      setFocused = _useState[1];

  react.exports.useEffect(function () {
    var onFocusIn = function onFocusIn() {
      setFocused(true);
    };

    var onFocusOut = function onFocusOut() {
      setFocused(false);
    };

    var rootNode = rootRef.current;
    rootNode.addEventListener("focusin", onFocusIn);
    rootNode.addEventListener("focusout", onFocusOut);
    return function () {
      rootNode.removeEventListener("focusin", onFocusIn);
      rootNode.removeEventListener("focusout", onFocusOut);
    };
  });
  return __jsx$S(Root$5, _extends$b({}, props, {
    ref: rootRef,
    isFocused: isFocused
  }), Icon && __jsx$S(IconContainer, props, __jsx$S(Icon, null)), props.children);
};
function getControlPadding() {
  return Ce(["padding-left:", ";padding-right:", ";"], function (p) {
    return sizing(p).paddingIcon;
  }, function (p) {
    return sizing(p).paddingHorizontal;
  });
}

var __jsx$R = React.createElement;
var ArrowIconContainer = styled.div.withConfig({
  displayName: "Select__ArrowIconContainer",
  componentId: "sc-rea5of-0"
})(["position:absolute;right:2px;top:50%;transform:translateY(-50%);pointer-events:none;color:", ";"], SSColors.black40);
var StyledSelect = styled.select.withConfig({
  displayName: "Select__StyledSelect",
  componentId: "sc-rea5of-1"
})(["all:unset;box-sizing:border-box;display:block;appearance:none;border:none;", " padding-right:20px;height:100%;width:100%;text-align:right;line-height:28px;select:-moz-focusring,select::-moz-focus-inner{color:transparent;text-shadow:0 0 0 #000;}"], getControlPadding());
var SSSelect = function SSSelect(_ref) {
  var onChange = _ref.onChange,
      restProps = _objectWithoutProperties$2(_ref, ["onChange"]);

  return __jsx$R(ControlContainer, restProps, __jsx$R(StyledSelect, _extends$b({}, restProps, {
    onChange: onChange
  })), __jsx$R(ArrowIconContainer, {
    className: "ss-arrow"
  }, __jsx$R(SSIcons.Dropdown, null)));
};

var __jsx$Q = React.createElement;
var StyledInput = styled.input.withConfig({
  displayName: "Input__StyledInput",
  componentId: "sc-1e03x4f-0"
})(["all:unset;box-sizing:border-box;width:100%;height:100%;outline:none;border:none;::-webkit-search-decoration,::-webkit-search-cancel-button,::-webkit-search-results-button,::-webkit-search-results-decoration{display:none;}", " ", ";text-align:", ";"], function (p) {
  return !p.isRaw && getControlPadding();
}, SSFonts.body, function (p) {
  return p.align === "right" ? "right" : "left";
});
var InputBase = /*#__PURE__*/react.exports.forwardRef(function (props, ref) {
  return __jsx$Q(StyledInput, _extends$b({}, props, {
    ref: ref
  }));
});
var SSInput = /*#__PURE__*/react.exports.forwardRef(function (props, ref) {
  var iconBlack = props.iconBlack,
      size = props.size,
      iconOnly = props.iconOnly,
      isFocused = props.isFocused;
      props.alwaysFocus;
      var inputProps = _objectWithoutProperties$2(props, ["iconBlack", "size", "iconOnly", "isFocused", "alwaysFocus"]);

  return __jsx$Q(ControlContainer, {
    iconBlack: iconBlack,
    size: size,
    iconOnly: iconOnly,
    isFocused: isFocused,
    alwaysFocus: true
  }, __jsx$Q(InputBase, _extends$b({}, inputProps, {
    ref: ref
  })));
});
var SSInputRaw = /*#__PURE__*/react.exports.forwardRef(function (props, ref) {
  return __jsx$Q(InputBase, _extends$b({}, props, {
    ref: ref,
    isRaw: true
  }));
});

var __jsx$P = React.createElement;
var StyledButton = styled.button.withConfig({
  displayName: "ToggleButton__StyledButton",
  componentId: "sc-cws65u-0"
})(["all:unset;box-sizing:border-box;width:100%;height:100%;outline:none;border:none;", " ", " border-radius:2px;background-color:", ";"], getControlPadding(), function (p) {
  return p.hideLabel ? "padding-right: 0;" : "";
}, function (p) {
  return p.selected ? SSColors.black10 : "transparent";
});
var SSToggleButton = function SSToggleButton(props) {
  var onClick = props.onClick,
      restProps = _objectWithoutProperties$2(props, ["onClick"]);

  return __jsx$P(ControlContainer, _extends$b({}, restProps, {
    iconBlack: true,
    iconOnly: props.hideLabel
  }), __jsx$P(StyledButton, _extends$b({}, restProps, {
    onClick: onClick,
    iconOnly: props.hideLabel,
    "aria-label": props.children
  }), props.hideLabel ? null : props.children));
};
var SelectInlineRoot = styled.div.withConfig({
  displayName: "ToggleButton__SelectInlineRoot",
  componentId: "sc-cws65u-1"
})(["display:flex;flex-direction:row;gap:4px;flex-wrap:nowrap;"]);
var SSSelectInline = function SSSelectInline(props) {
  var buttons = React.Children.toArray(props.children);
  return __jsx$P(SelectInlineRoot, null, buttons.map(function (button) {
    return /*#__PURE__*/React.cloneElement(button, {
      selected: button.props.value === props.value,
      onClick: function onClick() {
        props.onChange(button.props.value);
      }
    });
  }));
};

var __jsx$O = React.createElement;
var SSToggle = function SSToggle(props) {
  var labels = props.labels,
      inputProps = _objectWithoutProperties$2(props, ["labels"]);

  var checked = !!props.checked;
  var normalizedLabels;

  if (labels) {
    var fieldLabels = typeof props.labels === "object" && "true" in props.labels && "false" in props.labels && labels;
    normalizedLabels = {
      "true": fieldLabels ? fieldLabels["true"] : "Yes",
      "false": fieldLabels ? fieldLabels["false"] : "No"
    };
  }

  var name = inputProps.name;
  return __jsx$O(ToggleWrap, null, normalizedLabels && __jsx$O("span", null, normalizedLabels["false"]), __jsx$O(ToggleElement, {
    hasToggleLabels: labels !== null
  }, __jsx$O(ToggleInput, _extends$b({
    id: name,
    type: "checkbox"
  }, inputProps)), __jsx$O(ToggleLabel, {
    htmlFor: name,
    role: "switch",
    disabled: !!props.disabled
  }, __jsx$O(ToggleSwitch, {
    checked: checked,
    disabled: !!props.disabled
  }, __jsx$O("span", null)))), normalizedLabels && __jsx$O("span", null, normalizedLabels["true"]));
};
var ToggleWrap = styled.div.withConfig({
  displayName: "Toggle__ToggleWrap",
  componentId: "sc-1bqzs95-0"
})(["display:flex;align-items:center;> span{color:var(--tina-color-grey-8);}"]);
var ToggleElement = styled.div.withConfig({
  displayName: "Toggle__ToggleElement",
  componentId: "sc-1bqzs95-1"
})(["position:relative;width:32px;height:18px;padding:1px;margin:", ";"], function (props) {
  return props.hasToggleLabels ? "0 10px" : "0";
});
var ToggleLabel = styled.label.withConfig({
  displayName: "Toggle__ToggleLabel",
  componentId: "sc-1bqzs95-2"
})(["background:none;color:inherit;padding:0;opacity:", ";outline:none;width:30px;height:16px;pointer-events:", ";"], function (props) {
  return props.disabled ? "0.4" : "1";
}, function (props) {
  return props.disabled ? "none" : "inherit";
});
var ToggleSwitch = styled.div.withConfig({
  displayName: "Toggle__ToggleSwitch",
  componentId: "sc-1bqzs95-3"
})(["position:relative;width:30px;height:16px;border-radius:var(--tina-radius-big);background-color:white;box-shadow:0 0 0 1px ", ";transition:all 0.1s;pointer-events:none;span{position:absolute;border-radius:8px;left:2px;top:50%;width:10px;height:10px;background:", ";transform:translate3d(", ",-50%,0);transition:transform 150ms ease-out,opacity 0.1s;}"], function (p) {
  return !p.checked || p.disabled ? SSColors.black40 : "black";
}, function (p) {
  return !p.checked || p.disabled ? SSColors.black40 : "black";
}, function (p) {
  return p.checked ? "16px" : "0";
});
var ToggleInput = styled.input.withConfig({
  displayName: "Toggle__ToggleInput",
  componentId: "sc-1bqzs95-4"
})(["position:absolute;left:0;top:0;width:30px;height:16px;opacity:0;margin:0;cursor:", ";pointer-events:auto;", ""], function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, function (p) {
  return p.disabled ? "" : "\n  &:hover {\n    + ".concat(ToggleLabel, " ").concat(ToggleSwitch, " {\n      box-shadow: 0 0 0 1px black;\n    }\n    \n    + ").concat(ToggleLabel, " ").concat(ToggleSwitch, " span {\n      background-color: black;\n    }\n  }\n  ");
});

var lib$3 = {exports: {}};

var Modal$1 = {};

var ModalPortal = {exports: {}};

var focusManager = {};

var tabbable = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";
var tabbableNode = /input|select|textarea|button|object|iframe/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0; // If the node is empty, this is good enough

  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();

  while (parentElement) {
    if (parentElement === document.body) break; // if we are not hidden yet, skip to checking outside the Web Component

    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }

  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}

module.exports = exports["default"];
}(tabbable, tabbable.exports));

Object.defineProperty(focusManager, "__esModule", {
  value: true
});
focusManager.resetState = resetState$3;
focusManager.log = log$5;
focusManager.handleBlur = handleBlur;
focusManager.handleFocus = handleFocus;
focusManager.markForFocusLater = markForFocusLater;
focusManager.returnFocus = returnFocus;
focusManager.popWithoutFocus = popWithoutFocus;
focusManager.setupScopedFocus = setupScopedFocus;
focusManager.teardownScopedFocus = teardownScopedFocus;

var _tabbable = tabbable.exports;

var _tabbable2 = _interopRequireDefault$2(_tabbable);

function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;
/* eslint-disable no-console */

/* istanbul ignore next */

function resetState$3() {
  focusLaterElements = [];
}
/* istanbul ignore next */


function log$5() {
}
/* eslint-enable no-console */


function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;

    if (!modalElement) {
      return;
    } // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.


    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }

      var el = (0, _tabbable2["default"])(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */


function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var toFocus = null;

  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({
        preventScroll: preventScroll
      });
    }

    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */


function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

var scopeTab = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = scopeTab;

var _tabbable = tabbable.exports;

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2["default"])(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;
  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement(); // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.

  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  } // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.


  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null; // If we are not in safari desktop, let the browser control
  // the focus

  if (!isSafariDesktop) return;
  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x]; // If the tabbable element does not exist,
  // focus head/tail based on shiftKey

  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();
  target.focus();
}

module.exports = exports["default"];
}(scopeTab, scopeTab.exports));

var ariaAppHider = {};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var warning = function warning() {};

var warning_1 = warning;

var safeHTMLElement = {};

var exenv = {exports: {}};

/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function (module) {
/* global define */
(function () {

  var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
  var ExecutionEnvironment = {
    canUseDOM: canUseDOM,
    canUseWorkers: typeof Worker !== 'undefined',
    canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
    canUseViewport: canUseDOM && !!window.screen
  };

  if (module.exports) {
    module.exports = ExecutionEnvironment;
  } else {
    window.ExecutionEnvironment = ExecutionEnvironment;
  }
})();
}(exenv));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = exenv.exports;

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var EE = _exenv2["default"];
var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
exports.canUseDOM = EE.canUseDOM;
exports["default"] = SafeHTMLElement;
}(safeHTMLElement));

Object.defineProperty(ariaAppHider, "__esModule", {
  value: true
});
ariaAppHider.resetState = resetState$2;
ariaAppHider.log = log$4;
ariaAppHider.assertNodeList = assertNodeList;
ariaAppHider.setElement = setElement;
ariaAppHider.validateElement = validateElement;
ariaAppHider.hide = hide$2;
ariaAppHider.show = show;
ariaAppHider.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = warning_1;

var _warning2 = _interopRequireDefault$1(_warning);

var _safeHTMLElement = safeHTMLElement;

function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var globalElement = null;
/* eslint-disable no-console */

/* istanbul ignore next */

function resetState$2() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }

  globalElement = null;
}
/* istanbul ignore next */


function log$4() {
}
/* eslint-enable no-console */


function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;

  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }

  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;

  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2["default"])(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
    return [];
  }
}

function hide$2(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;
      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"]) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;
      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
        _iterator2["return"]();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

var classList = {};

Object.defineProperty(classList, "__esModule", {
  value: true
});
classList.resetState = resetState$1;
classList.log = log$3;
var htmlClassList = {};
var docBodyClassList = {};
/* eslint-disable no-console */

/* istanbul ignore next */

function removeClass(at, cls) {
  at.classList.remove(cls);
}
/* istanbul ignore next */


function resetState$1() {
  var htmlElement = document.getElementsByTagName("html")[0];

  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;

  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}
/* istanbul ignore next */


function log$3() {
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */


var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }

  poll[className] += 1;
  return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */


var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }

  return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */


var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */


var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */


classList.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */


classList.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

var portalOpenInstances = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
} // Tracks portals that are open and emits events to subscribers


var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {

      return;
    }

    _this.openInstances.push(openInstance);

    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);

    if (index === -1) {

      return;
    }

    _this.openInstances.splice(index, 1);

    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType, // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();
/* eslint-disable no-console */

/* istanbul ignore next */

function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */


function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */


exports["default"] = portalOpenInstances;
}(portalOpenInstances));

var bodyTrap$1 = {};

Object.defineProperty(bodyTrap$1, "__esModule", {
  value: true
});
bodyTrap$1.resetState = resetState;
bodyTrap$1.log = log$2;

var _portalOpenInstances = portalOpenInstances;

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // Body focus trap see Issue #742


var before = void 0,
    after = void 0,
    instances = [];
/* eslint-disable no-console */

/* istanbul ignore next */

function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }

  before = after = null;
  instances = [];
}
/* istanbul ignore next */


function log$2() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];

  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }

  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */


function focusContent() {
  if (instances.length === 0) {

    return;
  }

  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }

    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }

    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2["default"].subscribe(bodyTrap);

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = react.exports;

var _propTypes = propTypes.exports;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = focusManager;

var focusManager$1 = _interopRequireWildcard(_focusManager);

var _scopeTab = scopeTab.exports;

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = ariaAppHider;

var ariaAppHider$1 = _interopRequireWildcard(_ariaAppHider);

var _classList = classList;

var classList$1 = _interopRequireWildcard(_classList);

var _safeHTMLElement = safeHTMLElement;

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = portalOpenInstances;

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);



function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // so that our CSS is statically analyzable


var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */

var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};

var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;
      var parentDocument = parentSelector && parentSelector().ownerDocument || document; // Remove classes.

      bodyOpenClassName && classList$1.remove(parentDocument.body, bodyOpenClassName);
      htmlOpenClassName && classList$1.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName); // Reset aria-hidden attribute if all modals have been removed

      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider$1.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager$1.returnFocus(_this.props.preventScroll);
          focusManager$1.teardownScopedFocus();
        } else {
          focusManager$1.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2["default"].deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();

      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);

        _this.setState({
          beforeClose: false
        });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager$1.setupScopedFocus(_this.node);
          focusManager$1.markForFocusLater();
        }

        _this.setState({
          isOpen: true
        }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({
              afterOpen: true
            });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({
        preventScroll: true
      });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;

      _this.setState({
        beforeClose: true,
        closesAt: closesAt
      }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2["default"])(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();

        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }

      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;

      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }

      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }

      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };
    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      } // Focus only needs to be set once when the modal is being opened


      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }

      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;
      var parentDocument = parentSelector && parentSelector().ownerDocument || document; // Add classes.

      bodyOpenClassName && classList$1.add(parentDocument.body, bodyOpenClassName);
      htmlOpenClassName && classList$1.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider$1.hide(appElement);
      }

      _portalOpenInstances2["default"].register(this);
    } // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;
      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({
        modal: true
      }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2["default"].bool.isRequired,
  defaultStyles: _propTypes2["default"].shape({
    content: _propTypes2["default"].object,
    overlay: _propTypes2["default"].object
  }),
  style: _propTypes2["default"].shape({
    content: _propTypes2["default"].object,
    overlay: _propTypes2["default"].object
  }),
  className: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].object]),
  overlayClassName: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].object]),
  parentSelector: _propTypes2["default"].func,
  bodyOpenClassName: _propTypes2["default"].string,
  htmlOpenClassName: _propTypes2["default"].string,
  ariaHideApp: _propTypes2["default"].bool,
  appElement: _propTypes2["default"].oneOfType([_propTypes2["default"].instanceOf(_safeHTMLElement2["default"]), _propTypes2["default"].instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2["default"].instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2["default"].arrayOf(_propTypes2["default"].instanceOf(_safeHTMLElement2["default"]))]),
  onAfterOpen: _propTypes2["default"].func,
  onAfterClose: _propTypes2["default"].func,
  onRequestClose: _propTypes2["default"].func,
  closeTimeoutMS: _propTypes2["default"].number,
  shouldFocusAfterRender: _propTypes2["default"].bool,
  shouldCloseOnOverlayClick: _propTypes2["default"].bool,
  shouldReturnFocusAfterClose: _propTypes2["default"].bool,
  preventScroll: _propTypes2["default"].bool,
  role: _propTypes2["default"].string,
  contentLabel: _propTypes2["default"].string,
  aria: _propTypes2["default"].object,
  data: _propTypes2["default"].object,
  children: _propTypes2["default"].node,
  shouldCloseOnEsc: _propTypes2["default"].bool,
  overlayRef: _propTypes2["default"].func,
  contentRef: _propTypes2["default"].func,
  id: _propTypes2["default"].string,
  overlayElement: _propTypes2["default"].func,
  contentElement: _propTypes2["default"].func,
  testId: _propTypes2["default"].string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];
}(ModalPortal, ModalPortal.exports));

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);

  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  } // Binding "this" is important for shallow renderer support.


  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
} // React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.


componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
    return Component;
  } // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.


  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;

  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }

  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }

  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }

  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
  } // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.


  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  } // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.


  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
    }

    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
	__proto__: null,
	polyfill: polyfill
});

var require$$6 = /*@__PURE__*/getAugmentedNamespace(reactLifecyclesCompat_es);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = react.exports;

var _react2 = _interopRequireDefault(_react);

var _reactDom = reactDom.exports;

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = propTypes.exports;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = ModalPortal.exports;

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = ariaAppHider;

var ariaAppHider$1 = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = safeHTMLElement;

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = require$$6;

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2["default"].createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2["default"].createPortal : _reactDom2["default"].unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2["default"].unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);

      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2["default"].createElement(_ModalPortal2["default"], _extends({
        defaultStyles: Modal.defaultStyles
      }, props)), _this.node);

      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }

      this.node.className = this.props.portalClassName;
      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);
      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return {
        prevParent: prevParent,
        nextParent: nextParent
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;

      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      } // Stop unnecessary renders if modal is remaining closed


      if (!prevProps.isOpen && !isOpen) return;
      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2["default"].createElement(_ModalPortal2["default"], _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider$1.setElement(element);
    }
    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2["default"].bool.isRequired,
  style: _propTypes2["default"].shape({
    content: _propTypes2["default"].object,
    overlay: _propTypes2["default"].object
  }),
  portalClassName: _propTypes2["default"].string,
  bodyOpenClassName: _propTypes2["default"].string,
  htmlOpenClassName: _propTypes2["default"].string,
  className: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].shape({
    base: _propTypes2["default"].string.isRequired,
    afterOpen: _propTypes2["default"].string.isRequired,
    beforeClose: _propTypes2["default"].string.isRequired
  })]),
  overlayClassName: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].shape({
    base: _propTypes2["default"].string.isRequired,
    afterOpen: _propTypes2["default"].string.isRequired,
    beforeClose: _propTypes2["default"].string.isRequired
  })]),
  appElement: _propTypes2["default"].oneOfType([_propTypes2["default"].instanceOf(_safeHTMLElement2["default"]), _propTypes2["default"].instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2["default"].instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2["default"].arrayOf(_propTypes2["default"].instanceOf(_safeHTMLElement2["default"]))]),
  onAfterOpen: _propTypes2["default"].func,
  onRequestClose: _propTypes2["default"].func,
  closeTimeoutMS: _propTypes2["default"].number,
  ariaHideApp: _propTypes2["default"].bool,
  shouldFocusAfterRender: _propTypes2["default"].bool,
  shouldCloseOnOverlayClick: _propTypes2["default"].bool,
  shouldReturnFocusAfterClose: _propTypes2["default"].bool,
  preventScroll: _propTypes2["default"].bool,
  parentSelector: _propTypes2["default"].func,
  aria: _propTypes2["default"].object,
  data: _propTypes2["default"].object,
  role: _propTypes2["default"].string,
  contentLabel: _propTypes2["default"].string,
  shouldCloseOnEsc: _propTypes2["default"].bool,
  overlayRef: _propTypes2["default"].func,
  contentRef: _propTypes2["default"].func,
  id: _propTypes2["default"].string,
  overlayElement: _propTypes2["default"].func,
  contentElement: _propTypes2["default"].func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2["default"].createElement("div", props, contentEl);
  },
  contentElement: function contentElement(props, children) {
    return _react2["default"].createElement("div", props, children);
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, _reactLifecyclesCompat.polyfill)(Modal);

exports["default"] = Modal;
}(Modal$1));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = Modal$1;

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports["default"] = _Modal2["default"];
module.exports = exports["default"];
}(lib$3, lib$3.exports));

var Modal = /*@__PURE__*/getDefaultExportFromCjs(lib$3.exports);

var __jsx$N = React.createElement;
var ModalRoot$2 = styled.div.withConfig({
  displayName: "Modal__ModalRoot",
  componentId: "sc-1eoptak-0"
})([""]);
var Root$4 = styled.div.withConfig({
  displayName: "Modal__Root",
  componentId: "sc-1eoptak-1"
})(["width:", ";max-width:", ";height:", ";max-height:", ";position:relative;box-shadow:0px 2px 14px rgba(0,0,0,0.15);border-radius:4px;display:grid;grid-template-columns:1fr;grid-template-rows:auto 1fr;background-color:white;overflow:hidden;"], function (p) {
  return p.width || "100%";
}, function (p) {
  return p.maxWidth || "none";
}, function (p) {
  return p.height || "auto";
}, function (p) {
  return p.maxHeight || "none";
});
var HeaderBody = styled.div.withConfig({
  displayName: "Modal__HeaderBody",
  componentId: "sc-1eoptak-2"
})(["position:relative;", " color:black;"], function (p) {
  return p.headerLine && "border-bottom: 1px solid ".concat(SSColors.black10, ";");
});
var ContentBody = styled.div.withConfig({
  displayName: "Modal__ContentBody",
  componentId: "sc-1eoptak-3"
})(["position:relative;overflow-y:scroll;overflow-x:hidden;"]);
var TitleHeader = styled.div.withConfig({
  displayName: "Modal__TitleHeader",
  componentId: "sc-1eoptak-4"
})(["padding:12px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;"]);
var TitleHeaderLabel = styled.div.withConfig({
  displayName: "Modal__TitleHeaderLabel",
  componentId: "sc-1eoptak-5"
})(["", ";"], SSFonts.label);
var HeaderLetter = styled.div.withConfig({
  displayName: "Modal__HeaderLetter",
  componentId: "sc-1eoptak-6"
})(["width:24px;height:24px;border-radius:4px;background-color:", ";", ";display:flex;justify-content:center;align-items:center;"], SSColors.black10, SSFonts.label3);
var SSModalBody = function SSModalBody(_ref) {
  var onRequestClose = _ref.onRequestClose,
      props = _objectWithoutProperties$2(_ref, ["onRequestClose"]);

  var title = props.title,
      children = props.children,
      _props$headerSymbol = props.headerSymbol,
      headerSymbol = _props$headerSymbol === void 0 ? "close" : _props$headerSymbol;
      props.sidebar;
      var searchProps = props.searchProps;
  return __jsx$N(Root$4, props, __jsx$N(HeaderBody, props, __jsx$N(TitleHeader, null, !searchProps && __jsx$N(TitleHeaderLabel, null, title), searchProps && __jsx$N(SSInputRaw, _extends$b({}, searchProps, {
    autoFocus: true
  })), headerSymbol === "close" && __jsx$N(SSButtonGhost, {
    icon: SSIcons.Close,
    hideLabel: true,
    onClick: function onClick() {
      if (onRequestClose) {
        onRequestClose();
      }
    }
  }, "Close"), headerSymbol && headerSymbol !== "close" && __jsx$N(HeaderLetter, null, headerSymbol))), __jsx$N(ContentBody, props, children));
};
var MODES = {
  "center-small": {
    width: "320px",
    maxHeight: "380px",
    extraClass: ""
  },
  "center-huge": {
    width: "80vw",
    maxWidth: "1200px",
    height: "90vh",
    extraClass: "background-shade"
  }
};
var SSModalContext = /*#__PURE__*/React.createContext(null);
var SSModal = function SSModal(props) {
  var _useContext;

  var isOpen = props.isOpen,
      onRequestClose = props.onRequestClose,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? "center-small" : _props$mode,
      bodyProps = _objectWithoutProperties$2(props, ["isOpen", "onRequestClose", "mode"]);

  var parentSelector = (_useContext = react.exports.useContext(SSModalContext)) !== null && _useContext !== void 0 ? _useContext : function () {
    return document.querySelector("#modalContainer");
  };

  var content = __jsx$N(ModalRoot$2, null, __jsx$N(SSModalBody, _extends$b({}, bodyProps, {
    onRequestClose: onRequestClose
  }, MODES[mode]))); // TODO: here we are introducing a bug. Parent can't change when component is rendered. But here we check the context of parent for styled components.


  var parentNode = parentSelector();

  if (document && document !== parentNode.ownerDocument) {
    content = __jsx$N(ye, {
      target: parentNode.ownerDocument.head
    }, content);
  }

  return __jsx$N(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    parentSelector: parentSelector,
    className: {
      base: "Shopstory__ReactModal__Content",
      afterOpen: "Shopstory__ReactModal__Content--after-open",
      beforeClose: "Shopstory__ReactModal__Content--before-close"
    },
    overlayClassName: {
      base: "Shopstory__ReactModal__Overlay ".concat(MODES[mode].extraClass),
      afterOpen: "Shopstory__ReactModal__Overlay--after-open ".concat(MODES[mode].extraClass),
      beforeClose: "Shopstory__ReactModal__Overlay--before-close ".concat(MODES[mode].extraClass)
    },
    ariaHideApp: false,
    portalClassName: "Shopstory__ReactModalPortal"
  }, content);
};
var sharedContentStyles = "\n    &:focus {\n      border: none;\n      outline: none;\n    }\n";
var SSModalStyles = We([".Shopstory__ReactModal__Overlay{width:100vw;height:100vh;display:flex;justify-content:center;align-items:center;&:before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;opacity:0.2;z-index:-1;}}.Shopstory__ReactModal__Overlay.background-shade{&:before{background-color:black;}}.Shopstory__ReactModal__Content{", "}.Shopstory__ReactModal__Content__Left{", " height:100vh;width:70vw;transition:all 350ms cubic-bezier(0.16,1,0.3,1);transform:translateX(-100%);}.Shopstory__ReactModal__Content__Left.Shopstory__ReactModal__Content__Left--after-open{transform:none;}.Shopstory__ReactModal__Content__Left.Shopstory__ReactModal__Content__Left--before-close{transform:translateX(-100%);}"], sharedContentStyles, sharedContentStyles);

var CustomComponentSymbol = styled.div.withConfig({
  displayName: "CustomComponentSymbol",
  componentId: "sc-vwgh1k-0"
})(["width:6px;height:6px;background:", ";transform:rotate(45deg);"], SSColors.purple);

var __jsx$M = React.createElement;
var Root$3 = styled.div.withConfig({
  displayName: "BasicRow__Root",
  componentId: "sc-omt4xy-0"
})(["position:relative;background-color:white;transition:all 0.1s;padding:12px;&:hover{background-color:", ";}display:flex;flex-direction:row;align-items:center;gap:8px;cursor:pointer;"], SSColors.black5);
var ImageContainer$1 = styled.div.withConfig({
  displayName: "BasicRow__ImageContainer",
  componentId: "sc-omt4xy-1"
})(["position:relative;flex-shrink:0;box-sizing:border-box;background:", ";width:52px;height:52px;pointer-events:none;padding:2px;"], SSColors.black10);
var Image = styled.img.withConfig({
  displayName: "BasicRow__Image",
  componentId: "sc-omt4xy-2"
})(["width:100%;height:100%;object-fit:contain;"]);
var TextContainer = styled.div.withConfig({
  displayName: "BasicRow__TextContainer",
  componentId: "sc-omt4xy-3"
})(["pointer-events:none;"]);
var TitleContainer$1 = styled.div.withConfig({
  displayName: "BasicRow__TitleContainer",
  componentId: "sc-omt4xy-4"
})(["display:flex;flex-direction:row;align-items:center;gap:8px;margin-bottom:4px;"]);
var Title$1 = styled.div.withConfig({
  displayName: "BasicRow__Title",
  componentId: "sc-omt4xy-5"
})(["", ";color:", ";"], SSFonts.label, function (p) {
  return p.custom ? SSColors.purple : "black";
});
var Description = styled.div.withConfig({
  displayName: "BasicRow__Description",
  componentId: "sc-omt4xy-6"
})(["", ";color:", ";"], SSFonts.body, SSColors.black40);
var SSBasicRow = function SSBasicRow(props) {
  return __jsx$M(Root$3, {
    onClick: props.onClick
  }, __jsx$M(ImageContainer$1, props, props.image && __jsx$M(Image, {
    src: props.image
  })), __jsx$M(TextContainer, null, __jsx$M(TitleContainer$1, null, props.custom && __jsx$M(CustomComponentSymbol, null), __jsx$M(Title$1, {
    custom: props.custom
  }, props.title)), __jsx$M(Description, null, props.description)));
};

React.createElement;
styled.button.withConfig({
  displayName: "ItemButton__StyledButton",
  componentId: "sc-1uzquk1-0"
})(["all:unset;box-sizing:border-box;border:none;outline:none;height:28px;padding:0 6px;width:100%;height:100%;display:flex;flex-direction:row;gap:6px;align-items:center;"]);
styled.div.withConfig({
  displayName: "ItemButton__Label",
  componentId: "sc-1uzquk1-1"
})(["", ";"], SSFonts.body);
styled.div.withConfig({
  displayName: "ItemButton__ImageContainer",
  componentId: "sc-1uzquk1-2"
})(["width:16px;height:16px;background-color:magenta;"]);

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';
/** Used as references for various `Number` constants. */

var NAN$1 = 0 / 0;
/** `Object#toString` result references. */

var symbolTag$1 = '[object Symbol]';
/** Used to match leading and trailing whitespace. */

var reTrim$1 = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary$1 = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal$1 = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt$1 = parseInt;
/** Detect free variable `global` from Node.js. */

var freeGlobal$2 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf$2 = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$2 = freeGlobal$2 || freeSelf$2 || Function('return this')();
/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString$5 = objectProto$4.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$2 = Math.max,
    nativeMin$1 = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */

var now = function now() {
  return root$2.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */


function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }

  wait = toNumber$3(wait) || 0;

  if (isObject$4(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$2(toNumber$3(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;
    return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject$4(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike$4(value) {
  return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol$2(value) {
  return typeof value == 'symbol' || isObjectLike$4(value) && objectToString$5.call(value) == symbolTag$1;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */


function toNumber$3(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol$2(value)) {
    return NAN$1;
  }

  if (isObject$4(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$4(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return isBinary || reIsOctal$1.test(value) ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8) : reIsBadHex$1.test(value) ? NAN$1 : +value;
}

var lodash_debounce = debounce$1;

var __jsx$L = React.createElement;

function getProductFromId(id, api) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee(resolve, reject) {
      var cached;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cached = getProductFromCache(id);

              if (cached) {
                resolve(cached);
              }

              api.product(id).then(function (product) {
                resolve(product);
              }, function () {
                reject();
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}

var productCache = {};

function getProductFromCache(id) {
  if (!id) {
    return null;
  }

  if (productCache[id]) {
    return productCache[id];
  }

  return null;
}

function saveProductToCache(product) {
  productCache[product.id] = product;
}

var SSProductPicker = function SSProductPicker(_ref2) {
  var value = _ref2.value,
      onChange = _ref2.onChange,
      api = _ref2.api,
      _ref2$clearable = _ref2.clearable,
      clearable = _ref2$clearable === void 0 ? false : _ref2$clearable;

  var _useState = react.exports.useState(getProductFromCache(value.id)),
      product = _useState[0],
      setProduct = _useState[1];

  var _useState2 = react.exports.useState(false),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = react.exports.useState("unknown"),
      state = _useState3[0],
      setState = _useState3[1];

  function error() {
    setProduct(null);
    setState("error");
  }

  react.exports.useEffect(function () {
    if ((product === null || product === void 0 ? void 0 : product.id) === value.id) {
      return;
    }

    if (!value.id) {
      setProduct(null);
      return;
    }

    var isMounted = true;
    getProductFromId(value.id, api).then(function (product) {
      if (!isMounted) {
        return;
      }

      if (product === null || product === undefined) {
        error();
      } else {
        if (!isMounted) {
          return;
        }

        setProduct(product);
        saveProductToCache(product);
        setState("success");
      }
    }, function () {
      if (!isMounted) {
        return;
      }

      error();
    });
    return function () {
      isMounted = false;
    };
  }, [value]);
  var enhancer;

  if (product) {
    enhancer = __jsx$L("img", {
      src: product.thumbnail,
      style: {
        width: "100%",
        height: "100%",
        objectFit: "contain"
      }
    });
  } else {
    if (state === "loading") {
      enhancer = __jsx$L(LoadingIndicator, null, loadingIcon);
    } else {
      enhancer = __jsx$L("div", {
        style: {
          boxSizing: "border-box",
          width: "100%",
          height: "100%",
          border: "1px solid " + SSColors.black10
        }
      });
    }
  }

  return __jsx$L("div", {
    style: {
      maxWidth: "100%"
    }
  }, state === "error" && __jsx$L(ErrorMessage, null, "Couldn't fetch data for id: ", value.id), __jsx$L("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    }
  }, __jsx$L(SelectedProductButton, {
    variant: "large",
    onClick: function onClick() {
      setOpen(true);
    },
    enhancer: enhancer
  }, product ? __jsx$L(ProductTitle, null, product.title, " ", product.title) : __jsx$L("span", {
    style: {
      color: SSColors.black40
    }
  }, state === "loading" ? "Loading..." : "Pick a product")), product && clearable && __jsx$L(SSButtonGhost, {
    icon: SSIcons.Close,
    hideLabel: true,
    onClick: function onClick() {
      onChange({
        id: null
      });
    }
  }, "Close"), __jsx$L(ItemPickerModal, {
    isOpen: isOpen,
    getItems: api.products,
    onClose: function onClose() {
      setOpen(false);
    },
    onItemPick: function onItemPick(item) {
      onChange({
        id: item.id
      });
    }
  })));
};

function ItemPickerModal(_ref3) {
  var _getProductsRequest$d, _getProductsRequest$d2;

  var isOpen = _ref3.isOpen,
      getItems = _ref3.getItems,
      onClose = _ref3.onClose,
      onItemPick = _ref3.onItemPick;

  var _useState4 = react.exports.useState(""),
      query = _useState4[0],
      setQuery = _useState4[1];

  var previousQuery = react.exports.useRef();

  var _useState5 = react.exports.useState({
    status: "idle",
    data: undefined,
    error: null
  }),
      getProductsRequest = _useState5[0],
      setGetProductsRequest = _useState5[1];

  react.exports.useEffect(function () {
    previousQuery.current = query;
  }, [query]);
  react.exports.useEffect(function () {
    if (!isOpen && query !== "") {
      setQuery("");
    }
  }, [isOpen, query]);
  react.exports.useEffect(function () {
    var loadingTimeoutId;
    var isCanceled = false;
    var debouncedGetProducts = lodash_debounce(function (query) {
      loadingTimeoutId = window.setTimeout(function () {
        setGetProductsRequest({
          status: "loading",
          data: getProductsRequest.data,
          error: null
        });
      }, 1000);
      getItems(query).then(function (products) {
        setGetProductsRequest({
          status: "success",
          data: products,
          error: null
        }); // update cache after every download

        products.forEach(function (product) {
          saveProductToCache(product);
        });
      })["catch"](function (error) {
        setGetProductsRequest({
          status: "error",
          data: undefined,
          error: error
        });
      })["finally"](function () {
        window.clearTimeout(loadingTimeoutId);

        if (isCanceled) {
          return;
        }
      });
    }, 300);
    debouncedGetProducts(query);
    return function () {
      isCanceled = true;

      if (loadingTimeoutId) {
        window.clearTimeout(loadingTimeoutId);
      }

      debouncedGetProducts.cancel();
    };
  }, [query]);
  return isOpen ? __jsx$L(SSModal, {
    mode: "center-small",
    isOpen: true,
    onRequestClose: function onRequestClose() {
      onClose();
    },
    headerLine: true,
    searchProps: {
      placeholder: "Search...",
      onChange: function onChange(e) {
        setQuery(e.target.value);
      }
    },
    headerSymbol: "P"
  }, getProductsRequest.status === "loading" && __jsx$L(LoadingContainer, {
    isEmpty: !Boolean((_getProductsRequest$d = getProductsRequest.data) === null || _getProductsRequest$d === void 0 ? void 0 : _getProductsRequest$d.length)
  }, __jsx$L(ProductsContainer, null, (_getProductsRequest$d2 = getProductsRequest.data) === null || _getProductsRequest$d2 === void 0 ? void 0 : _getProductsRequest$d2.map(function (product) {
    return __jsx$L(SSBasicRow, {
      title: product.title,
      onClick: function onClick() {
        onItemPick(product);
        onClose();
      },
      image: product.thumbnail
    });
  }), __jsx$L(LoadingIndicatorBackdrop, null)), __jsx$L(LoadingIndicatorWrapper, null, __jsx$L(LoadingIndicator, null, loadingIcon))), getProductsRequest.status === "success" && (getProductsRequest.data.length > 0 ? getProductsRequest.data.map(function (product) {
    return __jsx$L(SSBasicRow, {
      key: product.id,
      title: product.title,
      onClick: function onClick() {
        onItemPick(product);
        onClose();
      },
      image: product.thumbnail
    });
  }) : __jsx$L(NoResults, null, "No results")), getProductsRequest.status === "error" && __jsx$L(NoResults, null, "Couldn't fetch data for query \"", previousQuery.current, "\"")) : null;
}

var ErrorMessage = styled.div.withConfig({
  displayName: "ProductPicker__ErrorMessage",
  componentId: "sc-kak0ge-0"
})(["word-break:break-all;white-space:normal;margin-left:4px;", " color:", ";"], SSFonts.body, SSColors.black40);
var LoadingContainer = styled.div.withConfig({
  displayName: "ProductPicker__LoadingContainer",
  componentId: "sc-kak0ge-1"
})(["position:relative;display:flex;flex-direction:column;flex-grow:1;width:100%;", " max-height:331px;"], function (_ref4) {
  var isEmpty = _ref4.isEmpty;
  return isEmpty && Ce(["min-height:72px;"]);
});
var ProductsContainer = styled.div.withConfig({
  displayName: "ProductPicker__ProductsContainer",
  componentId: "sc-kak0ge-2"
})(["width:100%;overflow:hidden;filter:blur(1px);"]);
var LoadingIndicatorBackdrop = styled.div.withConfig({
  displayName: "ProductPicker__LoadingIndicatorBackdrop",
  componentId: "sc-kak0ge-3"
})(["position:absolute;left:0;top:0;width:100%;height:100%;background:#fefefea1;filter:blur(1px);"]);
var LoadingIndicatorWrapper = styled.div.withConfig({
  displayName: "ProductPicker__LoadingIndicatorWrapper",
  componentId: "sc-kak0ge-4"
})(["position:absolute;display:grid;place-items:center;left:0;top:0;width:100%;height:100%;"]);
var rotate = Ue(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var LoadingIndicator = styled.div.withConfig({
  displayName: "ProductPicker__LoadingIndicator",
  componentId: "sc-kak0ge-5"
})(["width:24px;height:24px;font-size:24px;> svg{animation:", " 500ms linear infinite;}"], rotate);
var NoResults = styled.div.withConfig({
  displayName: "ProductPicker__NoResults",
  componentId: "sc-kak0ge-6"
})(["display:grid;place-items:center;height:48px;padding:12px;", ";"], SSFonts.body);
var SelectedProductButton = styled(SSButtonGhost).withConfig({
  displayName: "ProductPicker__SelectedProductButton",
  componentId: "sc-kak0ge-7"
})(["overflow:hidden;"]);
var ProductTitle = styled.span.withConfig({
  displayName: "ProductPicker__ProductTitle",
  componentId: "sc-kak0ge-8"
})(["overflow:hidden;text-overflow:ellipsis;"]);

var loadingIcon = __jsx$L("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx$L("path", {
  d: "M4.5 12.5C4.5 16.9183 8.08172 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5",
  stroke: "currentColor",
  strokeWidth: 1.2
}));

var __jsx$K = React.createElement;
var trackHeight = "1px";
var thumbSize = "11px";
var thumbRadius = "50%";
var trackColor = SSColors.black10;
var trackColorHover = "black";
var thumbColor = "black";
var Root$2 = styled.div.withConfig({
  displayName: "Slider__Root",
  componentId: "sc-9t39p0-0"
})(["input[type=\"range\"]{width:100%;margin:5px 0;height:20px;-webkit-appearance:none;cursor:pointer;}input[type=\"range\"]:focus{outline:none;}input[type=\"range\"]::-webkit-slider-runnable-track{background:", ";border:0;width:100%;height:", ";transition:all 0.1s;}input[type=\"range\"]::-webkit-slider-thumb{margin-top:-5px;width:", ";height:", ";border-radius:", ";background:", ";-webkit-appearance:none;}input[type=\"range\"]:focus::-webkit-slider-runnable-track{background:", ";}input[type=\"range\"]:hover::-webkit-slider-runnable-track{background:", ";}input[type=\"range\"]::-moz-range-track{background:", ";border:0;width:100%;height:", ";transition:all 0.1s;}input[type=\"range\"]::-moz-range-thumb{width:", ";height:", ";border-radius:", ";background:", ";border:none;}input[type=\"range\"]:hover::-moz-range-track{background:", ";}input[type=\"range\"]::-ms-track{background:transparent;border-color:transparent;border-width:0px 0;color:transparent;width:100%;height:", ";}input[type=\"range\"]::-ms-fill-lower{background:#000080;border:0;}input[type=\"range\"]::-ms-fill-upper{background:", ";border:0;}input[type=\"range\"]::-ms-thumb{width:", ";height:", ";border-radius:", ";background:", ";margin-top:0px;}input[type=\"range\"]:focus::-ms-fill-lower{background:", ";}input[type=\"range\"]:focus::-ms-fill-upper{background:", ";}"], trackColor, trackHeight, thumbSize, thumbSize, thumbRadius, thumbColor, trackColor, trackColorHover, trackColor, trackHeight, thumbSize, thumbSize, thumbRadius, thumbColor, trackColorHover, trackHeight, trackColor, thumbSize, thumbSize, thumbRadius, thumbColor, trackColor, trackColor);
var SliderStyled = styled.input.withConfig({
  displayName: "Slider__SliderStyled",
  componentId: "sc-9t39p0-1"
})([""]);
var SSRangeSlider = function SSRangeSlider(props) {
  return __jsx$K(Root$2, null, __jsx$K(SliderStyled, _extends$b({}, props, {
    type: "range"
  })));
};

var __jsx$J = React.createElement;

var Typography = function Typography(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? "div" : _ref$component,
      color = _ref.color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "body" : _ref$variant,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? "left" : _ref$align,
      restProps = _objectWithoutProperties$2(_ref, ["children", "className", "component", "color", "variant", "align"]);

  return __jsx$J(TypographyRoot, _extends$b({
    as: Component,
    className: className,
    variant: variant,
    color: color,
    align: align
  }, restProps), children);
};

// Why use `div` as the default text tag?
// 1. We mostly stack up lines of text so it's natural for typography component to be block element
// 2. We can easily put other `Typography` components within. Why does it matter?
//    Imagine we want to only bold a fragment of text so we use `Typography` as the child of `Typography`.
//    If we would use `p` as the default, there are restricted tags that can be placed within
//    and maybe you would remember about that to change tag of outer `Typography` component
//    or maybe you would get warning from React about incorrect nesting of HTML elements.
//    By using the `div` as the default, you don't have to worry about it.
var TypographyRoot = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidator) {
    // Don't forward `color` prop to host element since it's our custom prop, not native one.
    return !["color"].includes(prop) && defaultValidator(prop);
  }
}).withConfig({
  displayName: "Typography__TypographyRoot",
  componentId: "sc-12wdyy-0"
})(["color:", ";", " text-align:", ";overflow:hidden;text-overflow:ellipsis;"], function (_ref2) {
  var color = _ref2.color;
  return color !== undefined ? SSColors[color] : "black";
}, function (_ref3) {
  var variant = _ref3.variant;
  return SSFonts[variant];
}, function (_ref4) {
  var align = _ref4.align;
  return align;
});

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == "x" ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
var uniqueId = uuidv4;

function splitTemplateName(templateName) {
  var _templateName$split = templateName.split("$$$"),
      _templateName$split2 = _slicedToArray$2(_templateName$split, 2),
      name = _templateName$split2[0],
      ref = _templateName$split2[1];

  if (!ref) {
    return {
      name: name
    };
  }

  var refSplit = ref.split("local.");

  if (refSplit.length > 1) {
    return {
      name: name,
      ref: refSplit[1],
      isRefLocal: true
    };
  }

  return {
    name: name,
    ref: ref,
    isRefLocal: false
  };
}

function allDefs(context) {
  var _context$definitions$;

  return [].concat(_toConsumableArray$2((context === null || context === void 0 ? void 0 : context.definitions.components) || []), _toConsumableArray$2((context === null || context === void 0 ? void 0 : context.definitions.links) || []), _toConsumableArray$2((context === null || context === void 0 ? void 0 : context.definitions.actions) || []), _toConsumableArray$2((_context$definitions$ = context === null || context === void 0 ? void 0 : context.definitions.textModifiers) !== null && _context$definitions$ !== void 0 ? _context$definitions$ : []));
}
/**
 * Versions with context and custom components sweep
 */


function findComponentDefinition(config, context) {
  return $findComponentDefinition(config, context);
}
function findComponentDefinitionById(id, context) {
  return $findComponentDefinitionById(id, context);
}
/**
 * Generic
 */

function $findComponentDefinition(config, context) {
  if (!config) {
    return undefined;
  }

  return $findComponentDefinitionById(config._template, context);
}

function $findComponentDefinitionById(id, context) {
  return allDefs(context).find(function (component) {
    return component.id === splitTemplateName(id).name;
  });
}

function isSchemaPropComponentCollectionLocalised(schemaProp) {
  return schemaProp.type === "component-collection-localised";
}
function isSchemaPropCollection(schemaProp) {
  return schemaProp.type === "component-collection" || schemaProp.type === "component-collection-localised";
}
function isSchemaPropComponent(schemaProp) {
  return schemaProp.type === "component" || schemaProp.type === "component-fixed";
}
function isSchemaPropComponentOrComponentCollection(schemaProp) {
  return isSchemaPropCollection(schemaProp) || isSchemaPropComponent(schemaProp);
}
function isSchemaPropAction(schemaProp) {
  var _componentTypes, _componentTypes2;

  return schemaProp.type === "component" && (((_componentTypes = schemaProp.componentTypes) === null || _componentTypes === void 0 ? void 0 : _componentTypes.includes("action")) || ((_componentTypes2 = schemaProp.componentTypes) === null || _componentTypes2 === void 0 ? void 0 : _componentTypes2.includes("actionLink")));
}
function isSchemaPropActionTextModifier(schemaProp) {
  return schemaProp.type === "component" && schemaProp.componentTypes.includes("actionTextModifier");
}
function isSchemaPropTextModifier(schemaProp) {
  return schemaProp.type === "component" && schemaProp.componentTypes.includes("textModifier");
}
function isResourceSchemaProp(schemaProp) {
  var nonExternal = ["string", "string$", "number", "boolean", "boolean$", "select", "select$", "radio-group", "radio-group$", "color", "stringToken", "space", "font", "icon", "component", "component-collection", "component-fixed", "component-collection-localised"];
  return !nonExternal.includes(schemaProp.type);
}
function isSchemaPropTokenized(schemaProp) {
  return schemaProp.type === "color" || schemaProp.type === "space" || schemaProp.type === "font" || schemaProp.type === "stringToken";
}

/**
 * Traverses given `config` by invoking given `callback` for each schema prop defined within components from `context`
 */
function traverseComponents(config, context, callback) {
  traverseComponentsInternal(config, context, callback, "");
}

function traverseComponentsArray(array, context, callback, path) {
  array.forEach(function (config, index) {
    traverseComponentsInternal(config, context, callback, "".concat(path, ".").concat(index));
  });
}

function traverseComponentsInternal(componentConfig, context, callback, path) {
  var componentDefinition = findComponentDefinition(componentConfig, context);

  if (!componentDefinition) {
    console.warn("[traverseComponents] Unknown component definition", componentConfig);
    return;
  }

  var pathPrefix = path === "" ? "" : path + ".";
  callback({
    componentConfig: componentConfig,
    path: path
  });
  componentDefinition.schema.forEach(function (schemaProp) {
    if (isSchemaPropComponent(schemaProp) || schemaProp.type === "component-collection") {
      traverseComponentsArray(componentConfig[schemaProp.prop], context, callback, "".concat(pathPrefix).concat(schemaProp.prop));
    } else if (schemaProp.type === "component-collection-localised") {
      for (var locale in componentConfig[schemaProp.prop]) {
        traverseComponentsArray(componentConfig[schemaProp.prop][locale], context, callback, "".concat(pathPrefix).concat(schemaProp.prop, ".").concat(locale));
      }
    }
  });
}

var dist$2 = {};

var utils$k = {};

var splitConfigs = {};

var getFallbackForLocale$2 = {};

var getFallbackLocaleForLocale$2 = {};

var getDefaultLocale$2 = {};

Object.defineProperty(getDefaultLocale$2, "__esModule", {
  value: true
});
getDefaultLocale$2.getDefaultLocale = void 0;

function getDefaultLocale$1(locales) {
  return locales.find(function (locale) {
    return locale.isDefault;
  });
}

getDefaultLocale$2.getDefaultLocale = getDefaultLocale$1;

Object.defineProperty(getFallbackLocaleForLocale$2, "__esModule", {
  value: true
});
getFallbackLocaleForLocale$2.getFallbackLocaleForLocale = void 0;

var getDefaultLocale_1 = getDefaultLocale$2;

function getFallbackLocaleForLocale$1(locale, locales) {
  var _a, _b;

  do {
    var fallbackId = (_b = (_a = locales.find(function (l) {
      return l.code === locale;
    })) === null || _a === void 0 ? void 0 : _a.fallback) !== null && _b !== void 0 ? _b : (0, getDefaultLocale_1.getDefaultLocale)(locales).code; // Default locale, no fallback

    if (fallbackId === locale) {
      return;
    }

    return fallbackId;
  } while (true);
}

getFallbackLocaleForLocale$2.getFallbackLocaleForLocale = getFallbackLocaleForLocale$1;

Object.defineProperty(getFallbackForLocale$2, "__esModule", {
  value: true
});
getFallbackForLocale$2.getFallbackForLocale = void 0;

var getFallbackLocaleForLocale_1 = getFallbackLocaleForLocale$2;

function getFallbackForLocale$1(translatedValues, locale, locales) {
  while (true) {
    var fallbackLocale = (0, getFallbackLocaleForLocale_1.getFallbackLocaleForLocale)(locale, locales);

    if (!fallbackLocale) {
      return;
    }

    var fallbackValue = translatedValues[fallbackLocale];

    if (fallbackValue !== undefined && fallbackValue !== null) {
      return fallbackValue;
    }

    locale = fallbackLocale;
  }
}

getFallbackForLocale$2.getFallbackForLocale = getFallbackForLocale$1;

Object.defineProperty(splitConfigs, "__esModule", {
  value: true
});
splitConfigs.splitConfigIntoSingleLocaleConfigs = void 0;

var getFallbackForLocale_1 = getFallbackForLocale$2;

function isLocalizedText(configComponent) {
  var _a;

  var LOCAL_PREFIX = "local.";
  return ((_a = configComponent === null || configComponent === void 0 ? void 0 : configComponent.id) !== null && _a !== void 0 ? _a : "").startsWith(LOCAL_PREFIX);
}

function extractSingleLocaleConfigs(configComponent, localeCode, locales) {
  var _a, _b, _c, _d;

  var _e;

  if (configComponent === null) {
    return;
  }

  if (typeof configComponent !== "object") {
    return configComponent;
  }

  if (Array.isArray(configComponent)) {
    return configComponent.map(function (value) {
      return extractSingleLocaleConfigs(value, localeCode, locales);
    });
  }

  if (configComponent.__localized !== true) {
    return Object.fromEntries(Object.entries(configComponent).map(function (_a) {
      var key = _a[0],
          value = _a[1];
      return [key, extractSingleLocaleConfigs(value, localeCode, locales)];
    }));
  }

  if (isLocalizedText(configComponent)) {
    var stringValue = (_e = configComponent === null || configComponent === void 0 ? void 0 : configComponent.value) === null || _e === void 0 ? void 0 : _e[localeCode];

    if (stringValue === null || stringValue === undefined) {
      return {
        id: configComponent.id,
        value: (_a = {}, _a[localeCode] = (0, getFallbackForLocale_1.getFallbackForLocale)(configComponent.value, localeCode, locales), _a.__fallback = true, _a)
      };
    } else {
      return {
        id: configComponent.id,
        value: (_b = {}, _b[localeCode] = stringValue, _b)
      };
    }
  }

  var localeCollection = configComponent[localeCode];

  if (localeCollection) {
    return _c = {}, _c[localeCode] = extractSingleLocaleConfigs(localeCollection, localeCode, locales), _c;
  } else {
    return _d = {}, _d[localeCode] = (0, getFallbackForLocale_1.getFallbackForLocale)(configComponent, localeCode, locales), _d.__fallback = true, _d;
  }
}
/**
 * Our Editor always works with one Config where each text is represented by localized object like:
 *
 * {
 *  en: "Hello",
 *  pl: "Dzień dobry",
 *  de: "Halo"
 * }
 *
 * This is easy for us to manage, however this is not a good format for API output, because you never really render all the langauges at once so providing all the langauges is hugely redundant.
 *
 * That's why when we save to the CMS, we save separate configs for each language with ONLY THIS LANGUAGE in texts.
 *
 * So English will have texts like { en: "Hello" } and Polish will have { de: "Dzień dobry" }, etc.
 *
 * Those single-locale configs saved in CMS have a name: SingleLocaleConfig.
 *
 */


function splitConfigIntoSingleLocaleConfigs(config, locales) {
  var localisedConfigs = {};
  locales.forEach(function (locale) {
    localisedConfigs[locale.code] = extractSingleLocaleConfigs(config, locale.code, locales);
  });
  return localisedConfigs;
}

splitConfigs.splitConfigIntoSingleLocaleConfigs = splitConfigIntoSingleLocaleConfigs;

(function (exports) {

var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

__exportStar(splitConfigs, exports);
}(utils$k));

var types = {};

var ConfigComponent = {};

Object.defineProperty(ConfigComponent, "__esModule", {
  value: true
});

var ConfigComponentIdentifier = {};

Object.defineProperty(ConfigComponentIdentifier, "__esModule", {
  value: true
});
ConfigComponentIdentifier.isComponentConfigIdentifier = void 0;

function isComponentConfigIdentifier(value) {
  var isNotNull = typeof value !== null;
  var isObject = typeof value === "object";
  var idIsAString = typeof (value === null || value === void 0 ? void 0 : value.id) === "string";
  return isNotNull && isObject && idIsAString;
}

ConfigComponentIdentifier.isComponentConfigIdentifier = isComponentConfigIdentifier;

var ConfigModel = {};

Object.defineProperty(ConfigModel, "__esModule", {
  value: true
});

var ConfigOrConfigArray = {};

Object.defineProperty(ConfigOrConfigArray, "__esModule", {
  value: true
});

var ContentPiece = {};

Object.defineProperty(ContentPiece, "__esModule", {
  value: true
});
ContentPiece.isContentPieceFull = ContentPiece.isContentPieceLocal = ContentPiece.isContentPieceRemote = ContentPiece.isContentPiece = void 0;
/**
 * @deprecated
 */

var isContentPieceRemote = function isContentPieceRemote(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 2 && "id" in value && "hash" in value;
};

ContentPiece.isContentPieceRemote = isContentPieceRemote;
/**
 * @deprecated
 */

var isContentPieceLocal = function isContentPieceLocal(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 1 && "config" in value;
};

ContentPiece.isContentPieceLocal = isContentPieceLocal;
/**
 * @deprecated
 */

var isContentPieceFull = function isContentPieceFull(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 3 && "id" in value && "hash" in value && "config" in value;
};

ContentPiece.isContentPieceFull = isContentPieceFull;
/**
 * @deprecated
 */

var isContentPiece = function isContentPiece(value) {
  return isContentPieceRemote(value) || isContentPieceLocal(value) || isContentPieceFull(value);
};

ContentPiece.isContentPiece = isContentPiece;

var Locale = {};

Object.defineProperty(Locale, "__esModule", {
  value: true
});

var RawContent = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRawContent = exports.isRawContentFull = exports.isRawContentLocal = exports.isRawContentRemote = void 0;

var isRawContentRemote = function isRawContentRemote(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 2 && "id" in value && "hash" in value;
};

exports.isRawContentRemote = isRawContentRemote;

var isRawContentLocal = function isRawContentLocal(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 1 && "content" in value;
};

exports.isRawContentLocal = isRawContentLocal;

var isRawContentFull = function isRawContentFull(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 3 && "id" in value && "hash" in value && "content" in value;
};

exports.isRawContentFull = isRawContentFull;

var isRawContent = function isRawContent(value) {
  return (0, exports.isRawContentRemote)(value) || (0, exports.isRawContentLocal)(value) || (0, exports.isRawContentFull)(value);
};

exports.isRawContent = isRawContent;
}(RawContent));

(function (exports) {

var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

__exportStar(ConfigComponent, exports);

__exportStar(ConfigComponentIdentifier, exports);

__exportStar(ConfigModel, exports);

__exportStar(ConfigOrConfigArray, exports);

__exportStar(ContentPiece, exports);

__exportStar(Locale, exports);

__exportStar(RawContent, exports);
}(types));

var objects = {};

var objectMap$1 = {};

Object.defineProperty(objectMap$1, "__esModule", {
  value: true
});
objectMap$1.objectMap = void 0;

function objectMap(o, callback) {
  return Object.fromEntries(objectMapInternal(o, callback));
}

objectMap$1.objectMap = objectMap;

function objectMapInternal(o, callback) {
  return Object.entries(o).map(function (entry) {
    if (typeof entry[1] === "object") {
      if (entry[1] === null) {
        return callback(entry);
      }

      if (Array.isArray(entry[1])) {
        return callback([entry[0], entry[1].map(function (value) {
          return typeof value === "object" ? Object.fromEntries(objectMapInternal(value, callback)) : value;
        })]);
      }

      return callback([entry[0], Object.fromEntries(objectMapInternal(entry[1], callback))]);
    }

    return callback(entry);
  });
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objectMap = void 0;

var objectMap_1 = objectMap$1;

Object.defineProperty(exports, "objectMap", {
  enumerable: true,
  get: function get() {
    return objectMap_1.objectMap;
  }
});
}(objects));

(function (exports) {

var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

__exportStar(utils$k, exports);

__exportStar(types, exports);

__exportStar(objects, exports);
}(dist$2));

/**
 * Traverses given `config` by invoking given `callback` for each schema prop defined within components from `context`
 */
function configTraverse(config, context, callback) {
  configTraverseInternal(config, context, callback, "");
}

function configTraverseArray(array, context, callback, path) {
  array.forEach(function (config, index) {
    configTraverseInternal(config, context, callback, "".concat(path, ".").concat(index));
  });
}

function configTraverseInternal(config, context, callback, path) {
  var componentDefinition = findComponentDefinition(config, context);

  if (!componentDefinition) {
    console.warn("[configTraverse] Unknown component definition for: ".concat(config._template));
    return;
  }

  var pathPrefix = path === "" ? "" : path + ".";
  componentDefinition.schema.forEach(function (schemaProp) {
    if (isSchemaPropComponent(schemaProp) || schemaProp.type === "component-collection") {
      callback({
        value: config[schemaProp.prop],
        path: "".concat(pathPrefix).concat(schemaProp.prop),
        schemaProp: schemaProp
      });
      configTraverseArray(config[schemaProp.prop], context, callback, "".concat(pathPrefix).concat(schemaProp.prop));
    } else if (schemaProp.type === "component-collection-localised") {
      callback({
        value: config[schemaProp.prop],
        path: "".concat(pathPrefix).concat(schemaProp.prop),
        schemaProp: schemaProp
      });

      for (var locale in config[schemaProp.prop]) {
        configTraverseArray(config[schemaProp.prop][locale], context, callback, "".concat(pathPrefix).concat(schemaProp.prop, ".").concat(locale));
      }
    } else {
      var currentPath = "".concat(pathPrefix).concat(schemaProp.prop);
      callback({
        path: currentPath,
        value: config[schemaProp.prop],
        schemaProp: schemaProp
      });
    }
  });
}

function configFindAllPaths(config, editorContext, predicate) {
  var matchedConfigPaths = [];
  traverseComponents(config, editorContext, function (_ref) {
    var path = _ref.path,
        componentConfig = _ref.componentConfig;

    if (predicate(componentConfig, editorContext)) {
      matchedConfigPaths.push(path);
    }
  });
  return matchedConfigPaths;
}

function deepClone(source) {
  return JSON.parse(JSON.stringify(source));
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';
/** Used as the internal argument placeholder. */

var PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */

var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_BOUND_FLAG = 4,
    CURRY_FLAG = 8,
    CURRY_RIGHT_FLAG = 16,
    PARTIAL_FLAG = 32,
    PARTIAL_RIGHT_FLAG = 64,
    ARY_FLAG = 128,
    REARG_FLAG = 256,
    FLIP_FLAG = 512;
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER$1 = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;
/** Used to associate wrap methods with their bit flags. */

var wrapFlags = [['ary', ARY_FLAG], ['bind', BIND_FLAG], ['bindKey', BIND_KEY_FLAG], ['curry', CURRY_FLAG], ['curryRight', CURRY_RIGHT_FLAG], ['flip', FLIP_FLAG], ['partial', PARTIAL_FLAG], ['partialRight', PARTIAL_RIGHT_FLAG], ['rearg', REARG_FLAG]];
/** `Object#toString` result references. */

var funcTag$1 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match leading and trailing whitespace. */

var reTrim = /^\s+|\s+$/g;
/** Used to match wrap detail comments. */

var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$2(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */


function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */


function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }

  return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }

  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }

  return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */


function baseIsNaN(value) {
  return value !== value;
}
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */


function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      result++;
    }
  }

  return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */


function getValue$2(object, key) {
  return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */


function isHostObject$1(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;

  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }

  return result;
}
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */


function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }

  return result;
}
/** Used for built-in method references. */


var funcProto$1 = Function.prototype,
    objectProto$3 = Object.prototype;
/** Used to detect overreaching core-js shims. */

var coreJsData = root$1['__core-js_shared__'];
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */


var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString$4 = objectProto$3.toString;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */

var objectCreate = Object.create;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$1 = Math.max,
    nativeMin = Math.min;
/* Used to set `toString` methods. */

var defineProperty$1 = function () {
  var func = getNative(Object, 'defineProperty'),
      name = getNative.name;
  return name && name.length > 2 ? func : undefined;
}();
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */


function baseCreate(proto) {
  return isObject$3(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */


function baseIsNative(value) {
  if (!isObject$3(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction$2(value) || isHostObject$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */


function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax$1(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }

  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }

  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }

  return result;
}
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */


function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax$1(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }

  var offset = argsIndex;

  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }

  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }

  return result;
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */


function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */


function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = this && this !== root$1 && this instanceof wrapper ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }

  return wrapper;
}
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */


function createCtor(Ctor) {
  return function () {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;

    switch (args.length) {
      case 0:
        return new Ctor();

      case 1:
        return new Ctor(args[0]);

      case 2:
        return new Ctor(args[0], args[1]);

      case 3:
        return new Ctor(args[0], args[1], args[2]);

      case 4:
        return new Ctor(args[0], args[1], args[2], args[3]);

      case 5:
        return new Ctor(args[0], args[1], args[2], args[3], args[4]);

      case 6:
        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);

      case 7:
        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }

    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args); // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.

    return isObject$3(result) ? result : thisBinding;
  };
}
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */


function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }

    var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
    length -= holders.length;

    if (length < arity) {
      return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
    }

    var fn = this && this !== root$1 && this instanceof wrapper ? Ctor : func;
    return apply$2(fn, this, args);
  }

  return wrapper;
}
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */


function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & ARY_FLAG,
      isBind = bitmask & BIND_FLAG,
      isBindKey = bitmask & BIND_KEY_FLAG,
      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
      isFlip = bitmask & FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }

    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }

    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }

    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }

    length -= holdersCount;

    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
    }

    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;
    length = args.length;

    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }

    if (isAry && ary < length) {
      args.length = ary;
    }

    if (this && this !== root$1 && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }

    return fn.apply(thisBinding, args);
  }

  return wrapper;
}
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */


function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = this && this !== root$1 && this instanceof wrapper ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }

    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }

    return apply$2(fn, isBind ? thisArg : this, args);
  }

  return wrapper;
}
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */


function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;
  bitmask |= isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG;
  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

  if (!(bitmask & CURRY_BOUND_FLAG)) {
    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
  }

  var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *  The bitmask may be composed of the following flags:
 *     1 - `_.bind`
 *     2 - `_.bindKey`
 *     4 - `_.curry` or `_.curryRight` of a bound function
 *     8 - `_.curry`
 *    16 - `_.curryRight`
 *    32 - `_.partial`
 *    64 - `_.partialRight`
 *   128 - `_.rearg`
 *   256 - `_.ary`
 *   512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */


function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & BIND_KEY_FLAG;

  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }

  var length = partials ? partials.length : 0;

  if (!length) {
    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }

  ary = ary === undefined ? ary : nativeMax$1(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;
    partials = holders = undefined;
  }

  var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] == null ? isBindKey ? 0 : func.length : nativeMax$1(newData[9] - length, 0);

  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
  }

  if (!bitmask || bitmask == BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }

  return setWrapToString(result, func, bitmask);
}
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */


function getHolder(func) {
  var object = func;
  return object.placeholder;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue$2(object, key);
  return baseIsNative(value) ? value : undefined;
}
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */


function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */


function insertWrapDetails(source, details) {
  var length = details.length,
      lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */


function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */


function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }

  return array;
}
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */


var setWrapToString = !defineProperty$1 ? identity : function (wrapper, reference, bitmask) {
  var source = reference + '';
  return defineProperty$1(wrapper, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
  });
};
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */


function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function (pair) {
    var value = '_.' + pair[0];

    if (bitmask & pair[1] && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */


function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */


function isFunction$2(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject$3(value) ? objectToString$4.call(value) : '';
  return tag == funcTag$1 || tag == genTag$1;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject$3(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike$3(value) {
  return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol$1(value) {
  return typeof value == 'symbol' || isObjectLike$3(value) && objectToString$4.call(value) == symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */


function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }

  value = toNumber$2(value);

  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }

  return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */


function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */


function toNumber$2(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol$1(value)) {
    return NAN;
  }

  if (isObject$3(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$3(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */


function constant(value) {
  return function () {
    return value;
  };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */


function identity(value) {
  return value;
} // Assign default placeholders.


curry.placeholder = {};
var lodash_curry = curry;

function trace(source, sink, event) {
  var _source$tracing = source.tracing;
  _source$tracing = _source$tracing === void 0 ? {} : _source$tracing;
  var traceClicks = _source$tracing.traceClicks,
      traceImpressions = _source$tracing.traceImpressions,
      traceId = _source$tracing.traceId,
      _source$tracing$type = _source$tracing.type,
      type = _source$tracing$type === void 0 ? "item" : _source$tracing$type;

  if (event === "click" && !traceClicks) {
    return;
  }

  if (event === "impression" && !traceImpressions) {
    return;
  }

  var isCustomComponent = !source._template.startsWith("$");
  sink({
    event: event,
    source: {
      traceId: traceId,
      type: type,
      props: isCustomComponent ? source.props : undefined,
      component: isCustomComponent ? source._template : undefined
    }
  });
}

lodash_curry(trace);

function generateDefaultTraceId(config) {
  return "".concat(config._template, "-").concat(uniqueId().slice(0, 8));
}

React.createElement;

function traceIdSchemaProp() {
  return {
    prop: "traceId",
    type: "string",
    label: "Trace Id",
    group: "Analytics",
    normalize: function normalize(x) {
      if (x.trim() === "") {
        return null;
      }

      return x;
    }
  };
}

function traceClicksSchemaProp() {
  return {
    prop: "traceClicks",
    type: "boolean",
    label: "Trace clicks",
    group: "Analytics",
    visible: function visible(values) {
      if (values.noAction) {
        return false;
      }

      if (Array.isArray(values.action)) {
        return true;
      }

      return false;
    }
  };
}

function traceImpressionsSchemaProp() {
  return {
    prop: "traceImpressions",
    type: "boolean",
    label: "Trace Impressions",
    group: "Analytics"
  };
}

var hasSchema = function hasSchema(definition, schemaProp) {
  return definition.schema.some(function (_ref) {
    var prop = _ref.prop;
    return prop === schemaProp.prop;
  });
};

function addTracingSchema(definition) {
  if (definition.tags.includes("notrace")) {
    return definition;
  }

  var traceIdProp = traceIdSchemaProp();

  if (!hasSchema(definition, traceIdProp)) {
    definition.schema.push(traceIdProp);
  }

  var traceImpressionsSchemaPropInstance = traceImpressionsSchemaProp();

  if (!hasSchema(definition, traceImpressionsSchemaPropInstance)) {
    definition.schema.push(traceImpressionsSchemaPropInstance);
  }

  var traceClicksSchemaPropInstance = traceClicksSchemaProp();

  if (!hasSchema(definition, traceClicksSchemaPropInstance)) {
    definition.schema.push(traceClicksSchemaPropInstance);
  }

  return definition;
}

var isTracingSchemaProp = function isTracingSchemaProp(prop) {
  return prop === "traceId" || prop === "traceClicks" || prop === "traceImpressions";
};

function duplicateConfig(inputConfig, compilationContext) {
  // deep copy first
  var config = deepClone(inputConfig); // refresh component ids and traceIds

  traverseComponents(config, compilationContext, function (_ref) {
    var componentConfig = _ref.componentConfig;
    componentConfig._id = uniqueId();
    componentConfig.traceId = generateDefaultTraceId(componentConfig);
  }); // every text must get new local id

  configTraverse(config, compilationContext, function (_ref2) {
    var value = _ref2.value,
        schemaProp = _ref2.schemaProp;

    if (schemaProp.type === "text") {
      value.id = "local." + uniqueId();
    }
  });
  return config;
}

function ownKeys$1b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1b(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var buttonActionSchemaProp = {
  prop: "action",
  label: "Action",
  type: "component",
  // for now actions are components
  componentTypes: ["action"],
  visible: true,
  group: "Action",
  defaultValue: [],
  isLabelHidden: true
};
var buttonLabelSchemaProp = {
  prop: "label",
  type: "text",
  label: "Label",
  group: "Properties",
  normalize: function normalize(x) {
    if (x.trim() === "") {
      return null;
    }

    return x;
  }
};
var buttonOptionalIconSchemaProp = {
  prop: "symbol",
  label: "Symbol",
  type: "component",
  componentTypes: ["symbol"],
  visible: true,
  group: "Properties"
};
var buttonRequiredIconSchemaProp = _objectSpread$1a(_objectSpread$1a({}, buttonOptionalIconSchemaProp), {}, {
  required: true
});

function ownKeys$1a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$19(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1a(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var richTextInlineWrapperActionSchemaProp = _objectSpread$19(_objectSpread$19({}, buttonActionSchemaProp), {}, {
  componentTypes: ["action"],
  label: "Link"
});

/**
 * This is a copy of validate-color function from validate-color npm package. This package has problem with bundling, so I copied it here. It was modified 100 years ago anyway and had 32 stars, so nothing fancy really.
 */
// Good article on HTML Colors:
// https://dev.to/alvaromontoro/the-ultimate-guide-to-css-colors-2020-edition-1bh1#hsl
// Check if parameter is defined and a string
var isString$3 = function isString(color) {
  return color && typeof color === "string";
}; // All existing HTML color names


var htmlColorNames = ["AliceBlue", "AntiqueWhite", "Aqua", "Aquamarine", "Azure", "Beige", "Bisque", "Black", "BlanchedAlmond", "Blue", "BlueViolet", "Brown", "BurlyWood", "CadetBlue", "Chartreuse", "Chocolate", "Coral", "CornflowerBlue", "Cornsilk", "Crimson", "Cyan", "DarkBlue", "DarkCyan", "DarkGoldenrod", "DarkGray", "DarkGreen", "DarkKhaki", "DarkMagenta", "DarkOliveGreen", "DarkOrange", "DarkOrchid", "DarkRed", "DarkSalmon", "DarkSeaGreen", "DarkSlateBlue", "DarkSlateGray", "DarkTurquoise", "DarkViolet", "DeepPink", "DeepSkyBlue", "DimGray", "DodgerBlue", "FireBrick", "FloralWhite", "ForestGreen", "Fuchsia", "Gainsboro", "GhostWhite", "Gold", "Goldenrod", "Gray", "Green", "GreenYellow", "HoneyDew", "HotPink", "IndianRed", "Indigo", "Ivory", "Khaki", "Lavender", "LavenderBlush", "LawnGreen", "LemonChiffon", "LightBlue", "LightCoral", "LightCyan", "LightGoldenrodYellow", "LightGray", "LightGreen", "LightPink", "LightSalmon", "LightSalmon", "LightSeaGreen", "LightSkyBlue", "LightSlateGray", "LightSteelBlue", "LightYellow", "Lime", "LimeGreen", "Linen", "Magenta", "Maroon", "MediumAquamarine", "MediumBlue", "MediumOrchid", "MediumPurple", "MediumSeaGreen", "MediumSlateBlue", "MediumSlateBlue", "MediumSpringGreen", "MediumTurquoise", "MediumVioletRed", "MidnightBlue", "MintCream", "MistyRose", "Moccasin", "NavajoWhite", "Navy", "OldLace", "Olive", "OliveDrab", "Orange", "OrangeRed", "Orchid", "PaleGoldenrod", "PaleGreen", "PaleTurquoise", "PaleVioletRed", "PapayaWhip", "PeachPuff", "Peru", "Pink", "Plum", "PowderBlue", "Purple", "RebeccaPurple", "Red", "RosyBrown", "RoyalBlue", "SaddleBrown", "Salmon", "SandyBrown", "SeaGreen", "SeaShell", "Sienna", "Silver", "SkyBlue", "SlateBlue", "SlateGray", "Snow", "SpringGreen", "SteelBlue", "Tan", "Teal", "Thistle", "Tomato", "Turquoise", "Violet", "Wheat", "White", "WhiteSmoke", "Yellow", "YellowGreen"]; // These 3 values are valid, usable color names, which are special in their own way

var htmlColorNamesSpecial = ["currentColor", "inherit", "transparent"]; // Validate HTML color name (red, yellow, etc)

var validateHTMLColorName = function validateHTMLColorName(color) {
  var status = false;

  if (isString$3(color)) {
    htmlColorNames.map(function (c) {
      if (color.toLowerCase() === c.toLowerCase()) {
        status = true;
      }

      return null;
    });
  }

  return status;
}; // Validate HTML color special name (currentColor, inherit, etc)

var validateHTMLColorSpecialName = function validateHTMLColorSpecialName(color) {
  var status = false;

  if (isString$3(color)) {
    htmlColorNamesSpecial.map(function (c) {
      if (color.toLowerCase() === c.toLowerCase()) {
        status = true;
      }

      return null;
    });
  }

  return status;
}; // Validate HTML color 'hex'

var validateHTMLColorHex = function validateHTMLColorHex(color) {
  if (isString$3(color)) {
    var regex = /^#([\da-f]{3}){1,2}$|^#([\da-f]{4}){1,2}$/i;
    return !!color && regex.test(color);
  }

  return false;
}; // Validate HTML color 'rgb'
// -- legacy notation
// color: rgb(255, 255, 255);
// color: rgba(255, 255, 255, 1);
// -- new notation
// color: rgb(255 255 255);
// color: rgb(255 255 255 / 1);
// Note that 'rgba()' is now merged into 'rgb()'

var validateHTMLColorRgb = function validateHTMLColorRgb(color) {
  if (isString$3(color)) {
    var regex = /(rgb)a?\((\s*\d+%?\s*?,?\s*){2}(\s*\d+%?\s*?,?\s*\)?)(\s*,?\s*\/?\s*(0?\.?\d+%?\s*)?|1|0)?\)$/i;
    return !!color && regex.test(color);
  }

  return false;
};
var optionalCommaOrRequiredSpace = "((\\s*,\\s*)|(\\s+))";
var optionalDecimals = "(\\.\\d+)?";
var anyPercentage = "((\\d*".concat(optionalDecimals, ")%)");
var hundredPercent = "(([0-9]|[1-9][0-9]|100)%)";
var alphaPercentage = "(((".concat(hundredPercent, "))|(0?").concat(optionalDecimals, ")|1))?");
var endingWithAlphaPercentage = "\\s*?\\)?)(\\s*?(\\/?)\\s+".concat(alphaPercentage, "\\s*?\\)$"); // Validate HTML color 'hsl'
// -- These units are valid for the first parameter
// 'deg': degrees | full circle = 360
// 'gra': gradians | full circle = 400
// 'radians': radians | full circle = 2π (approx. 6.28)
// 'turn': turns | full circle = 1

var validateHTMLColorHsl = function validateHTMLColorHsl(color) {
  if (isString$3(color)) {
    // Validate each possible unit value separately, as their values differ
    var degRegex = "(-?([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9]|360)(deg)?)";
    var graRegex = "(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-9][0-9]|400)gra)";
    var radRegex = "((([0-5])?\\.\\d+|6\\.([0-9]|1[0-9]|2[0-8])|[0-6])rad)";
    var turnRegex = "((0?".concat(optionalDecimals, "|1)turn)");
    var regexLogic = "(hsl)a?\\((\\s*?(".concat(degRegex, "|").concat(graRegex, "|").concat(radRegex, "|").concat(turnRegex, ")").concat(optionalCommaOrRequiredSpace, ")(\\s*?(0|").concat(hundredPercent, ")").concat(optionalCommaOrRequiredSpace, ")(\\s*?(0|").concat(hundredPercent, ")\\s*?\\)?)(\\s*?(\\/?|,?)\\s*?(((").concat(hundredPercent, "))|(0?").concat(optionalDecimals, ")|1))?\\)$");
    var regex = new RegExp(regexLogic);
    return !!color && regex.test(color);
  }

  return false;
}; // Validate HTML color 'hwb'
// -- 'hwb' accepts 'deg' as unit in its 1st property, which stands for 'hue'
// 'deg': degrees | full circle = 360

var validateHTMLColorHwb = function validateHTMLColorHwb(color) {
  if (isString$3(color)) {
    var degRegex = "(-?([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9]|360)(deg)?)";
    var regexLogic = "(hwb\\(\\s*?".concat(degRegex, "\\s+)((0|").concat(hundredPercent, ")\\s+)((0|").concat(hundredPercent, ")").concat(endingWithAlphaPercentage);
    var regex = new RegExp(regexLogic);
    return !!color && regex.test(color);
  }

  return false;
}; // Validate HTML color 'lab'
// -- 'lab' 2nd & 3rd parameters are any number between -160 & 160

var validateHTMLColorLab = function validateHTMLColorLab(color) {
  if (isString$3(color)) {
    var labParam = "(-?(([0-9]|[1-9][0-9]|1[0-5][0-9])".concat(optionalDecimals, "?|160))");
    var regexLogic = "(lab\\(\\s*?".concat(anyPercentage, "\\s+").concat(labParam, "\\s+").concat(labParam).concat(endingWithAlphaPercentage);
    var regex = new RegExp(regexLogic);
    return !!color && regex.test(color);
  }

  return false;
}; // Validate only HTML colors (`hex`, `rgb`, `rgba`, `hsl`, `hsla`, `hwb`, `lab`), without `name` og `special name`**

var validateColor = function validateColor(color) {
  // Former validation - source: https://www.regextester.com/103656
  // if (isString(color)) {
  //   const regex = /^#([\da-f]{3}){1,2}$|^#([\da-f]{4}){1,2}$|(rgb|hsl)a?\((\s*-?\d+%?\s*,){2}(\s*-?\d+%?\s*,?\s*\)?)(,\s*(0?\.\d+)?|1|0)?\)$/i;
  //   return color && regex.test(color);
  // }
  // New validation
  if (color && validateHTMLColorHex(color) || validateHTMLColorName(color) || validateHTMLColorSpecialName(color) || validateHTMLColorRgb(color) || validateHTMLColorHsl(color) || validateHTMLColorHwb(color) || validateHTMLColorLab(color)) {
    return true;
  }

  return false;
};

function getMappedToken(tokenId, themeValues) {
  if (!tokenId.startsWith("$")) {
    return undefined;
  }

  var mappedValue = undefined;
  Object.entries(themeValues).forEach(function (_ref) {
    var _ref2 = _slicedToArray$2(_ref, 2),
        themeTokenId = _ref2[0],
        themeValue = _ref2[1];

    if (!themeValue.mapTo) {
      return;
    }

    var mapToArray = typeof themeValue.mapTo === "string" ? [themeValue.mapTo] : themeValue.mapTo;

    if (mapToArray.includes(tokenId)) {
      mappedValue = {
        ref: themeTokenId,
        value: themeValue.value
      };
    }
  });
  return mappedValue;
}

function ownKeys$19(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$18(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$19(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$19(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getCommonFieldProps(schemaProp) {
  var label = schemaProp.label || schemaProp.prop;
  var group = schemaProp.group || "Properties";
  return {
    label: label,
    name: schemaProp.prop,
    group: group,
    schemaProp: schemaProp,
    description: schemaProp.description,
    isLabelHidden: schemaProp.isLabelHidden
  };
}

function buildThemeDefinition$1(themeValues, schemaProp, allowCustom) {
  var normalizeCustomValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (x) {
    return x;
  };

  var outputThemeValues = _objectSpread$18({}, themeValues);

  if (schemaProp.prefix) {
    for (var _key in outputThemeValues) {
      if (!_key.startsWith(schemaProp.prefix + ".")) {
        delete outputThemeValues[_key];
      } else {
        outputThemeValues[_key] = _objectSpread$18(_objectSpread$18({}, outputThemeValues[_key]), {}, {
          label: _key.split("".concat(schemaProp.prefix, "."))[1]
        });
      }
    }
  }

  for (var _key2 in outputThemeValues) {
    if (getMappedToken(_key2, themeValues)) {
      delete outputThemeValues[_key2];
    }
  }

  return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
    component: "responsive2",
    subComponent: "token",

    /**
     * For now we force "hasAuto: false", because auto logic is not yet decided.
     * 1. We must decide if we set 100px on desktop and go to mobile if we should show "auto" or "100px". Or "(auto) 100px".
     * 2. To show sth like "(auto) 100px" we must have access to compiled field (right now we have only access to compiled).
     * 3. This causes a bug, that when linearity is on, show value from higher breakpoint which is bascially not true (the value is different).
     */
    hasAuto: false,
    tokens: outputThemeValues,
    extraValues: schemaProp.extraValues,
    // other fields might ignore it
    normalizeCustomValue: normalizeCustomValue,
    allowCustom: allowCustom,
    format: function format(x) {
      return x;
    },
    parse: function parse(x) {
      return x;
    }
  });
}

var tinaFieldProviders = {
  text: function text(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "text",
      name: schemaProp.prop,
      normalize: schemaProp.normalize
    });
  },
  number: function number(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "number",
      step: 1,
      min: schemaProp.min,
      max: schemaProp.max
    });
  },
  string: function string(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "text",
      normalize: schemaProp.normalize
    });
  },
  string$: function string$(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "text",
      normalize: schemaProp.normalize
    });
  },
  "boolean": function boolean(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "toggle"
    });
  },
  boolean$: function boolean$(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "toggle"
    });
  },
  select: function select(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "select",
      options: schemaProp.options
    });
  },
  "radio-group": function radioGroup(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "radio-group",
      options: schemaProp.options
    });
  },
  select$: function select$(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "select",
      options: schemaProp.options
    });
  },
  "radio-group$": function radioGroup$(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "radio-group",
      options: schemaProp.options
    });
  },
  color: function color(schemaProp, editorContext) {
    return buildThemeDefinition$1(editorContext.theme.colors, schemaProp, true, function (x) {
      if (validateColor(x)) {
        return x;
      } // "fafafa" should be a correct color!


      if (validateColor("#" + x)) {
        return "#" + x;
      }

      return "#999999";
    });
  },
  stringToken: function stringToken(schemaProp, editorContext) {
    var allowCustom;
    var normalizeFunction;

    if (schemaProp.tokenId === "aspectRatios") {
      allowCustom = true;

      normalizeFunction = function normalizeFunction(x) {
        var defaultValue = "3:2";

        if (typeof x !== "string") {
          return defaultValue;
        }

        if (!x.match(/[0-9]+:[0-9]+/)) {
          return defaultValue;
        }

        return x;
      };
    } else if (schemaProp.tokenId === "containerWidths") {
      allowCustom = true;

      normalizeFunction = function normalizeFunction(x) {
        if (x === "none") {
          return x;
        }

        var defaultValue = "1600";

        if (typeof x !== "string") {
          return defaultValue;
        }

        var parsed = parseInt(x);

        if (isNaN(parsed)) {
          return defaultValue;
        }

        parsed = Math.max(parsed, 500);
        parsed = Math.min(parsed, 3000);
        return parsed.toString();
      };
    }

    return buildThemeDefinition$1(_objectSpread$18({}, editorContext.theme[schemaProp.tokenId]), schemaProp, allowCustom, normalizeFunction);
  },
  font: function font(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, buildThemeDefinition$1(editorContext.theme.fonts, schemaProp)), {}, {
      subComponent: "fontToken"
    });
  },
  space: function space(schemaProp, editorContext) {
    return buildThemeDefinition$1(editorContext.theme.space, schemaProp, true, function (x) {
      var _int = Math.round(parseInt(x));

      if (isNaN(_int) || _int < 0) {
        return "0px";
      }

      return "".concat(_int, "px");
    });
  },
  icon: function icon(schemaProp, editorContext) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "token",

      /**
       * For now we force "hasAuto: false", because auto logic is not yet decided.
       * 1. We must decide if we set 100px on desktop and go to mobile if we should show "auto" or "100px". Or "(auto) 100px".
       * 2. To show sth like "(auto) 100px" we must have access to compiled field (right now we have only access to compiled).
       * 3. This causes a bug, that when linearity is on, show value from higher breakpoint which is bascially not true (the value is different).
       */
      hasAuto: false,
      tokens: editorContext.theme.icons,
      normalizeCustomValue: function normalizeCustomValue(x) {
        return x;
      },
      allowCustom: true
    }); // return {
    //   ...getCommonFieldProps(schemaProp),
    //   component: "icon",
    // };
  },
  image: function image(schemaProp, editorContext) {
    var _editorContext$image = editorContext.image,
        resourceType = _editorContext$image.resourceType,
        _editorContext$image$ = _editorContext$image.params,
        params = _editorContext$image$ === void 0 ? {} : _editorContext$image$; // Looking for type representing image

    var imageType = editorContext.resourceTypes[resourceType];

    if (!imageType) {
      throw new Error("Can't find field named \"".concat(resourceType, "\" for image"));
    }

    var imageWidget = imageType.widget;

    if (!imageWidget) {
      throw new Error("Can't find widget named \"".concat(resourceType, "\" for image"));
    } // Passing custom schemaProp parameters to the field if a function


    var imageField = typeof imageWidget === "function" ? imageWidget(params) : imageWidget;
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "external",
      externalField: imageField
    });
  },
  video: function video(schemaProp, editorContext) {
    var _editorContext$video = editorContext.video,
        resourceType = _editorContext$video.resourceType,
        _editorContext$video$ = _editorContext$video.params,
        params = _editorContext$video$ === void 0 ? {} : _editorContext$video$; // Looking for type representing image

    var videoType = editorContext.resourceTypes[resourceType];

    if (!videoType) {
      throw new Error("Can't find field named \"".concat(resourceType, "\" for image"));
    }

    var videoWidget = videoType.widget;

    if (!videoWidget) {
      throw new Error("Can't find widget named \"".concat(resourceType, "\" for image"));
    } // Passing custom schemaProp parameters to the field if a function


    var videoField = typeof videoWidget === "function" ? videoWidget(params) : videoWidget;
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "external",
      externalField: videoField
    });
  },
  component: function component(schemaProp) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "ss-block",
      schemaProp: schemaProp
    });
  },
  "component-fixed": function componentFixed(schemaProp) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "ss-block",
      schemaProp: schemaProp
    });
  },
  "component-collection": function componentCollection(schemaProp) {
    throw new Error("component-collection is not yet supported in sidebar");
  },
  "component-collection-localised": function componentCollectionLocalised(schemaProp) {
    throw new Error("component-collection-localised is not yet supported in sidebar");
  },
  component$$$: function component$$$(schemaProp) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "identity",
      schemaProp: schemaProp
    });
  },
  variants$$$: function variants$$$(schemaProp) {
    return _objectSpread$18(_objectSpread$18({}, getCommonFieldProps(schemaProp)), {}, {
      component: "variant",
      schemaProp: schemaProp
    });
  },
  resource: function resource(schemaProp, editorContext) {
    var _schemaProp$params;

    var resourceType = editorContext.resourceTypes[schemaProp.resourceType];

    if (!resourceType) {
      throw new Error("Resource field of type '".concat(schemaProp.resourceType, "' not defined."));
    }

    var fieldWidget = resourceType.widget;

    if (!fieldWidget) {
      throw new Error("Can't find widget named \"".concat(schemaProp.resourceType, "\""));
    }

    var field = typeof fieldWidget === "function" ? fieldWidget((_schemaProp$params = schemaProp.params) !== null && _schemaProp$params !== void 0 ? _schemaProp$params : {}) : fieldWidget;
    return _objectSpread$18({
      component: "external",
      externalField: field
    }, getCommonFieldProps(schemaProp));
  }
};
function getTinaField(schemaProp, editorContext, componentDefinition) {
  var fieldProvider = tinaFieldProviders[schemaProp.type] || tinaFieldProviders.resource;
  return fieldProvider(schemaProp, editorContext, componentDefinition);
}

/**
 * When selecting text within $richText, we keep information about which text parts are selected
 * within focused fields. If the text part is partially selected, we add information about the selection.
 * This selection has format: ".{textPartCharacterSelectionStartIndex,textPartCharacterSelectionEndIndex}".
 * We often want to query related to selection text part component config and to do that correctly we need to
 * strip information about selection.
 */
function stripRichTextPartSelection(value) {
  return value.replace(/\.\{\d+,\d+\}$/g, "");
}

function parsePath(path, form) {
  var values = form.values;
  var pathSplit = path === "" ? [] : stripRichTextPartSelection(path).split(".");
  var pathInfo = undefined; // We're going from current path down the path to find current template and parent template

  for (var i = pathSplit.length; i >= 0; i--) {
    var testedPath = pathSplit.slice(0, i).join(".");
    var value = dotNotationGet(values, testedPath);

    if (typeof value === "object" && typeof value._template === "string") {
      if (pathInfo === undefined) {
        pathInfo = {
          templateId: value._template
        }; // fieldName

        var fieldPath = pathSplit.slice(i);

        if (fieldPath.length > 0) {
          pathInfo.fieldName = fieldPath.join(".");
        }

        var potentialIndex = parseInt(pathSplit[i - 1]);

        if (!isNaN(potentialIndex)) {
          pathInfo.index = potentialIndex;
        }
      } else {
        pathInfo.parent = {
          templateId: value._template,
          fieldName: pathSplit[i],
          path: testedPath
        };
        break;
      }
    }
  }

  if (!pathInfo) {
    throw new Error("incorrect path: ".concat(path));
  }

  return pathInfo;
}
function findPathOfFirstAncestorOfType(path, templateId, form) {
  while (true) {
    var parseResult = parsePath(path, form);

    if (!parseResult.parent) {
      throw new Error("couldn't find ancestor of type ".concat(templateId));
    }

    if (parseResult.parent.templateId === templateId) {
      return parseResult.parent.path;
    }

    path = parseResult.parent.path;
  }
}

var pxKeys = {
  margin: true,
  marginTop: true,
  marginBottom: true,
  marginLeft: true,
  marginRight: true,
  m: true,
  mt: true,
  mb: true,
  ml: true,
  mr: true,
  mx: true,
  my: true,
  padding: true,
  paddingTop: true,
  paddingBottom: true,
  paddingLeft: true,
  paddingRight: true,
  p: true,
  pt: true,
  pb: true,
  pl: true,
  pr: true,
  px: true,
  py: true,
  top: true,
  bottom: true,
  left: true,
  right: true,
  flexBasis: true,
  gridColumnGap: true,
  gridRowGap: true
};

function numericToPx(input) {
  var ret = {};

  for (var _key in input) {
    if (pxKeys[_key] && typeof input[_key] === "number") {
      ret[_key] = input[_key] + "px";
    } else {
      ret[_key] = input[_key];
    }
  }

  return ret;
}

var box = function box(styles, tag) {
  var ret = numericToPx(styles);
  ret.__isBox = true;

  if (tag) {
    ret.__as = tag;
  }

  return ret;
};

function ownKeys$18(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$17(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$18(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$18(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var DEFAULT_FONT_VALUES = {
  fontWeight: "initial",
  fontStyle: "initial"
};
function styles$m(_ref, t) {
  var color = _ref.color,
      font = _ref.font,
      value = _ref.value,
      __modifierStyles = _ref.__modifierStyles;

  var fontWithDefaults = _objectSpread$17(_objectSpread$17({}, DEFAULT_FONT_VALUES), font);

  return {
    Text: box(_objectSpread$17(_objectSpread$17(_objectSpread$17({
      color: color
    }, fontWithDefaults), __modifierStyles), {}, {
      "& *": _objectSpread$17({
        fontFamily: "inherit",
        fontStyle: "inherit",
        color: "inherit"
      }, __modifierStyles)
    }), "span"),
    __props: {
      color: color,
      font: font,
      value: value
    }
  };
}

function ownKeys$17(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$16(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$17(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$17(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var richTextPartEditableComponent = {
  id: "$richTextPart",
  schema: [{
    prop: "value",
    type: "string",
    visible: false,
    group: "Text"
  }, {
    prop: "font",
    label: "Style",
    type: "font",
    group: "Text"
  }, {
    prop: "color",
    label: "Color",
    type: "color",
    group: "Text"
  }],
  editing: function editing(_, editingInfo, _ref) {
    var pathPrefix = _ref.pathPrefix,
        editorContext = _ref.editorContext;
    var resultFields = [];
    var richTextPath = findPathOfFirstAncestorOfType(pathPrefix, "$richText", editorContext.form);
    var richTextBlockPath = findPathOfFirstAncestorOfType(pathPrefix, "$richTextBlockElement", editorContext.form);
    resultFields.push.apply(resultFields, [{
      portal: "component",
      source: richTextPath,
      includeHeader: true,
      groups: ["Size", "Margins"]
    }].concat(_toConsumableArray$2(editingInfo.fields.slice(1)), [{
      portal: "field",
      source: richTextBlockPath,
      fieldName: "type"
    }, {
      portal: "field",
      source: richTextPath,
      fieldName: "isListStyleAuto"
    }, {
      portal: "field",
      source: richTextPath,
      fieldName: "mainFont"
    }, {
      portal: "field",
      source: richTextPath,
      fieldName: "mainColor"
    }, {
      portal: "component",
      source: richTextPath,
      groups: ["Accessibility and SEO"]
    }]));

    try {
      // We add fields from inline-wrapper to show current values of filtered fields and any additional field within
      // sidebar when text is selected.
      var inlineWrapperPath = findPathOfFirstAncestorOfType(pathPrefix, "$richTextInlineWrapperElement", editorContext.form);
      resultFields.push({
        portal: "component",
        source: inlineWrapperPath
      });
    } catch (error) {
      // When $richTextPart is outside of wrapper element, we add field for displaying action schema prop to allow
      // to add action to selected text without putting it into schemas of $richTextPart.
      var actionField = getTinaField(_objectSpread$16(_objectSpread$16({}, richTextInlineWrapperActionSchemaProp), {}, {
        prop: "$action",
        definition: findComponentDefinitionById("$richTextInlineWrapperElement", editorContext)
      }), editorContext);
      resultFields.push(_objectSpread$16(_objectSpread$16({}, actionField), {}, {
        name: "".concat(pathPrefix, ".$action")
      })); // if (
      //   "disabled" ===
      //   "enabled"
      // ) {
      //   const textModifierField = getTinaField(
      //     {
      //       ...optionalTextModifierSchemaProp,
      //       prop: "$textModifier",
      //       definition: findComponentDefinitionById(
      //         "$richTextInlineWrapperElement",
      //         editorContext
      //       )!,
      //       defaultValue: [],
      //       visible: true,
      //     },
      //     editorContext
      //   );
      //   resultFields.push({
      //     ...textModifierField,
      //     name: `${pathPrefix}.$textModifier`,
      //   });
      // }
    }

    return {
      fields: resultFields
    };
  },
  tags: ["notrace"],
  styles: styles$m
};

// Sorry for this name
function isTrulyResponsiveValue(x) {
  return typeof x === "object" && x !== null && !Array.isArray(x) && x.$res === true;
}

function responsiveValueGet(value, deviceId) {
  if (isTrulyResponsiveValue(value)) {
    return value[deviceId];
  }

  return value;
}
function responsiveValueForceGet(value, deviceId) {
  if (isTrulyResponsiveValue(value)) {
    if (value[deviceId] === undefined) {
      var error = "You called responsiveValueForceGet with value ".concat(JSON.stringify(value), " and deviceId: ").concat(deviceId, ". Value undefined.");
      throw new Error(error);
    }

    return value[deviceId];
  }

  return value;
}

function responsiveValueNormalize(arg, devices) {
  if (!isTrulyResponsiveValue(arg)) {
    return arg;
  }

  var previousVal = undefined;
  var ret = {
    $res: true
  };
  var numberOfDefinedValues = 0;

  for (var i = devices.length - 1; i >= 0; i--) {
    var breakpoint = devices[i].id;
    var val = arg[breakpoint]; // TODO: if values are objects, it's to do

    if (typeof val === "object" && val !== null) {
      if (JSON.stringify(val) !== JSON.stringify(previousVal)) {
        ret[breakpoint] = val;
        previousVal = val;
        numberOfDefinedValues++;
      }
    } else {
      if (val !== undefined && val !== previousVal) {
        ret[breakpoint] = val;
        previousVal = val;
        numberOfDefinedValues++;
      }
    } // [x, null, null, y] => [x, y]


    if (i < devices.length - 1) {
      var nextBreakpoint = devices[i + 1].id;

      if (numberOfDefinedValues === 1 && ret[breakpoint] === undefined && ret[nextBreakpoint] !== undefined) {
        ret[breakpoint] = ret[nextBreakpoint];
        delete ret[nextBreakpoint];
      }
    }
  }

  if (numberOfDefinedValues === 1) {
    return ret[devices[0].id];
  }

  return ret;
}

function ownKeys$16(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$15(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$16(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$16(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 *  Input like: { breakpoint1: sth, breakpoint2: sth, breakpoint3: sth, ... }
 */
function squashCSSResults(scalarValues, devices, disableNesting) {
  // Let's check whether scalarValues represent object (for nesting) or a scalar value.
  var objectsNum = 0;
  var noObjectsNum = 0;
  var arraysNum = 0;

  for (var breakpointName in scalarValues) {
    var val = scalarValues[breakpointName];

    if (Array.isArray(val) && !disableNesting) {
      arraysNum++;
    } else if (typeof val === "object" && val !== null && !Array.isArray(val) && !disableNesting) {
      objectsNum++;
    } else if (val !== null && val !== undefined) {
      noObjectsNum++;
    }
  } // Only one flag can be > 0!!! Otherwise breakpoints return incompatible types


  if (objectsNum > 0 && (noObjectsNum > 0 || arraysNum > 0) || arraysNum > 0 && (noObjectsNum > 0 || objectsNum > 0) || noObjectsNum > 0 && (arraysNum > 0 || objectsNum > 0)) {
    throw new Error("This shouldn't happen. Mismatched types for different breakpoints!!!");
  }

  if (arraysNum > 0) {
    var biggestArrayLength = 0;

    for (var breakpoint in scalarValues) {
      biggestArrayLength = Math.max(biggestArrayLength, scalarValues[breakpoint].length); // {...allKeysObject, ...scalarValues[breakpoint]};
    }

    var ret = [];

    for (var i = 0; i < biggestArrayLength; i++) {
      var newScalarValues = {};

      for (var _breakpoint in scalarValues) {
        var value = undefined;

        if (scalarValues[_breakpoint]) {
          value = scalarValues[_breakpoint][i];
        }

        newScalarValues[_breakpoint] = value;
      }

      ret[i] = squashCSSResults(newScalarValues, devices);
    }

    return ret;
  } // If object -> recursion


  if (objectsNum > 0) {
    // allKeys is the object that has all the keys from all the scalar configs
    var allKeysObject = {};
    /**
     * Scalar values are like:
     *
     * {
     *    b1: { a: 10, b: 20 }
     *    b2: { a: 100, c: 300 }
     * }
     */

    for (var _breakpoint2 in scalarValues) {
      allKeysObject = _objectSpread$15(_objectSpread$15({}, allKeysObject), scalarValues[_breakpoint2]);
    } // scalarValues.forEach(scalarConfig => {
    //     allKeysObject = {...allKeysObject, ...scalarConfig};
    // });


    var allKeys = Object.keys(allKeysObject);
    var _ret = {};
    /**
     * All keys are like: ['a', 'b', 'c']
     *
     * All used keys across all breakpoints
     */

    allKeys.forEach(function (key) {
      var newScalarValues = {};

      for (var _breakpoint3 in scalarValues) {
        var _value = undefined;

        if (scalarValues[_breakpoint3]) {
          _value = scalarValues[_breakpoint3][key];
        }

        newScalarValues[_breakpoint3] = _value;
      }
      /**
       * newScalarValues values are like:
       *
       * For key 'a':
       * {
       *      b1: 10,
       *      b2: 100
       * }
       *
       * For key 'b':
       * {
       *     b1: 20,
       *     b2: undefined
       * }
       *
       */

      /**
       * For fonts we don't want nesting + recursion. We want entire object to be passed to results.
       *
       * Later, renderer must know how to render xfont property :)
       *
       * Otherwise, media query conflicts arise and bad values are set.
       */


      _ret[key] = squashCSSResults(newScalarValues, devices, key === "xfont");
    });
    return _ret;
  } // Here we are sure we have scalar value, not some object to be nested. We must do 2 things:
  // - add "unset" instead of null / undefined
  // - create ResponsiveValue and normalize


  for (var _key in scalarValues) {
    if (scalarValues[_key] === undefined || scalarValues[_key] === null) {
      scalarValues[_key] = "unset";
    }
  } // Values (non-objects -> no nesting)


  return responsiveValueNormalize(_objectSpread$15(_objectSpread$15({}, scalarValues), {}, {
    $res: true
  }), devices);
}

function scalarizeNonComponentProp(value, breakpoint, devices, schemaProp) {
  if (schemaProp) {
    // This function should never be called with component type
    if (schemaProp.type.startsWith("component")) {
      throw new Error("unreachable");
    } // image and video are responsive


    if (schemaProp.type === "image" || schemaProp.type === "video") {
      return responsiveValueForceGet(value, breakpoint);
    } // resources should be ignored (not to run scalarise on value which we don't control)


    if (isResourceSchemaProp(schemaProp)) {
      return value;
    } // other props are potentially responsive, so let's run responsiveValueGet


    return responsiveValueForceGet(value, breakpoint);
  } // for context props we just treat them as responsive


  return responsiveValueForceGet(value, breakpoint);
}

function scalarizeCollection(configs, breakpoint, devices, itemFieldsSchema) {
  return configs.map(function (child) {
    var scalarizedChild = _objectSpread$15({}, child);

    var _loop = function _loop() {
      var _Object$entries$_i = _slicedToArray$2(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      var schemaProp = itemFieldsSchema.find(function (itemFieldSchemaProp) {
        return itemFieldSchemaProp.prop === key;
      });

      if (schemaProp) {
        scalarizedChild[schemaProp.prop] = scalarizeNonComponentProp(value, breakpoint, devices, schemaProp);
      } else {
        scalarizedChild[key] = scalarizeNonComponentProp(value, breakpoint);
      }
    };

    for (var _i = 0, _Object$entries = Object.entries(scalarizedChild); _i < _Object$entries.length; _i++) {
      _loop();
    }

    return scalarizedChild;
  });
}

function scalarizeConfig(config, breakpoint, devices, schema) {
  var ret = {};
  /**
   * There is a bit of chaos here. To understand what is happening, we must know what "Config" is in context of resop.
   *
   * Config is not a "real" config we're using in the Shopstory in almost all places. We're dealing here with "intermediate compiled config" used during compilation. What it means:
   * 1. It has _template, _id, etc.
   * 2. All the props from schema that are *not* components are compiled and are available.
   * 3. All the props from schema that are components have only _template and _id (exception below)
   * 4. component-collections has child Configs that have item props that are also compiled and are added *to the root level of the config*. They're simply context props. (IMPORTANT! -> localised is already non-localised ;p)
   * 5. context props from compilation are also added to the config.
   *
   * PROBLEM:
   *
   * As long as we know the component "own props" (we have schema) and item props, we have no idea about context props types. It means that we can only blindly apply responsiveValueGet on them.
   *
   * SOLUTION:
   *
   * context props should be typed. Each editable component should have schema of own props and of context props.
   *
   */

  var _loop2 = function _loop2(prop) {
    var schemaProp = schema.find(function (x) {
      return x.prop === prop;
    }); // If schemaProp is defined, it means "own prop". Otherwise it must be a context prop (they're not "typed" yet and we don't have any information what types of context props we have)

    if (schemaProp) {
      // subcomponents don't get scalarized
      if (isSchemaPropComponent(schemaProp)) {
        // Text modifiers are components for now and in contrast to real components, we need to compile its values.
        if (isSchemaPropActionTextModifier(schemaProp) || isSchemaPropTextModifier(schemaProp)) {
          (function () {
            var modifierConfig = config[prop][0];

            if (modifierConfig) {
              (function () {
                var scalarModifierValues = {};

                var _loop3 = function _loop3(modifierKey) {
                  if (Array.isArray(modifierConfig[modifierKey])) {
                    scalarModifierValues[modifierKey] = [];
                    modifierConfig[modifierKey].forEach(function (values, index) {
                      scalarModifierValues[modifierKey][index] = {};

                      for (var nestedModifierKey in values) {
                        scalarModifierValues[modifierKey][index][nestedModifierKey] = scalarizeNonComponentProp(modifierConfig[modifierKey][index][nestedModifierKey], breakpoint);
                      }
                    });
                  } else {
                    scalarModifierValues[modifierKey] = scalarizeNonComponentProp(modifierConfig[modifierKey], breakpoint);
                  }
                };

                for (var modifierKey in modifierConfig) {
                  _loop3(modifierKey);
                }

                ret[prop] = [scalarModifierValues];
              })();
            } else {
              ret[prop] = config[prop];
            }
          })();
        } else {
          ret[prop] = config[prop];
        }
      } // component collection should have item props scalarized. We know the types of item props!
      // component collection localised is already dealing with value that is NON-LOCALISED (it was flattened earlier)
      else if (isSchemaPropCollection(schemaProp)) {
        ret[prop] = scalarizeCollection(config[prop], breakpoint, devices, schemaProp.itemFields || []);
      } else {
        ret[prop] = scalarizeNonComponentProp(config[prop], breakpoint, devices, schemaProp);
      }
    } else {
      // context props automatically get scalarized
      ret[prop] = scalarizeNonComponentProp(config[prop], breakpoint);
    }
  };

  for (var prop in config) {
    _loop2(prop);
  }

  return ret;
}

function getUndefinedBreakpoints(resVal, devices) {
  var undefinedBreakpoints = [];
  devices.forEach(function (device) {
    if (resVal[device.id] === undefined) {
      undefinedBreakpoints.push(device.id);
    }
  });
  return undefinedBreakpoints;
}

function hasDefinedBreakpoints(resVal, devices) {
  var undefinedBreakpoints = getUndefinedBreakpoints(resVal, devices);
  return undefinedBreakpoints.length < devices.length;
}

function resop2(config, callback, devices, componentDefinition) {
  var _componentDefinition$;

  var schema = (_componentDefinition$ = componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.schema) !== null && _componentDefinition$ !== void 0 ? _componentDefinition$ : []; // Decompose config into scalar configs

  var scalarConfigs = {};
  devices.forEach(function (device) {
    scalarConfigs[device.id] = scalarizeConfig(config, device.id, devices, schema);
  });
  var scalarOutputs = {}; // run callback for scalar configs

  devices.forEach(function (device) {
    scalarOutputs[device.id] = callback(scalarConfigs[device.id], device.id);
  });
  /**
   * Let's first squash all __props, components and item props
   */

  var componentPropNames = {};
  var componentItemPropsNamesAndLength = {};
  var propNames = new Set(); // Let's add keys

  schema.forEach(function (schemaProp) {
    if (isSchemaPropComponentOrComponentCollection(schemaProp)) {
      componentPropNames[schemaProp.prop] = new Set();
    }

    if (isSchemaPropCollection(schemaProp)) {
      componentItemPropsNamesAndLength[schemaProp.prop] = {
        lengths: new Set(),
        names: new Set()
      };
    }
  }); // Let's find all output prop names

  devices.forEach(function (device) {
    var _scalarOutputs$device;

    // prop names
    var propsObject = (_scalarOutputs$device = scalarOutputs[device.id].__props) !== null && _scalarOutputs$device !== void 0 ? _scalarOutputs$device : {};

    if (typeof propsObject !== "object" || propsObject === null) {
      throw new Error("__props must be object, it is not for breakpoint: ".concat(device.id));
    }

    for (var propName in propsObject) {
      propNames.add(propName);
    } // component prop names


    schema.forEach(function (schemaProp) {
      if (isSchemaPropComponentOrComponentCollection(schemaProp)) {
        var _scalarOutputs$device2;

        var componentObject = (_scalarOutputs$device2 = scalarOutputs[device.id][schemaProp.prop]) !== null && _scalarOutputs$device2 !== void 0 ? _scalarOutputs$device2 : {};

        if (typeof componentObject !== "object" || componentObject === null) {
          throw new Error("resop error: component must be undefined or an object, it is not for device ".concat(device.id, " and prop ").concat(schemaProp.prop, ". Template: ").concat(componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.id));
        }

        for (var _key2 in componentObject) {
          if (_key2 === "itemProps") {
            continue;
          }

          componentPropNames[schemaProp.prop].add(_key2);
        }

        if (isSchemaPropCollection(schemaProp)) {
          var _componentObject$item;

          var itemPropsArray = (_componentObject$item = componentObject.itemProps) !== null && _componentObject$item !== void 0 ? _componentObject$item : [];

          if (!Array.isArray(itemPropsArray)) {
            throw new Error("resop error: item props must be undefined or an array (".concat(schemaProp.prop, "). Template: ").concat(componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.id));
          }

          itemPropsArray.forEach(function (itemObject, index) {
            if (typeof itemObject !== "object" || itemObject === null) {
              throw new Error("resop error: item in itemProps array must be object (".concat(schemaProp.prop, ".itemProps.").concat(index, "). Template: ").concat(componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.id));
            }

            for (var _key3 in itemObject) {
              componentItemPropsNamesAndLength[schemaProp.prop].names.add(_key3);
            }
          });
          componentItemPropsNamesAndLength[schemaProp.prop].lengths.add(itemPropsArray.length);
        }
      }
    });
  }); // Let's verify array lengths

  for (var componentName in componentItemPropsNamesAndLength) {
    var lengths = componentItemPropsNamesAndLength[componentName].lengths;

    if (lengths.size > 1) {
      throw new Error("resop: incompatible item props arrays length for component: ".concat(componentName, ". Template: ").concat(componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.id));
    }

    var length = Array.from(lengths)[0]; // If non-zero length, then there are extra requirements

    if (length > 0) {
      var itemsLength = config[componentName].length;

      if (itemsLength === 0 ? length > 1 : itemsLength !== length) {
        throw new Error("resop: item props arrays length incompatible with items length for component: ".concat(componentName, ". Template: ").concat(componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.id));
      }
    }
  } // Let's compress


  var output = {
    __props: {}
  }; // squash props

  propNames.forEach(function (propName) {
    var squashedValue = {
      $res: true
    };
    devices.forEach(function (device) {
      var _scalarOutputs$device3, _scalarOutputs$device4;

      squashedValue[device.id] = (_scalarOutputs$device3 = scalarOutputs[device.id]) === null || _scalarOutputs$device3 === void 0 ? void 0 : (_scalarOutputs$device4 = _scalarOutputs$device3.__props) === null || _scalarOutputs$device4 === void 0 ? void 0 : _scalarOutputs$device4[propName];
    });

    if (hasDefinedBreakpoints(squashedValue, devices)) {
      var undefinedBreakpoints = getUndefinedBreakpoints(squashedValue, devices);

      if (undefinedBreakpoints.length > 0) {
        throw new Error("resop: undefined value (breakpoints: ".concat(undefinedBreakpoints, ") for __props.").concat(propName, ". Template: ").concat(componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.id));
      }

      output.__props[propName] = responsiveValueNormalize(squashedValue, devices); // props should be normalized
    }
  }); // Squash components

  var _loop4 = function _loop4(_componentName) {
    output[_componentName] = {};

    componentPropNames[_componentName].forEach(function (componentPropName) {
      var squashedValue = {
        $res: true
      };
      devices.forEach(function (device) {
        var _scalarOutputs$device5;

        squashedValue[device.id] = (_scalarOutputs$device5 = scalarOutputs[device.id][_componentName]) === null || _scalarOutputs$device5 === void 0 ? void 0 : _scalarOutputs$device5[componentPropName];
      });

      if (hasDefinedBreakpoints(squashedValue, devices)) {
        var undefinedBreakpoints = getUndefinedBreakpoints(squashedValue, devices);

        if (undefinedBreakpoints.length > 0) {
          throw new Error("resop: undefined value (breakpoints ".concat(undefinedBreakpoints, ") for ").concat(_componentName, ".").concat(componentPropName, ". Template: ").concat(componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.id));
        }

        output[_componentName][componentPropName] = squashedValue;
      }
    });
  };

  for (var _componentName in componentPropNames) {
    _loop4(_componentName);
  } // Squash item props


  var _loop5 = function _loop5(_componentName2) {
    output[_componentName2].itemProps = [];
    var length = Array.from(componentItemPropsNamesAndLength[_componentName2].lengths)[0];

    var _loop6 = function _loop6(i) {
      output[_componentName2].itemProps[i] = {};

      componentItemPropsNamesAndLength[_componentName2].names.forEach(function (itemPropName) {
        var squashedValue = {
          $res: true
        };
        devices.forEach(function (device) {
          var _scalarOutputs$device6, _scalarOutputs$device7, _scalarOutputs$device8;

          squashedValue[device.id] = (_scalarOutputs$device6 = scalarOutputs[device.id][_componentName2]) === null || _scalarOutputs$device6 === void 0 ? void 0 : (_scalarOutputs$device7 = _scalarOutputs$device6.itemProps) === null || _scalarOutputs$device7 === void 0 ? void 0 : (_scalarOutputs$device8 = _scalarOutputs$device7[i]) === null || _scalarOutputs$device8 === void 0 ? void 0 : _scalarOutputs$device8[itemPropName];
        });

        if (hasDefinedBreakpoints(squashedValue, devices)) {
          var undefinedBreakpoints = getUndefinedBreakpoints(squashedValue, devices);

          if (undefinedBreakpoints.length > 0) {
            throw new Error("resop: undefined value (breakpoints ".concat(undefinedBreakpoints, ") for ").concat(_componentName2, ".").concat(i, ".").concat(itemPropName, ". Template: ").concat(componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.id));
          }

          output[_componentName2].itemProps[i][itemPropName] = squashedValue;
        }
      });
    };

    for (var i = 0; i < length; i++) {
      _loop6(i);
    }
  };

  for (var _componentName2 in componentItemPropsNamesAndLength) {
    _loop5(_componentName2);
  }

  delete scalarOutputs.__props;
  schema.forEach(function (schemaProp) {
    if (isSchemaPropComponentOrComponentCollection(schemaProp)) {
      delete scalarOutputs[schemaProp.prop];
    }
  });

  var result = _objectSpread$15(_objectSpread$15({}, squashCSSResults(scalarOutputs, devices)), output);

  return result;
}

/**
 * `Object.entries` is badly typed for its reasons and this function just fixes it.
 * https://stackoverflow.com/questions/55012174/why-doesnt-object-keys-return-a-keyof-type-in-typescript
 */
function entries(o) {
  return Object.entries(o);
}

function responsiveValueEntries(value) {
  var values = [];
  entries(value).forEach(function (_ref) {
    var _ref2 = _slicedToArray$2(_ref, 2),
        key = _ref2[0],
        v = _ref2[1];

    if (key === "$res") return;
    values.push([key, v]);
  });
  return values;
}

function responsiveValueMap(resVal, mapper) {
  if (!isTrulyResponsiveValue(resVal)) {
    return mapper(resVal);
  }

  var ret = {
    $res: true
  };
  responsiveValueEntries(resVal).forEach(function (_ref) {
    var _ref2 = _slicedToArray$2(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    ret[key] = mapper(value, key);
  });
  return ret;
}

function compileBox(input, devices) {
  if (typeof input === "object" && input.$res) {
    var ret = {};

    for (var _key in input) {
      if (_key !== "$res") {
        ret["@" + _key] = input[_key];
      }
    }

    return ret;
  } else if (typeof input === "object" && input !== null) {
    var _ret = {};
    /**
     * FIXME: there's a bug here!!!
     *
     * I don't know what to do about it. We add items in a correct order to the ret object, and JS should keep this order
     * but it clearly doesn't work and order gets broken. This breaks where "unset" is set in CSS and hence, inheritance is broken.
     *
     * This can be fixed by adding "specific media queries" (from - to) here. It's gonna work.
     */

    for (var _key2 in input) {
      var val = input[_key2];

      if (typeof val === "object" && val.$res === true) {
        // const maxBreakpoint = responsiveValueGetMaxDefinedBreakpoint(val, devices);
        var isFirst = true;

        for (var i = devices.length - 1; i >= 0; i--) {
          var breakpoint = devices[i].id;

          if (val[breakpoint] === null || val[breakpoint] === undefined) {
            continue;
          }

          if (isFirst) {
            _ret[_key2] = val[breakpoint];
            isFirst = false;
          } else {
            if (!_ret["@" + breakpoint]) {
              _ret["@" + breakpoint] = {};
            }

            _ret["@" + breakpoint][_key2] = val[breakpoint];
          }
        }

        continue;
      }

      _ret[_key2] = compileBox(val, devices);
    }

    return _ret;
  }

  return input;
}

function getDevicesWidths(devices) {
  var widths = {
    $res: true
  };
  devices.forEach(function (device) {
    widths[device.id] = device.w;
  });
  return widths;
}
var DEFAULT_DEVICES = [// de facto all vertical phones have max 414px
// de facto all horizontal phones start with 620px (end with ~900, almost all below 915) -> vertical tablet resolutions
// most people don't use horizontal phones anyway
// no one uses such tiny resolutions on other devices
// we obviously need phone resolution
// we introduce "pro forma" resolution (568 - 767px) which is "some horizontal phones". It's here mostly because there is such resolution in bootstrap, tailwind etc.
// personally I think we could have one resolution that covers all horizontal phones and tablets (620 - 996). But it would break naming that is "commonly understood" by devs (xs phone, sm horizontal phone, md tablet). sm is mostly dead, should be covered by md
{
  id: "xs",
  w: 375,
  h: 667,
  breakpoint: 568,
  label: "Mobile"
}, {
  id: "sm",
  w: 667,
  h: 375,
  breakpoint: 768,
  label: "Mobile SM h",
  hidden: true
}, {
  id: "md",
  w: 768,
  h: 1024,
  breakpoint: 992,
  label: "Tablet"
}, {
  id: "lg",
  w: 1024,
  h: 768,
  breakpoint: 1280,
  label: "TabletH",
  hidden: true
}, {
  id: "xl",
  w: 1366,
  h: 768,
  breakpoint: 1600,
  label: "Desktop",
  isMain: true
}, {
  id: "2xl",
  w: 1920,
  h: 920,
  label: "Large desktop",
  breakpoint: null // hidden: true,

}];

function responsiveValueGetHighestDefinedDevice(input, devices) {
  var highestDefinedDevice;

  for (var i = devices.length - 1; i >= 0; i--) {
    var device = devices[i];

    if (input[device.id] !== undefined) {
      highestDefinedDevice = device;
      break;
    }
  }

  if (highestDefinedDevice === undefined) {
    throw new Error("highest defined value doesn't exist");
  }

  return highestDefinedDevice;
}

function getDeviceWidthPairs(widths, devices) {
  var componentWidths = [];

  for (var key in widths) {
    if (key === "$res") {
      continue;
    }

    componentWidths.push({
      width: responsiveValueForceGet(widths, key),
      deviceId: key
    });
  }

  componentWidths.sort(function (x, y) {
    if (x.width === y.width) {
      var xDevicesIndex = devices.findIndex(function (d) {
        return d.id === x.deviceId;
      });
      var yDevicesIndex = devices.findIndex(function (d) {
        return d.id === y.deviceId;
      });
      return xDevicesIndex > yDevicesIndex ? 1 : -1;
    }

    return x.width === y.width ? 0 : x.width > y.width ? 1 : -1;
  });
  return componentWidths;
}
function getDeviceWidthPairsFromDevices(devices) {
  return devices.map(function (d) {
    return {
      width: d.w,
      deviceId: d.id
    };
  });
}

function responsiveValueFindHigherDeviceWithDefinedValue(value, breakpoint, devices, widths) {
  var componentWidths = widths ? getDeviceWidthPairs(widths, devices) : getDeviceWidthPairsFromDevices(devices);
  var componentWidthIndex = componentWidths.findIndex(function (x) {
    return x.deviceId === breakpoint;
  });
  var componentWidth = devices[componentWidthIndex];

  if (!componentWidth) {
    throw new Error("undefined breakpoint");
  } //
  // if (device.breakpoint === null) {
  //   return;
  // }


  var _loop = function _loop(i) {
    var deviceId = componentWidths[i].deviceId;

    if (value[deviceId] !== undefined) {
      return {
        v: devices.find(function (d) {
          return d.id === deviceId;
        })
      };
    }
  };

  for (var i = componentWidthIndex + 1; i <= componentWidths.length - 1; i++) {
    var _ret = _loop(i);

    if (typeof _ret === "object") return _ret.v;
  }

  return undefined;
}
function responsiveValueFindLowerDeviceWithDefinedValue(value, breakpoint, devices, widths) {
  var componentWidths = widths ? getDeviceWidthPairs(widths, devices) : getDeviceWidthPairsFromDevices(devices);
  var componentWidthIndex = componentWidths.findIndex(function (x) {
    return x.deviceId === breakpoint;
  });
  var componentWidth = devices[componentWidthIndex];

  if (!componentWidth) {
    throw new Error("undefined breakpoint");
  }

  var _loop2 = function _loop2(i) {
    var deviceId = componentWidths[i].deviceId;

    if (value[deviceId] !== undefined) {
      return {
        v: devices.find(function (d) {
          return d.id === deviceId;
        })
      };
    }
  };

  for (var i = componentWidthIndex - 1; i >= 0; i--) {
    var _ret2 = _loop2(i);

    if (typeof _ret2 === "object") return _ret2.v;
  }

  return undefined;
}
function responsiveValueFindDeviceWithDefinedValue(value, breakpoint, devices, widths) {
  if (value[breakpoint] !== undefined) {
    return devices.find(function (x) {
      return x.id === breakpoint;
    });
  }

  var higherDevice = responsiveValueFindHigherDeviceWithDefinedValue(value, breakpoint, devices, widths);

  if (higherDevice !== undefined) {
    return higherDevice;
  }

  var lowerDevice = responsiveValueFindLowerDeviceWithDefinedValue(value, breakpoint, devices, widths);

  if (lowerDevice !== undefined) {
    return lowerDevice;
  }

  return undefined;
}

function responsiveValueGetFirstHigherValue(value, breakpoint, devices, widths) {
  var higherDefinedDevice = responsiveValueFindHigherDeviceWithDefinedValue(value, breakpoint, devices, widths);

  if (!higherDefinedDevice) {
    return;
  }

  return value[higherDefinedDevice.id];
}
function responsiveValueGetFirstLowerValue(value, breakpoint, devices, widths) {
  var lowerDefinedDevice = responsiveValueFindLowerDeviceWithDefinedValue(value, breakpoint, devices, widths);

  if (!lowerDefinedDevice) {
    return;
  }

  return value[lowerDefinedDevice.id];
}
function responsiveValueGetDefinedValue(value, breakpoint, devices, widths) {
  if (!isTrulyResponsiveValue(value)) {
    return value;
  }

  var definedDevice = responsiveValueFindDeviceWithDefinedValue(value, breakpoint, devices, widths);

  if (!definedDevice) {
    return;
  }

  return value[definedDevice.id];
}

function ownKeys$15(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$14(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$15(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$15(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function responsiveValueFlatten(resVal, devices) {
  if (!isTrulyResponsiveValue(resVal)) {
    return resVal;
  }

  var result = {
    $res: true
  };
  var activeNestedValue = undefined; // resValCopy has maximum breakpoint always set correctly, otherwise if we have b1, ..., b5 and responsive value is set to b4, then values ABOVE b4 won't be set.

  var resValCopy = _objectSpread$14({}, resVal);

  var maxDeviceInValue = responsiveValueGetHighestDefinedDevice(resValCopy, devices);
  var maxBreakpoint = devices[devices.length - 1].id; // Important condition. Sometimes if b5 is missing, b3 can be responsive and have b5 inside. Then b5 is defined.

  if (!resValCopy[maxBreakpoint] && isTrulyResponsiveValue(resValCopy[maxDeviceInValue.id])) {
    activeNestedValue = resValCopy[maxDeviceInValue.id];
  }

  for (var i = devices.length - 1; i >= 0; i--) {
    var breakpoint = devices[i].id;
    var value = resValCopy[breakpoint];

    if (value === undefined) {
      // If active nested value, we take from nested value;
      if (activeNestedValue !== undefined && activeNestedValue[breakpoint] !== undefined) {
        result[breakpoint] = responsiveValueGetDefinedValue(activeNestedValue, breakpoint, devices, getDevicesWidths(devices)
        /** FOR NOW TOKENS ARE ALWAYS RELATIVE TO SCREEN WIDTH */
        );
      }

      continue;
    } else if (!isTrulyResponsiveValue(value)) {
      activeNestedValue = undefined;
      result[breakpoint] = value;
    } else {
      activeNestedValue = value;
      result[breakpoint] = responsiveValueGetDefinedValue(activeNestedValue, breakpoint, devices, getDevicesWidths(devices)
      /** FOR NOW TOKENS ARE ALWAYS RELATIVE TO SCREEN WIDTH */
      );
    }
  }

  return result;
}

/**
 * Because of how `TrulyResponsiveValue` is typed, if we try to access value at the current breakpoint it would return `true | T | undefined`.
 * The literal type `true` in this type shouldn't be included, because it makes no sense.
 * This comes from definition of `$res` property which is a special property that marks given object as responsive value instead of normal object.
 */
function responsiveValueAt(responsiveValue, breakpointIndex) {
  if (breakpointIndex === "$res") {
    throw new Error("This situation isn't possible! Value of responsive value must be accessed by valid breakpoint name");
  }

  var breakpointValue = responsiveValue[breakpointIndex];
  return breakpointValue;
}

function getDefaultLocale(locales) {
  return locales.find(function (locale) {
    return locale.isDefault;
  });
}

function getFallbackLocaleForLocale(locale, locales) {
  do {
    var _locales$find$fallbac, _locales$find;

    var fallbackId = (_locales$find$fallbac = (_locales$find = locales.find(function (l) {
      return l.code === locale;
    })) === null || _locales$find === void 0 ? void 0 : _locales$find.fallback) !== null && _locales$find$fallbac !== void 0 ? _locales$find$fallbac : getDefaultLocale(locales).code; // Default locale, no fallback

    if (fallbackId === locale) {
      return;
    }

    return fallbackId;
  } while (true);
}

function getFallbackForLocale(translatedValues, locale, locales) {
  while (true) {
    var fallbackLocale = getFallbackLocaleForLocale(locale, locales);

    if (!fallbackLocale) {
      return;
    }

    var fallbackValue = translatedValues[fallbackLocale];

    if (fallbackValue !== undefined && fallbackValue !== null) {
      return fallbackValue;
    }

    locale = fallbackLocale;
  }
}

var textProvider = function textProvider(schemaProp, compilationContext) {
  var checkIfValid = function checkIfValid(x) {
    if (typeof x !== "object" || x === null) {
      return false;
    }

    if (typeof x.id !== "string") {
      return false;
    }

    if (x.id.startsWith("local.")) {
      // for local values "value" must be object
      if (typeof x.value !== "object" || x.value === null) {
        return false;
      }
    }

    return true;
  };

  return {
    normalize: function normalize(x) {
      if (x === undefined || x === null) {
        var _schemaProp$defaultVa;

        return {
          id: "local." + uniqueId(),
          value: _defineProperty$g({}, compilationContext.contextParams.locale, (_schemaProp$defaultVa = schemaProp.defaultValue) !== null && _schemaProp$defaultVa !== void 0 ? _schemaProp$defaultVa : "Lorem ipsum")
        };
      }

      if (checkIfValid(x)) {
        return x;
      }

      throw new Error("incorrect text type: ".concat(x));
    },
    compile: function compile(x) {
      if (x.id === null) {
        throw new Error("text cant be null");
      }

      if (!x.value) {
        throw new Error("text value cant be empty");
      }

      var value = x.value[compilationContext.contextParams.locale]; // Let's apply fallback when we're editing

      var editorContext = compilationContext;

      if (editorContext.locales && typeof value !== "string") {
        var _getFallbackForLocale;

        value = (_getFallbackForLocale = getFallbackForLocale(x.value, compilationContext.contextParams.locale, editorContext.locales)) !== null && _getFallbackForLocale !== void 0 ? _getFallbackForLocale : "";
      }

      return {
        id: x.id,
        value: value
      };
    },
    getHash: function getHash(value) {
      var _value$id;

      // TODO: those conditions will be removed after we merge external-local texts update
      if (typeof value === "string") {
        return value;
      }

      if (value === null) {
        return undefined;
      }

      return (_value$id = value.id) !== null && _value$id !== void 0 ? _value$id : undefined;
    }
  };
}; // const normalize = getNormalize(
//   compilationContext,
//   { value: schemaProp.defaultValue } as ExternalValue<string>,
//   { value: globalTextDefault } as ExternalValue<string>,
//   (x: any) => {
//     if (typeof x === "string") {
//       return {
//         id: "local." + uniqueId(), // temporary id
//         value: x,
//       };
//     }
//
//     if (typeof x === "object" && x !== null) {
//       if (typeof x.id === "string") {
//         return {
//           id: x.id,
//           value: x.value, // doesn't hurt
//           fallback: x.fallback,
//         };
//       }
//
//       if (typeof x.value === "string") {
//         return {
//           id: "local." + uniqueId(), // temporary id
//           value: x.value,
//           fallback: x.fallback,
//         };
//       }
//     }
//   }
// );

function bubbleDown(matcher, items) {
  var originalOrder = [];
  var bubbledDown = [];
  items.forEach(function (item) {
    if (matcher(item)) {
      bubbledDown.push(item);
    } else {
      originalOrder.push(item);
    }
  });
  return [].concat(originalOrder, bubbledDown);
}

function last(collection) {
  return collection[collection.length - 1];
}

function range(start, end) {
  var itemsCount = start === end ? 1 : end - start + 1;
  return Array.from({
    length: itemsCount
  }, function (_, index) {
    return start + index;
  });
}

/**
 * Returns a new function that filters nullable elements to be used as callback of `.filter` method.
 * It's useful because it has already defined guard which otherwise would be repeated in many places
 * and also it automatically changes the return value of filter function by extracting `null` and `undefined` types.
 *
 * Usage:
 * ```
 * const onlyNonNullable = nullableElements.filter<TypeOfCollectionItem>(nonNullable())
 * ```
 */
function nonNullable() {
  return function (value) {
    return value != null;
  };
}

function styles$l(values) {
  return {
    Root: box({
      display: "flex",
      justifyContent: mapAlignmentToFlexAlignment(values.align),
      textAlign: values.align
    }),
    elements: {
      // We store values within $richText to allow for changing them from sidebar, but we use them inside of $richTextBlockElement.
      itemProps: values.elements.map(function () {
        return {
          accessibilityRole: values.accessibilityRole,
          mainColor: values.mainColor,
          mainFont: values.mainFont,
          mainFontSize: values.mainFontSize,
          align: values.align
        };
      })
    },
    __props: {
      align: values.align
    }
  };
}
function mapAlignmentToFlexAlignment(align) {
  if (align === "center") {
    return "center";
  }

  if (align === "right") {
    return "flex-end";
  }

  return "flex-start";
}

function styles$k(values) {
  return {
    TextLine: box({
      lineHeight: "initial",
      wordBreak: "break-word"
    }, "div"),
    ListItem: box({
      display: "flex",
      justifyContent: mapAlignmentToFlexAlignment(values.align),
      alignItems: "baseline",
      paddingLeft: 0,
      lineHeight: "initial",
      wordBreak: "break-word",
      listStyle: "none",
      counterIncrement: "list-item",
      // Allows flex items to break when text is overflowing
      "& > *": {
        minWidth: 0
      }
    }, "li"),
    __props: {
      blockType: values.blockType
    }
  };
}

function ownKeys$14(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$13(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$14(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$14(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function textModifierSchemaProp(options) {
  return _objectSpread$13({
    type: "component",
    componentTypes: ["textModifier"],
    // Schema props of type "component" are hidden by default
    visible: true
  }, options);
}

function getTextModifierStyles(modifier, compilationContext) {
  var modifierStyles = {};
  var childStyles;

  if (modifier.length === 1) {
    var modifierDefinition = findComponentDefinitionById(modifier[0]._template, compilationContext);

    if (modifierDefinition) {
      var _modifierDefinition$c;

      modifierStyles = modifierDefinition.apply(modifier[0]);
      childStyles = (_modifierDefinition$c = modifierDefinition.childApply) === null || _modifierDefinition$c === void 0 ? void 0 : _modifierDefinition$c.call(modifierDefinition, modifier[0]);
    }
  }

  return {
    modifierStyles: modifierStyles,
    childStyles: childStyles
  };
}

function ownKeys$13(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$12(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$13(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$13(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function styles$j(_ref, t) {
  var action = _ref.action,
      elements = _ref.elements,
      actionTextModifier = _ref.actionTextModifier;
  var actionStyles = action.length > 0 ? {
    __action: "action",
    background: "transparent"
  } : {};

  var _getTextModifierStyle = getTextModifierStyles(actionTextModifier, t.compilationContext),
      modifierStyles = _getTextModifierStyle.modifierStyles,
      childStyles = _getTextModifierStyle.childStyles;

  var contextProps = childStyles !== undefined ? {
    elements: {
      itemProps: elements.map(function () {
        return {
          __modifierStyles: childStyles
        };
      })
    }
  } : {};
  return _objectSpread$12({
    Link: box(_objectSpread$12(_objectSpread$12({}, actionStyles), modifierStyles), t.compilationContext.isEditing ? "span" : "a")
  }, contextProps);
}

function ownKeys$12(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$11(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$12(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$12(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var optionalTextModifierSchemaProp = textModifierSchemaProp({
  prop: "textModifier",
  label: "Text modifier",
  group: "Text",
  visible: function visible(_ref) {
    var actionTextModifier = _ref.actionTextModifier;
    return actionTextModifier.length === 0;
  },
  defaultValue: []
});

var requiredActionTextModifierSchemaProp = _objectSpread$11(_objectSpread$11({}, optionalTextModifierSchemaProp), {}, {
  prop: "actionTextModifier",
  componentTypes: ["actionTextModifier"],
  required: true,
  label: "Link styles",
  group: "Action",
  visible: function visible(_ref2) {
    var action = _ref2.action;
    return action.length === 1;
  }
});

var richTextInlineWrapperElementEditableComponent = {
  id: "$richTextInlineWrapperElement",
  schema: [{
    prop: "elements",
    type: "component-collection",
    componentTypes: ["$richTextPart"]
  }, // optionalTextModifierSchemaProp,
  richTextInlineWrapperActionSchemaProp, requiredActionTextModifierSchemaProp],
  styles: styles$j,
  tags: ["notrace"]
};

var richTextLineElementEditableComponent = {
  id: "$richTextLineElement",
  schema: [{
    prop: "elements",
    type: "component-collection",
    componentTypes: [richTextPartEditableComponent.id, richTextInlineWrapperElementEditableComponent.id]
  }],
  styles: styles$k,
  tags: ["notrace"]
};

function ownKeys$11(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$10(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$11(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$11(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function px(value) {
  if (typeof value === "number") {
    return value === 0 ? "0" : "".concat(value, "px");
  }

  return value;
}

var BULLETED_LIST_MIN_INLINE_SPACING = 8;
var NUMBERED_LIST_MIN_COUNTER_SPACING = 8;
var NUMBERED_LIST_MAX_COUNTER_SPACING = "0.5ch";
/**
 * Numbered list consists of number and dot. We can safely calculate required space for number by
 * counting digits of list length and using `ch` unit. Dot character differentiate between fonts
 * and we reserve at least 0.5ch of space.
 */

var NUMBERED_LIST_DOT_CHARACTER_SAFE_WIDTH = "0.5ch";
var BULLET_CHARACTER = "\u2022";
function styles$i(_ref) {
  var accessibilityRole = _ref.accessibilityRole,
      align = _ref.align,
      elements = _ref.elements,
      mainColor = _ref.mainColor,
      mainFont = _ref.mainFont,
      mainFontSize = _ref.mainFontSize,
      type = _ref.type;
  var maxDigitsCount = elements.length.toString().length;
  var paddingInline = "clamp(".concat(px(BULLETED_LIST_MIN_INLINE_SPACING), ", calc(").concat(px(mainFontSize), " * 0.5), ").concat(px(mainFontSize), ")");
  var bulletedListMarkerStyles = {
    paddingLeft: paddingInline,
    paddingRight: paddingInline,
    content: BULLET_CHARACTER
  };
  var numberedListMarkerStyles = {
    minWidth: "calc(".concat(maxDigitsCount, " * 1ch + ").concat(NUMBERED_LIST_DOT_CHARACTER_SAFE_WIDTH, ")"),
    paddingRight: "clamp(".concat(px(NUMBERED_LIST_MIN_COUNTER_SPACING), ", 0.5ch, ").concat(NUMBERED_LIST_MAX_COUNTER_SPACING, ")"),
    fontVariantNumeric: "tabular-nums",
    textAlign: "right",
    content: "counter(list-item)\".\""
  };

  var markerStyles = _objectSpread$10({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 0,
    flexShrink: 0,
    fontSize: mainFontSize
  }, type === "bulleted-list" ? bulletedListMarkerStyles : numberedListMarkerStyles);

  var listStyles = _objectSpread$10(_objectSpread$10({
    counterSet: "list-item",
    paddingLeft: 0,
    listStyle: "none",
    color: mainColor
  }, mainFont), {}, {
    "& > li": _objectSpread$10(_objectSpread$10({
      color: mainColor
    }, mainFont), {}, {
      // Instead of using ::marker pseudo-element, we use ::before because it gives us more control over its appearance.
      "&::before": markerStyles
    })
  });

  return {
    Paragraph: box({}, accessibilityRole),
    BulletedList: box(listStyles, "ul"),
    NumberedList: box(listStyles, "ol"),
    elements: {
      itemProps: elements.map(function () {
        return {
          blockType: type,
          align: align
        };
      })
    },
    __props: {
      type: type
    }
  };
}

var RICH_TEXT_BLOCK_ELEMENT_TYPES = ["bulleted-list", "numbered-list", "paragraph"];
var RICH_TEXT_BLOCK_ELEMENT_TYPE_OPTIONS = [{
  value: RICH_TEXT_BLOCK_ELEMENT_TYPES[0],
  label: "Bulleted"
}, {
  value: RICH_TEXT_BLOCK_ELEMENT_TYPES[1],
  label: "Numbered"
}, {
  value: RICH_TEXT_BLOCK_ELEMENT_TYPES[2],
  label: "No list"
}];
var richTextBlockElementEditableComponent = {
  id: "$richTextBlockElement",
  schema: [{
    prop: "type",
    type: "select",
    options: RICH_TEXT_BLOCK_ELEMENT_TYPE_OPTIONS,
    defaultValue: RICH_TEXT_BLOCK_ELEMENT_TYPES[2],
    label: "Type",
    group: "Text"
  }, {
    prop: "elements",
    type: "component-collection",
    componentTypes: [richTextLineElementEditableComponent.id]
  }],
  styles: styles$i,
  tags: ["notrace"]
};

function ownKeys$10(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$$(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$10(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$10(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var richTextEditableComponent = {
  id: "$richText",
  schema: [{
    prop: "elements",
    type: "component-collection-localised",
    componentTypes: [richTextBlockElementEditableComponent.id],
    visible: false
  }, {
    prop: "accessibilityRole",
    type: "select",
    label: "Role",
    options: [{
      value: "div",
      label: "Paragraph"
    }].concat(_toConsumableArray$2(range(1, 6).map(function (index) {
      return {
        value: "h".concat(index),
        label: "Heading ".concat(index)
      };
    }))),
    group: "Accessibility and SEO"
  }, {
    prop: "isListStyleAuto",
    type: "boolean",
    label: "Auto list styles",
    defaultValue: true,
    visible: false,
    group: "Text"
  }, {
    prop: "mainFont",
    type: "font",
    label: "Main font",
    visible: false,
    group: "Text"
  }, {
    prop: "mainColor",
    type: "color",
    label: "Main color",
    visible: false,
    group: "Text"
  }],
  tags: ["item", "notrace"],
  styles: styles$l,
  editing: function editing(values, _ref, _ref2) {
    var fields = _ref.fields;
    var editorContext = _ref2.editorContext,
        pathPrefix = _ref2.pathPrefix;
    var richTextConfig = dotNotationGet(editorContext.form.values, pathPrefix);
    var richTextBlockPaths = configFindAllPaths(richTextConfig, editorContext, function (config) {
      return config._template === "$richTextBlockElement";
    });
    var richTextBlockPath = "".concat(pathPrefix, ".").concat(richTextBlockPaths[0]);
    var richTextBlockType = dotNotationGet(editorContext.form.values, "".concat(richTextBlockPath, ".type"));
    var accessibilityRoleFieldIndex = fields.findIndex(function (field) {
      return field.schemaProp.prop === "accessibilityRole";
    });
    var fieldsBeforeAccessibilityRole = fields.slice(0, accessibilityRoleFieldIndex);
    var listStyleField = {
      portal: "field",
      fieldName: "type",
      source: richTextBlockPath,
      overrides: {
        label: "List style",
        group: "Text"
      },
      hidden: richTextBlockPaths.length === 0
    };
    var fieldsAfterAccessibilityRole = fields.slice(accessibilityRoleFieldIndex).map(function (field) {
      if (richTextBlockType !== "paragraph") {
        if (field.schemaProp.prop === "accessibilityRole") {
          return _objectSpread$$(_objectSpread$$({}, field), {}, {
            hidden: true
          });
        }

        if (field.schemaProp.prop === "isListStyleAuto" && richTextBlockPaths.length > 0) {
          return _objectSpread$$(_objectSpread$$({}, field), {}, {
            hidden: false
          });
        }

        if (!values.isListStyleAuto && (field.schemaProp.prop === "mainFont" || field.schemaProp.prop === "mainColor")) {
          return _objectSpread$$(_objectSpread$$({}, field), {}, {
            hidden: false
          });
        }
      }

      return field;
    });
    var richTextPartPaths = configFindAllPaths(richTextConfig, editorContext, function (config) {
      return config._template === "$richTextPart";
    });
    var currentLocaleRichTextPartPaths = richTextPartPaths.filter(isRichTextPartPathForLocale(editorContext.contextParams.locale));

    if (currentLocaleRichTextPartPaths.length === 0) {
      var fallbackLocale = getFallbackLocaleForLocale(editorContext.contextParams.locale, editorContext.locales);

      if (fallbackLocale) {
        currentLocaleRichTextPartPaths = richTextPartPaths.filter(isRichTextPartPathForLocale(fallbackLocale));
      }
    }

    var richTextPartSources = currentLocaleRichTextPartPaths.map(function (path) {
      return "".concat(pathPrefix, ".").concat(path);
    });
    return {
      fields: [].concat(_toConsumableArray$2(fieldsBeforeAccessibilityRole), [{
        portal: "multi-field",
        fieldName: "font",
        sources: richTextPartSources,
        hidden: richTextPartSources.length === 0
      }, {
        portal: "multi-field",
        fieldName: "color",
        sources: richTextPartSources,
        hidden: richTextPartSources.length === 0
      }, listStyleField], _toConsumableArray$2(fieldsAfterAccessibilityRole)).filter(nonNullable())
    };
  }
};

function isRichTextPartPathForLocale(locale) {
  return function innerIsLocalizedRichTextPart(richTextPartConfigPath) {
    return richTextPartConfigPath.startsWith("elements.".concat(locale));
  };
}

function ownKeys$$(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$_(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$$(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$$(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Returns the most common value for given `prop` parameter among all $richTextPart components from `richTextComponentConfig`.
 */

function getMostCommonValueFromRichTextParts(richTextComponentConfig, prop, compilationContext, cache) {
  var richTextBlockElements = richTextComponentConfig.elements[compilationContext.contextParams.locale];

  if (compilationContext.isEditing && !richTextBlockElements) {
    richTextBlockElements = getFallbackForLocale(richTextComponentConfig.elements, compilationContext.contextParams.locale, compilationContext.locales);
  }

  if (!richTextBlockElements) {
    return;
  }

  var richTextParts = richTextBlockElements.flatMap(function (blockElement) {
    return blockElement.elements.flatMap(function (lineElement) {
      return lineElement.elements.flatMap(function (child) {
        if (child._template === richTextInlineWrapperElementEditableComponent.id) {
          return child.elements;
        }

        return child;
      });
    });
  });
  var richTextPartComponentDefinition = findComponentDefinitionById(richTextPartEditableComponent.id, compilationContext);
  var deviceIdToRichTextPartValuesGroupedByPropValue = Object.fromEntries(compilationContext.devices.map(function (device) {
    var richTextPartsCompiledPropValues = richTextParts.flatMap(function (richTextPart) {
      return mapRichTextPartToCompiledPropValue(richTextPart, richTextPartComponentDefinition, compilationContext, prop, cache);
    });
    var richTextPartValuesLengthGroupedByPropValue = richTextPartsCompiledPropValues.reduce(function (acc, current) {
      return groupTotalValueLengthByCompiledPropValue(prop, device)(acc, current);
    }, {});
    return [device.id, richTextPartValuesLengthGroupedByPropValue];
  }).filter(function (entry) {
    return Object.keys(entry[1]).length > 0;
  }).map(function (entry) {
    return [entry[0], getCompiledValueFromEntryWithMaxTotalValueLength(entry)];
  }));

  if (Object.keys(deviceIdToRichTextPartValuesGroupedByPropValue).length === 0) {
    return;
  }

  return _objectSpread$_({
    $res: true
  }, deviceIdToRichTextPartValuesGroupedByPropValue);
}

function getCompiledValueFromEntryWithMaxTotalValueLength(entry) {
  var compiledPropValue = entries(entry[1]).reduce(function (maxEntry, currentEntry) {
    return currentEntry[1] > maxEntry[1] ? currentEntry : maxEntry;
  })[0];

  try {
    return JSON.parse(compiledPropValue);
  } catch (_unused) {
    return compiledPropValue;
  }
}

function groupTotalValueLengthByCompiledPropValue(prop, device) {
  return function (acc, current) {
    var key = JSON.stringify(current[prop][device.id]);

    if (key === undefined) {
      return acc;
    }

    if (!acc[key]) {
      acc[key] = 0;
    }

    acc[key] += current.value.length;
    return acc;
  };
}

function mapRichTextPartToCompiledPropValue(richTextPart, richTextPartComponentDefinition, compilationContext, prop, cache) {
  var compiledValues = compileComponentValues(richTextPart, richTextPartComponentDefinition, compilationContext, cache);
  return _defineProperty$g({
    value: richTextPart.value
  }, prop, compiledValues[prop]);
}

function areWidthsFullyDefined(widths, devices) {
  var areWidthsFullyDefined = true;
  devices.forEach(function (device) {
    if (widths[device.id] === -1) {
      areWidthsFullyDefined = false;
    }
  });
  return areWidthsFullyDefined;
}

function ownKeys$_(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$Z(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$_(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$_(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function responsiveValueFill(value, devices, widths) {
  if (!isTrulyResponsiveValue(value)) {
    return value;
  }

  var componentWidths = getDeviceWidthPairs(widths, devices);

  var result = _objectSpread$Z({}, value);

  componentWidths.forEach(function (_ref, index) {
    _ref.width;
        var deviceId = _ref.deviceId;

    if (result[deviceId] === undefined) {
      // Let's look for a value up
      for (var i = index + 1; i < componentWidths.length; i++) {
        var valueForHigherWidth = result[componentWidths[i].deviceId];

        if (valueForHigherWidth !== undefined) {
          result[deviceId] = valueForHigherWidth;
          break;
        }
      } // If still undefined, let's look for a value down


      if (result[deviceId] === undefined) {
        for (var _i = index - 1; _i >= 0; _i--) {
          var valueForLowerWidth = result[componentWidths[_i].deviceId];

          if (valueForLowerWidth !== undefined) {
            result[deviceId] = valueForLowerWidth;
            break;
          }
        }
      }

      if (result[deviceId] === undefined) {
        throw new Error("Can't fill");
      }
    }
  });
  return result;
}

var dist$1 = {exports: {}};

var openParentheses = "(".charCodeAt(0);
var closeParentheses = ")".charCodeAt(0);
var singleQuote$1 = "'".charCodeAt(0);
var doubleQuote$1 = '"'.charCodeAt(0);
var backslash = "\\".charCodeAt(0);
var slash = "/".charCodeAt(0);
var comma = ",".charCodeAt(0);
var colon = ":".charCodeAt(0);
var star = "*".charCodeAt(0);

var parse$6 = function (input) {
  var tokens = [];
  var value = input;
  var next, quote, prev, token, escape, escapePos, whitespacePos;
  var pos = 0;
  var code = value.charCodeAt(pos);
  var max = value.length;
  var stack = [{
    nodes: tokens
  }];
  var balanced = 0;
  var parent;
  var name = "";
  var before = "";
  var after = "";

  while (pos < max) {
    // Whitespaces
    if (code <= 32) {
      next = pos;

      do {
        next += 1;
        code = value.charCodeAt(next);
      } while (code <= 32);

      token = value.slice(pos, next);
      prev = tokens[tokens.length - 1];

      if (code === closeParentheses && balanced) {
        after = token;
      } else if (prev && prev.type === "div") {
        prev.after = token;
      } else if (code === comma || code === colon || code === slash && value.charCodeAt(next + 1) !== star) {
        before = token;
      } else {
        tokens.push({
          type: "space",
          sourceIndex: pos,
          value: token
        });
      }

      pos = next; // Quotes
    } else if (code === singleQuote$1 || code === doubleQuote$1) {
      next = pos;
      quote = code === singleQuote$1 ? "'" : '"';
      token = {
        type: "string",
        sourceIndex: pos,
        quote: quote
      };

      do {
        escape = false;
        next = value.indexOf(quote, next + 1);

        if (~next) {
          escapePos = next;

          while (value.charCodeAt(escapePos - 1) === backslash) {
            escapePos -= 1;
            escape = !escape;
          }
        } else {
          value += quote;
          next = value.length - 1;
          token.unclosed = true;
        }
      } while (escape);

      token.value = value.slice(pos + 1, next);
      tokens.push(token);
      pos = next + 1;
      code = value.charCodeAt(pos); // Comments
    } else if (code === slash && value.charCodeAt(pos + 1) === star) {
      token = {
        type: "comment",
        sourceIndex: pos
      };
      next = value.indexOf("*/", pos);

      if (next === -1) {
        token.unclosed = true;
        next = value.length;
      }

      token.value = value.slice(pos + 2, next);
      tokens.push(token);
      pos = next + 2;
      code = value.charCodeAt(pos); // Dividers
    } else if (code === slash || code === comma || code === colon) {
      token = value[pos];
      tokens.push({
        type: "div",
        sourceIndex: pos - before.length,
        value: token,
        before: before,
        after: ""
      });
      before = "";
      pos += 1;
      code = value.charCodeAt(pos); // Open parentheses
    } else if (openParentheses === code) {
      // Whitespaces after open parentheses
      next = pos;

      do {
        next += 1;
        code = value.charCodeAt(next);
      } while (code <= 32);

      token = {
        type: "function",
        sourceIndex: pos - name.length,
        value: name,
        before: value.slice(pos + 1, next)
      };
      pos = next;

      if (name === "url" && code !== singleQuote$1 && code !== doubleQuote$1) {
        next -= 1;

        do {
          escape = false;
          next = value.indexOf(")", next + 1);

          if (~next) {
            escapePos = next;

            while (value.charCodeAt(escapePos - 1) === backslash) {
              escapePos -= 1;
              escape = !escape;
            }
          } else {
            value += ")";
            next = value.length - 1;
            token.unclosed = true;
          }
        } while (escape); // Whitespaces before closed


        whitespacePos = next;

        do {
          whitespacePos -= 1;
          code = value.charCodeAt(whitespacePos);
        } while (code <= 32);

        if (pos !== whitespacePos + 1) {
          token.nodes = [{
            type: "word",
            sourceIndex: pos,
            value: value.slice(pos, whitespacePos + 1)
          }];
        } else {
          token.nodes = [];
        }

        if (token.unclosed && whitespacePos + 1 !== next) {
          token.after = "";
          token.nodes.push({
            type: "space",
            sourceIndex: whitespacePos + 1,
            value: value.slice(whitespacePos + 1, next)
          });
        } else {
          token.after = value.slice(whitespacePos + 1, next);
        }

        pos = next + 1;
        code = value.charCodeAt(pos);
        tokens.push(token);
      } else {
        balanced += 1;
        token.after = "";
        tokens.push(token);
        stack.push(token);
        tokens = token.nodes = [];
        parent = token;
      }

      name = ""; // Close parentheses
    } else if (closeParentheses === code && balanced) {
      pos += 1;
      code = value.charCodeAt(pos);
      parent.after = after;
      after = "";
      balanced -= 1;
      stack.pop();
      parent = stack[balanced];
      tokens = parent.nodes; // Words
    } else {
      next = pos;

      do {
        if (code === backslash) {
          next += 1;
        }

        next += 1;
        code = value.charCodeAt(next);
      } while (next < max && !(code <= 32 || code === singleQuote$1 || code === doubleQuote$1 || code === comma || code === colon || code === slash || code === openParentheses || code === closeParentheses && balanced));

      token = value.slice(pos, next);

      if (openParentheses === code) {
        name = token;
      } else {
        tokens.push({
          type: "word",
          sourceIndex: pos,
          value: token
        });
      }

      pos = next;
    }
  }

  for (pos = stack.length - 1; pos; pos -= 1) {
    stack[pos].unclosed = true;
  }

  return stack[0].nodes;
};

var walk$1 = function walk(nodes, cb, bubble) {
  var i, max, node, result;

  for (i = 0, max = nodes.length; i < max; i += 1) {
    node = nodes[i];

    if (!bubble) {
      result = cb(node, i, nodes);
    }

    if (result !== false && node.type === "function" && Array.isArray(node.nodes)) {
      walk(node.nodes, cb, bubble);
    }

    if (bubble) {
      cb(node, i, nodes);
    }
  }
};

function stringifyNode(node, custom) {
  var type = node.type;
  var value = node.value;
  var buf;
  var customResult;

  if (custom && (customResult = custom(node)) !== undefined) {
    return customResult;
  } else if (type === "word" || type === "space") {
    return value;
  } else if (type === "string") {
    buf = node.quote || "";
    return buf + value + (node.unclosed ? "" : buf);
  } else if (type === "comment") {
    return "/*" + value + (node.unclosed ? "" : "*/");
  } else if (type === "div") {
    return (node.before || "") + value + (node.after || "");
  } else if (Array.isArray(node.nodes)) {
    buf = stringify$4(node.nodes);

    if (type !== "function") {
      return buf;
    }

    return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
  }

  return value;
}

function stringify$4(nodes, custom) {
  var result, i;

  if (Array.isArray(nodes)) {
    result = "";

    for (i = nodes.length - 1; ~i; i -= 1) {
      result = stringifyNode(nodes[i], custom) + result;
    }

    return result;
  }

  return stringifyNode(nodes, custom);
}

var stringify_1$1 = stringify$4;

var minus = "-".charCodeAt(0);
var plus = "+".charCodeAt(0);
var dot = ".".charCodeAt(0);
var exp = "e".charCodeAt(0);
var EXP = "E".charCodeAt(0);

var unit = function (value) {
  var pos = 0;
  var length = value.length;
  var dotted = false;
  var sciPos = -1;
  var containsNumber = false;
  var code;

  while (pos < length) {
    code = value.charCodeAt(pos);

    if (code >= 48 && code <= 57) {
      containsNumber = true;
    } else if (code === exp || code === EXP) {
      if (sciPos > -1) {
        break;
      }

      sciPos = pos;
    } else if (code === dot) {
      if (dotted) {
        break;
      }

      dotted = true;
    } else if (code === plus || code === minus) {
      if (pos !== 0) {
        break;
      }
    } else {
      break;
    }

    pos += 1;
  }

  if (sciPos + 1 === pos) pos--;
  return containsNumber ? {
    number: value.slice(0, pos),
    unit: value.slice(pos)
  } : false;
};

var parse$5 = parse$6;

var walk = walk$1;

var stringify$3 = stringify_1$1;

function ValueParser(value) {
  if (this instanceof ValueParser) {
    this.nodes = parse$5(value);
    return this;
  }

  return new ValueParser(value);
}

ValueParser.prototype.toString = function () {
  return Array.isArray(this.nodes) ? stringify$3(this.nodes) : "";
};

ValueParser.prototype.walk = function (cb, bubble) {
  walk(this.nodes, cb, bubble);
  return this;
};

ValueParser.unit = unit;
ValueParser.walk = walk;
ValueParser.stringify = stringify$3;
var lib$2 = ValueParser;

var parser = {};

/* parser generated by jison 0.6.1-215 */

(function (exports) {
/*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */
var parser = function () {
  // See also:
  // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
  // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
  // with userland code which might access the derived class in a 'classic' way.
  function JisonParserError(msg, hash) {
    Object.defineProperty(this, 'name', {
      enumerable: false,
      writable: false,
      value: 'JisonParserError'
    });
    if (msg == null) msg = '???';
    Object.defineProperty(this, 'message', {
      enumerable: false,
      writable: true,
      value: msg
    });
    this.hash = hash;
    var stacktrace;

    if (hash && hash.exception instanceof Error) {
      var ex2 = hash.exception;
      this.message = ex2.message || msg;
      stacktrace = ex2.stack;
    }

    if (!stacktrace) {
      if (Error.hasOwnProperty('captureStackTrace')) {
        // V8/Chrome engine
        Error.captureStackTrace(this, this.constructor);
      } else {
        stacktrace = new Error(msg).stack;
      }
    }

    if (stacktrace) {
      Object.defineProperty(this, 'stack', {
        enumerable: false,
        writable: false,
        value: stacktrace
      });
    }
  }

  if (typeof Object.setPrototypeOf === 'function') {
    Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
  } else {
    JisonParserError.prototype = Object.create(Error.prototype);
  }

  JisonParserError.prototype.constructor = JisonParserError;
  JisonParserError.prototype.name = 'JisonParserError'; // helper: reconstruct the productions[] table

  function bp(s) {
    var rv = [];
    var p = s.pop;
    var r = s.rule;

    for (var i = 0, l = p.length; i < l; i++) {
      rv.push([p[i], r[i]]);
    }

    return rv;
  } // helper: reconstruct the defaultActions[] table


  function bda(s) {
    var rv = {};
    var d = s.idx;
    var g = s["goto"];

    for (var i = 0, l = d.length; i < l; i++) {
      var j = d[i];
      rv[j] = g[i];
    }

    return rv;
  } // helper: reconstruct the 'goto' table


  function bt(s) {
    var rv = [];
    var d = s.len;
    var y = s.symbol;
    var t = s.type;
    var a = s.state;
    var m = s.mode;
    var g = s["goto"];

    for (var i = 0, l = d.length; i < l; i++) {
      var n = d[i];
      var q = {};

      for (var j = 0; j < n; j++) {
        var z = y.shift();

        switch (t.shift()) {
          case 2:
            q[z] = [m.shift(), g.shift()];
            break;

          case 0:
            q[z] = a.shift();
            break;

          default:
            // type === 1: accept
            q[z] = [3];
        }
      }

      rv.push(q);
    }

    return rv;
  } // helper: runlength encoding with increment step: code, length: step (default step = 0)
  // `this` references an array


  function s(c, l, a) {
    a = a || 0;

    for (var i = 0; i < l; i++) {
      this.push(c);
      c += a;
    }
  } // helper: duplicate sequence from *relative* offset and length.
  // `this` references an array


  function c(i, l) {
    i = this.length - i;

    for (l += i; i < l; i++) {
      this.push(this[i]);
    }
  } // helper: unpack an array using helpers and data, all passed in an array argument 'a'.


  function u(a) {
    var rv = [];

    for (var i = 0, l = a.length; i < l; i++) {
      var e = a[i]; // Is this entry a helper function?

      if (typeof e === 'function') {
        i++;
        e.apply(rv, a[i]);
      } else {
        rv.push(e);
      }
    }

    return rv;
  }

  var parser = {
    // Code Generator Information Report
    // ---------------------------------
    //
    // Options:
    //
    //   default action mode: ............. ["classic","merge"]
    //   test-compile action mode: ........ "parser:*,lexer:*"
    //   try..catch: ...................... true
    //   default resolve on conflict: ..... true
    //   on-demand look-ahead: ............ false
    //   error recovery token skip maximum: 3
    //   yyerror in parse actions is: ..... NOT recoverable,
    //   yyerror in lexer actions and other non-fatal lexer are:
    //   .................................. NOT recoverable,
    //   debug grammar/output: ............ false
    //   has partial LR conflict upgrade:   true
    //   rudimentary token-stack support:   false
    //   parser table compression mode: ... 2
    //   export debug tables: ............. false
    //   export *all* tables: ............. false
    //   module type: ..................... commonjs
    //   parser engine type: .............. lalr
    //   output main() in the module: ..... true
    //   has user-specified main(): ....... false
    //   has user-specified require()/import modules for main():
    //   .................................. false
    //   number of expected conflicts: .... 0
    //
    //
    // Parser Analysis flags:
    //
    //   no significant actions (parser is a language matcher only):
    //   .................................. false
    //   uses yyleng: ..................... false
    //   uses yylineno: ................... false
    //   uses yytext: ..................... false
    //   uses yylloc: ..................... false
    //   uses ParseError API: ............. false
    //   uses YYERROR: .................... false
    //   uses YYRECOVERING: ............... false
    //   uses YYERROK: .................... false
    //   uses YYCLEARIN: .................. false
    //   tracks rule values: .............. true
    //   assigns rule values: ............. true
    //   uses location tracking: .......... false
    //   assigns location: ................ false
    //   uses yystack: .................... false
    //   uses yysstack: ................... false
    //   uses yysp: ....................... true
    //   uses yyrulelength: ............... false
    //   uses yyMergeLocationInfo API: .... false
    //   has error recovery: .............. false
    //   has error reporting: ............. false
    //
    // --------- END OF REPORT -----------
    trace: function no_op_trace() {},
    JisonParserError: JisonParserError,
    yy: {},
    options: {
      type: "lalr",
      hasPartialLrUpgradeOnConflict: true,
      errorRecoveryTokenDiscardCount: 3
    },
    symbols_: {
      "$accept": 0,
      "$end": 1,
      "ADD": 3,
      "ANGLE": 18,
      "CHS": 24,
      "COMMA": 11,
      "CSS_CPROP": 16,
      "CSS_VAR": 15,
      "DIV": 6,
      "EMS": 22,
      "EOF": 1,
      "EXS": 23,
      "FREQ": 20,
      "LENGTH": 17,
      "LPAREN": 7,
      "MAX": 10,
      "MIN": 12,
      "MUL": 5,
      "NESTED_CALC": 9,
      "NUMBER": 14,
      "PERCENTAGE": 30,
      "PREFIX": 13,
      "REMS": 25,
      "RES": 21,
      "RPAREN": 8,
      "SUB": 4,
      "TIME": 19,
      "VHS": 26,
      "VMAXS": 29,
      "VMINS": 28,
      "VWS": 27,
      "css_value": 35,
      "css_variable": 34,
      "error": 2,
      "expression": 31,
      "math_expression": 32,
      "value": 33
    },
    terminals_: {
      1: "EOF",
      2: "error",
      3: "ADD",
      4: "SUB",
      5: "MUL",
      6: "DIV",
      7: "LPAREN",
      8: "RPAREN",
      9: "NESTED_CALC",
      10: "MAX",
      11: "COMMA",
      12: "MIN",
      13: "PREFIX",
      14: "NUMBER",
      15: "CSS_VAR",
      16: "CSS_CPROP",
      17: "LENGTH",
      18: "ANGLE",
      19: "TIME",
      20: "FREQ",
      21: "RES",
      22: "EMS",
      23: "EXS",
      24: "CHS",
      25: "REMS",
      26: "VHS",
      27: "VWS",
      28: "VMINS",
      29: "VMAXS",
      30: "PERCENTAGE"
    },
    TERROR: 2,
    EOF: 1,
    // internals: defined here so the object *structure* doesn't get modified by parse() et al,
    // thus helping JIT compilers like Chrome V8.
    originalQuoteName: null,
    originalParseError: null,
    cleanupAfterParse: null,
    constructParseErrorInfo: null,
    yyMergeLocationInfo: null,
    __reentrant_call_depth: 0,
    // INTERNAL USE ONLY
    __error_infos: [],
    // INTERNAL USE ONLY: the set of parseErrorInfo objects created since the last cleanup
    __error_recovery_infos: [],
    // INTERNAL USE ONLY: the set of parseErrorInfo objects created since the last cleanup
    // APIs which will be set up depending on user action code analysis:
    //yyRecovering: 0,
    //yyErrOk: 0,
    //yyClearIn: 0,
    // Helper APIs
    // -----------
    // Helper function which can be overridden by user code later on: put suitable quotes around
    // literal IDs in a description string.
    quoteName: function parser_quoteName(id_str) {
      return '"' + id_str + '"';
    },
    // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
    //
    // Return NULL when the symbol is unknown to the parser.
    getSymbolName: function parser_getSymbolName(symbol) {
      if (this.terminals_[symbol]) {
        return this.terminals_[symbol];
      } // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
      //
      // An example of this may be where a rule's action code contains a call like this:
      //
      //      parser.getSymbolName(#$)
      //
      // to obtain a human-readable name of the current grammar rule.


      var s = this.symbols_;

      for (var key in s) {
        if (s[key] === symbol) {
          return key;
        }
      }

      return null;
    },
    // Return a more-or-less human-readable description of the given symbol, when available,
    // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
    //
    // Return NULL when the symbol is unknown to the parser.
    describeSymbol: function parser_describeSymbol(symbol) {
      if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) {
        return this.terminal_descriptions_[symbol];
      } else if (symbol === this.EOF) {
        return 'end of input';
      }

      var id = this.getSymbolName(symbol);

      if (id) {
        return this.quoteName(id);
      }

      return null;
    },
    // Produce a (more or less) human-readable list of expected tokens at the point of failure.
    //
    // The produced list may contain token or token set descriptions instead of the tokens
    // themselves to help turning this output into something that easier to read by humans
    // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
    // expected terminals and nonterminals is produced.
    //
    // The returned list (array) will not contain any duplicate entries.
    collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
      var TERROR = this.TERROR;
      var tokenset = [];
      var check = {}; // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
      // If so, use that one instead of the less palatable token set.

      if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) {
        return [this.state_descriptions_[state]];
      }

      for (var p in this.table[state]) {
        p = +p;

        if (p !== TERROR) {
          var d = do_not_describe ? p : this.describeSymbol(p);

          if (d && !check[d]) {
            tokenset.push(d);
            check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
          }
        }
      }

      return tokenset;
    },
    productions_: bp({
      pop: u([31, s, [32, 12], 33, 33, 34, 34, s, [35, 15]]),
      rule: u([2, s, [3, 5], 4, 6, 6, 7, s, [1, 4], 2, 4, 6, s, [1, 14], 2])
    }),
    performAction: function parser__PerformAction(yystate
    /* action[1] */
    , yysp, yyvstack) {
      /* this == yyval */
      // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
      var yy = this.yy;
      yy.parser;
      yy.lexer;

      switch (yystate) {
        case 0:
          /*! Production::    $accept : expression $end */
          // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
          this.$ = yyvstack[yysp - 1]; // END of default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-)

          break;

        case 1:
          /*! Production::    expression : math_expression EOF */
          // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
          this.$ = yyvstack[yysp - 1]; // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)

          return yyvstack[yysp - 1];

        case 2:
        /*! Production::    math_expression : math_expression ADD math_expression */

        case 3:
        /*! Production::    math_expression : math_expression SUB math_expression */

        case 4:
        /*! Production::    math_expression : math_expression MUL math_expression */

        case 5:
          /*! Production::    math_expression : math_expression DIV math_expression */
          this.$ = {
            type: 'MathExpression',
            operator: yyvstack[yysp - 1],
            left: yyvstack[yysp - 2],
            right: yyvstack[yysp]
          };
          break;

        case 6:
          /*! Production::    math_expression : LPAREN math_expression RPAREN */
          this.$ = yyvstack[yysp - 1];
          break;

        case 7:
          /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */
          this.$ = {
            type: 'Calc',
            value: yyvstack[yysp - 1]
          };
          break;

        case 8:
          /*! Production::    math_expression : MAX LPAREN math_expression COMMA math_expression RPAREN */
          this.$ = {
            type: 'MathExpression',
            operator: 'max',
            left: yyvstack[yysp - 3],
            right: yyvstack[yysp - 1]
          };
          break;

        case 9:
          /*! Production::    math_expression : MIN LPAREN math_expression COMMA math_expression RPAREN */
          this.$ = {
            type: 'MathExpression',
            operator: 'min',
            left: yyvstack[yysp - 3],
            right: yyvstack[yysp - 1]
          };
          break;

        case 10:
          /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */
          this.$ = {
            type: 'Calc',
            value: yyvstack[yysp - 1],
            prefix: yyvstack[yysp - 5]
          };
          break;

        case 11:
        /*! Production::    math_expression : css_variable */

        case 12:
        /*! Production::    math_expression : css_value */

        case 13:
          /*! Production::    math_expression : value */
          this.$ = yyvstack[yysp];
          break;

        case 14:
          /*! Production::    value : NUMBER */
          this.$ = {
            type: 'Value',
            value: parseFloat(yyvstack[yysp])
          };
          break;

        case 15:
          /*! Production::    value : SUB NUMBER */
          this.$ = {
            type: 'Value',
            value: parseFloat(yyvstack[yysp]) * -1
          };
          break;

        case 16:
          /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */
          this.$ = {
            type: 'CssVariable',
            value: yyvstack[yysp - 1]
          };
          break;

        case 17:
          /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */
          this.$ = {
            type: 'CssVariable',
            value: yyvstack[yysp - 3],
            fallback: yyvstack[yysp - 1]
          };
          break;

        case 18:
          /*! Production::    css_value : LENGTH */
          this.$ = {
            type: 'LengthValue',
            value: parseFloat(yyvstack[yysp]),
            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
          };
          break;

        case 19:
          /*! Production::    css_value : ANGLE */
          this.$ = {
            type: 'AngleValue',
            value: parseFloat(yyvstack[yysp]),
            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
          };
          break;

        case 20:
          /*! Production::    css_value : TIME */
          this.$ = {
            type: 'TimeValue',
            value: parseFloat(yyvstack[yysp]),
            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
          };
          break;

        case 21:
          /*! Production::    css_value : FREQ */
          this.$ = {
            type: 'FrequencyValue',
            value: parseFloat(yyvstack[yysp]),
            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
          };
          break;

        case 22:
          /*! Production::    css_value : RES */
          this.$ = {
            type: 'ResolutionValue',
            value: parseFloat(yyvstack[yysp]),
            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
          };
          break;

        case 23:
          /*! Production::    css_value : EMS */
          this.$ = {
            type: 'EmValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'em'
          };
          break;

        case 24:
          /*! Production::    css_value : EXS */
          this.$ = {
            type: 'ExValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'ex'
          };
          break;

        case 25:
          /*! Production::    css_value : CHS */
          this.$ = {
            type: 'ChValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'ch'
          };
          break;

        case 26:
          /*! Production::    css_value : REMS */
          this.$ = {
            type: 'RemValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'rem'
          };
          break;

        case 27:
          /*! Production::    css_value : VHS */
          this.$ = {
            type: 'VhValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'vh'
          };
          break;

        case 28:
          /*! Production::    css_value : VWS */
          this.$ = {
            type: 'VwValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'vw'
          };
          break;

        case 29:
          /*! Production::    css_value : VMINS */
          this.$ = {
            type: 'VminValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'vmin'
          };
          break;

        case 30:
          /*! Production::    css_value : VMAXS */
          this.$ = {
            type: 'VmaxValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'vmax'
          };
          break;

        case 31:
          /*! Production::    css_value : PERCENTAGE */
          this.$ = {
            type: 'PercentageValue',
            value: parseFloat(yyvstack[yysp]),
            unit: '%'
          };
          break;

        case 32:
          /*! Production::    css_value : SUB css_value */
          var prev = yyvstack[yysp];
          prev.value *= -1;
          this.$ = prev;
          break;
      }
    },
    table: bt({
      len: u([26, 1, 5, 25, s, [1, 3], 18, s, [0, 3], 1, s, [0, 16], s, [25, 4], 5, s, [25, 3], c, [25, 3], 16, 1, 7, 7, s, [0, 3], s, [5, 3], 1, 2, c, [24, 3], 1, 0, 25, 5, 5, 25, 5, c, [17, 3], 0, 0]),
      symbol: u([4, 7, 9, 10, 12, 14, 15, s, [17, 19, 1], 1, 1, s, [3, 4, 1], c, [32, 21], c, [31, 4], s, [7, 3], 4, 13, 14, c, [24, 14], 35, 7, c, [47, 25], c, [25, 75], c, [151, 4], 8, c, [105, 76], 4, c, [198, 15], 16, c, [250, 5], 8, 11, c, [7, 7], c, [6, 5], c, [5, 4], c, [10, 5], 11, 9, 8, 11, c, [100, 50], c, [281, 26], c, [94, 9], c, [211, 26], c, [35, 10]]),
      type: u([s, [2, 21], s, [0, 5], 1, s, [2, 26], s, [0, 4], c, [24, 21], c, [47, 46], c, [25, 76], c, [80, 75], c, [97, 27], s, [2, 28], c, [180, 51], c, [206, 30], c, [35, 19]]),
      state: u([1, 2, 10, 8, 9, 32, c, [4, 3], 37, 41, c, [5, 3], 42, c, [4, 3], 43, c, [4, 3], 44, c, [4, 3], 46, c, [4, 3], 47, c, [4, 3], 48, c, [29, 4], 57, c, [5, 3], 58, c, [4, 3], 60, c, [4, 3], 63, c, [4, 3]]),
      mode: u([s, [1, 237], s, [2, 3], c, [5, 5], c, [7, 6], s, [1, 123]]),
      "goto": u([7, s, [3, 4, 1], 26, s, [11, 15, 1], s, [27, 5, 1], c, [26, 21], 33, 34, 35, 39, 36, 38, c, [20, 14], 40, c, [42, 21], c, [21, 63], c, [130, 4], 45, c, [68, 63], 49, 39, c, [16, 14], 50, s, [2, 3], 30, 31, 2, 2, s, [3, 3], 30, 31, 3, 3, c, [99, 4], 51, c, [5, 4], 52, c, [5, 4], s, [53, 4, 1], c, [91, 42], 59, c, [181, 25], 61, c, [5, 4], 62, c, [31, 25], 64, c, [5, 4], 65])
    }),
    defaultActions: bda({
      idx: u([8, 9, 10, s, [12, 16, 1], 37, 38, 43, 44, 45, 51, 55, 61, 62, 64, 65]),
      "goto": u([11, 12, 13, s, [18, 14, 1], 14, 1, 32, 15, s, [4, 4, 1], 16, 8, 9, 17, 10])
    }),
    parseError: function parseError(str, hash, ExceptionClass) {
      if (hash.recoverable) {
        if (typeof this.trace === 'function') {
          this.trace(str);
        }

        hash.destroy(); // destroy... well, *almost*!
      } else {
        if (typeof this.trace === 'function') {
          this.trace(str);
        }

        if (!ExceptionClass) {
          ExceptionClass = this.JisonParserError;
        }

        throw new ExceptionClass(str, hash);
      }
    },
    parse: function parse(input) {
      var self = this;
      var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)

      var sstack = new Array(128); // state stack: stores states (column storage)

      var vstack = new Array(128); // semantic value stack

      var table = this.table;
      var sp = 0; // 'stack pointer': index into the stacks

      var symbol = 0;
      this.TERROR;
      var EOF = this.EOF;
      this.options.errorRecoveryTokenDiscardCount | 0 || 3;
      var NO_ACTION = [0, 66
      /* === table.length :: ensures that anyone using this new state will fail dramatically! */
      ];
      var lexer;

      if (this.__lexer__) {
        lexer = this.__lexer__;
      } else {
        lexer = this.__lexer__ = Object.create(this.lexer);
      }

      var sharedState_yy = {
        parseError: undefined,
        quoteName: undefined,
        lexer: undefined,
        parser: undefined,
        pre_parse: undefined,
        post_parse: undefined,
        pre_lex: undefined,
        post_lex: undefined // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!

      };

      if (typeof assert !== 'function') ; else {
        assert;
      }

      this.yyGetSharedState = function yyGetSharedState() {
        return sharedState_yy;
      };

      function shallow_copy_noclobber(dst, src) {
        for (var k in src) {
          if (typeof dst[k] === 'undefined' && Object.prototype.hasOwnProperty.call(src, k)) {
            dst[k] = src[k];
          }
        }
      } // copy state


      shallow_copy_noclobber(sharedState_yy, this.yy);
      sharedState_yy.lexer = lexer;
      sharedState_yy.parser = this; // Does the shared state override the default `parseError` that already comes with this instance?

      if (typeof sharedState_yy.parseError === 'function') {
        this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
          if (!ExceptionClass) {
            ExceptionClass = this.JisonParserError;
          }

          return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
        };
      } else {
        this.parseError = this.originalParseError;
      } // Does the shared state override the default `quoteName` that already comes with this instance?


      if (typeof sharedState_yy.quoteName === 'function') {
        this.quoteName = function quoteNameAlt(id_str) {
          return sharedState_yy.quoteName.call(this, id_str);
        };
      } else {
        this.quoteName = this.originalQuoteName;
      } // set up the cleanup function; make it an API so that external code can re-use this one in case of
      // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
      // case this parse() API method doesn't come with a `finally { ... }` block any more!
      //
      // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
      //       or else your `sharedState`, etc. references will be *wrong*!


      this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
        var rv;

        if (invoke_post_methods) {
          var hash;

          if (sharedState_yy.post_parse || this.post_parse) {
            // create an error hash info instance: we re-use this API in a **non-error situation**
            // as this one delivers all parser internals ready for access by userland code.
            hash = this.constructParseErrorInfo(null
            /* no error! */
            , null
            /* no exception! */
            , null, false);
          }

          if (sharedState_yy.post_parse) {
            rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
            if (typeof rv !== 'undefined') resultValue = rv;
          }

          if (this.post_parse) {
            rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
            if (typeof rv !== 'undefined') resultValue = rv;
          } // cleanup:


          if (hash && hash.destroy) {
            hash.destroy();
          }
        }

        if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.
        // clean up the lingering lexer structures as well:

        if (lexer.cleanupAfterLex) {
          lexer.cleanupAfterLex(do_not_nuke_errorinfos);
        } // prevent lingering circular references from causing memory leaks:


        if (sharedState_yy) {
          sharedState_yy.lexer = undefined;
          sharedState_yy.parser = undefined;

          if (lexer.yy === sharedState_yy) {
            lexer.yy = undefined;
          }
        }

        sharedState_yy = undefined;
        this.parseError = this.originalParseError;
        this.quoteName = this.originalQuoteName; // nuke the vstack[] array at least as that one will still reference obsoleted user values.
        // To be safe, we nuke the other internal stack columns as well...

        stack.length = 0; // fastest way to nuke an array without overly bothering the GC

        sstack.length = 0;
        vstack.length = 0;
        sp = 0; // nuke the error hash info instances created during this run.
        // Userland code must COPY any data/references
        // in the error hash instance(s) it is more permanently interested in.

        if (!do_not_nuke_errorinfos) {
          for (var i = this.__error_infos.length - 1; i >= 0; i--) {
            var el = this.__error_infos[i];

            if (el && typeof el.destroy === 'function') {
              el.destroy();
            }
          }

          this.__error_infos.length = 0;
        }

        return resultValue;
      }; // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
      //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!


      this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
        var pei = {
          errStr: msg,
          exception: ex,
          text: lexer.match,
          value: lexer.yytext,
          token: this.describeSymbol(symbol) || symbol,
          token_id: symbol,
          line: lexer.yylineno,
          expected: expected,
          recoverable: recoverable,
          state: state,
          action: action,
          new_state: newState,
          symbol_stack: stack,
          state_stack: sstack,
          value_stack: vstack,
          stack_pointer: sp,
          yy: sharedState_yy,
          lexer: lexer,
          parser: this,
          // and make sure the error info doesn't stay due to potential
          // ref cycle via userland code manipulations.
          // These would otherwise all be memory leak opportunities!
          //
          // Note that only array and object references are nuked as those
          // constitute the set of elements which can produce a cyclic ref.
          // The rest of the members is kept intact as they are harmless.
          destroy: function destructParseErrorInfo() {
            // remove cyclic references added to error info:
            // info.yy = null;
            // info.lexer = null;
            // info.value = null;
            // info.value_stack = null;
            // ...
            var rec = !!this.recoverable;

            for (var key in this) {
              if (this.hasOwnProperty(key) && typeof key === 'object') {
                this[key] = undefined;
              }
            }

            this.recoverable = rec;
          }
        }; // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!

        this.__error_infos.push(pei);

        return pei;
      };

      function stdLex() {
        var token = lexer.lex(); // if token isn't its numeric value, convert

        if (typeof token !== 'number') {
          token = self.symbols_[token] || token;
        }

        return token || EOF;
      }

      function fastLex() {
        var token = lexer.fastLex(); // if token isn't its numeric value, convert

        if (typeof token !== 'number') {
          token = self.symbols_[token] || token;
        }

        return token || EOF;
      }

      var lex = stdLex;
      var state, action, r, t;
      var yyval = {
        $: true,
        _$: undefined,
        yy: sharedState_yy
      };
      var p;
      var yyrulelen;
      var this_production;
      var newState;
      var retval = false;

      try {
        this.__reentrant_call_depth++;
        lexer.setInput(input, sharedState_yy); // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
        // this initial `setInput()` call: hence we can now check and decide
        // whether we'll go with the standard, slower, lex() API or the
        // `fast_lex()` one:

        if (typeof lexer.canIUse === 'function') {
          var lexerInfo = lexer.canIUse();

          if (lexerInfo.fastLex && typeof fastLex === 'function') {
            lex = fastLex;
          }
        }

        vstack[sp] = null;
        sstack[sp] = 0;
        stack[sp] = 0;
        ++sp;

        if (this.pre_parse) {
          this.pre_parse.call(this, sharedState_yy);
        }

        if (sharedState_yy.pre_parse) {
          sharedState_yy.pre_parse.call(this, sharedState_yy);
        }

        newState = sstack[sp - 1];

        for (;;) {
          // retrieve state number from top of stack
          state = newState; // sstack[sp - 1];
          // use default actions if available

          if (this.defaultActions[state]) {
            action = 2;
            newState = this.defaultActions[state];
          } else {
            // The single `==` condition below covers both these `===` comparisons in a single
            // operation:
            //
            //     if (symbol === null || typeof symbol === 'undefined') ...
            if (!symbol) {
              symbol = lex();
            } // read action for current state and first input


            t = table[state] && table[state][symbol] || NO_ACTION;
            newState = t[1];
            action = t[0]; // handle parse error

            if (!action) {
              var errStr;
              var errSymbolDescr = this.describeSymbol(symbol) || symbol;
              var expected = this.collect_expected_token_set(state); // Report error

              if (typeof lexer.yylineno === 'number') {
                errStr = 'Parse error on line ' + (lexer.yylineno + 1) + ': ';
              } else {
                errStr = 'Parse error: ';
              }

              if (typeof lexer.showPosition === 'function') {
                errStr += '\n' + lexer.showPosition(79 - 10, 10) + '\n';
              }

              if (expected.length) {
                errStr += 'Expecting ' + expected.join(', ') + ', got unexpected ' + errSymbolDescr;
              } else {
                errStr += 'Unexpected ' + errSymbolDescr;
              } // we cannot recover from the error!


              p = this.constructParseErrorInfo(errStr, null, expected, false);
              r = this.parseError(p.errStr, p, this.JisonParserError);

              if (typeof r !== 'undefined') {
                retval = r;
              }

              break;
            }
          }

          switch (action) {
            // catch misc. parse failures:
            default:
              // this shouldn't happen, unless resolve defaults are off
              if (action instanceof Array) {
                p = this.constructParseErrorInfo('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol, null, null, false);
                r = this.parseError(p.errStr, p, this.JisonParserError);

                if (typeof r !== 'undefined') {
                  retval = r;
                }

                break;
              } // Another case of better safe than sorry: in case state transitions come out of another error recovery process
              // or a buggy LUT (LookUp Table):


              p = this.constructParseErrorInfo('Parsing halted. No viable error recovery approach available due to internal system failure.', null, null, false);
              r = this.parseError(p.errStr, p, this.JisonParserError);

              if (typeof r !== 'undefined') {
                retval = r;
              }

              break;
            // shift:

            case 1:
              stack[sp] = symbol;
              vstack[sp] = lexer.yytext;
              sstack[sp] = newState; // push state

              ++sp;
              symbol = 0; // Pick up the lexer details for the current symbol as that one is not 'look-ahead' any more:

              continue;
            // reduce:

            case 2:
              this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...

              yyrulelen = this_production[1];
              r = this.performAction.call(yyval, newState, sp - 1, vstack);

              if (typeof r !== 'undefined') {
                retval = r;
                break;
              } // pop off stack


              sp -= yyrulelen; // don't overwrite the `symbol` variable: use a local var to speed things up:

              var ntsymbol = this_production[0]; // push nonterminal (reduce)

              stack[sp] = ntsymbol;
              vstack[sp] = yyval.$; // goto new state = table[STATE][NONTERMINAL]

              newState = table[sstack[sp - 1]][ntsymbol];
              sstack[sp] = newState;
              ++sp;
              continue;
            // accept:

            case 3:
              if (sp !== -2) {
                retval = true; // Return the `$accept` rule's `$$` result, if available.
                //
                // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                // default, action):
                //
                //     $accept: <startSymbol> $end
                //                  %{ $$ = $1; @$ = @1; %}
                //
                // which, combined with the parse kernel's `$accept` state behaviour coded below,
                // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                //
                // In code:
                //
                //                  %{
                //                      @$ = @1;            // if location tracking support is included
                //                      if (typeof $1 !== 'undefined')
                //                          return $1;
                //                      else
                //                          return true;           // the default parse result if the rule actions don't produce anything
                //                  %}

                sp--;

                if (typeof vstack[sp] !== 'undefined') {
                  retval = vstack[sp];
                }
              }

              break;
          } // break out of loop: we accept or fail with error


          break;
        }
      } catch (ex) {
        // report exceptions through the parseError callback too, but keep the exception intact
        // if it is a known parser or lexer error which has been thrown by parseError() already:
        if (ex instanceof this.JisonParserError) {
          throw ex;
        } else if (lexer && typeof lexer.JisonLexerError === 'function' && ex instanceof lexer.JisonLexerError) {
          throw ex;
        }

        p = this.constructParseErrorInfo('Parsing aborted due to exception.', ex, null, false);
        retval = false;
        r = this.parseError(p.errStr, p, this.JisonParserError);

        if (typeof r !== 'undefined') {
          retval = r;
        }
      } finally {
        retval = this.cleanupAfterParse(retval, true, true);
        this.__reentrant_call_depth--;
      } // /finally


      return retval;
    }
  };
  parser.originalParseError = parser.parseError;
  parser.originalQuoteName = parser.quoteName;
  /* lexer generated by jison-lex 0.6.1-215 */

  /*
   * Returns a Lexer object of the following structure:
   *
   *  Lexer: {
   *    yy: {}     The so-called "shared state" or rather the *source* of it;
   *               the real "shared state" `yy` passed around to
   *               the rule actions, etc. is a direct reference!
   *
   *               This "shared context" object was passed to the lexer by way of 
   *               the `lexer.setInput(str, yy)` API before you may use it.
   *
   *               This "shared context" object is passed to the lexer action code in `performAction()`
   *               so userland code in the lexer actions may communicate with the outside world 
   *               and/or other lexer rules' actions in more or less complex ways.
   *
   *  }
   *
   *  Lexer.prototype: {
   *    EOF: 1,
   *    ERROR: 2,
   *
   *    yy:        The overall "shared context" object reference.
   *
   *    JisonLexerError: function(msg, hash),
   *
   *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
   *
   *               The function parameters and `this` have the following value/meaning:
   *               - `this`    : reference to the `lexer` instance. 
   *                               `yy_` is an alias for `this` lexer instance reference used internally.
   *
   *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
   *                             by way of the `lexer.setInput(str, yy)` API before.
   *
   *                             Note:
   *                             The extra arguments you specified in the `%parse-param` statement in your
   *                             **parser** grammar definition file are passed to the lexer via this object
   *                             reference as member variables.
   *
   *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
   *
   *               - `YY_START`: the current lexer "start condition" state.
   *
   *    parseError: function(str, hash, ExceptionClass),
   *
   *    constructLexErrorInfo: function(error_message, is_recoverable),
   *               Helper function.
   *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
   *               See it's use in this lexer kernel in many places; example usage:
   *
   *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
   *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
   *
   *    options: { ... lexer %options ... },
   *
   *    lex: function(),
   *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
   *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
   *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
   *
   *               WARNING:
   *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
   *               any attributes already added to `yy` by the **parser** or the jison run-time; 
   *               when such a collision is detected an exception is thrown to prevent the generated run-time 
   *               from silently accepting this confusing and potentially hazardous situation! 
   *
   *    cleanupAfterLex: function(do_not_nuke_errorinfos),
   *               Helper function.
   *
   *               This helper API is invoked when the **parse process** has completed: it is the responsibility
   *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
   *
   *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
   *
   *    setInput: function(input, [yy]),
   *
   *
   *    input: function(),
   *
   *
   *    unput: function(str),
   *
   *
   *    more: function(),
   *
   *
   *    reject: function(),
   *
   *
   *    less: function(n),
   *
   *
   *    pastInput: function(n),
   *
   *
   *    upcomingInput: function(n),
   *
   *
   *    showPosition: function(),
   *
   *
   *    test_match: function(regex_match_array, rule_index),
   *
   *
   *    next: function(),
   *
   *
   *    begin: function(condition),
   *
   *
   *    pushState: function(condition),
   *
   *
   *    popState: function(),
   *
   *
   *    topState: function(),
   *
   *
   *    _currentRules: function(),
   *
   *
   *    stateStackSize: function(),
   *
   *
   *    performAction: function(yy, yy_, yyrulenumber, YY_START),
   *
   *
   *    rules: [...],
   *
   *
   *    conditions: {associative list: name ==> set},
   *  }
   *
   *
   *  token location info (`yylloc`): {
   *    first_line: n,
   *    last_line: n,
   *    first_column: n,
   *    last_column: n,
   *    range: [start_number, end_number]
   *               (where the numbers are indexes into the input string, zero-based)
   *  }
   *
   * ---
   *
   * The `parseError` function receives a 'hash' object with these members for lexer errors:
   *
   *  {
   *    text:        (matched text)
   *    token:       (the produced terminal token, if any)
   *    token_id:    (the produced terminal token numeric ID, if any)
   *    line:        (yylineno)
   *    loc:         (yylloc)
   *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
   *                  available for this particular error)
   *    yy:          (object: the current parser internal "shared state" `yy`
   *                  as is also available in the rule actions; this can be used,
   *                  for instance, for advanced error analysis and reporting)
   *    lexer:       (reference to the current lexer instance used by the parser)
   *  }
   *
   * while `this` will reference the current lexer instance.
   *
   * When `parseError` is invoked by the lexer, the default implementation will
   * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
   * it will try to invoke `yy.parseError()` instead. When that callback is also not
   * provided, a `JisonLexerError` exception will be thrown containing the error
   * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
   *
   * Note that the lexer's `JisonLexerError` error class is passed via the
   * `ExceptionClass` argument, which is invoked to construct the exception
   * instance to be thrown, so technically `parseError` will throw the object
   * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
   *
   * ---
   *
   * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
   * These options are available:
   *
   * (Options are permanent.)
   *  
   *  yy: {
   *      parseError: function(str, hash, ExceptionClass)
   *                 optional: overrides the default `parseError` function.
   *  }
   *
   *  lexer.options: {
   *      pre_lex:  function()
   *                 optional: is invoked before the lexer is invoked to produce another token.
   *                 `this` refers to the Lexer object.
   *      post_lex: function(token) { return token; }
   *                 optional: is invoked when the lexer has produced a token `token`;
   *                 this function can override the returned token value by returning another.
   *                 When it does not return any (truthy) value, the lexer will return
   *                 the original `token`.
   *                 `this` refers to the Lexer object.
   *
   * WARNING: the next set of options are not meant to be changed. They echo the abilities of
   * the lexer as per when it was compiled!
   *
   *      ranges: boolean
   *                 optional: `true` ==> token location info will include a .range[] member.
   *      flex: boolean
   *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
   *                 exhaustively to find the longest match.
   *      backtrack_lexer: boolean
   *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
   *                 the lexer terminates the scan when a token is returned by the action code.
   *      xregexp: boolean
   *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
   *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
   *                 rule regexes have been written as standard JavaScript RegExp expressions.
   *  }
   */

  var lexer = function () {
    /**
     * See also:
     * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
     * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
     * with userland code which might access the derived class in a 'classic' way.
     *
     * @public
     * @constructor
     * @nocollapse
     */
    function JisonLexerError(msg, hash) {
      Object.defineProperty(this, 'name', {
        enumerable: false,
        writable: false,
        value: 'JisonLexerError'
      });
      if (msg == null) msg = '???';
      Object.defineProperty(this, 'message', {
        enumerable: false,
        writable: true,
        value: msg
      });
      this.hash = hash;
      var stacktrace;

      if (hash && hash.exception instanceof Error) {
        var ex2 = hash.exception;
        this.message = ex2.message || msg;
        stacktrace = ex2.stack;
      }

      if (!stacktrace) {
        if (Error.hasOwnProperty('captureStackTrace')) {
          // V8
          Error.captureStackTrace(this, this.constructor);
        } else {
          stacktrace = new Error(msg).stack;
        }
      }

      if (stacktrace) {
        Object.defineProperty(this, 'stack', {
          enumerable: false,
          writable: false,
          value: stacktrace
        });
      }
    }

    if (typeof Object.setPrototypeOf === 'function') {
      Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
    } else {
      JisonLexerError.prototype = Object.create(Error.prototype);
    }

    JisonLexerError.prototype.constructor = JisonLexerError;
    JisonLexerError.prototype.name = 'JisonLexerError';
    var lexer = {
      // Code Generator Information Report
      // ---------------------------------
      //
      // Options:
      //
      //   backtracking: .................... false
      //   location.ranges: ................. false
      //   location line+column tracking: ... true
      //
      //
      // Forwarded Parser Analysis flags:
      //
      //   uses yyleng: ..................... false
      //   uses yylineno: ................... false
      //   uses yytext: ..................... false
      //   uses yylloc: ..................... false
      //   uses lexer values: ............... true / true
      //   location tracking: ............... false
      //   location assignment: ............. false
      //
      //
      // Lexer Analysis flags:
      //
      //   uses yyleng: ..................... ???
      //   uses yylineno: ................... ???
      //   uses yytext: ..................... ???
      //   uses yylloc: ..................... ???
      //   uses ParseError API: ............. ???
      //   uses yyerror: .................... ???
      //   uses location tracking & editing:  ???
      //   uses more() API: ................. ???
      //   uses unput() API: ................ ???
      //   uses reject() API: ............... ???
      //   uses less() API: ................. ???
      //   uses display APIs pastInput(), upcomingInput(), showPosition():
      //        ............................. ???
      //   uses describeYYLLOC() API: ....... ???
      //
      // --------- END OF REPORT -----------
      EOF: 1,
      ERROR: 2,
      // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator
      // options: {},                             /// <-- injected by the code generator
      // yy: ...,                                 /// <-- injected by setInput()
      __currentRuleSet__: null,
      /// INTERNAL USE ONLY: internal rule set cache for the current lexer state  
      __error_infos: [],
      /// INTERNAL USE ONLY: the set of lexErrorInfo objects created since the last cleanup  
      __decompressed: false,
      /// INTERNAL USE ONLY: mark whether the lexer instance has been 'unfolded' completely and is now ready for use  
      done: false,
      /// INTERNAL USE ONLY  
      _backtrack: false,
      /// INTERNAL USE ONLY  
      _input: '',
      /// INTERNAL USE ONLY  
      _more: false,
      /// INTERNAL USE ONLY  
      _signaled_error_token: false,
      /// INTERNAL USE ONLY  
      conditionStack: [],
      /// INTERNAL USE ONLY; managed via `pushState()`, `popState()`, `topState()` and `stateStackSize()`  
      match: '',
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks input which has been matched so far for the lexer token under construction. `match` is identical to `yytext` except that this one still contains the matched input string after `lexer.performAction()` has been invoked, where userland code MAY have changed/replaced the `yytext` value entirely!  
      matched: '',
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks entire input which has been matched so far  
      matches: false,
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks RE match result for last (successful) match attempt  
      yytext: '',
      /// ADVANCED USE ONLY: tracks input which has been matched so far for the lexer token under construction; this value is transferred to the parser as the 'token value' when the parser consumes the lexer token produced through a call to the `lex()` API.  
      offset: 0,
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks the 'cursor position' in the input string, i.e. the number of characters matched so far  
      yyleng: 0,
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: length of matched input for the token under construction (`yytext`)  
      yylineno: 0,
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: 'line number' at which the token under construction is located  
      yylloc: null,
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks location info (lines + columns) for the token under construction  

      /**
       * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
       * 
       * @public
       * @this {RegExpLexer}
       */
      constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
        msg = '' + msg; // heuristic to determine if the error message already contains a (partial) source code dump
        // as produced by either `showPosition()` or `prettyPrintRange()`:

        if (show_input_position == undefined) {
          show_input_position = !(msg.indexOf('\n') > 0 && msg.indexOf('^') > 0);
        }

        if (this.yylloc && show_input_position) {
          if (typeof this.prettyPrintRange === 'function') {
            this.prettyPrintRange(this.yylloc);

            if (!/\n\s*$/.test(msg)) {
              msg += '\n';
            }

            msg += '\n  Erroneous area:\n' + this.prettyPrintRange(this.yylloc);
          } else if (typeof this.showPosition === 'function') {
            var pos_str = this.showPosition();

            if (pos_str) {
              if (msg.length && msg[msg.length - 1] !== '\n' && pos_str[0] !== '\n') {
                msg += '\n' + pos_str;
              } else {
                msg += pos_str;
              }
            }
          }
        }
        /** @constructor */


        var pei = {
          errStr: msg,
          recoverable: !!recoverable,
          text: this.match,
          // This one MAY be empty; userland code should use the `upcomingInput` API to obtain more text which follows the 'lexer cursor position'...  
          token: null,
          line: this.yylineno,
          loc: this.yylloc,
          yy: this.yy,
          lexer: this,

          /**
           * and make sure the error info doesn't stay due to potential
           * ref cycle via userland code manipulations.
           * These would otherwise all be memory leak opportunities!
           * 
           * Note that only array and object references are nuked as those
           * constitute the set of elements which can produce a cyclic ref.
           * The rest of the members is kept intact as they are harmless.
           * 
           * @public
           * @this {LexErrorInfo}
           */
          destroy: function destructLexErrorInfo() {
            // remove cyclic references added to error info:
            // info.yy = null;
            // info.lexer = null;
            // ...
            var rec = !!this.recoverable;

            for (var key in this) {
              if (this.hasOwnProperty(key) && typeof key === 'object') {
                this[key] = undefined;
              }
            }

            this.recoverable = rec;
          }
        }; // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!

        this.__error_infos.push(pei);

        return pei;
      },

      /**
       * handler which is invoked when a lexer error occurs.
       * 
       * @public
       * @this {RegExpLexer}
       */
      parseError: function lexer_parseError(str, hash, ExceptionClass) {
        if (!ExceptionClass) {
          ExceptionClass = this.JisonLexerError;
        }

        if (this.yy) {
          if (this.yy.parser && typeof this.yy.parser.parseError === 'function') {
            return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
          } else if (typeof this.yy.parseError === 'function') {
            return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
          }
        }

        throw new ExceptionClass(str, hash);
      },

      /**
       * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
       * 
       * @public
       * @this {RegExpLexer}
       */
      yyerror: function yyError(str
      /*, ...args */
      ) {
        var lineno_msg = '';

        if (this.yylloc) {
          lineno_msg = ' on line ' + (this.yylineno + 1);
        }

        var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': ' + str, this.options.lexerErrorsAreRecoverable); // Add any extra args to the hash under the name `extra_error_attributes`:

        var args = Array.prototype.slice.call(arguments, 1);

        if (args.length) {
          p.extra_error_attributes = args;
        }

        return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
      },

      /**
       * final cleanup function for when we have completed lexing the input;
       * make it an API so that external code can use this one once userland
       * code has decided it's time to destroy any lingering lexer error
       * hash object instances and the like: this function helps to clean
       * up these constructs, which *may* carry cyclic references which would
       * otherwise prevent the instances from being properly and timely
       * garbage-collected, i.e. this function helps prevent memory leaks!
       * 
       * @public
       * @this {RegExpLexer}
       */
      cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
        // prevent lingering circular references from causing memory leaks:
        this.setInput('', {}); // nuke the error hash info instances created during this run.
        // Userland code must COPY any data/references
        // in the error hash instance(s) it is more permanently interested in.

        if (!do_not_nuke_errorinfos) {
          for (var i = this.__error_infos.length - 1; i >= 0; i--) {
            var el = this.__error_infos[i];

            if (el && typeof el.destroy === 'function') {
              el.destroy();
            }
          }

          this.__error_infos.length = 0;
        }

        return this;
      },

      /**
       * clear the lexer token context; intended for internal use only
       * 
       * @public
       * @this {RegExpLexer}
       */
      clear: function lexer_clear() {
        this.yytext = '';
        this.yyleng = 0;
        this.match = ''; // - DO NOT reset `this.matched`

        this.matches = false;
        this._more = false;
        this._backtrack = false;
        var col = this.yylloc ? this.yylloc.last_column : 0;
        this.yylloc = {
          first_line: this.yylineno + 1,
          first_column: col,
          last_line: this.yylineno + 1,
          last_column: col,
          range: [this.offset, this.offset]
        };
      },

      /**
       * resets the lexer, sets new input
       * 
       * @public
       * @this {RegExpLexer}
       */
      setInput: function lexer_setInput(input, yy) {
        this.yy = yy || this.yy || {}; // also check if we've fully initialized the lexer instance,
        // including expansion work to be done to go from a loaded
        // lexer to a usable lexer:

        if (!this.__decompressed) {
          // step 1: decompress the regex list:
          var rules = this.rules;

          for (var i = 0, len = rules.length; i < len; i++) {
            var rule_re = rules[i]; // compression: is the RE an xref to another RE slot in the rules[] table?

            if (typeof rule_re === 'number') {
              rules[i] = rules[rule_re];
            }
          } // step 2: unfold the conditions[] set to make these ready for use:


          var conditions = this.conditions;

          for (var k in conditions) {
            var spec = conditions[k];
            var rule_ids = spec.rules;
            var len = rule_ids.length;
            var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 

            var rule_new_ids = new Array(len + 1);

            for (var i = 0; i < len; i++) {
              var idx = rule_ids[i];
              var rule_re = rules[idx];
              rule_regexes[i + 1] = rule_re;
              rule_new_ids[i + 1] = idx;
            }

            spec.rules = rule_new_ids;
            spec.__rule_regexes = rule_regexes;
            spec.__rule_count = len;
          }

          this.__decompressed = true;
        }

        this._input = input || '';
        this.clear();
        this._signaled_error_token = false;
        this.done = false;
        this.yylineno = 0;
        this.matched = '';
        this.conditionStack = ['INITIAL'];
        this.__currentRuleSet__ = null;
        this.yylloc = {
          first_line: 1,
          first_column: 0,
          last_line: 1,
          last_column: 0,
          range: [0, 0]
        };
        this.offset = 0;
        return this;
      },

      /**
       * edit the remaining input via user-specified callback.
       * This can be used to forward-adjust the input-to-parse, 
       * e.g. inserting macro expansions and alike in the
       * input which has yet to be lexed.
       * The behaviour of this API contrasts the `unput()` et al
       * APIs as those act on the *consumed* input, while this
       * one allows one to manipulate the future, without impacting
       * the current `yyloc` cursor location or any history. 
       * 
       * Use this API to help implement C-preprocessor-like
       * `#include` statements, etc.
       * 
       * The provided callback must be synchronous and is
       * expected to return the edited input (string).
       *
       * The `cpsArg` argument value is passed to the callback
       * as-is.
       *
       * `callback` interface: 
       * `function callback(input, cpsArg)`
       * 
       * - `input` will carry the remaining-input-to-lex string
       *   from the lexer.
       * - `cpsArg` is `cpsArg` passed into this API.
       * 
       * The `this` reference for the callback will be set to
       * reference this lexer instance so that userland code
       * in the callback can easily and quickly access any lexer
       * API. 
       *
       * When the callback returns a non-string-type falsey value,
       * we assume the callback did not edit the input and we
       * will using the input as-is.
       *
       * When the callback returns a non-string-type value, it
       * is converted to a string for lexing via the `"" + retval`
       * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
       * -- that way any returned object's `toValue()` and `toString()`
       * methods will be invoked in a proper/desirable order.)
       * 
       * @public
       * @this {RegExpLexer}
       */
      editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
        var rv = callback.call(this, this._input, cpsArg);

        if (typeof rv !== 'string') {
          if (rv) {
            this._input = '' + rv;
          } // else: keep `this._input` as is.  

        } else {
          this._input = rv;
        }

        return this;
      },

      /**
       * consumes and returns one char from the input
       * 
       * @public
       * @this {RegExpLexer}
       */
      input: function lexer_input() {
        if (!this._input) {
          //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
          return null;
        }

        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch; // Count the linenumber up when we hit the LF (or a stand-alone CR).
        // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
        // and we advance immediately past the LF as well, returning both together as if
        // it was all a single 'character' only.

        var slice_len = 1;
        var lines = false;

        if (ch === '\n') {
          lines = true;
        } else if (ch === '\r') {
          lines = true;
          var ch2 = this._input[1];

          if (ch2 === '\n') {
            slice_len++;
            ch += ch2;
            this.yytext += ch2;
            this.yyleng++;
            this.offset++;
            this.match += ch2;
            this.matched += ch2;
            this.yylloc.range[1]++;
          }
        }

        if (lines) {
          this.yylineno++;
          this.yylloc.last_line++;
          this.yylloc.last_column = 0;
        } else {
          this.yylloc.last_column++;
        }

        this.yylloc.range[1]++;
        this._input = this._input.slice(slice_len);
        return ch;
      },

      /**
       * unshifts one char (or an entire string) into the input
       * 
       * @public
       * @this {RegExpLexer}
       */
      unput: function lexer_unput(ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);
        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        this.yyleng = this.yytext.length;
        this.offset -= len;
        this.match = this.match.substr(0, this.match.length - len);
        this.matched = this.matched.substr(0, this.matched.length - len);

        if (lines.length > 1) {
          this.yylineno -= lines.length - 1;
          this.yylloc.last_line = this.yylineno + 1; // Get last entirely matched line into the `pre_lines[]` array's
          // last index slot; we don't mind when other previously 
          // matched lines end up in the array too. 

          var pre = this.match;
          var pre_lines = pre.split(/(?:\r\n?|\n)/g);

          if (pre_lines.length === 1) {
            pre = this.matched;
            pre_lines = pre.split(/(?:\r\n?|\n)/g);
          }

          this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
        } else {
          this.yylloc.last_column -= len;
        }

        this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
        this.done = false;
        return this;
      },

      /**
       * cache matched text and append it on next action
       * 
       * @public
       * @this {RegExpLexer}
       */
      more: function lexer_more() {
        this._more = true;
        return this;
      },

      /**
       * signal the lexer that this rule fails to match the input, so the
       * next matching rule (regex) should be tested instead.
       * 
       * @public
       * @this {RegExpLexer}
       */
      reject: function lexer_reject() {
        if (this.options.backtrack_lexer) {
          this._backtrack = true;
        } else {
          // when the `parseError()` call returns, we MUST ensure that the error is registered.
          // We accomplish this by signaling an 'error' token to be produced for the current
          // `.lex()` run.
          var lineno_msg = '';

          if (this.yylloc) {
            lineno_msg = ' on line ' + (this.yylineno + 1);
          }

          var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).', false);
          this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
        }

        return this;
      },

      /**
       * retain first n characters of the match
       * 
       * @public
       * @this {RegExpLexer}
       */
      less: function lexer_less(n) {
        return this.unput(this.match.slice(n));
      },

      /**
       * return (part of the) already matched input, i.e. for error
       * messages.
       * 
       * Limit the returned string length to `maxSize` (default: 20).
       * 
       * Limit the returned string to the `maxLines` number of lines of
       * input (default: 1).
       * 
       * Negative limit values equal *unlimited*.
       * 
       * @public
       * @this {RegExpLexer}
       */
      pastInput: function lexer_pastInput(maxSize, maxLines) {
        var past = this.matched.substring(0, this.matched.length - this.match.length);
        if (maxSize < 0) maxSize = past.length;else if (!maxSize) maxSize = 20;
        if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this! 
        else if (!maxLines) maxLines = 1; // `substr` anticipation: treat \r\n as a single character and take a little
        // more than necessary so that we can still properly check against maxSize
        // after we've transformed and limited the newLines in here:

        past = past.substr(-maxSize * 2 - 2); // now that we have a significantly reduced string to process, transform the newlines
        // and chop them, then limit them:

        var a = past.replace(/\r\n|\r/g, '\n').split('\n');
        a = a.slice(-maxLines);
        past = a.join('\n'); // When, after limiting to maxLines, we still have too much to return,
        // do add an ellipsis prefix...

        if (past.length > maxSize) {
          past = '...' + past.substr(-maxSize);
        }

        return past;
      },

      /**
       * return (part of the) upcoming input, i.e. for error messages.
       * 
       * Limit the returned string length to `maxSize` (default: 20).
       * 
       * Limit the returned string to the `maxLines` number of lines of input (default: 1).
       * 
       * Negative limit values equal *unlimited*.
       *
       * > ### NOTE ###
       * >
       * > *"upcoming input"* is defined as the whole of the both
       * > the *currently lexed* input, together with any remaining input
       * > following that. *"currently lexed"* input is the input 
       * > already recognized by the lexer but not yet returned with
       * > the lexer token. This happens when you are invoking this API
       * > from inside any lexer rule action code block. 
       * >
       * 
       * @public
       * @this {RegExpLexer}
       */
      upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
        var next = this.match;
        if (maxSize < 0) maxSize = next.length + this._input.length;else if (!maxSize) maxSize = 20;
        if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this! 
        else if (!maxLines) maxLines = 1; // `substring` anticipation: treat \r\n as a single character and take a little
        // more than necessary so that we can still properly check against maxSize
        // after we've transformed and limited the newLines in here:

        if (next.length < maxSize * 2 + 2) {
          next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8 
        } // now that we have a significantly reduced string to process, transform the newlines
        // and chop them, then limit them:


        var a = next.replace(/\r\n|\r/g, '\n').split('\n');
        a = a.slice(0, maxLines);
        next = a.join('\n'); // When, after limiting to maxLines, we still have too much to return,
        // do add an ellipsis postfix...

        if (next.length > maxSize) {
          next = next.substring(0, maxSize) + '...';
        }

        return next;
      },

      /**
       * return a string which displays the character position where the
       * lexing error occurred, i.e. for error messages
       * 
       * @public
       * @this {RegExpLexer}
       */
      showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
        var pre = this.pastInput(maxPrefix).replace(/\s/g, ' ');
        var c = new Array(pre.length + 1).join('-');
        return pre + this.upcomingInput(maxPostfix).replace(/\s/g, ' ') + '\n' + c + '^';
      },

      /**
       * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
       * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
       * it MAY be NULL) and you MUST have a valid location info object anyway:
       * then we take the given context of the `preceding` and `following` locations, IFF those are available,
       * and reconstruct the `actual` location info from those.
       * If this fails, the heuristic is to take the `current` location, IFF available.
       * If this fails as well, we assume the sought location is at/around the current lexer position
       * and then produce that one as a response. DO NOTE that these heuristic/derived location info
       * values MAY be inaccurate!
       *
       * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
       * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
       * 
       * @public
       * @this {RegExpLexer}
       */
      deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
        var loc = {
          first_line: 1,
          first_column: 0,
          last_line: 1,
          last_column: 0,
          range: [0, 0]
        };

        if (actual) {
          loc.first_line = actual.first_line | 0;
          loc.last_line = actual.last_line | 0;
          loc.first_column = actual.first_column | 0;
          loc.last_column = actual.last_column | 0;

          if (actual.range) {
            loc.range[0] = actual.range[0] | 0;
            loc.range[1] = actual.range[1] | 0;
          }
        }

        if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
          // plan B: heuristic using preceding and following:
          if (loc.first_line <= 0 && preceding) {
            loc.first_line = preceding.last_line | 0;
            loc.first_column = preceding.last_column | 0;

            if (preceding.range) {
              loc.range[0] = actual.range[1] | 0;
            }
          }

          if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
            loc.last_line = following.first_line | 0;
            loc.last_column = following.first_column | 0;

            if (following.range) {
              loc.range[1] = actual.range[0] | 0;
            }
          } // plan C?: see if the 'current' location is useful/sane too:


          if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
            loc.first_line = current.first_line | 0;
            loc.first_column = current.first_column | 0;

            if (current.range) {
              loc.range[0] = current.range[0] | 0;
            }
          }

          if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
            loc.last_line = current.last_line | 0;
            loc.last_column = current.last_column | 0;

            if (current.range) {
              loc.range[1] = current.range[1] | 0;
            }
          }
        } // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
        // or plan D heuristics to produce a 'sensible' last_line value:


        if (loc.last_line <= 0) {
          if (loc.first_line <= 0) {
            loc.first_line = this.yylloc.first_line;
            loc.last_line = this.yylloc.last_line;
            loc.first_column = this.yylloc.first_column;
            loc.last_column = this.yylloc.last_column;
            loc.range[0] = this.yylloc.range[0];
            loc.range[1] = this.yylloc.range[1];
          } else {
            loc.last_line = this.yylloc.last_line;
            loc.last_column = this.yylloc.last_column;
            loc.range[1] = this.yylloc.range[1];
          }
        }

        if (loc.first_line <= 0) {
          loc.first_line = loc.last_line;
          loc.first_column = 0; // loc.last_column; 

          loc.range[1] = loc.range[0];
        }

        if (loc.first_column < 0) {
          loc.first_column = 0;
        }

        if (loc.last_column < 0) {
          loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
        }

        return loc;
      },

      /**
       * return a string which displays the lines & columns of input which are referenced 
       * by the given location info range, plus a few lines of context.
       * 
       * This function pretty-prints the indicated section of the input, with line numbers 
       * and everything!
       * 
       * This function is very useful to provide highly readable error reports, while
       * the location range may be specified in various flexible ways:
       * 
       * - `loc` is the location info object which references the area which should be
       *   displayed and 'marked up': these lines & columns of text are marked up by `^`
       *   characters below each character in the entire input range.
       * 
       * - `context_loc` is the *optional* location info object which instructs this
       *   pretty-printer how much *leading* context should be displayed alongside
       *   the area referenced by `loc`. This can help provide context for the displayed
       *   error, etc.
       * 
       *   When this location info is not provided, a default context of 3 lines is
       *   used.
       * 
       * - `context_loc2` is another *optional* location info object, which serves
       *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
       *   context lines to display in the pretty-print output.
       * 
       *   When this location info is not provided, a default context of 1 line only is
       *   used.
       * 
       * Special Notes:
       * 
       * - when the `loc`-indicated range is very large (about 5 lines or more), then
       *   only the first and last few lines of this block are printed while a
       *   `...continued...` message will be printed between them.
       * 
       *   This serves the purpose of not printing a huge amount of text when the `loc`
       *   range happens to be huge: this way a manageable & readable output results
       *   for arbitrary large ranges.
       * 
       * - this function can display lines of input which whave not yet been lexed.
       *   `prettyPrintRange()` can access the entire input!
       * 
       * @public
       * @this {RegExpLexer}
       */
      prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
        loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
        var CONTEXT = 3;
        var CONTEXT_TAIL = 1;
        var MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
        var input = this.matched + this._input;
        var lines = input.split('\n');
        var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
        var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
        var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
        var ws_prefix = new Array(lineno_display_width).join(' ');
        var nonempty_line_indexes = [];
        var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
          var lno = index + l0;
          var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
          var rv = lno_pfx + ': ' + line;
          var errpfx = new Array(lineno_display_width + 1).join('^');
          var offset = 2 + 1;
          var len = 0;

          if (lno === loc.first_line) {
            offset += loc.first_column;
            len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
          } else if (lno === loc.last_line) {
            len = Math.max(2, loc.last_column + 1);
          } else if (lno > loc.first_line && lno < loc.last_line) {
            len = Math.max(2, line.length + 1);
          }

          if (len) {
            var lead = new Array(offset).join('.');
            var mark = new Array(len).join('^');
            rv += '\n' + errpfx + lead + mark;

            if (line.trim().length > 0) {
              nonempty_line_indexes.push(index);
            }
          }

          rv = rv.replace(/\t/g, ' ');
          return rv;
        }); // now make sure we don't print an overly large amount of error area: limit it 
        // to the top and bottom line count:

        if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
          var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
          var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
          var intermediate_line = new Array(lineno_display_width + 1).join(' ') + '  (...continued...)';
          intermediate_line += '\n' + new Array(lineno_display_width + 1).join('-') + '  (---------------)';
          rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
        }

        return rv.join('\n');
      },

      /**
       * helper function, used to produce a human readable description as a string, given
       * the input `yylloc` location object.
       * 
       * Set `display_range_too` to TRUE to include the string character index position(s)
       * in the description if the `yylloc.range` is available.
       * 
       * @public
       * @this {RegExpLexer}
       */
      describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
        var l1 = yylloc.first_line;
        var l2 = yylloc.last_line;
        var c1 = yylloc.first_column;
        var c2 = yylloc.last_column;
        var dl = l2 - l1;
        var dc = c2 - c1;
        var rv;

        if (dl === 0) {
          rv = 'line ' + l1 + ', ';

          if (dc <= 1) {
            rv += 'column ' + c1;
          } else {
            rv += 'columns ' + c1 + ' .. ' + c2;
          }
        } else {
          rv = 'lines ' + l1 + '(column ' + c1 + ') .. ' + l2 + '(column ' + c2 + ')';
        }

        if (yylloc.range && display_range_too) {
          var r1 = yylloc.range[0];
          var r2 = yylloc.range[1] - 1;

          if (r2 <= r1) {
            rv += ' {String Offset: ' + r1 + '}';
          } else {
            rv += ' {String Offset range: ' + r1 + ' .. ' + r2 + '}';
          }
        }

        return rv;
      },

      /**
       * test the lexed token: return FALSE when not a match, otherwise return token.
       * 
       * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
       * contains the actually matched text string.
       * 
       * Also move the input cursor forward and update the match collectors:
       * 
       * - `yytext`
       * - `yyleng`
       * - `match`
       * - `matches`
       * - `yylloc`
       * - `offset`
       * 
       * @public
       * @this {RegExpLexer}
       */
      test_match: function lexer_test_match(match, indexed_rule) {
        var token, lines, backup, match_str, match_str_len;

        if (this.options.backtrack_lexer) {
          // save context
          backup = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.yylloc.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column,
              range: this.yylloc.range.slice(0)
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            //_signaled_error_token: this._signaled_error_token,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          };
        }

        match_str = match[0];
        match_str_len = match_str.length; // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {

        lines = match_str.split(/(?:\r\n?|\n)/g);

        if (lines.length > 1) {
          this.yylineno += lines.length - 1;
          this.yylloc.last_line = this.yylineno + 1;
          this.yylloc.last_column = lines[lines.length - 1].length;
        } else {
          this.yylloc.last_column += match_str_len;
        } // }


        this.yytext += match_str;
        this.match += match_str;
        this.matched += match_str;
        this.matches = match;
        this.yyleng = this.yytext.length;
        this.yylloc.range[1] += match_str_len; // previous lex rules MAY have invoked the `more()` API rather than producing a token:
        // those rules will already have moved this `offset` forward matching their match lengths,
        // hence we must only add our own match length now:

        this.offset += match_str_len;
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match_str_len); // calling this method:
        //
        //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}

        token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]
        /* = YY_START */
        ); // otherwise, when the action codes are all simple return token statements:
        //token = this.simpleCaseActionClusters[indexed_rule];

        if (this.done && this._input) {
          this.done = false;
        }

        if (token) {
          return token;
        } else if (this._backtrack) {
          // recover context
          for (var k in backup) {
            this[k] = backup[k];
          }

          this.__currentRuleSet__ = null;
          return false; // rule action called reject() implying the next rule should be tested instead. 
        } else if (this._signaled_error_token) {
          // produce one 'error' token as `.parseError()` in `reject()`
          // did not guarantee a failure signal by throwing an exception!
          token = this._signaled_error_token;
          this._signaled_error_token = false;
          return token;
        }

        return false;
      },

      /**
       * return next match in input
       * 
       * @public
       * @this {RegExpLexer}
       */
      next: function lexer_next() {
        if (this.done) {
          this.clear();
          return this.EOF;
        }

        if (!this._input) {
          this.done = true;
        }

        var token, match, tempMatch, index;

        if (!this._more) {
          this.clear();
        }

        var spec = this.__currentRuleSet__;

        if (!spec) {
          // Update the ruleset cache as we apparently encountered a state change or just started lexing.
          // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
          // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
          // speed up those activities a tiny bit.
          spec = this.__currentRuleSet__ = this._currentRules(); // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
          // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19

          if (!spec || !spec.rules) {
            var lineno_msg = '';

            if (this.options.trackPosition) {
              lineno_msg = ' on line ' + (this.yylineno + 1);
            }

            var p = this.constructLexErrorInfo('Internal lexer engine error' + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false); // produce one 'error' token until this situation has been resolved, most probably by parse termination!

            return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
          }
        }

        var rule_ids = spec.rules;
        var regexes = spec.__rule_regexes;
        var len = spec.__rule_count; // Note: the arrays are 1-based, while `len` itself is a valid index,
        // hence the non-standard less-or-equal check in the next loop condition!

        for (var i = 1; i <= len; i++) {
          tempMatch = this._input.match(regexes[i]);

          if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
            match = tempMatch;
            index = i;

            if (this.options.backtrack_lexer) {
              token = this.test_match(tempMatch, rule_ids[i]);

              if (token !== false) {
                return token;
              } else if (this._backtrack) {
                match = undefined;
                continue; // rule action called reject() implying a rule MISmatch. 
              } else {
                // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                return false;
              }
            } else if (!this.options.flex) {
              break;
            }
          }
        }

        if (match) {
          token = this.test_match(match, rule_ids[index]);

          if (token !== false) {
            return token;
          } // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)


          return false;
        }

        if (!this._input) {
          this.done = true;
          this.clear();
          return this.EOF;
        } else {
          var lineno_msg = '';

          if (this.options.trackPosition) {
            lineno_msg = ' on line ' + (this.yylineno + 1);
          }

          var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': Unrecognized text.', this.options.lexerErrorsAreRecoverable);
          var pendingInput = this._input;
          var activeCondition = this.topState();
          var conditionStackDepth = this.conditionStack.length;
          token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;

          if (token === this.ERROR) {
            // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
            // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
            // has not consumed/modified any pending input or changed state in the error handler:
            if (!this.matches && // and make sure the input has been modified/consumed ...
            pendingInput === this._input && // ...or the lexer state has been modified significantly enough
            // to merit a non-consuming error handling action right now.
            activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) {
              this.input();
            }
          }

          return token;
        }
      },

      /**
       * return next match that has a token
       * 
       * @public
       * @this {RegExpLexer}
       */
      lex: function lexer_lex() {
        var r; // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:

        if (typeof this.pre_lex === 'function') {
          r = this.pre_lex.call(this, 0);
        }

        if (typeof this.options.pre_lex === 'function') {
          // (also account for a userdef function which does not return any value: keep the token as is)
          r = this.options.pre_lex.call(this, r) || r;
        }

        if (this.yy && typeof this.yy.pre_lex === 'function') {
          // (also account for a userdef function which does not return any value: keep the token as is)
          r = this.yy.pre_lex.call(this, r) || r;
        }

        while (!r) {
          r = this.next();
        }

        if (this.yy && typeof this.yy.post_lex === 'function') {
          // (also account for a userdef function which does not return any value: keep the token as is)
          r = this.yy.post_lex.call(this, r) || r;
        }

        if (typeof this.options.post_lex === 'function') {
          // (also account for a userdef function which does not return any value: keep the token as is)
          r = this.options.post_lex.call(this, r) || r;
        }

        if (typeof this.post_lex === 'function') {
          // (also account for a userdef function which does not return any value: keep the token as is)
          r = this.post_lex.call(this, r) || r;
        }

        return r;
      },

      /**
       * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
       * `pre_lex()` nor any of the `post_lex()` callbacks.
       * 
       * @public
       * @this {RegExpLexer}
       */
      fastLex: function lexer_fastLex() {
        var r;

        while (!r) {
          r = this.next();
        }

        return r;
      },

      /**
       * return info about the lexer state that can help a parser or other lexer API user to use the
       * most efficient means available. This API is provided to aid run-time performance for larger
       * systems which employ this lexer.
       * 
       * @public
       * @this {RegExpLexer}
       */
      canIUse: function lexer_canIUse() {
        var rv = {
          fastLex: !(typeof this.pre_lex === 'function' || typeof this.options.pre_lex === 'function' || this.yy && typeof this.yy.pre_lex === 'function' || this.yy && typeof this.yy.post_lex === 'function' || typeof this.options.post_lex === 'function' || typeof this.post_lex === 'function') && typeof this.fastLex === 'function'
        };
        return rv;
      },

      /**
       * backwards compatible alias for `pushState()`;
       * the latter is symmetrical with `popState()` and we advise to use
       * those APIs in any modern lexer code, rather than `begin()`.
       * 
       * @public
       * @this {RegExpLexer}
       */
      begin: function lexer_begin(condition) {
        return this.pushState(condition);
      },

      /**
       * activates a new lexer condition state (pushes the new lexer
       * condition state onto the condition stack)
       * 
       * @public
       * @this {RegExpLexer}
       */
      pushState: function lexer_pushState(condition) {
        this.conditionStack.push(condition);
        this.__currentRuleSet__ = null;
        return this;
      },

      /**
       * pop the previously active lexer condition state off the condition
       * stack
       * 
       * @public
       * @this {RegExpLexer}
       */
      popState: function lexer_popState() {
        var n = this.conditionStack.length - 1;

        if (n > 0) {
          this.__currentRuleSet__ = null;
          return this.conditionStack.pop();
        } else {
          return this.conditionStack[0];
        }
      },

      /**
       * return the currently active lexer condition state; when an index
       * argument is provided it produces the N-th previous condition state,
       * if available
       * 
       * @public
       * @this {RegExpLexer}
       */
      topState: function lexer_topState(n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);

        if (n >= 0) {
          return this.conditionStack[n];
        } else {
          return 'INITIAL';
        }
      },

      /**
       * (internal) determine the lexer rule set which is active for the
       * currently active lexer condition state
       * 
       * @public
       * @this {RegExpLexer}
       */
      _currentRules: function lexer__currentRules() {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
          return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
        } else {
          return this.conditions['INITIAL'];
        }
      },

      /**
       * return the number of states currently on the stack
       * 
       * @public
       * @this {RegExpLexer}
       */
      stateStackSize: function lexer_stateStackSize() {
        return this.conditionStack.length;
      },
      options: {
        trackPosition: true
      },
      JisonLexerError: JisonLexerError,
      performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {

        switch (yyrulenumber) {
          case 1:
            /*! Conditions:: INITIAL */

            /*! Rule::       \s+ */

            /* skip whitespace */
            break;

          default:
            return this.simpleCaseActionClusters[yyrulenumber];
        }
      },
      simpleCaseActionClusters: {
        /*! Conditions:: INITIAL */

        /*! Rule::       (--[0-9a-z-A-Z-]*) */
        0: 16,

        /*! Conditions:: INITIAL */

        /*! Rule::       \* */
        2: 5,

        /*! Conditions:: INITIAL */

        /*! Rule::       \/ */
        3: 6,

        /*! Conditions:: INITIAL */

        /*! Rule::       \+ */
        4: 3,

        /*! Conditions:: INITIAL */

        /*! Rule::       - */
        5: 4,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */
        6: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */
        7: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */
        8: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */
        9: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */
        10: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */
        11: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */
        12: 18,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */
        13: 18,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */
        14: 18,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */
        15: 18,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */
        16: 19,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */
        17: 19,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */
        18: 20,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */
        19: 20,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */
        20: 21,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */
        21: 21,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */
        22: 21,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */
        23: 22,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */
        24: 23,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */
        25: 24,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */
        26: 25,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */
        27: 27,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */
        28: 26,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */
        29: 28,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */
        30: 29,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */
        31: 30,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */
        32: 14,

        /*! Conditions:: INITIAL */

        /*! Rule::       (calc) */
        33: 9,

        /*! Conditions:: INITIAL */

        /*! Rule::       (var) */
        34: 15,

        /*! Conditions:: INITIAL */

        /*! Rule::       (max) */
        35: 10,

        /*! Conditions:: INITIAL */

        /*! Rule::       (min) */
        36: 12,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([a-z]+) */
        37: 13,

        /*! Conditions:: INITIAL */

        /*! Rule::       \( */
        38: 7,

        /*! Conditions:: INITIAL */

        /*! Rule::       \) */
        39: 8,

        /*! Conditions:: INITIAL */

        /*! Rule::       , */
        40: 11,

        /*! Conditions:: INITIAL */

        /*! Rule::       $ */
        41: 1
      },
      rules: [
      /*  0: */
      /^(?:(--[\d\-A-Za-z]*))/,
      /*  1: */
      /^(?:\s+)/,
      /*  2: */
      /^(?:\*)/,
      /*  3: */
      /^(?:\/)/,
      /*  4: */
      /^(?:\+)/,
      /*  5: */
      /^(?:-)/,
      /*  6: */
      /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
      /*  7: */
      /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
      /*  8: */
      /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
      /*  9: */
      /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
      /* 10: */
      /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
      /* 11: */
      /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
      /* 12: */
      /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
      /* 13: */
      /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
      /* 14: */
      /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
      /* 15: */
      /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
      /* 16: */
      /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
      /* 17: */
      /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
      /* 18: */
      /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
      /* 19: */
      /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
      /* 20: */
      /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
      /* 21: */
      /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
      /* 22: */
      /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
      /* 23: */
      /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
      /* 24: */
      /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
      /* 25: */
      /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
      /* 26: */
      /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
      /* 27: */
      /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
      /* 28: */
      /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
      /* 29: */
      /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
      /* 30: */
      /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
      /* 31: */
      /^(?:(\d+(\.\d*)?|\.\d+)%)/,
      /* 32: */
      /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
      /* 33: */
      /^(?:(calc))/,
      /* 34: */
      /^(?:(var))/,
      /* 35: */
      /^(?:(max))/,
      /* 36: */
      /^(?:(min))/,
      /* 37: */
      /^(?:([a-z]+))/,
      /* 38: */
      /^(?:\()/,
      /* 39: */
      /^(?:\))/,
      /* 40: */
      /^(?:,)/,
      /* 41: */
      /^(?:$)/],
      conditions: {
        'INITIAL': {
          rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41],
          inclusive: true
        }
      }
    };
    return lexer;
  }();

  parser.lexer = lexer;

  function Parser() {
    this.yy = {};
  }

  Parser.prototype = parser;
  parser.Parser = Parser;
  return new Parser();
}();

if (typeof commonjsRequire !== 'undefined' && 'object' !== 'undefined') {
  exports.parser = parser;
  exports.Parser = parser.Parser;

  exports.parse = function () {
    return parser.parse.apply(parser, arguments);
  };
}
}(parser));

var reducer$2 = {};

var convert = {exports: {}};

var conversions = {
  // length
  'px': {
    'px': 1,
    'cm': 96.0 / 2.54,
    'mm': 96.0 / 25.4,
    'in': 96,
    'pt': 96.0 / 72.0,
    'pc': 16
  },
  'cm': {
    'px': 2.54 / 96.0,
    'cm': 1,
    'mm': 0.1,
    'in': 2.54,
    'pt': 2.54 / 72.0,
    'pc': 2.54 / 6.0
  },
  'mm': {
    'px': 25.4 / 96.0,
    'cm': 10,
    'mm': 1,
    'in': 25.4,
    'pt': 25.4 / 72.0,
    'pc': 25.4 / 6.0
  },
  'in': {
    'px': 1.0 / 96.0,
    'cm': 1.0 / 2.54,
    'mm': 1.0 / 25.4,
    'in': 1,
    'pt': 1.0 / 72.0,
    'pc': 1.0 / 6.0
  },
  'pt': {
    'px': 0.75,
    'cm': 72.0 / 2.54,
    'mm': 72.0 / 25.4,
    'in': 72,
    'pt': 1,
    'pc': 12
  },
  'pc': {
    'px': 6.0 / 96.0,
    'cm': 6.0 / 2.54,
    'mm': 6.0 / 25.4,
    'in': 6,
    'pt': 6.0 / 72.0,
    'pc': 1
  },
  // angle
  'deg': {
    'deg': 1,
    'grad': 0.9,
    'rad': 180 / Math.PI,
    'turn': 360
  },
  'grad': {
    'deg': 400 / 360,
    'grad': 1,
    'rad': 200 / Math.PI,
    'turn': 400
  },
  'rad': {
    'deg': Math.PI / 180,
    'grad': Math.PI / 200,
    'rad': 1,
    'turn': Math.PI * 2
  },
  'turn': {
    'deg': 1 / 360,
    'grad': 1 / 400,
    'rad': 0.5 / Math.PI,
    'turn': 1
  },
  // time
  's': {
    's': 1,
    'ms': 1 / 1000
  },
  'ms': {
    's': 1000,
    'ms': 1
  },
  // frequency
  'Hz': {
    'Hz': 1,
    'kHz': 1000
  },
  'kHz': {
    'Hz': 1 / 1000,
    'kHz': 1
  },
  // resolution
  'dpi': {
    'dpi': 1,
    'dpcm': 1.0 / 2.54,
    'dppx': 1 / 96
  },
  'dpcm': {
    'dpi': 2.54,
    'dpcm': 1,
    'dppx': 2.54 / 96.0
  },
  'dppx': {
    'dpi': 96,
    'dpcm': 96.0 / 2.54,
    'dppx': 1
  }
};

var cssUnitConverter = function (value, sourceUnit, targetUnit, precision) {
  if (!conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
  if (!conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
  var converted = conversions[targetUnit][sourceUnit] * value;

  if (precision !== false) {
    precision = Math.pow(10, parseInt(precision) || 5);
    return Math.round(converted * precision) / precision;
  }

  return converted;
};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cssUnitConverter = cssUnitConverter;

var _cssUnitConverter2 = _interopRequireDefault(_cssUnitConverter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function convertNodes(left, right, precision) {
  switch (left.type) {
    case "LengthValue":
    case "AngleValue":
    case "TimeValue":
    case "FrequencyValue":
    case "ResolutionValue":
      return convertAbsoluteLength(left, right, precision);

    default:
      return {
        left: left,
        right: right
      };
  }
}

function convertAbsoluteLength(left, right, precision) {
  if (right.type === left.type) {
    right = {
      type: left.type,
      value: (0, _cssUnitConverter2["default"])(right.value, right.unit, left.unit, precision),
      unit: left.unit
    };
  }

  return {
    left: left,
    right: right
  };
}

exports["default"] = convertNodes;
module.exports = exports["default"];
}(convert, convert.exports));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flip = flip;

var _convert = convert.exports;

var _convert2 = _interopRequireDefault(_convert);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function reduce(node, precision) {
  if (node.type === "MathExpression") return reduceMathExpression(node, precision);
  if (node.type === "Calc") return reduce(node.value, precision);
  return node;
}

function isEqual(left, right) {
  return left.type === right.type && left.value === right.value;
}

function isValueType(type) {
  switch (type) {
    case "LengthValue":
    case "AngleValue":
    case "TimeValue":
    case "FrequencyValue":
    case "ResolutionValue":
    case "EmValue":
    case "ExValue":
    case "ChValue":
    case "RemValue":
    case "VhValue":
    case "VwValue":
    case "VminValue":
    case "VmaxValue":
    case "PercentageValue":
    case "Value":
      return true;
  }

  return false;
}

function convertMathExpression(node, precision) {
  var nodes = (0, _convert2["default"])(node.left, node.right, precision);
  var left = reduce(nodes.left, precision);
  var right = reduce(nodes.right, precision);

  if (left.type === "MathExpression" && right.type === "MathExpression") {
    if (left.operator === "/" && right.operator === "*" || left.operator === "-" && right.operator === "+" || left.operator === "*" && right.operator === "/" || left.operator === "+" && right.operator === "-") {
      if (isEqual(left.right, right.right)) nodes = (0, _convert2["default"])(left.left, right.left, precision);else if (isEqual(left.right, right.left)) nodes = (0, _convert2["default"])(left.left, right.right, precision);
      left = reduce(nodes.left, precision);
      right = reduce(nodes.right, precision);
    }
  }

  node.left = left;
  node.right = right;
  return node;
}

function flip(operator) {
  return operator === "+" ? "-" : "+";
}

function flipValue(node) {
  if (isValueType(node.type)) node.value = -node.value;else if (node.type == "MathExpression") {
    node.left = flipValue(node.left);
    node.right = flipValue(node.right);
  }
  return node;
}

function reduceAddSubExpression(node, precision) {
  var _node = node,
      left = _node.left,
      right = _node.right,
      op = _node.operator;
  if (left.type === "CssVariable" || right.type === "CssVariable") return node; // something + 0 => something
  // something - 0 => something

  if (right.value === 0) return left; // 0 + something => something

  if (left.value === 0 && op === "+") return right; // 0 - something => -something

  if (left.value === 0 && op === "-") return flipValue(right); // value + value
  // value - value

  if (left.type === right.type && isValueType(left.type)) {
    node = Object.assign({}, left);
    if (op === "+") node.value = left.value + right.value;else node.value = left.value - right.value;
  } // value <op> (expr)


  if (isValueType(left.type) && (right.operator === "+" || right.operator === "-") && right.type === "MathExpression") {
    // value + (value + something) => (value + value) + something
    // value + (value - something) => (value + value) - something
    // value - (value + something) => (value - value) - something
    // value - (value - something) => (value - value) + something
    if (left.type === right.left.type) {
      node = Object.assign({}, node);
      node.left = reduce({
        type: "MathExpression",
        operator: op,
        left: left,
        right: right.left
      }, precision);
      node.right = right.right;
      node.operator = op === "-" ? flip(right.operator) : right.operator;
      return reduce(node, precision);
    } // value + (something + value) => (value + value) + something
    // value + (something - value) => (value - value) + something
    // value - (something + value) => (value - value) - something
    // value - (something - value) => (value + value) - something
    else if (left.type === right.right.type) {
      node = Object.assign({}, node);
      node.left = reduce({
        type: "MathExpression",
        operator: op === "-" ? flip(right.operator) : right.operator,
        left: left,
        right: right.right
      }, precision);
      node.right = right.left;
      return reduce(node, precision);
    }
  } // (expr) <op> value


  if (left.type === "MathExpression" && (left.operator === "+" || left.operator === "-") && isValueType(right.type)) {
    // (value + something) + value => (value + value) + something
    // (value - something) + value => (value + value) - something
    // (value + something) - value => (value - value) + something
    // (value - something) - value => (value - value) - something
    if (right.type === left.left.type) {
      node = Object.assign({}, left);
      node.left = reduce({
        type: "MathExpression",
        operator: op,
        left: left.left,
        right: right
      }, precision);
      return reduce(node, precision);
    } // (something + value) + value => something + (value + value)
    // (something - value1) + value2 => something - (value2 - value1)
    // (something + value) - value => something + (value - value)
    // (something - value) - value => something - (value + value)
    else if (right.type === left.right.type) {
      node = Object.assign({}, left);

      if (left.operator === "-") {
        node.right = reduce({
          type: "MathExpression",
          operator: op === "-" ? "+" : "-",
          left: right,
          right: left.right
        }, precision);
        node.operator = op === "-" ? "-" : "+";
      } else {
        node.right = reduce({
          type: "MathExpression",
          operator: op,
          left: left.right,
          right: right
        }, precision);
      }

      if (node.right.value < 0) {
        node.right.value *= -1;
        node.operator = node.operator === "-" ? "+" : "-";
      }

      return reduce(node, precision);
    }
  }

  return node;
}

function reduceDivisionExpression(node, precision) {
  if (!isValueType(node.right.type)) return node;
  if (node.right.type !== "Value") throw new Error("Cannot divide by \"" + node.right.unit + "\", number expected");
  if (node.right.value === 0) throw new Error("Cannot divide by zero"); // (expr) / value

  if (node.left.type === "MathExpression") {
    if (isValueType(node.left.left.type) && isValueType(node.left.right.type)) {
      node.left.left.value /= node.right.value;
      node.left.right.value /= node.right.value;
      return reduce(node.left, precision);
    }

    return node;
  } // something / value
  else if (isValueType(node.left.type)) {
    node.left.value /= node.right.value;
    return node.left;
  }

  return node;
}

function reduceMultiplicationExpression(node) {
  // (expr) * value
  if (node.left.type === "MathExpression" && node.right.type === "Value") {
    if (isValueType(node.left.left.type) && isValueType(node.left.right.type)) {
      node.left.left.value *= node.right.value;
      node.left.right.value *= node.right.value;
      return node.left;
    }
  } // something * value
  else if (isValueType(node.left.type) && node.right.type === "Value") {
    node.left.value *= node.right.value;
    return node.left;
  } // value * (expr)
  else if (node.left.type === "Value" && node.right.type === "MathExpression") {
    if (isValueType(node.right.left.type) && isValueType(node.right.right.type)) {
      node.right.left.value *= node.left.value;
      node.right.right.value *= node.left.value;
      return node.right;
    }
  } // value * something
  else if (node.left.type === "Value" && isValueType(node.right.type)) {
    node.right.value *= node.left.value;
    return node.right;
  }

  return node;
}

function reduceMaxExpression(node) {
  if (node.left.type !== "LengthValue" || node.right.type !== "LengthValue") {
    throw new Error("Max function can be reduced only if types are LengthValue");
  }

  node.left.value = Math.max(node.left.value, node.right.value);
  return node.left;
}

function reduceMinExpression(node) {
  if (node.left.type !== "LengthValue" || node.right.type !== "LengthValue") {
    throw new Error("Min function can be reduced only if types are LengthValue");
  }

  node.left.value = Math.min(node.left.value, node.right.value);
  return node.left;
}

function reduceMathExpression(node, precision) {
  node = convertMathExpression(node, precision);

  switch (node.operator) {
    case "+":
    case "-":
      return reduceAddSubExpression(node, precision);

    case "/":
      return reduceDivisionExpression(node, precision);

    case "*":
      return reduceMultiplicationExpression(node);

    case "max":
      return reduceMaxExpression(node);

    case "min":
      return reduceMinExpression(node);
  }

  return node;
}

exports["default"] = reduce;
}(reducer$2));

var stringifier = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (calc, node, precision) {
  var str = stringify(node, precision);

  if (node.type === "MathExpression") {
    // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
  }

  return str;
};

var _reducer = reducer$2;

var order = {
  "*": 0,
  "/": 0,
  "+": 1,
  "-": 1
};

function round(value, prec) {
  if (prec !== false) {
    var precision = Math.pow(10, prec);
    return Math.round(value * precision) / precision;
  }

  return value;
}

function stringify(node, prec) {
  switch (node.type) {
    case "MathExpression":
      {
        var left = node.left,
            right = node.right,
            op = node.operator;
        var str = "";
        if (left.type === "MathExpression" && order[op] < order[left.operator]) str += "(" + stringify(left, prec) + ")";else str += stringify(left, prec);
        str += " " + node.operator + " ";

        if (right.type === "MathExpression" && order[op] < order[right.operator]) {
          str += "(" + stringify(right, prec) + ")";
        } else if (right.type === "MathExpression" && op === "-" && ["+", "-"].includes(right.operator)) {
          // fix #52 : a-(b+c) = a-b-c
          right.operator = (0, _reducer.flip)(right.operator);
          str += stringify(right, prec);
        } else {
          str += stringify(right, prec);
        }

        return str;
      }

    case "Value":
      return round(node.value, prec);

    case "CssVariable":
      if (node.fallback) {
        return "var(" + node.value + ", " + stringify(node.fallback, prec) + ")";
      }

      return "var(" + node.value + ")";

    case "Calc":
      if (node.prefix) {
        return "-" + node.prefix + "-calc(" + stringify(node.value, prec) + ")";
      }

      return "calc(" + stringify(node.value, prec) + ")";

    default:
      return round(node.value, prec) + node.unit;
  }
}

module.exports = exports["default"];
}(stringifier, stringifier.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
}; // eslint-disable-line


var _postcssValueParser = lib$2;

var _postcssValueParser2 = _interopRequireDefault(_postcssValueParser);

var _parser = parser;

var _reducer = reducer$2;

var _reducer2 = _interopRequireDefault(_reducer);

var _stringifier = stringifier.exports;

var _stringifier2 = _interopRequireDefault(_stringifier);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;

function calculateAllViewportValues(ast, map) {
  if ((typeof ast === "undefined" ? "undefined" : _typeof(ast)) === "object" && ast !== null) {
    if (ast.type === "VwValue" && ast.unit === "vw" && typeof map.vw === "number") {
      return {
        type: "LengthValue",
        unit: "px",
        value: ast.value / 100 * map.vw
      };
    } else if (ast.type === "PercentageValue" && ast.unit === "%" && typeof map.percent === "number") {
      return {
        type: "LengthValue",
        unit: "px",
        value: ast.value / 100 * map.percent
      };
    } else {
      for (var key in ast) {
        if (_typeof(ast[key]) === "object" && ast[key] !== null) {
          ast[key] = calculateAllViewportValues(ast[key], map);
        }
      }
    }
  }

  return ast;
}

exports["default"] = function (value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var map = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _postcssValueParser2["default"])(value).walk(function (node) {
    // skip anything which isn't a calc() function
    if (node.type !== "function" || !MATCH_CALC.test(node.value)) return; // stringify calc expression and produce an AST

    var contents = _postcssValueParser2["default"].stringify(node.nodes); // skip constant() and env()


    if (contents.indexOf("constant") >= 0 || contents.indexOf("env") >= 0) return;
    var ast = calculateAllViewportValues(_parser.parser.parse(contents), map); // reduce AST to its simplest form, that is, either to a single value
    // or a simplified calc expression

    var reducedAst = (0, _reducer2["default"])(ast, precision, map); // stringify AST and write it back

    node.type = "word";
    node.value = (0, _stringifier2["default"])(node.value, reducedAst, precision);
  }, true).toString();
};

module.exports = exports["default"];
}(dist$1, dist$1.exports));

var reduceCSSCalc = /*@__PURE__*/getDefaultExportFromCjs(dist$1.exports);

function parseSpacing(spacing) {
  if (spacing.endsWith("px")) {
    var value = parseFloat(spacing);

    if (isNaN(value)) {
      throw new Error("incorrect spacing: ".concat(spacing));
    }

    return {
      unit: "px",
      value: value
    };
  }

  if (spacing.endsWith("vw")) {
    var _value = parseFloat(spacing);

    if (isNaN(_value)) {
      throw new Error("incorrect spacing: ".concat(spacing));
    }

    return {
      unit: "vw",
      value: _value
    };
  }

  throw new Error("incorrect spacing: ".concat(spacing, "."));
}
function spacingToPx(spacing, width) {
  var reducedSpacing = reduceCSSCalc("calc(".concat(spacing, ")")
  /* wrapping calc is necessary, otherwise max(10px,20px) doesn't work */
  , 5, {
    vw: width,
    percent: width
  });
  var parsed = parseSpacing(reducedSpacing);

  if (parsed.unit === "px") {
    return parsed.value;
  }

  throw new Error("unreachable");
}

function applyAutoUsingResponsiveTokens(input, compilationContext) {
  if (!isTrulyResponsiveValue(input)) {
    return input;
  }

  var highestDefinedDevice = responsiveValueGetHighestDefinedDevice(input, compilationContext.devices);
  var highestDefinedValue = responsiveValueForceGet(input, highestDefinedDevice.id);
  var inputAfterAuto = {
    $res: true
  };

  for (var i = compilationContext.devices.length - 1; i >= 0; i--) {
    var device = compilationContext.devices[i];
    var value = responsiveValueGet(input, device.id);

    if (value === undefined && isTrulyResponsiveValue(highestDefinedValue.value)) {
      inputAfterAuto[device.id] = highestDefinedValue;
    }

    if (value !== undefined) {
      inputAfterAuto[device.id] = value;
      highestDefinedValue = input[device.id];
    }
  }

  return inputAfterAuto;
}

function linearizeSpace(input, compilationContext, widths) {
  var constant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (!isTrulyResponsiveValue(input)) {
    return input;
  }
  /**
   *
   * Important!
   *
   * Although linearizeSpace takes widths into account (it's obvious) we must still remember about responsive tokens.
   *
   * Responsive tokens will be quite rare (like a container margin or a font size).
   * But still we must remember that responsive tokens are defined relative to SCREEN WIDTH.
   * It means that even if our component has "width" that is not a screen width and is very irregular, then responsive tokens relative to screen width takes precedence!
   * So if our component has width 500px on XL and is wider on smaller breakpoint LG (800px), then if responsive token is bigger on XL than LG it will still hold.
   * It makes a total sense. If we broke this rule and somehow applied widths to responsive tokens, then user could see a font that she totally doesn't want for a specific breakpoint.
   * It usually won't hurt at all, because fonts and container margins are responsive by nature. Actually maybe other spacings shouldn't be possible to be responsive at all!
   * That's why first thing below is to fill undefined values with responsive tokens if possible and only then linearize the remaining ones (with widths taken into account).
   *
   */
  // If responsive value has some token that is responsive, then this token should be applied to all surrounding breakpoints.
  // Responsive token kind of "overrides auto".
  // If we want in the future auto for responsive tokens it's not the place for it. Linearizing tokens should happen in creating compilation context.


  var inputAfterResponsiveTokenAuto = applyAutoUsingResponsiveTokens(input, compilationContext);
  var inputWithScalarNonRefValues = {
    $res: true
  };
  compilationContext.devices.forEach(function (device) {
    if (inputAfterResponsiveTokenAuto[device.id] === undefined) {
      return;
    }

    var refValue = responsiveValueGetDefinedValue(inputAfterResponsiveTokenAuto, device.id, compilationContext.devices, getDevicesWidths(compilationContext.devices));

    if (isTrulyResponsiveValue(refValue.value)) {
      inputWithScalarNonRefValues[device.id] = spacingToPx(responsiveValueGetDefinedValue(refValue.value, device.id, compilationContext.devices, getDevicesWidths(compilationContext.devices)), device.w);
    } else {
      inputWithScalarNonRefValues[device.id] = spacingToPx(refValue.value, device.w);
    }
  });

  if (!areWidthsFullyDefined(widths, compilationContext.devices)) {
    return responsiveValueFill(inputAfterResponsiveTokenAuto, compilationContext.devices, getDevicesWidths(compilationContext.devices));
  } // Let's run linearize function


  var linearisedCompiledValues = linearizeSpaceWithoutNesting(inputWithScalarNonRefValues, compilationContext, widths, constant);
  compilationContext.devices.forEach(function (device) {
    if (inputAfterResponsiveTokenAuto[device.id] === undefined) {
      inputAfterResponsiveTokenAuto[device.id] = snapValueToToken(responsiveValueForceGet(linearisedCompiledValues, device.id), responsiveValueGetFirstLowerValue(inputWithScalarNonRefValues, device.id, compilationContext.devices, getDevicesWidths(compilationContext.devices)), responsiveValueGetFirstHigherValue(inputWithScalarNonRefValues, device.id, compilationContext.devices, getDevicesWidths(compilationContext.devices)), compilationContext.theme.space, constant);
    }
  });
  return inputAfterResponsiveTokenAuto;
}

function snapValueToToken(value, lowerDefinedValue, higherDefinedValue, spaces, constant) {
  var currentToken = undefined;
  var minDelta = Number.MAX_VALUE;

  for (var tokenId in spaces) {
    var tokenValue = spaces[tokenId].value;

    if (isTrulyResponsiveValue(tokenValue)) {
      // only non-responsive
      continue;
    }

    var parsedValue = parseSpacing(tokenValue);

    if (parsedValue.unit === "vw") {
      continue;
    }

    var tokenPxValue = parsedValue.value; // If value smaller than constant then the only possible token is the token equaling the value

    if (value <= constant && tokenPxValue !== value) {
      continue;
    } // token value must be within higher and lower limits


    if (higherDefinedValue !== undefined) {
      if (tokenPxValue > higherDefinedValue) {
        continue;
      }
    }

    if (lowerDefinedValue !== undefined) {
      if (tokenPxValue < lowerDefinedValue) {
        continue;
      }
    }

    if (tokenId.split(".").length > 1) {
      // only non-prefixed
      continue;
    } // snapped token can never be bigger than our constant


    if (tokenPxValue < constant) {
      continue;
    }

    var delta = Math.abs(value - tokenPxValue);

    if (delta < minDelta ||
    /* in case of equal deltas, let's take bigger token */
    currentToken && delta === minDelta && tokenValue > currentToken.value) {
      minDelta = delta;
      currentToken = {
        ref: tokenId,
        value: tokenValue
      };
    }
  }

  if (!currentToken) {
    return {
      value: "".concat(value, "px")
    };
  }

  return currentToken;
}

function linearizeSpaceWithoutNesting(input, compilationContext, widths) {
  var constant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (!isTrulyResponsiveValue(input)) {
    return input;
  } // // If only 1 value is defined (2 keys, $res and value), then we return
  // if (Object.keys(input).length === 2) {
  //   return responsiveValueFill(input, compilationContext.devices);
  // }
  // Empty object returns 0


  if (Object.keys(input).length === 0) {
    console.warn("linearize Space - empty object input, that shouldn't happen, fallback to 0");
    return 0;
  } // For now we just use arrays (from previous implementation). Later they're mapped back to object


  var value = [];
  var referencePoints = [];
  var componentWidths = getDeviceWidthPairs(widths, compilationContext.devices);
  componentWidths.forEach(function (componentWidth, index) {
    var breakpointValue = input[componentWidth.deviceId];
    value[index] = breakpointValue;

    if (breakpointValue === null || breakpointValue === undefined) {
      value[index] = null; // null padding and normalization

      var leftIndex;
      var rightIndex; // Let's find closest left index

      for (var i = index - 1; i >= 0; i--) {
        var val = input[componentWidths[i].deviceId];

        if (val !== undefined) {
          leftIndex = i;
          break;
        }
      } // Let's find closest right index


      for (var _i = index + 1; _i < componentWidths.length; _i++) {
        var _val = input[componentWidths[_i].deviceId];

        if (_val !== undefined) {
          rightIndex = _i;
          break;
        }
      }

      if (leftIndex === undefined && rightIndex === undefined) {
        throw new Error("unreachable");
      }

      referencePoints[index] = {
        leftIndex: leftIndex,
        rightIndex: rightIndex
      };
      return;
    }
  });
  referencePoints.forEach(function (refPoint, index) {
    if (!refPoint) {
      return;
    }

    var currentX = componentWidths[index].width; // Single point linearity

    if (refPoint.leftIndex !== undefined && refPoint.rightIndex === undefined || refPoint.leftIndex === undefined && refPoint.rightIndex !== undefined) {
      var _refPoint$leftIndex;

      var currentRefPoint = (_refPoint$leftIndex = refPoint.leftIndex) !== null && _refPoint$leftIndex !== void 0 ? _refPoint$leftIndex : refPoint.rightIndex;
      var refY = value[currentRefPoint];
      var refX = componentWidths[currentRefPoint].width;
      var deltaY = refY - constant;

      if (deltaY <= 0) {
        value[index] = refY;
      } else {
        var a = (refY - constant) / refX;
        value[index] = a * currentX + constant;
      }
    } else if (refPoint.leftIndex !== undefined && refPoint.rightIndex !== undefined) {
      var p1_x = componentWidths[refPoint.leftIndex].width;
      var p1_y = value[refPoint.leftIndex]; // default a, b (enabled when only p1 is defined)

      var _a = 0,
          b = p1_y;
      var p2_x = componentWidths[refPoint.rightIndex].width;
      var p2_y = value[refPoint.rightIndex];
      var deltaX = p1_x - p2_x;

      if (deltaX === 0) {
        // if delta 0 then we take lower for left and higher for right
        value[index] = index < refPoint.leftIndex ? p1_y : p2_y;
      } else {
        _a = (p1_y - p2_y) / deltaX;
        b = p2_y - _a * p2_x;

        if (_a >= 0) {
          // take into account 0 values!!!
          if (p1_y === 0 || p2_y === 0) {
            if (index < refPoint.leftIndex) {
              _a = 0;
              b = p1_y;
            } else {
              _a = 0;
              b = p2_y;
            }
          }

          value[index] = currentX * _a + b;
        } else {
          // We don't linearize descending functions!
          value[index] = index < refPoint.leftIndex ? p1_y : p2_y;
        }
      }
    } else {
      throw new Error("unreachable");
    }
  });
  var output = {
    $res: true
  };
  value.forEach(function (scalarVal, index) {
    if (scalarVal === undefined || scalarVal === null) {
      return;
    }

    output[componentWidths[index].deviceId] = scalarVal;
  });
  return output;
}

function dotNotationSet(obj, path, value) {
  if (path === "") {
    throw new Error("Path can't be empty in dotNotationSetter");
  }

  if (typeof obj !== "object" || obj === null) {
    throw new Error("dotNotationSet - you're trying to set value for non-object");
  }

  var splitPath = typeof path === "string" ? path.split(".").map(function (x) {
    if (typeof x === "string" && !isNaN(parseInt(x))) {
      return parseInt(x);
    }

    return x;
  }) : path;

  if (splitPath.length === 1) {
    obj[splitPath[0]] = value;
  } else {
    if (!obj[splitPath[0]]) {
      if (typeof splitPath[1] === "number") {
        obj[splitPath[0]] = [];
      } else {
        obj[splitPath[0]] = {};
      }
    }

    dotNotationSet(obj[splitPath[0]], splitPath.slice(1), value);
  }
}

var arrowLeftIcon = {
  type: "dev",
  // label: "Arrow left",
  value: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"red\" width=\"100px\" height=\"100px\"><path d=\"M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z\"/></svg>"
};
var arrowRightIcon = {
  type: "dev",
  // label: "Arrow right",
  value: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z\"/></svg>"
}; // export const chevronLeftIcon: Theme["icons"]["key"] = {
//   type: "dev",
//   // label: "Arrow left",
//   value: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" width="100px" height="100px"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>`,
// };
//
// export const chevronRightIcon: Theme["icons"]["key"] = {
//   type: "dev",
//   // label: "Arrow right",
//   value: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 15" fill="currentColor"><path d="M0.220635 0.208548C0.514814 -0.0695159 0.991773 -0.0695159 1.28595 0.208548L9 7.5L1.28595 14.7915C0.991773 15.0695 0.514814 15.0695 0.220635 14.7915C-0.0735449 14.5134 -0.0735449 14.0626 0.220635 13.7845L6.86937 7.5L0.220635 1.2155C-0.0735449 0.937441 -0.0735449 0.486611 0.220635 0.208548Z" fill="currentColor"/></svg>`,
// };

var playIcon = {
  type: "dev",
  // label: "Play",
  value: "<svg viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M8,5.14V19.14L19,12.14L8,5.14Z\" /></svg>"
};
var pauseIcon = {
  type: "dev",
  // label: "Pause",
  value: "<svg style=\"width:24px;height:24px\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M14,19H18V5H14M6,19H10V5H6V19Z\" /></svg>"
};
var muteIcon = {
  type: "dev",
  // label: "Mute",
  value: "<svg viewBox=\"0 0 24 24\">\n    <path fill=\"currentColor\" d=\"M12,4L9.91,6.09L12,8.18M4.27,3L3,4.27L7.73,9H3V15H7L12,20V13.27L16.25,17.53C15.58,18.04 14.83,18.46 14,18.7V20.77C15.38,20.45 16.63,19.82 17.68,18.96L19.73,21L21,19.73L12,10.73M19,12C19,12.94 18.8,13.82 18.46,14.64L19.97,16.15C20.62,14.91 21,13.5 21,12C21,7.72 18,4.14 14,3.23V5.29C16.89,6.15 19,8.83 19,12M16.5,12C16.5,10.23 15.5,8.71 14,7.97V10.18L16.45,12.63C16.5,12.43 16.5,12.21 16.5,12Z\" />\n</svg>"
};
var unmuteIcon = {
  type: "dev",
  // label: "Unmute",
  value: "<svg viewBox=\"0 0 24 24\">\n    <path fill=\"currentColor\" d=\"M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.84 14,18.7V20.77C18,19.86 21,16.28 21,12C21,7.72 18,4.14 14,3.23M16.5,12C16.5,10.23 15.5,8.71 14,7.97V16C15.5,15.29 16.5,13.76 16.5,12M3,9V15H7L12,20V4L7,9H3Z\" />\n</svg>"
};

function ownKeys$Z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$Y(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$Z(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$Z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var MASTER_FONT_FAMILY = "-apple-system, BlinkMacSystemFont, sans-serif";
var defaultTheme = {
  space: {
    0: {
      value: "0px",
      type: "dev"
    },
    1: {
      value: "1px",
      type: "dev"
    },
    2: {
      value: "2px",
      type: "dev"
    },
    4: {
      value: "4px",
      type: "dev"
    },
    6: {
      value: "6px",
      type: "dev"
    },
    8: {
      value: "8px",
      type: "dev"
    },
    12: {
      value: "12px",
      type: "dev"
    },
    16: {
      value: "16px",
      type: "dev"
    },
    24: {
      value: "24px",
      type: "dev"
    },
    32: {
      value: "32px",
      type: "dev"
    },
    48: {
      value: "48px",
      type: "dev"
    },
    64: {
      value: "64px",
      type: "dev"
    },
    96: {
      value: "96px",
      type: "dev"
    },
    128: {
      value: "128px",
      type: "dev"
    },
    160: {
      value: "160px",
      type: "dev"
    },
    "containerMargin.default": {
      value: {
        $res: true,
        xl: "5vw"
      },
      type: "dev"
    }
  },
  colors: {
    $dark: {
      value: "black",
      type: "dev"
    },
    $light: {
      value: "white",
      type: "dev"
    },
    $backgroundDark: {
      value: "#363636",
      type: "dev"
    },
    $backgroundLight: {
      value: "#F2F2F2",
      type: "dev"
    },
    transparent: {
      value: "transparent",
      type: "dev"
    }
  },
  fonts: {
    $body: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 20,
        fontWeight: 400,
        lineHeight: 1.2,
        "@xs": {
          fontSize: 18
        }
      },
      type: "dev"
    },
    "$body.bold": {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 20,
        fontWeight: 500,
        lineHeight: 1.2,
        "@xs": {
          fontSize: 18
        }
      },
      type: "dev"
    },
    $body2: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: 1.2
      },
      type: "dev"
    },
    "$body2.bold": {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 16,
        fontWeight: 500,
        lineHeight: 1.2
      },
      type: "dev"
    },
    $heading1: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 64,
        fontWeight: 500,
        lineHeight: 1.2,
        "@xs": {
          fontSize: 36
        }
      },
      type: "dev"
    },
    $heading2: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 48,
        fontWeight: 500,
        lineHeight: 1.2,
        "@xs": {
          fontSize: 32
        }
      },
      type: "dev"
    },
    $heading3: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 32,
        fontWeight: 500,
        lineHeight: 1.2,
        "@xs": {
          fontSize: 28
        }
      },
      type: "dev"
    },
    $heading4: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 24,
        fontWeight: 500,
        lineHeight: 1.2
      },
      type: "dev"
    }
  },
  icons: {
    $sliderLeft: _objectSpread$Y({}, arrowLeftIcon),
    $sliderRight: _objectSpread$Y({}, arrowRightIcon),
    $play: _objectSpread$Y({}, playIcon),
    $pause: _objectSpread$Y({}, pauseIcon),
    $mute: _objectSpread$Y({}, muteIcon),
    $unmute: _objectSpread$Y({}, unmuteIcon)
  },
  aspectRatios: {
    $panoramic: {
      value: "2:1",
      type: "dev" // label: "Panoramic",

    },
    $landscape: {
      value: "16:9",
      type: "dev" // label: "Landscape",

    },
    $portrait: {
      value: "4:5",
      type: "dev" // label: "Portrait",

    },
    $square: {
      value: "1:1",
      type: "dev" // label: "Square",

    },
    $gridMainObjectDefault: {
      value: "4:5",
      type: "dev" // label: "Grid main object default",

    }
  },
  numberOfItemsInRow: {
    "1": {
      value: "1",
      type: "dev"
    },
    "2": {
      value: "2",
      type: "dev"
    },
    "3": {
      value: "3",
      type: "dev"
    },
    "4": {
      value: "4",
      type: "dev"
    },
    "5": {
      value: "5",
      type: "dev"
    },
    "6": {
      value: "6",
      type: "dev"
    }
  },
  containerWidths: {
    none: {
      value: "none",
      type: "dev"
    }
  }
};
function buildFullTheme(theme) {
  var _theme$space$containe, _theme$space;

  var userFonts = theme.fonts || {};
  var userAspectRatios = theme.aspectRatios || {};
  var userContainerWidths = theme.containerWidths || {}; // We spread values from default theme because we want to prevent overriding master tokens by our users

  return {
    space: _objectSpread$Y(_objectSpread$Y(_objectSpread$Y({}, theme.space), defaultTheme.space), {}, {
      // This token is an exception and need to be handled manually.
      "containerMargin.default": (_theme$space$containe = (_theme$space = theme.space) === null || _theme$space === void 0 ? void 0 : _theme$space["containerMargin.default"]) !== null && _theme$space$containe !== void 0 ? _theme$space$containe : defaultTheme.space["containerMargin.default"]
    }),
    colors: _objectSpread$Y(_objectSpread$Y({}, theme.colors), defaultTheme.colors),
    fonts: _objectSpread$Y(_objectSpread$Y({}, userFonts), defaultTheme.fonts),
    icons: _objectSpread$Y(_objectSpread$Y({}, theme.icons), defaultTheme.icons),
    numberOfItemsInRow: _objectSpread$Y(_objectSpread$Y({}, theme.numberOfItemsInRow), defaultTheme.numberOfItemsInRow),
    aspectRatios: _objectSpread$Y(_objectSpread$Y({}, userAspectRatios), defaultTheme.aspectRatios),
    containerWidths: _objectSpread$Y(_objectSpread$Y({}, userContainerWidths), defaultTheme.containerWidths)
  };
}

function isComponentConfig(value) {
  return typeof value === "object" && typeof (value === null || value === void 0 ? void 0 : value._template) === "string" && typeof (value === null || value === void 0 ? void 0 : value._id) === "string";
}

function deepCompare() {
  for (var index = 0; index < arguments.length - 1; index++) {
    var currentObject = sortObject(index < 0 || arguments.length <= index ? undefined : arguments[index]);
    var nextObject = sortObject(index + 1 < 0 || arguments.length <= index + 1 ? undefined : arguments[index + 1]);
    var areObjectsHashesEqual = JSON.stringify(currentObject) === JSON.stringify(nextObject);

    if (!areObjectsHashesEqual) {
      return false;
    }
  }

  return true;
}

function sortObject(value) {
  if (typeof value !== "object") {
    return value;
  }

  if (Array.isArray(value)) {
    return _toConsumableArray$2(value).sort();
  }

  if (value === null) {
    return null;
  }

  var sortedObject = {};
  var objectKeys = Object.keys(value).sort();
  objectKeys.forEach(function (key) {
    sortedObject[key] = sortObject(value[key]);
  });
  return sortedObject;
}

var CompilationCache = /*#__PURE__*/function () {
  function CompilationCache(initialEntries) {
    _classCallCheck$d(this, CompilationCache);

    _defineProperty$g(this, "cache", void 0);

    this.cache = initialEntries ? new Map(initialEntries) : new Map();
  }

  _createClass$b(CompilationCache, [{
    key: "get",
    value: function get(key) {
      return this.cache.get(key);
    }
  }, {
    key: "set",
    value: function set(key, entry) {
      this.cache.set(key, entry);
    }
  }, {
    key: "remove",
    value: function remove(path) {
      this.cache["delete"](path);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.cache.clear();
    }
  }, {
    key: "count",
    get: function get() {
      return this.cache.size;
    }
  }]);

  return CompilationCache;
}();

var cryptoJs = {exports: {}};

var core = {exports: {}};

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': _nodeResolve_empty
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

(function (module, exports) {

(function (root, factory) {
  {
    // CommonJS
    module.exports = factory();
  }
})(commonjsGlobal, function () {
  /*globals window, global, require*/

  /**
   * CryptoJS core components.
   */
  var CryptoJS = CryptoJS || function (Math, undefined$1) {
    var crypto; // Native crypto from window (Browser)

    if (typeof window !== 'undefined' && window.crypto) {
      crypto = window.crypto;
    } // Native crypto in web worker (Browser)


    if (typeof self !== 'undefined' && self.crypto) {
      crypto = self.crypto;
    } // Native crypto from worker


    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
      crypto = globalThis.crypto;
    } // Native (experimental IE 11) crypto from window (Browser)


    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
      crypto = window.msCrypto;
    } // Native crypto from global (NodeJS)


    if (!crypto && typeof commonjsGlobal !== 'undefined' && commonjsGlobal.crypto) {
      crypto = commonjsGlobal.crypto;
    } // Native crypto import via require (NodeJS)


    if (!crypto && typeof commonjsRequire === 'function') {
      try {
        crypto = require$$0;
      } catch (err) {}
    }
    /*
     * Cryptographically secure pseudorandom number generator
     *
     * As Math.random() is cryptographically not safe to use
     */


    var cryptoSecureRandomInt = function cryptoSecureRandomInt() {
      if (crypto) {
        // Use getRandomValues method (Browser)
        if (typeof crypto.getRandomValues === 'function') {
          try {
            return crypto.getRandomValues(new Uint32Array(1))[0];
          } catch (err) {}
        } // Use randomBytes method (NodeJS)


        if (typeof crypto.randomBytes === 'function') {
          try {
            return crypto.randomBytes(4).readInt32LE();
          } catch (err) {}
        }
      }

      throw new Error('Native crypto module could not be used to get secure random number.');
    };
    /*
     * Local polyfill of Object.create
      */


    var create = Object.create || function () {
      function F() {}

      return function (obj) {
        var subtype;
        F.prototype = obj;
        subtype = new F();
        F.prototype = null;
        return subtype;
      };
    }();
    /**
     * CryptoJS namespace.
     */


    var C = {};
    /**
     * Library namespace.
     */

    var C_lib = C.lib = {};
    /**
     * Base object for prototypal inheritance.
     */

    var Base = C_lib.Base = function () {
      return {
        /**
         * Creates a new object that inherits from this object.
         *
         * @param {Object} overrides Properties to copy into the new object.
         *
         * @return {Object} The new object.
         *
         * @static
         *
         * @example
         *
         *     var MyType = CryptoJS.lib.Base.extend({
         *         field: 'value',
         *
         *         method: function () {
         *         }
         *     });
         */
        extend: function extend(overrides) {
          // Spawn
          var subtype = create(this); // Augment

          if (overrides) {
            subtype.mixIn(overrides);
          } // Create default initializer


          if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
            subtype.init = function () {
              subtype.$super.init.apply(this, arguments);
            };
          } // Initializer's prototype is the subtype object


          subtype.init.prototype = subtype; // Reference supertype

          subtype.$super = this;
          return subtype;
        },

        /**
         * Extends this object and runs the init method.
         * Arguments to create() will be passed to init().
         *
         * @return {Object} The new object.
         *
         * @static
         *
         * @example
         *
         *     var instance = MyType.create();
         */
        create: function create() {
          var instance = this.extend();
          instance.init.apply(instance, arguments);
          return instance;
        },

        /**
         * Initializes a newly created object.
         * Override this method to add some logic when your objects are created.
         *
         * @example
         *
         *     var MyType = CryptoJS.lib.Base.extend({
         *         init: function () {
         *             // ...
         *         }
         *     });
         */
        init: function init() {},

        /**
         * Copies properties into this object.
         *
         * @param {Object} properties The properties to mix in.
         *
         * @example
         *
         *     MyType.mixIn({
         *         field: 'value'
         *     });
         */
        mixIn: function mixIn(properties) {
          for (var propertyName in properties) {
            if (properties.hasOwnProperty(propertyName)) {
              this[propertyName] = properties[propertyName];
            }
          } // IE won't copy toString using the loop above


          if (properties.hasOwnProperty('toString')) {
            this.toString = properties.toString;
          }
        },

        /**
         * Creates a copy of this object.
         *
         * @return {Object} The clone.
         *
         * @example
         *
         *     var clone = instance.clone();
         */
        clone: function clone() {
          return this.init.prototype.extend(this);
        }
      };
    }();
    /**
     * An array of 32-bit words.
     *
     * @property {Array} words The array of 32-bit words.
     * @property {number} sigBytes The number of significant bytes in this word array.
     */


    var WordArray = C_lib.WordArray = Base.extend({
      /**
       * Initializes a newly created word array.
       *
       * @param {Array} words (Optional) An array of 32-bit words.
       * @param {number} sigBytes (Optional) The number of significant bytes in the words.
       *
       * @example
       *
       *     var wordArray = CryptoJS.lib.WordArray.create();
       *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
       *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
       */
      init: function init(words, sigBytes) {
        words = this.words = words || [];

        if (sigBytes != undefined$1) {
          this.sigBytes = sigBytes;
        } else {
          this.sigBytes = words.length * 4;
        }
      },

      /**
       * Converts this word array to a string.
       *
       * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
       *
       * @return {string} The stringified word array.
       *
       * @example
       *
       *     var string = wordArray + '';
       *     var string = wordArray.toString();
       *     var string = wordArray.toString(CryptoJS.enc.Utf8);
       */
      toString: function toString(encoder) {
        return (encoder || Hex).stringify(this);
      },

      /**
       * Concatenates a word array to this word array.
       *
       * @param {WordArray} wordArray The word array to append.
       *
       * @return {WordArray} This word array.
       *
       * @example
       *
       *     wordArray1.concat(wordArray2);
       */
      concat: function concat(wordArray) {
        // Shortcuts
        var thisWords = this.words;
        var thatWords = wordArray.words;
        var thisSigBytes = this.sigBytes;
        var thatSigBytes = wordArray.sigBytes; // Clamp excess bits

        this.clamp(); // Concat

        if (thisSigBytes % 4) {
          // Copy one byte at a time
          for (var i = 0; i < thatSigBytes; i++) {
            var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
            thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
          }
        } else {
          // Copy one word at a time
          for (var j = 0; j < thatSigBytes; j += 4) {
            thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
          }
        }

        this.sigBytes += thatSigBytes; // Chainable

        return this;
      },

      /**
       * Removes insignificant bits.
       *
       * @example
       *
       *     wordArray.clamp();
       */
      clamp: function clamp() {
        // Shortcuts
        var words = this.words;
        var sigBytes = this.sigBytes; // Clamp

        words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
        words.length = Math.ceil(sigBytes / 4);
      },

      /**
       * Creates a copy of this word array.
       *
       * @return {WordArray} The clone.
       *
       * @example
       *
       *     var clone = wordArray.clone();
       */
      clone: function clone() {
        var clone = Base.clone.call(this);
        clone.words = this.words.slice(0);
        return clone;
      },

      /**
       * Creates a word array filled with random bytes.
       *
       * @param {number} nBytes The number of random bytes to generate.
       *
       * @return {WordArray} The random word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.lib.WordArray.random(16);
       */
      random: function random(nBytes) {
        var words = [];

        for (var i = 0; i < nBytes; i += 4) {
          words.push(cryptoSecureRandomInt());
        }

        return new WordArray.init(words, nBytes);
      }
    });
    /**
     * Encoder namespace.
     */

    var C_enc = C.enc = {};
    /**
     * Hex encoding strategy.
     */

    var Hex = C_enc.Hex = {
      /**
       * Converts a word array to a hex string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The hex string.
       *
       * @static
       *
       * @example
       *
       *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
       */
      stringify: function stringify(wordArray) {
        // Shortcuts
        var words = wordArray.words;
        var sigBytes = wordArray.sigBytes; // Convert

        var hexChars = [];

        for (var i = 0; i < sigBytes; i++) {
          var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
          hexChars.push((bite >>> 4).toString(16));
          hexChars.push((bite & 0x0f).toString(16));
        }

        return hexChars.join('');
      },

      /**
       * Converts a hex string to a word array.
       *
       * @param {string} hexStr The hex string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
       */
      parse: function parse(hexStr) {
        // Shortcut
        var hexStrLength = hexStr.length; // Convert

        var words = [];

        for (var i = 0; i < hexStrLength; i += 2) {
          words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
        }

        return new WordArray.init(words, hexStrLength / 2);
      }
    };
    /**
     * Latin1 encoding strategy.
     */

    var Latin1 = C_enc.Latin1 = {
      /**
       * Converts a word array to a Latin1 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The Latin1 string.
       *
       * @static
       *
       * @example
       *
       *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
       */
      stringify: function stringify(wordArray) {
        // Shortcuts
        var words = wordArray.words;
        var sigBytes = wordArray.sigBytes; // Convert

        var latin1Chars = [];

        for (var i = 0; i < sigBytes; i++) {
          var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
          latin1Chars.push(String.fromCharCode(bite));
        }

        return latin1Chars.join('');
      },

      /**
       * Converts a Latin1 string to a word array.
       *
       * @param {string} latin1Str The Latin1 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
       */
      parse: function parse(latin1Str) {
        // Shortcut
        var latin1StrLength = latin1Str.length; // Convert

        var words = [];

        for (var i = 0; i < latin1StrLength; i++) {
          words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
        }

        return new WordArray.init(words, latin1StrLength);
      }
    };
    /**
     * UTF-8 encoding strategy.
     */

    var Utf8 = C_enc.Utf8 = {
      /**
       * Converts a word array to a UTF-8 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-8 string.
       *
       * @static
       *
       * @example
       *
       *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
       */
      stringify: function stringify(wordArray) {
        try {
          return decodeURIComponent(escape(Latin1.stringify(wordArray)));
        } catch (e) {
          throw new Error('Malformed UTF-8 data');
        }
      },

      /**
       * Converts a UTF-8 string to a word array.
       *
       * @param {string} utf8Str The UTF-8 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
       */
      parse: function parse(utf8Str) {
        return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
      }
    };
    /**
     * Abstract buffered block algorithm template.
     *
     * The property blockSize must be implemented in a concrete subtype.
     *
     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
     */

    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
      /**
       * Resets this block algorithm's data buffer to its initial state.
       *
       * @example
       *
       *     bufferedBlockAlgorithm.reset();
       */
      reset: function reset() {
        // Initial values
        this._data = new WordArray.init();
        this._nDataBytes = 0;
      },

      /**
       * Adds new data to this block algorithm's buffer.
       *
       * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
       *
       * @example
       *
       *     bufferedBlockAlgorithm._append('data');
       *     bufferedBlockAlgorithm._append(wordArray);
       */
      _append: function _append(data) {
        // Convert string to WordArray, else assume WordArray already
        if (typeof data == 'string') {
          data = Utf8.parse(data);
        } // Append


        this._data.concat(data);

        this._nDataBytes += data.sigBytes;
      },

      /**
       * Processes available data blocks.
       *
       * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
       *
       * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
       *
       * @return {WordArray} The processed data.
       *
       * @example
       *
       *     var processedData = bufferedBlockAlgorithm._process();
       *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
       */
      _process: function _process(doFlush) {
        var processedWords; // Shortcuts

        var data = this._data;
        var dataWords = data.words;
        var dataSigBytes = data.sigBytes;
        var blockSize = this.blockSize;
        var blockSizeBytes = blockSize * 4; // Count blocks ready

        var nBlocksReady = dataSigBytes / blockSizeBytes;

        if (doFlush) {
          // Round up to include partial blocks
          nBlocksReady = Math.ceil(nBlocksReady);
        } else {
          // Round down to include only full blocks,
          // less the number of blocks that must remain in the buffer
          nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
        } // Count words ready


        var nWordsReady = nBlocksReady * blockSize; // Count bytes ready

        var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes); // Process blocks

        if (nWordsReady) {
          for (var offset = 0; offset < nWordsReady; offset += blockSize) {
            // Perform concrete-algorithm logic
            this._doProcessBlock(dataWords, offset);
          } // Remove processed words


          processedWords = dataWords.splice(0, nWordsReady);
          data.sigBytes -= nBytesReady;
        } // Return processed words


        return new WordArray.init(processedWords, nBytesReady);
      },

      /**
       * Creates a copy of this object.
       *
       * @return {Object} The clone.
       *
       * @example
       *
       *     var clone = bufferedBlockAlgorithm.clone();
       */
      clone: function clone() {
        var clone = Base.clone.call(this);
        clone._data = this._data.clone();
        return clone;
      },
      _minBufferSize: 0
    });
    /**
     * Abstract hasher template.
     *
     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
     */

    C_lib.Hasher = BufferedBlockAlgorithm.extend({
      /**
       * Configuration options.
       */
      cfg: Base.extend(),

      /**
       * Initializes a newly created hasher.
       *
       * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
       *
       * @example
       *
       *     var hasher = CryptoJS.algo.SHA256.create();
       */
      init: function init(cfg) {
        // Apply config defaults
        this.cfg = this.cfg.extend(cfg); // Set initial values

        this.reset();
      },

      /**
       * Resets this hasher to its initial state.
       *
       * @example
       *
       *     hasher.reset();
       */
      reset: function reset() {
        // Reset data buffer
        BufferedBlockAlgorithm.reset.call(this); // Perform concrete-hasher logic

        this._doReset();
      },

      /**
       * Updates this hasher with a message.
       *
       * @param {WordArray|string} messageUpdate The message to append.
       *
       * @return {Hasher} This hasher.
       *
       * @example
       *
       *     hasher.update('message');
       *     hasher.update(wordArray);
       */
      update: function update(messageUpdate) {
        // Append
        this._append(messageUpdate); // Update the hash


        this._process(); // Chainable


        return this;
      },

      /**
       * Finalizes the hash computation.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} messageUpdate (Optional) A final message update.
       *
       * @return {WordArray} The hash.
       *
       * @example
       *
       *     var hash = hasher.finalize();
       *     var hash = hasher.finalize('message');
       *     var hash = hasher.finalize(wordArray);
       */
      finalize: function finalize(messageUpdate) {
        // Final message update
        if (messageUpdate) {
          this._append(messageUpdate);
        } // Perform concrete-hasher logic


        var hash = this._doFinalize();

        return hash;
      },
      blockSize: 512 / 32,

      /**
       * Creates a shortcut function to a hasher's object interface.
       *
       * @param {Hasher} hasher The hasher to create a helper for.
       *
       * @return {Function} The shortcut function.
       *
       * @static
       *
       * @example
       *
       *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
       */
      _createHelper: function _createHelper(hasher) {
        return function (message, cfg) {
          return new hasher.init(cfg).finalize(message);
        };
      },

      /**
       * Creates a shortcut function to the HMAC's object interface.
       *
       * @param {Hasher} hasher The hasher to use in this HMAC helper.
       *
       * @return {Function} The shortcut function.
       *
       * @static
       *
       * @example
       *
       *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
       */
      _createHmacHelper: function _createHmacHelper(hasher) {
        return function (message, key) {
          return new C_algo.HMAC.init(hasher, key).finalize(message);
        };
      }
    });
    /**
     * Algorithm namespace.
     */

    var C_algo = C.algo = {};
    return C;
  }(Math);

  return CryptoJS;
});
}(core));

var x64Core = {exports: {}};

(function (module, exports) {

(function (root, factory) {
  {
    // CommonJS
    module.exports = factory(core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function (undefined$1) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Base = C_lib.Base;
    var X32WordArray = C_lib.WordArray;
    /**
     * x64 namespace.
     */

    var C_x64 = C.x64 = {};
    /**
     * A 64-bit word.
     */

    C_x64.Word = Base.extend({
      /**
       * Initializes a newly created 64-bit word.
       *
       * @param {number} high The high 32 bits.
       * @param {number} low The low 32 bits.
       *
       * @example
       *
       *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
       */
      init: function init(high, low) {
        this.high = high;
        this.low = low;
      }
      /**
       * Bitwise NOTs this word.
       *
       * @return {X64Word} A new x64-Word object after negating.
       *
       * @example
       *
       *     var negated = x64Word.not();
       */
      // not: function () {
      // var high = ~this.high;
      // var low = ~this.low;
      // return X64Word.create(high, low);
      // },

      /**
       * Bitwise ANDs this word with the passed word.
       *
       * @param {X64Word} word The x64-Word to AND with this word.
       *
       * @return {X64Word} A new x64-Word object after ANDing.
       *
       * @example
       *
       *     var anded = x64Word.and(anotherX64Word);
       */
      // and: function (word) {
      // var high = this.high & word.high;
      // var low = this.low & word.low;
      // return X64Word.create(high, low);
      // },

      /**
       * Bitwise ORs this word with the passed word.
       *
       * @param {X64Word} word The x64-Word to OR with this word.
       *
       * @return {X64Word} A new x64-Word object after ORing.
       *
       * @example
       *
       *     var ored = x64Word.or(anotherX64Word);
       */
      // or: function (word) {
      // var high = this.high | word.high;
      // var low = this.low | word.low;
      // return X64Word.create(high, low);
      // },

      /**
       * Bitwise XORs this word with the passed word.
       *
       * @param {X64Word} word The x64-Word to XOR with this word.
       *
       * @return {X64Word} A new x64-Word object after XORing.
       *
       * @example
       *
       *     var xored = x64Word.xor(anotherX64Word);
       */
      // xor: function (word) {
      // var high = this.high ^ word.high;
      // var low = this.low ^ word.low;
      // return X64Word.create(high, low);
      // },

      /**
       * Shifts this word n bits to the left.
       *
       * @param {number} n The number of bits to shift.
       *
       * @return {X64Word} A new x64-Word object after shifting.
       *
       * @example
       *
       *     var shifted = x64Word.shiftL(25);
       */
      // shiftL: function (n) {
      // if (n < 32) {
      // var high = (this.high << n) | (this.low >>> (32 - n));
      // var low = this.low << n;
      // } else {
      // var high = this.low << (n - 32);
      // var low = 0;
      // }
      // return X64Word.create(high, low);
      // },

      /**
       * Shifts this word n bits to the right.
       *
       * @param {number} n The number of bits to shift.
       *
       * @return {X64Word} A new x64-Word object after shifting.
       *
       * @example
       *
       *     var shifted = x64Word.shiftR(7);
       */
      // shiftR: function (n) {
      // if (n < 32) {
      // var low = (this.low >>> n) | (this.high << (32 - n));
      // var high = this.high >>> n;
      // } else {
      // var low = this.high >>> (n - 32);
      // var high = 0;
      // }
      // return X64Word.create(high, low);
      // },

      /**
       * Rotates this word n bits to the left.
       *
       * @param {number} n The number of bits to rotate.
       *
       * @return {X64Word} A new x64-Word object after rotating.
       *
       * @example
       *
       *     var rotated = x64Word.rotL(25);
       */
      // rotL: function (n) {
      // return this.shiftL(n).or(this.shiftR(64 - n));
      // },

      /**
       * Rotates this word n bits to the right.
       *
       * @param {number} n The number of bits to rotate.
       *
       * @return {X64Word} A new x64-Word object after rotating.
       *
       * @example
       *
       *     var rotated = x64Word.rotR(7);
       */
      // rotR: function (n) {
      // return this.shiftR(n).or(this.shiftL(64 - n));
      // },

      /**
       * Adds this word with the passed word.
       *
       * @param {X64Word} word The x64-Word to add with this word.
       *
       * @return {X64Word} A new x64-Word object after adding.
       *
       * @example
       *
       *     var added = x64Word.add(anotherX64Word);
       */
      // add: function (word) {
      // var low = (this.low + word.low) | 0;
      // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
      // var high = (this.high + word.high + carry) | 0;
      // return X64Word.create(high, low);
      // }

    });
    /**
     * An array of 64-bit words.
     *
     * @property {Array} words The array of CryptoJS.x64.Word objects.
     * @property {number} sigBytes The number of significant bytes in this word array.
     */

    C_x64.WordArray = Base.extend({
      /**
       * Initializes a newly created word array.
       *
       * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
       * @param {number} sigBytes (Optional) The number of significant bytes in the words.
       *
       * @example
       *
       *     var wordArray = CryptoJS.x64.WordArray.create();
       *
       *     var wordArray = CryptoJS.x64.WordArray.create([
       *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
       *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
       *     ]);
       *
       *     var wordArray = CryptoJS.x64.WordArray.create([
       *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
       *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
       *     ], 10);
       */
      init: function init(words, sigBytes) {
        words = this.words = words || [];

        if (sigBytes != undefined$1) {
          this.sigBytes = sigBytes;
        } else {
          this.sigBytes = words.length * 8;
        }
      },

      /**
       * Converts this 64-bit word array to a 32-bit word array.
       *
       * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
       *
       * @example
       *
       *     var x32WordArray = x64WordArray.toX32();
       */
      toX32: function toX32() {
        // Shortcuts
        var x64Words = this.words;
        var x64WordsLength = x64Words.length; // Convert

        var x32Words = [];

        for (var i = 0; i < x64WordsLength; i++) {
          var x64Word = x64Words[i];
          x32Words.push(x64Word.high);
          x32Words.push(x64Word.low);
        }

        return X32WordArray.create(x32Words, this.sigBytes);
      },

      /**
       * Creates a copy of this word array.
       *
       * @return {X64WordArray} The clone.
       *
       * @example
       *
       *     var clone = x64WordArray.clone();
       */
      clone: function clone() {
        var clone = Base.clone.call(this); // Clone "words" array

        var words = clone.words = this.words.slice(0); // Clone each X64Word object

        var wordsLength = words.length;

        for (var i = 0; i < wordsLength; i++) {
          words[i] = words[i].clone();
        }

        return clone;
      }
    });
  })();

  return CryptoJS;
});
}(x64Core));

var libTypedarrays = {exports: {}};

(function (module, exports) {

(function (root, factory) {
  {
    // CommonJS
    module.exports = factory(core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Check if typed arrays are supported
    if (typeof ArrayBuffer != 'function') {
      return;
    } // Shortcuts


    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray; // Reference original init

    var superInit = WordArray.init; // Augment WordArray.init to handle typed arrays

    var subInit = WordArray.init = function (typedArray) {
      // Convert buffers to uint8
      if (typedArray instanceof ArrayBuffer) {
        typedArray = new Uint8Array(typedArray);
      } // Convert other array views to uint8


      if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
        typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
      } // Handle Uint8Array


      if (typedArray instanceof Uint8Array) {
        // Shortcut
        var typedArrayByteLength = typedArray.byteLength; // Extract bytes

        var words = [];

        for (var i = 0; i < typedArrayByteLength; i++) {
          words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
        } // Initialize this word array


        superInit.call(this, words, typedArrayByteLength);
      } else {
        // Else call normal init
        superInit.apply(this, arguments);
      }
    };

    subInit.prototype = WordArray;
  })();

  return CryptoJS.lib.WordArray;
});
}(libTypedarrays));

var encUtf16 = {exports: {}};

(function (module, exports) {

(function (root, factory) {
  {
    // CommonJS
    module.exports = factory(core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var C_enc = C.enc;
    /**
     * UTF-16 BE encoding strategy.
     */

    C_enc.Utf16 = C_enc.Utf16BE = {
      /**
       * Converts a word array to a UTF-16 BE string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-16 BE string.
       *
       * @static
       *
       * @example
       *
       *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
       */
      stringify: function stringify(wordArray) {
        // Shortcuts
        var words = wordArray.words;
        var sigBytes = wordArray.sigBytes; // Convert

        var utf16Chars = [];

        for (var i = 0; i < sigBytes; i += 2) {
          var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
          utf16Chars.push(String.fromCharCode(codePoint));
        }

        return utf16Chars.join('');
      },

      /**
       * Converts a UTF-16 BE string to a word array.
       *
       * @param {string} utf16Str The UTF-16 BE string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
       */
      parse: function parse(utf16Str) {
        // Shortcut
        var utf16StrLength = utf16Str.length; // Convert

        var words = [];

        for (var i = 0; i < utf16StrLength; i++) {
          words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
        }

        return WordArray.create(words, utf16StrLength * 2);
      }
    };
    /**
     * UTF-16 LE encoding strategy.
     */

    C_enc.Utf16LE = {
      /**
       * Converts a word array to a UTF-16 LE string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-16 LE string.
       *
       * @static
       *
       * @example
       *
       *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
       */
      stringify: function stringify(wordArray) {
        // Shortcuts
        var words = wordArray.words;
        var sigBytes = wordArray.sigBytes; // Convert

        var utf16Chars = [];

        for (var i = 0; i < sigBytes; i += 2) {
          var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
          utf16Chars.push(String.fromCharCode(codePoint));
        }

        return utf16Chars.join('');
      },

      /**
       * Converts a UTF-16 LE string to a word array.
       *
       * @param {string} utf16Str The UTF-16 LE string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
       */
      parse: function parse(utf16Str) {
        // Shortcut
        var utf16StrLength = utf16Str.length; // Convert

        var words = [];

        for (var i = 0; i < utf16StrLength; i++) {
          words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
        }

        return WordArray.create(words, utf16StrLength * 2);
      }
    };

    function swapEndian(word) {
      return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
    }
  })();

  return CryptoJS.enc.Utf16;
});
}(encUtf16));

var encBase64 = {exports: {}};

(function (module, exports) {

(function (root, factory) {
  {
    // CommonJS
    module.exports = factory(core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var C_enc = C.enc;
    /**
     * Base64 encoding strategy.
     */

    C_enc.Base64 = {
      /**
       * Converts a word array to a Base64 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The Base64 string.
       *
       * @static
       *
       * @example
       *
       *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
       */
      stringify: function stringify(wordArray) {
        // Shortcuts
        var words = wordArray.words;
        var sigBytes = wordArray.sigBytes;
        var map = this._map; // Clamp excess bits

        wordArray.clamp(); // Convert

        var base64Chars = [];

        for (var i = 0; i < sigBytes; i += 3) {
          var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
          var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
          var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
          var triplet = byte1 << 16 | byte2 << 8 | byte3;

          for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
            base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
          }
        } // Add padding


        var paddingChar = map.charAt(64);

        if (paddingChar) {
          while (base64Chars.length % 4) {
            base64Chars.push(paddingChar);
          }
        }

        return base64Chars.join('');
      },

      /**
       * Converts a Base64 string to a word array.
       *
       * @param {string} base64Str The Base64 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
       */
      parse: function parse(base64Str) {
        // Shortcuts
        var base64StrLength = base64Str.length;
        var map = this._map;
        var reverseMap = this._reverseMap;

        if (!reverseMap) {
          reverseMap = this._reverseMap = [];

          for (var j = 0; j < map.length; j++) {
            reverseMap[map.charCodeAt(j)] = j;
          }
        } // Ignore padding


        var paddingChar = map.charAt(64);

        if (paddingChar) {
          var paddingIndex = base64Str.indexOf(paddingChar);

          if (paddingIndex !== -1) {
            base64StrLength = paddingIndex;
          }
        } // Convert


        return parseLoop(base64Str, base64StrLength, reverseMap);
      },
      _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    };

    function parseLoop(base64Str, base64StrLength, reverseMap) {
      var words = [];
      var nBytes = 0;

      for (var i = 0; i < base64StrLength; i++) {
        if (i % 4) {
          var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
          var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
          var bitsCombined = bits1 | bits2;
          words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
          nBytes++;
        }
      }

      return WordArray.create(words, nBytes);
    }
  })();

  return CryptoJS.enc.Base64;
});
}(encBase64));

var encBase64url = {exports: {}};

(function (module, exports) {

(function (root, factory) {
  {
    // CommonJS
    module.exports = factory(core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var C_enc = C.enc;
    /**
     * Base64url encoding strategy.
     */

    C_enc.Base64url = {
      /**
       * Converts a word array to a Base64url string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @param {boolean} urlSafe Whether to use url safe
       *
       * @return {string} The Base64url string.
       *
       * @static
       *
       * @example
       *
       *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
       */
      stringify: function stringify(wordArray) {
        var urlSafe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        // Shortcuts
        var words = wordArray.words;
        var sigBytes = wordArray.sigBytes;
        var map = urlSafe ? this._safe_map : this._map; // Clamp excess bits

        wordArray.clamp(); // Convert

        var base64Chars = [];

        for (var i = 0; i < sigBytes; i += 3) {
          var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
          var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
          var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
          var triplet = byte1 << 16 | byte2 << 8 | byte3;

          for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
            base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
          }
        } // Add padding


        var paddingChar = map.charAt(64);

        if (paddingChar) {
          while (base64Chars.length % 4) {
            base64Chars.push(paddingChar);
          }
        }

        return base64Chars.join('');
      },

      /**
       * Converts a Base64url string to a word array.
       *
       * @param {string} base64Str The Base64url string.
       *
       * @param {boolean} urlSafe Whether to use url safe
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
       */
      parse: function parse(base64Str) {
        var urlSafe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        // Shortcuts
        var base64StrLength = base64Str.length;
        var map = urlSafe ? this._safe_map : this._map;
        var reverseMap = this._reverseMap;

        if (!reverseMap) {
          reverseMap = this._reverseMap = [];

          for (var j = 0; j < map.length; j++) {
            reverseMap[map.charCodeAt(j)] = j;
          }
        } // Ignore padding


        var paddingChar = map.charAt(64);

        if (paddingChar) {
          var paddingIndex = base64Str.indexOf(paddingChar);

          if (paddingIndex !== -1) {
            base64StrLength = paddingIndex;
          }
        } // Convert


        return parseLoop(base64Str, base64StrLength, reverseMap);
      },
      _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
      _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
    };

    function parseLoop(base64Str, base64StrLength, reverseMap) {
      var words = [];
      var nBytes = 0;

      for (var i = 0; i < base64StrLength; i++) {
        if (i % 4) {
          var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
          var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
          var bitsCombined = bits1 | bits2;
          words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
          nBytes++;
        }
      }

      return WordArray.create(words, nBytes);
    }
  })();

  return CryptoJS.enc.Base64url;
});
}(encBase64url));

var md5 = {exports: {}};

(function (module, exports) {

(function (root, factory) {
  {
    // CommonJS
    module.exports = factory(core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function (Math) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var Hasher = C_lib.Hasher;
    var C_algo = C.algo; // Constants table

    var T = []; // Compute constants

    (function () {
      for (var i = 0; i < 64; i++) {
        T[i] = Math.abs(Math.sin(i + 1)) * 0x100000000 | 0;
      }
    })();
    /**
     * MD5 hash algorithm.
     */


    var MD5 = C_algo.MD5 = Hasher.extend({
      _doReset: function _doReset() {
        this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476]);
      },
      _doProcessBlock: function _doProcessBlock(M, offset) {
        // Swap endian
        for (var i = 0; i < 16; i++) {
          // Shortcuts
          var offset_i = offset + i;
          var M_offset_i = M[offset_i];
          M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
        } // Shortcuts


        var H = this._hash.words;
        var M_offset_0 = M[offset + 0];
        var M_offset_1 = M[offset + 1];
        var M_offset_2 = M[offset + 2];
        var M_offset_3 = M[offset + 3];
        var M_offset_4 = M[offset + 4];
        var M_offset_5 = M[offset + 5];
        var M_offset_6 = M[offset + 6];
        var M_offset_7 = M[offset + 7];
        var M_offset_8 = M[offset + 8];
        var M_offset_9 = M[offset + 9];
        var M_offset_10 = M[offset + 10];
        var M_offset_11 = M[offset + 11];
        var M_offset_12 = M[offset + 12];
        var M_offset_13 = M[offset + 13];
        var M_offset_14 = M[offset + 14];
        var M_offset_15 = M[offset + 15]; // Working varialbes

        var a = H[0];
        var b = H[1];
        var c = H[2];
        var d = H[3]; // Computation

        a = FF(a, b, c, d, M_offset_0, 7, T[0]);
        d = FF(d, a, b, c, M_offset_1, 12, T[1]);
        c = FF(c, d, a, b, M_offset_2, 17, T[2]);
        b = FF(b, c, d, a, M_offset_3, 22, T[3]);
        a = FF(a, b, c, d, M_offset_4, 7, T[4]);
        d = FF(d, a, b, c, M_offset_5, 12, T[5]);
        c = FF(c, d, a, b, M_offset_6, 17, T[6]);
        b = FF(b, c, d, a, M_offset_7, 22, T[7]);
        a = FF(a, b, c, d, M_offset_8, 7, T[8]);
        d = FF(d, a, b, c, M_offset_9, 12, T[9]);
        c = FF(c, d, a, b, M_offset_10, 17, T[10]);
        b = FF(b, c, d, a, M_offset_11, 22, T[11]);
        a = FF(a, b, c, d, M_offset_12, 7, T[12]);
        d = FF(d, a, b, c, M_offset_13, 12, T[13]);
        c = FF(c, d, a, b, M_offset_14, 17, T[14]);
        b = FF(b, c, d, a, M_offset_15, 22, T[15]);
        a = GG(a, b, c, d, M_offset_1, 5, T[16]);
        d = GG(d, a, b, c, M_offset_6, 9, T[17]);
        c = GG(c, d, a, b, M_offset_11, 14, T[18]);
        b = GG(b, c, d, a, M_offset_0, 20, T[19]);
        a = GG(a, b, c, d, M_offset_5, 5, T[20]);
        d = GG(d, a, b, c, M_offset_10, 9, T[21]);
        c = GG(c, d, a, b, M_offset_15, 14, T[22]);
        b = GG(b, c, d, a, M_offset_4, 20, T[23]);
        a = GG(a, b, c, d, M_offset_9, 5, T[24]);
        d = GG(d, a, b, c, M_offset_14, 9, T[25]);
        c = GG(c, d, a, b, M_offset_3, 14, T[26]);
        b = GG(b, c, d, a, M_offset_8, 20, T[27]);
        a = GG(a, b, c, d, M_offset_13, 5, T[28]);
        d = GG(d, a, b, c, M_offset_2, 9, T[29]);
        c = GG(c, d, a, b, M_offset_7, 14, T[30]);
        b = GG(b, c, d, a, M_offset_12, 20, T[31]);
        a = HH(a, b, c, d, M_offset_5, 4, T[32]);
        d = HH(d, a, b, c, M_offset_8, 11, T[33]);
        c = HH(c, d, a, b, M_offset_11, 16, T[34]);
        b = HH(b, c, d, a, M_offset_14, 23, T[35]);
        a = HH(a, b, c, d, M_offset_1, 4, T[36]);
        d = HH(d, a, b, c, M_offset_4, 11, T[37]);
        c = HH(c, d, a, b, M_offset_7, 16, T[38]);
        b = HH(b, c, d, a, M_offset_10, 23, T[39]);
        a = HH(a, b, c, d, M_offset_13, 4, T[40]);
        d = HH(d, a, b, c, M_offset_0, 11, T[41]);
        c = HH(c, d, a, b, M_offset_3, 16, T[42]);
        b = HH(b, c, d, a, M_offset_6, 23, T[43]);
        a = HH(a, b, c, d, M_offset_9, 4, T[44]);
        d = HH(d, a, b, c, M_offset_12, 11, T[45]);
        c = HH(c, d, a, b, M_offset_15, 16, T[46]);
        b = HH(b, c, d, a, M_offset_2, 23, T[47]);
        a = II(a, b, c, d, M_offset_0, 6, T[48]);
        d = II(d, a, b, c, M_offset_7, 10, T[49]);
        c = II(c, d, a, b, M_offset_14, 15, T[50]);
        b = II(b, c, d, a, M_offset_5, 21, T[51]);
        a = II(a, b, c, d, M_offset_12, 6, T[52]);
        d = II(d, a, b, c, M_offset_3, 10, T[53]);
        c = II(c, d, a, b, M_offset_10, 15, T[54]);
        b = II(b, c, d, a, M_offset_1, 21, T[55]);
        a = II(a, b, c, d, M_offset_8, 6, T[56]);
        d = II(d, a, b, c, M_offset_15, 10, T[57]);
        c = II(c, d, a, b, M_offset_6, 15, T[58]);
        b = II(b, c, d, a, M_offset_13, 21, T[59]);
        a = II(a, b, c, d, M_offset_4, 6, T[60]);
        d = II(d, a, b, c, M_offset_11, 10, T[61]);
        c = II(c, d, a, b, M_offset_2, 15, T[62]);
        b = II(b, c, d, a, M_offset_9, 21, T[63]); // Intermediate hash value

        H[0] = H[0] + a | 0;
        H[1] = H[1] + b | 0;
        H[2] = H[2] + c | 0;
        H[3] = H[3] + d | 0;
      },
      _doFinalize: function _doFinalize() {
        // Shortcuts
        var data = this._data;
        var dataWords = data.words;
        var nBitsTotal = this._nDataBytes * 8;
        var nBitsLeft = data.sigBytes * 8; // Add padding

        dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
        var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
        var nBitsTotalL = nBitsTotal;
        dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
        dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
        data.sigBytes = (dataWords.length + 1) * 4; // Hash final blocks

        this._process(); // Shortcuts


        var hash = this._hash;
        var H = hash.words; // Swap endian

        for (var i = 0; i < 4; i++) {
          // Shortcut
          var H_i = H[i];
          H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
        } // Return final computed hash


        return hash;
      },
      clone: function clone() {
        var clone = Hasher.clone.call(this);
        clone._hash = this._hash.clone();
        return clone;
      }
    });

    function FF(a, b, c, d, x, s, t) {
      var n = a + (b & c | ~b & d) + x + t;
      return (n << s | n >>> 32 - s) + b;
    }

    function GG(a, b, c, d, x, s, t) {
      var n = a + (b & d | c & ~d) + x + t;
      return (n << s | n >>> 32 - s) + b;
    }

    function HH(a, b, c, d, x, s, t) {
      var n = a + (b ^ c ^ d) + x + t;
      return (n << s | n >>> 32 - s) + b;
    }

    function II(a, b, c, d, x, s, t) {
      var n = a + (c ^ (b | ~d)) + x + t;
      return (n << s | n >>> 32 - s) + b;
    }
    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.MD5('message');
     *     var hash = CryptoJS.MD5(wordArray);
     */


    C.MD5 = Hasher._createHelper(MD5);
    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacMD5(message, key);
     */

    C.HmacMD5 = Hasher._createHmacHelper(MD5);
  })(Math);

  return CryptoJS.MD5;
});
}(md5));

var sha1 = {exports: {}};

(function (module, exports) {

(function (root, factory) {
  {
    // CommonJS
    module.exports = factory(core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var Hasher = C_lib.Hasher;
    var C_algo = C.algo; // Reusable object

    var W = [];
    /**
     * SHA-1 hash algorithm.
     */

    var SHA1 = C_algo.SHA1 = Hasher.extend({
      _doReset: function _doReset() {
        this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0]);
      },
      _doProcessBlock: function _doProcessBlock(M, offset) {
        // Shortcut
        var H = this._hash.words; // Working variables

        var a = H[0];
        var b = H[1];
        var c = H[2];
        var d = H[3];
        var e = H[4]; // Computation

        for (var i = 0; i < 80; i++) {
          if (i < 16) {
            W[i] = M[offset + i] | 0;
          } else {
            var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = n << 1 | n >>> 31;
          }

          var t = (a << 5 | a >>> 27) + e + W[i];

          if (i < 20) {
            t += (b & c | ~b & d) + 0x5a827999;
          } else if (i < 40) {
            t += (b ^ c ^ d) + 0x6ed9eba1;
          } else if (i < 60) {
            t += (b & c | b & d | c & d) - 0x70e44324;
          } else
            /* if (i < 80) */
            {
              t += (b ^ c ^ d) - 0x359d3e2a;
            }

          e = d;
          d = c;
          c = b << 30 | b >>> 2;
          b = a;
          a = t;
        } // Intermediate hash value


        H[0] = H[0] + a | 0;
        H[1] = H[1] + b | 0;
        H[2] = H[2] + c | 0;
        H[3] = H[3] + d | 0;
        H[4] = H[4] + e | 0;
      },
      _doFinalize: function _doFinalize() {
        // Shortcuts
        var data = this._data;
        var dataWords = data.words;
        var nBitsTotal = this._nDataBytes * 8;
        var nBitsLeft = data.sigBytes * 8; // Add padding

        dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
        dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
        dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
        data.sigBytes = dataWords.length * 4; // Hash final blocks

        this._process(); // Return final computed hash


        return this._hash;
      },
      clone: function clone() {
        var clone = Hasher.clone.call(this);
        clone._hash = this._hash.clone();
        return clone;
      }
    });
    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA1('message');
     *     var hash = CryptoJS.SHA1(wordArray);
     */

    C.SHA1 = Hasher._createHelper(SHA1);
    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA1(message, key);
     */

    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
  })();

  return CryptoJS.SHA1;
});
}(sha1));

var sha256 = {exports: {}};

(function (module, exports) {

(function (root, factory) {
  {
    // CommonJS
    module.exports = factory(core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function (Math) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var Hasher = C_lib.Hasher;
    var C_algo = C.algo; // Initialization and round constants tables

    var H = [];
    var K = []; // Compute constants

    (function () {
      function isPrime(n) {
        var sqrtN = Math.sqrt(n);

        for (var factor = 2; factor <= sqrtN; factor++) {
          if (!(n % factor)) {
            return false;
          }
        }

        return true;
      }

      function getFractionalBits(n) {
        return (n - (n | 0)) * 0x100000000 | 0;
      }

      var n = 2;
      var nPrime = 0;

      while (nPrime < 64) {
        if (isPrime(n)) {
          if (nPrime < 8) {
            H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
          }

          K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
          nPrime++;
        }

        n++;
      }
    })(); // Reusable object


    var W = [];
    /**
     * SHA-256 hash algorithm.
     */

    var SHA256 = C_algo.SHA256 = Hasher.extend({
      _doReset: function _doReset() {
        this._hash = new WordArray.init(H.slice(0));
      },
      _doProcessBlock: function _doProcessBlock(M, offset) {
        // Shortcut
        var H = this._hash.words; // Working variables

        var a = H[0];
        var b = H[1];
        var c = H[2];
        var d = H[3];
        var e = H[4];
        var f = H[5];
        var g = H[6];
        var h = H[7]; // Computation

        for (var i = 0; i < 64; i++) {
          if (i < 16) {
            W[i] = M[offset + i] | 0;
          } else {
            var gamma0x = W[i - 15];
            var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
            var gamma1x = W[i - 2];
            var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
            W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
          }

          var ch = e & f ^ ~e & g;
          var maj = a & b ^ a & c ^ b & c;
          var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
          var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
          var t1 = h + sigma1 + ch + K[i] + W[i];
          var t2 = sigma0 + maj;
          h = g;
          g = f;
          f = e;
          e = d + t1 | 0;
          d = c;
          c = b;
          b = a;
          a = t1 + t2 | 0;
        } // Intermediate hash value


        H[0] = H[0] + a | 0;
        H[1] = H[1] + b | 0;
        H[2] = H[2] + c | 0;
        H[3] = H[3] + d | 0;
        H[4] = H[4] + e | 0;
        H[5] = H[5] + f | 0;
        H[6] = H[6] + g | 0;
        H[7] = H[7] + h | 0;
      },
      _doFinalize: function _doFinalize() {
        // Shortcuts
        var data = this._data;
        var dataWords = data.words;
        var nBitsTotal = this._nDataBytes * 8;
        var nBitsLeft = data.sigBytes * 8; // Add padding

        dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
        dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
        dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
        data.sigBytes = dataWords.length * 4; // Hash final blocks

        this._process(); // Return final computed hash


        return this._hash;
      },
      clone: function clone() {
        var clone = Hasher.clone.call(this);
        clone._hash = this._hash.clone();
        return clone;
      }
    });
    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA256('message');
     *     var hash = CryptoJS.SHA256(wordArray);
     */

    C.SHA256 = Hasher._createHelper(SHA256);
    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA256(message, key);
     */

    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
  })(Math);

  return CryptoJS.SHA256;
});
}(sha256));

var sha224 = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, sha256.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var C_algo = C.algo;
    var SHA256 = C_algo.SHA256;
    /**
     * SHA-224 hash algorithm.
     */

    var SHA224 = C_algo.SHA224 = SHA256.extend({
      _doReset: function _doReset() {
        this._hash = new WordArray.init([0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4]);
      },
      _doFinalize: function _doFinalize() {
        var hash = SHA256._doFinalize.call(this);

        hash.sigBytes -= 4;
        return hash;
      }
    });
    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA224('message');
     *     var hash = CryptoJS.SHA224(wordArray);
     */

    C.SHA224 = SHA256._createHelper(SHA224);
    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA224(message, key);
     */

    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
  })();

  return CryptoJS.SHA224;
});
}(sha224));

var sha512 = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, x64Core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Hasher = C_lib.Hasher;
    var C_x64 = C.x64;
    var X64Word = C_x64.Word;
    var X64WordArray = C_x64.WordArray;
    var C_algo = C.algo;

    function X64Word_create() {
      return X64Word.create.apply(X64Word, arguments);
    } // Constants


    var K = [X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd), X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc), X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019), X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118), X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe), X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2), X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1), X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694), X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3), X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65), X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483), X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5), X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210), X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4), X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725), X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70), X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926), X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df), X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8), X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b), X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001), X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30), X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910), X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8), X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53), X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8), X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb), X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3), X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60), X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec), X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9), X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b), X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207), X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178), X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6), X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b), X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493), X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c), X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a), X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)]; // Reusable objects

    var W = [];

    (function () {
      for (var i = 0; i < 80; i++) {
        W[i] = X64Word_create();
      }
    })();
    /**
     * SHA-512 hash algorithm.
     */


    var SHA512 = C_algo.SHA512 = Hasher.extend({
      _doReset: function _doReset() {
        this._hash = new X64WordArray.init([new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b), new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1), new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f), new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)]);
      },
      _doProcessBlock: function _doProcessBlock(M, offset) {
        // Shortcuts
        var H = this._hash.words;
        var H0 = H[0];
        var H1 = H[1];
        var H2 = H[2];
        var H3 = H[3];
        var H4 = H[4];
        var H5 = H[5];
        var H6 = H[6];
        var H7 = H[7];
        var H0h = H0.high;
        var H0l = H0.low;
        var H1h = H1.high;
        var H1l = H1.low;
        var H2h = H2.high;
        var H2l = H2.low;
        var H3h = H3.high;
        var H3l = H3.low;
        var H4h = H4.high;
        var H4l = H4.low;
        var H5h = H5.high;
        var H5l = H5.low;
        var H6h = H6.high;
        var H6l = H6.low;
        var H7h = H7.high;
        var H7l = H7.low; // Working variables

        var ah = H0h;
        var al = H0l;
        var bh = H1h;
        var bl = H1l;
        var ch = H2h;
        var cl = H2l;
        var dh = H3h;
        var dl = H3l;
        var eh = H4h;
        var el = H4l;
        var fh = H5h;
        var fl = H5l;
        var gh = H6h;
        var gl = H6l;
        var hh = H7h;
        var hl = H7l; // Rounds

        for (var i = 0; i < 80; i++) {
          var Wil;
          var Wih; // Shortcut

          var Wi = W[i]; // Extend message

          if (i < 16) {
            Wih = Wi.high = M[offset + i * 2] | 0;
            Wil = Wi.low = M[offset + i * 2 + 1] | 0;
          } else {
            // Gamma0
            var gamma0x = W[i - 15];
            var gamma0xh = gamma0x.high;
            var gamma0xl = gamma0x.low;
            var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
            var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25); // Gamma1

            var gamma1x = W[i - 2];
            var gamma1xh = gamma1x.high;
            var gamma1xl = gamma1x.low;
            var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
            var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26); // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]

            var Wi7 = W[i - 7];
            var Wi7h = Wi7.high;
            var Wi7l = Wi7.low;
            var Wi16 = W[i - 16];
            var Wi16h = Wi16.high;
            var Wi16l = Wi16.low;
            Wil = gamma0l + Wi7l;
            Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
            Wil = Wil + gamma1l;
            Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
            Wil = Wil + Wi16l;
            Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
            Wi.high = Wih;
            Wi.low = Wil;
          }

          var chh = eh & fh ^ ~eh & gh;
          var chl = el & fl ^ ~el & gl;
          var majh = ah & bh ^ ah & ch ^ bh & ch;
          var majl = al & bl ^ al & cl ^ bl & cl;
          var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
          var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
          var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
          var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9); // t1 = h + sigma1 + ch + K[i] + W[i]

          var Ki = K[i];
          var Kih = Ki.high;
          var Kil = Ki.low;
          var t1l = hl + sigma1l;
          var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
          var t1l = t1l + chl;
          var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
          var t1l = t1l + Kil;
          var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
          var t1l = t1l + Wil;
          var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0); // t2 = sigma0 + maj

          var t2l = sigma0l + majl;
          var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0); // Update working variables

          hh = gh;
          hl = gl;
          gh = fh;
          gl = fl;
          fh = eh;
          fl = el;
          el = dl + t1l | 0;
          eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
          dh = ch;
          dl = cl;
          ch = bh;
          cl = bl;
          bh = ah;
          bl = al;
          al = t1l + t2l | 0;
          ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
        } // Intermediate hash value


        H0l = H0.low = H0l + al;
        H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
        H1l = H1.low = H1l + bl;
        H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
        H2l = H2.low = H2l + cl;
        H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
        H3l = H3.low = H3l + dl;
        H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
        H4l = H4.low = H4l + el;
        H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
        H5l = H5.low = H5l + fl;
        H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
        H6l = H6.low = H6l + gl;
        H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
        H7l = H7.low = H7l + hl;
        H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
      },
      _doFinalize: function _doFinalize() {
        // Shortcuts
        var data = this._data;
        var dataWords = data.words;
        var nBitsTotal = this._nDataBytes * 8;
        var nBitsLeft = data.sigBytes * 8; // Add padding

        dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
        dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
        dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
        data.sigBytes = dataWords.length * 4; // Hash final blocks

        this._process(); // Convert hash to 32-bit word array before returning


        var hash = this._hash.toX32(); // Return final computed hash


        return hash;
      },
      clone: function clone() {
        var clone = Hasher.clone.call(this);
        clone._hash = this._hash.clone();
        return clone;
      },
      blockSize: 1024 / 32
    });
    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA512('message');
     *     var hash = CryptoJS.SHA512(wordArray);
     */

    C.SHA512 = Hasher._createHelper(SHA512);
    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA512(message, key);
     */

    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
  })();

  return CryptoJS.SHA512;
});
}(sha512));

var sha384 = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, x64Core.exports, sha512.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_x64 = C.x64;
    var X64Word = C_x64.Word;
    var X64WordArray = C_x64.WordArray;
    var C_algo = C.algo;
    var SHA512 = C_algo.SHA512;
    /**
     * SHA-384 hash algorithm.
     */

    var SHA384 = C_algo.SHA384 = SHA512.extend({
      _doReset: function _doReset() {
        this._hash = new X64WordArray.init([new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507), new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939), new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511), new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)]);
      },
      _doFinalize: function _doFinalize() {
        var hash = SHA512._doFinalize.call(this);

        hash.sigBytes -= 16;
        return hash;
      }
    });
    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA384('message');
     *     var hash = CryptoJS.SHA384(wordArray);
     */

    C.SHA384 = SHA512._createHelper(SHA384);
    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA384(message, key);
     */

    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
  })();

  return CryptoJS.SHA384;
});
}(sha384));

var sha3 = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, x64Core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function (Math) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var Hasher = C_lib.Hasher;
    var C_x64 = C.x64;
    var X64Word = C_x64.Word;
    var C_algo = C.algo; // Constants tables

    var RHO_OFFSETS = [];
    var PI_INDEXES = [];
    var ROUND_CONSTANTS = []; // Compute Constants

    (function () {
      // Compute rho offset constants
      var x = 1,
          y = 0;

      for (var t = 0; t < 24; t++) {
        RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
        var newX = y % 5;
        var newY = (2 * x + 3 * y) % 5;
        x = newX;
        y = newY;
      } // Compute pi index constants


      for (var x = 0; x < 5; x++) {
        for (var y = 0; y < 5; y++) {
          PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
        }
      } // Compute round constants


      var LFSR = 0x01;

      for (var i = 0; i < 24; i++) {
        var roundConstantMsw = 0;
        var roundConstantLsw = 0;

        for (var j = 0; j < 7; j++) {
          if (LFSR & 0x01) {
            var bitPosition = (1 << j) - 1;

            if (bitPosition < 32) {
              roundConstantLsw ^= 1 << bitPosition;
            } else
              /* if (bitPosition >= 32) */
              {
                roundConstantMsw ^= 1 << bitPosition - 32;
              }
          } // Compute next LFSR


          if (LFSR & 0x80) {
            // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
            LFSR = LFSR << 1 ^ 0x71;
          } else {
            LFSR <<= 1;
          }
        }

        ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
      }
    })(); // Reusable objects for temporary values


    var T = [];

    (function () {
      for (var i = 0; i < 25; i++) {
        T[i] = X64Word.create();
      }
    })();
    /**
     * SHA-3 hash algorithm.
     */


    var SHA3 = C_algo.SHA3 = Hasher.extend({
      /**
       * Configuration options.
       *
       * @property {number} outputLength
       *   The desired number of bits in the output hash.
       *   Only values permitted are: 224, 256, 384, 512.
       *   Default: 512
       */
      cfg: Hasher.cfg.extend({
        outputLength: 512
      }),
      _doReset: function _doReset() {
        var state = this._state = [];

        for (var i = 0; i < 25; i++) {
          state[i] = new X64Word.init();
        }

        this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
      },
      _doProcessBlock: function _doProcessBlock(M, offset) {
        // Shortcuts
        var state = this._state;
        var nBlockSizeLanes = this.blockSize / 2; // Absorb

        for (var i = 0; i < nBlockSizeLanes; i++) {
          // Shortcuts
          var M2i = M[offset + 2 * i];
          var M2i1 = M[offset + 2 * i + 1]; // Swap endian

          M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
          M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00; // Absorb message into state

          var lane = state[i];
          lane.high ^= M2i1;
          lane.low ^= M2i;
        } // Rounds


        for (var round = 0; round < 24; round++) {
          // Theta
          for (var x = 0; x < 5; x++) {
            // Mix column lanes
            var tMsw = 0,
                tLsw = 0;

            for (var y = 0; y < 5; y++) {
              var lane = state[x + 5 * y];
              tMsw ^= lane.high;
              tLsw ^= lane.low;
            } // Temporary values


            var Tx = T[x];
            Tx.high = tMsw;
            Tx.low = tLsw;
          }

          for (var x = 0; x < 5; x++) {
            // Shortcuts
            var Tx4 = T[(x + 4) % 5];
            var Tx1 = T[(x + 1) % 5];
            var Tx1Msw = Tx1.high;
            var Tx1Lsw = Tx1.low; // Mix surrounding columns

            var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
            var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);

            for (var y = 0; y < 5; y++) {
              var lane = state[x + 5 * y];
              lane.high ^= tMsw;
              lane.low ^= tLsw;
            }
          } // Rho Pi


          for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
            var tMsw;
            var tLsw; // Shortcuts

            var lane = state[laneIndex];
            var laneMsw = lane.high;
            var laneLsw = lane.low;
            var rhoOffset = RHO_OFFSETS[laneIndex]; // Rotate lanes

            if (rhoOffset < 32) {
              tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
              tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
            } else
              /* if (rhoOffset >= 32) */
              {
                tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
              } // Transpose lanes


            var TPiLane = T[PI_INDEXES[laneIndex]];
            TPiLane.high = tMsw;
            TPiLane.low = tLsw;
          } // Rho pi at x = y = 0


          var T0 = T[0];
          var state0 = state[0];
          T0.high = state0.high;
          T0.low = state0.low; // Chi

          for (var x = 0; x < 5; x++) {
            for (var y = 0; y < 5; y++) {
              // Shortcuts
              var laneIndex = x + 5 * y;
              var lane = state[laneIndex];
              var TLane = T[laneIndex];
              var Tx1Lane = T[(x + 1) % 5 + 5 * y];
              var Tx2Lane = T[(x + 2) % 5 + 5 * y]; // Mix rows

              lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
              lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
            }
          } // Iota


          var lane = state[0];
          var roundConstant = ROUND_CONSTANTS[round];
          lane.high ^= roundConstant.high;
          lane.low ^= roundConstant.low;
        }
      },
      _doFinalize: function _doFinalize() {
        // Shortcuts
        var data = this._data;
        var dataWords = data.words;
        this._nDataBytes * 8;
        var nBitsLeft = data.sigBytes * 8;
        var blockSizeBits = this.blockSize * 32; // Add padding

        dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
        dataWords[(Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
        data.sigBytes = dataWords.length * 4; // Hash final blocks

        this._process(); // Shortcuts


        var state = this._state;
        var outputLengthBytes = this.cfg.outputLength / 8;
        var outputLengthLanes = outputLengthBytes / 8; // Squeeze

        var hashWords = [];

        for (var i = 0; i < outputLengthLanes; i++) {
          // Shortcuts
          var lane = state[i];
          var laneMsw = lane.high;
          var laneLsw = lane.low; // Swap endian

          laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
          laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00; // Squeeze state to retrieve hash

          hashWords.push(laneLsw);
          hashWords.push(laneMsw);
        } // Return final computed hash


        return new WordArray.init(hashWords, outputLengthBytes);
      },
      clone: function clone() {
        var clone = Hasher.clone.call(this);

        var state = clone._state = this._state.slice(0);

        for (var i = 0; i < 25; i++) {
          state[i] = state[i].clone();
        }

        return clone;
      }
    });
    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA3('message');
     *     var hash = CryptoJS.SHA3(wordArray);
     */

    C.SHA3 = Hasher._createHelper(SHA3);
    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA3(message, key);
     */

    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
  })(Math);

  return CryptoJS.SHA3;
});
}(sha3));

var ripemd160 = {exports: {}};

(function (module, exports) {

(function (root, factory) {
  {
    // CommonJS
    module.exports = factory(core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /** @preserve
  (c) 2012 by Cédric Mesnil. All rights reserved.
  	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
  	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
  	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
  (function (Math) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var Hasher = C_lib.Hasher;
    var C_algo = C.algo; // Constants table

    var _zl = WordArray.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]);

    var _zr = WordArray.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]);

    var _sl = WordArray.create([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]);

    var _sr = WordArray.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]);

    var _hl = WordArray.create([0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);

    var _hr = WordArray.create([0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
    /**
     * RIPEMD160 hash algorithm.
     */


    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
      _doReset: function _doReset() {
        this._hash = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
      },
      _doProcessBlock: function _doProcessBlock(M, offset) {
        // Swap endian
        for (var i = 0; i < 16; i++) {
          // Shortcuts
          var offset_i = offset + i;
          var M_offset_i = M[offset_i]; // Swap

          M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
        } // Shortcut


        var H = this._hash.words;
        var hl = _hl.words;
        var hr = _hr.words;
        var zl = _zl.words;
        var zr = _zr.words;
        var sl = _sl.words;
        var sr = _sr.words; // Working variables

        var al, bl, cl, dl, el;
        var ar, br, cr, dr, er;
        ar = al = H[0];
        br = bl = H[1];
        cr = cl = H[2];
        dr = dl = H[3];
        er = el = H[4]; // Computation

        var t;

        for (var i = 0; i < 80; i += 1) {
          t = al + M[offset + zl[i]] | 0;

          if (i < 16) {
            t += f1(bl, cl, dl) + hl[0];
          } else if (i < 32) {
            t += f2(bl, cl, dl) + hl[1];
          } else if (i < 48) {
            t += f3(bl, cl, dl) + hl[2];
          } else if (i < 64) {
            t += f4(bl, cl, dl) + hl[3];
          } else {
            // if (i<80) {
            t += f5(bl, cl, dl) + hl[4];
          }

          t = t | 0;
          t = rotl(t, sl[i]);
          t = t + el | 0;
          al = el;
          el = dl;
          dl = rotl(cl, 10);
          cl = bl;
          bl = t;
          t = ar + M[offset + zr[i]] | 0;

          if (i < 16) {
            t += f5(br, cr, dr) + hr[0];
          } else if (i < 32) {
            t += f4(br, cr, dr) + hr[1];
          } else if (i < 48) {
            t += f3(br, cr, dr) + hr[2];
          } else if (i < 64) {
            t += f2(br, cr, dr) + hr[3];
          } else {
            // if (i<80) {
            t += f1(br, cr, dr) + hr[4];
          }

          t = t | 0;
          t = rotl(t, sr[i]);
          t = t + er | 0;
          ar = er;
          er = dr;
          dr = rotl(cr, 10);
          cr = br;
          br = t;
        } // Intermediate hash value


        t = H[1] + cl + dr | 0;
        H[1] = H[2] + dl + er | 0;
        H[2] = H[3] + el + ar | 0;
        H[3] = H[4] + al + br | 0;
        H[4] = H[0] + bl + cr | 0;
        H[0] = t;
      },
      _doFinalize: function _doFinalize() {
        // Shortcuts
        var data = this._data;
        var dataWords = data.words;
        var nBitsTotal = this._nDataBytes * 8;
        var nBitsLeft = data.sigBytes * 8; // Add padding

        dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
        dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
        data.sigBytes = (dataWords.length + 1) * 4; // Hash final blocks

        this._process(); // Shortcuts


        var hash = this._hash;
        var H = hash.words; // Swap endian

        for (var i = 0; i < 5; i++) {
          // Shortcut
          var H_i = H[i]; // Swap

          H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
        } // Return final computed hash


        return hash;
      },
      clone: function clone() {
        var clone = Hasher.clone.call(this);
        clone._hash = this._hash.clone();
        return clone;
      }
    });

    function f1(x, y, z) {
      return x ^ y ^ z;
    }

    function f2(x, y, z) {
      return x & y | ~x & z;
    }

    function f3(x, y, z) {
      return (x | ~y) ^ z;
    }

    function f4(x, y, z) {
      return x & z | y & ~z;
    }

    function f5(x, y, z) {
      return x ^ (y | ~z);
    }

    function rotl(x, n) {
      return x << n | x >>> 32 - n;
    }
    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.RIPEMD160('message');
     *     var hash = CryptoJS.RIPEMD160(wordArray);
     */


    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
     */

    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
  })();

  return CryptoJS.RIPEMD160;
});
}(ripemd160));

var hmac = {exports: {}};

(function (module, exports) {

(function (root, factory) {
  {
    // CommonJS
    module.exports = factory(core.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Base = C_lib.Base;
    var C_enc = C.enc;
    var Utf8 = C_enc.Utf8;
    var C_algo = C.algo;
    /**
     * HMAC algorithm.
     */

    C_algo.HMAC = Base.extend({
      /**
       * Initializes a newly created HMAC.
       *
       * @param {Hasher} hasher The hash algorithm to use.
       * @param {WordArray|string} key The secret key.
       *
       * @example
       *
       *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
       */
      init: function init(hasher, key) {
        // Init hasher
        hasher = this._hasher = new hasher.init(); // Convert string to WordArray, else assume WordArray already

        if (typeof key == 'string') {
          key = Utf8.parse(key);
        } // Shortcuts


        var hasherBlockSize = hasher.blockSize;
        var hasherBlockSizeBytes = hasherBlockSize * 4; // Allow arbitrary length keys

        if (key.sigBytes > hasherBlockSizeBytes) {
          key = hasher.finalize(key);
        } // Clamp excess bits


        key.clamp(); // Clone key for inner and outer pads

        var oKey = this._oKey = key.clone();
        var iKey = this._iKey = key.clone(); // Shortcuts

        var oKeyWords = oKey.words;
        var iKeyWords = iKey.words; // XOR keys with pad constants

        for (var i = 0; i < hasherBlockSize; i++) {
          oKeyWords[i] ^= 0x5c5c5c5c;
          iKeyWords[i] ^= 0x36363636;
        }

        oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes; // Set initial values

        this.reset();
      },

      /**
       * Resets this HMAC to its initial state.
       *
       * @example
       *
       *     hmacHasher.reset();
       */
      reset: function reset() {
        // Shortcut
        var hasher = this._hasher; // Reset

        hasher.reset();
        hasher.update(this._iKey);
      },

      /**
       * Updates this HMAC with a message.
       *
       * @param {WordArray|string} messageUpdate The message to append.
       *
       * @return {HMAC} This HMAC instance.
       *
       * @example
       *
       *     hmacHasher.update('message');
       *     hmacHasher.update(wordArray);
       */
      update: function update(messageUpdate) {
        this._hasher.update(messageUpdate); // Chainable


        return this;
      },

      /**
       * Finalizes the HMAC computation.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} messageUpdate (Optional) A final message update.
       *
       * @return {WordArray} The HMAC.
       *
       * @example
       *
       *     var hmac = hmacHasher.finalize();
       *     var hmac = hmacHasher.finalize('message');
       *     var hmac = hmacHasher.finalize(wordArray);
       */
      finalize: function finalize(messageUpdate) {
        // Shortcut
        var hasher = this._hasher; // Compute HMAC

        var innerHash = hasher.finalize(messageUpdate);
        hasher.reset();
        var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
        return hmac;
      }
    });
  })();
});
}(hmac));

var pbkdf2 = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, sha1.exports, hmac.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Base = C_lib.Base;
    var WordArray = C_lib.WordArray;
    var C_algo = C.algo;
    var SHA1 = C_algo.SHA1;
    var HMAC = C_algo.HMAC;
    /**
     * Password-Based Key Derivation Function 2 algorithm.
     */

    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
      /**
       * Configuration options.
       *
       * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
       * @property {Hasher} hasher The hasher to use. Default: SHA1
       * @property {number} iterations The number of iterations to perform. Default: 1
       */
      cfg: Base.extend({
        keySize: 128 / 32,
        hasher: SHA1,
        iterations: 1
      }),

      /**
       * Initializes a newly created key derivation function.
       *
       * @param {Object} cfg (Optional) The configuration options to use for the derivation.
       *
       * @example
       *
       *     var kdf = CryptoJS.algo.PBKDF2.create();
       *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
       *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
       */
      init: function init(cfg) {
        this.cfg = this.cfg.extend(cfg);
      },

      /**
       * Computes the Password-Based Key Derivation Function 2.
       *
       * @param {WordArray|string} password The password.
       * @param {WordArray|string} salt A salt.
       *
       * @return {WordArray} The derived key.
       *
       * @example
       *
       *     var key = kdf.compute(password, salt);
       */
      compute: function compute(password, salt) {
        // Shortcut
        var cfg = this.cfg; // Init HMAC

        var hmac = HMAC.create(cfg.hasher, password); // Initial values

        var derivedKey = WordArray.create();
        var blockIndex = WordArray.create([0x00000001]); // Shortcuts

        var derivedKeyWords = derivedKey.words;
        var blockIndexWords = blockIndex.words;
        var keySize = cfg.keySize;
        var iterations = cfg.iterations; // Generate key

        while (derivedKeyWords.length < keySize) {
          var block = hmac.update(salt).finalize(blockIndex);
          hmac.reset(); // Shortcuts

          var blockWords = block.words;
          var blockWordsLength = blockWords.length; // Iterations

          var intermediate = block;

          for (var i = 1; i < iterations; i++) {
            intermediate = hmac.finalize(intermediate);
            hmac.reset(); // Shortcut

            var intermediateWords = intermediate.words; // XOR intermediate with block

            for (var j = 0; j < blockWordsLength; j++) {
              blockWords[j] ^= intermediateWords[j];
            }
          }

          derivedKey.concat(block);
          blockIndexWords[0]++;
        }

        derivedKey.sigBytes = keySize * 4;
        return derivedKey;
      }
    });
    /**
     * Computes the Password-Based Key Derivation Function 2.
     *
     * @param {WordArray|string} password The password.
     * @param {WordArray|string} salt A salt.
     * @param {Object} cfg (Optional) The configuration options to use for this computation.
     *
     * @return {WordArray} The derived key.
     *
     * @static
     *
     * @example
     *
     *     var key = CryptoJS.PBKDF2(password, salt);
     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
     */

    C.PBKDF2 = function (password, salt, cfg) {
      return PBKDF2.create(cfg).compute(password, salt);
    };
  })();

  return CryptoJS.PBKDF2;
});
}(pbkdf2));

var evpkdf = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, sha1.exports, hmac.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Base = C_lib.Base;
    var WordArray = C_lib.WordArray;
    var C_algo = C.algo;
    var MD5 = C_algo.MD5;
    /**
     * This key derivation function is meant to conform with EVP_BytesToKey.
     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
     */

    var EvpKDF = C_algo.EvpKDF = Base.extend({
      /**
       * Configuration options.
       *
       * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
       * @property {Hasher} hasher The hash algorithm to use. Default: MD5
       * @property {number} iterations The number of iterations to perform. Default: 1
       */
      cfg: Base.extend({
        keySize: 128 / 32,
        hasher: MD5,
        iterations: 1
      }),

      /**
       * Initializes a newly created key derivation function.
       *
       * @param {Object} cfg (Optional) The configuration options to use for the derivation.
       *
       * @example
       *
       *     var kdf = CryptoJS.algo.EvpKDF.create();
       *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
       *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
       */
      init: function init(cfg) {
        this.cfg = this.cfg.extend(cfg);
      },

      /**
       * Derives a key from a password.
       *
       * @param {WordArray|string} password The password.
       * @param {WordArray|string} salt A salt.
       *
       * @return {WordArray} The derived key.
       *
       * @example
       *
       *     var key = kdf.compute(password, salt);
       */
      compute: function compute(password, salt) {
        var block; // Shortcut

        var cfg = this.cfg; // Init hasher

        var hasher = cfg.hasher.create(); // Initial values

        var derivedKey = WordArray.create(); // Shortcuts

        var derivedKeyWords = derivedKey.words;
        var keySize = cfg.keySize;
        var iterations = cfg.iterations; // Generate key

        while (derivedKeyWords.length < keySize) {
          if (block) {
            hasher.update(block);
          }

          block = hasher.update(password).finalize(salt);
          hasher.reset(); // Iterations

          for (var i = 1; i < iterations; i++) {
            block = hasher.finalize(block);
            hasher.reset();
          }

          derivedKey.concat(block);
        }

        derivedKey.sigBytes = keySize * 4;
        return derivedKey;
      }
    });
    /**
     * Derives a key from a password.
     *
     * @param {WordArray|string} password The password.
     * @param {WordArray|string} salt A salt.
     * @param {Object} cfg (Optional) The configuration options to use for this computation.
     *
     * @return {WordArray} The derived key.
     *
     * @static
     *
     * @example
     *
     *     var key = CryptoJS.EvpKDF(password, salt);
     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
     */

    C.EvpKDF = function (password, salt, cfg) {
      return EvpKDF.create(cfg).compute(password, salt);
    };
  })();

  return CryptoJS.EvpKDF;
});
}(evpkdf));

var cipherCore = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, evpkdf.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /**
   * Cipher core components.
   */
  CryptoJS.lib.Cipher || function (undefined$1) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Base = C_lib.Base;
    var WordArray = C_lib.WordArray;
    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
    var C_enc = C.enc;
    C_enc.Utf8;
    var Base64 = C_enc.Base64;
    var C_algo = C.algo;
    var EvpKDF = C_algo.EvpKDF;
    /**
     * Abstract base cipher template.
     *
     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
     */

    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
      /**
       * Configuration options.
       *
       * @property {WordArray} iv The IV to use for this operation.
       */
      cfg: Base.extend(),

      /**
       * Creates this cipher in encryption mode.
       *
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {Cipher} A cipher instance.
       *
       * @static
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
       */
      createEncryptor: function createEncryptor(key, cfg) {
        return this.create(this._ENC_XFORM_MODE, key, cfg);
      },

      /**
       * Creates this cipher in decryption mode.
       *
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {Cipher} A cipher instance.
       *
       * @static
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
       */
      createDecryptor: function createDecryptor(key, cfg) {
        return this.create(this._DEC_XFORM_MODE, key, cfg);
      },

      /**
       * Initializes a newly created cipher.
       *
       * @param {number} xformMode Either the encryption or decryption transormation mode constant.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
       */
      init: function init(xformMode, key, cfg) {
        // Apply config defaults
        this.cfg = this.cfg.extend(cfg); // Store transform mode and key

        this._xformMode = xformMode;
        this._key = key; // Set initial values

        this.reset();
      },

      /**
       * Resets this cipher to its initial state.
       *
       * @example
       *
       *     cipher.reset();
       */
      reset: function reset() {
        // Reset data buffer
        BufferedBlockAlgorithm.reset.call(this); // Perform concrete-cipher logic

        this._doReset();
      },

      /**
       * Adds data to be encrypted or decrypted.
       *
       * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
       *
       * @return {WordArray} The data after processing.
       *
       * @example
       *
       *     var encrypted = cipher.process('data');
       *     var encrypted = cipher.process(wordArray);
       */
      process: function process(dataUpdate) {
        // Append
        this._append(dataUpdate); // Process available blocks


        return this._process();
      },

      /**
       * Finalizes the encryption or decryption process.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
       *
       * @return {WordArray} The data after final processing.
       *
       * @example
       *
       *     var encrypted = cipher.finalize();
       *     var encrypted = cipher.finalize('data');
       *     var encrypted = cipher.finalize(wordArray);
       */
      finalize: function finalize(dataUpdate) {
        // Final data update
        if (dataUpdate) {
          this._append(dataUpdate);
        } // Perform concrete-cipher logic


        var finalProcessedData = this._doFinalize();

        return finalProcessedData;
      },
      keySize: 128 / 32,
      ivSize: 128 / 32,
      _ENC_XFORM_MODE: 1,
      _DEC_XFORM_MODE: 2,

      /**
       * Creates shortcut functions to a cipher's object interface.
       *
       * @param {Cipher} cipher The cipher to create a helper for.
       *
       * @return {Object} An object with encrypt and decrypt shortcut functions.
       *
       * @static
       *
       * @example
       *
       *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
       */
      _createHelper: function () {
        function selectCipherStrategy(key) {
          if (typeof key == 'string') {
            return PasswordBasedCipher;
          } else {
            return SerializableCipher;
          }
        }

        return function (cipher) {
          return {
            encrypt: function encrypt(message, key, cfg) {
              return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
            },
            decrypt: function decrypt(ciphertext, key, cfg) {
              return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
            }
          };
        };
      }()
    });
    /**
     * Abstract base stream cipher template.
     *
     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
     */

    C_lib.StreamCipher = Cipher.extend({
      _doFinalize: function _doFinalize() {
        // Process partial blocks
        var finalProcessedBlocks = this._process(!!'flush');

        return finalProcessedBlocks;
      },
      blockSize: 1
    });
    /**
     * Mode namespace.
     */

    var C_mode = C.mode = {};
    /**
     * Abstract base block cipher mode template.
     */

    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
      /**
       * Creates this mode for encryption.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @static
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
       */
      createEncryptor: function createEncryptor(cipher, iv) {
        return this.Encryptor.create(cipher, iv);
      },

      /**
       * Creates this mode for decryption.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @static
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
       */
      createDecryptor: function createDecryptor(cipher, iv) {
        return this.Decryptor.create(cipher, iv);
      },

      /**
       * Initializes a newly created mode.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
       */
      init: function init(cipher, iv) {
        this._cipher = cipher;
        this._iv = iv;
      }
    });
    /**
     * Cipher Block Chaining mode.
     */

    var CBC = C_mode.CBC = function () {
      /**
       * Abstract base CBC mode.
       */
      var CBC = BlockCipherMode.extend();
      /**
       * CBC encryptor.
       */

      CBC.Encryptor = CBC.extend({
        /**
         * Processes the data block at offset.
         *
         * @param {Array} words The data words to operate on.
         * @param {number} offset The offset where the block starts.
         *
         * @example
         *
         *     mode.processBlock(data.words, offset);
         */
        processBlock: function processBlock(words, offset) {
          // Shortcuts
          var cipher = this._cipher;
          var blockSize = cipher.blockSize; // XOR and encrypt

          xorBlock.call(this, words, offset, blockSize);
          cipher.encryptBlock(words, offset); // Remember this block to use with next block

          this._prevBlock = words.slice(offset, offset + blockSize);
        }
      });
      /**
       * CBC decryptor.
       */

      CBC.Decryptor = CBC.extend({
        /**
         * Processes the data block at offset.
         *
         * @param {Array} words The data words to operate on.
         * @param {number} offset The offset where the block starts.
         *
         * @example
         *
         *     mode.processBlock(data.words, offset);
         */
        processBlock: function processBlock(words, offset) {
          // Shortcuts
          var cipher = this._cipher;
          var blockSize = cipher.blockSize; // Remember this block to use with next block

          var thisBlock = words.slice(offset, offset + blockSize); // Decrypt and XOR

          cipher.decryptBlock(words, offset);
          xorBlock.call(this, words, offset, blockSize); // This block becomes the previous block

          this._prevBlock = thisBlock;
        }
      });

      function xorBlock(words, offset, blockSize) {
        var block; // Shortcut

        var iv = this._iv; // Choose mixing block

        if (iv) {
          block = iv; // Remove IV for subsequent blocks

          this._iv = undefined$1;
        } else {
          block = this._prevBlock;
        } // XOR blocks


        for (var i = 0; i < blockSize; i++) {
          words[offset + i] ^= block[i];
        }
      }

      return CBC;
    }();
    /**
     * Padding namespace.
     */


    var C_pad = C.pad = {};
    /**
     * PKCS #5/7 padding strategy.
     */

    var Pkcs7 = C_pad.Pkcs7 = {
      /**
       * Pads data using the algorithm defined in PKCS #5/7.
       *
       * @param {WordArray} data The data to pad.
       * @param {number} blockSize The multiple that the data should be padded to.
       *
       * @static
       *
       * @example
       *
       *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
       */
      pad: function pad(data, blockSize) {
        // Shortcut
        var blockSizeBytes = blockSize * 4; // Count padding bytes

        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes; // Create padding word

        var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes; // Create padding

        var paddingWords = [];

        for (var i = 0; i < nPaddingBytes; i += 4) {
          paddingWords.push(paddingWord);
        }

        var padding = WordArray.create(paddingWords, nPaddingBytes); // Add padding

        data.concat(padding);
      },

      /**
       * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
       *
       * @param {WordArray} data The data to unpad.
       *
       * @static
       *
       * @example
       *
       *     CryptoJS.pad.Pkcs7.unpad(wordArray);
       */
      unpad: function unpad(data) {
        // Get number of padding bytes from last byte
        var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff; // Remove padding

        data.sigBytes -= nPaddingBytes;
      }
    };
    /**
     * Abstract base block cipher template.
     *
     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
     */

    C_lib.BlockCipher = Cipher.extend({
      /**
       * Configuration options.
       *
       * @property {Mode} mode The block mode to use. Default: CBC
       * @property {Padding} padding The padding strategy to use. Default: Pkcs7
       */
      cfg: Cipher.cfg.extend({
        mode: CBC,
        padding: Pkcs7
      }),
      reset: function reset() {
        var modeCreator; // Reset cipher

        Cipher.reset.call(this); // Shortcuts

        var cfg = this.cfg;
        var iv = cfg.iv;
        var mode = cfg.mode; // Reset block mode

        if (this._xformMode == this._ENC_XFORM_MODE) {
          modeCreator = mode.createEncryptor;
        } else
          /* if (this._xformMode == this._DEC_XFORM_MODE) */
          {
            modeCreator = mode.createDecryptor; // Keep at least one block in the buffer for unpadding

            this._minBufferSize = 1;
          }

        if (this._mode && this._mode.__creator == modeCreator) {
          this._mode.init(this, iv && iv.words);
        } else {
          this._mode = modeCreator.call(mode, this, iv && iv.words);
          this._mode.__creator = modeCreator;
        }
      },
      _doProcessBlock: function _doProcessBlock(words, offset) {
        this._mode.processBlock(words, offset);
      },
      _doFinalize: function _doFinalize() {
        var finalProcessedBlocks; // Shortcut

        var padding = this.cfg.padding; // Finalize

        if (this._xformMode == this._ENC_XFORM_MODE) {
          // Pad data
          padding.pad(this._data, this.blockSize); // Process final blocks

          finalProcessedBlocks = this._process(!!'flush');
        } else
          /* if (this._xformMode == this._DEC_XFORM_MODE) */
          {
            // Process final blocks
            finalProcessedBlocks = this._process(!!'flush'); // Unpad data

            padding.unpad(finalProcessedBlocks);
          }

        return finalProcessedBlocks;
      },
      blockSize: 128 / 32
    });
    /**
     * A collection of cipher parameters.
     *
     * @property {WordArray} ciphertext The raw ciphertext.
     * @property {WordArray} key The key to this ciphertext.
     * @property {WordArray} iv The IV used in the ciphering operation.
     * @property {WordArray} salt The salt used with a key derivation function.
     * @property {Cipher} algorithm The cipher algorithm.
     * @property {Mode} mode The block mode used in the ciphering operation.
     * @property {Padding} padding The padding scheme used in the ciphering operation.
     * @property {number} blockSize The block size of the cipher.
     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
     */

    var CipherParams = C_lib.CipherParams = Base.extend({
      /**
       * Initializes a newly created cipher params object.
       *
       * @param {Object} cipherParams An object with any of the possible cipher parameters.
       *
       * @example
       *
       *     var cipherParams = CryptoJS.lib.CipherParams.create({
       *         ciphertext: ciphertextWordArray,
       *         key: keyWordArray,
       *         iv: ivWordArray,
       *         salt: saltWordArray,
       *         algorithm: CryptoJS.algo.AES,
       *         mode: CryptoJS.mode.CBC,
       *         padding: CryptoJS.pad.PKCS7,
       *         blockSize: 4,
       *         formatter: CryptoJS.format.OpenSSL
       *     });
       */
      init: function init(cipherParams) {
        this.mixIn(cipherParams);
      },

      /**
       * Converts this cipher params object to a string.
       *
       * @param {Format} formatter (Optional) The formatting strategy to use.
       *
       * @return {string} The stringified cipher params.
       *
       * @throws Error If neither the formatter nor the default formatter is set.
       *
       * @example
       *
       *     var string = cipherParams + '';
       *     var string = cipherParams.toString();
       *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
       */
      toString: function toString(formatter) {
        return (formatter || this.formatter).stringify(this);
      }
    });
    /**
     * Format namespace.
     */

    var C_format = C.format = {};
    /**
     * OpenSSL formatting strategy.
     */

    var OpenSSLFormatter = C_format.OpenSSL = {
      /**
       * Converts a cipher params object to an OpenSSL-compatible string.
       *
       * @param {CipherParams} cipherParams The cipher params object.
       *
       * @return {string} The OpenSSL-compatible string.
       *
       * @static
       *
       * @example
       *
       *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
       */
      stringify: function stringify(cipherParams) {
        var wordArray; // Shortcuts

        var ciphertext = cipherParams.ciphertext;
        var salt = cipherParams.salt; // Format

        if (salt) {
          wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
        } else {
          wordArray = ciphertext;
        }

        return wordArray.toString(Base64);
      },

      /**
       * Converts an OpenSSL-compatible string to a cipher params object.
       *
       * @param {string} openSSLStr The OpenSSL-compatible string.
       *
       * @return {CipherParams} The cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
       */
      parse: function parse(openSSLStr) {
        var salt; // Parse base64

        var ciphertext = Base64.parse(openSSLStr); // Shortcut

        var ciphertextWords = ciphertext.words; // Test for salt

        if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
          // Extract salt
          salt = WordArray.create(ciphertextWords.slice(2, 4)); // Remove salt from ciphertext

          ciphertextWords.splice(0, 4);
          ciphertext.sigBytes -= 16;
        }

        return CipherParams.create({
          ciphertext: ciphertext,
          salt: salt
        });
      }
    };
    /**
     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
     */

    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
      /**
       * Configuration options.
       *
       * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
       */
      cfg: Base.extend({
        format: OpenSSLFormatter
      }),

      /**
       * Encrypts a message.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {WordArray|string} message The message to encrypt.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {CipherParams} A cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       */
      encrypt: function encrypt(cipher, message, key, cfg) {
        // Apply config defaults
        cfg = this.cfg.extend(cfg); // Encrypt

        var encryptor = cipher.createEncryptor(key, cfg);
        var ciphertext = encryptor.finalize(message); // Shortcut

        var cipherCfg = encryptor.cfg; // Create and return serializable cipher params

        return CipherParams.create({
          ciphertext: ciphertext,
          key: key,
          iv: cipherCfg.iv,
          algorithm: cipher,
          mode: cipherCfg.mode,
          padding: cipherCfg.padding,
          blockSize: cipher.blockSize,
          formatter: cfg.format
        });
      },

      /**
       * Decrypts serialized ciphertext.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {WordArray} The plaintext.
       *
       * @static
       *
       * @example
       *
       *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       */
      decrypt: function decrypt(cipher, ciphertext, key, cfg) {
        // Apply config defaults
        cfg = this.cfg.extend(cfg); // Convert string to CipherParams

        ciphertext = this._parse(ciphertext, cfg.format); // Decrypt

        var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
        return plaintext;
      },

      /**
       * Converts serialized ciphertext to CipherParams,
       * else assumed CipherParams already and returns ciphertext unchanged.
       *
       * @param {CipherParams|string} ciphertext The ciphertext.
       * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
       *
       * @return {CipherParams} The unserialized ciphertext.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
       */
      _parse: function _parse(ciphertext, format) {
        if (typeof ciphertext == 'string') {
          return format.parse(ciphertext, this);
        } else {
          return ciphertext;
        }
      }
    });
    /**
     * Key derivation function namespace.
     */

    var C_kdf = C.kdf = {};
    /**
     * OpenSSL key derivation function.
     */

    var OpenSSLKdf = C_kdf.OpenSSL = {
      /**
       * Derives a key and IV from a password.
       *
       * @param {string} password The password to derive from.
       * @param {number} keySize The size in words of the key to generate.
       * @param {number} ivSize The size in words of the IV to generate.
       * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
       *
       * @return {CipherParams} A cipher params object with the key, IV, and salt.
       *
       * @static
       *
       * @example
       *
       *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
       *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
       */
      execute: function execute(password, keySize, ivSize, salt) {
        // Generate random salt
        if (!salt) {
          salt = WordArray.random(64 / 8);
        } // Derive key and IV


        var key = EvpKDF.create({
          keySize: keySize + ivSize
        }).compute(password, salt); // Separate key and IV

        var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
        key.sigBytes = keySize * 4; // Return params

        return CipherParams.create({
          key: key,
          iv: iv,
          salt: salt
        });
      }
    };
    /**
     * A serializable cipher wrapper that derives the key from a password,
     * and returns ciphertext as a serializable cipher params object.
     */

    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
      /**
       * Configuration options.
       *
       * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
       */
      cfg: SerializableCipher.cfg.extend({
        kdf: OpenSSLKdf
      }),

      /**
       * Encrypts a message using a password.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {WordArray|string} message The message to encrypt.
       * @param {string} password The password.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {CipherParams} A cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
       *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
       */
      encrypt: function encrypt(cipher, message, password, cfg) {
        // Apply config defaults
        cfg = this.cfg.extend(cfg); // Derive key and other params

        var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize); // Add IV to config

        cfg.iv = derivedParams.iv; // Encrypt

        var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg); // Mix in derived params

        ciphertext.mixIn(derivedParams);
        return ciphertext;
      },

      /**
       * Decrypts serialized ciphertext using a password.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
       * @param {string} password The password.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {WordArray} The plaintext.
       *
       * @static
       *
       * @example
       *
       *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
       *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
       */
      decrypt: function decrypt(cipher, ciphertext, password, cfg) {
        // Apply config defaults
        cfg = this.cfg.extend(cfg); // Convert string to CipherParams

        ciphertext = this._parse(ciphertext, cfg.format); // Derive key and other params

        var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt); // Add IV to config

        cfg.iv = derivedParams.iv; // Decrypt

        var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
        return plaintext;
      }
    });
  }();
});
}(cipherCore));

var modeCfb = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /**
   * Cipher Feedback block mode.
   */
  CryptoJS.mode.CFB = function () {
    var CFB = CryptoJS.lib.BlockCipherMode.extend();
    CFB.Encryptor = CFB.extend({
      processBlock: function processBlock(words, offset) {
        // Shortcuts
        var cipher = this._cipher;
        var blockSize = cipher.blockSize;
        generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher); // Remember this block to use with next block

        this._prevBlock = words.slice(offset, offset + blockSize);
      }
    });
    CFB.Decryptor = CFB.extend({
      processBlock: function processBlock(words, offset) {
        // Shortcuts
        var cipher = this._cipher;
        var blockSize = cipher.blockSize; // Remember this block to use with next block

        var thisBlock = words.slice(offset, offset + blockSize);
        generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher); // This block becomes the previous block

        this._prevBlock = thisBlock;
      }
    });

    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
      var keystream; // Shortcut

      var iv = this._iv; // Generate keystream

      if (iv) {
        keystream = iv.slice(0); // Remove IV for subsequent blocks

        this._iv = undefined;
      } else {
        keystream = this._prevBlock;
      }

      cipher.encryptBlock(keystream, 0); // Encrypt

      for (var i = 0; i < blockSize; i++) {
        words[offset + i] ^= keystream[i];
      }
    }

    return CFB;
  }();

  return CryptoJS.mode.CFB;
});
}(modeCfb));

var modeCtr = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /**
   * Counter block mode.
   */
  CryptoJS.mode.CTR = function () {
    var CTR = CryptoJS.lib.BlockCipherMode.extend();
    var Encryptor = CTR.Encryptor = CTR.extend({
      processBlock: function processBlock(words, offset) {
        // Shortcuts
        var cipher = this._cipher;
        var blockSize = cipher.blockSize;
        var iv = this._iv;
        var counter = this._counter; // Generate keystream

        if (iv) {
          counter = this._counter = iv.slice(0); // Remove IV for subsequent blocks

          this._iv = undefined;
        }

        var keystream = counter.slice(0);
        cipher.encryptBlock(keystream, 0); // Increment counter

        counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0; // Encrypt

        for (var i = 0; i < blockSize; i++) {
          words[offset + i] ^= keystream[i];
        }
      }
    });
    CTR.Decryptor = Encryptor;
    return CTR;
  }();

  return CryptoJS.mode.CTR;
});
}(modeCtr));

var modeCtrGladman = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /** @preserve
   * Counter block mode compatible with  Dr Brian Gladman fileenc.c
   * derived from CryptoJS.mode.CTR
   * Jan Hruby jhruby.web@gmail.com
   */
  CryptoJS.mode.CTRGladman = function () {
    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

    function incWord(word) {
      if ((word >> 24 & 0xff) === 0xff) {
        //overflow
        var b1 = word >> 16 & 0xff;
        var b2 = word >> 8 & 0xff;
        var b3 = word & 0xff;

        if (b1 === 0xff) // overflow b1
          {
            b1 = 0;

            if (b2 === 0xff) {
              b2 = 0;

              if (b3 === 0xff) {
                b3 = 0;
              } else {
                ++b3;
              }
            } else {
              ++b2;
            }
          } else {
          ++b1;
        }

        word = 0;
        word += b1 << 16;
        word += b2 << 8;
        word += b3;
      } else {
        word += 0x01 << 24;
      }

      return word;
    }

    function incCounter(counter) {
      if ((counter[0] = incWord(counter[0])) === 0) {
        // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
        counter[1] = incWord(counter[1]);
      }

      return counter;
    }

    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
      processBlock: function processBlock(words, offset) {
        // Shortcuts
        var cipher = this._cipher;
        var blockSize = cipher.blockSize;
        var iv = this._iv;
        var counter = this._counter; // Generate keystream

        if (iv) {
          counter = this._counter = iv.slice(0); // Remove IV for subsequent blocks

          this._iv = undefined;
        }

        incCounter(counter);
        var keystream = counter.slice(0);
        cipher.encryptBlock(keystream, 0); // Encrypt

        for (var i = 0; i < blockSize; i++) {
          words[offset + i] ^= keystream[i];
        }
      }
    });
    CTRGladman.Decryptor = Encryptor;
    return CTRGladman;
  }();

  return CryptoJS.mode.CTRGladman;
});
}(modeCtrGladman));

var modeOfb = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /**
   * Output Feedback block mode.
   */
  CryptoJS.mode.OFB = function () {
    var OFB = CryptoJS.lib.BlockCipherMode.extend();
    var Encryptor = OFB.Encryptor = OFB.extend({
      processBlock: function processBlock(words, offset) {
        // Shortcuts
        var cipher = this._cipher;
        var blockSize = cipher.blockSize;
        var iv = this._iv;
        var keystream = this._keystream; // Generate keystream

        if (iv) {
          keystream = this._keystream = iv.slice(0); // Remove IV for subsequent blocks

          this._iv = undefined;
        }

        cipher.encryptBlock(keystream, 0); // Encrypt

        for (var i = 0; i < blockSize; i++) {
          words[offset + i] ^= keystream[i];
        }
      }
    });
    OFB.Decryptor = Encryptor;
    return OFB;
  }();

  return CryptoJS.mode.OFB;
});
}(modeOfb));

var modeEcb = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /**
   * Electronic Codebook block mode.
   */
  CryptoJS.mode.ECB = function () {
    var ECB = CryptoJS.lib.BlockCipherMode.extend();
    ECB.Encryptor = ECB.extend({
      processBlock: function processBlock(words, offset) {
        this._cipher.encryptBlock(words, offset);
      }
    });
    ECB.Decryptor = ECB.extend({
      processBlock: function processBlock(words, offset) {
        this._cipher.decryptBlock(words, offset);
      }
    });
    return ECB;
  }();

  return CryptoJS.mode.ECB;
});
}(modeEcb));

var padAnsix923 = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /**
   * ANSI X.923 padding strategy.
   */
  CryptoJS.pad.AnsiX923 = {
    pad: function pad(data, blockSize) {
      // Shortcuts
      var dataSigBytes = data.sigBytes;
      var blockSizeBytes = blockSize * 4; // Count padding bytes

      var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes; // Compute last byte position

      var lastBytePos = dataSigBytes + nPaddingBytes - 1; // Pad

      data.clamp();
      data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
      data.sigBytes += nPaddingBytes;
    },
    unpad: function unpad(data) {
      // Get number of padding bytes from last byte
      var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff; // Remove padding

      data.sigBytes -= nPaddingBytes;
    }
  };
  return CryptoJS.pad.Ansix923;
});
}(padAnsix923));

var padIso10126 = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /**
   * ISO 10126 padding strategy.
   */
  CryptoJS.pad.Iso10126 = {
    pad: function pad(data, blockSize) {
      // Shortcut
      var blockSizeBytes = blockSize * 4; // Count padding bytes

      var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes; // Pad

      data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
    },
    unpad: function unpad(data) {
      // Get number of padding bytes from last byte
      var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff; // Remove padding

      data.sigBytes -= nPaddingBytes;
    }
  };
  return CryptoJS.pad.Iso10126;
});
}(padIso10126));

var padIso97971 = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /**
   * ISO/IEC 9797-1 Padding Method 2.
   */
  CryptoJS.pad.Iso97971 = {
    pad: function pad(data, blockSize) {
      // Add 0x80 byte
      data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1)); // Zero pad the rest

      CryptoJS.pad.ZeroPadding.pad(data, blockSize);
    },
    unpad: function unpad(data) {
      // Remove zero padding
      CryptoJS.pad.ZeroPadding.unpad(data); // Remove one more byte -- the 0x80 byte

      data.sigBytes--;
    }
  };
  return CryptoJS.pad.Iso97971;
});
}(padIso97971));

var padZeropadding = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /**
   * Zero padding strategy.
   */
  CryptoJS.pad.ZeroPadding = {
    pad: function pad(data, blockSize) {
      // Shortcut
      var blockSizeBytes = blockSize * 4; // Pad

      data.clamp();
      data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
    },
    unpad: function unpad(data) {
      // Shortcut
      var dataWords = data.words; // Unpad

      var i = data.sigBytes - 1;

      for (var i = data.sigBytes - 1; i >= 0; i--) {
        if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
          data.sigBytes = i + 1;
          break;
        }
      }
    }
  };
  return CryptoJS.pad.ZeroPadding;
});
}(padZeropadding));

var padNopadding = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  /**
   * A noop padding strategy.
   */
  CryptoJS.pad.NoPadding = {
    pad: function pad() {},
    unpad: function unpad() {}
  };
  return CryptoJS.pad.NoPadding;
});
}(padNopadding));

var formatHex = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function (undefined$1) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var CipherParams = C_lib.CipherParams;
    var C_enc = C.enc;
    var Hex = C_enc.Hex;
    var C_format = C.format;
    C_format.Hex = {
      /**
       * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
       *
       * @param {CipherParams} cipherParams The cipher params object.
       *
       * @return {string} The hexadecimally encoded string.
       *
       * @static
       *
       * @example
       *
       *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
       */
      stringify: function stringify(cipherParams) {
        return cipherParams.ciphertext.toString(Hex);
      },

      /**
       * Converts a hexadecimally encoded ciphertext string to a cipher params object.
       *
       * @param {string} input The hexadecimally encoded string.
       *
       * @return {CipherParams} The cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
       */
      parse: function parse(input) {
        var ciphertext = Hex.parse(input);
        return CipherParams.create({
          ciphertext: ciphertext
        });
      }
    };
  })();

  return CryptoJS.format.Hex;
});
}(formatHex));

var aes = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, encBase64.exports, md5.exports, evpkdf.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var BlockCipher = C_lib.BlockCipher;
    var C_algo = C.algo; // Lookup tables

    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX_0 = [];
    var SUB_MIX_1 = [];
    var SUB_MIX_2 = [];
    var SUB_MIX_3 = [];
    var INV_SUB_MIX_0 = [];
    var INV_SUB_MIX_1 = [];
    var INV_SUB_MIX_2 = [];
    var INV_SUB_MIX_3 = []; // Compute lookup tables

    (function () {
      // Compute double table
      var d = [];

      for (var i = 0; i < 256; i++) {
        if (i < 128) {
          d[i] = i << 1;
        } else {
          d[i] = i << 1 ^ 0x11b;
        }
      } // Walk GF(2^8)


      var x = 0;
      var xi = 0;

      for (var i = 0; i < 256; i++) {
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x; // Compute multiplication

        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4]; // Compute sub bytes, mix columns tables

        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX_0[x] = t << 24 | t >>> 8;
        SUB_MIX_1[x] = t << 16 | t >>> 16;
        SUB_MIX_2[x] = t << 8 | t >>> 24;
        SUB_MIX_3[x] = t; // Compute inv sub bytes, inv mix columns tables

        var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
        INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
        INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
        INV_SUB_MIX_3[sx] = t; // Compute next counter

        if (!x) {
          x = xi = 1;
        } else {
          x = x2 ^ d[d[d[x8 ^ x2]]];
          xi ^= d[d[xi]];
        }
      }
    })(); // Precomputed Rcon lookup


    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
    /**
     * AES block cipher algorithm.
     */

    var AES = C_algo.AES = BlockCipher.extend({
      _doReset: function _doReset() {
        var t; // Skip reset of nRounds has been set before and key did not change

        if (this._nRounds && this._keyPriorReset === this._key) {
          return;
        } // Shortcuts


        var key = this._keyPriorReset = this._key;
        var keyWords = key.words;
        var keySize = key.sigBytes / 4; // Compute number of rounds

        var nRounds = this._nRounds = keySize + 6; // Compute number of key schedule rows

        var ksRows = (nRounds + 1) * 4; // Compute key schedule

        var keySchedule = this._keySchedule = [];

        for (var ksRow = 0; ksRow < ksRows; ksRow++) {
          if (ksRow < keySize) {
            keySchedule[ksRow] = keyWords[ksRow];
          } else {
            t = keySchedule[ksRow - 1];

            if (!(ksRow % keySize)) {
              // Rot word
              t = t << 8 | t >>> 24; // Sub word

              t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff]; // Mix Rcon

              t ^= RCON[ksRow / keySize | 0] << 24;
            } else if (keySize > 6 && ksRow % keySize == 4) {
              // Sub word
              t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
            }

            keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
          }
        } // Compute inv key schedule


        var invKeySchedule = this._invKeySchedule = [];

        for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
          var ksRow = ksRows - invKsRow;

          if (invKsRow % 4) {
            var t = keySchedule[ksRow];
          } else {
            var t = keySchedule[ksRow - 4];
          }

          if (invKsRow < 4 || ksRow <= 4) {
            invKeySchedule[invKsRow] = t;
          } else {
            invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
          }
        }
      },
      encryptBlock: function encryptBlock(M, offset) {
        this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
      },
      decryptBlock: function decryptBlock(M, offset) {
        // Swap 2nd and 4th rows
        var t = M[offset + 1];
        M[offset + 1] = M[offset + 3];
        M[offset + 3] = t;

        this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX); // Inv swap 2nd and 4th rows


        var t = M[offset + 1];
        M[offset + 1] = M[offset + 3];
        M[offset + 3] = t;
      },
      _doCryptBlock: function _doCryptBlock(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
        // Shortcut
        var nRounds = this._nRounds; // Get input, add round key

        var s0 = M[offset] ^ keySchedule[0];
        var s1 = M[offset + 1] ^ keySchedule[1];
        var s2 = M[offset + 2] ^ keySchedule[2];
        var s3 = M[offset + 3] ^ keySchedule[3]; // Key schedule row counter

        var ksRow = 4; // Rounds

        for (var round = 1; round < nRounds; round++) {
          // Shift rows, sub bytes, mix columns, add round key
          var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
          var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
          var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
          var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++]; // Update state

          s0 = t0;
          s1 = t1;
          s2 = t2;
          s3 = t3;
        } // Shift rows, sub bytes, add round key


        var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
        var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
        var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
        var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]; // Set output

        M[offset] = t0;
        M[offset + 1] = t1;
        M[offset + 2] = t2;
        M[offset + 3] = t3;
      },
      keySize: 256 / 32
    });
    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
     */

    C.AES = BlockCipher._createHelper(AES);
  })();

  return CryptoJS.AES;
});
}(aes));

var tripledes = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, encBase64.exports, md5.exports, evpkdf.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var BlockCipher = C_lib.BlockCipher;
    var C_algo = C.algo; // Permuted Choice 1 constants

    var PC1 = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4]; // Permuted Choice 2 constants

    var PC2 = [14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32]; // Cumulative bit shift constants

    var BIT_SHIFTS = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28]; // SBOXes and round permutation constants

    var SBOX_P = [{
      0x0: 0x808200,
      0x10000000: 0x8000,
      0x20000000: 0x808002,
      0x30000000: 0x2,
      0x40000000: 0x200,
      0x50000000: 0x808202,
      0x60000000: 0x800202,
      0x70000000: 0x800000,
      0x80000000: 0x202,
      0x90000000: 0x800200,
      0xa0000000: 0x8200,
      0xb0000000: 0x808000,
      0xc0000000: 0x8002,
      0xd0000000: 0x800002,
      0xe0000000: 0x0,
      0xf0000000: 0x8202,
      0x8000000: 0x0,
      0x18000000: 0x808202,
      0x28000000: 0x8202,
      0x38000000: 0x8000,
      0x48000000: 0x808200,
      0x58000000: 0x200,
      0x68000000: 0x808002,
      0x78000000: 0x2,
      0x88000000: 0x800200,
      0x98000000: 0x8200,
      0xa8000000: 0x808000,
      0xb8000000: 0x800202,
      0xc8000000: 0x800002,
      0xd8000000: 0x8002,
      0xe8000000: 0x202,
      0xf8000000: 0x800000,
      0x1: 0x8000,
      0x10000001: 0x2,
      0x20000001: 0x808200,
      0x30000001: 0x800000,
      0x40000001: 0x808002,
      0x50000001: 0x8200,
      0x60000001: 0x200,
      0x70000001: 0x800202,
      0x80000001: 0x808202,
      0x90000001: 0x808000,
      0xa0000001: 0x800002,
      0xb0000001: 0x8202,
      0xc0000001: 0x202,
      0xd0000001: 0x800200,
      0xe0000001: 0x8002,
      0xf0000001: 0x0,
      0x8000001: 0x808202,
      0x18000001: 0x808000,
      0x28000001: 0x800000,
      0x38000001: 0x200,
      0x48000001: 0x8000,
      0x58000001: 0x800002,
      0x68000001: 0x2,
      0x78000001: 0x8202,
      0x88000001: 0x8002,
      0x98000001: 0x800202,
      0xa8000001: 0x202,
      0xb8000001: 0x808200,
      0xc8000001: 0x800200,
      0xd8000001: 0x0,
      0xe8000001: 0x8200,
      0xf8000001: 0x808002
    }, {
      0x0: 0x40084010,
      0x1000000: 0x4000,
      0x2000000: 0x80000,
      0x3000000: 0x40080010,
      0x4000000: 0x40000010,
      0x5000000: 0x40084000,
      0x6000000: 0x40004000,
      0x7000000: 0x10,
      0x8000000: 0x84000,
      0x9000000: 0x40004010,
      0xa000000: 0x40000000,
      0xb000000: 0x84010,
      0xc000000: 0x80010,
      0xd000000: 0x0,
      0xe000000: 0x4010,
      0xf000000: 0x40080000,
      0x800000: 0x40004000,
      0x1800000: 0x84010,
      0x2800000: 0x10,
      0x3800000: 0x40004010,
      0x4800000: 0x40084010,
      0x5800000: 0x40000000,
      0x6800000: 0x80000,
      0x7800000: 0x40080010,
      0x8800000: 0x80010,
      0x9800000: 0x0,
      0xa800000: 0x4000,
      0xb800000: 0x40080000,
      0xc800000: 0x40000010,
      0xd800000: 0x84000,
      0xe800000: 0x40084000,
      0xf800000: 0x4010,
      0x10000000: 0x0,
      0x11000000: 0x40080010,
      0x12000000: 0x40004010,
      0x13000000: 0x40084000,
      0x14000000: 0x40080000,
      0x15000000: 0x10,
      0x16000000: 0x84010,
      0x17000000: 0x4000,
      0x18000000: 0x4010,
      0x19000000: 0x80000,
      0x1a000000: 0x80010,
      0x1b000000: 0x40000010,
      0x1c000000: 0x84000,
      0x1d000000: 0x40004000,
      0x1e000000: 0x40000000,
      0x1f000000: 0x40084010,
      0x10800000: 0x84010,
      0x11800000: 0x80000,
      0x12800000: 0x40080000,
      0x13800000: 0x4000,
      0x14800000: 0x40004000,
      0x15800000: 0x40084010,
      0x16800000: 0x10,
      0x17800000: 0x40000000,
      0x18800000: 0x40084000,
      0x19800000: 0x40000010,
      0x1a800000: 0x40004010,
      0x1b800000: 0x80010,
      0x1c800000: 0x0,
      0x1d800000: 0x4010,
      0x1e800000: 0x40080010,
      0x1f800000: 0x84000
    }, {
      0x0: 0x104,
      0x100000: 0x0,
      0x200000: 0x4000100,
      0x300000: 0x10104,
      0x400000: 0x10004,
      0x500000: 0x4000004,
      0x600000: 0x4010104,
      0x700000: 0x4010000,
      0x800000: 0x4000000,
      0x900000: 0x4010100,
      0xa00000: 0x10100,
      0xb00000: 0x4010004,
      0xc00000: 0x4000104,
      0xd00000: 0x10000,
      0xe00000: 0x4,
      0xf00000: 0x100,
      0x80000: 0x4010100,
      0x180000: 0x4010004,
      0x280000: 0x0,
      0x380000: 0x4000100,
      0x480000: 0x4000004,
      0x580000: 0x10000,
      0x680000: 0x10004,
      0x780000: 0x104,
      0x880000: 0x4,
      0x980000: 0x100,
      0xa80000: 0x4010000,
      0xb80000: 0x10104,
      0xc80000: 0x10100,
      0xd80000: 0x4000104,
      0xe80000: 0x4010104,
      0xf80000: 0x4000000,
      0x1000000: 0x4010100,
      0x1100000: 0x10004,
      0x1200000: 0x10000,
      0x1300000: 0x4000100,
      0x1400000: 0x100,
      0x1500000: 0x4010104,
      0x1600000: 0x4000004,
      0x1700000: 0x0,
      0x1800000: 0x4000104,
      0x1900000: 0x4000000,
      0x1a00000: 0x4,
      0x1b00000: 0x10100,
      0x1c00000: 0x4010000,
      0x1d00000: 0x104,
      0x1e00000: 0x10104,
      0x1f00000: 0x4010004,
      0x1080000: 0x4000000,
      0x1180000: 0x104,
      0x1280000: 0x4010100,
      0x1380000: 0x0,
      0x1480000: 0x10004,
      0x1580000: 0x4000100,
      0x1680000: 0x100,
      0x1780000: 0x4010004,
      0x1880000: 0x10000,
      0x1980000: 0x4010104,
      0x1a80000: 0x10104,
      0x1b80000: 0x4000004,
      0x1c80000: 0x4000104,
      0x1d80000: 0x4010000,
      0x1e80000: 0x4,
      0x1f80000: 0x10100
    }, {
      0x0: 0x80401000,
      0x10000: 0x80001040,
      0x20000: 0x401040,
      0x30000: 0x80400000,
      0x40000: 0x0,
      0x50000: 0x401000,
      0x60000: 0x80000040,
      0x70000: 0x400040,
      0x80000: 0x80000000,
      0x90000: 0x400000,
      0xa0000: 0x40,
      0xb0000: 0x80001000,
      0xc0000: 0x80400040,
      0xd0000: 0x1040,
      0xe0000: 0x1000,
      0xf0000: 0x80401040,
      0x8000: 0x80001040,
      0x18000: 0x40,
      0x28000: 0x80400040,
      0x38000: 0x80001000,
      0x48000: 0x401000,
      0x58000: 0x80401040,
      0x68000: 0x0,
      0x78000: 0x80400000,
      0x88000: 0x1000,
      0x98000: 0x80401000,
      0xa8000: 0x400000,
      0xb8000: 0x1040,
      0xc8000: 0x80000000,
      0xd8000: 0x400040,
      0xe8000: 0x401040,
      0xf8000: 0x80000040,
      0x100000: 0x400040,
      0x110000: 0x401000,
      0x120000: 0x80000040,
      0x130000: 0x0,
      0x140000: 0x1040,
      0x150000: 0x80400040,
      0x160000: 0x80401000,
      0x170000: 0x80001040,
      0x180000: 0x80401040,
      0x190000: 0x80000000,
      0x1a0000: 0x80400000,
      0x1b0000: 0x401040,
      0x1c0000: 0x80001000,
      0x1d0000: 0x400000,
      0x1e0000: 0x40,
      0x1f0000: 0x1000,
      0x108000: 0x80400000,
      0x118000: 0x80401040,
      0x128000: 0x0,
      0x138000: 0x401000,
      0x148000: 0x400040,
      0x158000: 0x80000000,
      0x168000: 0x80001040,
      0x178000: 0x40,
      0x188000: 0x80000040,
      0x198000: 0x1000,
      0x1a8000: 0x80001000,
      0x1b8000: 0x80400040,
      0x1c8000: 0x1040,
      0x1d8000: 0x80401000,
      0x1e8000: 0x400000,
      0x1f8000: 0x401040
    }, {
      0x0: 0x80,
      0x1000: 0x1040000,
      0x2000: 0x40000,
      0x3000: 0x20000000,
      0x4000: 0x20040080,
      0x5000: 0x1000080,
      0x6000: 0x21000080,
      0x7000: 0x40080,
      0x8000: 0x1000000,
      0x9000: 0x20040000,
      0xa000: 0x20000080,
      0xb000: 0x21040080,
      0xc000: 0x21040000,
      0xd000: 0x0,
      0xe000: 0x1040080,
      0xf000: 0x21000000,
      0x800: 0x1040080,
      0x1800: 0x21000080,
      0x2800: 0x80,
      0x3800: 0x1040000,
      0x4800: 0x40000,
      0x5800: 0x20040080,
      0x6800: 0x21040000,
      0x7800: 0x20000000,
      0x8800: 0x20040000,
      0x9800: 0x0,
      0xa800: 0x21040080,
      0xb800: 0x1000080,
      0xc800: 0x20000080,
      0xd800: 0x21000000,
      0xe800: 0x1000000,
      0xf800: 0x40080,
      0x10000: 0x40000,
      0x11000: 0x80,
      0x12000: 0x20000000,
      0x13000: 0x21000080,
      0x14000: 0x1000080,
      0x15000: 0x21040000,
      0x16000: 0x20040080,
      0x17000: 0x1000000,
      0x18000: 0x21040080,
      0x19000: 0x21000000,
      0x1a000: 0x1040000,
      0x1b000: 0x20040000,
      0x1c000: 0x40080,
      0x1d000: 0x20000080,
      0x1e000: 0x0,
      0x1f000: 0x1040080,
      0x10800: 0x21000080,
      0x11800: 0x1000000,
      0x12800: 0x1040000,
      0x13800: 0x20040080,
      0x14800: 0x20000000,
      0x15800: 0x1040080,
      0x16800: 0x80,
      0x17800: 0x21040000,
      0x18800: 0x40080,
      0x19800: 0x21040080,
      0x1a800: 0x0,
      0x1b800: 0x21000000,
      0x1c800: 0x1000080,
      0x1d800: 0x40000,
      0x1e800: 0x20040000,
      0x1f800: 0x20000080
    }, {
      0x0: 0x10000008,
      0x100: 0x2000,
      0x200: 0x10200000,
      0x300: 0x10202008,
      0x400: 0x10002000,
      0x500: 0x200000,
      0x600: 0x200008,
      0x700: 0x10000000,
      0x800: 0x0,
      0x900: 0x10002008,
      0xa00: 0x202000,
      0xb00: 0x8,
      0xc00: 0x10200008,
      0xd00: 0x202008,
      0xe00: 0x2008,
      0xf00: 0x10202000,
      0x80: 0x10200000,
      0x180: 0x10202008,
      0x280: 0x8,
      0x380: 0x200000,
      0x480: 0x202008,
      0x580: 0x10000008,
      0x680: 0x10002000,
      0x780: 0x2008,
      0x880: 0x200008,
      0x980: 0x2000,
      0xa80: 0x10002008,
      0xb80: 0x10200008,
      0xc80: 0x0,
      0xd80: 0x10202000,
      0xe80: 0x202000,
      0xf80: 0x10000000,
      0x1000: 0x10002000,
      0x1100: 0x10200008,
      0x1200: 0x10202008,
      0x1300: 0x2008,
      0x1400: 0x200000,
      0x1500: 0x10000000,
      0x1600: 0x10000008,
      0x1700: 0x202000,
      0x1800: 0x202008,
      0x1900: 0x0,
      0x1a00: 0x8,
      0x1b00: 0x10200000,
      0x1c00: 0x2000,
      0x1d00: 0x10002008,
      0x1e00: 0x10202000,
      0x1f00: 0x200008,
      0x1080: 0x8,
      0x1180: 0x202000,
      0x1280: 0x200000,
      0x1380: 0x10000008,
      0x1480: 0x10002000,
      0x1580: 0x2008,
      0x1680: 0x10202008,
      0x1780: 0x10200000,
      0x1880: 0x10202000,
      0x1980: 0x10200008,
      0x1a80: 0x2000,
      0x1b80: 0x202008,
      0x1c80: 0x200008,
      0x1d80: 0x0,
      0x1e80: 0x10000000,
      0x1f80: 0x10002008
    }, {
      0x0: 0x100000,
      0x10: 0x2000401,
      0x20: 0x400,
      0x30: 0x100401,
      0x40: 0x2100401,
      0x50: 0x0,
      0x60: 0x1,
      0x70: 0x2100001,
      0x80: 0x2000400,
      0x90: 0x100001,
      0xa0: 0x2000001,
      0xb0: 0x2100400,
      0xc0: 0x2100000,
      0xd0: 0x401,
      0xe0: 0x100400,
      0xf0: 0x2000000,
      0x8: 0x2100001,
      0x18: 0x0,
      0x28: 0x2000401,
      0x38: 0x2100400,
      0x48: 0x100000,
      0x58: 0x2000001,
      0x68: 0x2000000,
      0x78: 0x401,
      0x88: 0x100401,
      0x98: 0x2000400,
      0xa8: 0x2100000,
      0xb8: 0x100001,
      0xc8: 0x400,
      0xd8: 0x2100401,
      0xe8: 0x1,
      0xf8: 0x100400,
      0x100: 0x2000000,
      0x110: 0x100000,
      0x120: 0x2000401,
      0x130: 0x2100001,
      0x140: 0x100001,
      0x150: 0x2000400,
      0x160: 0x2100400,
      0x170: 0x100401,
      0x180: 0x401,
      0x190: 0x2100401,
      0x1a0: 0x100400,
      0x1b0: 0x1,
      0x1c0: 0x0,
      0x1d0: 0x2100000,
      0x1e0: 0x2000001,
      0x1f0: 0x400,
      0x108: 0x100400,
      0x118: 0x2000401,
      0x128: 0x2100001,
      0x138: 0x1,
      0x148: 0x2000000,
      0x158: 0x100000,
      0x168: 0x401,
      0x178: 0x2100400,
      0x188: 0x2000001,
      0x198: 0x2100000,
      0x1a8: 0x0,
      0x1b8: 0x2100401,
      0x1c8: 0x100401,
      0x1d8: 0x400,
      0x1e8: 0x2000400,
      0x1f8: 0x100001
    }, {
      0x0: 0x8000820,
      0x1: 0x20000,
      0x2: 0x8000000,
      0x3: 0x20,
      0x4: 0x20020,
      0x5: 0x8020820,
      0x6: 0x8020800,
      0x7: 0x800,
      0x8: 0x8020000,
      0x9: 0x8000800,
      0xa: 0x20800,
      0xb: 0x8020020,
      0xc: 0x820,
      0xd: 0x0,
      0xe: 0x8000020,
      0xf: 0x20820,
      0x80000000: 0x800,
      0x80000001: 0x8020820,
      0x80000002: 0x8000820,
      0x80000003: 0x8000000,
      0x80000004: 0x8020000,
      0x80000005: 0x20800,
      0x80000006: 0x20820,
      0x80000007: 0x20,
      0x80000008: 0x8000020,
      0x80000009: 0x820,
      0x8000000a: 0x20020,
      0x8000000b: 0x8020800,
      0x8000000c: 0x0,
      0x8000000d: 0x8020020,
      0x8000000e: 0x8000800,
      0x8000000f: 0x20000,
      0x10: 0x20820,
      0x11: 0x8020800,
      0x12: 0x20,
      0x13: 0x800,
      0x14: 0x8000800,
      0x15: 0x8000020,
      0x16: 0x8020020,
      0x17: 0x20000,
      0x18: 0x0,
      0x19: 0x20020,
      0x1a: 0x8020000,
      0x1b: 0x8000820,
      0x1c: 0x8020820,
      0x1d: 0x20800,
      0x1e: 0x820,
      0x1f: 0x8000000,
      0x80000010: 0x20000,
      0x80000011: 0x800,
      0x80000012: 0x8020020,
      0x80000013: 0x20820,
      0x80000014: 0x20,
      0x80000015: 0x8020000,
      0x80000016: 0x8000000,
      0x80000017: 0x8000820,
      0x80000018: 0x8020820,
      0x80000019: 0x8000020,
      0x8000001a: 0x8000800,
      0x8000001b: 0x0,
      0x8000001c: 0x20800,
      0x8000001d: 0x820,
      0x8000001e: 0x20020,
      0x8000001f: 0x8020800
    }]; // Masks that select the SBOX input

    var SBOX_MASK = [0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000, 0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f];
    /**
     * DES block cipher algorithm.
     */

    var DES = C_algo.DES = BlockCipher.extend({
      _doReset: function _doReset() {
        // Shortcuts
        var key = this._key;
        var keyWords = key.words; // Select 56 bits according to PC1

        var keyBits = [];

        for (var i = 0; i < 56; i++) {
          var keyBitPos = PC1[i] - 1;
          keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
        } // Assemble 16 subkeys


        var subKeys = this._subKeys = [];

        for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
          // Create subkey
          var subKey = subKeys[nSubKey] = []; // Shortcut

          var bitShift = BIT_SHIFTS[nSubKey]; // Select 48 bits according to PC2

          for (var i = 0; i < 24; i++) {
            // Select from the left 28 key bits
            subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6; // Select from the right 28 key bits

            subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
          } // Since each subkey is applied to an expanded 32-bit input,
          // the subkey can be broken into 8 values scaled to 32-bits,
          // which allows the key to be used without expansion


          subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;

          for (var i = 1; i < 7; i++) {
            subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
          }

          subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
        } // Compute inverse subkeys


        var invSubKeys = this._invSubKeys = [];

        for (var i = 0; i < 16; i++) {
          invSubKeys[i] = subKeys[15 - i];
        }
      },
      encryptBlock: function encryptBlock(M, offset) {
        this._doCryptBlock(M, offset, this._subKeys);
      },
      decryptBlock: function decryptBlock(M, offset) {
        this._doCryptBlock(M, offset, this._invSubKeys);
      },
      _doCryptBlock: function _doCryptBlock(M, offset, subKeys) {
        // Get input
        this._lBlock = M[offset];
        this._rBlock = M[offset + 1]; // Initial permutation

        exchangeLR.call(this, 4, 0x0f0f0f0f);
        exchangeLR.call(this, 16, 0x0000ffff);
        exchangeRL.call(this, 2, 0x33333333);
        exchangeRL.call(this, 8, 0x00ff00ff);
        exchangeLR.call(this, 1, 0x55555555); // Rounds

        for (var round = 0; round < 16; round++) {
          // Shortcuts
          var subKey = subKeys[round];
          var lBlock = this._lBlock;
          var rBlock = this._rBlock; // Feistel function

          var f = 0;

          for (var i = 0; i < 8; i++) {
            f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
          }

          this._lBlock = rBlock;
          this._rBlock = lBlock ^ f;
        } // Undo swap from last round


        var t = this._lBlock;
        this._lBlock = this._rBlock;
        this._rBlock = t; // Final permutation

        exchangeLR.call(this, 1, 0x55555555);
        exchangeRL.call(this, 8, 0x00ff00ff);
        exchangeRL.call(this, 2, 0x33333333);
        exchangeLR.call(this, 16, 0x0000ffff);
        exchangeLR.call(this, 4, 0x0f0f0f0f); // Set output

        M[offset] = this._lBlock;
        M[offset + 1] = this._rBlock;
      },
      keySize: 64 / 32,
      ivSize: 64 / 32,
      blockSize: 64 / 32
    }); // Swap bits across the left and right words

    function exchangeLR(offset, mask) {
      var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
      this._rBlock ^= t;
      this._lBlock ^= t << offset;
    }

    function exchangeRL(offset, mask) {
      var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
      this._lBlock ^= t;
      this._rBlock ^= t << offset;
    }
    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
     */


    C.DES = BlockCipher._createHelper(DES);
    /**
     * Triple-DES block cipher algorithm.
     */

    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
      _doReset: function _doReset() {
        // Shortcuts
        var key = this._key;
        var keyWords = key.words; // Make sure the key length is valid (64, 128 or >= 192 bit)

        if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
          throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
        } // Extend the key according to the keying options defined in 3DES standard


        var key1 = keyWords.slice(0, 2);
        var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
        var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6); // Create DES instances

        this._des1 = DES.createEncryptor(WordArray.create(key1));
        this._des2 = DES.createEncryptor(WordArray.create(key2));
        this._des3 = DES.createEncryptor(WordArray.create(key3));
      },
      encryptBlock: function encryptBlock(M, offset) {
        this._des1.encryptBlock(M, offset);

        this._des2.decryptBlock(M, offset);

        this._des3.encryptBlock(M, offset);
      },
      decryptBlock: function decryptBlock(M, offset) {
        this._des3.decryptBlock(M, offset);

        this._des2.encryptBlock(M, offset);

        this._des1.decryptBlock(M, offset);
      },
      keySize: 192 / 32,
      ivSize: 64 / 32,
      blockSize: 64 / 32
    });
    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
     */

    C.TripleDES = BlockCipher._createHelper(TripleDES);
  })();

  return CryptoJS.TripleDES;
});
}(tripledes));

var rc4 = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, encBase64.exports, md5.exports, evpkdf.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var StreamCipher = C_lib.StreamCipher;
    var C_algo = C.algo;
    /**
     * RC4 stream cipher algorithm.
     */

    var RC4 = C_algo.RC4 = StreamCipher.extend({
      _doReset: function _doReset() {
        // Shortcuts
        var key = this._key;
        var keyWords = key.words;
        var keySigBytes = key.sigBytes; // Init sbox

        var S = this._S = [];

        for (var i = 0; i < 256; i++) {
          S[i] = i;
        } // Key setup


        for (var i = 0, j = 0; i < 256; i++) {
          var keyByteIndex = i % keySigBytes;
          var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
          j = (j + S[i] + keyByte) % 256; // Swap

          var t = S[i];
          S[i] = S[j];
          S[j] = t;
        } // Counters


        this._i = this._j = 0;
      },
      _doProcessBlock: function _doProcessBlock(M, offset) {
        M[offset] ^= generateKeystreamWord.call(this);
      },
      keySize: 256 / 32,
      ivSize: 0
    });

    function generateKeystreamWord() {
      // Shortcuts
      var S = this._S;
      var i = this._i;
      var j = this._j; // Generate keystream word

      var keystreamWord = 0;

      for (var n = 0; n < 4; n++) {
        i = (i + 1) % 256;
        j = (j + S[i]) % 256; // Swap

        var t = S[i];
        S[i] = S[j];
        S[j] = t;
        keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
      } // Update counters


      this._i = i;
      this._j = j;
      return keystreamWord;
    }
    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
     */


    C.RC4 = StreamCipher._createHelper(RC4);
    /**
     * Modified RC4 stream cipher algorithm.
     */

    var RC4Drop = C_algo.RC4Drop = RC4.extend({
      /**
       * Configuration options.
       *
       * @property {number} drop The number of keystream words to drop. Default 192
       */
      cfg: RC4.cfg.extend({
        drop: 192
      }),
      _doReset: function _doReset() {
        RC4._doReset.call(this); // Drop


        for (var i = this.cfg.drop; i > 0; i--) {
          generateKeystreamWord.call(this);
        }
      }
    });
    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
     */

    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
  })();

  return CryptoJS.RC4;
});
}(rc4));

var rabbit = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, encBase64.exports, md5.exports, evpkdf.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var StreamCipher = C_lib.StreamCipher;
    var C_algo = C.algo; // Reusable objects

    var S = [];
    var C_ = [];
    var G = [];
    /**
     * Rabbit stream cipher algorithm
     */

    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
      _doReset: function _doReset() {
        // Shortcuts
        var K = this._key.words;
        var iv = this.cfg.iv; // Swap endian

        for (var i = 0; i < 4; i++) {
          K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
        } // Generate initial state values


        var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16]; // Generate initial counter values

        var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff]; // Carry bit

        this._b = 0; // Iterate the system four times

        for (var i = 0; i < 4; i++) {
          nextState.call(this);
        } // Modify the counters


        for (var i = 0; i < 8; i++) {
          C[i] ^= X[i + 4 & 7];
        } // IV setup


        if (iv) {
          // Shortcuts
          var IV = iv.words;
          var IV_0 = IV[0];
          var IV_1 = IV[1]; // Generate four subvectors

          var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
          var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
          var i1 = i0 >>> 16 | i2 & 0xffff0000;
          var i3 = i2 << 16 | i0 & 0x0000ffff; // Modify counter values

          C[0] ^= i0;
          C[1] ^= i1;
          C[2] ^= i2;
          C[3] ^= i3;
          C[4] ^= i0;
          C[5] ^= i1;
          C[6] ^= i2;
          C[7] ^= i3; // Iterate the system four times

          for (var i = 0; i < 4; i++) {
            nextState.call(this);
          }
        }
      },
      _doProcessBlock: function _doProcessBlock(M, offset) {
        // Shortcut
        var X = this._X; // Iterate the system

        nextState.call(this); // Generate four keystream words

        S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
        S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
        S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
        S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;

        for (var i = 0; i < 4; i++) {
          // Swap endian
          S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00; // Encrypt

          M[offset + i] ^= S[i];
        }
      },
      blockSize: 128 / 32,
      ivSize: 64 / 32
    });

    function nextState() {
      // Shortcuts
      var X = this._X;
      var C = this._C; // Save old counter values

      for (var i = 0; i < 8; i++) {
        C_[i] = C[i];
      } // Calculate new counter values


      C[0] = C[0] + 0x4d34d34d + this._b | 0;
      C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
      C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
      C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
      C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
      C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
      C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
      C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
      this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0; // Calculate the g-values

      for (var i = 0; i < 8; i++) {
        var gx = X[i] + C[i]; // Construct high and low argument for squaring

        var ga = gx & 0xffff;
        var gb = gx >>> 16; // Calculate high and low result of squaring

        var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
        var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0); // High XOR low

        G[i] = gh ^ gl;
      } // Calculate new state values


      X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
      X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
      X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
      X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
      X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
      X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
      X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
      X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
    }
    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
     */


    C.Rabbit = StreamCipher._createHelper(Rabbit);
  })();

  return CryptoJS.Rabbit;
});
}(rabbit));

var rabbitLegacy = {exports: {}};

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, encBase64.exports, md5.exports, evpkdf.exports, cipherCore.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  (function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var StreamCipher = C_lib.StreamCipher;
    var C_algo = C.algo; // Reusable objects

    var S = [];
    var C_ = [];
    var G = [];
    /**
     * Rabbit stream cipher algorithm.
     *
     * This is a legacy version that neglected to convert the key to little-endian.
     * This error doesn't affect the cipher's security,
     * but it does affect its compatibility with other implementations.
     */

    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
      _doReset: function _doReset() {
        // Shortcuts
        var K = this._key.words;
        var iv = this.cfg.iv; // Generate initial state values

        var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16]; // Generate initial counter values

        var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff]; // Carry bit

        this._b = 0; // Iterate the system four times

        for (var i = 0; i < 4; i++) {
          nextState.call(this);
        } // Modify the counters


        for (var i = 0; i < 8; i++) {
          C[i] ^= X[i + 4 & 7];
        } // IV setup


        if (iv) {
          // Shortcuts
          var IV = iv.words;
          var IV_0 = IV[0];
          var IV_1 = IV[1]; // Generate four subvectors

          var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
          var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
          var i1 = i0 >>> 16 | i2 & 0xffff0000;
          var i3 = i2 << 16 | i0 & 0x0000ffff; // Modify counter values

          C[0] ^= i0;
          C[1] ^= i1;
          C[2] ^= i2;
          C[3] ^= i3;
          C[4] ^= i0;
          C[5] ^= i1;
          C[6] ^= i2;
          C[7] ^= i3; // Iterate the system four times

          for (var i = 0; i < 4; i++) {
            nextState.call(this);
          }
        }
      },
      _doProcessBlock: function _doProcessBlock(M, offset) {
        // Shortcut
        var X = this._X; // Iterate the system

        nextState.call(this); // Generate four keystream words

        S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
        S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
        S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
        S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;

        for (var i = 0; i < 4; i++) {
          // Swap endian
          S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00; // Encrypt

          M[offset + i] ^= S[i];
        }
      },
      blockSize: 128 / 32,
      ivSize: 64 / 32
    });

    function nextState() {
      // Shortcuts
      var X = this._X;
      var C = this._C; // Save old counter values

      for (var i = 0; i < 8; i++) {
        C_[i] = C[i];
      } // Calculate new counter values


      C[0] = C[0] + 0x4d34d34d + this._b | 0;
      C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
      C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
      C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
      C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
      C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
      C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
      C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
      this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0; // Calculate the g-values

      for (var i = 0; i < 8; i++) {
        var gx = X[i] + C[i]; // Construct high and low argument for squaring

        var ga = gx & 0xffff;
        var gb = gx >>> 16; // Calculate high and low result of squaring

        var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
        var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0); // High XOR low

        G[i] = gh ^ gl;
      } // Calculate new state values


      X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
      X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
      X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
      X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
      X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
      X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
      X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
      X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
    }
    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
     */


    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
  })();

  return CryptoJS.RabbitLegacy;
});
}(rabbitLegacy));

(function (module, exports) {

(function (root, factory, undef) {
  {
    // CommonJS
    module.exports = factory(core.exports, x64Core.exports, libTypedarrays.exports, encUtf16.exports, encBase64.exports, encBase64url.exports, md5.exports, sha1.exports, sha256.exports, sha224.exports, sha512.exports, sha384.exports, sha3.exports, ripemd160.exports, hmac.exports, pbkdf2.exports, evpkdf.exports, cipherCore.exports, modeCfb.exports, modeCtr.exports, modeCtrGladman.exports, modeOfb.exports, modeEcb.exports, padAnsix923.exports, padIso10126.exports, padIso97971.exports, padZeropadding.exports, padNopadding.exports, formatHex.exports, aes.exports, tripledes.exports, rc4.exports, rabbit.exports, rabbitLegacy.exports);
  }
})(commonjsGlobal, function (CryptoJS) {
  return CryptoJS;
});
}(cryptoJs));

function ownKeys$Y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$X(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$Y(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$Y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getNormalize(compilationContext, defaultValue, fallbackDefaultValue) {
  var normalize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (x) {
    return x;
  };
  return function (val) {
    var normalizedVal = normalize(val);

    if (normalizedVal !== undefined) {
      return normalizedVal;
    }

    var normalizedDefaultVal = normalize(defaultValue);

    if (normalizedDefaultVal !== undefined) {
      return normalizedDefaultVal;
    }

    return normalize(fallbackDefaultValue);
  };
}

function getResponsiveNormalize(compilationContext, defaultValue, fallbackDefaultValue) {
  var normalize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (x) {
    return x;
  };

  if (isTrulyResponsiveValue(defaultValue)) {
    /**
     * Here we must decide how this behaves. It's not obvious. If default is responsive, we cannot easily use default breakpoints.
     * It's because auto might be different. Changing one breakpoint changes "context" for others.
     */
    throw new Error("default responsive values not yet supported");
  }

  return function (val) {
    var scalarNormalize = getNormalize(compilationContext, defaultValue, fallbackDefaultValue, normalize); // if value is not really responsive

    if (!isTrulyResponsiveValue(val)) {
      return _defineProperty$g({
        $res: true
      }, compilationContext.mainBreakpointIndex, scalarNormalize(val));
    }

    var responsiveVal = responsiveValueMap(val, function (x) {
      return normalize(x);
    }); // main breakpoint always set

    if (responsiveVal[compilationContext.mainBreakpointIndex] === undefined) {
      responsiveVal[compilationContext.mainBreakpointIndex] = scalarNormalize(undefined);
    }

    return responsiveVal;
  };
}

function getSelectValue(arg) {
  if (typeof arg === "string") {
    return arg;
  }

  return arg.value;
}

function isSelectValueCorrect(value, options) {
  if (typeof value !== "string") {
    return false;
  }

  return options.map(getSelectValue).indexOf(value) > -1;
}

function getFirstOptionValue(schemaProp) {
  if (schemaProp.options.length === 0) {
    throw new Error("Select field can't have 0 options");
  }

  var firstOption = schemaProp.options[0];
  var firstOptionValue = typeof firstOption === "object" ? firstOption.value : firstOption;
  return firstOptionValue;
}

function getSelectSchemaPropDefinition() {
  return function (schemaProp, compilationContext) {
    return {
      normalize: getNormalize(compilationContext, schemaProp.defaultValue, getFirstOptionValue(schemaProp), function (x) {
        return isSelectValueCorrect(x, schemaProp.options) ? x : undefined;
      }),
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value) {
        return value;
      }
    };
  };
}

function getResponsiveSelectSchemaPropDefinition() {
  return function (schemaProp, compilationContext) {
    return {
      normalize: getResponsiveNormalize(compilationContext, schemaProp.defaultValue, getFirstOptionValue(schemaProp), function (x) {
        return isSelectValueCorrect(x, schemaProp.options) ? x : undefined;
      }),
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value, currentBreakpoint) {
        if (isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, currentBreakpoint);
          return breakpointValue === null || breakpointValue === void 0 ? void 0 : breakpointValue.toString();
        }

        return value;
      }
    };
  };
}

function normalizeTokenValue(x, themeValues, defaultValue) {
  var scalarValueNormalize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (x) {
    return undefined;
  };

  // Mapping of legacy value of string (now not possible)
  if (typeof x === "string" && themeValues[x]) {
    // If string value exist as a theme key
    x = {
      value: themeValues[x].value,
      ref: x
    };
  } // Mapping of legacy value of type object which could be a font (now not possible)
  // The test below is shitty but this code should stay.


  if (!(typeof x === "object" && x !== null && (x.value !== undefined || typeof x.ref === "string")
  /* this is primitive test if this is ThemeRef value (either ref or value defined). It can also be object for Font! */
  )) {
    x = {
      value: x
    };
  }

  if (typeof x.ref === "string") {
    var _getMappedToken;

    // Mapping
    x = (_getMappedToken = getMappedToken(x.ref, themeValues)) !== null && _getMappedToken !== void 0 ? _getMappedToken : x; // If ref is defined

    var val = themeValues[x.ref]; // If ref exists in a theme we just take ref value

    if (val) {
      return {
        value: val.value,
        ref: x.ref
      };
    } // If ref is defined but doesn't exist in a theme it means that it was probably removed
    // In that case we simply pass the non-existent ref name (it can be later brought back).
    // The value is scalar-normalized! We'll never get incorrect value after normalization.


    var normalizedVal = scalarValueNormalize(x.value);

    if (normalizedVal === undefined) {
      return {
        value: defaultValue.value,
        // if value was incorrect, we apply default value
        ref: x.ref
      };
    } else {
      return {
        value: normalizedVal,
        // if value was correct, it stays
        ref: x.ref
      };
    }
  } // If ref is not defined
  else {
    var _normalizedVal = scalarValueNormalize(x.value);

    if (_normalizedVal === undefined) {
      return;
    } else {
      return {
        value: _normalizedVal
      };
    }
  }
}

function buildThemeDefinition(themeValues, defaultKey, // we must make sure that defaultKey is always correct
schemaProp, compilationContext) {
  var scalarValueNormalize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (x) {
    return undefined;
  };
  // Create default value
  var defaultValue = {
    ref: defaultKey,
    value: themeValues[defaultKey].value
  };
  /**
   * TODO:
   * - getResponsiveNormalize and helpers take into account recursion now!
   * - only thing we need to do is to write compile properly
   */

  var normalize = getResponsiveNormalize(compilationContext, schemaProp.defaultValue, defaultValue, function (x) {
    return normalizeTokenValue(x, themeValues, defaultValue, scalarValueNormalize);
  });
  return {
    normalize: normalize,
    // FIXME: input of compile should be output of normalize.
    compile: function compile(x) {
      // /**
      //  * We need to run this normalization here. Why?
      //  *
      //  * Although compiled config is promised to be normalized, but in case of theme can change under the hood.
      //  * And this will cause Tina state to be invalid (ref not conformant with value). That's why we normalize here.
      //  *
      //  * That could probably go from here.
      //  */
      //
      // // x = normalize(x);
      var val = responsiveValueMap(x, function (y) {
        return y === null || y === void 0 ? void 0 : y.value;
      });
      var flattened = responsiveValueFlatten(val, compilationContext.devices);
      return responsiveValueFill(flattened, compilationContext.devices, getDevicesWidths(compilationContext.devices));
    }
  };
}

function addStylesHash(styles) {
  if ("__hash" in styles) {
    delete styles["__hash"];
  }

  var hash = cryptoJs.exports.SHA1(JSON.stringify(styles));
  styles.__hash = hash.toString();
  return styles;
}

function compileBoxes(value, compilationContext) {
  if (Array.isArray(value)) {
    return value.map(function (x) {
      return compileBoxes(x, compilationContext);
    });
  } else if (typeof value === "object" && value !== null) {
    if (value.__isBox) {
      return addStylesHash(compileBox(value, compilationContext.devices));
    }

    var ret = {};

    for (var _key in value) {
      ret[_key] = compileBoxes(value[_key], compilationContext);
    }

    return ret;
  }

  return value;
}

function tracingType(tags, overwrite) {
  var _types$find;

  if (overwrite) {
    return overwrite;
  }

  var types = ["section", "card", "button", "item"];
  return (_types$find = types.find(function (t) {
    return tags.includes(t);
  })) !== null && _types$find !== void 0 ? _types$find : "item";
}

function isSchemaPropTracing(prop) {
  return isTracingSchemaProp(prop);
}
/**
 * This compilation function doesn't take schema. It means that it assumes couple of things:
 * 1. That input is ConfigComponent or 1-item array of. ConfigComponent. Basically it's a single component.
 * 2. It also assumes that component-fixed schema.
 * 3. Return format
 */


function compileComponentValues(inputValues, componentDefinition, compilationContext, cache) {
  var values = {};
  componentDefinition.schema.forEach(function (schemaProp) {
    if (!isSchemaPropComponentOrComponentCollection(schemaProp)) {
      values[schemaProp.prop] = compileFromSchema(inputValues[schemaProp.prop], schemaProp, compilationContext, cache);
    }
  });
  return _objectSpread$X({}, values);
}

function compileAction(editableElement, compilationContext, serializedDefinitions, configPrefix, cache) {
  var componentDefinition = findComponentDefinitionById(editableElement._template, compilationContext);

  if (!componentDefinition) {
    componentDefinition = findComponentDefinitionById("$MissingAction", compilationContext);
    editableElement = {
      _template: componentDefinition.id
    };
  }

  addComponentToSerializedComponentDefinitions(editableElement, componentDefinition.tags.includes("actionLink") ? serializedDefinitions.links : serializedDefinitions.actions, compilationContext);
  var compiledValues = compileComponentValues(editableElement, componentDefinition, compilationContext, cache);
  var compiled = {
    _template: editableElement._template,
    _id: editableElement._id,
    props: compiledValues
  };

  if (compilationContext.isEditing) {
    var editorContext = compilationContext;
    var editingInfo = buildDefaultEditingInfo(componentDefinition, configPrefix, editorContext, compiledValues, editableElement._template);
    compiled.__editing = {
      fields: editingInfo.fields
    };
  }

  return [compiled];
}

function compileSubcomponents(editableElement, subcomponentsContextProps, compilationContext, refMap, serializedDefinitions, editingInfoComponents, configPrefix, compiledComponentConfig, configAfterAuto, // null means that we don't want auto
cache) {
  var componentDefinition = findComponentDefinition(editableElement, compilationContext);
  componentDefinition.schema.forEach(function (schemaProp) {
    if (isSchemaPropComponentOrComponentCollection(schemaProp)) {
      // Currently these are processed outside of compileSubcomponents
      if (isSchemaPropActionTextModifier(schemaProp) || isSchemaPropTextModifier(schemaProp)) {
        return;
      }

      if (isSchemaPropAction(schemaProp)) {
        var actionFieldValue = editableElement[schemaProp.prop];

        if (actionFieldValue.length > 0) {
          var actionConfigPrefix = "".concat(configPrefix).concat(configPrefix === "" ? "" : ".").concat(schemaProp.prop, ".0");
          var compiledAction = compileAction(editableElement[schemaProp.prop][0], compilationContext, serializedDefinitions, actionConfigPrefix, cache);
          compiledComponentConfig.actions[schemaProp.prop] = compiledAction;
        } else {
          compiledComponentConfig.actions[schemaProp.prop] = [];
        }

        return;
      }

      var contextProps = subcomponentsContextProps[schemaProp.prop] || {};
      var compilationOutput = compileFromSchema(editableElement[schemaProp.prop], schemaProp, compilationContext, cache, contextProps, serializedDefinitions, refMap, editingInfoComponents === null || editingInfoComponents === void 0 ? void 0 : editingInfoComponents[schemaProp.prop], "".concat(configPrefix).concat(configPrefix === "" ? "" : ".").concat(schemaProp.prop));
      compiledComponentConfig.components[schemaProp.prop] = compilationOutput.map(function (compilationOutput) {
        return compilationOutput.compiledComponentConfig;
      }); // Merge config after auto

      if (compilationContext.isEditing && configAfterAuto !== null) {
        if (schemaProp.type === "component" || schemaProp.type === "component-fixed") {
          var _compilationOutput$0$, _compilationOutput$;

          configAfterAuto[schemaProp.prop] = [(_compilationOutput$0$ = (_compilationOutput$ = compilationOutput[0]) === null || _compilationOutput$ === void 0 ? void 0 : _compilationOutput$.configAfterAuto) !== null && _compilationOutput$0$ !== void 0 ? _compilationOutput$0$ : []];
        } else if (schemaProp.type === "component-collection" || schemaProp.type === "component-collection-localised") {
          var configsAfterAuto = compilationOutput.map(function (compilationOutput, index) {
            if (schemaProp.itemFields) {
              var itemPropsCollectionPath = "_itemProps.".concat(editableElement._template, ".").concat(schemaProp.prop);
              var itemProps = Object.fromEntries(schemaProp.itemFields.map(function (itemSchemaProp) {
                // const itemPropPathExpanded = `${itemPropsCollectionPath}.${itemSchemaProp.prop}`;
                // const currentItemPropValue = dotNotationGet(
                //   compilationOutput.configAfterAuto,
                //   itemPropPathExpanded
                // );
                // if (currentItemPropValue) {
                //   return [itemSchemaProp.prop, currentItemPropValue];
                // }
                var itemPropValue = configAfterAuto[schemaProp.prop][index][itemSchemaProp.prop];
                return [itemSchemaProp.prop, itemPropValue];
              }));
              dotNotationSet(compilationOutput.configAfterAuto, itemPropsCollectionPath, itemProps);
            }

            return compilationOutput.configAfterAuto;
          });

          if (schemaProp.type === "component-collection-localised") {
            // We store after auto config within context of current locale only
            configAfterAuto[schemaProp.prop] = _defineProperty$g({}, compilationContext.contextParams.locale, configsAfterAuto);
          } else {
            configAfterAuto[schemaProp.prop] = configsAfterAuto;
          }
        }
      }
    }
  });
}

function addComponentToSerializedComponentDefinitions(component, serializedDefinitions, compilationContext) {
  if (serializedDefinitions.find(function (def) {
    return def.id === component._template;
  })) {
    return;
  }

  var internalDefinition = findComponentDefinition(component, compilationContext);
  var newDef = {
    id: internalDefinition.id,
    label: internalDefinition.label,
    schema: internalDefinition.schema,
    tags: internalDefinition.tags
  };

  if ("componentCode" in internalDefinition) {
    newDef.componentCode = internalDefinition.componentCode;
  }

  serializedDefinitions.push(newDef);
}

function createFieldName(schemaProp, configPrefix, templateId, editorContext) {
  var _splitTemplateName = splitTemplateName(templateId),
      ref = _splitTemplateName.ref,
      isRefLocal = _splitTemplateName.isRefLocal;
  /**
   * This condition is kind of "ancient". It's ref mechanism (shared properties) that is not in use anymore. But it's necessary for backward compatibility.
   */


  if (ref && !isResourceSchemaProp(schemaProp)) {
    // local ref
    if (!isRefLocal) {
      throw new Error("global refs not enabled");
    }

    var parent = parsePath(configPrefix + "." + schemaProp.prop, editorContext.form).parent;
    return "".concat(parent.path, ".$$$refs.").concat(ref, ".").concat(schemaProp.prop);
  } else {
    return schemaProp.prop === "$myself" ? configPrefix : "".concat(configPrefix).concat(configPrefix === "" ? "" : ".").concat(schemaProp.prop);
  }
}

function getDefaultFieldDefinition(schemaProp, configPrefix, definition, editorContext, compiledValues, templateId) {
  var _schemaProp$label, _schemaProp$group;

  var tinaField = getTinaField(_objectSpread$X(_objectSpread$X({}, schemaProp), {}, {
    definition: definition
  }), editorContext, definition);
  var visible = !isSchemaPropComponentOrComponentCollection(schemaProp);

  if (typeof schemaProp.visible === "boolean") {
    visible = schemaProp.visible;
  } else if (typeof schemaProp.visible === "function") {
    visible = schemaProp.visible(compiledValues, {
      editorContext: editorContext
    });
  }

  return _objectSpread$X(_objectSpread$X({}, tinaField), {}, {
    prop: schemaProp.prop,
    label: (_schemaProp$label = schemaProp.label) !== null && _schemaProp$label !== void 0 ? _schemaProp$label : schemaProp.prop,
    group: (_schemaProp$group = schemaProp.group) !== null && _schemaProp$group !== void 0 ? _schemaProp$group : "Properties",
    name: createFieldName(schemaProp, configPrefix, templateId, editorContext),
    hidden: !visible
  });
}

function buildDefaultEditingInfo(definition, configPrefix, editorContext, compiledValues, templateId) {
  var scalarizedConfig = scalarizeConfig(compiledValues, editorContext.breakpointIndex, editorContext.devices, definition.schema);

  var schema = _toConsumableArray$2(definition.schema);

  var defaultFields = schema.filter(function (schemaProp) {
    return !isSchemaPropCollection(schemaProp);
  }).filter(function (schemaProp) {
    if (compiledValues.noTrace && schemaProp.prop.startsWith("trace")) {
      return false;
    }

    return true;
  }).map(function (schemaProp) {
    return getDefaultFieldDefinition(schemaProp, configPrefix, definition, editorContext, scalarizedConfig, templateId);
  }); // noAction is a special property

  if (compiledValues.noAction) {
    defaultFields = defaultFields.filter(function (field) {
      return field.prop !== "action";
    });
  }

  var pathInfo = parsePath(configPrefix, editorContext.form);
  var parentInfo = pathInfo.parent;

  if (parentInfo) {
    var parentDefinition = findComponentDefinitionById(parentInfo.templateId, editorContext);

    if (!parentDefinition) {
      throw new Error("Can't find parent definition: ".concat(parentInfo.templateId));
    }

    var parentSchemaProp = parentDefinition.schema.find(function (schemaProp) {
      return schemaProp.prop === parentInfo.fieldName;
    });

    if (!parentSchemaProp) {
      throw new Error("Can't find parent schemaProp: ".concat(parentInfo.templateId, " > ").concat(parentInfo.fieldName));
    }

    var required;

    if (parentSchemaProp.type === "component-fixed") {
      required = true;
    } else if (isSchemaPropCollection(parentSchemaProp)) {
      required = false;
    } else {
      required = !!parentSchemaProp.required;
    }

    var headerSchemaProp = {
      prop: "$myself",
      label: "Component type",
      type: "component$$$",
      picker: parentSchemaProp.picker,
      definition: parentDefinition,
      required: required,
      group: "Component"
    };
    var headerField = {
      component: "identity",
      hidden: false,
      label: "Component type",
      name: configPrefix,
      prop: "$myself",
      schemaProp: headerSchemaProp
    };

    if (process.env.NEXT_PUBLIC_SHOPSTORY_FEATURE_VARIANTS === "enabled") {
      var variantSchemaProp = {
        prop: "$myself",
        label: "Variants",
        type: "variants$$$",
        group: "Variations",
        definition: parentDefinition
      };
      var variantsField = {
        component: "variant",
        group: "Variations",
        hidden: false,
        label: "Variants",
        name: configPrefix,
        prop: "$myself",
        schemaProp: variantSchemaProp
      };
      defaultFields.unshift(variantsField);
    }

    defaultFields.unshift(headerField);
  }

  var fields = bubbleDown(function (x) {
    return x.prop === "Analytics";
  }, defaultFields);
  var editingInfo = {
    fields: fields,
    components: {}
  };
  definition.schema.forEach(function (schemaProp) {
    if (isSchemaPropCollection(schemaProp)) {
      editingInfo.components[schemaProp.prop] = {
        items: scalarizedConfig[schemaProp.prop].map(function (x, index) {
          var _schemaProp$itemField;

          return {
            fields: ((_schemaProp$itemField = schemaProp.itemFields) !== null && _schemaProp$itemField !== void 0 ? _schemaProp$itemField : []).map(function (itemSchemaProp) {
              return getDefaultFieldDefinition(itemSchemaProp, "".concat(configPrefix).concat(configPrefix === "" ? "" : ".").concat(schemaProp.prop, ".").concat(index, "._itemProps.").concat(definition.id, ".").concat(schemaProp.prop), definition, editorContext, scalarizedConfig, templateId);
            })
          };
        })
      };
    } else if (isSchemaPropComponent(schemaProp)) {
      editingInfo.components[schemaProp.prop] = {
        fields: []
      };
    }
  });
  return editingInfo;
}

function applyEditingInfoToCompiledConfig(compiledComponentConfig, editingInfo, parentEditingInfo) {
  var headerFields = editingInfo.fields.filter(function (field) {
    return field.prop === "$myself";
  });
  var nonHeaderFields = editingInfo.fields.filter(function (field) {
    return field.prop !== "$myself";
  });
  var fields = [].concat(_toConsumableArray$2(headerFields), _toConsumableArray$2(parentEditingInfo && "fields" in parentEditingInfo ? parentEditingInfo.fields : []), _toConsumableArray$2(nonHeaderFields));
  compiledComponentConfig.__editing = _objectSpread$X(_objectSpread$X({}, parentEditingInfo), {}, {
    fields: fields,
    components: {}
  });

  for (var fieldName in editingInfo.components) {
    compiledComponentConfig.__editing.components[fieldName] = {}; // Here we copy only noInline. It's the only flag we need in parent component. It's only because we need noInline info even if there is no component in array (to know that we shouldn't render placeholder)

    if (editingInfo.components[fieldName].noInline !== undefined) {
      compiledComponentConfig.__editing.components[fieldName].noInline = editingInfo.components[fieldName].noInline;
    }
  }
}

var deepObjectMergeWithoutArrays = function deepObjectMergeWithoutArrays(target, source) {
  // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
  for (var _i = 0, _Object$keys = Object.keys(source); _i < _Object$keys.length; _i++) {
    var _key2 = _Object$keys[_i];
    if (source[_key2] instanceof Object && !Array.isArray(source[_key2])) Object.assign(source[_key2], deepObjectMergeWithoutArrays(target[_key2], source[_key2]));
  } // Join `target` and modified `source`


  Object.assign(target || {}, source);
  return target;
};

function itemFieldsForEach(config, compilationContext, callback) {
  var componentDefinition = findComponentDefinition(config, compilationContext);
  componentDefinition.schema.forEach(function (schemaProp) {
    if (isSchemaPropCollection(schemaProp)) {
      var _dotNotationGet;

      var itemFields = schemaProp.itemFields;
      var path = schemaProp.prop;

      if (schemaProp.type === "component-collection-localised") {
        var localizedValue = resolveLocalisedValue(config[schemaProp.prop], compilationContext);

        if (localizedValue) {
          path = "".concat(path, ".").concat(localizedValue.locale);
        } else {
          path = "".concat(path, ".").concat(compilationContext.contextParams.locale);
        }
      }

      var value = (_dotNotationGet = dotNotationGet(config, path)) !== null && _dotNotationGet !== void 0 ? _dotNotationGet : [];
      value.forEach(function (itemConfig, index) {
        if (itemFields) {
          itemFields.forEach(function (itemSchemaProp) {
            var itemPath = "".concat(path, ".").concat(index, ".").concat(itemSchemaProp.prop);
            var itemValue = dotNotationGet(config, itemPath);
            callback({
              collectionSchemaProp: schemaProp,
              itemIndex: index,
              itemSchemaProp: itemSchemaProp,
              itemPropPath: itemPath,
              itemPropValue: itemValue
            });
          });
        }
      });
    }
  });
}

function compileComponent(editableElement, compilationContext, // contextProps are already compiled! They're result of compilation function.
contextProps, serializedDefinitions, refMap, cache, parentComponentEditingInfo, configPrefix) {
  var _configPrefix;

  configPrefix = (_configPrefix = configPrefix) !== null && _configPrefix !== void 0 ? _configPrefix : "";

  if (!isComponentConfig(editableElement)) {
    console.error("[compile] wrong input for compileComponent", editableElement);
    throw new Error("[compile] wrong input for compileComponent");
  }

  var cachedResult = cache.get(editableElement._id);

  var _splitTemplateName2 = splitTemplateName(editableElement._template),
      name = _splitTemplateName2.name,
      ref = _splitTemplateName2.ref;

  var componentDefinition = findComponentDefinitionById(name, compilationContext);

  if (!componentDefinition) {
    componentDefinition = findComponentDefinitionById("$MissingComponent", compilationContext);
    editableElement = {
      _template: componentDefinition.id,
      _id: uniqueId(),
      error: "Shopstory can\u2019t find definition for component: ".concat(name, " in your project. Please contact your developers to resolve this issue.")
    };
    parentComponentEditingInfo = undefined;
  }

  refMap = _objectSpread$X(_objectSpread$X({}, refMap), editableElement.$$$refs || {});

  if (componentDefinition.tags.length > 0 && componentDefinition.tags[0].startsWith("action")) {
    throw new Error("compileComponent can never be called for action");
  }

  var ownProps = createOwnComponentProps({
    config: editableElement,
    contextProps: contextProps,
    componentDefinition: componentDefinition,
    compilationContext: compilationContext,
    refMap: refMap,
    ref: ref
  });
  var hasComponentConfigChanged = true;
  var ownPropsAfterAuto;
  var compiled = {
    _template: editableElement._template,
    _id: editableElement._id,
    props: {},
    actions: {},
    components: {},
    textModifiers: {}
  };
  var configAfterAuto;
  var editingInfo;
  var compiledValues = {};
  var subcomponentsContextProps = {};
  var editingContextProps;

  if (cachedResult) {
    hasComponentConfigChanged = !deepCompare(ownProps, cachedResult.values);

    if (!hasComponentConfigChanged) {
      ownPropsAfterAuto = cachedResult.valuesAfterAuto;
      compiledValues = cachedResult.compiledValues;
      compiled = cachedResult.compiledConfig;
      configAfterAuto = cachedResult.valuesAfterAuto;
      subcomponentsContextProps = cachedResult.contextProps;
      editingContextProps = cachedResult.editingContextProps;
    }
  }

  addComponentToSerializedComponentDefinitions(editableElement, serializedDefinitions.components, compilationContext);
  var isCustomComponent = !editableElement._template.startsWith("$");
  var isButton = componentDefinition.tags.includes("button");

  if (hasComponentConfigChanged) {
    // We are going to mutate this object so let's disconnect it from its source object
    ownPropsAfterAuto = deepClone(ownProps); // update refMap
    // refMap = { ...refMap, ...(editableElement.$$$refs || {}) };

    var _calculateWidths = calculateWidths(compilationContext, contextProps, componentDefinition),
        $width = _calculateWidths.$width,
        $widthAuto = _calculateWidths.$widthAuto;
    /**
     * APPLY AUTO
     */


    var DEFAULT_SPACE_AUTO_CONSTANT = 16; // linearize space

    componentDefinition.schema.forEach(function (schemaProp) {
      if (isSchemaPropTokenized(schemaProp)) {
        ownPropsAfterAuto[schemaProp.prop] = applyAutoUsingResponsiveTokens(ownPropsAfterAuto[schemaProp.prop], compilationContext);
      }

      if (schemaProp.type === "space") {
        var _schemaProp$autoConst;

        ownPropsAfterAuto[schemaProp.prop] = linearizeSpace(ownPropsAfterAuto[schemaProp.prop], compilationContext, $width, (_schemaProp$autoConst = schemaProp.autoConstant) !== null && _schemaProp$autoConst !== void 0 ? _schemaProp$autoConst : DEFAULT_SPACE_AUTO_CONSTANT);
      }
    });
    itemFieldsForEach(ownPropsAfterAuto, compilationContext, function (arg) {
      var value = arg.itemPropValue;

      if (isSchemaPropTokenized(arg.itemSchemaProp)) {
        value = applyAutoUsingResponsiveTokens(value, compilationContext);
      }

      if (arg.itemSchemaProp.type === "space") {
        var _arg$itemSchemaProp$a;

        value = linearizeSpace(value, compilationContext, $width, (_arg$itemSchemaProp$a = arg.itemSchemaProp.autoConstant) !== null && _arg$itemSchemaProp$a !== void 0 ? _arg$itemSchemaProp$a : DEFAULT_SPACE_AUTO_CONSTANT);
      }

      dotNotationSet(ownPropsAfterAuto, arg.itemPropPath, value);
    });
    var autoFunction = componentDefinition.auto;

    if (autoFunction) {
      ownPropsAfterAuto = autoFunction(ownPropsAfterAuto, compilationContext, $width);
    } // Fill all responsive values. We can assume that values after auto for each breakpoint MUST be defined!!!
    // IMPORTANT: For now we make it realtive to device widths, so Webflow way


    for (var _prop in ownPropsAfterAuto) {
      ownPropsAfterAuto[_prop] = responsiveValueFill(ownPropsAfterAuto[_prop], compilationContext.devices, getDevicesWidths(compilationContext.devices));
    }

    itemFieldsForEach(ownPropsAfterAuto, compilationContext, function (arg) {
      dotNotationSet(ownPropsAfterAuto, arg.itemPropPath, responsiveValueFill(arg.itemPropValue, compilationContext.devices, getDevicesWidths(compilationContext.devices)));
    }); // First we compile all the props and store them in compiledValues

    var _compileComponentValu = compileComponentValues(ownPropsAfterAuto, componentDefinition, compilationContext, cache),
        traceId = _compileComponentValu.traceId,
        traceClicks = _compileComponentValu.traceClicks,
        traceImpressions = _compileComponentValu.traceImpressions,
        _compiledValues = _objectWithoutProperties$2(_compileComponentValu, ["traceId", "traceClicks", "traceImpressions"]);

    compiledValues = _objectSpread$X(_objectSpread$X({}, deepClone(ownPropsAfterAuto)), _compiledValues); // Compile item props

    itemFieldsForEach(ownPropsAfterAuto, compilationContext, function (_ref2) {
      var itemPropValue = _ref2.itemPropValue,
          itemIndex = _ref2.itemIndex,
          itemSchemaProp = _ref2.itemSchemaProp,
          collectionSchemaProp = _ref2.collectionSchemaProp;
      var compiledValue = compileFromSchema(itemPropValue, itemSchemaProp, compilationContext, cache, {}, serializedDefinitions, refMap);
      compiledValues[collectionSchemaProp.prop][itemIndex][itemSchemaProp.prop] = compiledValue;
    }); // Let's compile tracing

    if (componentDefinition.schema.some(function (_ref3) {
      var prop = _ref3.prop;
      return isSchemaPropTracing(prop);
    })) {
      compiled.tracing = {
        traceId: traceId,
        traceClicks: traceClicks,
        traceImpressions: traceImpressions,
        type: tracingType(componentDefinition.tags, contextProps.tracingType)
      };
    }

    componentDefinition.schema.forEach(function (schemaProp) {
      if (isSchemaPropActionTextModifier(schemaProp) || isSchemaPropTextModifier(schemaProp)) {
        var modifierValue = editableElement[schemaProp.prop][0];

        if (!modifierValue) {
          compiledValues[schemaProp.prop] = [];
          return;
        }

        compiledValues[schemaProp.prop] = [compileTextModifier(modifierValue, editableElement.elements, compilationContext, "".concat(configPrefix).concat(configPrefix === "" ? "" : ".").concat(schemaProp.prop, ".0"), cache)];
        compiled.textModifiers[schemaProp.prop] = compiledValues[schemaProp.prop];
      }
    }); // We want to style block element based on the most common values from all text parts within all lines.
    // Only for this component, we compile nested $richTextPart components values.

    if (editableElement._template === richTextEditableComponent.id) {
      if (compiledValues.isListStyleAuto) {
        var _compileRichTextValue = compileRichTextValuesFromRichTextParts(editableElement, compilationContext, cache),
            _compileRichTextValue2 = _compileRichTextValue.mainColor,
            mainColor = _compileRichTextValue2 === void 0 ? compiledValues.mainColor : _compileRichTextValue2,
            _compileRichTextValue3 = _compileRichTextValue.mainFont,
            mainFont = _compileRichTextValue3 === void 0 ? compiledValues.mainFont : _compileRichTextValue3;

        compiledValues.mainColor = mainColor;
        compiledValues.mainFont = mainFont;
      }

      compiledValues.mainFontSize = mapResponsiveFontToResponsiveFontSize(compiledValues.mainFont);
    } // $SectionWrapper holds the hide prop, but the $RootSections component is responsible for showing/hiding sections
    // We add `hide` value of each section to compiled values of $RootSections component


    if (editableElement._template === "$RootSections") {
      compiledValues.data = compiledValues.data.map(function (data, index) {
        return _objectSpread$X(_objectSpread$X({}, data), {}, {
          hide: responsiveValueFill(editableElement.data[index].hide, compilationContext.devices, getDevicesWidths(compilationContext.devices))
        });
      });
    } // User-defined components don't need any more work


    if (isCustomComponent) {
      compiled.props = compiledValues; // for now we're not adding context values to custom components

      var stylesOutput = {};

      if (compilationContext.isEditing) {
        editingInfo = buildDefaultEditingInfo(componentDefinition, configPrefix, compilationContext, compiledValues, editableElement._template);
      }
      /**
       * This is exception. If we have button we pass special context props to the symbol subcomponent (ignoreColor).
       * Actually maybe custom components should also have compilation phase?
       */


      var _isButton = componentDefinition.tags.includes("button");

      if (_isButton) {
        var _editingInfo;

        stylesOutput.symbol = {
          noInline: true,
          ignoreColor: true
        };

        if ((_editingInfo = editingInfo) === null || _editingInfo === void 0 ? void 0 : _editingInfo.components.symbol) {
          editingInfo.components.symbol.noInline = true;
        }
      }

      if (compilationContext.isEditing && editingInfo) {
        applyEditingInfoToCompiledConfig(compiled, editingInfo, parentComponentEditingInfo);
      }

      subcomponentsContextProps = extractContextPropsFromStyles(stylesOutput); // We are going to mutate this object so let's disconnect it from its source object

      configAfterAuto = deepClone(ownProps);
    } else {
      compiled = _objectSpread$X(_objectSpread$X({}, compiled), {}, {
        components: {},
        styled: {}
      });
      var renderableComponentDefinition = componentDefinition;

      if (compilationContext.isEditing) {
        /**
         * Let's build default editingOutput (fields and component output)
         */
        var editorContext = compilationContext;
        editingInfo = buildDefaultEditingInfo(renderableComponentDefinition, configPrefix, editorContext, compiledValues, editableElement._template);
        /**
         * Let's run custom editing function
         */

        if (renderableComponentDefinition.editing) {
          var fieldsMap = {};
          editingInfo.fields.forEach(function (field) {
            fieldsMap[field.prop] = field;
          });
          var scalarizedConfig = scalarizeConfig(compiledValues, editorContext.breakpointIndex, editorContext.devices, renderableComponentDefinition.schema);
          var editingInfoPartial = renderableComponentDefinition.editing(scalarizedConfig, editingInfo, {
            fields: fieldsMap,
            pathPrefix: configPrefix,
            editorContext: editorContext
          });

          if (editingInfoPartial) {
            deepObjectMergeWithoutArrays(editingInfo, editingInfoPartial);
          }
        }
        /**
         * Save to __editing
         */


        applyEditingInfoToCompiledConfig(compiled, editingInfo, parentComponentEditingInfo);
        editingContextProps = editingInfo.components;
      }

      var _resop = resop2(compiledValues, function (x, breakpointIndex) {
        if (!renderableComponentDefinition.styles) {
          return {};
        }

        var device = compilationContext.devices.find(function (device) {
          return device.id === breakpointIndex;
        });
        return renderableComponentDefinition.styles(x, {
          breakpointIndex: breakpointIndex,
          device: device,
          compilationContext: compilationContext,
          $width: $width[breakpointIndex],
          $widthAuto: $widthAuto[breakpointIndex]
        });
      }, compilationContext.devices, renderableComponentDefinition),
          __props = _resop.__props,
          _stylesOutput = _objectWithoutProperties$2(_resop, ["__props"]);

      subcomponentsContextProps = extractContextPropsFromStyles(_stylesOutput); // Move all the boxes to _compiled

      var _loop = function _loop(_key3) {
        var value = _stylesOutput[_key3];
        var schemaProp = componentDefinition.schema.find(function (x) {
          return x.prop === _key3;
        }); // Context props processed below

        if (schemaProp) {
          return "continue";
        } // If box


        compiled.styled[_key3] = compileBoxes(value, compilationContext);
      };

      for (var _key3 in _stylesOutput) {
        var _ret = _loop(_key3);

        if (_ret === "continue") continue;
      }
      /**
       * 1. We must move resources to props by default.
       * 2. Compiled values at this point are "filled", all breakpoints are defined. It's OK for auto and compilation.
       * 3. However, it's not OK for responsive resources (like image, video).
       */


      componentDefinition.schema.forEach(function (schemaProp) {
        if (isResourceSchemaProp(schemaProp)) {
          compiled.props[schemaProp.prop] = responsiveValueNormalize(compiledValues[schemaProp.prop], compilationContext.devices);
        }
      }); // we also add __props to props

      compiled.props = _objectSpread$X(_objectSpread$X({}, __props), compiled.props); // We are going to mutate this object so let's disconnect it from its source object

      configAfterAuto = deepClone(ownPropsAfterAuto);
    }
  }

  if (compilationContext.isEditing) {
    if (isCustomComponent) {
      editingInfo = buildDefaultEditingInfo(componentDefinition, configPrefix, compilationContext, compiledValues, editableElement._template);
      /**
       * This is exception. If we have button we pass special context props to the symbol subcomponent (ignoreColor).
       * Actually maybe custom components should also have compilation phase?
       */

      if (isButton) {
        var _editingInfo2;

        if ((_editingInfo2 = editingInfo) === null || _editingInfo2 === void 0 ? void 0 : _editingInfo2.components.symbol) {
          editingInfo.components.symbol.noInline = true;
        }
      }
    } else {
      /**
       * Let's build default editingOutput (fields and component output)
       */
      var _editorContext = compilationContext;
      var _renderableComponentDefinition = componentDefinition;
      editingInfo = buildDefaultEditingInfo(_renderableComponentDefinition, configPrefix, _editorContext, compiledValues, editableElement._template);
      /**
       * Let's run custom editing function
       */

      if (_renderableComponentDefinition.editing) {
        var _fieldsMap = {};
        editingInfo.fields.forEach(function (field) {
          _fieldsMap[field.prop] = field;
        });

        var _scalarizedConfig = scalarizeConfig(compiledValues, _editorContext.breakpointIndex, _editorContext.devices, _renderableComponentDefinition.schema);

        var _editingInfoPartial = _renderableComponentDefinition.editing(_scalarizedConfig, editingInfo, {
          fields: _fieldsMap,
          pathPrefix: configPrefix,
          editorContext: _editorContext
        });

        if (_editingInfoPartial) {
          deepObjectMergeWithoutArrays(editingInfo, _editingInfoPartial);
        }
      }
    }

    if (editingInfo) // Save to __editing
      applyEditingInfoToCompiledConfig(compiled, editingInfo, parentComponentEditingInfo);
    editingContextProps = editingInfo.components;
  }

  compileSubcomponents(editableElement, subcomponentsContextProps, compilationContext, refMap, serializedDefinitions, editingContextProps, configPrefix, compiled, isCustomComponent ? null : configAfterAuto, cache);
  cache.set(ownProps._id, {
    values: ownProps,
    valuesAfterAuto: ownPropsAfterAuto,
    compiledValues: compiledValues,
    compiledConfig: compiled,
    contextProps: subcomponentsContextProps,
    editingContextProps: editingContextProps
  });

  if (process.env.NEXT_PUBLIC_SHOPSTORY_INTERNAL_COMPILATION_DEBUG === "true") {
    logCompilationDebugOutput({
      cachedResult: cachedResult,
      hasComponentConfigChanged: hasComponentConfigChanged,
      configPrefix: configPrefix,
      ownProps: ownProps,
      compiled: compiled
    });
  }

  return {
    compiledComponentConfig: compiled,
    configAfterAuto: configAfterAuto
  };
}

function logCompilationDebugOutput(_ref4) {
  var cachedResult = _ref4.cachedResult,
      hasComponentConfigChanged = _ref4.hasComponentConfigChanged,
      configPrefix = _ref4.configPrefix,
      ownProps = _ref4.ownProps,
      compiled = _ref4.compiled;

  if (cachedResult && !hasComponentConfigChanged) {
    console.groupCollapsed("[cache] ", configPrefix ? configPrefix : "root");
  } else {
    console.groupCollapsed("[compiled] ", configPrefix ? configPrefix : "root");
  }

  console.log(ownProps);
  console.log(compiled);
  console.groupEnd();
}

function calculateWidths(compilationContext, contextProps, componentDefinition) {
  var $width = {
    $res: true
  };
  var $widthAuto = {
    $res: true
  };
  compilationContext.devices.forEach(function (device) {
    var _contextProps$$width$, _contextProps$$width, _contextProps$$widthA, _contextProps$$widthA2;

    $width[device.id] = (_contextProps$$width$ = (_contextProps$$width = contextProps.$width) === null || _contextProps$$width === void 0 ? void 0 : _contextProps$$width[device.id]) !== null && _contextProps$$width$ !== void 0 ? _contextProps$$width$ : (componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.tags.includes("section")) || (componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.tags.includes("root")) ? device.w : -1;
    $widthAuto[device.id] = (_contextProps$$widthA = (_contextProps$$widthA2 = contextProps.$widthAuto) === null || _contextProps$$widthA2 === void 0 ? void 0 : _contextProps$$widthA2[device.id]) !== null && _contextProps$$widthA !== void 0 ? _contextProps$$widthA : false;
  });
  return {
    $width: $width,
    $widthAuto: $widthAuto
  };
}

function mapResponsiveFontToResponsiveFontSize(responsiveFontValue) {
  return Object.fromEntries(entries(responsiveFontValue).map(function (_ref5) {
    var _ref6 = _slicedToArray$2(_ref5, 2),
        breakpoint = _ref6[0],
        fontValue = _ref6[1];

    if (breakpoint === "$res") {
      return [breakpoint, fontValue];
    }

    return [breakpoint, fontValue.fontSize];
  }));
}

function resourceNormalize(x) {
  if (typeof x === "object" && x !== null) {
    if (typeof x.id === "string") {
      var normalized = {
        id: x.id
      };

      if (typeof x.info === "object") {
        normalized.info = x.info;
      }

      return normalized;
    }

    return {
      id: null
    };
  }

  return;
}

function externalGetHash(value, breakpointIndex) {
  var _value$id;

  if (isTrulyResponsiveValue(value)) {
    var breakpointValue = responsiveValueAt(value, breakpointIndex);

    if (breakpointValue) {
      var _breakpointValue$id;

      return (_breakpointValue$id = breakpointValue.id) !== null && _breakpointValue$id !== void 0 ? _breakpointValue$id : undefined;
    }

    return;
  }

  return (_value$id = value.id) !== null && _value$id !== void 0 ? _value$id : undefined;
}

function resolveLocalisedValue(localisedValue, compilationContext) {
  var locale = compilationContext.contextParams.locale;

  if (localisedValue[locale] !== undefined) {
    return {
      value: localisedValue[locale],
      locale: locale
    };
  }

  if (compilationContext.isEditing) {
    var editorContext = compilationContext;
    var fallbackLocale = getFallbackLocaleForLocale(locale, editorContext.locales);

    if (!fallbackLocale) {
      return;
    }

    return {
      value: localisedValue[fallbackLocale],
      locale: fallbackLocale
    };
  } else {
    return;
  }
}
var schemaPropDefinitions = {
  text: textProvider,
  number: function number(schemaProp, compilationContext) {
    var normalize = getNormalize(compilationContext, schemaProp.defaultValue, 0, function (x) {
      return typeof x === "number" ? x : undefined;
    });
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value) {
        return value.toString();
      }
    };
  },
  string: function string(schemaProp, compilationContext) {
    var normalize = getNormalize(compilationContext, schemaProp.defaultValue, "", function (x) {
      return typeof x === "string" ? x : undefined;
    });
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value) {
        return value;
      }
    };
  },
  string$: function string$(schemaProp, compilationContext) {
    var normalize = getResponsiveNormalize(compilationContext, schemaProp.defaultValue, "", function (x) {
      return typeof x === "string" ? x : undefined;
    });
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value, breakpointIndex) {
        if (isTrulyResponsiveValue(value)) {
          return responsiveValueAt(value, breakpointIndex);
        }

        return value;
      }
    };
  },
  "boolean": function boolean(schemaProp, compilationContext) {
    var normalize = getNormalize(compilationContext, schemaProp.defaultValue, false, function (x) {
      return typeof x === "boolean" ? x : undefined;
    });
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value) {
        return value.toString();
      }
    };
  },
  boolean$: function boolean$(schemaProp, compilationContext) {
    var normalize = getResponsiveNormalize(compilationContext, schemaProp.defaultValue, false, function (x) {
      return typeof x === "boolean" ? x : undefined;
    });
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value, breakpointIndex) {
        if (isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, breakpointIndex);
          return breakpointValue === null || breakpointValue === void 0 ? void 0 : breakpointValue.toString();
        }

        return value.toString();
      }
    };
  },
  select: getSelectSchemaPropDefinition(),
  "radio-group": getSelectSchemaPropDefinition(),
  select$: getResponsiveSelectSchemaPropDefinition(),
  "radio-group$": getResponsiveSelectSchemaPropDefinition(),
  // @ts-ignore TODO: temporary, we need to fix those types
  color: function color(schemaProp, compilationContext) {
    // @ts-ignore
    return _objectSpread$X(_objectSpread$X({}, buildThemeDefinition(compilationContext.theme.colors, "$dark", schemaProp, compilationContext, function (x) {
      if (typeof x !== "string") {
        return;
      } // right now we assume that user gives correct CSS color!


      return x;
    })), {}, {
      getHash: function getHash(value, breakpointIndex) {
        if (isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, breakpointIndex);
          return breakpointValue ? getRef(breakpointValue) : undefined;
        }

        return getRef(value);
      }
    });
  },
  stringToken: function stringToken(schemaProp, compilationContext) {
    var themeValues = compilationContext.theme[schemaProp.tokenId];

    if (!themeValues) {
      throw new Error("string token with ID \"".concat(schemaProp.tokenId, "\" doesn't have any values."));
    }

    var defaultKey;

    if (schemaProp.tokenId === "numberOfItemsInRow") {
      defaultKey = "4";
    } else if (schemaProp.tokenId === "aspectRatios") {
      defaultKey = "$landscape";
    } else if (schemaProp.tokenId === "containerWidths") {
      defaultKey = "none";
    } else {
      throw new Error("unknown token Id: " + schemaProp.tokenId);
    } // @ts-ignore


    return _objectSpread$X(_objectSpread$X({}, buildThemeDefinition(themeValues, defaultKey, schemaProp, compilationContext, function (x) {
      if (typeof x !== "string") {
        return;
      } // right now we assume that user gives correct CSS color!


      return x;
    })), {}, {
      getHash: function getHash(value, breakpointIndex) {
        if (isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, breakpointIndex);

          if (!breakpointValue) {
            return breakpointValue;
          }

          if (breakpointValue.ref) {
            return breakpointValue.ref;
          }

          if (isTrulyResponsiveValue(breakpointValue.value)) {
            var nestedBreakpointValue = responsiveValueAt(breakpointValue.value, breakpointIndex);
            return nestedBreakpointValue;
          }

          return breakpointValue.value;
        }

        if (value.ref) {
          return value.ref;
        }

        if (isTrulyResponsiveValue(value.value)) {
          var _breakpointValue = responsiveValueAt(value.value, breakpointIndex);

          return _breakpointValue;
        }

        return value.value;
      }
    });
  },
  // @ts-ignore TODO: temporary, we need to fix those types
  font: function font(schemaProp, compilationContext) {
    // @ts-ignore
    return _objectSpread$X(_objectSpread$X({}, buildThemeDefinition(compilationContext.theme.fonts, "$body", schemaProp, compilationContext, function (x) {
      if (typeof x !== "object" || x === null) {
        return;
      }

      return x;
    })), {}, {
      getHash: function getHash(value, breakpointIndex) {
        if (isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, breakpointIndex);
          return breakpointValue ? getRef(breakpointValue) : undefined;
        }

        return getRef(value);
      }
    });
  },
  // @ts-ignore TODO: temporary, we need to fix those types
  space: function space(schemaProp, compilationContext) {
    // @ts-ignore
    return _objectSpread$X(_objectSpread$X({}, buildThemeDefinition(compilationContext.theme.space, schemaProp.prefix ? schemaProp.prefix + ".default" : "0", schemaProp, compilationContext, function (x) {
      if (typeof x === "number") {
        return "".concat(x, "px");
      }

      if (typeof x !== "string") {
        return;
      }

      try {
        parseSpacing(x);
        return x;
      } catch (error) {
        return;
      }
    })), {}, {
      getHash: function getHash(value, breakpointIndex) {
        if (isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, breakpointIndex);
          return breakpointValue ? getRef(breakpointValue) : undefined;
        }

        return getRef(value);
      }
    });
  },
  icon: function icon(schemaProp, compilationContext) {
    var ultimateDefaultValue = {
      ref: "$sliderLeft",
      value: compilationContext.theme.icons["$sliderLeft"].value
    };

    var scalarValueNormalize = function scalarValueNormalize(x) {
      if (typeof x === "string" && x.trim().startsWith("<svg")) {
        return x;
      }

      return;
    };

    var defaultValue = normalizeTokenValue(schemaProp.defaultValue, compilationContext.theme.icons, ultimateDefaultValue, scalarValueNormalize) || ultimateDefaultValue;
    return {
      normalize: function normalize(x) {
        var normalized = normalizeTokenValue(x, compilationContext.theme.icons, defaultValue, scalarValueNormalize);

        if (!normalized) {
          return defaultValue;
        }

        return normalized;
      },
      compile: function compile(x) {
        return x.value;
      },
      getHash: function getHash(x) {
        return getRef(x);
      }
    };
  },
  image: function image(_, compilationContext) {
    var normalize = getResponsiveNormalize(compilationContext, {}, {
      id: null
    }, resourceNormalize);
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: externalGetHash
    };
  },
  video: function video(_, compilationContext) {
    var normalize = getResponsiveNormalize(compilationContext, {}, {
      id: null
    }, resourceNormalize);
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: externalGetHash
    };
  },
  custom: function custom() {
    return {
      normalize: function normalize(x) {
        var normalized = resourceNormalize(x);

        if (!normalized) {
          return {
            id: null
          };
        }

        return normalized;
      },
      compile: function compile(x) {
        return x;
      },
      getHash: externalGetHash
    };
  },
  component: function component(_, compilationContext) {
    // Here:
    // 1. if non-fixed => ss-block field.
    // 2. if fixed => ss-block field with "fixed" flag (no component picker).
    var normalize = function normalize(x) {
      if (!Array.isArray(x) || x.length === 0) {
        return [];
      }

      return [normalizeComponent(x[0], compilationContext)];
    };

    return {
      normalize: normalize,
      compile: function compile(arg, contextProps, serializedDefinitions, refMap, editingInfoComponent, configPrefix, cache) {
        if (arg.length === 0) {
          return [];
        }

        var _compileComponent = compileComponent(arg[0], compilationContext, contextProps, serializedDefinitions || {}, refMap, cache, editingInfoComponent, "".concat(configPrefix, ".0")),
            configAfterAuto = _compileComponent.configAfterAuto,
            compiledComponentConfig = _compileComponent.compiledComponentConfig;

        return [{
          configAfterAuto: configAfterAuto,
          compiledComponentConfig: compiledComponentConfig
        }];
      },
      getHash: function getHash(value) {
        if (value.length > 0) {

          return value[0]._template;
        }

        return "__BLOCK_EMPTY__";
      }
    };
  },
  "component-fixed": function componentFixed(schemaProp, compilationContext) {
    var normalize = function normalize(x) {
      if (!Array.isArray(x) || x.length === 0) {
        return [normalizeComponent({
          _template: schemaProp.componentType
        }, compilationContext)];
      }

      return [normalizeComponent(x[0], compilationContext)];
    };

    return {
      normalize: normalize,
      compile: function compile(arr, contextProps, serializedDefinitions, refMap, editingInfoComponent, configPrefix, cache) {
        var _compileComponent2 = compileComponent(arr[0], compilationContext, contextProps, serializedDefinitions, refMap, cache, editingInfoComponent, "".concat(configPrefix, ".0")),
            configAfterAuto = _compileComponent2.configAfterAuto,
            compiledComponentConfig = _compileComponent2.compiledComponentConfig;

        return [{
          configAfterAuto: configAfterAuto,
          compiledComponentConfig: compiledComponentConfig
        }];
      },
      getHash: function getHash(value) {
        return value.map(function (v) {
          return v._template;
        }).join(";");
      }
    };
  },
  "component-collection": function componentCollection(_, compilationContext) {
    var normalize = function normalize(x) {
      if (!Array.isArray(x)) {
        return [];
      }

      var ret = (x || []).map(function (item) {
        return normalizeComponent(item, compilationContext);
      });
      return ret;
    };

    return {
      normalize: normalize,
      compile: function compile(arr, contextProps, serializedDefinitions, refMap, editingInfoComponents, configPrefix, cache) {
        // pass index here!!!
        return arr.map(function (componentConfig, index) {
          var _items;

          return compileComponent(componentConfig, compilationContext, _objectSpread$X(_objectSpread$X({}, (contextProps.itemProps || [])[index] || {}), {}, {
            index: index,
            length: arr.length
          }), serializedDefinitions, refMap, cache, editingInfoComponents === null || editingInfoComponents === void 0 ? void 0 : (_items = editingInfoComponents.items) === null || _items === void 0 ? void 0 : _items[index], "".concat(configPrefix, ".").concat(index));
        });
      },
      getHash: function getHash(value) {
        return value.map(function (v) {
          return v._template;
        }).join(";");
      }
    };
  },
  "component-collection-localised": function componentCollectionLocalised(schemaProp, compilationContext) {
    var collectionSchemaPropDefinition = schemaPropDefinitions["component-collection"](_objectSpread$X(_objectSpread$X({}, schemaProp), {}, {
      type: "component-collection"
    }), compilationContext);
    return {
      normalize: function normalize(x) {
        if (x === undefined) {
          return {};
        }

        var normalized = {};

        for (var _locale in x) {
          if (_locale === "__fallback") {
            continue;
          }

          normalized[_locale] = collectionSchemaPropDefinition.normalize(x[_locale]);
        }

        return normalized;
      },
      compile: function compile(value, contextProps, serializedDefinitions, refMap, editingInfoComponents, configPrefix, cache) {
        var _resolvedLocalisedVal, _resolvedLocalisedVal2;

        var resolvedLocalisedValue = resolveLocalisedValue(value, compilationContext);
        return collectionSchemaPropDefinition.compile((_resolvedLocalisedVal = resolvedLocalisedValue === null || resolvedLocalisedValue === void 0 ? void 0 : resolvedLocalisedValue.value) !== null && _resolvedLocalisedVal !== void 0 ? _resolvedLocalisedVal : [], contextProps, serializedDefinitions, refMap, editingInfoComponents, "".concat(configPrefix, ".").concat((_resolvedLocalisedVal2 = resolvedLocalisedValue === null || resolvedLocalisedValue === void 0 ? void 0 : resolvedLocalisedValue.locale) !== null && _resolvedLocalisedVal2 !== void 0 ? _resolvedLocalisedVal2 : compilationContext.contextParams.locale), cache);
      },
      getHash: function getHash(value, breakpoint, devices) {
        var _value$compilationCon;

        return collectionSchemaPropDefinition.getHash((_value$compilationCon = value[compilationContext.contextParams.locale]) !== null && _value$compilationCon !== void 0 ? _value$compilationCon : [], breakpoint, devices);
      }
    };
  },
  component$$$: function component$$$() {
    return {
      normalize: function normalize() {
        throw new Error("unreachable");
      },
      compile: function compile() {
        throw new Error("unreachable");
      },
      getHash: function getHash(value) {
        return value === null || value === void 0 ? void 0 : value._template;
      }
    };
  },
  resource: function resource(schemaProp) {
    return {
      normalize: function normalize(value) {
        var normalized = resourceNormalize(value);

        if (!normalized) {
          return {
            id: null
          };
        }

        return normalized;
      },
      compile: function compile(value) {
        return value;
      },
      getHash: function getHash(value) {
        if (value.id === null) {
          return "".concat(schemaProp.type, ".").concat(schemaProp.resourceType);
        }

        return "".concat(schemaProp.type, ".").concat(schemaProp.resourceType, ".").concat(value.id);
      }
    };
  }
};

function getRef(value) {
  if (value.ref) {
    return value.ref;
  }

  if (typeof value.value === "object") {
    return JSON.stringify(value.value);
  }

  var scalarVal = value.value;

  if (scalarVal.toString) {
    return scalarVal.toString();
  }

  throw new Error("unreachable");
}

function getSchemaDefinition(schemaProp, compilationContext) {
  var provider = schemaPropDefinitions[schemaProp.type] || schemaPropDefinitions.custom;
  return provider(schemaProp, compilationContext);
}
function compileFromSchema(value, schemaProp, compilationContext, cache, contextProps, serializedDefinitions, refMap, editingInfoComponent, configPrefix) {
  return getSchemaDefinition(schemaProp, compilationContext).compile( // @ts-expect-error //FIXME
  value, contextProps, serializedDefinitions, refMap, editingInfoComponent, configPrefix, cache);
}
function compile(configComponent, compilationContext) {
  var cache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new CompilationCache();

  if (process.env.NEXT_PUBLIC_SHOPSTORY_INTERNAL_COMPILATION_DEBUG === "true") {
    console.groupCollapsed("compilation");
  }

  var compilationContextWithFullTheme = _objectSpread$X(_objectSpread$X({}, compilationContext), {}, {
    theme: buildFullTheme(compilationContext.theme)
  });

  var serializedDefinitions = {
    links: [],
    actions: [],
    components: [],
    textModifiers: []
  };
  /**
   * If we're editing, we should set form.values properly (during compilation in editor we need that)
   */

  if (compilationContext.isEditing) {
    var editorContext = compilationContextWithFullTheme;
    editorContext.form = new Form({
      id: editorContext.form.id,
      label: editorContext.form.label,
      onSubmit: editorContext.form.onSubmit,
      initialValues: configComponent
    });
  }

  var compilationArtifacts = compileComponent(configComponent, compilationContextWithFullTheme, {}, serializedDefinitions, {}, cache);
  var compilationOutput = {
    compiled: compilationArtifacts.compiledComponentConfig,
    meta: {
      devices: compilationContextWithFullTheme.devices,
      image: compilationContextWithFullTheme.image,
      video: compilationContextWithFullTheme.video,
      definitions: serializedDefinitions
    }
  };

  if (!compilationContext.isEditing) {
    return compilationOutput;
  }

  if (process.env.NEXT_PUBLIC_SHOPSTORY_INTERNAL_COMPILATION_DEBUG === "true") {
    console.groupEnd();
  }

  return _objectSpread$X(_objectSpread$X({}, compilationOutput), {}, {
    configAfterAuto: compilationArtifacts.configAfterAuto
  });
}
function normalizeComponent(configComponent, compilationContext, isRef) {
  if (configComponent._template === "$ExternalBlock") {
    return configComponent;
  }

  var ret = {
    _id: configComponent._id,
    _template: configComponent._template,
    _variantGroupId: configComponent._variantGroupId,
    _audience: configComponent._audience,
    _variants: configComponent._variants,
    _master: configComponent._master,
    $$$refs: configComponent.$$$refs,
    traceId: configComponent.traceId
  }; // Normalize itemProps (before own props). If component definition is missing, we still normalize item props

  if (configComponent._itemProps) {
    ret._itemProps = {};

    var _loop2 = function _loop2(templateId) {
      ret._itemProps[templateId] = {};

      var _loop3 = function _loop3(fieldName) {
        ret._itemProps[templateId][fieldName] = {};
        var values = configComponent._itemProps[templateId][fieldName];
        var ownerDefinition = findComponentDefinitionById(templateId, compilationContext);
        var ownerSchemaProp = ownerDefinition.schema.find(function (x) {
          return x.prop === fieldName;
        });

        if (!ownerSchemaProp) {
          return "continue";
        }

        (ownerSchemaProp.itemFields || []).forEach(function (itemFieldSchemaProp) {
          ret._itemProps[templateId][fieldName][itemFieldSchemaProp.prop] = getSchemaDefinition(itemFieldSchemaProp, compilationContext).normalize(values[itemFieldSchemaProp.prop]);
        });
      };

      for (var fieldName in configComponent._itemProps[templateId]) {
        var _ret2 = _loop3(fieldName);

        if (_ret2 === "continue") continue;
      }
    };

    for (var templateId in configComponent._itemProps) {
      _loop2(templateId);
    }
  }

  var componentDefinition = findComponentDefinitionById(splitTemplateName(configComponent._template).name, compilationContext);

  if (!componentDefinition) {
    console.warn("[normalize] Unknown _template ".concat(configComponent._template));
    return ret;
  }

  componentDefinition.schema.forEach(function (schemaProp) {
    if (!isRef) {
      var _splitTemplateName3 = splitTemplateName(configComponent._template),
          ref = _splitTemplateName3.ref;

      if (ref) {
        if (!isResourceSchemaProp(schemaProp)) {
          return;
        }
      }
    } else {
      if (isResourceSchemaProp(schemaProp)) {
        return;
      }
    }

    ret[schemaProp.prop] = getSchemaDefinition(schemaProp, compilationContext).normalize(configComponent[schemaProp.prop]);
  }); // Normalize refs

  if (configComponent.$$$refs) {
    ret.$$$refs = {};

    for (var refName in configComponent.$$$refs) {
      ret.$$$refs[refName] = normalizeComponent(configComponent.$$$refs[refName], compilationContext, true);
    }
  }

  if (!ret._id) {
    ret._id = uniqueId();
  }

  if (!ret.traceId) {
    ret.traceId = generateDefaultTraceId(ret);
  }

  return ret;
}
function normalize(configComponent, compilationContext) {
  var compilationContextWithFullTheme = _objectSpread$X(_objectSpread$X({}, compilationContext), {}, {
    theme: buildFullTheme(compilationContext.theme)
  });

  return normalizeComponent(configComponent, compilationContextWithFullTheme);
}

function compileTextModifier(modifierValue, textParts, compilationContext, configPrefix, cache) {
  var modifierDefinition = findComponentDefinitionById(modifierValue._template, compilationContext);

  if (!modifierDefinition) {
    return {
      _template: "$MissingTextModifier",
      _id: uniqueId(),
      elements: []
    };
  }

  var compiledModifierValues = compileComponentValues(modifierValue, modifierDefinition, compilationContext, cache);
  var textPartDefinition = findComponentDefinitionById(richTextPartEditableComponent.id, compilationContext);

  if (!textPartDefinition) {
    throw new Error("[compile] Couldn't find a modifier definition for ".concat(richTextPartEditableComponent.id, ". "));
  }

  var compiledTextPartsValues = textParts.map(function (textPartConfig) {
    return compileComponentValues(textPartConfig, textPartDefinition, compilationContext, cache);
  });

  var compiledModifier = _objectSpread$X(_objectSpread$X({
    _template: modifierValue._template,
    _id: modifierValue._id
  }, compiledModifierValues), {}, {
    elements: compiledTextPartsValues
  });

  if (compilationContext.isEditing) {
    var editorContext = compilationContext;
    var editingInfo = buildDefaultEditingInfo(modifierDefinition, configPrefix, editorContext, compiledModifierValues, modifierValue._template);
    compiledModifier.__editing = {
      fields: editingInfo.fields
    };
  }

  return compiledModifier;
}

function createOwnComponentProps(_ref7) {
  var config = _ref7.config,
      contextProps = _ref7.contextProps,
      componentDefinition = _ref7.componentDefinition,
      compilationContext = _ref7.compilationContext,
      refMap = _ref7.refMap,
      ref = _ref7.ref;
  // Copy all values and refs defined in schema, for component fields copy only _id, _template and its _itemProps but flattened
  var values = Object.fromEntries(componentDefinition.schema.map(function (schemaProp) {
    if (isSchemaPropComponentOrComponentCollection(schemaProp)) {
      var configValue = config[schemaProp.prop];

      if (configValue.length === 0) {
        return [schemaProp.prop, []];
      }

      if (isSchemaPropComponent(schemaProp)) {
        return [schemaProp.prop, [{
          _id: configValue[0]._id,
          _template: configValue[0]._template
        }]];
      }

      if (isSchemaPropComponentCollectionLocalised(schemaProp)) {
        var _ref8, _resolveLocalisedValu;

        configValue = (_ref8 = (_resolveLocalisedValu = resolveLocalisedValue(config[schemaProp.prop], compilationContext)) === null || _resolveLocalisedValu === void 0 ? void 0 : _resolveLocalisedValu.value) !== null && _ref8 !== void 0 ? _ref8 : [];
      }

      var configValuesWithFlattenedItemProps = configValue.map(function (config) {
        if (schemaProp.itemFields) {
          var flattenedItemProps = flattenItemProps(config, componentDefinition, schemaProp, schemaProp.itemFields);
          return _objectSpread$X({
            _id: config._id,
            _template: config._template
          }, flattenedItemProps);
        }

        return {
          _id: config._id,
          _template: config._template
        };
      });
      return [schemaProp.prop, configValuesWithFlattenedItemProps];
    }

    return [schemaProp.prop, config[schemaProp.prop]];
  }));

  var ownValues = _objectSpread$X(_objectSpread$X({
    // Copy id and template which uniquely identify component.
    _id: config._id,
    _template: config._template
  }, values), contextProps);

  if (ref) {
    var refs = Object.fromEntries(componentDefinition.schema.filter(function (schemaProp) {
      return !isResourceSchemaProp(schemaProp);
    }).map(function (schemaProp) {
      return [schemaProp.prop, refMap[ref][schemaProp.prop]];
    }));
    Object.assign(ownValues, refs);
  }

  return ownValues;
}

function flattenItemProps(config, componentDefinition, collectionSchemaProp, itemsSchemas) {
  var itemProps = Object.fromEntries(itemsSchemas.map(function (itemSchemaProp) {
    return [itemSchemaProp.prop, config._itemProps[componentDefinition.id][collectionSchemaProp.prop][itemSchemaProp.prop]];
  }));
  return itemProps;
}

function extractContextPropsFromStyles(styles) {
  var contextProps = Object.fromEntries(Object.entries(styles).filter(function (_ref9) {
    var _ref10 = _slicedToArray$2(_ref9, 2),
        componentStyles = _ref10[1];

    return !componentStyles.__isBox;
  }));
  return contextProps;
}

function compileRichTextValuesFromRichTextParts(richTextConfig, compilationContext, cache) {
  var mainColor = getMostCommonValueFromRichTextParts(richTextConfig, "color", compilationContext, cache);
  var mainFont = getMostCommonValueFromRichTextParts(richTextConfig, "font", compilationContext, cache);
  return {
    mainColor: mainColor,
    mainFont: mainFont
  };
}

/**
 *
 * @param collection Array of values
 * @param mapper Optional callback function that will be invoked for each item of given array to map it into comparable string
 */
function getUniqueValues(collection, mapper) {
  if (mapper) {
    var uniqueValues = new Set();
    var uniqueItems = [];
    collection.forEach(function (item, index) {
      var mappedItem = mapper(item, index);

      if (!uniqueValues.has(mappedItem)) {
        uniqueValues.add(mappedItem);
        uniqueItems.push(item);
      }
    });
    return uniqueItems;
  }

  return Array.from(new Set(collection));
}

// It suggests that in onChange you can pass event OR any value. It's a bit confusing and should be cleaned up in the future.

function createFieldController(_ref) {
  var field = _ref.field,
      editorContext = _ref.editorContext,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? function (v) {
    return v;
  } : _ref$format,
      _ref$parse = _ref.parse,
      parse = _ref$parse === void 0 ? function (v) {
    return v;
  } : _ref$parse;
  var actions = editorContext.actions,
      activeEditor = editorContext.activeEditor,
      contextParams = editorContext.contextParams,
      form = editorContext.form,
      locales = editorContext.locales;
  var normalizedFieldName = toArray$2(field.name);
  return {
    onChange: function onChange(mainNewValue) {
      for (var _len = arguments.length, extraNewValues = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        extraNewValues[_key - 1] = arguments[_key];
      }

      /**
       * There are 2 modes of onChange: single param and multiple params
       *
       * 1. single param mode is when onChange is given ONE value (1 parameter). It means: "apply this value for all selected fields"
       * 2. multiple param mode is when onChange is given more than one value. It means: "apply each value for respective selected field".
       */
      var newValue = extraNewValues.length === 0 ? mainNewValue : [mainNewValue].concat(extraNewValues);

      if (!Array.isArray(mainNewValue) && Array.isArray(newValue) && newValue.length !== normalizedFieldName.length) {
        throw new Error("onChange in multiple param mode was given wrong number of values");
      }

      if (activeEditor === null || activeEditor === void 0 ? void 0 : activeEditor.selection) {
        // For editor selection we can safely pick a first field name because:
        // * we only can select fields that are children of $richTextPart
        // * we only can update only single property
        var _parsePath = parsePath(normalizedFieldName[0], form),
            templateId = _parsePath.templateId;

        invalidateCache(normalizedFieldName[0], editorContext);

        if (templateId === richTextPartEditableComponent.id || templateId === richTextInlineWrapperElementEditableComponent.id) {
          var schemaPropNameToUpdate = last(normalizedFieldName[0].split("."));

          if (schemaPropNameToUpdate.startsWith("$")) {
            schemaPropNameToUpdate = schemaPropNameToUpdate.slice(1);
          }

          if (extraNewValues.length > 0) {
            var parsedValues = newValue.map(function (value) {
              return parse(getValue$1(value), normalizedFieldName[0], field);
            });
            actions.setActiveEditorSelection.apply(actions, [schemaPropNameToUpdate, field.schemaProp].concat(_toConsumableArray$2(parsedValues)));
          } else {
            var parsedValue = parse(getValue$1(newValue), normalizedFieldName[0], field);
            actions.setActiveEditorSelection(schemaPropNameToUpdate, field.schemaProp, parsedValue);
          }

          return;
        }
      }

      actions.runChange(function () {
        normalizedFieldName.forEach(function (path, fieldIndex) {
          var inputValue = Array.isArray(newValue) ? getValue$1(newValue[fieldIndex]) : getValue$1(newValue);
          var parsedValue = parse(inputValue, path, field); // If path has locale token [locale] (component-collection-localised) then we must first replace it with correct token

          if (hasLocaleToken(path)) {
            var currentLocaleFieldName = replaceLocaleToken(path, contextParams.locale);
            var currentLocaleValue = dotNotationGet(form.values, currentLocaleFieldName);
            parsedValue = parse(inputValue, currentLocaleFieldName, field); // If the path doesn't exist it means that there is no config for path for current locale. It means we must create it!

            if (currentLocaleValue === undefined) {
              var fallbackLocale = getFallbackLocaleForLocale(contextParams.locale, locales);
              var fieldNameSegments = path.split(".");
              var localeTokenIndex = fieldNameSegments.indexOf("[locale]");
              var localisedConfigPath = [].concat(_toConsumableArray$2(fieldNameSegments.slice(0, localeTokenIndex + 1)), ["0"]).join(".");
              var fallbackLocaleFieldName = replaceLocaleToken(localisedConfigPath, fallbackLocale);
              var localeConfigPath = replaceLocaleToken(localisedConfigPath, contextParams.locale);
              form.change(localeConfigPath, duplicateConfig(dotNotationGet(form.values, fallbackLocaleFieldName), editorContext));
            }

            path = currentLocaleFieldName;
          }

          invalidateCache(path, editorContext); // At this point we have correct fieldName and correct parsedValue after all [locale] issues solved

          /**
           * Below we're trying to see whether there is a custom change function for specific EditableComponent
           */

          var split = path.split(".");
          var propName = last(split); // TODO: here we can have either a component or component field. parsePath should take this into account!

          var componentPath = split.slice(0, split.length - 1).join(".");

          var _parsePath2 = parsePath(componentPath, editorContext.form),
              templateId = _parsePath2.templateId;

          var parentDefinition = findComponentDefinitionById(templateId, editorContext);
          var config = dotNotationGet(editorContext.form.values, componentPath);

          if (parentDefinition && parentDefinition.change) {
            var values = {};
            var closestDefinedValues = {};
            parentDefinition.schema.forEach(function (schemaProp) {
              var val = config[schemaProp.prop];
              values[schemaProp.prop] = isTrulyResponsiveValue(val) ? val[editorContext.breakpointIndex] : val;
              /**
               * IMPORTANT!!! Using responsiveValueGetClosestDefinedValue here is a total simplification. It can lead to bugs in the future, good thing it's only used in TwoCards, which are used in full screen mode.
               * This should be fixed.
               * Same applies
               */

              closestDefinedValues[schemaProp.prop] = responsiveValueGetDefinedValue(val, editorContext.breakpointIndex, editorContext.devices, getDevicesWidths(editorContext.devices));
            });
            var result = parentDefinition.change({
              value: isTrulyResponsiveValue(parsedValue) ? parsedValue[editorContext.breakpointIndex] : parsedValue,
              closestDefinedValue: responsiveValueGetDefinedValue(
              /** IMPORTANT!!! See warning above */
              parsedValue, editorContext.breakpointIndex, editorContext.devices, getDevicesWidths(editorContext.devices)),
              fieldName: propName,
              values: values,
              closestDefinedValues: closestDefinedValues
            });
            parentDefinition.schema.forEach(function (schemaProp) {
              if (!result.hasOwnProperty(schemaProp.prop)) {
                return;
              }

              var pathPrefix = "".concat(componentPath, ".").concat(schemaProp.prop);

              if (pathPrefix[0] === ".") {
                pathPrefix = pathPrefix.substring(1);
              }

              if (isTrulyResponsiveValue(config[schemaProp.prop])) {
                form.change("".concat(pathPrefix, ".").concat(editorContext.breakpointIndex), result[schemaProp.prop]);
              } else {
                form.change("".concat(pathPrefix), result[schemaProp.prop]);
              }
            });
          } else {
            form.change(path, parsedValue);
          }
        });
      });
    },
    getValue: function getValue() {
      var fieldValues = normalizedFieldName.map(function (fieldName) {
        var propName = last(fieldName.split("."));

        if (propName.startsWith("$")) {
          return field.schemaProp.defaultValue;
        }

        if (hasLocaleToken(fieldName)) {
          var resolvedFieldName = replaceLocaleToken(fieldName, editorContext.contextParams.locale);
          var fieldValue = dotNotationGet(form.values, resolvedFieldName);

          if (fieldValue) {
            return fieldValue;
          }

          var fallbackLocale = getFallbackLocaleForLocale(editorContext.contextParams.locale, editorContext.locales);
          var resolvedFieldFallbackName = replaceLocaleToken(fieldName, fallbackLocale);
          var fieldFallbackValue = dotNotationGet(form.values, resolvedFieldFallbackName);
          return fieldFallbackValue;
        }

        return dotNotationGet(form.values, fieldName);
      });
      var uniqueFieldValues = getUniqueValues(fieldValues, function (fieldValue) {
        var _getSchemaDefinition = getSchemaDefinition(field.schemaProp, editorContext),
            getHash = _getSchemaDefinition.getHash;

        return getHash( // @ts-expect-error Discriminated union of all schema prop definitions produces `never`, but we can safely ignore it for now.
        fieldValue, editorContext.breakpointIndex, editorContext.devices);
      });

      if (uniqueFieldValues.length > 1) {
        return {
          __mixed__: true
        };
      }

      return format(uniqueFieldValues[0], normalizedFieldName[0], field);
    }
  };
}

function hasLocaleToken(configPath) {
  return configPath.includes("[locale]");
}

function replaceLocaleToken(configPath, locale) {
  var localisedFieldName = configPath.replace("[locale]", locale);
  return localisedFieldName;
}

function getValue$1(eventOrValue) {
  // Event of course has more properties or methods, but for this case
  // checking only for `currentTarget` is sufficient
  var isEventObject = typeof eventOrValue === "object" && eventOrValue !== null && "currentTarget" in eventOrValue;

  if (isEventObject) {
    if ("checked" in eventOrValue.currentTarget && eventOrValue.currentTarget.type === "checkbox") {
      return eventOrValue.currentTarget.checked;
    }

    return eventOrValue.currentTarget.value;
  } else {
    return eventOrValue;
  }
}

// $richText and $richTextPart uses a lot of portals to display correct fields within sidebar
// Changing value through portal won't trigger the recompilation of component using that portal.
// When we change any $richText related component we remove cache for that component (if it is $richText)
// and for all of its ancestors.
var richTextCacheInvalidator = function richTextCacheInvalidator(cache, changedPath, context) {
  var cacheKeysToRemove = [];

  var _parsePath3 = parsePath(changedPath, context.form),
      templateId = _parsePath3.templateId,
      fieldName = _parsePath3.fieldName,
      parent = _parsePath3.parent;

  var isRichTextOrRichTextAncestorComponent = templateId.startsWith("$richText") || (parent === null || parent === void 0 ? void 0 : parent.templateId.startsWith("$richText"));

  if (isRichTextOrRichTextAncestorComponent) {
    var richTextPath = templateId === "$richText" && fieldName ? changedPath.replace(".".concat(fieldName), "") : findPathOfFirstAncestorOfType(changedPath, "$richText", context.form);
    var richTextConfig = dotNotationGet(context.form.values, richTextPath);
    traverseComponents(richTextConfig, context, function (_ref2) {
      var componentConfig = _ref2.componentConfig;

      if (componentConfig && componentConfig._template.startsWith("$richText")) {
        cacheKeysToRemove.push(componentConfig._id);
      }
    });
  }

  return cacheKeysToRemove;
}; // $SectionWrapper holds the hide prop, but the $RootSections component is responsible for showing/hiding sections
// This is done during the compilation of $RootSections so we have to make sure that it's compiled when $SectionWrapper changes.


var sectionWrapperCacheInvalidator = function sectionWrapperCacheInvalidator(_, changedPath, context) {
  var cacheKeysToRemove = [];

  var _parsePath4 = parsePath(changedPath, context.form),
      parent = _parsePath4.parent;

  if (parent && parent.templateId === "$RootSections") {
    var rootSectionsConfig = dotNotationGet(context.form.values, parent.path);
    cacheKeysToRemove.push(rootSectionsConfig._id);
  }

  return cacheKeysToRemove;
};

var cacheInvalidators = [richTextCacheInvalidator, sectionWrapperCacheInvalidator];

function invalidateCache(changedPath, context) {
  var cacheKeysToRemove = new Set(cacheInvalidators.flatMap(function (invalidator) {
    return invalidator(context.compilationCache, changedPath, context);
  }));
  cacheKeysToRemove.forEach(function (cacheKey) {
    context.compilationCache.remove(cacheKey);
  });
}

var EditorContext = /*#__PURE__*/React.createContext(null);
function useEditorContext() {
  var context = react.exports.useContext(EditorContext);

  if (!context) {
    throw new Error("EditorContext not defined");
  }

  return context;
}

var __jsx$I = react.exports.createElement;

function shouldFieldBeDisplayed(form, field) {
  if (field.component === null) return false;

  if (Array.isArray(field.name)) {
    return true;
  }

  if (field.hidden) {
    return false;
  }

  return true;
}

function FieldBuilder(_ref) {
  var _field$format, _field$parse;

  var form = _ref.form,
      field = _ref.field,
      noWrap = _ref.noWrap,
      isLabelHidden = _ref.isLabelHidden;
  var cms = useCMS();
  var editorContext = useEditorContext();

  if (!shouldFieldBeDisplayed(form, field)) {
    return null;
  }

  var plugin = cms.plugins.findOrCreateMap("field").find(field.component);

  var _createFieldControlle = createFieldController({
    field: field,
    editorContext: editorContext,
    format: (_field$format = field.format) !== null && _field$format !== void 0 ? _field$format : plugin === null || plugin === void 0 ? void 0 : plugin.format,
    parse: (_field$parse = field.parse) !== null && _field$parse !== void 0 ? _field$parse : plugin === null || plugin === void 0 ? void 0 : plugin.parse
  }),
      onChange = _createFieldControlle.onChange,
      getValue = _createFieldControlle.getValue;

  if (plugin) {
    return __jsx$I(plugin.Component, {
      // Let's talk about this code
      // This branch of code is created to display single input and label that handles multiple inputs under the hood
      // To make this work, we had to skip usage of `Field` from `Final Form` because it requires a single field object with single name
      // Moreover, since we don't use `Field` anymore we have to pretend that it still exists to make fields works as it was there.
      // In the future, this code should become a part of new component (ex. FieldWrapper)
      // and new controller should be introduced (ex. fieldWrapperController) to have single source of truth about behaviour of responsive field.
      input: {
        value: getValue(),
        onChange: onChange
      } // MetaFieldWrapper accesses `error` property of this object, it's needed to prevent runtime error
      ,
      meta: {},
      tinaForm: form,
      form: form.finalForm,
      field: field,
      noWrap: noWrap,
      isLabelHidden: isLabelHidden
    });
  }

  if (typeof field.component !== "string" && field.component !== null) {
    return __jsx$I(field.component, {
      input: {
        value: getValue(),
        onChange: onChange
      },
      meta: {},
      tinaForm: form,
      form: form.finalForm,
      field: field,
      noWrap: noWrap,
      isLabelHidden: isLabelHidden
    });
  }

  return __jsx$I("p", null, "Unrecognized field type");
}
function FieldsBuilder(_ref2) {
  var form = _ref2.form,
      fields = _ref2.fields;
  var grouped = {};
  var ungrouped = [];
  fields.forEach(function (field) {
    if (!shouldFieldBeDisplayed(form, field)) {
      return;
    }

    if (field.group) {
      grouped[field.group] = grouped[field.group] || [];
      grouped[field.group].push(field);
    } else {
      if (field.component === "identity") {
        return;
      }

      ungrouped.push(field);
    }
  });

  var horizontalLine = __jsx$I(_StyledDiv$4, {
    $_css: SSColors.black10
  });

  var identityField = fields.find(function (field) {
    return field.component === "identity";
  });
  return __jsx$I(FieldsGroup, null, identityField !== undefined && __jsx$I(react.exports.Fragment, null, __jsx$I(FieldBuilder, {
    field: identityField,
    form: form
  }), horizontalLine), Object.keys(grouped).map(function (groupName) {
    return __jsx$I("div", {
      key: groupName
    }, __jsx$I(FieldsGroupLabel, null, groupName), grouped[groupName].map(function (field, index, fields) {
      return __jsx$I(_StyledDiv2$2, {
        key: toArray$2(field.name).join("_"),
        $_css2: index === fields.length - 1 ? "8px" : 0
      }, __jsx$I(FieldBuilder, {
        field: field,
        form: form,
        isLabelHidden: field.schemaProp.isLabelHidden
      }));
    }), horizontalLine);
  }), ungrouped.map(function (field, index, fields) {
    return __jsx$I(_StyledDiv3$2, {
      key: toArray$2(field.name).join("_"),
      $_css3: index === fields.length - 1 ? "8px" : 0
    }, __jsx$I(FieldBuilder, {
      field: field,
      form: form,
      isLabelHidden: field.schemaProp.isLabelHidden
    }));
  }), horizontalLine);
}
var FieldsGroupLabel = styled.div.withConfig({
  displayName: "fields-builder__FieldsGroupLabel",
  componentId: "sc-1l83d9z-0"
})(["display:flex;align-items:center;padding:20px 16px 10px 16px;", ";color:#000;"], SSFonts.label);
var FieldsGroup = styled.div.withConfig({
  displayName: "fields-builder__FieldsGroup",
  componentId: "sc-1l83d9z-1"
})(["position:relative;display:block;width:100%;padding:0;white-space:nowrap;overflow-x:hidden;overflow-y:auto !important;"]);

var _StyledDiv$4 = styled("div").withConfig({
  displayName: "fields-builder___StyledDiv",
  componentId: "sc-1l83d9z-2"
})(["height:1px;margin-top:-1px;background-color:", ";"], function (p) {
  return p.$_css;
});

var _StyledDiv2$2 = styled("div").withConfig({
  displayName: "fields-builder___StyledDiv2",
  componentId: "sc-1l83d9z-3"
})(["margin-bottom:", ";"], function (p) {
  return p.$_css2;
});

var _StyledDiv3$2 = styled("div").withConfig({
  displayName: "fields-builder___StyledDiv3",
  componentId: "sc-1l83d9z-4"
})(["margin-bottom:", ";"], function (p) {
  return p.$_css3;
});

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$2(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$2(subClass, superClass);
}

function _typeof$6(obj) {
  "@babel/helpers - typeof";

  return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$6(obj);
}

function _toPrimitive$4(input, hint) {
  if (_typeof$6(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof$6(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey$4(arg) {
  var key = _toPrimitive$4(arg, "string");
  return _typeof$6(key) === "symbol" ? key : String(key);
}

function _defineProperty$d(obj, key, value) {
  key = _toPropertyKey$4(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$X(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$X(Object(source), !0).forEach(function (key) {
      _defineProperty$d(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$X(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */

function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
} // Inlined version of the `symbol-observable` polyfill


var $$observable = function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */


var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */

function isPlainObject$3(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
} // Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */


function createStore$1(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error(formatProdErrorMessage(0) );
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error(formatProdErrorMessage(1) );
    }

    return enhancer(createStore$1)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error(formatProdErrorMessage(2) );
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error(formatProdErrorMessage(3) );
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error(formatProdErrorMessage(4) );
    }

    if (isDispatching) {
      throw new Error(formatProdErrorMessage(5) );
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error(formatProdErrorMessage(6) );
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject$3(action)) {
      throw new Error(formatProdErrorMessage(7) );
    }

    if (typeof action.type === 'undefined') {
      throw new Error(formatProdErrorMessage(8) );
    }

    if (isDispatching) {
      throw new Error(formatProdErrorMessage(9) );
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error(formatProdErrorMessage(10) );
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error(formatProdErrorMessage(11) );
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators$1(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error(formatProdErrorMessage(16) );
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */


function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */


function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error(formatProdErrorMessage(15) );
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2$1(_objectSpread2$1({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

var ReactReduxContext = /*#__PURE__*/React.createContext(null);

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}

// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect$2 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.exports.useLayoutEffect : react.exports.useEffect;

function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = react.exports.useMemo(function () {
    var subscription = createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = react.exports.useMemo(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect$2(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b$1 = 60103,
    c$1 = 60106,
    d$1 = 60107,
    e = 60108,
    f$1 = 60114,
    g$1 = 60109,
    h$1 = 60110,
    k$1 = 60112,
    l$1 = 60113,
    m = 60120,
    n$2 = 60115,
    p$1 = 60116,
    q$1 = 60121,
    r$2 = 60122,
    u$1 = 60117,
    v$1 = 60129,
    w$1 = 60131;

if ("function" === typeof Symbol && Symbol["for"]) {
  var x$1 = Symbol["for"];
  b$1 = x$1("react.element");
  c$1 = x$1("react.portal");
  d$1 = x$1("react.fragment");
  e = x$1("react.strict_mode");
  f$1 = x$1("react.profiler");
  g$1 = x$1("react.provider");
  h$1 = x$1("react.context");
  k$1 = x$1("react.forward_ref");
  l$1 = x$1("react.suspense");
  m = x$1("react.suspense_list");
  n$2 = x$1("react.memo");
  p$1 = x$1("react.lazy");
  q$1 = x$1("react.block");
  r$2 = x$1("react.server.block");
  u$1 = x$1("react.fundamental");
  v$1 = x$1("react.debug_trace_mode");
  w$1 = x$1("react.legacy_hidden");
}

function y$1(a) {
  if ("object" === typeof a && null !== a) {
    var t = a.$$typeof;

    switch (t) {
      case b$1:
        switch (a = a.type, a) {
          case d$1:
          case f$1:
          case e:
          case l$1:
          case m:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case h$1:
              case k$1:
              case p$1:
              case n$2:
              case g$1:
                return a;

              default:
                return t;
            }

        }

      case c$1:
        return t;
    }
  }
}

var z$1 = g$1,
    A$1 = b$1,
    B$1 = k$1,
    C = d$1,
    D$1 = p$1,
    E$1 = n$2,
    F = c$1,
    G$1 = f$1,
    H$1 = e,
    I$1 = l$1;
reactIs_production_min.ContextConsumer = h$1;
reactIs_production_min.ContextProvider = z$1;
reactIs_production_min.Element = A$1;
reactIs_production_min.ForwardRef = B$1;
reactIs_production_min.Fragment = C;
reactIs_production_min.Lazy = D$1;
reactIs_production_min.Memo = E$1;
reactIs_production_min.Portal = F;
reactIs_production_min.Profiler = G$1;
reactIs_production_min.StrictMode = H$1;
reactIs_production_min.Suspense = I$1;

reactIs_production_min.isAsyncMode = function () {
  return !1;
};

reactIs_production_min.isConcurrentMode = function () {
  return !1;
};

reactIs_production_min.isContextConsumer = function (a) {
  return y$1(a) === h$1;
};

reactIs_production_min.isContextProvider = function (a) {
  return y$1(a) === g$1;
};

reactIs_production_min.isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === b$1;
};

reactIs_production_min.isForwardRef = function (a) {
  return y$1(a) === k$1;
};

reactIs_production_min.isFragment = function (a) {
  return y$1(a) === d$1;
};

reactIs_production_min.isLazy = function (a) {
  return y$1(a) === p$1;
};

reactIs_production_min.isMemo = function (a) {
  return y$1(a) === n$2;
};

reactIs_production_min.isPortal = function (a) {
  return y$1(a) === c$1;
};

reactIs_production_min.isProfiler = function (a) {
  return y$1(a) === f$1;
};

reactIs_production_min.isStrictMode = function (a) {
  return y$1(a) === e;
};

reactIs_production_min.isSuspense = function (a) {
  return y$1(a) === l$1;
};

reactIs_production_min.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === d$1 || a === f$1 || a === v$1 || a === e || a === l$1 || a === m || a === w$1 || "object" === typeof a && null !== a && (a.$$typeof === p$1 || a.$$typeof === n$2 || a.$$typeof === g$1 || a.$$typeof === h$1 || a.$$typeof === k$1 || a.$$typeof === u$1 || a.$$typeof === q$1 || a[0] === r$2) ? !0 : !1;
};

reactIs_production_min.typeOf = y$1;

{
  reactIs.exports = reactIs_production_min;
}

var _excluded$7 = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2$4 = ["reactReduxForwardedRef"];

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect$2(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey;
      _ref2.withRef;
      var _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose$2(_ref2, _excluded$7);

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends$9({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? react.exports.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = react.exports.useMemo(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = _objectWithoutPropertiesLoose$2(props, _excluded2$4);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = react.exports.useMemo(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && reactIs.exports.isContextConsumer( /*#__PURE__*/React.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = react.exports.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      Boolean(contextValue) && Boolean(contextValue.store);


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = react.exports.useMemo(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = react.exports.useMemo(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = react.exports.useMemo(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends$9({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = react.exports.useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = react.exports.useRef();
      var lastWrapperProps = react.exports.useRef(wrapperProps);
      var childPropsFromStoreUpdate = react.exports.useRef();
      var renderIsScheduled = react.exports.useRef(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = react.exports.useMemo(function () {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends$9({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = react.exports.useMemo(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/React.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? /*#__PURE__*/React.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = /*#__PURE__*/React.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/React.createElement(Connect, _extends$9({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistNonReactStatics_cjs(forwarded, WrappedComponent);
    }

    return hoistNonReactStatics_cjs(Connect, WrappedComponent);
  };
}

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }
      return props;
    };

    return proxy;
  };
}

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps) : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps) : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends$9({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    _ref.displayName;
        var pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

var _excluded$6 = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose$2(_ref2, _excluded$6);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

var _excluded$5 = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose$2(_ref3, _excluded$5);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends$9({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
var connect = /*#__PURE__*/createConnect();

// with standard React renderers (ReactDOM, React Native)

setBatch(reactDom.exports.unstable_batchedUpdates);

function areInputsEqual$1(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = react.exports.useState(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var isFirstRun = react.exports.useRef(true);
  var committed = react.exports.useRef(initial);
  var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual$1(inputs, committed.current.inputs));
  var cache = useCache ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  react.exports.useEffect(function () {
    isFirstRun.current = false;
    committed.current = cache;
  }, [cache]);
  return cache.result;
}

function useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}

var useMemo = useMemoOne;
var useCallback = useCallbackOne;

var isProduction = "production" === 'production';
var prefix$2 = 'Invariant failed';

function invariant$1(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix$2);
  }

  var provided = typeof message === 'function' ? message() : message;
  var value = provided ? "".concat(prefix$2, ": ").concat(provided) : prefix$2;
  throw new Error(value);
}

var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};

var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};

var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing$1 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing$1 : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing$1 : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing$1 : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse$4 = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ? invariant$1(false) : void 0;
  return result;
};

var getWindowScroll$2 = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset$2 = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};

var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll$2();
  }

  return offset$2(original, scroll);
};

var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse$4(styles.marginTop),
    right: parse$4(styles.marginRight),
    bottom: parse$4(styles.marginBottom),
    left: parse$4(styles.marginLeft)
  };
  var padding = {
    top: parse$4(styles.paddingTop),
    right: parse$4(styles.paddingRight),
    bottom: parse$4(styles.paddingBottom),
    left: parse$4(styles.paddingLeft)
  };
  var border = {
    top: parse$4(styles.borderTopWidth),
    right: parse$4(styles.borderRightWidth),
    bottom: parse$4(styles.borderBottomWidth),
    left: parse$4(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};

var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};

var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === 'number' && value !== value;
};

function isEqual$2(first, second) {
  if (first === second) {
    return true;
  }

  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }

  return false;
}

function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual$2(newInputs[i], lastInputs[i])) {
      return false;
    }
  }

  return true;
}

function memoizeOne(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  function memoized() {
    var newArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }

  return memoized;
}

var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

var rafSchd$1 = rafSchd;

function log$1(type, message) {

  {
    return;
  }
}

log$1.bind(null, 'warn');
log$1.bind(null, 'error');

function noop$2() {}

function getOptions(shared, fromBinding) {
  return _extends$9({}, shared, {}, fromBinding);
}

function bindEvents(el, bindings, sharedOptions) {
  var unbindings = bindings.map(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
    return function unbind() {
      el.removeEventListener(binding.eventName, binding.fn, options);
    };
  });
  return function unbindAll() {
    unbindings.forEach(function (unbind) {
      unbind();
    });
  };
}
var prefix = 'Invariant failed';

function RbdInvariant(message) {
  this.message = message;
}

RbdInvariant.prototype.toString = function toString() {
  return this.message;
};

function invariant(condition, message) {
  if (condition) {
    return;
  }

  {
    throw new RbdInvariant(prefix);
  }
}

var ErrorBoundary = function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.callbacks = null;
    _this.unbind = noop$2;

    _this.onWindowError = function (event) {
      var callbacks = _this.getCallbacks();

      if (callbacks.isDragging()) {
        callbacks.tryAbort();
      }

      var err = event.error;

      if (err instanceof RbdInvariant) {
        event.preventDefault();
      }
    };

    _this.getCallbacks = function () {
      if (!_this.callbacks) {
        throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
      }

      return _this.callbacks;
    };

    _this.setCallbacks = function (callbacks) {
      _this.callbacks = callbacks;
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.unbind = bindEvents(window, [{
      eventName: 'error',
      fn: this.onWindowError
    }]);
  };

  _proto.componentDidCatch = function componentDidCatch(err) {
    if (err instanceof RbdInvariant) {

      this.setState({});
      return;
    }

    throw err;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unbind();
  };

  _proto.render = function render() {
    return this.props.children(this.setCallbacks);
  };

  return ErrorBoundary;
}(React.Component);

var dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + "\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  dragHandleUsageInstructions: dragHandleUsageInstructions,
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};
var origin = {
  x: 0,
  y: 0
};

var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};

var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};

var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};

var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};

var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};

var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};

var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};

var apply$1 = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = function executeClip(frame, subject) {
  var result = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
};

var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};

var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};

var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return _extends$9({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return getRect(target);
};

var getSubject = function getSubject(_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
};

var scrollDroppable = function scrollDroppable(droppable, newScroll) {
  !droppable.frame ? invariant(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = _extends$9({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = _extends$9({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
};

function values(map) {
  if (Object.values) {
    return Object.values(map);
  }

  return Object.keys(map).map(function (key) {
    return map[key];
  });
}

function findIndex(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}

function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}

function toArray$1(list) {
  return Array.prototype.slice.call(list);
}

var toDroppableMap = memoizeOne(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = memoizeOne(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = memoizeOne(function (droppables) {
  return values(droppables);
});
var toDraggableList = memoizeOne(function (draggables) {
  return values(draggables);
});
var getDraggablesInsideDroppable = memoizeOne(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

function tryGetDestination(impact) {
  if (impact.at && impact.at.type === 'REORDER') {
    return impact.at.destination;
  }

  return null;
}

function tryGetCombine(impact) {
  if (impact.at && impact.at.type === 'COMBINE') {
    return impact.at.combine;
  }

  return null;
}

var removeDraggableFromList = memoizeOne(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var moveToNextCombine = function moveToNextCombine(_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var location = tryGetDestination(previousImpact);

  if (!location) {
    return null;
  }

  function getImpact(target) {
    var at = {
      type: 'COMBINE',
      combine: {
        draggableId: target,
        droppableId: destination.descriptor.id
      }
    };
    return _extends$9({}, previousImpact, {
      at: at
    });
  }

  var all = previousImpact.displaced.all;
  var closestId = all.length ? all[0] : null;

  if (isMovingForward) {
    return closestId ? getImpact(closestId) : null;
  }

  var withoutDraggable = removeDraggableFromList(draggable, insideDestination);

  if (!closestId) {
    if (!withoutDraggable.length) {
      return null;
    }

    var last = withoutDraggable[withoutDraggable.length - 1];
    return getImpact(last.descriptor.id);
  }

  var indexOfClosest = findIndex(withoutDraggable, function (d) {
    return d.descriptor.id === closestId;
  });
  !(indexOfClosest !== -1) ? invariant(false) : void 0;
  var proposedIndex = indexOfClosest - 1;

  if (proposedIndex < 0) {
    return null;
  }

  var before = withoutDraggable[proposedIndex];
  return getImpact(before.descriptor.id);
};

var isHomeOf = function isHomeOf(draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
};

var noDisplacedBy = {
  point: origin,
  value: 0
};
var emptyGroups = {
  invisible: {},
  visible: {},
  all: []
};
var noImpact = {
  displaced: emptyGroups,
  displacedBy: noDisplacedBy,
  at: null
};

var isWithin = function isWithin(lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
};

var isPartiallyVisibleThroughFrame = function isPartiallyVisibleThroughFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
};

var isTotallyVisibleThroughFrame = function isTotallyVisibleThroughFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
};

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isTotallyVisibleThroughFrameOnAxis = function isTotallyVisibleThroughFrameOnAxis(axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
};

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible(_extends$9({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};

var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible(_extends$9({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};

var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible(_extends$9({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!last) {
    return true;
  }

  var invisible = last.invisible,
      visible = last.visible;

  if (invisible[id]) {
    return false;
  }

  var previous = visible[id];
  return previous ? previous.shouldAnimate : true;
};

function getTarget(draggable, displacedBy) {
  var marginBox = draggable.page.marginBox;
  var expandBy = {
    top: displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: displacedBy.point.x
  };
  return getRect(expand(marginBox, expandBy));
}

function getDisplacementGroups(_ref) {
  var afterDragging = _ref.afterDragging,
      destination = _ref.destination,
      displacedBy = _ref.displacedBy,
      viewport = _ref.viewport,
      forceShouldAnimate = _ref.forceShouldAnimate,
      last = _ref.last;
  return afterDragging.reduce(function process(groups, draggable) {
    var target = getTarget(draggable, displacedBy);
    var id = draggable.descriptor.id;
    groups.all.push(id);
    var isVisible = isPartiallyVisible({
      target: target,
      destination: destination,
      viewport: viewport,
      withDroppableDisplacement: true
    });

    if (!isVisible) {
      groups.invisible[draggable.descriptor.id] = true;
      return groups;
    }

    var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
    var displacement = {
      draggableId: id,
      shouldAnimate: shouldAnimate
    };
    groups.visible[id] = displacement;
    return groups;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}

function getIndexOfLastItem(draggables, options) {
  if (!draggables.length) {
    return 0;
  }

  var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}

function goAtEnd(_ref) {
  var insideDestination = _ref.insideDestination,
      inHomeList = _ref.inHomeList,
      displacedBy = _ref.displacedBy,
      destination = _ref.destination;
  var newIndex = getIndexOfLastItem(insideDestination, {
    inHomeList: inHomeList
  });
  return {
    displaced: emptyGroups,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: newIndex
      }
    }
  };
}

function calculateReorderImpact(_ref2) {
  var draggable = _ref2.draggable,
      insideDestination = _ref2.insideDestination,
      destination = _ref2.destination,
      viewport = _ref2.viewport,
      displacedBy = _ref2.displacedBy,
      last = _ref2.last,
      index = _ref2.index,
      forceShouldAnimate = _ref2.forceShouldAnimate;
  var inHomeList = isHomeOf(draggable, destination);

  if (index == null) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var match = find(insideDestination, function (item) {
    return item.descriptor.index === index;
  });

  if (!match) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var sliceFrom = insideDestination.indexOf(match);
  var impacted = withoutDragging.slice(sliceFrom);
  var displaced = getDisplacementGroups({
    afterDragging: impacted,
    destination: destination,
    displacedBy: displacedBy,
    last: last,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate
  });
  return {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: index
      }
    }
  };
}

function didStartAfterCritical(draggableId, afterCritical) {
  return Boolean(afterCritical.effected[draggableId]);
}

var fromCombine = function fromCombine(_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      draggables = _ref.draggables,
      combine = _ref.combine,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var combineId = combine.draggableId;
  var combineWith = draggables[combineId];
  var combineWithIndex = combineWith.descriptor.index;
  var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);

  if (didCombineWithStartAfterCritical) {
    if (isMovingForward) {
      return combineWithIndex;
    }

    return combineWithIndex - 1;
  }

  if (isMovingForward) {
    return combineWithIndex + 1;
  }

  return combineWithIndex;
};

var fromReorder = function fromReorder(_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      insideDestination = _ref.insideDestination,
      location = _ref.location;

  if (!insideDestination.length) {
    return null;
  }

  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var firstIndex = insideDestination[0].descriptor.index;
  var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
  var upperBound = isInHomeList ? lastIndex : lastIndex + 1;

  if (proposedIndex < firstIndex) {
    return null;
  }

  if (proposedIndex > upperBound) {
    return null;
  }

  return proposedIndex;
};

var moveToNextIndex = function moveToNextIndex(_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var wasAt = previousImpact.at;
  !wasAt ? invariant(false) : void 0;

  if (wasAt.type === 'REORDER') {
    var _newIndex = fromReorder({
      isMovingForward: isMovingForward,
      isInHomeList: isInHomeList,
      location: wasAt.destination,
      insideDestination: insideDestination
    });

    if (_newIndex == null) {
      return null;
    }

    return calculateReorderImpact({
      draggable: draggable,
      insideDestination: insideDestination,
      destination: destination,
      viewport: viewport,
      last: previousImpact.displaced,
      displacedBy: previousImpact.displacedBy,
      index: _newIndex
    });
  }

  var newIndex = fromCombine({
    isMovingForward: isMovingForward,
    destination: destination,
    displaced: previousImpact.displaced,
    draggables: draggables,
    combine: wasAt.combine,
    afterCritical: afterCritical
  });

  if (newIndex == null) {
    return null;
  }

  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: previousImpact.displaced,
    displacedBy: previousImpact.displacedBy,
    index: newIndex
  });
};

var getCombinedItemDisplacement = function getCombinedItemDisplacement(_ref) {
  var displaced = _ref.displaced,
      afterCritical = _ref.afterCritical,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);

  if (didStartAfterCritical(combineWith, afterCritical)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
};

var whenCombining = function whenCombining(_ref) {
  var afterCritical = _ref.afterCritical,
      impact = _ref.impact,
      draggables = _ref.draggables;
  var combine = tryGetCombine(impact);
  !combine ? invariant(false) : void 0;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: impact.displaced,
    afterCritical: afterCritical,
    combineWith: combineWith,
    displacedBy: impact.displacedBy
  });
  return add(center, displaceBy);
};

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};

var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};

var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = function whenReordering(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      afterCritical = _ref.afterCritical;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = impact.displaced,
      displacedBy = impact.displacedBy;
  var closestAfter = displaced.all[0];

  if (closestAfter) {
    var closest = draggables[closestAfter];

    if (didStartAfterCritical(closestAfter, afterCritical)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closest.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = offset$2(closest.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
    var page = offset$2(last.page, negate(afterCritical.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
};

var withDroppableDisplacement = function withDroppableDisplacement(droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
};

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      afterCritical = _ref.afterCritical;
  var original = draggable.page.borderBox.center;
  var at = impact.at;

  if (!droppable) {
    return original;
  }

  if (!at) {
    return original;
  }

  if (at.type === 'REORDER') {
    return whenReordering({
      impact: impact,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      afterCritical: afterCritical
    });
  }

  return whenCombining({
    impact: impact,
    draggables: draggables,
    afterCritical: afterCritical
  });
};

var getPageBorderBoxCenterFromImpact = function getPageBorderBoxCenterFromImpact(args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
};

var scrollViewport = function scrollViewport(viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
};

function getDraggables(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

function tryGetVisible(id, groups) {
  for (var i = 0; i < groups.length; i++) {
    var displacement = groups[i].visible[id];

    if (displacement) {
      return displacement;
    }
  }

  return null;
}

var speculativelyIncrease = function speculativelyIncrease(_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var last = impact.displaced;
  var withViewportScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: scrolledViewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var withDroppableScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: scrolledDroppable,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var invisible = {};
  var visible = {};
  var groups = [last, withViewportScroll, withDroppableScroll];
  last.all.forEach(function (id) {
    var displacement = tryGetVisible(id, groups);

    if (displacement) {
      visible[id] = displacement;
      return;
    }

    invisible[id] = true;
  });

  var newImpact = _extends$9({}, impact, {
    displaced: {
      all: last.all,
      invisible: invisible,
      visible: visible
    }
  });

  return newImpact;
};

var withViewportDisplacement = function withViewportDisplacement(viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
};

var getClientFromPageBorderBoxCenter = function getClientFromPageBorderBoxCenter(_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
};

var isTotallyVisibleInNewLocation = function isTotallyVisibleInNewLocation(_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
};

var moveToNextPlace = function moveToNextPlace(_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      afterCritical = _ref.afterCritical;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
};

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ? invariant(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = function getBestCrossAxisDroppable(_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
};

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
  var original = draggable.page.borderBox.center;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};

var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
  var original = draggable.page.borderBox;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};

var getClosestDraggable = function getClosestDraggable(_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, afterCritical),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
};

var getDisplacedBy = memoizeOne(function getDisplacedBy(axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;

  if (droppable.descriptor.mode === 'virtual') {
    return patch(axis.line, placeholderSize[axis.line]);
  }

  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return _extends$9({}, frame, {
    scroll: _extends$9({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ? invariant(false) : void 0;
  !!droppable.subject.withPlaceholder ? invariant(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return _extends$9({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return _extends$9({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ? invariant(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return _extends$9({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ? invariant(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return _extends$9({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var moveToNewDroppable = function moveToNewDroppable(_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      displaced: emptyGroups,
      displacedBy: noDisplacedBy,
      at: {
        type: 'REORDER',
        destination: {
          droppableId: destination.descriptor.id,
          index: 0
        }
      }
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      afterCritical: afterCritical
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);

  var proposedIndex = function () {
    var relativeTo = moveRelativeTo.descriptor.index;

    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return relativeTo;
    }

    if (isGoingBeforeTarget) {
      return relativeTo;
    }

    return relativeTo + 1;
  }();

  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    displacedBy: displacedBy,
    last: emptyGroups,
    index: proposedIndex
  });
};

var moveCrossAxis = function moveCrossAxis(_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
};

var whatIsDraggedOver = function whatIsDraggedOver(impact) {
  var at = impact.at;

  if (!at) {
    return null;
  }

  if (at.type === 'REORDER') {
    return at.destination.droppableId;
  }

  return at.combine.droppableId;
};

var getDroppableOver = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = function moveInDirection(_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    afterCritical: state.afterCritical
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    viewport: state.viewport,
    afterCritical: state.afterCritical
  });
};

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

function isPositionInFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function run(point) {
    return isWithinVertical(point.y) && isWithinHorizontal(point.x);
  };
}

function getHasOverlap(first, second) {
  return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}

function getFurthestAway(_ref) {
  var pageBorderBox = _ref.pageBorderBox,
      draggable = _ref.draggable,
      candidates = _ref.candidates;
  var startCenter = draggable.page.borderBox.center;
  var sorted = candidates.map(function (candidate) {
    var axis = candidate.axis;
    var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
    return {
      id: candidate.descriptor.id,
      distance: distance(startCenter, target)
    };
  }).sort(function (a, b) {
    return b.distance - a.distance;
  });
  return sorted[0] ? sorted[0].id : null;
}

function getDroppableOver$1(_ref2) {
  var pageBorderBox = _ref2.pageBorderBox,
      draggable = _ref2.draggable,
      droppables = _ref2.droppables;
  var candidates = toDroppableList(droppables).filter(function (item) {
    if (!item.isEnabled) {
      return false;
    }

    var active = item.subject.active;

    if (!active) {
      return false;
    }

    if (!getHasOverlap(pageBorderBox, active)) {
      return false;
    }

    if (isPositionInFrame(active)(pageBorderBox.center)) {
      return true;
    }

    var axis = item.axis;
    var childCenter = active.center[axis.crossAxisLine];
    var crossAxisStart = pageBorderBox[axis.crossAxisStart];
    var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
    var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
    var isStartContained = isContained(crossAxisStart);
    var isEndContained = isContained(crossAxisEnd);

    if (!isStartContained && !isEndContained) {
      return true;
    }

    if (isStartContained) {
      return crossAxisStart < childCenter;
    }

    return crossAxisEnd > childCenter;
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0].descriptor.id;
  }

  return getFurthestAway({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    candidates: candidates
  });
}

var offsetRectByPosition = function offsetRectByPosition(rect, point) {
  return getRect(offsetByPosition(rect, point));
};

var withDroppableScroll = function withDroppableScroll(droppable, area) {
  var frame = droppable.frame;

  if (!frame) {
    return area;
  }

  return offsetRectByPosition(area, frame.scroll.diff.value);
};

function getIsDisplaced(_ref) {
  var displaced = _ref.displaced,
      id = _ref.id;
  return Boolean(displaced.visible[id] || displaced.invisible[id]);
}

function atIndex(_ref) {
  var draggable = _ref.draggable,
      closest = _ref.closest,
      inHomeList = _ref.inHomeList;

  if (!closest) {
    return null;
  }

  if (!inHomeList) {
    return closest.descriptor.index;
  }

  if (closest.descriptor.index > draggable.descriptor.index) {
    return closest.descriptor.index - 1;
  }

  return closest.descriptor.index;
}

var getReorderImpact = function getReorderImpact(_ref2) {
  var targetRect = _ref2.pageBorderBoxWithDroppableScroll,
      draggable = _ref2.draggable,
      destination = _ref2.destination,
      insideDestination = _ref2.insideDestination,
      last = _ref2.last,
      viewport = _ref2.viewport,
      afterCritical = _ref2.afterCritical;
  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var closest = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childCenter = child.page.borderBox.center[axis.line];
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: last,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd <= childCenter;
      }

      return targetStart < childCenter - displacement;
    }

    if (isDisplaced) {
      return targetEnd <= childCenter + displacement;
    }

    return targetStart < childCenter;
  });
  var newIndex = atIndex({
    draggable: draggable,
    closest: closest,
    inHomeList: isHomeOf(draggable, destination)
  });
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: last,
    displacedBy: displacedBy,
    index: newIndex
  });
};

var combineThresholdDivisor = 4;

var getCombineImpact = function getCombineImpact(_ref) {
  var draggable = _ref.draggable,
      targetRect = _ref.pageBorderBoxWithDroppableScroll,
      previousImpact = _ref.previousImpact,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var combineWith = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childRect = child.page.borderBox;
    var childSize = childRect[axis.size];
    var threshold = childSize / combineThresholdDivisor;
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: previousImpact.displaced,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
      }

      return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
    }

    if (isDisplaced) {
      return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
    }

    return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
  });

  if (!combineWith) {
    return null;
  }

  var impact = {
    displacedBy: displacedBy,
    displaced: previousImpact.displaced,
    at: {
      type: 'COMBINE',
      combine: {
        draggableId: combineWith.descriptor.id,
        droppableId: destination.descriptor.id
      }
    }
  };
  return impact;
};

var getDragImpact = function getDragImpact(_ref) {
  var pageOffset = _ref.pageOffset,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
  var destinationId = getDroppableOver$1({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
  return getCombineImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    previousImpact: previousImpact,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  }) || getReorderImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    last: previousImpact.displaced,
    viewport: viewport,
    afterCritical: afterCritical
  });
};

var patchDroppableMap = function patchDroppableMap(droppables, updated) {
  var _extends2;

  return _extends$9({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = function recomputePlaceholders(_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
};

var update = function update(_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, viewport.scroll.current),
    borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
    offset: add(client.offset, viewport.scroll.diff.value)
  };
  var current = {
    client: client,
    page: page
  };

  if (state.phase === 'COLLECTING') {
    return _extends$9({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageOffset: page.offset,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = _extends$9({}, state, {
    current: current,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
};

function getDraggables$1(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

var recompute = function recompute(_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      destination = _ref.destination,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var last = impact.displaced;
  var afterDragging = getDraggables$1(last.all, draggables);
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate,
    last: last
  });
  return _extends$9({}, impact, {
    displaced: displaced
  });
};

var getClientBorderBoxCenter = function getClientBorderBoxCenter(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    afterCritical: afterCritical
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
};

var refreshSnap = function refreshSnap(_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ? invariant(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ? invariant(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  return update({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
};

var getHomeLocation = function getHomeLocation(descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
};

var getLiftEffect = function getLiftEffect(_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var rawIndex = insideHome.indexOf(draggable);
  !(rawIndex !== -1) ? invariant(false) : void 0;
  var afterDragging = insideHome.slice(rawIndex + 1);
  var effected = afterDragging.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var afterCritical = {
    inVirtualList: home.descriptor.mode === 'virtual',
    displacedBy: displacedBy,
    effected: effected
  };
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: home,
    displacedBy: displacedBy,
    last: null,
    viewport: viewport.frame,
    forceShouldAnimate: false
  });
  var impact = {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: getHomeLocation(draggable.descriptor)
    }
  };
  return {
    impact: impact,
    afterCritical: afterCritical
  };
};

var patchDimensionMap = function patchDimensionMap(dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
};

var offsetDraggable = function offsetDraggable(_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = offset$2(draggable.client, offset$1);
  var page = withScroll(client, initialWindowScroll);

  var moved = _extends$9({}, draggable, {
    placeholder: _extends$9({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
};

var getFrame = function getFrame(droppable) {
  var frame = droppable.frame;
  !frame ? invariant(false) : void 0;
  return frame;
};

var adjustAdditionsForScrollChanges = function adjustAdditionsForScrollChanges(_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = getFrame(modified);
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
};

var publishWhileDraggingInVirtual = function publishWhileDraggingInVirtual(_ref) {
  var state = _ref.state,
      published = _ref.published;
  var withScrollChange = published.modified.map(function (update) {
    var existing = state.dimensions.droppables[update.droppableId];
    var scrolled = scrollDroppable(existing, update.scroll);
    return scrolled;
  });

  var droppables = _extends$9({}, state.dimensions.droppables, {}, toDroppableMap(withScrollChange));

  var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
    additions: published.additions,
    updatedDroppables: droppables,
    viewport: state.viewport
  }));

  var draggables = _extends$9({}, state.dimensions.draggables, {}, updatedAdditions);

  published.removals.forEach(function (id) {
    delete draggables[id];
  });
  var dimensions = {
    droppables: droppables,
    draggables: draggables
  };
  var wasOverId = whatIsDraggedOver(state.impact);
  var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
  var draggable = dimensions.draggables[state.critical.draggable.id];
  var home = dimensions.droppables[state.critical.droppable.id];

  var _getLiftEffect = getLiftEffect({
    draggable: draggable,
    home: home,
    draggables: draggables,
    viewport: state.viewport
  }),
      onLiftImpact = _getLiftEffect.impact,
      afterCritical = _getLiftEffect.afterCritical;

  var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
  var impact = getDragImpact({
    pageOffset: state.current.page.offset,
    draggable: dimensions.draggables[state.critical.draggable.id],
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: previousImpact,
    viewport: state.viewport,
    afterCritical: afterCritical
  });

  var draggingState = _extends$9({
    phase: 'DRAGGING'
  }, state, {
    phase: 'DRAGGING',
    impact: impact,
    onLiftImpact: onLiftImpact,
    dimensions: dimensions,
    afterCritical: afterCritical,
    forceShouldAnimate: false
  });

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = _extends$9({
    phase: 'DROP_PENDING'
  }, draggingState, {
    phase: 'DROP_PENDING',
    reason: state.reason,
    isWaiting: false
  });

  return dropPending;
};

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

function removeScrollJumpRequest(state) {
  if (state.isDragging && state.movementMode === 'SNAP') {
    return _extends$9({
      phase: 'DRAGGING'
    }, state, {
      scrollJumpRequest: null
    });
  }

  return state;
}

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};

var reducer$1 = function reducer(state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'FLUSH') {
    return _extends$9({}, idle, {
      shouldFlush: true
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ? invariant(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial),
        offset: add(client.selection, viewport.scroll.diff.value)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getLiftEffect = getLiftEffect({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getLiftEffect.impact,
        afterCritical = _getLiftEffect.afterCritical;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      afterCritical: afterCritical,
      onLiftImpact: impact,
      viewport: viewport,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? invariant(false) : void 0;

    var _result = _extends$9({
      phase: 'COLLECTING'
    }, state, {
      phase: 'COLLECTING'
    });

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ? invariant(false) : void 0;
    return publishWhileDraggingInVirtual({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? invariant(false) : void 0;
    var _clientSelection = action.payload.client;

    if (isEqual(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return removeScrollJumpRequest(state);
    }

    if (state.phase === 'COLLECTING') {
      return removeScrollJumpRequest(state);
    }

    !isMovementAllowed(state) ? invariant(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        newScroll = _action$payload2.newScroll;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, newScroll);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? invariant(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ? invariant(false) : void 0;
    !(_target.isEnabled !== isEnabled) ? invariant(false) : void 0;

    var updated = _extends$9({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? invariant(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ? invariant(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ? invariant(false) : void 0;

    var _updated = _extends$9({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ? invariant(false) : void 0;
    !state.isWindowScrollAllowed ? invariant(false) : void 0;
    var _newScroll = action.payload.newScroll;

    if (isEqual(state.viewport.scroll.current, _newScroll)) {
      return removeScrollJumpRequest(state);
    }

    var _viewport = scrollViewport(state.viewport, _newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (isEqual(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = _extends$9({}, state.viewport, {
      scroll: _extends$9({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return _extends$9({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? invariant(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ? invariant(false) : void 0;

    var newState = _extends$9({
      phase: 'DROP_PENDING'
    }, state, {
      phase: 'DROP_PENDING',
      isWaiting: true,
      reason: reason
    });

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? invariant(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset,
      dimensions: state.dimensions
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _completed = action.payload.completed;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: false
    };
  }

  return state;
};

var beforeInitialCapture = function beforeInitialCapture(args) {
  return {
    type: 'BEFORE_INITIAL_CAPTURE',
    payload: args
  };
};

var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};

var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};

var publishWhileDragging = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};

var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};

var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};

var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};

var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};

var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};

var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};

var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};

var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};

var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};

var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};

var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};

var flush = function flush() {
  return {
    type: 'FLUSH',
    payload: null
  };
};

var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};

var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};

var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};

var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};

var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

var lift$1 = function lift$1(marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed
          }));
        }

        !(getState().phase === 'IDLE') ? invariant(false) : void 0;
        dispatch(flush());
        dispatch(beforeInitialCapture({
          draggableId: id,
          movementMode: movementMode
        }));
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;
        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
};

var style = function style(marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
};

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine$1 = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine$1.scale.drop + ")";
  }
};
var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;

var getDropDuration = function getDropDuration(_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
};

var getNewHomeClientOffset = function getNewHomeClientOffset(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    afterCritical: afterCritical,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  return offset;
};

var getDropImpact = function getDropImpact(_ref) {
  var draggables = _ref.draggables,
      reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      onLiftImpact = _ref.onLiftImpact;

  if (!lastImpact.at || reason !== 'DROP') {
    var recomputedHomeImpact = recompute({
      draggables: draggables,
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      forceShouldAnimate: true
    });
    return {
      impact: recomputedHomeImpact,
      didDropInsideDroppable: false
    };
  }

  if (lastImpact.at.type === 'REORDER') {
    return {
      impact: lastImpact,
      didDropInsideDroppable: true
    };
  }

  var withoutMovement = _extends$9({}, lastImpact, {
    displaced: emptyGroups
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: true
  };
};

var drop$1 = function drop$1(_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ? invariant(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? invariant(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var draggable = dimensions.draggables[state.critical.draggable.id];

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        afterCritical: state.afterCritical,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
      var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        afterCritical: state.afterCritical
      });
      var completed = {
        critical: state.critical,
        afterCritical: state.afterCritical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
};

var getWindowScroll$1 = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

function getWindowScrollBinding(update) {
  return {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn(event) {
      if (event.target !== window && event.target !== window.document) {
        return;
      }

      update();
    }
  };
}

function getScrollListener(_ref) {
  var onWindowScroll = _ref.onWindowScroll;

  function updateScroll() {
    onWindowScroll(getWindowScroll$1());
  }

  var scheduled = rafSchd$1(updateScroll);
  var binding = getWindowScrollBinding(scheduled);
  var unbind = noop$2;

  function isActive() {
    return unbind !== noop$2;
  }

  function start() {
    !!isActive() ? invariant(false) : void 0;
    unbind = bindEvents(window, [binding]);
  }

  function stop() {
    !isActive() ? invariant(false) : void 0;
    scheduled.cancel();
    unbind();
    unbind = noop$2;
  }

  return {
    start: start,
    stop: stop,
    isActive: isActive
  };
}

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var scrollListener = function scrollListener(store) {
  var listener = getScrollListener({
    onWindowScroll: function onWindowScroll(newScroll) {
      store.dispatch(moveByWindowScroll({
        newScroll: newScroll
      }));
    }
  });
  return function (next) {
    return function (action) {
      if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') {
        listener.start();
      }

      if (listener.isActive() && shouldEnd(action)) {
        listener.stop();
      }

      next(action);
    };
  };
};

var getExpiringAnnounce = function getExpiringAnnounce(announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
      return;
    }

    if (isExpired) {
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
};

var getAsyncMarshal = function getAsyncMarshal() {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ? invariant(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
};

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};

var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};

var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  fn();
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = function getPublisher(getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeCapture = function beforeCapture(draggableId, mode) {
    !!dragging ? invariant(false) : void 0;
    withTimings('onBeforeCapture', function () {
      var fn = getResponders().onBeforeCapture;

      if (fn) {
        var before = {
          draggableId: draggableId,
          mode: mode
        };
        fn(before);
      }
    });
  };

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ? invariant(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ? invariant(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = tryGetDestination(impact);
    var combine = tryGetCombine(impact);
    !dragging ? invariant(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = _extends$9({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ? invariant(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ? invariant(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = _extends$9({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeCapture: beforeCapture,
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
};

var responders = function responders(getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'BEFORE_INITIAL_CAPTURE') {
          publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'FLUSH') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
};

var dropAnimationFinish = function dropAnimationFinish(store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ? invariant(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed
      }));
    };
  };
};

var dropAnimationFlushOnScroll = function dropAnimationFlushOnScroll(store) {
  var unbind = null;
  var frameId = null;

  function clear() {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }

    if (unbind) {
      unbind();
      unbind = null;
    }
  }

  return function (next) {
    return function (action) {
      if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') {
        clear();
      }

      next(action);

      if (action.type !== 'DROP_ANIMATE') {
        return;
      }

      var binding = {
        eventName: 'scroll',
        options: {
          capture: true,
          passive: false,
          once: true
        },
        fn: function flushDropAnimation() {
          var state = store.getState();

          if (state.phase === 'DROP_ANIMATING') {
            store.dispatch(dropAnimationFinished());
          }
        }
      };
      frameId = requestAnimationFrame(function () {
        frameId = null;
        unbind = bindEvents(window, [binding]);
      });
    };
  };
};

var dimensionMarshalStopper = function dimensionMarshalStopper(marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
};

var focus = function focus(marshal) {
  var isWatching = false;
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          isWatching = true;
          marshal.tryRecordFocus(action.payload.critical.draggable.id);
          next(action);
          marshal.tryRestoreFocusRecorded();
          return;
        }

        next(action);

        if (!isWatching) {
          return;
        }

        if (action.type === 'FLUSH') {
          isWatching = false;
          marshal.tryRestoreFocusRecorded();
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          isWatching = false;
          var result = action.payload.completed.result;

          if (result.combine) {
            marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
          }

          marshal.tryRestoreFocusRecorded();
        }
      };
    };
  };
};

var shouldStop = function shouldStop(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var autoScroll = function autoScroll(autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldStop(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ? invariant(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
};

var pendingDrop = function pendingDrop(store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
};

var composeEnhancers = compose;

var createStore = function createStore(_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      focusMarshal = _ref.focusMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return createStore$1(reducer$1, composeEnhancers(applyMiddleware(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop, autoScroll(autoScroller), scrollListener, focus(focusMarshal), responders(getResponders, announce))));
};

var clean$1 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};

function createPublisher(_ref) {
  var registry = _ref.registry,
      callbacks = _ref.callbacks;
  var staging = clean$1();
  var frameId = null;

  var collect = function collect() {
    if (frameId) {
      return;
    }

    callbacks.collectionStarting();
    frameId = requestAnimationFrame(function () {
      frameId = null;
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;
      var added = Object.keys(additions).map(function (id) {
        return registry.draggable.getById(id).getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });
      var updated = Object.keys(modified).map(function (id) {
        var entry = registry.droppable.getById(id);
        var scroll = entry.callbacks.getScrollWhileDragging();
        return {
          droppableId: id,
          scroll: scroll
        };
      });
      var result = {
        additions: added,
        removals: Object.keys(removals),
        modified: updated
      };
      staging = clean$1();
      callbacks.publish(result);
    });
  };

  var add = function add(entry) {
    var id = entry.descriptor.id;
    staging.additions[id] = entry;
    staging.modified[entry.descriptor.droppableId] = true;

    if (staging.removals[id]) {
      delete staging.removals[id];
    }

    collect();
  };

  var remove = function remove(entry) {
    var descriptor = entry.descriptor;
    staging.removals[descriptor.id] = true;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$1();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
}

var getMaxScroll = function getMaxScroll(_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
};

var getDocumentElement$1 = function getDocumentElement() {
  var doc = document.documentElement;
  !doc ? invariant(false) : void 0;
  return doc;
};

var getMaxWindowScroll = function getMaxWindowScroll() {
  var doc = getDocumentElement$1();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
};

var getViewport = function getViewport() {
  var scroll = getWindowScroll$1();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement$1();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = getRect({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
};

var getInitialPublish = function getInitialPublish(_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      registry = _ref.registry;
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = registry.droppable.getAllByType(home.type).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
};

function shouldPublishUpdate(registry, dragging, entry) {
  if (entry.descriptor.id === dragging.id) {
    return false;
  }

  if (entry.descriptor.type !== dragging.type) {
    return false;
  }

  var home = registry.droppable.getById(entry.descriptor.droppableId);

  if (home.descriptor.mode !== 'virtual') {
    return false;
  }

  return true;
}

var createDimensionMarshal = function createDimensionMarshal(registry, callbacks) {
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting
    },
    registry: registry
  });

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !registry.droppable.exists(id) ? invariant(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ? invariant(false) : void 0;
    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ? invariant(false) : void 0;
    callbacks.updateDroppableScroll({
      id: id,
      newScroll: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    if (!collection) {
      return;
    }

    registry.droppable.getById(id).callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    registry.droppable.getAllByType(home.type).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection.unsubscribe();
    collection = null;
  };

  var subscriber = function subscriber(event) {
    !collection ? invariant(false) : void 0;
    var dragging = collection.critical.draggable;

    if (event.type === 'ADDITION') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.add(event.value);
      }
    }

    if (event.type === 'REMOVAL') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.remove(event.value);
      }
    }
  };

  var startPublishing = function startPublishing(request) {
    !!collection ? invariant(false) : void 0;
    var entry = registry.draggable.getById(request.draggableId);
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    var unsubscribe = registry.subscribe(subscriber);
    collection = {
      critical: critical,
      unsubscribe: unsubscribe
    };
    return getInitialPublish({
      critical: critical,
      registry: registry,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
};

var canStartDrag = function canStartDrag(state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
};

var scrollWindow = function scrollWindow(change) {
  window.scrollBy(change.x, change.y);
};

var getScrollableDroppables = memoizeOne(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ? invariant(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = function getBestScrollableDroppable(_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
};

var config = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = function getDistanceThresholds(container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
};

var getPercentage = function getPercentage(_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
};

var minScroll = 1;

var getValueFromDistance = function getValueFromDistance(distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
};

var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;

var dampenValueByTime = function dampenValueByTime(proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;
  var now = Date.now();
  var runTime = now - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
};

var getValue = function getValue(_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
};

var getScrollOnAxis = function getScrollOnAxis(_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
};

var adjustForSizeLimits = function adjustForSizeLimits(_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
};

var clean$2 = apply$1(function (value) {
  return value === 0 ? 0 : value;
});

var getScroll = function getScroll(_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$2({
    x: x,
    y: y
  });

  if (isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual(limited, origin) ? null : limited;
};

var smallestSigned = apply$1(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});

var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();

var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};

var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};

var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};

var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = function getWindowScrollChange(_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
};

var getDroppableScrollChange = function getDroppableScrollChange(_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
};

var scroll$1 = function scroll$1(_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
};

var createFluidScroller = function createFluidScroller(_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = rafSchd$1(scrollWindow);
  var scheduleDroppableScroll = rafSchd$1(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ? invariant(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var start$1 = function start$1(state) {
    !!dragging ? invariant(false) : void 0;
    var dragStartTime = Date.now();
    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
    dragging = null;
  };

  return {
    start: start$1,
    stop: stop,
    scroll: tryScroll
  };
};

var createJumpScroller = function createJumpScroller(_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ? invariant(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
};

var createAutoScroller = function createAutoScroller(_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
};

var prefix$1 = 'data-rbd';

var dragHandle = function () {
  var base = prefix$1 + "-drag-handle";
  return {
    base: base,
    draggableId: base + "-draggable-id",
    contextId: base + "-context-id"
  };
}();

var draggable = function () {
  var base = prefix$1 + "-draggable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();

var droppable = function () {
  var base = prefix$1 + "-droppable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();

var scrollContainer = {
  contextId: prefix$1 + "-scroll-container-context-id"
};

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';

var getStyles$1 = function getStyles$1(contextId) {
  var getSelector = makeGetSelector(contextId);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle.contextId),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable.contextId),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
};

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.exports.useLayoutEffect : react.exports.useEffect;

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ? invariant(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl(nonce) {
  var el = document.createElement('style');

  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  el.type = 'text/css';
  return el;
};

function useStyleMarshal(contextId, nonce) {
  var styles = useMemo(function () {
    return getStyles$1(contextId);
  }, [contextId]);
  var alwaysRef = react.exports.useRef(null);
  var dynamicRef = react.exports.useRef(null);
  var setDynamicStyle = useCallback(memoizeOne(function (proposed) {
    var el = dynamicRef.current;
    !el ? invariant(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = useCallback(function (proposed) {
    var el = alwaysRef.current;
    !el ? invariant(false) : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect$1(function () {
    !(!alwaysRef.current && !dynamicRef.current) ? invariant(false) : void 0;
    var always = createStyleEl(nonce);
    var dynamic = createStyleEl(nonce);
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix$1 + "-always", contextId);
    dynamic.setAttribute(prefix$1 + "-dynamic", contextId);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ? invariant(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [nonce, setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, contextId]);
  var dragging = useCallback(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = useCallback(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = useCallback(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = useMemo(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting
    };
  }, [dragging, dropping, resting]);
  return marshal;
}

var getWindowFromEl = function getWindowFromEl(el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function findDragHandle(contextId, draggableId) {
  var selector = "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
  var possible = toArray$1(document.querySelectorAll(selector));

  if (!possible.length) {
    return null;
  }

  var handle = find(possible, function (el) {
    return el.getAttribute(dragHandle.draggableId) === draggableId;
  });

  if (!handle) {
    return null;
  }

  if (!isHtmlElement(handle)) {
    return null;
  }

  return handle;
}

function useFocusMarshal(contextId) {
  var entriesRef = react.exports.useRef({});
  var recordRef = react.exports.useRef(null);
  var restoreFocusFrameRef = react.exports.useRef(null);
  var isMountedRef = react.exports.useRef(false);
  var register = useCallback(function register(id, focus) {
    var entry = {
      id: id,
      focus: focus
    };
    entriesRef.current[id] = entry;
    return function unregister() {
      var entries = entriesRef.current;
      var current = entries[id];

      if (current !== entry) {
        delete entries[id];
      }
    };
  }, []);
  var tryGiveFocus = useCallback(function tryGiveFocus(tryGiveFocusTo) {
    var handle = findDragHandle(contextId, tryGiveFocusTo);

    if (handle && handle !== document.activeElement) {
      handle.focus();
    }
  }, [contextId]);
  var tryShiftRecord = useCallback(function tryShiftRecord(previous, redirectTo) {
    if (recordRef.current === previous) {
      recordRef.current = redirectTo;
    }
  }, []);
  var tryRestoreFocusRecorded = useCallback(function tryRestoreFocusRecorded() {
    if (restoreFocusFrameRef.current) {
      return;
    }

    if (!isMountedRef.current) {
      return;
    }

    restoreFocusFrameRef.current = requestAnimationFrame(function () {
      restoreFocusFrameRef.current = null;
      var record = recordRef.current;

      if (record) {
        tryGiveFocus(record);
      }
    });
  }, [tryGiveFocus]);
  var tryRecordFocus = useCallback(function tryRecordFocus(id) {
    recordRef.current = null;
    var focused = document.activeElement;

    if (!focused) {
      return;
    }

    if (focused.getAttribute(dragHandle.draggableId) !== id) {
      return;
    }

    recordRef.current = id;
  }, []);
  useIsomorphicLayoutEffect$1(function () {
    isMountedRef.current = true;
    return function clearFrameOnUnmount() {
      isMountedRef.current = false;
      var frameId = restoreFocusFrameRef.current;

      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  }, []);
  var marshal = useMemo(function () {
    return {
      register: register,
      tryRecordFocus: tryRecordFocus,
      tryRestoreFocusRecorded: tryRestoreFocusRecorded,
      tryShiftRecord: tryShiftRecord
    };
  }, [register, tryRecordFocus, tryRestoreFocusRecorded, tryShiftRecord]);
  return marshal;
}

function createRegistry() {
  var entries = {
    draggables: {},
    droppables: {}
  };
  var subscribers = [];

  function subscribe(cb) {
    subscribers.push(cb);
    return function unsubscribe() {
      var index = subscribers.indexOf(cb);

      if (index === -1) {
        return;
      }

      subscribers.splice(index, 1);
    };
  }

  function notify(event) {
    if (subscribers.length) {
      subscribers.forEach(function (cb) {
        return cb(event);
      });
    }
  }

  function findDraggableById(id) {
    return entries.draggables[id] || null;
  }

  function getDraggableById(id) {
    var entry = findDraggableById(id);
    !entry ? invariant(false) : void 0;
    return entry;
  }

  var draggableAPI = {
    register: function register(entry) {
      entries.draggables[entry.descriptor.id] = entry;
      notify({
        type: 'ADDITION',
        value: entry
      });
    },
    update: function update(entry, last) {
      var current = entries.draggables[last.descriptor.id];

      if (!current) {
        return;
      }

      if (current.uniqueId !== entry.uniqueId) {
        return;
      }

      delete entries.draggables[last.descriptor.id];
      entries.draggables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var draggableId = entry.descriptor.id;
      var current = findDraggableById(draggableId);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.draggables[draggableId];
      notify({
        type: 'REMOVAL',
        value: entry
      });
    },
    getById: getDraggableById,
    findById: findDraggableById,
    exists: function exists(id) {
      return Boolean(findDraggableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.draggables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function findDroppableById(id) {
    return entries.droppables[id] || null;
  }

  function getDroppableById(id) {
    var entry = findDroppableById(id);
    !entry ? invariant(false) : void 0;
    return entry;
  }

  var droppableAPI = {
    register: function register(entry) {
      entries.droppables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var current = findDroppableById(entry.descriptor.id);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.droppables[entry.descriptor.id];
    },
    getById: getDroppableById,
    findById: findDroppableById,
    exists: function exists(id) {
      return Boolean(findDroppableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.droppables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function clean() {
    entries.draggables = {};
    entries.droppables = {};
    subscribers.length = 0;
  }

  return {
    draggable: draggableAPI,
    droppable: droppableAPI,
    subscribe: subscribe,
    clean: clean
  };
}

function useRegistry() {
  var registry = useMemo(createRegistry, []);
  react.exports.useEffect(function () {
    return function unmount() {
      requestAnimationFrame(registry.clean);
    };
  }, [registry]);
  return registry;
}

var StoreContext = /*#__PURE__*/React.createContext(null);

var getBodyElement = function getBodyElement() {
  var body = document.body;
  !body ? invariant(false) : void 0;
  return body;
};

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};

var getId = function getId(contextId) {
  return "rbd-announcement-" + contextId;
};

function useAnnouncer(contextId) {
  var id = useMemo(function () {
    return getId(contextId);
  }, [contextId]);
  var ref = react.exports.useRef(null);
  react.exports.useEffect(function setup() {
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('aria-atomic', 'true');

    _extends$9(el.style, visuallyHidden);

    getBodyElement().appendChild(el);
    return function cleanup() {
      setTimeout(function remove() {
        var body = getBodyElement();

        if (body.contains(el)) {
          body.removeChild(el);
        }

        if (el === ref.current) {
          ref.current = null;
        }
      });
    };
  }, [id]);
  var announce = useCallback(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }
  }, []);
  return announce;
}

var count = 0;
var defaults$5 = {
  separator: '::'
};

function useUniqueId(prefix, options) {
  if (options === void 0) {
    options = defaults$5;
  }

  return useMemo(function () {
    return "" + prefix + options.separator + count++;
  }, [options.separator, prefix]);
}

function getElementId(_ref) {
  var contextId = _ref.contextId,
      uniqueId = _ref.uniqueId;
  return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}

function useHiddenTextElement(_ref2) {
  var contextId = _ref2.contextId,
      text = _ref2.text;
  var uniqueId = useUniqueId('hidden-text', {
    separator: '-'
  });
  var id = useMemo(function () {
    return getElementId({
      contextId: contextId,
      uniqueId: uniqueId
    });
  }, [uniqueId, contextId]);
  react.exports.useEffect(function mount() {
    var el = document.createElement('div');
    el.id = id;
    el.textContent = text;
    el.style.display = 'none';
    getBodyElement().appendChild(el);
    return function unmount() {
      var body = getBodyElement();

      if (body.contains(el)) {
        body.removeChild(el);
      }
    };
  }, [id, text]);
  return id;
}

var AppContext = /*#__PURE__*/React.createContext(null);

function usePrevious(current) {
  var ref = react.exports.useRef(current);
  react.exports.useEffect(function () {
    ref.current = current;
  });
  return ref;
}

function create$1() {
  var lock = null;

  function isClaimed() {
    return Boolean(lock);
  }

  function isActive(value) {
    return value === lock;
  }

  function claim(abandon) {
    !!lock ? invariant(false) : void 0;
    var newLock = {
      abandon: abandon
    };
    lock = newLock;
    return newLock;
  }

  function release() {
    !lock ? invariant(false) : void 0;
    lock = null;
  }

  function tryAbandon() {
    if (lock) {
      lock.abandon();
      release();
    }
  }

  return {
    isClaimed: isClaimed,
    isActive: isActive,
    claim: claim,
    release: release,
    tryAbandon: tryAbandon
  };
}

var tab = 9;
var enter = 13;
var escape$1 = 27;
var space$1 = 32;
var pageUp = 33;
var pageDown = 34;
var end$1 = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var _preventedKeys;

var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);

var preventStandardKeyEvents = function preventStandardKeyEvents(event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
};

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var primaryButton = 0;
var sloppyClickThreshold = 5;

function isSloppyClickThresholdExceeded(original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}

var idle$1 = {
  type: 'IDLE'
};

function getCaptureBindings(_ref) {
  var cancel = _ref.cancel,
      completed = _ref.completed,
      getPhase = _ref.getPhase,
      setPhase = _ref.setPhase;
  return [{
    eventName: 'mousemove',
    fn: function fn(event) {
      var button = event.button,
          clientX = event.clientX,
          clientY = event.clientY;

      if (button !== primaryButton) {
        return;
      }

      var point = {
        x: clientX,
        y: clientY
      };
      var phase = getPhase();

      if (phase.type === 'DRAGGING') {
        event.preventDefault();
        phase.actions.move(point);
        return;
      }

      !(phase.type === 'PENDING') ? invariant(false) : void 0;
      var pending = phase.point;

      if (!isSloppyClickThresholdExceeded(pending, point)) {
        return;
      }

      event.preventDefault();
      var actions = phase.actions.fluidLift(point);
      setPhase({
        type: 'DRAGGING',
        actions: actions
      });
    }
  }, {
    eventName: 'mouseup',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'mousedown',
    fn: function fn(event) {
      if (getPhase().type === 'DRAGGING') {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        cancel();
        return;
      }

      if (event.keyCode === escape$1) {
        event.preventDefault();
        cancel();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn() {
      if (getPhase().type === 'PENDING') {
        cancel();
      }
    }
  }, {
    eventName: 'webkitmouseforcedown',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ? invariant(false) : void 0;

      if (phase.actions.shouldRespectForcePress()) {
        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor(api) {
  var phaseRef = react.exports.useRef(idle$1);
  var unbindEventsRef = react.exports.useRef(noop$2);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'mousedown',
      fn: function onMouseDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.button !== primaryButton) {
          return;
        }

        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        event.preventDefault();
        var point = {
          x: event.clientX,
          y: event.clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var preventForcePressBinding = useMemo(function () {
    return {
      eventName: 'webkitmouseforcewillbegin',
      fn: function fn(event) {
        if (event.defaultPrevented) {
          return;
        }

        var id = api.findClosestDraggableId(event);

        if (!id) {
          return;
        }

        var options = api.findOptionsForDraggable(id);

        if (!options) {
          return;
        }

        if (options.shouldRespectForcePress) {
          return;
        }

        if (!api.canGetLock(id)) {
          return;
        }

        event.preventDefault();
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [preventForcePressBinding, startCaptureBinding], options);
  }, [preventForcePressBinding, startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    phaseRef.current = idle$1;
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var bindings = getCaptureBindings({
      cancel: cancel,
      completed: stop,
      getPhase: function getPhase() {
        return phaseRef.current;
      },
      setPhase: function setPhase(phase) {
        phaseRef.current = phase;
      }
    });
    unbindEventsRef.current = bindEvents(window, bindings, options);
  }, [cancel, stop]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(phaseRef.current.type === 'IDLE') ? invariant(false) : void 0;
    phaseRef.current = {
      type: 'PENDING',
      point: point,
      actions: actions
    };
    bindCapturingEvents();
  }, [bindCapturingEvents]);
  useIsomorphicLayoutEffect$1(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var _scrollJumpKeys;

function noop$1$1() {}

var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end$1] = true, _scrollJumpKeys);

function getDraggingBindings(actions, stop) {
  function cancel() {
    stop();
    actions.cancel();
  }

  function drop() {
    stop();
    actions.drop();
  }

  return [{
    eventName: 'keydown',
    fn: function fn(event) {
      if (event.keyCode === escape$1) {
        event.preventDefault();
        cancel();
        return;
      }

      if (event.keyCode === space$1) {
        event.preventDefault();
        drop();
        return;
      }

      if (event.keyCode === arrowDown) {
        event.preventDefault();
        actions.moveDown();
        return;
      }

      if (event.keyCode === arrowUp) {
        event.preventDefault();
        actions.moveUp();
        return;
      }

      if (event.keyCode === arrowRight) {
        event.preventDefault();
        actions.moveRight();
        return;
      }

      if (event.keyCode === arrowLeft) {
        event.preventDefault();
        actions.moveLeft();
        return;
      }

      if (scrollJumpKeys[event.keyCode]) {
        event.preventDefault();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'mousedown',
    fn: cancel
  }, {
    eventName: 'mouseup',
    fn: cancel
  }, {
    eventName: 'click',
    fn: cancel
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'wheel',
    fn: cancel,
    options: {
      passive: true
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useKeyboardSensor(api) {
  var unbindEventsRef = react.exports.useRef(noop$1$1);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'keydown',
      fn: function onKeyDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.keyCode !== space$1) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var preDrag = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!preDrag) {
          return;
        }

        event.preventDefault();
        var isCapturing = true;
        var actions = preDrag.snapLift();
        unbindEventsRef.current();

        function stop() {
          !isCapturing ? invariant(false) : void 0;
          isCapturing = false;
          unbindEventsRef.current();
          listenForCapture();
        }

        unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
          capture: true,
          passive: false
        });
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function tryStartCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  useIsomorphicLayoutEffect$1(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var idle$2 = {
  type: 'IDLE'
};
var timeForLongPress = 120;
var forcePressThreshold = 0.15;

function getWindowBindings(_ref) {
  var cancel = _ref.cancel,
      getPhase = _ref.getPhase;
  return [{
    eventName: 'orientationchange',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'contextmenu',
    fn: function fn(event) {
      event.preventDefault();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      if (event.keyCode === escape$1) {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function getHandleBindings(_ref2) {
  var cancel = _ref2.cancel,
      completed = _ref2.completed,
      getPhase = _ref2.getPhase;
  return [{
    eventName: 'touchmove',
    options: {
      capture: false
    },
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      phase.hasMoved = true;
      var _event$touches$ = event.touches[0],
          clientX = _event$touches$.clientX,
          clientY = _event$touches$.clientY;
      var point = {
        x: clientX,
        y: clientY
      };
      event.preventDefault();
      phase.actions.move(point);
    }
  }, {
    eventName: 'touchend',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'touchcancel',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      cancel();
    }
  }, {
    eventName: 'touchforcechange',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ? invariant(false) : void 0;
      var touch = event.touches[0];

      if (!touch) {
        return;
      }

      var isForcePress = touch.force >= forcePressThreshold;

      if (!isForcePress) {
        return;
      }

      var shouldRespect = phase.actions.shouldRespectForcePress();

      if (phase.type === 'PENDING') {
        if (shouldRespect) {
          cancel();
        }

        return;
      }

      if (shouldRespect) {
        if (phase.hasMoved) {
          event.preventDefault();
          return;
        }

        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useTouchSensor(api) {
  var phaseRef = react.exports.useRef(idle$2);
  var unbindEventsRef = react.exports.useRef(noop$2);
  var getPhase = useCallback(function getPhase() {
    return phaseRef.current;
  }, []);
  var setPhase = useCallback(function setPhase(phase) {
    phaseRef.current = phase;
  }, []);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'touchstart',
      fn: function onTouchStart(event) {
        if (event.defaultPrevented) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        var touch = event.touches[0];
        var clientX = touch.clientX,
            clientY = touch.clientY;
        var point = {
          x: clientX,
          y: clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      capture: true,
      passive: false
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    if (current.type === 'PENDING') {
      clearTimeout(current.longPressTimerId);
    }

    setPhase(idle$2);
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture, setPhase]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var args = {
      cancel: cancel,
      completed: stop,
      getPhase: getPhase
    };
    var unbindTarget = bindEvents(window, getHandleBindings(args), options);
    var unbindWindow = bindEvents(window, getWindowBindings(args), options);

    unbindEventsRef.current = function unbindAll() {
      unbindTarget();
      unbindWindow();
    };
  }, [cancel, getPhase, stop]);
  var startDragging = useCallback(function startDragging() {
    var phase = getPhase();
    !(phase.type === 'PENDING') ? invariant(false) : void 0;
    var actions = phase.actions.fluidLift(phase.point);
    setPhase({
      type: 'DRAGGING',
      actions: actions,
      hasMoved: false
    });
  }, [getPhase, setPhase]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(getPhase().type === 'IDLE') ? invariant(false) : void 0;
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    setPhase({
      type: 'PENDING',
      point: point,
      actions: actions,
      longPressTimerId: longPressTimerId
    });
    bindCapturingEvents();
  }, [bindCapturingEvents, getPhase, setPhase, startDragging]);
  useIsomorphicLayoutEffect$1(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        clearTimeout(phase.longPressTimerId);
        setPhase(idle$2);
      }
    };
  }, [getPhase, listenForCapture, setPhase]);
  useIsomorphicLayoutEffect$1(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: 'touchmove',
      fn: function fn() {},
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
}

function isEventInInteractiveElement(draggable, event) {
  var target = event.target;

  if (!isHtmlElement(target)) {
    return false;
  }

  return isAnInteractiveElement(draggable, target);
}

var getBorderBoxCenterPosition = function getBorderBoxCenterPosition(el) {
  return getRect(el.getBoundingClientRect()).center;
};

function isElement$3(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var supportedMatchesName = function () {
  var base = 'matches';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, 'msMatchesSelector', 'webkitMatchesSelector'];
  var value = find(candidates, function (name) {
    return name in Element.prototype;
  });
  return value || base;
}();

function closestPonyfill(el, selector) {
  if (el == null) {
    return null;
  }

  if (el[supportedMatchesName](selector)) {
    return el;
  }

  return closestPonyfill(el.parentElement, selector);
}

function closest$1(el, selector) {
  if (el.closest) {
    return el.closest(selector);
  }

  return closestPonyfill(el, selector);
}

function getSelector(contextId) {
  return "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
}

function findClosestDragHandleFromEvent(contextId, event) {
  var target = event.target;

  if (!isElement$3(target)) {
    return null;
  }

  var selector = getSelector(contextId);
  var handle = closest$1(target, selector);

  if (!handle) {
    return null;
  }

  if (!isHtmlElement(handle)) {
    return null;
  }

  return handle;
}

function tryGetClosestDraggableIdFromEvent(contextId, event) {
  var handle = findClosestDragHandleFromEvent(contextId, event);

  if (!handle) {
    return null;
  }

  return handle.getAttribute(dragHandle.draggableId);
}

function findDraggable(contextId, draggableId) {
  var selector = "[" + draggable.contextId + "=\"" + contextId + "\"]";
  var possible = toArray$1(document.querySelectorAll(selector));
  var draggable$1 = find(possible, function (el) {
    return el.getAttribute(draggable.id) === draggableId;
  });

  if (!draggable$1) {
    return null;
  }

  if (!isHtmlElement(draggable$1)) {
    return null;
  }

  return draggable$1;
}

function preventDefault(event) {
  event.preventDefault();
}

function _isActive(_ref) {
  var expected = _ref.expected,
      phase = _ref.phase,
      isLockActive = _ref.isLockActive;
      _ref.shouldWarn;

  if (!isLockActive()) {

    return false;
  }

  if (expected !== phase) {

    return false;
  }

  return true;
}

function canStart(_ref2) {
  var lockAPI = _ref2.lockAPI,
      store = _ref2.store,
      registry = _ref2.registry,
      draggableId = _ref2.draggableId;

  if (lockAPI.isClaimed()) {
    return false;
  }

  var entry = registry.draggable.findById(draggableId);

  if (!entry) {
    return false;
  }

  if (!entry.options.isEnabled) {
    return false;
  }

  if (!canStartDrag(store.getState(), draggableId)) {
    return false;
  }

  return true;
}

function tryStart(_ref3) {
  var lockAPI = _ref3.lockAPI,
      contextId = _ref3.contextId,
      store = _ref3.store,
      registry = _ref3.registry,
      draggableId = _ref3.draggableId,
      forceSensorStop = _ref3.forceSensorStop,
      sourceEvent = _ref3.sourceEvent;
  var shouldStart = canStart({
    lockAPI: lockAPI,
    store: store,
    registry: registry,
    draggableId: draggableId
  });

  if (!shouldStart) {
    return null;
  }

  var entry = registry.draggable.getById(draggableId);
  var el = findDraggable(contextId, entry.descriptor.id);

  if (!el) {
    return null;
  }

  if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) {
    return null;
  }

  var lock = lockAPI.claim(forceSensorStop || noop$2);
  var phase = 'PRE_DRAG';

  function getShouldRespectForcePress() {
    return entry.options.shouldRespectForcePress;
  }

  function isLockActive() {
    return lockAPI.isActive(lock);
  }

  function tryDispatch(expected, getAction) {
    if (_isActive({
      expected: expected,
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    })) {
      store.dispatch(getAction());
    }
  }

  var tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');

  function lift$1(args) {
    function completed() {
      lockAPI.release();
      phase = 'COMPLETED';
    }

    if (phase !== 'PRE_DRAG') {
      completed();
      !(phase === 'PRE_DRAG') ? invariant(false) : void 0;
    }

    store.dispatch(lift(args.liftActionArgs));
    phase = 'DRAGGING';

    function finish(reason, options) {
      if (options === void 0) {
        options = {
          shouldBlockNextClick: false
        };
      }

      args.cleanup();

      if (options.shouldBlockNextClick) {
        var unbind = bindEvents(window, [{
          eventName: 'click',
          fn: preventDefault,
          options: {
            once: true,
            passive: false,
            capture: true
          }
        }]);
        setTimeout(unbind);
      }

      completed();
      store.dispatch(drop({
        reason: reason
      }));
    }

    return _extends$9({
      isActive: function isActive() {
        return _isActive({
          expected: 'DRAGGING',
          phase: phase,
          isLockActive: isLockActive,
          shouldWarn: false
        });
      },
      shouldRespectForcePress: getShouldRespectForcePress,
      drop: function drop(options) {
        return finish('DROP', options);
      },
      cancel: function cancel(options) {
        return finish('CANCEL', options);
      }
    }, args.actions);
  }

  function fluidLift(clientSelection) {
    var move$1 = rafSchd$1(function (client) {
      tryDispatchWhenDragging(function () {
        return move({
          client: client
        });
      });
    });
    var api = lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: clientSelection,
        movementMode: 'FLUID'
      },
      cleanup: function cleanup() {
        return move$1.cancel();
      },
      actions: {
        move: move$1
      }
    });
    return _extends$9({}, api, {
      move: move$1
    });
  }

  function snapLift() {
    var actions = {
      moveUp: function moveUp$1() {
        return tryDispatchWhenDragging(moveUp);
      },
      moveRight: function moveRight$1() {
        return tryDispatchWhenDragging(moveRight);
      },
      moveDown: function moveDown$1() {
        return tryDispatchWhenDragging(moveDown);
      },
      moveLeft: function moveLeft$1() {
        return tryDispatchWhenDragging(moveLeft);
      }
    };
    return lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: getBorderBoxCenterPosition(el),
        movementMode: 'SNAP'
      },
      cleanup: noop$2,
      actions: actions
    });
  }

  function abortPreDrag() {
    var shouldRelease = _isActive({
      expected: 'PRE_DRAG',
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    });

    if (shouldRelease) {
      lockAPI.release();
    }
  }

  var preDrag = {
    isActive: function isActive() {
      return _isActive({
        expected: 'PRE_DRAG',
        phase: phase,
        isLockActive: isLockActive,
        shouldWarn: false
      });
    },
    shouldRespectForcePress: getShouldRespectForcePress,
    fluidLift: fluidLift,
    snapLift: snapLift,
    abort: abortPreDrag
  };
  return preDrag;
}

var defaultSensors = [useMouseSensor, useKeyboardSensor, useTouchSensor];

function useSensorMarshal(_ref4) {
  var contextId = _ref4.contextId,
      store = _ref4.store,
      registry = _ref4.registry,
      customSensors = _ref4.customSensors,
      enableDefaultSensors = _ref4.enableDefaultSensors;
  var useSensors = [].concat(enableDefaultSensors ? defaultSensors : [], customSensors || []);
  var lockAPI = react.exports.useState(function () {
    return create$1();
  })[0];
  var tryAbandonLock = useCallback(function tryAbandonLock(previous, current) {
    if (previous.isDragging && !current.isDragging) {
      lockAPI.tryAbandon();
    }
  }, [lockAPI]);
  useIsomorphicLayoutEffect$1(function listenToStore() {
    var previous = store.getState();
    var unsubscribe = store.subscribe(function () {
      var current = store.getState();
      tryAbandonLock(previous, current);
      previous = current;
    });
    return unsubscribe;
  }, [lockAPI, store, tryAbandonLock]);
  useIsomorphicLayoutEffect$1(function () {
    return lockAPI.tryAbandon;
  }, [lockAPI.tryAbandon]);
  var canGetLock = useCallback(function (draggableId) {
    return canStart({
      lockAPI: lockAPI,
      registry: registry,
      store: store,
      draggableId: draggableId
    });
  }, [lockAPI, registry, store]);
  var tryGetLock = useCallback(function (draggableId, forceStop, options) {
    return tryStart({
      lockAPI: lockAPI,
      registry: registry,
      contextId: contextId,
      store: store,
      draggableId: draggableId,
      forceSensorStop: forceStop,
      sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
    });
  }, [contextId, lockAPI, registry, store]);
  var findClosestDraggableId = useCallback(function (event) {
    return tryGetClosestDraggableIdFromEvent(contextId, event);
  }, [contextId]);
  var findOptionsForDraggable = useCallback(function (id) {
    var entry = registry.draggable.findById(id);
    return entry ? entry.options : null;
  }, [registry.draggable]);
  var tryReleaseLock = useCallback(function tryReleaseLock() {
    if (!lockAPI.isClaimed()) {
      return;
    }

    lockAPI.tryAbandon();

    if (store.getState().phase !== 'IDLE') {
      store.dispatch(flush());
    }
  }, [lockAPI, store]);
  var isLockClaimed = useCallback(lockAPI.isClaimed, [lockAPI]);
  var api = useMemo(function () {
    return {
      canGetLock: canGetLock,
      tryGetLock: tryGetLock,
      findClosestDraggableId: findClosestDraggableId,
      findOptionsForDraggable: findOptionsForDraggable,
      tryReleaseLock: tryReleaseLock,
      isLockClaimed: isLockClaimed
    };
  }, [canGetLock, tryGetLock, findClosestDraggableId, findOptionsForDraggable, tryReleaseLock, isLockClaimed]);

  for (var i = 0; i < useSensors.length; i++) {
    useSensors[i](api);
  }
}

var createResponders = function createResponders(props) {
  return {
    onBeforeCapture: props.onBeforeCapture,
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ? invariant(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var contextId = props.contextId,
      setCallbacks = props.setCallbacks,
      sensors = props.sensors,
      nonce = props.nonce,
      dragHandleUsageInstructions = props.dragHandleUsageInstructions;
  var lazyStoreRef = react.exports.useRef(null);
  var lastPropsRef = usePrevious(props);
  var getResponders = useCallback(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(contextId);
  var dragHandleUsageInstructionsId = useHiddenTextElement({
    contextId: contextId,
    text: dragHandleUsageInstructions
  });
  var styleMarshal = useStyleMarshal(contextId, nonce);
  var lazyDispatch = useCallback(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var marshalCallbacks = useMemo(function () {
    return bindActionCreators$1({
      publishWhileDragging: publishWhileDragging,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var registry = useRegistry();
  var dimensionMarshal = useMemo(function () {
    return createDimensionMarshal(registry, marshalCallbacks);
  }, [registry, marshalCallbacks]);
  var autoScroller = useMemo(function () {
    return createAutoScroller(_extends$9({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, bindActionCreators$1({
      move: move
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var focusMarshal = useFocusMarshal(contextId);
  var store = useMemo(function () {
    return createStore({
      announce: announce,
      autoScroller: autoScroller,
      dimensionMarshal: dimensionMarshal,
      focusMarshal: focusMarshal,
      getResponders: getResponders,
      styleMarshal: styleMarshal
    });
  }, [announce, autoScroller, dimensionMarshal, focusMarshal, getResponders, styleMarshal]);

  lazyStoreRef.current = store;
  var tryResetStore = useCallback(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(flush());
    }
  }, []);
  var isDragging = useCallback(function () {
    var state = getStore(lazyStoreRef).getState();
    return state.isDragging || state.phase === 'DROP_ANIMATING';
  }, []);
  var appCallbacks = useMemo(function () {
    return {
      isDragging: isDragging,
      tryAbort: tryResetStore
    };
  }, [isDragging, tryResetStore]);
  setCallbacks(appCallbacks);
  var getCanLift = useCallback(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = useCallback(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = useMemo(function () {
    return {
      marshal: dimensionMarshal,
      focus: focusMarshal,
      contextId: contextId,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed,
      dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
      registry: registry
    };
  }, [contextId, dimensionMarshal, dragHandleUsageInstructionsId, focusMarshal, getCanLift, getIsMovementAllowed, registry]);
  useSensorMarshal({
    contextId: contextId,
    store: store,
    registry: registry,
    customSensors: sensors,
    enableDefaultSensors: props.enableDefaultSensors !== false
  });
  react.exports.useEffect(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: appContext
  }, /*#__PURE__*/React.createElement(Provider, {
    context: StoreContext,
    store: store
  }, props.children));
}

var count$1 = 0;

function useInstanceCount() {
  return useMemo(function () {
    return "" + count$1++;
  }, []);
}

function DragDropContext(props) {
  var contextId = useInstanceCount();
  var dragHandleUsageInstructions = props.dragHandleUsageInstructions || preset.dragHandleUsageInstructions;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, function (setCallbacks) {
    return /*#__PURE__*/React.createElement(App, {
      nonce: props.nonce,
      contextId: contextId,
      setCallbacks: setCallbacks,
      dragHandleUsageInstructions: dragHandleUsageInstructions,
      enableDefaultSensors: props.enableDefaultSensors,
      sensors: props.sensors,
      onBeforeCapture: props.onBeforeCapture,
      onBeforeDragStart: props.onBeforeDragStart,
      onDragStart: props.onDragStart,
      onDragUpdate: props.onDragUpdate,
      onDragEnd: props.onDragEnd
    }, props.children);
  });
}

var isEqual$1 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$1('scroll');
var isAuto = isEqual$1('auto');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  {
    return false;
  }
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var getScroll$1 = function getScroll$1(el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
};

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = function getEnv(start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
};

var getDroppableDimension = function getDroppableDimension(_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
};

var getClient = function getClient(targetRef, closestScrollable) {
  var base = getBox(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = expand(paddingBox, base.border);
  var client = createBox({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = function getDimension(_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = withScroll(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = getBox(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
};

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};

var getListenerOptions = function getListenerOptions(options) {
  return options.shouldPublishImmediately ? immediate : delayed;
};

function useRequiredContext(Context) {
  var result = react.exports.useContext(Context);
  !result ? invariant(false) : void 0;
  return result;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppablePublisher(args) {
  var whileDraggingRef = react.exports.useRef(null);
  var appContext = useRequiredContext(AppContext);
  var uniqueId = useUniqueId('droppable');
  var registry = appContext.registry,
      marshal = appContext.marshal;
  var previousRef = usePrevious(args);
  var descriptor = useMemo(function () {
    return {
      id: args.droppableId,
      type: args.type,
      mode: args.mode
    };
  }, [args.droppableId, args.mode, args.type]);
  var publishedDescriptorRef = react.exports.useRef(descriptor);
  var memoizedUpdateScroll = useMemo(function () {
    return memoizeOne(function (x, y) {
      !whileDraggingRef.current ? invariant(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = useCallback(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = useMemo(function () {
    return rafSchd$1(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? invariant(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = useCallback(function (windowScroll, options) {
    !!whileDraggingRef.current ? invariant(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ? invariant(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });
    var scrollable = env.closestScrollable;

    if (scrollable) {
      scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
      scrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
    }

    return dimension;
  }, [appContext.contextId, descriptor, onClosestScroll, previousRef]);
  var getScrollWhileDragging = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? invariant(false) : void 0;
    return getScroll$1(closest);
  }, []);
  var dragStopped = useCallback(function () {
    var dragging = whileDraggingRef.current;
    !dragging ? invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeAttribute(scrollContainer.contextId);
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = useCallback(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ? invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ? invariant(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = useMemo(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      getScrollWhileDragging: getScrollWhileDragging,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, getScrollWhileDragging, scroll]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      callbacks: callbacks
    };
  }, [callbacks, descriptor, uniqueId]);
  useIsomorphicLayoutEffect$1(function () {
    publishedDescriptorRef.current = entry.descriptor;
    registry.droppable.register(entry);
    return function () {
      if (whileDraggingRef.current) {
        dragStopped();
      }

      registry.droppable.unregister(entry);
    };
  }, [callbacks, descriptor, dragStopped, entry, marshal, registry.droppable]);
  useIsomorphicLayoutEffect$1(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect$1(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop$2$1() {}

var empty = {
  width: 0,
  height: 0,
  margin: noSpacing
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty;
  }

  if (animate === 'close') {
    return empty;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: animate !== 'none' ? transitions.placeholder : null
  };
};

function Placeholder$1(props) {
  var animateOpenTimerRef = react.exports.useRef(null);
  var tryClearAnimateOpenTimer = useCallback(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      contextId = props.contextId;

  var _useState = react.exports.useState(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  react.exports.useEffect(function () {
    if (!isAnimatingOpenOnMount) {
      return noop$2$1;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop$2$1;
    }

    if (animateOpenTimerRef.current) {
      return noop$2$1;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = useCallback(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return /*#__PURE__*/React.createElement(props.placeholder.tagName, {
    style: style,
    'data-rbd-placeholder-context-id': contextId,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1$1 = /*#__PURE__*/React.memo(Placeholder$1);
var DroppableContext = /*#__PURE__*/React.createContext(null);

var AnimateInOut = function (_React$PureComponent) {
  _inheritsLoose(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(React.PureComponent);

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine$1.opacity.drop : combine$1.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = calculateBox(borderBox, computedStyles);
  var page = withScroll(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggablePublisher(args) {
  var uniqueId = useUniqueId('draggable');
  var descriptor = args.descriptor,
      registry = args.registry,
      getDraggableRef = args.getDraggableRef,
      canDragInteractiveElements = args.canDragInteractiveElements,
      shouldRespectForcePress = args.shouldRespectForcePress,
      isEnabled = args.isEnabled;
  var options = useMemo(function () {
    return {
      canDragInteractiveElements: canDragInteractiveElements,
      shouldRespectForcePress: shouldRespectForcePress,
      isEnabled: isEnabled
    };
  }, [canDragInteractiveElements, isEnabled, shouldRespectForcePress]);
  var getDimension = useCallback(function (windowScroll) {
    var el = getDraggableRef();
    !el ? invariant(false) : void 0;
    return getDimension$1(descriptor, el, windowScroll);
  }, [descriptor, getDraggableRef]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      options: options,
      getDimension: getDimension
    };
  }, [descriptor, getDimension, options, uniqueId]);
  var publishedRef = react.exports.useRef(entry);
  var isFirstPublishRef = react.exports.useRef(true);
  useIsomorphicLayoutEffect$1(function () {
    registry.draggable.register(publishedRef.current);
    return function () {
      return registry.draggable.unregister(publishedRef.current);
    };
  }, [registry.draggable]);
  useIsomorphicLayoutEffect$1(function () {
    if (isFirstPublishRef.current) {
      isFirstPublishRef.current = false;
      return;
    }

    var last = publishedRef.current;
    publishedRef.current = entry;
    registry.draggable.update(entry, last);
  }, [entry, registry.draggable]);
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function Draggable$1(props) {
  var ref = react.exports.useRef(null);
  var setRef = useCallback(function (el) {
    ref.current = el;
  }, []);
  var getRef = useCallback(function () {
    return ref.current;
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      contextId = _useRequiredContext.contextId,
      dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId,
      registry = _useRequiredContext.registry;

  var _useRequiredContext2 = useRequiredContext(DroppableContext),
      type = _useRequiredContext2.type,
      droppableId = _useRequiredContext2.droppableId;

  var descriptor = useMemo(function () {
    return {
      id: props.draggableId,
      index: props.index,
      type: type,
      droppableId: droppableId
    };
  }, [props.draggableId, props.index, type, droppableId]);
  var children = props.children,
      draggableId = props.draggableId,
      isEnabled = props.isEnabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.canDragInteractiveElements,
      isClone = props.isClone,
      mapped = props.mapped,
      dropAnimationFinishedAction = props.dropAnimationFinished;

  if (!isClone) {
    var forPublisher = useMemo(function () {
      return {
        descriptor: descriptor,
        registry: registry,
        getDraggableRef: getRef,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress,
        isEnabled: isEnabled
      };
    }, [descriptor, registry, getRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled]);
    useDraggablePublisher(forPublisher);
  }

  var dragHandleProps = useMemo(function () {
    return isEnabled ? {
      tabIndex: 0,
      role: 'button',
      'aria-describedby': dragHandleUsageInstructionsId,
      'data-rbd-drag-handle-draggable-id': draggableId,
      'data-rbd-drag-handle-context-id': contextId,
      draggable: false,
      onDragStart: preventHtml5Dnd
    } : null;
  }, [contextId, dragHandleUsageInstructionsId, draggableId, isEnabled]);
  var onMoveEnd = useCallback(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = useMemo(function () {
    var style = getStyle$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-rbd-draggable-context-id': contextId,
        'data-rbd-draggable-id': draggableId,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [contextId, dragHandleProps, draggableId, mapped, onMoveEnd, setRef]);
  var rubric = useMemo(function () {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  }, [descriptor.droppableId, descriptor.id, descriptor.index, descriptor.type]);
  return children(provided, mapped.snapshot, rubric);
}

var isStrictEqual = function isStrictEqual(a, b) {
  return a === b;
};

var whatIsDraggedOverFromResult = function whatIsDraggedOverFromResult(result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
};

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};

function getDraggableSelector() {
  var memoizedOffset = memoizeOne(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoizeOne(function (mode, isClone, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isClone: isClone,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getMemoizedProps = memoizeOne(function (offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
      }
    };
  });

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var isClone = ownProps.isClone;
      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine$1.opacity.drop : null,
        scale: _combineWith ? combine$1.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: mode,
          forceShouldAnimate: null,
          snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  return selector;
}

function getSecondarySnapshot(combineTargetFor) {
  return {
    isDragging: false,
    isDropAnimating: false,
    isClone: false,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: combineTargetFor,
    combineWith: null
  };
}

var atRest = {
  mapped: {
    type: 'SECONDARY',
    offset: origin,
    combineTargetFor: null,
    shouldAnimateDisplacement: true,
    snapshot: getSecondarySnapshot(null)
  }
};

function getSecondarySelector() {
  var memoizedOffset = memoizeOne(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoizeOne(getSecondarySnapshot);
  var getMemoizedProps = memoizeOne(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getMemoizedSnapshot(combineTargetFor)
      }
    };
  });

  var getFallback = function getFallback(combineTargetFor) {
    return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
  };

  var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
    var visualDisplacement = impact.displaced.visible[ownId];
    var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
    var combine = tryGetCombine(impact);
    var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;

    if (!visualDisplacement) {
      if (!isAfterCriticalInVirtualList) {
        return getFallback(combineTargetFor);
      }

      if (impact.displaced.invisible[ownId]) {
        return null;
      }

      var change = negate(afterCritical.displacedBy.point);

      var _offset = memoizedOffset(change.x, change.y);

      return getMemoizedProps(_offset, combineTargetFor, true);
    }

    if (isAfterCriticalInVirtualList) {
      return getFallback(combineTargetFor);
    }

    var displaceBy = impact.displacedBy.point;
    var offset = memoizedOffset(displaceBy.x, displaceBy.y);
    return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
  };

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
    }

    return null;
  };

  return selector;
}

var makeMapStateToProps = function makeMapStateToProps() {
  var draggingSelector = getDraggableSelector();
  var secondarySelector = getSecondarySelector();

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
  };

  return selector;
};

var mapDispatchToProps = {
  dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = connect(makeMapStateToProps, mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable$1);

function PrivateDraggable(props) {
  var droppableContext = useRequiredContext(DroppableContext);
  var isUsingCloneFor = droppableContext.isUsingCloneFor;

  if (isUsingCloneFor === props.draggableId && !props.isClone) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ConnectedDraggable, props);
}

function PublicDraggable(props) {
  var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
  var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
  var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
  return /*#__PURE__*/React.createElement(PrivateDraggable, _extends$9({}, props, {
    isClone: false,
    isEnabled: isEnabled,
    canDragInteractiveElements: canDragInteractiveElements,
    shouldRespectForcePress: shouldRespectForcePress
  }));
}

function Droppable(props) {
  var appContext = react.exports.useContext(AppContext);
  !appContext ? invariant(false) : void 0;
  var contextId = appContext.contextId,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = react.exports.useRef(null);
  var placeholderRef = react.exports.useRef(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      mode = props.mode,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      useClone = props.useClone,
      updateViewportMaxScroll = props.updateViewportMaxScroll,
      getContainerForClone = props.getContainerForClone;
  var getDroppableRef = useCallback(function () {
    return droppableRef.current;
  }, []);
  var setDroppableRef = useCallback(function (value) {
    droppableRef.current = value;
  }, []);
  useCallback(function () {
    return placeholderRef.current;
  }, []);
  var setPlaceholderRef = useCallback(function (value) {
    placeholderRef.current = value;
  }, []);
  var onPlaceholderTransitionEnd = useCallback(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppablePublisher({
    droppableId: droppableId,
    type: type,
    mode: mode,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef
  });
  var placeholder = /*#__PURE__*/React.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return /*#__PURE__*/React.createElement(Placeholder$1$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      contextId: contextId,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = useMemo(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-rbd-droppable-id': droppableId,
        'data-rbd-droppable-context-id': contextId
      }
    };
  }, [contextId, droppableId, placeholder, setDroppableRef]);
  var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
  var droppableContext = useMemo(function () {
    return {
      droppableId: droppableId,
      type: type,
      isUsingCloneFor: isUsingCloneFor
    };
  }, [droppableId, isUsingCloneFor, type]);

  function getClone() {
    if (!useClone) {
      return null;
    }

    var dragging = useClone.dragging,
        render = useClone.render;
    var node = /*#__PURE__*/React.createElement(PrivateDraggable, {
      draggableId: dragging.draggableId,
      index: dragging.source.index,
      isClone: true,
      isEnabled: true,
      shouldRespectForcePress: false,
      canDragInteractiveElements: true
    }, function (draggableProvided, draggableSnapshot) {
      return render(draggableProvided, draggableSnapshot, dragging);
    });
    return /*#__PURE__*/ReactDOM.createPortal(node, getContainerForClone());
  }

  return /*#__PURE__*/React.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot), getClone());
}

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var idleWithAnimation = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: false
    },
    useClone: null
  };

  var idleWithoutAnimation = _extends$9({}, idleWithAnimation, {
    shouldAnimatePlaceholder: false
  });

  var getDraggableRubric = memoizeOne(function (descriptor) {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  });
  var getMapProps = memoizeOne(function (id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      var useClone = renderClone ? {
        render: renderClone,
        dragging: getDraggableRubric(dragging.descriptor)
      } : null;
      var _snapshot = {
        isDraggingOver: isDraggingOverForConsumer,
        draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
        draggingFromThisWith: draggableId,
        isUsingPlaceholder: true
      };
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: _snapshot,
        useClone: useClone
      };
    }

    if (!isEnabled) {
      return idleWithoutAnimation;
    }

    if (!isDraggingOverForImpact) {
      return idleWithAnimation;
    }

    var snapshot = {
      isDraggingOver: isDraggingOverForConsumer,
      draggingOverWith: draggableId,
      draggingFromThisWith: null,
      isUsingPlaceholder: true
    };
    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot,
      useClone: null
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;
    var isEnabled = !ownProps.isDropDisabled;
    var renderClone = ownProps.renderClone;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idleWithoutAnimation;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idleWithoutAnimation;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
    }

    if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idleWithoutAnimation;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
      var isHome = _completed.critical.droppable.id === id;

      if (wasOver) {
        return wasCombining ? idleWithAnimation : idleWithoutAnimation;
      }

      if (isHome) {
        return idleWithAnimation;
      }

      return idleWithoutAnimation;
    }

    return idleWithoutAnimation;
  };

  return selector;
};

var mapDispatchToProps$1 = {
  updateViewportMaxScroll: updateViewportMaxScroll
};

function getBody() {
  !document.body ? invariant(false) : void 0;
  return document.body;
}

var defaultProps = {
  mode: 'standard',
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false,
  renderClone: null,
  getContainerForClone: getBody
};
var ConnectedDroppable = connect(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;

var __jsx$H = react.exports.createElement;
var LoadingDots = function LoadingDots(_ref) {
  var _ref$dotSize = _ref.dotSize,
      dotSize = _ref$dotSize === void 0 ? 8 : _ref$dotSize,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "white" : _ref$color;
  return __jsx$H("div", null, __jsx$H(SingleDot, {
    dotSize: dotSize,
    color: color
  }), __jsx$H(SingleDot, {
    dotSize: dotSize,
    color: color
  }), __jsx$H(SingleDot, {
    dotSize: dotSize,
    color: color
  }));
};
var scaleUpAndDown = Ue(["0%{transform:scale(0.1);}50%{transform:scale(1);}90%{transform:scale(0.1);}100%{transform:scale(0.1);}"]);
var SingleDot = styled.span.withConfig({
  displayName: "LoadingDots__SingleDot",
  componentId: "sc-1jdbb21-0"
})(["animation:", " 2s linear infinite;display:inline-block;margin-right:4px;:nth-child(2){animation-delay:0.3s;}:nth-child(3){animation-delay:0.5s;}", ""], scaleUpAndDown, function (_ref2) {
  var color = _ref2.color,
      dotSize = _ref2.dotSize;
  return Ce(["background:", ";width:", "px;height:", "px;border-radius:", "px;"], color, dotSize, dotSize, dotSize);
});

var __jsx$G = react.exports.createElement;
var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children,
      rootContainerNode = _ref.rootContainerNode;

  var _useState = react.exports.useState(null),
      modalRootContainerRef = _useState[0],
      setModalRootContainerRef = _useState[1];

  var setModalRef = react.exports.useCallback(function (node) {
    if (node !== null) {
      setModalRootContainerRef(node);
    }
  }, []);

  var content = __jsx$G(react.exports.Fragment, null, __jsx$G("div", {
    id: "modal-root",
    ref: setModalRef
  }), __jsx$G(ModalContainerContext.Provider, {
    value: {
      portalNode: rootContainerNode || modalRootContainerRef
    }
  }, children));

  return content;
};
var ModalContainerContext = /*#__PURE__*/react.exports.createContext(null);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
styled.div.withConfig({
  displayName: "ModalOverlay",
  componentId: "sc-16npwil-0"
})(["position:fixed;top:0;right:0;bottom:0;left:0;width:100vw;height:100vh;overflow:auto;padding:0;z-index:var(--tina-z-index-5);"]);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
styled.div.withConfig({
  displayName: "ModalActions",
  componentId: "sc-1xec7f7-0"
})(["display:flex;justify-content:flex-end;border-radius:0 0 5px 5px;padding:0 var(--tina-padding-big) var(--tina-padding-big) var(--tina-padding-big);", "{flex:0 1 auto;min-width:128px;margin:0 var(--tina-padding-small) 0 0;&:last-child{margin-right:0;}}"], Button);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var ModalBody = styled.div.withConfig({
  displayName: "ModalBody",
  componentId: "sc-9zhpzh-0"
})(["padding:", ";margin:0;overflow:hidden;display:flex;flex-direction:column;min-height:160px;&:last-child{border-radius:0 0 5px 5px;}"], function (p) {
  return p.padded ? "var(--tina-padding-big)" : "0";
});

var __jsx$F = react.exports.createElement;
styled(function (_ref) {
  var children = _ref.children,
      close = _ref.close,
      styleProps = _objectWithoutProperties$2(_ref, ["children", "close"]);

  return __jsx$F("div", styleProps, __jsx$F(ModalTitle, null, children), close && __jsx$F(CloseButton, {
    onClick: close
  }, __jsx$F(CloseIcon, null)));
}).withConfig({
  displayName: "ModalHeader",
  componentId: "sc-1ql3adl-0"
})(["height:56px;display:flex;align-items:center;justify-content:space-between;padding:0 var(--tina-padding-big) 0 var(--tina-padding-big);border-bottom:1px solid var(--tina-color-grey-3);margin:0;"]);
var ModalTitle = styled.h2.withConfig({
  displayName: "ModalHeader__ModalTitle",
  componentId: "sc-1ql3adl-1"
})(["all:unset;color:var(--tina-color-grey-10);font-weight:var(--tina-font-weight-regular);font-family:var(--tina-font-family);font-size:var(--tina-font-size-4);font-weight:var(--tina-font-weight-regular);line-height:1;margin:0;"]);
var CloseButton = styled.div.withConfig({
  displayName: "ModalHeader__CloseButton",
  componentId: "sc-1ql3adl-2"
})(["display:flex;align-items:center;fill:var(--tina-color-grey-5);cursor:pointer;transition:fill 85ms ease-out;svg{width:24px;height:auto;}&:hover{fill:var(--tina-color-grey-8);}"]);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var ModalFullscreenKeyframes = Ue(["0%{transform:translate3d( -2rem,0,0 );opacity:0;}100%{transform:translate3d( 0,0,0 );opacity:1;}"]);
styled.div.withConfig({
  displayName: "FullscreenModal",
  componentId: "sc-16cj00-0"
})(["display:flex;flex-direction:column;z-index:var(--tina-z-index-0);overflow:visible;background-color:#fff;border-radius:0;position:absolute;top:0;left:0;width:100%;max-width:1500px;height:100%;animation:", " 150ms ease-out 1;", "{height:100%;display:flex;flex-direction:column;}@media (min-width:721px){width:calc(100% - 170px);}"], ModalFullscreenKeyframes, ModalBody);

var cjs = {exports: {}};

var Draggable = {};

function r$1(e) {
  var t,
      f,
      n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) {
    e[t] && (f = r$1(e[t])) && (n && (n += " "), n += f);
  } else for (t in e) {
    e[t] && (n && (n += " "), n += t);
  }
  return n;
}

function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) {
    (e = arguments[f++]) && (t = r$1(e)) && (n && (n += " "), n += t);
  }

  return n;
}

var clsx_m = /*#__PURE__*/Object.freeze({
	__proto__: null,
	clsx: clsx,
	'default': clsx
});

var require$$3 = /*@__PURE__*/getAugmentedNamespace(clsx_m);

var domFns = {};

var shims = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dontSetMe = dontSetMe;
exports.findInArray = findInArray;
exports["int"] = _int;
exports.isFunction = isFunction;
exports.isNum = isNum; // @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc

function findInArray(array
/*: Array<any> | TouchList*/
, callback
/*: Function*/
)
/*: any*/
{
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}

function isFunction(func
/*: any*/
)
/*: boolean %checks*/
{
  // $FlowIgnore[method-unbinding]
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

function isNum(num
/*: any*/
)
/*: boolean %checks*/
{
  return typeof num === 'number' && !isNaN(num);
}

function _int(a
/*: string*/
)
/*: number*/
{
  return parseInt(a, 10);
}

function dontSetMe(props
/*: Object*/
, propName
/*: string*/
, componentName
/*: string*/
)
/*: ?Error*/
{
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}
}(shims));

var getPrefix = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
exports["default"] = void 0;
exports.getPrefix = getPrefix;
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];

function getPrefix()
/*: string*/
{
  var _window$document, _window$document$docu;

  var prop
  /*: string*/
  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform'; // Ensure we're running in an environment where there is actually a global
  // `window` obj

  if (typeof window === 'undefined') return ''; // If we're in a pseudo-browser server-side environment, this access
  // path may not exist, so bail out if it doesn't.

  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
  if (!style) return '';
  if (prop in style) return '';

  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }

  return '';
}

function browserPrefixToKey(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}

function browserPrefixToStyle(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}

function kebabToTitleCase(str
/*: string*/
)
/*: string*/
{
  var out = '';
  var shouldCapitalize = true;

  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }

  return out;
} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`


var _default = getPrefix()
/*: string*/
;

exports["default"] = _default;
}(getPrefix));

function _typeof$5(obj) {
  "@babel/helpers - typeof";

  return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$5(obj);
}

Object.defineProperty(domFns, "__esModule", {
  value: true
});
domFns.addClassName = addClassName;
domFns.addEvent = addEvent;
domFns.addUserSelectStyles = addUserSelectStyles;
domFns.createCSSTransform = createCSSTransform;
domFns.createSVGTransform = createSVGTransform;
domFns.getTouch = getTouch;
domFns.getTouchIdentifier = getTouchIdentifier;
domFns.getTranslation = getTranslation;
domFns.innerHeight = innerHeight;
domFns.innerWidth = innerWidth;
domFns.matchesSelector = matchesSelector;
domFns.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
domFns.offsetXYFromParent = offsetXYFromParent;
domFns.outerHeight = outerHeight;
domFns.outerWidth = outerWidth;
domFns.removeClassName = removeClassName;
domFns.removeEvent = removeEvent;
domFns.removeUserSelectStyles = removeUserSelectStyles;

var _shims$1 = shims;

var _getPrefix = _interopRequireWildcard(getPrefix);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof$5(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys$W(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$W(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$W(Object(source), !0).forEach(function (key) {
      _defineProperty$c(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$W(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty$c(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var matchesSelectorFunc = '';

function matchesSelector(el
/*: Node*/
, selector
/*: string*/
)
/*: boolean*/
{
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims$1.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims$1.isFunction)(el[method]);
    });
  } // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable


  if (!(0, _shims$1.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable

  return el[matchesSelectorFunc](selector);
} // Works up the tree to the draggable itself attempting to match selector.


function matchesSelectorAndParentsTo(el
/*: Node*/
, selector
/*: string*/
, baseNode
/*: Node*/
)
/*: boolean*/
{
  var node = el;

  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

function addEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread$W({
    capture: true
  }, inputOptions); // $FlowIgnore[method-unbinding]


  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}

function removeEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread$W({
    capture: true
  }, inputOptions); // $FlowIgnore[method-unbinding]


  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}

function outerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims$1["int"])(computedStyle.borderTopWidth);
  height += (0, _shims$1["int"])(computedStyle.borderBottomWidth);
  return height;
}

function outerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims$1["int"])(computedStyle.borderLeftWidth);
  width += (0, _shims$1["int"])(computedStyle.borderRightWidth);
  return width;
}

function innerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims$1["int"])(computedStyle.paddingTop);
  height -= (0, _shims$1["int"])(computedStyle.paddingBottom);
  return height;
}

function innerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims$1["int"])(computedStyle.paddingLeft);
  width -= (0, _shims$1["int"])(computedStyle.paddingRight);
  return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/
// Get from offsetParent


function offsetXYFromParent(evt
/*: EventWithOffset*/
, offsetParent
/*: HTMLElement*/
, scale
/*: number*/
)
/*: ControlPosition*/
{
  var isBody = offsetParent === offsetParent.ownerDocument.body;
  var offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
  return {
    x: x,
    y: y
  };
}

function createCSSTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: Object*/
{
  var translation = getTranslation(controlPos, positionOffset, 'px');
  return _defineProperty$c({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix["default"]), translation);
}

function createSVGTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: string*/
{
  var translation = getTranslation(controlPos, positionOffset, '');
  return translation;
}

function getTranslation(_ref2, positionOffset
/*: PositionOffsetControlPosition*/
, unitSuffix
/*: string*/
)
/*: string*/
{
  var x = _ref2.x,
      y = _ref2.y;
  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");

  if (positionOffset) {
    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }

  return translation;
}

function getTouch(e
/*: MouseTouchEvent*/
, identifier
/*: number*/
)
/*: ?{clientX: number, clientY: number}*/
{
  return e.targetTouches && (0, _shims$1.findInArray)(e.targetTouches, function (t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims$1.findInArray)(e.changedTouches, function (t) {
    return identifier === t.identifier;
  });
}

function getTouchIdentifier(e
/*: MouseTouchEvent*/
)
/*: ?number*/
{
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
} // User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed


function addUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');

  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }

  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}

function removeUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;

  try {
    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE

    if (doc.selection) {
      // $FlowIgnore: IE
      doc.selection.empty();
    } else {
      // Remove selection caused by scroll, unless it's a focused input
      // (we use doc.defaultView in case we're in an iframe)
      var selection = (doc.defaultView || window).getSelection();

      if (selection && selection.type !== 'Caret') {
        selection.removeAllRanges();
      }
    }
  } catch (e) {// probably IE
  }
}

function addClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}

function removeClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
  }
}

var positionFns = {};

Object.defineProperty(positionFns, "__esModule", {
  value: true
});
positionFns.canDragX = canDragX;
positionFns.canDragY = canDragY;
positionFns.createCoreData = createCoreData;
positionFns.createDraggableData = createDraggableData;
positionFns.getBoundPosition = getBoundPosition;
positionFns.getControlPosition = getControlPosition;
positionFns.snapToGrid = snapToGrid;

var _shims = shims;

var _domFns = domFns;

function getBoundPosition(draggable
/*: Draggable*/
, x
/*: number*/
, y
/*: number*/
)
/*: [number, number]*/
{
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y]; // Clone new bounds

  var bounds = draggable.props.bounds;
  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);

  if (typeof bounds === 'string') {
    var ownerDocument = node.ownerDocument;
    var ownerWindow = ownerDocument.defaultView;
    var boundNode;

    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }

    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }

    var boundNodeEl
    /*: HTMLElement*/
    = boundNode; // for Flow, can't seem to refine correctly

    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.

    bounds = {
      left: -node.offsetLeft + (0, _shims["int"])(boundNodeStyle.paddingLeft) + (0, _shims["int"])(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims["int"])(boundNodeStyle.paddingTop) + (0, _shims["int"])(nodeStyle.marginTop),
      right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims["int"])(boundNodeStyle.paddingRight) - (0, _shims["int"])(nodeStyle.marginRight),
      bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims["int"])(boundNodeStyle.paddingBottom) - (0, _shims["int"])(nodeStyle.marginBottom)
    };
  } // Keep x and y below right and bottom limits...


  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.

  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
  return [x, y];
}

function snapToGrid(grid
/*: [number, number]*/
, pendingX
/*: number*/
, pendingY
/*: number*/
)
/*: [number, number]*/
{
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}

function canDragX(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}

function canDragY(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
} // Get {x, y} positions from event.


function getControlPosition(e
/*: MouseTouchEvent*/
, touchIdentifier
/*: ?number*/
, draggableCore
/*: DraggableCore*/
)
/*: ?ControlPosition*/
{
  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch

  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.

  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
} // Create an data object exposed by <DraggableCore>'s events


function createCoreData(draggable
/*: DraggableCore*/
, x
/*: number*/
, y
/*: number*/
)
/*: DraggableData*/
{
  var state = draggable.state;
  var isStart = !(0, _shims.isNum)(state.lastX);
  var node = findDOMNode(draggable);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node: node,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x: x,
      y: y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node: node,
      deltaX: x - state.lastX,
      deltaY: y - state.lastY,
      lastX: state.lastX,
      lastY: state.lastY,
      x: x,
      y: y
    };
  }
} // Create an data exposed by <Draggable>'s events


function createDraggableData(draggable
/*: Draggable*/
, coreData
/*: DraggableData*/
)
/*: DraggableData*/
{
  var scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
} // A lot faster than stringify/parse


function cloneBounds(bounds
/*: Bounds*/
)
/*: Bounds*/
{
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}

function findDOMNode(draggable
/*: Draggable | DraggableCore*/
)
/*: HTMLElement*/
{
  var node = draggable.findDOMNode();

  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME


  return node;
}

var DraggableCore = {};

var log = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = log;
/*eslint no-console:0*/

function log() {
}
}(log));

(function (exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(react.exports);

var _propTypes = _interopRequireDefault(propTypes.exports);

var _reactDom = _interopRequireDefault(reactDom.exports);

var _domFns = domFns;

var _positionFns = positionFns;

var _shims = shims;

var _log = _interopRequireDefault(log);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Simple abstraction for dragging events names.


var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
}; // Default to mouse events.

var dragEventFor = eventsFor.mouse;
/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/

/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/

/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/

/*:: export type ControlPosition = {x: number, y: number};*/

/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/

/*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/

/*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/
//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//

var DraggableCore = /*#__PURE__*/function (_React$Component) {
  _inherits(DraggableCore, _React$Component);

  var _super = _createSuper(DraggableCore);

  function DraggableCore() {
    var _this;

    _classCallCheck(this, DraggableCore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: null
    });

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
      // Make it possible to attach event handlers on top of this one.
      _this.props.onMouseDown(e); // Only accept left-clicks.


      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)

      var thisNode = _this.findDOMNode();

      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }

      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.

      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      } // Prevent scrolling on mobile devices, like ipad/iphone.
      // Important that this is after handle/cancel.


      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.

      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);

      _this.setState({
        touchIdentifier: touchIdentifier
      }); // Get the current drag point from the event. This is used as the offset.


      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return; // not possible but satisfies flow

      var x = position.x,
          y = position.y; // Create an event object with all the data parents need to make a decision here.

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log["default"])('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.

      (0, _log["default"])('calling', _this.props.onStart);

      var shouldUpdate = _this.props.onStart(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.

      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.

      _this.setState({
        dragging: true,
        lastX: x,
        lastY: y
      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.


      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y; // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX,
            deltaY = y - _this.state.lastY;

        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);

        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

        deltaX = _snapToGrid2[0];
        deltaY = _snapToGrid2[1];
        if (!deltaX && !deltaY) return; // skip useless drag

        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log["default"])('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.

      var shouldUpdate = _this.props.onDrag(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) {
        try {
          // $FlowIgnore
          _this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          var event = document.createEvent('MouseEvents')
          /*: any*/

          /*: MouseTouchEvent*/
          ; // I see why this insanity was deprecated
          // $FlowIgnore

          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

          _this.handleDragStop(event);
        }

        return;
      }

      _this.setState({
        lastX: x,
        lastY: y
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
      if (!_this.state.dragging) return;
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y; // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX || 0;
        var deltaY = y - _this.state.lastY || 0;

        var _snapToGrid3 = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);

        var _snapToGrid4 = _slicedToArray(_snapToGrid3, 2);

        deltaX = _snapToGrid4[0];
        deltaY = _snapToGrid4[1];
        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler

      var shouldContinue = _this.props.onStop(e, coreEvent);

      if (shouldContinue === false || _this.mounted === false) return false;

      var thisNode = _this.findDOMNode();

      if (thisNode) {
        // Remove user-select hack
        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }

      (0, _log["default"])('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.

      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });

      if (thisNode) {
        // Remove event handlers
        (0, _log["default"])('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStop(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStop(e);
    });

    return _this;
  }

  _createClass(DraggableCore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention

      var thisNode = this.findDOMNode();

      if (thisNode) {
        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.

      var thisNode = this.findDOMNode();

      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      var _this$props, _this$props2, _this$props2$nodeRef;

      return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$nodeRef = _this$props2.nodeRef) === null || _this$props2$nodeRef === void 0 ? void 0 : _this$props2$nodeRef.current : _reactDom["default"].findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    /*: React.Element<any>*/
    {
      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return DraggableCore;
}(React.Component);

exports["default"] = DraggableCore;

_defineProperty(DraggableCore, "displayName", 'DraggableCore');

_defineProperty(DraggableCore, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes["default"].bool,

  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes["default"].bool,

  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes["default"].bool,

  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function offsetParent(props
  /*: DraggableCoreProps*/
  , propName
  /*: $Keys<DraggableCoreProps>*/
  ) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },

  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes["default"].arrayOf(_propTypes["default"].number),

  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes["default"].string,

  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes["default"].string,

  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes["default"].object,

  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes["default"].func,

  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes["default"].func,

  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes["default"].func,

  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes["default"].func,

  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes["default"].number,

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});

_defineProperty(DraggableCore, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  disabled: false,
  enableUserSelectHack: true,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {},
  scale: 1
});
}(DraggableCore));

(function (exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DraggableCore", {
  enumerable: true,
  get: function get() {
    return _DraggableCore["default"];
  }
});
exports["default"] = void 0;

var React = _interopRequireWildcard(react.exports);

var _propTypes = _interopRequireDefault(propTypes.exports);

var _reactDom = _interopRequireDefault(reactDom.exports);

var _clsx2 = _interopRequireDefault(require$$3);

var _domFns = domFns;

var _positionFns = positionFns;

var _shims = shims;

var _DraggableCore = _interopRequireDefault(DraggableCore);

var _log = _interopRequireDefault(log);

var _excluded = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} //
// Define <Draggable>
//


var Draggable = /*#__PURE__*/function (_React$Component) {
  _inherits(Draggable, _React$Component);

  var _super = _createSuper(Draggable);

  function Draggable(props
  /*: DraggableProps*/
  ) {
    var _this;

    _classCallCheck(this, Draggable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
      (0, _log["default"])('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.

      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.


      if (shouldStart === false) return false;

      _this.setState({
        dragging: true,
        dragged: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
      if (!_this.state.dragging) return false;
      (0, _log["default"])('Draggable: onDrag: %j', coreData);
      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        x: uiData.x,
        y: uiData.y
      }; // Keep within bounds.

      if (_this.props.bounds) {
        // Save original x and y.
        var x = newState.x,
            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.

        newState.x += _this.state.slackX;
        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.

        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
            newStateX = _getBoundPosition2[0],
            newStateY = _getBoundPosition2[1];

        newState.x = newStateX;
        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.

        newState.slackX = _this.state.slackX + (x - newState.x);
        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.

        uiData.x = newState.x;
        uiData.y = newState.y;
        uiData.deltaX = newState.x - _this.state.x;
        uiData.deltaY = newState.y - _this.state.y;
      } // Short-circuit if user's callback killed it.


      var shouldUpdate = _this.props.onDrag(e, uiData);

      if (shouldUpdate === false) return false;

      _this.setState(newState);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.

      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));

      if (shouldContinue === false) return false;
      (0, _log["default"])('Draggable: onDragStop: %j', coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        dragging: false,
        slackX: 0,
        slackY: 0
      }; // If this is a controlled component, the result of this operation will be to
      // revert back to the old position. We expect a handler on `onDragStop`, at the least.

      var controlled = Boolean(_this.props.position);

      if (controlled) {
        var _this$props$position = _this.props.position,
            x = _this$props$position.x,
            y = _this$props$position.y;
        newState.x = x;
        newState.y = y;
      }

      _this.setState(newState);
    });

    _this.state = {
      // Whether or not we are currently dragging.
      dragging: false,
      // Whether or not we have been dragged before.
      dragged: false,
      // Current transform x and y.
      x: props.position ? props.position.x : props.defaultPosition.x,
      y: props.position ? props.position.y : props.defaultPosition.y,
      prevPropsPosition: _objectSpread({}, props.position),
      // Used for compensating for out-of-bounds drags
      slackX: 0,
      slackY: 0,
      // Can only determine if SVG after mounting
      isElementSVG: false
    };

    if (props.position && !(props.onDrag || props.onStop)) {
      // eslint-disable-next-line no-console
      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
    }

    return _this;
  }

  _createClass(Draggable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Check to see if the element passed is an instanceof SVGElement
      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
        this.setState({
          isElementSVG: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        dragging: false
      }); // prevents invariant if unmounted while dragging
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;

      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom["default"].findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    /*: ReactElement<any>*/
    {
      var _clsx;

      var _this$props2 = this.props;
          _this$props2.axis;
          _this$props2.bounds;
          var children = _this$props2.children,
          defaultPosition = _this$props2.defaultPosition,
          defaultClassName = _this$props2.defaultClassName,
          defaultClassNameDragging = _this$props2.defaultClassNameDragging,
          defaultClassNameDragged = _this$props2.defaultClassNameDragged,
          position = _this$props2.position,
          positionOffset = _this$props2.positionOffset;
          _this$props2.scale;
          var draggableCoreProps = _objectWithoutProperties(_this$props2, _excluded);

      var style = {};
      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.

      var controlled = Boolean(position);
      var draggable = !controlled || this.state.dragging;
      var validPosition = position || defaultPosition;
      var transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
        // Set top if vertical drag is enabled
        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
      }; // If this element was SVG, we use the `transform` attribute.

      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
      } else {
        // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
      } // Mark with class while dragging


      var className = (0, _clsx2["default"])(children.props.className || '', defaultClassName, (_clsx = {}, _defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), _defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)

      return /*#__PURE__*/React.createElement(_DraggableCore["default"], _extends({}, draggableCoreProps, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
        className: className,
        style: _objectSpread(_objectSpread({}, children.props.style), style),
        transform: svgTransform
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: // React 16.3+
    // Arity (props, state)
    function getDerivedStateFromProps(_ref, _ref2)
    /*: ?$Shape<DraggableState>*/
    {
      var position = _ref.position;
      var prevPropsPosition = _ref2.prevPropsPosition; // Set x/y if a new position is provided in props that is different than the previous.

      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
        (0, _log["default"])('Draggable: getDerivedStateFromProps %j', {
          position: position,
          prevPropsPosition: prevPropsPosition
        });
        return {
          x: position.x,
          y: position.y,
          prevPropsPosition: _objectSpread({}, position)
        };
      }

      return null;
    }
  }]);

  return Draggable;
}(React.Component);

exports["default"] = Draggable;

_defineProperty(Draggable, "displayName", 'Draggable');

_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore["default"].propTypes), {}, {
  /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */
  axis: _propTypes["default"].oneOf(['both', 'x', 'y', 'none']),

  /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  bounds: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    left: _propTypes["default"].number,
    right: _propTypes["default"].number,
    top: _propTypes["default"].number,
    bottom: _propTypes["default"].number
  }), _propTypes["default"].string, _propTypes["default"].oneOf([false])]),
  defaultClassName: _propTypes["default"].string,
  defaultClassNameDragging: _propTypes["default"].string,
  defaultClassNameDragged: _propTypes["default"].string,

  /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  defaultPosition: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),
  positionOffset: _propTypes["default"].shape({
    x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  }),

  /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  position: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
}));

_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore["default"].defaultProps), {}, {
  axis: 'both',
  bounds: false,
  defaultClassName: 'react-draggable',
  defaultClassNameDragging: 'react-draggable-dragging',
  defaultClassNameDragged: 'react-draggable-dragged',
  defaultPosition: {
    x: 0,
    y: 0
  },
  scale: 1
}));
}(Draggable));

(function (module) {

var _require = Draggable,
    Draggable$1 = _require["default"],
    DraggableCore = _require.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266


module.exports = Draggable$1;
module.exports["default"] = Draggable$1;
module.exports.DraggableCore = DraggableCore;
}(cjs));

React.createElement;
var ModalPopupKeyframes = Ue(["0%{transform:translate3d( 0,-2rem,0 );opacity:0;}100%{transform:translate3d( 0,0,0 );opacity:1;}"]);
styled.div.withConfig({
  displayName: "PopupModal__PopupModalStyled",
  componentId: "sc-1f5amwb-0"
})(["display:block;z-index:var(--tina-z-index-0);overflow:visible;background-color:var(--tina-color-grey-1);border-radius:var(--tina-radius-small);margin:40px auto;width:460px;max-width:90%;animation:", " 150ms ease-out 1;box-shadow:0 14px 28px rgb(0 0 0 / 15%),0 10px 10px rgb(0 0 0 / 12%);"], ModalPopupKeyframes);

styled(Button).withConfig({
  displayName: "ResetForm__ResetButton",
  componentId: "sc-bf5dkv-0"
})(["flex:0 0 96px;"]);

var Emoji = styled.span.withConfig({
  displayName: "FormView__Emoji",
  componentId: "sc-1ux1lgt-0"
})(["font-size:40px;line-height:1;display:inline-block;"]);
var EmptyStateAnimation = Ue(["0%{opacity:0;}100%{opacity:1;}"]);
styled.div.withConfig({
  displayName: "FormView__EmptyState",
  componentId: "sc-1ux1lgt-1"
})(["position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:var(--tina-padding-big) var(--tina-padding-big) 64px var(--tina-padding-big);width:100%;height:100%;overflow-y:auto;animation-name:", ";animation-delay:300ms;animation-timing-function:ease-out;animation-iteration-count:1;animation-fill-mode:both;animation-duration:150ms;> *:first-child{margin:0 0 var(--tina-padding-big) 0;}> ", "{display:block;}h3{font-size:var(--tina-font-size-5);font-weight:normal;color:inherit;display:block;margin:0 0 var(--tina-padding-big) 0;", "{font-size:1em;}}p{display:block;margin:0 0 var(--tina-padding-big) 0;}"], EmptyStateAnimation, Emoji, Emoji);
styled.a.withConfig({
  displayName: "FormView__LinkButton",
  componentId: "sc-1ux1lgt-2"
})(["text-align:center;border:0;border-radius:var(--tina-radius-big);border:1px solid var(--tina-color-grey-2);box-shadow:var(--tina-shadow-small);font-weight:var(--tina-font-weight-regular);cursor:pointer;font-size:var(--tina-font-size-0);transition:all var(--tina-timing-short) ease-out;background-color:white;color:var(--tina-color-grey-8);padding:var(--tina-padding-small) var(--tina-padding-big) var(--tina-padding-small) 56px;position:relative;text-decoration:none;display:inline-block;", "{font-size:24px;position:absolute;left:var(--tina-padding-big);top:50%;transform-origin:50% 50%;transform:translate3d(0,-50%,0);transition:all var(--tina-timing-short) ease-out;}&:hover{color:var(--tina-color-primary);", "{transform:translate3d(0,-50%,0);}}"], Emoji, Emoji);

var Wrapper$2 = styled.div.withConfig({
  displayName: "FormView__Wrapper",
  componentId: "sc-1ux1lgt-3"
})(["display:block;margin:0 auto;width:100%;"]);
styled.div.withConfig({
  displayName: "FormView__FormBody",
  componentId: "sc-1ux1lgt-4"
})(["position:relative;flex:1 1 auto;display:flex;flex-direction:column;width:100%;overflow:auto;border-top:1px solid var(--tina-color-grey-2);background-color:white;", "{height:100%;}"], Wrapper$2);
styled.div.withConfig({
  displayName: "FormView__FormFooter",
  componentId: "sc-1ux1lgt-5"
})(["position:relative;flex:0 0 auto;display:flex;align-items:center;width:100%;height:64px;background-color:white;border-top:1px solid var(--tina-color-grey-2);", "{flex:1 0 auto;display:flex;justify-content:space-between;align-items:center;padding:0 16px;}"], Wrapper$2); // @ts-ignore

styled(Button).withConfig({
  displayName: "FormView__SaveButton",
  componentId: "sc-1ux1lgt-6"
})(["flex:1.5 0 auto;padding:12px 24px;"]);

var __jsx$E = react.exports.createElement;

function ownKeys$V(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$V(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$V(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$V(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GetTextColorForBackground = function GetTextColorForBackground(backgroundColor) {
  //fudgy rgb values found on the internets
  return !backgroundColor || backgroundColor.r * 0.299 + backgroundColor.g * 0.587 + backgroundColor.b * 0.114 > 186 ? "#000000" : "#ffffff";
};

var Swatch = styled(function (_ref) {
  var colorRGBA = _ref.colorRGBA,
      colorFormat = _ref.colorFormat;
      _ref.unselectable;
      var props = _objectWithoutProperties$2(_ref, ["colorRGBA", "colorFormat", "unselectable"]);

  return __jsx$E("div", props, __jsx$E("div", {
    className: "swatch-inner"
  }, !colorRGBA ? "Click to add color" : ColorFormatter[colorFormat].getLabel(colorRGBA)));
}).withConfig({
  displayName: "ColorPicker__Swatch",
  componentId: "sc-o45di8-0"
})(["background:var(--tina-color-grey-2);border-radius:var(--tina-radius-big);box-shadow:var(--tina-shadow-small);cursor:pointer;width:100%;margin:0;> div{display:flex;align-items:center;justify-content:center;font-size:var(--tina-font-size-1);font-weight:bold;width:100%;height:40px;border-radius:var(--tina-radius-big);box-shadow:inset 0 0 1px 1px rgba(0,0,0,0.075);background:", ";color:", ";transition:all var(--tina-timing-short) ease-out;}&:hover{> div{opacity:0.6;}}"], function (props) {
  return props.colorRGBA ? "rgba(".concat(props.colorRGBA.r, ", ").concat(props.colorRGBA.g, ", ").concat(props.colorRGBA.b, ", ").concat(props.colorRGBA.a, ")") : "#fff";
}, function (props) {
  return GetTextColorForBackground(props.colorRGBA);
});
var ColorPopupKeyframes = Ue(["0%{transform:translate3d(-50%,0,0) scale3d(0.5,0.5,1)}100%{transform:translate3d(-50%,8px,0) scale3d(1,1,1);}"]);
var ColorPopupOpenTopKeyframes = Ue(["0%{transform:translate3d(-50%,-100%,0) scale3d(0.5,0.5,1)}100%{transform:translate3d(-50%,calc(-100% - 8px),0) scale3d(1,1,1);}"]);
var Popover = styled.div.withConfig({
  displayName: "ColorPicker__Popover",
  componentId: "sc-o45di8-1"
})(["position:fixed;top:", "px;left:", "px;transform:translate3d(-50%,8px,0) scale3d(1,1,1);transform-origin:50% 0;animation:", " 85ms ease-out both 1;z-index:var(--tina-z-index-5);&:before{content:\"\";position:absolute;top:0;left:50%;margin-top:1px;transform:translate3d(-50%,-100%,0);width:18px;height:14px;clip-path:polygon(50% 0%,0% 100%,100% 100%);background-color:var(--tina-color-grey-3);z-index:var(--tina-z-index-1);}&:after{content:\"\";position:absolute;top:0;left:50%;margin-top:2px;transform:translate3d(-50%,-100%,0);width:16px;height:13px;clip-path:polygon(50% 0%,0% 100%,100% 100%);background-color:white;z-index:var(--tina-z-index-2);}", ";"], function (props) {
  return props.triggerBoundingBox ? props.triggerBoundingBox.bottom : "0";
}, function (props) {
  return props.triggerBoundingBox ? props.triggerBoundingBox.left + props.triggerBoundingBox.width / 2 : "0";
}, ColorPopupKeyframes, function (props) {
  return props.openTop && Ce(["top:", "px;transform:translate3d(-50%,calc(-100% - 8px),0) scale3d(1,1,1);animation:", " 85ms ease-out both 1;transform-origin:50% 100%;&:before,&:after{top:auto;bottom:0;transform:translate3d(-50%,100%,0);clip-path:polygon(0% 0%,100% 0%,50% 100%);}&:before{margin-top:0;margin-bottom:1px;}&:after{margin-top:0;margin-bottom:2px;}"], props.triggerBoundingBox ? props.triggerBoundingBox.top : "0", ColorPopupOpenTopKeyframes);
});
styled.div.withConfig({
  displayName: "ColorPicker__Cover",
  componentId: "sc-o45di8-2"
})(["position:fixed;top:0;right:0;bottom:0;left:0;width:100%;height:100vh;z-index:var(--tina-z-index-1);"]);
var ColorPickerWrapper = styled.div.withConfig({
  displayName: "ColorPicker__ColorPickerWrapper",
  componentId: "sc-o45di8-3"
})(["position:relative;"]);
var nullColor = "transparent";
var presetColors = ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"];

var SketchWidget = function SketchWidget(props) {
  return __jsx$E(SketchPicker, {
    presetColors: props.presetColors,
    color: props.color,
    onChange: props.onChange,
    disableAlpha: props.disableAlpha,
    width: props.width
  });
};

var BlockWidget = function BlockWidget(props) {
  return __jsx$E(BlockPicker, {
    colors: props.presetColors,
    color: props.color,
    onChange: props.onChange,
    width: props.width
  });
};

var WIDGETS = {
  sketch: SketchWidget,
  block: BlockWidget
};
var ColorPicker = function ColorPicker(_ref2) {
  var colorFormat = _ref2.colorFormat,
      _ref2$userColors = _ref2.userColors,
      userColors = _ref2$userColors === void 0 ? presetColors : _ref2$userColors,
      _ref2$widget = _ref2.widget,
      widget = _ref2$widget === void 0 ? "sketch" : _ref2$widget,
      input = _ref2.input;
  var FormPortal = useFormPortal();
  var triggerRef = react.exports.useRef(null);

  var _useState = react.exports.useState(null),
      triggerBoundingBox = _useState[0],
      setTriggerBoundingBox = _useState[1];

  var _useState2 = react.exports.useState(false),
      openTop = _useState2[0],
      setOpenTop = _useState2[1];

  var updateTriggerBoundingBox = function updateTriggerBoundingBox() {
    if (triggerRef.current) {
      setTriggerBoundingBox(triggerRef.current.getBoundingClientRect());
    }
  };

  react.exports.useEffect(function () {
    if (triggerBoundingBox) {
      var triggerOffsetTop = triggerBoundingBox.top + triggerBoundingBox.height / 2;
      var windowHeight = window.innerHeight;

      if (triggerOffsetTop > windowHeight / 2) {
        setOpenTop(true);
      } else {
        setOpenTop(false);
      }
    }
  }, [triggerBoundingBox]);
  react.exports.useEffect(function () {
    var delay = 100;
    var timeout = false;
    setTimeout(function () {
      updateTriggerBoundingBox();
    }, delay);

    var handleResize = function handleResize() {
      clearTimeout(timeout);
      timeout = setTimeout(updateTriggerBoundingBox, delay);
    };

    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [triggerRef.current]);
  var Widget = WIDGETS[widget];
  if (!Widget) throw new Error("You must specify a widget type.");

  var _useState3 = react.exports.useState(false),
      displayColorPicker = _useState3[0],
      setDisplayColorPicker = _useState3[1];

  var getColorFormat = (colorFormat || ColorFormat.Hex).toLowerCase();
  var getColorRGBA = input.value ? ColorFormatter[getColorFormat].parse(input.value) : null;

  var handleChange = function handleChange(pickerColor) {
    var color = pickerColor.hex === nullColor ? null : _objectSpread$V(_objectSpread$V({}, pickerColor.rgb), {}, {
      a: 1
    });
    input.onChange(color ? ColorFormatter[getColorFormat].getValue(color) : null);
  };

  var toggleColorPicker = function toggleColorPicker(event) {
    event.stopPropagation();
    var display = !displayColorPicker;
    setDisplayColorPicker(display);

    if (display) {
      updateTriggerBoundingBox();
    }
  };

  return __jsx$E(ColorPickerWrapper, {
    ref: triggerRef
  }, __jsx$E(Swatch, {
    onClick: toggleColorPicker,
    colorRGBA: getColorRGBA,
    colorFormat: getColorFormat
  }), displayColorPicker && __jsx$E(FormPortal, null, __jsx$E(Popover, {
    openTop: openTop,
    triggerBoundingBox: triggerBoundingBox
  }, __jsx$E(build.exports.Dismissible, {
    click: true,
    escape: true,
    disabled: !displayColorPicker,
    onDismiss: toggleColorPicker
  }, __jsx$E(Widget, {
    presetColors: [].concat(_toConsumableArray$2(userColors), [nullColor]),
    color: getColorRGBA || {
      r: 0,
      g: 0,
      b: 0,
      a: 0
    },
    onChange: handleChange,
    disableAlpha: true,
    width: "240px"
  })))));
};

var __jsx$D = react.exports.createElement;

function ownKeys$U(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$U(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$U(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$U(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Toggle = function Toggle(_ref) {
  var input = _ref.input,
      field = _ref.field;
      _ref.name;
      var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var checked = !!(input.value || input.checked);

  var toggleProps = _objectSpread$U(_objectSpread$U({}, input), {}, {
    labels: null,
    name: field.name,
    disabled: disabled,
    value: checked,
    checked: checked
  });

  return __jsx$D(ToggleFieldWrapper, null, __jsx$D(SSToggle, toggleProps));
};
var ToggleFieldWrapper = styled.div.withConfig({
  displayName: "Toggle__ToggleFieldWrapper",
  componentId: "sc-arbxdj-0"
})(["display:flex;justify-content:flex-end;"]);

var MIXED_VALUE = "__MIXED__";
var COMPONENTS_SUPPORTING_MIXED_VALUES = ["ss-block", "radio-group", "select", "token"];

function isMixedFieldValue(value) {
  return typeof value === "object" && value !== null && "__mixed__" in value && value.__mixed__;
}

var __jsx$C = react.exports.createElement;
var NULL_VALUE = "__NULL__";
var Select = function Select(_ref) {
  var input = _ref.input,
      field = _ref.field,
      options = _ref.options;
  var value = input.value,
      onChange = input.onChange;
  var isMixedValue = isMixedFieldValue(value);
  var selectOptions = options || field.options;
  var normalizedSelectOptions = selectOptions.map(toProps);

  if (isMixedValue) {
    normalizedSelectOptions.unshift({
      label: "Mixed",
      value: MIXED_VALUE
    }, {
      isDivider: true
    });
  }

  var inputValue = isMixedValue ? MIXED_VALUE : value;

  if (field.nullLabel) {
    normalizedSelectOptions = [{
      value: NULL_VALUE,
      label: field.nullLabel
    }].concat(_toConsumableArray$2(normalizedSelectOptions));
    inputValue = inputValue || NULL_VALUE;
  }

  var handleChange = function handleChange(event) {
    event.stopPropagation();
    var value = event.target.value;

    if (value === NULL_VALUE) {
      onChange(null);
    } else {
      onChange(event);
    }
  };

  return __jsx$C(SSSelect, _extends$b({}, input, {
    value: inputValue,
    icon: field.icon,
    onChange: handleChange,
    size: "full-width"
  }), normalizedSelectOptions ? normalizedSelectOptions.map(toComponent) : __jsx$C("option", null, inputValue));
};

function toProps(option) {
  if (typeof option === "object") return option;
  return {
    value: option,
    label: option
  };
}

function toComponent(option) {
  if ("isDivider" in option) {
    return __jsx$C("option", {
      disabled: true,
      key: "divider",
      "aria-hidden": "true"
    }, "----------");
  }

  return __jsx$C("option", {
    key: option.value,
    value: option.value,
    disabled: option.value === MIXED_VALUE
  }, option.label);
}

var __jsx$B = react.exports.createElement;
var RadioGroup = function RadioGroup(_ref) {
  var input = _ref.input,
      field = _ref.field,
      options = _ref.options;
  var value = input.value;

  var _React$useState = react.exports.useState(null),
      _React$useState2 = _slicedToArray$2(_React$useState, 2);
      _React$useState2[0];
      var setActiveRadioRef = _React$useState2[1];

  var radioOptions = options || field.options;
  var radioRefs = {};
  var toggleButtonValue = isMixedFieldValue(value) ? undefined : value;
  react.exports.useEffect(function () {
    if (toggleButtonValue) {
      setActiveRadioRef(radioRefs["radio_".concat(toggleButtonValue)]);
    }
  }, [toggleButtonValue]);

  var toProps = function toProps(option) {
    if (typeof option === "object") return option;
    return {
      value: option,
      label: option
    };
  };

  var radioOptionsMapped = radioOptions ? radioOptions.map(toProps) : [];
  return radioOptionsMapped && __jsx$B(SSSelectInline, _extends$b({}, input, {
    value: toggleButtonValue
  }), radioOptionsMapped.map(function (option) {
    return __jsx$B(SSToggleButton, {
      key: option.value,
      icon: option.icon,
      value: option.value,
      hideLabel: option.hideLabel
    }, option.label);
  }));
};
styled.span.withConfig({
  displayName: "RadioGroup__Label",
  componentId: "sc-1ovmjz5-0"
})(["", ""], function (p) {
  return p.variant === "button" ? "position: relative;" : "";
});
styled.div.withConfig({
  displayName: "RadioGroup__ActiveRadioIndicator",
  componentId: "sc-1ovmjz5-1"
})(["position:absolute;", ";", ";", ";", " ", " transition:all 85ms ease-out;backface-visibility:hidden;background-color:var(--tina-color-primary);box-shadow:var(--tina-shadow-small);border-radius:var(--tina-radius-big);height:calc(40px - 6px);pointer-events:none;"], function (p) {
  return p.width ? "width: ".concat(p.width, "px;") : "";
}, function (p) {
  return p.height ? "height: ".concat(p.width, "px;") : "";
}, function (p) {
  return p.left ? "left: ".concat(p.left, "px;") : "";
}, function (p) {
  return p.top ? "top: ".concat(p.top, "px;") : "";
}, function (p) {
  return "transform: scale(".concat(p.hasValue ? "1" : "0", ");");
});
styled.div.withConfig({
  displayName: "RadioGroup__RadioOptions",
  componentId: "sc-1ovmjz5-2"
})(["display:flex;padding-top:4px;", " ", ""], function (p) {
  return p.variant === "button" ? "\n    min-height: calc(40px + 2px);\n    background-color: var(--tina-color-grey-0);\n    border-radius: var(--tina-radius-big);\n    box-shadow: var(--tina-shadow-small);\n    background-color: var(--tina-color-grey-0);\n    border: 1px solid var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    padding: 3px;\n    box-shadow: 0 0 0 0 var(--tina-color-grey-3);\n    transition: all 85ms ease-out;\n    gap: 3px;\n    &:hover {\n      box-shadow: 0 0 0 2px var(--tina-color-grey-3);\n    }\n    &:focus-within, &:active {\n      box-shadow: 0 0 0 2px var(--tina-color-primary);\n    }\n  " : "\n    gap: 12px;\n    flex-wrap: wrap;\n  ";
}, function (p) {
  return p.direction === "vertical" ? "flex-direction: column;" : "";
});
styled.div.withConfig({
  displayName: "RadioGroup__RadioOptionWrap",
  componentId: "sc-1ovmjz5-3"
})(["", " & > input{position:absolute;opacity:0;cursor:pointer;height:0;width:0;}"], function (p) {
  return p.variant === "button" ? "\n      \n    flex: 1;\n    " : "";
});
styled.label.withConfig({
  displayName: "RadioGroup__RadioOption",
  componentId: "sc-1ovmjz5-4"
})(["display:flex;align-items:center;font-size:var(--tina-font-size-1);", ""], function (p) {
  return p.variant === "button" ? "\n    flex: 1;\n    text-align: center;\n    border-radius: var(--tina-radius-big);\n    border: 1px solid var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    font-weight: var(--tina-font-weight-regular);\n    cursor: pointer;\n    font-size: var(--tina-font-size-1);\n    height: calc(40px - 6px);\n    padding: 0 var(--tina-padding-small);\n    transition: all 85ms ease-out;\n    margin: 0;\n    border: none;\n    text-align: center;\n    justify-content: center;\n    input:checked + & {\n      color: var(--tina-color-grey-0);\n    }\n    &:hover {\n      background-color: var(--tina-color-grey-1);\n    }\n    &:active {\n      background-color: var(--tina-color-grey-2);\n    }\n  " : "\n  &:before {\n    content: '';\n    display: block;\n    width: 16px;\n    height: 16px;\n    margin-right: 4px;\n    border-radius: var(--tina-radius-big);\n    background-color: var(--tina-color-primary);\n    border: 1px solid var(".concat(function (p) {
    return p.checked ? "--tina-color-primary" : "--tina-color-grey-2";
  }, ");\n    box-shadow: 0 0 0 0 var(--tina-color-grey-3), inset 0 0 0 8px white;\n    transition: all 85ms ease-out;\n  }\n  &:hover:before {\n    box-shadow: 0 0 0 2px var(--tina-color-grey-3), inset 0 0 0 8px white;\n  }\n  input:focus + &:before {\n    border: 1px solid var(--tina-color-grey-2);\n    box-shadow: 0 0 0 2px var(--tina-color-primary), inset 0 0 0 8px white;\n  }\n  input:checked + &:before {\n    border: 1px solid var(--tina-color-primary);\n    box-shadow: 0 0 0 0 var(--tina-color-primary), inset 0 0 0 4px white;\n  }\n  input:checked:focus + &:before {\n    border: 1px solid var(--tina-color-grey-2);\n    box-shadow: 0 0 0 2px var(--tina-color-primary), inset 0 0 0 4px white;\n  }\n  ");
});

var __jsx$A = react.exports.createElement;
var NumberInput = function NumberInput(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      step = _ref.step,
      min = _ref.min,
      max = _ref.max;
  return __jsx$A(SSInput, {
    type: "number" // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    step: step,
    value: value,
    onChange: onChange,
    min: min,
    max: max
  });
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}
/** @deprecated */

function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}

var COMMON_MIME_TYPES = new Map([['avi', 'video/avi'], ['gif', 'image/gif'], ['ico', 'image/x-icon'], ['jpeg', 'image/jpeg'], ['jpg', 'image/jpeg'], ['mkv', 'video/x-matroska'], ['mov', 'video/quicktime'], ['mp4', 'video/mp4'], ['pdf', 'application/pdf'], ['png', 'image/png'], ['zip', 'application/zip'], ['doc', 'application/msword'], ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']]);
function toFileWithPath(file, path) {
  var f = withMimeType(file);

  if (typeof f.path !== 'string') {
    // on electron, path is already set to the absolute path
    var webkitRelativePath = file.webkitRelativePath;
    Object.defineProperty(f, 'path', {
      value: typeof path === 'string' ? path // If <input webkitdirectory> is set,
      // the File will have a {webkitRelativePath} property
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
      : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
      writable: false,
      configurable: false,
      enumerable: true
    });
  }

  return f;
}

function withMimeType(file) {
  var name = file.name;
  var hasExtension = name && name.lastIndexOf('.') !== -1;

  if (hasExtension && !file.type) {
    var ext = name.split('.').pop().toLowerCase();
    var type = COMMON_MIME_TYPES.get(ext);

    if (type) {
      Object.defineProperty(file, 'type', {
        value: type,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  }

  return file;
}

var FILES_TO_IGNORE = [// Thumbnail cache files for macOS and Windows
'.DS_Store', 'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */

function fromEvent(evt) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , isDragEvt(evt) && evt.dataTransfer ? getDataTransferFiles(evt.dataTransfer, evt.type) : getInputFiles(evt)];
    });
  });
}

function isDragEvt(value) {
  return !!value.dataTransfer;
}

function getInputFiles(evt) {
  var files = isInput(evt.target) ? evt.target.files ? fromList(evt.target.files) : [] : [];
  return files.map(function (file) {
    return toFileWithPath(file);
  });
}

function isInput(value) {
  return value !== null;
}

function getDataTransferFiles(dt, type) {
  return __awaiter(this, void 0, void 0, function () {
    var items, files;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!dt.items) return [3
          /*break*/
          , 2];
          items = fromList(dt.items).filter(function (item) {
            return item.kind === 'file';
          }); // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
          // only 'dragstart' and 'drop' has access to the data (source node)

          if (type !== 'drop') {
            return [2
            /*return*/
            , items];
          }

          return [4
          /*yield*/
          , Promise.all(items.map(toFilePromises))];

        case 1:
          files = _a.sent();
          return [2
          /*return*/
          , noIgnoredFiles(flatten(files))];

        case 2:
          return [2
          /*return*/
          , noIgnoredFiles(fromList(dt.files).map(function (file) {
            return toFileWithPath(file);
          }))];
      }
    });
  });
}

function noIgnoredFiles(files) {
  return files.filter(function (file) {
    return FILES_TO_IGNORE.indexOf(file.name) === -1;
  });
} // IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList


function fromList(items) {
  var files = []; // tslint:disable: prefer-for-of

  for (var i = 0; i < items.length; i++) {
    var file = items[i];
    files.push(file);
  }

  return files;
} // https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem


function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry !== 'function') {
    return fromDataTransferItem(item);
  }

  var entry = item.webkitGetAsEntry(); // Safari supports dropping an image node from a different window and can be retrieved using
  // the DataTransferItem.getAsFile() API
  // NOTE: FileSystemEntry.file() throws if trying to get the file

  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }

  return fromDataTransferItem(item);
}

function flatten(items) {
  return items.reduce(function (acc, files) {
    return __spread(acc, Array.isArray(files) ? flatten(files) : [files]);
  }, []);
}

function fromDataTransferItem(item) {
  var file = item.getAsFile();

  if (!file) {
    return Promise.reject(item + " is not a File");
  }

  var fwp = toFileWithPath(file);
  return Promise.resolve(fwp);
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry


function fromEntry(entry) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
    });
  });
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry


function fromDirEntry(entry) {
  var reader = entry.createReader();
  return new Promise(function (resolve, reject) {
    var entries = [];

    function readEntries() {
      var _this = this; // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
      // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries


      reader.readEntries(function (batch) {
        return __awaiter(_this, void 0, void 0, function () {
          var files, err_1, items;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!!batch.length) return [3
                /*break*/
                , 5];
                _a.label = 1;

              case 1:
                _a.trys.push([1, 3,, 4]);

                return [4
                /*yield*/
                , Promise.all(entries)];

              case 2:
                files = _a.sent();
                resolve(files);
                return [3
                /*break*/
                , 4];

              case 3:
                err_1 = _a.sent();
                reject(err_1);
                return [3
                /*break*/
                , 4];

              case 4:
                return [3
                /*break*/
                , 6];

              case 5:
                items = Promise.all(batch.map(fromEntry));
                entries.push(items); // Continue reading

                readEntries();
                _a.label = 6;

              case 6:
                return [2
                /*return*/
                ];
            }
          });
        });
      }, function (err) {
        reject(err);
      });
    }

    readEntries();
  });
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry


function fromFileEntry(entry) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , new Promise(function (resolve, reject) {
        entry.file(function (file) {
          var fwp = toFileWithPath(file, entry.fullPath);
          resolve(fwp);
        }, function (err) {
          reject(err);
        });
      })];
    });
  });
}

var dist = function (t) {
  function n(e) {
    if (r[e]) return r[e].exports;
    var o = r[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return t[e].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  var r = {};
  return n.m = t, n.c = r, n.d = function (t, r, e) {
    n.o(t, r) || Object.defineProperty(t, r, {
      configurable: !1,
      enumerable: !0,
      get: e
    });
  }, n.n = function (t) {
    var r = t && t.__esModule ? function () {
      return t["default"];
    } : function () {
      return t;
    };
    return n.d(r, "a", r), r;
  }, n.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n);
  }, n.p = "", n(n.s = 13);
}([function (t, n) {
  var r = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
  "number" == typeof __g && (__g = r);
}, function (t, n) {
  t.exports = function (t) {
    return "object" == typeof t ? null !== t : "function" == typeof t;
  };
}, function (t, n) {
  var r = t.exports = {
    version: "2.5.0"
  };
  "number" == typeof __e && (__e = r);
}, function (t, n, r) {
  t.exports = !r(4)(function () {
    return 7 != Object.defineProperty({}, "a", {
      get: function get() {
        return 7;
      }
    }).a;
  });
}, function (t, n) {
  t.exports = function (t) {
    try {
      return !!t();
    } catch (t) {
      return !0;
    }
  };
}, function (t, n) {
  var r = {}.toString;

  t.exports = function (t) {
    return r.call(t).slice(8, -1);
  };
}, function (t, n, r) {
  var e = r(32)("wks"),
      o = r(9),
      i = r(0).Symbol,
      u = "function" == typeof i;
  (t.exports = function (t) {
    return e[t] || (e[t] = u && i[t] || (u ? i : o)("Symbol." + t));
  }).store = e;
}, function (t, n, r) {
  var e = r(0),
      o = r(2),
      i = r(8),
      u = r(22),
      c = r(10),
      f = function f(t, n, r) {
    var a,
        s,
        p,
        l,
        v = t & f.F,
        y = t & f.G,
        h = t & f.S,
        d = t & f.P,
        x = t & f.B,
        g = y ? e : h ? e[n] || (e[n] = {}) : (e[n] || {}).prototype,
        m = y ? o : o[n] || (o[n] = {}),
        b = m.prototype || (m.prototype = {});
    y && (r = n);

    for (a in r) {
      s = !v && g && void 0 !== g[a], p = (s ? g : r)[a], l = x && s ? c(p, e) : d && "function" == typeof p ? c(Function.call, p) : p, g && u(g, a, p, t & f.U), m[a] != p && i(m, a, l), d && b[a] != p && (b[a] = p);
    }
  };

  e.core = o, f.F = 1, f.G = 2, f.S = 4, f.P = 8, f.B = 16, f.W = 32, f.U = 64, f.R = 128, t.exports = f;
}, function (t, n, r) {
  var e = r(16),
      o = r(21);
  t.exports = r(3) ? function (t, n, r) {
    return e.f(t, n, o(1, r));
  } : function (t, n, r) {
    return t[n] = r, t;
  };
}, function (t, n) {
  var r = 0,
      e = Math.random();

  t.exports = function (t) {
    return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++r + e).toString(36));
  };
}, function (t, n, r) {
  var e = r(24);

  t.exports = function (t, n, r) {
    if (e(t), void 0 === n) return t;

    switch (r) {
      case 1:
        return function (r) {
          return t.call(n, r);
        };

      case 2:
        return function (r, e) {
          return t.call(n, r, e);
        };

      case 3:
        return function (r, e, o) {
          return t.call(n, r, e, o);
        };
    }

    return function () {
      return t.apply(n, arguments);
    };
  };
}, function (t, n) {
  t.exports = function (t) {
    if (void 0 == t) throw TypeError("Can't call method on  " + t);
    return t;
  };
}, function (t, n, r) {
  var e = r(28),
      o = Math.min;

  t.exports = function (t) {
    return t > 0 ? o(e(t), 9007199254740991) : 0;
  };
}, function (t, n, r) {

  n.__esModule = !0, n["default"] = function (t, n) {
    if (t && n) {
      var r = Array.isArray(n) ? n : n.split(","),
          e = t.name || "",
          o = t.type || "",
          i = o.replace(/\/.*$/, "");
      return r.some(function (t) {
        var n = t.trim();
        return "." === n.charAt(0) ? e.toLowerCase().endsWith(n.toLowerCase()) : n.endsWith("/*") ? i === n.replace(/\/.*$/, "") : o === n;
      });
    }

    return !0;
  }, r(14), r(34);
}, function (t, n, r) {
  r(15), t.exports = r(2).Array.some;
}, function (t, n, r) {

  var e = r(7),
      o = r(25)(3);
  e(e.P + e.F * !r(33)([].some, !0), "Array", {
    some: function some(t) {
      return o(this, t, arguments[1]);
    }
  });
}, function (t, n, r) {
  var e = r(17),
      o = r(18),
      i = r(20),
      u = Object.defineProperty;
  n.f = r(3) ? Object.defineProperty : function (t, n, r) {
    if (e(t), n = i(n, !0), e(r), o) try {
      return u(t, n, r);
    } catch (t) {}
    if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
    return "value" in r && (t[n] = r.value), t;
  };
}, function (t, n, r) {
  var e = r(1);

  t.exports = function (t) {
    if (!e(t)) throw TypeError(t + " is not an object!");
    return t;
  };
}, function (t, n, r) {
  t.exports = !r(3) && !r(4)(function () {
    return 7 != Object.defineProperty(r(19)("div"), "a", {
      get: function get() {
        return 7;
      }
    }).a;
  });
}, function (t, n, r) {
  var e = r(1),
      o = r(0).document,
      i = e(o) && e(o.createElement);

  t.exports = function (t) {
    return i ? o.createElement(t) : {};
  };
}, function (t, n, r) {
  var e = r(1);

  t.exports = function (t, n) {
    if (!e(t)) return t;
    var r, o;
    if (n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
    if ("function" == typeof (r = t.valueOf) && !e(o = r.call(t))) return o;
    if (!n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
    throw TypeError("Can't convert object to primitive value");
  };
}, function (t, n) {
  t.exports = function (t, n) {
    return {
      enumerable: !(1 & t),
      configurable: !(2 & t),
      writable: !(4 & t),
      value: n
    };
  };
}, function (t, n, r) {
  var e = r(0),
      o = r(8),
      i = r(23),
      u = r(9)("src"),
      c = Function.toString,
      f = ("" + c).split("toString");
  r(2).inspectSource = function (t) {
    return c.call(t);
  }, (t.exports = function (t, n, r, c) {
    var a = "function" == typeof r;
    a && (i(r, "name") || o(r, "name", n)), t[n] !== r && (a && (i(r, u) || o(r, u, t[n] ? "" + t[n] : f.join(String(n)))), t === e ? t[n] = r : c ? t[n] ? t[n] = r : o(t, n, r) : (delete t[n], o(t, n, r)));
  })(Function.prototype, "toString", function () {
    return "function" == typeof this && this[u] || c.call(this);
  });
}, function (t, n) {
  var r = {}.hasOwnProperty;

  t.exports = function (t, n) {
    return r.call(t, n);
  };
}, function (t, n) {
  t.exports = function (t) {
    if ("function" != typeof t) throw TypeError(t + " is not a function!");
    return t;
  };
}, function (t, n, r) {
  var e = r(10),
      o = r(26),
      i = r(27),
      u = r(12),
      c = r(29);

  t.exports = function (t, n) {
    var r = 1 == t,
        f = 2 == t,
        a = 3 == t,
        s = 4 == t,
        p = 6 == t,
        l = 5 == t || p,
        v = n || c;
    return function (n, c, y) {
      for (var h, d, x = i(n), g = o(x), m = e(c, y, 3), b = u(g.length), _ = 0, w = r ? v(n, b) : f ? v(n, 0) : void 0; b > _; _++) {
        if ((l || _ in g) && (h = g[_], d = m(h, _, x), t)) if (r) w[_] = d;else if (d) switch (t) {
          case 3:
            return !0;

          case 5:
            return h;

          case 6:
            return _;

          case 2:
            w.push(h);
        } else if (s) return !1;
      }

      return p ? -1 : a || s ? s : w;
    };
  };
}, function (t, n, r) {
  var e = r(5);
  t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
    return "String" == e(t) ? t.split("") : Object(t);
  };
}, function (t, n, r) {
  var e = r(11);

  t.exports = function (t) {
    return Object(e(t));
  };
}, function (t, n) {
  var r = Math.ceil,
      e = Math.floor;

  t.exports = function (t) {
    return isNaN(t = +t) ? 0 : (t > 0 ? e : r)(t);
  };
}, function (t, n, r) {
  var e = r(30);

  t.exports = function (t, n) {
    return new (e(t))(n);
  };
}, function (t, n, r) {
  var e = r(1),
      o = r(31),
      i = r(6)("species");

  t.exports = function (t) {
    var n;
    return o(t) && (n = t.constructor, "function" != typeof n || n !== Array && !o(n.prototype) || (n = void 0), e(n) && null === (n = n[i]) && (n = void 0)), void 0 === n ? Array : n;
  };
}, function (t, n, r) {
  var e = r(5);

  t.exports = Array.isArray || function (t) {
    return "Array" == e(t);
  };
}, function (t, n, r) {
  var e = r(0),
      o = e["__core-js_shared__"] || (e["__core-js_shared__"] = {});

  t.exports = function (t) {
    return o[t] || (o[t] = {});
  };
}, function (t, n, r) {

  var e = r(4);

  t.exports = function (t, n) {
    return !!t && e(function () {
      n ? t.call(null, function () {}, 1) : t.call(null);
    });
  };
}, function (t, n, r) {
  r(35), t.exports = r(2).String.endsWith;
}, function (t, n, r) {

  var e = r(7),
      o = r(12),
      i = r(36),
      u = "".endsWith;
  e(e.P + e.F * r(38)("endsWith"), "String", {
    endsWith: function endsWith(t) {
      var n = i(this, t, "endsWith"),
          r = arguments.length > 1 ? arguments[1] : void 0,
          e = o(n.length),
          c = void 0 === r ? e : Math.min(o(r), e),
          f = String(t);
      return u ? u.call(n, f, c) : n.slice(c - f.length, c) === f;
    }
  });
}, function (t, n, r) {
  var e = r(37),
      o = r(11);

  t.exports = function (t, n, r) {
    if (e(n)) throw TypeError("String#" + r + " doesn't accept regex!");
    return String(o(t));
  };
}, function (t, n, r) {
  var e = r(1),
      o = r(5),
      i = r(6)("match");

  t.exports = function (t) {
    var n;
    return e(t) && (void 0 !== (n = t[i]) ? !!n : "RegExp" == o(t));
  };
}, function (t, n, r) {
  var e = r(6)("match");

  t.exports = function (t) {
    var n = /./;

    try {
      "/./"[t](n);
    } catch (r) {
      try {
        return n[e] = !1, !"/./"[t](n);
      } catch (t) {}
    }

    return !0;
  };
}]);

// that MIME type will always be accepted

function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || dist(file, accept);
}
function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}
function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit$1(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectSpread$T(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$b(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty$b(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof$4(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$4 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$4 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$4(obj);
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/react.exports.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties$1(_ref, ["children"]);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties$1(_useDropzone, ["open"]);

  react.exports.useEffect(function () {
    if (typeof ref === 'function') {
      ref({
        open: open
      });
    } else if (_typeof$4(ref) === 'object' && ref !== null) {
      ref.current = {
        open: open
      };
    }

    return function () {
      if (typeof ref === 'function') {
        ref(null);
      } else if (_typeof$4(ref) === 'object' && ref !== null) {
        ref.current = null;
      }
    };
  }, [ref]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React.createElement(react.exports.Fragment, null, children(_objectSpread$T({}, props, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone';
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {File[]} params.rejectedFiles Rejected files
   */
  children: PropTypes.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {File[]} rejectedFiles
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {object[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {File[]} rejectedFiles List of rejected files
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {File[]} rejectedFiles Rejected files
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  rejectedFiles: []
  /**
   * A React hook that creates a drag 'n' drop area.
   *
   * ```jsx
   * function MyDropzone(props) {
   *   const {getRootProps, getInputProps} = useDropzone({
   *     onDrop: acceptedFiles => {
   *       // do something with the File objects, e.g. upload to some server
   *     }
   *   });
   *   return (
   *     <div {...getRootProps()}>
   *       <input {...getInputProps()} />
   *       <p>Drag and drop some files here, or click to select files</p>
   *     </div>
   *   )
   * }
   * ```
   *
   * @function useDropzone
   *
   * @param {object} props
   * @param {string|string[]} [props.accept] Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
   * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
   * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
   * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
   * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
   * @param {number} [props.minSize=0] Minimum file size (in bytes)
   * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
   * @param {boolean} [props.disabled=false] Enable/disable the dropzone
   * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
   * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
   * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
   * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
   * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
   * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   * @param {dropAcceptedCb} [props.onDropAccepted]
   * @param {dropRejectedCb} [props.onDropRejected]
   *
   * @returns {DropzoneState}
   */

};
function useDropzone() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      accept = _ref2.accept,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$getFilesFromEve = _ref2.getFilesFromEvent,
      getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? fromEvent : _ref2$getFilesFromEve,
      _ref2$maxSize = _ref2.maxSize,
      maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize,
      _ref2$minSize = _ref2.minSize,
      minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? true : _ref2$multiple,
      onDragEnter = _ref2.onDragEnter,
      onDragLeave = _ref2.onDragLeave,
      onDragOver = _ref2.onDragOver,
      onDrop = _ref2.onDrop,
      onDropAccepted = _ref2.onDropAccepted,
      onDropRejected = _ref2.onDropRejected,
      onFileDialogCancel = _ref2.onFileDialogCancel,
      _ref2$preventDropOnDo = _ref2.preventDropOnDocument,
      preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo,
      _ref2$noClick = _ref2.noClick,
      noClick = _ref2$noClick === void 0 ? false : _ref2$noClick,
      _ref2$noKeyboard = _ref2.noKeyboard,
      noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard,
      _ref2$noDrag = _ref2.noDrag,
      noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag,
      _ref2$noDragEventsBub = _ref2.noDragEventsBubbling,
      noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;

  var rootRef = react.exports.useRef(null);
  var inputRef = react.exports.useRef(null);

  var _useReducer = react.exports.useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray$1(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = function openFileDialog() {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }; // Update file dialog active state when the window is focused on


  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  react.exports.useEffect(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = react.exports.useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]); // Update focus state for the dropzone

  var onFocusCb = react.exports.useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = react.exports.useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = react.exports.useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);

  var _useState = react.exports.useState([]),
      _useState2 = _slicedToArray$1(_useState, 2),
      dragTargets = _useState2[0],
      setDragTargets = _useState2[1];

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    setDragTargets([]);
  };

  react.exports.useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = react.exports.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event); // Count the dropzone and any children that are entered.

    if (dragTargets.indexOf(event.target) === -1) {
      setDragTargets([].concat(_toConsumableArray$1(dragTargets), [event.target]));
    }

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [dragTargets, getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = react.exports.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);

    if (event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (isEvtWithFiles(event) && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = react.exports.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = _toConsumableArray$1(dragTargets.filter(function (target) {
      return target !== event.target && rootRef.current && rootRef.current.contains(target);
    }));

    setDragTargets(targets);

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, dragTargets, onDragLeave, noDragEventsBubbling]);
  var onDropCb = react.exports.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    setDragTargets([]);
    dispatch({
      type: 'reset'
    });

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var rejectedFiles = [];
        files.forEach(function (file) {
          if (fileAccepted(file, accept) && fileMatchSize(file, maxSize, minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple && acceptedFiles.length > 1) {
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray$1(acceptedFiles.splice(0))); // Reject everything and empty accepted files
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          rejectedFiles: rejectedFiles,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, rejectedFiles, event);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected(rejectedFiles, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }
  }, [multiple, accept, minSize, maxSize, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = react.exports.useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onKeyDown = _ref3.onKeyDown,
          onFocus = _ref3.onFocus,
          onBlur = _ref3.onBlur,
          onClick = _ref3.onClick,
          onDragEnter = _ref3.onDragEnter,
          onDragOver = _ref3.onDragOver,
          onDragLeave = _ref3.onDragLeave,
          onDrop = _ref3.onDrop,
          rest = _objectWithoutProperties$1(_ref3, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

      return _objectSpread$T(_defineProperty$b({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}, rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = react.exports.useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = react.exports.useMemo(function () {
    return function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$refKey = _ref4.refKey,
          refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
          onChange = _ref4.onChange,
          onClick = _ref4.onClick,
          rest = _objectWithoutProperties$1(_ref4, ["refKey", "onChange", "onClick"]);

      var inputProps = _defineProperty$b({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread$T({}, inputProps, rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isMultipleAllowed = multiple || fileCount <= 1;
  var isDragAccept = fileCount > 0 && allFilesAccepted(draggedFiles, accept);
  var isDragReject = fileCount > 0 && (!isDragAccept || !isMultipleAllowed);
  return _objectSpread$T({}, state, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread$T({}, state, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread$T({}, state, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread$T({}, state, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread$T({}, state, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread$T({}, state, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread$T({}, state, {
        acceptedFiles: action.acceptedFiles,
        rejectedFiles: action.rejectedFiles
      });

    case 'reset':
      return _objectSpread$T({}, state, {
        isFileDialogActive: false,
        isDragActive: false,
        draggedFiles: []
      });

    default:
      return state;
  }
}

var __jsx$z = react.exports.createElement;
var DropArea = styled.div.withConfig({
  displayName: "ImageUpload__DropArea",
  componentId: "sc-13la4l7-0"
})(["border-radius:var(--tina-radius-small);flex:1;display:flex;flex-direction:column;outline:none;cursor:pointer;"]);
var ImgPlaceholder = styled.div.withConfig({
  displayName: "ImageUpload__ImgPlaceholder",
  componentId: "sc-13la4l7-1"
})(["text-align:center;border-radius:var(--tina-radius-small);background-color:var(--tina-color-grey-2);color:var(--tina-color-grey-4);line-height:1.35;padding:12px 0;font-size:var(--tina-font-size-2);font-weight:var(--tina-font-weight-regular);transition:all 85ms ease-out;&:hover{opacity:0.6;}"]);
var StyledImage = styled.img.withConfig({
  displayName: "ImageUpload__StyledImage",
  componentId: "sc-13la4l7-2"
})(["max-width:100%;min-height:100px;border-radius:var(--tina-radius-small);transition:opacity var(--tina-timing-short) ease-out;margin:0;display:block;background-color:#e1ddec;background-size:auto;background-position:center center;background-repeat:no-repeat;", ""], function (props) {
  return props.src && (props.src.includes("png") || props.src.includes("svg")) ? Ce(["background-image:none;"]) : Ce(["background-image:url(\"data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='40px' height='50px' viewBox='0 0 40 50' style='enable-background:new 0 0 40 50;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cdefs%3E%3C/defs%3E%3Cpath class='st0' d='M16.09,24.97c-3.31,0.55-6.16-2.09-5.57-5.16c0.34-1.73,1.82-3.14,3.68-3.5c3.39-0.66,6.37,2.11,5.67,5.25 C19.48,23.28,17.96,24.66,16.09,24.97z M1.88,26.75c0-7.69,0-15.38,0-23.07C2,3.64,1.97,3.53,1.99,3.45c0.5-1.7,1.64-2.82,3.48-3.31 C5.57,0.12,5.71,0.14,5.75,0c7.31,0,14.63,0,21.94,0c0.03,0.1,0.12,0.08,0.2,0.1c0.96,0.2,1.77,0.63,2.47,1.28 c2.72,2.52,5.44,5.05,8.16,7.57c0.68,0.63,1.14,1.38,1.37,2.24c0.02,0.08-0.02,0.19,0.11,0.23c0,5.11,0,10.22,0,15.34h-4.76 c0-3.38,0-6.75,0-10.13c0-0.35-0.1-0.43-0.46-0.43c-3.21,0.01-6.42,0.01-9.63,0.01c-1.65,0-2.62-0.9-2.62-2.42 c0-2.94-0.01-5.89,0.01-8.83c0-0.46-0.14-0.54-0.6-0.53c-4.91,0.02-9.83,0.02-14.74,0c-0.44,0-0.57,0.09-0.57,0.52 c0.02,6.21,0.01,12.42,0.01,18.63c0,1.06,0,2.12,0,3.18H1.88z M27.28,11.46c0,0.31,0.14,0.34,0.41,0.34c2.25-0.01,4.5,0,6.75-0.01 c0.09,0,0.2,0.04,0.24,0c-2.46-2.28-4.92-4.56-7.39-6.85C27.29,7.1,27.3,9.28,27.28,11.46z M33.37,29.61c0,5.18-0.01,10.37,0,15.55 c0,0.35-0.1,0.43-0.46,0.43c-9.23-0.01-18.46-0.01-27.69,0c-0.44,0-0.45-0.17-0.45-0.48c0.01-5.17,0-10.33,0-15.5H0 c0,5.6,0,11.19,0,16.79c0.17,0.09,0.15,0.26,0.19,0.4c0.57,1.85,2.39,3.18,4.47,3.19c9.6,0.01,19.2,0.01,28.81,0 c2.08,0,3.89-1.33,4.47-3.19c0.04-0.14,0.02-0.31,0.19-0.4c0-5.6,0-11.19,0-16.79H33.37z M29.75,42.62c0.34,0,0.44-0.06,0.44-0.4 c-0.01-3.68-0.01-4.6-0.01-8.28c0-0.25-0.08-0.43-0.28-0.6c-0.62-0.55-1.22-1.13-1.83-1.69c-0.79-0.73-1.36-0.74-2.15-0.01 c-2.71,2.52-5.43,5.03-8.13,7.55c-0.26,0.25-0.39,0.24-0.65,0c-1.13-1.08-2.28-2.13-3.43-3.19c-0.7-0.65-1.31-0.65-2.01,0 c-1.16,1.07-2.31,2.15-3.48,3.22c-0.2,0.19-0.29,0.37-0.29,0.64c0.01,1.69,0.03,0.61,0,2.3c-0.01,0.41,0.14,0.46,0.53,0.46 c3.52-0.01,7.05-0.01,10.57-0.01C22.6,42.61,26.17,42.61,29.75,42.62z'/%3E%3C/svg%3E\");"]);
}); // @ts-ignore circularly references itself

var DeleteButton = styled(IconButton$2).withConfig({
  displayName: "ImageUpload__DeleteButton",
  componentId: "sc-13la4l7-3"
})(["top:8px;right:8px;position:absolute;&:not(:hover){fill:var(--tina-color-grey-0);background-color:transparent;border-color:transparent;}"]);
var StyledImageContainer = styled.div.withConfig({
  displayName: "ImageUpload__StyledImageContainer",
  componentId: "sc-13la4l7-4"
})(["background-color:var(--tina-color-grey-4);position:relative;border-radius:var(--tina-radius-small);overflow:hidden;background-color:var(--tina-color-grey-8);&:hover{", "{opacity:0.6;}}"], StyledImage);
var ImageUpload = function ImageUpload(_ref) {
  var onDrop = _ref.onDrop,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      value = _ref.value,
      previewSrc = _ref.previewSrc,
      loading = _ref.loading;

  var _useDropzone = useDropzone({
    accept: "image/*",
    onDrop: onDrop,
    noClick: !!onClick
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps;

  return __jsx$z(DropArea, _extends$b({}, getRootProps(), {
    onClick: onClick
  }), __jsx$z("input", getInputProps()), value ? __jsx$z(StyledImageContainer, null, loading ? __jsx$z(ImageLoadingIndicator, null) : __jsx$z(react.exports.Fragment, null, __jsx$z(StyledImage, {
    src: previewSrc
  }), onClear && __jsx$z(DeleteButton, {
    onClick: function onClick(e) {
      e.stopPropagation();
      onClear();
    }
  }, __jsx$z(TrashIcon, null)))) : __jsx$z(ImgPlaceholder, null, "Drag 'n' drop some files here,", __jsx$z("br", null), "or click to select files"));
};

var ImageLoadingIndicator = function ImageLoadingIndicator() {
  return __jsx$z(ImageLoaderWrapper, null, __jsx$z(LoadingDots, null));
};

var ImageLoaderWrapper = styled.div.withConfig({
  displayName: "ImageUpload__ImageLoaderWrapper",
  componentId: "sc-13la4l7-5"
})(["padding:1rem;width:100%;min-height:6rem;display:flex;flex-direction:column;justify-content:center;align-items:center;"]);

function getResourceFetchParams(schemaProp, compilationContext) {
  if (schemaProp.type === "text") {
    return;
  }

  if (schemaProp.type === "image" || schemaProp.type === "video") {
    return compilationContext[schemaProp.type].fetchParams;
  }

  return schemaProp.fetchParams;
}

function getResourceIdentifier(id, info, fetchParams) {
  if (info || fetchParams) {
    var serializableIdentifier = {
      id: id
    };

    if (info) {
      serializableIdentifier.info = sortObject(info);
    }

    if (fetchParams) {
      serializableIdentifier.fetchParams = sortObject(fetchParams);
    }

    return JSON.stringify(serializableIdentifier);
  }

  return id;
}

function getResourceType(schemaProp, context) {
  if (schemaProp.type === "resource") {
    return schemaProp.resourceType;
  }

  if (schemaProp.type === "image" || schemaProp.type === "video") {
    var imageOrVideoCompilationType = context[schemaProp.type];

    if (!imageOrVideoCompilationType) {
      throw new Error("Missing \"".concat(schemaProp.type, "\" property within Shopstory config."));
    }

    return imageOrVideoCompilationType.resourceType;
  }

  return schemaProp.type;
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function getResourceValue(resource, transformHash) {
  if (resource.status !== "success") {
    return;
  }

  if (transformHash) {
    return resource.values[transformHash];
  }

  return resource.values["default"];
}

function getTransformHash(transformer) {
  return cryptoJs.exports.SHA1(transformer.toString()).toString();
}

function resourceByIdentity(id, type, info, fetchParams) {
  return function (resource) {
    return getResourceIdentifier(resource.id, resource.info, resource.fetchParams) === getResourceIdentifier(id, info, fetchParams) && resource.type === type;
  };
}

var __jsx$y = React.createElement;
var Tooltip = /*#__PURE__*/react.exports.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      style = _ref.style,
      rest = _objectWithoutProperties$2(_ref, ["children", "style"]);

  return /*#__PURE__*/reactDom.exports.createPortal(__jsx$y("div", _extends$b({
    style: style,
    ref: ref
  }, rest), children), document.body);
});
var TooltipBody = styled.div.withConfig({
  displayName: "Tooltip__TooltipBody",
  componentId: "sc-typ5dd-0"
})(["position:relative;top:6px;display:flex;flex-direction:row;justify-content:center;align-items:center;padding:6px 4px;background:#333333;border-radius:2px;", " color:#fff;"], SSFonts.body);
var TooltipArrow = styled.div.withConfig({
  displayName: "Tooltip__TooltipArrow",
  componentId: "sc-typ5dd-1"
})(["width:12px;height:6px;margin:0 auto;background:#333333;clip-path:polygon(50% 0%,0% 100%,100% 100%);"]);

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
* Copyright 2020 Adobe. All rights reserved.
* This file is licensed to you under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License. You may obtain a copy
* of the License at http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software distributed under
* the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
* OF ANY KIND, either express or implied. See the License for the specific language
* governing permissions and limitations under the License.
*/
// We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.

var $704cf1d3b684cc5c$var$defaultContext = {
  prefix: String(Math.round(Math.random() * 10000000000)),
  current: 0
};
var $704cf1d3b684cc5c$var$SSRContext = /*#__PURE__*/(React).createContext($704cf1d3b684cc5c$var$defaultContext);

var $704cf1d3b684cc5c$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);

function $704cf1d3b684cc5c$export$619500959fc48b26(defaultId) {
  var ctx = (react.exports.useContext)($704cf1d3b684cc5c$var$SSRContext); // If we are rendering in a non-DOM environment, and there's no SSRProvider,
  // provide a warning to hint to the developer to add one.

  if (ctx === $704cf1d3b684cc5c$var$defaultContext && !$704cf1d3b684cc5c$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server."); // eslint-disable-next-line react-hooks/exhaustive-deps

  return (react.exports.useMemo)(function () {
    return defaultId || "react-aria".concat(ctx.prefix, "-").concat(++ctx.current);
  }, [defaultId]);
}

function ownKeys$T(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$S(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$T(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$T(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper$7(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }

function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
* Copyright 2020 Adobe. All rights reserved.
* This file is licensed to you under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License. You may obtain a copy
* of the License at http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software distributed under
* the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
* OF ANY KIND, either express or implied. See the License for the specific language
* governing permissions and limitations under the License.
*/

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof window !== "undefined" ? (React).useLayoutEffect : function () {};

var $bdb11010cef70236$var$idsUpdaterMap = new Map();

function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
  var _ref3 = (react.exports.useState)(defaultId),
      _ref4 = _slicedToArray$2(_ref3, 2),
      value = _ref4[0],
      setValue = _ref4[1];

  var nextId = (react.exports.useRef)(null);
  var res = ($704cf1d3b684cc5c$export$619500959fc48b26)(value);
  var updateValue = (react.exports.useCallback)(function (val) {
    nextId.current = val;
  }, []);
  $bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(function () {
    var r = res;
    return function () {
      $bdb11010cef70236$var$idsUpdaterMap["delete"](r);
    };
  }, [res]); // This cannot cause an infinite loop because the ref is updated first.
  // eslint-disable-next-line

  (react.exports.useEffect)(function () {
    var newId = nextId.current;

    if (newId) {
      nextId.current = null;
      setValue(newId);
    }
  });
  return res;
}

function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
  if (idA === idB) return idA;
  var setIdA = $bdb11010cef70236$var$idsUpdaterMap.get(idA);

  if (setIdA) {
    setIdA(idB);
    return idB;
  }

  var setIdB = $bdb11010cef70236$var$idsUpdaterMap.get(idB);

  if (setIdB) {
    setIdB(idA);
    return idA;
  }

  return idB;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/**
* Calls all functions in the order they were chained with the same arguments.
*/


function $ff5963eb1fccf552$export$e08e3b67e392101e() {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }

  return function () {
    var _iterator = _createForOfIteratorHelper$7(callbacks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var callback = _step.value;
        if (typeof callback === "function") callback.apply(void 0, arguments);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */


function $3ef42575df84b30b$export$9d1611c77c2fe928() {
  // Start with a base clone of the first argument. This is a lot faster than starting
  // with an empty object and adding properties as we go.
  var result = _objectSpread$S({}, arguments.length <= 0 ? undefined : arguments[0]);

  for (var i = 1; i < arguments.length; i++) {
    var props = i < 0 || arguments.length <= i ? undefined : arguments[i];

    for (var key in props) {
      var a = result[key];
      var b = props[key]; // Chain events

      if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
      key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >=
      /* 'A' */
      65 && key.charCodeAt(2) <=
      /* 'Z' */
      90) result[key] = ($ff5963eb1fccf552$export$e08e3b67e392101e)(a, b);else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (clsx)(a, b);else if (key === "id" && a && b) result.id = ($bdb11010cef70236$export$cd8c9cb68f842629)(a, b);else result[key] = b !== undefined ? b : a;
    }
  }

  return result;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */


function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
  if ($7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
    preventScroll: true
  });else {
    var scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
    element.focus();
    $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
  }
}

var $7215afc6de606d6b$var$supportsPreventScrollCached = null;

function $7215afc6de606d6b$var$supportsPreventScroll() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached = false;

    try {
      var focusElem = document.createElement("div");
      focusElem.focus({
        get preventScroll() {
          $7215afc6de606d6b$var$supportsPreventScrollCached = true;
          return true;
        }

      });
    } catch (e) {// Ignore
    }
  }

  return $7215afc6de606d6b$var$supportsPreventScrollCached;
}

function $7215afc6de606d6b$var$getScrollableElements(element) {
  var parent = element.parentNode;
  var scrollableElements = [];
  var rootScrollingElement = document.scrollingElement || document.documentElement;

  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
      element: parent,
      scrollTop: parent.scrollTop,
      scrollLeft: parent.scrollLeft
    });
    parent = parent.parentNode;
  }

  if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
    element: rootScrollingElement,
    scrollTop: rootScrollingElement.scrollTop,
    scrollLeft: rootScrollingElement.scrollLeft
  });
  return scrollableElements;
}

function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
  var _iterator3 = _createForOfIteratorHelper$7(scrollableElements),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _step3.value,
          element = _step3$value.element,
          scrollTop = _step3$value.scrollTop,
          scrollLeft = _step3$value.scrollLeft;
      element.scrollTop = scrollTop;
      element.scrollLeft = scrollLeft;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.


var $bbed8b41f857bcc0$var$transitionsByElement = new Map(); // A list of callbacks to call once there are no transitioning elements.

var $bbed8b41f857bcc0$var$transitionCallbacks = new Set();

function $bbed8b41f857bcc0$var$setupGlobalEvents() {
  if (typeof window === "undefined") return;

  var onTransitionStart = function onTransitionStart(e) {
    // Add the transitioning property to the list for this element.
    var transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);

    if (!transitions) {
      transitions = new Set();
      $bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions); // The transitioncancel event must be registered on the element itself, rather than as a global
      // event. This enables us to handle when the node is deleted from the document while it is transitioning.
      // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.

      e.target.addEventListener("transitioncancel", onTransitionEnd);
    }

    transitions.add(e.propertyName);
  };

  var onTransitionEnd = function onTransitionEnd(e) {
    // Remove property from list of transitioning properties.
    var properties = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
    if (!properties) return;
    properties["delete"](e.propertyName); // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.

    if (properties.size === 0) {
      e.target.removeEventListener("transitioncancel", onTransitionEnd);
      $bbed8b41f857bcc0$var$transitionsByElement["delete"](e.target);
    } // If no transitioning elements, call all of the queued callbacks.


    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
      var _iterator4 = _createForOfIteratorHelper$7($bbed8b41f857bcc0$var$transitionCallbacks),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var cb = _step4.value;
          cb();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      $bbed8b41f857bcc0$var$transitionCallbacks.clear();
    }
  };

  document.body.addEventListener("transitionrun", onTransitionStart);
  document.body.addEventListener("transitionend", onTransitionEnd);
}

if (typeof document !== "undefined") {
  if (document.readyState !== "loading") $bbed8b41f857bcc0$var$setupGlobalEvents();else document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents);
}

function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
  // Wait one frame to see if an animation starts, e.g. a transition on mount.
  requestAnimationFrame(function () {
    // If no transitions are running, call the function immediately.
    // Otherwise, add it to a list of callbacks to run at the end of the animation.
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
  });
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */


function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
  var globalListeners = (react.exports.useRef)(new Map());
  var addGlobalListener = (react.exports.useCallback)(function (eventTarget, type, listener, options) {
    // Make sure we remove the listener after it is called with the `once` option.
    var fn = (options === null || options === void 0 ? void 0 : options.once) ? function () {
      globalListeners.current["delete"](listener);
      listener.apply(void 0, arguments);
    } : listener;
    globalListeners.current.set(listener, {
      type: type,
      eventTarget: eventTarget,
      fn: fn,
      options: options
    });
    eventTarget.addEventListener(type, listener, options);
  }, []);
  var removeGlobalListener = (react.exports.useCallback)(function (eventTarget, type, listener, options) {
    var _globalListeners_current_get;

    var fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
    eventTarget.removeEventListener(type, fn, options);
    globalListeners.current["delete"](listener);
  }, []);
  var removeAllGlobalListeners = (react.exports.useCallback)(function () {
    globalListeners.current.forEach(function (value, key) {
      removeGlobalListener(value.eventTarget, value.type, key, value.options);
    });
  }, [removeGlobalListener]); // eslint-disable-next-line arrow-body-style

  (react.exports.useEffect)(function () {
    return removeAllGlobalListeners;
  }, [removeAllGlobalListeners]);
  return {
    addGlobalListener: addGlobalListener,
    removeGlobalListener: removeGlobalListener,
    removeAllGlobalListeners: removeAllGlobalListeners
  };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */


function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref) {
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(function () {
    if (context && context.ref && ref) {
      context.ref.current = ref.current;
      return function () {
        context.ref.current = null;
      };
    }
  }, [context, ref]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */


function $c87311424ea30a05$var$testUserAgent(re) {
  var _window_navigator_userAgentData;

  if (typeof window === "undefined" || window.navigator == null) return false;
  return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some(function (brand) {
    return re.test(brand.brand);
  })) || re.test(window.navigator.userAgent);
}

function $c87311424ea30a05$var$testPlatform(re) {
  var _window_navigator_userAgentData;

  return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}

function $c87311424ea30a05$export$9ac100e40613ea10() {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}

function $c87311424ea30a05$export$186c6964ca17d99() {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}

function $c87311424ea30a05$export$7bef049ce92e4224() {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}

function $c87311424ea30a05$export$fedb369cb70207f1() {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}

function $c87311424ea30a05$export$a11b0059900ceec8() {
  return $c87311424ea30a05$var$testUserAgent(/Android/i);
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */


function $6a7db85432448f7f$export$60278871457622de(event) {
  // JAWS/NVDA with Firefox.
  if (event.mozInputSource === 0 && event.isTrusted) return true; // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
  // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
  // to detect TalkBack virtual clicks.

  if (($c87311424ea30a05$export$a11b0059900ceec8)() && event.pointerType) return event.type === "click" && event.buttons === 1;
  return event.detail === 0 && !event.pointerType;
}

function $6a7db85432448f7f$export$29bf1b5f2c56cf63(event) {
  // If the pointer size is zero, then we assume it's from a screen reader.
  // Android TalkBack double tap will sometimes return a event with width and height of 1
  // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
  // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
  // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
  // Talkback double tap from Windows Firefox touch screen press
  return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}

function _createForOfIteratorHelper$6(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$S(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$R(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$S(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$S(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
* Copyright 2020 Adobe. All rights reserved.
* This file is licensed to you under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License. You may obtain a copy
* of the License at http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software distributed under
* the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
* OF ANY KIND, either express or implied. See the License for the specific language
* governing permissions and limitations under the License.
*/

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually

var $14c0b72509d70225$var$state = "default";
var $14c0b72509d70225$var$savedUserSelect = "";
var $14c0b72509d70225$var$modifiedElementMap = new WeakMap();

function $14c0b72509d70225$export$16a4697467175487(target) {
  if (($c87311424ea30a05$export$fedb369cb70207f1)()) {
    if ($14c0b72509d70225$var$state === "default") {
      $14c0b72509d70225$var$savedUserSelect = document.documentElement.style.webkitUserSelect;
      document.documentElement.style.webkitUserSelect = "none";
    }

    $14c0b72509d70225$var$state = "disabled";
  } else if (target instanceof HTMLElement || target instanceof SVGElement) {
    // If not iOS, store the target's original user-select and change to user-select: none
    // Ignore state since it doesn't apply for non iOS
    $14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
    target.style.userSelect = "none";
  }
}

function $14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
  if (($c87311424ea30a05$export$fedb369cb70207f1)()) {
    // If the state is already default, there's nothing to do.
    // If it is restoring, then there's no need to queue a second restore.
    if ($14c0b72509d70225$var$state !== "disabled") return;
    $14c0b72509d70225$var$state = "restoring"; // There appears to be a delay on iOS where selection still might occur
    // after pointer up, so wait a bit before removing user-select.

    setTimeout(function () {
      // Wait for any CSS transitions to complete so we don't recompute style
      // for the whole page in the middle of the animation and cause jank.
      ($bbed8b41f857bcc0$export$24490316f764c430)(function () {
        // Avoid race conditions
        if ($14c0b72509d70225$var$state === "restoring") {
          if (document.documentElement.style.webkitUserSelect === "none") document.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || "";
          $14c0b72509d70225$var$savedUserSelect = "";
          $14c0b72509d70225$var$state = "default";
        }
      });
    }, 300);
  } else if (target instanceof HTMLElement || target instanceof SVGElement) // If not iOS, restore the target's original user-select if any
    // Ignore state since it doesn't apply for non iOS
    {
      if (target && $14c0b72509d70225$var$modifiedElementMap.has(target)) {
        var targetOldUserSelect = $14c0b72509d70225$var$modifiedElementMap.get(target);
        if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
        if (target.getAttribute("style") === "") target.removeAttribute("style");
        $14c0b72509d70225$var$modifiedElementMap["delete"](target);
      }
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */


var $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (React).createContext(null);
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";

function $f6c31cce2adf654f$var$usePressResponderContext(props) {
  // Consume context from <PressResponder> and merge with props.
  var context = (react.exports.useContext)(($ae1eeba8b9eafd08$export$5165eccb35aaadb5));

  if (context) {
    var register = context.register,
        contextProps = _objectWithoutProperties$2(context, ["register"]);

    props = ($3ef42575df84b30b$export$9d1611c77c2fe928)(contextProps, props);
    register();
  }

  ($e7801be82b4b2a53$export$4debdb1a3f0fa79e)(context, props.ref);
  return props;
}

function $f6c31cce2adf654f$export$45712eceda6fad21(props) {
  var _$f6c31cce2adf654f$va = $f6c31cce2adf654f$var$usePressResponderContext(props),
      onPress = _$f6c31cce2adf654f$va.onPress,
      onPressChange = _$f6c31cce2adf654f$va.onPressChange,
      onPressStart = _$f6c31cce2adf654f$va.onPressStart,
      onPressEnd = _$f6c31cce2adf654f$va.onPressEnd,
      onPressUp = _$f6c31cce2adf654f$va.onPressUp,
      isDisabled = _$f6c31cce2adf654f$va.isDisabled,
      isPressedProp = _$f6c31cce2adf654f$va.isPressed,
      preventFocusOnPress = _$f6c31cce2adf654f$va.preventFocusOnPress,
      shouldCancelOnPointerExit = _$f6c31cce2adf654f$va.shouldCancelOnPointerExit,
      allowTextSelectionOnPress = _$f6c31cce2adf654f$va.allowTextSelectionOnPress;
      _$f6c31cce2adf654f$va.ref;
      var domProps = _objectWithoutProperties$2(_$f6c31cce2adf654f$va, ["onPress", "onPressChange", "onPressStart", "onPressEnd", "onPressUp", "isDisabled", "isPressed", "preventFocusOnPress", "shouldCancelOnPointerExit", "allowTextSelectionOnPress", "ref"]);

  var propsRef = (react.exports.useRef)(null);
  propsRef.current = {
    onPress: onPress,
    onPressChange: onPressChange,
    onPressStart: onPressStart,
    onPressEnd: onPressEnd,
    onPressUp: onPressUp,
    isDisabled: isDisabled,
    shouldCancelOnPointerExit: shouldCancelOnPointerExit
  };

  var _ref = (react.exports.useState)(false),
      _ref2 = _slicedToArray$2(_ref, 2),
      isPressed = _ref2[0],
      setPressed = _ref2[1];

  var ref = (react.exports.useRef)({
    isPressed: false,
    ignoreEmulatedMouseEvents: false,
    ignoreClickAfterPress: false,
    didFirePressStart: false,
    activePointerId: null,
    target: null,
    isOverTarget: false,
    pointerType: null
  });

  var _ref3 = ($03deb23ff14920c4$export$4eaf04e54aa8eed6)(),
      addGlobalListener = _ref3.addGlobalListener,
      removeAllGlobalListeners = _ref3.removeAllGlobalListeners;

  var pressProps = (react.exports.useMemo)(function () {
    var state = ref.current;

    var triggerPressStart = function triggerPressStart(originalEvent, pointerType) {
      var _propsRef$current = propsRef.current,
          onPressStart = _propsRef$current.onPressStart,
          onPressChange = _propsRef$current.onPressChange,
          isDisabled = _propsRef$current.isDisabled;
      if (isDisabled || state.didFirePressStart) return;
      if (onPressStart) onPressStart({
        type: "pressstart",
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
      if (onPressChange) onPressChange(true);
      state.didFirePressStart = true;
      setPressed(true);
    };

    var triggerPressEnd = function triggerPressEnd(originalEvent, pointerType) {
      var wasPressed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var _propsRef$current2 = propsRef.current,
          onPressEnd = _propsRef$current2.onPressEnd,
          onPressChange = _propsRef$current2.onPressChange,
          onPress = _propsRef$current2.onPress,
          isDisabled = _propsRef$current2.isDisabled;
      if (!state.didFirePressStart) return;
      state.ignoreClickAfterPress = true;
      state.didFirePressStart = false;
      if (onPressEnd) onPressEnd({
        type: "pressend",
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
      if (onPressChange) onPressChange(false);
      setPressed(false);
      if (onPress && wasPressed && !isDisabled) onPress({
        type: "press",
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
    };

    var triggerPressUp = function triggerPressUp(originalEvent, pointerType) {
      var _propsRef$current3 = propsRef.current,
          onPressUp = _propsRef$current3.onPressUp,
          isDisabled = _propsRef$current3.isDisabled;
      if (isDisabled) return;
      if (onPressUp) onPressUp({
        type: "pressup",
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
    };

    var cancel = function cancel(e) {
      if (state.isPressed) {
        if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
        state.isPressed = false;
        state.isOverTarget = false;
        state.activePointerId = null;
        state.pointerType = null;
        removeAllGlobalListeners();
        if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$b0d6fa1ab32e3295)(state.target);
      }
    };

    var pressProps = {
      onKeyDown: function onKeyDown(e) {
        if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
          if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
          e.stopPropagation(); // If the event is repeating, it may have started on a different element
          // after which focus moved to the current element. Ignore these events and
          // only handle the first key down event.

          if (!state.isPressed && !e.repeat) {
            state.target = e.currentTarget;
            state.isPressed = true;
            triggerPressStart(e, "keyboard"); // Focus may move before the key up event, so register the event on the document
            // instead of the same element where the key down event occurred.

            addGlobalListener(document, "keyup", onKeyUp, false);
          }
        } else if (e.key === "Enter" && $f6c31cce2adf654f$var$isHTMLAnchorLink(e.currentTarget)) // If the target is a link, we won't have handled this above because we want the default
          // browser behavior to open the link when pressing Enter. But we still need to prevent
          // default so that elements above do not also handle it (e.g. table row).
          e.stopPropagation();
      },
      onKeyUp: function onKeyUp(e) {
        if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && !e.repeat && e.currentTarget.contains(e.target)) triggerPressUp($f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
      },
      onClick: function onClick(e) {
        if (e && !e.currentTarget.contains(e.target)) return;

        if (e && e.button === 0) {
          e.stopPropagation();
          if (isDisabled) e.preventDefault(); // If triggered from a screen reader or by using element.click(),
          // trigger as if it were a keyboard click.

          if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && (state.pointerType === "virtual" || ($6a7db85432448f7f$export$60278871457622de)(e.nativeEvent))) {
            // Ensure the element receives focus (VoiceOver on iOS does not do this)
            if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
            triggerPressStart(e, "virtual");
            triggerPressUp(e, "virtual");
            triggerPressEnd(e, "virtual");
          }

          state.ignoreEmulatedMouseEvents = false;
          state.ignoreClickAfterPress = false;
        }
      }
    };

    var onKeyUp = function onKeyUp(e) {
      if (state.isPressed && $f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
        if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
        e.stopPropagation();
        state.isPressed = false;
        var target = e.target;
        triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
        removeAllGlobalListeners(); // If the target is a link, trigger the click method to open the URL,
        // but defer triggering pressEnd until onClick event handler.

        if (state.target instanceof HTMLElement && state.target.contains(target) && ($f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) || state.target.getAttribute("role") === "link")) state.target.click();
      }
    };

    if (typeof PointerEvent !== "undefined") {
      pressProps.onPointerDown = function (e) {
        // Only handle left clicks, and ignore events that bubbled through portals.
        if (e.button !== 0 || !e.currentTarget.contains(e.target)) return; // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
        // Ignore and let the onClick handler take care of it instead.
        // https://bugs.webkit.org/show_bug.cgi?id=222627
        // https://bugs.webkit.org/show_bug.cgi?id=223202

        if (($6a7db85432448f7f$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
          state.pointerType = "virtual";
          return;
        } // Due to browser inconsistencies, especially on mobile browsers, we prevent
        // default on pointer down and handle focusing the pressable element ourselves.


        if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
        state.pointerType = e.pointerType;
        e.stopPropagation();

        if (!state.isPressed) {
          state.isPressed = true;
          state.isOverTarget = true;
          state.activePointerId = e.pointerId;
          state.target = e.currentTarget;
          if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
          if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$16a4697467175487)(state.target);
          triggerPressStart(e, state.pointerType);
          addGlobalListener(document, "pointermove", onPointerMove, false);
          addGlobalListener(document, "pointerup", onPointerUp, false);
          addGlobalListener(document, "pointercancel", onPointerCancel, false);
        }
      };

      pressProps.onMouseDown = function (e) {
        if (!e.currentTarget.contains(e.target)) return;

        if (e.button === 0) {
          // Chrome and Firefox on touch Windows devices require mouse down events
          // to be canceled in addition to pointer events, or an extra asynchronous
          // focus event will be fired.
          if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
          e.stopPropagation();
        }
      };

      pressProps.onPointerUp = function (e) {
        // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
        if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return; // Only handle left clicks
        // Safari on iOS sometimes fires pointerup events, even
        // when the touch isn't over the target, so double check.

        if (e.button === 0 && $f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
      }; // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
      // Use pointer move events instead to implement our own hit testing.
      // See https://bugs.webkit.org/show_bug.cgi?id=199803


      var onPointerMove = function onPointerMove(e) {
        if (e.pointerId !== state.activePointerId) return;

        if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
          if (!state.isOverTarget) {
            state.isOverTarget = true;
            triggerPressStart($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
          }
        } else if (state.isOverTarget) {
          state.isOverTarget = false;
          triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
        }
      };

      var onPointerUp = function onPointerUp(e) {
        if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0) {
          if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);else if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
          state.isPressed = false;
          state.isOverTarget = false;
          state.activePointerId = null;
          state.pointerType = null;
          removeAllGlobalListeners();
          if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$b0d6fa1ab32e3295)(state.target);
        }
      };

      var onPointerCancel = function onPointerCancel(e) {
        cancel(e);
      };

      pressProps.onDragStart = function (e) {
        if (!e.currentTarget.contains(e.target)) return; // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.

        cancel(e);
      };
    } else {
      pressProps.onMouseDown = function (e) {
        // Only handle left clicks
        if (e.button !== 0 || !e.currentTarget.contains(e.target)) return; // Due to browser inconsistencies, especially on mobile browsers, we prevent
        // default on mouse down and handle focusing the pressable element ourselves.

        if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
        e.stopPropagation();
        if (state.ignoreEmulatedMouseEvents) return;
        state.isPressed = true;
        state.isOverTarget = true;
        state.target = e.currentTarget;
        state.pointerType = ($6a7db85432448f7f$export$60278871457622de)(e.nativeEvent) ? "virtual" : "mouse";
        if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
        triggerPressStart(e, state.pointerType);
        addGlobalListener(document, "mouseup", onMouseUp, false);
      };

      pressProps.onMouseEnter = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();

        if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
          state.isOverTarget = true;
          triggerPressStart(e, state.pointerType);
        }
      };

      pressProps.onMouseLeave = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();

        if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
          state.isOverTarget = false;
          triggerPressEnd(e, state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
        }
      };

      pressProps.onMouseUp = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType);
      };

      var onMouseUp = function onMouseUp(e) {
        // Only handle left clicks
        if (e.button !== 0) return;
        state.isPressed = false;
        removeAllGlobalListeners();

        if (state.ignoreEmulatedMouseEvents) {
          state.ignoreEmulatedMouseEvents = false;
          return;
        }

        if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);else if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
        state.isOverTarget = false;
      };

      pressProps.onTouchStart = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        var touch = $f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
        if (!touch) return;
        state.activePointerId = touch.identifier;
        state.ignoreEmulatedMouseEvents = true;
        state.isOverTarget = true;
        state.isPressed = true;
        state.target = e.currentTarget;
        state.pointerType = "touch"; // Due to browser inconsistencies, especially on mobile browsers, we prevent default
        // on the emulated mouse event and handle focusing the pressable element ourselves.

        if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
        if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$16a4697467175487)(state.target);
        triggerPressStart(e, state.pointerType);
        addGlobalListener(window, "scroll", onScroll, true);
      };

      pressProps.onTouchMove = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        if (!state.isPressed) return;
        var touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);

        if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
          if (!state.isOverTarget) {
            state.isOverTarget = true;
            triggerPressStart(e, state.pointerType);
          }
        } else if (state.isOverTarget) {
          state.isOverTarget = false;
          triggerPressEnd(e, state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
        }
      };

      pressProps.onTouchEnd = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        if (!state.isPressed) return;
        var touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);

        if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
          triggerPressUp(e, state.pointerType);
          triggerPressEnd(e, state.pointerType);
        } else if (state.isOverTarget) triggerPressEnd(e, state.pointerType, false);

        state.isPressed = false;
        state.activePointerId = null;
        state.isOverTarget = false;
        state.ignoreEmulatedMouseEvents = true;
        if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$b0d6fa1ab32e3295)(state.target);
        removeAllGlobalListeners();
      };

      pressProps.onTouchCancel = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        if (state.isPressed) cancel(e);
      };

      var onScroll = function onScroll(e) {
        if (state.isPressed && e.target.contains(state.target)) cancel({
          currentTarget: state.target,
          shiftKey: false,
          ctrlKey: false,
          metaKey: false,
          altKey: false
        });
      };

      pressProps.onDragStart = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        cancel(e);
      };
    }

    return pressProps;
  }, [addGlobalListener, isDisabled, preventFocusOnPress, removeAllGlobalListeners, allowTextSelectionOnPress]); // Remove user-select: none in case component unmounts immediately after pressStart
  // eslint-disable-next-line arrow-body-style

  (react.exports.useEffect)(function () {
    return function () {
      if (!allowTextSelectionOnPress) // eslint-disable-next-line react-hooks/exhaustive-deps
        ($14c0b72509d70225$export$b0d6fa1ab32e3295)(ref.current.target);
    };
  }, [allowTextSelectionOnPress]);
  return {
    isPressed: isPressedProp || isPressed,
    pressProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, pressProps)
  };
}

function $f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
  return target.tagName === "A" && target.hasAttribute("href");
}

function $f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
  var key = event.key,
      code = event.code;
  var element = currentTarget;
  var role = element.getAttribute("role"); // Accessibility for keyboards. Space and Enter only.
  // "Spacebar" is for IE 11

  return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof HTMLTextAreaElement || element.isContentEditable) && ( // A link with a valid href should be handled natively,
  // unless it also has role='button' and was triggered using Space.
  !$f6c31cce2adf654f$var$isHTMLAnchorLink(element) || role === "button" && key !== "Enter") && // An element with role='link' should only trigger with Enter key
  !(role === "link" && key !== "Enter");
}

function $f6c31cce2adf654f$var$getTouchFromEvent(event) {
  var targetTouches = event.targetTouches;
  if (targetTouches.length > 0) return targetTouches[0];
  return null;
}

function $f6c31cce2adf654f$var$getTouchById(event, pointerId) {
  var changedTouches = event.changedTouches;

  for (var i = 0; i < changedTouches.length; i++) {
    var touch = changedTouches[i];
    if (touch.identifier === pointerId) return touch;
  }

  return null;
}

function $f6c31cce2adf654f$var$createEvent(target, e) {
  return {
    currentTarget: target,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey
  };
}

function $f6c31cce2adf654f$var$getPointClientRect(point) {
  var offsetX = point.width / 2 || point.radiusX || 0;
  var offsetY = point.height / 2 || point.radiusY || 0;
  return {
    top: point.clientY - offsetY,
    right: point.clientX + offsetX,
    bottom: point.clientY + offsetY,
    left: point.clientX - offsetX
  };
}

function $f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
  // check if they cannot overlap on x axis
  if (a.left > b.right || b.left > a.right) return false; // check if they cannot overlap on y axis

  if (a.top > b.bottom || b.top > a.bottom) return false;
  return true;
}

function $f6c31cce2adf654f$var$isOverTarget(point, target) {
  var rect = target.getBoundingClientRect();
  var pointRect = $f6c31cce2adf654f$var$getPointClientRect(point);
  return $f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}

function $f6c31cce2adf654f$var$shouldPreventDefault(target) {
  // We cannot prevent default if the target is a draggable element.
  return !(target instanceof HTMLElement) || !target.draggable;
}

function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
  if (target instanceof HTMLInputElement) return !$f6c31cce2adf654f$var$isValidInputKey(target, key);
  if (target instanceof HTMLButtonElement) return target.type !== "submit";
  return true;
}

var $f6c31cce2adf654f$var$nonTextInputTypes = new Set(["checkbox", "radio", "range", "color", "file", "image", "button", "submit", "reset"]);

function $f6c31cce2adf654f$var$isValidInputKey(target, key) {
  // Only space should toggle checkboxes and radios, not enter.
  return target.type === "checkbox" || target.type === "radio" ? key === " " : $f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $8a9cb279dc87e130$export$905e7fc544a71f36 = /*#__PURE__*/function () {
  _createClass$b($8a9cb279dc87e130$export$905e7fc544a71f36, [{
    key: "isDefaultPrevented",
    value: function isDefaultPrevented() {
      return this.nativeEvent.defaultPrevented;
    }
  }, {
    key: "preventDefault",
    value: function preventDefault() {
      this.defaultPrevented = true;
      this.nativeEvent.preventDefault();
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      this.nativeEvent.stopPropagation();

      this.isPropagationStopped = function () {
        return true;
      };
    }
  }, {
    key: "isPropagationStopped",
    value: function isPropagationStopped() {
      return false;
    }
  }, {
    key: "persist",
    value: function persist() {}
  }]);

  function $8a9cb279dc87e130$export$905e7fc544a71f36(type, nativeEvent) {
    _classCallCheck$d(this, $8a9cb279dc87e130$export$905e7fc544a71f36);

    this.nativeEvent = nativeEvent;
    this.target = nativeEvent.target;
    this.currentTarget = nativeEvent.currentTarget;
    this.relatedTarget = nativeEvent.relatedTarget;
    this.bubbles = nativeEvent.bubbles;
    this.cancelable = nativeEvent.cancelable;
    this.defaultPrevented = nativeEvent.defaultPrevented;
    this.eventPhase = nativeEvent.eventPhase;
    this.isTrusted = nativeEvent.isTrusted;
    this.timeStamp = nativeEvent.timeStamp;
    this.type = type;
  }

  return $8a9cb279dc87e130$export$905e7fc544a71f36;
}();

function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
  var stateRef = (react.exports.useRef)({
    isFocused: false,
    onBlur: onBlur,
    observer: null
  });
  stateRef.current.onBlur = onBlur; // Clean up MutationObserver on unmount. See below.
  // eslint-disable-next-line arrow-body-style

  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(function () {
    var state = stateRef.current;
    return function () {
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
    };
  }, []); // This function is called during a React onFocus event.

  return (react.exports.useCallback)(function (e) {
    // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
    // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
    // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
    // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
    if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
      stateRef.current.isFocused = true;
      var target = e.target;

      var onBlurHandler = function onBlurHandler(e) {
        var // For backward compatibility, dispatch a (fake) React synthetic event.
        _stateRef_current, _stateRef_current_onBlur;

        stateRef.current.isFocused = false;
        if (target.disabled) (_stateRef_current_onBlur = (_stateRef_current = stateRef.current).onBlur) === null || _stateRef_current_onBlur === void 0 ? void 0 : _stateRef_current_onBlur.call(_stateRef_current, new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", e)); // We no longer need the MutationObserver once the target is blurred.

        if (stateRef.current.observer) {
          stateRef.current.observer.disconnect();
          stateRef.current.observer = null;
        }
      };

      target.addEventListener("focusout", onBlurHandler, {
        once: true
      });
      stateRef.current.observer = new MutationObserver(function () {
        if (stateRef.current.isFocused && target.disabled) {
          stateRef.current.observer.disconnect();
          target.dispatchEvent(new FocusEvent("blur"));
          target.dispatchEvent(new FocusEvent("focusout", {
            bubbles: true
          }));
        }
      });
      stateRef.current.observer.observe(target, {
        attributes: true,
        attributeFilter: ["disabled"]
      });
    }
  }, []);
}

function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
  var isDisabled = props.isDisabled,
      onFocusProp = props.onFocus,
      onBlurProp = props.onBlur,
      onFocusChange = props.onFocusChange;
  var onBlur = (react.exports.useCallback)(function (e) {
    if (e.target === e.currentTarget) {
      if (onBlurProp) onBlurProp(e);
      if (onFocusChange) onFocusChange(false);
      return true;
    }
  }, [onBlurProp, onFocusChange]);
  var onSyntheticFocus = ($8a9cb279dc87e130$export$715c682d09d639cc)(onBlur);
  var onFocus = (react.exports.useCallback)(function (e) {
    if (e.target === e.currentTarget) {
      if (onFocusProp) onFocusProp(e);
      if (onFocusChange) onFocusChange(true);
      onSyntheticFocus(e);
    }
  }, [onFocusChange, onFocusProp, onSyntheticFocus]);
  return {
    focusProps: {
      onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
      onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : null
    }
  };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions


var $507fabe10e71c6fb$var$currentModality = null;
var $507fabe10e71c6fb$var$changeHandlers = new Set();
var $507fabe10e71c6fb$var$hasSetupGlobalListeners = false;
var $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
var $507fabe10e71c6fb$var$hasBlurredWindowRecently = false; // Only Tab or Esc keys will make focus visible on text input elements

function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
  var _iterator = _createForOfIteratorHelper$6($507fabe10e71c6fb$var$changeHandlers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var handler = _step.value;
      handler(modality, e);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */


function $507fabe10e71c6fb$var$isValidKey(e) {
  // Control and Shift keys trigger when navigating back to the tab with keyboard.
  return !(e.metaKey || !($c87311424ea30a05$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}

function $507fabe10e71c6fb$var$handleKeyboardEvent(e) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = true;

  if ($507fabe10e71c6fb$var$isValidKey(e)) {
    $507fabe10e71c6fb$var$currentModality = "keyboard";
    $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
  }
}

function $507fabe10e71c6fb$var$handlePointerEvent(e) {
  $507fabe10e71c6fb$var$currentModality = "pointer";

  if (e.type === "mousedown" || e.type === "pointerdown") {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
  }
}

function $507fabe10e71c6fb$var$handleClickEvent(e) {
  if (($6a7db85432448f7f$export$60278871457622de)(e)) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$currentModality = "virtual";
  }
}

function $507fabe10e71c6fb$var$handleFocusEvent(e) {
  // Firefox fires two extra focus events when the user first clicks into an iframe:
  // first on the window, then on the document. We ignore these events so they don't
  // cause keyboard focus rings to appear.
  if (e.target === window || e.target === document) return; // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
  // This occurs, for example, when navigating a form with the next/previous buttons on iOS.

  if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
    $507fabe10e71c6fb$var$currentModality = "virtual";
    $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
  }

  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}

function $507fabe10e71c6fb$var$handleWindowBlur() {
  // When the window is blurred, reset state. This is necessary when tabbing out of the window,
  // for example, since a subsequent focus event won't be fired.
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */


function $507fabe10e71c6fb$var$setupGlobalFocusEvents() {
  if (typeof window === "undefined" || $507fabe10e71c6fb$var$hasSetupGlobalListeners) return; // Programmatic focus() calls shouldn't affect the current input modality.
  // However, we need to detect other cases when a focus event occurs without
  // a preceding user event (e.g. screen reader focus). Overriding the focus
  // method on HTMLElement.prototype is a bit hacky, but works.

  var focus = HTMLElement.prototype.focus;

  HTMLElement.prototype.focus = function () {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    focus.apply(this, arguments);
  };

  document.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  document.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  document.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true); // Register focus events on the window so they are sure to happen
  // before React's event listeners (registered on the document).

  window.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  window.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);

  if (typeof PointerEvent !== "undefined") {
    document.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else {
    document.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }

  $507fabe10e71c6fb$var$hasSetupGlobalListeners = true;
}

if (typeof document !== "undefined") {
  if (document.readyState !== "loading") $507fabe10e71c6fb$var$setupGlobalFocusEvents();else document.addEventListener("DOMContentLoaded", $507fabe10e71c6fb$var$setupGlobalFocusEvents);
}

function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
  return $507fabe10e71c6fb$var$currentModality !== "pointer";
}

function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
  return $507fabe10e71c6fb$var$currentModality;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.


var $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
var $6179b936705e76d3$var$hoverCount = 0;

function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
  $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true; // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
  // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
  // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
  // the distant future because a user previously touched the element.

  setTimeout(function () {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
  }, 50);
}

function $6179b936705e76d3$var$handleGlobalPointerEvent(e) {
  if (e.pointerType === "touch") $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}

function $6179b936705e76d3$var$setupGlobalTouchEvents() {
  if (typeof document === "undefined") return;
  if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);else document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  $6179b936705e76d3$var$hoverCount++;
  return function () {
    $6179b936705e76d3$var$hoverCount--;
    if ($6179b936705e76d3$var$hoverCount > 0) return;
    if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);else document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  };
}

function $6179b936705e76d3$export$ae780daf29e6d456(props) {
  var onHoverStart = props.onHoverStart,
      onHoverChange = props.onHoverChange,
      onHoverEnd = props.onHoverEnd,
      isDisabled = props.isDisabled;

  var _ref11 = (react.exports.useState)(false),
      _ref12 = _slicedToArray$2(_ref11, 2),
      isHovered = _ref12[0],
      setHovered = _ref12[1];

  var state = (react.exports.useRef)({
    isHovered: false,
    ignoreEmulatedMouseEvents: false,
    pointerType: "",
    target: null
  }).current;
  (react.exports.useEffect)($6179b936705e76d3$var$setupGlobalTouchEvents, []);

  var _ref13 = (react.exports.useMemo)(function () {
    var triggerHoverStart = function triggerHoverStart(event, pointerType) {
      state.pointerType = pointerType;
      if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
      state.isHovered = true;
      var target = event.currentTarget;
      state.target = target;
      if (onHoverStart) onHoverStart({
        type: "hoverstart",
        target: target,
        pointerType: pointerType
      });
      if (onHoverChange) onHoverChange(true);
      setHovered(true);
    };

    var triggerHoverEnd = function triggerHoverEnd(event, pointerType) {
      state.pointerType = "";
      state.target = null;
      if (pointerType === "touch" || !state.isHovered) return;
      state.isHovered = false;
      var target = event.currentTarget;
      if (onHoverEnd) onHoverEnd({
        type: "hoverend",
        target: target,
        pointerType: pointerType
      });
      if (onHoverChange) onHoverChange(false);
      setHovered(false);
    };

    var hoverProps = {};

    if (typeof PointerEvent !== "undefined") {
      hoverProps.onPointerEnter = function (e) {
        if ($6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
        triggerHoverStart(e, e.pointerType);
      };

      hoverProps.onPointerLeave = function (e) {
        if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
      };
    } else {
      hoverProps.onTouchStart = function () {
        state.ignoreEmulatedMouseEvents = true;
      };

      hoverProps.onMouseEnter = function (e) {
        if (!state.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
        state.ignoreEmulatedMouseEvents = false;
      };

      hoverProps.onMouseLeave = function (e) {
        if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
      };
    }

    return {
      hoverProps: hoverProps,
      triggerHoverEnd: triggerHoverEnd
    };
  }, [onHoverStart, onHoverChange, onHoverEnd, isDisabled, state]),
      hoverProps = _ref13.hoverProps,
      triggerHoverEnd = _ref13.triggerHoverEnd;

  (react.exports.useEffect)(function () {
    // Call the triggerHoverEnd as soon as isDisabled changes to true
    // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
    if (isDisabled) triggerHoverEnd({
      currentTarget: state.target
    }, state.pointerType); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisabled]);
  return {
    hoverProps: hoverProps,
    isHovered: isHovered
  };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
* Copyright 2020 Adobe. All rights reserved.
* This file is licensed to you under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License. You may obtain a copy
* of the License at http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software distributed under
* the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
* OF ANY KIND, either express or implied. See the License for the specific language
* governing permissions and limitations under the License.
*/


function $93925083ecbb358c$export$48d1ea6320830260(handler) {
  if (!handler) return;
  var shouldStopPropagation = true;
  return function (e) {
    var event = _objectSpread$R(_objectSpread$R({}, e), {}, {
      preventDefault: function preventDefault() {
        e.preventDefault();
      },
      isDefaultPrevented: function isDefaultPrevented() {
        return e.isDefaultPrevented();
      },
      stopPropagation: function stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation: function continuePropagation() {
        shouldStopPropagation = false;
      }
    });

    handler(event);
    if (shouldStopPropagation) e.stopPropagation();
  };
}

function $46d819fcbaf35654$export$8f71654801c2f7cd(props) {
  return {
    keyboardProps: props.isDisabled ? {} : {
      onKeyDown: ($93925083ecbb358c$export$48d1ea6320830260)(props.onKeyDown),
      onKeyUp: ($93925083ecbb358c$export$48d1ea6320830260)(props.onKeyUp)
    }
  };
}

function _defineProperty$a(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$R(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$Q(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$R(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$R(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper$5(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
* Copyright 2020 Adobe. All rights reserved.
* This file is licensed to you under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License. You may obtain a copy
* of the License at http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software distributed under
* the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
* OF ANY KIND, either express or implied. See the License for the specific language
* governing permissions and limitations under the License.
*/

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $6a99195332edec8b$export$80f3e147d781571c(element) {
  // If the user is interacting with a virtual cursor, e.g. screen reader, then
  // wait until after any animated transitions that are currently occurring on
  // the page before shifting focus. This avoids issues with VoiceOver on iOS
  // causing the page to scroll when moving focus if the element is transitioning
  // from off the screen.
  if (($507fabe10e71c6fb$export$630ff653c5ada6a9)() === "virtual") {
    var lastFocusedElement = document.activeElement;
    ($bbed8b41f857bcc0$export$24490316f764c430)(function () {
      // If focus did not move and the element is still in the document, focus it.
      if (document.activeElement === lastFocusedElement && document.contains(element)) ($7215afc6de606d6b$export$de79e2c695e052f3)(element);
    });
  } else ($7215afc6de606d6b$export$de79e2c695e052f3)(element);
}

function $9bf71ea28793e738$var$isElementInScope(element, scope) {
  return scope.some(function (node) {
    return node.contains(element);
  });
}

var $9bf71ea28793e738$var$Tree = /*#__PURE__*/function () {
  _createClass$b($9bf71ea28793e738$var$Tree, [{
    key: "getTreeNode",
    value: function getTreeNode(data) {
      return this.fastMap.get(data);
    }
  }, {
    key: "addTreeNode",
    value: function addTreeNode(scopeRef, parent, nodeToRestore) {
      var parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
      var node = new $9bf71ea28793e738$var$TreeNode({
        scopeRef: scopeRef
      });
      parentNode.addChild(node);
      node.parent = parentNode;
      this.fastMap.set(scopeRef, node);
      if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
  }, {
    key: "removeTreeNode",
    value: function removeTreeNode(scopeRef) {
      // never remove the root
      if (scopeRef === null) return;
      var node = this.fastMap.get(scopeRef);
      var parentNode = node.parent; // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
      // if we are, then replace the siblings restore with the restore from the scope we're removing

      var _iterator2 = _createForOfIteratorHelper$5(this.traverse()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var current = _step2.value;
          if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var children = node.children;
      parentNode.removeChild(node);
      if (children.length > 0) children.forEach(function (child) {
        return parentNode.addChild(child);
      });
      this.fastMap["delete"](node.scopeRef);
    } // Pre Order Depth First

  }, {
    key: "traverse",
    value: /*#__PURE__*/regenerator.mark(function traverse() {
      var node,
          _iterator3,
          _step3,
          child,
          _args = arguments;

      return regenerator.wrap(function traverse$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              node = _args.length > 0 && _args[0] !== undefined ? _args[0] : this.root;

              if (!(node.scopeRef != null)) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return node;

            case 4:
              if (!(node.children.length > 0)) {
                _context.next = 21;
                break;
              }

              _iterator3 = _createForOfIteratorHelper$5(node.children);
              _context.prev = 6;

              _iterator3.s();

            case 8:
              if ((_step3 = _iterator3.n()).done) {
                _context.next = 13;
                break;
              }

              child = _step3.value;
              return _context.delegateYield(this.traverse(child), "t0", 11);

            case 11:
              _context.next = 8;
              break;

            case 13:
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t1 = _context["catch"](6);

              _iterator3.e(_context.t1);

            case 18:
              _context.prev = 18;

              _iterator3.f();

              return _context.finish(18);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, traverse, this, [[6, 15, 18, 21]]);
    })
  }, {
    key: "clone",
    value: function clone() {
      var newTree = new $9bf71ea28793e738$var$Tree();

      var _iterator4 = _createForOfIteratorHelper$5(this.traverse()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var node = _step4.value;
          newTree.addTreeNode(node.scopeRef, node.parent.scopeRef, node.nodeToRestore);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return newTree;
    }
  }, {
    key: "size",
    get: function get() {
      return this.fastMap.size;
    }
  }]);

  function $9bf71ea28793e738$var$Tree() {
    _classCallCheck$d(this, $9bf71ea28793e738$var$Tree);

    (_defineProperty$a)(this, "fastMap", new Map());
    this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    });
    this.fastMap.set(null, this.root);
  }

  return $9bf71ea28793e738$var$Tree;
}();

var $9bf71ea28793e738$var$TreeNode = /*#__PURE__*/function () {
  _createClass$b($9bf71ea28793e738$var$TreeNode, [{
    key: "addChild",
    value: function addChild(node) {
      this.children.push(node);
      node.parent = this;
    }
  }, {
    key: "removeChild",
    value: function removeChild(node) {
      this.children.splice(this.children.indexOf(node), 1);
      node.parent = undefined;
    }
  }]);

  function $9bf71ea28793e738$var$TreeNode(props) {
    _classCallCheck$d(this, $9bf71ea28793e738$var$TreeNode);

    (_defineProperty$a)(this, "children", []);
    (_defineProperty$a)(this, "contain", false);
    this.scopeRef = props.scopeRef;
  }

  return $9bf71ea28793e738$var$TreeNode;
}();

new $9bf71ea28793e738$var$Tree();
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */


var $e6afbd83fe6ebbd2$var$FocusableContext = /*#__PURE__*/(React).createContext(null);

function $e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
  var context = (react.exports.useContext)($e6afbd83fe6ebbd2$var$FocusableContext) || {};
  ($e7801be82b4b2a53$export$4debdb1a3f0fa79e)(context, ref); // eslint-disable-next-line

  context.ref;
      var otherProps = _objectWithoutProperties$2(context, ["ref"]);

  return otherProps;
}

function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, domRef) {
  var _ref9 = ($a1ea59d68270f0dd$export$f8168d8dd8fd66e6)(props),
      focusProps = _ref9.focusProps;

  var _ref10 = ($46d819fcbaf35654$export$8f71654801c2f7cd)(props),
      keyboardProps = _ref10.keyboardProps;

  var interactions = ($3ef42575df84b30b$export$9d1611c77c2fe928)(focusProps, keyboardProps);
  var domProps = $e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
  var interactionProps = props.isDisabled ? {} : domProps;
  var autoFocusRef = (react.exports.useRef)(props.autoFocus);
  (react.exports.useEffect)(function () {
    if (autoFocusRef.current && domRef.current) ($6a99195332edec8b$export$80f3e147d781571c)(domRef.current);
    autoFocusRef.current = false;
  }, [domRef]);
  return {
    focusableProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(_objectSpread$Q(_objectSpread$Q({}, interactions), {}, {
      tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
    }), interactionProps)
  };
}

function ownKeys$Q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$P(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$Q(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$Q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */


function $4e1b34546679e357$export$a6da6c504e4bba8b(props, state, ref) {
  var isDisabled = props.isDisabled,
      trigger = props.trigger;
  var tooltipId = ($bdb11010cef70236$export$f680877a34711e37)();
  var isHovered = (react.exports.useRef)(false);
  var isFocused = (react.exports.useRef)(false);

  var handleShow = function handleShow() {
    if (isHovered.current || isFocused.current) state.open(isFocused.current);
  };

  var handleHide = function handleHide(immediate) {
    if (!isHovered.current && !isFocused.current) state.close(immediate);
  };

  (react.exports.useEffect)(function () {
    var onKeyDown = function onKeyDown(e) {
      if (ref && ref.current) // Escape after clicking something can give it keyboard focus
        // dismiss tooltip on esc key press
        {
          if (e.key === "Escape") state.close(true);
        }
    };

    if (state.isOpen) {
      document.addEventListener("keydown", onKeyDown, true);
      return function () {
        document.removeEventListener("keydown", onKeyDown, true);
      };
    }
  }, [ref, state]);

  var onHoverStart = function onHoverStart() {
    if (trigger === "focus") return; // In chrome, if you hover a trigger, then another element obscures it, due to keyboard
    // interactions for example, hover will end. When hover is restored after that element disappears,
    // focus moves on for example, then the tooltip will reopen. We check the modality to know if the hover
    // is the result of moving the mouse.

    if (($507fabe10e71c6fb$export$630ff653c5ada6a9)() === "pointer") isHovered.current = true;else isHovered.current = false;
    handleShow();
  };

  var onHoverEnd = function onHoverEnd() {
    if (trigger === "focus") return; // no matter how the trigger is left, we should close the tooltip

    isFocused.current = false;
    isHovered.current = false;
    handleHide();
  };

  var onPressStart = function onPressStart() {
    // no matter how the trigger is pressed, we should close the tooltip
    isFocused.current = false;
    isHovered.current = false;
    handleHide(true);
  };

  var onFocus = function onFocus() {
    var isVisible = ($507fabe10e71c6fb$export$b9b3dfddab17db27)();

    if (isVisible) {
      isFocused.current = true;
      handleShow();
    }
  };

  var onBlur = function onBlur() {
    isFocused.current = false;
    isHovered.current = false;
    handleHide(true);
  };

  var _ref2 = ($6179b936705e76d3$export$ae780daf29e6d456)({
    isDisabled: isDisabled,
    onHoverStart: onHoverStart,
    onHoverEnd: onHoverEnd
  }),
      hoverProps = _ref2.hoverProps;

  var _ref3 = ($f6c31cce2adf654f$export$45712eceda6fad21)({
    onPressStart: onPressStart
  }),
      pressProps = _ref3.pressProps;

  var _ref4 = ($e6afbd83fe6ebbd2$export$4c014de7c8940b4c)({
    isDisabled: isDisabled,
    onFocus: onFocus,
    onBlur: onBlur
  }, ref),
      focusableProps = _ref4.focusableProps;

  return {
    triggerProps: _objectSpread$P({
      "aria-describedby": state.isOpen ? tooltipId : undefined
    }, ($3ef42575df84b30b$export$9d1611c77c2fe928)(focusableProps, hoverProps, pressProps)),
    tooltipProps: {
      id: tooltipId
    }
  };
}

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? react.exports.useLayoutEffect : react.exports.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow$1(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement$2(node) {
  var OwnElement = getWindow$1(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow$1(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow$1(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement$2(element) ? getWindow$1(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;

    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...


      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow$1(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$2(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow$1(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow$1(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow$1(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow$1(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow$1(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow$1(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$2(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement$2(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement$2(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$2(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name; // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step

  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow$1(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$2(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap$1 = typeof Map === 'function';
var hasSet$1 = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView; // Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;

    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    } // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.


    var it;

    if (hasMap$1 && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      it = a.entries();

      while (!(i = it.next()).done) {
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      }

      return true;
    }

    if (hasSet$1 && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      return true;
    } // END: Modifications


    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (a[i] !== b[i]) return false;
      }

      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    } // END: fast-deep-equal
    // START: react-fast-compare
    // custom handling for DOM elements


    if (hasElementType && a instanceof Element) return false; // custom handling for React/Preact

    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements
        continue;
      } // all other properties should be traversed as usual


      if (!equal(a[keys[i]], b[keys[i]])) return false;
    } // END: react-fast-compare
    // START: fast-deep-equal


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
};

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = react.exports.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = react.exports.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = react.exports.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        reactDom.exports.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = react.exports.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = react.exports.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

function ownKeys$P(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$O(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$P(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$P(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function useTooltip() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick;

  var _useState = react.exports.useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = react.exports.useState(null),
      triggerElement = _useState2[0],
      setTriggerElement = _useState2[1];

  var _useState3 = react.exports.useState(null),
      tooltipElement = _useState3[0],
      setTooltipElement = _useState3[1];

  var _useState4 = react.exports.useState(null),
      arrowElement = _useState4[0],
      setArrowElement = _useState4[1];

  var _usePopper = usePopper(triggerElement, tooltipElement, {
    strategy: "absolute",
    placement: "bottom",
    modifiers: [{
      name: "arrow",
      options: {
        element: arrowElement,
        padding: 6
      }
    }]
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var tooltipTrigger = $4e1b34546679e357$export$a6da6c504e4bba8b({
    isDisabled: isDisabled,
    delay: 0
  }, {
    isOpen: isOpen,
    open: function open() {
      setIsOpen(true);
    },
    close: function close() {
      setIsOpen(false);
    }
  }, {
    current: triggerElement
  });

  var triggerProps = _objectSpread$O(_objectSpread$O({
    ref: setTriggerElement
  }, tooltipTrigger.triggerProps), {}, {
    onClick: onClick === undefined ? tooltipTrigger.tooltipProps.onClick : function (event) {
      var _tooltipTrigger$toolt, _tooltipTrigger$toolt2;

      (_tooltipTrigger$toolt = (_tooltipTrigger$toolt2 = tooltipTrigger.tooltipProps).onClick) === null || _tooltipTrigger$toolt === void 0 ? void 0 : _tooltipTrigger$toolt.call(_tooltipTrigger$toolt2, event);
      onClick();
    }
  });

  var tooltipProps = _objectSpread$O(_objectSpread$O({
    ref: setTooltipElement,
    style: styles.popper
  }, attributes.popper), tooltipTrigger.tooltipProps);

  var arrowProps = {
    ref: setArrowElement,
    style: styles.arrow
  };
  return {
    isOpen: isOpen,
    triggerProps: triggerProps,
    tooltipProps: tooltipProps,
    arrowProps: arrowProps
  };
}

var __jsx$x = react.exports.createElement;
// Wraps the Field component in labels describing the field's meta state
// Add any other fields that the Field component should expect onto the ExtraFieldProps generic type
function FieldMetaWrapper(_ref) {
  var _renderLabel;

  var children = _ref.children,
      field = _ref.field,
      input = _ref.input,
      meta = _ref.meta,
      noWrap = _ref.noWrap,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? "row" : _ref$layout,
      renderLabel = _ref.renderLabel,
      isLabelHidden = _ref.isLabelHidden;
  var editorContext = useEditorContext();
  var runChange = editorContext.actions.runChange,
      form = editorContext.form,
      resources = editorContext.resources;

  var _useTooltip = useTooltip({
    isDisabled: field.description === undefined
  }),
      isOpen = _useTooltip.isOpen,
      tooltipProps = _useTooltip.tooltipProps,
      triggerProps = _useTooltip.triggerProps,
      arrowProps = _useTooltip.arrowProps;

  var isMixedValueSupported = isMixedValueSupportedByComponent(isResponsiveField(field) ? field.subComponent : field.component);
  var isMixedValue = isMixedFieldValue(input.value);

  function handleButtonMixedClick() {
    runChange(function () {
      toArray$2(field.name).forEach(function (fieldName, _, names) {
        var firstFieldValue = dotNotationGet(form.values, names[0]);
        form.change(fieldName, firstFieldValue);
      });
    });
  }

  var content = __jsx$x(_StyledDiv$3, {
    $_css: layout === "row" ? "flex-end" : "flex-start"
  }, !isMixedValue || isMixedValue && isMixedValueSupported ? children : __jsx$x(TextButton, {
    component: "button",
    variant: "label",
    color: "black40",
    onClick: handleButtonMixedClick
  }, "Mixed"), meta.error && __jsx$x(FieldError, null, meta.error));

  if (noWrap) {
    return content;
  }

  var label = field.label || input.name;
  var schemaProp = field.schemaProp;
  var isResource = isResourceSchemaProp(schemaProp);
  var resolvedResource = isResource ? resources.find(resourceByIdentity(input.value.id, getResourceType(schemaProp, editorContext), input.value.info, getResourceFetchParams(schemaProp, editorContext))) : undefined;
  return __jsx$x(FieldWrapper, {
    margin: false,
    layout: layout
  }, !isLabelHidden && __jsx$x(FieldLabelWrapper, null, (_renderLabel = renderLabel === null || renderLabel === void 0 ? void 0 : renderLabel({
    label: label
  })) !== null && _renderLabel !== void 0 ? _renderLabel : __jsx$x(FieldLabel, _extends$b({
    htmlFor: input.name,
    isError: resolvedResource !== undefined && resolvedResource.status === "error"
  }, triggerProps), label, isOpen && __jsx$x(Tooltip, tooltipProps, __jsx$x(TooltipArrow, arrowProps), __jsx$x(TooltipBody, null, field.description)))), __jsx$x(FieldInputWrapper, {
    layout: layout
  }, content));
}

function isResponsiveField(field) {
  return typeof field.component === "string" && field.component === "responsive2";
}

function isMixedValueSupportedByComponent(component) {
  if (typeof component === "string") {
    return COMPONENTS_SUPPORTING_MIXED_VALUES.includes(component);
  }

  return false;
}

var TextButton = styled(Typography).withConfig({
  displayName: "wrapFieldWithMeta__TextButton",
  componentId: "sc-18u09ea-0"
})(["padding:0;margin:0;background:transparent;border:0;font-weight:500;&:hover{color:black;cursor:pointer;text-decoration:underline;}"]);
function wrapFieldsWithMeta(Field, extraProps) {
  return function (props) {
    return __jsx$x(FieldMetaWrapper, _extends$b({}, props, extraProps), __jsx$x(Field, props));
  };
}
var FieldWrapper = styled.div.withConfig({
  displayName: "wrapFieldWithMeta__FieldWrapper",
  componentId: "sc-18u09ea-1"
})(["display:flex;flex-direction:", ";gap:", ";justify-content:space-between;align-items:flex-start;position:relative;padding:4px 16px;"], function (_ref2) {
  var layout = _ref2.layout;
  return layout;
}, function (_ref3) {
  var layout = _ref3.layout;
  return layout === "row" ? "10px" : "4px";
});
var FieldLabelWrapper = styled.div.withConfig({
  displayName: "wrapFieldWithMeta__FieldLabelWrapper",
  componentId: "sc-18u09ea-2"
})(["all:unset;position:relative;display:flex;flex-direction:row;align-items:center;min-height:28px;"]);
var FieldLabel = styled.label.withConfig({
  displayName: "wrapFieldWithMeta__FieldLabel",
  componentId: "sc-18u09ea-3"
})(["all:unset;", ";display:block;color:", ";text-overflow:ellipsis;overflow:hidden;cursor:default;"], SSFonts.body, function (_ref4) {
  var isError = _ref4.isError;
  return isError ? "red" : "#000";
});
styled.span.withConfig({
  displayName: "wrapFieldWithMeta__FieldDescription",
  componentId: "sc-18u09ea-4"
})(["all:unset;display:block;font-family:\"Inter\",sans-serif;font-size:var(--tina-font-size-0);font-style:italic;font-weight:lighter;color:var(--tina-color-grey-6);padding-top:4px;white-space:normal;margin:0;"]);
var FieldError = styled.span.withConfig({
  displayName: "wrapFieldWithMeta__FieldError",
  componentId: "sc-18u09ea-5"
})(["display:block;color:red;font-size:var(--tina-font-size-1);margin-top:8px;font-weight:var(--tina-font-weight-regular);"]);
var FieldInputWrapper = styled.div.withConfig({
  displayName: "wrapFieldWithMeta__FieldInputWrapper",
  componentId: "sc-18u09ea-6"
})(["display:flex;justify-content:flex-end;align-items:center;", ";min-height:28px;"], function (_ref5) {
  var layout = _ref5.layout;
  return layout === "row" ? Ce(["flex-grow:1;"]) : Ce(["width:100%;"]);
});

var _StyledDiv$3 = styled("div").withConfig({
  displayName: "wrapFieldWithMeta___StyledDiv",
  componentId: "sc-18u09ea-7"
})(["width:100%;display:flex;justify-content:", ";"], function (p) {
  return p.$_css;
});

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var parse$3 = function parse(value) {
  return value || "";
};

var __jsx$w = react.exports.createElement;
var ColorField = wrapFieldsWithMeta(function (_ref) {
  var input = _ref.input,
      field = _ref.field;
  return __jsx$w(ColorPicker, {
    colorFormat: field.colorFormat,
    userColors: field.colors,
    widget: field.widget,
    input: input
  });
});
var ColorFieldPlugin = {
  name: "color",
  Component: ColorField,
  parse: parse$3
};

var PanelBody = styled.div.withConfig({
  displayName: "GroupFieldPlugin__PanelBody",
  componentId: "sc-13nltqr-0"
})(["background:white;position:relative;height:100%;overflow-y:auto;"]);
var GroupPanelKeyframes = Ue(["0%{transform:translate3d( 100%,0,0 );}100%{transform:translate3d( 0,0,0 );}"]);
var GroupPanel = styled.div.withConfig({
  displayName: "GroupFieldPlugin__GroupPanel",
  componentId: "sc-13nltqr-1"
})(["position:absolute;width:100%;top:0;bottom:0;left:0;overflow:hidden;z-index:var(--tina-z-index-1);pointer-events:", ";> *{", ";", ";}"], function (p) {
  return p.isExpanded ? "all" : "none";
}, function (p) {
  return p.isExpanded && Ce(["animation-name:", ";animation-duration:150ms;animation-delay:0ms;animation-iteration-count:1;animation-timing-function:ease-out;animation-fill-mode:backwards;"], GroupPanelKeyframes);
}, function (p) {
  return !p.isExpanded && Ce(["transition:transform 150ms ease-out;transform:translate3d(100%,0,0);"]);
});

var __jsx$v = react.exports.createElement;
function usePreviewSrc(value, fieldName, formValues, getPreviewSrc) {
  var cms = useCMS();
  var getSrc = getPreviewSrc || cms.media.previewSrc;

  var _useState = react.exports.useState({
    src: "",
    loading: true
  }),
      _useState$ = _useState[0],
      src = _useState$.src,
      loading = _useState$.loading,
      setState = _useState[1];

  react.exports.useEffect(function () {
    var componentUnmounted = false;
    var tmpSrc = "";

    _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getSrc(value, fieldName, formValues);

            case 3:
              tmpSrc = _context.sent;
              _context.next = 8;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);

            case 8:
              if (!componentUnmounted) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              setState({
                src: tmpSrc,
                loading: false
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6]]);
    }))();

    return function () {
      componentUnmounted = true;
    };
  }, [value]);
  return [src, loading];
}
var ImageField = wrapFieldsWithMeta(function (props) {
  var cms = useCMS();
  var form = props.form,
      field = props.field;
  var _props$input = props.input,
      name = _props$input.name,
      value = _props$input.value;

  var _usePreviewSrc = usePreviewSrc(value, name, form.getState().values, field.previewSrc),
      _usePreviewSrc2 = _slicedToArray$2(_usePreviewSrc, 2),
      src = _usePreviewSrc2[0],
      srcIsLoading = _usePreviewSrc2[1];

  var onClear;

  if (props.field.clearable) {
    onClear = function onClear() {
      return props.input.onChange("");
    };
  }

  function onChange(media) {
    if (media) {
      props.input.onChange("");
      props.input.onChange(media);
    }
  }

  var uploadDir = props.field.uploadDir || function () {
    return "";
  };

  return __jsx$v(ImageUpload, {
    value: value,
    previewSrc: src,
    loading: srcIsLoading,
    onClick: function onClick() {
      var directory = uploadDir(props.form.getState().values);
      cms.media.open({
        allowDelete: true,
        directory: directory,
        onSelect: onChange
      });
    },
    onDrop: /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2(_ref2) {
        var _ref4, file, directory, _yield$cms$media$pers, _yield$cms$media$pers2, media;

        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref4 = _slicedToArray$2(_ref2, 1), file = _ref4[0];
                directory = uploadDir(props.form.getState().values);
                _context2.next = 4;
                return cms.media.persist([{
                  directory: directory,
                  file: file
                }]);

              case 4:
                _yield$cms$media$pers = _context2.sent;
                _yield$cms$media$pers2 = _slicedToArray$2(_yield$cms$media$pers, 1);
                media = _yield$cms$media$pers2[0];
                onChange(media);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }(),
    onClear: onClear
  });
});
var ImageFieldPlugin = {
  name: "image",
  Component: ImageField,
  parse: parse$3
};

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var parse$2 = function parse(value) {
  return value && +value;
};

var __jsx$u = react.exports.createElement;
var NumberField = wrapFieldsWithMeta(function (_ref) {
  var input = _ref.input,
      field = _ref.field;
  return __jsx$u(NumberInput, _extends$b({}, input, {
    step: field.step,
    min: field.min,
    max: field.max
  }));
});
var NumberFieldPlugin = {
  name: "number",
  Component: NumberField,
  parse: parse$2
};

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var SelectField = wrapFieldsWithMeta(Select);
var SelectFieldPlugin = {
  name: "select",
  type: "select",
  Component: SelectField,
  parse: parse$3
};

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var RadioGroupField = wrapFieldsWithMeta(RadioGroup);
var RadioGroupFieldPlugin = {
  name: "radio-group",
  Component: RadioGroupField
};

var __jsx$t = react.exports.createElement;
var TextareaField = wrapFieldsWithMeta(function (_ref) {
  var input = _ref.input;
  return __jsx$t(TextArea, input);
});
var TextareaFieldPlugin = {
  name: "textarea",
  Component: TextareaField,
  parse: parse$3
};

function cleanString(value) {
  return value.replace(/\u2028/g, "");
}

var __jsx$s = react.exports.createElement;

function ownKeys$O(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$N(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$O(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$O(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useTextValue(value, onChange, defaultPlaceholder, normalize) {
  var _useEditorContext = useEditorContext(),
      actions = _useEditorContext.actions,
      locale = _useEditorContext.contextParams.locale,
      locales = _useEditorContext.locales;

  var isExternal = typeof value === "object" && value !== null;
  var fallbackValue = isExternal ? getFallbackForLocale(value.value, locale, locales) : undefined;

  var valueFromProps = function () {
    if (isExternal) {
      var displayedValue = value.value[locale];

      if (typeof displayedValue !== "string") {
        displayedValue = fallbackValue !== null && fallbackValue !== void 0 ? fallbackValue : "";
      }

      return displayedValue;
    }

    return value !== null && value !== void 0 ? value : "";
  }();

  var previousValue = react.exports.useRef(valueFromProps);

  var _React$useState = react.exports.useState(valueFromProps),
      _React$useState2 = _slicedToArray$2(_React$useState, 2),
      localInputValue = _React$useState2[0],
      setLocalInputValue = _React$useState2[1];

  function saveNewValue(newValue) {
    actions.runChange(function () {
      if (isExternal) {
        var newExternalValue = _objectSpread$N(_objectSpread$N({}, value), {}, {
          value: _objectSpread$N(_objectSpread$N({}, value.value), {}, _defineProperty$g({}, locale, newValue))
        });

        onChange(newExternalValue);
      } else {
        onChange(newValue);
      }
    });
  }

  var onChangeDebounced = react.exports.useCallback(lodash_debounce(function (newValue) {
    // If normalization is on, we shouldn't save on change
    if (normalize) {
      return;
    }

    saveNewValue(newValue);
  }, 500), [isExternal]);

  function handleBlur() {
    onChangeDebounced.cancel();
    var newValue = localInputValue;

    if (normalize) {
      var normalized = normalize(newValue);

      if (normalized === null) {
        newValue = previousValue.current;
      } else {
        newValue = normalized;
        previousValue.current = localInputValue;
      }
    }

    setLocalInputValue(newValue);

    if (isExternal) {
      if (newValue.trim() === "") {
        saveNewValue(null);
        setLocalInputValue(fallbackValue !== null && fallbackValue !== void 0 ? fallbackValue : "");
      } else {
        saveNewValue(newValue);
      }
    } else {
      if (value !== newValue) {
        saveNewValue(newValue);
      }
    }
  }

  function handleChange(event) {
    setLocalInputValue(event.currentTarget.value);
    onChangeDebounced(event.currentTarget.value);
  } // Sync local value with value from the config if the field value has been
  // changed from outside


  react.exports.useEffect(function () {
    setLocalInputValue(valueFromProps);
  }, [valueFromProps]);
  var style = {
    opacity: localInputValue === fallbackValue ? 0.5 : 1
  };
  return {
    onChange: handleChange,
    onBlur: handleBlur,
    value: cleanString(localInputValue),
    style: style,
    placeholder: defaultPlaceholder !== null && defaultPlaceholder !== void 0 ? defaultPlaceholder : "Enter text"
  };
}

var TextField = wrapFieldsWithMeta(function (_ref) {
  var input = _ref.input,
      field = _ref.field;

  var value = input.value,
      onChange = input.onChange,
      restInputProperties = _objectWithoutProperties$2(input, ["value", "onChange"]);

  var inputProps = useTextValue(value, onChange, field.placeholder, field.normalize);
  return __jsx$s(SSInput, _extends$b({}, restInputProperties, inputProps, {
    icon: field.icon,
    align: "right"
  }));
});
var TextFieldPlugin = {
  name: "text",
  Component: TextField,
  validate: function validate(value, values, meta, field) {
    if (field.required && !value) return "Required";
  },
  parse: parse$3
};

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var ToggleField = wrapFieldsWithMeta(Toggle);
var ToggleFieldPlugin = {
  name: "toggle",
  type: "checkbox",
  Component: ToggleField
};

function ownKeys$N(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$M(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$N(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$N(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function pathToCompiledPath(path, editorContext) {
  var pathInfo = parsePath(path, editorContext.form);

  if (pathInfo.parent) {
    var definition = findComponentDefinitionById(pathInfo.parent.templateId, editorContext);
    var schemaProp = definition.schema.find(function (schemaProp) {
      return schemaProp.prop === pathInfo.parent.fieldName;
    });
    var result = "".concat(pathToCompiledPath(pathInfo.parent.path, editorContext), ".").concat(getPropertyNameFromSchemaProp(schemaProp), ".").concat(pathInfo.parent.fieldName, ".").concat(pathInfo.index);

    if (result.startsWith(".")) {
      return result.substring(1);
    }

    return result;
  }

  return "";
}
function isFieldPortal(x) {
  return "portal" in x;
}
function buildTinaFields(path, editorContext) {
  return internalBuildTinaFields(path, editorContext);
}

function internalBuildTinaFields(path, editorContext, fieldsFilter) {
  var _compiledComponent$__, _compiledComponent$__2;

  var compiledPath = pathToCompiledPath(stripRichTextPartSelection(path), editorContext);
  var compiledComponent = dotNotationGet(editorContext.compiledComponentConfig, compiledPath);
  var allFields = [];
  ((_compiledComponent$__ = (_compiledComponent$__2 = compiledComponent.__editing) === null || _compiledComponent$__2 === void 0 ? void 0 : _compiledComponent$__2.fields) !== null && _compiledComponent$__ !== void 0 ? _compiledComponent$__ : []).filter(function (field) {
    return fieldsFilter ? fieldsFilter(field) : true;
  }).forEach(function (item) {
    if (isFieldPortal(item)) {
      var fields = [];

      if (item.portal === "component") {
        var _fields;

        var portalComponentFields = internalBuildTinaFields(item.source, editorContext);

        (_fields = fields).push.apply(_fields, _toConsumableArray$2(portalComponentFields));

        if (!item.includeHeader) {
          fields = fields.filter(function (x) {
            return x.prop !== "$myself";
          });
        }

        var groups = item.groups;

        if (groups) {
          fields = fields.filter(function (x) {
            return x.prop === "$myself" || groups.includes(x.group || "___doesn't matter___");
          });
        }
      } else if (item.portal === "field") {
        if (item.hidden) {
          return;
        }

        var portalFieldFields = internalBuildTinaFields(item.source, editorContext, function (field) {
          return !isFieldPortal(field) && field.prop === item.fieldName;
        });

        var portalField = _objectSpread$M(_objectSpread$M({}, portalFieldFields[0]), item.overrides);

        fields.push(portalField);
      } else if (item.portal === "multi-field") {
        if (item.sources.length === 0) {
          if (item.hidden) {
            return;
          }

          throw new Error("Missing sources for multi field portal of component \"".concat(compiledComponent._template, "\" at path \"").concat(path, "\". Set \"hidden\" to \"true\" for this portal if sources are empty"));
        }

        var _portalFieldFields = item.sources.flatMap(function (source) {
          return internalBuildTinaFields(source, editorContext, function (field) {
            return !isFieldPortal(field) && field.prop === item.fieldName;
          });
        });

        var firstField = _portalFieldFields[0];

        var combinedField = _objectSpread$M(_objectSpread$M(_objectSpread$M({}, firstField), item.overrides), {}, {
          name: _portalFieldFields.flatMap(function (field) {
            return field.name;
          })
        });

        fields.push(combinedField);
      }

      allFields = [].concat(_toConsumableArray$2(allFields), _toConsumableArray$2(fields));
    } else {
      allFields.push(item);
    }
  }); // Analytics fields should always go to the bottom (later they'll be in separate tab)

  var nonAnalyticsFields = allFields.filter(function (x) {
    return x.group !== "Analytics";
  });
  var analyticsFields = allFields.filter(function (x) {
    return x.group === "Analytics";
  });
  return [].concat(_toConsumableArray$2(nonAnalyticsFields), _toConsumableArray$2(analyticsFields));
}

function getPropertyNameFromSchemaProp(schemaProp) {
  if (isSchemaPropAction(schemaProp)) {
    return "actions";
  }

  if (isSchemaPropTextModifier(schemaProp) || isSchemaPropActionTextModifier(schemaProp)) {
    return "textModifiers";
  }

  return "components";
}

function ownKeys$M(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$L(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$M(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$M(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function mergeCommonFields(_ref) {
  var fields = _ref.fields;
  var mergedCommonFields = [];
  var fieldsGroupedByProperty = groupFieldsByPropertyName(fields.flat());

  for (var _i = 0, _Object$values = Object.values(fieldsGroupedByProperty); _i < _Object$values.length; _i++) {
    var currentFields = _Object$values[_i];

    if (currentFields.length < fields.length) {
      continue;
    }
    /**
     * Some fields can be hidden depending on the context of usage
     * ex. margin bottom is not applicable to the last element in stack
     */


    var visibleFields = currentFields.filter(function (field) {
      return !field.hidden;
    });

    if (visibleFields.length === 0) {
      continue;
    }

    var fieldDefinitionIds = visibleFields.map(function (field) {
      return getFieldSchemaWithDefinition(field).definition.id;
    });
    /**
     * All fields for given property have to be defined within the same schema, because ex.
     * field can have the same prop name in schema A, but different meaning in schema B
     */

    var uniqueDefinitionIds = getUniqueValues(fieldDefinitionIds); // It's common when interacting with $richText to pass fields of parent or ancestor down to $richTextPart.
    // Verify if the all unique ids aren't fields of $richText components.

    if (uniqueDefinitionIds.length > 1 && !uniqueDefinitionIds.every(function (id) {
      return id.startsWith("$richText");
    })) {
      continue;
    }

    var firstVisibleField = visibleFields[0];
    mergedCommonFields.push(_objectSpread$L(_objectSpread$L({}, firstVisibleField), {}, {
      name: visibleFields.length === 1 ? firstVisibleField.name : getUniqueValues(visibleFields.flatMap(function (field) {
        return field.name;
      }))
    }));
  }

  return mergedCommonFields;
}

function groupFieldsByPropertyName(fields) {
  return fields.reduce(function (repeatedFields, field) {
    var currentFieldPropertyName = getPropertyName(field.schemaProp.prop);
    var fields = repeatedFields[currentFieldPropertyName];
    repeatedFields[currentFieldPropertyName] = fields !== undefined ? [].concat(_toConsumableArray$2(fields), [field]) : [field];
    return repeatedFields;
  }, {});
}

function getPropertyName(fieldName) {
  var fieldNameParts = fieldName.split(".");
  var lastPart = last(fieldNameParts); // If property name starts with `$` sign it's a special property of fake field.

  if (lastPart.startsWith("$")) {
    lastPart = lastPart.slice(1);
  }

  if (fieldNameParts[0] === "$previous") {
    return "".concat(fieldNameParts[0], ".").concat(lastPart);
  }

  return lastPart;
}

function getFieldSchemaWithDefinition(field) {
  return field.schemaProp;
}

var __jsx$r = react.exports.createElement;
var Preview = styled.div.withConfig({
  displayName: "ThumbnailButton__Preview",
  componentId: "sc-bw2u19-0"
})(["display:flex;align-items:center;justify-content:center;margin-left:-1px;width:32px;height:32px;border:1px solid #e5e5e5;border-radius:2px;position:relative;min-width:0;"]);
var PreviewImage = styled.img.withConfig({
  displayName: "ThumbnailButton__PreviewImage",
  componentId: "sc-bw2u19-1"
})(["display:block;max-width:100%;max-height:100%;object-fit:contain;"]);
var SolidColorPreview = styled.div.withConfig({
  displayName: "ThumbnailButton__SolidColorPreview",
  componentId: "sc-bw2u19-2"
})(["width:100%;height:100%;background-color:", ";"], function (_ref) {
  var color = _ref.color;
  return color;
});
var ContentRoot = styled.div.withConfig({
  displayName: "ThumbnailButton__ContentRoot",
  componentId: "sc-bw2u19-3"
})(["display:flex;align-items:center;gap:8px;width:100%;"]);
var Labels = styled.div.withConfig({
  displayName: "ThumbnailButton__Labels",
  componentId: "sc-bw2u19-4"
})(["flex:1 0;overflow:hidden;min-width:0;"]);
function ThumbnailButton(_ref2) {
  var onClick = _ref2.onClick,
      label = _ref2.label,
      description = _ref2.description,
      thumbnail = _ref2.thumbnail,
      disabled = _ref2.disabled;
  var preview;

  if ((thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.type) === "image") {
    preview = __jsx$r(PreviewImage, {
      src: thumbnail.src,
      "aria-hidden": "true"
    });
  } else if ((thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.type) === "color") {
    preview = __jsx$r(SolidColorPreview, {
      color: thumbnail.color
    });
  } else if ((thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.type) === "icon") {
    preview = __jsx$r(thumbnail.icon, {
      size: 16
    });
  } else {
    preview = __jsx$r(SolidColorPreview, {
      color: "transparent"
    });
  }

  var content = __jsx$r(ContentRoot, null, __jsx$r(Preview, null, preview), __jsx$r(Labels, null, label && __jsx$r(Typography, {
    variant: "label"
  }, label), description && __jsx$r(Typography, {
    variant: "body",
    color: "black40"
  }, description)));

  if (disabled) {
    return __jsx$r(ContentRoot, null, content);
  }

  return __jsx$r("div", {
    style: {
      display: "grid",
      width: "100%"
    }
  }, __jsx$r(SSButtonGhost, {
    onClick: onClick,
    height: "32px",
    noPadding: true
  }, content));
}

var __jsx$q = react.exports.createElement;
var IdWrapper = styled.div.withConfig({
  displayName: "SidebarFooter__IdWrapper",
  componentId: "sc-1tymhxv-0"
})(["display:block;padding:16px;", " color:", ";"], SSFonts.body, SSColors.black40);
function SidebarFooter(props) {
  var _useEditorContext = useEditorContext(),
      form = _useEditorContext.form,
      isMaster = _useEditorContext.isMaster,
      isAdminMode = _useEditorContext.isAdminMode;

  var value = props.paths.length === 1 ? dotNotationGet(form.values, stripRichTextPartSelection(props.paths[0])) : null;

  var _useState = react.exports.useState(false),
      canClipboardCopy = _useState[0],
      setClipboardCopy = _useState[1];

  react.exports.useEffect(function () {
    // @ts-ignore
    navigator.permissions.query({
      name: "clipboard-read",
      allowWithoutGesture: false
    }).then(function (_ref) {
      var state = _ref.state;

      if (state === "granted" || state === "prompt") {
        setClipboardCopy(true);
      }
    });
  }, []);

  if (!value) {
    return null;
  }

  return __jsx$q("div", null, __jsx$q(IdWrapper, null, __jsx$q("div", null, "Id: ", value._id), (isMaster || isAdminMode) && __jsx$q("div", {
    style: {
      paddingTop: 16
    }
  }, __jsx$q("div", {
    style: {
      display: "flex",
      flexWrap: "wrap",
      gap: "8px"
    }
  }, __jsx$q(SSButtonPrimary, {
    onClick: function onClick() {
      console.log("The config:");
      console.log(value);
    }
  }, "Print to console"), canClipboardCopy && __jsx$q(SSButtonPrimary, {
    onClick: function onClick() {
      console.log("trying to copy config to clipboard");
      navigator.clipboard.writeText(JSON.stringify(value)).then(function () {
        console.log("copied successfully!");
      }, function (reason) {
        console.error("error while copying: ", reason);
      });
    }
  }, "Copy data")), value._master && __jsx$q("div", {
    style: {
      paddingTop: 16
    }
  }, "Master: ", value._master))));
}

var __jsx$p = react.exports.createElement;

var BlockField = function BlockField(_ref) {
  var field = _ref.field,
      input = _ref.input,
      isLabelHidden = _ref.isLabelHidden;

  var _React$useState = react.exports.useState(false),
      _React$useState2 = _slicedToArray$2(_React$useState, 2),
      isSubcomponentPanelExpanded = _React$useState2[0],
      setIsSubcomponentPanelExpanded = _React$useState2[1];

  var editorContext = useEditorContext();
  var actions = editorContext.actions,
      activeEditor = editorContext.activeEditor;
  var openComponentPicker = actions.openComponentPicker;
  var schemaProp = field.schemaProp;
  var isConfigRequired = schemaProp.type === "component-fixed" || schemaProp.required;
  var isMixed = isMixedFieldValue(input.value);

  var config = function () {
    if (isMixed) {
      return null;
    } // @ts-expect-error We can safely ignore the error since we know the value is not mixed


    return input.value[0] || null;
  }();

  var normalizedName = toArray$2(field.name); // Let's create paths

  var paths = normalizedName.map(function (x) {
    return "".concat(x, ".0");
  });
  var componentPickerPath = normalizedName[0];
  return __jsx$p(react.exports.Fragment, null, !isLabelHidden && __jsx$p(_StyledDiv$2, null, __jsx$p(Typography, null, field.label || field.name)), __jsx$p(_StyledDiv2$1, null, config !== null && __jsx$p(react.exports.Fragment, null, __jsx$p("div", {
    style: {
      flex: "1 1 auto",
      minWidth: 0
    }
  }, __jsx$p(SubComponentPanelButton, {
    paths: paths,
    isExpanded: isSubcomponentPanelExpanded,
    onExpand: function onExpand() {
      setIsSubcomponentPanelExpanded(true);
    },
    onCollapse: function onCollapse() {
      setIsSubcomponentPanelExpanded(false);
    }
  })), !isConfigRequired && __jsx$p("div", {
    style: {
      flex: "0 0 auto",
      minWidth: 0
    }
  }, __jsx$p(SSButtonGhost, {
    onClick: function onClick() {
      if (activeEditor) {
        input.onChange([]);
      } else {
        actions.removeItems(paths);
      }
    },
    icon: SSIcons.Remove,
    "aria-label": "Remove"
  }))), config === null && (isMixed ? __jsx$p(ThumbnailButton, {
    label: "Mixed",
    disabled: true
  }) : __jsx$p(AddButton$1, {
    onAdd: function onAdd() {
      openComponentPicker({
        path: componentPickerPath
      }).then(function (newConfig) {
        if (newConfig) {
          if (activeEditor) {
            input.onChange([newConfig]);
          } else {
            actions.replaceItems(paths, newConfig);
          }

          setIsSubcomponentPanelExpanded(true);
        }
      });
    }
  }))));
};

function AddButton$1(_ref2) {
  var onAdd = _ref2.onAdd;
  return __jsx$p(_StyledSSButtonGhost$1, {
    onClick: onAdd,
    height: "32px"
  }, __jsx$p(_StyledDiv3$1, null, __jsx$p(_StyledDiv4, {
    $_css: SSColors.black20
  }, __jsx$p(SSIcons.Add, {
    size: 16
  })), "Add"));
}

var SubComponentPanelButton = function SubComponentPanelButton(_ref3) {
  var _ref4, _componentDefinition$, _componentDefinition$2;

  var paths = _ref3.paths,
      isExpanded = _ref3.isExpanded,
      onExpand = _ref3.onExpand,
      onCollapse = _ref3.onCollapse;
  var sidebarPanelsRoot = document.getElementById("sidebar-panels-root");
  var editorContext = useEditorContext();
  var config = dotNotationGet(editorContext.configAfterAuto, paths[0]);
  var componentDefinition = findComponentDefinition(config, editorContext);
  var label = (_ref4 = (_componentDefinition$ = componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.label) !== null && _componentDefinition$ !== void 0 ? _componentDefinition$ : componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.id) !== null && _ref4 !== void 0 ? _ref4 : "Shopstory can\u2019t find custom component with id: ".concat(config._template, " in your project. Please contact your developers to resolve this issue.");
  var showError = componentDefinition === undefined;
  var sidebarPreview = componentDefinition === null || componentDefinition === void 0 ? void 0 : (_componentDefinition$2 = componentDefinition.getEditorSidebarPreview) === null || _componentDefinition$2 === void 0 ? void 0 : _componentDefinition$2.call(componentDefinition, config, editorContext);

  var thumbnail = function () {
    if (!sidebarPreview) {
      return;
    }

    if (sidebarPreview.type === "icon" && sidebarPreview.icon) {
      return {
        type: "icon",
        icon: sidebarPreview.icon
      };
    } else if (sidebarPreview.type === "image") {
      return {
        type: "image",
        src: sidebarPreview.url
      };
    } else if (sidebarPreview.type === "solid") {
      return {
        type: "color",
        color: sidebarPreview.color
      };
    }

    return;
  }();

  return showError ? __jsx$p(Error$2, null, label) : __jsx$p(react.exports.Fragment, null, __jsx$p(ThumbnailButton, {
    onClick: onExpand,
    label: label,
    description: sidebarPreview === null || sidebarPreview === void 0 ? void 0 : sidebarPreview.description,
    thumbnail: thumbnail
  }), sidebarPanelsRoot && /*#__PURE__*/ReactDOM.createPortal(__jsx$p(Panel, {
    isExpanded: isExpanded,
    onCollapse: onCollapse,
    paths: paths
  }), sidebarPanelsRoot));
};

var Error$2 = styled.div.withConfig({
  displayName: "BlockFieldPlugin__Error",
  componentId: "sc-151seuc-0"
})(["", " padding:7px 6px 7px;color:hsl(0deg 0% 50% / 0.8);white-space:normal;background:hsl(0deg 100% 50% / 0.2);margin-right:10px;border-radius:2px;"], SSFonts.body);
var PanelContext = /*#__PURE__*/react.exports.createContext(undefined);

function Panel(_ref5) {
  var onCollapse = _ref5.onCollapse,
      isExpanded = _ref5.isExpanded,
      paths = _ref5.paths;
  var editorContext = useEditorContext();
  var fields = react.exports.useMemo(function () {
    if (!isExpanded) {
      return [];
    }

    var fieldsPerName = toArray$2(paths).map(function (path) {
      return buildTinaFields(path, editorContext);
    });
    var mergedFields = mergeCommonFields({
      fields: fieldsPerName
    });
    return mergedFields;
  }, [isExpanded, paths]);
  return __jsx$p(PanelContext.Provider, {
    value: {
      onClose: onCollapse
    }
  }, __jsx$p(GroupPanel, {
    isExpanded: isExpanded
  }, __jsx$p(PanelBody, null, isExpanded ? __jsx$p("div", null, __jsx$p(FieldsBuilder, {
    form: editorContext.form,
    fields: fields
  }), __jsx$p(SidebarFooter, {
    paths: paths
  })) : null)));
}

var BlockFieldPlugin = {
  __type: "field",
  name: "ss-block",
  Component: BlockField
};

var _StyledDiv$2 = styled("div").withConfig({
  displayName: "BlockFieldPlugin___StyledDiv",
  componentId: "sc-151seuc-1"
})(["display:flex;align-items:center;padding:4px 16px;min-height:28px;"]);

var _StyledDiv2$1 = styled("div").withConfig({
  displayName: "BlockFieldPlugin___StyledDiv2",
  componentId: "sc-151seuc-2"
})(["display:flex;justify-content:space-between;align-items:center;padding:4px 16px;margin-bottom:12px;"]);

var _StyledSSButtonGhost$1 = styled(SSButtonGhost).withConfig({
  displayName: "BlockFieldPlugin___StyledSSButtonGhost",
  componentId: "sc-151seuc-3"
})(["width:100%;padding-left:0;"]);

var _StyledDiv3$1 = styled("div").withConfig({
  displayName: "BlockFieldPlugin___StyledDiv3",
  componentId: "sc-151seuc-4"
})(["display:flex;align-items:center;gap:8px;width:100%;"]);

var _StyledDiv4 = styled("div").withConfig({
  displayName: "BlockFieldPlugin___StyledDiv4",
  componentId: "sc-151seuc-5"
})(["display:grid;place-items:center;width:32px;height:32px;margin-left:-1px;border:1px dashed ", ";border-radius:2px;"], function (p) {
  return p.$_css;
});

var __jsx$o = react.exports.createElement;
var VariantsList = styled.ul.withConfig({
  displayName: "VariantsPlugin__VariantsList",
  componentId: "sc-84qzfz-0"
})(["display:flex;flex-direction:column;gap:0.25rem;list-style:none;padding:0;margin:1rem;"]);
var VariantListItem = styled.li.withConfig({
  displayName: "VariantsPlugin__VariantListItem",
  componentId: "sc-84qzfz-1"
})(["padding:0.5rem;display:flex;justify-content:space-between;align-items:center;border-radius:0.25rem;border:1px solid ", ";"], function (props) {
  return props.isActive ? SSColors.blue50 : SSColors.black10;
});

var VariantItem = function VariantItem(_ref) {
  var id = _ref.id,
      index = _ref.index,
      isActive = _ref.isActive,
      onClick = _ref.onClick,
      children = _ref.children;
  return __jsx$o(PublicDraggable, {
    draggableId: id,
    key: id,
    index: index
  }, function (draggableProvided) {
    return __jsx$o(VariantListItem, _extends$b({
      isActive: isActive,
      onClick: onClick,
      ref: draggableProvided.innerRef
    }, draggableProvided.draggableProps, draggableProvided.dragHandleProps), children);
  });
};

var isVariant = function isVariant(config) {
  return config !== null || "_variantGroupId" in (config !== null && config !== void 0 ? config : {});
};

var VariantsComponent = function VariantsComponent(_ref2) {
  var field = _ref2.field,
      input = _ref2.input;

  var _useEditorContext = useEditorContext(),
      variantsManager = _useEditorContext.variantsManager;

  if (!variantsManager) {
    return null;
  }

  var getVariantsGroup = variantsManager.getVariantsGroup,
      reorderVariant = variantsManager.reorderVariant,
      selectVariant = variantsManager.selectVariant,
      removeVariant = variantsManager.removeVariant,
      openAddVariantModal = variantsManager.openAddVariantModal,
      openEditVariantModal = variantsManager.openEditVariantModal;

  var currentVariant = function () {
    if (field.schemaProp.type === "variants$$$") {
      return input.value || null;
    } else {
      // @ts-ignore it's safe
      return input.value[0] || null;
    }
  }();

  if (!isVariant(currentVariant)) {
    return null;
  }

  var variantGroupId = currentVariant._variantGroupId;
  var variants = getVariantsGroup(variantGroupId);
  var path = Array.isArray(field.name) ? field.name[0] : field.name;
  return __jsx$o(react.exports.Fragment, null, variants.length > 0 && __jsx$o(DragDropContext, {
    onDragEnd: function onDragEnd(result) {
      var _result$destination;

      reorderVariant(variantGroupId, result.source.index, result === null || result === void 0 ? void 0 : (_result$destination = result.destination) === null || _result$destination === void 0 ? void 0 : _result$destination.index);
    }
  }, __jsx$o(ConnectedDroppable, {
    droppableId: "variants"
  }, function (provided) {
    return __jsx$o(VariantsList, _extends$b({}, provided.droppableProps, {
      ref: provided.innerRef
    }), variants.map(function (_ref3, index) {
      var variantId = _ref3.variantId,
          name = _ref3.name,
          description = _ref3.description;
      return __jsx$o(VariantItem, {
        key: variantId,
        id: variantId,
        index: index,
        isActive: currentVariant._id === variantId,
        onClick: function onClick() {
          selectVariant(variantId, path);
        }
      }, __jsx$o(VariantInfo, {
        title: "".concat(name, " - ").concat(description)
      }, __jsx$o(VariantName, null, name), description && __jsx$o(VariantDescription, null, description)), __jsx$o(VariantActions, null, __jsx$o(SSButtonGhostColor, {
        onClick: function onClick(e) {
          e.stopPropagation();
          openEditVariantModal(variantId, variantGroupId, path);
        }
      }, "Edit"), __jsx$o(SSButtonGhostColor, {
        onClick: function onClick(e) {
          e.stopPropagation();
          removeVariant(variantId, variantGroupId, path);
        }
      }, __jsx$o(TrashIcon, null))));
    }), provided.placeholder);
  })), __jsx$o(AddVariant, null, __jsx$o(SSButtonGhostColor, {
    onClick: function onClick() {
      openAddVariantModal(currentVariant, path);
    }
  }, __jsx$o(SSIcons.Add, null), " Add Variant")));
};

var VariantInfo = styled.div.withConfig({
  displayName: "VariantsPlugin__VariantInfo",
  componentId: "sc-84qzfz-2"
})(["flex:1 1;display:flex;flex-direction:column;overflow:hidden;"]);
var VariantDescription = styled.div.withConfig({
  displayName: "VariantsPlugin__VariantDescription",
  componentId: "sc-84qzfz-3"
})(["", " color:", ";text-overflow:ellipsis;overflow:hidden;"], SSFonts.body, SSColors.black40);
var VariantName = styled.span.withConfig({
  displayName: "VariantsPlugin__VariantName",
  componentId: "sc-84qzfz-4"
})(["flex:1 1 auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:all 85ms ease-out;text-align:left;", ";", ";"], SSFonts.label, function (props) {
  return props.error && Ce(["color:var(--tina-color-error) !important;"]);
});
var VariantActions = styled.div.withConfig({
  displayName: "VariantsPlugin__VariantActions",
  componentId: "sc-84qzfz-5"
})(["flex:0 0;display:flex;"]);
var AddVariant = styled.div.withConfig({
  displayName: "VariantsPlugin__AddVariant",
  componentId: "sc-84qzfz-6"
})(["margin:1rem;"]);
var VariantsPlugin = {
  __type: "variant",
  name: "variant",
  Component: VariantsComponent
};

function ownKeys$L(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$K(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$L(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$L(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**

 Copyright 2019 Forestry.io Inc

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.

 */
var Alerts = /*#__PURE__*/function () {
  function Alerts(events) {
    var _this = this;

    var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$d(this, Alerts);

    this.events = events;
    this.map = map;

    _defineProperty$g(this, "alerts", new Map());

    _defineProperty$g(this, "mapEventToAlert", function (event) {
      var toAlert = _this.map[event.type];

      if (toAlert) {
        var getArgs;

        if (typeof toAlert === "function") {
          getArgs = toAlert;
        } else {
          getArgs = function getArgs() {
            return toAlert;
          };
        }

        var _getArgs = getArgs(event),
            level = _getArgs.level,
            message = _getArgs.message,
            timeout = _getArgs.timeout;

        _this.add(level, message, timeout);
      }
    });

    this.events.subscribe("*", this.mapEventToAlert);
  }

  _createClass$b(Alerts, [{
    key: "setMap",
    value: function setMap(eventsToAlerts) {
      this.map = _objectSpread$K(_objectSpread$K({}, this.map), eventsToAlerts);
    }
  }, {
    key: "add",
    value: function add(level, message) {
      var _this2 = this;

      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3000;
      var alert = {
        level: level,
        message: message,
        timeout: timeout,
        id: "".concat(message, "|").concat(Date.now())
      };
      this.alerts.set(alert.id, alert);
      this.events.dispatch({
        type: "alerts:add",
        alert: alert
      });
      var timeoutId = null;

      var dismiss = function dismiss() {
        clearTimeout(timeoutId);

        _this2.dismiss(alert);
      };

      timeoutId = setTimeout(dismiss, alert.timeout);
      return dismiss;
    }
  }, {
    key: "dismiss",
    value: function dismiss(alert) {
      this.alerts["delete"](alert.id);
      this.events.dispatch({
        type: "alerts:remove",
        alert: alert
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(cb) {
      var unsub = this.events.subscribe("alerts", cb);
      return function () {
        return unsub();
      };
    }
  }, {
    key: "info",
    value: function info(message, timeout) {
      return this.add("info", message, timeout);
    }
  }, {
    key: "success",
    value: function success(message, timeout) {
      return this.add("success", message, timeout);
    }
  }, {
    key: "warn",
    value: function warn(message, timeout) {
      return this.add("warn", message, timeout);
    }
  }, {
    key: "error",
    value: function error(message, timeout) {
      return this.add("error", message, timeout);
    }
  }, {
    key: "all",
    get: function get() {
      return Array.from(this.alerts.values());
    }
  }]);

  return Alerts;
}();

function ownKeys$K(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$J(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$K(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$K(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$a(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DEFAULT_FIELDS = [TextFieldPlugin, TextareaFieldPlugin, ImageFieldPlugin, ColorFieldPlugin, NumberFieldPlugin, ToggleFieldPlugin, SelectFieldPlugin, RadioGroupFieldPlugin];
var TinaCMS = /*#__PURE__*/function (_CMS) {
  _inherits$b(TinaCMS, _CMS);

  var _super = _createSuper$2(TinaCMS);

  function TinaCMS() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref$alerts = _ref.alerts,
        alerts = _ref$alerts === void 0 ? {} : _ref$alerts,
        config = _objectWithoutProperties$2(_ref, ["alerts"]);

    _classCallCheck$d(this, TinaCMS);

    _this = _super.call(this, config);

    _defineProperty$g(_assertThisInitialized$1(_this), "_alerts", void 0);

    _this.alerts.setMap(_objectSpread$J({
      "media:upload:failure": function mediaUploadFailure() {
        return {
          level: "error",
          message: "Failed to upload file."
        };
      },
      "media:delete:failure": function mediaDeleteFailure() {
        return {
          level: "error",
          message: "Failed to delete file."
        };
      }
    }, alerts));

    DEFAULT_FIELDS.forEach(function (field) {
      if (!_this.fields.find(field.name)) {
        _this.fields.add(field);
      }
    }); // this.plugins.add(MediaManagerScreenPlugin);
    // if (!this.plugins.getType("media:ui").find("paginator")) {
    //   this.plugins.add(BaseMediaPaginator);
    // }

    return _this;
  }

  _createClass$b(TinaCMS, [{
    key: "registerApi",
    value: function registerApi(name, api) {
      if (api.alerts) {
        this.alerts.setMap(api.alerts);
      }

      _get(_getPrototypeOf$2(TinaCMS.prototype), "registerApi", this).call(this, name, api);
    }
  }, {
    key: "alerts",
    get: function get() {
      if (!this._alerts) {
        this._alerts = new Alerts(this.events);
      }

      return this._alerts;
    }
  }, {
    key: "forms",
    get: function get() {
      return this.plugins.findOrCreateMap("form");
    }
  }, {
    key: "fields",
    get: function get() {
      return this.plugins.findOrCreateMap("field");
    }
  }, {
    key: "screens",
    get: function get() {
      return this.plugins.findOrCreateMap("screen");
    }
  }]);

  return TinaCMS;
}(CMS);

var __jsx$n = react.exports.createElement;
var INVALID_CMS_ERROR = "The `cms` prop must be an instance of `TinaCMS`.";
var TinaProvider = function TinaProvider(_ref) {
  var cms = _ref.cms,
      children = _ref.children,
      _ref$styled = _ref.styled,
      styled = _ref$styled === void 0 ? true : _ref$styled,
      rootContainerNode = _ref.rootContainerNode;

  var _useState = react.exports.useState(cms.enabled),
      enabled = _useState[0],
      setEnabled = _useState[1];

  react.exports.useEffect(function () {
    return cms.events.subscribe("cms", function () {
      setEnabled(cms.enabled);
    });
  }, []);

  if (!(cms instanceof TinaCMS)) {
    throw new Error(INVALID_CMS_ERROR);
  }

  return __jsx$n(CMSContext.Provider, {
    value: cms
  }, __jsx$n(ModalProvider, {
    rootContainerNode: rootContainerNode
  }, enabled && styled && __jsx$n(Theme, null), children));
};
/**
 * @deprecated This has been renamed to `TinaProviderProps`.
 */

function includesAny(a, b) {
  return a.some(function (i) {
    return b.includes(i);
  });
}

function ownKeys$J(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$I(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$J(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$J(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function reconcile(_ref) {
  var context = _ref.context,
      templateId = _ref.templateId,
      fieldName = _ref.fieldName;
  return function (item) {
    var _item$_itemProps, _item$_itemProps$temp;

    if (!fieldName || !templateId) {
      return item;
    }

    var contextMatches = ((_item$_itemProps = item._itemProps) === null || _item$_itemProps === void 0 ? void 0 : (_item$_itemProps$temp = _item$_itemProps[templateId]) === null || _item$_itemProps$temp === void 0 ? void 0 : _item$_itemProps$temp[fieldName]) !== undefined;

    if (contextMatches) {
      return item;
    }

    return normalize(_objectSpread$I(_objectSpread$I({}, item), {}, {
      _itemProps: _defineProperty$g({}, templateId, _defineProperty$g({}, fieldName, {}))
    }), context);
  };
}

var getTypes = function getTypes(schema) {
  if ((schema === null || schema === void 0 ? void 0 : schema.type) === "component-collection" || (schema === null || schema === void 0 ? void 0 : schema.type) === "component") {
    return schema.componentTypes;
  }

  return [];
};

var insertCommand = function insertCommand(_ref) {
  var context = _ref.context,
      form = _ref.form,
      schema = _ref.schema,
      templateId = _ref.templateId;
  var types = getTypes(schema);
  var reconcileItem = reconcile({
    context: context,
    templateId: templateId,
    fieldName: schema === null || schema === void 0 ? void 0 : schema.prop
  });
  return function (path, index, item) {
    var itemDefinition = findComponentDefinition(item, context);

    if (!itemDefinition) {
      return null;
    }

    var itemTypes = [itemDefinition.id].concat(_toConsumableArray$2(itemDefinition.tags));

    if (!includesAny(types, itemTypes)) {
      return null;
    }

    var reconciledItem = reconcileItem(item);
    var duplicatedItem = duplicateConfig(reconciledItem, context);
    form.mutators.insert(path, index, duplicatedItem);
    return "".concat(path, ".").concat(index);
  };
};

function _createForOfIteratorHelper$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function getSchema(path, context) {
  var _path$parent$template, _path$parent, _parentDefinition$sch;

  var parentDefinition = findComponentDefinitionById((_path$parent$template = (_path$parent = path.parent) === null || _path$parent === void 0 ? void 0 : _path$parent.templateId) !== null && _path$parent$template !== void 0 ? _path$parent$template : "", context);
  var schema = ((_parentDefinition$sch = parentDefinition === null || parentDefinition === void 0 ? void 0 : parentDefinition.schema) !== null && _parentDefinition$sch !== void 0 ? _parentDefinition$sch : []).find(function (s) {
    var _path$parent2;

    return s.prop === ((_path$parent2 = path.parent) === null || _path$parent2 === void 0 ? void 0 : _path$parent2.fieldName);
  });
  return schema;
}

var toName = function toName(destination) {
  var _destination$parent, _destination$parent2;

  return [(_destination$parent = destination.parent) === null || _destination$parent === void 0 ? void 0 : _destination$parent.path, (_destination$parent2 = destination.parent) === null || _destination$parent2 === void 0 ? void 0 : _destination$parent2.fieldName].filter(Boolean).join(".");
};

var fixIndexInCollection = function fixIndexInCollection() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var schema = arguments.length > 1 ? arguments[1] : undefined;

  if ((schema === null || schema === void 0 ? void 0 : schema.type) === "component-collection") {
    return index + 1;
  }

  return index;
};

function destinationResolver(_ref) {
  var form = _ref.form,
      context = _ref.context;
  return function (initialDestinationPath) {
    var resolvedDestinations = [];
    var resolvedPaths = new Set();
    var pathsQueue = [initialDestinationPath];

    while (pathsQueue.length > 0) {
      var _parsed$templateId, _parsed$parent, _pasteSlots;

      var path = pathsQueue.shift();

      if (!path) {
        continue;
      }

      if (resolvedPaths.has(path)) {
        continue;
      }

      if (!dotNotationGet(form.values, path)) {
        continue;
      }

      var parsed = parsePath(path, form);
      var definition = findComponentDefinitionById((_parsed$templateId = parsed.templateId) !== null && _parsed$templateId !== void 0 ? _parsed$templateId : "", context);

      if (!definition) {
        continue;
      }

      var schema = getSchema(parsed, context);
      resolvedDestinations.push({
        index: fixIndexInCollection(parsed.index, schema),
        name: toName(parsed),
        insert: insertCommand({
          context: context,
          form: form,
          schema: schema,
          templateId: (_parsed$parent = parsed.parent) === null || _parsed$parent === void 0 ? void 0 : _parsed$parent.templateId
        })
      });

      var _iterator = _createForOfIteratorHelper$4((_pasteSlots = definition.pasteSlots) !== null && _pasteSlots !== void 0 ? _pasteSlots : []),
          _step;

      try {
        var _loop = function _loop() {
          var _dotNotationGet;

          var slot = _step.value;
          var slotSchema = definition.schema.find(function (_ref2) {
            var prop = _ref2.prop;
            return prop === slot;
          });

          if (!slotSchema) {
            return "continue";
          }

          var slotPath = "".concat(path, ".").concat(slot);
          var slotValues = (_dotNotationGet = dotNotationGet(form.values, slotPath)) !== null && _dotNotationGet !== void 0 ? _dotNotationGet : [];

          if (slotValues.length === 0) {
            resolvedDestinations.push({
              name: slotPath,
              index: 0,
              insert: insertCommand({
                context: context,
                form: form,
                schema: slotSchema,
                templateId: definition.id
              })
            });
          } else if (slotSchema.type === "component-fixed" || slotSchema.type === "component") {
            pathsQueue.push("".concat(slotPath, ".0"));
          } else if (slotSchema.type === "component-collection") {
            pathsQueue.push.apply(pathsQueue, _toConsumableArray$2(Array.from(Array(slotValues.length).keys()).map(function (idx) {
              return "".concat(slotPath, ".").concat(idx);
            }).reverse()));
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return resolvedDestinations;
  };
}

var TOP_BAR_HEIGHT = 40;

function getCode(fun, name) {
  var codeAsString = fun.toString().trim();
  /**
   * TODO: this should be done properly
   *
   * This code is supposed to serialize component function. Obviously it's the wrong way to do it but it was super fast to code. It's code that was probably written in the first month of Shopstory.
   * To do it right, we should bundle each component separately with Rollup and we should somehow access it here.
   * For now current solution seems to work.
   *
   */
  // Get function name

  if (codeAsString.startsWith("function(")) {
    // this is production minification
    return "var TheComponent = ".concat(codeAsString, "; TheComponent");
  } else {
    var functionName = codeAsString.match(/function (.*?)\(/)[1];
    return "".concat(codeAsString, "; ").concat(functionName);
  }
}

React.createElement;

/** @jsx createElement */
function BannerCard(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      Container = _props$__fromEditor$c.Container,
      SidePhotoContainer = _props$__fromEditor$c.SidePhotoContainer,
      ContentContainer = _props$__fromEditor$c.ContentContainer,
      Background = _props$__fromEditor$c.Background,
      BackgroundContainer = _props$__fromEditor$c.BackgroundContainer,
      Stack = _props$__fromEditor$c.Stack,
      StackContainer = _props$__fromEditor$c.StackContainer,
      StackInnerContainer = _props$__fromEditor$c.StackInnerContainer,
      SideImage = _props$__fromEditor$c.SideImage,
      Link = _props$__fromEditor$c.Link;
  return createElement(Container, null, createElement(Link, null), createElement(SidePhotoContainer, null, createElement(SideImage, null)), createElement(ContentContainer, null, createElement(BackgroundContainer, null, createElement(Background, null)), createElement(StackContainer, null, createElement(StackInnerContainer, null, createElement(Stack, null)))));
}

function ownKeys$I(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$H(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$I(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$I(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function styles$h(config, _ref) {
  var _config$edgeLeftMargi, _config$edgeRightMarg;

  var compilationContext = _ref.compilationContext,
      $width = _ref.$width;
      _ref.$widthAuto;
  // For now only mobile possible
  var cornerRadius = config.cornerRadius;
  var isEditing = compilationContext.isEditing;
  var posH = config.positionHorizontal;
  var posV = config.verticalAlign;
  var offH = config.Background.length === 0 && config.SideImage.length > 0 && (config.sideImagePosition === "top" || config.sideImagePosition === "bottom") ? config.offsetHorizontalForVerticalImagePosition : config.offsetHorizontal;
  var offV = config.offsetVertical;
  var flexPosH = posH === "left" ? "flex-start" : posH === "center" ? "center" : "flex-end";
  var flexPosV = posV === "top" ? "flex-start" : posV === "center" ? "center" : "flex-end";
  var stackContainerGridRow = "1 / span 1";
  var backgroundAspectRatio = "none";
  var offset = {
    left: offH,
    right: offH,
    top: offV,
    bottom: offV
  };
  var mainImageOn = config.SideImage.length > 0;
  var isSideMode = mainImageOn && (config.sideImagePosition === "left" || config.sideImagePosition === "right");
  var isBackgroundMode = mainImageOn && config.sideImagePosition === "background";
  var rootStyles = {};
  var sidePhotoStyles = {};
  var contentStyles = {};
  var $stackWidth = $width; // approximation

  if (!mainImageOn) {
    rootStyles = {
      display: "grid"
    };
    sidePhotoStyles = {
      display: "none"
    };

    if (config.size !== "fit-content" && config.size !== "natural") {
      backgroundAspectRatio = config.size;
    } // backgroundAspectRatio = config.size === "fit-content" ? "none" : parseAspectRatio(config.size);

  } else if (!isBackgroundMode) {
    // rootStyles = {
    //   display: "flex",
    //   alignItems: "stretch",
    // };
    // sidePhotoStyles = {
    //   flex: "0 0 50%",
    // };
    // contentStyles = {
    //   flex: "1 1 auto",
    // };
    if (isSideMode) {
      rootStyles = {
        display: "flex",
        alignItems: "stretch",
        flexDirection: "row"
      };
      sidePhotoStyles = {
        flex: "0 0 50%"
      };
      contentStyles = {
        flex: "0 0 50%"
      };
      rootStyles.flexDirection = "row";

      if (config.sideImagePosition === "right") {
        // sidePhotoOrder = 1;
        sidePhotoStyles.order = 1;
      }

      $stackWidth = $width / 2; // content don't "make height" in side-by-side
      // placeholderPaddingBottom = "auto"
    } else {
      rootStyles = {
        display: "flex",
        alignItems: "stretch",
        flexDirection: "column"
      };
      sidePhotoStyles = {
        flex: "0 0 auto"
      };
      contentStyles = {
        flex: "1 1 auto"
      };

      if (config.sideImagePosition === "bottom") {
        sidePhotoStyles.order = 1;
      }
    }
  } else {
    rootStyles = {
      display: "grid",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "1fr"
    };
    sidePhotoStyles = {
      gridColumn: "1 / span 1",
      gridRow: "1 / span 1"
    };

    var _config$contentPositi = config.contentPositionInBackgroundMode.split("-"),
        _config$contentPositi2 = _slicedToArray$2(_config$contentPositi, 2),
        vPos = _config$contentPositi2[0],
        hPos = _config$contentPositi2[1];

    var map = {
      left: "start",
      center: "center",
      right: "end",
      top: "start",
      bottom: "end"
    };
    contentStyles = {
      gridColumn: "1 / span 1",
      gridRow: "1 / span 1",
      position: "relative",
      paddingLeft: config.contentHorizontalMarginInBackgroundMode,
      paddingRight: config.contentHorizontalMarginInBackgroundMode,
      paddingTop: config.contentVerticalMarginInBackgroundMode,
      paddingBottom: config.contentVerticalMarginInBackgroundMode,
      alignSelf: map[vPos],
      justifySelf: map[hPos]
    };
  } // const placeholderPaddingBottom = aspectRatio ? `${aspectRatio * 100}%` : "auto";
  // For now it can be only on both sides, so we just take left.
  // const snappedToEdge = !!config.edgeLeft;
  // const edgeMargin = config.edgeLeft?.margin ?? 0;


  var edgeLeft = config.edgeLeft;
  var edgeLeftMargin = (_config$edgeLeftMargi = config.edgeLeftMargin) !== null && _config$edgeLeftMargi !== void 0 ? _config$edgeLeftMargi : "0px";
  var edgeRight = config.edgeRight;
  var edgeRightMargin = (_config$edgeRightMarg = config.edgeRightMargin) !== null && _config$edgeRightMarg !== void 0 ? _config$edgeRightMarg : "0px"; // If no main image

  if (!mainImageOn) {
    // ... and no background, then offsets don't make sense
    if (config.Background.length === 0) {
      offset.left = "0px";
      offset.right = "0px";
      offset.top = "0px";
      offset.bottom = "0px";
    } // If in section (not a card) and section has escaped margins, stack items can never be bigger than container margin


    if (edgeLeft) {
      offset.left = "max(".concat(offset.left, ", ").concat(edgeLeftMargin, ")");
    }

    if (edgeRight) {
      offset.right = "max(".concat(offset.right, ", ").concat(edgeRightMargin, ")");
    }
  } else {
    // If main image is top
    if (config.sideImagePosition === "top" || config.sideImagePosition === "bottom") {
      // ... and no background, only top offset makes sense
      // if (config.Background.length === 0) {
      //   offset.left = "0px";
      //   offset.right = "0px";

      /**
       * Following conditions are discussable. Related to https://linear.app/shopstory/issue/SHO-115/2-columns-bottom-margin-auto-responsiveness
       *
       * 1. Obviously, when there is no background there should be no bottom / top margin. It's parent component that should set this margin.
       * 2. Still, very common use case is left / right mode that becomes top on mobile. In such case when on desktop gap between sections was 0, then it easily breaks.
       * 3. In BannerCards this is totally pointless if this margin is not 0. It really breaks so many layouts.
       *
       * The correct solution is hard.
       * 1. Auto should be handled by CONTAINER (like sections wrapper)
       * 2. It should understand that if (1) its adjacent items have 0 gap and (2) on mobile top item becomes "non-stickable" (it has no background and there is no safe space)...
       * 3. then section wrapper should set auto as non-0.
       *
       * Definition: element is "non-stickable at the bottom" when it is design error when this element has 0 bottom margin to the next component.
       *
       * It's quite easy for banner card to produce this information if it's "non-stickable" or not. Non-stickability conditions:
       * 1. In no-image mode it's always non-stickable on all sides.
       * 2. In background mode it's always stickable on all sides.
       * 3. When content has background, it's always stickable (in all modes). Otherwise:
       * 3. In left/right mode it's non-stickable
       * 4. In top mode it's non-stickable at the bottom
       * 5. In bottom mode it's non-stickable at the top.
       *
       *  But it's still tricky because how parent get this information? Problem:
       *  1. Parent (sections wrapper) must be compiled in order to know what context variables pass to children (banner cards)
       *  2. Children are compiled later, and only then there is information about stickable / non-stickable.
       *  3. Parent is already compiled. Recompilation could possibly lead to new context variables which might lead to infinite recursion :|
       *
       *  It's definitely solvable but also complex and we must postpone it for now.
       *
       *  DECISION AT THE TIME BEING:
       *
       *  For now we can give up setting this bottom margin to 0.
       *  1. It's bad because layout is bad and it's not really REUSABLE.
       *  2. It's good because auto is not fucked up. Correct auto is actually more important.
       *
       */
      // if (config.sideImagePosition === "top") {
      //   offset.bottom = 0;
      // } else if (config.sideImagePosition === "bottom") {
      //   offset.top = 0;
      // }
      // }
      // If in section (not a card) and section has escaped margins, stack items can never be bigger than container margin
      if (edgeLeft) {
        offset.left = "max(".concat(offset.left, ",").concat(edgeLeftMargin, ")");
      }

      if (edgeRight) {
        offset.right = "max(".concat(offset.right, ",").concat(edgeRightMargin, ")");
      }
    } else if (config.sideImagePosition === "left" || config.sideImagePosition === "right") {
      if (config.Background.length === 0) {
        offset.top = "0px";
        offset.bottom = "0px";
      }

      if (config.Background.length === 0 || edgeLeft || edgeRight
      /* escape even with background leads to the same stuff */
      ) {
        /**
         * SideImage on right:
         *
         * 1. NO ESCAPE / position right -> offset right = offH, offset left = 0
         * 2. NO ESCAPE / position center -> offset left+right = offH (not sure about that)
         * 3. NO ESCAPE / position left -> offset right = offH, offset left = 0;
         * 4. ESCAPE / position right -> offset right = offH, offset left = max(offH, margin)
         * 5. ESCAPE / position center -> offset left+right = max(offH, margin)
         * 6. ESCAPE / position left -> offset right = offH, offset left = max(offH, margin)
         */
        var imagePos = config.sideImagePosition;
        var contentPos = config.sideImagePosition === "right" ? "left" : "right";
        var isContentSnappedOnItsSide = false;
        var edgeMargin;

        if (contentPos === "left") {
          isContentSnappedOnItsSide = !!edgeLeft;
          edgeMargin = edgeLeftMargin;
        }

        if (contentPos === "right") {
          isContentSnappedOnItsSide = !!edgeRight;
          edgeMargin = edgeRightMargin;
        } // snappedToEdge.includes(contentPos);


        var hasBackground = config.Background.length > 0; // If has content has background and is *not* snapped on its side, we don't do anything
        // eslint-disable-next-line no-empty

        if (!isContentSnappedOnItsSide && hasBackground) ; // Not snapped on its side but no background
        else if (!isContentSnappedOnItsSide && !hasBackground) {
          // if (snappedToEdge === "no") { // if *not* snapped on the content side
          if (posH === imagePos) {
            offset[contentPos] = "0px";
          } else if (posH === contentPos) {
            offset[contentPos] = "0px";
          }
        } // Snapped on its side, doesn't matter if has background or not
        else {
          if (posH === imagePos) {
            offset[contentPos] = "max(".concat(offset[contentPos], ", ").concat(edgeMargin, ")");
          } else if (posH === "center") {
            offset[contentPos] = "max(".concat(offset[contentPos], ", ").concat(edgeMargin, ")");
            offset[imagePos] = "max(".concat(offset[imagePos], ", ").concat(edgeMargin, ")");
          } else {
            offset[contentPos] = "max(".concat(offset[contentPos], ", ").concat(edgeMargin, ")");
          }
        }
      }
    } else if (config.sideImagePosition === "background") {
      if (config.Background.length === 0) {
        offset.top = "0px";
        offset.bottom = "0px";
        offset.left = "0px";
        offset.right = "0px";
      }

      if (edgeLeft) {
        contentStyles.paddingLeft = "max(".concat(contentStyles.paddingLeft, ", ").concat(edgeLeftMargin, ")");
      }

      if (edgeRight) {
        contentStyles.paddingRight = "max(".concat(contentStyles.paddingRight, ", ").concat(edgeRightMargin, ")");
      }
    }
  }
  /**
   * shouldActivateCardLink conditions below:
   *
   * If BannerCard is a link, then we want entire banner to be a link AND we want buttons / links inside to work properly.
   * How do we do this?
   * 1. We set pointerEvents to "none" to entire container.
   * 2. We set pointerEvents of global link to pointerEvents: "auto"
   * 3. ButtonGroup has forced pointerEvents: auto"
   * 4. When isEditing, we hide global link and don't do any pointerEvents stuff. It's because if we did, editing wouldn't work properly.
   *
   */


  var shouldActivateCardLink = !isEditing && config.action.length > 0;
  return {
    Container: box(_objectSpread$H({
      position: "relative",
      width: "100%",
      borderRadius: cornerRadius + "px",
      overflow: "hidden",
      pointerEvents: shouldActivateCardLink ? "none" : "auto"
    }, rootStyles)),
    Link: box({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      opacity: 0,
      cursor: "pointer",
      display: shouldActivateCardLink ? "block" : "none",
      pointerEvents: shouldActivateCardLink ? "auto" : "none",
      // zIndex: 1
      // outline: "none",
      __action: "action"
    }),
    SidePhotoContainer: box(_objectSpread$H(_objectSpread$H({}, sidePhotoStyles), {}, {
      position: "relative",
      display: "grid"
    })),
    SideImage: {
      // fitH: true,
      // noInline: true,
      passedAspectRatio: config.sideImageSize,
      gridBaseLineHeight: config.gridBaseLineHeight,
      // TODO: remove this prop drill :(
      noAction: true,
      noAspectRatio: true
    },
    ContentContainer: box(_objectSpread$H({
      display: "grid"
    }, contentStyles)),
    BackgroundContainer: box({
      position: "relative",
      gridColumn: "1 / span 1",
      gridRow: "1 / span 1",
      display: "grid"
    }),
    Background: {
      // noInline: true,
      passedAspectRatio: backgroundAspectRatio,
      gridBaseLineHeight: config.gridBaseLineHeight,
      // TODO: remove this prop drill :(
      noAction: true
    },
    Stack: {
      // noInline: true,
      paddingLeft: offset.left,
      paddingRight: offset.right,
      paddingBottom: offset.bottom,
      paddingTop: offset.top,
      passedAlign: config.stackAlign,
      $width: $stackWidth,
      $widthAuto: true
    },
    StackContainer: box({
      gridColumn: "1 / span 1",
      gridRow: stackContainerGridRow,
      display: "flex",
      justifyContent: flexPosH,
      alignItems: flexPosV
    }),
    StackInnerContainer: box({
      position: "relative",
      width: "auto",
      maxWidth: "100%"
    }),
    TextOuterContainer: box({
      display: "flex",
      justifyContent: flexPosH,
      alignItems: flexPosV,
      height: "100%"
    }),
    TextContainer: box({
      position: "relative",
      maxWidth: "auto" // width: stackWidth

    }),
    BackgroundOuterContainer: box({})
  };
}

function decomposeValues(config, widths, devices, deviceId) {
  var width = widths[deviceId];
  var device = devices.find(function (device) {
    return device.id === deviceId;
  });
  var result = {
    values: {},
    width: width,
    lowerDefinedValues: {},
    higherDefinedValues: {},
    closestDefinedValues: {}
  };

  for (var key in config) {
    var value = config[key];

    if (!isTrulyResponsiveValue(value)) {
      result.values[key] = value;
      var definedValues = {
        value: value,
        width: width,
        device: device
      };
      result.closestDefinedValues[key] = definedValues;
      result.lowerDefinedValues[key] = definedValues;
      result.higherDefinedValues[key] = definedValues;
    } else {
      result.values[key] = isTrulyResponsiveValue(value) ? value[deviceId] : value;
      var defaultDefinedDevice = responsiveValueFindDeviceWithDefinedValue(value, deviceId, devices, widths);

      if (defaultDefinedDevice) {
        result.closestDefinedValues[key] = {
          value: responsiveValueGetDefinedValue(value, deviceId, devices, widths),
          width: responsiveValueGetDefinedValue(widths, defaultDefinedDevice.id, devices, widths),
          device: defaultDefinedDevice
        };
      }

      var lowerDefinedDevice = responsiveValueFindLowerDeviceWithDefinedValue(value, deviceId, devices, widths);

      if (lowerDefinedDevice) {
        result.lowerDefinedValues[key] = {
          value: responsiveValueGetFirstLowerValue(value, deviceId, devices, widths),
          width: responsiveValueGetDefinedValue(widths, lowerDefinedDevice.id, devices, widths),
          device: lowerDefinedDevice
        };
      }

      var higherDefinedDevice = responsiveValueFindHigherDeviceWithDefinedValue(value, deviceId, devices, widths);

      if (higherDefinedDevice) {
        result.higherDefinedValues[key] = {
          value: responsiveValueGetFirstHigherValue(value, deviceId, devices, widths),
          width: responsiveValueGetDefinedValue(widths, higherDefinedDevice.id, devices, widths),
          device: higherDefinedDevice
        };
      }
    }
  }

  return result;
}

function ownKeys$H(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$G(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$H(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$H(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function responsiveValueSet(responsiveValue, deviceId, value, devices) {
  var trulyResponsive;

  if (isTrulyResponsiveValue(responsiveValue)) {
    trulyResponsive = _objectSpread$G({}, responsiveValue);
  } else {
    trulyResponsive = {
      $res: true
    };
    devices.forEach(function (device) {
      trulyResponsive[device.id] = responsiveValue;
    });
  }

  return _objectSpread$G(_objectSpread$G({}, trulyResponsive), {}, _defineProperty$g({}, deviceId, value));
}

function ownKeys$G(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$F(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$G(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$G(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function responsiveAuto(inputValues, compilationContext, widths, callback) {
  var values = _objectSpread$F({}, inputValues);

  compilationContext.devices.forEach(function (device) {
    var decomposedValues = decomposeValues(inputValues, widths, compilationContext.devices, device.id);
    var result = callback(decomposedValues, {
      config: inputValues,
      device: device,
      compilationContext: compilationContext,
      widths: widths
    });

    for (var prop in result) {
      if (values[prop] === undefined) {
        values[prop] = _defineProperty$g({
          $res: true
        }, device.id, result[prop]);
      } else {
        values[prop] = responsiveValueSet(values[prop], device.id, result[prop], compilationContext.devices);
      }
    }
  });
  return values;
}

var bannerCardAuto = function bannerCardAuto(config, compilationContext, widths) {
  var values = responsiveAuto(config, compilationContext, widths, function (_ref, _ref2) {
    var values = _ref.values,
        higherDefinedValues = _ref.higherDefinedValues,
        lowerDefinedValues = _ref.lowerDefinedValues,
        closestDefinedValues = _ref.closestDefinedValues,
        width = _ref.width;
    _ref2.config;
        _ref2.compilationContext;
        _ref2.widths;
        _ref2.device;
    var sideImagePosition = values.sideImagePosition;

    if (sideImagePosition === undefined) {
      /**
       * The only thing we do here is switch from side mode to top mode only when all of those occur:
       * - higher defined is side-by-side
       * - higher defined width is 2x higher
       * - lower defined is not side-by-side
       */
      var higherMode = higherDefinedValues.sideImagePosition;
      var lowerMode = lowerDefinedValues.sideImagePosition;

      if (higherMode && (higherMode.value === "left" || higherMode.value === "right") && higherMode.width / 2 > width && (!lowerMode || lowerMode.value !== "left" && lowerMode.value !== "right")) {
        sideImagePosition = "top";
      } else {
        sideImagePosition = closestDefinedValues.sideImagePosition.value;
      }
    }

    return {
      sideImagePosition: sideImagePosition
    };
  });
  return values;
};

React.createElement;

/** @jsx createElement */
function BannerCard2(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      Container = _props$__fromEditor$c.Container,
      SidePhotoContainer = _props$__fromEditor$c.SidePhotoContainer,
      ContentContainer = _props$__fromEditor$c.ContentContainer,
      Link = _props$__fromEditor$c.Link,
      Card1 = _props$__fromEditor$c.Card1,
      Card2 = _props$__fromEditor$c.Card2;
  return createElement(Container, null, createElement(Link, null), createElement(SidePhotoContainer, null, createElement(Card2, null)), createElement(ContentContainer, null, createElement(Card1, null)));
}

function getEdgeValues(optionalEdgeValues) {
  var _optionalEdgeValues$e, _optionalEdgeValues$e2, _optionalEdgeValues$e3, _optionalEdgeValues$e4, _optionalEdgeValues$e5, _optionalEdgeValues$e6;

  var edgeLeft = (_optionalEdgeValues$e = optionalEdgeValues.edgeLeft) !== null && _optionalEdgeValues$e !== void 0 ? _optionalEdgeValues$e : false;
  var edgeRight = (_optionalEdgeValues$e2 = optionalEdgeValues.edgeRight) !== null && _optionalEdgeValues$e2 !== void 0 ? _optionalEdgeValues$e2 : false;
  var edgeTop = (_optionalEdgeValues$e3 = optionalEdgeValues.edgeTop) !== null && _optionalEdgeValues$e3 !== void 0 ? _optionalEdgeValues$e3 : false;
  var edgeBottom = (_optionalEdgeValues$e4 = optionalEdgeValues.edgeBottom) !== null && _optionalEdgeValues$e4 !== void 0 ? _optionalEdgeValues$e4 : false;
  var edgeLeftMargin = (_optionalEdgeValues$e5 = optionalEdgeValues.edgeLeftMargin) !== null && _optionalEdgeValues$e5 !== void 0 ? _optionalEdgeValues$e5 : null;
  var edgeRightMargin = (_optionalEdgeValues$e6 = optionalEdgeValues.edgeRightMargin) !== null && _optionalEdgeValues$e6 !== void 0 ? _optionalEdgeValues$e6 : null;
  return {
    edgeLeft: edgeLeft,
    edgeRight: edgeRight,
    edgeTop: edgeTop,
    edgeBottom: edgeBottom,
    edgeLeftMargin: edgeLeftMargin,
    edgeRightMargin: edgeRightMargin
  };
}

function arePaddingFieldsSeparate(arg) {
  return arg.start !== undefined && arg.end !== undefined;
}

function getBiggerPaddingType(input1, input2) {
  if (input1 === "internal" || input2 === "internal") {
    return "internal";
  } else if (input1 === "external" || input2 === "external") {
    return "external";
  }

  return null;
}

function calculatePaddings(input) {
  var resultPaddingFields;
  /**
   * Calculate padding fields
   */

  if (!input.edge) {
    if (input.isCentered) {
      resultPaddingFields = {
        both: getBiggerPaddingType(input.startPaddingType, input.endPaddingType)
      };
    } else {
      resultPaddingFields = {
        start: input.startPaddingType,
        end: input.endPaddingType
      };
    }
  } else {
    if (input.isCentered) {
      // if no edge, then let's just take more important one (internal > external > null)
      if (!input.edge.start && !input.edge.end) {
        resultPaddingFields = {
          both: getBiggerPaddingType(input.startPaddingType, input.endPaddingType)
        };
      } else {
        // if at any edge with protection, we must adjust to the container margin forcefully
        if (input.edge.snap) {
          resultPaddingFields = {
            both: null
          };
        } // if at any edge without protection, then internal wins (it's always internal next to edge)
        else {
          resultPaddingFields = {
            both: "internal"
          };
        }
      }
    } else {
      resultPaddingFields = {
        start: null,
        end: null
      };

      if (!input.edge.start) {
        resultPaddingFields.start = input.startPaddingType;
      } else {
        if (input.edge.snap) {
          resultPaddingFields.start = null;
        } else {
          resultPaddingFields.start = "internal"; // always internal in case of edge without protection
        }
      }

      if (!input.edge.end) {
        resultPaddingFields.end = input.endPaddingType;
      } else {
        if (input.edge.snap) {
          resultPaddingFields.end = null;
        } else {
          resultPaddingFields.end = "internal"; // always internal in case of edge without protection
        }
      }
    }
  }
  /**
   * Calculating real paddings
   */


  function getPadding(which, spec) {
    if (spec === "internal") {
      return input.values["".concat(which, "Padding")];
    } else if (spec === "external") {
      return input.values["".concat(which, "PaddingExternal")];
    }

    return "0px";
  }

  var startPadding;
  var endPadding;

  if (!input.edge) {
    if (arePaddingFieldsSeparate(resultPaddingFields)) {
      startPadding = getPadding("start", resultPaddingFields.start);
      endPadding = getPadding("end", resultPaddingFields.end);
    } else {
      startPadding = getPadding("start", resultPaddingFields.both);
      endPadding = startPadding;
    }
  } else {
    if (arePaddingFieldsSeparate(resultPaddingFields)) {
      if (input.edge.start && input.edge.snap && resultPaddingFields.start === null) {
        startPadding = input.edge.startMargin;
      } else {
        startPadding = getPadding("start", resultPaddingFields.start);
      }

      if (input.edge.end && input.edge.snap && resultPaddingFields.end === null) {
        endPadding = input.edge.endMargin;
      } else {
        endPadding = getPadding("end", resultPaddingFields.end);
      }
    } else {
      if ((input.edge.start || input.edge.end) && input.edge.snap && resultPaddingFields.both === null) {
        var margin = "max(".concat(input.edge.start ? input.edge.startMargin : "0px", ",").concat(input.edge.end ? input.edge.endMargin : "0px", ")");
        startPadding = margin;
        endPadding = margin;
      } else {
        startPadding = getPadding("start", resultPaddingFields.both);
        endPadding = startPadding;
      }
    }
  }

  return {
    startPadding: startPadding,
    endPadding: endPadding,
    fields: resultPaddingFields
  };
}
function basicCardController(config) {
  var _config$hideContent, _config$hideBackgroun, _edgeInfo$edgeLeftMar, _edgeInfo$edgeRightMa;

  var position = config.position.split("-");
  var posH = position[1];
  var posV = position[0];
  var isCenteredHorizontally = posH === "center";
  var isCenteredVertically = posV === "center";
  var hideCornerRadius = true;
  var hideContent = (_config$hideContent = config.hideContent) !== null && _config$hideContent !== void 0 ? _config$hideContent : false;
  var hideBackground = (_config$hideBackgroun = config.hideBackground) !== null && _config$hideBackgroun !== void 0 ? _config$hideBackgroun : false;
  var edgeInfo = getEdgeValues(config);
  var shouldUseOnlyInternalPaddings = hideBackground ? false : hideContent ? true : config.Background.length > 0;
  var paddingSpec;
  /**
   * setting padding specs
   */

  if (shouldUseOnlyInternalPaddings) {
    paddingSpec = {
      top: "internal",
      bottom: "internal",
      left: "internal",
      right: "internal"
    };
  } else {
    paddingSpec = {
      top: config.edgeTop ? config.useExternalPaddingTop ? "external" : "internal" : null,
      bottom: config.edgeBottom ? config.useExternalPaddingBottom ? "external" : "internal" : null,
      left: config.edgeLeft ? config.useExternalPaddingLeft ? "external" : "internal" : null,
      right: config.edgeRight ? config.useExternalPaddingRight ? "external" : "internal" : null
    };
  }

  var horizontalResults = calculatePaddings({
    startPaddingType: paddingSpec.left,
    endPaddingType: paddingSpec.right,
    values: {
      startPadding: config.paddingLeft,
      startPaddingExternal: config.paddingLeftExternal,
      endPadding: config.paddingRight,
      endPaddingExternal: config.paddingRightExternal
    },
    edge: {
      snap: !!config.edgeMarginProtection,

      /**
       * calculatePaddings understand start and startMargin as EDGE-ONLY. Doesn't recognize edgeLeft=true with edgeLeftMargin=null. It's legacy, that's why below we make a little transformation.
       */
      start: edgeInfo.edgeLeft && edgeInfo.edgeLeftMargin !== null,
      startMargin: (_edgeInfo$edgeLeftMar = edgeInfo.edgeLeftMargin) !== null && _edgeInfo$edgeLeftMar !== void 0 ? _edgeInfo$edgeLeftMar : "0px",
      end: edgeInfo.edgeRight && edgeInfo.edgeRightMargin !== null,
      endMargin: (_edgeInfo$edgeRightMa = edgeInfo.edgeRightMargin) !== null && _edgeInfo$edgeRightMa !== void 0 ? _edgeInfo$edgeRightMa : "0px"
    },
    isCentered: isCenteredHorizontally
  });
  var verticalResults = calculatePaddings({
    startPaddingType: paddingSpec.top,
    endPaddingType: paddingSpec.bottom,
    values: {
      startPadding: config.paddingTop,
      startPaddingExternal: config.paddingTopExternal,
      endPadding: config.paddingBottom,
      endPaddingExternal: config.paddingBottomExternal
    },
    isCentered: isCenteredVertically
  });
  var resultPaddingFields = {
    vertical: verticalResults.fields,
    horizontal: horizontalResults.fields
  };
  var resultPadding = {
    top: verticalResults.startPadding,
    bottom: verticalResults.endPadding,
    left: horizontalResults.startPadding,
    right: horizontalResults.endPadding
  };
  var shouldUsePassedSize = config.passedSize !== undefined && config.passedSize !== "auto";
  var size = shouldUsePassedSize ? config.passedSize : config.size;
  var backgroundAspectRatio = size === "fit-background" ? "natural" : size === "fit-content" ? "none" : size;
  return {
    padding: resultPadding,
    paddingFields: resultPaddingFields,
    posH: posH,
    posV: posV,
    hideContent: hideContent,
    hideBackground: hideBackground,
    enableContent: config.enableContent,
    hideCornerRadius: hideCornerRadius,
    ignoreSize: shouldUsePassedSize,
    backgroundAspectRatio: backgroundAspectRatio
  };
}

function bannerCard2SeparateStackModeController(config) {
  var _config$edgeLeft, _config$edgeLeftMargi, _config$edgeRight, _config$edgeRightMarg;

  var _config$backgroundMod = config.backgroundModePosition.split("-"),
      _config$backgroundMod2 = _slicedToArray$2(_config$backgroundMod, 2),
      vPos = _config$backgroundMod2[0],
      hPos = _config$backgroundMod2[1];

  var paddingLeft = config.backgroundModePaddingLeft;
  var paddingRight = config.backgroundModePaddingRight;
  var paddingTop = config.backgroundModePaddingTop;
  var paddingBottom = config.backgroundModePaddingBottom;
  var horizontalPaddingInfo = calculatePaddings({
    startPaddingType: "internal",
    endPaddingType: "internal",
    values: {
      startPadding: paddingLeft,
      startPaddingExternal: paddingLeft,
      endPadding: paddingRight,
      endPaddingExternal: paddingRight
    },
    edge: {
      snap: config.backgroundModeEdgeMarginProtection,
      start: (_config$edgeLeft = config.edgeLeft) !== null && _config$edgeLeft !== void 0 ? _config$edgeLeft : false,
      startMargin: (_config$edgeLeftMargi = config.edgeLeftMargin) !== null && _config$edgeLeftMargi !== void 0 ? _config$edgeLeftMargi : "0px",
      end: (_config$edgeRight = config.edgeRight) !== null && _config$edgeRight !== void 0 ? _config$edgeRight : false,
      endMargin: (_config$edgeRightMarg = config.edgeRightMargin) !== null && _config$edgeRightMarg !== void 0 ? _config$edgeRightMarg : "0px"
    },
    isCentered: hPos === "center"
  });
  var verticalPaddingInfo = calculatePaddings({
    startPaddingType: "internal",
    endPaddingType: "internal",
    values: {
      startPadding: paddingTop,
      startPaddingExternal: paddingTop,
      endPadding: paddingBottom,
      endPaddingExternal: paddingBottom
    },
    isCentered: vPos === "center"
  });
  paddingLeft = horizontalPaddingInfo.startPadding;
  paddingRight = horizontalPaddingInfo.endPadding;
  paddingTop = verticalPaddingInfo.startPadding;
  paddingBottom = verticalPaddingInfo.endPadding;
  return {
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    paddingTop: paddingTop,
    paddingBottom: paddingBottom,
    fieldsVertical: verticalPaddingInfo.fields,
    fieldsHorizontal: horizontalPaddingInfo.fields,
    verticalPosition: vPos,
    horizontalPosition: hPos
  };
}

function ownKeys$F(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$E(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$F(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$F(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function styles$g(config, toolkit) {
  var compilationContext = toolkit.compilationContext,
      $width = toolkit.$width;

  if ($width === -1) {
    throw new Error("$BannerCard2 without width!!!");
  } // For now only mobile possible


  var cornerRadius = config.cornerRadius;
  var isEditing = compilationContext.isEditing;
  var isNoneMode = config.mode === "none";
  var isBackgroundMode = config.mode === "background";
  var isSideMode = config.mode === "left" || config.mode === "right";
  var isTopBottomMode = config.mode === "top" || config.mode === "bottom";
  var isBackgroundWithSeparateStackMode = config.mode === "background-separate-stack";
  var rootStyles = {};
  var backgroundStyles = {};
  var contentStyles = {};
  var $widthCard1 = $width;
  var $widthCard2 = $width;
  var $widthAutoCard1 = false;

  if (isNoneMode) {
    rootStyles = {
      display: "grid"
    };
    backgroundStyles = {
      display: "none"
    };
  } else if (isBackgroundMode) {
    rootStyles = {
      display: "grid"
    };
    backgroundStyles = {
      gridRow: 1,
      gridColumn: 1
    };
    contentStyles = {
      gridRow: 1,
      gridColumn: 1,
      pointerEvents: isEditing ? "auto" : "none" // For basic mode Content should be pointer-events: none, so that control on background are reachable

    };
  } else if (isSideMode) {
    rootStyles = {
      display: "flex",
      alignItems: "stretch",
      flexDirection: "row"
    };
    var sideImageWidth = parseInt(config.sideModeWidth) / 100;
    var contentWidth = 1 - sideImageWidth;
    backgroundStyles = {
      flex: "0 0 ".concat(sideImageWidth * 100, "%")
    };
    contentStyles = {
      flex: "0 0 ".concat(contentWidth * 100, "%")
    };
    rootStyles.flexDirection = "row";

    if (config.mode === "right") {
      // backgroundOrder = 1;
      backgroundStyles.order = 1;
    }

    $widthCard1 = $widthCard1 * contentWidth;
    $widthCard2 = $widthCard2 * sideImageWidth; // content don't "make height" in side-by-side
    // placeholderPaddingBottom = "auto"
  } else if (isTopBottomMode) {
    rootStyles = {
      display: "flex",
      alignItems: "stretch",
      flexDirection: "column"
    };
    backgroundStyles = {
      flex: "0 0 auto"
    };
    contentStyles = {
      flex: "1 1 auto"
    };

    if (config.mode === "bottom") {
      backgroundStyles.order = 1;
    }
  } else if (isBackgroundWithSeparateStackMode) {
    rootStyles = {
      display: "grid",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "1fr"
    };
    backgroundStyles = {
      gridColumn: "1 / span 1",
      gridRow: "1 / span 1"
    };
    var map = {
      left: "start",
      center: "center",
      right: "end",
      top: "start",
      bottom: "end"
    };

    var _bannerCard2SeparateS = bannerCard2SeparateStackModeController(config),
        paddingLeft = _bannerCard2SeparateS.paddingLeft,
        paddingBottom = _bannerCard2SeparateS.paddingBottom,
        paddingTop = _bannerCard2SeparateS.paddingTop,
        paddingRight = _bannerCard2SeparateS.paddingRight,
        verticalPosition = _bannerCard2SeparateS.verticalPosition,
        horizontalPosition = _bannerCard2SeparateS.horizontalPosition;

    $widthCard1 = $widthCard1 - spacingToPx(paddingLeft, toolkit.device.w) - spacingToPx(paddingRight, toolkit.device.w);
    $widthAutoCard1 = true;
    contentStyles = {
      gridColumn: "1 / span 1",
      gridRow: "1 / span 1",
      position: "relative",
      marginLeft: paddingLeft,
      marginRight: paddingRight,
      marginTop: paddingTop,
      marginBottom: paddingBottom,
      alignSelf: map[verticalPosition],
      justifySelf: map[horizontalPosition]
    };
  }
  /**
   * shouldActivateCardLink conditions below:
   *
   * If BannerCard is a link, then we want entire banner to be a link AND we want buttons / links inside to work properly.
   * How do we do this?
   * 1. We set pointerEvents to "none" to entire container.
   * 2. We set pointerEvents of global link to pointerEvents: "auto"
   * 3. ButtonGroup has forced pointerEvents: auto"
   * 4. When isEditing, we hide global link and don't do any pointerEvents stuff. It's because if we did, editing wouldn't work properly.
   *
   */


  var shouldActivateCardLink = !isEditing && config.action.length > 0;
  /**
   * Edge margins
   */

  var edgeInfo = getEdgeValues(config);
  var Card1 = {
    gridBaseLineHeight: config.gridBaseLineHeight,
    $width: $widthCard1,
    $widthAuto: $widthAutoCard1,
    passedSize: "none",
    edgeLeft: false,
    edgeLeftMargin: null,
    edgeRight: false,
    edgeRightMargin: null,
    edgeTop: false,
    edgeBottom: false,
    useExternalPaddingTop: false,
    useExternalPaddingBottom: false,
    useExternalPaddingLeft: false,
    useExternalPaddingRight: false
  };
  var Card2 = {
    gridBaseLineHeight: config.gridBaseLineHeight,
    $width: $widthCard2,
    $widthAuto: false,
    passedSize: "auto",
    edgeLeft: false,
    edgeLeftMargin: null,
    edgeRight: false,
    edgeRightMargin: null,
    edgeTop: false,
    edgeBottom: false,
    useExternalPaddingTop: false,
    useExternalPaddingBottom: false,
    useExternalPaddingLeft: false,
    useExternalPaddingRight: false
  };

  if (config.mode === "none") {
    Card1.edgeLeft = edgeInfo.edgeLeft;
    Card1.edgeLeftMargin = edgeInfo.edgeLeftMargin;
    Card1.edgeRight = edgeInfo.edgeRight;
    Card1.edgeRightMargin = edgeInfo.edgeRightMargin;
    Card1.edgeTop = edgeInfo.edgeTop;
    Card1.edgeBottom = edgeInfo.edgeBottom;
  } else if (config.mode === "background") {
    Card1.edgeLeft = true;
    Card1.edgeLeftMargin = edgeInfo.edgeLeftMargin;
    Card1.edgeRight = true;
    Card1.edgeRightMargin = edgeInfo.edgeRightMargin;
    Card1.edgeTop = true;
    Card1.edgeBottom = true;
    Card1.hideBackground = true;
    Card2.hideContent = true;
  } else if (config.mode === "background-separate-stack") {
    Card2.edgeLeft = edgeInfo.edgeLeft;
    Card2.edgeLeftMargin = edgeInfo.edgeLeftMargin;
    Card2.edgeRight = edgeInfo.edgeRight;
    Card2.edgeRightMargin = edgeInfo.edgeRightMargin;
  } else if (config.mode === "left" || config.mode === "right") {
    var CardLeft = config.mode === "left" ? Card2 : Card1;
    var CardRight = config.mode === "left" ? Card1 : Card2;
    CardRight.edgeRight = edgeInfo.edgeRight;
    CardRight.edgeRightMargin = edgeInfo.edgeRightMargin;
    CardRight.edgeLeft = true;
    CardRight.edgeLeftMargin = null;
    CardRight.edgeTop = true; // we mock edge

    CardRight.edgeBottom = true; // we mock edge

    CardRight.useExternalPaddingTop = true;
    CardRight.useExternalPaddingBottom = true;
    CardLeft.edgeLeft = edgeInfo.edgeLeft;
    CardLeft.edgeLeftMargin = edgeInfo.edgeLeftMargin;
    CardLeft.edgeRight = true;
    CardLeft.edgeRightMargin = null;
    CardLeft.edgeTop = true; // we mock edge

    CardLeft.edgeBottom = true; // we mock edge

    CardLeft.useExternalPaddingTop = true;
    CardLeft.useExternalPaddingBottom = true;
  } else if (config.mode === "top" || config.mode === "bottom") {
    Card1.edgeLeft = true;
    Card1.edgeLeftMargin = edgeInfo.edgeLeftMargin;
    Card1.edgeRight = true;
    Card1.edgeRightMargin = edgeInfo.edgeRightMargin;
    Card1.edgeTop = true;
    Card1.edgeBottom = true;
    Card1.useExternalPaddingLeft = true;
    Card1.useExternalPaddingRight = true;
    Card1.passedSize = "auto";
    Card2.edgeLeft = edgeInfo.edgeLeft;
    Card2.edgeLeftMargin = edgeInfo.edgeLeftMargin;
    Card2.edgeRight = edgeInfo.edgeRight;
    Card2.edgeRightMargin = edgeInfo.edgeRightMargin;
  }

  return {
    Container: box(_objectSpread$E({
      position: "relative",
      width: "100%",
      borderRadius: cornerRadius + "px",
      overflow: cornerRadius !== "0" ? "hidden" : "visible",
      pointerEvents: shouldActivateCardLink ? "none" : "auto"
    }, rootStyles)),
    Link: box({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      opacity: 0,
      cursor: "pointer",
      display: shouldActivateCardLink ? "block" : "none",
      pointerEvents: "auto",
      __action: "action"
    }),
    SidePhotoContainer: box(_objectSpread$E({
      position: "relative",
      display: "grid"
    }, backgroundStyles)),
    ContentContainer: box(_objectSpread$E({
      display: "grid"
    }, contentStyles)),
    Card1: Card1,
    Card2: Card2
  };
}

var bannerCard2Auto = function bannerCard2Auto(config, compilationContext, widths) {
  var values = responsiveAuto(config, compilationContext, widths, function (_ref, _ref2) {
    var values = _ref.values,
        higherDefinedValues = _ref.higherDefinedValues,
        lowerDefinedValues = _ref.lowerDefinedValues,
        closestDefinedValues = _ref.closestDefinedValues,
        width = _ref.width;
    _ref2.config;
        _ref2.compilationContext;
        _ref2.widths;
        _ref2.device;
    var mode = values.mode;

    if (mode === undefined) {
      /**
       * The only thing we do here is switch from side mode to top mode only when all of those occur:
       * - higher defined is side-by-side
       * - higher defined width is 2x higher
       * - lower defined is not side-by-side
       */
      var higherMode = higherDefinedValues.mode;
      var lowerMode = lowerDefinedValues.mode;

      if (higherMode && (higherMode.value === "left" || higherMode.value === "right") && higherMode.width / 2 > width && (!lowerMode || lowerMode.value !== "left" && lowerMode.value !== "right")) {
        mode = "top";
      } else {
        mode = closestDefinedValues.mode.value;
      }
    }

    return {
      mode: mode
    };
  });
  return values;
};

React.createElement;

/** @jsx createElement */
function TwoCards(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      Card1 = _props$__fromEditor$c.Card1,
      Card2 = _props$__fromEditor$c.Card2,
      Card1Container = _props$__fromEditor$c.Card1Container,
      Card2Container = _props$__fromEditor$c.Card2Container,
      Root = _props$__fromEditor$c.Root;
  return createElement(Root, null, createElement(Card1Container, null, createElement(Card1, null)), createElement(Card2Container, null, createElement(Card2, null)));
}

var TWO_CARDS_COL_NUM = 24;

function ownKeys$E(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$D(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$E(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$E(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function styles$f(config, _ref) {
  var _edgeInfo$edgeLeftMar, _edgeInfo$edgeRightMa;

  var $width = _ref.$width,
      device = _ref.device;

  if ($width === -1) {
    throw new Error("$TwoCards without width!!!");
  }

  var edgeInfo = getEdgeValues(config);
  var edgeLeftMargin = (_edgeInfo$edgeLeftMar = edgeInfo.edgeLeftMargin) !== null && _edgeInfo$edgeLeftMar !== void 0 ? _edgeInfo$edgeLeftMar : "0px";
  var edgeRightMargin = (_edgeInfo$edgeRightMa = edgeInfo.edgeRightMargin) !== null && _edgeInfo$edgeRightMa !== void 0 ? _edgeInfo$edgeRightMa : "0px";
  var card1Width = parseInt(config.card1Width);
  var card2Width = parseInt(config.card2Width);
  var alignItems = "";

  if (config.verticalLayout === "center") {
    alignItems = "center";
  } else if (config.verticalLayout === "align-top" || config.verticalLayout === "irregular") {
    alignItems = "start";
  } else if (config.verticalLayout === "align-bottom") {
    alignItems = "end";
  } else if (config.verticalLayout === "fit") {
    alignItems = "stretch";
  } else {
    throw new Error("[TwoCards] unknown verticalLayout value");
  }

  var verticalOffset = parseInt(config.verticalOffset);
  var containerWidthCalc = "calc(100% - ".concat(edgeLeftMargin, " - ").concat(edgeRightMargin, ")"); // Init state is for "non-collapsed" state

  var card1ContainerStyles;
  var card2ContainerStyles;
  var card1Props;
  var card2Props;
  var horizontalGap = card1Width + card2Width === TWO_CARDS_COL_NUM && config.collapse === false ? config.gap : "0px";
  var horizontalGapNumber = spacingToPx(horizontalGap, device.w);
  var edgeLeftMarginNumber = spacingToPx(edgeLeftMargin, device.w);
  var edgeRightMarginNumber = spacingToPx(edgeRightMargin, device.w);
  var $widthContainer = $width - edgeLeftMarginNumber - edgeRightMarginNumber;
  var $widthContainer1 = card1Width / TWO_CARDS_COL_NUM * ($widthContainer - horizontalGapNumber);
  var $widthContainer2 = card2Width / TWO_CARDS_COL_NUM * ($widthContainer - horizontalGapNumber);
  var container1WidthCalc = "calc(".concat(card1Width / TWO_CARDS_COL_NUM, " * ").concat(containerWidthCalc, ")");
  var container2WidthCalc = "calc(".concat(card2Width / TWO_CARDS_COL_NUM, " * ").concat(containerWidthCalc, ")");

  if (!config.collapse) {
    card1ContainerStyles = {
      marginLeft: edgeLeftMargin,
      marginRight: 0,
      position: "relative",
      marginTop: config.verticalLayout === "irregular" && verticalOffset > 0 ? "calc(".concat(containerWidthCalc, " / ").concat(TWO_CARDS_COL_NUM, " * ").concat(verticalOffset, ")") : 0,
      width: container1WidthCalc
    };
    card2ContainerStyles = {
      marginLeft: 0,
      marginRight: edgeRightMargin,
      marginTop: config.verticalLayout === "irregular" && verticalOffset < 0 ? "calc(".concat(containerWidthCalc, " / ").concat(TWO_CARDS_COL_NUM, " * ").concat(-verticalOffset, ")") : 0,
      width: container2WidthCalc
    };
    card1Props = {
      edgeLeft: false,
      edgeRight: false,
      edgeLeftMargin: null,
      edgeRightMargin: null
    };
    card2Props = {
      edgeLeft: false,
      edgeRight: false,
      edgeLeftMargin: null,
      edgeRightMargin: null
    };

    if (config.card1EscapeMargin) {
      card1ContainerStyles.marginLeft = "0px";
      card1ContainerStyles.width = "calc(".concat(container1WidthCalc, " + ").concat(edgeLeftMargin, ")");
      card1Props.edgeLeft = true;
      card1Props.edgeLeftMargin = edgeInfo.edgeLeftMargin;
      $widthContainer1 = $widthContainer1 + edgeLeftMarginNumber;
    }

    if (config.card2EscapeMargin) {
      card2ContainerStyles.marginRight = "0px";
      card2ContainerStyles.width = "calc(".concat(container2WidthCalc, " + ").concat(edgeRightMargin, ")");
      card2Props.edgeRight = true;
      card2Props.edgeRightMargin = edgeInfo.edgeRightMargin;
      $widthContainer2 = $widthContainer2 + edgeRightMarginNumber;
    }
  } else {
    card1ContainerStyles = {
      marginLeft: edgeLeftMargin,
      marginRight: edgeRightMargin,
      alignSelf: "start",
      width: container1WidthCalc
    };
    card2ContainerStyles = {
      marginLeft: edgeLeftMargin,
      marginRight: edgeRightMargin,
      alignSelf: "end",
      width: container2WidthCalc
    };
    card1Props = {
      edgeLeft: false,
      edgeRight: false,
      edgeLeftMargin: "0px",
      edgeRightMargin: "0px"
    };
    card2Props = {
      edgeLeft: false,
      edgeRight: false,
      edgeLeftMargin: "0px",
      edgeRightMargin: "0px"
    };

    if (config.card1EscapeMargin) {
      card1ContainerStyles.marginLeft = "0px";
      card1ContainerStyles.marginRight = "0px";

      if (card1Width === TWO_CARDS_COL_NUM) {
        card1ContainerStyles.width = "100%";
        card1Props.edgeLeft = true;
        card1Props.edgeLeftMargin = edgeInfo.edgeLeftMargin;
        card1Props.edgeRight = true;
        card1Props.edgeRightMargin = edgeInfo.edgeRightMargin;
        $widthContainer1 = $width;
      } else {
        card1ContainerStyles.width = "calc(".concat(container1WidthCalc, " + ").concat(edgeLeftMargin, ")");
        card1Props.edgeLeft = true;
        card1Props.edgeLeftMargin = edgeInfo.edgeLeftMargin;
        $widthContainer1 = $widthContainer1 + edgeLeftMarginNumber;
      }
    }

    if (config.card2EscapeMargin) {
      card2ContainerStyles.marginLeft = "0px";
      card2ContainerStyles.marginRight = "0px";

      if (card2Width === TWO_CARDS_COL_NUM) {
        card2ContainerStyles.width = "100%";
        card2Props.edgeLeft = true;
        card2Props.edgeLeftMargin = edgeInfo.edgeLeftMargin;
        card2Props.edgeRight = true;
        card2Props.edgeRightMargin = edgeInfo.edgeRightMargin;
        $widthContainer2 = $width;
      } else {
        card2ContainerStyles.width = "calc(".concat(container2WidthCalc, " + ").concat(edgeRightMargin, ")");
        card2Props.edgeRight = true;
        card2Props.edgeRightMargin = edgeInfo.edgeRightMargin;
        $widthContainer2 = $widthContainer2 + edgeRightMarginNumber;
      }
    }
  }

  return {
    Root: box({
      display: "flex",
      flexDirection: config.collapse ? "column" : "row",
      justifyContent: "space-between",
      gap: config.collapse ? config.verticalGap : horizontalGap,
      alignItems: alignItems
    }),
    Card1: _objectSpread$D(_objectSpread$D({}, card1Props), {}, {
      $width: $widthContainer1,
      $widthAuto: false
    }),
    Card2: _objectSpread$D(_objectSpread$D({}, card2Props), {}, {
      $width: $widthContainer2,
      $widthAuto: false
    }),
    Card1Container: box(_objectSpread$D({
      display: "grid"
    }, card1ContainerStyles)),
    Card2Container: box(_objectSpread$D({
      display: "grid"
    }, card2ContainerStyles))
  };
}

React.createElement;

/** @jsx createElement */
function Token(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      Container = _props$__fromEditor$c.Container,
      InnerContainer = _props$__fromEditor$c.InnerContainer,
      Component = _props$__fromEditor$c.Component;
  return createElement(Container, null, createElement(InnerContainer, null, createElement(Component, null)));
}

function styles$e(config, _ref) {
  _ref.theme;
  var Container = box({
    backgroundColor: "#E5E5E5",
    display: "flex",
    justifyContent: "center"
  });
  var InnerContainer = box({
    backgroundColor: config.backgroundColor,
    width: config.width,
    paddingTop: config.paddingTop,
    paddingBottom: config.paddingBottom,
    paddingLeft: config.paddingLeft,
    paddingRight: config.paddingRight,
    minHeight: 1
  });
  return {
    Container: Container,
    InnerContainer: InnerContainer,
    Component: {
      fitW: true
    }
  };
}

React.createElement;

/** @jsx createElement */
function TokenColor(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      Container = _props$__fromEditor$c.Container,
      InnerContainer = _props$__fromEditor$c.InnerContainer,
      ColorBox = _props$__fromEditor$c.ColorBox;
  return createElement(Container, null, createElement(InnerContainer, null, createElement(ColorBox, null)));
}

function styles$d(config, _ref) {
  _ref.theme;
  var Container = box({
    backgroundColor: "#E5E5E5",
    display: "flex",
    justifyContent: "center"
  });
  var InnerContainer = box({
    backgroundColor: config.backgroundColor,
    width: config.width,
    paddingTop: config.paddingTop,
    paddingBottom: config.paddingBottom,
    paddingLeft: config.paddingLeft,
    paddingRight: config.paddingRight,
    minHeight: 1
  });
  var ColorBox = box({
    width: 50,
    height: 50,
    border: "1px dashed black",
    backgroundColor: config.color
  });
  return {
    Container: Container,
    InnerContainer: InnerContainer,
    ColorBox: ColorBox
  };
}

React.createElement;

/** @jsx createElement */
function TokenFont(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      Container = _props$__fromEditor$c.Container,
      InnerContainer = _props$__fromEditor$c.InnerContainer,
      Text = _props$__fromEditor$c.Text;
  return createElement(Container, null, createElement(InnerContainer, null, createElement(Text, null, props.configProps.exampleTextLength === "short" ? "Lorem ipsum dolor sit amet" : props.configProps.exampleTextLength === "medium" ? "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt." : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.")));
}

function styles$c(config) {
  var Container = box({
    backgroundColor: "#E5E5E5",
    display: "flex",
    justifyContent: "center"
  });
  var InnerContainer = box({
    backgroundColor: config.backgroundColor,
    width: config.width,
    paddingTop: config.paddingTop,
    paddingBottom: config.paddingBottom,
    paddingLeft: config.paddingLeft,
    paddingRight: config.paddingRight,
    minHeight: 1
  });
  var Text = box({
    fontFamily: config.family,
    fontWeight: config.weight,
    maxWidth: 600,
    color: "black",
    fontSize: config.size,
    letterSpacing: config.letterSpacing,
    textTransform: config.isUppercase ? "uppercase" : "none"
  });
  return {
    Container: Container,
    InnerContainer: InnerContainer,
    Text: Text
  };
}

React.createElement;

/** @jsx createElement */
function Grid2(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      Container = _props$__fromEditor$c.Container,
      InnerContainer = _props$__fromEditor$c.InnerContainer,
      SpacerLeft = _props$__fromEditor$c.SpacerLeft,
      SpacerRight = _props$__fromEditor$c.SpacerRight,
      Cards = _props$__fromEditor$c.Cards,
      LeftArrowWrapper = _props$__fromEditor$c.LeftArrowWrapper,
      LeftArrowInnerWrapper = _props$__fromEditor$c.LeftArrowInnerWrapper,
      LeftArrow = _props$__fromEditor$c.LeftArrow,
      RightArrowWrapper = _props$__fromEditor$c.RightArrowWrapper,
      RightArrowInnerWrapper = _props$__fromEditor$c.RightArrowInnerWrapper,
      RightArrow = _props$__fromEditor$c.RightArrow,
      Root = _props$__fromEditor$c.Root,
      itemContainers = _props$__fromEditor$c.itemContainers,
      horizontalLines = _props$__fromEditor$c.horizontalLines,
      verticalLines = _props$__fromEditor$c.verticalLines,
      itemInnerContainers = _props$__fromEditor$c.itemInnerContainers;
  var React = props.__fromEditor.React;
  var isEditing = !!props.__fromEditor.__editing;
  var spacerRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var innerContainerRef = React.useRef(null);
  var leftArrowWrapperRef = React.useRef(null);
  var rightArrowWrapperRef = React.useRef(null); // TODO: move this method to lazy-loaded payload!!!

  function getNextPos(scrollableContainer, spacer, items) {
    var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    if (items.length === 0) {
      return 0;
    }

    var spacerWidth = spacer.getBoundingClientRect().width;
    var containerRect = scrollableContainer.getBoundingClientRect();
    var containerWidth = containerRect.width - spacerWidth * 2;
    var closestItem;
    var closestDiff = 999999;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var left = item.getBoundingClientRect().left - containerRect.left;
      var diff = Math.abs(left + containerWidth * direction - spacerWidth);

      if (diff < closestDiff) {
        closestItem = item;
        closestDiff = diff;
      }
    }

    var pos = scrollableContainer.scrollLeft + (closestItem.getBoundingClientRect().left - containerRect.left - spacerWidth); // snap to boundaries (1px problem)

    pos = Math.ceil(pos);

    if (Math.abs(pos) < 3) {
      pos = 0;
    }

    return pos;
  }

  var clickHandler = function clickHandler(directionRight) {
    var itemNodes = innerContainerRef.current.querySelectorAll("[data-item]");
    var newPos = getNextPos(containerRef.current, spacerRef.current, itemNodes, directionRight ? -1 : 1);
    containerRef.current.scrollTo({
      left: newPos,
      behavior: "smooth"
    });
  };

  React.useEffect(function () {
    function updateArrowsVisibility() {
      if (!containerRef.current) {
        return;
      }

      var isAtBeginning = containerRef.current.scrollLeft < 3;
      var scrollableWidth = containerRef.current.scrollWidth;
      var maxScrollLeftValue = scrollableWidth - containerRef.current.getBoundingClientRect().width;
      var isAtEnd = Math.abs(containerRef.current.scrollLeft - maxScrollLeftValue) < 3;
      leftArrowWrapperRef.current.style.opacity = 1;
      rightArrowWrapperRef.current.style.opacity = 1;
      var inactiveOpacity = isEditing ? 1 : 0;

      if (isAtBeginning) {
        leftArrowWrapperRef.current.style.opacity = inactiveOpacity;
      }

      if (isAtEnd) {
        rightArrowWrapperRef.current.style.opacity = inactiveOpacity;
      }
    }

    containerRef.current.addEventListener("scroll", updateArrowsVisibility);
    updateArrowsVisibility();
    return function () {
      if (containerRef.current) {
        containerRef.current.removeEventListener("scroll", updateArrowsVisibility);
      }
    };
  }, []);
  return createElement(Root, null, createElement(Container, {
    ref: containerRef,
    "data-shopstory-scrollable-root": true
  }, createElement(InnerContainer, {
    ref: innerContainerRef
  }, createElement(SpacerLeft, {
    ref: spacerRef
  }), Cards.map(function (Card, index) {
    var ItemContainer = itemContainers[index];
    var ItemInnerContainer = itemInnerContainers[index];
    var HorizontalLine = horizontalLines[index];
    var VerticalLine = verticalLines[index];
    return createElement(ItemContainer, {
      "data-item": true,
      key: index
    }, createElement(HorizontalLine, null), createElement(VerticalLine, null), createElement(ItemInnerContainer, null, createElement(Card, null)));
  }), createElement(SpacerRight, {
    ref: spacerRef
  }))), createElement(LeftArrowWrapper, {
    ref: leftArrowWrapperRef
  }, createElement(LeftArrowInnerWrapper, null, createElement(LeftArrow, {
    onClick: function onClick() {
      clickHandler(false);
    }
  }))), createElement(RightArrowWrapper, {
    ref: rightArrowWrapperRef
  }, createElement(RightArrowInnerWrapper, null, createElement(RightArrow, {
    onClick: function onClick() {
      clickHandler(true);
    }
  }))));
}

var sizeMap = {
  none: 0.00001,
  landscape: 0.7,
  portrait: 1.32,
  square: 1,
  panoramic: 0.5
};
function parseAspectRatio(aspectRatio) {
  if (sizeMap[aspectRatio]) {
    return sizeMap[aspectRatio];
  }

  var split = aspectRatio.split(":");

  if (split.length < 2) {
    return 1;
  }

  var result = parseInt(split[1]) / parseInt(split[0]);

  if (isNaN(result)) {
    return 1;
  }

  return result;
}
function getPaddingBottomAndHeightFromAspectRatio(aspectRatio, naturalAspectRatio, gridBaseLineHeight) {
  var aspectRatioFieldValue = aspectRatio || "16:9";
  var paddingBottom = "100%";
  var height = "auto";

  if (aspectRatio === "100vh") {
    height = "100vh";
    paddingBottom = "auto";
  } else if (aspectRatio === "grid-baseline") {
    if (gridBaseLineHeight) {
      height = gridBaseLineHeight;
      paddingBottom = "auto";
    }
  } else {
    var _aspectRatio = aspectRatioFieldValue === "natural" ? 1 / (naturalAspectRatio || 1.5) : parseAspectRatio(aspectRatioFieldValue);

    paddingBottom = "".concat(_aspectRatio * 100, "%");
  }

  return {
    paddingBottom: paddingBottom,
    height: height
  };
}

function gridContainerController(config, containerWidth, device) {
  var _config$escapeMargin, _config$edgeLeftMargi, _config$edgeRightMarg;

  var escapeMargin = (_config$escapeMargin = config.escapeMargin) !== null && _config$escapeMargin !== void 0 ? _config$escapeMargin : true;
  var marginLeftCss = (_config$edgeLeftMargi = config.edgeLeftMargin) !== null && _config$edgeLeftMargi !== void 0 ? _config$edgeLeftMargi : "0px";
  var marginRightCss = (_config$edgeRightMarg = config.edgeRightMargin) !== null && _config$edgeRightMarg !== void 0 ? _config$edgeRightMarg : "0px";

  if (escapeMargin) {
    marginLeftCss = "0px";
    marginRightCss = "0px";
  }

  var marginLeftNumber = spacingToPx(marginLeftCss, device.w);
  var marginRightNumber = spacingToPx(marginRightCss, device.w);
  var hasMaxWidth;
  var realWidth;
  var widthMinusMargins = containerWidth - marginLeftNumber - marginRightNumber;

  if (typeof config.maxWidth === "number") {
    hasMaxWidth = true;
    realWidth = config.maxWidth < widthMinusMargins ? config.maxWidth : widthMinusMargins;
  } else {
    hasMaxWidth = false;
    realWidth = widthMinusMargins;
  }

  return {
    marginLeft: marginLeftCss,
    marginRight: marginRightCss,
    hasMaxWidth: hasMaxWidth,
    realWidth: realWidth
  };
}
function gridController(config, $width, device) {
  var _gridContainerControl = gridContainerController(config, $width, device),
      marginRight = _gridContainerControl.marginRight,
      marginLeft = _gridContainerControl.marginLeft,
      hasMaxWidth = _gridContainerControl.hasMaxWidth,
      realWidth = _gridContainerControl.realWidth;

  var gap = spacingToPx(config.columnGap, device.w);
  var isSlider = config.variant === "slider";
  var numberOfItems = parseInt(config.numberOfItems);
  var itemsVisible = isSlider && device.id === "xs" ? numberOfItems + (parseFloat(config.fractionalItemWidth) - 1) : numberOfItems;

  var calculateCSSAbsoluteMargin = function calculateCSSAbsoluteMargin(margin) {
    return hasMaxWidth ? "max(calc(calc(100% - ".concat(config.maxWidth, "px) / 2), ").concat(margin, ")") : margin;
  };

  var cssAbsoluteLeftPosition = calculateCSSAbsoluteMargin(marginLeft);
  var cssAbsoluteRightPosition = calculateCSSAbsoluteMargin(marginRight);
  var $widthItem = (realWidth - gap * (itemsVisible - 1)) / itemsVisible;
  return {
    cssAbsoluteLeftPosition: cssAbsoluteLeftPosition,
    cssAbsoluteRightPosition: cssAbsoluteRightPosition,
    itemsVisible: itemsVisible,
    $widthItem: $widthItem,
    $width: realWidth
  };
}

function findFirstItemInRows(rows, itemIndex) {
  for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
    if (rows[rowIndex] === null || rows[rowIndex] === undefined) {
      continue;
    }

    for (var colIndex = 0; colIndex < rows[rowIndex].length; colIndex++) {
      if (rows[rowIndex][colIndex] === itemIndex) {
        return {
          row: rowIndex,
          col: colIndex
        };
      }
    }
  }
}
function buildRows(cardStyles, isSlider, numberOfItems) {
  var rows = [];

  if (isSlider) {
    rows.push([]);
    cardStyles.forEach(function (card, index) {
      rows[0].push(index);
    });
  } else {
    // First fill the 2x1 cards, then fill the rest
    cardStyles.forEach(function (card, index) {
      if (numberOfItems >= 2 && (card.itemSize === "2x1" || card.itemSize === "2x2")) {
        // Below we find where current 2x1 / 2x2 element would be currently placed if it was 1x1
        var filled = fillRowsWithUnplacedCardsWith1x1Size(cardStyles, numberOfItems, rows);

        var _ref = findFirstItemInRows(filled, index),
            row = _ref.row,
            col = _ref.col;

        if (col === numberOfItems - 1) {
          col = 0;
          row++;
        }

        if (!rows[row]) {
          rows[row] = [];
        }

        rows[row][col] = index;
        rows[row][col + 1] = index;

        if (card.itemSize === "2x2") {
          if (!rows[row + 1]) {
            rows[row + 1] = [];
          }

          rows[row + 1][col] = index;
          rows[row + 1][col + 1] = index;
        }
      }
    });
    rows = fillRowsWithUnplacedCardsWith1x1Size(cardStyles, numberOfItems, rows);
  }

  return rows;
}
function fillRowsWithUnplacedCardsWith1x1Size(cardStyles, numberOfItems, inputRows) {
  var rows = deepClone(inputRows);
  cardStyles.forEach(function (card, index) {
    if (findFirstItemInRows(rows, index)) {
      return;
    }

    for (var row = 0; row < 999; row++) {
      if (rows[row]) {
        var isFull = true;

        for (var col = 0; col < numberOfItems; col++) {
          if (rows[row][col] === undefined || rows[row][col] === null) {
            rows[row][col] = index;
            isFull = false;
            break;
          }
        }

        if (isFull) {
          continue;
        } else {
          break;
        }
      } else {
        rows[row] = [index];
        break;
      }
    }
  });
  return rows;
}
function buildItemPositions(rows, length, itemsInRow) {
  var itemPositions = [];

  for (var i = 0; i < length; i++) {
    itemPositions.push({
      isFirstRow: false,
      isFirstColumn: false,
      isLastColumn: false,
      isLastRow: false
    });
  }

  rows.forEach(function (row, index) {
    if (index === 0) {
      row.forEach(function (itemIndex) {
        if (itemIndex === null || itemIndex === undefined) {
          return;
        }

        itemPositions[itemIndex].isFirstRow = true;
      });
    }

    if (index === rows.length - 1) {
      row.forEach(function (itemIndex) {
        if (itemIndex === null || itemIndex === undefined) {
          return;
        }

        itemPositions[itemIndex].isLastRow = true;
      });
    }

    row.forEach(function (itemIndex, colIndex) {
      if (itemIndex === null || itemIndex === undefined) {
        return;
      }

      if (colIndex === 0) {
        itemPositions[itemIndex].isFirstColumn = true;
      }

      if (colIndex === itemsInRow - 1) {
        itemPositions[itemIndex].isLastColumn = true;
      }
    });
  });
  return itemPositions;
}

function ownKeys$D(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$C(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$D(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$D(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function styles$b(config, _ref) {
  var $width = _ref.$width,
      device = _ref.device;

  if ($width === -1) {
    throw new Error("$GridCard without width!!!");
  }

  var _gridController = gridController(config, $width, device),
      cssAbsoluteLeftPosition = _gridController.cssAbsoluteLeftPosition,
      cssAbsoluteRightPosition = _gridController.cssAbsoluteRightPosition,
      itemsVisible = _gridController.itemsVisible,
      $widthItem = _gridController.$widthItem;

  var numberOfItems = parseInt(config.numberOfItems);
  var isSlider = config.variant === "slider";
  var shouldSliderItemsBeVisibleOnMargin = config.shouldSliderItemsBeVisibleOnMargin,
      rightArrowOffset = config.rightArrowOffset,
      rightArrowPlacement = config.rightArrowPlacement,
      leftArrowPlacement = config.leftArrowPlacement,
      leftArrowOffset = config.leftArrowOffset;
  var columnGap = config.columnGap;
  var rowGap = config.rowGap;

  if (config.borderEnabled) {
    columnGap = "max(".concat(columnGap, ", ").concat(config.borderInner, "px)");
    rowGap = "max(".concat(rowGap, ", ").concat(config.borderInner, "px)");
  }

  var showSliderControls = isSlider && device.id !== "xs";
  var base = "100%";

  if (shouldSliderItemsBeVisibleOnMargin) {
    base = "calc(100% - ".concat(cssAbsoluteLeftPosition, " - ").concat(cssAbsoluteRightPosition, ")");
  }

  base += " - calc(".concat(columnGap, " * ").concat(itemsVisible - 1, ")");
  base = "calc(".concat(base, ")");
  var size = "calc(".concat(base, " / ").concat(itemsVisible, ")");
  var containerDisplay;
  var containerMarginLeft;
  var containerMarginRight;
  var innerContainerDisplay;
  var spacerDisplay;
  var itemContainerMarginRight;
  var itemContainerWidth;
  var gridColumnGap; // Default left arrow state

  var leftArrowWrapperDisplay = "none";
  var leftArrowWrapperLeft = "0px";
  var leftArrowWrapperRight = "auto";
  var leftArrowInnerWrapperLeft = "auto"; // Default right arrow state

  var rightArrowWrapperDisplay = "none";
  var rightArrowWrapperLeft = "auto";
  var rightArrowWrapperRight = "0px";
  var rightArrowInnerWrapperLeft = "auto";
  var spacerLeftWidth = "0px";
  var spacerRightWidth = "0px";
  var paddingLeft = config.borderEnabled && (config.borderLeft !== "0" || config.borderTop !== "0" || config.borderBottom !== "0") ? config.paddingLeft : "0px";
  var paddingRight = config.borderEnabled && (config.borderRight !== "0" || config.borderTop !== "0" || config.borderBottom !== "0") ? config.paddingRight : "0px";
  var paddingTop = config.borderEnabled && config.borderTop !== "0" ? config.paddingTop : "0px";
  var paddingBottom = config.borderEnabled && config.borderBottom !== "0" ? config.paddingBottom : "0px";

  if (isSlider) {
    containerDisplay = "flex";
    innerContainerDisplay = "flex";
    spacerDisplay = "block";
    itemContainerMarginRight = columnGap;
    gridColumnGap = 0;
    itemContainerWidth = size;

    if (shouldSliderItemsBeVisibleOnMargin) {
      containerMarginLeft = 0;
      containerMarginRight = 0;
      spacerLeftWidth = "calc(".concat(cssAbsoluteLeftPosition, " + ").concat(paddingLeft, ")");
      spacerRightWidth = "calc(".concat(cssAbsoluteRightPosition, " + ").concat(paddingRight, ")");
    } else {
      containerMarginLeft = cssAbsoluteLeftPosition;
      containerMarginRight = cssAbsoluteRightPosition;
      spacerLeftWidth = paddingLeft;
      spacerRightWidth = paddingRight;
    }

    paddingLeft = "0px";
    paddingRight = "0px"; // Left arrow

    leftArrowWrapperDisplay = showSliderControls ? "flex" : "none";

    if (leftArrowPlacement === "inside") {
      leftArrowWrapperLeft = "calc(".concat(cssAbsoluteLeftPosition, " + ").concat(leftArrowOffset, ")");
    } else if (leftArrowPlacement === "outside") {
      leftArrowWrapperLeft = "calc(".concat(cssAbsoluteLeftPosition, " - ").concat(leftArrowOffset, ")");
      leftArrowInnerWrapperLeft = "-100%";
    } else if (leftArrowPlacement === "center") {
      leftArrowWrapperLeft = cssAbsoluteLeftPosition;
      leftArrowInnerWrapperLeft = "-50%";
    } else {
      leftArrowWrapperLeft = leftArrowOffset;
    } // Left arrow


    rightArrowWrapperDisplay = showSliderControls ? "flex" : "none";

    if (rightArrowPlacement === "inside") {
      rightArrowWrapperRight = "calc(".concat(cssAbsoluteRightPosition, " + ").concat(rightArrowOffset, ")");
    } else if (rightArrowPlacement === "outside") {
      rightArrowWrapperRight = "calc(".concat(cssAbsoluteRightPosition, " - ").concat(rightArrowOffset, ")");
      rightArrowInnerWrapperLeft = "100%";
    } else if (rightArrowPlacement === "center") {
      rightArrowWrapperRight = cssAbsoluteRightPosition;
      rightArrowInnerWrapperLeft = "50%";
    } else {
      rightArrowWrapperRight = rightArrowOffset;
    }
  } else {
    containerDisplay = "block";
    spacerDisplay = "none";
    itemContainerMarginRight = "0px";
    itemContainerWidth = "auto";
    innerContainerDisplay = "grid";
    containerMarginLeft = cssAbsoluteLeftPosition;
    containerMarginRight = cssAbsoluteRightPosition;
    gridColumnGap = columnGap;
  }

  var gridTemplateColumns = "repeat(".concat(itemsVisible, ", minmax(0, 1fr))");
  var Root = box({
    position: "relative",
    paddingLeft: containerMarginLeft,
    paddingRight: containerMarginRight
  });
  var Container = box({
    position: "relative",
    display: containerDisplay,
    overflowX: isSlider ? "auto" : "visible",
    "&::-webkit-scrollbar": {
      display: "none"
    },
    scrollbarWidth: "none",
    width: "100%",
    borderTop: config.borderEnabled ? "".concat(config.borderTop, "px solid ").concat(config.borderColor) : "none",
    borderBottom: config.borderEnabled ? "".concat(config.borderBottom, "px solid ").concat(config.borderColor) : "none",
    borderLeft: config.borderEnabled ? "".concat(config.borderLeft, "px solid ").concat(config.borderColor) : "none",
    borderRight: config.borderEnabled ? "".concat(config.borderRight, "px solid ").concat(config.borderColor) : "none",
    paddingTop: paddingTop,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight
  });
  var InnerContainer = box({
    display: innerContainerDisplay,
    flexDirection: "row",
    flexWrap: "nowrap",
    gridTemplateColumns: gridTemplateColumns,
    gridColumnGap: gridColumnGap,
    gridRowGap: rowGap,
    alignItems: "stretch",
    width: "100%"
  });

  var createSpacer = function createSpacer(basis) {
    return box({
      display: spacerDisplay,
      height: "1px",
      position: "relative",
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: basis,
      zIndex: 0
    });
  };

  var SpacerLeft = createSpacer(spacerLeftWidth);
  var SpacerRight = createSpacer(spacerRightWidth);
  var LeftArrowWrapper = box({
    display: leftArrowWrapperDisplay,
    position: "absolute",
    top: 0,
    left: leftArrowWrapperLeft,
    right: leftArrowWrapperRight,
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "none",
    zIndex: 100,
    transition: "opacity .15s",
    opacity: 0
  });
  var LeftArrowInnerWrapper = box({
    position: "relative",
    left: leftArrowInnerWrapperLeft,
    pointerEvents: "initial"
  });
  var RightArrowWrapper = box({
    display: rightArrowWrapperDisplay,
    position: "absolute",
    top: 0,
    left: rightArrowWrapperLeft,
    right: rightArrowWrapperRight,
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "none",
    zIndex: 100,
    transition: "opacity .15s",
    opacity: 0
  });
  var RightArrowInnerWrapper = box({
    position: "relative",
    left: rightArrowInnerWrapperLeft,
    pointerEvents: "initial"
  });
  var itemProps = []; // This is tricky. Ask Andrzej in case of questions. vw is problematic because of potential scrollbar, but we should introduce global CSS var with correct vw.

  var sizeWithVw = size.replace(/100%/g, "var(--shopstory-viewport-width, 100vw)");
  var GRID_BASELINE_ASPECT_RATIO = parseAspectRatio(config.gridMainObjectAspectRatio);
  var gridBaseLineHeight = "calc(".concat(sizeWithVw, " * ").concat(GRID_BASELINE_ASPECT_RATIO, ")"); // We set default item container for placeholder

  var cardStyles = config.Cards.length > 0 ? config.Cards : [{
    itemSize: "1x1"
  }];
  var rows = buildRows(cardStyles, isSlider, numberOfItems);
  var itemPositions = buildItemPositions(rows, cardStyles.length, isSlider ? cardStyles.length : numberOfItems);
  var colGapPx = spacingToPx(config.columnGap, $width);
  var rowGapPx = spacingToPx(config.rowGap, $width);
  var borderWidthPx = parseInt(config.borderInner);
  var colDiff = (colGapPx - borderWidthPx) / 2;
  var rowDiff = (rowGapPx - borderWidthPx) / 2;
  var itemContainers = cardStyles.map(function (card, index) {
    // For slider we always return item container
    var baseProps = {
      gridBaseLineHeight: gridBaseLineHeight,
      $widthAuto: false,
      $width: $widthItem,
      edgeLeft: calculateEdge(config.borderEnabled, $width, paddingLeft, config.borderLeft, itemPositions[index].isFirstColumn, config.escapeMargin, colDiff),
      edgeRight: calculateEdge(config.borderEnabled, $width, paddingRight, config.borderRight, itemPositions[index].isLastColumn, config.escapeMargin, colDiff),
      edgeTop: calculateEdge(config.borderEnabled, $width, paddingTop, config.borderTop, itemPositions[index].isFirstRow, false, rowDiff),
      edgeBottom: calculateEdge(config.borderEnabled, $width, paddingBottom, config.borderBottom, itemPositions[index].isLastRow, false, rowDiff)
    };

    if (isSlider) {
      itemProps.push(_objectSpread$C({}, baseProps));
      return box({
        display: "grid",
        position: "relative",
        marginRight: index < cardStyles.length - 1 ? itemContainerMarginRight : 0,
        flexGrow: 0,
        flexShrink: 0,
        width: itemContainerWidth
      });
    }

    if (card.itemSize === "1x1") {
      itemProps.push(_objectSpread$C({}, baseProps));
      return box({
        position: "relative",
        display: "grid"
      });
    } else if (card.itemSize === "2x1" || card.itemSize === "2x2") {
      itemProps.push(_objectSpread$C(_objectSpread$C({}, baseProps), {}, {
        $width: $widthItem * 2 + spacingToPx(columnGap, device.w)
      }));

      if (numberOfItems === 1) {
        return box({
          position: "relative",
          display: "grid"
        });
      }

      var _ref2 = findFirstItemInRows(rows, index),
          row = _ref2.row,
          col = _ref2.col;

      row++;
      col++;
      return box({
        position: "relative",
        display: "grid",
        gridRow: card.itemSize === "2x1" ? row : "".concat(row, " / span 2"),
        gridColumn: "".concat(col, " / span 2")
      });
    } else {
      throw new Error("other modes than 1x1 and 2x1 are not yet supported");
    }
  });
  var itemInnerContainers = cardStyles.map(function (card) {
    var verticalAlign = card.verticalAlign === "auto" ? config.verticalAlign : card.verticalAlign;
    return box({
      display: "grid",
      position: "relative",
      alignItems: verticalAlignToFlexAlign(verticalAlign)
    });
  });
  var verticalLines = cardStyles.map(function (_, index) {
    if (!config.borderEnabled) {
      return box({
        display: "none"
      });
    }

    if (itemPositions[index].isLastColumn) {
      return box({
        position: "absolute",
        display: "none"
      });
    }

    var halfRowGap = "calc(".concat(rowGap, " / 2)");
    var halfRowGapNegative = "calc(".concat(rowGap, " / -2)");
    var top;
    var height;

    if (itemPositions[index].isFirstRow && itemPositions[index].isLastRow) {
      top = "calc(".concat(paddingTop, " * -1)");
      height = "calc(100% + ".concat(paddingTop, " + ").concat(paddingBottom, ")");
    } else if (itemPositions[index].isFirstRow) {
      top = "calc(".concat(paddingTop, " * -1)");
      height = "calc(100% + ".concat(halfRowGap, " + ").concat(paddingTop, ")");
    } else if (itemPositions[index].isLastRow) {
      top = halfRowGapNegative;
      height = "calc(100% + ".concat(halfRowGap, " + ").concat(paddingBottom, ")");
    } else {
      top = halfRowGapNegative;
      height = "calc(100% + ".concat(rowGap, ")");
    }

    return box({
      position: "absolute",
      top: top,
      right: getLineEndPosition(config.borderInner + "px", columnGap),
      width: "".concat(config.borderInner, "px"),
      height: height,
      background: config.borderColor,
      zIndex: 50
    });
  });
  var horizontalLines = cardStyles.map(function (_, index) {
    if (!config.borderEnabled) {
      return box({
        display: "none"
      });
    }

    if (itemPositions[index].isLastRow
    /* || !itemPositions[index].isFirstColumn*/
    ) {
      return box({
        position: "absolute",
        display: "none"
      });
    }

    var width;
    var left;
    var halfColGap = "calc(".concat(columnGap, " / 2)");
    var halfColGapNegative = "calc(".concat(columnGap, " / -2)");

    if (itemPositions[index].isFirstColumn && itemPositions[index].isLastColumn) {
      width = "calc(100% + ".concat(paddingLeft, " + ").concat(paddingRight, ")");
      left = "calc(".concat(paddingLeft, " * -1)");
    } else if (itemPositions[index].isFirstColumn) {
      width = "calc(100% + ".concat(paddingLeft, " + ").concat(halfColGap, ")");
      left = "calc(".concat(paddingLeft, " * -1)");
    } else if (itemPositions[index].isLastColumn) {
      width = "calc(100% + ".concat(paddingRight, " + ").concat(halfColGap, ")");
      left = halfColGapNegative;
    } else {
      width = "calc(100% + ".concat(columnGap, ")");
      left = halfColGapNegative;
    }

    return box({
      position: "absolute",
      bottom: getLineEndPosition(config.borderInner + "px", rowGap),
      // this min() is required to have at least 1px. This is super important for zero gaps.
      width: width,
      left: left,
      height: "".concat(config.borderInner, "px"),
      background: config.borderColor,
      zIndex: 50
    });
  });
  return {
    Root: Root,
    Container: Container,
    InnerContainer: InnerContainer,
    SpacerLeft: SpacerLeft,
    SpacerRight: SpacerRight,
    itemContainers: itemContainers,
    itemInnerContainers: itemInnerContainers,
    Cards: {
      itemProps: itemProps
    },
    LeftArrowWrapper: LeftArrowWrapper,
    LeftArrowInnerWrapper: LeftArrowInnerWrapper,
    LeftArrow: {
      noAction: true
    },
    RightArrowWrapper: RightArrowWrapper,
    RightArrowInnerWrapper: RightArrowInnerWrapper,
    RightArrow: {
      noAction: true
    },
    horizontalLines: horizontalLines,
    verticalLines: verticalLines
  };
}

function verticalAlignToFlexAlign(align) {
  if (align === "bottom") {
    return "flex-end";
  } else if (align === "center" || align === "stretch") {
    return align;
  } else {
    return "flex-start";
  }
}

var THRESHOLD = 4;

function calculateEdge(borderEnabled, width, padding, border, isAtEdge, touching, innerDiff) {
  var paddingPx = spacingToPx(padding, width);
  var hasBorder = borderEnabled && border !== "0";
  return isAtEdge && !hasBorder && touching || isAtEdge && hasBorder && paddingPx < THRESHOLD || !isAtEdge && innerDiff < THRESHOLD;
}

function getLineEndPosition(borderWidth, gap) {
  return "min(-1px, calc(calc(".concat(gap, " / -2) + calc(").concat(borderWidth, " / -2)))");
}

function calculateContainerWidth(config, device, devices, widths) {
  var _responsiveValueGetDe, _responsiveValueGetDe2;

  var edgeMargin = (_responsiveValueGetDe = responsiveValueGetDefinedValue(config.edgeMargin, device.id, devices, widths)) !== null && _responsiveValueGetDe !== void 0 ? _responsiveValueGetDe : "0px";
  var snappedToEdge = (_responsiveValueGetDe2 = responsiveValueGetDefinedValue(config.snappedToEdge, device.id, devices, widths)) !== null && _responsiveValueGetDe2 !== void 0 ? _responsiveValueGetDe2 : 0;
  var width = widths[device.id];

  if (snappedToEdge) {
    return width;
  }

  return width - 2 * spacingToPx(edgeMargin, device.w);
}

var MAGIC_NUMBER = 1;

function tokenizeNumberOfItems(numberOfItems) {
  return {
    ref: numberOfItems.toString(),
    value: numberOfItems.toString()
  };
}

var gridAuto = function gridAuto(config, compilationContext, inputWidths) {
  var devices = compilationContext.devices; // Auto should be done relative to real container widths but Grid also have container margins inside.

  var widths = {
    $res: true
  };
  devices.forEach(function (device) {
    var scalarizedContainerProps = scalarizeConfig({
      edgeLeftMargin: responsiveValueFill(config.edgeLeftMargin, devices, getDevicesWidths(devices)),
      edgeRightMargin: responsiveValueFill(config.edgeRightMargin, devices, getDevicesWidths(devices)),
      escapeMargin: responsiveValueFill(config.escapeMargin, devices, getDevicesWidths(devices)),
      maxWidth: responsiveValueFill(config.maxWidth, devices, getDevicesWidths(devices))
    }, device.id, devices, []);

    var _gridContainerControl = gridContainerController(scalarizedContainerProps, responsiveValueForceGet(inputWidths, device.id), device),
        realWidth = _gridContainerControl.realWidth;

    widths[device.id] = realWidth;
  });
  var values = responsiveAuto(config, compilationContext, widths, function (_ref, _ref2) {
    var values = _ref.values;
        _ref.higherDefinedValues;
        _ref.lowerDefinedValues;
        var closestDefinedValues = _ref.closestDefinedValues;
        _ref.width;
    _ref2.config;
        _ref2.compilationContext;
        _ref2.widths;
        var device = _ref2.device;
    var shouldSliderItemsBeVisibleOnMargin = values.shouldSliderItemsBeVisibleOnMargin;

    if (shouldSliderItemsBeVisibleOnMargin === undefined) {
      shouldSliderItemsBeVisibleOnMargin = device.id === "xs" ? true : closestDefinedValues.shouldSliderItemsBeVisibleOnMargin.value;
    }

    return {
      shouldSliderItemsBeVisibleOnMargin: shouldSliderItemsBeVisibleOnMargin
    };
  });
  /**
   * NUMBER OF ITEMS / FRACTIONAL ITEM WIDTH
   */

  var maxNumberOfItems = 0;
  devices.forEach(function (device) {
    var numberOfItems = config.numberOfItems[device.id];

    if (numberOfItems !== undefined) {
      maxNumberOfItems = Math.max(maxNumberOfItems, parseInt(numberOfItems.value));
    }
  });
  values = responsiveAuto(values, compilationContext, widths, function (_ref3, _ref4) {
    var values = _ref3.values,
        higherDefinedValues = _ref3.higherDefinedValues,
        lowerDefinedValues = _ref3.lowerDefinedValues,
        closestDefinedValues = _ref3.closestDefinedValues,
        width = _ref3.width;
    var config = _ref4.config;
        _ref4.compilationContext;
        var widths = _ref4.widths,
        device = _ref4.device;

    if (values.numberOfItems !== undefined) {
      if (device.id === "xs" && values.fractionalItemWidth === undefined) {
        return {
          numberOfItems: values.numberOfItems,
          fractionalItemWidth: config.Cards.length <= parseInt(values.numberOfItems.value) ? "1" : "1.25"
        };
      }

      return {
        numberOfItems: values.numberOfItems,
        fractionalItemWidth: closestDefinedValues.fractionalItemWidth.value
      };
    }

    if (!higherDefinedValues.numberOfItems) {
      return {
        numberOfItems: closestDefinedValues.numberOfItems.value,
        fractionalItemWidth: closestDefinedValues.fractionalItemWidth.value
      };
    }

    var minNumberOfItems = lowerDefinedValues.numberOfItems ? parseInt(lowerDefinedValues.numberOfItems.value.value) : 1;
    var maxNumberOfItems = parseInt(higherDefinedValues.numberOfItems.value.value);
    var variant = closestDefinedValues.variant.value;
    /**
     * Below there's a very simple check to prevent showing 1-item grid too soon.
     */
    // We could make this condition more generic

    if (maxNumberOfItems === 1) {
      minNumberOfItems = 1;
    } else if (variant === "grid" || variant === "slider" && device.id !== "xs") {
      /**
       * This condition is super important.
       *
       * The switch from grid with 2 items into grid with 1 item is usually unwanted. It looks bad.
       * However, if someone creates 2 absolutely HUGE items then we should still switch them to one under another.
       * Here we make a decision when do we allow for 1 or 2 minimum.
       */
      var higherWidth = higherDefinedValues.numberOfItems.width;
      var higherNumberOfItems = parseInt(higherDefinedValues.numberOfItems.value.value);
      var higherItemWidth = higherWidth / higherNumberOfItems;
      var current2ItemsWidth = width / 2; // don't allow for switch from 2 to 1 until item is 2.5x smaller (huge difference). Switching from 2 to 1 is usually very unwanted.

      if (higherNumberOfItems === 2 && current2ItemsWidth * 2.5 > higherItemWidth) {
        minNumberOfItems = 2;
      } // don't allow for switch when on higher breakpoint there are > 4
      else if (higherNumberOfItems >= 4) {
        minNumberOfItems = 2;
      }
    }

    var containerWidth = calculateContainerWidth(config, device, devices, widths);
    var bestNum = minNumberOfItems;
    var bestFraction = 0;
    var bestXFactor = 99999;
    var pairs = [];

    for (var num = minNumberOfItems; num <= maxNumberOfItems; num++) {
      if (device.id !== "xs") {
        pairs.push({
          numberOfItems: num,
          fraction: 0
        });
      } else {
        var currentFraction = values.fractionalItemWidth;

        if (currentFraction !== undefined) {
          pairs.push({
            numberOfItems: num,
            fraction: parseFloat(currentFraction) - 1
          });
        } else {
          pairs.push({
            numberOfItems: num,
            fraction: 0.25
          });
        }
      }
    }

    pairs.forEach(function (pair) {
      var num = pair.numberOfItems + pair.fraction;
      var higherNumberOfItems = parseInt(higherDefinedValues.numberOfItems.value.value);
      var higherIsRow = higherNumberOfItems <= config.Cards.length;
      var higherContainerWidth = calculateContainerWidth(config, higherDefinedValues.numberOfItems.device, devices, widths);
      var higherItemWidth = higherContainerWidth / higherNumberOfItems; // If last defined value is a row and now we're having a grid, we can't do the layout that has "empty spaces". Unless when lastDefinedCount is 4 or less

      if (higherIsRow && variant === "grid" && higherNumberOfItems <= 4) {
        // If we start with a row
        if (config.Cards.length % num !== 0) {
          return;
        }
      } // If slider with n items when n >= 2, then we can't show n - 1 items. That would be odd.


      if (variant === "slider") {
        if (num === config.Cards.length - 1 && num >= 3) {
          return;
        }
      }

      var itemWidth = containerWidth / num;
      var P = itemWidth / higherItemWidth; // proportion

      var xfactor = P >= 1 ? P : MAGIC_NUMBER * (1 / P);

      if (xfactor < bestXFactor) {
        bestNum = pair.numberOfItems;
        bestFraction = pair.fraction;
        bestXFactor = xfactor;
      }
    });

    if (bestNum >= config.Cards.length) {
      bestFraction = 0;
    }

    return {
      numberOfItems: tokenizeNumberOfItems(bestNum),
      fractionalItemWidth: (bestFraction + 1).toString()
    };
  }); // for (const prop in values) {
  //   if (isTrulyResponsiveValue(values[prop])) {
  //     values[prop] = responsiveValueNormalize(
  //       values[prop],
  //       compilationContext.devices
  //     );
  //   }
  // }

  return values;
};

React.createElement;

/** @jsx createElement */

/* global createElement */
function IconButton$1(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      ButtonRoot = _props$__fromEditor$c.ButtonRoot,
      Symbol = _props$__fromEditor$c.symbol,
      IconWrapper = _props$__fromEditor$c.IconWrapper; // We don't use JSX here because for now spread operator doesn't work in components code... :(

  var buttonProps = {
    // dangerouslySetInnerHTML: { __html: props.__fromEditor.props.icon },
    ref: props.forwardedRef
  };

  for (var key in props) {
    if (key === "as" || key === "onClick" || key === "href" || key === "target") {
      buttonProps[key] = props[key];
    }
  }

  return createElement(ButtonRoot, buttonProps, createElement(IconWrapper, null, createElement(Symbol, null)));
}

function styles$a(values, _ref) {
  _ref.theme;
  var ButtonRoot = box({
    // reset (no fonts, just SVG)
    margin: 0,
    padding: 0,
    overflow: "hidden",
    background: "transparent",
    WebkitAppearance: "none",
    // styles
    position: "relative",
    display: "grid",
    justifyContent: "center",
    alignItems: "center",
    width: values.buttonSize,
    height: values.buttonSize,
    backgroundColor: values.backgroundColor,
    borderRadius: values.shape === "circle" ? "50%" : 0,
    border: "".concat(values.border, "px solid ").concat(values.borderColor),
    transition: "opacity .15s",
    "&:hover": {
      opacity: 0.75
    },
    cursor: "pointer"
  }, "button");
  return {
    symbol: {
      passed_allowColor: true
    },
    ButtonRoot: ButtonRoot,
    IconWrapper: box({
      display: "grid",
      width: values.symbolSize + "px",
      height: values.symbolSize + "px"
    })
  };
}

React.createElement;

/** @jsx createElement */

/* global createElement */
function IconButton(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      ButtonRoot = _props$__fromEditor$c.ButtonRoot,
      Symbol = _props$__fromEditor$c.symbol,
      IconWrapper = _props$__fromEditor$c.IconWrapper; // We don't use JSX here because for now spread operator doesn't work in components code... :(

  var buttonProps = {
    // dangerouslySetInnerHTML: { __html: props.__fromEditor.props.icon },
    ref: props.forwardedRef
  };

  for (var key in props) {
    if (key === "as" || key === "onClick" || key === "href" || key === "target") {
      buttonProps[key] = props[key];
    }
  }

  return createElement(ButtonRoot, buttonProps, createElement(IconWrapper, null, createElement(Symbol, null)));
}

function styles$9(config) {
  var hasBackground = config.hasBackground;
  var hasBorder = config.hasBorder;
  var isNaked = !hasBackground && !hasBorder;
  var ButtonRoot = box({
    // reset (no fonts, just SVG)
    margin: 0,
    padding: 0,
    overflow: "hidden",
    background: "transparent",
    WebkitAppearance: "none",
    // styles
    position: "relative",
    display: "grid",
    justifyContent: "center",
    alignItems: "center",
    width: isNaked ? "auto" : "".concat(config.buttonSize, "px"),
    height: isNaked ? "auto" : "".concat(config.buttonSize, "px"),
    backgroundColor: hasBackground ? config.backgroundColor : "transparent",
    borderWidth: hasBorder ? "".concat(config.borderWidth, "px") : 0,
    borderColor: config.borderColor,
    borderStyle: "solid",
    borderRadius: config.shape === "circle" ? "50%" : 0,
    transition: "opacity .15s",
    "&:hover": {
      opacity: 0.75
    },
    cursor: "pointer"
  }, "button");
  return {
    symbol: {
      passed_allowColor: true
    },
    ButtonRoot: ButtonRoot,
    IconWrapper: box({
      display: "grid",
      width: config.symbolSize + "px",
      height: config.symbolSize + "px"
    })
  };
}

React.createElement;

/** @jsx createElement */
function Placeholder(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      Image = _props$__fromEditor$c.Image,
      Title = _props$__fromEditor$c.Title,
      Desc = _props$__fromEditor$c.Desc;
  return createElement("div", null, createElement(Image, null), createElement(Title, null), createElement(Desc, null));
}

function styles$8(config, _ref) {
  _ref.theme;
  var color = "#eaeaea";
  var Image = box({
    height: config.gridBaseLineHeight,
    background: color
  });
  var Title = box({
    marginTop: 16,
    height: 24,
    width: "70%",
    background: color
  });
  var Desc = box({
    marginTop: 12,
    height: 16,
    width: "50%",
    background: color
  });
  return {
    Image: Image,
    Title: Title,
    Desc: Desc
  };
}

React.createElement;

/** @jsx createElement */

/* global createElement */
function StandardButton(props) {
  var ButtonRoot = props.__fromEditor.components.ButtonRoot; // Every Shopstory button is just a component that must have props and ref passed.
  // We don't use JSX here because for now spread operator doesn't work in components code... :(

  var buttonProps = {
    // dangerouslySetInnerHTML: {__html: props.configProps.icon },
    ref: props.forwardedRef
  }; // TODO: pass through button-related props -> do "spread" later -> there's duplication in IconButton too, do sth with it

  for (var key in props) {
    if (key === "as" || key === "onClick" || key === "href" || key === "target") {
      buttonProps[key] = props[key];
    }
  }

  return createElement(ButtonRoot, buttonProps, createElement("div", null, props.__fromEditor.props.label.value));
}

function ownKeys$C(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$B(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$C(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$C(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function styles$7(config) {
  var hasBackground = config.hasBackground;
  var hasBorder = config.hasBorder;
  var isNaked = !hasBackground && !hasBorder;
  var ButtonRoot = box(_objectSpread$B(_objectSpread$B({
    // reset (no fonts, just SVG)
    border: "none",
    margin: 0,
    padding: 0,
    overflow: "visible",
    background: "transparent",
    WebkitAppearance: "none",
    // styles
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: config.color
  }, config.font), {}, {
    transition: "opacity .15s",
    textDecoration: config.underline === "off" ? "none" : "underline",
    textUnderlineOffset: config.underline === "on-custom" ? "".concat(config.underlineOffset, "px") : "auto",
    "&:hover": {
      opacity: 0.75
    },
    minHeight: isNaked ? 0 : "".concat(config.minHeight, "px"),
    minWidth: isNaked ? 0 : "".concat(config.minWidth, "px"),
    paddingLeft: isNaked ? 0 : config.horizontalPadding,
    paddingRight: isNaked ? 0 : config.horizontalPadding,
    backgroundColor: hasBackground ? config.backgroundColor : "transparent",
    borderRadius: isNaked ? 0 : "".concat(config.radius, "px"),
    borderWidth: hasBorder ? "".concat(config.borderWidth, "px") : 0,
    borderColor: config.borderColor,
    borderStyle: "solid",
    whiteSpace: "nowrap",
    cursor: "pointer"
  }), "button");
  return {
    ButtonRoot: ButtonRoot
  };
}

React.createElement;

/** @jsx createElement */
function ProductCard(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      Image = _props$__fromEditor$c.Image,
      Root = _props$__fromEditor$c.Root,
      Title = _props$__fromEditor$c.Title,
      Price = _props$__fromEditor$c.Price;
  var product = props.__fromEditor.props.product;
  var image = product.images[0];
  var shopstoryImage = {
    alt: image.alt,
    url: image.src,
    aspectRatio: 1,
    srcset: [{
      url: image.src,
      w: 100,
      h: 100
    }]
  };
  return createElement(Root, null, createElement(Image, {
    image: shopstoryImage
  }), createElement(Title, null, product.title), createElement(Price, null, parseFloat(product.price), "$"));
}

function ownKeys$B(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$A(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$B(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$B(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function styles$6(config, _ref) {
  _ref.theme;
  return {
    Root: box({
      position: "relative"
    }),
    Image: {
      aspectRatio: 1.3
    },
    Title: box(_objectSpread$A(_objectSpread$A({}, config.titleFont), {}, {
      marginTop: config.imageTitleSpace,
      marginBottom: config.titlePriceSpace,
      color: config.titleColor
    })),
    Price: box(_objectSpread$A(_objectSpread$A({}, config.priceFont), {}, {
      color: config.priceColor
    }))
  };
}

React.createElement;

/** @jsx createElement */
function LocalisedCollectionTest(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      Root = _props$__fromEditor$c.Root,
      Items = _props$__fromEditor$c.Items,
      itemWrappers = _props$__fromEditor$c.itemWrappers;
  return createElement(Root, null, Items.map(function (Item, index) {
    var ItemWrapper = itemWrappers[index];
    return createElement(ItemWrapper, {
      "data-item": true
    }, createElement(Item, null));
  }));
}

function styles$5(config, _ref) {
  _ref.theme;
  var items = config.Items.length > 0 ? config.Items : [{
    hasTopMargin: false
  }];
  var itemWrappers = items.map(function (item) {
    return box({
      paddingTop: item.hasTopMargin ? "32px" : 0
    });
  });
  return {
    itemWrappers: itemWrappers,
    Root: box({
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr"
    })
  };
}

/**
 * Playground purpose is to have as many use cases as possible for tests
 */

function styles$4(config, _ref) {
  _ref.theme;
  return {
    Root: box({
      position: "relative",
      top: 100
    }),
    Span: box({
      position: "relative",
      right: 50
    }, "span"),
    ActionElement: box({
      __action: "action",
      left: 100
    })
  };
}

var validator$4 = {};

var util$2 = {};

(function (exports) {

var nameStartChar = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var nameChar = nameStartChar + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
var nameRegexp = '[' + nameStartChar + '][' + nameChar + ']*';
var regexName = new RegExp('^' + nameRegexp + '$');

var getAllMatches = function getAllMatches(string, regex) {
  var matches = [];
  var match = regex.exec(string);

  while (match) {
    var allmatches = [];
    allmatches.startIndex = regex.lastIndex - match[0].length;
    var len = match.length;

    for (var index = 0; index < len; index++) {
      allmatches.push(match[index]);
    }

    matches.push(allmatches);
    match = regex.exec(string);
  }

  return matches;
};

var isName = function isName(string) {
  var match = regexName.exec(string);
  return !(match === null || typeof match === 'undefined');
};

exports.isExist = function (v) {
  return typeof v !== 'undefined';
};

exports.isEmptyObject = function (obj) {
  return Object.keys(obj).length === 0;
};
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */


exports.merge = function (target, a, arrayMode) {
  if (a) {
    var keys = Object.keys(a); // will return an array of own properties

    var len = keys.length; //don't make it inline

    for (var i = 0; i < len; i++) {
      if (arrayMode === 'strict') {
        target[keys[i]] = [a[keys[i]]];
      } else {
        target[keys[i]] = a[keys[i]];
      }
    }
  }
};
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */


exports.getValue = function (v) {
  if (exports.isExist(v)) {
    return v;
  } else {
    return '';
  }
}; // const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};


exports.isName = isName;
exports.getAllMatches = getAllMatches;
exports.nameRegexp = nameRegexp;
}(util$2));

var util$1 = util$2;

var defaultOptions$2 = {
  allowBooleanAttributes: false,
  //A tag can have attributes without any value
  unpairedTags: []
}; //const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");

validator$4.validate = function (xmlData, options) {
  options = Object.assign({}, defaultOptions$2, options); //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
  //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
  //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE

  var tags = [];
  var tagFound = false; //indicates that the root tag has been closed (aka. depth 0 has been reached)

  var reachedRoot = false;

  if (xmlData[0] === "\uFEFF") {
    // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
  }

  for (var i = 0; i < xmlData.length; i++) {
    if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
      i += 2;
      i = readPI(xmlData, i);
      if (i.err) return i;
    } else if (xmlData[i] === '<') {
      //starting of tag
      //read until you reach to '>' avoiding any '>' in attribute value
      var tagStartPos = i;
      i++;

      if (xmlData[i] === '!') {
        i = readCommentAndCDATA(xmlData, i);
        continue;
      } else {
        var closingTag = false;

        if (xmlData[i] === '/') {
          //closing tag
          closingTag = true;
          i++;
        } //read tagname


        var tagName = '';

        for (; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++) {
          tagName += xmlData[i];
        }

        tagName = tagName.trim(); //console.log(tagName);

        if (tagName[tagName.length - 1] === '/') {
          //self closing tag without attributes
          tagName = tagName.substring(0, tagName.length - 1); //continue;

          i--;
        }

        if (!validateTagName(tagName)) {
          var msg = void 0;

          if (tagName.trim().length === 0) {
            msg = "Invalid space after '<'.";
          } else {
            msg = "Tag '" + tagName + "' is an invalid name.";
          }

          return getErrorObject('InvalidTag', msg, getLineNumberForPosition(xmlData, i));
        }

        var result = readAttributeStr(xmlData, i);

        if (result === false) {
          return getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", getLineNumberForPosition(xmlData, i));
        }

        var attrStr = result.value;
        i = result.index;

        if (attrStr[attrStr.length - 1] === '/') {
          //self closing tag
          var attrStrStart = i - attrStr.length;
          attrStr = attrStr.substring(0, attrStr.length - 1);
          var isValid = validateAttributeString(attrStr, options);

          if (isValid === true) {
            tagFound = true; //continue; //text may presents after self closing tag
          } else {
            //the result from the nested function returns the position of the error within the attribute
            //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
            //this gives us the absolute index in the entire xml, which we can use to find the line at last
            return getErrorObject(isValid.err.code, isValid.err.msg, getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
          }
        } else if (closingTag) {
          if (!result.tagClosed) {
            return getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", getLineNumberForPosition(xmlData, i));
          } else if (attrStr.trim().length > 0) {
            return getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", getLineNumberForPosition(xmlData, tagStartPos));
          } else {
            var otg = tags.pop();

            if (tagName !== otg.tagName) {
              var openPos = getLineNumberForPosition(xmlData, otg.tagStartPos);
              return getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", getLineNumberForPosition(xmlData, tagStartPos));
            } //when there are no more tags, we reached the root level.


            if (tags.length == 0) {
              reachedRoot = true;
            }
          }
        } else {
          var _isValid = validateAttributeString(attrStr, options);

          if (_isValid !== true) {
            //the result from the nested function returns the position of the error within the attribute
            //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
            //this gives us the absolute index in the entire xml, which we can use to find the line at last
            return getErrorObject(_isValid.err.code, _isValid.err.msg, getLineNumberForPosition(xmlData, i - attrStr.length + _isValid.err.line));
          } //if the root level has been reached before ...


          if (reachedRoot === true) {
            return getErrorObject('InvalidXml', 'Multiple possible root nodes found.', getLineNumberForPosition(xmlData, i));
          } else if (options.unpairedTags.indexOf(tagName) !== -1) ; else {
            tags.push({
              tagName: tagName,
              tagStartPos: tagStartPos
            });
          }

          tagFound = true;
        } //skip tag text value
        //It may include comments and CDATA value


        for (i++; i < xmlData.length; i++) {
          if (xmlData[i] === '<') {
            if (xmlData[i + 1] === '!') {
              //comment or CADATA
              i++;
              i = readCommentAndCDATA(xmlData, i);
              continue;
            } else if (xmlData[i + 1] === '?') {
              i = readPI(xmlData, ++i);
              if (i.err) return i;
            } else {
              break;
            }
          } else if (xmlData[i] === '&') {
            var afterAmp = validateAmpersand(xmlData, i);
            if (afterAmp == -1) return getErrorObject('InvalidChar', "char '&' is not expected.", getLineNumberForPosition(xmlData, i));
            i = afterAmp;
          } else {
            if (reachedRoot === true && !isWhiteSpace(xmlData[i])) {
              return getErrorObject('InvalidXml', "Extra text at the end", getLineNumberForPosition(xmlData, i));
            }
          }
        } //end of reading tag text value


        if (xmlData[i] === '<') {
          i--;
        }
      }
    } else {
      if (isWhiteSpace(xmlData[i])) {
        continue;
      }

      return getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", getLineNumberForPosition(xmlData, i));
    }
  }

  if (!tagFound) {
    return getErrorObject('InvalidXml', 'Start tag expected.', 1);
  } else if (tags.length == 1) {
    return getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", getLineNumberForPosition(xmlData, tags[0].tagStartPos));
  } else if (tags.length > 0) {
    return getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map(function (t) {
      return t.tagName;
    }), null, 4).replace(/\r?\n/g, '') + "' found.", {
      line: 1,
      col: 1
    });
  }

  return true;
};

function isWhiteSpace(_char) {
  return _char === ' ' || _char === '\t' || _char === '\n' || _char === '\r';
}
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */


function readPI(xmlData, i) {
  var start = i;

  for (; i < xmlData.length; i++) {
    if (xmlData[i] == '?' || xmlData[i] == ' ') {
      //tagname
      var tagname = xmlData.substr(start, i - start);

      if (i > 5 && tagname === 'xml') {
        return getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', getLineNumberForPosition(xmlData, i));
      } else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
        //check if valid attribut string
        i++;
        break;
      } else {
        continue;
      }
    }
  }

  return i;
}

function readCommentAndCDATA(xmlData, i) {
  if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
    //comment
    for (i += 3; i < xmlData.length; i++) {
      if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
        i += 2;
        break;
      }
    }
  } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
    var angleBracketsCount = 1;

    for (i += 8; i < xmlData.length; i++) {
      if (xmlData[i] === '<') {
        angleBracketsCount++;
      } else if (xmlData[i] === '>') {
        angleBracketsCount--;

        if (angleBracketsCount === 0) {
          break;
        }
      }
    }
  } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
    for (i += 8; i < xmlData.length; i++) {
      if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
        i += 2;
        break;
      }
    }
  }

  return i;
}

var doubleQuote = '"';
var singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */

function readAttributeStr(xmlData, i) {
  var attrStr = '';
  var startChar = '';
  var tagClosed = false;

  for (; i < xmlData.length; i++) {
    if (xmlData[i] === doubleQuote || xmlData[i] === singleQuote) {
      if (startChar === '') {
        startChar = xmlData[i];
      } else if (startChar !== xmlData[i]) ; else {
        startChar = '';
      }
    } else if (xmlData[i] === '>') {
      if (startChar === '') {
        tagClosed = true;
        break;
      }
    }

    attrStr += xmlData[i];
  }

  if (startChar !== '') {
    return false;
  }

  return {
    value: attrStr,
    index: i,
    tagClosed: tagClosed
  };
}
/**
 * Select all the attributes whether valid or invalid.
 */


var validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g'); //attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""

function validateAttributeString(attrStr, options) {
  //console.log("start:"+attrStr+":end");
  //if(attrStr.trim().length === 0) return true; //empty string
  var matches = util$1.getAllMatches(attrStr, validAttrStrRegxp);
  var attrNames = {};

  for (var i = 0; i < matches.length; i++) {
    if (matches[i][1].length === 0) {
      //nospace before attribute name: a="sd"b="saf"
      return getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", getPositionFromMatch(matches[i]));
    } else if (matches[i][3] !== undefined && matches[i][4] === undefined) {
      return getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' is without value.", getPositionFromMatch(matches[i]));
    } else if (matches[i][3] === undefined && !options.allowBooleanAttributes) {
      //independent attribute: ab
      return getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", getPositionFromMatch(matches[i]));
    }
    /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */


    var attrName = matches[i][2];

    if (!validateAttrName(attrName)) {
      return getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", getPositionFromMatch(matches[i]));
    }

    if (!attrNames.hasOwnProperty(attrName)) {
      //check for duplicate attribute.
      attrNames[attrName] = 1;
    } else {
      return getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", getPositionFromMatch(matches[i]));
    }
  }

  return true;
}

function validateNumberAmpersand(xmlData, i) {
  var re = /\d/;

  if (xmlData[i] === 'x') {
    i++;
    re = /[\da-fA-F]/;
  }

  for (; i < xmlData.length; i++) {
    if (xmlData[i] === ';') return i;
    if (!xmlData[i].match(re)) break;
  }

  return -1;
}

function validateAmpersand(xmlData, i) {
  // https://www.w3.org/TR/xml/#dt-charref
  i++;
  if (xmlData[i] === ';') return -1;

  if (xmlData[i] === '#') {
    i++;
    return validateNumberAmpersand(xmlData, i);
  }

  var count = 0;

  for (; i < xmlData.length; i++, count++) {
    if (xmlData[i].match(/\w/) && count < 20) continue;
    if (xmlData[i] === ';') break;
    return -1;
  }

  return i;
}

function getErrorObject(code, message, lineNumber) {
  return {
    err: {
      code: code,
      msg: message,
      line: lineNumber.line || lineNumber,
      col: lineNumber.col
    }
  };
}

function validateAttrName(attrName) {
  return util$1.isName(attrName);
} // const startsWithXML = /^xml/i;


function validateTagName(tagname) {
  return util$1.isName(tagname)
  /* && !tagname.match(startsWithXML) */
  ;
} //this function returns the line number for the character at the given index


function getLineNumberForPosition(xmlData, index) {
  var lines = xmlData.substring(0, index).split(/\r?\n/);
  return {
    line: lines.length,
    // column number is last line's length + 1, because column numbering starts at 1:
    col: lines[lines.length - 1].length + 1
  };
} //this function returns the position of the first character of match within attrStr


function getPositionFromMatch(match) {
  return match.startIndex + match[1].length;
}

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck$4;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass$2;

var OptionsBuilder = {};

var defaultOptions$1 = {
  preserveOrder: false,
  attributeNamePrefix: '@_',
  attributesGroupName: false,
  textNodeName: '#text',
  ignoreAttributes: true,
  removeNSPrefix: false,
  // remove NS from tag name or attribute name if true
  allowBooleanAttributes: false,
  //a tag can have attributes without any value
  //ignoreRootElement : false,
  parseTagValue: true,
  parseAttributeValue: false,
  trimValues: true,
  //Trim string values of tag and attributes
  cdataPropName: false,
  numberParseOptions: {
    hex: true,
    leadingZeros: true
  },
  tagValueProcessor: function tagValueProcessor(tagName, val) {
    return val;
  },
  attributeValueProcessor: function attributeValueProcessor(attrName, val) {
    return val;
  },
  stopNodes: [],
  //nested tags will not be parsed even for errors
  alwaysCreateTextNode: false,
  isArray: function isArray() {
    return false;
  },
  commentPropName: false,
  unpairedTags: [],
  processEntities: true,
  htmlEntities: false,
  ignoreDeclaration: false,
  ignorePiTags: false,
  transformTagName: false,
  transformAttributeName: false
};

var buildOptions$1 = function buildOptions(options) {
  return Object.assign({}, defaultOptions$1, options);
};

OptionsBuilder.buildOptions = buildOptions$1;
OptionsBuilder.defaultOptions = defaultOptions$1;

function _defineProperty$9(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty$9;

var _defineProperty$8 = defineProperty;

var _classCallCheck$3 = classCallCheck;

var _createClass$1 = createClass;

var XmlNode = /*#__PURE__*/function () {
  function XmlNode(tagname) {
    _classCallCheck$3(this, XmlNode);

    this.tagname = tagname;
    this.child = []; //nested tags, text, cdata, comments in order

    this[":@"] = {}; //attributes map
  }

  _createClass$1(XmlNode, [{
    key: "add",
    value: function add(key, val) {
      // this.child.push( {name : key, val: val, isCdata: isCdata });
      this.child.push(_defineProperty$8({}, key, val));
    }
  }, {
    key: "addChild",
    value: function addChild(node) {
      if (node[":@"] && Object.keys(node[":@"]).length > 0) {
        var _this$child$push2;

        this.child.push((_this$child$push2 = {}, _defineProperty$8(_this$child$push2, node.tagname, node.child), _defineProperty$8(_this$child$push2, ":@", node[":@"]), _this$child$push2));
      } else {
        this.child.push(_defineProperty$8({}, node.tagname, node.child));
      }
    }
  }]);

  return XmlNode;
}();
var xmlNode$1 = XmlNode;

//TODO: handle comments
function readDocType$1(xmlData, i) {
  var entities = {};

  if (xmlData[i + 3] === 'O' && xmlData[i + 4] === 'C' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'Y' && xmlData[i + 7] === 'P' && xmlData[i + 8] === 'E') {
    i = i + 9;
    var angleBracketsCount = 1;
    var hasBody = false,
        entity = false,
        comment = false;
    var exp = "";

    for (; i < xmlData.length; i++) {
      if (xmlData[i] === '<') {
        if (hasBody && xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'N' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'I' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'Y') {
          i += 7;
          entity = true;
        } else if (hasBody && xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'L' && xmlData[i + 4] === 'E' && xmlData[i + 5] === 'M' && xmlData[i + 6] === 'E' && xmlData[i + 7] === 'N' && xmlData[i + 8] === 'T') {
          //Not supported
          i += 8;
        } else if (hasBody && xmlData[i + 1] === '!' && xmlData[i + 2] === 'A' && xmlData[i + 3] === 'T' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'L' && xmlData[i + 6] === 'I' && xmlData[i + 7] === 'S' && xmlData[i + 8] === 'T') {
          //Not supported
          i += 8;
        } else if (hasBody && xmlData[i + 1] === '!' && xmlData[i + 2] === 'N' && xmlData[i + 3] === 'O' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'A' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'I' && xmlData[i + 8] === 'O' && xmlData[i + 9] === 'N') {
          //Not supported
          i += 9;
        } else if ( //comment
        xmlData[i + 1] === '!' && xmlData[i + 2] === '-' && xmlData[i + 3] === '-') {
          comment = true;
        } else {
          throw new Error("Invalid DOCTYPE");
        }

        angleBracketsCount++;
        exp = "";
      } else if (xmlData[i] === '>') {
        if (comment) {
          if (xmlData[i - 1] === "-" && xmlData[i - 2] === "-") {
            comment = false;
          } else {
            throw new Error("Invalid XML comment in DOCTYPE");
          }
        } else if (entity) {
          parseEntityExp(exp, entities);
          entity = false;
        }

        angleBracketsCount--;

        if (angleBracketsCount === 0) {
          break;
        }
      } else if (xmlData[i] === '[') {
        hasBody = true;
      } else {
        exp += xmlData[i];
      }
    }

    if (angleBracketsCount !== 0) {
      throw new Error("Unclosed DOCTYPE");
    }
  } else {
    throw new Error("Invalid Tag instead of DOCTYPE");
  }

  return {
    entities: entities,
    i: i
  };
}

var entityRegex = RegExp("^\\s([a-zA-z0-0]+)[ \t](['\"])([^&]+)\\2");

function parseEntityExp(exp, entities) {
  var match = entityRegex.exec(exp);

  if (match) {
    entities[match[1]] = {
      regx: RegExp("&".concat(match[1], ";"), "g"),
      val: match[3]
    };
  }
}

var DocTypeReader = readDocType$1;

var hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
var numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/; // const octRegex = /0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;
//polyfill

if (!Number.parseInt && window.parseInt) {
  Number.parseInt = window.parseInt;
}

if (!Number.parseFloat && window.parseFloat) {
  Number.parseFloat = window.parseFloat;
}

var consider = {
  hex: true,
  leadingZeros: true,
  decimalPoint: "\.",
  eNotation: true //skipLike: /regex/

};

function toNumber$1(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // const options = Object.assign({}, consider);
  // if(opt.leadingZeros === false){
  //     options.leadingZeros = false;
  // }else if(opt.hex === false){
  //     options.hex = false;
  // }
  options = Object.assign({}, consider, options);
  if (!str || typeof str !== "string") return str;
  var trimmedStr = str.trim(); // if(trimmedStr === "0.0") return 0;
  // else if(trimmedStr === "+0.0") return 0;
  // else if(trimmedStr === "-0.0") return -0;

  if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;else if (options.hex && hexRegex.test(trimmedStr)) {
    return Number.parseInt(trimmedStr, 16); // } else if (options.parseOct && octRegex.test(str)) {
    //     return Number.parseInt(val, 8);
    // }else if (options.parseBin && binRegex.test(str)) {
    //     return Number.parseInt(val, 2);
  } else {
    //separate negative sign, leading zeros, and rest number
    var match = numRegex.exec(trimmedStr);

    if (match) {
      var sign = match[1];
      var leadingZeros = match[2];
      var numTrimmedByZeros = trimZeros(match[3]); //complete num without leading zeros
      //trim ending zeros for floating number

      var eNotation = match[4] || match[6];
      if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
      else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
      else {
        //no leading zeros or leading zeros are allowed
        var num = Number(trimmedStr);
        var numStr = "" + num;

        if (numStr.search(/[eE]/) !== -1) {
          //given number is long and parsed to eNotation
          if (options.eNotation) return num;else return str;
        } else if (eNotation) {
          //given number has enotation
          if (options.eNotation) return num;else return str;
        } else if (trimmedStr.indexOf(".") !== -1) {
          //floating number
          // const decimalPart = match[5].substr(1);
          // const intPart = trimmedStr.substr(0,trimmedStr.indexOf("."));
          // const p = numStr.indexOf(".");
          // const givenIntPart = numStr.substr(0,p);
          // const givenDecPart = numStr.substr(p+1);
          if (numStr === "0" && numTrimmedByZeros === "") return num; //0.0
          else if (numStr === numTrimmedByZeros) return num; //0.456. 0.79000
          else if (sign && numStr === "-" + numTrimmedByZeros) return num;else return str;
        }

        if (leadingZeros) {
          // if(numTrimmedByZeros === numStr){
          //     if(options.leadingZeros) return num;
          //     else return str;
          // }else return str;
          if (numTrimmedByZeros === numStr) return num;else if (sign + numTrimmedByZeros === numStr) return num;else return str;
        }

        if (trimmedStr === numStr) return num;else if (trimmedStr === sign + numStr) return num; // else{
        //     //number with +/- sign
        //     trimmedStr.test(/[-+][0-9]);
        // }

        return str;
      } // else if(!eNotation && trimmedStr && trimmedStr !== Number(trimmedStr) ) return str;
    } else {
      //non-numeric string
      return str;
    }
  }
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */


function trimZeros(numStr) {
  if (numStr && numStr.indexOf(".") !== -1) {
    //float
    numStr = numStr.replace(/0+$/, ""); //remove ending zeros

    if (numStr === ".") numStr = "0";else if (numStr[0] === ".") numStr = "0" + numStr;else if (numStr[numStr.length - 1] === ".") numStr = numStr.substr(0, numStr.length - 1);
    return numStr;
  }

  return numStr;
}

var strnum = toNumber$1;

var _defineProperty$7 = defineProperty;

var _classCallCheck$2 = classCallCheck;

var util = util$2;

var xmlNode = xmlNode$1;

var readDocType = DocTypeReader;

var toNumber = strnum;

'<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'.replace(/NAME/g, util.nameRegexp); //const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");

var OrderedObjParser$1 = function OrderedObjParser(options) {
  _classCallCheck$2(this, OrderedObjParser);

  this.options = options;
  this.currentNode = null;
  this.tagsNodeStack = [];
  this.docTypeEntities = {};
  this.lastEntities = {
    "apos": {
      regex: /&(apos|#39|#x27);/g,
      val: "'"
    },
    "gt": {
      regex: /&(gt|#62|#x3E);/g,
      val: ">"
    },
    "lt": {
      regex: /&(lt|#60|#x3C);/g,
      val: "<"
    },
    "quot": {
      regex: /&(quot|#34|#x22);/g,
      val: "\""
    }
  };
  this.ampEntity = {
    regex: /&(amp|#38|#x26);/g,
    val: "&"
  };
  this.htmlEntities = {
    "space": {
      regex: /&(nbsp|#160);/g,
      val: " "
    },
    // "lt" : { regex: /&(lt|#60);/g, val: "<" },
    // "gt" : { regex: /&(gt|#62);/g, val: ">" },
    // "amp" : { regex: /&(amp|#38);/g, val: "&" },
    // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
    // "apos" : { regex: /&(apos|#39);/g, val: "'" },
    "cent": {
      regex: /&(cent|#162);/g,
      val: "¢"
    },
    "pound": {
      regex: /&(pound|#163);/g,
      val: "£"
    },
    "yen": {
      regex: /&(yen|#165);/g,
      val: "¥"
    },
    "euro": {
      regex: /&(euro|#8364);/g,
      val: "€"
    },
    "copyright": {
      regex: /&(copy|#169);/g,
      val: "©"
    },
    "reg": {
      regex: /&(reg|#174);/g,
      val: "®"
    },
    "inr": {
      regex: /&(inr|#8377);/g,
      val: "₹"
    }
  };
  this.addExternalEntities = addExternalEntities;
  this.parseXml = parseXml;
  this.parseTextData = parseTextData;
  this.resolveNameSpace = resolveNameSpace;
  this.buildAttributesMap = buildAttributesMap;
  this.isItStopNode = isItStopNode;
  this.replaceEntitiesValue = replaceEntitiesValue$2;
  this.readStopNodeData = readStopNodeData;
  this.saveTextToParentTag = saveTextToParentTag;
};

function addExternalEntities(externalEntities) {
  var entKeys = Object.keys(externalEntities);

  for (var i = 0; i < entKeys.length; i++) {
    var ent = entKeys[i];
    this.lastEntities[ent] = {
      regex: new RegExp("&" + ent + ";", "g"),
      val: externalEntities[ent]
    };
  }
}
/**
 * @param {string} val
 * @param {string} tagName
 * @param {string} jPath
 * @param {boolean} dontTrim
 * @param {boolean} hasAttributes
 * @param {boolean} isLeafNode
 * @param {boolean} escapeEntities
 */


function parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
  if (val !== undefined) {
    if (this.options.trimValues && !dontTrim) {
      val = val.trim();
    }

    if (val.length > 0) {
      if (!escapeEntities) val = this.replaceEntitiesValue(val);
      var newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);

      if (newval === null || newval === undefined) {
        //don't parse
        return val;
      } else if (typeof newval !== typeof val || newval !== val) {
        //overwrite
        return newval;
      } else if (this.options.trimValues) {
        return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
      } else {
        var trimmedVal = val.trim();

        if (trimmedVal === val) {
          return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
        } else {
          return val;
        }
      }
    }
  }
}

function resolveNameSpace(tagname) {
  if (this.options.removeNSPrefix) {
    var tags = tagname.split(':');
    var prefix = tagname.charAt(0) === '/' ? '/' : '';

    if (tags[0] === 'xmlns') {
      return '';
    }

    if (tags.length === 2) {
      tagname = prefix + tags[1];
    }
  }

  return tagname;
} //TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");


var attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');

function buildAttributesMap(attrStr, jPath) {
  if (!this.options.ignoreAttributes && typeof attrStr === 'string') {
    // attrStr = attrStr.replace(/\r?\n/g, ' ');
    //attrStr = attrStr || attrStr.trim();
    var matches = util.getAllMatches(attrStr, attrsRegx);
    var len = matches.length; //don't make it inline

    var attrs = {};

    for (var i = 0; i < len; i++) {
      var attrName = this.resolveNameSpace(matches[i][1]);
      var oldVal = matches[i][4];
      var aName = this.options.attributeNamePrefix + attrName;

      if (attrName.length) {
        if (this.options.transformAttributeName) {
          aName = this.options.transformAttributeName(aName);
        }

        if (oldVal !== undefined) {
          if (this.options.trimValues) {
            oldVal = oldVal.trim();
          }

          oldVal = this.replaceEntitiesValue(oldVal);
          var newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);

          if (newVal === null || newVal === undefined) {
            //don't parse
            attrs[aName] = oldVal;
          } else if (typeof newVal !== typeof oldVal || newVal !== oldVal) {
            //overwrite
            attrs[aName] = newVal;
          } else {
            //parse
            attrs[aName] = parseValue(oldVal, this.options.parseAttributeValue, this.options.numberParseOptions);
          }
        } else if (this.options.allowBooleanAttributes) {
          attrs[aName] = true;
        }
      }
    }

    if (!Object.keys(attrs).length) {
      return;
    }

    if (this.options.attributesGroupName) {
      var attrCollection = {};
      attrCollection[this.options.attributesGroupName] = attrs;
      return attrCollection;
    }

    return attrs;
  }
}

var parseXml = function parseXml(xmlData) {
  xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line

  var xmlObj = new xmlNode('!xml');
  var currentNode = xmlObj;
  var textData = "";
  var jPath = "";

  for (var i = 0; i < xmlData.length; i++) {
    //for each char in XML data
    var ch = xmlData[i];

    if (ch === '<') {
      // const nextIndex = i+1;
      // const _2ndChar = xmlData[nextIndex];
      if (xmlData[i + 1] === '/') {
        //Closing Tag
        var closeIndex = findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
        var tagName = xmlData.substring(i + 2, closeIndex).trim();

        if (this.options.removeNSPrefix) {
          var colonIndex = tagName.indexOf(":");

          if (colonIndex !== -1) {
            tagName = tagName.substr(colonIndex + 1);
          }
        }

        if (this.options.transformTagName) {
          tagName = this.options.transformTagName(tagName);
        }

        if (currentNode) {
          textData = this.saveTextToParentTag(textData, currentNode, jPath);
        }

        jPath = jPath.substr(0, jPath.lastIndexOf("."));
        currentNode = this.tagsNodeStack.pop(); //avoid recurssion, set the parent tag scope

        textData = "";
        i = closeIndex;
      } else if (xmlData[i + 1] === '?') {
        var tagData = readTagExp(xmlData, i, false, "?>");
        if (!tagData) throw new Error("Pi Tag is not closed.");
        textData = this.saveTextToParentTag(textData, currentNode, jPath);

        if (this.options.ignoreDeclaration && tagData.tagName === "?xml" || this.options.ignorePiTags) ; else {
          var childNode = new xmlNode(tagData.tagName);
          childNode.add(this.options.textNodeName, "");

          if (tagData.tagName !== tagData.tagExp && tagData.attrExpPresent) {
            childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath);
          }

          currentNode.addChild(childNode);
        }

        i = tagData.closeIndex + 1;
      } else if (xmlData.substr(i + 1, 3) === '!--') {
        var endIndex = findClosingIndex(xmlData, "-->", i + 4, "Comment is not closed.");

        if (this.options.commentPropName) {
          var comment = xmlData.substring(i + 4, endIndex - 2);
          textData = this.saveTextToParentTag(textData, currentNode, jPath);
          currentNode.add(this.options.commentPropName, [_defineProperty$7({}, this.options.textNodeName, comment)]);
        }

        i = endIndex;
      } else if (xmlData.substr(i + 1, 2) === '!D') {
        var result = readDocType(xmlData, i);
        this.docTypeEntities = result.entities;
        i = result.i;
      } else if (xmlData.substr(i + 1, 2) === '![') {
        var _closeIndex = findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;

        var tagExp = xmlData.substring(i + 9, _closeIndex);
        textData = this.saveTextToParentTag(textData, currentNode, jPath); //cdata should be set even if it is 0 length string

        if (this.options.cdataPropName) {
          // let val = this.parseTextData(tagExp, this.options.cdataPropName, jPath + "." + this.options.cdataPropName, true, false, true);
          // if(!val) val = "";
          currentNode.add(this.options.cdataPropName, [_defineProperty$7({}, this.options.textNodeName, tagExp)]);
        } else {
          var val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true);
          if (val == undefined) val = "";
          currentNode.add(this.options.textNodeName, val);
        }

        i = _closeIndex + 2;
      } else {
        //Opening tag
        var _result = readTagExp(xmlData, i, this.options.removeNSPrefix);

        var _tagName = _result.tagName;
        var _tagExp = _result.tagExp;
        var attrExpPresent = _result.attrExpPresent;
        var _closeIndex2 = _result.closeIndex;

        if (this.options.transformTagName) {
          _tagName = this.options.transformTagName(_tagName);
        } //save text as child node


        if (currentNode && textData) {
          if (currentNode.tagname !== '!xml') {
            //when nested tag is found
            textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
          }
        }

        if (_tagName !== xmlObj.tagname) {
          jPath += jPath ? "." + _tagName : _tagName;
        } //check if last tag was unpaired tag


        var lastTag = currentNode;

        if (lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1) {
          currentNode = this.tagsNodeStack.pop();
        }

        if (this.isItStopNode(this.options.stopNodes, jPath, _tagName)) {
          //TODO: namespace
          var tagContent = ""; //self-closing tag

          if (_tagExp.length > 0 && _tagExp.lastIndexOf("/") === _tagExp.length - 1) {
            i = _result.closeIndex;
          } //boolean tag
          else if (this.options.unpairedTags.indexOf(_tagName) !== -1) {
            i = _result.closeIndex;
          } //normal tag
          else {
            //read until closing tag is found
            var _result2 = this.readStopNodeData(xmlData, _tagName, _closeIndex2 + 1);

            if (!_result2) throw new Error("Unexpected end of ".concat(_tagName));
            i = _result2.i;
            tagContent = _result2.tagContent;
          }

          var _childNode = new xmlNode(_tagName);

          if (_tagName !== _tagExp && attrExpPresent) {
            _childNode[":@"] = this.buildAttributesMap(_tagExp, jPath);
          }

          if (tagContent) {
            tagContent = this.parseTextData(tagContent, _tagName, jPath, true, attrExpPresent, true, true);
          }

          jPath = jPath.substr(0, jPath.lastIndexOf("."));

          _childNode.add(this.options.textNodeName, tagContent);

          currentNode.addChild(_childNode);
        } else {
          //selfClosing tag
          if (_tagExp.length > 0 && _tagExp.lastIndexOf("/") === _tagExp.length - 1) {
            if (_tagName[_tagName.length - 1] === "/") {
              //remove trailing '/'
              _tagName = _tagName.substr(0, _tagName.length - 1);
              _tagExp = _tagName;
            } else {
              _tagExp = _tagExp.substr(0, _tagExp.length - 1);
            }

            if (this.options.transformTagName) {
              _tagName = this.options.transformTagName(_tagName);
            }

            var _childNode2 = new xmlNode(_tagName);

            if (_tagName !== _tagExp && attrExpPresent) {
              _childNode2[":@"] = this.buildAttributesMap(_tagExp, jPath);
            }

            jPath = jPath.substr(0, jPath.lastIndexOf("."));
            currentNode.addChild(_childNode2);
          } //opening tag
          else {
            var _childNode3 = new xmlNode(_tagName);

            this.tagsNodeStack.push(currentNode);

            if (_tagName !== _tagExp && attrExpPresent) {
              _childNode3[":@"] = this.buildAttributesMap(_tagExp, jPath);
            }

            currentNode.addChild(_childNode3);
            currentNode = _childNode3;
          }

          textData = "";
          i = _closeIndex2;
        }
      }
    } else {
      textData += xmlData[i];
    }
  }

  return xmlObj.child;
};

var replaceEntitiesValue$2 = function replaceEntitiesValue(val) {
  if (this.options.processEntities) {
    for (var entityName in this.docTypeEntities) {
      var entity = this.docTypeEntities[entityName];
      val = val.replace(entity.regx, entity.val);
    }

    for (var _entityName in this.lastEntities) {
      var _entity = this.lastEntities[_entityName];
      val = val.replace(_entity.regex, _entity.val);
    }

    if (this.options.htmlEntities) {
      for (var _entityName2 in this.htmlEntities) {
        var _entity2 = this.htmlEntities[_entityName2];
        val = val.replace(_entity2.regex, _entity2.val);
      }
    }

    val = val.replace(this.ampEntity.regex, this.ampEntity.val);
  }

  return val;
};

function saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
  if (textData) {
    //store previously collected data as textNode
    if (isLeafNode === undefined) isLeafNode = Object.keys(currentNode.child).length === 0;
    textData = this.parseTextData(textData, currentNode.tagname, jPath, false, currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false, isLeafNode);
    if (textData !== undefined && textData !== "") currentNode.add(this.options.textNodeName, textData);
    textData = "";
  }

  return textData;
} //TODO: use jPath to simplify the logic

/**
 * 
 * @param {string[]} stopNodes 
 * @param {string} jPath
 * @param {string} currentTagName 
 */


function isItStopNode(stopNodes, jPath, currentTagName) {
  var allNodesExp = "*." + currentTagName;

  for (var stopNodePath in stopNodes) {
    var stopNodeExp = stopNodes[stopNodePath];
    if (allNodesExp === stopNodeExp || jPath === stopNodeExp) return true;
  }

  return false;
}
/**
 * Returns the tag Expression and where it is ending handling single-dobule quotes situation
 * @param {string} xmlData 
 * @param {number} i starting index
 * @returns 
 */


function tagExpWithClosingIndex(xmlData, i) {
  var closingChar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ">";
  var attrBoundary;
  var tagExp = "";

  for (var index = i; index < xmlData.length; index++) {
    var ch = xmlData[index];

    if (attrBoundary) {
      if (ch === attrBoundary) attrBoundary = ""; //reset
    } else if (ch === '"' || ch === "'") {
      attrBoundary = ch;
    } else if (ch === closingChar[0]) {
      if (closingChar[1]) {
        if (xmlData[index + 1] === closingChar[1]) {
          return {
            data: tagExp,
            index: index
          };
        }
      } else {
        return {
          data: tagExp,
          index: index
        };
      }
    } else if (ch === '\t') {
      ch = " ";
    }

    tagExp += ch;
  }
}

function findClosingIndex(xmlData, str, i, errMsg) {
  var closingIndex = xmlData.indexOf(str, i);

  if (closingIndex === -1) {
    throw new Error(errMsg);
  } else {
    return closingIndex + str.length - 1;
  }
}

function readTagExp(xmlData, i, removeNSPrefix) {
  var closingChar = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ">";
  var result = tagExpWithClosingIndex(xmlData, i + 1, closingChar);
  if (!result) return;
  var tagExp = result.data;
  var closeIndex = result.index;
  var separatorIndex = tagExp.search(/\s/);
  var tagName = tagExp;
  var attrExpPresent = true;

  if (separatorIndex !== -1) {
    //separate tag name and attributes expression
    tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, '');
    tagExp = tagExp.substr(separatorIndex + 1);
  }

  if (removeNSPrefix) {
    var colonIndex = tagName.indexOf(":");

    if (colonIndex !== -1) {
      tagName = tagName.substr(colonIndex + 1);
      attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
    }
  }

  return {
    tagName: tagName,
    tagExp: tagExp,
    closeIndex: closeIndex,
    attrExpPresent: attrExpPresent
  };
}
/**
 * find paired tag for a stop node
 * @param {string} xmlData 
 * @param {string} tagName 
 * @param {number} i 
 */


function readStopNodeData(xmlData, tagName, i) {
  var startIndex = i; // Starting at 1 since we already have an open tag

  var openTagCount = 1;

  for (; i < xmlData.length; i++) {
    if (xmlData[i] === "<") {
      if (xmlData[i + 1] === "/") {
        //close tag
        var closeIndex = findClosingIndex(xmlData, ">", i, "".concat(tagName, " is not closed"));
        var closeTagName = xmlData.substring(i + 2, closeIndex).trim();

        if (closeTagName === tagName) {
          openTagCount--;

          if (openTagCount === 0) {
            return {
              tagContent: xmlData.substring(startIndex, i),
              i: closeIndex
            };
          }
        }

        i = closeIndex;
      } else if (xmlData[i + 1] === '?') {
        var _closeIndex3 = findClosingIndex(xmlData, "?>", i + 1, "StopNode is not closed.");

        i = _closeIndex3;
      } else if (xmlData.substr(i + 1, 3) === '!--') {
        var _closeIndex4 = findClosingIndex(xmlData, "-->", i + 3, "StopNode is not closed.");

        i = _closeIndex4;
      } else if (xmlData.substr(i + 1, 2) === '![') {
        var _closeIndex5 = findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;

        i = _closeIndex5;
      } else {
        var tagData = readTagExp(xmlData, i, '>');

        if (tagData) {
          var openTagName = tagData && tagData.tagName;

          if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length - 1] !== "/") {
            openTagCount++;
          }

          i = tagData.closeIndex;
        }
      }
    }
  } //end for loop

}

function parseValue(val, shouldParse, options) {
  if (shouldParse && typeof val === 'string') {
    //console.log(options)
    var newval = val.trim();
    if (newval === 'true') return true;else if (newval === 'false') return false;else return toNumber(val, options);
  } else {
    if (util.isExist(val)) {
      return val;
    } else {
      return '';
    }
  }
}

var OrderedObjParser_1 = OrderedObjParser$1;

var node2json = {};

/**
 * 
 * @param {array} node 
 * @param {any} options 
 * @returns 
 */

function prettify$1(node, options) {
  return compress(node, options);
}
/**
 * 
 * @param {array} arr 
 * @param {object} options 
 * @param {string} jPath 
 * @returns object
 */


function compress(arr, options, jPath) {
  var text;
  var compressedObj = {};

  for (var i = 0; i < arr.length; i++) {
    var tagObj = arr[i];
    var property = propName$1(tagObj);
    var newJpath = "";
    if (jPath === undefined) newJpath = property;else newJpath = jPath + "." + property;

    if (property === options.textNodeName) {
      if (text === undefined) text = tagObj[property];else text += "" + tagObj[property];
    } else if (property === undefined) {
      continue;
    } else if (tagObj[property]) {
      var val = compress(tagObj[property], options, newJpath);
      var isLeaf = isLeafTag(val, options);

      if (tagObj[":@"]) {
        assignAttributes(val, tagObj[":@"], newJpath, options);
      } else if (Object.keys(val).length === 1 && val[options.textNodeName] !== undefined && !options.alwaysCreateTextNode) {
        val = val[options.textNodeName];
      } else if (Object.keys(val).length === 0) {
        if (options.alwaysCreateTextNode) val[options.textNodeName] = "";else val = "";
      }

      if (compressedObj[property] !== undefined && compressedObj.hasOwnProperty(property)) {
        if (!Array.isArray(compressedObj[property])) {
          compressedObj[property] = [compressedObj[property]];
        }

        compressedObj[property].push(val);
      } else {
        //TODO: if a node is not an array, then check if it should be an array
        //also determine if it is a leaf node
        if (options.isArray(property, newJpath, isLeaf)) {
          compressedObj[property] = [val];
        } else {
          compressedObj[property] = val;
        }
      }
    }
  } // if(text && text.length > 0) compressedObj[options.textNodeName] = text;


  if (typeof text === "string") {
    if (text.length > 0) compressedObj[options.textNodeName] = text;
  } else if (text !== undefined) compressedObj[options.textNodeName] = text;

  return compressedObj;
}

function propName$1(obj) {
  var keys = Object.keys(obj);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key !== ":@") return key;
  }
}

function assignAttributes(obj, attrMap, jpath, options) {
  if (attrMap) {
    var keys = Object.keys(attrMap);
    var len = keys.length; //don't make it inline

    for (var i = 0; i < len; i++) {
      var atrrName = keys[i];

      if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) {
        obj[atrrName] = [attrMap[atrrName]];
      } else {
        obj[atrrName] = attrMap[atrrName];
      }
    }
  }
}

function isLeafTag(obj, options) {
  var propCount = Object.keys(obj).length;
  if (propCount === 0 || propCount === 1 && obj[options.textNodeName]) return true;
  return false;
}

node2json.prettify = prettify$1;

var _classCallCheck$1 = classCallCheck;

var _createClass = createClass;

var _require = OptionsBuilder,
    buildOptions = _require.buildOptions;

var OrderedObjParser = OrderedObjParser_1;

var _require2 = node2json,
    prettify = _require2.prettify;

var validator$3 = validator$4;

var XMLParser$1 = /*#__PURE__*/function () {

  function XMLParser(options) {
    _classCallCheck$1(this, XMLParser);

    this.externalEntities = {};
    this.options = buildOptions(options);
  }
  /**
   * Parse XML dats to JS object 
   * @param {string|Buffer} xmlData 
   * @param {boolean|Object} validationOption 
   */


  _createClass(XMLParser, [{
    key: "parse",
    value: function parse(xmlData, validationOption) {
      if (typeof xmlData === "string") ; else if (xmlData.toString) {
        xmlData = xmlData.toString();
      } else {
        throw new Error("XML data is accepted in String or Bytes[] form.");
      }

      if (validationOption) {
        if (validationOption === true) validationOption = {}; //validate with default options

        var result = validator$3.validate(xmlData, validationOption);

        if (result !== true) {
          throw Error("".concat(result.err.msg, ":").concat(result.err.line, ":").concat(result.err.col));
        }
      }

      var orderedObjParser = new OrderedObjParser(this.options);
      orderedObjParser.addExternalEntities(this.externalEntities);
      var orderedResult = orderedObjParser.parseXml(xmlData);
      if (this.options.preserveOrder || orderedResult === undefined) return orderedResult;else return prettify(orderedResult, this.options);
    }
    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */

  }, {
    key: "addEntity",
    value: function addEntity(key, value) {
      if (value.indexOf("&") !== -1) {
        throw new Error("Entity value can't have '&'");
      } else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) {
        throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
      } else if (value === "&") {
        throw new Error("An entity with value '&' is not permitted");
      } else {
        this.externalEntities[key] = value;
      }
    }
  }]);

  return XMLParser;
}();

var XMLParser_1 = XMLParser$1;

var EOL = "\n";
/**
 * 
 * @param {array} jArray 
 * @param {any} options 
 * @returns 
 */

function toXml(jArray, options) {
  var indentation = "";

  if (options.format && options.indentBy.length > 0) {
    indentation = EOL;
  }

  return arrToStr(jArray, options, "", indentation);
}

function arrToStr(arr, options, jPath, indentation) {
  var xmlStr = "";
  var isPreviousElementTag = false;

  for (var i = 0; i < arr.length; i++) {
    var tagObj = arr[i];
    var tagName = propName(tagObj);
    var newJPath = "";
    if (jPath.length === 0) newJPath = tagName;else newJPath = "".concat(jPath, ".").concat(tagName);

    if (tagName === options.textNodeName) {
      var tagText = tagObj[tagName];

      if (!isStopNode(newJPath, options)) {
        tagText = options.tagValueProcessor(tagName, tagText);
        tagText = replaceEntitiesValue$1(tagText, options);
      }

      if (isPreviousElementTag) {
        xmlStr += indentation;
      }

      xmlStr += tagText;
      isPreviousElementTag = false;
      continue;
    } else if (tagName === options.cdataPropName) {
      if (isPreviousElementTag) {
        xmlStr += indentation;
      }

      xmlStr += "<![CDATA[".concat(tagObj[tagName][0][options.textNodeName], "]]>");
      isPreviousElementTag = false;
      continue;
    } else if (tagName === options.commentPropName) {
      xmlStr += indentation + "<!--".concat(tagObj[tagName][0][options.textNodeName], "-->");
      isPreviousElementTag = true;
      continue;
    } else if (tagName[0] === "?") {
      var _attStr = attr_to_str(tagObj[":@"], options);

      var tempInd = tagName === "?xml" ? "" : indentation;
      var piTextNodeName = tagObj[tagName][0][options.textNodeName];
      piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : ""; //remove extra spacing

      xmlStr += tempInd + "<".concat(tagName).concat(piTextNodeName).concat(_attStr, "?>");
      isPreviousElementTag = true;
      continue;
    }

    var newIdentation = indentation;

    if (newIdentation !== "") {
      newIdentation += options.indentBy;
    }

    var attStr = attr_to_str(tagObj[":@"], options);
    var tagStart = indentation + "<".concat(tagName).concat(attStr);
    var tagValue = arrToStr(tagObj[tagName], options, newJPath, newIdentation);

    if (options.unpairedTags.indexOf(tagName) !== -1) {
      if (options.suppressUnpairedNode) xmlStr += tagStart + ">";else xmlStr += tagStart + "/>";
    } else if ((!tagValue || tagValue.length === 0) && options.suppressEmptyNode) {
      xmlStr += tagStart + "/>";
    } else if (tagValue && tagValue.endsWith(">")) {
      xmlStr += tagStart + ">".concat(tagValue).concat(indentation, "</").concat(tagName, ">");
    } else {
      xmlStr += tagStart + ">";

      if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) {
        xmlStr += indentation + options.indentBy + tagValue + indentation;
      } else {
        xmlStr += tagValue;
      }

      xmlStr += "</".concat(tagName, ">");
    }

    isPreviousElementTag = true;
  }

  return xmlStr;
}

function propName(obj) {
  var keys = Object.keys(obj);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key !== ":@") return key;
  }
}

function attr_to_str(attrMap, options) {
  var attrStr = "";

  if (attrMap && !options.ignoreAttributes) {
    for (var attr in attrMap) {
      var attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
      attrVal = replaceEntitiesValue$1(attrVal, options);

      if (attrVal === true && options.suppressBooleanAttributes) {
        attrStr += " ".concat(attr.substr(options.attributeNamePrefix.length));
      } else {
        attrStr += " ".concat(attr.substr(options.attributeNamePrefix.length), "=\"").concat(attrVal, "\"");
      }
    }
  }

  return attrStr;
}

function isStopNode(jPath, options) {
  jPath = jPath.substr(0, jPath.length - options.textNodeName.length - 1);
  var tagName = jPath.substr(jPath.lastIndexOf(".") + 1);

  for (var index in options.stopNodes) {
    if (options.stopNodes[index] === jPath || options.stopNodes[index] === "*." + tagName) return true;
  }

  return false;
}

function replaceEntitiesValue$1(textValue, options) {
  if (textValue && textValue.length > 0 && options.processEntities) {
    for (var i = 0; i < options.entities.length; i++) {
      var entity = options.entities[i];
      textValue = textValue.replace(entity.regex, entity.val);
    }
  }

  return textValue;
}

var orderedJs2Xml = toXml;

var _defineProperty$6 = defineProperty;

var buildFromOrderedJs = orderedJs2Xml;

var defaultOptions = {
  attributeNamePrefix: '@_',
  attributesGroupName: false,
  textNodeName: '#text',
  ignoreAttributes: true,
  cdataPropName: false,
  format: false,
  indentBy: '  ',
  suppressEmptyNode: false,
  suppressUnpairedNode: true,
  suppressBooleanAttributes: true,
  tagValueProcessor: function tagValueProcessor(key, a) {
    return a;
  },
  attributeValueProcessor: function attributeValueProcessor(attrName, a) {
    return a;
  },
  preserveOrder: false,
  commentPropName: false,
  unpairedTags: [],
  entities: [{
    regex: new RegExp("&", "g"),
    val: "&amp;"
  }, //it must be on top
  {
    regex: new RegExp(">", "g"),
    val: "&gt;"
  }, {
    regex: new RegExp("<", "g"),
    val: "&lt;"
  }, {
    regex: new RegExp("\'", "g"),
    val: "&apos;"
  }, {
    regex: new RegExp("\"", "g"),
    val: "&quot;"
  }],
  processEntities: true,
  stopNodes: [] // transformTagName: false,
  // transformAttributeName: false,

};

function Builder(options) {
  this.options = Object.assign({}, defaultOptions, options);

  if (this.options.ignoreAttributes || this.options.attributesGroupName) {
    this.isAttribute = function
      /*a*/
    () {
      return false;
    };
  } else {
    this.attrPrefixLen = this.options.attributeNamePrefix.length;
    this.isAttribute = isAttribute;
  }

  this.processTextOrObjNode = processTextOrObjNode;

  if (this.options.format) {
    this.indentate = indentate;
    this.tagEndChar = '>\n';
    this.newLine = '\n';
  } else {
    this.indentate = function () {
      return '';
    };

    this.tagEndChar = '>';
    this.newLine = '';
  }

  if (this.options.suppressEmptyNode) {
    this.buildTextNode = buildEmptyTextNode;
    this.buildObjNode = buildEmptyObjNode;
  } else {
    this.buildTextNode = buildTextValNode;
    this.buildObjNode = buildObjectNode;
  }

  this.buildTextValNode = buildTextValNode;
  this.buildObjectNode = buildObjectNode;
  this.replaceEntitiesValue = replaceEntitiesValue;
  this.buildAttrPairStr = buildAttrPairStr;
}

Builder.prototype.build = function (jObj) {
  if (this.options.preserveOrder) {
    return buildFromOrderedJs(jObj, this.options);
  } else {
    if (Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1) {
      jObj = _defineProperty$6({}, this.options.arrayNodeName, jObj);
    }

    return this.j2x(jObj, 0).val;
  }
};

Builder.prototype.j2x = function (jObj, level) {
  var attrStr = '';
  var val = '';

  for (var key in jObj) {
    if (typeof jObj[key] === 'undefined') ; else if (jObj[key] === null) {
      if (key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar; // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
    } else if (jObj[key] instanceof Date) {
      val += this.buildTextNode(jObj[key], key, '', level);
    } else if (typeof jObj[key] !== 'object') {
      //premitive type
      var attr = this.isAttribute(key);

      if (attr) {
        attrStr += this.buildAttrPairStr(attr, '' + jObj[key]);
      } else {
        //tag value
        if (key === this.options.textNodeName) {
          var newval = this.options.tagValueProcessor(key, '' + jObj[key]);
          val += this.replaceEntitiesValue(newval);
        } else {
          val += this.buildTextNode(jObj[key], key, '', level);
        }
      }
    } else if (Array.isArray(jObj[key])) {
      //repeated nodes
      var arrLen = jObj[key].length;

      for (var j = 0; j < arrLen; j++) {
        var item = jObj[key][j];

        if (typeof item === 'undefined') ; else if (item === null) {
          if (key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar; // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        } else if (typeof item === 'object') {
          val += this.processTextOrObjNode(item, key, level);
        } else {
          val += this.buildTextNode(item, key, '', level);
        }
      }
    } else {
      //nested node
      if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
        var Ks = Object.keys(jObj[key]);
        var L = Ks.length;

        for (var _j = 0; _j < L; _j++) {
          attrStr += this.buildAttrPairStr(Ks[_j], '' + jObj[key][Ks[_j]]);
        }
      } else {
        val += this.processTextOrObjNode(jObj[key], key, level);
      }
    }
  }

  return {
    attrStr: attrStr,
    val: val
  };
};

function buildAttrPairStr(attrName, val) {
  val = this.options.attributeValueProcessor(attrName, '' + val);
  val = this.replaceEntitiesValue(val);

  if (this.options.suppressBooleanAttributes && val === "true") {
    return ' ' + attrName;
  } else return ' ' + attrName + '="' + val + '"';
}

function processTextOrObjNode(object, key, level) {
  var result = this.j2x(object, level + 1);

  if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) {
    return this.buildTextNode(object[this.options.textNodeName], key, result.attrStr, level);
  } else {
    return this.buildObjNode(result.val, key, result.attrStr, level);
  }
}

function buildObjectNode(val, key, attrStr, level) {
  var tagEndExp = '</' + key + this.tagEndChar;
  var piClosingChar = "";

  if (key[0] === "?") {
    piClosingChar = "?";
    tagEndExp = "";
  }

  if (attrStr && val.indexOf('<') === -1) {
    return this.indentate(level) + '<' + key + attrStr + piClosingChar + '>' + val + tagEndExp;
  } else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) {
    return this.indentate(level) + "<!--".concat(val, "-->") + this.newLine;
  } else {
    return this.indentate(level) + '<' + key + attrStr + piClosingChar + this.tagEndChar + val + this.indentate(level) + tagEndExp;
  }
}

function buildEmptyObjNode(val, key, attrStr, level) {
  if (val !== '') {
    return this.buildObjectNode(val, key, attrStr, level);
  } else {
    if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
  }
}

function buildTextValNode(val, key, attrStr, level) {
  if (this.options.cdataPropName !== false && key === this.options.cdataPropName) {
    return this.indentate(level) + "<![CDATA[".concat(val, "]]>") + this.newLine;
  } else if (this.options.commentPropName !== false && key === this.options.commentPropName) {
    return this.indentate(level) + "<!--".concat(val, "-->") + this.newLine;
  } else {
    var textValue = this.options.tagValueProcessor(key, val);
    textValue = this.replaceEntitiesValue(textValue);

    if (textValue === '' && this.options.unpairedTags.indexOf(key) !== -1) {
      //unpaired
      if (this.options.suppressUnpairedNode) {
        return this.indentate(level) + '<' + key + this.tagEndChar;
      } else {
        return this.indentate(level) + '<' + key + "/" + this.tagEndChar;
      }
    } else {
      return this.indentate(level) + '<' + key + attrStr + '>' + textValue + '</' + key + this.tagEndChar;
    }
  }
}

function replaceEntitiesValue(textValue) {
  if (textValue && textValue.length > 0 && this.options.processEntities) {
    for (var i = 0; i < this.options.entities.length; i++) {
      var entity = this.options.entities[i];
      textValue = textValue.replace(entity.regex, entity.val);
    }
  }

  return textValue;
}

function buildEmptyTextNode(val, key, attrStr, level) {
  if (val === '' && this.options.unpairedTags.indexOf(key) !== -1) {
    //unpaired
    if (this.options.suppressUnpairedNode) {
      return this.indentate(level) + '<' + key + this.tagEndChar;
    } else {
      return this.indentate(level) + '<' + key + "/" + this.tagEndChar;
    }
  } else if (val !== '') {
    //empty
    return this.buildTextValNode(val, key, attrStr, level);
  } else {
    if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar; //PI tag
    else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar; //normal
  }
}

function indentate(level) {
  return this.options.indentBy.repeat(level);
}

function isAttribute(name
/*, options*/
) {
  if (name.startsWith(this.options.attributeNamePrefix)) {
    return name.substr(this.attrPrefixLen);
  } else {
    return false;
  }
}

var json2xml = Builder;

var validator$2 = validator$4;

var XMLParser = XMLParser_1;

var XMLBuilder = json2xml;

var fxp = {
  XMLParser: XMLParser,
  XMLValidator: validator$2,
  XMLBuilder: XMLBuilder
};

/**
 * Cleans up SVG string, assumes that input string is correct XML
 * - removes style, width, height
 * - changes all the stroke / fill to the currentColor (icons are unicolor)
 * @param svg
 */

function transformStrokeAndFill$1(obj) {
  for (var key in obj) {
    var val = obj[key];

    if ((key === "@_stroke" || key === "@_fill") && val !== "none" && val !== "transparent") {
      obj[key] = "currentColor";
    } else if (typeof val === "object" && val !== null) {
      transformStrokeAndFill$1(val);
    }
  }
}

function cleanupIconSVG(svgString) {
  var parser = new fxp.XMLParser({
    ignoreAttributes: false
  });
  var svg = parser.parse(svgString);

  if (Object.keys(svg).length !== 1) {
    throw new Error("input is wrong XML");
  }

  var rootKey = Object.keys(svg)[0];

  if (rootKey.toLowerCase() !== "svg") {
    throw new Error("SVG root node must be svg");
  }

  delete svg[rootKey]["@_style"];
  delete svg[rootKey]["@_width"];
  delete svg[rootKey]["@_height"];
  transformStrokeAndFill$1(svg);
  var builder = new fxp.XMLBuilder({
    ignoreAttributes: false
  });
  return builder.build(svg);
}

function $iconStyles (values) {
  return {
    IconWrapper: box({
      display: "grid",
      color: values.passed_allowColor ? values.color : "currentColor"
    }),
    __props: {
      icon: cleanupIconSVG(values.icon)
    }
  };
}

function $backgroundColorStyles (configProps) {
  var _getPaddingBottomAndH = getPaddingBottomAndHeightFromAspectRatio(configProps.passedAspectRatio, 10, configProps.gridBaseLineHeight),
      height = _getPaddingBottomAndH.height,
      paddingBottom = _getPaddingBottomAndH.paddingBottom;

  return {
    Wrapper: box({
      position: "relative"
    }),
    AspectRatioMaker: box({
      position: "relative",
      paddingBottom: paddingBottom,
      height: height
    }),
    Background: box({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: configProps.color
    })
  };
}

function $buttonsStyles (configProps) {
  var align = configProps.align || "left";
  var flexAlign = "flex-start";

  if (align === "center") {
    flexAlign = "center";
  } else if (align === "right") {
    flexAlign = "flex-end";
  }

  var gap = configProps.gap;
  return {
    ButtonsContainer: box({
      display: "flex",
      flexWrap: "wrap",
      flexDirection: configProps.verticalLayout ? "column" : "row",
      justifyContent: configProps.verticalLayout ? "normal" : flexAlign,
      alignItems: configProps.verticalLayout ? flexAlign : "center",
      // ">*:not(:last-child)": {
      //   marginRight: configProps.verticalLayout ? 0 : configProps.gap,
      //   marginBottom: configProps.verticalLayout ? configProps.gap : 0,
      // },
      gap: gap,
      pointerEvents: "auto" // force clickability

    })
  };
}

function ownKeys$A(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$z(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$A(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$A(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function $stackStyles (compiled, _ref) {
  var _compiled$passedAlign;

  var device = _ref.device,
      $width = _ref.$width;
      _ref.$widthAuto;

  if ($width === -1) {
    throw new Error("$stack without width!!!");
  } // Legacy -> if we get passedAlign from external, we use it "by force"


  if (compiled.passedAlign) {
    compiled.Items = compiled.Items.map(function (item) {
      return _objectSpread$z(_objectSpread$z({}, item), {}, {
        align: compiled.passedAlign
      });
    });
  } // here we must apply default for placeholder!


  var items = compiled.Items.length > 0 ? compiled.Items : [{
    marginBottom: 0,
    escapeMargin: false,
    width: "512px",
    align: (_compiled$passedAlign = compiled.passedAlign) !== null && _compiled$passedAlign !== void 0 ? _compiled$passedAlign : "left"
  }];
  var itemWrappers = items.map(function (item, index) {
    var maxWidth = item.width;

    if (isNaN(parseInt(maxWidth))) {
      maxWidth = "10000px"; // auto when not a pixel value -> and this is the default value!
    }

    var flexAlign = "center";

    if (item.align === "left") {
      flexAlign = "flex-start";
    } else if (item.align === "right") {
      flexAlign = "flex-end";
    }

    return {
      StackItemOuter: box({
        display: "flex",
        justifyContent: flexAlign,
        paddingLeft: !item.escapeMargin ? compiled.paddingLeft : 0,
        paddingRight: !item.escapeMargin ? compiled.paddingRight : 0,
        paddingTop: (index === 0 || compiled.Items.length === 0) && !item.escapeMargin ? compiled.paddingTop : 0,
        paddingBottom: (index === compiled.Items.length - 1 || compiled.Items.length === 0) && !item.escapeMargin ? compiled.paddingBottom : 0
      }),
      StackItemInner: box({
        position: "relative",
        maxWidth: "100%",
        width: maxWidth,
        marginBottom: index === items.length - 1 ? 0 : item.marginBottom,
        pointerEvents: "auto" // every stack item can have interaction

      })
    };
  });
  return {
    StackContainer: box({
      display: "grid"
    }),
    itemWrappers: itemWrappers,
    Items: {
      itemProps: compiled.Items.map(function (item, index) {
        var _compiled$paddingLeft, _compiled$paddingRigh;

        return {
          align: item.align,
          $width: Math.min(item.width === "max" ? Number.MAX_VALUE : parseInt(item.width), $width - spacingToPx((_compiled$paddingLeft = compiled.paddingLeft) !== null && _compiled$paddingLeft !== void 0 ? _compiled$paddingLeft : "0px", device.w) - spacingToPx((_compiled$paddingRigh = compiled.paddingRight) !== null && _compiled$paddingRigh !== void 0 ? _compiled$paddingRigh : "0px", device.w)),
          $widthAuto: false
        };
      })
    }
  };
}

function $twoItems (configProps, t) {
  var $width = t.$width;
  t.$widthAuto;
  var items = configProps.Items.length > 0 ? configProps.Items : [{
    columnWidth: "fill",
    itemWidth: "fill",
    itemAlign: "flex-start"
  }];
  var $itemWidth = $width / items.length; // TODO: very lame interpolation, no time :(

  var itemWrappers = items.map(function (x) {
    return {
      OuterWrapper: box({
        display: "flex",
        flex: x.columnWidth === "fill" ? "1 1 0" : "0 0 ".concat(x.columnWidth, "px"),
        justifyContent: x.itemWidth === "fill" ? "stretch" : x.itemAlign
      }),
      InnerWrapper: box({
        display: "grid",
        flexBasis: x.itemWidth === "fill" ? "100%" : "".concat(x.itemWidth, "px")
      })
    };
  });
  return {
    Container: box({
      display: "flex",
      flexDirection: "row",
      alignItems: configProps.verticalAlign,
      gap: configProps.gap
    }),
    itemWrappers: itemWrappers,
    Items: {
      itemProps: items.map(function (x) {
        return {
          align: x.itemAlign === "flex-start" ? "left" : x.itemAlign === "center" ? "center" : "right",
          $width: $itemWidth,
          $widthAuto: false
        };
      })
    }
  };
}

React.createElement;

/** @jsx createElement */
function Separator(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      Container = _props$__fromEditor$c.Container,
      Separator = _props$__fromEditor$c.Separator;
  return createElement(Container, null, createElement(Separator, null));
}

function $separatorStyles (configProps, t) {
  return {
    Container: box({
      minHeight: 9,
      display: "flex",
      alignItems: "center",
      position: "relative"
    }),
    Separator: box({
      height: configProps.height + "px",
      width: "100%",
      backgroundColor: configProps.color
    })
  };
}

React.createElement;

/** @jsx createElement */
function SectionWrapper(props) {
  // Underscores are for the namespace purpose - we don't want to clutter it with common names
  var _props$__fromEditor$c = props.__fromEditor.components,
      Container__ = _props$__fromEditor$c.Container__,
      Root__ = _props$__fromEditor$c.Root__,
      BackgroundContainer__ = _props$__fromEditor$c.BackgroundContainer__,
      Background__ = _props$__fromEditor$c.Background__,
      HeaderStack = _props$__fromEditor$c.HeaderStack,
      HeaderSecondaryStack = _props$__fromEditor$c.HeaderSecondaryStack,
      HeaderStackContainer__ = _props$__fromEditor$c.HeaderStackContainer__,
      SubheaderStackContainer__ = _props$__fromEditor$c.SubheaderStackContainer__,
      ContentContainer__ = _props$__fromEditor$c.ContentContainer__,
      Component = _props$__fromEditor$c.Component;
  var headerMode = props.__fromEditor.props.headerMode;
  return createElement(Root__, {
    id: props.__fromEditor._id
  }, Background__ && createElement(BackgroundContainer__, null, createElement(Background__, null)), createElement(Container__, null, headerMode !== "none" && createElement(HeaderStackContainer__, null, createElement(HeaderStack, null)), headerMode === "2-stacks" && createElement(SubheaderStackContainer__, null, createElement(HeaderSecondaryStack, null)), createElement(ContentContainer__, null, createElement(Component, null))));
}

function ownKeys$z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$y(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$z(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function $sectionWrapperStyles(compiled, t) {
  var $width = t.$width;

  if ($width === -1) {
    throw new Error("$sectionWrapper without width!!!");
  }

  var styles = {
    grid: {},
    content: {},
    header: {},
    headerSecondary: {},
    HeaderStack: {
      $width: t.$width,
      $widthAuto: true
    },
    HeaderSecondaryStack: {
      $width: t.$width,
      $widthAuto: true
    }
  };
  var maxWidth = compiled.containerMaxWidth === "none" || isNaN(parseInt(compiled.containerMaxWidth)) ? null : parseInt(compiled.containerMaxWidth);
  var containerMargin = {
    css: compiled.containerMargin,
    px: spacingToPx(compiled.containerMargin, t.device.w)
  };
  var containerWidth = $width - containerMargin.px * 2; // const applyMaxWidth = maxWidth && maxWidth < containerWidth;

  var getCssAbsoluteMargin = function getCssAbsoluteMargin(margin) {
    return maxWidth !== null ? "max(".concat(margin, ", calc(calc(100% - ").concat(maxWidth, "px) / 2))") : margin;
  };

  var margin = getCssAbsoluteMargin(containerMargin.css);

  if (compiled.headerMode === "1-stack") {
    styles.grid.gridTemplateColumns = "".concat(margin, " 1fr ").concat(margin);
    styles.content.gridColumn = "1 / span 3";
    styles.content.gridRow = "2 / span 1";
    styles.content.marginTop = compiled.headerSectionGap;
    styles.header.gridColumn = "2 / span 1";
    styles.header.gridRow = "1 / span 1";
    styles.header.display = "flex";
    styles.header.justifyContent = compiled.layout1Stack === "left" ? "flex-start" : compiled.layout1Stack === "right" ? "flex-end" : "center";
    styles.HeaderStack.passedAlign = compiled.layout1Stack;
  } else if (compiled.headerMode === "2-stacks") {
    if (compiled.layout2Stacks.startsWith("below") || compiled.layout2Stacks.startsWith("stacked")) {
      var _compiled$layout2Stac = compiled.layout2Stacks.split("-"),
          _compiled$layout2Stac2 = _slicedToArray$2(_compiled$layout2Stac, 2),
          align = _compiled$layout2Stac2[1];

      var isBelow = compiled.layout2Stacks.startsWith("below");
      styles.grid.gridTemplateColumns = "".concat(margin, " 1fr ").concat(margin);
      styles.header.gridColumn = "2 / span 1";
      styles.header.gridRow = "1 / span 1";
      styles.header.justifySelf = align;
      styles.HeaderStack.passedAlign = align;
      styles.headerSecondary.gridColumn = "2 / span 1";
      styles.headerSecondary.gridRow = "".concat(isBelow ? 3 : 2, " / span 1");
      styles.headerSecondary.justifySelf = align;
      styles.HeaderSecondaryStack.passedAlign = align;
      styles.headerSecondary.marginTop = isBelow ? compiled.footerSectionGap : compiled.headerStacksGap;
      styles.content.gridColumn = "1 / span 3";
      styles.content.gridRow = "".concat(isBelow ? 2 : 3, " / span 1");
      styles.content.marginTop = compiled.headerSectionGap;
    } else {
      var _compiled$layout2Stac3 = compiled.layout2Stacks.split("-"),
          _compiled$layout2Stac4 = _slicedToArray$2(_compiled$layout2Stac3, 2),
          primaryPos = _compiled$layout2Stac4[0];
          _compiled$layout2Stac4[1];
      /**
       * Solution with items on the same grid cell is shitty but:
       * - we can do it on the same markup
       * - display: contents doesn't work on iOS Safari (accessibility bug), so we can't do flex +
       * grid
       * - pure flexbox solution with flex:wrap would work but left / center / right layout not
       * possible
       * - OK, flexbox layout is possible with placeholder, but weird things are happening if title
       * is VERY long.
       * - We could try to solve that problem but it's highly unlikely there's a good solution
       * without duplication.
       *
       * Overlapping items have huge problems with selection. Terrible UX.
       *
       * Let's just do simple FR for now! (1 / 2)
       */


      if (primaryPos === "left") {
        styles.grid.gridTemplateColumns = "".concat(margin, " 1fr 1fr ").concat(margin);
        styles.content.gridColumn = "1 / span 4";
        styles.content.gridRow = "2 / span 1";
        styles.content.marginTop = compiled.headerSectionGap;
        styles.header.gridColumn = "2 / span 1";
        styles.header.gridRow = "1 / span 1";
        styles.header.justifySelf = "left";
        styles.headerSecondary.gridColumn = "3 / span 1";
        styles.headerSecondary.gridRow = "1 / span 1";
        styles.headerSecondary.justifySelf = "right";
        styles.HeaderStack.passedAlign = "left";
        styles.HeaderSecondaryStack.passedAlign = "right";
      } else {
        // center + right
        styles.grid.gridTemplateColumns = "".concat(margin, " 1fr 2fr 1fr ").concat(margin);
        styles.content.gridColumn = "1 / span 5";
        styles.content.gridRow = "2 / span 1";
        styles.content.marginTop = compiled.headerSectionGap;
        styles.header.gridColumn = "3 / span 1";
        styles.header.gridRow = "1 / span 1";
        styles.header.justifySelf = "center";
        styles.headerSecondary.gridColumn = "4 / span 1";
        styles.headerSecondary.gridRow = "1 / span 1";
        styles.headerSecondary.justifySelf = "right";
        styles.HeaderStack.passedAlign = "center";
        styles.HeaderSecondaryStack.passedAlign = "right";
      }

      if (compiled.layout2StacksVerticalAlign === "top") {
        styles.grid.alignItems = "start";
      } else if (compiled.layout2StacksVerticalAlign === "center") {
        styles.grid.alignItems = "center";
      } else {
        styles.grid.alignItems = "end";
      }
    }
  } else {
    styles.grid.gridTemplateColumns = "1fr";
    styles.content.gridColumn = "1 / span 1";
  } // container max width
  // styles.grid.width = "100%";
  // styles.grid.justifySelf = "center";


  var Component; // GridCard handles margins on its own because of advanced margins

  if (compiled.Component[0]._template === "$GridCard") {
    Component = {
      edgeLeft: true,
      edgeLeftMargin: containerMargin.css,
      edgeRight: true,
      edgeRightMargin: containerMargin.css,
      escapeMargin: !!compiled.escapeMargin,
      maxWidth: maxWidth,
      $width: $width
    };
  } else {
    // we must always display paddings even if max width is applied.
    var escapeMargin = !!compiled.escapeMargin;
    styles.content.paddingLeft = getCssAbsoluteMargin(escapeMargin ? "0px" : containerMargin.css);
    styles.content.paddingRight = getCssAbsoluteMargin(escapeMargin ? "0px" : containerMargin.css); // Should we apply max width

    if (maxWidth && maxWidth < containerWidth) {
      // styles.grid.maxWidth = `${maxWidth + leftMargin + rightMargin}px`;
      Component = {
        edgeLeft: false,
        edgeRight: false,
        edgeLeftMargin: null,
        edgeRightMargin: null,
        $width: maxWidth
      };
    } else {
      Component = {
        edgeLeft: escapeMargin,
        edgeRight: escapeMargin,
        edgeLeftMargin: escapeMargin ? containerMargin.css : null,
        edgeRightMargin: escapeMargin ? containerMargin.css : null,
        $width: escapeMargin ? $width : $width - 2 * containerMargin.px
      };
    }
  }

  var hasNoBackground = !compiled.Background__ || compiled.Background__.length === 0;
  return {
    Root__: box({
      position: "relative",
      paddingTop: hasNoBackground ? "0px" : compiled.padding,
      paddingBottom: hasNoBackground ? "0px" : compiled.padding,
      display: !t.compilationContext.isEditing && compiled.hide ? "none" : "block",
      opacity: t.compilationContext.isEditing && compiled.hide ? 0.33 : 1
    }, "section"),
    BackgroundContainer__: box({
      position: "absolute",
      top: 0,
      left: 0,
      overflow: "hidden",
      width: "100%",
      height: "100%",
      display: "grid"
    }),
    Container__: box(_objectSpread$y({
      position: "relative",
      paddingLeft: 0,
      paddingRight: 0,
      display: "grid",
      gridTemplateRows: "auto auto auto"
    }, styles.grid)),
    Background__: {
      noAction: true
    },
    HeaderStackContainer__: box(styles.header),
    SubheaderStackContainer__: box(styles.headerSecondary),
    ContentContainer__: box(_objectSpread$y(_objectSpread$y({}, styles.content), {}, {
      position: "relative"
    })),
    HeaderStack: styles.HeaderStack,
    HeaderSecondaryStack: styles.HeaderSecondaryStack,
    Component: _objectSpread$y(_objectSpread$y({}, Component), {}, {
      tracingType: "section"
    }),
    __props: {
      headerMode: compiled.headerMode
    }
  };
}

var sectionWrapperEditing = function sectionWrapperEditing(values, editing, _ref) {
  var pathPrefix = _ref.pathPrefix,
      fields = _ref.fields;
  return {
    fields: [].concat(_toConsumableArray$2(editing.fields.filter(function (field) {
      return field.group === "General";
    })), [{
      portal: "component",
      source: "".concat(pathPrefix, ".Component.0")
    }], _toConsumableArray$2(editing.fields.filter(function (field) {
      return field.group !== "General";
    }))),
    components: {
      Component: {
        noInline: true
      },
      Background__: {
        noInline: true
      },
      HeaderStack: {
        fields: [fields.headerMode, fields.layout1Stack, fields.layout2Stacks, fields.headerSectionGap, fields.layout2StacksVerticalAlign, fields.footerSectionGap, fields.headerStacksGap]
      },
      HeaderSecondaryStack: {
        fields: [fields.headerMode, fields.layout2Stacks, fields.headerSectionGap, fields.layout2StacksVerticalAlign, fields.footerSectionGap, fields.headerStacksGap]
      }
    }
  };
};

function ownKeys$y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$x(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$y(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function correctCardWidths(values, fixedWidthField) {
  var ret = _objectSpread$x({}, values); // if collapsed, do nothing


  if (values.collapse) {
    return values;
  }

  var sum = parseInt(values.card1Width) + parseInt(values.card2Width);

  if (sum > TWO_CARDS_COL_NUM) {
    var variableWidthField = fixedWidthField === "card1Width" ? "card2Width" : "card1Width";
    ret[variableWidthField] = (TWO_CARDS_COL_NUM - parseInt(values[fixedWidthField])).toString();
  }

  return ret;
}

var twoCardsChange = function twoCardsChange(_ref) {
  var value = _ref.value,
      fieldName = _ref.fieldName;
      _ref.closestDefinedValue;
      var values = _ref.values,
      closestDefinedValues = _ref.closestDefinedValues;

  if (fieldName === "card1Width" || fieldName === "card2Width" || fieldName === "collapse") {
    var definedValues = {
      card1Width: closestDefinedValues.card1Width,
      card2Width: closestDefinedValues.card2Width,
      collapse: closestDefinedValues.collapse
    };

    if (fieldName === "collapse") {
      if (values.card1Width === undefined) {
        // we don't touch undefined card widths
        return {
          collapse: value
        };
      } else {
        return correctCardWidths(_objectSpread$x(_objectSpread$x({}, definedValues), {}, {
          collapse: value
        }), "card1Width");
      }
    } else if (fieldName === "card1Width" || fieldName === "card2Width") {
      if (value === undefined) {
        return {
          collapse: values.collapse,
          card1Width: undefined,
          card2Width: undefined
        };
      }

      return _objectSpread$x(_objectSpread$x({}, correctCardWidths(_objectSpread$x(_objectSpread$x({}, definedValues), {}, _defineProperty$g({}, fieldName, value)), fieldName)), {}, {
        collapse: values.collapse
      });
    } else {
      throw new Error("unreachable");
    }
  }

  return _defineProperty$g({}, fieldName, value);
};

function ownKeys$x(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$w(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$x(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$x(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function $textStyles (configProps, t) {
  var align = configProps.align || "left";

  var fontWithDefaults = _objectSpread$w({
    fontWeight: "initial",
    fontStyle: "initial"
  }, configProps.font);

  return {
    Text: box(_objectSpread$w(_objectSpread$w({}, fontWithDefaults), {}, {
      color: configProps.color,
      textAlign: align,
      "& textarea::placeholder": {
        color: "currentColor",
        opacity: 0.5
      },
      "& textarea": _objectSpread$w(_objectSpread$w({}, fontWithDefaults), {}, {
        color: configProps.color
      }),
      border: configProps.value === "" ? "1px dotted grey" : "none"
    }), configProps.accessibilityRole)
  };
}

var index$1 = react.exports.useLayoutEffect;

var useLatest = function useLatest(value) {
  var ref = react.exports.useRef(value);
  index$1(function () {
    ref.current = value;
  });
  return ref;
};

var updateRef = function updateRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }

  ref.current = value;
};

var useComposedRef = function useComposedRef(libRef, userRef) {
  var prevUserRef = react.exports.useRef();
  return react.exports.useCallback(function (instance) {
    libRef.current = instance;

    if (prevUserRef.current) {
      updateRef(prevUserRef.current, null);
    }

    prevUserRef.current = userRef;

    if (!userRef) {
      return;
    }

    updateRef(userRef, instance);
  }, [userRef]);
};

var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};

var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
}; //   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259


var hiddenTextarea = null;

var getHeight = function getHeight(node, sizingData) {
  var height = node.scrollHeight;

  if (sizingData.sizingStyle.boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
  } // remove padding, since height = content


  return height - sizingData.paddingSize;
};

function calculateNodeHeight(sizingData, value, minRows, maxRows) {
  if (minRows === void 0) {
    minRows = 1;
  }

  if (maxRows === void 0) {
    maxRows = Infinity;
  }

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tabindex', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    forceHiddenStyles(hiddenTextarea);
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  }

  var paddingSize = sizingData.paddingSize,
      borderSize = sizingData.borderSize,
      sizingStyle = sizingData.sizingStyle;
  var boxSizing = sizingStyle.boxSizing;
  Object.keys(sizingStyle).forEach(function (_key) {
    var key = _key;
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = value;
  var height = getHeight(hiddenTextarea, sizingData); // measure height of a textarea with a single row

  hiddenTextarea.value = 'x';
  var rowHeight = hiddenTextarea.scrollHeight - paddingSize;
  var minHeight = rowHeight * minRows;

  if (boxSizing === 'border-box') {
    minHeight = minHeight + paddingSize + borderSize;
  }

  height = Math.max(minHeight, height);
  var maxHeight = rowHeight * maxRows;

  if (boxSizing === 'border-box') {
    maxHeight = maxHeight + paddingSize + borderSize;
  }

  height = Math.min(maxHeight, height);
  return [height, rowHeight];
}

var noop$1 = function noop() {};

var pick = function pick(props, obj) {
  return props.reduce(function (acc, prop) {
    acc[prop] = obj[prop];
    return acc;
  }, {});
};

var SIZING_STYLE = ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'boxSizing', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop', // non-standard
'tabSize', 'textIndent', // non-standard
'textRendering', 'textTransform', 'width', 'wordBreak'];
var isIE = !!document.documentElement.currentStyle;

var getSizingData = function getSizingData(node) {
  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = pick(SIZING_STYLE, style);
  var boxSizing = sizingStyle.boxSizing; // probably node is detached from DOM, can't read computed dimensions

  if (boxSizing === '') {
    return null;
  } // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths


  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
  var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
  return {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize
  };
};

var useWindowResizeListener = function useWindowResizeListener(listener) {
  var latestListener = useLatest(listener);
  react.exports.useLayoutEffect(function () {
    var handler = function handler(event) {
      latestListener.current(event);
    };

    window.addEventListener('resize', handler);
    return function () {
      window.removeEventListener('resize', handler);
    };
  }, []);
};

var TextareaAutosize = function TextareaAutosize(_ref, userRef) {
  var cacheMeasurements = _ref.cacheMeasurements,
      maxRows = _ref.maxRows,
      minRows = _ref.minRows,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop$1 : _ref$onChange,
      _ref$onHeightChange = _ref.onHeightChange,
      onHeightChange = _ref$onHeightChange === void 0 ? noop$1 : _ref$onHeightChange,
      props = _objectWithoutPropertiesLoose$2(_ref, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);

  var isControlled = props.value !== undefined;
  var libRef = react.exports.useRef(null);
  var ref = useComposedRef(libRef, userRef);
  var heightRef = react.exports.useRef(0);
  var measurementsCacheRef = react.exports.useRef();

  var resizeTextarea = function resizeTextarea() {
    var node = libRef.current;
    var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData(node);

    if (!nodeSizingData) {
      return;
    }

    measurementsCacheRef.current = nodeSizingData;

    var _calculateNodeHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows),
        height = _calculateNodeHeight[0],
        rowHeight = _calculateNodeHeight[1];

    if (heightRef.current !== height) {
      heightRef.current = height;
      node.style.setProperty('height', height + "px", 'important');
      onHeightChange(height, {
        rowHeight: rowHeight
      });
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      resizeTextarea();
    }

    onChange(event);
  };

  {
    react.exports.useLayoutEffect(resizeTextarea);
    useWindowResizeListener(resizeTextarea);
  }
  return /*#__PURE__*/react.exports.createElement("textarea", _extends$9({}, props, {
    onChange: handleChange,
    ref: ref
  }));
};

var index = /* #__PURE__ */react.exports.forwardRef(TextareaAutosize);
var TextareaAutosize$1 = index;

React.createElement;
styled(TextareaAutosize$1).withConfig({
  displayName: "inline-textarea-field__Textarea",
  componentId: "sc-19t6lju-0"
})(["width:100%;word-wrap:break-word;display:block;font-size:inherit;font-family:inherit;font-weight:inherit;box-sizing:border-box;color:inherit;letter-spacing:inherit;line-height:inherit;margin:0 auto;max-width:inherit;text-transform:inherit;background-color:inherit;text-align:inherit;outline:none;resize:none;border:none;overflow:visible;position:relative;padding:0;-ms-overflow-style:none;::-webkit-scrollbar{display:none;}"]);

React.createElement;
var textEditableComponent = {
  id: "$text",
  styles: $textStyles,
  tags: ["item", "notrace"],
  schema: [{
    prop: "value",
    type: "text"
  }, {
    prop: "color",
    label: "Color",
    type: "color"
  }, {
    prop: "font",
    label: "Font",
    type: "font"
  }, {
    prop: "accessibilityRole",
    type: "select",
    label: "Role",
    options: [{
      value: "p",
      label: "Paragraph"
    }].concat(_toConsumableArray$2(range(1, 6).map(function (index) {
      return {
        value: "h".concat(index),
        label: "Heading ".concat(index)
      };
    }))),
    group: "Accessibility and SEO"
  }]
};

var $rootSectionStyles = function $rootSectionStyles(config, t) {
  // We must have at least 1 item wrapper for placeholder.
  var dataProps = config.data.length === 0 ? [{
    topMargin: 0,
    bottomMargin: 0
  }] : config.data;
  var ItemWrappers = dataProps.map(function (x) {
    return box({
      display: !t.compilationContext.isEditing && x.hide ? "none" : "block",
      paddingTop: x.topMargin,
      paddingBottom: x.bottomMargin
    });
  });
  return {
    ItemWrappers: ItemWrappers
  };
};

var $rootGridStyles = function $rootGridStyles(config, t) {
  return {
    data: {}
  };
};

function calculateWidthsFromNonRoundedGap(autoGapNotRounded, higherCard1Width, higherCard2Width) {
  if (autoGapNotRounded < 1 && higherCard1Width > 0 && higherCard2Width > 0) {
    autoGapNotRounded = 1;
  }

  if (autoGapNotRounded > 20) {
    autoGapNotRounded = 20;
  }

  var autoGap = Math.round(autoGapNotRounded);
  var autoGapCeil = Math.ceil(autoGapNotRounded);
  var autoGapFloor = Math.floor(autoGapNotRounded); // If at higher breakpoint cards were equal width, they must be equal width in auto mode, so odd auto gap must be corrected

  if (higherCard1Width === higherCard2Width && autoGap % 2 === 1) {
    if (autoGapCeil % 2 === 0) {
      autoGap = autoGapCeil;
    } else if (autoGapFloor % 2 === 0) {
      autoGap = autoGapFloor;
    } else if (autoGap === 1) {
      autoGap = 2;
    } else {
      autoGap = autoGap - 1;
    }

    if (autoGap % 2 === 1) {
      throw new Error("can't happen");
    }
  }

  var roundingFunction = higherCard1Width > higherCard2Width ? Math.floor : Math.ceil;
  var autoCard1Width = roundingFunction((TWO_CARDS_COL_NUM - autoGap) * (higherCard1Width / (higherCard1Width + higherCard2Width)));
  var autoCard2Width = TWO_CARDS_COL_NUM - autoCard1Width - autoGap;
  return [autoCard1Width, autoCard2Width];
}

function calculateAutoWidths(higherCard1Width, higherCard2Width, higherWidth, currentWidth, magicNumber) {
  var MAGIC_NUMBER = magicNumber !== null && magicNumber !== void 0 ? magicNumber : -0.45;
  var higherGap = TWO_CARDS_COL_NUM - higherCard1Width - higherCard2Width;

  if (higherGap === 0) {
    return [higherCard1Width, higherCard2Width];
  } // For vertical mobile phones we always apply fullscreen!


  if ((higherCard1Width === 0 || higherCard2Width === 0) && currentWidth < 568) {
    return [TWO_CARDS_COL_NUM, TWO_CARDS_COL_NUM];
  }

  var autoGapNotRounded = TWO_CARDS_COL_NUM * Math.max(0, higherGap / TWO_CARDS_COL_NUM + (1 - currentWidth / higherWidth) * MAGIC_NUMBER);
  return calculateWidthsFromNonRoundedGap(autoGapNotRounded, higherCard1Width, higherCard2Width);
}

function calculateAutoWidthsForBetweenMode(card1WidthHigher, card2WidthHigher, card1WidthLower, card2WidthLower, higherWidth, lowerWidth, currentWidth) {
  var autoCard1Width;
  var autoCard2Width;
  var resolutionProportion = (currentWidth - lowerWidth) / (higherWidth - lowerWidth); // If lower is 1000, higher 1600 and device 1200, then we have 200 / 600 = 0.33. For lower it's 0, for higher it's 1. It's always 0-1.

  autoCard1Width = Math.round(card1WidthLower + (card1WidthHigher - card1WidthLower) * resolutionProportion);
  autoCard2Width = Math.round(card2WidthLower + (card2WidthHigher - card2WidthLower) * resolutionProportion);

  if (autoCard1Width + autoCard2Width === 25) {
    if (autoCard2Width >= autoCard1Width) {
      autoCard2Width--;
    } else {
      autoCard1Width--;
    }
  }

  return [autoCard1Width, autoCard2Width];
}

function autoCollapse(_ref) {
  var values = _ref.values,
      higherDefinedValues = _ref.higherDefinedValues,
      lowerDefinedValues = _ref.lowerDefinedValues,
      closestDefinedValues = _ref.closestDefinedValues,
      width = _ref.width;
  var collapse = values.collapse;
  /**
   * COLLAPSE
   */

  if (collapse === undefined) {
    if (higherDefinedValues.collapse && higherDefinedValues.collapse.value === false) {
      if (lowerDefinedValues.collapse && lowerDefinedValues.collapse.value === true || !lowerDefinedValues.collapse) {
        // if higher is non-collapsed and lower potentially collapsed
        collapse = higherDefinedValues.collapse.width > width * 2; // collapse if size decreased at least twice
      }
    } else {
      collapse = closestDefinedValues.collapse.value;
    }
  }

  return {
    collapse: collapse
  };
}

function autoWidths(_ref2) {
  var values = _ref2.values,
      higherDefinedValues = _ref2.higherDefinedValues,
      lowerDefinedValues = _ref2.lowerDefinedValues,
      closestDefinedValues = _ref2.closestDefinedValues,
      width = _ref2.width;

  /**
   * widths and gap
   */
  var card1Width = values.card1Width;
  var card2Width = values.card2Width;

  if (card1Width !== undefined && card2Width !== undefined) ; else if (card1Width === undefined && card2Width !== undefined || card1Width !== undefined && card2Width === undefined) {
    throw new Error("this is error situation. card1Width and card2Width are both either defined or not defined");
  } else {
    var card1WidthHigher = higherDefinedValues.card1Width ? parseInt(higherDefinedValues.card1Width.value) : undefined;
    var card1WidthLower = lowerDefinedValues.card1Width ? parseInt(lowerDefinedValues.card1Width.value) : undefined;
    var card2WidthHigher = higherDefinedValues.card2Width ? parseInt(higherDefinedValues.card2Width.value) : undefined;
    var card2WidthLower = lowerDefinedValues.card2Width ? parseInt(lowerDefinedValues.card2Width.value) : undefined;

    if (card1WidthHigher === undefined || card2WidthHigher === undefined) {
      // If we are on the breakpoint that has only lower values defined, then we just take defaults.
      card1Width = closestDefinedValues.card1Width.value;
      card2Width = closestDefinedValues.card2Width.value;
    } else {
      var autoCard1Width;
      var autoCard2Width;
      var higherDefinedWidth = higherDefinedValues.card1Width.width;
      var isBetween2DefinedValues = card1WidthHigher !== undefined && card1WidthLower !== undefined; // const collapse =
      //   responsiveValueGet(config.collapse, device.id, devices) === true;
      // If we're in collapsed mode
      // console.log('values collaspe value!', values.collapse.value);

      if (closestDefinedValues.collapse.value === true) {
        if (isBetween2DefinedValues) {
          var lowerDefinedWidth = lowerDefinedValues.card1Width.width;

          var _calculateAutoWidthsF = calculateAutoWidthsForBetweenMode(card1WidthHigher, 0, card1WidthLower, 0, higherDefinedWidth, lowerDefinedWidth, width);

          var _calculateAutoWidthsF2 = _slicedToArray$2(_calculateAutoWidthsF, 1);

          autoCard1Width = _calculateAutoWidthsF2[0];

          var _calculateAutoWidthsF3 = calculateAutoWidthsForBetweenMode(0, card2WidthHigher, 0, card2WidthLower, higherDefinedWidth, lowerDefinedWidth, width);

          var _calculateAutoWidthsF4 = _slicedToArray$2(_calculateAutoWidthsF3, 2);

          autoCard2Width = _calculateAutoWidthsF4[1];
        } else {
          // If it's not irregular layout always make full size on mobile
          if (card1WidthHigher + card2WidthHigher === TWO_CARDS_COL_NUM) {
            autoCard1Width = TWO_CARDS_COL_NUM;
            autoCard2Width = TWO_CARDS_COL_NUM;
          } else {
            var _calculateAutoWidths = calculateAutoWidths(card1WidthHigher, 0, higherDefinedWidth, width, -0.8);

            var _calculateAutoWidths2 = _slicedToArray$2(_calculateAutoWidths, 1);

            autoCard1Width = _calculateAutoWidths2[0];

            var _calculateAutoWidths3 = calculateAutoWidths(0, card2WidthHigher, higherDefinedWidth, width, -0.8);

            var _calculateAutoWidths4 = _slicedToArray$2(_calculateAutoWidths3, 2);

            autoCard2Width = _calculateAutoWidths4[1];
          }
        }
      } else {
        if (isBetween2DefinedValues) {
          var _lowerDefinedWidth = lowerDefinedValues.card1Width.width;

          var _calculateAutoWidthsF5 = calculateAutoWidthsForBetweenMode(card1WidthHigher, card2WidthHigher, card1WidthLower, card2WidthLower, higherDefinedWidth, _lowerDefinedWidth, width);

          var _calculateAutoWidthsF6 = _slicedToArray$2(_calculateAutoWidthsF5, 2);

          autoCard1Width = _calculateAutoWidthsF6[0];
          autoCard2Width = _calculateAutoWidthsF6[1];
        } else {
          var _calculateAutoWidths5 = calculateAutoWidths(card1WidthHigher, card2WidthHigher, higherDefinedWidth, width);

          var _calculateAutoWidths6 = _slicedToArray$2(_calculateAutoWidths5, 2);

          autoCard1Width = _calculateAutoWidths6[0];
          autoCard2Width = _calculateAutoWidths6[1];
        }
      }

      card1Width = autoCard1Width.toString();
      card2Width = autoCard2Width.toString();
    }
  }

  return {
    card1Width: card1Width,
    card2Width: card2Width
  };
}

var autoVerticalOffset = function autoVerticalOffset(_ref3, _ref4) {
  var values = _ref3.values;
      _ref3.higherDefinedValues;
      _ref3.lowerDefinedValues;
      var closestDefinedValues = _ref3.closestDefinedValues,
      width = _ref3.width;
  _ref4.config;
  var verticalOffset = values.verticalOffset;

  if (verticalOffset === undefined) {
    // const currentGap =
    //   TWO_CARDS_COL_NUM -
    //   parseInt(closestDefinedValues.card1Width.value) -
    //   parseInt(closestDefinedValues.card2Width.value);
    // const deviceId = closestDefinedValues.verticalOffset.device.id;
    //
    // const gapForClosestDefinedVerticalOffset =
    //   TWO_CARDS_COL_NUM -
    //   parseInt(config.card1Width[deviceId]) -
    //   parseInt(config.card2Width[deviceId]);
    var closestDefinedVerticalOffsetValue = parseInt(closestDefinedValues.verticalOffset.value);
    verticalOffset = Math.ceil(width / closestDefinedValues.verticalOffset.width * closestDefinedVerticalOffsetValue * 1.5 // this very simple heuristic actually works quite well
    );
  }

  return {
    verticalOffset: verticalOffset
  };
};

var autoVerticalGap = function autoVerticalGap(_ref5, _ref6) {
  var values = _ref5.values,
      higherDefinedValues = _ref5.higherDefinedValues,
      lowerDefinedValues = _ref5.lowerDefinedValues,
      closestDefinedValues = _ref5.closestDefinedValues;
      _ref5.width;
  var config = _ref6.config,
      compilationContext = _ref6.compilationContext,
      widths = _ref6.widths;
  var verticalGap = values.verticalGap;

  if (verticalGap === undefined) {
    // if closest higher defined vertical gap is for collapse = true, then let's do nothing, it will be used anyway
    if (higherDefinedValues.verticalGap && config.collapse[higherDefinedValues.verticalGap.device.id] === true) ; // if closest lower defined vertical gap is for collapse = true, then let's take it, it's more important than higher defined for collapse = false, MODES!!!
    else if (lowerDefinedValues.verticalGap && config.collapse[lowerDefinedValues.verticalGap.device.id] === true) {
      verticalGap = lowerDefinedValues.verticalGap.value;
    } // otherwise it means closest defined vertical gap is for collapse = false. Let's take "gap" only if sum of widths is 24.
    else {
      // now we know that closest is only collapse = false
      var closestDefinedVerticalGapDevice = closestDefinedValues.verticalGap.device;
      var closestDefinedGap = TWO_CARDS_COL_NUM - parseInt(config.card1Width[closestDefinedVerticalGapDevice.id]) - parseInt(config.card2Width[closestDefinedVerticalGapDevice.id]);

      if (closestDefinedGap === 0) {
        verticalGap = responsiveValueGetDefinedValue(config.gap, closestDefinedVerticalGapDevice.id, compilationContext.devices, widths);
      }
    }
  }

  return {
    verticalGap: verticalGap
  };
};

function twoCardsAuto(inputValues, compilationContext, widths) {
  var values = responsiveAuto(inputValues, compilationContext, widths, autoCollapse);
  values = responsiveAuto(values, compilationContext, widths, autoWidths);
  values = responsiveAuto(values, compilationContext, widths, autoVerticalOffset);
  values = responsiveAuto(values, compilationContext, widths, autoVerticalGap);
  return values;
}

function styles$3(values, t) {
  var _getPaddingBottomAndH = getPaddingBottomAndHeightFromAspectRatio(values.aspectRatio),
      height = _getPaddingBottomAndH.height,
      paddingBottom = _getPaddingBottomAndH.paddingBottom;

  return {
    Wrapper: box({
      position: "relative"
    }),
    ContentWrapper: box({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%"
    }),
    Placeholder: box({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundImage: "linear-gradient(45deg, #ccc 25%, transparent 25%),linear-gradient(135deg, #ccc 25%, transparent 25%),linear-gradient(45deg, transparent 75%, #ccc 75%),linear-gradient(135deg, transparent 75%, #ccc 75%);",
      backgroundSize: "25px 25px;",
      backgroundPosition: "0 0, 12.5px 0, 12.5px -12.5px, 0px 12.5px;"
    }),
    AspectRatioMaker: box({
      position: "relative",
      paddingBottom: paddingBottom,
      height: height
    }),
    PlayerContainer: box({
      height: "100%",
      width: "100%",
      overflow: "hidden"
    }),
    ErrorContainer: box({
      position: "absolute",
      boxSizing: "border-box",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "#fafafa",
      color: "grey",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "sans-serif",
      textAlign: "center",
      padding: 32
    }),
    __props: {
      aspectRatio: values.aspectRatio,
      isLoop: values.isLoop,
      isAutoPlay: values.isAutoPlay,
      isMuted: values.isMuted,
      videoId: values.videoId,
      areControlsDisabled: values.areControlsDisabled
    }
  };
}

var vimeoPlayerEditableComponent = {
  id: "$vimeoPlayer",
  label: "Vimeo Player",
  tags: ["item", "image"],
  schema: [{
    prop: "videoId",
    type: "string",
    label: "Video ID"
  }, {
    prop: "aspectRatio",
    label: "Aspect Ratio",
    type: "stringToken",
    tokenId: "aspectRatios",
    extraValues: ["grid-baseline"]
  }, {
    prop: "isAutoPlay",
    type: "boolean",
    defaultValue: true,
    label: "Auto play"
  }, {
    prop: "isMuted",
    type: "boolean",
    defaultValue: true,
    label: "Muted"
  }, {
    prop: "isLoop",
    type: "boolean",
    defaultValue: true,
    label: "Loop"
  }, {
    prop: "areControlsDisabled",
    type: "boolean",
    label: "Hide controls"
  }],
  styles: styles$3 // change: ({ value, fieldName }) => {
  //   const updatedValues: Record<string, unknown> = {
  //     [fieldName]: value,
  //   };
  //   if (fieldName === "areControlsDisabled" && value === true) {
  //     updatedValues.isAutoPlay = true;
  //   }
  //   return updatedValues;
  // },

};

function getSchemaPropByProp(definition, prop) {
  var schemaProp = definition.schema.find(function (schemaProp) {
    return schemaProp.prop === prop;
  });

  if (!schemaProp) {
    throw new Error("Missing schema prop \"".concat(prop, "\" in \"").concat(definition.id, "\" component definition"));
  }

  return schemaProp;
}

function styles$2(configProps) {
  var _configProps$passedAs;

  return {
    Wrapper: box({
      position: "relative"
    }),
    ImageWrapper: box({
      __action: "action",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      transition: "opacity .15s",
      "& img": {
        objectFit: "cover"
      }
    }),
    AspectRatioMaker: box({
      // this component does the size. If parent forces element to go bigger, it's gonna break aspect ratio. But in most cases it won't.
      position: "relative"
    }),
    __props: {
      aspectRatio: (_configProps$passedAs = configProps.passedAspectRatio) !== null && _configProps$passedAs !== void 0 ? _configProps$passedAs : configProps.aspectRatio,
      gridBaseLineHeight: configProps.gridBaseLineHeight
    }
  };
}

var imageComponentDefinition = {
  id: "$image",
  label: "Image",
  tags: ["image", "item"],
  styles: styles$2,
  editing: function editing(values, editingInfo) {
    var fields = _toConsumableArray$2(editingInfo.fields); // If aspect ratio passed from external, we don't need it.


    if (values.noAspectRatio) {
      fields = fields.filter(function (field) {
        return field.prop !== "aspectRatio";
      });
    }

    if (values.noAction) {
      fields = fields.filter(function (field) {
        return field.prop !== "action";
      });
    }

    return {
      fields: fields
    };
  },
  schema: [{
    prop: "image",
    type: "image",
    label: "Source"
  }, {
    prop: "aspectRatio",
    // main image size
    label: "Aspect Ratio",
    type: "stringToken",
    tokenId: "aspectRatios",
    extraValues: ["grid-baseline", "natural"]
  }, buttonActionSchemaProp],
  getEditorSidebarPreview: function getEditorSidebarPreview(config, editorContext) {
    var breakpointIndex = editorContext.breakpointIndex,
        resources = editorContext.resources,
        image = editorContext.image;
    var activeImageValue = responsiveValueForceGet(config.image, breakpointIndex);

    if (activeImageValue.id == null) {
      return {
        type: "icon",
        icon: SSIcons.Link,
        description: "None"
      };
    }

    var schemaProp = getSchemaPropByProp(findComponentDefinition(config, editorContext), "image");
    var imageResource = resources.find(function (resource) {
      return resourceByIdentity(activeImageValue.id, image.resourceType, activeImageValue.info, schemaProp.params)(resource);
    });

    if (!imageResource || imageResource.status !== "success") {
      return {
        type: "icon",
        icon: SSIcons.Link,
        description: "None"
      };
    }

    var imageResourceValue = getResourceValue(imageResource, schemaProp.transformHash);
    var imageFileName = last(imageResourceValue.url.split("/"));
    var imageFileNameWithoutQueryParams = imageFileName.split("?")[0];
    return {
      type: "image",
      url: imageResourceValue.url,
      description: imageFileNameWithoutQueryParams
    };
  }
};

function ownKeys$w(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$v(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$w(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$w(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function styles$1(values) {
  var _box;

  var imageBoxes = styles$2(values);
  var positions;

  if (values.controlsPosition === "top-left") {
    positions = ["top", "left"];
  } else if (values.controlsPosition === "top-right") {
    positions = ["top", "right"];
  } else if (values.controlsPosition === "bottom-left") {
    positions = ["bottom", "left"];
  } else if (values.controlsPosition === "bottom-right") {
    positions = ["bottom", "right"];
  } else {
    throw new Error("unreachable");
  }

  var ControlsContainer = box((_box = {
    display: values.enablePlaybackControls || values.enableSoundControls ? "flex" : "none",
    position: "absolute"
  }, _defineProperty$g(_box, positions[0], values.margin), _defineProperty$g(_box, positions[1], values.margin), _defineProperty$g(_box, "right", values.margin), _defineProperty$g(_box, "flexDirection", "row"), _defineProperty$g(_box, "gap", values.gap), _defineProperty$g(_box, "pointerEvents", "auto"), _box));

  var ImageWrapper = _objectSpread$v({}, imageBoxes.ImageWrapper);

  delete ImageWrapper.__action; // Video doesn't have action!!!

  return _objectSpread$v(_objectSpread$v({}, imageBoxes), {}, {
    ImageWrapper: ImageWrapper,
    ControlsContainer: ControlsContainer,
    Video: box({
      objectFit: "cover",
      objectPosition: "center center",
      width: "100%",
      height: "100%",
      position: "relative"
    }, "video"),
    PlayButton: {
      noAction: true
    },
    PauseButton: {
      noAction: true
    },
    MuteButton: {
      noAction: true
    },
    UnmuteButton: {
      noAction: true
    },
    __props: _objectSpread$v({
      enablePlaybackControls: values.enablePlaybackControls,
      enableSoundControls: values.enableSoundControls
    }, imageBoxes.__props)
  });
}

var videoComponentDefinition = {
  id: "$video",
  label: "Video",
  tags: ["image", "item"],
  styles: styles$1,
  editing: function editing(values, editingInfo) {
    var fields = _toConsumableArray$2(editingInfo.fields); // If aspect ratio passed from external, we don't need it.


    if (values.noAspectRatio) {
      fields = fields.filter(function (field) {
        return field.prop !== "aspectRatio";
      });
    }

    return {
      fields: fields
    };
  },
  schema: [{
    prop: "image",
    label: "Video",
    type: "video"
  }, {
    prop: "aspectRatio",
    // main image size
    label: "Aspect Ratio",
    type: "stringToken",
    tokenId: "aspectRatios",
    extraValues: ["grid-baseline"]
  }, {
    prop: "enablePlaybackControls",
    label: "Enable play/pause",
    type: "boolean",
    group: "Playback control"
  }, {
    prop: "PlayButton",
    label: "Play Button",
    type: "component",
    required: true,
    componentTypes: ["button"],
    group: "Playback control",
    visible: function visible(values) {
      return values.enablePlaybackControls;
    }
  }, {
    prop: "PauseButton",
    label: "Pause Button",
    type: "component",
    required: true,
    componentTypes: ["button"],
    group: "Playback control",
    visible: function visible(values) {
      return values.enablePlaybackControls;
    }
  }, {
    prop: "enableSoundControls",
    label: "Enable sound controls",
    type: "boolean",
    group: "Sound control"
  }, {
    prop: "MuteButton",
    label: "Mute Button",
    type: "component",
    required: true,
    componentTypes: ["button"],
    group: "Sound control",
    visible: function visible(values) {
      return values.enableSoundControls;
    }
  }, {
    prop: "UnmuteButton",
    label: "Unmute Button",
    type: "component",
    required: true,
    componentTypes: ["button"],
    group: "Sound control",
    visible: function visible(values) {
      return values.enableSoundControls;
    }
  }, {
    prop: "controlsPosition",
    label: "Controls position",
    type: "select$",
    options: ["top-left", "top-right", "bottom-left", "bottom-right"],
    visible: function visible(values) {
      return values.enablePlaybackControls;
    },
    group: "Controls styling"
  }, {
    prop: "margin",
    label: "Margin",
    type: "space",
    visible: function visible(values) {
      return values.enablePlaybackControls;
    },
    group: "Controls styling"
  }, {
    prop: "gap",
    label: "Gap",
    type: "space",
    visible: function visible(values) {
      return values.enablePlaybackControls;
    },
    group: "Controls styling"
  }],
  getEditorSidebarPreview: function getEditorSidebarPreview(config, editorContext) {
    var breakpointIndex = editorContext.breakpointIndex,
        resources = editorContext.resources,
        video = editorContext.video;
    var activeVideoValue = responsiveValueForceGet(config.image, breakpointIndex);

    if (activeVideoValue.id == null) {
      return {
        type: "icon",
        icon: SSIcons.Link,
        description: "None"
      };
    }

    var schemaProp = getSchemaPropByProp(findComponentDefinition(config, editorContext), "image");
    var videoResource = resources.find(function (resource) {
      return resourceByIdentity(activeVideoValue.id, video.resourceType, activeVideoValue.info, schemaProp.params)(resource);
    });

    if (!videoResource || videoResource.status !== "success") {
      return {
        type: "icon",
        icon: SSIcons.Link,
        description: "None"
      };
    }

    var videoResourceValue = getResourceValue(videoResource, schemaProp.transformHash);
    var videoFileName = last(videoResourceValue.url.split("/"));
    var videoFileNameWithoutQueryParams = videoFileName.split("?")[0];
    return {
      type: "icon",
      icon: SSIcons.Link,
      description: videoFileNameWithoutQueryParams
    };
  }
};

function styles(config, _ref) {
  var $width = _ref.$width;
      _ref.$widthAuto;

  var _basicCardController = basicCardController(config),
      padding = _basicCardController.padding,
      posH = _basicCardController.posH,
      posV = _basicCardController.posV,
      backgroundAspectRatio = _basicCardController.backgroundAspectRatio,
      hideContent = _basicCardController.hideContent,
      hideBackground = _basicCardController.hideBackground,
      enableContent = _basicCardController.enableContent;

  if ($width === -1) {
    throw new Error("$BasicCard without width!!!");
  }

  var flexPosH = posH === "left" ? "flex-start" : posH === "center" ? "center" : "flex-end";
  var flexPosV = posV === "top" ? "flex-start" : posV === "center" ? "center" : "flex-end";
  return {
    ContentContainer: box({
      position: "relative",
      borderRadius: 0 ,
      overflow: "visible" ,
      display: "grid"
    }),
    BackgroundContainer: box({
      position: "relative",
      gridColumn: "1 / span 1",
      gridRow: "1 / span 1",
      display: hideBackground ? "none" : "grid"
    }),
    Background: {
      passedAspectRatio: backgroundAspectRatio,
      // we set name "passedAspectRatio" to avoid conflict with "aspectRatio" internal prop. For now overriding is risky.
      gridBaseLineHeight: config.gridBaseLineHeight,
      noAction: true,
      noAspectRatio: true,
      noTrace: true
    },
    Stack: {
      paddingLeft: padding.left,
      paddingRight: padding.right,
      paddingBottom: padding.bottom,
      paddingTop: padding.top,
      $width: $width,
      $widthAuto: true
    },
    StackContainer: box({
      gridColumn: "1 / span 1",
      gridRow: "1 / span 1",
      display: hideContent || !enableContent ? "none" : "flex",
      justifyContent: flexPosH,
      alignItems: flexPosV
    }),
    StackInnerContainer: box({
      position: "relative",
      width: "auto",
      maxWidth: "100%"
    })
  };
}

React.createElement;

/** @jsx createElement */
function BasicCardClient(props) {
  var _props$__fromEditor$c = props.__fromEditor.components,
      ContentContainer = _props$__fromEditor$c.ContentContainer,
      Background = _props$__fromEditor$c.Background,
      BackgroundContainer = _props$__fromEditor$c.BackgroundContainer,
      Stack = _props$__fromEditor$c.Stack,
      StackContainer = _props$__fromEditor$c.StackContainer,
      StackInnerContainer = _props$__fromEditor$c.StackInnerContainer;
      _props$__fromEditor$c.Link;
  return (// <Root>
    //   {/*<Link />*/}
    createElement(ContentContainer, null, createElement(BackgroundContainer, null, createElement(Background, null)), createElement(StackContainer, null, createElement(StackInnerContainer, null, createElement(Stack, null)))) // </Root>

  );
}

function ownKeys$v(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$u(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$v(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$v(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var basicCardDefinition = {
  id: "$BasicCard",
  tags: ["notrace"],
  componentCode: getCode(BasicCardClient),
  pasteSlots: ["Stack"],
  styles: styles,
  editing: function editing(values, editingInfo, _ref) {
    var fields = _ref.fields;

    var _basicCardController = basicCardController(values),
        paddingFields = _basicCardController.paddingFields,
        hideContent = _basicCardController.hideContent,
        hideCornerRadius = _basicCardController.hideCornerRadius,
        enableContent = _basicCardController.enableContent,
        ignoreSize = _basicCardController.ignoreSize;

    if (
    /*noBackground || */
    ignoreSize) {
      fields.size.hidden = true;
    }

    fields.paddingLeft.hidden = true;
    fields.paddingRight.hidden = true;
    fields.paddingTop.hidden = true;
    fields.paddingBottom.hidden = true;
    fields.paddingTopExternal.hidden = true;
    fields.paddingBottomExternal.hidden = true;
    fields.paddingLeftExternal.hidden = true;
    fields.paddingRightExternal.hidden = true;
    fields.cornerRadius.hidden = hideCornerRadius;

    if (arePaddingFieldsSeparate(paddingFields.vertical)) {
      if (paddingFields.vertical.start === "internal") {
        fields.paddingTop.hidden = false;
      } else if (paddingFields.vertical.start === "external") {
        fields.paddingTopExternal.hidden = false;
      }

      if (paddingFields.vertical.end === "internal") {
        fields.paddingBottom.hidden = false;
      } else if (paddingFields.vertical.end === "external") {
        fields.paddingBottomExternal.hidden = false;
      }
    } else {
      if (paddingFields.vertical.both === "internal") {
        fields.paddingTop.hidden = false;
        fields.paddingTop.label = "Padding vertical";
      } else if (paddingFields.vertical.both === "external") {
        fields.paddingTopExternal.hidden = false;
        fields.paddingTopExternal.label = "Padding vertical";
      }
    }

    if (arePaddingFieldsSeparate(paddingFields.horizontal)) {
      if (paddingFields.horizontal.start === "internal") {
        fields.paddingLeft.hidden = false;
      } else if (paddingFields.horizontal.start === "external") {
        fields.paddingLeftExternal.hidden = false;
      }

      if (paddingFields.horizontal.end === "internal") {
        fields.paddingRight.hidden = false;
      } else if (paddingFields.horizontal.end === "external") {
        fields.paddingRightExternal.hidden = false;
      }
    } else {
      if (paddingFields.horizontal.both === "internal") {
        fields.paddingLeft.hidden = false;
        fields.paddingLeft.label = "Padding horizontal";
      } else if (paddingFields.horizontal.both === "external") {
        fields.paddingLeftExternal.hidden = false;
        fields.paddingLeftExternal.label = "Padding horizontal";
      }
    }

    var myFields = _toConsumableArray$2(editingInfo.fields); // If hideContent, we must hide the switch


    if (hideContent) {
      fields.enableContent.hidden = true;
    }

    if (hideContent || !enableContent) {
      editingInfo.fields.forEach(function (field) {
        if (field.group === "Stack" && field.prop !== "enableContent") {
          field.hidden = true;
        }
      });
    }

    return {
      fields: myFields,
      components: {
        Background: {
          noInline: true
        },
        Stack: {
          noInline: true
        }
      }
    };
  },
  schema: [{
    prop: "size",
    // main image size
    label: "Size",
    type: "stringToken",
    tokenId: "aspectRatios",
    extraValues: ["grid-baseline", "fit-content", "fit-background"],
    group: "General"
  }, {
    prop: "cornerRadius",
    label: "Corner radius",
    type: "select$",
    options: Array.from(Array(30).keys()).map(function (x) {
      return x.toString();
    }),
    group: "General"
  }, {
    prop: "Background",
    label: "Background",
    type: "component",
    componentTypes: ["image"],
    visible: true,
    group: "Background"
  }, {
    prop: "enableContent",
    label: "Visible",
    type: "boolean",
    defaultValue: true,
    group: "Stack",
    visible: false
  }, {
    prop: "position",
    label: "Position",
    type: "select$",
    options: ["top-left", "top-center", "top-right", "center-left", "center-center", "center-right", "bottom-left", "bottom-center", "bottom-right"],
    group: "Stack"
  }, // Standard offsets
  {
    prop: "paddingLeft",
    label: "Padding left",
    type: "space",
    group: "Stack",
    defaultValue: {
      value: "24px",
      ref: "24"
    }
  }, {
    prop: "paddingRight",
    label: "Padding right",
    type: "space",
    group: "Stack",
    defaultValue: {
      value: "24px",
      ref: "24"
    }
  }, {
    prop: "paddingTop",
    label: "Padding top",
    type: "space",
    group: "Stack",
    defaultValue: {
      value: "24px",
      ref: "24"
    }
  }, {
    prop: "paddingBottom",
    label: "Padding bottom",
    type: "space",
    group: "Stack",
    defaultValue: {
      value: "24px",
      ref: "24"
    }
  }, {
    prop: "paddingLeftExternal",
    label: "Padding left",
    type: "space",
    group: "Stack",
    defaultValue: {
      value: "0px",
      ref: "0"
    }
  }, {
    prop: "paddingRightExternal",
    label: "Padding right",
    type: "space",
    group: "Stack",
    defaultValue: {
      value: "0px",
      ref: "0"
    }
  }, {
    prop: "paddingTopExternal",
    label: "Padding top",
    type: "space",
    group: "Stack",
    defaultValue: {
      value: "0px",
      ref: "0"
    }
  }, {
    prop: "paddingBottomExternal",
    label: "Padding bottom",
    type: "space",
    group: "Stack",
    defaultValue: {
      value: "0px",
      ref: "0"
    }
  }, {
    prop: "edgeMarginProtection",
    label: "Snap to container margin",
    type: "boolean$",
    defaultValue: true,
    group: "Stack"
  }, // {
  //   prop: "edgeMargin",
  //   label: "Edge margin",
  //   type: "space",
  //   extraValues: ["edge"],
  //   group: "Properties",
  // },
  {
    prop: "Stack",
    label: "Stack",
    type: "component-fixed",
    componentType: "$stack"
  }]
}; // Let's build basic background card schema

var basicBackgroundCardSchema = JSON.parse(JSON.stringify(basicCardDefinition.schema)); // extra values don't have "fit-background"
// const sizeSchemaProp = basicBackgroundCardSchema.find(
//   (schemaProp) => schemaProp.prop === "size"
// ) as StringTokenSchemaProp;
// sizeSchemaProp.extraValues = ["grid-baseline", "fit-background"];
// background is required

var backgroundSchemaProp = basicBackgroundCardSchema.find(function (schemaProp) {
  return schemaProp.prop === "Background";
});
backgroundSchemaProp.required = true; // enable content

var enableContentSchemaProp = basicBackgroundCardSchema.find(function (schemaProp) {
  return schemaProp.prop === "enableContent";
});
enableContentSchemaProp.visible = true;
enableContentSchemaProp.defaultValue = false;
var basicBackgroundCardDefinition = _objectSpread$u(_objectSpread$u({}, basicCardDefinition), {}, {
  id: "$BasicCardBackground",
  schema: basicBackgroundCardSchema
});

React.createElement;

/** @jsx createElement */
function CardPlaceholderClient(props) {
  var _props$__fromEditor$p;

  var _props$__fromEditor$c = props.__fromEditor.components,
      Root = _props$__fromEditor$c.Root,
      ImageContainer = _props$__fromEditor$c.ImageContainer,
      TextContainer = _props$__fromEditor$c.TextContainer,
      AspectRatioMaker = _props$__fromEditor$c.AspectRatioMaker;
  var value = (_props$__fromEditor$p = props.__fromEditor.props.value) !== null && _props$__fromEditor$p !== void 0 ? _props$__fromEditor$p : "";
  return createElement(Root, null, createElement(AspectRatioMaker, null, createElement(ImageContainer, null, createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "40%",
      height: "50%"
    },
    viewBox: "0 0 150 110",
    fill: "currentColor"
  }, createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20 10C14.4772 10 10 14.4772 10 20V90C10 95.523 14.4772 100 20 100H130C135.523 100 140 95.523 140 90V20C140 14.4772 135.523 10 130 10H20ZM0 20C0 8.9543 8.95431 0 20 0H130C141.046 0 150 8.9543 150 20V90C150 101.046 141.046 110 130 110H20C8.95431 110 0 101.046 0 90V20ZM20 22.5C20 21.1193 21.1193 20 22.5 20H47.5C48.8807 20 50 21.1193 50 22.5V37.5454C50 38.9261 48.8807 40.0454 47.5 40.0454H22.5C21.1193 40.0454 20 38.9261 20 37.5454V22.5ZM121.01 55.8421C121.01 70.2073 109.365 81.853 94.9998 81.853C80.6346 81.853 68.9893 70.2073 68.9893 55.8421C68.9893 41.4769 80.6346 29.8315 94.9998 29.8315C109.365 29.8315 121.01 41.4769 121.01 55.8421ZM131.01 55.8421C131.01 75.7302 114.888 91.853 94.9998 91.853C75.1117 91.853 58.9893 75.7302 58.9893 55.8421C58.9893 35.954 75.1117 19.8315 94.9998 19.8315C114.888 19.8315 131.01 35.954 131.01 55.8421Z",
    fill: "currentColor"
  })))), createElement(TextContainer, null, value));
}

function ownKeys$u(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$t(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$u(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$u(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function cardPlaceholderStyles(config) {
  var paddingBottom = getPaddingBottomAndHeightFromAspectRatio(config.aspectRatio, undefined, "1");
  return {
    Root: box({
      position: "relative"
    }),
    AspectRatioMaker: box(_objectSpread$t({
      position: "relative"
    }, paddingBottom)),
    ImageContainer: box({
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: config.backgroundColor,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#D8D8D8"
    }),
    TextContainer: box(_objectSpread$t({
      marginTop: "12px"
    }, config.font)),
    __props: {
      value: config.value
    }
  };
}

var cardPlaceholderDefinition = {
  id: "$CardPlaceholder",
  label: "Card Placeholder",
  tags: ["card", "item"],
  componentCode: getCode(CardPlaceholderClient),
  styles: cardPlaceholderStyles,
  schema: [{
    prop: "font",
    type: "font",
    defaultValue: {
      ref: "$body",
      value: {}
    },
    visible: false
  }, {
    prop: "aspectRatio",
    label: "Aspect ratio",
    type: "stringToken",
    tokenId: "aspectRatios",
    defaultValue: {
      ref: "$portrait",
      value: ""
    },
    visible: false
  }, {
    prop: "backgroundColor",
    type: "color",
    defaultValue: {
      value: "rgb(242, 242, 242)"
    },
    visible: false
  }, {
    prop: "value",
    type: "string",
    defaultValue: "Product",
    visible: false
  }]
};

function ownKeys$t(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$s(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$t(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$t(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function pxValueNormalize(from, to) {
  return function (x) {
    var num = parseInt(x);

    if (isNaN(num)) {
      return null;
    }

    if (num < from || num > to) {
      return null;
    }

    return num.toString();
  };
}

var sectionWrapperFieldsProvider = function sectionWrapperFieldsProvider(options) {
  var extraEscapeMarginProps = {
    visible: true
  };

  if (options.fixedEscapeMarginValue === true) {
    extraEscapeMarginProps.visible = false;
    extraEscapeMarginProps.defaultValue = true;
  } else if (options.fixedEscapeMarginValue === false) {
    extraEscapeMarginProps.visible = false;
  }

  return [{
    prop: "containerMargin",
    label: "Container",
    type: "space",
    group: "Section margins",
    prefix: "containerMargin"
  }, {
    prop: "containerMaxWidth",
    // main image size
    label: "Max width",
    type: "stringToken",
    tokenId: "containerWidths",
    defaultValue: {
      ref: "none",
      value: "none"
    },
    group: "Section margins"
  }, _objectSpread$s({
    prop: "escapeMargin",
    label: "Escape",
    type: "boolean$",
    group: "Section margins"
  }, extraEscapeMarginProps), {
    prop: "hide",
    label: "Hide",
    type: "boolean$",
    group: "General"
  }, // HEADER
  {
    prop: "headerMode",
    label: "Variant",
    type: "select",
    options: [{
      value: "none",
      label: "No header"
    }, {
      value: "1-stack",
      label: "1 stack"
    }, {
      value: "2-stacks",
      label: "2 stacks"
    }],
    group: "Section Header"
  }, {
    prop: "layout1Stack",
    label: "Position",
    type: "select",
    group: "Section Header",
    options: [{
      value: "left",
      label: "Left" // icon: SSIcons.AlignLeft,
      // hideLabel: true,

    }, {
      value: "center",
      label: "Center" // icon: SSIcons.AlignCenter,
      // hideLabel: true,

    }, {
      value: "right",
      label: "Right" // icon: SSIcons.AlignRight,
      // hideLabel: true,

    }],
    visible: function visible(values) {
      return values.headerMode === "1-stack";
    }
  }, {
    prop: "layout2Stacks",
    label: "Position",
    type: "select$",
    group: "Section Header",
    options: [{
      value: "left-right",
      label: "left + right"
    }, {
      value: "center-right",
      label: "center + right"
    }, {
      value: "stacked-left",
      label: "stacked left"
    }, {
      value: "stacked-center",
      label: "stacked center"
    }, {
      value: "stacked-right",
      label: "stacked right"
    }, {
      value: "below-left",
      label: "above+below left"
    }, {
      value: "below-center",
      label: "above+below center"
    }, {
      value: "below-right",
      label: "above+below right"
    }],
    visible: function visible(values) {
      return values.headerMode === "2-stacks";
    }
  }, {
    prop: "layout2StacksVerticalAlign",
    label: "Align",
    type: "select$",
    group: "Section Header",
    options: ["center", "top", "bottom"],
    visible: function visible(values) {
      return values.headerMode === "2-stacks" && !values.layout2Stacks.startsWith("stacked") && !values.layout2Stacks.startsWith("below");
    }
  }, {
    prop: "headerStacksGap",
    label: "Stacks gap",
    type: "space",
    group: "Section Header",
    visible: function visible(values) {
      return values.headerMode === "2-stacks" && values.layout2Stacks && values.layout2Stacks.startsWith("stacked");
    },
    defaultValue: {
      value: "12px",
      ref: "12"
    }
  }, {
    prop: "headerSectionGap",
    label: "Gap",
    type: "space",
    group: "Section Header",
    visible: function visible(values) {
      return values.headerMode !== "none";
    },
    defaultValue: {
      value: "12px",
      ref: "12"
    }
  }, {
    prop: "footerSectionGap",
    label: "Bottom gap",
    type: "space",
    group: "Section Header",
    visible: function visible(values) {
      return values.headerMode === "2-stacks" && values.layout2Stacks && values.layout2Stacks.startsWith("below");
    },
    defaultValue: {
      value: "12px",
      ref: "12"
    }
  },
  /**
   * The problem is that we can't show label based on values :(
   */
  {
    prop: "HeaderStack",
    label: "Stack",
    type: "component-fixed",
    componentType: "$stack"
  }, {
    prop: "HeaderSecondaryStack",
    label: "Stack",
    type: "component-fixed",
    componentType: "$stack"
  }, // section background
  {
    prop: "Background__",
    label: "Outer Background",
    type: "component",
    group: "Section background",
    componentTypes: ["image"],
    visible: true
  }, {
    prop: "padding",
    label: "Inner margin",
    type: "space",
    group: "Section background",
    visible: function visible(values) {
      return values.Background__ && values.Background__.length > 0;
    },
    defaultValue: {
      value: "24px",
      ref: "24"
    }
  }];
};
var sectionWrapperFields = sectionWrapperFieldsProvider({});
var sectionWrapperFieldsWithoutEscapeMargin = sectionWrapperFieldsProvider({
  fixedEscapeMarginValue: true
});
var widthScalePreview = ["100px", "200px", "300px", "400px", "500px", "600px", "700px", "800px", "900px", "1000px", "100%", "auto"];
var maxWidthScale = ["max"];

for (var i$1 = 2; i$1 < 8; i$1++) {
  maxWidthScale.push(i$1 * 32 + "px");
}

for (var _i = 4; _i < 24; _i++) {
  maxWidthScale.push(_i * 64 + "px");
}

var tokenFields = function tokenFields(defaultWidth) {
  return [{
    prop: "name",
    type: "text"
  }, {
    prop: "paddingTop",
    type: "space"
  }, {
    prop: "paddingBottom",
    type: "space"
  }, {
    prop: "paddingLeft",
    type: "space"
  }, {
    prop: "paddingRight",
    type: "space"
  }, {
    prop: "backgroundColor",
    type: "color",
    defaultValue: {
      ref: "transparent",
      value: "transparent"
    }
  }, {
    prop: "width",
    type: "select$",
    options: widthScalePreview,
    defaultValue: defaultWidth
  }];
};

var bannerFields = [{
  prop: "cornerRadius",
  label: "Corner radius",
  type: "select$",
  options: Array.from(Array(30).keys()).map(function (x) {
    return x.toString();
  }),
  group: "General"
}, {
  prop: "SideImage",
  label: "Cover",
  type: "component",
  componentTypes: ["image"],
  visible: true,
  group: "Cover"
}, {
  prop: "sideImagePosition",
  // main image size
  label: "Position",
  type: "select$",
  options: [{
    label: "Left",
    value: "left"
  }, {
    label: "Right",
    value: "right"
  }, {
    label: "Top",
    value: "top"
  }, {
    label: "Bottom",
    value: "bottom"
  }, {
    label: "Background",
    value: "background"
  }],
  // there is no "fit-content", because it doesn't make sense on mobile and it's actually very rare. If you want image, you don't want it to have some super narrow height, so the height is kind of "minimal" heihgt only.
  group: "Cover",
  visible: function visible(values) {
    return values.SideImage.length > 0;
  }
}, {
  prop: "sideImageSize",
  // main image size
  label: "Aspect ratio",
  type: "stringToken",
  tokenId: "aspectRatios",
  // "natural"
  extraValues: ["grid-baseline", "natural", "100vh"],
  group: "Cover",
  defaultValue: {
    ref: "$landscape",
    value: "whatever" // will be normalized anyway

  },
  // defaultValue: "landscape",
  visible: function visible(values) {
    return values.SideImage.length > 0;
  }
}, {
  prop: "size",
  // main image size
  label: "Size",
  type: "stringToken",
  tokenId: "aspectRatios",
  extraValues: ["grid-baseline", "natural", "fit-content", "100vh"],
  group: "Stack",
  visible: function visible(values) {
    return values.SideImage.length === 0;
  }
}, {
  prop: "contentPositionInBackgroundMode",
  label: "Position",
  type: "select$",
  options: ["top-left", "top-center", "top-right", "center-left", "center-center", "center-right", "bottom-left", "bottom-center", "bottom-right"],
  group: "Stack",
  visible: function visible(values) {
    return values.SideImage.length > 0 && values.sideImagePosition === "background";
  },
  defaultValue: "bottom-center"
}, {
  prop: "contentHorizontalMarginInBackgroundMode",
  label: "Horizontal margin",
  type: "space",
  group: "Stack",
  visible: function visible(values) {
    return values.SideImage.length > 0 && values.sideImagePosition === "background";
  },
  defaultValue: {
    value: "24px",
    ref: "24"
  }
}, {
  prop: "contentVerticalMarginInBackgroundMode",
  label: "Vertical margin",
  type: "space",
  group: "Stack",
  visible: function visible(values) {
    return values.SideImage.length > 0 && values.sideImagePosition === "background";
  },
  defaultValue: {
    value: "24px",
    ref: "24"
  }
}, {
  prop: "Background",
  label: "Background",
  type: "component",
  componentTypes: ["image"],
  visible: true,
  group: "Stack"
},
/**
 * Offset horizontal, vertical and corner radius make sense ONLY if background is set. Otherwise, they don't make sense. We should show as little fields as possible!!!
 */
{
  prop: "offsetHorizontal",
  label: "Horizontal margin",
  type: "space",
  group: "Stack",
  visible: function visible(allValues) {
    return allValues.Background.length > 0 || allValues.SideImage.length > 0 && (allValues.sideImagePosition === "left" || allValues.sideImagePosition === "right"); // if side image is enabled and there is no background, this properly is only left gap (for image left) or right gap (for image right)
  },
  defaultValue: {
    value: "24px",
    ref: "24"
  }
}, {
  prop: "offsetHorizontalForVerticalImagePosition",
  label: "Horizontal margin",
  type: "space",
  group: "Stack",
  visible: function visible(allValues) {
    return allValues.Background.length === 0 && allValues.SideImage.length > 0 && (allValues.sideImagePosition === "top" || allValues.sideImagePosition === "bottom");
  },
  defaultValue: {
    value: "0px",
    ref: "0"
  }
}, {
  prop: "offsetVertical",
  label: "Vertical margin",
  type: "space",
  group: "Stack",
  visible: function visible(allValues) {
    return allValues.Background.length > 0 || allValues.SideImage.length > 0 && (allValues.sideImagePosition === "top" || allValues.sideImagePosition === "bottom"); // if side image is enabled and there is no background, this properly is only left gap (for image left) or right gap (for image right)
  },
  defaultValue: {
    value: "24px",
    ref: "24"
  }
}, {
  prop: "Stack",
  label: "Stack",
  type: "component-fixed",
  componentType: "$stack"
}, {
  prop: "stackAlign",
  label: "Align",
  type: "radio-group$",
  options: [{
    value: "left",
    label: "Left",
    icon: SSIcons.AlignLeft,
    hideLabel: true
  }, {
    value: "center",
    label: "Center",
    icon: SSIcons.AlignCenter,
    hideLabel: true
  }, {
    value: "right",
    label: "Right",
    icon: SSIcons.AlignRight,
    hideLabel: true
  }],
  defaultValue: "left",
  group: "Stack"
}, {
  prop: "positionHorizontal",
  label: "Horizontal position",
  type: "select$",
  options: [{
    value: "left",
    label: "Left"
  }, {
    value: "center",
    label: "Center"
  }, {
    value: "right",
    label: "Right"
  }],
  group: "Stack"
}, {
  prop: "verticalAlign",
  label: "Vertical position",
  type: "select$",
  options: [{
    value: "top",
    label: "Top"
  }, {
    value: "center",
    label: "Center"
  }, {
    value: "bottom",
    label: "Bottom"
  }],
  group: "Stack",
  visible: function visible(values) {
    return values.SideImage.length === 0 || values.SideImage.length > 0 && (values.sideImagePosition === "left" || values.sideImagePosition === "right"); // if side image is enabled and there is no background, this properly is only left gap (for image left) or right gap (for image right)
  }
}, buttonActionSchemaProp];
var components = [// root sections
{
  id: "$Zone",
  schema: [{
    prop: "blocks",
    type: "component-collection",
    componentTypes: ["section"]
  }],
  styles: function styles() {
    return {};
  },
  tags: []
}, {
  id: "$RootSections",
  styles: $rootSectionStyles,
  tags: ["root", "notrace"],
  editing: function editing(config, _editing) {
    var data = _editing.components.data;
    return {
      components: {
        data: {
          items: data.items.map(function (item, index) {
            var fields = item.fields;

            if (index > 0) {
              fields = [_objectSpread$s(_objectSpread$s({}, data.items[index - 1].fields[1]), {}, {
                label: "Top margin"
              }), fields[1]];
            }

            return {
              fields: fields
            };
          })
        }
      }
    };
  },
  schema: [{
    prop: "data",
    label: "data",
    type: "component-collection",
    componentTypes: ["section"],
    itemFields: [{
      prop: "topMargin",
      // property only for first value!
      label: "Top",
      type: "space",
      group: "Section margins",
      defaultValue: {
        value: "0px",
        ref: "0"
      },
      autoConstant: 24
    }, {
      prop: "bottomMargin",
      label: "Bottom",
      type: "space",
      group: "Section margins",
      defaultValue: {
        value: "32px",
        ref: "32"
      },
      autoConstant: 24
    }]
  }]
}, {
  id: "$RootGrid",
  styles: $rootGridStyles,
  editing: function editing() {
    return {
      components: {
        data: {
          noInline: true
        }
      }
    };
  },
  tags: ["root", "notrace"],
  schema: [{
    prop: "data",
    label: "data",
    type: "component-fixed",
    componentType: "$Grid"
  }]
}, {
  id: "$RootTokens",
  styles: function styles() {
    return {};
  },
  tags: ["root", "notrace"],
  schema: [{
    prop: "data",
    label: "data",
    type: "component-collection",
    componentTypes: ["token"]
  }]
}, textEditableComponent, {
  id: "$icon",
  styles: $iconStyles,
  tags: ["symbol", "notrace"],
  schema: [{
    prop: "icon",
    type: "icon",
    label: "Icon"
  },
  /**
   * Icon is tricky.
   *
   * 1. First, icon is of type "symbol", we might have different kinds of symbols in the future, animated, etc.
   * 2. When we have component like IconButton (built-in) it's very natural to set color for icon symbol. At the end of the day we don't want to have color for both IconButton AND Icon. It doesn't make sense.
   * 3. However, sometimes custom button might want to FORCE a color for an icon.
   * 4. Auto color means that color is set by a parent component (always custom). By default it's set to "false" for built-in Icon Button.
   * 5. Probably later we should do this via some context.
   */
  {
    prop: "color",
    label: "Color",
    type: "color",
    group: "Color",
    visible: function visible(values) {
      return !!values.passed_allowColor;
    },
    defaultValue: {
      ref: "$dark",
      value: "black"
    }
  }]
}, {
  id: "$twoItems",
  tags: ["item", "notrace"],
  label: "Left / Right layout",
  pasteSlots: ["Items"],
  styles: $twoItems,
  editing: function editing(values, _editing2) {
    return {
      components: {
        Items: {
          items: values.Items.map(function (value, index) {
            return {
              direction: "horizontal",
              fields: _editing2.components.Items.items[index].fields
            };
          })
        }
      }
    };
  },
  schema: [{
    prop: "gap",
    type: "space",
    label: "Gap"
  }, {
    prop: "verticalAlign",
    type: "radio-group$",
    options: [{
      value: "flex-start",
      label: "Top"
    }, {
      value: "center",
      label: "Center"
    }, {
      value: "flex-end",
      label: "Bottom"
    }],
    label: "Vertical align"
  }, {
    prop: "Items",
    label: "Items",
    type: "component-collection",
    componentTypes: ["item"],
    itemFields: [{
      prop: "columnWidth",
      label: "Column width",
      type: "select$",
      options: ["fill", "32", "64", "96", "128", "160", "192", "224", "256", "288", "320", "352", "384", "416", "448", "480", "512"]
    }, {
      prop: "itemWidth",
      label: "Item max width",
      type: "select$",
      options: ["fill", "32", "64", "96", "128", "160", "192", "224", "256", "288", "320", "352", "384", "416", "448", "480", "512"]
    }, {
      prop: "itemAlign",
      label: "Item align",
      type: "radio-group$",
      options: [{
        value: "flex-start",
        label: "Left",
        icon: SSIcons.AlignLeft,
        hideLabel: true
      }, {
        value: "center",
        label: "Center",
        icon: SSIcons.AlignCenter,
        hideLabel: true
      }, {
        value: "flex-end",
        label: "Right",
        icon: SSIcons.AlignRight,
        hideLabel: true
      }],
      defaultValue: "left"
    }]
  }]
}, {
  id: "$separator",
  tags: ["item", "notrace"],
  label: "Separator",
  styles: $separatorStyles,
  componentCode: getCode(Separator),
  schema: [{
    prop: "color",
    type: "color",
    label: "Color",
    defaultValue: {
      ref: "black",
      value: "black"
    }
  }, {
    prop: "height",
    label: "Stroke width",
    type: "select$",
    options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16"]
  }]
}, {
  id: "$backgroundColor",
  label: "Color",
  tags: ["image", "notrace"],
  styles: $backgroundColorStyles,
  schema: [{
    prop: "color",
    label: "Color",
    type: "color"
  }],
  getEditorSidebarPreview: function getEditorSidebarPreview(config, _ref) {
    var _activeColorValue$ref;

    var breakpointIndex = _ref.breakpointIndex;
    var activeColorValue = responsiveValueForceGet(config.color, breakpointIndex);

    if (!activeColorValue) {
      return;
    }

    return {
      type: "solid",
      color: activeColorValue.value,
      description: (_activeColorValue$ref = activeColorValue.ref) !== null && _activeColorValue$ref !== void 0 ? _activeColorValue$ref : activeColorValue.value
    };
  }
}, imageComponentDefinition, videoComponentDefinition, {
  id: "$buttons",
  tags: ["item", "notrace"],
  pasteSlots: ["Buttons"],
  styles: $buttonsStyles,
  editing: function editing(values) {
    return {
      components: {
        Buttons: {
          items: values.Buttons.map(function () {
            return {
              direction: "horizontal"
            };
          })
        }
      }
    };
  },
  schema: [{
    prop: "verticalLayout",
    label: "Vertical layout",
    type: "boolean"
  }, {
    prop: "gap",
    label: "Gap",
    type: "space"
  }, {
    prop: "Buttons",
    label: "Buttons",
    type: "component-collection",
    componentTypes: ["button"]
  }]
}, {
  id: "$stack",
  tags: ["notrace"],
  styles: $stackStyles,
  pasteSlots: ["Items"],
  editing: function editing(config, _editing3) {
    var items = _editing3.components.Items.items;

    var fields = _toConsumableArray$2(_editing3.fields);

    return {
      fields: fields,
      components: {
        Items: {
          items: items.map(function (item, index) {
            var maxWidth = item.fields.find(function (field) {
              return field.schemaProp.prop === "width";
            });
            var marginBottom = item.fields.find(function (field) {
              return field.schemaProp.prop === "marginBottom";
            });
            var align = item.fields.find(function (field) {
              return field.schemaProp.prop === "align";
            });
            var fields;

            if (index === 0) {
              fields = [maxWidth, marginBottom];
            } else {
              var topMargin = _objectSpread$s(_objectSpread$s({}, items[index - 1].fields.find(function (field) {
                return field.schemaProp.prop === "marginBottom";
              })), {}, {
                label: "Top"
              });

              if (index !== items.length - 1) {
                fields = [maxWidth, topMargin, marginBottom];
              } else {
                fields = [maxWidth, topMargin];
              }
            }

            if (!config.passedAlign) {
              fields.push(align);
            }

            return _objectSpread$s(_objectSpread$s({}, item), {}, {
              fields: fields
            });
          })
        }
      }
    };
  },
  schema: [{
    prop: "Items",
    label: "Items",
    type: "component-collection",
    componentTypes: ["item"],
    itemFields: [{
      prop: "width",
      label: "Max width",
      type: "select$",
      options: maxWidthScale,
      defaultValue: "512px",
      group: "Size"
    }, {
      prop: "marginBottom",
      label: "Bottom",
      type: "space",
      group: "Margins"
    }, {
      prop: "align",
      label: "Align",
      type: "radio-group$",
      options: [{
        value: "left",
        label: "Left",
        icon: SSIcons.AlignLeft,
        hideLabel: true
      }, {
        value: "center",
        label: "Center",
        icon: SSIcons.AlignCenter,
        hideLabel: true
      }, {
        value: "right",
        label: "Right",
        icon: SSIcons.AlignRight,
        hideLabel: true
      }],
      defaultValue: "left",
      group: "Layout"
    }]
  }]
}, {
  id: "$BannerSection",
  tags: ["section", "notrace"],
  label: "Banner",
  componentCode: getCode(SectionWrapper),
  styles: $sectionWrapperStyles,
  editing: sectionWrapperEditing,
  pasteSlots: ["Component"],
  schema: [].concat(_toConsumableArray$2(sectionWrapperFields), [{
    prop: "Component",
    type: "component-fixed",
    componentType: "$BannerCard"
  }])
}, {
  id: "$BannerSection2",
  tags: ["section", "notrace"],
  label: "Banner",
  componentCode: getCode(SectionWrapper),
  styles: $sectionWrapperStyles,
  editing: sectionWrapperEditing,
  pasteSlots: ["Component"],
  schema: [].concat(_toConsumableArray$2(sectionWrapperFields), [{
    prop: "Component",
    type: "component-fixed",
    componentType: "$BannerCard2"
  }])
}, {
  id: "$Grid",
  tags: ["section", "notrace"],
  label: "Grid / Slider",
  icon: SSIcons.Grid3x3,
  componentCode: getCode(SectionWrapper),
  styles: $sectionWrapperStyles,
  editing: sectionWrapperEditing,
  schema: [].concat(_toConsumableArray$2(sectionWrapperFields.filter(function (x) {
    return x.group === "General";
  })), [{
    prop: "Component",
    type: "component-fixed",
    componentType: "$GridCard",
    importFields: true
  }], _toConsumableArray$2(sectionWrapperFields.filter(function (x) {
    return x.group !== "General";
  }))),
  pasteSlots: ["Component"]
}, {
  id: "$TwoCards",
  tags: ["section", "notrace"],
  label: "Two Cards",
  componentCode: getCode(SectionWrapper),
  styles: $sectionWrapperStyles,
  editing: sectionWrapperEditing,
  schema: [].concat(_toConsumableArray$2(sectionWrapperFieldsWithoutEscapeMargin), [{
    prop: "Component",
    type: "component-fixed",
    componentType: "$TwoCardsCard"
  }])
}, {
  id: "$GridCard",
  pasteSlots: ["Cards"],
  tags: ["card"],
  componentCode: getCode(Grid2),
  styles: styles$b,
  auto: gridAuto,
  editing: function editing(values, editingInfo, _ref2) {
    var fields = _ref2.fields;
    var leftArrowFields = [fields.leftArrowPlacement];

    if (values.leftArrowPlacement !== "center") {
      leftArrowFields.push(fields.leftArrowOffset);
    }

    var rightArrowFields = [fields.rightArrowPlacement];

    if (values.rightArrowPlacement !== "center") {
      rightArrowFields.push(fields.rightArrowOffset);
    }

    var cards = editingInfo.components.Cards;
    return {
      fields: editingInfo.fields.filter(function (field) {
        return !field.prop.startsWith("rightArrow") && !field.prop.startsWith("leftArrow");
      }),
      components: {
        Cards: {
          items: cards.items.map(function (cardItem) {
            return _objectSpread$s(_objectSpread$s({}, cardItem), {}, {
              direction: "horizontal"
            });
          })
        },
        LeftArrow: {
          fields: leftArrowFields
        },
        RightArrow: {
          fields: rightArrowFields
        }
      }
    };
  },
  schema: [{
    prop: "Cards",
    type: "component-collection",
    componentTypes: ["card"],
    itemFields: [{
      prop: "itemSize",
      label: "Item size",
      group: "General",
      type: "select$",
      options: ["1x1", "2x1", "2x2"]
    }, {
      prop: "verticalAlign",
      label: "Vertical align",
      group: "General",
      type: "select$",
      options: ["auto", "top", "center", "bottom", "stretch"]
    }]
  }, {
    prop: "variant",
    label: "Variant",
    type: "radio-group$",
    group: "Grid / Slider",
    options: [{
      value: "grid",
      label: "Grid"
    }, {
      value: "slider",
      label: "Slider"
    }]
  }, {
    prop: "numberOfItems",
    label: "Visible items",
    type: "stringToken",
    tokenId: "numberOfItemsInRow",
    group: "Grid / Slider" // visible: (values, { editorContext }) => {
    //   if (values.variant === "grid") {
    //     return true;
    //   }
    //   return editorContext.breakpointIndex !== "xs";
    // },

  }, {
    prop: "fractionalItemWidth",
    label: "Fraction",
    type: "select$",
    options: [{
      value: "1",
      label: "none"
    }, {
      value: "1.25",
      label: "25%"
    }, {
      value: "1.5",
      label: "50%"
    }, {
      value: "1.75",
      label: "75%"
    } // { value: "2", label: "50%" },
    // { value: "1.66", label: "60%" },
    // { value: "1.43", label: "70%" },
    // { value: "1.25", label: "80%" },
    // { value: "1.11", label: "90%" },
    // { value: "1", label: "100%" },
    ],
    defaultValue: "1.25",
    group: "Grid / Slider",
    visible: function visible(values, _ref3) {
      var editorContext = _ref3.editorContext;

      if (values.variant === "grid") {
        return false;
      }

      return editorContext.breakpointIndex === "xs";
    }
  }, {
    prop: "columnGap",
    label: "Gap",
    type: "space",
    group: "Grid / Slider",
    defaultValue: {
      ref: "16",
      value: "16px"
    },
    autoConstant: 16
  }, {
    prop: "rowGap",
    label: "Gap vertical",
    type: "space",
    visible: function visible(values) {
      return values.variant === "grid";
    },
    group: "Grid / Slider",
    defaultValue: {
      ref: "16",
      value: "16px"
    },
    autoConstant: 16
  }, {
    prop: "verticalAlign",
    label: "Vertical align",
    type: "select$",
    options: ["top", "center", "bottom", "stretch"],
    group: "Grid / Slider"
  }, {
    prop: "showSliderControls",
    label: "Show slider controls?",
    type: "boolean$",
    visible: false,
    group: "Grid / Slider"
  }, {
    prop: "shouldSliderItemsBeVisibleOnMargin",
    label: "Show items on margins?",
    type: "boolean$",
    visible: function visible(values) {
      return values.variant === "slider";
    },
    group: "Grid / Slider",
    defaultValue: true
  }, {
    prop: "gridMainObjectAspectRatio",
    label: "Main object aspect ratio",
    type: "stringToken",
    tokenId: "aspectRatios",
    group: "Grid / Slider",
    defaultValue: {
      ref: "$gridMainObjectDefault",
      value: "whatever" // will be normalized anyway

    },
    visible: false
  }, {
    prop: "borderEnabled",
    label: "Enable",
    type: "boolean",
    group: "Border"
  }, {
    prop: "borderColor",
    label: "Color",
    type: "color",
    defaultValue: {
      ref: "$dark",
      value: "black"
    },
    visible: function visible(x) {
      return !!x.borderEnabled;
    },
    group: "Border"
  }, {
    prop: "borderTop",
    label: "Top width",
    type: "select$",
    options: ["0", "1", "2", "3", "4", "5", "6", "7", "8"],
    defaultValue: "1",
    visible: function visible(x) {
      return !!x.borderEnabled;
    },
    group: "Border"
  }, {
    prop: "borderBottom",
    label: "Bottom width",
    type: "select$",
    options: ["0", "1", "2", "3", "4", "5", "6", "7", "8"],
    defaultValue: "1",
    visible: function visible(x) {
      return !!x.borderEnabled;
    },
    group: "Border"
  }, {
    prop: "borderLeft",
    label: "Left width",
    type: "select$",
    options: ["0", "1", "2", "3", "4", "5", "6", "7", "8"],
    defaultValue: "1",
    visible: function visible(x) {
      return !!x.borderEnabled;
    },
    group: "Border"
  }, {
    prop: "borderRight",
    label: "Right width",
    type: "select$",
    options: ["0", "1", "2", "3", "4", "5", "6", "7", "8"],
    defaultValue: "1",
    visible: function visible(x) {
      return !!x.borderEnabled;
    },
    group: "Border"
  }, {
    prop: "borderInner",
    label: "Inner width",
    type: "select$",
    options: ["0", "1", "2", "3", "4", "5", "6", "7", "8"],
    defaultValue: "1",
    visible: function visible(x) {
      return !!x.borderEnabled;
    },
    group: "Border"
  }, {
    prop: "paddingTop",
    label: "Top",
    type: "space",
    defaultValue: {
      ref: "0",
      value: "0px"
    },
    visible: function visible(x) {
      return !!x.borderEnabled && x.borderTop !== "0";
    },
    group: "Padding"
  }, {
    prop: "paddingBottom",
    label: "Bottom",
    type: "space",
    defaultValue: {
      ref: "0",
      value: "0px"
    },
    visible: function visible(x) {
      return !!x.borderEnabled && x.borderBottom !== "0";
    },
    group: "Padding"
  }, {
    prop: "paddingLeft",
    label: "Left",
    type: "space",
    defaultValue: {
      ref: "0",
      value: "0px"
    },
    visible: function visible(x) {
      return !!x.borderEnabled && (x.borderLeft !== "0" || x.borderTop !== "0" || x.borderBottom !== "0");
    },
    group: "Padding"
  }, {
    prop: "paddingRight",
    label: "Right",
    type: "space",
    defaultValue: {
      ref: "0",
      value: "0px"
    },
    visible: function visible(x) {
      return !!x.borderEnabled && (x.borderRight !== "0" || x.borderTop !== "0" || x.borderBottom !== "0");
    },
    group: "Padding"
  }, // Left arrow properties
  {
    prop: "LeftArrow",
    type: "component",
    componentTypes: ["button"],
    required: true
  }, {
    prop: "leftArrowPlacement",
    label: "Left arrow placement",
    type: "select$",
    options: ["inside", "center", "outside", "screen-edge"],
    group: "Placement"
  }, {
    prop: "leftArrowOffset",
    label: "Left arrow offset",
    type: "space",
    group: "Placement"
  }, // Right arrow properties
  {
    prop: "RightArrow",
    type: "component",
    componentTypes: ["button"],
    required: true
  }, {
    prop: "rightArrowPlacement",
    label: "Right arrow placement",
    type: "select$",
    options: ["inside", "center", "outside", "screen-edge"],
    group: "Placement"
  }, {
    prop: "rightArrowOffset",
    label: "Right arrow offset",
    type: "space",
    group: "Placement"
  }]
}, {
  id: "$TokenSection",
  tags: ["token", "notrace"],
  componentCode: getCode(Token),
  styles: styles$e,
  schema: [].concat(_toConsumableArray$2(tokenFields("100%")), [{
    prop: "Component",
    type: "component",
    componentTypes: ["section"]
  }])
}, {
  id: "$TokenCard",
  tags: ["token", "notrace"],
  componentCode: getCode(Token),
  styles: styles$e,
  schema: [].concat(_toConsumableArray$2(tokenFields("600px")), [{
    prop: "Component",
    type: "component",
    componentTypes: ["card"]
  }])
}, {
  id: "$TokenButton",
  tags: ["token"],
  componentCode: getCode(Token),
  styles: styles$e,
  schema: [].concat(_toConsumableArray$2(tokenFields("auto")), [{
    prop: "Component",
    type: "component",
    componentTypes: ["button"]
  }])
}, {
  id: "$TokenColor",
  tags: ["token", "notrace"],
  componentCode: getCode(TokenColor),
  styles: styles$d,
  schema: [{
    prop: "name",
    type: "text"
  }, {
    prop: "color",
    label: "Color hex (#xxxxxx)",
    type: "text",
    defaultValue: "#ffffff"
  }]
}, {
  id: "$TokenFont",
  tags: ["token", "notrace"],
  componentCode: getCode(TokenFont),
  styles: styles$c,
  schema: [{
    prop: "name",
    type: "text"
  }, {
    prop: "exampleTextLength",
    type: "radio-group",
    options: ["short", "medium", "long"]
  }, {
    prop: "family",
    type: "text",
    defaultValue: "sans-serif"
  }, {
    prop: "weight",
    type: "text",
    defaultValue: "500"
  }, {
    prop: "size",
    type: "space"
  }, {
    prop: "letterSpacing",
    type: "text",
    defaultValue: "0"
  }, {
    prop: "isUppercase",
    type: "boolean"
  }]
}, {
  id: "$BannerCard",
  tags: ["card"],
  componentCode: getCode(BannerCard),
  pasteSlots: ["SideImage", "Stack"],
  styles: styles$h,
  auto: bannerCardAuto,
  schema: bannerFields,
  editing: function editing() {
    return {
      components: {
        SideImage: {
          noInline: true
        },
        Background: {
          noInline: true
        },
        Stack: {
          noInline: true
        }
      }
    };
  }
}, {
  id: "$TwoCardsCard",
  tags: ["card"],
  auto: twoCardsAuto,
  componentCode: getCode(TwoCards),
  styles: styles$f,
  change: twoCardsChange,
  editing: function editing(values, editingInfo, _ref4) {
    var fields = _ref4.fields;
    fields.card1Width.hidden = true;
    fields.card1EscapeMargin.hidden = true;
    fields.card2Width.hidden = true;
    fields.card2EscapeMargin.hidden = true;
    fields.verticalOffset.hidden = values.verticalLayout !== "irregular";
    fields.gap.hidden = !(parseInt(values.card1Width) + parseInt(values.card2Width) === TWO_CARDS_COL_NUM && !values.collapse);
    fields.verticalGap.hidden = !values.collapse;
    return {
      fields: editingInfo.fields,
      components: {
        Card1: {
          fields: [_objectSpread$s(_objectSpread$s({}, fields.card1Width), {}, {
            hidden: false,
            group: "Placement and size",
            label: "Width"
          }), _objectSpread$s(_objectSpread$s({}, fields.card1EscapeMargin), {}, {
            hidden: false,
            group: "Placement and size",
            label: "Escape margin"
          }), _objectSpread$s(_objectSpread$s({}, fields.gap), {}, {
            group: "Placement and size",
            label: "Gap"
          }), _objectSpread$s(_objectSpread$s({}, fields.verticalLayout), {}, {
            group: "Placement and size"
          }), _objectSpread$s(_objectSpread$s({}, fields.verticalOffset), {}, {
            group: "Placement and size"
          })]
        },
        Card2: {
          fields: [_objectSpread$s(_objectSpread$s({}, fields.card2Width), {}, {
            hidden: false,
            group: "Placement and size",
            label: "Width"
          }), _objectSpread$s(_objectSpread$s({}, fields.card2EscapeMargin), {}, {
            hidden: false,
            group: "Placement and size",
            label: "Escape margin"
          }), _objectSpread$s(_objectSpread$s({}, fields.gap), {}, {
            group: "Placement and size",
            label: "Gap"
          }), _objectSpread$s(_objectSpread$s({}, fields.verticalLayout), {}, {
            group: "Placement and size"
          }), _objectSpread$s(_objectSpread$s({}, fields.verticalOffset), {}, {
            group: "Placement and size"
          })]
        }
      }
    };
  },
  schema: [{
    prop: "Card1",
    type: "component",
    componentTypes: ["card"]
  }, {
    prop: "Card2",
    type: "component",
    componentTypes: ["card"]
  }, {
    prop: "card1Width",
    type: "select$",
    options: ["4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"],
    defaultValue: "12"
  }, {
    prop: "card1EscapeMargin",
    type: "boolean$",
    label: "Escape margin"
  }, {
    prop: "card2Width",
    type: "select$",
    options: range(4, 20).map(String),
    defaultValue: "12",
    label: "Width"
  }, {
    prop: "card2EscapeMargin",
    type: "boolean$",
    label: "Escape margin"
  }, {
    prop: "verticalLayout",
    type: "select$",
    options: [{
      label: "Top",
      value: "align-top"
    }, {
      label: "Bottom",
      value: "align-bottom"
    }, {
      label: "Center",
      value: "center"
    }, {
      label: "Fit",
      value: "fit"
    }, {
      label: "Irregular",
      value: "irregular"
    }],
    label: "Align",
    group: "Layout"
  }, {
    prop: "verticalOffset",
    label: "Offset",
    type: "select$",
    options: Array.from(Array(25).keys()).map(function (x) {
      return "".concat(x - 12);
    }),
    defaultValue: "-4",
    group: "Layout"
  }, {
    prop: "collapse",
    label: "Stack cards",
    type: "boolean$",
    group: "Layout"
  }, {
    prop: "gap",
    label: "Gap",
    type: "space",
    defaultValue: {
      value: "32px",
      ref: "32"
    },
    group: "Layout"
  }, {
    prop: "verticalGap",
    label: "Gap",
    type: "space",
    defaultValue: {
      value: "24px",
      ref: "24"
    },
    group: "Layout"
  }]
}, {
  id: "$IconButton",
  tags: ["button"],
  componentCode: getCode(IconButton$1),
  styles: styles$a,
  editing: function editing() {
    return {
      components: {
        symbol: {
          noInline: true
        }
      }
    };
  },
  schema: [buttonActionSchemaProp, buttonLabelSchemaProp, buttonRequiredIconSchemaProp, {
    prop: "symbolSize",
    label: "Symbol size",
    type: "select$",
    options: ["8", "16", "20", "24", "32", "40", "48", "64"],
    defaultValue: "24",
    group: "Properties" // visible: false FIXME: when we can pass icon size to the icon we will hide this field from here

  }, {
    prop: "buttonSize",
    label: "Button size",
    type: "space",
    defaultValue: {
      value: "32px",
      ref: "32"
    },
    group: "Properties"
  }, {
    prop: "shape",
    type: "select",
    options: ["circle", "square"],
    group: "Properties"
  }, {
    prop: "backgroundColor",
    label: "Background color",
    type: "color",
    group: "Properties",
    defaultValue: {
      ref: "transparent",
      value: "transparent"
    }
  }, {
    prop: "border",
    label: "Border width",
    type: "select",
    options: ["0", "1", "2", "3", "4", "5", "6", "7", "8"]
  }, {
    prop: "borderColor",
    label: "Border color",
    type: "color",
    visible: function visible(values) {
      return values.border !== "0";
    }
  }]
}, {
  id: "$IconButton2",
  label: "Basic Icon Button",
  tags: ["button"],
  componentCode: getCode(IconButton),
  styles: styles$9,
  editing: function editing() {
    return {
      components: {
        symbol: {
          noInline: true
        }
      }
    };
  },
  schema: [buttonActionSchemaProp, _objectSpread$s(_objectSpread$s({}, buttonRequiredIconSchemaProp), {}, {
    group: "Symbol"
  }), {
    prop: "hasBackground",
    type: "boolean",
    group: "Background",
    label: "Enabled",
    defaultValue: true
  }, {
    prop: "backgroundColor",
    type: "color",
    defaultValue: {
      ref: "$neutral",
      value: "grey"
    },
    visible: function visible(values) {
      return !!values.hasBackground;
    },
    group: "Background",
    label: "Color"
  }, {
    prop: "hasBorder",
    type: "boolean",
    group: "Border",
    label: "Enabled"
  }, {
    prop: "borderWidth",
    type: "string",
    defaultValue: "1",
    group: "Border",
    label: "Width",
    visible: function visible(values) {
      return !!values.hasBorder;
    },
    normalize: pxValueNormalize(1, 16)
  }, {
    prop: "borderColor",
    type: "color",
    defaultValue: {
      ref: "$dark",
      value: "black"
    },
    group: "Border",
    label: "Color",
    visible: function visible(values) {
      return !!values.hasBorder;
    }
  }, {
    prop: "symbolSize",
    label: "Symbol size",
    type: "string$",
    defaultValue: "24",
    group: "Size",
    normalize: pxValueNormalize(8, 128)
  }, {
    prop: "buttonSize",
    label: "Button size",
    type: "string$",
    defaultValue: "32",
    group: "Size",
    visible: function visible(values) {
      return values.hasBorder || values.hasBackground;
    }
  }, {
    prop: "shape",
    type: "select",
    options: ["circle", "square"],
    group: "Shape",
    label: "Shape",
    visible: function visible(values) {
      return values.hasBorder || values.hasBackground;
    }
  }, _objectSpread$s(_objectSpread$s({}, buttonLabelSchemaProp), {}, {
    group: "Accessibility"
  })]
}, {
  id: "$Placeholder",
  tags: ["card", "notrace"],
  componentCode: getCode(Placeholder),
  styles: styles$8,
  schema: []
}, {
  id: "$ProductCard",
  tags: ["card"],
  componentCode: getCode(ProductCard),
  styles: styles$6,
  schema: [{
    prop: "Image",
    type: "component-fixed",
    componentType: "$image"
  }, {
    prop: "imageTitleSpace",
    label: "Image - Title space",
    type: "space"
  }, {
    prop: "titleFont",
    type: "font"
  }, {
    prop: "titleColor",
    type: "color"
  }, {
    prop: "titlePriceSpace",
    label: "Title - Price space",
    type: "space"
  }, {
    prop: "priceFont",
    type: "font"
  }, {
    prop: "priceColor",
    type: "color"
  }]
}, {
  id: "$LocalisedCollectionTest",
  tags: ["section", "notrace"],
  componentCode: getCode(LocalisedCollectionTest),
  styles: styles$5,
  schema: [{
    prop: "Items",
    type: "component-collection-localised",
    componentTypes: ["card"],
    itemFields: [{
      prop: "hasTopMargin",
      label: "Top margin",
      type: "boolean$",
      group: "General"
    }]
  }]
}, {
  id: "$StandardButton",
  label: "Basic Button",
  tags: ["button"],
  componentCode: getCode(StandardButton),
  styles: styles$7,
  schema: [buttonActionSchemaProp, buttonLabelSchemaProp, _objectSpread$s(_objectSpread$s({}, buttonOptionalIconSchemaProp), {}, {
    visible: false
  }), {
    prop: "font",
    type: "font",
    group: "Font",
    label: "Style",
    defaultValue: {
      ref: "$body2.bold",
      value: {}
    }
  }, {
    prop: "color",
    type: "color",
    group: "Font",
    label: "Color",
    defaultValue: {
      ref: "$dark",
      value: "?"
    }
  }, {
    prop: "underline",
    type: "select",
    group: "Font",
    label: "Underline",
    options: [{
      value: "off",
      label: "Off"
    }, {
      value: "on",
      label: "On"
    }, {
      value: "on-custom",
      label: "On (custom offset)"
    }]
  }, {
    prop: "underlineOffset",
    type: "string$",
    group: "Font",
    label: "Underline offset",
    visible: function visible(values) {
      return values.underline === "on-custom";
    },
    normalize: pxValueNormalize(1, 16),
    defaultValue: "1"
  }, {
    prop: "hasBackground",
    type: "boolean",
    group: "Background",
    label: "Enabled",
    defaultValue: true
  }, {
    prop: "backgroundColor",
    type: "color",
    defaultValue: {
      ref: "$neutral",
      value: "grey"
    },
    visible: function visible(values) {
      return !!values.hasBackground;
    },
    group: "Background",
    label: "Color"
  }, {
    prop: "hasBorder",
    type: "boolean",
    group: "Border",
    label: "Enabled"
  }, {
    prop: "borderWidth",
    type: "string$",
    defaultValue: "1",
    group: "Border",
    label: "Width",
    visible: function visible(values) {
      return !!values.hasBorder;
    },
    normalize: pxValueNormalize(1, 16)
  }, {
    prop: "borderColor",
    type: "color",
    defaultValue: {
      ref: "$dark",
      value: "black"
    },
    group: "Border",
    label: "Color",
    visible: function visible(values) {
      return !!values.hasBorder;
    }
  }, {
    prop: "minHeight",
    type: "string$",
    defaultValue: "42",
    group: "Size",
    label: "Min height",
    visible: function visible(values) {
      return values.hasBorder || values.hasBackground;
    },
    normalize: pxValueNormalize(0, 256)
  }, {
    prop: "minWidth",
    type: "string$",
    defaultValue: "100",
    group: "Size",
    label: "Min width",
    visible: function visible(values) {
      return values.hasBorder || values.hasBackground;
    },
    normalize: pxValueNormalize(0, 512)
  }, {
    prop: "horizontalPadding",
    type: "space",
    group: "Size",
    label: "Left / Right padding",
    visible: function visible(values) {
      return values.hasBorder || values.hasBackground;
    },
    defaultValue: {
      ref: "16",
      value: "16px"
    }
  }, {
    prop: "radius",
    type: "string$",
    defaultValue: "0",
    visible: function visible(values) {
      return values.hasBorder || values.hasBackground;
    },
    group: "Shape",
    label: "Corner radius",
    normalize: pxValueNormalize(0, 16)
  }]
}, {
  id: "$MissingComponent",
  schema: [{
    prop: "error",
    type: "string",
    visible: false
  }],
  tags: ["notrace"],
  styles: function styles() {
    return {};
  },
  editing: function editing() {
    return {
      components: {},
      fields: []
    };
  }
}, {
  id: "$MissingAction",
  schema: [],
  tags: ["action", "notrace"],
  styles: function styles() {
    return {};
  },
  editing: function editing() {
    return {
      components: {},
      fields: []
    };
  }
}, {
  id: "$Playground",
  tags: ["notrace"],
  styles: styles$4,
  schema: [_objectSpread$s(_objectSpread$s({}, buttonActionSchemaProp), {}, {
    label: "Action"
  })]
}, {
  id: "$BannerCard2",
  tags: ["card"],
  componentCode: getCode(BannerCard2),
  pasteSlots: ["SideImage", "Stack"],
  styles: styles$g,
  auto: bannerCard2Auto,
  editing: function editing(values, editingInfo, _ref5) {
    var pathPrefix = _ref5.pathPrefix,
        fields = _ref5.fields;
        _ref5.editorContext;
    var isNoneMode = values.mode === "none";
    var isBackgroundMode = values.mode === "background";
    var isBackgroundWithSeparateStackMode = values.mode === "background-separate-stack";

    var newFields = _toConsumableArray$2(editingInfo.fields);

    var modeIndexPlus1 = editingInfo.fields.findIndex(function (field) {
      return field.prop === "sideModeWidth";
    }) + 1;
    var fieldsBefore = editingInfo.fields.slice(0, modeIndexPlus1);
    var fieldsAfter = editingInfo.fields.slice(modeIndexPlus1);
    fields.sideModeWidth.hidden = true; // fields.sideModeImageSize.hidden = true;

    var card1Fields = [];
    var card1StackFields = [{
      portal: "component",
      source: "".concat(pathPrefix, ".Card1.0"),
      groups: ["Stack"]
    }];
    var card2Size = {
      portal: "field",
      source: "".concat(pathPrefix, ".Card2.0"),
      fieldName: "size",
      overrides: {
        group: "Cover"
      }
    };
    var card2Background = {
      portal: "field",
      source: "".concat(pathPrefix, ".Card2.0"),
      fieldName: "Background",
      overrides: {
        group: "Cover",
        label: "Cover"
      }
    }; // hide all background mode fields by default

    for (var key in fields) {
      if (key.startsWith("backgroundMode")) {
        fields[key].hidden = true;
      }
    }

    if (isNoneMode) {
      newFields = [].concat(_toConsumableArray$2(fieldsBefore), card1StackFields, _toConsumableArray$2(fieldsAfter));
    } else if (isBackgroundMode) {
      newFields = [].concat(_toConsumableArray$2(fieldsBefore), [card2Size, card2Background], card1StackFields, _toConsumableArray$2(fieldsAfter));
    } else if (isBackgroundWithSeparateStackMode) {
      newFields = [].concat(_toConsumableArray$2(fieldsBefore), [card2Size, card2Background], _toConsumableArray$2(fieldsAfter));
    } else if (values.mode === "left" || values.mode === "right") {
      fields.sideModeWidth.hidden = false; // fields.sideModeImageSize.hidden = false;

      newFields = [].concat(_toConsumableArray$2(fieldsBefore), [card2Size, card2Background], _toConsumableArray$2(fieldsAfter));
    } else if (values.mode === "top" || values.mode === "bottom") {
      newFields = [].concat(_toConsumableArray$2(fieldsBefore), [card2Size, card2Background], _toConsumableArray$2(fieldsAfter));
    }

    if (isBackgroundWithSeparateStackMode) {
      var _bannerCard2SeparateS = bannerCard2SeparateStackModeController(values),
          fieldsHorizontal = _bannerCard2SeparateS.fieldsHorizontal,
          fieldsVertical = _bannerCard2SeparateS.fieldsVertical;

      for (var _key in fields) {
        if (_key.startsWith("backgroundMode")) {
          // fields[key].hidden = false;
          card1Fields.push(fields[_key]);
        }
      }

      fields.backgroundModePosition.hidden = false;
      fields.backgroundModeEdgeMarginProtection.hidden = false;

      if (arePaddingFieldsSeparate(fieldsHorizontal)) {
        if (fieldsHorizontal.start !== null) {
          fields.backgroundModePaddingLeft.hidden = false;
        }

        if (fieldsHorizontal.end !== null) {
          fields.backgroundModePaddingRight.hidden = false;
        }
      } else {
        if (fieldsHorizontal.both !== null) {
          fields.backgroundModePaddingLeft.hidden = false;
          fields.backgroundModePaddingLeft.label = "Offset horizontal";
        }
      }

      if (arePaddingFieldsSeparate(fieldsVertical)) {
        if (fieldsVertical.start !== null) {
          fields.backgroundModePaddingTop.hidden = false;
        }

        if (fieldsVertical.end !== null) {
          fields.backgroundModePaddingBottom.hidden = false;
        }
      } else {
        if (fieldsVertical.both !== null) {
          fields.backgroundModePaddingTop.hidden = false;
          fields.backgroundModePaddingTop.label = "Offset vertical";
        }
      }
    }

    return {
      fields: newFields,
      components: {
        Card1: {
          noInline: isBackgroundMode || isNoneMode,
          fields: card1Fields,
          passedSize: "none"
        },
        Card2: {
          noInline: isBackgroundMode || isNoneMode || isBackgroundWithSeparateStackMode,
          passedSize: "auto"
        }
      }
    };
  },
  schema: [{
    prop: "cornerRadius",
    label: "Corner radius",
    type: "select$",
    options: Array.from(Array(30).keys()).map(function (x) {
      return x.toString();
    }),
    group: "General"
  }, {
    prop: "Card1",
    label: "Card1",
    type: "component-fixed",
    componentType: "$BasicCard"
  }, {
    prop: "Card2",
    label: "Card2",
    type: "component-fixed",
    componentType: "$BasicCardBackground",
    importFields: true
  }, {
    prop: "mode",
    // main image size
    label: "Position",
    type: "select$",
    options: [{
      value: "none",
      label: "none"
    }, {
      value: "background",
      label: "background"
    }, {
      value: "left",
      label: "left"
    }, {
      value: "right",
      label: "right"
    }, {
      value: "top",
      label: "top"
    }, {
      value: "bottom",
      label: "bottom"
    }, {
      value: "background-separate-stack",
      label: "background (stack separate)"
    }],
    // there is no "fit-content", because it doesn't make sense on mobile and it's actually very rare. If you want image, you don't want it to have some super narrow height, so the height is kind of "minimal" heihgt only.
    group: "Cover"
  }, {
    prop: "sideModeWidth",
    // main image size
    label: "Width",
    type: "select$",
    options: ["25%", "33%", "40%", "50%", "60%", "66%", "75%"],
    // there is no "fit-content", because it doesn't make sense on mobile and it's actually very rare. If you want image, you don't want it to have some super narrow height, so the height is kind of "minimal" heihgt only.
    group: "Cover",
    defaultValue: "50%"
  }, {
    prop: "backgroundModePosition",
    label: "Position",
    type: "select$",
    options: ["top-left", "top-center", "top-right", "center-left", "center-center", "center-right", "bottom-left", "bottom-center", "bottom-right"],
    group: "Content Card",
    visible: function visible(values) {
      return values.mode === "background";
    },
    defaultValue: "bottom-center"
  }, {
    prop: "backgroundModePaddingLeft",
    label: "Offset left",
    type: "space",
    group: "Content Card",
    visible: function visible(values) {
      return values.mode === "background";
    },
    defaultValue: {
      value: "24px",
      ref: "24"
    }
  }, {
    prop: "backgroundModePaddingRight",
    label: "Offset right",
    type: "space",
    group: "Content Card",
    visible: function visible(values) {
      return values.mode === "background";
    },
    defaultValue: {
      value: "24px",
      ref: "24"
    }
  }, {
    prop: "backgroundModePaddingTop",
    label: "Offset top",
    type: "space",
    group: "Content Card",
    visible: function visible(values) {
      return values.mode === "background";
    },
    defaultValue: {
      value: "24px",
      ref: "24"
    }
  }, {
    prop: "backgroundModePaddingBottom",
    label: "Offset bottom",
    type: "space",
    group: "Content Card",
    visible: function visible(values) {
      return values.mode === "background";
    },
    defaultValue: {
      value: "24px",
      ref: "24"
    }
  }, {
    prop: "backgroundModeEdgeMarginProtection",
    label: "Snap to container margin",
    type: "boolean$",
    defaultValue: true,
    group: "Content Card"
  }, buttonActionSchemaProp]
}, richTextEditableComponent, richTextBlockElementEditableComponent, richTextLineElementEditableComponent, richTextPartEditableComponent, richTextInlineWrapperElementEditableComponent, vimeoPlayerEditableComponent, basicCardDefinition, basicBackgroundCardDefinition, cardPlaceholderDefinition];
var schemas = components;

function ownKeys$s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$r(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$s(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function themeScalarValueToResponsiveValue(input, devices) {
  if (typeof input !== "object") {
    return input;
  }

  var objectInput = _objectSpread$r({}, input);

  var maxBreakpoint = devices[devices.length - 1].id;

  if (objectInput["@initial"] !== undefined) {
    // If max resolution range is defined and initial is also defined, max range wins
    if (objectInput["@" + maxBreakpoint] === undefined) {
      objectInput["@" + maxBreakpoint] = objectInput["@initial"];
    }

    delete objectInput["@initial"];
  }

  var output = {
    $res: true
  };
  devices.forEach(function (device) {
    var val = objectInput["@" + device.id];

    if (val !== undefined) {
      output[device.id] = val;
    }
  });
  return output;
}
function themeObjectValueToResponsiveValue(input, devices) {
  var maxBreakpoint = devices[devices.length - 1].id;
  var output = {
    $res: true
  };
  var defaultValue = {};
  var initial = {};

  var _loop = function _loop(_key) {
    // if breakpoint
    if (_key.startsWith("@")) {
      if (devices.find(function (device) {
        return device.id === _key.substr(1);
      })) {
        output[_key.substr(1)] = input[_key];
      } else if (_key === "@initial") {
        initial = input[_key];
      }
    } // if non-breakpoint, it's just a key of default value
    else {
      defaultValue[_key] = input[_key];
    }
  };

  for (var _key in input) {
    _loop(_key);
  } // Let's clear move default values and @initial values into max breakpoint


  var maxBreakpointValue = {}; // most important is maxBreakpoint, then @initial and at the end default values

  Object.assign(maxBreakpointValue, defaultValue);
  Object.assign(maxBreakpointValue, initial);
  Object.assign(maxBreakpointValue, output[maxBreakpoint]);

  if (Object.keys(maxBreakpointValue).length > 0) {
    output[maxBreakpoint] = maxBreakpointValue;
  }

  var lastActiveBreakpointValue = output[maxBreakpoint] || {};

  for (var i = devices.length - 2; i >= 0; i--) {
    var breakpoint = devices[i].id;

    if (!input["@" + breakpoint]) {
      continue;
    }

    output[breakpoint] = _objectSpread$r(_objectSpread$r({}, lastActiveBreakpointValue), output[breakpoint]);
    lastActiveBreakpointValue = output[breakpoint];
  }

  return output;
}

var TRANSITION_TIMING_FUNCTION = "cubic-bezier(0.4, 0, 0.2, 1)";
var OPACITY_OPTIONS = Array.from({
  length: 10
}, function (_, index) {
  var percentageValue = (index + 1) * 10;
  return {
    value: "".concat(percentageValue / 100),
    label: "".concat(percentageValue, "%")
  };
});
var actionTextModifier = {
  id: "$StandardActionStyles",
  label: "Basic styles",
  schema: [{
    prop: "isColorOverwriteEnabled",
    type: "boolean",
    label: "Enable",
    group: "Color"
  }, {
    prop: "color",
    type: "color",
    label: "Color",
    group: "Color",
    visible: function visible(_ref) {
      var isColorOverwriteEnabled = _ref.isColorOverwriteEnabled;
      return isColorOverwriteEnabled;
    }
  }, {
    prop: "isHoverColorEnabled",
    type: "boolean",
    label: "Enable",
    group: "Hover color",
    visible: function visible(_ref2) {
      var underline = _ref2.underline;
      return underline !== "none";
    }
  }, {
    prop: "hoverColor",
    type: "color",
    label: "Color",
    group: "Hover color",
    visible: function visible(_ref3) {
      var underline = _ref3.underline,
          isHoverColorEnabled = _ref3.isHoverColorEnabled;
      return underline !== "none" && isHoverColorEnabled;
    }
  }, {
    prop: "underline",
    type: "select",
    options: [{
      value: "none",
      label: "Off"
    }, {
      value: "enabled",
      label: "On"
    }, {
      value: "showOnHover",
      label: "Show on hover"
    }, {
      value: "hideOnHover",
      label: "Hide on hover"
    }],
    label: "Underline",
    group: "Underline"
  }, {
    prop: "opacity",
    type: "select",
    options: OPACITY_OPTIONS,
    label: "Opacity",
    group: "Opacity"
  }, {
    prop: "hoverOpacity",
    type: "select",
    options: OPACITY_OPTIONS,
    label: "Hover opacity",
    group: "Opacity",
    visible: function visible(_ref4) {
      var underline = _ref4.underline;
      return underline !== "none";
    }
  }, {
    prop: "hoverOpacityAnimationDuration",
    type: "select",
    options: [{
      value: "0ms",
      label: "0ms"
    }, {
      value: "50ms",
      label: "50ms"
    }, {
      value: "100ms",
      label: "100ms"
    }, {
      value: "150ms",
      label: "150ms"
    }, {
      value: "200ms",
      label: "200ms"
    }],
    label: "Duration",
    group: "Animation"
  }],
  apply: function apply(_ref5) {
    var isColorOverwriteEnabled = _ref5.isColorOverwriteEnabled,
        color = _ref5.color,
        underline = _ref5.underline,
        isHoverColorEnabled = _ref5.isHoverColorEnabled,
        hoverColor = _ref5.hoverColor,
        opacity = _ref5.opacity,
        hoverOpacity = _ref5.hoverOpacity,
        hoverOpacityAnimationDuration = _ref5.hoverOpacityAnimationDuration;
    var styles = {
      textDecoration: "none",
      color: "inherit",
      opacity: opacity,
      transition: "opacity ".concat(hoverOpacityAnimationDuration, " ").concat(TRANSITION_TIMING_FUNCTION)
    };

    if (underline === "enabled") {
      var childStyles = {
        textDecoration: "underline",
        textDecorationColor: isColorOverwriteEnabled ? color : "currentColor",
        transition: "text-decoration-color ".concat(hoverOpacityAnimationDuration, " ").concat(TRANSITION_TIMING_FUNCTION, ",\n           color ").concat(hoverOpacityAnimationDuration, " ").concat(TRANSITION_TIMING_FUNCTION)
      };
      var interactiveColor = isHoverColorEnabled ? hoverColor : isColorOverwriteEnabled ? color : "currentColor";
      var interactiveStyles = {
        opacity: hoverOpacity,
        "& span": {
          textDecorationColor: interactiveColor
        }
      };

      if (isColorOverwriteEnabled) {
        childStyles.color = color;
        interactiveStyles["& span"].color = interactiveColor;
      }

      styles["& span"] = childStyles;
      styles["&:hover"] = interactiveStyles;
      styles["&:focus"] = interactiveStyles;
    } else if (underline === "showOnHover") {
      var _childStyles = {
        textDecoration: "underline",
        textDecorationColor: "transparent",
        transition: "text-decoration-color ".concat(hoverOpacityAnimationDuration, " ").concat(TRANSITION_TIMING_FUNCTION, ",\n           color ").concat(hoverOpacityAnimationDuration, " ").concat(TRANSITION_TIMING_FUNCTION)
      };

      if (isColorOverwriteEnabled) {
        _childStyles.color = color;
      }

      var _interactiveStyles = {
        opacity: hoverOpacity
      };

      if (isColorOverwriteEnabled || isHoverColorEnabled) {
        _interactiveStyles["& span"] = {
          color: isHoverColorEnabled ? hoverColor : color,
          textDecorationColor: isHoverColorEnabled ? hoverColor : color
        };
      } else {
        _interactiveStyles["& span"] = {
          textDecorationColor: "currentColor"
        };
      }

      styles["& span"] = _childStyles;
      styles["&:hover"] = _interactiveStyles;
      styles["&:focus"] = _interactiveStyles;
    } else if (underline === "hideOnHover") {
      var _childStyles2 = {
        textDecoration: "underline",
        textDecorationColor: "currentColor",
        transition: "text-decoration-color ".concat(hoverOpacityAnimationDuration, " ").concat(TRANSITION_TIMING_FUNCTION, ",\n           color ").concat(hoverOpacityAnimationDuration, " ").concat(TRANSITION_TIMING_FUNCTION)
      };

      if (isColorOverwriteEnabled) {
        _childStyles2.color = color;
        _childStyles2.textDecorationColor = color;
      }

      var _interactiveStyles2 = {
        opacity: hoverOpacity,
        "& span": {
          textDecorationColor: "transparent"
        }
      };

      if (isHoverColorEnabled) {
        _interactiveStyles2["& span"].color = hoverColor;
      }

      styles["& span"] = _childStyles2;
      styles["&:hover"] = _interactiveStyles2;
      styles["&:focus"] = _interactiveStyles2;
    }

    return styles;
  },
  tags: ["actionTextModifier"]
};

React.createElement;

var StandardLink = {
  id: "$StandardLink",
  label: "Basic Link",
  schema: [{
    prop: "url",
    type: "text",
    defaultValue: "https://google.com"
  }, {
    prop: "shouldOpenInNewWindow",
    label: "Open in new window?",
    type: "boolean"
  }],
  tags: ["actionLink"],
  icon: SSIcons.Link,
  getEditorSidebarPreview: function getEditorSidebarPreview(config, editorContext) {
    var _config$url$value$edi, _config$url$value;

    if (!config.url) {
      return undefined;
    }

    return {
      type: "icon",
      description: (_config$url$value$edi = (_config$url$value = config.url.value) === null || _config$url$value === void 0 ? void 0 : _config$url$value[editorContext.contextParams.locale]) !== null && _config$url$value$edi !== void 0 ? _config$url$value$edi : "None"
    };
  }
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */


function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}
/** Used for built-in method references. */


var objectProto$2 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString$3 = objectProto$2.toString;
/** Built-in value references. */

var Symbol$1 = root.Symbol,
    propertyIsEnumerable = objectProto$2.propertyIsEnumerable,
    spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max;
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */

function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];

    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }

  return result;
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */


function baseRest(func, start) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */


function createFlow(fromRight) {
  return baseRest(function (funcs) {
    funcs = baseFlatten(funcs, 1);
    var length = funcs.length,
        index = length;

    if (fromRight) {
      funcs.reverse();
    }

    while (index--) {
      if (typeof funcs[index] != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
    }

    return function () {
      var index = 0,
          result = length ? funcs[index].apply(this, arguments) : arguments[0];

      while (++index < length) {
        result = funcs[index].call(this, result);
      }

      return result;
    };
  });
}
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */


function isFlattenable(value) {
  return isArray$6(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */


function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty$1.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString$3.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */


var isArray$6 = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */


function isArrayLikeObject(value) {
  return isObjectLike$2(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */


function isFunction$1(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject$2(value) ? objectToString$3.call(value) : '';
  return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */


function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike$2(value) {
  return !!value && typeof value == 'object';
}
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */


var flow = createFlow();
var lodash_flow = flow;

var __jsx$m = React.createElement;
var ModalRoot$1 = styled.div.withConfig({
  displayName: "mockMediaPicker__ModalRoot",
  componentId: "sc-1noc7b5-0"
})(["padding:16px;"]);
var Notice = styled.div.withConfig({
  displayName: "mockMediaPicker__Notice",
  componentId: "sc-1noc7b5-1"
})(["", " max-width:500px;margin:40px 0 60px;"], SSFonts.bodyLarge);
var GridRoot$1 = styled.div.withConfig({
  displayName: "mockMediaPicker__GridRoot",
  componentId: "sc-1noc7b5-2"
})(["display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));grid-column-gap:30px;grid-row-gap:30px;"]);
var CardTitle = styled.div.withConfig({
  displayName: "mockMediaPicker__CardTitle",
  componentId: "sc-1noc7b5-3"
})(["margin-top:12px;", ""], SSFonts.body);
var FieldMessage = styled.div.withConfig({
  displayName: "mockMediaPicker__FieldMessage",
  componentId: "sc-1noc7b5-4"
})(["", " color:", ";white-space:normal;margin-bottom:12px;"], SSFonts.body, SSColors.black40);
var PLAYGROUND_MESSAGE = "This is the playground media picker. In production Shopstory would connect to the media picker of your CMS.";
styled.div.withConfig({
  displayName: "mockMediaPicker__GroupTitle",
  componentId: "sc-1noc7b5-5"
})(["", " margin-bottom:12px;"], SSFonts.label);
var Card = styled.div.withConfig({
  displayName: "mockMediaPicker__Card",
  componentId: "sc-1noc7b5-6"
})(["&:hover{outline:1px solid ", ";}outline-offset:4px;cursor:pointer;"], SSColors.black40);

function CardsGroup(props) {
  return __jsx$m("div", {
    style: {
      marginTop: "40px"
    }
  }, __jsx$m(GridRoot$1, null, props.items.map(function (item) {
    return __jsx$m(Card, {
      onClick: function onClick() {
        props.onSelect(item);
      }
    }, __jsx$m("div", {
      style: {
        paddingBottom: "100%",
        background: "#eaeaea",
        overflow: "hidden",
        position: "relative"
      }
    }, item.thumbnail && __jsx$m("img", {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        objectFit: "contain"
      },
      src: item.thumbnail
    })), __jsx$m(CardTitle, null, item.title));
  })));
}

var Component = function Component(props) {
  var id = props.value.id;

  var _useState = react.exports.useState(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var _useState2 = react.exports.useState(null),
      items = _useState2[0],
      setItems = _useState2[1];

  var selectedItem = items && items.find(function (item) {
    return item.id === props.value.id;
  });
  react.exports.useEffect(function () {
    props.fetcher().then(function (images) {
      setItems(images);
    });
  }, []);
  var label = "Pick media";

  if (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.isVideo) {
    label = "Video";
  } else if ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.mimeType) === "image/svg+xml") {
    label = "SVG";
  } else if (selectedItem) {
    label = "Image'";
  }

  return __jsx$m("div", null, __jsx$m(FieldMessage, null, PLAYGROUND_MESSAGE), items === null && __jsx$m(ThumbnailButton, {
    label: "Loading...",
    disabled: true
  }), items !== null && __jsx$m(ThumbnailButton, {
    onClick: function onClick() {
      setOpen(true);
    },
    label: label,
    description: selectedItem ? selectedItem.title : undefined,
    thumbnail: selectedItem && selectedItem.thumbnail ? {
      type: "image",
      src: selectedItem.thumbnail
    } : undefined
  }), __jsx$m(SSModal, {
    title: "Playground media picker",
    isOpen: isOpen,
    onRequestClose: function onRequestClose() {
      setOpen(false);
    },
    mode: "center-huge",
    headerLine: true
  }, __jsx$m(ModalRoot$1, null, __jsx$m(Notice, null, __jsx$m("strong", null, "Important!"), " ", PLAYGROUND_MESSAGE), __jsx$m(CardsGroup, {
    onSelect: function onSelect(item) {
      props.onChange({
        id: item.id
      });
      setOpen(false);
    },
    items: items !== null && items !== void 0 ? items : []
  }))), __jsx$m("div", {
    style: {
      marginTop: "12px",
      display: "flex",
      flexDirection: "row",
      gap: "8px"
    }
  }, id !== null && __jsx$m(SSButtonSecondary, {
    onClick: function onClick() {
      props.onChange({
        id: null
      });
    }
  }, "Clear")));
};

function mockMediaPicker(fetcher, key) {
  return {
    type: "custom",
    component: function component(_ref) {
      var root = _ref.root,
          onChange = _ref.onChange,
          value = _ref.value;
      ReactDOM.render(__jsx$m(Component, {
        value: value,
        onChange: onChange,
        fetcher: fetcher,
        key: key
      }), root);
    }
  };
}

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

var axios$1 = {exports: {}};

var bind$3 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    return fn.apply(thisArg, args);
  };
};

var bind$2 = bind$3; // utils is a library of generic helper functions non-specific to axios


var toString = Object.prototype.toString; // eslint-disable-next-line func-names

var kindOf = function (cache) {
  // eslint-disable-next-line func-names
  return function (thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
}(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */


function isArray$5(val) {
  return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */


function isUndefined(val) {
  return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */


function isBuffer$1(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */


var isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */

function isArrayBufferView(val) {
  var result;

  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }

  return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */


function isString$2(val) {
  return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */


function isNumber$1(val) {
  return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */


function isObject$1(val) {
  return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */


function isPlainObject$2(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */


var isDate$1 = kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */

var isFile = kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */

var isBlob = kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */

var isFileList = kindOfTest('FileList');
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */

function isFunction(val) {
  return toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */


function isStream(val) {
  return isObject$1(val) && isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */


function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (typeof FormData === 'function' && thing instanceof FormData || toString.call(thing) === pattern || isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */


var isURLSearchParams = kindOfTest('URLSearchParams');
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */

function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */


function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */


function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  } // Force an array if not already something iterable


  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$5(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */


function
  /* obj1, obj2, obj3, ... */
merge$1() {
  var result = {};

  function assignValue(val, key) {
    if (isPlainObject$2(result[key]) && isPlainObject$2(val)) {
      result[key] = merge$1(result[key], val);
    } else if (isPlainObject$2(val)) {
      result[key] = merge$1({}, val);
    } else if (isArray$5(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }

  return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */


function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$2(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */


function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }

  return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */


function inherits$1(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */


function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};
  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;

    while (i-- > 0) {
      prop = props[i];

      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }

    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */


function endsWith(str, searchString, position) {
  str = String(str);

  if (position === undefined || position > str.length) {
    position = str.length;
  }

  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */


function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);

  while (i-- > 0) {
    arr[i] = thing[i];
  }

  return arr;
} // eslint-disable-next-line func-names


var isTypedArray = function (TypedArray) {
  // eslint-disable-next-line func-names
  return function (thing) {
    return TypedArray && thing instanceof TypedArray;
  };
}(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

var utils$j = {
  isArray: isArray$5,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer$1,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString$2,
  isNumber: isNumber$1,
  isObject: isObject$1,
  isPlainObject: isPlainObject$2,
  isUndefined: isUndefined,
  isDate: isDate$1,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge$1,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits$1,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};

var utils$i = utils$j;

function encode$1(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */


var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;

  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$i.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$i.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$i.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$i.forEach(val, function parseValue(v) {
        if (utils$i.isDate(v)) {
          v = v.toISOString();
        } else if (utils$i.isObject(v)) {
          v = JSON.stringify(v);
        }

        parts.push(encode$1(key) + '=' + encode$1(v));
      });
    });
    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$h = utils$j;

function InterceptorManager$1() {
  this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */


InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */


InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */


InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$h.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$g = utils$j;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$g.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

var utils$f = utils$j;
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */


function AxiosError$5(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils$f.inherits(AxiosError$5, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var prototype = AxiosError$5.prototype;
var descriptors = {};
['ERR_BAD_OPTION_VALUE', 'ERR_BAD_OPTION', 'ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK', 'ERR_FR_TOO_MANY_REDIRECTS', 'ERR_DEPRECATED', 'ERR_BAD_RESPONSE', 'ERR_BAD_REQUEST', 'ERR_CANCELED' // eslint-disable-next-line func-names
].forEach(function (code) {
  descriptors[code] = {
    value: code
  };
});
Object.defineProperties(AxiosError$5, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {
  value: true
}); // eslint-disable-next-line func-names

AxiosError$5.from = function (error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);
  utils$f.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });
  AxiosError$5.call(axiosError, error.message, code, config, request, response);
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};

var AxiosError_1 = AxiosError$5;

var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var utils$e = utils$j;
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/


function toFormData$1(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();
  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils$e.isDate(value)) {
      return value.toISOString();
    }

    if (utils$e.isArrayBuffer(value) || utils$e.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils$e.isPlainObject(data) || utils$e.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);
      utils$e.forEach(data, function each(value, key) {
        if (utils$e.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils$e.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils$e.endsWith(key, '[]') && (arr = utils$e.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function (el) {
              !utils$e.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });
      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);
  return formData;
}

var toFormData_1 = toFormData$1;

var AxiosError$4 = AxiosError_1;
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */


var settle$1 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;

  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError$4('Request failed with status code ' + response.status, [AxiosError$4.ERR_BAD_REQUEST, AxiosError$4.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4], response.config, response.request, response));
  }
};

var utils$d = utils$j;

var cookies$1 = utils$d.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils$d.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils$d.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils$d.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

var isAbsoluteURL = isAbsoluteURL$1;

var combineURLs = combineURLs$1;
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */


var buildFullPath$2 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }

  return requestedURL;
};

var utils$c = utils$j; // Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers


var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */

var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils$c.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$c.trim(line.substr(0, i)).toLowerCase();
    val = utils$c.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }

      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

var utils$b = utils$j;

var isURLSameOrigin$1 = utils$b.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;
  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */

  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);
  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */

  return function isURLSameOrigin(requestURL) {
    var parsed = utils$b.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

var AxiosError$3 = AxiosError_1;

var utils$a = utils$j;
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */


function CanceledError$3(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError$3.call(this, message == null ? 'canceled' : message, AxiosError$3.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils$a.inherits(CanceledError$3, AxiosError$3, {
  __CANCEL__: true
});
var CanceledError_1 = CanceledError$3;

var parseProtocol$1 = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};

var utils$9 = utils$j;

var settle = settle$1;

var cookies = cookies$1;

var buildURL$1 = buildURL$2;

var buildFullPath$1 = buildFullPath$2;

var parseHeaders = parseHeaders$1;

var isURLSameOrigin = isURLSameOrigin$1;

var transitionalDefaults$1 = transitional;

var AxiosError$2 = AxiosError_1;

var CanceledError$2 = CanceledError_1;

var parseProtocol = parseProtocol$1;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;

    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils$9.isFormData(requestData) && utils$9.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest(); // HTTP basic authentication

    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath$1(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      } // Prepare the response


      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response); // Clean up request

      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        } // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request


        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        } // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'


        setTimeout(onloadend);
      };
    } // Handle browser request cancellation (as opposed to a manual cancellation)


    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError$2('Request aborted', AxiosError$2.ECONNABORTED, config, request)); // Clean up request

      request = null;
    }; // Handle low level network errors


    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError$2('Network Error', AxiosError$2.ERR_NETWORK, config, request, request)); // Clean up request

      request = null;
    }; // Handle timeout


    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults$1;

      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }

      reject(new AxiosError$2(timeoutErrorMessage, transitional.clarifyTimeoutError ? AxiosError$2.ETIMEDOUT : AxiosError$2.ECONNABORTED, config, request)); // Clean up request

      request = null;
    }; // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.


    if (utils$9.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    } // Add headers to the request


    if ('setRequestHeader' in request) {
      utils$9.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    } // Add withCredentials to request if needed


    if (!utils$9.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    } // Add responseType to request if needed


    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    } // Handle progress if needed


    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    } // Not all browsers support upload events


    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function onCanceled(cancel) {
        if (!request) {
          return;
        }

        reject(!cancel || cancel && cancel.type ? new CanceledError$2() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);

      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && ['http', 'https', 'file'].indexOf(protocol) === -1) {
      reject(new AxiosError$2('Unsupported protocol ' + protocol + ':', AxiosError$2.ERR_BAD_REQUEST, config));
      return;
    } // Send the request


    request.send(requestData);
  });
};

// eslint-disable-next-line strict
var _null = null;

var utils$8 = utils$j;

var normalizeHeaderName = normalizeHeaderName$1;

var AxiosError$1 = AxiosError_1;

var transitionalDefaults = transitional;

var toFormData = toFormData_1;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$8.isUndefined(headers) && utils$8.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;

  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }

  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$8.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$8.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$4 = {
  transitional: transitionalDefaults,
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$8.isFormData(data) || utils$8.isArrayBuffer(data) || utils$8.isBuffer(data) || utils$8.isStream(data) || utils$8.isFile(data) || utils$8.isBlob(data)) {
      return data;
    }

    if (utils$8.isArrayBufferView(data)) {
      return data.buffer;
    }

    if (utils$8.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils$8.isObject(data);
    var contentType = headers && headers['Content-Type'];
    var isFileList;

    if ((isFileList = utils$8.isFileList(data)) || isObjectPayload && contentType === 'multipart/form-data') {
      var _FormData = this.env && this.env.FormData;

      return toFormData(isFileList ? {
        'files[]': data
      } : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],
  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults$4.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || forcedJSONParsing && utils$8.isString(data) && data.length) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response);
          }

          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: _null
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};
utils$8.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$4.headers[method] = {};
});
utils$8.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$4.headers[method] = utils$8.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$4;

var utils$7 = utils$j;

var defaults$3 = defaults_1;
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */


var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$3;
  /*eslint no-param-reassign:0*/

  utils$7.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });
  return data;
};

var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var utils$6 = utils$j;

var transformData = transformData$1;

var isCancel = isCancel$1;

var defaults$2 = defaults_1;

var CanceledError$1 = CanceledError_1;
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */


function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError$1();
  }
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */


var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config); // Ensure headers exist

  config.headers = config.headers || {}; // Transform request data

  config.data = transformData.call(config, config.data, config.headers, config.transformRequest); // Flatten headers

  config.headers = utils$6.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$6.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$2.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config); // Transform response data

    response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config); // Transform response data

      if (reason && reason.response) {
        reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

var utils$5 = utils$j;
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */


var mergeConfig$1 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils$5.isPlainObject(target) && utils$5.isPlainObject(source)) {
      return utils$5.merge(target, source);
    } else if (utils$5.isPlainObject(source)) {
      return utils$5.merge({}, source);
    } else if (utils$5.isArray(source)) {
      return source.slice();
    }

    return source;
  } // eslint-disable-next-line consistent-return


  function mergeDeepProperties(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$5.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  } // eslint-disable-next-line consistent-return


  function valueFromConfig2(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  } // eslint-disable-next-line consistent-return


  function defaultToConfig2(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils$5.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  } // eslint-disable-next-line consistent-return


  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };
  utils$5.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    utils$5.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};

var data = {
  "version": "0.27.2"
};

var VERSION = data.version;

var AxiosError = AxiosError_1;

var validators$1 = {}; // eslint-disable-next-line func-names

['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});
var deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */

validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  } // eslint-disable-next-line func-names


  return function (value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), AxiosError.ERR_DEPRECATED);
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
    }

    return validator ? validator(value, opt, opts) : true;
  };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */


function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }

  var keys = Object.keys(options);
  var i = keys.length;

  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];

    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);

      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }

      continue;
    }

    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator$1 = {
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$4 = utils$j;

var buildURL = buildURL$2;

var InterceptorManager = InterceptorManager_1;

var dispatchRequest = dispatchRequest$1;

var mergeConfig = mergeConfig$1;

var buildFullPath = buildFullPath$2;

var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */

function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */


Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config); // Set config.method

  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators["boolean"]),
      forcedJSONParsing: validators.transitional(validators["boolean"]),
      clarifyTimeoutError: validators.transitional(validators["boolean"])
    }, false);
  } // filter out skipped interceptors


  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);

    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }

  var newConfig = config;

  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();

    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
}; // Provide aliases for supported request methods


utils$4.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});
utils$4.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();
  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var Axios_1 = Axios;

var CanceledError = CanceledError_1;
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */


function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this; // eslint-disable-next-line func-names

  this.promise.then(function (cancel) {
    if (!token._listeners) return;
    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }

    token._listeners = null;
  }); // eslint-disable-next-line func-names

  this.promise.then = function (onfulfilled) {
    var _resolve; // eslint-disable-next-line func-names


    var promise = new Promise(function (resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */


CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
/**
 * Subscribe to the cancel signal
 */


CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
/**
 * Unsubscribe from the cancel signal
 */


CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }

  var index = this._listeners.indexOf(listener);

  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */


CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

var utils$3 = utils$j;
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */


var isAxiosError = function isAxiosError(payload) {
  return utils$3.isObject(payload) && payload.isAxiosError === true;
};

(function (module) {

var utils = utils$j;

var bind = bind$3;

var Axios = Axios_1;

var mergeConfig = mergeConfig$1;

var defaults = defaults_1;
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */


function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context); // Copy axios.prototype to instance

  utils.extend(instance, Axios.prototype, context); // Copy context to instance

  utils.extend(instance, context); // Factory for creating new instances

  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
} // Create the default instance to be exported


var axios = createInstance(defaults); // Expose Axios class to allow class inheritance

axios.Axios = Axios; // Expose Cancel & CancelToken

axios.CanceledError = CanceledError_1;
axios.CancelToken = CancelToken_1;
axios.isCancel = isCancel$1;
axios.VERSION = data.version;
axios.toFormData = toFormData_1; // Expose AxiosError class

axios.AxiosError = AxiosError_1; // alias for CanceledError for backward compatibility

axios.Cancel = axios.CanceledError; // Expose all/spread

axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread; // Expose isAxiosError

axios.isAxiosError = isAxiosError;
module.exports = axios; // Allow use of default import syntax in TypeScript

module.exports["default"] = axios;
}(axios$1));

var axios = axios$1.exports;

var fastCopy = {exports: {}};

(function (module, exports) {
(function (global, factory) {
  module.exports = factory() ;
})(commonjsGlobal, function () {

  var toStringFunction = Function.prototype.toString;
  var create = Object.create,
      defineProperty = Object.defineProperty,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
      getOwnPropertyNames = Object.getOwnPropertyNames,
      getOwnPropertySymbols = Object.getOwnPropertySymbols,
      getPrototypeOf$1 = Object.getPrototypeOf;
  var _a = Object.prototype,
      hasOwnProperty = _a.hasOwnProperty,
      propertyIsEnumerable = _a.propertyIsEnumerable;
  var SYMBOL_PROPERTIES = typeof getOwnPropertySymbols === 'function';
  var WEAK_MAP = typeof WeakMap === 'function';
  /**
   * @function createCache
   *
   * @description
   * get a new cache object to prevent circular references
   *
   * @returns the new cache object
   */

  var createCache = function () {
    if (WEAK_MAP) {
      return function () {
        return new WeakMap();
      };
    }

    var Cache =
    /** @class */
    function () {
      function Cache() {
        this._keys = [];
        this._values = [];
      }

      Cache.prototype.has = function (key) {
        return !!~this._keys.indexOf(key);
      };

      Cache.prototype.get = function (key) {
        return this._values[this._keys.indexOf(key)];
      };

      Cache.prototype.set = function (key, value) {
        this._keys.push(key);

        this._values.push(value);
      };

      return Cache;
    }();

    return function () {
      return new Cache();
    };
  }();
  /**
   * @function getCleanClone
   *
   * @description
   * get an empty version of the object with the same prototype it has
   *
   * @param object the object to build a clean clone from
   * @param realm the realm the object resides in
   * @returns the empty cloned object
   */


  var getCleanClone = function getCleanClone(object, realm) {
    var prototype = object.__proto__ || getPrototypeOf$1(object);

    if (!prototype) {
      return create(null);
    }

    var Constructor = prototype.constructor;

    if (Constructor === realm.Object) {
      return prototype === realm.Object.prototype ? {} : create(prototype);
    }

    if (~toStringFunction.call(Constructor).indexOf('[native code]')) {
      try {
        return new Constructor();
      } catch (_a) {}
    }

    return create(prototype);
  };
  /**
   * @function getObjectCloneLoose
   *
   * @description
   * get a copy of the object based on loose rules, meaning all enumerable keys
   * and symbols are copied, but property descriptors are not considered
   *
   * @param object the object to clone
   * @param realm the realm the object resides in
   * @param handleCopy the function that handles copying the object
   * @returns the copied object
   */


  var getObjectCloneLoose = function getObjectCloneLoose(object, realm, handleCopy, cache) {
    var clone = getCleanClone(object, realm); // set in the cache immediately to be able to reuse the object recursively

    cache.set(object, clone);

    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        clone[key] = handleCopy(object[key], cache);
      }
    }

    if (SYMBOL_PROPERTIES) {
      var symbols = getOwnPropertySymbols(object);

      for (var index = 0, length_1 = symbols.length, symbol = void 0; index < length_1; ++index) {
        symbol = symbols[index];

        if (propertyIsEnumerable.call(object, symbol)) {
          clone[symbol] = handleCopy(object[symbol], cache);
        }
      }
    }

    return clone;
  };
  /**
   * @function getObjectCloneStrict
   *
   * @description
   * get a copy of the object based on strict rules, meaning all keys and symbols
   * are copied based on the original property descriptors
   *
   * @param object the object to clone
   * @param realm the realm the object resides in
   * @param handleCopy the function that handles copying the object
   * @returns the copied object
   */


  var getObjectCloneStrict = function getObjectCloneStrict(object, realm, handleCopy, cache) {
    var clone = getCleanClone(object, realm); // set in the cache immediately to be able to reuse the object recursively

    cache.set(object, clone);
    var properties = SYMBOL_PROPERTIES ? getOwnPropertyNames(object).concat(getOwnPropertySymbols(object)) : getOwnPropertyNames(object);

    for (var index = 0, length_2 = properties.length, property = void 0, descriptor = void 0; index < length_2; ++index) {
      property = properties[index];

      if (property !== 'callee' && property !== 'caller') {
        descriptor = getOwnPropertyDescriptor(object, property);

        if (descriptor) {
          // Only clone the value if actually a value, not a getter / setter.
          if (!descriptor.get && !descriptor.set) {
            descriptor.value = handleCopy(object[property], cache);
          }

          try {
            defineProperty(clone, property, descriptor);
          } catch (error) {
            // Tee above can fail on node in edge cases, so fall back to the loose assignment.
            clone[property] = descriptor.value;
          }
        } else {
          // In extra edge cases where the property descriptor cannot be retrived, fall back to
          // the loose assignment.
          clone[property] = handleCopy(object[property], cache);
        }
      }
    }

    return clone;
  };
  /**
   * @function getRegExpFlags
   *
   * @description
   * get the flags to apply to the copied regexp
   *
   * @param regExp the regexp to get the flags of
   * @returns the flags for the regexp
   */


  var getRegExpFlags = function getRegExpFlags(regExp) {
    var flags = '';

    if (regExp.global) {
      flags += 'g';
    }

    if (regExp.ignoreCase) {
      flags += 'i';
    }

    if (regExp.multiline) {
      flags += 'm';
    }

    if (regExp.unicode) {
      flags += 'u';
    }

    if (regExp.sticky) {
      flags += 'y';
    }

    return flags;
  }; // utils


  var isArray = Array.isArray;
  var getPrototypeOf = Object.getPrototypeOf;

  var GLOBAL_THIS = function () {
    if (typeof globalThis !== 'undefined') {
      return globalThis;
    }

    if (typeof self !== 'undefined') {
      return self;
    }

    if (typeof window !== 'undefined') {
      return window;
    }

    if (typeof commonjsGlobal !== 'undefined') {
      return commonjsGlobal;
    }

    if (console && console.error) {
      console.error('Unable to locate global object, returning "this".');
    }

    return this;
  }();
  /**
   * @function copy
   *
   * @description
   * copy an value deeply as much as possible
   *
   * If `strict` is applied, then all properties (including non-enumerable ones)
   * are copied with their original property descriptors on both objects and arrays.
   *
   * The value is compared to the global constructors in the `realm` provided,
   * and the native constructor is always used to ensure that extensions of native
   * objects (allows in ES2015+) are maintained.
   *
   * @param value the value to copy
   * @param [options] the options for copying with
   * @param [options.isStrict] should the copy be strict
   * @param [options.realm] the realm (this) value the value is copied from
   * @returns the copied value
   */


  function copy(value, options) {
    // manually coalesced instead of default parameters for performance
    var isStrict = !!(options && options.isStrict);
    var realm = options && options.realm || GLOBAL_THIS;
    var getObjectClone = isStrict ? getObjectCloneStrict : getObjectCloneLoose;
    /**
     * @function handleCopy
     *
     * @description
     * copy the value recursively based on its type
     *
     * @param value the value to copy
     * @returns the copied value
     */

    var handleCopy = function handleCopy(value, cache) {
      if (!value || typeof value !== 'object') {
        return value;
      }

      if (cache.has(value)) {
        return cache.get(value);
      }

      var prototype = value.__proto__ || getPrototypeOf(value);
      var Constructor = prototype && prototype.constructor; // plain objects

      if (!Constructor || Constructor === realm.Object) {
        return getObjectClone(value, realm, handleCopy, cache);
      }

      var clone; // arrays

      if (isArray(value)) {
        // if strict, include non-standard properties
        if (isStrict) {
          return getObjectCloneStrict(value, realm, handleCopy, cache);
        }

        clone = new Constructor();
        cache.set(value, clone);

        for (var index = 0, length_1 = value.length; index < length_1; ++index) {
          clone[index] = handleCopy(value[index], cache);
        }

        return clone;
      } // dates


      if (value instanceof realm.Date) {
        return new Constructor(value.getTime());
      } // regexps


      if (value instanceof realm.RegExp) {
        clone = new Constructor(value.source, value.flags || getRegExpFlags(value));
        clone.lastIndex = value.lastIndex;
        return clone;
      } // maps


      if (realm.Map && value instanceof realm.Map) {
        clone = new Constructor();
        cache.set(value, clone);
        value.forEach(function (value, key) {
          clone.set(key, handleCopy(value, cache));
        });
        return clone;
      } // sets


      if (realm.Set && value instanceof realm.Set) {
        clone = new Constructor();
        cache.set(value, clone);
        value.forEach(function (value) {
          clone.add(handleCopy(value, cache));
        });
        return clone;
      } // blobs


      if (realm.Blob && value instanceof realm.Blob) {
        return value.slice(0, value.size, value.type);
      } // buffers (node-only)


      if (realm.Buffer && realm.Buffer.isBuffer(value)) {
        clone = realm.Buffer.allocUnsafe ? realm.Buffer.allocUnsafe(value.length) : new Constructor(value.length);
        cache.set(value, clone);
        value.copy(clone);
        return clone;
      } // arraybuffers / dataviews


      if (realm.ArrayBuffer) {
        // dataviews
        if (realm.ArrayBuffer.isView(value)) {
          clone = new Constructor(value.buffer.slice(0));
          cache.set(value, clone);
          return clone;
        } // arraybuffers


        if (value instanceof realm.ArrayBuffer) {
          clone = value.slice(0);
          cache.set(value, clone);
          return clone;
        }
      } // if the value cannot / should not be cloned, don't


      if ( // promise-like
      typeof value.then === 'function' || // errors
      value instanceof Error || // weakmaps
      realm.WeakMap && value instanceof realm.WeakMap || // weaksets
      realm.WeakSet && value instanceof realm.WeakSet) {
        return value;
      } // assume anything left is a custom constructor


      return getObjectClone(value, realm, handleCopy, cache);
    };

    return handleCopy(value, createCache());
  } // Adding reference to allow usage in CommonJS libraries compiled using TSC, which
  // expects there to be a default property on the exported value. See
  // [#37](https://github.com/planttheidea/fast-copy/issues/37) for details.


  copy["default"] = copy;
  /**
   * @function strictCopy
   *
   * @description
   * copy the value with `strict` option pre-applied
   *
   * @param value the value to copy
   * @param [options] the options for copying with
   * @param [options.realm] the realm (this) value the value is copied from
   * @returns the copied value
   */

  copy.strict = function strictCopy(value, options) {
    return copy(value, {
      isStrict: true,
      realm: options ? options.realm : void 0
    });
  };

  return copy;
});
}(fastCopy));

var copy = fastCopy.exports;

/* eslint complexity: [2, 18], max-statements: [2, 33] */

var shams = function hasSymbols() {
  if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
    return false;
  }

  if (typeof Symbol.iterator === 'symbol') {
    return true;
  }

  var obj = {};
  var sym = Symbol('test');
  var symObj = Object(sym);

  if (typeof sym === 'string') {
    return false;
  }

  if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
    return false;
  }

  if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
    return false;
  } // temp disabled per https://github.com/ljharb/object.assign/issues/17
  // if (sym instanceof Symbol) { return false; }
  // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
  // if (!(symObj instanceof Symbol)) { return false; }
  // if (typeof Symbol.prototype.toString !== 'function') { return false; }
  // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }


  var symVal = 42;
  obj[sym] = symVal;

  for (sym in obj) {
    return false;
  } // eslint-disable-line no-restricted-syntax, no-unreachable-loop


  if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
    return false;
  }

  if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }

  var syms = Object.getOwnPropertySymbols(obj);

  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }

  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }

  if (typeof Object.getOwnPropertyDescriptor === 'function') {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);

    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }

  return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;

var hasSymbolSham = shams;

var hasSymbols$1 = function hasNativeSymbols() {
  if (typeof origSymbol !== 'function') {
    return false;
  }

  if (typeof Symbol !== 'function') {
    return false;
  }

  if (typeof origSymbol('foo') !== 'symbol') {
    return false;
  }

  if (typeof Symbol('bar') !== 'symbol') {
    return false;
  }

  return hasSymbolSham();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr$1 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
  var target = this;

  if (typeof target !== 'function' || toStr$1.call(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }

  var args = slice.call(arguments, 1);
  var bound;

  var binder = function binder() {
    if (this instanceof bound) {
      var result = target.apply(this, args.concat(slice.call(arguments)));

      if (Object(result) === result) {
        return result;
      }

      return this;
    } else {
      return target.apply(that, args.concat(slice.call(arguments)));
    }
  };

  var boundLength = Math.max(0, target.length - args.length);
  var boundArgs = [];

  for (var i = 0; i < boundLength; i++) {
    boundArgs.push('$' + i);
  }

  bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

  if (target.prototype) {
    var Empty = function Empty() {};

    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }

  return bound;
};

var implementation = implementation$1;

var functionBind = Function.prototype.bind || implementation;

var bind$1 = functionBind;

var src = bind$1.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError; // eslint-disable-next-line consistent-return

var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
  } catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;

if ($gOPD) {
  try {
    $gOPD({}, '');
  } catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
  }
}

var throwTypeError = function throwTypeError() {
  throw new $TypeError$1();
};

var ThrowTypeError = $gOPD ? function () {
  try {
    // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
    arguments.callee; // IE 8 does not throw here

    return throwTypeError;
  } catch (calleeThrows) {
    try {
      // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
      return $gOPD(arguments, 'callee').get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;

var hasSymbols = hasSymbols$1();

var getProto = Object.getPrototypeOf || function (x) {
  return x.__proto__;
}; // eslint-disable-line no-proto


var needsEval = {};
var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  '%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
  '%Array%': Array,
  '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
  '%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined$1,
  '%AsyncFromSyncIteratorPrototype%': undefined$1,
  '%AsyncFunction%': needsEval,
  '%AsyncGenerator%': needsEval,
  '%AsyncGeneratorFunction%': needsEval,
  '%AsyncIteratorPrototype%': needsEval,
  '%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
  '%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
  '%Boolean%': Boolean,
  '%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
  '%Date%': Date,
  '%decodeURI%': decodeURI,
  '%decodeURIComponent%': decodeURIComponent,
  '%encodeURI%': encodeURI,
  '%encodeURIComponent%': encodeURIComponent,
  '%Error%': Error,
  '%eval%': eval,
  // eslint-disable-line no-eval
  '%EvalError%': EvalError,
  '%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
  '%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
  '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
  '%Function%': $Function,
  '%GeneratorFunction%': needsEval,
  '%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
  '%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
  '%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
  '%isFinite%': isFinite,
  '%isNaN%': isNaN,
  '%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  '%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
  '%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
  '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
  '%Math%': Math,
  '%Number%': Number,
  '%Object%': Object,
  '%parseFloat%': parseFloat,
  '%parseInt%': parseInt,
  '%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
  '%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
  '%RangeError%': RangeError,
  '%ReferenceError%': ReferenceError,
  '%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
  '%RegExp%': RegExp,
  '%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
  '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
  '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
  '%String%': String,
  '%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined$1,
  '%Symbol%': hasSymbols ? Symbol : undefined$1,
  '%SyntaxError%': $SyntaxError,
  '%ThrowTypeError%': ThrowTypeError,
  '%TypedArray%': TypedArray,
  '%TypeError%': $TypeError$1,
  '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
  '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
  '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
  '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
  '%URIError%': URIError,
  '%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
  '%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
  '%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
  var value;

  if (name === '%AsyncFunction%') {
    value = getEvalledConstructor('async function () {}');
  } else if (name === '%GeneratorFunction%') {
    value = getEvalledConstructor('function* () {}');
  } else if (name === '%AsyncGeneratorFunction%') {
    value = getEvalledConstructor('async function* () {}');
  } else if (name === '%AsyncGenerator%') {
    var fn = doEval('%AsyncGeneratorFunction%');

    if (fn) {
      value = fn.prototype;
    }
  } else if (name === '%AsyncIteratorPrototype%') {
    var gen = doEval('%AsyncGenerator%');

    if (gen) {
      value = getProto(gen.prototype);
    }
  }

  INTRINSICS[name] = value;
  return value;
};

var LEGACY_ALIASES = {
  '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
  '%ArrayPrototype%': ['Array', 'prototype'],
  '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
  '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
  '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
  '%ArrayProto_values%': ['Array', 'prototype', 'values'],
  '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
  '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
  '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
  '%BooleanPrototype%': ['Boolean', 'prototype'],
  '%DataViewPrototype%': ['DataView', 'prototype'],
  '%DatePrototype%': ['Date', 'prototype'],
  '%ErrorPrototype%': ['Error', 'prototype'],
  '%EvalErrorPrototype%': ['EvalError', 'prototype'],
  '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
  '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
  '%FunctionPrototype%': ['Function', 'prototype'],
  '%Generator%': ['GeneratorFunction', 'prototype'],
  '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
  '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
  '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
  '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
  '%JSONParse%': ['JSON', 'parse'],
  '%JSONStringify%': ['JSON', 'stringify'],
  '%MapPrototype%': ['Map', 'prototype'],
  '%NumberPrototype%': ['Number', 'prototype'],
  '%ObjectPrototype%': ['Object', 'prototype'],
  '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
  '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
  '%PromisePrototype%': ['Promise', 'prototype'],
  '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
  '%Promise_all%': ['Promise', 'all'],
  '%Promise_reject%': ['Promise', 'reject'],
  '%Promise_resolve%': ['Promise', 'resolve'],
  '%RangeErrorPrototype%': ['RangeError', 'prototype'],
  '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
  '%RegExpPrototype%': ['RegExp', 'prototype'],
  '%SetPrototype%': ['Set', 'prototype'],
  '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
  '%StringPrototype%': ['String', 'prototype'],
  '%SymbolPrototype%': ['Symbol', 'prototype'],
  '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
  '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
  '%TypeErrorPrototype%': ['TypeError', 'prototype'],
  '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
  '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
  '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
  '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
  '%URIErrorPrototype%': ['URIError', 'prototype'],
  '%WeakMapPrototype%': ['WeakMap', 'prototype'],
  '%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = functionBind;

var hasOwn$1 = src;

var $concat$1 = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */

var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
/** Used to match backslashes in property paths. */

var stringToPath = function stringToPath(string) {
  var first = $strSlice(string, 0, 1);
  var last = $strSlice(string, -1);

  if (first === '%' && last !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
  } else if (last === '%' && first !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
  }

  var result = [];
  $replace$1(string, rePropName, function (match, number, quote, subString) {
    result[result.length] = quote ? $replace$1(subString, reEscapeChar, '$1') : number || match;
  });
  return result;
};
/* end adaptation */


var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
  var intrinsicName = name;
  var alias;

  if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = '%' + alias[0] + '%';
  }

  if (hasOwn$1(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];

    if (value === needsEval) {
      value = doEval(intrinsicName);
    }

    if (typeof value === 'undefined' && !allowMissing) {
      throw new $TypeError$1('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
    }

    return {
      alias: alias,
      name: intrinsicName,
      value: value
    };
  }

  throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== 'string' || name.length === 0) {
    throw new $TypeError$1('intrinsic name must be a non-empty string');
  }

  if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
    throw new $TypeError$1('"allowMissing" argument must be a boolean');
  }

  var parts = stringToPath(name);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
  var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;

  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat$1([0, 1], alias));
  }

  for (var i = 1, isOwn = true; i < parts.length; i += 1) {
    var part = parts[i];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);

    if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
      throw new $SyntaxError('property names with quotes must have matching quotes');
    }

    if (part === 'constructor' || !isOwn) {
      skipFurtherCaching = true;
    }

    intrinsicBaseName += '.' + part;
    intrinsicRealName = '%' + intrinsicBaseName + '%';

    if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError$1('base intrinsic for ' + name + ' exists, but the property is not available.');
        }

        return void undefined$1;
      }

      if ($gOPD && i + 1 >= parts.length) {
        var desc = $gOPD(value, part);
        isOwn = !!desc; // By convention, when a data property is converted to an accessor
        // property to emulate a data property that does not suffer from
        // the override mistake, that accessor's getter is marked with
        // an `originalValue` property. Here, when we detect this, we
        // uphold the illusion by pretending to see that original data
        // property, i.e., returning the value rather than the getter
        // itself.

        if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn$1(value, part);
        value = value[part];
      }

      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }

  return value;
};

var callBind$1 = {exports: {}};

(function (module) {

var bind = functionBind;

var GetIntrinsic = getIntrinsic;

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
  try {
    $defineProperty({}, 'a', {
      value: 1
    });
  } catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = null;
  }
}

module.exports = function callBind(originalFunction) {
  var func = $reflectApply(bind, $call, arguments);

  if ($gOPD && $defineProperty) {
    var desc = $gOPD(func, 'length');

    if (desc.configurable) {
      // original length, plus the receiver, minus any additional arguments (after the receiver)
      $defineProperty(func, 'length', {
        value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
      });
    }
  }

  return func;
};

var applyBind = function applyBind() {
  return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
  $defineProperty(module.exports, 'apply', {
    value: applyBind
  });
} else {
  module.exports.apply = applyBind;
}
}(callBind$1));

var GetIntrinsic$1 = getIntrinsic;

var callBind = callBind$1.exports;

var $indexOf = callBind(GetIntrinsic$1('String.prototype.indexOf'));

var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = GetIntrinsic$1(name, !!allowMissing);

  if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
    return callBind(intrinsic);
  }

  return intrinsic;
};

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString$2 = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object'; // ie, `has-tostringtag/shams

var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
? function (O) {
  return O.__proto__; // eslint-disable-line no-proto
} : null);

function addNumericSeparator(num, str) {
  if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) {
    return str;
  }

  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;

  if (typeof num === 'number') {
    var _int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)


    if (_int !== num) {
      var intStr = String(_int);
      var dec = $slice.call(str, intStr.length + 1);
      return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
    }
  }

  return $replace.call(str, sepRegex, '$&_');
}

var inspectCustom = require$$0.custom;

var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
  var opts = options || {};

  if (has$3(opts, 'quoteStyle') && opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double') {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }

  if (has$3(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }

  var customInspect = has$3(opts, 'customInspect') ? opts.customInspect : true;

  if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
    throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
  }

  if (has$3(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  }

  if (has$3(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  }

  var numericSeparator = opts.numericSeparator;

  if (typeof obj === 'undefined') {
    return 'undefined';
  }

  if (obj === null) {
    return 'null';
  }

  if (typeof obj === 'boolean') {
    return obj ? 'true' : 'false';
  }

  if (typeof obj === 'string') {
    return inspectString(obj, opts);
  }

  if (typeof obj === 'number') {
    if (obj === 0) {
      return Infinity / obj > 0 ? '0' : '-0';
    }

    var str = String(obj);
    return numericSeparator ? addNumericSeparator(obj, str) : str;
  }

  if (typeof obj === 'bigint') {
    var bigIntStr = String(obj) + 'n';
    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
  }

  var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;

  if (typeof depth === 'undefined') {
    depth = 0;
  }

  if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
    return isArray$4(obj) ? '[Array]' : '[Object]';
  }

  var indent = getIndent(opts, depth);

  if (typeof seen === 'undefined') {
    seen = [];
  } else if (indexOf(seen, obj) >= 0) {
    return '[Circular]';
  }

  function inspect(value, from, noIndent) {
    if (from) {
      seen = $arrSlice.call(seen);
      seen.push(from);
    }

    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };

      if (has$3(opts, 'quoteStyle')) {
        newOpts.quoteStyle = opts.quoteStyle;
      }

      return inspect_(value, newOpts, depth + 1, seen);
    }

    return inspect_(value, opts, depth + 1, seen);
  }

  if (typeof obj === 'function') {
    var name = nameOf(obj);
    var keys = arrObjKeys(obj, inspect);
    return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
  }

  if (isSymbol(obj)) {
    var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
    return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
  }

  if (isElement$1(obj)) {
    var s = '<' + $toLowerCase.call(String(obj.nodeName));
    var attrs = obj.attributes || [];

    for (var i = 0; i < attrs.length; i++) {
      s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
    }

    s += '>';

    if (obj.childNodes && obj.childNodes.length) {
      s += '...';
    }

    s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
    return s;
  }

  if (isArray$4(obj)) {
    if (obj.length === 0) {
      return '[]';
    }

    var xs = arrObjKeys(obj, inspect);

    if (indent && !singleLineValues(xs)) {
      return '[' + indentedJoin(xs, indent) + ']';
    }

    return '[ ' + $join.call(xs, ', ') + ' ]';
  }

  if (isError(obj)) {
    var parts = arrObjKeys(obj, inspect);

    if ('cause' in obj && !isEnumerable.call(obj, 'cause')) {
      return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
    }

    if (parts.length === 0) {
      return '[' + String(obj) + ']';
    }

    return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
  }

  if (typeof obj === 'object' && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
      return obj[inspectSymbol]();
    } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
      return obj.inspect();
    }
  }

  if (isMap(obj)) {
    var mapParts = [];
    mapForEach.call(obj, function (value, key) {
      mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
    });
    return collectionOf('Map', mapSize.call(obj), mapParts, indent);
  }

  if (isSet(obj)) {
    var setParts = [];
    setForEach.call(obj, function (value) {
      setParts.push(inspect(value, obj));
    });
    return collectionOf('Set', setSize.call(obj), setParts, indent);
  }

  if (isWeakMap(obj)) {
    return weakCollectionOf('WeakMap');
  }

  if (isWeakSet(obj)) {
    return weakCollectionOf('WeakSet');
  }

  if (isWeakRef(obj)) {
    return weakCollectionOf('WeakRef');
  }

  if (isNumber(obj)) {
    return markBoxed(inspect(Number(obj)));
  }

  if (isBigInt(obj)) {
    return markBoxed(inspect(bigIntValueOf.call(obj)));
  }

  if (isBoolean(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }

  if (isString$1(obj)) {
    return markBoxed(inspect(String(obj)));
  }

  if (!isDate(obj) && !isRegExp$1(obj)) {
    var ys = arrObjKeys(obj, inspect);
    var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? '' : 'null prototype';
    var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
    var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
    var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');

    if (ys.length === 0) {
      return tag + '{}';
    }

    if (indent) {
      return tag + '{' + indentedJoin(ys, indent) + '}';
    }

    return tag + '{ ' + $join.call(ys, ', ') + ' }';
  }

  return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
  return quoteChar + s + quoteChar;
}

function quote(s) {
  return $replace.call(String(s), /"/g, '&quot;');
}

function isArray$4(obj) {
  return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}

function isDate(obj) {
  return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}

function isRegExp$1(obj) {
  return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}

function isError(obj) {
  return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}

function isString$1(obj) {
  return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}

function isNumber(obj) {
  return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}

function isBoolean(obj) {
  return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
} // Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives


function isSymbol(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === 'object' && obj instanceof Symbol;
  }

  if (typeof obj === 'symbol') {
    return true;
  }

  if (!obj || typeof obj !== 'object' || !symToString) {
    return false;
  }

  try {
    symToString.call(obj);
    return true;
  } catch (e) {}

  return false;
}

function isBigInt(obj) {
  if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
    return false;
  }

  try {
    bigIntValueOf.call(obj);
    return true;
  } catch (e) {}

  return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) {
  return key in this;
};

function has$3(obj, key) {
  return hasOwn.call(obj, key);
}

function toStr(obj) {
  return objectToString$2.call(obj);
}

function nameOf(f) {
  if (f.name) {
    return f.name;
  }

  var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);

  if (m) {
    return m[1];
  }

  return null;
}

function indexOf(xs, x) {
  if (xs.indexOf) {
    return xs.indexOf(x);
  }

  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) {
      return i;
    }
  }

  return -1;
}

function isMap(x) {
  if (!mapSize || !x || typeof x !== 'object') {
    return false;
  }

  try {
    mapSize.call(x);

    try {
      setSize.call(x);
    } catch (s) {
      return true;
    }

    return x instanceof Map; // core-js workaround, pre-v2.5.0
  } catch (e) {}

  return false;
}

function isWeakMap(x) {
  if (!weakMapHas || !x || typeof x !== 'object') {
    return false;
  }

  try {
    weakMapHas.call(x, weakMapHas);

    try {
      weakSetHas.call(x, weakSetHas);
    } catch (s) {
      return true;
    }

    return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
  } catch (e) {}

  return false;
}

function isWeakRef(x) {
  if (!weakRefDeref || !x || typeof x !== 'object') {
    return false;
  }

  try {
    weakRefDeref.call(x);
    return true;
  } catch (e) {}

  return false;
}

function isSet(x) {
  if (!setSize || !x || typeof x !== 'object') {
    return false;
  }

  try {
    setSize.call(x);

    try {
      mapSize.call(x);
    } catch (m) {
      return true;
    }

    return x instanceof Set; // core-js workaround, pre-v2.5.0
  } catch (e) {}

  return false;
}

function isWeakSet(x) {
  if (!weakSetHas || !x || typeof x !== 'object') {
    return false;
  }

  try {
    weakSetHas.call(x, weakSetHas);

    try {
      weakMapHas.call(x, weakMapHas);
    } catch (s) {
      return true;
    }

    return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
  } catch (e) {}

  return false;
}

function isElement$1(x) {
  if (!x || typeof x !== 'object') {
    return false;
  }

  if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
    return true;
  }

  return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
    return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
  } // eslint-disable-next-line no-control-regex


  var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
  var n = c.charCodeAt(0);
  var x = {
    8: 'b',
    9: 't',
    10: 'n',
    12: 'f',
    13: 'r'
  }[n];

  if (x) {
    return '\\' + x;
  }

  return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
  return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
  return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
  var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
  return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
  for (var i = 0; i < xs.length; i++) {
    if (indexOf(xs[i], '\n') >= 0) {
      return false;
    }
  }

  return true;
}

function getIndent(opts, depth) {
  var baseIndent;

  if (opts.indent === '\t') {
    baseIndent = '\t';
  } else if (typeof opts.indent === 'number' && opts.indent > 0) {
    baseIndent = $join.call(Array(opts.indent + 1), ' ');
  } else {
    return null;
  }

  return {
    base: baseIndent,
    prev: $join.call(Array(depth + 1), baseIndent)
  };
}

function indentedJoin(xs, indent) {
  if (xs.length === 0) {
    return '';
  }

  var lineJoiner = '\n' + indent.prev + indent.base;
  return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
  var isArr = isArray$4(obj);
  var xs = [];

  if (isArr) {
    xs.length = obj.length;

    for (var i = 0; i < obj.length; i++) {
      xs[i] = has$3(obj, i) ? inspect(obj[i], obj) : '';
    }
  }

  var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
  var symMap;

  if (hasShammedSymbols) {
    symMap = {};

    for (var k = 0; k < syms.length; k++) {
      symMap['$' + syms[k]] = syms[k];
    }
  }

  for (var key in obj) {
    // eslint-disable-line no-restricted-syntax
    if (!has$3(obj, key)) {
      continue;
    } // eslint-disable-line no-restricted-syntax, no-continue


    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    } // eslint-disable-line no-restricted-syntax, no-continue


    if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
      // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
      continue; // eslint-disable-line no-restricted-syntax, no-continue
    } else if ($test.call(/[^\w$]/, key)) {
      xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
    } else {
      xs.push(key + ': ' + inspect(obj[key], obj));
    }
  }

  if (typeof gOPS === 'function') {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable.call(obj, syms[j])) {
        xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
      }
    }
  }

  return xs;
}

var GetIntrinsic = getIntrinsic;

var callBound = callBound$1;

var inspect = objectInspect;

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);
var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */

var listGetNode = function listGetNode(list, key) {
  // eslint-disable-line consistent-return
  for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
    if (curr.key === key) {
      prev.next = curr.next;
      curr.next = list.next;
      list.next = curr; // eslint-disable-line no-param-reassign

      return curr;
    }
  }
};

var listGet = function listGet(objects, key) {
  var node = listGetNode(objects, key);
  return node && node.value;
};

var listSet = function listSet(objects, key, value) {
  var node = listGetNode(objects, key);

  if (node) {
    node.value = value;
  } else {
    // Prepend the new node to the beginning of the list
    objects.next = {
      // eslint-disable-line no-param-reassign
      key: key,
      next: objects.next,
      value: value
    };
  }
};

var listHas = function listHas(objects, key) {
  return !!listGetNode(objects, key);
};

var sideChannel = function getSideChannel() {
  var $wm;
  var $m;
  var $o;
  var channel = {
    assert: function assert(key) {
      if (!channel.has(key)) {
        throw new $TypeError('Side channel does not contain ' + inspect(key));
      }
    },
    get: function get(key) {
      // eslint-disable-line consistent-return
      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
        if ($wm) {
          return $weakMapGet($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapGet($m, key);
        }
      } else {
        if ($o) {
          // eslint-disable-line no-lonely-if
          return listGet($o, key);
        }
      }
    },
    has: function has(key) {
      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
        if ($wm) {
          return $weakMapHas($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapHas($m, key);
        }
      } else {
        if ($o) {
          // eslint-disable-line no-lonely-if
          return listHas($o, key);
        }
      }

      return false;
    },
    set: function set(key, value) {
      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
        if (!$wm) {
          $wm = new $WeakMap();
        }

        $weakMapSet($wm, key, value);
      } else if ($Map) {
        if (!$m) {
          $m = new $Map();
        }

        $mapSet($m, key, value);
      } else {
        if (!$o) {
          /*
           * Initialize the linked list as an empty node, so that we don't have
           * to special-case handling of the first node: we can always refer to
           * it as (previous node).next, instead of something like (list).head
           */
          $o = {
            key: {},
            next: null
          };
        }

        listSet($o, key, value);
      }
    }
  };
  return channel;
};

var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: 'RFC1738',
  RFC3986: 'RFC3986'
};
var formats$3 = {
  'default': Format.RFC3986,
  formatters: {
    RFC1738: function RFC1738(value) {
      return replace.call(value, percentTwenties, '+');
    },
    RFC3986: function RFC3986(value) {
      return String(value);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
};

var formats$2 = formats$3;

var has$2 = Object.prototype.hasOwnProperty;
var isArray$3 = Array.isArray;

var hexTable = function () {
  var array = [];

  for (var i = 0; i < 256; ++i) {
    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
  }

  return array;
}();

var compactQueue = function compactQueue(queue) {
  while (queue.length > 1) {
    var item = queue.pop();
    var obj = item.obj[item.prop];

    if (isArray$3(obj)) {
      var compacted = [];

      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== 'undefined') {
          compacted.push(obj[j]);
        }
      }

      item.obj[item.prop] = compacted;
    }
  }
};

var arrayToObject = function arrayToObject(source, options) {
  var obj = options && options.plainObjects ? Object.create(null) : {};

  for (var i = 0; i < source.length; ++i) {
    if (typeof source[i] !== 'undefined') {
      obj[i] = source[i];
    }
  }

  return obj;
};

var merge = function merge(target, source, options) {
  /* eslint no-param-reassign: 0 */
  if (!source) {
    return target;
  }

  if (typeof source !== 'object') {
    if (isArray$3(target)) {
      target.push(source);
    } else if (target && typeof target === 'object') {
      if (options && (options.plainObjects || options.allowPrototypes) || !has$2.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }

    return target;
  }

  if (!target || typeof target !== 'object') {
    return [target].concat(source);
  }

  var mergeTarget = target;

  if (isArray$3(target) && !isArray$3(source)) {
    mergeTarget = arrayToObject(target, options);
  }

  if (isArray$3(target) && isArray$3(source)) {
    source.forEach(function (item, i) {
      if (has$2.call(target, i)) {
        var targetItem = target[i];

        if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
          target[i] = merge(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i] = item;
      }
    });
    return target;
  }

  return Object.keys(source).reduce(function (acc, key) {
    var value = source[key];

    if (has$2.call(acc, key)) {
      acc[key] = merge(acc[key], value, options);
    } else {
      acc[key] = value;
    }

    return acc;
  }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};

var decode = function decode(str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, ' ');

  if (charset === 'iso-8859-1') {
    // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  } // utf-8


  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
  // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
  // It has been adapted here for stricter adherence to RFC 3986
  if (str.length === 0) {
    return str;
  }

  var string = str;

  if (typeof str === 'symbol') {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== 'string') {
    string = String(str);
  }

  if (charset === 'iso-8859-1') {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
      return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
  }

  var out = '';

  for (var i = 0; i < string.length; ++i) {
    var c = string.charCodeAt(i);

    if (c === 0x2D // -
    || c === 0x2E // .
    || c === 0x5F // _
    || c === 0x7E // ~
    || c >= 0x30 && c <= 0x39 // 0-9
    || c >= 0x41 && c <= 0x5A // a-z
    || c >= 0x61 && c <= 0x7A // A-Z
    || format === formats$2.RFC1738 && (c === 0x28 || c === 0x29) // ( )
    ) {
      out += string.charAt(i);
      continue;
    }

    if (c < 0x80) {
      out = out + hexTable[c];
      continue;
    }

    if (c < 0x800) {
      out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    if (c < 0xD800 || c >= 0xE000) {
      out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    i += 1;
    c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
    /* eslint operator-linebreak: [2, "before"] */

    out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
  }

  return out;
};

var compact = function compact(value) {
  var queue = [{
    obj: {
      o: value
    },
    prop: 'o'
  }];
  var refs = [];

  for (var i = 0; i < queue.length; ++i) {
    var item = queue[i];
    var obj = item.obj[item.prop];
    var keys = Object.keys(obj);

    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];

      if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
        queue.push({
          obj: obj,
          prop: key
        });
        refs.push(val);
      }
    }
  }

  compactQueue(queue);
  return value;
};

var isRegExp = function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
  return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
  if (isArray$3(val)) {
    var mapped = [];

    for (var i = 0; i < val.length; i += 1) {
      mapped.push(fn(val[i]));
    }

    return mapped;
  }

  return fn(val);
};

var utils$2 = {
  arrayToObject: arrayToObject,
  assign: assign,
  combine: combine,
  compact: compact,
  decode: decode,
  encode: encode,
  isBuffer: isBuffer,
  isRegExp: isRegExp,
  maybeMap: maybeMap,
  merge: merge
};

var getSideChannel = sideChannel;

var utils$1 = utils$2;

var formats$1 = formats$3;

var has$1 = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + '[]';
  },
  comma: 'comma',
  indices: function indices(prefix, key) {
    return prefix + '[' + key + ']';
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray$2 = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;

var pushToArray = function pushToArray(arr, valueOrArray) {
  push.apply(arr, isArray$2(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;
var defaultFormat = formats$1['default'];
var defaults$1 = {
  addQueryPrefix: false,
  allowDots: false,
  charset: 'utf-8',
  charsetSentinel: false,
  delimiter: '&',
  encode: true,
  encoder: utils$1.encode,
  encodeValuesOnly: false,
  format: defaultFormat,
  formatter: formats$1.formatters[defaultFormat],
  // deprecated
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
  return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};

var sentinel = {};

var stringify$2 = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
  var obj = object;
  var tmpSc = sideChannel;
  var step = 0;
  var findFlag = false;

  while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
    // Where object last appeared in the ref tree
    var pos = tmpSc.get(object);
    step += 1;

    if (typeof pos !== 'undefined') {
      if (pos === step) {
        throw new RangeError('Cyclic object value');
      } else {
        findFlag = true; // Break while
      }
    }

    if (typeof tmpSc.get(sentinel) === 'undefined') {
      step = 0;
    }
  }

  if (typeof filter === 'function') {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate(obj);
  } else if (generateArrayPrefix === 'comma' && isArray$2(obj)) {
    obj = utils$1.maybeMap(obj, function (value) {
      if (value instanceof Date) {
        return serializeDate(value);
      }

      return value;
    });
  }

  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, 'key', format) : prefix;
    }

    obj = '';
  }

  if (isNonNullishPrimitive(obj) || utils$1.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, 'key', format);

      if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
        var valuesArray = split.call(String(obj), ',');
        var valuesJoined = '';

        for (var i = 0; i < valuesArray.length; ++i) {
          valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults$1.encoder, charset, 'value', format));
        }

        return [formatter(keyValue) + (commaRoundTrip && isArray$2(obj) && valuesArray.length === 1 ? '[]' : '') + '=' + valuesJoined];
      }

      return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$1.encoder, charset, 'value', format))];
    }

    return [formatter(prefix) + '=' + formatter(String(obj))];
  }

  var values = [];

  if (typeof obj === 'undefined') {
    return values;
  }

  var objKeys;

  if (generateArrayPrefix === 'comma' && isArray$2(obj)) {
    // we need to join elements in
    objKeys = [{
      value: obj.length > 0 ? obj.join(',') || null : void undefined
    }];
  } else if (isArray$2(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }

  var adjustedPrefix = commaRoundTrip && isArray$2(obj) && obj.length === 1 ? prefix + '[]' : prefix;

  for (var j = 0; j < objKeys.length; ++j) {
    var key = objKeys[j];
    var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

    if (skipNulls && value === null) {
      continue;
    }

    var keyPrefix = isArray$2(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');
    sideChannel.set(object, step);
    var valueSideChannel = getSideChannel();
    valueSideChannel.set(sentinel, sideChannel);
    pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
  }

  return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
  if (!opts) {
    return defaults$1;
  }

  if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
    throw new TypeError('Encoder has to be a function.');
  }

  var charset = opts.charset || defaults$1.charset;

  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }

  var format = formats$1['default'];

  if (typeof opts.format !== 'undefined') {
    if (!has$1.call(formats$1.formatters, opts.format)) {
      throw new TypeError('Unknown format option provided.');
    }

    format = opts.format;
  }

  var formatter = formats$1.formatters[format];
  var filter = defaults$1.filter;

  if (typeof opts.filter === 'function' || isArray$2(opts.filter)) {
    filter = opts.filter;
  }

  return {
    addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
    allowDots: typeof opts.allowDots === 'undefined' ? defaults$1.allowDots : !!opts.allowDots,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$1.charsetSentinel,
    delimiter: typeof opts.delimiter === 'undefined' ? defaults$1.delimiter : opts.delimiter,
    encode: typeof opts.encode === 'boolean' ? opts.encode : defaults$1.encode,
    encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults$1.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
    filter: filter,
    format: format,
    formatter: formatter,
    serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults$1.serializeDate,
    skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults$1.skipNulls,
    sort: typeof opts.sort === 'function' ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$1.strictNullHandling
  };
};

var stringify_1 = function (object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions(opts);
  var objKeys;
  var filter;

  if (typeof options.filter === 'function') {
    filter = options.filter;
    obj = filter('', obj);
  } else if (isArray$2(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }

  var keys = [];

  if (typeof obj !== 'object' || obj === null) {
    return '';
  }

  var arrayFormat;

  if (opts && opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if (opts && 'indices' in opts) {
    arrayFormat = opts.indices ? 'indices' : 'repeat';
  } else {
    arrayFormat = 'indices';
  }

  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

  if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
    throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
  }

  var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

  if (!objKeys) {
    objKeys = Object.keys(obj);
  }

  if (options.sort) {
    objKeys.sort(options.sort);
  }

  var sideChannel = getSideChannel();

  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];

    if (options.skipNulls && obj[key] === null) {
      continue;
    }

    pushToArray(keys, stringify$2(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
  }

  var joined = keys.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? '?' : '';

  if (options.charsetSentinel) {
    if (options.charset === 'iso-8859-1') {
      // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
      prefix += 'utf8=%26%2310003%3B&';
    } else {
      // encodeURIComponent('✓')
      prefix += 'utf8=%E2%9C%93&';
    }
  }

  return joined.length > 0 ? prefix + joined : '';
};

var utils = utils$2;

var has = Object.prototype.hasOwnProperty;
var isArray$1 = Array.isArray;
var defaults = {
  allowDots: false,
  allowPrototypes: false,
  allowSparse: false,
  arrayLimit: 20,
  charset: 'utf-8',
  charsetSentinel: false,
  comma: false,
  decoder: utils.decode,
  delimiter: '&',
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1000,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};

var interpretNumericEntities = function interpretNumericEntities(str) {
  return str.replace(/&#(\d+);/g, function ($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};

var parseArrayValue = function parseArrayValue(val, options) {
  if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
    return val.split(',');
  }

  return val;
}; // This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.


var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.

var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
  var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1; // Keep track of where the utf8 sentinel was found

  var i;
  var charset = options.charset;

  if (options.charsetSentinel) {
    for (i = 0; i < parts.length; ++i) {
      if (parts[i].indexOf('utf8=') === 0) {
        if (parts[i] === charsetSentinel) {
          charset = 'utf-8';
        } else if (parts[i] === isoSentinel) {
          charset = 'iso-8859-1';
        }

        skipIndex = i;
        i = parts.length; // The eslint settings do not allow break;
      }
    }
  }

  for (i = 0; i < parts.length; ++i) {
    if (i === skipIndex) {
      continue;
    }

    var part = parts[i];
    var bracketEqualsPos = part.indexOf(']=');
    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
    var key, val;

    if (pos === -1) {
      key = options.decoder(part, defaults.decoder, charset, 'key');
      val = options.strictNullHandling ? null : '';
    } else {
      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
      val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function (encodedVal) {
        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
      });
    }

    if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
      val = interpretNumericEntities(val);
    }

    if (part.indexOf('[]=') > -1) {
      val = isArray$1(val) ? [val] : val;
    }

    if (has.call(obj, key)) {
      obj[key] = utils.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }

  return obj;
};

var parseObject = function parseObject(chain, val, options, valuesParsed) {
  var leaf = valuesParsed ? val : parseArrayValue(val, options);

  for (var i = chain.length - 1; i >= 0; --i) {
    var obj;
    var root = chain[i];

    if (root === '[]' && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? Object.create(null) : {};
      var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
      var index = parseInt(cleanRoot, 10);

      if (!options.parseArrays && cleanRoot === '') {
        obj = {
          0: leaf
        };
      } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
        obj = [];
        obj[index] = leaf;
      } else if (cleanRoot !== '__proto__') {
        obj[cleanRoot] = leaf;
      }
    }

    leaf = obj;
  }

  return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  } // Transform dot notation to bracket notation


  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey; // The regex chunks

  var brackets = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g; // Get the parent

  var segment = options.depth > 0 && brackets.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key; // Stash the parent if it exists

  var keys = [];

  if (parent) {
    // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
    if (!options.plainObjects && has.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(parent);
  } // Loop through children appending to the array until we hit depth


  var i = 0;

  while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;

    if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(segment[1]);
  } // If there's a remainder, just add whatever is left


  if (segment) {
    keys.push('[' + key.slice(segment.index) + ']');
  }

  return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
  if (!opts) {
    return defaults;
  }

  if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
    throw new TypeError('Decoder has to be a function.');
  }

  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }

  var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
  return {
    allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
    allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
    arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
    comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
    decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
    delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
  };
};

var parse$1 = function (str, opts) {
  var options = normalizeParseOptions(opts);

  if (str === '' || str === null || typeof str === 'undefined') {
    return options.plainObjects ? Object.create(null) : {};
  }

  var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
  var obj = options.plainObjects ? Object.create(null) : {}; // Iterate over the keys and setup the new object

  var keys = Object.keys(tempObj);

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
    obj = utils.merge(obj, newObj, options);
  }

  if (options.allowSparse === true) {
    return obj;
  }

  return utils.compact(obj);
};

var stringify$1 = stringify_1;

var parse = parse$1;

var formats = formats$3;

var lib$1 = {
  formats: formats,
  parse: parse,
  stringify: stringify$1
};

/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString$1 = objectProto$1.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */


function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike$1(value) && objectToString$1.call(value) == stringTag;
}

var lodash_isstring = isString;

var pThrottle$2 = {exports: {}};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$1(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var asyncToGenerator = _asyncToGenerator$1;

function _setPrototypeOf$1(o, p) {
  setPrototypeOf$3 = _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

var setPrototypeOf$3 = _setPrototypeOf$1;

var setPrototypeOf$2 = setPrototypeOf$3;

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf$2(subClass, superClass);
}

var inherits = _inherits$2;

function _typeof$3(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof_1 = _typeof$3 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof_1 = _typeof$3 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$3(obj);
}

var _typeof_1 = _typeof$3;

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized$1 = _assertThisInitialized;

var _typeof$2 = _typeof_1;

var assertThisInitialized = assertThisInitialized$1;

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn$1;

function _getPrototypeOf$1(o) {
  getPrototypeOf$1 = _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

var getPrototypeOf$1 = _getPrototypeOf$1;

function _isNativeFunction$1(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

var isNativeFunction$1 = _isNativeFunction$1;

function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var isNativeReflectConstruct$1 = _isNativeReflectConstruct$3;

var setPrototypeOf$1 = setPrototypeOf$3;

var isNativeReflectConstruct = isNativeReflectConstruct$1;

function _construct$1(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct$1 = _construct$1 = Reflect.construct;
  } else {
    construct$1 = _construct$1 = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) setPrototypeOf$1(instance, Class.prototype);
      return instance;
    };
  }

  return _construct$1.apply(null, arguments);
}

var construct$1 = _construct$1;

var getPrototypeOf = getPrototypeOf$1;

var setPrototypeOf = setPrototypeOf$3;

var isNativeFunction = isNativeFunction$1;

var construct = construct$1;

function _wrapNativeSuper$2(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = _wrapNativeSuper$2 = function _wrapNativeSuper(Class) {
    if (Class === null || !isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return construct(Class, arguments, getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper$2(Class);
}

var wrapNativeSuper = _wrapNativeSuper$2;

var _regeneratorRuntime = regenerator;

var _asyncToGenerator = asyncToGenerator;

var _classCallCheck = classCallCheck;

var _inherits$1 = inherits;

var _possibleConstructorReturn = possibleConstructorReturn;

var _getPrototypeOf = getPrototypeOf$1;

var _wrapNativeSuper$1 = wrapNativeSuper;

function _createForOfIteratorHelper$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AbortError = /*#__PURE__*/function (_Error) {
  _inherits$1(AbortError, _Error);

  var _super = _createSuper$1(AbortError);

  function AbortError() {
    var _this;

    _classCallCheck(this, AbortError);

    _this = _super.call(this, 'Throttled function aborted');
    _this.name = 'AbortError';
    return _this;
  }

  return AbortError;
}( /*#__PURE__*/_wrapNativeSuper$1(Error));

var pThrottle = function pThrottle(_ref) {
  var limit = _ref.limit,
      interval = _ref.interval,
      strict = _ref.strict;

  if (!Number.isFinite(limit)) {
    throw new TypeError('Expected `limit` to be a finite number');
  }

  if (!Number.isFinite(interval)) {
    throw new TypeError('Expected `interval` to be a finite number');
  }

  var queue = new Map();
  var currentTick = 0;
  var activeCount = 0;

  function windowedDelay() {
    var now = Date.now();

    if (now - currentTick > interval) {
      activeCount = 1;
      currentTick = now;
      return 0;
    }

    if (activeCount < limit) {
      activeCount++;
    } else {
      currentTick += interval;
      activeCount = 1;
    }

    return currentTick - now;
  }

  var strictTicks = [];

  function strictDelay() {
    var now = Date.now();

    if (strictTicks.length < limit) {
      strictTicks.push(now);
      return 0;
    }

    var earliestTime = strictTicks.shift() + interval;

    if (now >= earliestTime) {
      strictTicks.push(now);
      return 0;
    }

    strictTicks.push(earliestTime);
    return earliestTime - now;
  }

  var getDelay = strict ? strictDelay : windowedDelay;
  return function (function_) {
    var throttled = function throttled() {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (!throttled.isEnabled) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", function_.apply(_this2, args));

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }

      var timeout;
      return new Promise(function (resolve, reject) {
        var execute = function execute() {
          resolve(function_.apply(_this2, args));
          queue["delete"](timeout);
        };

        timeout = setTimeout(execute, getDelay());
        queue.set(timeout, reject);
      });
    };

    throttled.abort = function () {
      var _iterator = _createForOfIteratorHelper$3(queue.keys()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var timeout = _step.value;
          clearTimeout(timeout);
          queue.get(timeout)(new AbortError());
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      queue.clear();
      strictTicks.splice(0, strictTicks.length);
    };

    throttled.isEnabled = true;
    return throttled;
  };
};

pThrottle$2.exports = pThrottle;
pThrottle$2.exports.AbortError = AbortError;

var pThrottle$1 = pThrottle$2.exports;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var objectTag = '[object Object]';
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */

function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;

  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }

  return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */


function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
/** Used for built-in method references. */


var funcProto = Function.prototype,
    objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString = funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Built-in value references. */

var getPrototype = overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike(value) {
  return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */


function isPlainObject$1(value) {
  if (!isObjectLike(value) || objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }

  var proto = getPrototype(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

var lodash_isplainobject = isPlainObject$1;

function ownKeys$r(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$r(Object(source), !0).forEach(function (key) {
      _defineProperty$5(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$r(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$1(obj);
}

function _wrapRegExp$1() {
  _wrapRegExp$1 = function _wrapRegExp(re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      var i = g[name];
      if ("number" == typeof i) groups[name] = result[i];else {
        for (var k = 0; void 0 === result[i[k]] && k + 1 < i.length;) {
          k++;
        }

        groups[name] = result[i[k]];
      }
      return groups;
    }, Object.create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp$1.apply(this, arguments);
}

function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper$2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e3) {
      didErr = true;
      err = _e3;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function isNode() {
  /**
   * Polyfills of 'process' might set process.browser === true
   *
   * See:
   * https://github.com/webpack/node-libs-browser/blob/master/mock/process.js#L8
   * https://github.com/defunctzombie/node-process/blob/master/browser.js#L156
   **/
  return typeof process !== 'undefined' && !process.browser;
}

function isReactNative() {
  return typeof window !== 'undefined' && 'navigator' in window && 'product' in window.navigator && window.navigator.product === 'ReactNative';
}

function getNodeVersion() {
  return process.versions && process.versions.node ? "v".concat(process.versions.node) : process.version;
}

function getWindow() {
  return window;
}

function noop() {
  return undefined;
}

var PERCENTAGE_REGEX = /*#__PURE__*/_wrapRegExp$1(/(\d+)(%)/, {
  value: 1
});

function calculateLimit(type) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
  var limit = max;

  if (PERCENTAGE_REGEX.test(type)) {
    var _type$match;

    var groups = (_type$match = type.match(PERCENTAGE_REGEX)) === null || _type$match === void 0 ? void 0 : _type$match.groups;

    if (groups && groups.value) {
      var percentage = parseInt(groups.value) / 100;
      limit = Math.round(max * percentage);
    }
  }

  return Math.min(30, Math.max(1, limit));
}

function createThrottle(limit, logger) {
  logger('info', "Throttle request to ".concat(limit, "/s"));
  return pThrottle$1({
    limit: limit,
    interval: 1000,
    strict: false
  });
}

var rateLimitThrottle = function rateLimitThrottle(axiosInstance) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
  var _axiosInstance$defaul = axiosInstance.defaults.logHandler,
      logHandler = _axiosInstance$defaul === void 0 ? noop : _axiosInstance$defaul;
  var limit = lodash_isstring(type) ? calculateLimit(type) : calculateLimit('auto', type);
  var throttle = createThrottle(limit, logHandler);
  var isCalculated = false;
  var requestInterceptorId = axiosInstance.interceptors.request.use(function (config) {
    return throttle(function () {
      return config;
    })();
  }, function (error) {
    return Promise.reject(error);
  });
  var responseInterceptorId = axiosInstance.interceptors.response.use(function (response) {
    if (!isCalculated && lodash_isstring(type) && (type === 'auto' || PERCENTAGE_REGEX.test(type)) && response.headers && response.headers['x-contentful-ratelimit-second-limit']) {
      var rawLimit = parseInt(response.headers['x-contentful-ratelimit-second-limit']);
      var nextLimit = calculateLimit(type, rawLimit);

      if (nextLimit !== limit) {
        if (requestInterceptorId) {
          axiosInstance.interceptors.request.eject(requestInterceptorId);
        }

        limit = nextLimit;
        throttle = createThrottle(nextLimit, logHandler);
        requestInterceptorId = axiosInstance.interceptors.request.use(function (config) {
          return throttle(function () {
            return config;
          })();
        }, function (error) {
          return Promise.reject(error);
        });
      }

      isCalculated = true;
    }

    return response;
  }, function (error) {
    return Promise.reject(error);
  });
  return function () {
    axiosInstance.interceptors.request.eject(requestInterceptorId);
    axiosInstance.interceptors.response.eject(responseInterceptorId);
  };
};

var delay = function delay(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
};

var defaultWait = function defaultWait(attempts) {
  return Math.pow(Math.SQRT2, attempts);
};

function rateLimit(instance) {
  var maxRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var _instance$defaults = instance.defaults,
      _instance$defaults$re = _instance$defaults.responseLogger,
      responseLogger = _instance$defaults$re === void 0 ? noop : _instance$defaults$re,
      _instance$defaults$re2 = _instance$defaults.requestLogger,
      requestLogger = _instance$defaults$re2 === void 0 ? noop : _instance$defaults$re2;
  instance.interceptors.request.use(function (config) {
    requestLogger(config);
    return config;
  }, function (error) {
    requestLogger(error);
    return Promise.reject(error);
  });
  instance.interceptors.response.use(function (response) {
    // we don't need to do anything here
    responseLogger(response);
    return response;
  }, function (error) {
    var response = error.response;
    var config = error.config;
    responseLogger(error); // Do not retry if it is disabled or no request config exists (not an axios error)

    if (!config || !instance.defaults.retryOnError) {
      return Promise.reject(error);
    } // Retried already for max attempts


    var doneAttempts = config.attempts || 1;

    if (doneAttempts > maxRetry) {
      error.attempts = config.attempts;
      return Promise.reject(error);
    }

    var retryErrorType = null;
    var wait = defaultWait(doneAttempts); // Errors without response did not receive anything from the server

    if (!response) {
      retryErrorType = 'Connection';
    } else if (response.status >= 500 && response.status < 600) {
      // 5** errors are server related
      retryErrorType = "Server ".concat(response.status);
    } else if (response.status === 429) {
      // 429 errors are exceeded rate limit exceptions
      retryErrorType = 'Rate limit'; // all headers are lowercased by axios https://github.com/mzabriskie/axios/issues/413

      if (response.headers && error.response.headers['x-contentful-ratelimit-reset']) {
        wait = response.headers['x-contentful-ratelimit-reset'];
      }
    }

    if (retryErrorType) {
      // convert to ms and add jitter
      wait = Math.floor(wait * 1000 + Math.random() * 200 + 500);
      instance.defaults.logHandler('warning', "".concat(retryErrorType, " error occurred. Waiting for ").concat(wait, " ms before retrying...")); // increase attempts counter

      config.attempts = doneAttempts + 1;
      /* Somehow between the interceptor and retrying the request the httpAgent/httpsAgent gets transformed from an Agent-like object
       to a regular object, causing failures on retries after rate limits. Removing these properties here fixes the error, but retry
       requests still use the original http/httpsAgent property */

      delete config.httpAgent;
      delete config.httpsAgent;
      return delay(wait).then(function () {
        return instance(config);
      });
    }

    return Promise.reject(error);
  });
}

function asyncToken(instance, getToken) {
  instance.interceptors.request.use(function (config) {
    return getToken().then(function (accessToken) {
      config.headers = _objectSpread2(_objectSpread2({}, config.headers), {}, {
        Authorization: "Bearer ".concat(accessToken)
      });
      return config;
    });
  });
} // Matches 'sub.host:port' or 'host:port' and extracts hostname and port
// Also enforces toplevel domain specified, no spaces and no protocol


var HOST_REGEX = /^(?!\w+:\/\/)([^\s:]+\.?[^\s:]+)(?::(\d+))?(?!:)$/;
/**
 * Create pre configured axios instance
 * @private
 * @param {AxiosStatic} axios - Axios library
 * @param {CreateHttpClientParams} options - Initialization parameters for the HTTP client
 * @return {ContentfulAxiosInstance} Initialized axios instance
 */

function createHttpClient(axios, options) {
  var defaultConfig = {
    insecure: false,
    retryOnError: true,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    logHandler: function logHandler(level, data) {
      if (level === 'error' && data) {
        var title = [data.name, data.message].filter(function (a) {
          return a;
        }).join(' - ');
        console.error("[error] ".concat(title));
        console.error(data);
        return;
      }

      console.log("[".concat(level, "] ").concat(data));
    },
    // Passed to axios
    headers: {},
    httpAgent: false,
    httpsAgent: false,
    timeout: 30000,
    throttle: 0,
    proxy: false,
    basePath: '',
    adapter: undefined,
    maxContentLength: 1073741824,
    // 1GB
    maxBodyLength: 1073741824 // 1GB

  };

  var config = _objectSpread2(_objectSpread2({}, defaultConfig), options);

  if (!config.accessToken) {
    var missingAccessTokenError = new TypeError('Expected parameter accessToken');
    config.logHandler('error', missingAccessTokenError);
    throw missingAccessTokenError;
  } // Construct axios baseURL option


  var protocol = config.insecure ? 'http' : 'https';
  var space = config.space ? "".concat(config.space, "/") : '';
  var hostname = config.defaultHostname;
  var port = config.insecure ? 80 : 443;

  if (config.host && HOST_REGEX.test(config.host)) {
    var parsed = config.host.split(':');

    if (parsed.length === 2) {
      var _parsed = _slicedToArray(parsed, 2);

      hostname = _parsed[0];
      port = _parsed[1];
    } else {
      hostname = parsed[0];
    }
  } // Ensure that basePath does start but not end with a slash


  if (config.basePath) {
    config.basePath = "/".concat(config.basePath.split('/').filter(Boolean).join('/'));
  }

  var baseURL = options.baseURL || "".concat(protocol, "://").concat(hostname, ":").concat(port).concat(config.basePath, "/spaces/").concat(space);

  if (!config.headers.Authorization && typeof config.accessToken !== 'function') {
    config.headers.Authorization = 'Bearer ' + config.accessToken;
  } // Set these headers only for node because browsers don't like it when you
  // override user-agent or accept-encoding.
  // The SDKs should set their own X-Contentful-User-Agent.


  if (isNode()) {
    config.headers['user-agent'] = 'node.js/' + getNodeVersion();
    config.headers['Accept-Encoding'] = 'gzip';
  }

  var axiosOptions = {
    // Axios
    baseURL: baseURL,
    headers: config.headers,
    httpAgent: config.httpAgent,
    httpsAgent: config.httpsAgent,
    paramsSerializer: lib$1.stringify,
    proxy: config.proxy,
    timeout: config.timeout,
    adapter: config.adapter,
    maxContentLength: config.maxContentLength,
    maxBodyLength: config.maxBodyLength,
    // Contentful
    logHandler: config.logHandler,
    responseLogger: config.responseLogger,
    requestLogger: config.requestLogger,
    retryOnError: config.retryOnError
  };
  var instance = axios.create(axiosOptions);
  instance.httpClientParams = options;
  /**
   * Creates a new axios instance with the same default base parameters as the
   * current one, and with any overrides passed to the newParams object
   * This is useful as the SDKs use dependency injection to get the axios library
   * and the version of the library comes from different places depending
   * on whether it's a browser build or a node.js build.
   * @private
   * @param {CreateHttpClientParams} httpClientParams - Initialization parameters for the HTTP client
   * @return {ContentfulAxiosInstance} Initialized axios instance
   */

  instance.cloneWithNewParams = function (newParams) {
    return createHttpClient(axios, _objectSpread2(_objectSpread2({}, copy(options)), newParams));
  };
  /**
   * Apply interceptors.
   * Please note that the order of interceptors is important
   */


  if (config.onBeforeRequest) {
    instance.interceptors.request.use(config.onBeforeRequest);
  }

  if (typeof config.accessToken === 'function') {
    asyncToken(instance, config.accessToken);
  }

  if (config.throttle) {
    rateLimitThrottle(instance, config.throttle);
  }

  rateLimit(instance, config.retryLimit);

  if (config.onError) {
    instance.interceptors.response.use(function (response) {
      return response;
    }, config.onError);
  }

  return instance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Creates request parameters configuration by parsing an existing query object
 * @private
 * @param {Object} query
 * @return {Object} Config object with `params` property, ready to be used in axios
 */


function createRequestConfig(_ref) {
  var query = _ref.query;
  var config = {};
  delete query.resolveLinks;
  config.params = copy(query);
  return config;
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function deepFreeze(object) {
  var propNames = Object.getOwnPropertyNames(object);

  var _iterator = _createForOfIteratorHelper$2(propNames),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var name = _step.value;
      var value = object[name];

      if (value && _typeof$1(value) === 'object') {
        deepFreeze(value);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return Object.freeze(object);
}

function freezeSys(obj) {
  deepFreeze(obj.sys || {});
  return obj;
}

function getBrowserOS() {
  var win = getWindow();

  if (!win) {
    return null;
  }

  var userAgent = win.navigator.userAgent; // TODO: platform is deprecated.

  var platform = win.navigator.platform;
  var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  var iosPlatforms = ['iPhone', 'iPad', 'iPod'];

  if (macosPlatforms.indexOf(platform) !== -1) {
    return 'macOS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    return 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    return 'Windows';
  } else if (/Android/.test(userAgent)) {
    return 'Android';
  } else if (/Linux/.test(platform)) {
    return 'Linux';
  }

  return null;
}

function getNodeOS() {
  var platform = process.platform || 'linux';
  var version = process.version || '0.0.0';
  var platformMap = {
    android: 'Android',
    aix: 'Linux',
    darwin: 'macOS',
    freebsd: 'Linux',
    linux: 'Linux',
    openbsd: 'Linux',
    sunos: 'Linux',
    win32: 'Windows'
  };

  if (platform in platformMap) {
    return "".concat(platformMap[platform] || 'Linux', "/").concat(version);
  }

  return null;
}

function getUserAgentHeader(sdk, application, integration, feature) {
  var headerParts = [];

  if (application) {
    headerParts.push("app ".concat(application));
  }

  if (integration) {
    headerParts.push("integration ".concat(integration));
  }

  if (feature) {
    headerParts.push('feature ' + feature);
  }

  headerParts.push("sdk ".concat(sdk));
  var platform = null;

  try {
    if (isReactNative()) {
      platform = getBrowserOS();
      headerParts.push('platform ReactNative');
    } else if (isNode()) {
      platform = getNodeOS();
      headerParts.push("platform node.js/".concat(getNodeVersion()));
    } else {
      platform = getBrowserOS();
      headerParts.push('platform browser');
    }
  } catch (e) {
    platform = null;
  }

  if (platform) {
    headerParts.push("os ".concat(platform));
  }

  return "".concat(headerParts.filter(function (item) {
    return item !== '';
  }).join('; '), ";");
}
/**
 * Mixes in a method to return just a plain object with no additional methods
 * @private
 * @param data - Any plain JSON response returned from the API
 * @return Enhanced object with toPlainObject method
 */


function toPlainObject(data) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  return Object.defineProperty(data, 'toPlainObject', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: function value() {
      return copy(this);
    }
  });
}
/**
 * Handles errors received from the server. Parses the error into a more useful
 * format, places it in an exception and throws it.
 * See https://www.contentful.com/developers/docs/references/errors/
 * for more details on the data received on the errorResponse.data property
 * and the expected error codes.
 * @private
 */


function errorHandler(errorResponse) {
  var config = errorResponse.config,
      response = errorResponse.response;
  var errorName; // Obscure the Management token

  if (config && config.headers && config.headers['Authorization']) {
    var token = "...".concat(config.headers['Authorization'].toString().substr(-5));
    config.headers['Authorization'] = "Bearer ".concat(token);
  }

  if (!lodash_isplainobject(response) || !lodash_isplainobject(config)) {
    throw errorResponse;
  }

  var data = response === null || response === void 0 ? void 0 : response.data;
  var errorData = {
    status: response === null || response === void 0 ? void 0 : response.status,
    statusText: response === null || response === void 0 ? void 0 : response.statusText,
    message: '',
    details: {}
  };

  if (lodash_isplainobject(config)) {
    errorData.request = {
      url: config.url,
      headers: config.headers,
      method: config.method,
      payloadData: config.data
    };
  }

  if (data && lodash_isplainobject(data)) {
    if ('requestId' in data) {
      errorData.requestId = data.requestId || 'UNKNOWN';
    }

    if ('message' in data) {
      errorData.message = data.message || '';
    }

    if ('details' in data) {
      errorData.details = data.details || {};
    }

    if ('sys' in data) {
      if ('id' in data.sys) {
        errorName = data.sys.id;
      }
    }
  }

  var error = new Error();
  error.name = errorName && errorName !== 'Unknown' ? errorName : "".concat(response === null || response === void 0 ? void 0 : response.status, " ").concat(response === null || response === void 0 ? void 0 : response.statusText);

  try {
    error.message = JSON.stringify(errorData, null, '  ');
  } catch (_unused) {
    var _errorData$message;

    error.message = (_errorData$message = errorData === null || errorData === void 0 ? void 0 : errorData.message) !== null && _errorData$message !== void 0 ? _errorData$message : '';
  }

  throw error;
}

/**
 * @memberof Entities
 * @typedef Space
 * @prop {Object} sys - System metadata
 * @prop {string} sys.id - Space id
 * @prop {string} sys.type - Entity type
 * @prop {string} name - Space name
 * @prop {Array<string>} locales - Array with locale codes
 * @prop {function(): Object} toPlainObject() - Returns this Space as a plain JS object
 */

/**
 * @private
 * @param  {Object} data - API response for a Space
 * @return {Space}
 */

function wrapSpace(data) {
  return freezeSys(toPlainObject(data));
}

var space = /*#__PURE__*/Object.freeze({
	__proto__: null,
	wrapSpace: wrapSpace
});

var stringify = {exports: {}};

(function (module, exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

function serializer(replacer, cycleReplacer) {
  var stack = [],
      keys = [];
  if (cycleReplacer == null) cycleReplacer = function cycleReplacer(key, value) {
    if (stack[0] === value) return "[Circular ~]";
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
  };
  return function (key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
    } else stack.push(value);

    return replacer == null ? value : replacer.call(this, key, value);
  };
}
}(stringify, stringify.exports));

var jsonStringifySafe = stringify.exports;

function mixinStringifySafe(data) {
  return Object.defineProperty(data, 'stringifySafe', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: function value() {
      var serializer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return jsonStringifySafe(this, serializer, indent, function (key, value) {
        return {
          sys: {
            type: 'Link',
            linkType: 'Entry',
            id: value.sys.id,
            circular: true
          }
        };
      });
    }
  });
}

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); _groups.set(_this, groups || _groups.get(re)); return _setPrototypeOf$3(_this, BabelRegExp.prototype); } _inherits$b(BabelRegExp, RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; if (typeof args[args.length - 1] !== "object") { args = [].slice.call(args); args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}
var UNRESOLVED_LINK = {}; // unique object to avoid polyfill bloat using Symbol()

/**
 * isLink Function
 * Checks if the object has sys.type "Link"
 * @param object
 */

var isLink = function isLink(object) {
  return object && object.sys && object.sys.type === 'Link';
};
/**
 * isResourceLink Function
 * Checks if the object has sys.type "ResourceLink"
 * @param object
 */


var isResourceLink = function isResourceLink(object) {
  return object && object.sys && object.sys.type === 'ResourceLink';
};
/**
 * Creates a key with spaceId and a key without for entityMap
 *
 * @param {*} sys
 * @param {String} sys.type
 * @param {String} sys.id
 * @param {*} sys.space
 * @param {*} sys.space.sys
 * @param {String} sys.space.id
 * @return {string[]}
 */


var makeEntityMapKeys = function makeEntityMapKeys(sys) {
  return sys.space ? [sys.type + '!' + sys.id, sys.space.sys.id + '!' + sys.type + '!' + sys.id] : [sys.type + '!' + sys.id];
};
/**
 * Looks up in entityMap
 *
 * @param entityMap
 * @param {*} linkData
 * @param {String} linkData.type
 * @param {String} linkData.linkType
 * @param {String} linkData.id
 * @param {String} linkData.urn
 * @return {String}
 */


var lookupInEntityMap = function lookupInEntityMap(entityMap, linkData) {
  var entryId = linkData.entryId,
      linkType = linkData.linkType,
      spaceId = linkData.spaceId;

  if (spaceId) {
    return entityMap.get(spaceId + '!' + linkType + '!' + entryId);
  }

  return entityMap.get(linkType + '!' + entryId);
};
/**
 * getResolvedLink Function
 *
 * @param entityMap
 * @param link
 * @return {undefined}
 */


var getResolvedLink = function getResolvedLink(entityMap, link) {
  var _link$sys = link.sys,
      type = _link$sys.type,
      linkType = _link$sys.linkType;

  if (type === 'ResourceLink') {
    var urn = link.sys.urn;

    var regExp = /*#__PURE__*/_wrapRegExp(/.*:spaces\/([0-9A-Za-z]*)\/entries\/([0-9A-Za-z]*)/, {
      spaceId: 1,
      entryId: 2
    });

    if (!regExp.test(urn)) {
      return UNRESOLVED_LINK;
    }

    var _urn$match$groups = urn.match(regExp).groups,
        spaceId = _urn$match$groups.spaceId,
        _entryId = _urn$match$groups.entryId;
    var extractedLinkType = linkType.split(':')[1];
    return lookupInEntityMap(entityMap, {
      linkType: extractedLinkType,
      entryId: _entryId,
      spaceId: spaceId
    }) || UNRESOLVED_LINK;
  }

  var entryId = link.sys.id;
  return lookupInEntityMap(entityMap, {
    linkType: linkType,
    entryId: entryId
  }) || UNRESOLVED_LINK;
};
/**
 * cleanUpLinks Function
 * - Removes unresolvable links from Arrays and Objects
 *
 * @param {Object[]|Object} input
 */


var cleanUpLinks = function cleanUpLinks(input) {
  if (Array.isArray(input)) {
    return input.filter(function (val) {
      return val !== UNRESOLVED_LINK;
    });
  }

  for (var key in input) {
    if (input[key] === UNRESOLVED_LINK) {
      delete input[key];
    }
  }

  return input;
};
/**
 * walkMutate Function
 * @param input
 * @param predicate
 * @param mutator
 * @param removeUnresolved
 * @return {*}
 */


var walkMutate = function walkMutate(input, predicate, mutator, removeUnresolved) {
  if (predicate(input)) {
    return mutator(input);
  }

  if (input && (typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object') {
    for (var key in input) {
      // eslint-disable-next-line no-prototype-builtins
      if (input.hasOwnProperty(key)) {
        input[key] = walkMutate(input[key], predicate, mutator, removeUnresolved);
      }
    }

    if (removeUnresolved) {
      input = cleanUpLinks(input);
    }
  }

  return input;
};

var normalizeLink = function normalizeLink(entityMap, link, removeUnresolved) {
  var resolvedLink = getResolvedLink(entityMap, link);

  if (resolvedLink === UNRESOLVED_LINK) {
    return removeUnresolved ? resolvedLink : link;
  }

  return resolvedLink;
};

var makeEntryObject = function makeEntryObject(item, itemEntryPoints) {
  if (!Array.isArray(itemEntryPoints)) {
    return item;
  }

  var entryPoints = Object.keys(item).filter(function (ownKey) {
    return itemEntryPoints.indexOf(ownKey) !== -1;
  });
  return entryPoints.reduce(function (entryObj, entryPoint) {
    entryObj[entryPoint] = item[entryPoint];
    return entryObj;
  }, {});
};
/**
 * resolveResponse Function
 * Resolves contentful response to normalized form.
 * @param {Object} response Contentful response
 * @param {{removeUnresolved: Boolean, itemEntryPoints: Array<String>}|{}} options
 * @param {Boolean} options.removeUnresolved - Remove unresolved links default:false
 * @param {Array<String>} options.itemEntryPoints - Resolve links only in those item properties
 * @return {Object}
 */


var resolveResponse = function resolveResponse(response, options) {
  options = options || {};

  if (!response.items) {
    return [];
  }

  var responseClone = copy(response);
  var allIncludes = Object.keys(responseClone.includes || {}).reduce(function (all, type) {
    return [].concat(_toConsumableArray(all), _toConsumableArray(response.includes[type]));
  }, []);
  var allEntries = [].concat(_toConsumableArray(responseClone.items), _toConsumableArray(allIncludes));
  var entityMap = new Map(allEntries.reduce(function (acc, entity) {
    var entries = makeEntityMapKeys(entity.sys).map(function (key) {
      return [key, entity];
    });
    acc.push.apply(acc, _toConsumableArray(entries));
    return acc;
  }, []));
  allEntries.forEach(function (item) {
    var entryObject = makeEntryObject(item, options.itemEntryPoints);
    Object.assign(item, walkMutate(entryObject, function (x) {
      return isLink(x) || isResourceLink(x);
    }, function (link) {
      return normalizeLink(entityMap, link, options.removeUnresolved);
    }, options.removeUnresolved));
  });
  return responseClone.items;
};

/**
 * Types of fields found in an Entry
 * @namespace EntryFields
 */

/**
 * @memberof EntryFields
 * @typedef Symbol
 * @type string
 */

/**
 * @memberof EntryFields
 * @typedef Text
 * @type string
 */

/**
 * @memberof EntryFields
 * @typedef Integer
 * @type number
 */

/**
 * @memberof EntryFields
 * @typedef Number
 * @type number
 */

/**
 * @memberof EntryFields
 * @typedef Date
 * @type string
 */

/**
 * @memberof EntryFields
 * @typedef Boolean
 * @type boolean
 */

/**
 * @memberof EntryFields
 * @typedef Location
 * @prop {string} lat - latitude
 * @prop {string} lon - longitude
 */

/**
 * A Field in an Entry can have one of the following types that can be defined in Contentful. See <a href="https://www.contentful.com/developers/docs/references/field-type/">Field Types</a> for more details.
 * @memberof Entities
 * @typedef Field
 * @type EntryFields.Symbol | EntryFields.Text | EntryFields.Integer | EntryFields.Number | EntryFields.Date | EntryFields.Boolean | EntryFields.Location | Entities.Link | Entities.ResourceLink | Array<EntryFields.Symbol|Entities.Link|Entities.ResourceLink> | Object
 */

/**
 * @memberof Entities
 * @typedef Entry
 * @prop {Entities.Sys} sys - Standard system metadata with additional entry specific properties
 * @prop {Entities.Link} sys.contentType - Content Type used by this Entry
 * @prop {string=} sys.locale - If present, indicates the locale which this entry uses
 * @prop {Object<EntryFields.Field>} fields - Object with content for each field
 * @prop {function(): Object} toPlainObject() - Returns this Entry as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw entry data
 * @return {Entry} Wrapped entry data
 */

function wrapEntry(data) {
  return freezeSys(toPlainObject(copy(data)));
}
/**
 * @memberof Entities
 * @typedef EntryCollection
 * @prop {number} total
 * @prop {number} skip
 * @prop {number} limit
 * @prop {Array<Entities.Entry>} items
 * @prop {Array<Object>=} errors - Array of errors that might occur when retrieving entries.
 * @prop {Object<Array>=} includes - Object with arrays of includes for Entries and Assets. This will be present if resolveLinks is on, and any linked entries or assets exist. Those links will be resolved in the Entries present in the items array, but they are also present here in raw form.
 * @prop {function(): Object} toPlainObject() - Returns this Entry collection as a plain JS object
 * @prop {function(?function=, space=): Object} stringifySafe(replacer,space) - Stringifies the entry collection, accounting for circular references. Circular references will be replaced with just a Link object, with a <code>circular</code> property set to <code>true</code>. See <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify">MDN</a> and <a href="https://www.npmjs.com/package/json-stringify-safe">json-stringify-safe</a> for more details on the arguments this method can take.
 */

/**
 * Data is also mixed in with link getters if links exist and includes were requested
 * @private
 * @param {Object} data - Raw entry collection data
 * @param {Object} options - wrapper options
 * @return {EntryCollection} Wrapped entry collection data
 */

function wrapEntryCollection(data, _ref) {
  var resolveLinks = _ref.resolveLinks,
      removeUnresolved = _ref.removeUnresolved;
  var wrappedData = mixinStringifySafe(toPlainObject(copy(data)));

  if (resolveLinks) {
    wrappedData.items = resolveResponse(wrappedData, {
      removeUnresolved: removeUnresolved,
      itemEntryPoints: ['fields']
    });
  }

  return freezeSys(wrappedData);
}

var entry = /*#__PURE__*/Object.freeze({
	__proto__: null,
	wrapEntry: wrapEntry,
	wrapEntryCollection: wrapEntryCollection
});

/**
 * @memberof Entities
 * @typedef Asset
 * @prop {Entities.Sys} sys - Standard system metadata with additional entry specific properties
 * @prop {string=} sys.locale - If present, indicates the locale which this asset uses
 * @prop {Object} fields - Object with content for each field
 * @prop {string} fields.title - Title for this asset
 * @prop {string} fields.description - Description for this asset
 * @prop {Object} fields.file - File object for this asset
 * @prop {string} fields.file.fileName - Name for the file
 * @prop {string} fields.file.contentType - Mime type for the file
 * @prop {string} fields.file.url - Url where the file is available at.
 * @prop {Object} fields.file.details - Details for the file, depending on file type (example: image size in bytes, etc)
 * @prop {function(): Object} toPlainObject() - Returns this Asset as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw asset data
 * @return {Asset} Wrapped asset data
 */

function wrapAsset(data) {
  return freezeSys(toPlainObject(copy(data)));
}
/**
 * @memberof Entities
 * @typedef AssetCollection
 * @prop {number} total
 * @prop {number} skip
 * @prop {number} limit
 * @prop {Array<Entities.Asset>} items
 * @prop {function(): Object} toPlainObject() - Returns this Asset collection as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw asset collection data
 * @return {AssetCollection} Wrapped asset collection data
 */

function wrapAssetCollection(data) {
  return freezeSys(toPlainObject(copy(data)));
}

var asset = /*#__PURE__*/Object.freeze({
	__proto__: null,
	wrapAsset: wrapAsset,
	wrapAssetCollection: wrapAssetCollection
});

/**
 * @memberof Entities
 * @typedef AssetKey
 * @prop {string} policy - The asset key's policy
 * @prop {string} secret - The secret for creating a signing token
 * @prop {function(): Object} toPlainObject() - Returns this AssetKey as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw asset key data
 * @return {Asset} Wrapped asset key data
 */

function wrapAssetKey(data) {
  return freezeSys(toPlainObject(copy(data)));
}

var assetKey = /*#__PURE__*/Object.freeze({
	__proto__: null,
	wrapAssetKey: wrapAssetKey
});

/**
 * @memberof Entities
 * @typedef ContentType
 * @prop {Entities.Sys} sys - System metadata
 * @prop {string} name
 * @prop {string} description
 * @prop {string} displayField - Field used as the main display field for Entries
 * @prop {string} Array<Field> - All the fields contained in this Content Type
 * @prop {function(): Object} toPlainObject() - Returns this Content Type as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw content type data
 * @return {ContentType} Wrapped content type data
 */

function wrapContentType(data) {
  return freezeSys(toPlainObject(copy(data)));
}
/**
 * @memberof Entities
 * @typedef ContentTypeCollection
 * @prop {number} total
 * @prop {number} skip
 * @prop {number} limit
 * @prop {Array<Entities.ContentType>} items
 * @prop {function(): Object} toPlainObject() - Returns this Content Type collection as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw content type collection data
 * @return {ContentTypeCollection} Wrapped content type collection data
 */

function wrapContentTypeCollection(data) {
  return freezeSys(toPlainObject(copy(data)));
}

var contentType = /*#__PURE__*/Object.freeze({
	__proto__: null,
	wrapContentType: wrapContentType,
	wrapContentTypeCollection: wrapContentTypeCollection
});

/**
 * @memberof Entities
 * @typedef Locale
 * @prop {Entities.Sys} sys - Standard system metadata with additional entry specific properties
 * @prop {string} name - locale name (example: English)
 * @prop {string} code - locale code (example: en-US)
 * @prop {string} fallbackCode - the locale code to fallback to when there is not content for the current locale
 * @prop {boolean} default - If this is the default locale
 * @prop {boolean} optional - If the locale needs to be filled in on entries or not
 * @prop {function(): Object} toPlainObject() - Returns this Locale as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw locale data
 * @return {Locale} Wrapped locale data
 */

function wrapLocale(data) {
  return freezeSys(toPlainObject(copy(data)));
}
/**
 * @memberof Entities
 * @typedef LocaleCollection
 * @prop {number} total
 * @prop {number} skip
 * @prop {number} limit
 * @prop {Array<Entities.Locale>} items
 * @prop {function(): Object} toPlainObject() - Returns this Locale collection as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw locale collection data
 * @return {LocaleCollection} Wrapped locale collection data
 */

function wrapLocaleCollection(data) {
  return freezeSys(toPlainObject(copy(data)));
}

var locale = /*#__PURE__*/Object.freeze({
	__proto__: null,
	wrapLocale: wrapLocale,
	wrapLocaleCollection: wrapLocaleCollection
});

/**
 * @memberof Entities
 * @typedef Tag
 * @prop {Entities.Sys} sys - Standard system metadata with additional entry specific properties
 * @prop {string} name - Tag name
 * @prop {function(): Object} toPlainObject() - Returns this tag as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw tag data
 * @return {Tag} Wrapped tag data
 */

function wrapTag(data) {
  return freezeSys(toPlainObject(copy(data)));
}
/**
 * @memberof Entities
 * @typedef TagCollection
 * @prop {number} total
 * @prop {number} skip
 * @prop {number} limit
 * @prop {Array<Entities.Tag>} items
 * @prop {function(): Object} toPlainObject() - Returns this Tag collection as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw tag collection data
 * @return {TagCollection} Wrapped tag collection data
 */

function wrapTagCollection(data) {
  return freezeSys(toPlainObject(copy(data)));
}

var tag = /*#__PURE__*/Object.freeze({
	__proto__: null,
	wrapTag: wrapTag,
	wrapTagCollection: wrapTagCollection
});

var entities = {
  space: space,
  entry: entry,
  asset: asset,
  assetKey: assetKey,
  contentType: contentType,
  locale: locale,
  tag: tag
};

function ownKeys$q(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$q(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$q(Object(source), !0).forEach(function (key) {
      _defineProperty$4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$q(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty$4(obj, key, value) {
  key = _toPropertyKey$3(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey$3(arg) {
  var key = _toPrimitive$3(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive$3(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}
/**
 * @memberof Sync
 * @typedef SyncCollection
 * @prop {Array<Entities.Entry>} entries - All existing entries on first sync. New and updated entries on subsequent syncs.
 * @prop {Array<Entities.Asset>} assets - All existing assets on first sync. New and updated assets on subsequent syncs.
 * @prop {Array<Sync.DeletedEntry>} deletedEntries - List of deleted Entries since last sync
 * @prop {Array<Sync.DeletedAsset>} deletedAssets - List of deleted Assets since last sync
 * @prop {string} nextSyncToken - Token to be sent to the next sync call
 * @prop {function(): Object} toPlainObject() - Returns this Sync collection as a plain JS object
 * @prop {function(?function=, space=): Object} stringifySafe(replacer,space) - Stringifies the Sync collection, accounting for circular references. Circular references will be replaced with just a Link object, with a <code>circular</code> property set to <code>true</code>. See <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify">MDN</a> and <a href="https://www.npmjs.com/package/json-stringify-safe">json-stringify-safe</a> for more details on the arguments this method can take.
 */

/**
 * Deleted Entries are the same as Entries, but only appear on the sync API.
 * @memberof Sync
 * @typedef DeletedEntry
 * @type Entities.Entry
 */

/**
 * Deleted Assets are the same as Assets, but only appear on the sync API.
 * @memberof Sync
 * @typedef DeletedAsset
 * @type Entities.Asset
 */

/**
 * This module retrieves all the available pages for a sync operation
 * @private
 * @param {Object} http - HTTP client
 * @param {Object} query - Query object
 * @param {Object} options - Sync options object
 * @param {boolean} [options.resolveLinks = true] - If links should be resolved
 * @param {boolean} [options.removeUnresolved = false] - If unresolvable links should get removed
 * @param {boolean} [options.paginate = true] - If further sync pages should automatically be crawled
 * @return {Promise<SyncCollection>}
 */

function pagedSync(_x, _x2) {
  return _pagedSync.apply(this, arguments);
}
/**
 * @private
 * @param {Array<Entities.Entry|Entities.Array|Sync.DeletedEntry|Sync.DeletedAsset>} items
 * @return {Object} Entities mapped to an object for each entity type
 */

function _pagedSync() {
  _pagedSync = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee(http, query) {
    var options,
        defaultOptions,
        _objectSpread2,
        resolveLinks,
        removeUnresolved,
        paginate,
        syncOptions,
        response,
        mappedResponseItems,
        _args = arguments;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};

            if (!(!query || !query.initial && !query.nextSyncToken && !query.nextPageToken)) {
              _context.next = 3;
              break;
            }

            throw new Error('Please provide one of `initial`, `nextSyncToken` or `nextPageToken` parameters for syncing');

          case 3:
            if (!(query && query.content_type && !query.type)) {
              _context.next = 7;
              break;
            }

            query.type = 'Entry';
            _context.next = 9;
            break;

          case 7:
            if (!(query && query.content_type && query.type && query.type !== 'Entry')) {
              _context.next = 9;
              break;
            }

            throw new Error('When using the `content_type` filter your `type` parameter cannot be different from `Entry`.');

          case 9:
            defaultOptions = {
              resolveLinks: true,
              removeUnresolved: false,
              paginate: true
            };
            _objectSpread2 = _objectSpread$q(_objectSpread$q({}, defaultOptions), options), resolveLinks = _objectSpread2.resolveLinks, removeUnresolved = _objectSpread2.removeUnresolved, paginate = _objectSpread2.paginate;
            syncOptions = {
              paginate: paginate
            };
            _context.next = 14;
            return getSyncPage(http, [], query, syncOptions);

          case 14:
            response = _context.sent;

            // clones response.items used in includes because we don't want these to be mutated
            if (resolveLinks) {
              response.items = resolveResponse(response, {
                removeUnresolved: removeUnresolved,
                itemEntryPoints: ['fields']
              });
            } // maps response items again after getters are attached


            mappedResponseItems = mapResponseItems(response.items);

            if (response.nextSyncToken) {
              mappedResponseItems.nextSyncToken = response.nextSyncToken;
            }

            if (response.nextPageToken) {
              mappedResponseItems.nextPageToken = response.nextPageToken;
            }

            return _context.abrupt("return", freezeSys(mixinStringifySafe(toPlainObject(mappedResponseItems))));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _pagedSync.apply(this, arguments);
}

function mapResponseItems(items) {
  var reducer = function reducer(type) {
    return function (accumulated, item) {
      if (item.sys.type === type) {
        accumulated.push(toPlainObject(item));
      }

      return accumulated;
    };
  };

  return {
    entries: items.reduce(reducer('Entry'), []),
    assets: items.reduce(reducer('Asset'), []),
    deletedEntries: items.reduce(reducer('DeletedEntry'), []),
    deletedAssets: items.reduce(reducer('DeletedAsset'), [])
  };
}
/**
 * If the response contains a nextPageUrl, extracts the sync token to get the
 * next page and calls itself again with that token.
 * Otherwise, if the response contains a nextSyncUrl, extracts the sync token
 * and returns it.
 * On each call of this function, any retrieved items are collected in the
 * supplied items array, which gets returned in the end
 * @private
 * @param {Object} http
 * @param {Array<Entities.Entry|Entities.Array|Sync.DeletedEntry|Sync.DeletedAsset>} items
 * @param {Object} query
 * @param {Object} options - Sync page options object
 * @param {boolean} [options.paginate = true] - If further sync pages should automatically be crawled
 * @return {Promise<{items: Array, nextSyncToken: string}>}
 */


function getSyncPage(_x3, _x4, _x5, _x6) {
  return _getSyncPage.apply(this, arguments);
}
/**
 * Extracts token out of an url
 * @private
 */


function _getSyncPage() {
  _getSyncPage = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2(http, items, query, _ref) {
    var paginate, response, data;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            paginate = _ref.paginate;

            if (query.nextSyncToken) {
              query.sync_token = query.nextSyncToken;
              delete query.nextSyncToken;
            }

            if (query.nextPageToken) {
              query.sync_token = query.nextPageToken;
              delete query.nextPageToken;
            }

            if (query.sync_token) {
              delete query.initial;
              delete query.type;
              delete query.content_type;
              delete query.limit;
            }

            _context2.next = 6;
            return http.get('sync', createRequestConfig({
              query: query
            }));

          case 6:
            response = _context2.sent;
            data = response.data || {};
            items = items.concat(data.items || []);

            if (!data.nextPageUrl) {
              _context2.next = 17;
              break;
            }

            if (!paginate) {
              _context2.next = 14;
              break;
            }

            delete query.initial;
            query.sync_token = getToken(data.nextPageUrl);
            return _context2.abrupt("return", getSyncPage(http, items, query, {
              paginate: paginate
            }));

          case 14:
            return _context2.abrupt("return", {
              items: items,
              nextPageToken: getToken(data.nextPageUrl)
            });

          case 17:
            if (!data.nextSyncUrl) {
              _context2.next = 21;
              break;
            }

            return _context2.abrupt("return", {
              items: items,
              nextSyncToken: getToken(data.nextSyncUrl)
            });

          case 21:
            return _context2.abrupt("return", {
              items: []
            });

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getSyncPage.apply(this, arguments);
}

function getToken(url) {
  var urlParts = url.split('?');
  return urlParts.length > 0 ? urlParts[1].replace('sync_token=', '') : '';
}

function ownKeys$p(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$p(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$p(Object(source), !0).forEach(function (key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$p(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty$3(obj, key, value) {
  key = _toPropertyKey$2(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey$2(arg) {
  var key = _toPrimitive$2(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive$2(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}
/*
* sdk relies heavily on sys metadata
* so we cannot omit the sys property on sdk level entirely
* and we have to ensure that at least `id` and `type` are present
* */


function normalizeSelect(query) {
  if (!query.select) {
    return query;
  } // The selection of fields for the query is limited
  // Get the different parts that are listed for selection


  var allSelects = Array.isArray(query.select) ? query.select : query.select.split(','); // Move the parts into a set for easy access and deduplication

  var selectedSet = new Set(allSelects); // If we already select all of `sys` we can just return
  // since we're anyway fetching everything that is needed

  if (selectedSet.has('sys')) {
    return query;
  } // We don't select `sys` so we need to ensure the minimum set


  selectedSet.add('sys.id');
  selectedSet.add('sys.type'); // Reassign the normalized sys properties

  return _objectSpread$p(_objectSpread$p({}, query), {}, {
    select: _toConsumableArray$2(selectedSet).join(',')
  });
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$1()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf$3(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf$2(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$3(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$a(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ValidationError = /*#__PURE__*/function (_Error) {
  _inherits$b(ValidationError, _Error);

  var _super = _createSuper(ValidationError);

  function ValidationError(name, message) {
    var _this;

    _classCallCheck$d(this, ValidationError);

    _this = _super.call(this, "Invalid \"".concat(name, "\" provided, ") + message);
    _this.name = 'ValidationError';
    return _this;
  }

  return ValidationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
function validateTimestamp(name, timestamp, options) {
  options = options || {};

  if (typeof timestamp !== 'number') {
    throw new ValidationError(name, "only numeric values are allowed for timestamps, provided type was \"".concat(typeof timestamp, "\""));
  }

  if (options.maximum && timestamp > options.maximum) {
    throw new ValidationError(name, "value (".concat(timestamp, ") cannot be further in the future than expected maximum (").concat(options.maximum, ")"));
  }

  if (options.now && timestamp < options.now) {
    throw new ValidationError(name, "value (".concat(timestamp, ") cannot be in the past, current time was ").concat(options.now));
  }
}

function ownKeys$o(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$o(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$o(Object(source), !0).forEach(function (key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$o(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey$1(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive$1(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}
var ASSET_KEY_MAX_LIFETIME = 48 * 60 * 60;
/**
 * Creates API object with methods to access functionality from Contentful's
 * Delivery API
 * @private
 * @param {Object} params - API initialization params
 * @prop {Object} http - HTTP client instance
 * @prop {Object} entities - Object with wrapper methods for each kind of entity
 * @prop {Function} getGlobalOptions - Link resolver preconfigured with global setting
 * @return {ClientAPI}
 */

function createContentfulApi(_ref) {
  var http = _ref.http,
      getGlobalOptions = _ref.getGlobalOptions;
  var wrapSpace = entities.space.wrapSpace;
  var _entities$contentType = entities.contentType,
      wrapContentType = _entities$contentType.wrapContentType,
      wrapContentTypeCollection = _entities$contentType.wrapContentTypeCollection;
  var _entities$entry = entities.entry,
      wrapEntry = _entities$entry.wrapEntry,
      wrapEntryCollection = _entities$entry.wrapEntryCollection;
  var _entities$asset = entities.asset,
      wrapAsset = _entities$asset.wrapAsset,
      wrapAssetCollection = _entities$asset.wrapAssetCollection;
  var _entities$tag = entities.tag,
      wrapTag = _entities$tag.wrapTag,
      wrapTagCollection = _entities$tag.wrapTagCollection;
  var wrapAssetKey = entities.assetKey.wrapAssetKey;
  var wrapLocaleCollection = entities.locale.wrapLocaleCollection;

  var notFoundError = function notFoundError(id) {
    var error = new Error('The resource could not be found.');
    error.sys = {
      type: 'Error',
      id: 'NotFound'
    };
    error.details = {
      type: 'Entry',
      id: id,
      environment: getGlobalOptions().environment,
      space: getGlobalOptions().space
    };
    return error;
  };
  /**
   * Gets the Space which the client is currently configured to use
   * @memberof ContentfulClientAPI
   * @return {Promise<Entities.Space>} Promise for a Space
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   * // returns the space object with the above <space-id>
   * const space = await client.getSpace()
   * console.log(space)
   */


  function getSpace() {
    return _getSpace.apply(this, arguments);
  }
  /**
   * Gets a Content Type
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @return {Promise<Entities.ContentType>} Promise for a Content Type
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const contentType = await client.getContentType('<content_type_id>')
   * console.log(contentType)
   */


  function _getSpace() {
    _getSpace = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee() {
      var response;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              switchToSpace(http);
              _context.prev = 1;
              _context.next = 4;
              return http.get('/');

            case 4:
              response = _context.sent;
              return _context.abrupt("return", wrapSpace(response.data));

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              errorHandler(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));
    return _getSpace.apply(this, arguments);
  }

  function getContentType(_x) {
    return _getContentType.apply(this, arguments);
  }
  /**
   * Gets a collection of Content Types
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.ContentTypeCollection>} Promise for a collection of Content Types
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getContentTypes()
   * console.log(response.items)
   */


  function _getContentType() {
    _getContentType = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2(id) {
      var response;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              switchToEnvironment(http);
              _context2.prev = 1;
              _context2.next = 4;
              return http.get("content_types/".concat(id));

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", wrapContentType(response.data));

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              errorHandler(_context2.t0);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    }));
    return _getContentType.apply(this, arguments);
  }

  function getContentTypes() {
    return _getContentTypes.apply(this, arguments);
  }
  /**
   * Gets an Entry
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @param  {Object=} query - Object with search parameters. In this method it's only useful for `locale`.
   * @return {Promise<Entities.Entry>} Promise for an Entry
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const entry = await client.getEntry('<entry_id>')
   * console.log(entry)
   */


  function _getContentTypes() {
    _getContentTypes = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee3() {
      var query,
          response,
          _args3 = arguments;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              query = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              switchToEnvironment(http);
              _context3.prev = 2;
              _context3.next = 5;
              return http.get('content_types', createRequestConfig({
                query: query
              }));

            case 5:
              response = _context3.sent;
              return _context3.abrupt("return", wrapContentTypeCollection(response.data));

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](2);
              errorHandler(_context3.t0);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 9]]);
    }));
    return _getContentTypes.apply(this, arguments);
  }

  function getEntry(_x2) {
    return _getEntry.apply(this, arguments);
  }
  /**
   * Gets a collection of Entries
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.EntryCollection>} Promise for a collection of Entries
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getEntries()
   * console.log(response.items)
   */


  function _getEntry() {
    _getEntry = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee4(id) {
      var query,
          response,
          _args4 = arguments;
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              query = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};

              if (id) {
                _context4.next = 3;
                break;
              }

              throw notFoundError(id);

            case 3:
              _context4.prev = 3;
              _context4.next = 6;
              return this.getEntries(_objectSpread$o({
                'sys.id': id
              }, query));

            case 6:
              response = _context4.sent;

              if (!(response.items.length > 0)) {
                _context4.next = 11;
                break;
              }

              return _context4.abrupt("return", wrapEntry(response.items[0]));

            case 11:
              throw notFoundError(id);

            case 12:
              _context4.next = 17;
              break;

            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](3);
              errorHandler(_context4.t0);

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[3, 14]]);
    }));
    return _getEntry.apply(this, arguments);
  }

  function getEntries() {
    return _getEntries.apply(this, arguments);
  }
  /**
   * Gets an Asset
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @param  {Object=} query - Object with search parameters. In this method it's only useful for `locale`.
   * @return {Promise<Entities.Asset>} Promise for an Asset
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const asset = await client.getAsset('<asset_id>')
   * console.log(asset)
   */


  function _getEntries() {
    _getEntries = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee5() {
      var query,
          _getGlobalOptions2,
          resolveLinks,
          removeUnresolved,
          response,
          _args5 = arguments;

      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              query = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
              switchToEnvironment(http);
              _getGlobalOptions2 = getGlobalOptions(query), resolveLinks = _getGlobalOptions2.resolveLinks, removeUnresolved = _getGlobalOptions2.removeUnresolved;
              query = normalizeSelect(query);
              _context5.prev = 4;
              _context5.next = 7;
              return http.get('entries', createRequestConfig({
                query: query
              }));

            case 7:
              response = _context5.sent;
              return _context5.abrupt("return", wrapEntryCollection(response.data, {
                resolveLinks: resolveLinks,
                removeUnresolved: removeUnresolved
              }));

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](4);
              errorHandler(_context5.t0);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[4, 11]]);
    }));
    return _getEntries.apply(this, arguments);
  }

  function getAsset(_x3) {
    return _getAsset.apply(this, arguments);
  }
  /**
   * Gets a collection of Assets
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.AssetCollection>} Promise for a collection of Assets
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getAssets()
   * console.log(response.items)
   */


  function _getAsset() {
    _getAsset = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee6(id) {
      var query,
          response,
          _args6 = arguments;
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              query = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
              switchToEnvironment(http);
              query = normalizeSelect(query);
              _context6.prev = 3;
              _context6.next = 6;
              return http.get("assets/".concat(id), createRequestConfig({
                query: query
              }));

            case 6:
              response = _context6.sent;
              return _context6.abrupt("return", wrapAsset(response.data));

            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](3);
              errorHandler(_context6.t0);

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[3, 10]]);
    }));
    return _getAsset.apply(this, arguments);
  }

  function getAssets() {
    return _getAssets.apply(this, arguments);
  }
  /**
   * Gets a Tag
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @return {Promise<Entities.Tag>} Promise for a Tag
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const tag = await client.getTag('<asset_id>')
   * console.log(tag)
   */


  function _getAssets() {
    _getAssets = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee7() {
      var query,
          response,
          _args7 = arguments;
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              query = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
              switchToEnvironment(http);
              query = normalizeSelect(query);
              _context7.prev = 3;
              _context7.next = 6;
              return http.get('assets', createRequestConfig({
                query: query
              }));

            case 6:
              response = _context7.sent;
              return _context7.abrupt("return", wrapAssetCollection(response.data));

            case 10:
              _context7.prev = 10;
              _context7.t0 = _context7["catch"](3);
              errorHandler(_context7.t0);

            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[3, 10]]);
    }));
    return _getAssets.apply(this, arguments);
  }

  function getTag(_x4) {
    return _getTag.apply(this, arguments);
  }
  /**
   * Gets a collection of Tags
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters.
   * @return {Promise<Entities.TagCollection>} Promise for a collection of Tags
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getTags()
   * console.log(response.items)
   */


  function _getTag() {
    _getTag = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee8(id) {
      var response;
      return regenerator.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              switchToEnvironment(http);
              _context8.prev = 1;
              _context8.next = 4;
              return http.get("tags/".concat(id));

            case 4:
              response = _context8.sent;
              return _context8.abrupt("return", wrapTag(response.data));

            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8["catch"](1);
              errorHandler(_context8.t0);

            case 11:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[1, 8]]);
    }));
    return _getTag.apply(this, arguments);
  }

  function getTags() {
    return _getTags.apply(this, arguments);
  }
  /**
   * Creates an asset key for signing asset URLs (Embargoed Assets)
   * @memberof ContentfulClientAPI
   * @param {number} expiresAt - UNIX timestamp in the future, maximum of 48h from now
   * @return {Promise<Entities.AssetKey>} Promise for an AssetKey
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const assetKey = await client.getAssetKey(<UNIX timestamp>)
   * console.log(assetKey)
   */


  function _getTags() {
    _getTags = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee9() {
      var query,
          response,
          _args9 = arguments;
      return regenerator.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              query = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
              switchToEnvironment(http);
              query = normalizeSelect(query);
              _context9.prev = 3;
              _context9.next = 6;
              return http.get('tags', createRequestConfig({
                query: query
              }));

            case 6:
              response = _context9.sent;
              return _context9.abrupt("return", wrapTagCollection(response.data));

            case 10:
              _context9.prev = 10;
              _context9.t0 = _context9["catch"](3);
              errorHandler(_context9.t0);

            case 13:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[3, 10]]);
    }));
    return _getTags.apply(this, arguments);
  }

  function createAssetKey(_x5) {
    return _createAssetKey.apply(this, arguments);
  }
  /**
   * Gets a collection of Locale
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.LocaleCollection>} Promise for a collection of Locale
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getLocales()
   * console.log(response.items)
   */


  function _createAssetKey() {
    _createAssetKey = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee10(expiresAt) {
      var now, currentMaxLifetime, params, response;
      return regenerator.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              switchToEnvironment(http);
              _context10.prev = 1;
              now = Math.floor(Date.now() / 1000);
              currentMaxLifetime = now + ASSET_KEY_MAX_LIFETIME;
              validateTimestamp('expiresAt', expiresAt, {
                maximum: currentMaxLifetime,
                now: now
              });
              params = {
                expiresAt: expiresAt
              };
              _context10.next = 8;
              return http.post('asset_keys', params);

            case 8:
              response = _context10.sent;
              return _context10.abrupt("return", wrapAssetKey(response.data));

            case 12:
              _context10.prev = 12;
              _context10.t0 = _context10["catch"](1);
              errorHandler(_context10.t0);

            case 15:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[1, 12]]);
    }));
    return _createAssetKey.apply(this, arguments);
  }

  function getLocales() {
    return _getLocales.apply(this, arguments);
  }
  /**
   * Synchronizes either all the content or only new content since last sync
   * See <a href="https://www.contentful.com/developers/docs/concepts/sync/">Synchronization</a> for more information.
   * <strong> Important note: </strong> The the sync api endpoint does not support include or link resolution.
   * However contentful.js is doing link resolution client side if you only make an initial sync.
   * For the delta sync (using nextSyncToken) it is not possible since the sdk wont have access to all the data to make such an operation.
   * @memberof ContentfulClientAPI
   * @param  {Object} query - Query object for the sync call. One of initial or nextSyncToken always needs to be specified, but not both.
   * @param  {boolean?} query.initial - Indicates if this is the first sync. Use it if you don't have a sync token.
   * @param  {string?} query.nextSyncToken - The token you got the last time you used this method. Ensures you only get changed content.
   * @param  {string=} query.type - Filter by this type (all (default), Entry, Asset, Deletion, DeletedAsset or DeletedEntry)
   * @param  {string=} query.content_type - Filter by this content type id
   * @param  {boolean=} query.resolveLinks - When true, links to other Entries or Assets are resolved. Default: true.
   * @param  {Object} options
   * @param  {boolean=} [options.paginate = true] - Set to false to disable pagination
   * @return {Promise<Sync.SyncCollection>} Promise for the collection resulting of a sync operation
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.sync({
   *   initial: true
   * })
   * console.log({
   *   entries: response.entries,
   *   assets: response.assets,
   *   nextSyncToken: response.nextSyncToken
   * })
   */


  function _getLocales() {
    _getLocales = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee11() {
      var query,
          response,
          _args11 = arguments;
      return regenerator.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              query = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
              switchToEnvironment(http);
              _context11.prev = 2;
              _context11.next = 5;
              return http.get('locales', createRequestConfig({
                query: query
              }));

            case 5:
              response = _context11.sent;
              return _context11.abrupt("return", wrapLocaleCollection(response.data));

            case 9:
              _context11.prev = 9;
              _context11.t0 = _context11["catch"](2);
              errorHandler(_context11.t0);

            case 12:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[2, 9]]);
    }));
    return _getLocales.apply(this, arguments);
  }

  function sync() {
    return _sync.apply(this, arguments);
  }
  /**
  * Parse raw json data into collection of entry objects.Links will be resolved also
  * @memberof ContentfulClientAPI
  * @param {Object} raw json data
  * @example
  * let data = {items: [
  *    {
  *    sys: {type: 'Entry', locale: 'en-US'},
  *    fields: {
  *      animal: {sys: {type: 'Link', linkType: 'Animal', id: 'oink'}},
  *      anotheranimal: {sys: {type: 'Link', linkType: 'Animal', id: 'middle-parrot'}}
  *    }
  *  }
  * ],
  * includes: {
  *  Animal: [
  *    {
  *      sys: {type: 'Animal', id: 'oink', locale: 'en-US'},
  *      fields: {
  *        name: 'Pig',
  *        friend: {sys: {type: 'Link', linkType: 'Animal', id: 'groundhog'}}
  *      }
  *    }
  *   ]
  *  }
  * }
  * console.log( data.items[0].fields.foo ); // undefined
  * let parsedData = client.parseEntries(data);
  * console.log( parsedData.items[0].fields.foo ); // foo
  */


  function _sync() {
    _sync = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee12() {
      var query,
          options,
          _getGlobalOptions3,
          resolveLinks,
          removeUnresolved,
          _args12 = arguments;

      return regenerator.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              query = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
              options = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : {
                paginate: true
              };
              _getGlobalOptions3 = getGlobalOptions(query), resolveLinks = _getGlobalOptions3.resolveLinks, removeUnresolved = _getGlobalOptions3.removeUnresolved;
              switchToEnvironment(http);
              return _context12.abrupt("return", pagedSync(http, query, _objectSpread$o({
                resolveLinks: resolveLinks,
                removeUnresolved: removeUnresolved
              }, options)));

            case 5:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));
    return _sync.apply(this, arguments);
  }

  function parseEntries(data) {
    var _getGlobalOptions = getGlobalOptions({}),
        resolveLinks = _getGlobalOptions.resolveLinks,
        removeUnresolved = _getGlobalOptions.removeUnresolved;

    return wrapEntryCollection(data, {
      resolveLinks: resolveLinks,
      removeUnresolved: removeUnresolved
    });
  }
  /*
   * Switches BaseURL to use /environments path
   * */


  function switchToEnvironment(http) {
    http.defaults.baseURL = getGlobalOptions().environmentBaseUrl;
  }
  /*
   * Switches BaseURL to use /spaces path
   * */


  function switchToSpace(http) {
    http.defaults.baseURL = getGlobalOptions().spaceBaseUrl;
  }

  return {
    getSpace: getSpace,
    getContentType: getContentType,
    getContentTypes: getContentTypes,
    getEntry: getEntry,
    getEntries: getEntries,
    getAsset: getAsset,
    getAssets: getAssets,
    getTag: getTag,
    getTags: getTags,
    createAssetKey: createAssetKey,
    getLocales: getLocales,
    parseEntries: parseEntries,
    sync: sync
  };
}

/**
 * Link resolution can be set globally, or it can be turned off for the methods
 * which make use of it. The local setting always overrides the global setting.
 * @private
 * @param {boolean} globalSetting - Global library setting for link resolution
 * @returns {function} Link resolver method preconfigured with global setting
 */
function createGlobalOptions(globalSettings) {
  /**
   * Link resolver method
   * @param {Object} query - regular query object used for collection endpoints
   */
  return function getGlobalOptions(query) {
    return Object.assign({}, globalSettings, query);
  };
}

function ownKeys$n(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$n(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$n(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$n(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}
/**
 * Create a client instance
 * @func
 * @name createClient
 * @memberof contentful
 * @param {Object} params - Client initialization parameters
 * @prop {string} params.space - Space ID
 * @prop {string} params.accessToken - Contentful CDA Access Token
 * @prop {string} [params.environment="master"] - Contentful Environment ID
 * @prop {boolean=} params.insecure - Requests will be made over http instead of the default https (default: true)
 * @prop {string=} params.host - API host (default: cdn.contentful.com). Also usable with preview.contentful.com.
 * @prop {string=} params.basePath - Path appended to the host to support gateways/proxies with custom urls.
 * @prop {Object=} params.httpAgent - Optional Node.js HTTP agent for proxying (see <a href="https://nodejs.org/api/http.html#http_class_http_agent">Node.js docs</a> and <a href="https://www.npmjs.com/package/https-proxy-agent">https-proxy-agent</a>)
 * @prop {Object=} params.httpsAgent - Optional Node.js HTTP agent for proxying (see <a href="https://nodejs.org/api/http.html#http_class_http_agent">Node.js docs</a> and <a href="https://www.npmjs.com/package/https-proxy-agent">https-proxy-agent</a>)
 * @prop {Object=} params.proxy - Optional Axios proxy (see <a href="https://github.com/mzabriskie/axios#request-config"> axios docs </a>)
 * @prop {Object=} params.headers - Optional additional headers
 * @prop {function=} params.adapter - Optional axios request adapter (see <a href="https://github.com/mzabriskie/axios#request-config"> axios docs </a>)
 * @prop {boolean=?} params.resolveLinks - If we should resolve links between entries (default: true)
 * @prop {boolean=?} params.removeUnresolved - If we should remove links to entries which could not be resolved (default: false)
 * @prop {boolean=?} params.retryOnError - If we should retry on errors and 429 rate limit exceptions (default: true)
 * @prop {function=} params.logHandler - A log handler function to process given log messages & errors. Receives the log level (error, warning & info) and the actual log data (Error object or string). (The default can be found at: https://github.com/contentful/contentful-sdk-core/blob/master/src/create-http-client.ts)
 * @prop {string=?} params.application - Application name and version e.g myApp/version
 * @prop {string=?} params.integration - Integration name and version e.g react/version
 * @prop {number=} params.timeout in milliseconds - connection timeout (default:30000)
 * @prop {number=} params.retryLimit - Optional number of retries before failure. Default is 5
 * @returns {ContentfulClientAPI.ClientAPI}
 * @example
 * const contentful = require('contentful')
 * const client = contentful.createClient({
 *  accessToken: 'myAccessToken',
 *  space: 'mySpaceId'
 * })
 */

function createClient$1(params) {
  if (!params.accessToken) {
    throw new TypeError('Expected parameter accessToken');
  }

  if (!params.space) {
    throw new TypeError('Expected parameter space');
  }

  var defaultConfig = {
    resolveLinks: true,
    removeUnresolved: false,
    defaultHostname: 'cdn.contentful.com',
    environment: 'master'
  };

  var config = _objectSpread$n(_objectSpread$n({}, defaultConfig), params);

  var userAgentHeader = getUserAgentHeader("contentful.js/".concat("9.2.17"), config.application, config.integration);
  config.headers = _objectSpread$n(_objectSpread$n({}, config.headers), {}, {
    'Content-Type': 'application/vnd.contentful.delivery.v1+json',
    'X-Contentful-User-Agent': userAgentHeader
  });
  var http = createHttpClient(axios, config);
  var getGlobalOptions = createGlobalOptions({
    resolveLinks: config.resolveLinks,
    environment: config.environment,
    removeUnresolved: config.removeUnresolved,
    spaceBaseUrl: http.defaults.baseURL,
    environmentBaseUrl: "".concat(http.defaults.baseURL, "environments/").concat(config.environment)
  }); // Append environment to baseURL

  http.defaults.baseURL = getGlobalOptions().environmentBaseUrl;
  return createContentfulApi({
    http: http,
    getGlobalOptions: getGlobalOptions
  });
}

function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$m(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function createContentfulClient() {
  return createClient$1({
    space: "blh4anz05qu1",
    accessToken: "lYW4u-PLH0lAAzFqWUwfSluHeC-jL1MF0XIoTYlXAjI",
    host: undefined
  });
}

function fetchImages() {
  return _fetchImages.apply(this, arguments);
}

function _fetchImages() {
  _fetchImages = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee4() {
    var contentfulClient, entries, images;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            contentfulClient = createContentfulClient();
            _context4.next = 3;
            return contentfulClient.getEntries({
              content_type: "playgroundImages",
              include: 2
            });

          case 3:
            entries = _context4.sent;
            images = entries.items[0].fields.images;
            return _context4.abrupt("return", images.map(function (image) {
              return {
                id: image.sys.id,
                title: image.fields.title,
                url: "https:".concat(image.fields.file.url, "?fm=webp&w=1920"),
                thumbnail: "https:".concat(image.fields.file.url, "?fm=webp&w=400"),
                width: image.fields.file.details.image.width,
                height: image.fields.file.details.image.height,
                mimeType: image.fields.file.contentType,
                isVideo: false
              };
            }));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchImages.apply(this, arguments);
}

function fetchVideos() {
  return _fetchVideos.apply(this, arguments);
}

function _fetchVideos() {
  _fetchVideos = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee5() {
    var contentfulClient, entries, videos;
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            contentfulClient = createContentfulClient();
            _context5.next = 3;
            return contentfulClient.getEntries({
              content_type: "playgroundImages",
              include: 3
            });

          case 3:
            entries = _context5.sent;
            videos = entries.items[0].fields.videos;
            return _context5.abrupt("return", videos.map(function (video) {
              return {
                id: video.sys.id,
                title: video.fields.title,
                thumbnail: "https:".concat(video.fields.poster.fields.file.url, "?fm=webp&w=400"),
                width: video.fields.width,
                height: video.fields.height,
                url: "https:".concat(video.fields.video.fields.file.url),
                mimeType: video.fields.video.fields.file.contentType,
                isVideo: true
              };
            }));

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchVideos.apply(this, arguments);
}

function getLocale() {
  var urlSearchParams = new URLSearchParams(typeof window === "object" ? window.location.search : "");
  var params = Object.fromEntries(urlSearchParams.entries());
  var locale = typeof params.locale === "string" ? params.locale : undefined;
  return locale !== null && locale !== void 0 ? locale : "en";
}

var noCMSPlugin = {
  id: "nocms",
  resources: {
    "nocms.image": {
      defaultFetch: function () {
        var _defaultFetch = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee(resources) {
          var assets;
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return fetchImages();

                case 2:
                  assets = _context.sent;
                  return _context.abrupt("return", resources.map(function (resource) {
                    return _objectSpread$m(_objectSpread$m({}, resource), {}, {
                      value: assets.find(function (asset) {
                        return asset.id === resource.id;
                      })
                    });
                  }));

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function defaultFetch(_x) {
          return _defaultFetch.apply(this, arguments);
        }

        return defaultFetch;
      }(),
      widget: mockMediaPicker(fetchImages, "images")
    },
    "nocms.video": {
      defaultFetch: function () {
        var _defaultFetch2 = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2(resources) {
          var assets;
          return regenerator.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return fetchVideos();

                case 2:
                  assets = _context2.sent;
                  return _context2.abrupt("return", resources.map(function (resource) {
                    return _objectSpread$m(_objectSpread$m({}, resource), {}, {
                      value: assets.find(function (asset) {
                        return asset.id === resource.id;
                      })
                    });
                  }));

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function defaultFetch(_x2) {
          return _defaultFetch2.apply(this, arguments);
        }

        return defaultFetch;
      }(),
      widget: mockMediaPicker(fetchVideos, "videos")
    }
  },
  launcher: {
    image: {
      resourceType: "nocms.image",
      transform: function transform(x) {
        return {
          url: x.url,
          alt: x.title,
          aspectRatio: x.width / x.height,
          mimeType: x.mimeType,
          srcset: [{
            w: x.width,
            h: x.height,
            url: x.url
          }]
        };
      }
    },
    video: {
      resourceType: "nocms.video",
      transform: function transform(x) {
        return {
          url: x.url,
          alt: x.title,
          aspectRatio: x.width / x.height
        };
      }
    },
    onEditorLoad: function onEditorLoad(launchEditor) {
      var _window, _window2;

      launchEditor({
        onClose: function onClose() {
          alert("good bye bye");
        },
        save: function () {
          var _save = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee3(configs, externals) {
            return regenerator.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    console.debug("saving config...");
                    _context3.next = 3;
                    return sleep(1000);

                  case 3:
                    window.noCmsConfig = configs;
                    window.noCmsExternals = externals;
                    console.debug("saved config!");

                  case 6:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function save(_x3, _x4) {
            return _save.apply(this, arguments);
          }

          return save;
        }(),
        locales: [{
          code: "en",
          isDefault: true
        }, {
          code: "pl",
          fallback: "en"
        }],
        contextParams: {
          locale: getLocale()
        },
        configs: (_window = window) === null || _window === void 0 ? void 0 : _window.noCMSInputConfigs,
        mode: (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.noCMSMode
      });
    }
  }
};

function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$l(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function normalizeSpace(space) {
  return responsiveValueMap(space, function (val) {
    if (typeof val === "number") {
      return "".concat(val, "px");
    }

    return val;
  });
}

function prepareDevices(configDevices) {
  var devices = []; // let's make devices copy

  DEFAULT_DEVICES.forEach(function (defaultDevice) {
    devices.push(_objectSpread$l({}, defaultDevice));
  });

  if (configDevices) {
    devices.forEach(function (device, index) {
      var configDevice = configDevices[device.id];

      if (configDevice) {
        var _configDevice$w, _configDevice$h, _configDevice$hidden;

        device.w = (_configDevice$w = configDevice.w) !== null && _configDevice$w !== void 0 ? _configDevice$w : device.w;
        device.h = (_configDevice$h = configDevice.h) !== null && _configDevice$h !== void 0 ? _configDevice$h : device.h;
        device.hidden = (_configDevice$hidden = configDevice.hidden) !== null && _configDevice$hidden !== void 0 ? _configDevice$hidden : device.hidden;

        if (configDevice.startsFrom && index > 0) {
          var previousDevice = devices[index - 1];
          previousDevice.breakpoint = configDevice.startsFrom;
        }
      }
    });
  }

  return devices;
}

function getLauncherPlugin(config) {
  var _config$plugins;

  var plugins = (_config$plugins = config.plugins) !== null && _config$plugins !== void 0 ? _config$plugins : [];
  var launcherPlugins = plugins.filter(function (plugin) {
    return plugin.launcher;
  });

  if (launcherPlugins.length === 0) {
    return noCMSPlugin;
  }

  if (launcherPlugins.length > 1) {
    throw new Error("more than one launcher plugin!!!");
  }

  return launcherPlugins[0];
}
function createCompilationContext(config, contextParams) {
  var _config$mainGrid, _config$grids$context, _config$grids, _grid$containerMargin, _grid$horizontalGap, _grid$verticalGap, _grid$numberOfItemsIn, _config$textModifiers, _config$plugins2;

  var devices = prepareDevices(config.devices);
  var mainDevice = devices.find(function (x) {
    return x.isMain;
  });
  var theme = {
    colors: {},
    fonts: {},
    space: {},
    numberOfItemsInRow: {},
    aspectRatios: {},
    icons: {},
    containerWidths: {}
  };

  var grid = _objectSpread$l(_objectSpread$l({}, (_config$mainGrid = config.mainGrid) !== null && _config$mainGrid !== void 0 ? _config$mainGrid : {}), (_config$grids$context = (_config$grids = config.grids) === null || _config$grids === void 0 ? void 0 : _config$grids[contextParams.grid]) !== null && _config$grids$context !== void 0 ? _config$grids$context : {}); // Main grid values


  theme.space["grid.containerMargin"] = {
    type: "dev",
    value: normalizeSpace(themeScalarValueToResponsiveValue((_grid$containerMargin = grid === null || grid === void 0 ? void 0 : grid.containerMargin) !== null && _grid$containerMargin !== void 0 ? _grid$containerMargin : 32, devices))
  };
  theme.space["grid.horizontalGap"] = {
    type: "dev",
    value: normalizeSpace(themeScalarValueToResponsiveValue((_grid$horizontalGap = grid === null || grid === void 0 ? void 0 : grid.horizontalGap) !== null && _grid$horizontalGap !== void 0 ? _grid$horizontalGap : 16, devices))
  };
  theme.space["grid.verticalGap"] = {
    type: "dev",
    value: normalizeSpace(themeScalarValueToResponsiveValue((_grid$verticalGap = grid.verticalGap) !== null && _grid$verticalGap !== void 0 ? _grid$verticalGap : 16, devices))
  };
  theme.numberOfItemsInRow["grid"] = {
    type: "dev",
    value: themeScalarValueToResponsiveValue((_grid$numberOfItemsIn = grid.numberOfItemsInRow) !== null && _grid$numberOfItemsIn !== void 0 ? _grid$numberOfItemsIn : "4", devices)
  }; // fill necessary to prevent auto
  // TODO: allow for custom breakpoints!!! What happens with old ones when the new ones show up?

  if (config.space) {
    config.space.forEach(function (space) {
      var val = space.value; // If value is "vw" and is not responsive then we should responsify it.
      // Why? Because responsive token behaves differently from non-responsive in terms of auto.
      // Responsive token automatically "fills" all the breakpoints.
      // If someone does 10vw it is responsive in nature, it's NEVER a scalar.

      if (typeof val === "string" && parseSpacing(val).unit === "vw") {
        val = _defineProperty$g({}, "@".concat(mainDevice.id), val);
      }

      var id = space.id,
          rest = _objectWithoutProperties$2(space, ["id"]);

      theme.space[id] = _objectSpread$l(_objectSpread$l({}, rest), {}, {
        type: "dev",
        value: normalizeSpace(themeScalarValueToResponsiveValue(val, devices))
      });
    });
  }

  if (config.colors) {
    config.colors.forEach(function (color) {
      var id = color.id,
          rest = _objectWithoutProperties$2(color, ["id"]);

      theme.colors[id] = _objectSpread$l(_objectSpread$l({}, rest), {}, {
        type: "dev",
        value: themeScalarValueToResponsiveValue(color.value, devices)
      });
    });
  } // if (config.tokenMapping?.colors) {
  //   for (const masterTokenId in config.tokenMapping?.colors) {
  //     const mappedTokenId = config.tokenMapping?.colors[masterTokenId];
  //     const mappedToken = config.colors?.find(
  //       (token) => token.id === mappedTokenId
  //     );
  //
  //     if (mappedToken) {
  //       theme.tokenMapping.colors[masterTokenId] = mappedTokenId;
  //     } else {
  //       console.warn(
  //         `Wrong token mapping. Token "${mappedTokenId}" doesn't exist, you try to map ${masterTokenId} to it.`
  //       );
  //     }
  //   }
  // }


  if (config.fonts) {
    // fonts are a bit more complex because they're objects
    config.fonts.forEach(function (font) {
      var id = font.id,
          rest = _objectWithoutProperties$2(font, ["id"]);

      theme.fonts[id] = _objectSpread$l(_objectSpread$l({}, rest), {}, {
        type: "dev",
        value: themeObjectValueToResponsiveValue(font.value, devices)
      });
    });
  }

  if (config.aspectRatios) {
    config.aspectRatios.forEach(function (aspectRatio) {
      var id = aspectRatio.id,
          rest = _objectWithoutProperties$2(aspectRatio, ["id"]);

      theme.aspectRatios[id] = _objectSpread$l(_objectSpread$l({}, rest), {}, {
        type: "dev",
        value: themeScalarValueToResponsiveValue(aspectRatio.value, devices)
      });
    });
  }

  if (config.containerWidths) {
    config.containerWidths.forEach(function (containerWidth) {
      var id = containerWidth.id,
          rest = _objectWithoutProperties$2(containerWidth, ["id"]);

      theme.containerWidths[id] = _objectSpread$l(_objectSpread$l({}, rest), {}, {
        type: "dev",
        value: themeScalarValueToResponsiveValue(containerWidth.value.toString(), devices)
      });
    });
  }

  if (config.icons) {
    config.icons.forEach(function (icon) {
      var id = icon.id,
          rest = _objectWithoutProperties$2(icon, ["id"]);

      theme.icons[id] = _objectSpread$l(_objectSpread$l({}, rest), {}, {
        type: "dev",
        value: icon.value
      });
    });
  }

  var addTransformHashToResourceSchemaPropsForConfig = addTransformHashToResourceSchemaProps(config);
  var actions = (config.actions || []).map(function (action) {
    return lodash_flow(addTransformHashToResourceSchemaPropsForConfig)(_objectSpread$l(_objectSpread$l({}, action), {}, {
      tags: ["action"]
    }));
  });
  var components = [].concat(_toConsumableArray$2(schemas), _toConsumableArray$2((config.components || []).map(function (component) {
    var _component$type;

    var customComponent = _objectSpread$l(_objectSpread$l({}, component), {}, {
      tags: [(_component$type = component.type) !== null && _component$type !== void 0 ? _component$type : "item"]
    }); // if (component.type === "card") {
    //   if (!customComponent.tags.includes("item")) {
    //     customComponent.tags.push("item");
    //   }
    // }


    return customComponent;
  })), _toConsumableArray$2((config.buttons || []).map(function (component) {
    var customComponent = _objectSpread$l(_objectSpread$l({}, component), {}, {
      tags: ["button"]
    }); // Check if user didn't set label / symbol properties


    var userDefinedLabel = component.schema.find(function (schemaProp) {
      return schemaProp.prop === "label";
    });

    if (userDefinedLabel) {
      throw new Error("Your custom component \"".concat(component.id, "\" have a prop named \"label\". You can't use it as it's a reserved prop."));
    }

    var userDefinedSymbol = component.schema.find(function (schemaProp) {
      return schemaProp.prop === "symbol";
    });

    if (userDefinedSymbol) {
      throw new Error("Your custom component \"".concat(component.id, "\" have a prop named \"symbol\". You can't use it as it's a reserved prop."));
    }

    var buttonSchemaProps = [];
    buttonSchemaProps.push(buttonActionSchemaProp);

    var _ref = component.builtinProps || {},
        label = _ref.label,
        symbol = _ref.symbol;

    if (label !== "off") {
      buttonSchemaProps.push(buttonLabelSchemaProp);
    } else {
      buttonSchemaProps.push(_objectSpread$l(_objectSpread$l({}, buttonLabelSchemaProp), {}, {
        visible: false
      }));
    }

    if (symbol === "optional") {
      buttonSchemaProps.push(buttonOptionalIconSchemaProp);
    } else if (symbol === "on") {
      buttonSchemaProps.push(buttonRequiredIconSchemaProp);
    } else {
      buttonSchemaProps.push(_objectSpread$l(_objectSpread$l({}, buttonOptionalIconSchemaProp), {}, {
        visible: false // by default symbol is not visible

      }));
    }

    customComponent.schema = [].concat(buttonSchemaProps, _toConsumableArray$2(customComponent.schema.map(function (x) {
      return _objectSpread$l(_objectSpread$l({}, x), {}, {
        group: x.group || "Properties"
      });
    })));
    return customComponent;
  }))).map(lodash_flow(addTransformHashToResourceSchemaPropsForConfig, addTracingSchema));
  var links = [StandardLink].concat(_toConsumableArray$2((config.links || []).map(function (linkConfig) {
    return addTransformHashToResourceSchemaPropsForConfig(_objectSpread$l(_objectSpread$l({}, linkConfig), {}, {
      tags: ["actionLink"]
    }));
  })));
  var textModifiers = [{
    id: "$MissingTextModifier",
    tags: ["actionTextModifier"],
    schema: [],
    apply: function apply() {
      return {};
    }
  }, actionTextModifier].concat(_toConsumableArray$2(((_config$textModifiers = config.textModifiers) !== null && _config$textModifiers !== void 0 ? _config$textModifiers : []).map(function (modifier) {
    return addTransformHashToResourceSchemaPropsForConfig(_objectSpread$l(_objectSpread$l({}, modifier), {}, {
      tags: [modifier.type === "text" ? "textModifier" : "".concat(modifier.type, "TextModifier")]
    }));
  })));
  var launcherPlugin = getLauncherPlugin(config);

  var types = _objectSpread$l({}, config.resourceTypes);

  (_config$plugins2 = config.plugins) === null || _config$plugins2 === void 0 ? void 0 : _config$plugins2.forEach(function (plugin) {
    for (var id in plugin.resources) {
      var resource = plugin.resources[id];
      types[id] = _objectSpread$l(_objectSpread$l({}, types[id]), {}, {
        widget: resource.widget,
        defaultFetch: resource.defaultFetch
      });
    }
  });
  var compilationContext = {
    devices: devices,
    theme: buildFullTheme(theme),
    definitions: {
      components: components,
      actions: actions,
      links: links,
      textModifiers: textModifiers
    },
    resourceTypes: types,
    image: _objectSpread$l(_objectSpread$l({}, launcherPlugin.launcher.image), {}, {
      optional: true
    }),
    video: _objectSpread$l(_objectSpread$l({}, launcherPlugin.launcher.video), {}, {
      optional: true
    }),
    text: config.text,
    eventSink: config.eventSink,
    mainBreakpointIndex: mainDevice.id,
    contextParams: contextParams,
    isPlayground: launcherPlugin.id === noCMSPlugin.id,
    strict: config.strict
  };
  return compilationContext;
}

function addTransformHashToResourceSchemaProps(config) {
  var launcherPlugin = getLauncherPlugin(config);
  return function (componentDefinition) {
    return _objectSpread$l(_objectSpread$l({}, componentDefinition), {}, {
      schema: componentDefinition.schema.map(function (schemaProp) {
        if (isResourceSchemaProp(schemaProp)) {
          if (schemaProp.transform) {
            return _objectSpread$l(_objectSpread$l({}, schemaProp), {}, {
              transformHash: getTransformHash(schemaProp.transform)
            });
          }

          if (schemaProp.type === "image") {
            return _objectSpread$l(_objectSpread$l({}, schemaProp), {}, {
              transformHash: getTransformHash(launcherPlugin.launcher.image.transform)
            });
          }

          if (schemaProp.type === "video") {
            return _objectSpread$l(_objectSpread$l({}, schemaProp), {}, {
              transformHash: getTransformHash(launcherPlugin.launcher.video.transform)
            });
          }
        }

        return schemaProp;
      })
    });
  };
}

function getVariantsGroup(repository, groupId) {
  var _repository$groupId;

  if (!groupId) {
    return [];
  }

  var variants = (_repository$groupId = repository === null || repository === void 0 ? void 0 : repository[groupId]) !== null && _repository$groupId !== void 0 ? _repository$groupId : [];
  return variants;
}

function getVariant(repository, matcher, originalConfig) {
  var _originalConfig$_vari, _variants$find;

  var variants = getVariantsGroup(repository, (_originalConfig$_vari = originalConfig === null || originalConfig === void 0 ? void 0 : originalConfig._variantGroupId) !== null && _originalConfig$_vari !== void 0 ? _originalConfig$_vari : "");
  return (_variants$find = variants.find(matcher)) !== null && _variants$find !== void 0 ? _variants$find : originalConfig;
}

var curried$1 = lodash_curry(getVariant);

var addVariant = function addVariant(_ref) {
  var _variant$_variantGrou;

  var form = _ref.form,
      context = _ref.context,
      audience = _ref.audience,
      variant = _ref.variant,
      path = _ref.path;
  var newVariant = duplicateConfig(variant, context);
  newVariant._variantGroupId = (_variant$_variantGrou = variant._variantGroupId) !== null && _variant$_variantGrou !== void 0 ? _variant$_variantGrou : uniqueId();
  newVariant._audience = audience;
  var repository = storeVariant(form.values._variants, newVariant);
  form.change("_variants", repository);
  form.change(path, newVariant);
};

function mapToVariant(variantGetter, _ref) {
  var value = _ref.value,
      schemaProp = _ref.schemaProp;

  if (!isSchemaPropComponentOrComponentCollection(schemaProp)) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(variantGetter);
  }

  return variantGetter(value);
}

var curried = lodash_curry(mapToVariant);

React.createElement;
styled.div.withConfig({
  displayName: "AudiencePicker__Wrapper",
  componentId: "sc-1bf66mg-0"
})(["display:flex;border-radius:0.5rem;margin:0 1rem 0 0;"]);
styled.div.withConfig({
  displayName: "AudiencePicker__Picked",
  componentId: "sc-1bf66mg-1"
})(["display:flex;gap:0.25rem;align-items:center;padding:0 0.5rem;"]);
styled.div.withConfig({
  displayName: "AudiencePicker__Chip",
  componentId: "sc-1bf66mg-2"
})(["", ";color:", ";background:", ";padding:0.25rem 0.5rem;border-radius:0.25rem;&:hover{text-decoration:line-through;cursor:pointer;}"], SSFonts.body, SSColors.blue70, SSColors.blue20);

function AudiencePicker(_ref) {
  _ref.allAudiences;
      _ref.audiences;
      _ref.onAudienceChange;

  var _useState = react.exports.useState(false);
      _useState[0];
      _useState[1];

  var _useState2 = react.exports.useState(null);
      _useState2[0];
      _useState2[1];

  {
    return null;
  }
}

var firstMatchingVariantFor = function firstMatchingVariantFor() {
  var audiences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (_ref) {
    var _audience = _ref._audience;
    return audiences.includes(_audience);
  };
};

var byId = function byId(id) {
  return function (config) {
    return config._id === id;
  };
};

var selectVariant = function selectVariant(_ref) {
  var form = _ref.form,
      id = _ref.id,
      path = _ref.path;
  var currentVariant = dotNotationGet(form.values, path);
  var updatedRepository = storeVariant(form.values._variants, currentVariant);
  var resolvedVariant = curried$1(updatedRepository, byId(id), currentVariant);
  form.change(path, resolvedVariant);
  form.change("_variants", updatedRepository);
};

function removeVariant(_ref) {
  var _form$values$_variant, _repository$groupId;

  var form = _ref.form,
      path = _ref.path,
      id = _ref.id,
      groupId = _ref.groupId;
  var repository = deepClone((_form$values$_variant = form.values._variants) !== null && _form$values$_variant !== void 0 ? _form$values$_variant : {});
  var variants = (_repository$groupId = repository[groupId]) !== null && _repository$groupId !== void 0 ? _repository$groupId : [];
  var variantIndex = variants.findIndex(function (v) {
    return v._id === id;
  });

  if (variantIndex < 0) {
    return;
  }

  variants.splice(variantIndex, 1);

  if (variants.length === 0) {
    delete repository[groupId];
  }

  form.change("_variants", repository);
  var currentVariant = dotNotationGet(form.values, path);

  if (currentVariant._id === id) {
    if (variants.length > 0) {
      form.change(path, variants[Math.max(0, variantIndex - 1)]);
    } else {
      delete currentVariant._variantGroupId;
      delete currentVariant._audience;
      form.change(path, currentVariant);
    }
  }
}

function reorderVariant(form, groupId, sourceIndex, destinationIndex) {
  var _form$values$_variant, _repository$groupId;

  if (destinationIndex === undefined) {
    return;
  }

  if (destinationIndex === sourceIndex) {
    return;
  }

  var repository = deepClone((_form$values$_variant = form.values._variants) !== null && _form$values$_variant !== void 0 ? _form$values$_variant : {});
  var group = (_repository$groupId = repository[groupId]) !== null && _repository$groupId !== void 0 ? _repository$groupId : [];

  var _group$splice = group.splice(sourceIndex, 1),
      _group$splice2 = _slicedToArray$2(_group$splice, 1),
      temp = _group$splice2[0];

  group.splice(destinationIndex, 0, temp);
  form.change("_variants", repository);
}

var storeVariant = function storeVariant(repository, variant) {
  var repoCopy = JSON.parse(JSON.stringify(repository !== null && repository !== void 0 ? repository : {}));

  if (!variant._variantGroupId) {
    return repoCopy;
  }

  if (!(variant._variantGroupId in repoCopy)) {
    repoCopy[variant._variantGroupId] = [];
  }

  var variants = repoCopy[variant._variantGroupId];
  var index = variants.findIndex(function (v) {
    return v._id === variant._id;
  });

  if (index === -1) {
    variants.push(variant);
  } else {
    variants.splice(index, 1, variant);
  }

  return repoCopy;
};

function editVariant(_ref) {
  var _form$values$_variant, _repository;

  var form = _ref.form,
      groupId = _ref.groupId,
      id = _ref.id,
      path = _ref.path,
      newAudience = _ref.newAudience;
  var repository = deepClone((_form$values$_variant = form.values._variants) !== null && _form$values$_variant !== void 0 ? _form$values$_variant : {});
  var variants = (_repository = repository[groupId !== null && groupId !== void 0 ? groupId : ""]) !== null && _repository !== void 0 ? _repository : [];
  var variant = variants.find(byId(id));

  if (!variant) {
    return;
  }

  variant._audience = newAudience;
  var updatedVariant = curried$1(repository, firstMatchingVariantFor([newAudience]), variant);
  form.change(path, updatedVariant);
  form.change("_variants", repository);
}

function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$k(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getAudiencesForVariantsGroup(repository, audiences, groupId) {
  var variantsGroup = getVariantsGroup(repository, groupId);
  var audienceIdToAudience = new Map(audiences.map(function (_ref) {
    var id = _ref.id,
        rest = _objectWithoutProperties$2(_ref, ["id"]);

    return [id, _objectSpread$k({
      audienceId: id
    }, rest)];
  }));
  var mappedAudiences = variantsGroup.filter(function (v) {
    return v._audience;
  }).map(function (v) {
    if (audienceIdToAudience.has(v._audience)) {
      return _objectSpread$k(_objectSpread$k({}, audienceIdToAudience.get(v._audience)), {}, {
        variantId: v._id
      });
    }
  }).filter(function (a) {
    return !!a;
  });
  return mappedAudiences;
}

function useOnClickNTimes(ref, count, event) {
  var counterRef = react.exports.useRef(0);
  var timerRef = react.exports.useRef();
  react.exports.useEffect(function () {
    var _ref$current;

    if (!ref.current) {
      return;
    }

    (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.addEventListener("click", function () {
      clearTimeout(timerRef.current);
      counterRef.current++;

      if (counterRef.current === count) {
        event();
        counterRef.current = 0;
      }

      timerRef.current = setTimeout(function () {
        counterRef.current = 0;
      }, 300);
    });
  }, []);
}

var __jsx$l = React.createElement;
var TopBar = styled.div.withConfig({
  displayName: "EditorTopBar__TopBar",
  componentId: "sc-n7uh6s-0"
})(["position:relative;box-sizing:border-box;background-color:white;border-bottom:1px solid #eaeaea;padding:0 64px;min-height:", "px;display:flex;flex-direction:row;justify-content:center;align-items:center;"], TOP_BAR_HEIGHT);
var TopBarLeft = styled.div.withConfig({
  displayName: "EditorTopBar__TopBarLeft",
  componentId: "sc-n7uh6s-1"
})(["position:absolute;top:0;left:4px;height:100%;display:flex;flex-direction:row;align-items:center;gap:4px;"]);
var TopBarRight = styled.div.withConfig({
  displayName: "EditorTopBar__TopBarRight",
  componentId: "sc-n7uh6s-2"
})(["position:absolute;top:0;right:8px;height:100%;display:flex;flex-direction:row;align-items:center;gap:4px;"]);
var Heading = styled.div.withConfig({
  displayName: "EditorTopBar__Heading",
  componentId: "sc-n7uh6s-3"
})(["", ";user-select:none;"], SSFonts.body);
var EditorTopBar = function EditorTopBar(_ref) {
  var title = _ref.title,
      onClose = _ref.onClose,
      onBreakpointChange = _ref.onBreakpointChange,
      devices = _ref.devices,
      breakpointIndex = _ref.breakpointIndex,
      onIsEditingChange = _ref.onIsEditingChange,
      isEditing = _ref.isEditing,
      onUndo = _ref.onUndo,
      onRedo = _ref.onRedo;
      _ref.locale;
      _ref.locales;
      _ref.onLocaleChange;
      var _ref$allAudiences = _ref.allAudiences,
      allAudiences = _ref$allAudiences === void 0 ? [] : _ref$allAudiences,
      _ref$audiences = _ref.audiences,
      audiences = _ref$audiences === void 0 ? [] : _ref$audiences,
      _ref$onAudienceChange = _ref.onAudienceChange,
      onAudienceChange = _ref$onAudienceChange === void 0 ? function () {} : _ref$onAudienceChange,
      isFullScreen = _ref.isFullScreen,
      setFullScreen = _ref.setFullScreen,
      onAdminModeChange = _ref.onAdminModeChange;
  var headingRef = react.exports.useRef(null);
  useOnClickNTimes(headingRef, 5, function () {
    onAdminModeChange(true);
  });
  return __jsx$l(TopBar, null, __jsx$l(TopBarLeft, null, __jsx$l(SSButtonGhost, {
    icon: SSIcons.Close,
    hideLabel: true,
    onClick: function onClick() {
      if (onClose) {
        onClose();
      }
    }
  }, "Close"), __jsx$l("div", {
    style: {
      height: "100%",
      background: SSColors.black10,
      width: 1
    }
  }), __jsx$l(SSButtonGhost, {
    icon: SSIcons.Undo,
    hideLabel: true,
    onClick: function onClick() {
      onUndo();
    }
  }, "Undo"), __jsx$l(SSButtonGhost, {
    icon: SSIcons.Redo,
    hideLabel: true,
    onClick: function onClick() {
      onRedo();
    }
  }, "Redo")), __jsx$l(Heading, {
    ref: headingRef
  }, title), __jsx$l(TopBarRight, null, __jsx$l(AudiencePicker, {
    allAudiences: allAudiences,
    audiences: audiences,
    onAudienceChange: onAudienceChange
  }), __jsx$l(SSButtonSecondary, {
    onClick: function onClick() {
      onIsEditingChange();
    }
  }, isEditing ? "Preview" : "Edit"), __jsx$l(SSSelect, {
    value: !isEditing && isFullScreen ? "__fullscreen__" : breakpointIndex,
    onChange: function onChange(e) {
      var val = e.target.value;

      if (!isEditing) {
        var isFullscreen = val === "__fullscreen__";
        setFullScreen(isFullscreen);

        if (!isFullscreen) {
          onBreakpointChange(val);
        }
      } else {
        onBreakpointChange(val);
      }
    }
  }, devices.filter(function (device) {
    return !device.hidden;
  }).map(function (device) {
    return __jsx$l("option", {
      key: device.id,
      value: device.id
    }, device.label || device.id);
  }), !isEditing && __jsx$l("option", {
    key: "__fullscreen__",
    value: "__fullscreen__"
  }, "Fit screen"))));
};

var ConfigAfterAutoContext = /*#__PURE__*/React.createContext(null);
function useConfigAfterAuto() {
  var configAfterAutoContext = react.exports.useContext(ConfigAfterAutoContext);

  if (!configAfterAutoContext) {
    throw new Error("CompiledConfigContext is required for Responsive field");
  }

  return configAfterAutoContext;
}

var __jsx$k = react.exports.createElement;
function InlineSettings(_ref) {
  var fields = _ref.fields;
  var hasNoExtraFields = !(fields && fields.length);

  if (hasNoExtraFields) {
    return null;
  }

  return __jsx$k(StyleReset, {
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    style: {
      height: "100%"
    }
  }, __jsx$k(SettingsContent, {
    fields: fields
  }));
}

function SettingsContent(_ref2) {
  var fields = _ref2.fields;

  var _useEditorContext = useEditorContext(),
      form = _useEditorContext.form,
      focussedField = _useEditorContext.focussedField;

  return __jsx$k(FormBody, {
    id: "sidebar-panels-root"
  }, __jsx$k(Wrapper$1, null, __jsx$k(FieldsBuilder, {
    form: form,
    fields: fields
  }), __jsx$k(SidebarFooter, {
    paths: focussedField
  })));
}

var FormBody = styled.div.withConfig({
  displayName: "inline-settings__FormBody",
  componentId: "sc-107u4cx-0"
})(["position:relative;flex:1 1 auto;display:flex;flex-direction:column;width:100%;height:100%;border-top:1px solid var(--tina-color-grey-2);background-color:white;"]);
var Wrapper$1 = styled.div.withConfig({
  displayName: "inline-settings__Wrapper",
  componentId: "sc-107u4cx-1"
})(["display:block;margin:0 auto;width:100%;height:100%;overflow-y:auto;"]);

var __jsx$j = React.createElement;
var Error$1 = styled.div.withConfig({
  displayName: "EditorSidebar__Error",
  componentId: "sc-oxphy7-0"
})(["", " padding:7px 6px 7px;color:hsl(0deg 0% 50% / 0.8);white-space:normal;background:hsl(0deg 100% 50% / 0.2);margin-right:10px;border-radius:2px;margin:16px;"], SSFonts.body);
var EditorSidebar = function EditorSidebar(props) {
  var focussedField = props.focussedField,
      form = props.form;
  var editorContext = useEditorContext();

  var error = function () {
    if (focussedField.length === 1) {
      var path = focussedField[0];
      var compiledComponent = dotNotationGet(editorContext.compiledComponentConfig, path);
      var editableComponent = dotNotationGet(form.values, path);

      if ((compiledComponent === null || compiledComponent === void 0 ? void 0 : compiledComponent._template) === "$MissingComponent") {
        return "Shopstory can\u2019t find definition for component: ".concat(editableComponent._template, " in your project. Please contact your developers to resolve this issue.");
      }
    }

    return null;
  }();

  var areMultipleFieldsSelected = focussedField.length > 1;
  var fieldsPerFocusedField = focussedField.map(function (focusedField) {
    return buildTinaFields(focusedField, editorContext);
  });
  var mergedFields = areMultipleFieldsSelected ? mergeCommonFields({
    fields: fieldsPerFocusedField
  }) : fieldsPerFocusedField.flat();
  return __jsx$j(React.Fragment, null, error && __jsx$j(Error$1, null, error), __jsx$j(InlineSettings, {
    fields: mergedFields
  }));
};

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$j(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Traverses recursively the config tree (similar to traverseConfig) but behaves like "Array.map". It returns new tree with elements mapped to new ones.
 * Responsive values are mapped "per breakpoint", it smells a bit, maybe in the future we'll have to apply some flag to have option whether we want to disassemble responsives or not.
 */

function configMapArray(configArray, context, callback, prefix) {
  /**
   * Why this?
   *
   * Sometimes you might need configMap for config that have not yet been normalized. Such config still can be considered correct if it has a component that have a new schema property. Example of this is mergeSingleLocaleConfigsIntoConfig.
   */
  if (configArray === undefined) {
    return;
  }

  if (!Array.isArray(configArray)) {
    return;
  }

  return configArray.map(function (x, index) {
    return configMapInternal(x, context, callback, "".concat(prefix, ".").concat(index));
  });
}

function configMap(config, context, callback) {
  return configMapInternal(config, context, callback, "");
}

function configMapInternal(config, context, callback, prefix) {
  var componentDefinition = findComponentDefinition(config, context);

  var result = _objectSpread$j({}, config);

  if (!componentDefinition) {
    console.warn("[configMap] Unknown component definition for: ".concat(config._template));
    return result;
  }

  prefix = prefix === undefined || prefix === "" ? "" : "".concat(prefix, ".");
  componentDefinition.schema.forEach(function (schemaProp) {
    if (schemaProp.type === "component-collection-localised") {
      if (config[schemaProp.prop] === undefined) {
        return;
      }

      result[schemaProp.prop] = {};

      for (var locale in config[schemaProp.prop]) {
        if (locale === "__fallback") {
          continue;
        }

        result[schemaProp.prop][locale] = configMapArray(config[schemaProp.prop][locale], context, callback, "".concat(prefix).concat(schemaProp.prop, ".").concat(locale));
      }

      result[schemaProp.prop] = callback({
        value: result[schemaProp.prop],
        path: "".concat(prefix).concat(schemaProp.prop),
        schemaProp: schemaProp
      });
    } else if (schemaProp.type === "component" || schemaProp.type === "component-collection" || schemaProp.type === "component-fixed") {
      result[schemaProp.prop] = configMapArray(config[schemaProp.prop], context, callback, "".concat(prefix).concat(schemaProp.prop));
      result[schemaProp.prop] = callback({
        value: result[schemaProp.prop],
        path: "".concat(prefix).concat(schemaProp.prop),
        schemaProp: schemaProp
      });
    } else {
      if (isTrulyResponsiveValue(result[schemaProp.prop])) {
        var mappedVal = {
          $res: true
        };

        for (var key in result[schemaProp.prop]) {
          if (key === "$res") {
            continue;
          }

          mappedVal[key] = callback({
            value: result[schemaProp.prop][key],
            schemaProp: schemaProp,
            path: "".concat(prefix).concat(schemaProp.prop, ".").concat(key)
          });
        }

        result[schemaProp.prop] = mappedVal;
      } else {
        result[schemaProp.prop] = callback({
          value: result[schemaProp.prop],
          schemaProp: schemaProp,
          path: "".concat(prefix).concat(schemaProp.prop)
        });
      }
    }
  });
  return result;
}

var getComponentMainType = function getComponentMainType(componentTypes) {
  var type;

  if (componentTypes.includes("action") || componentTypes.includes("actionLink")) {
    type = "action";
  } else if (componentTypes.includes("card")) {
    type = "card";
  } else if (componentTypes.includes("symbol")) {
    type = "icon";
  } else if (componentTypes.includes("button")) {
    type = "button";
  } else if (componentTypes.includes("section") || componentTypes.includes("token")) {
    type = "section";
  } else if (componentTypes.includes("item")) {
    type = "item";
  } else if (componentTypes.includes("image") || componentTypes.includes("$image")) {
    type = "image";
  } else if (componentTypes.includes("actionTextModifier")) {
    type = "actionTextModifier";
  } else {
    // TODO: what if other types come here? TO DO!
    console.error("no way to determine type for", componentTypes);
    throw new Error("no way to determine type for ".concat(componentTypes));
  }

  return type;
};

function buildText(x, editorContext) {
  var defaultLocale = getDefaultLocale(editorContext.locales);
  return {
    id: "locale." + uniqueId(),
    value: _defineProperty$g({}, defaultLocale.code, x)
  };
}

function buildRichTextComponentConfig(_ref) {
  var accessibilityRole = _ref.accessibilityRole,
      compilationContext = _ref.compilationContext,
      elements = _ref.elements,
      isListStyleAuto = _ref.isListStyleAuto,
      mainColor = _ref.mainColor,
      mainFont = _ref.mainFont;
  return {
    _id: uniqueId(),
    _template: "$richText",
    accessibilityRole: accessibilityRole !== null && accessibilityRole !== void 0 ? accessibilityRole : "div",
    elements: _defineProperty$g({}, compilationContext.contextParams.locale, elements),
    isListStyleAuto: isListStyleAuto !== null && isListStyleAuto !== void 0 ? isListStyleAuto : true,
    mainColor: mainColor,
    mainFont: mainFont
  };
}

function buildRichTextBlockElementComponentConfig(type, elements) {
  return {
    _template: "$richTextBlockElement",
    elements: elements,
    type: type,
    _id: uniqueId()
  };
}

function buildRichTextLineElementComponentConfig(_ref4) {
  var elements = _ref4.elements;
  return {
    _template: "$richTextLineElement",
    elements: elements,
    _id: uniqueId()
  };
}

function buildRichTextInlineWrapperElementComponentConfig(_ref5) {
  var id = _ref5.id,
      elements = _ref5.elements,
      action = _ref5.action,
      textModifier = _ref5.textModifier,
      actionTextModifier = _ref5.actionTextModifier;
  return {
    _id: id !== null && id !== void 0 ? id : uniqueId(),
    _template: "$richTextInlineWrapperElement",
    elements: elements,
    action: action !== null && action !== void 0 ? action : [],
    textModifier: textModifier !== null && textModifier !== void 0 ? textModifier : [],
    actionTextModifier: actionTextModifier !== null && actionTextModifier !== void 0 ? actionTextModifier : []
  };
}

function buildRichTextPartComponentConfig(_ref6) {
  var color = _ref6.color,
      font = _ref6.font,
      value = _ref6.value,
      id = _ref6.id;
  return {
    _id: id !== null && id !== void 0 ? id : uniqueId(),
    _template: "$richTextPart",
    color: color,
    font: font,
    value: value
  };
}

function isSpecialTemplate(template) {
  return typeof template.specialRole === "string";
}
function isTemplate(template) {
  return template.specialRole === undefined;
}

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$i(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function entryToTemplate(entry, group, type) {
  var fields = entry.fields;
  var imageUrl = "https://".concat(fields.image.fields.file.url);

  if (!isComponentConfig(fields.data)) {
    return;
  }

  return {
    id: entry.sys.id,
    label: fields.name,
    config: fields.data,
    previewImage: imageUrl,
    group: group
  };
}

function useTemplates(componentTypes) {
  var editorContext = useEditorContext();
  var shouldUsePreview = editorContext.isMaster;
  react.exports.useEffect(function () {
    var contentfulClient = createClient$1({
      space: "blh4anz05qu1",
      accessToken: shouldUsePreview ? "2OqujCwpaLi_bz7mHNrFUthl2aidK0UgVeumw_2vlsc" : "lYW4u-PLH0lAAzFqWUwfSluHeC-jL1MF0XIoTYlXAjI",
      host: shouldUsePreview ? "preview.contentful.com" : undefined
    });
    contentfulClient.getEntries({
      content_type: "templatePicker",
      include: 5
    }).then(function (entries) {
      var fetchedTemplates = {
        section: [],
        card: []
      };
      var templatePickerFields = entries.items[0].fields;
      templatePickerFields.sectionCategories.forEach(function (sectionCategoryEntry) {
        sectionCategoryEntry.fields.sections.forEach(function (sectionEntry) {
          var template = entryToTemplate(sectionEntry, sectionCategoryEntry.fields.name);

          if (template) {
            fetchedTemplates.section.push(template);
          }
        });

        if (isComponentConfig(sectionCategoryEntry.fields.empty)) {
          fetchedTemplates.section.push({
            config: sectionCategoryEntry.fields.empty,
            isGroupEmptyTemplate: true,
            group: sectionCategoryEntry.fields.name
          });
        }
      });
      templatePickerFields.cardCategories.forEach(function (cardCategoryEntry) {
        cardCategoryEntry.fields.cards.forEach(function (cardEntry) {
          var template = entryToTemplate(cardEntry, cardCategoryEntry.fields.name);

          if (template) {
            fetchedTemplates.card.push(template);
          }
        });
      });
      editorContext.setRemoteTemplates(fetchedTemplates);
    })["catch"](function (error) {
      console.error(error);
    });
  }, []);

  if (!editorContext.remoteTemplates) {
    return;
  }

  return getTemplates(componentTypes, editorContext, editorContext.remoteTemplates);
}

function getUserDefinedTemplatesFromDefinitions(definitions) {
  return definitions.filter(function (x) {
    return !x.id.startsWith("$") && !x.hidden;
  }).map(function (def) {
    var _def$previewImage;

    var type = getComponentMainType(def.tags);
    return {
      id: def.id,
      // type: capitalizeFirstLetter(type),
      // label: def.label || def.id,
      previewImage: (_def$previewImage = def.previewImage) !== null && _def$previewImage !== void 0 ? _def$previewImage : type === "button" ? "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_button.png" : undefined,
      config: {
        _template: def.id
      },
      group: "My library"
    };
  });
}

function findMappedTemplate(masterId, templates) {
  return templates.find(function (template) {
    var mapToArray = Array.isArray(template.mapTo) ? template.mapTo : typeof template.mapTo === "string" ? [template.mapTo] : [];
    return mapToArray.includes(masterId);
  });
}

function findTemplatesOfType(templates, type, editorContext) {
  return templates.filter(function (template) {
    var definition = findComponentDefinition(template.config, editorContext);
    return definition.tags.includes(type); // const mainType = getComponentMainType(definition.tags);
    // return mainType === type;
  });
}

function getMyLibraryTemplates(definitions, templates, editorContext, filterType) {
  var myLibraryTemplates = [].concat(_toConsumableArray$2(findTemplatesOfType(templates, filterType, editorContext)), _toConsumableArray$2(getUserDefinedTemplatesFromDefinitions(definitions.filter(function (component) {
    return component.tags.includes(filterType);
  }))));
  return myLibraryTemplates.map(function (template) {
    var _template$previewImag;

    return _objectSpread$i(_objectSpread$i({}, template), {}, {
      group: "My library",
      previewImage: (_template$previewImag = template.previewImage) !== null && _template$previewImag !== void 0 ? _template$previewImag : filterType === "button" ? BUTTON_THUMBNAIL : undefined
    });
  });
}

var BUTTON_THUMBNAIL = "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_button.png";
var VIDEO_THUMBNAIL = "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_video.png";
function getTemplates(componentTypes, editorContext, inputTemplates) {
  var _templatesDict$item, _templatesDict$sectio, _templatesDict$card, _templatesDict$button, _templatesDict$image;

  if (componentTypes.length > 1) {
    console.error(componentTypes);
    throw new Error("wrong call of getTemplates. componentTypes must be array with one item (legacy).");
  }

  var componentType = componentTypes[0];
  /**
   * CONFIG GENERATORS
   */

  var icon = function icon(iconRef) {
    var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$dark";
    return {
      _template: "$icon",
      icon: {
        ref: iconRef
      },
      color: _defineProperty$g({
        $res: true
      }, editorContext.mainBreakpointIndex, {
        ref: color,
        value: "xxx"
      })
    };
  };

  var controlButton = function controlButton(symbol, label, buttonSize, symbolSize, backgroundColor) {
    return {
      _template: "$IconButton2",
      symbol: [symbol],
      label: buildText(label, editorContext),
      buttonSize: _defineProperty$g({
        $res: true
      }, editorContext.mainBreakpointIndex, buttonSize.toString()),
      symbolSize: _defineProperty$g({
        $res: true
      }, editorContext.mainBreakpointIndex, symbolSize.toString()),
      backgroundColor: _defineProperty$g({
        $res: true
      }, editorContext.mainBreakpointIndex, {
        value: backgroundColor
      })
    };
  };

  var standardButton = function standardButton(color, backgroundColor) {
    return {
      _template: "$StandardButton",
      color: _defineProperty$g({
        $res: true
      }, editorContext.mainBreakpointIndex, {
        ref: color,
        value: "xxx"
      }),
      hasBackground: backgroundColor === null ? false : true,
      backgroundColor: _defineProperty$g({
        $res: true
      }, editorContext.mainBreakpointIndex, {
        ref: backgroundColor,
        value: "xxx"
      }),
      radius: _defineProperty$g({
        $res: true
      }, editorContext.mainBreakpointIndex, "10"),
      underline: backgroundColor === null ? "on-custom" : "off",
      underlineOffset: _defineProperty$g({
        $res: true
      }, editorContext.mainBreakpointIndex, "4")
    };
  };

  var textConfig = function textConfig(key) {
    return buildRichTextComponentConfig({
      compilationContext: editorContext,
      elements: [buildRichTextBlockElementComponentConfig("paragraph", [buildRichTextLineElementComponentConfig({
        elements: [buildRichTextPartComponentConfig({
          color: {
            ref: "$dark",
            value: "black"
          },
          font: {
            value: {},
            ref: key
          },
          value: "Lorem ipsum"
        })]
      })])],
      mainColor: {
        ref: "$dark",
        value: "black"
      },
      mainFont: {
        value: {},
        ref: key
      }
    });
  };
  /**
   * MASTER CONFIGS
   */
  // Default master templates


  var masterConfigs = {
    buttonSliderLeft: controlButton(icon("$sliderLeft", "$dark"), "Previous", 40, 24, "#D8D8D880"),
    buttonSliderRight: controlButton(icon("$sliderRight", "$dark"), "Next", 40, 24, "#D8D8D880"),
    buttonSliderLeftDark: controlButton(icon("$sliderLeft", "$light"), "Previous", 40, 24, "#00000080"),
    buttonSliderRightDark: controlButton(icon("$sliderRight", "$light"), "Next", 40, 24, "#00000080"),
    buttonVideoPlay: controlButton(icon("$play", "$light"), "Play", 32, 20, "#36363680"),
    buttonVideoPause: controlButton(icon("$pause", "$light"), "Pause", 32, 20, "#36363680"),
    buttonVideoMute: controlButton(icon("$mute", "$light"), "Mute", 32, 20, "#36363680"),
    buttonVideoUnmute: controlButton(icon("$unmute", "$light"), "Unmute", 32, 20, "#36363680"),
    buttonLight: standardButton("$dark", "$light"),
    buttonDark: standardButton("$light", "$dark"),
    buttonTextLight: standardButton("$light", null),
    buttonTextDark: standardButton("$dark", null),
    productCard: {
      _template: "$CardPlaceholder"
    },
    textModifier: {
      _template: "$StandardActionStyles",
      isColorOverwriteEnabled: true,
      color: _defineProperty$g({
        $res: true
      }, editorContext.breakpointIndex, {
        value: "#0166cc"
      }),
      hoverColor: _defineProperty$g({
        $res: true
      }, editorContext.breakpointIndex, {
        ref: "black",
        value: "black"
      }),
      isHoverColorEnabled: false,
      underline: "enabled",
      opacity: "1",
      hoverOpacity: "1",
      hoverOpacityAnimationDuration: "100ms"
    }
  }; // video defined here because it uses above master configs (video buttons)

  masterConfigs.video = {
    _template: "$video",
    enableControls: false,
    margin: _defineProperty$g({
      $res: true
    }, editorContext.mainBreakpointIndex, {
      ref: "8",
      value: "8"
    }),
    gap: _defineProperty$g({
      $res: true
    }, editorContext.mainBreakpointIndex, {
      ref: "8",
      value: "8"
    }),
    controlsPosition: _defineProperty$g({
      $res: true
    }, editorContext.mainBreakpointIndex, "bottom-right"),
    PlayButton: [masterConfigs.buttonVideoPlay],
    PauseButton: [masterConfigs.buttonVideoPause],
    MuteButton: [masterConfigs.buttonVideoMute],
    UnmuteButton: [masterConfigs.buttonVideoUnmute]
  }; // Add _master property to all master configs

  Object.keys(masterConfigs).forEach(function (id) {
    masterConfigs[id]._master = id;
  });
  /**
   * SHARED TEMPLATES
   */

  var gridCard4 = {
    _template: "$GridCard",
    rightArrowPlacement: _defineProperty$g({
      $res: true
    }, editorContext.mainBreakpointIndex, "center"),
    leftArrowPlacement: _defineProperty$g({
      $res: true
    }, editorContext.mainBreakpointIndex, "center"),
    RightArrow: [masterConfigs.buttonSliderRight],
    LeftArrow: [masterConfigs.buttonSliderLeft]
  };
  var gridCard2 = {
    _template: "$GridCard",
    rightArrowPlacement: _defineProperty$g({
      $res: true
    }, editorContext.mainBreakpointIndex, "center"),
    leftArrowPlacement: _defineProperty$g({
      $res: true
    }, editorContext.mainBreakpointIndex, "center"),
    RightArrow: [masterConfigs.buttonSliderRight],
    LeftArrow: [masterConfigs.buttonSliderLeft],
    numberOfItems: {
      ref: "2"
    },
    shouldSliderItemsBeVisibleOnMargin: false
  }; // Cards

  var myLibraryCards = getMyLibraryTemplates(editorContext.definitions.components, editorContext.templates, editorContext, "card");
  var allCards = [];

  if (editorContext.isMaster) {
    allCards.push({
      label: "(Master) Product Card",
      previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/placeholder_banner_card.png",
      // temporary absolute path
      config: masterConfigs.productCard,
      group: "Master templates"
    });
  }

  allCards.push.apply(allCards, _toConsumableArray$2(myLibraryCards));

  if (inputTemplates === null || inputTemplates === void 0 ? void 0 : inputTemplates.card) {
    allCards.push.apply(allCards, _toConsumableArray$2(inputTemplates.card));
  }

  if (editorContext.isMaster) {
    allCards.push({
      label: "Banner card",
      previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/placeholder_banner_card.png",
      // temporary absolute path
      config: {
        _template: "$BannerCard2",
        mode: _defineProperty$g({
          $res: true
        }, editorContext.mainBreakpointIndex, "none"),
        Card2: [{
          _template: "$BasicCardBackground",
          Background: [{
            _template: "$image"
          }]
        }],
        Card1: [{
          _template: "$BasicCard",
          size: _defineProperty$g({
            $res: true
          }, editorContext.mainBreakpointIndex, {
            value: "fit-content"
          })
        }]
      },
      group: "Raw"
    });
    allCards.push({
      label: "Grid / Slider",
      previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/placeholder_banner_card.png",
      // temporary absolute path
      config: gridCard2
    });
  } // Image, video


  var imageTemplate = {
    type: "Image",
    previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_image.png",
    config: {
      _template: "$image"
    }
  };
  var templatesDict = {
    item: [],
    section: [],
    card: [],
    button: [],
    action: [],
    actionTextModifier: [],
    symbol: [],
    image: []
  }; // Items

  var myLibraryItems = getMyLibraryTemplates(editorContext.definitions.components, editorContext.templates, editorContext, "item");
  templatesDict.item.push({
    type: "Text",
    previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_text.png",
    config: normalize(textConfig("$body"), editorContext)
  }); // always add empty button group

  templatesDict.item.push({
    type: "Button Group",
    previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_button_group.png",
    config: {
      _template: "$buttons",
      gap: _defineProperty$g({
        $res: true
      }, editorContext.mainBreakpointIndex, {
        ref: "12",
        value: "12px"
      })
    }
  });
  templatesDict.item.push(imageTemplate);
  /**
   * Exception
   *
   * 1. This function takes care of the MAIN VIDEO ENTRY in the item list.
   * 2. Main video entry is always high in the list and has only one instance. It's the DEFAULT.
   * 3. The rest of templates will be later in the list.
   * 4. It assumes that the video is always of $video type. If someone added custom video type as main, it would be impossible to add custom $video types. We should later research this to make it more consistent.
   *
   * WARNING: this function returns the main video type and also, if possible, removes the old one from the list (if it was mapped to the main one).
   *
   */

  function getVideoTemplate(myLibraryTemplates) {
    if (editorContext.isMaster) {
      return {
        type: "Video",
        label: "(Master) Shopstory default",
        previewImage: VIDEO_THUMBNAIL,
        config: masterConfigs.video
      };
    } else {
      // Let's find the default video template in the list and put it here in the major position
      var customDefaultVideo = findMappedTemplate("video", myLibraryTemplates);

      if (customDefaultVideo) {
        var index = myLibraryTemplates.indexOf(customDefaultVideo);
        myLibraryTemplates.splice(index, 1);
        return _objectSpread$i(_objectSpread$i({}, customDefaultVideo), {}, {
          type: "Video",
          previewImage: VIDEO_THUMBNAIL
        });
      } else {
        return {
          type: "Video",
          previewImage: VIDEO_THUMBNAIL,
          config: _objectSpread$i(_objectSpread$i({}, masterConfigs.video), {}, {
            _master: undefined
          })
        };
      }
    }
  }

  templatesDict.item.push(getVideoTemplate(myLibraryItems));
  templatesDict.item.push({
    type: "Grid / Slider",
    config: gridCard2
  }); // always add two items

  templatesDict.item.push({
    type: "Horizontal layout",
    previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_horizontal_layout.png",
    config: {
      _template: "$twoItems"
    }
  }); // always add separator

  templatesDict.item.push({
    type: "Separator",
    previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_separator.png",
    config: {
      _template: "$separator"
    }
  });
  templatesDict.item.push({
    type: "Vimeo Player",
    previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_video.png",
    config: {
      _template: vimeoPlayerEditableComponent.id
    }
  });
  templatesDict.item.push({
    type: "Card",
    specialRole: "card"
  });

  (_templatesDict$item = templatesDict.item).push.apply(_templatesDict$item, _toConsumableArray$2(myLibraryItems)); // templatesDict.item.push(...allCards);
  // All font instances to the bottom (to be searchable)


  Object.entries(editorContext.theme.fonts).forEach(function (_ref) {
    var _value$label;

    var _ref2 = _slicedToArray$2(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (key.startsWith("__")) {
      return;
    }

    templatesDict.item.push({
      label: (_value$label = value.label) !== null && _value$label !== void 0 ? _value$label : key,
      type: "Text",
      previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_text.png",
      config: normalize(textConfig(key), editorContext)
    });
  });


  var myLibrarySections = getMyLibraryTemplates(editorContext.definitions.components, editorContext.templates, editorContext, "section");

  (_templatesDict$sectio = templatesDict.section).push.apply(_templatesDict$sectio, _toConsumableArray$2(myLibrarySections));

  if (inputTemplates === null || inputTemplates === void 0 ? void 0 : inputTemplates.section) {
    var _templatesDict$sectio2;

    (_templatesDict$sectio2 = templatesDict.section).push.apply(_templatesDict$sectio2, _toConsumableArray$2(inputTemplates.section));
  } // Raw


  if (editorContext.isMaster) {
    templatesDict.section.push({
      type: "Section",
      label: "Banner 2",
      previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/placeholder_banner.png",
      // temporary absolute path
      group: "Raw",
      config: {
        _template: "$BannerSection2",
        Component: [{
          _template: "$BannerCard2",
          Card2: [{
            _template: "$BasicCardBackground",
            Background: [{
              _template: "$image"
            }]
          }],
          Card1: [{
            _template: "$BasicCard",
            size: _defineProperty$g({
              $res: true
            }, editorContext.mainBreakpointIndex, {
              value: "fit-content"
            })
          }]
        }]
      }
    });
    templatesDict.section.push({
      type: "Section",
      label: "Grid / Slider",
      previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/placeholder_slider_grid.png",
      // temporary absolute path
      config: {
        _template: "$Grid",
        Component: [gridCard4]
      },
      group: "Raw"
    });
    templatesDict.section.push({
      type: "Section",
      label: "Two Cards",
      previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/placeholder_banner.png",
      // temporary absolute path
      config: {
        _template: "$TwoCards"
      },
      group: "Raw"
    });
  }


  (_templatesDict$card = templatesDict.card).push.apply(_templatesDict$card, allCards); // button


  if (editorContext.isMaster) {
    templatesDict.button.push({
      label: "(Master) Button dark",
      previewImage: BUTTON_THUMBNAIL,
      config: masterConfigs.buttonDark,
      group: "Master templates"
    });
    templatesDict.button.push({
      label: "(Master) Button light",
      previewImage: BUTTON_THUMBNAIL,
      config: masterConfigs.buttonLight,
      group: "Master templates"
    });
    templatesDict.button.push({
      label: "(Master) Text Button dark",
      previewImage: BUTTON_THUMBNAIL,
      config: masterConfigs.buttonTextDark,
      group: "Master templates"
    });
    templatesDict.button.push({
      label: "(Master) Text Button light",
      previewImage: BUTTON_THUMBNAIL,
      config: masterConfigs.buttonTextLight,
      group: "Master templates"
    });
    templatesDict.button.push({
      label: "(Master) Button slider right - light",
      previewImage: BUTTON_THUMBNAIL,
      config: masterConfigs.buttonSliderRight,
      group: "Master templates"
    });
    templatesDict.button.push({
      label: "(Master) Button slider left - light",
      previewImage: BUTTON_THUMBNAIL,
      config: masterConfigs.buttonSliderLeft
    });
    templatesDict.button.push({
      label: "(Master) Button slider right - dark",
      previewImage: BUTTON_THUMBNAIL,
      config: masterConfigs.buttonSliderRightDark,
      group: "Master templates"
    });
    templatesDict.button.push({
      label: "(Master) Button slider left - dark",
      previewImage: BUTTON_THUMBNAIL,
      config: masterConfigs.buttonSliderLeftDark,
      group: "Master templates"
    });
  }

  var myLibraryButtons = getMyLibraryTemplates(editorContext.definitions.components, editorContext.templates, editorContext, "button");

  (_templatesDict$button = templatesDict.button).push.apply(_templatesDict$button, _toConsumableArray$2(myLibraryButtons));

  templatesDict.button.push({
    label: "Default",
    previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_button.png",
    config: standardButton("$light", "$dark")
  });
  templatesDict.button.push({
    label: "Text",
    previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_button.png",
    config: {
      _template: "$StandardButton",
      hasBackground: false,
      hasBorder: false,
      underline: "on"
    }
  });
  templatesDict.button.push({
    label: "Default",
    previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_button.png",
    config: controlButton(icon("$sliderLeft", "$dark"), "Slider left", 32, 24, "#D8D8D880")
  }); // actions and links

  var myLibraryActions = getMyLibraryTemplates(editorContext.definitions.actions, editorContext.templates, editorContext, "action");
  var myLibraryLinks = getMyLibraryTemplates(editorContext.definitions.links, editorContext.templates, editorContext, "actionLink");
  templatesDict.action = [].concat(_toConsumableArray$2(myLibraryLinks), _toConsumableArray$2(myLibraryActions));
  templatesDict.action.push({
    config: {
      _template: "$StandardLink",
      url: {
        id: "local.96b6f39a-916f-43a5-bfdd-d78ca8f0b72d",
        value: {
          en: "https://google.com"
        }
      },
      shouldOpenInNewWindow: true,
      _itemProps: {
        $BannerCard: {
          action: {}
        }
      },
      traceId: "$StandardLink-8e01dd26"
    }
  }); // text modifiers

  var myLibraryTextModifiers = getMyLibraryTemplates(editorContext.definitions.textModifiers, editorContext.templates, editorContext, "actionTextModifier");

  if (editorContext.isMaster) {
    templatesDict.actionTextModifier.push({
      label: "(MASTER) Default link styling",
      config: masterConfigs.textModifier,
      isDefaultTextModifier: true
    });
  } else {
    var _templatesDict$action;

    (_templatesDict$action = templatesDict.actionTextModifier).push.apply(_templatesDict$action, _toConsumableArray$2(myLibraryTextModifiers));

    var defaultTemplate = findMappedTemplate("textModifier", templatesDict.actionTextModifier.filter(isTemplate));

    if (defaultTemplate) {
      defaultTemplate.isDefaultTextModifier = true;
    }

    templatesDict.actionTextModifier.push({
      label: "Shopstory default - blue link",
      config: _objectSpread$i(_objectSpread$i({}, masterConfigs.textModifier), {}, {
        _master: undefined // just default text modifier available in the list for user

      }),
      isDefaultTextModifier: defaultTemplate === undefined
    });
  } // symbols


  templatesDict.symbol.push({
    label: "Icon",
    previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_button.png",
    config: icon("$sliderLeft", "$dark")
  }); // background

  var myLibraryBackgrounds = getMyLibraryTemplates(editorContext.definitions.components, editorContext.templates, editorContext, "image");
  templatesDict.image.push({
    type: "Solid color",
    config: {
      _template: "$backgroundColor"
    }
  });
  templatesDict.image.push(imageTemplate);
  templatesDict.image.push(getVideoTemplate(myLibraryBackgrounds));

  (_templatesDict$image = templatesDict.image).push.apply(_templatesDict$image, _toConsumableArray$2(myLibraryBackgrounds));

  templatesDict.image.push({
    type: "Vimeo Player",
    previewImage: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_video.png",
    config: {
      _template: vimeoPlayerEditableComponent.id
    }
  });
  var templates = templatesDict[componentType];
  var allTemplates = [];
  Object.values(templatesDict).forEach(function (categoryTemplates) {
    allTemplates.push.apply(allTemplates, _toConsumableArray$2(categoryTemplates));
  });
  /**
   * MASTER TEMPLATE MAPPING
   */

  function replaceMasterTemplates(val) {
    if (Array.isArray(val)) {
      return val.map(function (item) {
        return replaceMasterTemplates(item);
      });
    } else if (typeof val === "object" && val !== null) {
      var isMasterConfig = typeof val._template === "string" && typeof val._master === "string";

      if (isMasterConfig) {
        var _findMappedTemplate;

        var mappedConfig = (_findMappedTemplate = findMappedTemplate(val._master, allTemplates.filter(isTemplate))) === null || _findMappedTemplate === void 0 ? void 0 : _findMappedTemplate.config;

        if (mappedConfig) {
          return _objectSpread$i(_objectSpread$i({}, mappedConfig), {}, {
            _itemProps: val._itemProps
          });
        }
      }

      var newObj = {};

      for (var key in val) {
        newObj[key] = replaceMasterTemplates(val[key]);
      }

      delete newObj._master;
      return newObj;
    }

    return val;
  }

  if (!editorContext.isMaster) {
    // in user environment we first exclude all the master templates, then replace all masters to mapped templates
    templates = templates.map(function (template) {
      if (isSpecialTemplate(template)) {
        return template;
      }

      return _objectSpread$i(_objectSpread$i({}, template), {}, {
        config: replaceMasterTemplates(template.config)
      });
    });
  }
  /**
   * NORMALIZE TEMPLATES
   */


  templates = templates.map(function (template) {
    if (isSpecialTemplate(template)) {
      return template;
    }

    return _objectSpread$i(_objectSpread$i({}, template), {}, {
      config: normalize(template.config, editorContext)
    });
  });
  /**
   * NORMALIZE LOCALES
   */

  /**
   * This counter is for the sake of adding consistent template ids when they're not available.
   * The thing is that when templates are presented in a list, we need to set a key. Key must be unique per template.
   * As we don't have ids we must fill them with sth. But if we used uniqueId then each re-render would trigger new ids and re-render.
   * This is far from perfect but for now it's fine.
   */

  var counter = 0;
  templates = templates.map(function (template) {
    var id = template.id;

    if (!id) {
      id = "template." + counter;
      counter++;
    }

    if (isSpecialTemplate(template)) {
      return _objectSpread$i(_objectSpread$i({}, template), {}, {
        id: id
      });
    }

    return _objectSpread$i(_objectSpread$i({}, template), {}, {
      id: id,
      config: configMap(template.config, editorContext, function (_ref3) {
        var value = _ref3.value,
            schemaProp = _ref3.schemaProp;

        if (schemaProp.type === "text") {
          var firstDefinedValue = Object.values(value.value).filter(function (x) {
            return x !== null && x !== undefined;
          })[0];
          return _objectSpread$i(_objectSpread$i({}, value), {}, {
            value: _defineProperty$g({}, getDefaultLocale(editorContext.locales).code, firstDefinedValue)
          });
        } else if (schemaProp.type === "component-collection-localised") {
          var _firstDefinedValue = Object.values(value).filter(function (x) {
            return x !== null && x !== undefined;
          })[0];
          return _defineProperty$g({}, getDefaultLocale(editorContext.locales).code, _firstDefinedValue);
        }

        return value;
      })
    });
  });
  return templates;
}

function getComponentLabelFromTemplate(template, editorContext) {
  if (isSpecialTemplate(template)) {
    var _template$label;

    return (_template$label = template.label) !== null && _template$label !== void 0 ? _template$label : "unknown";
  }

  var namesMap = {};
  Object.values(editorContext.definitions).forEach(function (definitions) {
    definitions.forEach(function (definition) {
      var _definition$label;

      namesMap[definition.id] = (_definition$label = definition.label) !== null && _definition$label !== void 0 ? _definition$label : definition.id;
    });
  });
  return namesMap[template.config._template];
}

var __jsx$i = React.createElement;

/**
 * CARD
 */
var CardRoot = styled.div.withConfig({
  displayName: "SectionPicker__CardRoot",
  componentId: "sc-1e0cm58-0"
})(["&:hover{outline:1px solid ", ";outline-offset:8px;}"], SSColors.black10);
var ImageContainer = styled.div.withConfig({
  displayName: "SectionPicker__ImageContainer",
  componentId: "sc-1e0cm58-1"
})(["position:relative;background-color:", ";margin-bottom:8px;padding-bottom:", ";cursor:pointer;"], SSColors.black10, function (p) {
  return p.mode === "card" ? "90%" : "60%";
});
var CardImg = styled.img.withConfig({
  displayName: "SectionPicker__CardImg",
  componentId: "sc-1e0cm58-2"
})(["position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;padding:24px;box-sizing:border-box;"]);
var CardLabelContainer = styled.div.withConfig({
  displayName: "SectionPicker__CardLabelContainer",
  componentId: "sc-1e0cm58-3"
})(["display:flex;flex-direction:row;align-items:center;margin-top:8px;"]);
var CardLabelTemplateName = styled.div.withConfig({
  displayName: "SectionPicker__CardLabelTemplateName",
  componentId: "sc-1e0cm58-4"
})(["", ";color:black;"], SSFonts.body);
var Title = styled.div.withConfig({
  displayName: "SectionPicker__Title",
  componentId: "sc-1e0cm58-5"
})(["", ""], SSFonts.label);
var TitleContainer = styled.div.withConfig({
  displayName: "SectionPicker__TitleContainer",
  componentId: "sc-1e0cm58-6"
})(["display:flex;flex-direction:row;gap:8px;align-items:center;margin-bottom:24px;"]);
var Message = styled.div.withConfig({
  displayName: "SectionPicker__Message",
  componentId: "sc-1e0cm58-7"
})(["padding-top:32px;", ";"], SSFonts.body);
var TemplateLabelRoot = styled.div.withConfig({
  displayName: "SectionPicker__TemplateLabelRoot",
  componentId: "sc-1e0cm58-8"
})(["display:flex;flex-direction:row;gap:8px;align-items:center;"]);
var TemplateLabelTitle = styled.div.withConfig({
  displayName: "SectionPicker__TemplateLabelTitle",
  componentId: "sc-1e0cm58-9"
})(["", ";line-height:1;color:", ";"], SSFonts.body, function (p) {
  return p.custom ? SSColors.purple : "black";
});

function TemplateLabel(props) {
  return __jsx$i(TemplateLabelRoot, null, props.custom && __jsx$i(CustomComponentSymbol, null), __jsx$i(TemplateLabelTitle, {
    custom: props.custom
  }, props.label));
}

var SectionCard = function SectionCard(_ref) {
  var template = _ref.template,
      onSelect = _ref.onSelect,
      mode = _ref.mode;
  var imageRef = react.exports.useRef(null);
  var editorContext = useEditorContext();
  var isCustom = isTemplate(template) && !template.config._template.startsWith("$");
  return __jsx$i(CardRoot, null, __jsx$i(ImageContainer, {
    ref: imageRef,
    onClick: onSelect,
    mode: mode
  }, template.previewImage && __jsx$i(CardImg, {
    src: template.previewImage
  })), __jsx$i(CardLabelContainer, null, isCustom && __jsx$i(TemplateLabel, {
    label: getComponentLabelFromTemplate(template, editorContext),
    custom: isCustom
  }), template.label && __jsx$i(CardLabelTemplateName, null, isCustom && __jsx$i("span", null, "\xA0\xA0-\xA0\xA0"), template.label)));
};
/**
 * MODAL
 */


var ModalRoot = styled.div.withConfig({
  displayName: "SectionPicker__ModalRoot",
  componentId: "sc-1e0cm58-10"
})(["position:absolute;top:0;left:0;width:100%;height:100%;display:grid;grid-template-columns:200px 1fr;"]);
var ModalGridRoot = styled.div.withConfig({
  displayName: "SectionPicker__ModalGridRoot",
  componentId: "sc-1e0cm58-11"
})(["display:grid;grid-template-columns:", ";grid-column-gap:16px;grid-row-gap:30px;"], function (p) {
  return p.mode === "card" ? "1fr 1fr 1fr" : "1fr 1fr";
});
var Sidebar = styled.div.withConfig({
  displayName: "SectionPicker__Sidebar",
  componentId: "sc-1e0cm58-12"
})(["overflow-y:hidden;overflow-x:hidden;border-right:1px solid ", ";height:100%;"], SSColors.black5);
var SidebarContent = styled.div.withConfig({
  displayName: "SectionPicker__SidebarContent",
  componentId: "sc-1e0cm58-13"
})(["padding:24px 4px;display:flex;flex-direction:column;gap:8px;"]);
var SidebarButton = styled.button.withConfig({
  displayName: "SectionPicker__SidebarButton",
  componentId: "sc-1e0cm58-14"
})(["all:unset;height:38px;", " display:flex;padding-left:16px;align-items:center;&:hover{background:", ";}cursor:pointer;"], SSFonts.body, SSColors.black5);
var GridRoot = styled.div.withConfig({
  displayName: "SectionPicker__GridRoot",
  componentId: "sc-1e0cm58-15"
})(["padding:0px 16px;height:100%;overflow-x:hidden;overflow-y:auto;"]);
var SectionPickerModal = function SectionPickerModal(props) {
  var isOpen = props.isOpen,
      onSelect = props.onSelect,
      onClose = props.onClose,
      componentTypes = props.componentTypes;
  var mode = componentTypes.includes("card") ? "card" : "section";
  var templates = useTemplates(componentTypes);
  var templateGroups = {};
  var NO_CATEGORY_LABEL = "-- NO CATEGORY --";
  (templates !== null && templates !== void 0 ? templates : []).forEach(function (template) {
    var _template$group;

    var groupName = (_template$group = template.group) !== null && _template$group !== void 0 ? _template$group : NO_CATEGORY_LABEL;

    if (!templateGroups[groupName]) {
      templateGroups[groupName] = {
        templates: []
      };
    }

    if (isTemplate(template) && template.isGroupEmptyTemplate) {
      templateGroups[groupName].empty = template;
    } else {
      templateGroups[groupName].templates.push(template);
    }
  }); // Let's move no category to the bottom

  var noCategoryGroup = templateGroups[NO_CATEGORY_LABEL];

  if (noCategoryGroup) {
    delete templateGroups[NO_CATEGORY_LABEL];
    templateGroups[NO_CATEGORY_LABEL] = noCategoryGroup;
  }

  var gridRootRef = react.exports.useRef(null);

  var templateSelected = function templateSelected(template) {
    if (onSelect) {
      onSelect(template);
    }

    if (onClose) {
      onClose();
    }
  };

  return __jsx$i(SSModal, {
    title: "Pick section",
    isOpen: isOpen,
    onRequestClose: function onRequestClose() {
      if (onClose) {
        onClose();
      }
    },
    mode: "center-huge",
    headerLine: true
  }, __jsx$i(ModalRoot, null, __jsx$i(Sidebar, null, templates && __jsx$i(SidebarContent, null, Object.keys(templateGroups).map(function (groupName) {
    return __jsx$i(SidebarButton, {
      onClick: function onClick() {
        var groupNode = document.getElementById("sectionPicker__group__".concat(groupName));
        var groupOffsetTop = groupNode.offsetTop;
        gridRootRef.current.scrollTo({
          top: groupOffsetTop,
          behavior: "smooth"
        });
      }
    }, groupName);
  }))), __jsx$i(GridRoot, {
    ref: gridRootRef
  }, templates === undefined && __jsx$i(Message, null, "Loading..."), templates && templates.length > 0 && Object.entries(templateGroups).map(function (_ref2, index) {
    var _ref3 = _slicedToArray$2(_ref2, 2),
        groupName = _ref3[0],
        groupTemplates = _ref3[1];

    return __jsx$i("div", {
      style: {
        paddingTop: "32px",
        paddingBottom: "32px"
      },
      id: "sectionPicker__group__".concat(groupName)
    }, __jsx$i(TitleContainer, null, __jsx$i(Title, null, groupName), groupTemplates.empty && __jsx$i(SSButtonGhostColor, {
      icon: SSIcons.Add,
      onClick: function onClick() {
        templateSelected(groupTemplates.empty);
      }
    }, "Add empty")), __jsx$i(ModalGridRoot, {
      mode: mode
    }, groupTemplates.templates.map(function (template, index) {
      return __jsx$i(SectionCard, {
        key: index,
        template: template,
        onSelect: function onSelect() {
          templateSelected(template);
        },
        mode: mode
      });
    })));
  }))));
};

var __jsx$h = React.createElement;
var SearchableSmallPickerModal = function SearchableSmallPickerModal(props) {
  var _useTemplates;

  var templates = (_useTemplates = useTemplates(props.componentTypes)) !== null && _useTemplates !== void 0 ? _useTemplates : [];
  var editorContext = useEditorContext();

  var _useState = react.exports.useState(""),
      query = _useState[0],
      setQuery = _useState[1];

  var trimmedQuery = query.trim();
  var filteredTemplates = trimmedQuery === "" ? templates : templates.filter(function (template) {
    return (template.type || "").toLocaleLowerCase().includes(trimmedQuery) || (template.label || "").toLocaleLowerCase().includes(trimmedQuery) || (isTemplate(template) ? template.config._template || "" : "").toLocaleLowerCase().includes(trimmedQuery);
  });

  var close = function close(template) {
    setQuery("");
    props.onClose(template);
  };

  return __jsx$h(SSModal, {
    mode: "center-small",
    isOpen: props.isOpen,
    onRequestClose: function onRequestClose() {
      close(undefined);
    },
    headerLine: true,
    searchProps: {
      value: query,
      placeholder: "Search...",
      onChange: function onChange(e) {
        setQuery(e.target.value);
      } // onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => {
      //   if (event.key === "Enter" && filteredTemplates.length === 1) {
      //     close(filteredTemplates[0]);
      //   }
      // },

    },
    headerSymbol: "S"
  }, filteredTemplates.map(function (template) {
    var _template$type;

    return __jsx$h(SSBasicRow, {
      key: template.id,
      title: (_template$type = template.type) !== null && _template$type !== void 0 ? _template$type : getComponentLabelFromTemplate(template, editorContext),
      description: template.label,
      onClick: function onClick() {
        close(template);
      },
      image: template.previewImage,
      custom: isTemplate(template) && !template.config._template.startsWith("$")
    });
  }));
};

var __jsx$g = React.createElement;

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$h(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ModalPicker = function ModalPicker(_ref) {
  var _config$componentType;

  var config = _ref.config,
      onClose = _ref.onClose;
  var editorContext = useEditorContext();
  var form = editorContext.form;
  var modal;
  var split = config.path.split("."); // TODO: right now only for collections

  var parentPath = split.slice(0, split.length - 1).join(".");
  var fieldName = split[split.length - 1];
  var parentData = dotNotationGet(form.values, parentPath);
  var schemaProp = findComponentDefinition(parentData, editorContext).schema.find(function (x) {
    return x.prop === fieldName;
  });

  if (!schemaProp && parentData._template === richTextPartEditableComponent.id) {
    if (fieldName === "$action") {
      schemaProp = richTextInlineWrapperActionSchemaProp;
    }

    if (fieldName === "$textModifier") {
      schemaProp = optionalTextModifierSchemaProp;
    }
  }

  var componentTypes = (_config$componentType = config.componentTypes) !== null && _config$componentType !== void 0 ? _config$componentType : schemaProp.componentTypes;
  var defaultPickerMode = componentTypes.includes("section") || componentTypes.includes("card") ? "big" : "small";
  var pickerMode = schemaProp.picker || defaultPickerMode;

  var close = function close(config) {
    var _itemProps = _defineProperty$g({}, parentData._template, _defineProperty$g({}, fieldName, {}));

    var newComponent = fieldName.startsWith("$") ? config : duplicateConfig(normalize(_objectSpread$h(_objectSpread$h({}, config), {}, {
      _itemProps: _itemProps
    }), editorContext), editorContext);
    onClose(newComponent);
  };

  var onModalClose = function onModalClose(template) {
    if (template) {
      if (isSpecialTemplate(template)) {
        editorContext.actions.openComponentPicker({
          path: config.path,
          componentTypes: ["card"]
        }).then(function (config) {
          if (config) {
            close(normalize(config, editorContext));
          } else {
            onClose();
          }
        });
      } else {
        close(normalize(template.config, editorContext));
      }
    } else {
      onClose();
    }
  };

  if (pickerMode === "small") {
    modal = __jsx$g(SearchableSmallPickerModal, {
      isOpen: true,
      onClose: onModalClose,
      componentTypes: componentTypes
    });
  } else {
    modal = __jsx$g(SectionPickerModal, {
      isOpen: true,
      onSelect: onModalClose,
      onClose: onClose,
      componentTypes: componentTypes
    });
  }

  return modal;
};

function getDefaultConfig(mode) {
  if (mode === "grid") {
    var rootGridConfig = {
      _id: uniqueId(),
      _template: "$RootGrid",
      data: [{
        _template: "$Grid",
        containerMargin: {
          ref: "grid.containerMargin"
        },
        Component: [{
          _template: "$GridCard",
          numberOfItems: {
            ref: "grid"
          },
          columnGap: {
            ref: "grid.horizontalGap"
          },
          rowGap: {
            ref: "grid.verticalGap"
          },
          Cards: []
        }]
      }]
    };
    return rootGridConfig;
  }

  return {
    _id: uniqueId(),
    _template: "$RootSections",
    data: []
  };
}

var ExtraKeys;

(function (ExtraKeys) {
  ExtraKeys["ALT_KEY"] = "altKey";
  ExtraKeys["CTRL_KEY"] = "ctrlKey";
  ExtraKeys["META_KEY"] = "metaKey";
  ExtraKeys["SHIFT_KEY"] = "shiftKey";
})(ExtraKeys || (ExtraKeys = {}));

var actionKeys = [ExtraKeys.ALT_KEY, ExtraKeys.CTRL_KEY, ExtraKeys.META_KEY, ExtraKeys.SHIFT_KEY];
var useWindowKeyDown = function useWindowKeyDown(key, callback) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    extraKeys: [],
    isDisabled: false
  },
      extraKeys = _ref.extraKeys,
      isDisabled = _ref.isDisabled;

  var downHandler = function downHandler(event) {
    var isExtraKeysPressed = extraKeys.every(function (k) {
      return event[k];
    });
    var extraKeysSet = new Set(_toConsumableArray$2(extraKeys));
    var isOtherExtraKeysPressed = actionKeys.filter(function (k) {
      return !extraKeysSet.has(k);
    }).some(function (k) {
      return event[k];
    });

    if (event.key === key && isExtraKeysPressed && !isOtherExtraKeysPressed) {
      event.preventDefault();
      callback();
    }
  };

  react.exports.useEffect(function () {
    if (!isDisabled) {
      document.getElementsByTagName("iframe")[0].contentWindow.window.document.body.addEventListener("keydown", downHandler);
      window.addEventListener("keydown", downHandler);
      return function () {
        window.removeEventListener("keydown", downHandler);
      };
    }
  }, [isDisabled]);
};

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$g(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var EditorHistoryAction;

(function (EditorHistoryAction) {
  EditorHistoryAction["PUSH"] = "PUSH";
  EditorHistoryAction["REPLACE"] = "REPLACE";
  EditorHistoryAction["NONE"] = "NONE";
})(EditorHistoryAction || (EditorHistoryAction = {}));

var HISTORY_SIZE = 50;

var EditorHistory = /*#__PURE__*/function () {
  function EditorHistory() {
    _classCallCheck$d(this, EditorHistory);

    _defineProperty$g(this, "values", void 0);

    _defineProperty$g(this, "currentIndex", void 0);

    this.values = [];
    this.currentIndex = -1;
  }

  _createClass$b(EditorHistory, [{
    key: "push",
    value: function push(value) {
      var isCurrentIndexLastEntry = this.values.length - 1 === this.currentIndex; // If we push to history while `currentIndex` is not set on latest history entry
      // our history would me messed up. We need to rewrite our history by removing all
      // entries after the current index.

      if (!isCurrentIndexLastEntry) {
        this.values.splice(this.currentIndex + 1, this.values.length - 1 - this.currentIndex);
      }

      var isAboutToReachSizeLimit = this.values.length + 1 > HISTORY_SIZE;

      if (isAboutToReachSizeLimit) {
        this.values.shift();
      }

      this.values.push(value);
      this.currentIndex = this.values.length - 1;
    }
  }, {
    key: "replace",
    value: function replace(value) {
      this.values[this.currentIndex] = value;
    }
  }, {
    key: "replaceAt",
    value: function replaceAt(oldValue, newValue) {
      var entryIndex = this.values.findIndex(function (value) {
        return value.config === oldValue.config;
      });

      if (entryIndex !== -1) {
        this.values[entryIndex] = newValue;
      }
    }
  }, {
    key: "forward",
    value: function forward() {
      if (!this.canGoForward()) {
        this.currentIndex = this.values.length - 1;
        return null;
      }

      var currentEntry = this.values[this.currentIndex];

      while (this.canGoForward()) {
        this.currentIndex += 1;
        var nextEntry = this.values[this.currentIndex];

        if (!deepCompare(nextEntry.config, currentEntry.config)) {
          return nextEntry;
        }
      }

      return null;
    }
  }, {
    key: "back",
    value: function back() {
      if (!this.canGoBack()) {
        return null;
      }

      var currentEntry = this.values[this.currentIndex];

      while (this.canGoBack()) {
        this.currentIndex -= 1;
        var previousEntry = this.values[this.currentIndex];

        if (!deepCompare(previousEntry.config, currentEntry.config)) {
          return previousEntry;
        }
      }

      return null;
    }
  }, {
    key: "getEntries",
    value: function getEntries() {
      return this.values.map(function (value) {
        return _objectSpread$g({}, value);
      });
    }
  }, {
    key: "canGoForward",
    value: function canGoForward() {
      return this.currentIndex < this.values.length - 1;
    }
  }, {
    key: "canGoBack",
    value: function canGoBack() {
      return this.currentIndex > 0;
    }
  }]);

  return EditorHistory;
}();

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$f(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function useEditorHistory(_ref) {
  var onChange = _ref.onChange;
  var editorHistory = react.exports.useRef(new EditorHistory()).current;

  function undo() {
    ReactDOM.unstable_batchedUpdates(function () {
      var entry = editorHistory.back();

      if (entry === null) {
        return;
      }

      var focussedField = entry.focussedField,
          rest = _objectWithoutProperties$2(entry, ["focussedField"]);

      onChange(_objectSpread$f(_objectSpread$f({
        focusedField: focussedField
      }, rest), {}, {
        type: "undo"
      }));
    });
  }

  function redo() {
    ReactDOM.unstable_batchedUpdates(function () {
      var entry = editorHistory.forward();

      if (!entry) {
        return null;
      }

      var focussedField = entry.focussedField,
          rest = _objectWithoutProperties$2(entry, ["focussedField"]);

      onChange(_objectSpread$f(_objectSpread$f({
        focusedField: focussedField
      }, rest), {}, {
        type: "redo"
      }));
    });
  }

  function push(entry) {
    editorHistory.push(entry);
  }

  return {
    push: push,
    redo: redo,
    undo: undo,
    editorHistoryInstance: editorHistory
  };
}

var takeNumbers = function takeNumbers(path) {
  return path.split(".").map(function (x) {
    return parseInt(x, 10);
  }).filter(function (x) {
    return !Number.isNaN(x);
  });
};

var preOrderPathComparator = function preOrderPathComparator() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ascending";
  return function (pathA, pathB) {
    var order = direction === "ascending" ? 1 : -1;
    var numbersA = takeNumbers(pathA);
    var numbersB = takeNumbers(pathB);
    var numberALength = numbersA.length;
    var numberBLength = numbersB.length;

    if (numberALength === 0 || numberBLength === 0) {
      throw new Error("Cannot compare paths '".concat(pathA, "' and '").concat(pathB, "'."));
    }

    var shorterLength = Math.min(numberALength, numberBLength);
    var index = 0;

    while (index < shorterLength) {
      var valueA = numbersA[index];
      var valueB = numbersB[index];

      if (valueA !== valueB) {
        return order * Math.sign(valueA - valueB);
      }

      index++;
    }

    return order * Math.sign(numberBLength - numberALength);
  };
};

var GLOBAL_SHORTCUTS_KEYS = ["Delete", "Backspace", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "l", "L"];
var DATA_TRANSFER_FORMAT = "text/x-shopstory";

function useEditorGlobalKeyboardShortcuts(editorContext) {
  react.exports.useEffect(function () {
    var focusedFields = editorContext.focussedField,
        actions = editorContext.actions;

    function handleKeydown(event) {
      if (isTargetInputElement(event.target)) {
        return;
      }

      if (!isGlobalShortcut(event) || !isAnyFieldSelected(focusedFields)) {
        return;
      }

      if (event.key === "Delete" || event.key === "Backspace") {
        actions.removeItems(focusedFields);
      } else if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
        actions.moveItems(focusedFields, "top");
      } else if (event.key === "ArrowDown" || event.key === "ArrowRight") {
        actions.moveItems(focusedFields, "bottom");
      } else if (event.key.toUpperCase() === "L") {
        actions.logSelectedItems();
      }
    }

    function handleCopy(event) {
      var _event$clipboardData;

      if (!canHandleCopyPaste(focusedFields, event)) {
        return;
      }

      var configs = getConfigsToCopy(focusedFields, editorContext);
      event.preventDefault();
      (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.setData(DATA_TRANSFER_FORMAT, JSON.stringify(configs));
    }

    function handleCut(event) {
      var _event$clipboardData2;

      if (!canHandleCopyPaste(focusedFields, event)) {
        return;
      }

      var configs = getConfigsToCopy(focusedFields, editorContext);
      event.preventDefault();
      (_event$clipboardData2 = event.clipboardData) === null || _event$clipboardData2 === void 0 ? void 0 : _event$clipboardData2.setData(DATA_TRANSFER_FORMAT, JSON.stringify(configs));
      actions.removeItems(focusedFields);
    }

    function handlePaste(event) {
      var _event$clipboardData3;

      if (!canHandleCopyPaste(focusedFields, event)) {
        return;
      }

      var rawData = (_event$clipboardData3 = event.clipboardData) === null || _event$clipboardData3 === void 0 ? void 0 : _event$clipboardData3.getData(DATA_TRANSFER_FORMAT);

      if (!rawData || rawData === "") {
        return;
      }

      try {
        var parsedData = JSON.parse(rawData);
        var data = Array.isArray(parsedData) ? parsedData : [parsedData];
        actions.pasteItems(data);
        event.preventDefault();
      } catch (e) {
        console.error(e);
        return;
      }
    }

    window.document.addEventListener("keydown", handleKeydown);
    window.document.addEventListener("copy", handleCopy);
    window.document.addEventListener("cut", handleCut);
    window.document.addEventListener("paste", handlePaste);
    return function () {
      window.document.removeEventListener("keydown", handleKeydown);
      window.document.removeEventListener("copy", handleCopy);
      window.document.removeEventListener("cut", handleCut);
      window.document.removeEventListener("paste", handlePaste);
    };
  });
}

function isTargetInputElement(target) {
  return isTargetHtmlElement(target) && (["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName) || target.tagName === "DIV" && target.getAttribute("role") === "textbox");
}

function isTargetHtmlElement(element) {
  return element !== null;
}

function getConfigsToCopy(paths, editorContext) {
  var sortedPaths = _toConsumableArray$2(paths).sort(preOrderPathComparator("ascending"));

  return sortedPaths.map(function (path) {
    var config = dotNotationGet(editorContext.form.values, path);
    return duplicateConfig(config, editorContext);
  });
}

function canHandleCopyPaste(focusedFields, event) {
  var notInsideInputElement = !(isTargetInputElement(event.target) || isTargetInputElement(document.activeElement));
  var insideEditorIFrame = window.frameElement;
  var focusedFieldsSelected = isAnyFieldSelected(focusedFields);
  return notInsideInputElement && insideEditorIFrame && focusedFieldsSelected;
}

function isGlobalShortcut(event) {
  return GLOBAL_SHORTCUTS_KEYS.includes(event.key);
} // FIXME: This is my mistake, because I was lazy at the beginning and it was easier for me to introduce changes
// by assuming that non empty array with empty string means no fields selected.
// IMO this is stupid and can lead to confusion.


function isAnyFieldSelected(focusedFields) {
  return focusedFields.length > 0 && focusedFields[0] !== "";
}

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$e(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function getAllExternals(config, context) {
  var result = [];
  configTraverse(config, context, function (_ref) {
    var schemaProp = _ref.schemaProp,
        path = _ref.path,
        value = _ref.value;

    if (isResourceSchemaProp(schemaProp)) {
      if (isTrulyResponsiveValue(value)) {
        for (var key in value) {
          if (key === "$res") {
            continue;
          }

          if (!value[key].id) {
            continue;
          }

          result.push({
            type: getResourceType(schemaProp, context),
            value: _objectSpread$e({}, value[key]),
            path: path + "." + key
          });
        }
      } else {
        result.push({
          type: getResourceType(schemaProp, context),
          value: _objectSpread$e({}, value),
          path: path
        });
      }
    }
  });
  return result;
}

function getExternalsForSave(configToSave, compilationContext) {
  var externalReferences = [];
  getAllExternals(configToSave, compilationContext).forEach(function (external) {
    if (!external.value.id) {
      return;
    }

    var newExternalReference; // We don't treat local. as external references

    if (external.value.id.startsWith("local.")) {
      return;
    }

    if (external.type === "image") {
      newExternalReference = {
        type: compilationContext.image.resourceType,
        id: external.value.id
      };
    } else if (external.type === "video") {
      newExternalReference = {
        type: compilationContext.image.resourceType,
        id: external.value.id
      };
    } else {
      newExternalReference = {
        type: external.type,
        id: external.value.id
      };
    } // We don't want duplicates


    if (externalReferences.some(function (x) {
      return x.id === newExternalReference.id && x.type === newExternalReference.type;
    })) {
      return;
    }

    externalReferences.push(newExternalReference);
  });
  return externalReferences;
}

// Outputs comparable config that is FULL COPY of config
function getConfigSnapshot(config) {
  var strippedConfig = JSON.parse(JSON.stringify(config));
  delete strippedConfig["_variants"];
  return strippedConfig;
}

function useForceRerender() {
  var _useState = react.exports.useState({}),
      setDummyState = _useState[1];

  var forceRerender = react.exports.useRef(function () {
    setDummyState({});
  }).current;
  return {
    forceRerender: forceRerender
  };
}

function useRemoteChangesTracker(_ref) {
  var inputConfig = _ref.inputConfig,
      onRemoteChanged = _ref.onLocalChangesOverwritten,
      context = _ref.context;
  var remoteConfigRef = react.exports.useRef(getConfigSnapshot(inputConfig));

  var _useForceRerender = useForceRerender(),
      forceRerender = _useForceRerender.forceRerender;

  var hasLocalChanges = react.exports.useCallback(function () {
    var configSnapshot = getConfigSnapshot(context.form.values);
    var anyLocalChanges = JSON.stringify(configSnapshot) !== JSON.stringify(remoteConfigRef.current);
    return anyLocalChanges;
  }, []);
  react.exports.useEffect(function () {
    var localConfig = getConfigSnapshot(inputConfig);

    if (JSON.stringify(remoteConfigRef.current) !== JSON.stringify(localConfig)) {
      if (hasLocalChanges()) {
        onRemoteChanged();
      }

      remoteConfigRef.current = localConfig;
      context.actions.runChange(function () {
        context.form.change("", inputConfig);
        return [];
      });
      forceRerender();
    }
  }, [inputConfig]);

  var updateRemote = function updateRemote(config) {
    remoteConfigRef.current = config;
    forceRerender();
  };

  return {
    updateRemote: updateRemote,
    remoteConfig: remoteConfigRef.current,
    hasLocalChanges: hasLocalChanges
  };
}

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$d(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function addLocalizedFlag(config, context) {
  return configMap(config, context, function (_ref) {
    var value = _ref.value,
        schemaProp = _ref.schemaProp;

    if (schemaProp.type === "text" && value.id.startsWith("local.") || schemaProp.type === "component-collection-localised") {
      return _objectSpread$d({
        __localized: true
      }, value);
    }

    return value;
  });
}

var createClient = function createClient(url, accessToken) {
  var HEADERS = {
    "content-type": "application/json",
    "x-shopstory-access-token": accessToken
  };
  return {
    call: function call(name, body) {
      return _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee() {
        var response, data;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch("".concat(url, "/api/").concat(name), {
                  method: "POST",
                  headers: HEADERS,
                  body: body
                });

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.json();

              case 6:
                data = _context.sent;

                if (!("error" in data)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", {
                  data: null,
                  error: data.error
                });

              case 9:
                return _context.abrupt("return", {
                  data: data,
                  error: null
                });

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", {
                  data: null,
                  error: _context.t0
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      }))();
    }
  };
};

var _httpsShopstoryAp;
var configuration = {
  url: (_httpsShopstoryAp = "https://shopstory-api.vercel.app") !== null && _httpsShopstoryAp !== void 0 ? _httpsShopstoryAp : ""
};

function createApiStorage(_ref) {
  var _ref$accessToken = _ref.accessToken,
      accessToken = _ref$accessToken === void 0 ? "" : _ref$accessToken;
  var apiClient = createClient(configuration.url, accessToken);

  var getConfig = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee(input) {
      var _ref3;

      var body, _yield$apiClient$call, data, error;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(Array.isArray(input) && input.length === 0 || !input)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", null);

            case 2:
              body = JSON.stringify(input);
              _context.next = 5;
              return apiClient.call("get-config", body);

            case 5:
              _yield$apiClient$call = _context.sent;
              data = _yield$apiClient$call.data;
              error = _yield$apiClient$call.error;

              if (!error) {
                _context.next = 10;
                break;
              }

              throw new Error("[API -> getConfig] (configuration:".concat(JSON.stringify(configuration), ", body:").concat(body, ") : ").concat(error.message));

            case 10:
              if (!(data === null)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", null);

            case 12:
              return _context.abrupt("return", (_ref3 = data) !== null && _ref3 !== void 0 ? _ref3 : null);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getConfig(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getConfigForLocale = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2(id, locale) {
      var _ref6;

      var body, _yield$apiClient$call2, data, error;

      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(Array.isArray(id) && id.length === 0 || !id)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", null);

            case 2:
              body = JSON.stringify({
                id: Array.isArray(id) ? id.map(function (_ref5) {
                  var id = _ref5.id;
                  return id;
                }) : [id.id],
                locale: locale
              });
              _context2.next = 5;
              return apiClient.call("get-config-localized", body);

            case 5:
              _yield$apiClient$call2 = _context2.sent;
              data = _yield$apiClient$call2.data;
              error = _yield$apiClient$call2.error;

              if (!error) {
                _context2.next = 10;
                break;
              }

              throw new Error("[API -> getConfig] (configuration:".concat(JSON.stringify(configuration), ", body:").concat(body, ") : ").concat(error.message));

            case 10:
              if (!(data === null)) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", null);

            case 12:
              return _context2.abrupt("return", (_ref6 = data) !== null && _ref6 !== void 0 ? _ref6 : null);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getConfigForLocale(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  return {
    getConfig: getConfig,
    getConfigForLocale: getConfigForLocale,
    saveConfig: function saveConfig(config) {
      return _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee3() {
        var _yield$apiClient$call3, data, error;

        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return apiClient.call("save-config", JSON.stringify(config));

              case 2:
                _yield$apiClient$call3 = _context3.sent;
                data = _yield$apiClient$call3.data;
                error = _yield$apiClient$call3.error;

                if (!error) {
                  _context3.next = 7;
                  break;
                }

                throw new Error("[API -> saveConfig]: ".concat(error.message));

              case 7:
                if (!(data === null)) {
                  _context3.next = 9;
                  break;
                }

                throw new Error("[API -> saveConfig]: Save config failed");

              case 9:
                return _context3.abrupt("return", {
                  id: data.id
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  };
}

var __jsx$f = React.createElement;
var StorageContext = /*#__PURE__*/React.createContext({
  getConfig: function () {
    var _getConfig = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(null));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getConfig() {
      return _getConfig.apply(this, arguments);
    }

    return getConfig;
  }(),
  getConfigForLocale: function () {
    var _getConfigForLocale = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Promise.resolve(null));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function getConfigForLocale() {
      return _getConfigForLocale.apply(this, arguments);
    }

    return getConfigForLocale;
  }(),
  saveConfig: function () {
    var _saveConfig = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", Promise.resolve({
                id: ""
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function saveConfig() {
      return _saveConfig.apply(this, arguments);
    }

    return saveConfig;
  }()
});

function useStorage() {
  return react.exports.useContext(StorageContext);
}

function StorageProvider(_ref) {
  var children = _ref.children,
      accessToken = _ref.accessToken;
  var storage = react.exports.useRef(createApiStorage({
    accessToken: accessToken
  })).current;
  return __jsx$f(StorageContext.Provider, {
    value: storage
  }, children);
}

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$c(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * RULES OF DATA SAVER
 * --
 * 1. Newly added items (not yet saved) must have ids starting with "local."
 * 2. The order of save operation is always "create/update texts", "save config", "remove unnecessary items"
 * 3. If there's ANYTHING wrong with create/update texts, config is not saved and the save/update operations are ignored.
 * 4. If there's ANYTHING wrong with remove, we ignore it.
 *
 */

function syncAddedAndModified(_x, _x2, _x3) {
  return _syncAddedAndModified.apply(this, arguments);
}

function _syncAddedAndModified() {
  _syncAddedAndModified = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee3(previousConfig, newConfig, editorContext) {
    var _editorContext$text;

    var _ref3, create, update, previousTextExternals, currentTextExternals, stagedForAdd, stagedForUpdate, addResults, updateResults, isValid, results;

    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // If text CRUD not there then this function does nothing.
            _ref3 = (_editorContext$text = editorContext === null || editorContext === void 0 ? void 0 : editorContext.text) !== null && _editorContext$text !== void 0 ? _editorContext$text : {}, create = _ref3.create, update = _ref3.update;

            if (!(!create || !update)) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", Promise.resolve({}));

          case 3:
            previousTextExternals = getAllExternals(previousConfig, editorContext).filter(function (x) {
              return x.type === "text";
            });
            currentTextExternals = getAllExternals(newConfig, editorContext).filter(function (x) {
              return x.type === "text";
            });
            stagedForAdd = [];
            stagedForUpdate = [];
            currentTextExternals.forEach(function (currentTextExternal) {
              var currentExternal = currentTextExternal.value; // value is always non-empty for a string
              // If newly added

              if (currentExternal.id.startsWith("local.")) {
                stagedForAdd.push({
                  id: currentTextExternal.value.id,
                  value: currentExternal.value // never undefined

                });
              } else {
                var previousTextExternal = previousTextExternals.find(function (x) {
                  return x.value.id === currentTextExternal.value.id;
                });

                if (!previousTextExternal) {
                  throw new Error("unreachable");
                }

                var previousExternal = previousTextExternal.value; // was changed!

                if (currentExternal.value !== previousExternal.value) {
                  stagedForUpdate.push({
                    id: currentExternal.id,
                    value: currentExternal.value // never undefined

                  });
                }
              }
            });

            if (!(stagedForAdd.length === 0 && stagedForUpdate.length === 0)) {
              _context3.next = 10;
              break;
            }

            return _context3.abrupt("return", {});

          case 10:
            if (!(stagedForAdd.length === 0)) {
              _context3.next = 14;
              break;
            }

            _context3.t0 = {};
            _context3.next = 17;
            break;

          case 14:
            _context3.next = 16;
            return create(stagedForAdd, editorContext.contextParams);

          case 16:
            _context3.t0 = _context3.sent;

          case 17:
            addResults = _context3.t0;

            if (!(stagedForUpdate.length === 0)) {
              _context3.next = 22;
              break;
            }

            _context3.t1 = {};
            _context3.next = 25;
            break;

          case 22:
            _context3.next = 24;
            return update(stagedForUpdate, editorContext.contextParams);

          case 24:
            _context3.t1 = _context3.sent;

          case 25:
            updateResults = _context3.t1;

            /**
             * VALIDATION!!! All the ids that were requested must be in the response
             */
            isValid = true;
            stagedForAdd.forEach(function (entry) {
              var result = addResults[entry.id]; // Requested ID must be in the response object

              if (!result) {
                isValid = false;
              } // Response ID must be string and can't start with "local."
              else if (typeof result.id !== "string" || result.id.startsWith("local.")) {
                isValid = false;
              } // result.value = result.value?.toString() || null; // force string for value if defined

            });
            stagedForUpdate.forEach(function (entry) {
              var result = updateResults[entry.id];

              if (!result) {
                isValid = false;
              } else if (typeof result.id !== "string" || result.id.startsWith("local.")) {
                isValid = false;
              } // result.value = result.value?.toString() || null; // force string for value if defined

            });

            if (isValid) {
              _context3.next = 31;
              break;
            }

            throw new Error("incorrect data from update / create operations");

          case 31:
            results = _objectSpread$c(_objectSpread$c({}, addResults), updateResults);
            return _context3.abrupt("return", results);

          case 33:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _syncAddedAndModified.apply(this, arguments);
}

function syncRemove(_x4, _x5, _x6) {
  return _syncRemove.apply(this, arguments);
}

function _syncRemove() {
  _syncRemove = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee4(previousConfig, newConfig, editorContext) {
    var _editorContext$text2;

    var _ref4, remove, previousTextExternals, currentTextExternals, stagedForRemove;

    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ref4 = (_editorContext$text2 = editorContext === null || editorContext === void 0 ? void 0 : editorContext.text) !== null && _editorContext$text2 !== void 0 ? _editorContext$text2 : {}, remove = _ref4.remove; // If text CRUD not there then this function does nothing.

            if (remove) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return", Promise.resolve());

          case 3:
            previousTextExternals = getAllExternals(previousConfig, editorContext).filter(function (x) {
              return x.type === "text";
            });
            currentTextExternals = getAllExternals(newConfig, editorContext).filter(function (x) {
              return x.type === "text";
            });
            stagedForRemove = [];
            previousTextExternals.forEach(function (previousTextExternal) {
              // If can't find previous in new, it means it's removed;
              if (!currentTextExternals.find(function (x) {
                return x.value.id === previousTextExternal.value.id;
              })) {
                stagedForRemove.push(previousTextExternal.value.id);
              }
            });

            if (!(stagedForRemove.length === 0)) {
              _context4.next = 9;
              break;
            }

            return _context4.abrupt("return");

          case 9:
            _context4.next = 11;
            return remove(stagedForRemove);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _syncRemove.apply(this, arguments);
}

function updateConfigExternals(config, textExternalMap, editorContext) {
  return configMap(config, editorContext, function (_ref) {
    var value = _ref.value,
        schemaProp = _ref.schemaProp;

    if (schemaProp.type !== "text") {
      return value;
    }

    var mapEntry = textExternalMap[value.id];

    if (!mapEntry) {
      return value;
    }

    return {
      id: mapEntry.id // we take new id (potentially was changed from temporary to real)

    };
  });
}

// useDataSaver works in a realm of SINGLE CONFIG.
function useDataSaver(editorContext, inputConfig) {
  var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var storage = useStorage();
  var newId = react.exports.useRef(uuidv4());

  var _useRemoteChangesTrac = useRemoteChangesTracker({
    inputConfig: inputConfig,
    context: editorContext,
    onLocalChangesOverwritten: function onLocalChangesOverwritten() {
      editorContext.actions.notify("Remote changes detected, local changes have been overwritten.");
    }
  }),
      updateRemote = _useRemoteChangesTrac.updateRemote,
      remoteConfig = _useRemoteChangesTrac.remoteConfig,
      hasLocalChanges = _useRemoteChangesTrac.hasLocalChanges;

  var onTickRef = react.exports.useRef(function () {
    return Promise.resolve();
  });
  var isSavedCalledAtLeastOnce = react.exports.useRef(false);

  var onTick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee() {
      var config, configSnapshot, isConfigTheSame, externalsMap, configToSave, _externalReferences, configToSaveWithLocalisedFlag, _id, result, hash, configAfterSplit, localisedRawContent, newFormValues;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(newId.current === parentId)) {
                _context.next = 3;
                break;
              }

              console.warn("parentId cannot be equal newId");
              return _context.abrupt("return");

            case 3:
              config = editorContext.form.values;
              configSnapshot = getConfigSnapshot(config);
              isConfigTheSame = !hasLocalChanges(); //If config didn't change, let's ignore auto-save!

              if (!(isConfigTheSame && isSavedCalledAtLeastOnce.current)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              isSavedCalledAtLeastOnce.current = true;
              _context.prev = 9;
              _context.next = 12;
              return syncAddedAndModified(remoteConfig, config, editorContext);

            case 12:
              externalsMap = _context.sent;
              _context.next = 20;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](9);
              console.warn("Unsuccessful add / update operations, error below");
              console.warn(_context.t0); // if sync unsuccessful, we do nothing.

              return _context.abrupt("return");

            case 20:
              if (!(Object.keys(externalsMap).length === 0 && isConfigTheSame)) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return");

            case 22:
              configToSave = updateConfigExternals(configSnapshot, externalsMap, editorContext);
              _context.prev = 23;
              _externalReferences = getExternalsForSave(configToSave, editorContext); // Adding __localized flag here but eventually we want to send compialtionContext to the
              // API and all the work related with localized text will be handled on the server

              configToSaveWithLocalisedFlag = addLocalizedFlag(configToSave, editorContext);

              if (!editorContext.isPlayground) {
                _context.next = 30;
                break;
              }

              _id = uuidv4();
              _context.next = 34;
              break;

            case 30:
              _context.next = 32;
              return storage.saveConfig({
                id: newId.current,
                parent_id: parentId,
                config: configToSaveWithLocalisedFlag
              });

            case 32:
              result = _context.sent;
              _id = result.id;

            case 34:
              hash = cryptoJs.exports.MD5(config).toString();
              configAfterSplit = dist$2.splitConfigIntoSingleLocaleConfigs(configToSaveWithLocalisedFlag, editorContext.locales);
              localisedRawContent = {};
              editorContext.locales.forEach(function (locale) {
                localisedRawContent[locale.code] = {
                  id: _id,
                  hash: hash,
                  content: configAfterSplit[locale.code]
                };
              });
              _context.next = 40;
              return editorContext.save(localisedRawContent, _externalReferences);

            case 40:
              // Only after successful save operation we can update previousSavedConfig. Otherwise it should stay the same as it was before.
              updateRemote(configToSave);

              if (Object.keys(externalsMap).length > 0) {
                newFormValues = updateConfigExternals(editorContext.form.values, externalsMap, editorContext);
                editorContext.form.change("", newFormValues);
              }

              _context.next = 44;
              return syncRemove(remoteConfig, configSnapshot, editorContext);

            case 44:
              _context.next = 50;
              break;

            case 46:
              _context.prev = 46;
              _context.t1 = _context["catch"](23);
              console.log(_context.t1); // We can safely ignore this. The worst case scenario is that there will be "zombie text nodes" in Contentful

              console.warn("Error while saving config or removing items");

            case 50:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 15], [23, 46]]);
    }));

    return function onTick() {
      return _ref2.apply(this, arguments);
    };
  }(); // We're keeping this in ref, because of setInterval keeping initial closure


  onTickRef.current = onTick;
  var inProgress = react.exports.useRef(false);
  var wasSaveNowCalled = react.exports.useRef(false);
  react.exports.useEffect(function () {
    var interval = setInterval(function () {
      // We ignore ticks when previous requests are in progress
      if (inProgress.current || wasSaveNowCalled.current) {
        return;
      }

      inProgress.current = true;
      onTickRef.current()["finally"](function () {
        inProgress.current = false;
      });
    }, 5000);
    return function () {
      clearInterval(interval);
    };
  }, []);
  return {
    saveNow: function () {
      var _saveNow = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                wasSaveNowCalled.current = true; // Wait until inProgress is false

              case 1:

                if (!inProgress.current) {
                  _context2.next = 8;
                  break;
                }

                console.debug("waiting...");
                _context2.next = 6;
                return sleep(500);

              case 6:
                _context2.next = 9;
                break;

              case 8:
                return _context2.abrupt("break", 11);

              case 9:
                _context2.next = 1;
                break;

              case 11:
                console.debug("Last save!");
                _context2.next = 14;
                return onTick();

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function saveNow() {
        return _saveNow.apply(this, arguments);
      }

      return saveNow;
    }()
  };
}

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$b(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function changeComponentConfig(previousConfig, newConfig, editorContext) {
  var previousComponentDefinition = findComponentDefinition(previousConfig, editorContext);
  var newComponentDefinition = findComponentDefinition(newConfig, editorContext);
  newConfig = _objectSpread$b(_objectSpread$b({}, newConfig), {}, {
    _itemProps: previousConfig === null || previousConfig === void 0 ? void 0 : previousConfig._itemProps
  });
  var isPreviousButton = previousComponentDefinition.tags.includes("button");
  var isNewButton = newComponentDefinition.tags.includes("button");

  if (isPreviousButton && isNewButton) {
    !newConfig._template.startsWith("$");
    var isNewIconButton = newConfig._template === "$IconButton";
    var previousSymbol = previousConfig.symbol[0];
    var defaultIcon = getTemplates(["symbol"], editorContext).filter(isTemplate).find(function (x) {
      return x.config._template === "$icon";
    });
    var symbol = undefined;

    if (previousSymbol) {
      symbol = _objectSpread$b({}, previousSymbol);
    } else {
      if (isNewIconButton) {
        symbol = defaultIcon.config;
      }
    }

    return _objectSpread$b(_objectSpread$b({}, newConfig), {}, {
      symbol: symbol ? [symbol] : [],
      label: _objectSpread$b({}, previousConfig.label)
    });
  }

  return newConfig;
}

function duplicateItem(form, _ref, compilationContext) {
  var name = _ref.name,
      sourceIndex = _ref.sourceIndex,
      targetIndex = _ref.targetIndex;

  // Placeholders are not copyable
  if (isPlaceholder(name + "." + sourceIndex, form.values)) {
    return;
  }

  var configToDuplicate = dotNotationGet(form.values, name + "." + sourceIndex);
  form.mutators.insert(name, targetIndex, duplicateConfig(configToDuplicate, compilationContext));
}

function pasteItems(_ref2) {
  var what = _ref2.what,
      where = _ref2.where,
      resolveDestination = _ref2.resolveDestination,
      pasteCommand = _ref2.pasteCommand;
  var successfulInsertsPaths = [];
  takeLastOfEachParent(where).sort(preOrderPathComparator()).map(function (initialDestination) {
    var destination = successfulInsertsPaths.reduce(function (acc, current) {
      return shiftPath(acc, current, "downward");
    }, initialDestination);
    var resolvedDestinations = resolveDestination(destination);
    return pasteCommand(resolvedDestinations);
  }).forEach(function (paste) {
    what.forEach(function (item) {
      var insertedPath = paste(item);

      if (insertedPath) {
        successfulInsertsPaths.push(insertedPath);
      }
    });
  });
  return successfulInsertsPaths.length !== 0 ? successfulInsertsPaths : where;
}
/**
 * Duplicates fields given in `fieldNames` within given `form`.
 * `compilationContext` is used to properly duplicate elements associated with given names.
 * @returns Array of fields to focus
 */


function duplicateItems(form, fieldNames, compilationContext) {
  var duplicatableFieldNames = fieldNames.filter(function (fieldName) {
    return isFieldDuplicatable(fieldName, form, compilationContext);
  });

  if (duplicatableFieldNames.length === 0) {
    return;
  }

  var fieldsGroupedByParentPath = groupFieldsByParentPath(duplicatableFieldNames, "ascending");
  var nextFocusedFieldsPerGroup = [];
  Object.values(fieldsGroupedByParentPath).forEach(function (sortedFields, fieldsGroupIndex) {
    nextFocusedFieldsPerGroup.push([]);
    var lastFieldIndex = getFieldPathIndex(last(sortedFields));
    sortedFields.forEach(function (focusedField, fieldIndex) {
      var sourceIndex = getFieldPathIndex(focusedField);
      var targetIndex = lastFieldIndex + 1 + fieldIndex;
      var parentPath = getParentPath(focusedField);
      duplicateItem(form, {
        name: parentPath,
        sourceIndex: sourceIndex,
        targetIndex: targetIndex
      }, compilationContext);
      nextFocusedFieldsPerGroup[fieldsGroupIndex].push("".concat(parentPath, ".").concat(lastFieldIndex + 1 + fieldIndex));
    });
  });
  return nextFocusedFieldsPerGroup.flat();
}

function moveItem(form, _ref3) {
  var from = _ref3.from,
      to = _ref3.to,
      name = _ref3.name;

  // Placeholders are not movable
  if (isPlaceholder(name + "." + from, form.values)) {
    return;
  }

  form.mutators.move(name, from, to);
}
/**
 * Moves fields given in `fieldNamesToRemove` within given `form` in given `direction`.
 * @returns Array of fields to focus.
 */


function moveItems(form, fieldsToMove, direction) {
  var nextFocusedFields = [];
  var isMovingMultipleFields = fieldsToMove.length > 1;

  if (direction === "top" || direction === "left") {
    var fieldsGroupedByParentPath = groupFieldsByParentPath(fieldsToMove, "ascending");
    Object.values(fieldsGroupedByParentPath).forEach(function (sortedFields) {
      var wasAnyFieldWithinCurrentGroupMoved = false;
      sortedFields.forEach(function (fieldName, fieldNameIndex) {
        var index = getFieldPathIndex(fieldName);
        var parentPath = getParentPath(fieldName);

        if (isFirst(fieldName)) {
          if (isMovingMultipleFields) {
            nextFocusedFields.push(fieldName);
          }

          return;
        }

        if (isMovingMultipleFields && fieldNameIndex > 0 && !wasAnyFieldWithinCurrentGroupMoved) {
          nextFocusedFields.push(fieldName);
          return;
        }

        moveItem(form, {
          from: index,
          name: parentPath,
          to: index - 1
        });

        if (!wasAnyFieldWithinCurrentGroupMoved) {
          wasAnyFieldWithinCurrentGroupMoved = true;
        }

        nextFocusedFields.push("".concat(parentPath, ".").concat(index - 1));
      });
    });

    if (nextFocusedFields.length > 0) {
      return nextFocusedFields;
    }
  } else {
    var _fieldsGroupedByParentPath = groupFieldsByParentPath(fieldsToMove, "descending");

    Object.values(_fieldsGroupedByParentPath).forEach(function (sortedFields) {
      var wasAnyFieldWithinCurrentGroupMoved = false;
      sortedFields.forEach(function (fieldName, fieldNameIndex) {
        if (isLast(fieldName, form)) {
          if (isMovingMultipleFields) {
            nextFocusedFields.push(fieldName);
          }

          return;
        }

        if (isMovingMultipleFields && fieldNameIndex > 0 && !wasAnyFieldWithinCurrentGroupMoved) {
          nextFocusedFields.push(fieldName);
          return;
        }

        var index = getFieldPathIndex(fieldName);
        var parentPath = getParentPath(fieldName);
        moveItem(form, {
          name: parentPath,
          from: index,
          to: index + 1
        });

        if (!wasAnyFieldWithinCurrentGroupMoved) {
          wasAnyFieldWithinCurrentGroupMoved = true;
        }

        nextFocusedFields.push("".concat(parentPath, ".").concat(index + 1));
      });
    });

    if (nextFocusedFields.length > 0) {
      return nextFocusedFields;
    }
  }
}

function removeItem(form, _ref4) {
  var index = _ref4.index,
      name = _ref4.name;
  var configPathToRemove = name + "." + index; // Placeholders are not removable

  if (isPlaceholder(configPathToRemove, form.values)) {
    return;
  }

  var componentConfigValue = dotNotationGet(form.values, name);

  if (componentConfigValue.length === 1) {
    form.change(name, []);
  } else {
    form.mutators.remove(name, index);
  }
}
/**
 * Removes fields given in `fieldNamesToRemove` from given `form`.
 * @returns Array of fields to focus
 */


function removeItems(form, fieldNamesToRemove, compilationContext) {
  var removableFieldNames = fieldNamesToRemove.filter(function (fieldName) {
    return isFieldRemovable(fieldName, form, compilationContext);
  });

  if (removableFieldNames.length === 0) {
    return;
  }

  var isRemovingMultipleFields = removableFieldNames.length > 1;
  var fieldsGroupedByParentPath = groupFieldsByParentPath(removableFieldNames, "descending");

  if (!isRemovingMultipleFields) {
    var index = getFieldPathIndex(removableFieldNames[0]);
    var parentPath = getParentPath(removableFieldNames[0]);
    var itemsLength = dotNotationGet(form.values, parentPath).length;
    var isOnlyItem = itemsLength === 1;
    var isLastItem = itemsLength - 1 === index;
    removeItem(form, {
      index: index,
      name: parentPath
    });

    if (isOnlyItem) {
      return [];
    } else if (isLastItem) {
      return ["".concat(parentPath, ".").concat(index - 1)];
    } else {
      return ["".concat(parentPath, ".").concat(index)];
    }
  }

  Object.values(fieldsGroupedByParentPath).forEach(function (sortedFields) {
    sortedFields.forEach(function (focusedField) {
      var field = dotNotationGet(form.values, focusedField); // Field could be already removed if its parent element was also selected

      if (!field) {
        return;
      }

      var index = getFieldPathIndex(focusedField);
      var parentPath = getParentPath(focusedField);
      removeItem(form, {
        index: index,
        name: parentPath
      });
    });
  });
  return [];
}

function replaceItems(paths, newConfig, editorContext) {
  paths.forEach(function (path) {
    var oldConfig = dotNotationGet(editorContext.form.values, path);
    editorContext.form.change(path, duplicateConfig(newConfig && oldConfig ? changeComponentConfig(oldConfig, newConfig, editorContext) : newConfig, editorContext));
  });
}

function logItems(form, configPaths) {
  var configValues = configPaths.map(function (configPath) {
    return dotNotationGet(form.values, configPath);
  });
  configValues.forEach(function (config, index) {
    console.log("Config for", configPaths[index], config);
  });
}

function groupFieldsByParentPath(fields, sortDirection) {
  var fieldsIndicesGroupedByParentPath = fields.reduce(function (accumulator, currentField) {
    var index = getFieldPathIndex(currentField);
    var parentPath = getParentPath(currentField);
    var indices = accumulator[parentPath];

    if (indices) {
      accumulator[parentPath] = [].concat(_toConsumableArray$2(indices), [index]).sort(function (a, b) {
        return sortDirection === "descending" ? b - a : a - b;
      });
      return accumulator;
    }

    accumulator[parentPath] = [index];
    return accumulator;
  }, {});
  return Object.fromEntries(Object.entries(fieldsIndicesGroupedByParentPath).map(function (_ref5) {
    var _ref6 = _slicedToArray$2(_ref5, 2),
        parentPath = _ref6[0],
        indices = _ref6[1];

    return [parentPath, indices.map(function (index) {
      return parentPath + "." + index;
    })];
  }));
}

function getFieldPathIndex(fieldPath) {
  var index = +last(fieldPath.split("."));

  if (Number.isNaN(index)) {
    return -1;
  }

  return index;
}

function getParentPath(fieldPath) {
  var fieldPathParts = fieldPath.split(".");
  return fieldPathParts.slice(0, -1).join(".");
}

function isFirst(fieldPath) {
  var index = getFieldPathIndex(fieldPath);
  return index === 0;
}

function isLast(fieldPath, form) {
  var index = getFieldPathIndex(fieldPath);
  var parentPath = getParentPath(fieldPath);
  var parentFieldElementsCount = dotNotationGet(form.values, parentPath).length;
  return index === parentFieldElementsCount - 1;
}

function isPlaceholder(path, values) {
  var templateId = dotNotationGet(values, path)._template;

  return templateId.startsWith("$Placeholder");
}

function isFieldRemovable(fieldName, form, compilationContext) {
  var _parsePath = parsePath(fieldName, form),
      parent = _parsePath.parent;

  if (parent) {
    var parentComponentDefinition = findComponentDefinitionById(parent.templateId, compilationContext);
    var fieldNameParent = last(getParentPath(fieldName).split("."));
    var fieldSchema = parentComponentDefinition === null || parentComponentDefinition === void 0 ? void 0 : parentComponentDefinition.schema.find(function (schema) {
      return schema.prop === fieldNameParent;
    });

    if (fieldSchema) {
      if (fieldSchema.type === "component-fixed") {
        return false;
      }

      if (fieldSchema.type === "component" && fieldSchema.required) {
        return false;
      }
    }
  }

  return true;
}

function isFieldDuplicatable(fieldName, form, compilationContext) {
  return isFieldRemovable(fieldName, form, compilationContext);
}

var shiftPath = function shiftPath(originalPath, shiftingPath) {
  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "downward";
  var directionFactor = direction === "downward" ? 1 : -1;
  var original = shiftingPath.split(".");
  var shifting = originalPath.split(".");

  if (original.length < 2) {
    return originalPath;
  }

  var index = 0;

  while (index < original.length - 1 && index < shifting.length - 1) {
    if (shifting[index] !== original[index]) {
      return originalPath;
    }

    if (shifting[index + 1] !== original[index + 1]) {
      var numberA = Number(original[index + 1]);
      var numberB = Number(shifting[index + 1]);

      if (numberA < numberB && (index + 1 == original.length - 1 || index + 1 === shifting.length - 1)) {
        shifting.splice(index + 1, 1, String(numberB + directionFactor));
        return shifting.join(".");
      } else {
        return originalPath;
      }
    }

    index += 2;
  }

  return originalPath;
};
function takeLastOfEachParent(where) {
  var lastOfEachParent = where.reduce(function (acc, curr) {
    var _acc$trimmed;

    var trimmed = getParentPath(curr);
    var index = getFieldPathIndex(curr);
    acc[trimmed] = Math.max(index, (_acc$trimmed = acc[trimmed]) !== null && _acc$trimmed !== void 0 ? _acc$trimmed : Number.MIN_SAFE_INTEGER);
    return acc;
  }, {});
  return Object.entries(lastOfEachParent).map(function (_ref7) {
    var _ref8 = _slicedToArray$2(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    return "".concat(key, ".").concat(value);
  });
}

function checkLocalesCorrectness(locales) {
  if (locales.length === 0) {
    throw new Error("Locales array can't be empty");
  }

  var defaultLocales = locales.filter(function (l) {
    return l.isDefault;
  });

  if (defaultLocales.length === 0) {
    throw new Error("One locale must be set as default, you didn't set any");
  }

  if (defaultLocales.length > 1) {
    throw new Error("Only one locale must be set as default, you set more than one");
  }

  var defaultLocale = defaultLocales[0];

  if (defaultLocale.fallback) {
    throw new Error("Default locale can't have fallback");
  } // Check for incorrect fallbacks


  locales.forEach(function (locale) {
    if (locale.fallback) {
      var fallback = locales.find(function (x) {
        return x.code === locale.fallback;
      });

      if (!fallback) {
        throw new Error("Locale ".concat(locale, " has a fallback ").concat(locale.fallback, " which doesn't exist in the locales list."));
      }
    } // If there is no fallback, then we treat default locale as a fallback!

  }); // Let's check for circulars

  locales.forEach(function (locale) {
    var localeChain = [];
    var currentLocale = locale;

    var _loop = function _loop() {
      var _currentLocale$fallba;

      localeChain.push(currentLocale.code);
      var fallbackId = (_currentLocale$fallba = currentLocale.fallback) !== null && _currentLocale$fallba !== void 0 ? _currentLocale$fallba : getDefaultLocale(locales).code; // If we got to the default locale then we're fine

      if (fallbackId === getDefaultLocale(locales).code) {
        return "break";
      } // If fallbackId does already exists in localeChain then it means we have circular!


      if (localeChain.includes(fallbackId)) {
        throw new Error("There is circular reference in locales: ".concat([].concat(localeChain, [fallbackId]).join(",")));
      }

      currentLocale = locales.find(function (x) {
        return x.code === fallbackId;
      });
    };

    do {
      var _ret = _loop();

      if (_ret === "break") break;
    } while (true);
  });
  return true;
}

var validateIntegrity = function validateIntegrity(configs, compilationContext) {
  var stripped = Object.values(configs).map(function (config) {
    return configMap(config, compilationContext, function (_ref) {
      var schemaProp = _ref.schemaProp,
          value = _ref.value;

      if (schemaProp.type === "text" || schemaProp.type === "component-collection-localised") {
        return;
      }

      return value;
    });
  });
  var stringifiedConfigs = stripped.map(function (c) {
    return JSON.stringify(c, Object.keys(c).sort());
  });
  return stringifiedConfigs.every(function (c) {
    return c === stringifiedConfigs[0];
  });
};
function mergeSingleLocaleConfigsIntoConfig(configs, compilationContext) {
  if (Object.keys(configs).length === 0) {
    return;
  }

  if (!validateIntegrity(configs, compilationContext)) {
    throw Error("You probably changed the value of the config for just one language");
  }

  var anyConfig = configs[Object.keys(configs)[0]];
  return configMap(anyConfig, compilationContext, function (_ref2) {
    var value = _ref2.value,
        schemaProp = _ref2.schemaProp,
        path = _ref2.path;

    if (schemaProp.type === "text") {
      // Sometimes value can be undefined but it is still correct.
      // It happens when schema gets new property and config was not yet opened and saved with this new property.
      // We must simply preserve undefined in merged config, Editor will later normalize it and save back proper value.
      if (value === undefined) {
        return undefined;
      }

      if (value.id.startsWith("local.")) {
        var localizedText = {};

        for (var _locale in configs) {
          var _dotNotationGet;

          var textValue = (_dotNotationGet = dotNotationGet(configs[_locale], path)) === null || _dotNotationGet === void 0 ? void 0 : _dotNotationGet.value;

          if (textValue && !textValue.__fallback) {
            localizedText[_locale] = textValue[_locale];
          }
        }

        return {
          id: value.id,
          value: localizedText
        };
      }
    } else if (schemaProp.type === "component-collection-localised") {
      if (value === undefined) {
        // as mentioned above in text schema prop
        return undefined;
      }

      var localisedCollection = {};

      for (var _locale2 in configs) {
        var _value = dotNotationGet(configs[_locale2], path);

        if (!_value.__fallback) {
          localisedCollection[_locale2] = _value[_locale2];
        }
      }

      delete localisedCollection.__fallback;
      return localisedCollection;
    }

    return value;
  });
}

var RICH_TEXT_PART_CONFIG_PATH_REGEXP = /\.elements\.[a-z(\-A-Z)?]+\.\d+(\.elements\.\d+){2,3}(\.\{\d+,\d+\})?$/;

function isConfigPathRichTextPart(configPath) {
  return RICH_TEXT_PART_CONFIG_PATH_REGEXP.test(configPath);
}

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject(o) {
  var ctor,prot;

  if (isObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}

function n$1(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return "'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return !!n&&!!n[Q]}function t(n){var r;return !!n&&(function(n){if(!n||"object"!=typeof n)return !1;var r=Object.getPrototypeOf(n);if(null===r)return !0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n);})):n.forEach((function(t,e){return r(e,t,n)}));}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t;}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]});}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n$1(2);}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n$1(18,r),t}function _(){return U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r);}function O(n){g(n),n.p.forEach(S),n.p=null;}function g(n){n===U&&(U=n.l);}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.O=!0;}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.g||b("ES5").S(e,r,o),o?(i[Q].P&&(O(e),n$1(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),O(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s);}return e.o}function A(e,i,o,a,c,s,v){if(r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1;}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c);}}function x(n,r,t){void 0===t&&(t=!1),n.h.D&&n.m&&d(r,t);}function z(n,r){var t=n[Q];return (t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t);}}function k(n){n.P||(n.P=!0,n.l&&k(n.l));}function E(n){n.o||(n.o=l(n.t));}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.g?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return (t?t.A:_()).p.push(e),e}function R(e){return r(e)||n$1(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1;}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t));})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t);})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return !0;E(n),k(n);}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n$1(11);},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n$1(12);}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)};})),on.deleteProperty=function(r,t){return on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.g=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return (t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n$1(6),void 0!==o&&"function"!=typeof o&&n$1(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1;}finally{v?O(c):g(c);}return "undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw O(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l);}return f}n$1(21,r);},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r;}));return "undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return [n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze);}var i=e.prototype;return i.createDraft=function(e){t(e)||n$1(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,g(i),o},i.finishDraft=function(r,t){var e=r&&r[Q];var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n;},i.setUseProxies=function(r){r&&!B&&n$1(20),this.g=r;},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce;an.produceWithPatches.bind(an);an.setAutoFreeze.bind(an);an.setUseProxies.bind(an);an.applyPatches.bind(an);var ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DIRTY_PATHS = new WeakMap();
var DIRTY_PATH_KEYS = new WeakMap();
var FLUSHING = new WeakMap();
var NORMALIZING = new WeakMap();
var PATH_REFS = new WeakMap();
var POINT_REFS = new WeakMap();
var RANGE_REFS = new WeakMap();

function ownKeys$9(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$9(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$9(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * Create a new Slate `Editor` object.
 */


var createEditor = function createEditor() {
  var editor = {
    children: [],
    operations: [],
    selection: null,
    marks: null,
    isInline: function isInline() {
      return false;
    },
    isVoid: function isVoid() {
      return false;
    },
    onChange: function onChange() {},
    apply: function apply(op) {
      var _iterator = _createForOfIteratorHelper$1(Editor$1.pathRefs(editor)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ref = _step.value;
          PathRef.transform(ref, op);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper$1(Editor$1.pointRefs(editor)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ref = _step2.value;
          PointRef.transform(_ref, op);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper$1(Editor$1.rangeRefs(editor)),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ref2 = _step3.value;
          RangeRef.transform(_ref2, op);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var oldDirtyPaths = DIRTY_PATHS.get(editor) || [];
      var oldDirtyPathKeys = DIRTY_PATH_KEYS.get(editor) || new Set();
      var dirtyPaths;
      var dirtyPathKeys;

      var add = function add(path) {
        if (path) {
          var key = path.join(',');

          if (!dirtyPathKeys.has(key)) {
            dirtyPathKeys.add(key);
            dirtyPaths.push(path);
          }
        }
      };

      if (Path.operationCanTransformPath(op)) {
        dirtyPaths = [];
        dirtyPathKeys = new Set();

        var _iterator4 = _createForOfIteratorHelper$1(oldDirtyPaths),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var path = _step4.value;
            var newPath = Path.transform(path, op);
            add(newPath);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } else {
        dirtyPaths = oldDirtyPaths;
        dirtyPathKeys = oldDirtyPathKeys;
      }

      var newDirtyPaths = getDirtyPaths(op);

      var _iterator5 = _createForOfIteratorHelper$1(newDirtyPaths),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _path = _step5.value;
          add(_path);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      DIRTY_PATHS.set(editor, dirtyPaths);
      DIRTY_PATH_KEYS.set(editor, dirtyPathKeys);
      Transforms.transform(editor, op);
      editor.operations.push(op);
      Editor$1.normalize(editor); // Clear any formats applied to the cursor if the selection changes.

      if (op.type === 'set_selection') {
        editor.marks = null;
      }

      if (!FLUSHING.get(editor)) {
        FLUSHING.set(editor, true);
        Promise.resolve().then(function () {
          FLUSHING.set(editor, false);
          editor.onChange();
          editor.operations = [];
        });
      }
    },
    addMark: function addMark(key, value) {
      var selection = editor.selection;

      if (selection) {
        if (Range.isExpanded(selection)) {
          Transforms.setNodes(editor, _defineProperty$g({}, key, value), {
            match: Text.isText,
            split: true
          });
        } else {
          var marks = _objectSpread$9(_objectSpread$9({}, Editor$1.marks(editor) || {}), {}, _defineProperty$g({}, key, value));

          editor.marks = marks;

          if (!FLUSHING.get(editor)) {
            editor.onChange();
          }
        }
      }
    },
    deleteBackward: function deleteBackward(unit) {
      var selection = editor.selection;

      if (selection && Range.isCollapsed(selection)) {
        Transforms["delete"](editor, {
          unit: unit,
          reverse: true
        });
      }
    },
    deleteForward: function deleteForward(unit) {
      var selection = editor.selection;

      if (selection && Range.isCollapsed(selection)) {
        Transforms["delete"](editor, {
          unit: unit
        });
      }
    },
    deleteFragment: function deleteFragment(direction) {
      var selection = editor.selection;

      if (selection && Range.isExpanded(selection)) {
        Transforms["delete"](editor, {
          reverse: direction === 'backward'
        });
      }
    },
    getFragment: function getFragment() {
      var selection = editor.selection;

      if (selection) {
        return Node.fragment(editor, selection);
      }

      return [];
    },
    insertBreak: function insertBreak() {
      Transforms.splitNodes(editor, {
        always: true
      });
    },
    insertSoftBreak: function insertSoftBreak() {
      Transforms.splitNodes(editor, {
        always: true
      });
    },
    insertFragment: function insertFragment(fragment) {
      Transforms.insertFragment(editor, fragment);
    },
    insertNode: function insertNode(node) {
      Transforms.insertNodes(editor, node);
    },
    insertText: function insertText(text) {
      var selection = editor.selection,
          marks = editor.marks;

      if (selection) {
        if (marks) {
          var node = _objectSpread$9({
            text: text
          }, marks);

          Transforms.insertNodes(editor, node);
        } else {
          Transforms.insertText(editor, text);
        }

        editor.marks = null;
      }
    },
    normalizeNode: function normalizeNode(entry) {
      var _entry2 = _slicedToArray$2(entry, 2),
          node = _entry2[0],
          path = _entry2[1]; // There are no core normalizations for text nodes.


      if (Text.isText(node)) {
        return;
      } // Ensure that block and inline nodes have at least one text child.


      if (Element$1.isElement(node) && node.children.length === 0) {
        var child = {
          text: ''
        };
        Transforms.insertNodes(editor, child, {
          at: path.concat(0),
          voids: true
        });
        return;
      } // Determine whether the node should have block or inline children.


      var shouldHaveInlines = Editor$1.isEditor(node) ? false : Element$1.isElement(node) && (editor.isInline(node) || node.children.length === 0 || Text.isText(node.children[0]) || editor.isInline(node.children[0])); // Since we'll be applying operations while iterating, keep track of an
      // index that accounts for any added/removed nodes.

      var n = 0;

      for (var i = 0; i < node.children.length; i++, n++) {
        var currentNode = Node.get(editor, path);
        if (Text.isText(currentNode)) continue;
        var _child = node.children[i];
        var prev = currentNode.children[n - 1];
        var isLast = i === node.children.length - 1;
        var isInlineOrText = Text.isText(_child) || Element$1.isElement(_child) && editor.isInline(_child); // Only allow block nodes in the top-level children and parent blocks
        // that only contain block nodes. Similarly, only allow inline nodes in
        // other inline nodes, or parent blocks that only contain inlines and
        // text.

        if (isInlineOrText !== shouldHaveInlines) {
          Transforms.removeNodes(editor, {
            at: path.concat(n),
            voids: true
          });
          n--;
        } else if (Element$1.isElement(_child)) {
          // Ensure that inline nodes are surrounded by text nodes.
          if (editor.isInline(_child)) {
            if (prev == null || !Text.isText(prev)) {
              var newChild = {
                text: ''
              };
              Transforms.insertNodes(editor, newChild, {
                at: path.concat(n),
                voids: true
              });
              n++;
            } else if (isLast) {
              var _newChild = {
                text: ''
              };
              Transforms.insertNodes(editor, _newChild, {
                at: path.concat(n + 1),
                voids: true
              });
              n++;
            }
          }
        } else {
          // Merge adjacent text nodes that are empty or match.
          if (prev != null && Text.isText(prev)) {
            if (Text.equals(_child, prev, {
              loose: true
            })) {
              Transforms.mergeNodes(editor, {
                at: path.concat(n),
                voids: true
              });
              n--;
            } else if (prev.text === '') {
              Transforms.removeNodes(editor, {
                at: path.concat(n - 1),
                voids: true
              });
              n--;
            } else if (_child.text === '') {
              Transforms.removeNodes(editor, {
                at: path.concat(n),
                voids: true
              });
              n--;
            }
          }
        }
      }
    },
    removeMark: function removeMark(key) {
      var selection = editor.selection;

      if (selection) {
        if (Range.isExpanded(selection)) {
          Transforms.unsetNodes(editor, key, {
            match: Text.isText,
            split: true
          });
        } else {
          var marks = _objectSpread$9({}, Editor$1.marks(editor) || {});

          delete marks[key];
          editor.marks = marks;

          if (!FLUSHING.get(editor)) {
            editor.onChange();
          }
        }
      }
    }
  };
  return editor;
};
/**
 * Get the "dirty" paths generated from an operation.
 */


var getDirtyPaths = function getDirtyPaths(op) {
  switch (op.type) {
    case 'insert_text':
    case 'remove_text':
    case 'set_node':
      {
        var path = op.path;
        return Path.levels(path);
      }

    case 'insert_node':
      {
        var node = op.node,
            _path2 = op.path;
        var levels = Path.levels(_path2);
        var descendants = Text.isText(node) ? [] : Array.from(Node.nodes(node), function (_ref3) {
          var _ref6 = _slicedToArray$2(_ref3, 2),
              p = _ref6[1];

          return _path2.concat(p);
        });
        return [].concat(_toConsumableArray$2(levels), _toConsumableArray$2(descendants));
      }

    case 'merge_node':
      {
        var _path3 = op.path;
        var ancestors = Path.ancestors(_path3);
        var previousPath = Path.previous(_path3);
        return [].concat(_toConsumableArray$2(ancestors), [previousPath]);
      }

    case 'move_node':
      {
        var _path4 = op.path,
            newPath = op.newPath;

        if (Path.equals(_path4, newPath)) {
          return [];
        }

        var oldAncestors = [];
        var newAncestors = [];

        var _iterator6 = _createForOfIteratorHelper$1(Path.ancestors(_path4)),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var ancestor = _step6.value;
            var p = Path.transform(ancestor, op);
            oldAncestors.push(p);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        var _iterator7 = _createForOfIteratorHelper$1(Path.ancestors(newPath)),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _ancestor = _step7.value;

            var _p = Path.transform(_ancestor, op);

            newAncestors.push(_p);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        var newParent = newAncestors[newAncestors.length - 1];
        var newIndex = newPath[newPath.length - 1];
        var resultPath = newParent.concat(newIndex);
        return [].concat(oldAncestors, newAncestors, [resultPath]);
      }

    case 'remove_node':
      {
        var _path5 = op.path;

        var _ancestors = Path.ancestors(_path5);

        return _toConsumableArray$2(_ancestors);
      }

    case 'split_node':
      {
        var _path6 = op.path;

        var _levels = Path.levels(_path6);

        var nextPath = Path.next(_path6);
        return [].concat(_toConsumableArray$2(_levels), [nextPath]);
      }

    default:
      {
        return [];
      }
  }
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
} // Character (grapheme cluster) boundaries are determined according to
// the default grapheme cluster boundary specification, extended grapheme clusters variant[1].
//
// References:
//
// [1] https://www.unicode.org/reports/tr29/#Default_Grapheme_Cluster_Table
// [2] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakProperty.txt
// [3] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.html
// [4] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.txt

/**
 * Get the distance to the end of the first character in a string of text.
 */


var getCharacterDistance = function getCharacterDistance(str) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isLTR = !isRTL;
  var codepoints = isRTL ? codepointsIteratorRTL(str) : str;
  var left = CodepointType.None;
  var right = CodepointType.None;
  var distance = 0; // Evaluation of these conditions are deferred.

  var gb11 = null; // Is GB11 applicable?

  var gb12Or13 = null; // Is GB12 or GB13 applicable?

  var _iterator8 = _createForOfIteratorHelper$1(codepoints),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var _char = _step8.value;

      var code = _char.codePointAt(0);

      if (!code) break;
      var type = getCodepointType(_char, code);

      var _ref7 = isLTR ? [right, type] : [type, left];

      var _ref8 = _slicedToArray$2(_ref7, 2);

      left = _ref8[0];
      right = _ref8[1];

      if (intersects(left, CodepointType.ZWJ) && intersects(right, CodepointType.ExtPict)) {
        if (isLTR) {
          gb11 = endsWithEmojiZWJ(str.substring(0, distance));
        } else {
          gb11 = endsWithEmojiZWJ(str.substring(0, str.length - distance));
        }

        if (!gb11) break;
      }

      if (intersects(left, CodepointType.RI) && intersects(right, CodepointType.RI)) {
        if (gb12Or13 !== null) {
          gb12Or13 = !gb12Or13;
        } else {
          if (isLTR) {
            gb12Or13 = true;
          } else {
            gb12Or13 = endsWithOddNumberOfRIs(str.substring(0, str.length - distance));
          }
        }

        if (!gb12Or13) break;
      }

      if (left !== CodepointType.None && right !== CodepointType.None && isBoundaryPair(left, right)) {
        break;
      }

      distance += _char.length;
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  return distance || 1;
};

var SPACE = /\s/;
var PUNCTUATION = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
var CHAMELEON = /['\u2018\u2019]/;
/**
 * Get the distance to the end of the first word in a string of text.
 */

var getWordDistance = function getWordDistance(text) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var dist = 0;
  var started = false;

  while (text.length > 0) {
    var charDist = getCharacterDistance(text, isRTL);

    var _splitByCharacterDist = splitByCharacterDistance(text, charDist, isRTL),
        _splitByCharacterDist2 = _slicedToArray$2(_splitByCharacterDist, 2),
        _char2 = _splitByCharacterDist2[0],
        remaining = _splitByCharacterDist2[1];

    if (isWordCharacter(_char2, remaining, isRTL)) {
      started = true;
      dist += charDist;
    } else if (!started) {
      dist += charDist;
    } else {
      break;
    }

    text = remaining;
  }

  return dist;
};
/**
 * Split a string in two parts at a given distance starting from the end when
 * `isRTL` is set to `true`.
 */


var splitByCharacterDistance = function splitByCharacterDistance(str, dist, isRTL) {
  if (isRTL) {
    var at = str.length - dist;
    return [str.slice(at, str.length), str.slice(0, at)];
  }

  return [str.slice(0, dist), str.slice(dist)];
};
/**
 * Check if a character is a word character. The `remaining` argument is used
 * because sometimes you must read subsequent characters to truly determine it.
 */


var isWordCharacter = function isWordCharacter(_char3, remaining) {
  var isRTL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (SPACE.test(_char3)) {
    return false;
  } // Chameleons count as word characters as long as they're in a word, so
  // recurse to see if the next one is a word character or not.


  if (CHAMELEON.test(_char3)) {
    var charDist = getCharacterDistance(remaining, isRTL);

    var _splitByCharacterDist3 = splitByCharacterDistance(remaining, charDist, isRTL),
        _splitByCharacterDist4 = _slicedToArray$2(_splitByCharacterDist3, 2),
        nextChar = _splitByCharacterDist4[0],
        nextRemaining = _splitByCharacterDist4[1];

    if (isWordCharacter(nextChar, nextRemaining, isRTL)) {
      return true;
    }
  }

  if (PUNCTUATION.test(_char3)) {
    return false;
  }

  return true;
};
/**
 * Iterate on codepoints from right to left.
 */


var codepointsIteratorRTL = /*#__PURE__*/regenerator.mark(function codepointsIteratorRTL(str) {
  var end, i, char1, char2;
  return regenerator.wrap(function codepointsIteratorRTL$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          end = str.length - 1;
          i = 0;

        case 2:
          if (!(i < str.length)) {
            _context.next = 16;
            break;
          }

          char1 = str.charAt(end - i);

          if (!isLowSurrogate(char1.charCodeAt(0))) {
            _context.next = 11;
            break;
          }

          char2 = str.charAt(end - i - 1);

          if (!isHighSurrogate(char2.charCodeAt(0))) {
            _context.next = 11;
            break;
          }

          _context.next = 9;
          return char2 + char1;

        case 9:
          i++;
          return _context.abrupt("continue", 13);

        case 11:
          _context.next = 13;
          return char1;

        case 13:
          i++;
          _context.next = 2;
          break;

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, codepointsIteratorRTL);
});
/**
 * Is `charCode` a high surrogate.
 *
 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
 */


var isHighSurrogate = function isHighSurrogate(charCode) {
  return charCode >= 0xd800 && charCode <= 0xdbff;
};
/**
 * Is `charCode` a low surrogate.
 *
 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
 */


var isLowSurrogate = function isLowSurrogate(charCode) {
  return charCode >= 0xdc00 && charCode <= 0xdfff;
};

var CodepointType;

(function (CodepointType) {
  CodepointType[CodepointType["None"] = 0] = "None";
  CodepointType[CodepointType["Extend"] = 1] = "Extend";
  CodepointType[CodepointType["ZWJ"] = 2] = "ZWJ";
  CodepointType[CodepointType["RI"] = 4] = "RI";
  CodepointType[CodepointType["Prepend"] = 8] = "Prepend";
  CodepointType[CodepointType["SpacingMark"] = 16] = "SpacingMark";
  CodepointType[CodepointType["L"] = 32] = "L";
  CodepointType[CodepointType["V"] = 64] = "V";
  CodepointType[CodepointType["T"] = 128] = "T";
  CodepointType[CodepointType["LV"] = 256] = "LV";
  CodepointType[CodepointType["LVT"] = 512] = "LVT";
  CodepointType[CodepointType["ExtPict"] = 1024] = "ExtPict";
  CodepointType[CodepointType["Any"] = 2048] = "Any";
})(CodepointType || (CodepointType = {}));

var reExtend = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/;
var rePrepend = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/;
var reSpacingMark = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/;
var reL = /^[\u1100-\u115F\uA960-\uA97C]$/;
var reV = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/;
var reT = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/;
var reLV = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/;
var reLVT = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/;
var reExtPict = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/;

var getCodepointType = function getCodepointType(_char4, code) {
  var type = CodepointType.Any;

  if (_char4.search(reExtend) !== -1) {
    type |= CodepointType.Extend;
  }

  if (code === 0x200d) {
    type |= CodepointType.ZWJ;
  }

  if (code >= 0x1f1e6 && code <= 0x1f1ff) {
    type |= CodepointType.RI;
  }

  if (_char4.search(rePrepend) !== -1) {
    type |= CodepointType.Prepend;
  }

  if (_char4.search(reSpacingMark) !== -1) {
    type |= CodepointType.SpacingMark;
  }

  if (_char4.search(reL) !== -1) {
    type |= CodepointType.L;
  }

  if (_char4.search(reV) !== -1) {
    type |= CodepointType.V;
  }

  if (_char4.search(reT) !== -1) {
    type |= CodepointType.T;
  }

  if (_char4.search(reLV) !== -1) {
    type |= CodepointType.LV;
  }

  if (_char4.search(reLVT) !== -1) {
    type |= CodepointType.LVT;
  }

  if (_char4.search(reExtPict) !== -1) {
    type |= CodepointType.ExtPict;
  }

  return type;
};

function intersects(x, y) {
  return (x & y) !== 0;
}

var NonBoundaryPairs = [// GB6
[CodepointType.L, CodepointType.L | CodepointType.V | CodepointType.LV | CodepointType.LVT], // GB7
[CodepointType.LV | CodepointType.V, CodepointType.V | CodepointType.T], // GB8
[CodepointType.LVT | CodepointType.T, CodepointType.T], // GB9
[CodepointType.Any, CodepointType.Extend | CodepointType.ZWJ], // GB9a
[CodepointType.Any, CodepointType.SpacingMark], // GB9b
[CodepointType.Prepend, CodepointType.Any], // GB11
[CodepointType.ZWJ, CodepointType.ExtPict], // GB12 and GB13
[CodepointType.RI, CodepointType.RI]];

function isBoundaryPair(left, right) {
  return NonBoundaryPairs.findIndex(function (r) {
    return intersects(left, r[0]) && intersects(right, r[1]);
  }) === -1;
}

var endingEmojiZWJ = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/;

var endsWithEmojiZWJ = function endsWithEmojiZWJ(str) {
  return str.search(endingEmojiZWJ) !== -1;
};

var endingRIs = /(?:\uD83C[\uDDE6-\uDDFF])+$/g;

var endsWithOddNumberOfRIs = function endsWithOddNumberOfRIs(str) {
  var match = str.match(endingRIs);

  if (match === null) {
    return false;
  } else {
    // A RI is represented by a surrogate pair.
    var numRIs = match[0].length / 2;
    return numRIs % 2 === 1;
  }
};
/**
 * Shared the function with isElementType utility
 */


var isElement = function isElement(value) {
  return isPlainObject(value) && Node.isNodeList(value.children) && !Editor$1.isEditor(value);
};

var Element$1 = {
  /**
   * Check if a value implements the 'Ancestor' interface.
   */
  isAncestor: function isAncestor(value) {
    return isPlainObject(value) && Node.isNodeList(value.children);
  },

  /**
   * Check if a value implements the `Element` interface.
   */
  isElement: isElement,

  /**
   * Check if a value is an array of `Element` objects.
   */
  isElementList: function isElementList(value) {
    return Array.isArray(value) && value.every(function (val) {
      return Element$1.isElement(val);
    });
  },

  /**
   * Check if a set of props is a partial of Element.
   */
  isElementProps: function isElementProps(props) {
    return props.children !== undefined;
  },

  /**
   * Check if a value implements the `Element` interface and has elementKey with selected value.
   * Default it check to `type` key value
   */
  isElementType: function isElementType(value, elementVal) {
    var elementKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'type';
    return isElement(value) && value[elementKey] === elementVal;
  },

  /**
   * Check if an element matches set of properties.
   *
   * Note: this checks custom properties, and it does not ensure that any
   * children are equivalent.
   */
  matches: function matches(element, props) {
    for (var key in props) {
      if (key === 'children') {
        continue;
      }

      if (element[key] !== props[key]) {
        return false;
      }
    }

    return true;
  }
};
var _excluded$4 = ["text"],
    _excluded2$3 = ["text"];

function ownKeys$8(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$8(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$8(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var IS_EDITOR_CACHE = new WeakMap();
var Editor$1 = {
  /**
   * Get the ancestor above a location in the document.
   */
  above: function above(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$voids = options.voids,
        voids = _options$voids === void 0 ? false : _options$voids,
        _options$mode = options.mode,
        mode = _options$mode === void 0 ? 'lowest' : _options$mode,
        _options$at = options.at,
        at = _options$at === void 0 ? editor.selection : _options$at,
        match = options.match;

    if (!at) {
      return;
    }

    var path = Editor$1.path(editor, at);
    var reverse = mode === 'lowest';

    var _iterator9 = _createForOfIteratorHelper$1(Editor$1.levels(editor, {
      at: path,
      voids: voids,
      match: match,
      reverse: reverse
    })),
        _step9;

    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var _step9$value = _slicedToArray$2(_step9.value, 2),
            n = _step9$value[0],
            p = _step9$value[1];

        if (!Text.isText(n) && !Path.equals(path, p)) {
          return [n, p];
        }
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  },

  /**
   * Add a custom property to the leaf text nodes in the current selection.
   *
   * If the selection is currently collapsed, the marks will be added to the
   * `editor.marks` property instead, and applied when text is inserted next.
   */
  addMark: function addMark(editor, key, value) {
    editor.addMark(key, value);
  },

  /**
   * Get the point after a location.
   */
  after: function after(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var anchor = Editor$1.point(editor, at, {
      edge: 'end'
    });
    var focus = Editor$1.end(editor, []);
    var range = {
      anchor: anchor,
      focus: focus
    };
    var _options$distance = options.distance,
        distance = _options$distance === void 0 ? 1 : _options$distance;
    var d = 0;
    var target;

    var _iterator10 = _createForOfIteratorHelper$1(Editor$1.positions(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
      at: range
    }))),
        _step10;

    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var p = _step10.value;

        if (d > distance) {
          break;
        }

        if (d !== 0) {
          target = p;
        }

        d++;
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }

    return target;
  },

  /**
   * Get the point before a location.
   */
  before: function before(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var anchor = Editor$1.start(editor, []);
    var focus = Editor$1.point(editor, at, {
      edge: 'start'
    });
    var range = {
      anchor: anchor,
      focus: focus
    };
    var _options$distance2 = options.distance,
        distance = _options$distance2 === void 0 ? 1 : _options$distance2;
    var d = 0;
    var target;

    var _iterator11 = _createForOfIteratorHelper$1(Editor$1.positions(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
      at: range,
      reverse: true
    }))),
        _step11;

    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var p = _step11.value;

        if (d > distance) {
          break;
        }

        if (d !== 0) {
          target = p;
        }

        d++;
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }

    return target;
  },

  /**
   * Delete content in the editor backward from the current selection.
   */
  deleteBackward: function deleteBackward(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$unit = options.unit,
        unit = _options$unit === void 0 ? 'character' : _options$unit;
    editor.deleteBackward(unit);
  },

  /**
   * Delete content in the editor forward from the current selection.
   */
  deleteForward: function deleteForward(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$unit2 = options.unit,
        unit = _options$unit2 === void 0 ? 'character' : _options$unit2;
    editor.deleteForward(unit);
  },

  /**
   * Delete the content in the current selection.
   */
  deleteFragment: function deleteFragment(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$direction = options.direction,
        direction = _options$direction === void 0 ? 'forward' : _options$direction;
    editor.deleteFragment(direction);
  },

  /**
   * Get the start and end points of a location.
   */
  edges: function edges(editor, at) {
    return [Editor$1.start(editor, at), Editor$1.end(editor, at)];
  },

  /**
   * Get the end point of a location.
   */
  end: function end(editor, at) {
    return Editor$1.point(editor, at, {
      edge: 'end'
    });
  },

  /**
   * Get the first node at a location.
   */
  first: function first(editor, at) {
    var path = Editor$1.path(editor, at, {
      edge: 'start'
    });
    return Editor$1.node(editor, path);
  },

  /**
   * Get the fragment at a location.
   */
  fragment: function fragment(editor, at) {
    var range = Editor$1.range(editor, at);
    var fragment = Node.fragment(editor, range);
    return fragment;
  },

  /**
   * Check if a node has block children.
   */
  hasBlocks: function hasBlocks(editor, element) {
    return element.children.some(function (n) {
      return Editor$1.isBlock(editor, n);
    });
  },

  /**
   * Check if a node has inline and text children.
   */
  hasInlines: function hasInlines(editor, element) {
    return element.children.some(function (n) {
      return Text.isText(n) || Editor$1.isInline(editor, n);
    });
  },

  /**
   * Check if a node has text children.
   */
  hasTexts: function hasTexts(editor, element) {
    return element.children.every(function (n) {
      return Text.isText(n);
    });
  },

  /**
   * Insert a block break at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertBreak: function insertBreak(editor) {
    editor.insertBreak();
  },

  /**
   * Insert a soft break at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertSoftBreak: function insertSoftBreak(editor) {
    editor.insertSoftBreak();
  },

  /**
   * Insert a fragment at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertFragment: function insertFragment(editor, fragment) {
    editor.insertFragment(fragment);
  },

  /**
   * Insert a node at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertNode: function insertNode(editor, node) {
    editor.insertNode(node);
  },

  /**
   * Insert text at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertText: function insertText(editor, text) {
    editor.insertText(text);
  },

  /**
   * Check if a value is a block `Element` object.
   */
  isBlock: function isBlock(editor, value) {
    return Element$1.isElement(value) && !editor.isInline(value);
  },

  /**
   * Check if a value is an `Editor` object.
   */
  isEditor: function isEditor(value) {
    if (!isPlainObject(value)) return false;
    var cachedIsEditor = IS_EDITOR_CACHE.get(value);

    if (cachedIsEditor !== undefined) {
      return cachedIsEditor;
    }

    var isEditor = typeof value.addMark === 'function' && typeof value.apply === 'function' && typeof value.deleteBackward === 'function' && typeof value.deleteForward === 'function' && typeof value.deleteFragment === 'function' && typeof value.insertBreak === 'function' && typeof value.insertSoftBreak === 'function' && typeof value.insertFragment === 'function' && typeof value.insertNode === 'function' && typeof value.insertText === 'function' && typeof value.isInline === 'function' && typeof value.isVoid === 'function' && typeof value.normalizeNode === 'function' && typeof value.onChange === 'function' && typeof value.removeMark === 'function' && (value.marks === null || isPlainObject(value.marks)) && (value.selection === null || Range.isRange(value.selection)) && Node.isNodeList(value.children) && Operation.isOperationList(value.operations);
    IS_EDITOR_CACHE.set(value, isEditor);
    return isEditor;
  },

  /**
   * Check if a point is the end point of a location.
   */
  isEnd: function isEnd(editor, point, at) {
    var end = Editor$1.end(editor, at);
    return Point.equals(point, end);
  },

  /**
   * Check if a point is an edge of a location.
   */
  isEdge: function isEdge(editor, point, at) {
    return Editor$1.isStart(editor, point, at) || Editor$1.isEnd(editor, point, at);
  },

  /**
   * Check if an element is empty, accounting for void nodes.
   */
  isEmpty: function isEmpty(editor, element) {
    var children = element.children;

    var _children = _slicedToArray$2(children, 1),
        first = _children[0];

    return children.length === 0 || children.length === 1 && Text.isText(first) && first.text === '' && !editor.isVoid(element);
  },

  /**
   * Check if a value is an inline `Element` object.
   */
  isInline: function isInline(editor, value) {
    return Element$1.isElement(value) && editor.isInline(value);
  },

  /**
   * Check if the editor is currently normalizing after each operation.
   */
  isNormalizing: function isNormalizing(editor) {
    var isNormalizing = NORMALIZING.get(editor);
    return isNormalizing === undefined ? true : isNormalizing;
  },

  /**
   * Check if a point is the start point of a location.
   */
  isStart: function isStart(editor, point, at) {
    // PERF: If the offset isn't `0` we know it's not the start.
    if (point.offset !== 0) {
      return false;
    }

    var start = Editor$1.start(editor, at);
    return Point.equals(point, start);
  },

  /**
   * Check if a value is a void `Element` object.
   */
  isVoid: function isVoid(editor, value) {
    return Element$1.isElement(value) && editor.isVoid(value);
  },

  /**
   * Get the last node at a location.
   */
  last: function last(editor, at) {
    var path = Editor$1.path(editor, at, {
      edge: 'end'
    });
    return Editor$1.node(editor, path);
  },

  /**
   * Get the leaf text node at a location.
   */
  leaf: function leaf(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = Editor$1.path(editor, at, options);
    var node = Node.leaf(editor, path);
    return [node, path];
  },

  /**
   * Iterate through all of the levels at a location.
   */
  levels: /*#__PURE__*/regenerator.mark(function levels(editor) {
    var options,
        _options$at2,
        at,
        _options$reverse,
        reverse,
        _options$voids2,
        voids,
        match,
        levels,
        path,
        _iterator12,
        _step12,
        _step12$value,
        n,
        p,
        _args2 = arguments;

    return regenerator.wrap(function levels$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _options$at2 = options.at, at = _options$at2 === void 0 ? editor.selection : _options$at2, _options$reverse = options.reverse, reverse = _options$reverse === void 0 ? false : _options$reverse, _options$voids2 = options.voids, voids = _options$voids2 === void 0 ? false : _options$voids2;
            match = options.match;

            if (match == null) {
              match = function match() {
                return true;
              };
            }

            if (at) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return");

          case 6:
            levels = [];
            path = Editor$1.path(editor, at);
            _iterator12 = _createForOfIteratorHelper$1(Node.levels(editor, path));
            _context2.prev = 9;

            _iterator12.s();

          case 11:
            if ((_step12 = _iterator12.n()).done) {
              _context2.next = 20;
              break;
            }

            _step12$value = _slicedToArray$2(_step12.value, 2), n = _step12$value[0], p = _step12$value[1];

            if (match(n, p)) {
              _context2.next = 15;
              break;
            }

            return _context2.abrupt("continue", 18);

          case 15:
            levels.push([n, p]);

            if (!(!voids && Editor$1.isVoid(editor, n))) {
              _context2.next = 18;
              break;
            }

            return _context2.abrupt("break", 20);

          case 18:
            _context2.next = 11;
            break;

          case 20:
            _context2.next = 25;
            break;

          case 22:
            _context2.prev = 22;
            _context2.t0 = _context2["catch"](9);

            _iterator12.e(_context2.t0);

          case 25:
            _context2.prev = 25;

            _iterator12.f();

            return _context2.finish(25);

          case 28:
            if (reverse) {
              levels.reverse();
            }

            return _context2.delegateYield(levels, "t1", 30);

          case 30:
          case "end":
            return _context2.stop();
        }
      }
    }, levels, null, [[9, 22, 25, 28]]);
  }),

  /**
   * Get the marks that would be added to text at the current selection.
   */
  marks: function marks(editor) {
    var marks = editor.marks,
        selection = editor.selection;

    if (!selection) {
      return null;
    }

    if (marks) {
      return marks;
    }

    if (Range.isExpanded(selection)) {
      var _Editor$nodes = Editor$1.nodes(editor, {
        match: Text.isText
      }),
          _Editor$nodes2 = _slicedToArray$2(_Editor$nodes, 1),
          match = _Editor$nodes2[0];

      if (match) {
        var _match = _slicedToArray$2(match, 1),
            _node = _match[0];

        var _rest = _objectWithoutProperties(_node, _excluded$4);

        return _rest;
      } else {
        return {};
      }
    }

    var anchor = selection.anchor;
    var path = anchor.path;

    var _Editor$leaf = Editor$1.leaf(editor, path),
        _Editor$leaf2 = _slicedToArray$2(_Editor$leaf, 1),
        node = _Editor$leaf2[0];

    if (anchor.offset === 0) {
      var prev = Editor$1.previous(editor, {
        at: path,
        match: Text.isText
      });
      var block = Editor$1.above(editor, {
        match: function match(n) {
          return Editor$1.isBlock(editor, n);
        }
      });

      if (prev && block) {
        var _prev2 = _slicedToArray$2(prev, 2),
            prevNode = _prev2[0],
            prevPath = _prev2[1];

        var _block = _slicedToArray$2(block, 2),
            blockPath = _block[1];

        if (Path.isAncestor(blockPath, prevPath)) {
          node = prevNode;
        }
      }
    }

    var rest = _objectWithoutProperties(node, _excluded2$3);

    return rest;
  },

  /**
   * Get the matching node in the branch of the document after a location.
   */
  next: function next(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$mode2 = options.mode,
        mode = _options$mode2 === void 0 ? 'lowest' : _options$mode2,
        _options$voids3 = options.voids,
        voids = _options$voids3 === void 0 ? false : _options$voids3;
    var match = options.match,
        _options$at3 = options.at,
        at = _options$at3 === void 0 ? editor.selection : _options$at3;

    if (!at) {
      return;
    }

    var pointAfterLocation = Editor$1.after(editor, at, {
      voids: voids
    });
    if (!pointAfterLocation) return;

    var _Editor$last = Editor$1.last(editor, []),
        _Editor$last2 = _slicedToArray$2(_Editor$last, 2),
        to = _Editor$last2[1];

    var span = [pointAfterLocation.path, to];

    if (Path.isPath(at) && at.length === 0) {
      throw new Error("Cannot get the next node from the root node!");
    }

    if (match == null) {
      if (Path.isPath(at)) {
        var _Editor$parent = Editor$1.parent(editor, at),
            _Editor$parent2 = _slicedToArray$2(_Editor$parent, 1),
            parent = _Editor$parent2[0];

        match = function match(n) {
          return parent.children.includes(n);
        };
      } else {
        match = function match() {
          return true;
        };
      }
    }

    var _Editor$nodes3 = Editor$1.nodes(editor, {
      at: span,
      match: match,
      mode: mode,
      voids: voids
    }),
        _Editor$nodes4 = _slicedToArray$2(_Editor$nodes3, 1),
        next = _Editor$nodes4[0];

    return next;
  },

  /**
   * Get the node at a location.
   */
  node: function node(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = Editor$1.path(editor, at, options);
    var node = Node.get(editor, path);
    return [node, path];
  },

  /**
   * Iterate through all of the nodes in the Editor.
   */
  nodes: /*#__PURE__*/regenerator.mark(function nodes(editor) {
    var options,
        _options$at4,
        at,
        _options$mode3,
        mode,
        _options$universal,
        universal,
        _options$reverse2,
        reverse,
        _options$voids4,
        voids,
        match,
        from,
        to,
        first,
        last,
        nodeEntries,
        matches,
        hit,
        _iterator13,
        _step13,
        _step13$value,
        node,
        path,
        isLower,
        emit,
        _args3 = arguments;

    return regenerator.wrap(function nodes$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            _options$at4 = options.at, at = _options$at4 === void 0 ? editor.selection : _options$at4, _options$mode3 = options.mode, mode = _options$mode3 === void 0 ? 'all' : _options$mode3, _options$universal = options.universal, universal = _options$universal === void 0 ? false : _options$universal, _options$reverse2 = options.reverse, reverse = _options$reverse2 === void 0 ? false : _options$reverse2, _options$voids4 = options.voids, voids = _options$voids4 === void 0 ? false : _options$voids4;
            match = options.match;

            if (!match) {
              match = function match() {
                return true;
              };
            }

            if (at) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return");

          case 6:
            if (Span.isSpan(at)) {
              from = at[0];
              to = at[1];
            } else {
              first = Editor$1.path(editor, at, {
                edge: 'start'
              });
              last = Editor$1.path(editor, at, {
                edge: 'end'
              });
              from = reverse ? last : first;
              to = reverse ? first : last;
            }

            nodeEntries = Node.nodes(editor, {
              reverse: reverse,
              from: from,
              to: to,
              pass: function pass(_ref) {
                var _ref9 = _slicedToArray$2(_ref, 1),
                    n = _ref9[0];

                return voids ? false : Editor$1.isVoid(editor, n);
              }
            });
            matches = [];
            _iterator13 = _createForOfIteratorHelper$1(nodeEntries);
            _context3.prev = 10;

            _iterator13.s();

          case 12:
            if ((_step13 = _iterator13.n()).done) {
              _context3.next = 37;
              break;
            }

            _step13$value = _slicedToArray$2(_step13.value, 2), node = _step13$value[0], path = _step13$value[1];
            isLower = hit && Path.compare(path, hit[1]) === 0; // In highest mode any node lower than the last hit is not a match.

            if (!(mode === 'highest' && isLower)) {
              _context3.next = 17;
              break;
            }

            return _context3.abrupt("continue", 35);

          case 17:
            if (match(node, path)) {
              _context3.next = 23;
              break;
            }

            if (!(universal && !isLower && Text.isText(node))) {
              _context3.next = 22;
              break;
            }

            return _context3.abrupt("return");

          case 22:
            return _context3.abrupt("continue", 35);

          case 23:
            if (!(mode === 'lowest' && isLower)) {
              _context3.next = 26;
              break;
            }

            hit = [node, path];
            return _context3.abrupt("continue", 35);

          case 26:
            // In lowest mode we emit the last hit, once it's guaranteed lowest.
            emit = mode === 'lowest' ? hit : [node, path];

            if (!emit) {
              _context3.next = 34;
              break;
            }

            if (!universal) {
              _context3.next = 32;
              break;
            }

            matches.push(emit);
            _context3.next = 34;
            break;

          case 32:
            _context3.next = 34;
            return emit;

          case 34:
            hit = [node, path];

          case 35:
            _context3.next = 12;
            break;

          case 37:
            _context3.next = 42;
            break;

          case 39:
            _context3.prev = 39;
            _context3.t0 = _context3["catch"](10);

            _iterator13.e(_context3.t0);

          case 42:
            _context3.prev = 42;

            _iterator13.f();

            return _context3.finish(42);

          case 45:
            if (!(mode === 'lowest' && hit)) {
              _context3.next = 52;
              break;
            }

            if (!universal) {
              _context3.next = 50;
              break;
            }

            matches.push(hit);
            _context3.next = 52;
            break;

          case 50:
            _context3.next = 52;
            return hit;

          case 52:
            if (!universal) {
              _context3.next = 54;
              break;
            }

            return _context3.delegateYield(matches, "t1", 54);

          case 54:
          case "end":
            return _context3.stop();
        }
      }
    }, nodes, null, [[10, 39, 42, 45]]);
  }),

  /**
   * Normalize any dirty objects in the editor.
   */
  normalize: function normalize(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$force = options.force,
        force = _options$force === void 0 ? false : _options$force;

    var getDirtyPaths = function getDirtyPaths(editor) {
      return DIRTY_PATHS.get(editor) || [];
    };

    var getDirtyPathKeys = function getDirtyPathKeys(editor) {
      return DIRTY_PATH_KEYS.get(editor) || new Set();
    };

    var popDirtyPath = function popDirtyPath(editor) {
      var path = getDirtyPaths(editor).pop();
      var key = path.join(',');
      getDirtyPathKeys(editor)["delete"](key);
      return path;
    };

    if (!Editor$1.isNormalizing(editor)) {
      return;
    }

    if (force) {
      var allPaths = Array.from(Node.nodes(editor), function (_ref2) {
        var _ref10 = _slicedToArray$2(_ref2, 2),
            p = _ref10[1];

        return p;
      });
      var allPathKeys = new Set(allPaths.map(function (p) {
        return p.join(',');
      }));
      DIRTY_PATHS.set(editor, allPaths);
      DIRTY_PATH_KEYS.set(editor, allPathKeys);
    }

    if (getDirtyPaths(editor).length === 0) {
      return;
    }

    Editor$1.withoutNormalizing(editor, function () {
      /*
        Fix dirty elements with no children.
        editor.normalizeNode() does fix this, but some normalization fixes also require it to work.
        Running an initial pass avoids the catch-22 race condition.
      */
      var _iterator14 = _createForOfIteratorHelper$1(getDirtyPaths(editor)),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var dirtyPath = _step14.value;

          if (Node.has(editor, dirtyPath)) {
            var entry = Editor$1.node(editor, dirtyPath);

            var _entry3 = _slicedToArray$2(entry, 2),
                node = _entry3[0],
                _ = _entry3[1];
            /*
              The default normalizer inserts an empty text node in this scenario, but it can be customised.
              So there is some risk here.
                         As long as the normalizer only inserts child nodes for this case it is safe to do in any order;
              by definition adding children to an empty node can't cause other paths to change.
            */


            if (Element$1.isElement(node) && node.children.length === 0) {
              editor.normalizeNode(entry);
            }
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }

      var max = getDirtyPaths(editor).length * 42; // HACK: better way?

      var m = 0;

      while (getDirtyPaths(editor).length !== 0) {
        if (m > max) {
          throw new Error("\n            Could not completely normalize the editor after ".concat(max, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state.\n          "));
        }

        var _dirtyPath = popDirtyPath(editor); // If the node doesn't exist in the tree, it does not need to be normalized.


        if (Node.has(editor, _dirtyPath)) {
          var _entry = Editor$1.node(editor, _dirtyPath);

          editor.normalizeNode(_entry);
        }

        m++;
      }
    });
  },

  /**
   * Get the parent node of a location.
   */
  parent: function parent(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = Editor$1.path(editor, at, options);
    var parentPath = Path.parent(path);
    var entry = Editor$1.node(editor, parentPath);
    return entry;
  },

  /**
   * Get the path of a location.
   */
  path: function path(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var depth = options.depth,
        edge = options.edge;

    if (Path.isPath(at)) {
      if (edge === 'start') {
        var _Node$first = Node.first(editor, at),
            _Node$first2 = _slicedToArray$2(_Node$first, 2),
            firstPath = _Node$first2[1];

        at = firstPath;
      } else if (edge === 'end') {
        var _Node$last = Node.last(editor, at),
            _Node$last2 = _slicedToArray$2(_Node$last, 2),
            lastPath = _Node$last2[1];

        at = lastPath;
      }
    }

    if (Range.isRange(at)) {
      if (edge === 'start') {
        at = Range.start(at);
      } else if (edge === 'end') {
        at = Range.end(at);
      } else {
        at = Path.common(at.anchor.path, at.focus.path);
      }
    }

    if (Point.isPoint(at)) {
      at = at.path;
    }

    if (depth != null) {
      at = at.slice(0, depth);
    }

    return at;
  },
  hasPath: function hasPath(editor, path) {
    return Node.has(editor, path);
  },

  /**
   * Create a mutable ref for a `Path` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  pathRef: function pathRef(editor, path) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$affinity = options.affinity,
        affinity = _options$affinity === void 0 ? 'forward' : _options$affinity;
    var ref = {
      current: path,
      affinity: affinity,
      unref: function unref() {
        var current = ref.current;
        var pathRefs = Editor$1.pathRefs(editor);
        pathRefs["delete"](ref);
        ref.current = null;
        return current;
      }
    };
    var refs = Editor$1.pathRefs(editor);
    refs.add(ref);
    return ref;
  },

  /**
   * Get the set of currently tracked path refs of the editor.
   */
  pathRefs: function pathRefs(editor) {
    var refs = PATH_REFS.get(editor);

    if (!refs) {
      refs = new Set();
      PATH_REFS.set(editor, refs);
    }

    return refs;
  },

  /**
   * Get the start or end point of a location.
   */
  point: function point(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$edge = options.edge,
        edge = _options$edge === void 0 ? 'start' : _options$edge;

    if (Path.isPath(at)) {
      var path;

      if (edge === 'end') {
        var _Node$last3 = Node.last(editor, at),
            _Node$last4 = _slicedToArray$2(_Node$last3, 2),
            lastPath = _Node$last4[1];

        path = lastPath;
      } else {
        var _Node$first3 = Node.first(editor, at),
            _Node$first4 = _slicedToArray$2(_Node$first3, 2),
            firstPath = _Node$first4[1];

        path = firstPath;
      }

      var node = Node.get(editor, path);

      if (!Text.isText(node)) {
        throw new Error("Cannot get the ".concat(edge, " point in the node at path [").concat(at, "] because it has no ").concat(edge, " text node."));
      }

      return {
        path: path,
        offset: edge === 'end' ? node.text.length : 0
      };
    }

    if (Range.isRange(at)) {
      var _Range$edges = Range.edges(at),
          _Range$edges2 = _slicedToArray$2(_Range$edges, 2),
          start = _Range$edges2[0],
          end = _Range$edges2[1];

      return edge === 'start' ? start : end;
    }

    return at;
  },

  /**
   * Create a mutable ref for a `Point` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  pointRef: function pointRef(editor, point) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$affinity2 = options.affinity,
        affinity = _options$affinity2 === void 0 ? 'forward' : _options$affinity2;
    var ref = {
      current: point,
      affinity: affinity,
      unref: function unref() {
        var current = ref.current;
        var pointRefs = Editor$1.pointRefs(editor);
        pointRefs["delete"](ref);
        ref.current = null;
        return current;
      }
    };
    var refs = Editor$1.pointRefs(editor);
    refs.add(ref);
    return ref;
  },

  /**
   * Get the set of currently tracked point refs of the editor.
   */
  pointRefs: function pointRefs(editor) {
    var refs = POINT_REFS.get(editor);

    if (!refs) {
      refs = new Set();
      POINT_REFS.set(editor, refs);
    }

    return refs;
  },

  /**
   * Return all the positions in `at` range where a `Point` can be placed.
   *
   * By default, moves forward by individual offsets at a time, but
   * the `unit` option can be used to to move by character, word, line, or block.
   *
   * The `reverse` option can be used to change iteration direction.
   *
   * Note: By default void nodes are treated as a single point and iteration
   * will not happen inside their content unless you pass in true for the
   * `voids` option, then iteration will occur.
   */
  positions: /*#__PURE__*/regenerator.mark(function positions(editor) {
    var options,
        _options$at5,
        at,
        _options$unit3,
        unit,
        _options$reverse3,
        reverse,
        _options$voids5,
        voids,
        range,
        _Range$edges3,
        _Range$edges4,
        start,
        end,
        first,
        isNewBlock,
        blockText,
        distance,
        leafTextRemaining,
        leafTextOffset,
        _iterator15,
        _step15,
        _step15$value,
        node,
        path,
        e,
        s,
        isFirst,
        calcDistance,
        _args4 = arguments;

    return regenerator.wrap(function positions$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            calcDistance = function _calcDistance(text, unit, reverse) {
              if (unit === 'character') {
                return getCharacterDistance(text, reverse);
              } else if (unit === 'word') {
                return getWordDistance(text, reverse);
              } else if (unit === 'line' || unit === 'block') {
                return text.length;
              }

              return 1;
            };

            options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            _options$at5 = options.at, at = _options$at5 === void 0 ? editor.selection : _options$at5, _options$unit3 = options.unit, unit = _options$unit3 === void 0 ? 'offset' : _options$unit3, _options$reverse3 = options.reverse, reverse = _options$reverse3 === void 0 ? false : _options$reverse3, _options$voids5 = options.voids, voids = _options$voids5 === void 0 ? false : _options$voids5;

            if (at) {
              _context4.next = 5;
              break;
            }

            return _context4.abrupt("return");

          case 5:
            /**
             * Algorithm notes:
             *
             * Each step `distance` is dynamic depending on the underlying text
             * and the `unit` specified.  Each step, e.g., a line or word, may
             * span multiple text nodes, so we iterate through the text both on
             * two levels in step-sync:
             *
             * `leafText` stores the text on a text leaf level, and is advanced
             * through using the counters `leafTextOffset` and `leafTextRemaining`.
             *
             * `blockText` stores the text on a block level, and is shortened
             * by `distance` every time it is advanced.
             *
             * We only maintain a window of one blockText and one leafText because
             * a block node always appears before all of its leaf nodes.
             */
            range = Editor$1.range(editor, at);
            _Range$edges3 = Range.edges(range), _Range$edges4 = _slicedToArray$2(_Range$edges3, 2), start = _Range$edges4[0], end = _Range$edges4[1];
            first = reverse ? end : start;
            isNewBlock = false;
            blockText = '';
            distance = 0; // Distance for leafText to catch up to blockText.

            leafTextRemaining = 0;
            leafTextOffset = 0; // Iterate through all nodes in range, grabbing entire textual content
            // of block nodes in blockText, and text nodes in leafText.
            // Exploits the fact that nodes are sequenced in such a way that we first
            // encounter the block node, then all of its text nodes, so when iterating
            // through the blockText and leafText we just need to remember a window of
            // one block node and leaf node, respectively.

            _iterator15 = _createForOfIteratorHelper$1(Editor$1.nodes(editor, {
              at: at,
              reverse: reverse,
              voids: voids
            }));
            _context4.prev = 14;

            _iterator15.s();

          case 16:
            if ((_step15 = _iterator15.n()).done) {
              _context4.next = 52;
              break;
            }

            _step15$value = _slicedToArray$2(_step15.value, 2), node = _step15$value[0], path = _step15$value[1];

            if (!Element$1.isElement(node)) {
              _context4.next = 27;
              break;
            }

            if (!(!voids && editor.isVoid(node))) {
              _context4.next = 24;
              break;
            }

            _context4.next = 22;
            return Editor$1.start(editor, path);

          case 22:
            // It's possible the start of the range we're iterating over is in a void, in which case
            // we want to make sure we don't incorrectly yield the start of a subsequent text node for unit !== 'offset'
            isNewBlock = false;
            return _context4.abrupt("continue", 50);

          case 24:
            if (!editor.isInline(node)) {
              _context4.next = 26;
              break;
            }

            return _context4.abrupt("continue", 50);

          case 26:
            // Block element node - set `blockText` to its text content.
            if (Editor$1.hasInlines(editor, node)) {
              // We always exhaust block nodes before encountering a new one:
              //   console.assert(blockText === '',
              //     `blockText='${blockText}' - `+
              //     `not exhausted before new block node`, path)
              // Ensure range considered is capped to `range`, in the
              // start/end edge cases where block extends beyond range.
              // Equivalent to this, but presumably more performant:
              //   blockRange = Editor.range(editor, ...Editor.edges(editor, path))
              //   blockRange = Range.intersection(range, blockRange) // intersect
              //   blockText = Editor.string(editor, blockRange, { voids })
              e = Path.isAncestor(path, end.path) ? end : Editor$1.end(editor, path);
              s = Path.isAncestor(path, start.path) ? start : Editor$1.start(editor, path);
              blockText = Editor$1.string(editor, {
                anchor: s,
                focus: e
              }, {
                voids: voids
              });
              isNewBlock = true;
            }

          case 27:
            if (!Text.isText(node)) {
              _context4.next = 50;
              break;
            }

            isFirst = Path.equals(path, first.path); // Proof that we always exhaust text nodes before encountering a new one:
            //   console.assert(leafTextRemaining <= 0,
            //     `leafTextRemaining=${leafTextRemaining} - `+
            //     `not exhausted before new leaf text node`, path)
            // Reset `leafText` counters for new text node.

            if (isFirst) {
              leafTextRemaining = reverse ? first.offset : node.text.length - first.offset;
              leafTextOffset = first.offset; // Works for reverse too.
            } else {
              leafTextRemaining = node.text.length;
              leafTextOffset = reverse ? leafTextRemaining : 0;
            } // Yield position at the start of node (potentially).


            if (!(isFirst || isNewBlock || unit === 'offset')) {
              _context4.next = 34;
              break;
            }

            _context4.next = 33;
            return {
              path: path,
              offset: leafTextOffset
            };

          case 33:
            isNewBlock = false;

          case 34:

            if (!(distance === 0)) {
              _context4.next = 40;
              break;
            }

            if (!(blockText === '')) {
              _context4.next = 38;
              break;
            }

            return _context4.abrupt("break", 50);

          case 38:
            distance = calcDistance(blockText, unit, reverse); // Split the string at the previously found distance and use the
            // remaining string for the next iteration.

            blockText = splitByCharacterDistance(blockText, distance, reverse)[1];

          case 40:
            // Advance `leafText` by the current `distance`.
            leafTextOffset = reverse ? leafTextOffset - distance : leafTextOffset + distance;
            leafTextRemaining = leafTextRemaining - distance; // If `leafText` is exhausted, break to get a new leaf node
            // and set distance to the overflow amount, so we'll (maybe)
            // catch up to blockText in the next leaf text node.

            if (!(leafTextRemaining < 0)) {
              _context4.next = 45;
              break;
            }

            distance = -leafTextRemaining;
            return _context4.abrupt("break", 50);

          case 45:
            // Successfully walked `distance` offsets through `leafText`
            // to catch up with `blockText`, so we can reset `distance`
            // and yield this position in this node.
            distance = 0;
            _context4.next = 48;
            return {
              path: path,
              offset: leafTextOffset
            };

          case 48:
            _context4.next = 34;
            break;

          case 50:
            _context4.next = 16;
            break;

          case 52:
            _context4.next = 57;
            break;

          case 54:
            _context4.prev = 54;
            _context4.t0 = _context4["catch"](14);

            _iterator15.e(_context4.t0);

          case 57:
            _context4.prev = 57;

            _iterator15.f();

            return _context4.finish(57);

          case 60:
          case "end":
            return _context4.stop();
        }
      }
    }, positions, null, [[14, 54, 57, 60]]);
  }),

  /**
   * Get the matching node in the branch of the document before a location.
   */
  previous: function previous(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$mode4 = options.mode,
        mode = _options$mode4 === void 0 ? 'lowest' : _options$mode4,
        _options$voids6 = options.voids,
        voids = _options$voids6 === void 0 ? false : _options$voids6;
    var match = options.match,
        _options$at6 = options.at,
        at = _options$at6 === void 0 ? editor.selection : _options$at6;

    if (!at) {
      return;
    }

    var pointBeforeLocation = Editor$1.before(editor, at, {
      voids: voids
    });

    if (!pointBeforeLocation) {
      return;
    }

    var _Editor$first = Editor$1.first(editor, []),
        _Editor$first2 = _slicedToArray$2(_Editor$first, 2),
        to = _Editor$first2[1]; // The search location is from the start of the document to the path of
    // the point before the location passed in


    var span = [pointBeforeLocation.path, to];

    if (Path.isPath(at) && at.length === 0) {
      throw new Error("Cannot get the previous node from the root node!");
    }

    if (match == null) {
      if (Path.isPath(at)) {
        var _Editor$parent3 = Editor$1.parent(editor, at),
            _Editor$parent4 = _slicedToArray$2(_Editor$parent3, 1),
            parent = _Editor$parent4[0];

        match = function match(n) {
          return parent.children.includes(n);
        };
      } else {
        match = function match() {
          return true;
        };
      }
    }

    var _Editor$nodes5 = Editor$1.nodes(editor, {
      reverse: true,
      at: span,
      match: match,
      mode: mode,
      voids: voids
    }),
        _Editor$nodes6 = _slicedToArray$2(_Editor$nodes5, 1),
        previous = _Editor$nodes6[0];

    return previous;
  },

  /**
   * Get a range of a location.
   */
  range: function range(editor, at, to) {
    if (Range.isRange(at) && !to) {
      return at;
    }

    var start = Editor$1.start(editor, at);
    var end = Editor$1.end(editor, to || at);
    return {
      anchor: start,
      focus: end
    };
  },

  /**
   * Create a mutable ref for a `Range` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  rangeRef: function rangeRef(editor, range) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$affinity3 = options.affinity,
        affinity = _options$affinity3 === void 0 ? 'forward' : _options$affinity3;
    var ref = {
      current: range,
      affinity: affinity,
      unref: function unref() {
        var current = ref.current;
        var rangeRefs = Editor$1.rangeRefs(editor);
        rangeRefs["delete"](ref);
        ref.current = null;
        return current;
      }
    };
    var refs = Editor$1.rangeRefs(editor);
    refs.add(ref);
    return ref;
  },

  /**
   * Get the set of currently tracked range refs of the editor.
   */
  rangeRefs: function rangeRefs(editor) {
    var refs = RANGE_REFS.get(editor);

    if (!refs) {
      refs = new Set();
      RANGE_REFS.set(editor, refs);
    }

    return refs;
  },

  /**
   * Remove a custom property from all of the leaf text nodes in the current
   * selection.
   *
   * If the selection is currently collapsed, the removal will be stored on
   * `editor.marks` and applied to the text inserted next.
   */
  removeMark: function removeMark(editor, key) {
    editor.removeMark(key);
  },

  /**
   * Manually set if the editor should currently be normalizing.
   *
   * Note: Using this incorrectly can leave the editor in an invalid state.
   *
   */
  setNormalizing: function setNormalizing(editor, isNormalizing) {
    NORMALIZING.set(editor, isNormalizing);
  },

  /**
   * Get the start point of a location.
   */
  start: function start(editor, at) {
    return Editor$1.point(editor, at, {
      edge: 'start'
    });
  },

  /**
   * Get the text string content of a location.
   *
   * Note: by default the text of void nodes is considered to be an empty
   * string, regardless of content, unless you pass in true for the voids option
   */
  string: function string(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$voids7 = options.voids,
        voids = _options$voids7 === void 0 ? false : _options$voids7;
    var range = Editor$1.range(editor, at);

    var _Range$edges5 = Range.edges(range),
        _Range$edges6 = _slicedToArray$2(_Range$edges5, 2),
        start = _Range$edges6[0],
        end = _Range$edges6[1];

    var text = '';

    var _iterator16 = _createForOfIteratorHelper$1(Editor$1.nodes(editor, {
      at: range,
      match: Text.isText,
      voids: voids
    })),
        _step16;

    try {
      for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
        var _step16$value = _slicedToArray$2(_step16.value, 2),
            node = _step16$value[0],
            path = _step16$value[1];

        var t = node.text;

        if (Path.equals(path, end.path)) {
          t = t.slice(0, end.offset);
        }

        if (Path.equals(path, start.path)) {
          t = t.slice(start.offset);
        }

        text += t;
      }
    } catch (err) {
      _iterator16.e(err);
    } finally {
      _iterator16.f();
    }

    return text;
  },

  /**
   * Convert a range into a non-hanging one.
   */
  unhangRange: function unhangRange(editor, range) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$voids8 = options.voids,
        voids = _options$voids8 === void 0 ? false : _options$voids8;

    var _Range$edges7 = Range.edges(range),
        _Range$edges8 = _slicedToArray$2(_Range$edges7, 2),
        start = _Range$edges8[0],
        end = _Range$edges8[1]; // PERF: exit early if we can guarantee that the range isn't hanging.


    if (start.offset !== 0 || end.offset !== 0 || Range.isCollapsed(range)) {
      return range;
    }

    var endBlock = Editor$1.above(editor, {
      at: end,
      match: function match(n) {
        return Editor$1.isBlock(editor, n);
      }
    });
    var blockPath = endBlock ? endBlock[1] : [];
    var first = Editor$1.start(editor, start);
    var before = {
      anchor: first,
      focus: end
    };
    var skip = true;

    var _iterator17 = _createForOfIteratorHelper$1(Editor$1.nodes(editor, {
      at: before,
      match: Text.isText,
      reverse: true,
      voids: voids
    })),
        _step17;

    try {
      for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
        var _step17$value = _slicedToArray$2(_step17.value, 2),
            node = _step17$value[0],
            path = _step17$value[1];

        if (skip) {
          skip = false;
          continue;
        }

        if (node.text !== '' || Path.isBefore(path, blockPath)) {
          end = {
            path: path,
            offset: node.text.length
          };
          break;
        }
      }
    } catch (err) {
      _iterator17.e(err);
    } finally {
      _iterator17.f();
    }

    return {
      anchor: start,
      focus: end
    };
  },

  /**
   * Match a void node in the current branch of the editor.
   */
  "void": function _void(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Editor$1.above(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
      match: function match(n) {
        return Editor$1.isVoid(editor, n);
      }
    }));
  },

  /**
   * Call a function, deferring normalization until after it completes.
   */
  withoutNormalizing: function withoutNormalizing(editor, fn) {
    var value = Editor$1.isNormalizing(editor);
    Editor$1.setNormalizing(editor, false);

    try {
      fn();
    } finally {
      Editor$1.setNormalizing(editor, value);
    }

    Editor$1.normalize(editor);
  }
};
var Span = {
  /**
   * Check if a value implements the `Span` interface.
   */
  isSpan: function isSpan(value) {
    return Array.isArray(value) && value.length === 2 && value.every(Path.isPath);
  }
};
var _excluded$3 = ["children"],
    _excluded2$2 = ["text"];
var IS_NODE_LIST_CACHE = new WeakMap();
var Node = {
  /**
   * Get the node at a specific path, asserting that it's an ancestor node.
   */
  ancestor: function ancestor(root, path) {
    var node = Node.get(root, path);

    if (Text.isText(node)) {
      throw new Error("Cannot get the ancestor node at path [".concat(path, "] because it refers to a text node instead: ").concat(node));
    }

    return node;
  },

  /**
   * Return a generator of all the ancestor nodes above a specific path.
   *
   * By default the order is bottom-up, from lowest to highest ancestor in
   * the tree, but you can pass the `reverse: true` option to go top-down.
   */
  ancestors: /*#__PURE__*/regenerator.mark(function ancestors(root, path) {
    var options,
        _iterator18,
        _step18,
        p,
        n,
        entry,
        _args5 = arguments;

    return regenerator.wrap(function ancestors$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            options = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
            _iterator18 = _createForOfIteratorHelper$1(Path.ancestors(path, options));
            _context5.prev = 2;

            _iterator18.s();

          case 4:
            if ((_step18 = _iterator18.n()).done) {
              _context5.next = 12;
              break;
            }

            p = _step18.value;
            n = Node.ancestor(root, p);
            entry = [n, p];
            _context5.next = 10;
            return entry;

          case 10:
            _context5.next = 4;
            break;

          case 12:
            _context5.next = 17;
            break;

          case 14:
            _context5.prev = 14;
            _context5.t0 = _context5["catch"](2);

            _iterator18.e(_context5.t0);

          case 17:
            _context5.prev = 17;

            _iterator18.f();

            return _context5.finish(17);

          case 20:
          case "end":
            return _context5.stop();
        }
      }
    }, ancestors, null, [[2, 14, 17, 20]]);
  }),

  /**
   * Get the child of a node at a specific index.
   */
  child: function child(root, index) {
    if (Text.isText(root)) {
      throw new Error("Cannot get the child of a text node: ".concat(JSON.stringify(root)));
    }

    var c = root.children[index];

    if (c == null) {
      throw new Error("Cannot get child at index `".concat(index, "` in node: ").concat(JSON.stringify(root)));
    }

    return c;
  },

  /**
   * Iterate over the children of a node at a specific path.
   */
  children: /*#__PURE__*/regenerator.mark(function children(root, path) {
    var options,
        _options$reverse4,
        reverse,
        ancestor,
        children,
        index,
        child,
        childPath,
        _args6 = arguments;

    return regenerator.wrap(function children$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            options = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
            _options$reverse4 = options.reverse, reverse = _options$reverse4 === void 0 ? false : _options$reverse4;
            ancestor = Node.ancestor(root, path);
            children = ancestor.children;
            index = reverse ? children.length - 1 : 0;

          case 5:
            if (!(reverse ? index >= 0 : index < children.length)) {
              _context6.next = 13;
              break;
            }

            child = Node.child(ancestor, index);
            childPath = path.concat(index);
            _context6.next = 10;
            return [child, childPath];

          case 10:
            index = reverse ? index - 1 : index + 1;
            _context6.next = 5;
            break;

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, children);
  }),

  /**
   * Get an entry for the common ancesetor node of two paths.
   */
  common: function common(root, path, another) {
    var p = Path.common(path, another);
    var n = Node.get(root, p);
    return [n, p];
  },

  /**
   * Get the node at a specific path, asserting that it's a descendant node.
   */
  descendant: function descendant(root, path) {
    var node = Node.get(root, path);

    if (Editor$1.isEditor(node)) {
      throw new Error("Cannot get the descendant node at path [".concat(path, "] because it refers to the root editor node instead: ").concat(node));
    }

    return node;
  },

  /**
   * Return a generator of all the descendant node entries inside a root node.
   */
  descendants: /*#__PURE__*/regenerator.mark(function descendants(root) {
    var options,
        _iterator19,
        _step19,
        _step19$value,
        node,
        path,
        _args7 = arguments;

    return regenerator.wrap(function descendants$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
            _iterator19 = _createForOfIteratorHelper$1(Node.nodes(root, options));
            _context7.prev = 2;

            _iterator19.s();

          case 4:
            if ((_step19 = _iterator19.n()).done) {
              _context7.next = 11;
              break;
            }

            _step19$value = _slicedToArray$2(_step19.value, 2), node = _step19$value[0], path = _step19$value[1];

            if (!(path.length !== 0)) {
              _context7.next = 9;
              break;
            }

            _context7.next = 9;
            return [node, path];

          case 9:
            _context7.next = 4;
            break;

          case 11:
            _context7.next = 16;
            break;

          case 13:
            _context7.prev = 13;
            _context7.t0 = _context7["catch"](2);

            _iterator19.e(_context7.t0);

          case 16:
            _context7.prev = 16;

            _iterator19.f();

            return _context7.finish(16);

          case 19:
          case "end":
            return _context7.stop();
        }
      }
    }, descendants, null, [[2, 13, 16, 19]]);
  }),

  /**
   * Return a generator of all the element nodes inside a root node. Each iteration
   * will return an `ElementEntry` tuple consisting of `[Element, Path]`. If the
   * root node is an element it will be included in the iteration as well.
   */
  elements: /*#__PURE__*/regenerator.mark(function elements(root) {
    var options,
        _iterator20,
        _step20,
        _step20$value,
        node,
        path,
        _args8 = arguments;

    return regenerator.wrap(function elements$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            options = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
            _iterator20 = _createForOfIteratorHelper$1(Node.nodes(root, options));
            _context8.prev = 2;

            _iterator20.s();

          case 4:
            if ((_step20 = _iterator20.n()).done) {
              _context8.next = 11;
              break;
            }

            _step20$value = _slicedToArray$2(_step20.value, 2), node = _step20$value[0], path = _step20$value[1];

            if (!Element$1.isElement(node)) {
              _context8.next = 9;
              break;
            }

            _context8.next = 9;
            return [node, path];

          case 9:
            _context8.next = 4;
            break;

          case 11:
            _context8.next = 16;
            break;

          case 13:
            _context8.prev = 13;
            _context8.t0 = _context8["catch"](2);

            _iterator20.e(_context8.t0);

          case 16:
            _context8.prev = 16;

            _iterator20.f();

            return _context8.finish(16);

          case 19:
          case "end":
            return _context8.stop();
        }
      }
    }, elements, null, [[2, 13, 16, 19]]);
  }),

  /**
   * Extract props from a Node.
   */
  extractProps: function extractProps(node) {
    if (Element$1.isAncestor(node)) {
      var properties = _objectWithoutProperties(node, _excluded$3);

      return properties;
    } else {
      var properties = _objectWithoutProperties(node, _excluded2$2);

      return properties;
    }
  },

  /**
   * Get the first node entry in a root node from a path.
   */
  first: function first(root, path) {
    var p = path.slice();
    var n = Node.get(root, p);

    while (n) {
      if (Text.isText(n) || n.children.length === 0) {
        break;
      } else {
        n = n.children[0];
        p.push(0);
      }
    }

    return [n, p];
  },

  /**
   * Get the sliced fragment represented by a range inside a root node.
   */
  fragment: function fragment(root, range) {
    if (Text.isText(root)) {
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(JSON.stringify(root)));
    }

    var newRoot = fn({
      children: root.children
    }, function (r) {
      var _Range$edges9 = Range.edges(range),
          _Range$edges10 = _slicedToArray$2(_Range$edges9, 2),
          start = _Range$edges10[0],
          end = _Range$edges10[1];

      var nodeEntries = Node.nodes(r, {
        reverse: true,
        pass: function pass(_ref) {
          var _ref11 = _slicedToArray$2(_ref, 2),
              path = _ref11[1];

          return !Range.includes(range, path);
        }
      });

      var _iterator21 = _createForOfIteratorHelper$1(nodeEntries),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var _step21$value = _slicedToArray$2(_step21.value, 2),
              path = _step21$value[1];

          if (!Range.includes(range, path)) {
            var parent = Node.parent(r, path);
            var index = path[path.length - 1];
            parent.children.splice(index, 1);
          }

          if (Path.equals(path, end.path)) {
            var leaf = Node.leaf(r, path);
            leaf.text = leaf.text.slice(0, end.offset);
          }

          if (Path.equals(path, start.path)) {
            var _leaf = Node.leaf(r, path);

            _leaf.text = _leaf.text.slice(start.offset);
          }
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }

      if (Editor$1.isEditor(r)) {
        r.selection = null;
      }
    });
    return newRoot.children;
  },

  /**
   * Get the descendant node referred to by a specific path. If the path is an
   * empty array, it refers to the root node itself.
   */
  get: function get(root, path) {
    var node = root;

    for (var i = 0; i < path.length; i++) {
      var p = path[i];

      if (Text.isText(node) || !node.children[p]) {
        throw new Error("Cannot find a descendant at path [".concat(path, "] in node: ").concat(JSON.stringify(root)));
      }

      node = node.children[p];
    }

    return node;
  },

  /**
   * Check if a descendant node exists at a specific path.
   */
  has: function has(root, path) {
    var node = root;

    for (var i = 0; i < path.length; i++) {
      var p = path[i];

      if (Text.isText(node) || !node.children[p]) {
        return false;
      }

      node = node.children[p];
    }

    return true;
  },

  /**
   * Check if a value implements the `Node` interface.
   */
  isNode: function isNode(value) {
    return Text.isText(value) || Element$1.isElement(value) || Editor$1.isEditor(value);
  },

  /**
   * Check if a value is a list of `Node` objects.
   */
  isNodeList: function isNodeList(value) {
    if (!Array.isArray(value)) {
      return false;
    }

    var cachedResult = IS_NODE_LIST_CACHE.get(value);

    if (cachedResult !== undefined) {
      return cachedResult;
    }

    var isNodeList = value.every(function (val) {
      return Node.isNode(val);
    });
    IS_NODE_LIST_CACHE.set(value, isNodeList);
    return isNodeList;
  },

  /**
   * Get the last node entry in a root node from a path.
   */
  last: function last(root, path) {
    var p = path.slice();
    var n = Node.get(root, p);

    while (n) {
      if (Text.isText(n) || n.children.length === 0) {
        break;
      } else {
        var i = n.children.length - 1;
        n = n.children[i];
        p.push(i);
      }
    }

    return [n, p];
  },

  /**
   * Get the node at a specific path, ensuring it's a leaf text node.
   */
  leaf: function leaf(root, path) {
    var node = Node.get(root, path);

    if (!Text.isText(node)) {
      throw new Error("Cannot get the leaf node at path [".concat(path, "] because it refers to a non-leaf node: ").concat(node));
    }

    return node;
  },

  /**
   * Return a generator of the in a branch of the tree, from a specific path.
   *
   * By default the order is top-down, from lowest to highest node in the tree,
   * but you can pass the `reverse: true` option to go bottom-up.
   */
  levels: /*#__PURE__*/regenerator.mark(function levels(root, path) {
    var options,
        _iterator22,
        _step22,
        p,
        n,
        _args9 = arguments;

    return regenerator.wrap(function levels$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            options = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : {};
            _iterator22 = _createForOfIteratorHelper$1(Path.levels(path, options));
            _context9.prev = 2;

            _iterator22.s();

          case 4:
            if ((_step22 = _iterator22.n()).done) {
              _context9.next = 11;
              break;
            }

            p = _step22.value;
            n = Node.get(root, p);
            _context9.next = 9;
            return [n, p];

          case 9:
            _context9.next = 4;
            break;

          case 11:
            _context9.next = 16;
            break;

          case 13:
            _context9.prev = 13;
            _context9.t0 = _context9["catch"](2);

            _iterator22.e(_context9.t0);

          case 16:
            _context9.prev = 16;

            _iterator22.f();

            return _context9.finish(16);

          case 19:
          case "end":
            return _context9.stop();
        }
      }
    }, levels, null, [[2, 13, 16, 19]]);
  }),

  /**
   * Check if a node matches a set of props.
   */
  matches: function matches(node, props) {
    return Element$1.isElement(node) && Element$1.isElementProps(props) && Element$1.matches(node, props) || Text.isText(node) && Text.isTextProps(props) && Text.matches(node, props);
  },

  /**
   * Return a generator of all the node entries of a root node. Each entry is
   * returned as a `[Node, Path]` tuple, with the path referring to the node's
   * position inside the root node.
   */
  nodes: /*#__PURE__*/regenerator.mark(function nodes(root) {
    var options,
        pass,
        _options$reverse5,
        reverse,
        _options$from,
        from,
        to,
        visited,
        p,
        n,
        nextIndex,
        newPath,
        _newPath,
        _args10 = arguments;

    return regenerator.wrap(function nodes$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            options = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
            pass = options.pass, _options$reverse5 = options.reverse, reverse = _options$reverse5 === void 0 ? false : _options$reverse5;
            _options$from = options.from, from = _options$from === void 0 ? [] : _options$from, to = options.to;
            visited = new Set();
            p = [];
            n = root;

          case 6:

            if (!(to && (reverse ? Path.isBefore(p, to) : Path.isAfter(p, to)))) {
              _context10.next = 9;
              break;
            }

            return _context10.abrupt("break", 37);

          case 9:
            if (visited.has(n)) {
              _context10.next = 12;
              break;
            }

            _context10.next = 12;
            return [n, p];

          case 12:
            if (!(!visited.has(n) && !Text.isText(n) && n.children.length !== 0 && (pass == null || pass([n, p]) === false))) {
              _context10.next = 19;
              break;
            }

            visited.add(n);
            nextIndex = reverse ? n.children.length - 1 : 0;

            if (Path.isAncestor(p, from)) {
              nextIndex = from[p.length];
            }

            p = p.concat(nextIndex);
            n = Node.get(root, p);
            return _context10.abrupt("continue", 6);

          case 19:
            if (!(p.length === 0)) {
              _context10.next = 21;
              break;
            }

            return _context10.abrupt("break", 37);

          case 21:
            if (reverse) {
              _context10.next = 27;
              break;
            }

            newPath = Path.next(p);

            if (!Node.has(root, newPath)) {
              _context10.next = 27;
              break;
            }

            p = newPath;
            n = Node.get(root, p);
            return _context10.abrupt("continue", 6);

          case 27:
            if (!(reverse && p[p.length - 1] !== 0)) {
              _context10.next = 32;
              break;
            }

            _newPath = Path.previous(p);
            p = _newPath;
            n = Node.get(root, p);
            return _context10.abrupt("continue", 6);

          case 32:
            // Otherwise we're going upward...
            p = Path.parent(p);
            n = Node.get(root, p);
            visited.add(n);
            _context10.next = 6;
            break;

          case 37:
          case "end":
            return _context10.stop();
        }
      }
    }, nodes);
  }),

  /**
   * Get the parent of a node at a specific path.
   */
  parent: function parent(root, path) {
    var parentPath = Path.parent(path);
    var p = Node.get(root, parentPath);

    if (Text.isText(p)) {
      throw new Error("Cannot get the parent of path [".concat(path, "] because it does not exist in the root."));
    }

    return p;
  },

  /**
   * Get the concatenated text string of a node's content.
   *
   * Note that this will not include spaces or line breaks between block nodes.
   * It is not a user-facing string, but a string for performing offset-related
   * computations for a node.
   */
  string: function string(node) {
    if (Text.isText(node)) {
      return node.text;
    } else {
      return node.children.map(Node.string).join('');
    }
  },

  /**
   * Return a generator of all leaf text nodes in a root node.
   */
  texts: /*#__PURE__*/regenerator.mark(function texts(root) {
    var options,
        _iterator23,
        _step23,
        _step23$value,
        node,
        path,
        _args11 = arguments;

    return regenerator.wrap(function texts$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            options = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {};
            _iterator23 = _createForOfIteratorHelper$1(Node.nodes(root, options));
            _context11.prev = 2;

            _iterator23.s();

          case 4:
            if ((_step23 = _iterator23.n()).done) {
              _context11.next = 11;
              break;
            }

            _step23$value = _slicedToArray$2(_step23.value, 2), node = _step23$value[0], path = _step23$value[1];

            if (!Text.isText(node)) {
              _context11.next = 9;
              break;
            }

            _context11.next = 9;
            return [node, path];

          case 9:
            _context11.next = 4;
            break;

          case 11:
            _context11.next = 16;
            break;

          case 13:
            _context11.prev = 13;
            _context11.t0 = _context11["catch"](2);

            _iterator23.e(_context11.t0);

          case 16:
            _context11.prev = 16;

            _iterator23.f();

            return _context11.finish(16);

          case 19:
          case "end":
            return _context11.stop();
        }
      }
    }, texts, null, [[2, 13, 16, 19]]);
  })
};

function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$7(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$7(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Operation = {
  /**
   * Check of a value is a `NodeOperation` object.
   */
  isNodeOperation: function isNodeOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_node');
  },

  /**
   * Check of a value is an `Operation` object.
   */
  isOperation: function isOperation(value) {
    if (!isPlainObject(value)) {
      return false;
    }

    switch (value.type) {
      case 'insert_node':
        return Path.isPath(value.path) && Node.isNode(value.node);

      case 'insert_text':
        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);

      case 'merge_node':
        return typeof value.position === 'number' && Path.isPath(value.path) && isPlainObject(value.properties);

      case 'move_node':
        return Path.isPath(value.path) && Path.isPath(value.newPath);

      case 'remove_node':
        return Path.isPath(value.path) && Node.isNode(value.node);

      case 'remove_text':
        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);

      case 'set_node':
        return Path.isPath(value.path) && isPlainObject(value.properties) && isPlainObject(value.newProperties);

      case 'set_selection':
        return value.properties === null && Range.isRange(value.newProperties) || value.newProperties === null && Range.isRange(value.properties) || isPlainObject(value.properties) && isPlainObject(value.newProperties);

      case 'split_node':
        return Path.isPath(value.path) && typeof value.position === 'number' && isPlainObject(value.properties);

      default:
        return false;
    }
  },

  /**
   * Check if a value is a list of `Operation` objects.
   */
  isOperationList: function isOperationList(value) {
    return Array.isArray(value) && value.every(function (val) {
      return Operation.isOperation(val);
    });
  },

  /**
   * Check of a value is a `SelectionOperation` object.
   */
  isSelectionOperation: function isSelectionOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_selection');
  },

  /**
   * Check of a value is a `TextOperation` object.
   */
  isTextOperation: function isTextOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_text');
  },

  /**
   * Invert an operation, returning a new operation that will exactly undo the
   * original when applied.
   */
  inverse: function inverse(op) {
    switch (op.type) {
      case 'insert_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'remove_node'
          });
        }

      case 'insert_text':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'remove_text'
          });
        }

      case 'merge_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'split_node',
            path: Path.previous(op.path)
          });
        }

      case 'move_node':
        {
          var newPath = op.newPath,
              path = op.path; // PERF: in this case the move operation is a no-op anyways.

          if (Path.equals(newPath, path)) {
            return op;
          } // If the move happens completely within a single parent the path and
          // newPath are stable with respect to each other.


          if (Path.isSibling(path, newPath)) {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              path: newPath,
              newPath: path
            });
          } // If the move does not happen within a single parent it is possible
          // for the move to impact the true path to the location where the node
          // was removed from and where it was inserted. We have to adjust for this
          // and find the original path. We can accomplish this (only in non-sibling)
          // moves by looking at the impact of the move operation on the node
          // after the original move path.


          var inversePath = Path.transform(path, op);
          var inverseNewPath = Path.transform(Path.next(path), op);
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            path: inversePath,
            newPath: inverseNewPath
          });
        }

      case 'remove_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'insert_node'
          });
        }

      case 'remove_text':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'insert_text'
          });
        }

      case 'set_node':
        {
          var properties = op.properties,
              newProperties = op.newProperties;
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            properties: newProperties,
            newProperties: properties
          });
        }

      case 'set_selection':
        {
          var _properties = op.properties,
              _newProperties = op.newProperties;

          if (_properties == null) {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              properties: _newProperties,
              newProperties: null
            });
          } else if (_newProperties == null) {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              properties: null,
              newProperties: _properties
            });
          } else {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              properties: _newProperties,
              newProperties: _properties
            });
          }
        }

      case 'split_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'merge_node',
            path: Path.next(op.path)
          });
        }
    }
  }
};
var Path = {
  /**
   * Get a list of ancestor paths for a given path.
   *
   * The paths are sorted from deepest to shallowest ancestor. However, if the
   * `reverse: true` option is passed, they are reversed.
   */
  ancestors: function ancestors(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$reverse6 = options.reverse,
        reverse = _options$reverse6 === void 0 ? false : _options$reverse6;
    var paths = Path.levels(path, options);

    if (reverse) {
      paths = paths.slice(1);
    } else {
      paths = paths.slice(0, -1);
    }

    return paths;
  },

  /**
   * Get the common ancestor path of two paths.
   */
  common: function common(path, another) {
    var common = [];

    for (var i = 0; i < path.length && i < another.length; i++) {
      var av = path[i];
      var bv = another[i];

      if (av !== bv) {
        break;
      }

      common.push(av);
    }

    return common;
  },

  /**
   * Compare a path to another, returning an integer indicating whether the path
   * was before, at, or after the other.
   *
   * Note: Two paths of unequal length can still receive a `0` result if one is
   * directly above or below the other. If you want exact matching, use
   * [[Path.equals]] instead.
   */
  compare: function compare(path, another) {
    var min = Math.min(path.length, another.length);

    for (var i = 0; i < min; i++) {
      if (path[i] < another[i]) return -1;
      if (path[i] > another[i]) return 1;
    }

    return 0;
  },

  /**
   * Check if a path ends after one of the indexes in another.
   */
  endsAfter: function endsAfter(path, another) {
    var i = path.length - 1;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    var av = path[i];
    var bv = another[i];
    return Path.equals(as, bs) && av > bv;
  },

  /**
   * Check if a path ends at one of the indexes in another.
   */
  endsAt: function endsAt(path, another) {
    var i = path.length;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    return Path.equals(as, bs);
  },

  /**
   * Check if a path ends before one of the indexes in another.
   */
  endsBefore: function endsBefore(path, another) {
    var i = path.length - 1;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    var av = path[i];
    var bv = another[i];
    return Path.equals(as, bs) && av < bv;
  },

  /**
   * Check if a path is exactly equal to another.
   */
  equals: function equals(path, another) {
    return path.length === another.length && path.every(function (n, i) {
      return n === another[i];
    });
  },

  /**
   * Check if the path of previous sibling node exists
   */
  hasPrevious: function hasPrevious(path) {
    return path[path.length - 1] > 0;
  },

  /**
   * Check if a path is after another.
   */
  isAfter: function isAfter(path, another) {
    return Path.compare(path, another) === 1;
  },

  /**
   * Check if a path is an ancestor of another.
   */
  isAncestor: function isAncestor(path, another) {
    return path.length < another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is before another.
   */
  isBefore: function isBefore(path, another) {
    return Path.compare(path, another) === -1;
  },

  /**
   * Check if a path is a child of another.
   */
  isChild: function isChild(path, another) {
    return path.length === another.length + 1 && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is equal to or an ancestor of another.
   */
  isCommon: function isCommon(path, another) {
    return path.length <= another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is a descendant of another.
   */
  isDescendant: function isDescendant(path, another) {
    return path.length > another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is the parent of another.
   */
  isParent: function isParent(path, another) {
    return path.length + 1 === another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check is a value implements the `Path` interface.
   */
  isPath: function isPath(value) {
    return Array.isArray(value) && (value.length === 0 || typeof value[0] === 'number');
  },

  /**
   * Check if a path is a sibling of another.
   */
  isSibling: function isSibling(path, another) {
    if (path.length !== another.length) {
      return false;
    }

    var as = path.slice(0, -1);
    var bs = another.slice(0, -1);
    var al = path[path.length - 1];
    var bl = another[another.length - 1];
    return al !== bl && Path.equals(as, bs);
  },

  /**
   * Get a list of paths at every level down to a path. Note: this is the same
   * as `Path.ancestors`, but including the path itself.
   *
   * The paths are sorted from shallowest to deepest. However, if the `reverse:
   * true` option is passed, they are reversed.
   */
  levels: function levels(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$reverse7 = options.reverse,
        reverse = _options$reverse7 === void 0 ? false : _options$reverse7;
    var list = [];

    for (var i = 0; i <= path.length; i++) {
      list.push(path.slice(0, i));
    }

    if (reverse) {
      list.reverse();
    }

    return list;
  },

  /**
   * Given a path, get the path to the next sibling node.
   */
  next: function next(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the next path of a root path [".concat(path, "], because it has no next index."));
    }

    var last = path[path.length - 1];
    return path.slice(0, -1).concat(last + 1);
  },

  /**
   * Returns whether this operation can affect paths or not. Used as an
   * optimization when updating dirty paths during normalization
   *
   * NOTE: This *must* be kept in sync with the implementation of 'transform'
   * below
   */
  operationCanTransformPath: function operationCanTransformPath(operation) {
    switch (operation.type) {
      case 'insert_node':
      case 'remove_node':
      case 'merge_node':
      case 'split_node':
      case 'move_node':
        return true;

      default:
        return false;
    }
  },

  /**
   * Given a path, return a new path referring to the parent node above it.
   */
  parent: function parent(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the parent path of the root path [".concat(path, "]."));
    }

    return path.slice(0, -1);
  },

  /**
   * Given a path, get the path to the previous sibling node.
   */
  previous: function previous(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the previous path of a root path [".concat(path, "], because it has no previous index."));
    }

    var last = path[path.length - 1];

    if (last <= 0) {
      throw new Error("Cannot get the previous path of a first child path [".concat(path, "] because it would result in a negative index."));
    }

    return path.slice(0, -1).concat(last - 1);
  },

  /**
   * Get a path relative to an ancestor.
   */
  relative: function relative(path, ancestor) {
    if (!Path.isAncestor(ancestor, path) && !Path.equals(path, ancestor)) {
      throw new Error("Cannot get the relative path of [".concat(path, "] inside ancestor [").concat(ancestor, "], because it is not above or equal to the path."));
    }

    return path.slice(ancestor.length);
  },

  /**
   * Transform a path by an operation.
   */
  transform: function transform(path, operation) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return fn(path, function (p) {
      var _options$affinity4 = options.affinity,
          affinity = _options$affinity4 === void 0 ? 'forward' : _options$affinity4; // PERF: Exit early if the operation is guaranteed not to have an effect.

      if (!path || (path === null || path === void 0 ? void 0 : path.length) === 0) {
        return;
      }

      if (p === null) {
        return null;
      }

      switch (operation.type) {
        case 'insert_node':
          {
            var op = operation.path;

            if (Path.equals(op, p) || Path.endsBefore(op, p) || Path.isAncestor(op, p)) {
              p[op.length - 1] += 1;
            }

            break;
          }

        case 'remove_node':
          {
            var _op = operation.path;

            if (Path.equals(_op, p) || Path.isAncestor(_op, p)) {
              return null;
            } else if (Path.endsBefore(_op, p)) {
              p[_op.length - 1] -= 1;
            }

            break;
          }

        case 'merge_node':
          {
            var _op2 = operation.path,
                position = operation.position;

            if (Path.equals(_op2, p) || Path.endsBefore(_op2, p)) {
              p[_op2.length - 1] -= 1;
            } else if (Path.isAncestor(_op2, p)) {
              p[_op2.length - 1] -= 1;
              p[_op2.length] += position;
            }

            break;
          }

        case 'split_node':
          {
            var _op3 = operation.path,
                _position = operation.position;

            if (Path.equals(_op3, p)) {
              if (affinity === 'forward') {
                p[p.length - 1] += 1;
              } else if (affinity === 'backward') ;else {
                return null;
              }
            } else if (Path.endsBefore(_op3, p)) {
              p[_op3.length - 1] += 1;
            } else if (Path.isAncestor(_op3, p) && path[_op3.length] >= _position) {
              p[_op3.length - 1] += 1;
              p[_op3.length] -= _position;
            }

            break;
          }

        case 'move_node':
          {
            var _op4 = operation.path,
                onp = operation.newPath; // If the old and new path are the same, it's a no-op.

            if (Path.equals(_op4, onp)) {
              return;
            }

            if (Path.isAncestor(_op4, p) || Path.equals(_op4, p)) {
              var copy = onp.slice();

              if (Path.endsBefore(_op4, onp) && _op4.length < onp.length) {
                copy[_op4.length - 1] -= 1;
              }

              return copy.concat(p.slice(_op4.length));
            } else if (Path.isSibling(_op4, onp) && (Path.isAncestor(onp, p) || Path.equals(onp, p))) {
              if (Path.endsBefore(_op4, p)) {
                p[_op4.length - 1] -= 1;
              } else {
                p[_op4.length - 1] += 1;
              }
            } else if (Path.endsBefore(onp, p) || Path.equals(onp, p) || Path.isAncestor(onp, p)) {
              if (Path.endsBefore(_op4, p)) {
                p[_op4.length - 1] -= 1;
              }

              p[onp.length - 1] += 1;
            } else if (Path.endsBefore(_op4, p)) {
              if (Path.equals(onp, p)) {
                p[onp.length - 1] += 1;
              }

              p[_op4.length - 1] -= 1;
            }

            break;
          }
      }
    });
  }
};
var PathRef = {
  /**
   * Transform the path ref's current value by an operation.
   */
  transform: function transform(ref, op) {
    var current = ref.current,
        affinity = ref.affinity;

    if (current == null) {
      return;
    }

    var path = Path.transform(current, op, {
      affinity: affinity
    });
    ref.current = path;

    if (path == null) {
      ref.unref();
    }
  }
};

function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$6(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$6(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Point = {
  /**
   * Compare a point to another, returning an integer indicating whether the
   * point was before, at, or after the other.
   */
  compare: function compare(point, another) {
    var result = Path.compare(point.path, another.path);

    if (result === 0) {
      if (point.offset < another.offset) return -1;
      if (point.offset > another.offset) return 1;
      return 0;
    }

    return result;
  },

  /**
   * Check if a point is after another.
   */
  isAfter: function isAfter(point, another) {
    return Point.compare(point, another) === 1;
  },

  /**
   * Check if a point is before another.
   */
  isBefore: function isBefore(point, another) {
    return Point.compare(point, another) === -1;
  },

  /**
   * Check if a point is exactly equal to another.
   */
  equals: function equals(point, another) {
    // PERF: ensure the offsets are equal first since they are cheaper to check.
    return point.offset === another.offset && Path.equals(point.path, another.path);
  },

  /**
   * Check if a value implements the `Point` interface.
   */
  isPoint: function isPoint(value) {
    return isPlainObject(value) && typeof value.offset === 'number' && Path.isPath(value.path);
  },

  /**
   * Transform a point by an operation.
   */
  transform: function transform(point, op) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return fn(point, function (p) {
      if (p === null) {
        return null;
      }

      var _options$affinity5 = options.affinity,
          affinity = _options$affinity5 === void 0 ? 'forward' : _options$affinity5;
      var path = p.path,
          offset = p.offset;

      switch (op.type) {
        case 'insert_node':
        case 'move_node':
          {
            p.path = Path.transform(path, op, options);
            break;
          }

        case 'insert_text':
          {
            if (Path.equals(op.path, path) && (op.offset < offset || op.offset === offset && affinity === 'forward')) {
              p.offset += op.text.length;
            }

            break;
          }

        case 'merge_node':
          {
            if (Path.equals(op.path, path)) {
              p.offset += op.position;
            }

            p.path = Path.transform(path, op, options);
            break;
          }

        case 'remove_text':
          {
            if (Path.equals(op.path, path) && op.offset <= offset) {
              p.offset -= Math.min(offset - op.offset, op.text.length);
            }

            break;
          }

        case 'remove_node':
          {
            if (Path.equals(op.path, path) || Path.isAncestor(op.path, path)) {
              return null;
            }

            p.path = Path.transform(path, op, options);
            break;
          }

        case 'split_node':
          {
            if (Path.equals(op.path, path)) {
              if (op.position === offset && affinity == null) {
                return null;
              } else if (op.position < offset || op.position === offset && affinity === 'forward') {
                p.offset -= op.position;
                p.path = Path.transform(path, op, _objectSpread$6(_objectSpread$6({}, options), {}, {
                  affinity: 'forward'
                }));
              }
            } else {
              p.path = Path.transform(path, op, options);
            }

            break;
          }
      }
    });
  }
};
var PointRef = {
  /**
   * Transform the point ref's current value by an operation.
   */
  transform: function transform(ref, op) {
    var current = ref.current,
        affinity = ref.affinity;

    if (current == null) {
      return;
    }

    var point = Point.transform(current, op, {
      affinity: affinity
    });
    ref.current = point;

    if (point == null) {
      ref.unref();
    }
  }
};
var _excluded$2 = ["anchor", "focus"];

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Range = {
  /**
   * Get the start and end points of a range, in the order in which they appear
   * in the document.
   */
  edges: function edges(range) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$reverse8 = options.reverse,
        reverse = _options$reverse8 === void 0 ? false : _options$reverse8;
    var anchor = range.anchor,
        focus = range.focus;
    return Range.isBackward(range) === reverse ? [anchor, focus] : [focus, anchor];
  },

  /**
   * Get the end point of a range.
   */
  end: function end(range) {
    var _Range$edges11 = Range.edges(range),
        _Range$edges12 = _slicedToArray$2(_Range$edges11, 2),
        end = _Range$edges12[1];

    return end;
  },

  /**
   * Check if a range is exactly equal to another.
   */
  equals: function equals(range, another) {
    return Point.equals(range.anchor, another.anchor) && Point.equals(range.focus, another.focus);
  },

  /**
   * Check if a range includes a path, a point or part of another range.
   */
  includes: function includes(range, target) {
    if (Range.isRange(target)) {
      if (Range.includes(range, target.anchor) || Range.includes(range, target.focus)) {
        return true;
      }

      var _Range$edges13 = Range.edges(range),
          _Range$edges14 = _slicedToArray$2(_Range$edges13, 2),
          rs = _Range$edges14[0],
          re = _Range$edges14[1];

      var _Range$edges15 = Range.edges(target),
          _Range$edges16 = _slicedToArray$2(_Range$edges15, 2),
          ts = _Range$edges16[0],
          te = _Range$edges16[1];

      return Point.isBefore(rs, ts) && Point.isAfter(re, te);
    }

    var _Range$edges17 = Range.edges(range),
        _Range$edges18 = _slicedToArray$2(_Range$edges17, 2),
        start = _Range$edges18[0],
        end = _Range$edges18[1];

    var isAfterStart = false;
    var isBeforeEnd = false;

    if (Point.isPoint(target)) {
      isAfterStart = Point.compare(target, start) >= 0;
      isBeforeEnd = Point.compare(target, end) <= 0;
    } else {
      isAfterStart = Path.compare(target, start.path) >= 0;
      isBeforeEnd = Path.compare(target, end.path) <= 0;
    }

    return isAfterStart && isBeforeEnd;
  },

  /**
   * Get the intersection of a range with another.
   */
  intersection: function intersection(range, another) {
    var rest = _objectWithoutProperties(range, _excluded$2);

    var _Range$edges19 = Range.edges(range),
        _Range$edges20 = _slicedToArray$2(_Range$edges19, 2),
        s1 = _Range$edges20[0],
        e1 = _Range$edges20[1];

    var _Range$edges21 = Range.edges(another),
        _Range$edges22 = _slicedToArray$2(_Range$edges21, 2),
        s2 = _Range$edges22[0],
        e2 = _Range$edges22[1];

    var start = Point.isBefore(s1, s2) ? s2 : s1;
    var end = Point.isBefore(e1, e2) ? e1 : e2;

    if (Point.isBefore(end, start)) {
      return null;
    } else {
      return _objectSpread$5({
        anchor: start,
        focus: end
      }, rest);
    }
  },

  /**
   * Check if a range is backward, meaning that its anchor point appears in the
   * document _after_ its focus point.
   */
  isBackward: function isBackward(range) {
    var anchor = range.anchor,
        focus = range.focus;
    return Point.isAfter(anchor, focus);
  },

  /**
   * Check if a range is collapsed, meaning that both its anchor and focus
   * points refer to the exact same position in the document.
   */
  isCollapsed: function isCollapsed(range) {
    var anchor = range.anchor,
        focus = range.focus;
    return Point.equals(anchor, focus);
  },

  /**
   * Check if a range is expanded.
   *
   * This is the opposite of [[Range.isCollapsed]] and is provided for legibility.
   */
  isExpanded: function isExpanded(range) {
    return !Range.isCollapsed(range);
  },

  /**
   * Check if a range is forward.
   *
   * This is the opposite of [[Range.isBackward]] and is provided for legibility.
   */
  isForward: function isForward(range) {
    return !Range.isBackward(range);
  },

  /**
   * Check if a value implements the [[Range]] interface.
   */
  isRange: function isRange(value) {
    return isPlainObject(value) && Point.isPoint(value.anchor) && Point.isPoint(value.focus);
  },

  /**
   * Iterate through all of the point entries in a range.
   */
  points: /*#__PURE__*/regenerator.mark(function points(range) {
    return regenerator.wrap(function points$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return [range.anchor, 'anchor'];

          case 2:
            _context12.next = 4;
            return [range.focus, 'focus'];

          case 4:
          case "end":
            return _context12.stop();
        }
      }
    }, points);
  }),

  /**
   * Get the start point of a range.
   */
  start: function start(range) {
    var _Range$edges23 = Range.edges(range),
        _Range$edges24 = _slicedToArray$2(_Range$edges23, 1),
        start = _Range$edges24[0];

    return start;
  },

  /**
   * Transform a range by an operation.
   */
  transform: function transform(range, op) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return fn(range, function (r) {
      if (r === null) {
        return null;
      }

      var _options$affinity6 = options.affinity,
          affinity = _options$affinity6 === void 0 ? 'inward' : _options$affinity6;
      var affinityAnchor;
      var affinityFocus;

      if (affinity === 'inward') {
        // If the range is collapsed, make sure to use the same affinity to
        // avoid the two points passing each other and expanding in the opposite
        // direction
        var isCollapsed = Range.isCollapsed(r);

        if (Range.isForward(r)) {
          affinityAnchor = 'forward';
          affinityFocus = isCollapsed ? affinityAnchor : 'backward';
        } else {
          affinityAnchor = 'backward';
          affinityFocus = isCollapsed ? affinityAnchor : 'forward';
        }
      } else if (affinity === 'outward') {
        if (Range.isForward(r)) {
          affinityAnchor = 'backward';
          affinityFocus = 'forward';
        } else {
          affinityAnchor = 'forward';
          affinityFocus = 'backward';
        }
      } else {
        affinityAnchor = affinity;
        affinityFocus = affinity;
      }

      var anchor = Point.transform(r.anchor, op, {
        affinity: affinityAnchor
      });
      var focus = Point.transform(r.focus, op, {
        affinity: affinityFocus
      });

      if (!anchor || !focus) {
        return null;
      }

      r.anchor = anchor;
      r.focus = focus;
    });
  }
};
var RangeRef = {
  /**
   * Transform the range ref's current value by an operation.
   */
  transform: function transform(ref, op) {
    var current = ref.current,
        affinity = ref.affinity;

    if (current == null) {
      return;
    }

    var path = Range.transform(current, op, {
      affinity: affinity
    });
    ref.current = path;

    if (path == null) {
      ref.unref();
    }
  }
};
/*
  Custom deep equal comparison for Slate nodes.

  We don't need general purpose deep equality;
  Slate only supports plain values, Arrays, and nested objects.
  Complex values nested inside Arrays are not supported.

  Slate objects are designed to be serialised, so
  missing keys are deliberately normalised to undefined.
 */

var isDeepEqual = function isDeepEqual(node, another) {
  for (var key in node) {
    var a = node[key];
    var b = another[key];

    if (isPlainObject(a) && isPlainObject(b)) {
      if (!isDeepEqual(a, b)) return false;
    } else if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;

      for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
    } else if (a !== b) {
      return false;
    }
  }
  /*
    Deep object equality is only necessary in one direction; in the reverse direction
    we are only looking for keys that are missing.
    As above, undefined keys are normalised to missing.
  */


  for (var _key in another) {
    if (node[_key] === undefined && another[_key] !== undefined) {
      return false;
    }
  }

  return true;
};

var _excluded$1 = ["text"],
    _excluded2$1 = ["anchor", "focus"];

function ownKeys$4$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Text = {
  /**
   * Check if two text nodes are equal.
   *
   * When loose is set, the text is not compared. This is
   * used to check whether sibling text nodes can be merged.
   */
  equals: function equals(text, another) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$loose = options.loose,
        loose = _options$loose === void 0 ? false : _options$loose;

    function omitText(obj) {
      var rest = _objectWithoutProperties(obj, _excluded$1);

      return rest;
    }

    return isDeepEqual(loose ? omitText(text) : text, loose ? omitText(another) : another);
  },

  /**
   * Check if a value implements the `Text` interface.
   */
  isText: function isText(value) {
    return isPlainObject(value) && typeof value.text === 'string';
  },

  /**
   * Check if a value is a list of `Text` objects.
   */
  isTextList: function isTextList(value) {
    return Array.isArray(value) && value.every(function (val) {
      return Text.isText(val);
    });
  },

  /**
   * Check if some props are a partial of Text.
   */
  isTextProps: function isTextProps(props) {
    return props.text !== undefined;
  },

  /**
   * Check if an text matches set of properties.
   *
   * Note: this is for matching custom properties, and it does not ensure that
   * the `text` property are two nodes equal.
   */
  matches: function matches(text, props) {
    for (var key in props) {
      if (key === 'text') {
        continue;
      }

      if (!text.hasOwnProperty(key) || text[key] !== props[key]) {
        return false;
      }
    }

    return true;
  },

  /**
   * Get the leaves for a text node given decorations.
   */
  decorations: function decorations(node, _decorations) {
    var leaves = [_objectSpread$4$1({}, node)];

    var _iterator24 = _createForOfIteratorHelper$1(_decorations),
        _step24;

    try {
      for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
        var dec = _step24.value;

        var rest = _objectWithoutProperties(dec, _excluded2$1);

        var _Range$edges25 = Range.edges(dec),
            _Range$edges26 = _slicedToArray$2(_Range$edges25, 2),
            start = _Range$edges26[0],
            end = _Range$edges26[1];

        var next = [];
        var o = 0;

        var _iterator25 = _createForOfIteratorHelper$1(leaves),
            _step25;

        try {
          for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
            var leaf = _step25.value;
            var length = leaf.text.length;
            var offset = o;
            o += length; // If the range encompases the entire leaf, add the range.

            if (start.offset <= offset && end.offset >= o) {
              Object.assign(leaf, rest);
              next.push(leaf);
              continue;
            } // If the range expanded and match the leaf, or starts after, or ends before it, continue.


            if (start.offset !== end.offset && (start.offset === o || end.offset === offset) || start.offset > o || end.offset < offset || end.offset === offset && offset !== 0) {
              next.push(leaf);
              continue;
            } // Otherwise we need to split the leaf, at the start, end, or both,
            // and add the range to the middle intersecting section. Do the end
            // split first since we don't need to update the offset that way.


            var middle = leaf;
            var before = void 0;
            var after = void 0;

            if (end.offset < o) {
              var off = end.offset - offset;
              after = _objectSpread$4$1(_objectSpread$4$1({}, middle), {}, {
                text: middle.text.slice(off)
              });
              middle = _objectSpread$4$1(_objectSpread$4$1({}, middle), {}, {
                text: middle.text.slice(0, off)
              });
            }

            if (start.offset > offset) {
              var _off = start.offset - offset;

              before = _objectSpread$4$1(_objectSpread$4$1({}, middle), {}, {
                text: middle.text.slice(0, _off)
              });
              middle = _objectSpread$4$1(_objectSpread$4$1({}, middle), {}, {
                text: middle.text.slice(_off)
              });
            }

            Object.assign(middle, rest);

            if (before) {
              next.push(before);
            }

            next.push(middle);

            if (after) {
              next.push(after);
            }
          }
        } catch (err) {
          _iterator25.e(err);
        } finally {
          _iterator25.f();
        }

        leaves = next;
      }
    } catch (err) {
      _iterator24.e(err);
    } finally {
      _iterator24.f();
    }

    return leaves;
  }
};

function ownKeys$3$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var applyToDraft = function applyToDraft(editor, selection, op) {
  switch (op.type) {
    case 'insert_node':
      {
        var path = op.path,
            node = op.node;
        var parent = Node.parent(editor, path);
        var index = path[path.length - 1];

        if (index > parent.children.length) {
          throw new Error("Cannot apply an \"insert_node\" operation at path [".concat(path, "] because the destination is past the end of the node."));
        }

        parent.children.splice(index, 0, node);

        if (selection) {
          var _iterator26 = _createForOfIteratorHelper$1(Range.points(selection)),
              _step26;

          try {
            for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
              var _step26$value = _slicedToArray$2(_step26.value, 2),
                  point = _step26$value[0],
                  key = _step26$value[1];

              selection[key] = Point.transform(point, op);
            }
          } catch (err) {
            _iterator26.e(err);
          } finally {
            _iterator26.f();
          }
        }

        break;
      }

    case 'insert_text':
      {
        var _path = op.path,
            offset = op.offset,
            text = op.text;
        if (text.length === 0) break;

        var _node = Node.leaf(editor, _path);

        var before = _node.text.slice(0, offset);

        var after = _node.text.slice(offset);

        _node.text = before + text + after;

        if (selection) {
          var _iterator27 = _createForOfIteratorHelper$1(Range.points(selection)),
              _step27;

          try {
            for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
              var _step27$value = _slicedToArray$2(_step27.value, 2),
                  _point = _step27$value[0],
                  _key = _step27$value[1];

              selection[_key] = Point.transform(_point, op);
            }
          } catch (err) {
            _iterator27.e(err);
          } finally {
            _iterator27.f();
          }
        }

        break;
      }

    case 'merge_node':
      {
        var _path2 = op.path;

        var _node2 = Node.get(editor, _path2);

        var prevPath = Path.previous(_path2);
        var prev = Node.get(editor, prevPath);

        var _parent = Node.parent(editor, _path2);

        var _index = _path2[_path2.length - 1];

        if (Text.isText(_node2) && Text.isText(prev)) {
          prev.text += _node2.text;
        } else if (!Text.isText(_node2) && !Text.isText(prev)) {
          var _prev$children;

          (_prev$children = prev.children).push.apply(_prev$children, _toConsumableArray$2(_node2.children));
        } else {
          throw new Error("Cannot apply a \"merge_node\" operation at path [".concat(_path2, "] to nodes of different interfaces: ").concat(_node2, " ").concat(prev));
        }

        _parent.children.splice(_index, 1);

        if (selection) {
          var _iterator28 = _createForOfIteratorHelper$1(Range.points(selection)),
              _step28;

          try {
            for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
              var _step28$value = _slicedToArray$2(_step28.value, 2),
                  _point2 = _step28$value[0],
                  _key2 = _step28$value[1];

              selection[_key2] = Point.transform(_point2, op);
            }
          } catch (err) {
            _iterator28.e(err);
          } finally {
            _iterator28.f();
          }
        }

        break;
      }

    case 'move_node':
      {
        var _path3 = op.path,
            newPath = op.newPath;

        if (Path.isAncestor(_path3, newPath)) {
          throw new Error("Cannot move a path [".concat(_path3, "] to new path [").concat(newPath, "] because the destination is inside itself."));
        }

        var _node3 = Node.get(editor, _path3);

        var _parent2 = Node.parent(editor, _path3);

        var _index2 = _path3[_path3.length - 1]; // This is tricky, but since the `path` and `newPath` both refer to
        // the same snapshot in time, there's a mismatch. After either
        // removing the original position, the second step's path can be out
        // of date. So instead of using the `op.newPath` directly, we
        // transform `op.path` to ascertain what the `newPath` would be after
        // the operation was applied.

        _parent2.children.splice(_index2, 1);

        var truePath = Path.transform(_path3, op);
        var newParent = Node.get(editor, Path.parent(truePath));
        var newIndex = truePath[truePath.length - 1];
        newParent.children.splice(newIndex, 0, _node3);

        if (selection) {
          var _iterator29 = _createForOfIteratorHelper$1(Range.points(selection)),
              _step29;

          try {
            for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
              var _step29$value = _slicedToArray$2(_step29.value, 2),
                  _point3 = _step29$value[0],
                  _key3 = _step29$value[1];

              selection[_key3] = Point.transform(_point3, op);
            }
          } catch (err) {
            _iterator29.e(err);
          } finally {
            _iterator29.f();
          }
        }

        break;
      }

    case 'remove_node':
      {
        var _path4 = op.path;
        var _index3 = _path4[_path4.length - 1];

        var _parent3 = Node.parent(editor, _path4);

        _parent3.children.splice(_index3, 1); // Transform all of the points in the value, but if the point was in the
        // node that was removed we need to update the range or remove it.


        if (selection) {
          var _iterator30 = _createForOfIteratorHelper$1(Range.points(selection)),
              _step30;

          try {
            for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
              var _step30$value = _slicedToArray$2(_step30.value, 2),
                  _point4 = _step30$value[0],
                  _key4 = _step30$value[1];

              var result = Point.transform(_point4, op);

              if (selection != null && result != null) {
                selection[_key4] = result;
              } else {
                var _prev = void 0;

                var next = void 0;

                var _iterator31 = _createForOfIteratorHelper$1(Node.texts(editor)),
                    _step31;

                try {
                  for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
                    var _step31$value = _slicedToArray$2(_step31.value, 2),
                        n = _step31$value[0],
                        p = _step31$value[1];

                    if (Path.compare(p, _path4) === -1) {
                      _prev = [n, p];
                    } else {
                      next = [n, p];
                      break;
                    }
                  }
                } catch (err) {
                  _iterator31.e(err);
                } finally {
                  _iterator31.f();
                }

                var preferNext = false;

                if (_prev && next) {
                  if (Path.equals(next[1], _path4)) {
                    preferNext = !Path.hasPrevious(next[1]);
                  } else {
                    preferNext = Path.common(_prev[1], _path4).length < Path.common(next[1], _path4).length;
                  }
                }

                if (_prev && !preferNext) {
                  _point4.path = _prev[1];
                  _point4.offset = _prev[0].text.length;
                } else if (next) {
                  _point4.path = next[1];
                  _point4.offset = 0;
                } else {
                  selection = null;
                }
              }
            }
          } catch (err) {
            _iterator30.e(err);
          } finally {
            _iterator30.f();
          }
        }

        break;
      }

    case 'remove_text':
      {
        var _path5 = op.path,
            _offset = op.offset,
            _text = op.text;
        if (_text.length === 0) break;

        var _node4 = Node.leaf(editor, _path5);

        var _before = _node4.text.slice(0, _offset);

        var _after = _node4.text.slice(_offset + _text.length);

        _node4.text = _before + _after;

        if (selection) {
          var _iterator32 = _createForOfIteratorHelper$1(Range.points(selection)),
              _step32;

          try {
            for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
              var _step32$value = _slicedToArray$2(_step32.value, 2),
                  _point5 = _step32$value[0],
                  _key5 = _step32$value[1];

              selection[_key5] = Point.transform(_point5, op);
            }
          } catch (err) {
            _iterator32.e(err);
          } finally {
            _iterator32.f();
          }
        }

        break;
      }

    case 'set_node':
      {
        var _path6 = op.path,
            properties = op.properties,
            newProperties = op.newProperties;

        if (_path6.length === 0) {
          throw new Error("Cannot set properties on the root node!");
        }

        var _node5 = Node.get(editor, _path6);

        for (var _key6 in newProperties) {
          if (_key6 === 'children' || _key6 === 'text') {
            throw new Error("Cannot set the \"".concat(_key6, "\" property of nodes!"));
          }

          var value = newProperties[_key6];

          if (value == null) {
            delete _node5[_key6];
          } else {
            _node5[_key6] = value;
          }
        } // properties that were previously defined, but are now missing, must be deleted


        for (var _key7 in properties) {
          if (!newProperties.hasOwnProperty(_key7)) {
            delete _node5[_key7];
          }
        }

        break;
      }

    case 'set_selection':
      {
        var _newProperties = op.newProperties;

        if (_newProperties == null) {
          selection = _newProperties;
        } else {
          if (selection == null) {
            if (!Range.isRange(_newProperties)) {
              throw new Error("Cannot apply an incomplete \"set_selection\" operation properties ".concat(JSON.stringify(_newProperties), " when there is no current selection."));
            }

            selection = _objectSpread$3$1({}, _newProperties);
          }

          for (var _key8 in _newProperties) {
            var _value = _newProperties[_key8];

            if (_value == null) {
              if (_key8 === 'anchor' || _key8 === 'focus') {
                throw new Error("Cannot remove the \"".concat(_key8, "\" selection property"));
              }

              delete selection[_key8];
            } else {
              selection[_key8] = _value;
            }
          }
        }

        break;
      }

    case 'split_node':
      {
        var _path7 = op.path,
            position = op.position,
            _properties = op.properties;

        if (_path7.length === 0) {
          throw new Error("Cannot apply a \"split_node\" operation at path [".concat(_path7, "] because the root node cannot be split."));
        }

        var _node6 = Node.get(editor, _path7);

        var _parent4 = Node.parent(editor, _path7);

        var _index4 = _path7[_path7.length - 1];
        var newNode;

        if (Text.isText(_node6)) {
          var _before2 = _node6.text.slice(0, position);

          var _after2 = _node6.text.slice(position);

          _node6.text = _before2;
          newNode = _objectSpread$3$1(_objectSpread$3$1({}, _properties), {}, {
            text: _after2
          });
        } else {
          var _before3 = _node6.children.slice(0, position);

          var _after3 = _node6.children.slice(position);

          _node6.children = _before3;
          newNode = _objectSpread$3$1(_objectSpread$3$1({}, _properties), {}, {
            children: _after3
          });
        }

        _parent4.children.splice(_index4 + 1, 0, newNode);

        if (selection) {
          var _iterator33 = _createForOfIteratorHelper$1(Range.points(selection)),
              _step33;

          try {
            for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
              var _step33$value = _slicedToArray$2(_step33.value, 2),
                  _point6 = _step33$value[0],
                  _key9 = _step33$value[1];

              selection[_key9] = Point.transform(_point6, op);
            }
          } catch (err) {
            _iterator33.e(err);
          } finally {
            _iterator33.f();
          }
        }

        break;
      }
  }

  return selection;
};

var GeneralTransforms = {
  /**
   * Transform the editor by an operation.
   */
  transform: function transform(editor, op) {
    editor.children = ln(editor.children);
    var selection = editor.selection && ln(editor.selection);

    try {
      selection = applyToDraft(editor, selection, op);
    } finally {
      editor.children = dn(editor.children);

      if (selection) {
        editor.selection = r(selection) ? dn(selection) : selection;
      } else {
        editor.selection = null;
      }
    }
  }
};
var _excluded = ["text"],
    _excluded2 = ["children"];

function ownKeys$2$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var NodeTransforms = {
  /**
   * Insert nodes at a specific location in the Editor.
   */
  insertNodes: function insertNodes(editor, nodes) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor$1.withoutNormalizing(editor, function () {
      var _options$hanging = options.hanging,
          hanging = _options$hanging === void 0 ? false : _options$hanging,
          _options$voids9 = options.voids,
          voids = _options$voids9 === void 0 ? false : _options$voids9,
          _options$mode5 = options.mode,
          mode = _options$mode5 === void 0 ? 'lowest' : _options$mode5;
      var at = options.at,
          match = options.match,
          select = options.select;

      if (Node.isNode(nodes)) {
        nodes = [nodes];
      }

      if (nodes.length === 0) {
        return;
      }

      var _nodes = nodes,
          _nodes2 = _slicedToArray$2(_nodes, 1),
          node = _nodes2[0]; // By default, use the selection as the target location. But if there is
      // no selection, insert at the end of the document since that is such a
      // common use case when inserting from a non-selected state.


      if (!at) {
        if (editor.selection) {
          at = editor.selection;
        } else if (editor.children.length > 0) {
          at = Editor$1.end(editor, []);
        } else {
          at = [0];
        }

        select = true;
      }

      if (select == null) {
        select = false;
      }

      if (Range.isRange(at)) {
        if (!hanging) {
          at = Editor$1.unhangRange(editor, at);
        }

        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var _Range$edges27 = Range.edges(at),
              _Range$edges28 = _slicedToArray$2(_Range$edges27, 2),
              end = _Range$edges28[1];

          var pointRef = Editor$1.pointRef(editor, end);
          Transforms["delete"](editor, {
            at: at
          });
          at = pointRef.unref();
        }
      }

      if (Point.isPoint(at)) {
        if (match == null) {
          if (Text.isText(node)) {
            match = function match(n) {
              return Text.isText(n);
            };
          } else if (editor.isInline(node)) {
            match = function match(n) {
              return Text.isText(n) || Editor$1.isInline(editor, n);
            };
          } else {
            match = function match(n) {
              return Editor$1.isBlock(editor, n);
            };
          }
        }

        var _Editor$nodes7 = Editor$1.nodes(editor, {
          at: at.path,
          match: match,
          mode: mode,
          voids: voids
        }),
            _Editor$nodes8 = _slicedToArray$2(_Editor$nodes7, 1),
            entry = _Editor$nodes8[0];

        if (entry) {
          var _entry4 = _slicedToArray$2(entry, 2),
              _matchPath = _entry4[1];

          var pathRef = Editor$1.pathRef(editor, _matchPath);
          var isAtEnd = Editor$1.isEnd(editor, at, _matchPath);
          Transforms.splitNodes(editor, {
            at: at,
            match: match,
            mode: mode,
            voids: voids
          });
          var path = pathRef.unref();
          at = isAtEnd ? Path.next(path) : path;
        } else {
          return;
        }
      }

      var parentPath = Path.parent(at);
      var index = at[at.length - 1];

      if (!voids && Editor$1["void"](editor, {
        at: parentPath
      })) {
        return;
      }

      var _iterator34 = _createForOfIteratorHelper$1(nodes),
          _step34;

      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var _node = _step34.value;

          var _path = parentPath.concat(index);

          index++;
          editor.apply({
            type: 'insert_node',
            path: _path,
            node: _node
          });
          at = Path.next(at);
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }

      at = Path.previous(at);

      if (select) {
        var point = Editor$1.end(editor, at);

        if (point) {
          Transforms.select(editor, point);
        }
      }
    });
  },

  /**
   * Lift nodes at a specific location upwards in the document tree, splitting
   * their parent in two if necessary.
   */
  liftNodes: function liftNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor$1.withoutNormalizing(editor, function () {
      var _options$at7 = options.at,
          at = _options$at7 === void 0 ? editor.selection : _options$at7,
          _options$mode6 = options.mode,
          mode = _options$mode6 === void 0 ? 'lowest' : _options$mode6,
          _options$voids10 = options.voids,
          voids = _options$voids10 === void 0 ? false : _options$voids10;
      var match = options.match;

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
          return Editor$1.isBlock(editor, n);
        };
      }

      if (!at) {
        return;
      }

      var matches = Editor$1.nodes(editor, {
        at: at,
        match: match,
        mode: mode,
        voids: voids
      });
      var pathRefs = Array.from(matches, function (_ref) {
        var _ref12 = _slicedToArray$2(_ref, 2),
            p = _ref12[1];

        return Editor$1.pathRef(editor, p);
      });

      for (var _i = 0, _pathRefs = pathRefs; _i < _pathRefs.length; _i++) {
        var pathRef = _pathRefs[_i];
        var path = pathRef.unref();

        if (path.length < 2) {
          throw new Error("Cannot lift node at a path [".concat(path, "] because it has a depth of less than `2`."));
        }

        var parentNodeEntry = Editor$1.node(editor, Path.parent(path));

        var _parentNodeEntry = _slicedToArray$2(parentNodeEntry, 2),
            parent = _parentNodeEntry[0],
            parentPath = _parentNodeEntry[1];

        var index = path[path.length - 1];
        var length = parent.children.length;

        if (length === 1) {
          var toPath = Path.next(parentPath);
          Transforms.moveNodes(editor, {
            at: path,
            to: toPath,
            voids: voids
          });
          Transforms.removeNodes(editor, {
            at: parentPath,
            voids: voids
          });
        } else if (index === 0) {
          Transforms.moveNodes(editor, {
            at: path,
            to: parentPath,
            voids: voids
          });
        } else if (index === length - 1) {
          var _toPath = Path.next(parentPath);

          Transforms.moveNodes(editor, {
            at: path,
            to: _toPath,
            voids: voids
          });
        } else {
          var splitPath = Path.next(path);

          var _toPath2 = Path.next(parentPath);

          Transforms.splitNodes(editor, {
            at: splitPath,
            voids: voids
          });
          Transforms.moveNodes(editor, {
            at: path,
            to: _toPath2,
            voids: voids
          });
        }
      }
    });
  },

  /**
   * Merge a node at a location with the previous node of the same depth,
   * removing any empty containing nodes after the merge if necessary.
   */
  mergeNodes: function mergeNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor$1.withoutNormalizing(editor, function () {
      var match = options.match,
          _options$at8 = options.at,
          at = _options$at8 === void 0 ? editor.selection : _options$at8;
      var _options$hanging2 = options.hanging,
          hanging = _options$hanging2 === void 0 ? false : _options$hanging2,
          _options$voids11 = options.voids,
          voids = _options$voids11 === void 0 ? false : _options$voids11,
          _options$mode7 = options.mode,
          mode = _options$mode7 === void 0 ? 'lowest' : _options$mode7;

      if (!at) {
        return;
      }

      if (match == null) {
        if (Path.isPath(at)) {
          var _Editor$parent5 = Editor$1.parent(editor, at),
              _Editor$parent6 = _slicedToArray$2(_Editor$parent5, 1),
              parent = _Editor$parent6[0];

          match = function match(n) {
            return parent.children.includes(n);
          };
        } else {
          match = function match(n) {
            return Editor$1.isBlock(editor, n);
          };
        }
      }

      if (!hanging && Range.isRange(at)) {
        at = Editor$1.unhangRange(editor, at);
      }

      if (Range.isRange(at)) {
        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var _Range$edges29 = Range.edges(at),
              _Range$edges30 = _slicedToArray$2(_Range$edges29, 2),
              end = _Range$edges30[1];

          var pointRef = Editor$1.pointRef(editor, end);
          Transforms["delete"](editor, {
            at: at
          });
          at = pointRef.unref();

          if (options.at == null) {
            Transforms.select(editor, at);
          }
        }
      }

      var _Editor$nodes9 = Editor$1.nodes(editor, {
        at: at,
        match: match,
        voids: voids,
        mode: mode
      }),
          _Editor$nodes10 = _slicedToArray$2(_Editor$nodes9, 1),
          current = _Editor$nodes10[0];

      var prev = Editor$1.previous(editor, {
        at: at,
        match: match,
        voids: voids,
        mode: mode
      });

      if (!current || !prev) {
        return;
      }

      var _current = _slicedToArray$2(current, 2),
          node = _current[0],
          path = _current[1];

      var _prev3 = _slicedToArray$2(prev, 2),
          prevNode = _prev3[0],
          prevPath = _prev3[1];

      if (path.length === 0 || prevPath.length === 0) {
        return;
      }

      var newPath = Path.next(prevPath);
      var commonPath = Path.common(path, prevPath);
      var isPreviousSibling = Path.isSibling(path, prevPath);
      var levels = Array.from(Editor$1.levels(editor, {
        at: path
      }), function (_ref2) {
        var _ref13 = _slicedToArray$2(_ref2, 1),
            n = _ref13[0];

        return n;
      }).slice(commonPath.length).slice(0, -1); // Determine if the merge will leave an ancestor of the path empty as a
      // result, in which case we'll want to remove it after merging.

      var emptyAncestor = Editor$1.above(editor, {
        at: path,
        mode: 'highest',
        match: function match(n) {
          return levels.includes(n) && hasSingleChildNest(editor, n);
        }
      });
      var emptyRef = emptyAncestor && Editor$1.pathRef(editor, emptyAncestor[1]);
      var properties;
      var position; // Ensure that the nodes are equivalent, and figure out what the position
      // and extra properties of the merge will be.

      if (Text.isText(node) && Text.isText(prevNode)) {
        var rest = _objectWithoutProperties(node, _excluded);

        position = prevNode.text.length;
        properties = rest;
      } else if (Element$1.isElement(node) && Element$1.isElement(prevNode)) {
        var rest = _objectWithoutProperties(node, _excluded2);

        position = prevNode.children.length;
        properties = rest;
      } else {
        throw new Error("Cannot merge the node at path [".concat(path, "] with the previous sibling because it is not the same kind: ").concat(JSON.stringify(node), " ").concat(JSON.stringify(prevNode)));
      } // If the node isn't already the next sibling of the previous node, move
      // it so that it is before merging.


      if (!isPreviousSibling) {
        Transforms.moveNodes(editor, {
          at: path,
          to: newPath,
          voids: voids
        });
      } // If there was going to be an empty ancestor of the node that was merged,
      // we remove it from the tree.


      if (emptyRef) {
        Transforms.removeNodes(editor, {
          at: emptyRef.current,
          voids: voids
        });
      } // If the target node that we're merging with is empty, remove it instead
      // of merging the two. This is a common rich text editor behavior to
      // prevent losing formatting when deleting entire nodes when you have a
      // hanging selection.
      // if prevNode is first child in parent,don't remove it.


      if (Element$1.isElement(prevNode) && Editor$1.isEmpty(editor, prevNode) || Text.isText(prevNode) && prevNode.text === '' && prevPath[prevPath.length - 1] !== 0) {
        Transforms.removeNodes(editor, {
          at: prevPath,
          voids: voids
        });
      } else {
        editor.apply({
          type: 'merge_node',
          path: newPath,
          position: position,
          properties: properties
        });
      }

      if (emptyRef) {
        emptyRef.unref();
      }
    });
  },

  /**
   * Move the nodes at a location to a new location.
   */
  moveNodes: function moveNodes(editor, options) {
    Editor$1.withoutNormalizing(editor, function () {
      var to = options.to,
          _options$at9 = options.at,
          at = _options$at9 === void 0 ? editor.selection : _options$at9,
          _options$mode8 = options.mode,
          mode = _options$mode8 === void 0 ? 'lowest' : _options$mode8,
          _options$voids12 = options.voids,
          voids = _options$voids12 === void 0 ? false : _options$voids12;
      var match = options.match;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
          return Editor$1.isBlock(editor, n);
        };
      }

      var toRef = Editor$1.pathRef(editor, to);
      var targets = Editor$1.nodes(editor, {
        at: at,
        match: match,
        mode: mode,
        voids: voids
      });
      var pathRefs = Array.from(targets, function (_ref3) {
        var _ref14 = _slicedToArray$2(_ref3, 2),
            p = _ref14[1];

        return Editor$1.pathRef(editor, p);
      });

      for (var _i2 = 0, _pathRefs2 = pathRefs; _i2 < _pathRefs2.length; _i2++) {
        var pathRef = _pathRefs2[_i2];
        var path = pathRef.unref();
        var newPath = toRef.current;

        if (path.length !== 0) {
          editor.apply({
            type: 'move_node',
            path: path,
            newPath: newPath
          });
        }

        if (toRef.current && Path.isSibling(newPath, path) && Path.isAfter(newPath, path)) {
          // When performing a sibling move to a later index, the path at the destination is shifted
          // to before the insertion point instead of after. To ensure our group of nodes are inserted
          // in the correct order we increment toRef to account for that
          toRef.current = Path.next(toRef.current);
        }
      }

      toRef.unref();
    });
  },

  /**
   * Remove the nodes at a specific location in the document.
   */
  removeNodes: function removeNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor$1.withoutNormalizing(editor, function () {
      var _options$hanging3 = options.hanging,
          hanging = _options$hanging3 === void 0 ? false : _options$hanging3,
          _options$voids13 = options.voids,
          voids = _options$voids13 === void 0 ? false : _options$voids13,
          _options$mode9 = options.mode,
          mode = _options$mode9 === void 0 ? 'lowest' : _options$mode9;
      var _options$at10 = options.at,
          at = _options$at10 === void 0 ? editor.selection : _options$at10,
          match = options.match;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
          return Editor$1.isBlock(editor, n);
        };
      }

      if (!hanging && Range.isRange(at)) {
        at = Editor$1.unhangRange(editor, at);
      }

      var depths = Editor$1.nodes(editor, {
        at: at,
        match: match,
        mode: mode,
        voids: voids
      });
      var pathRefs = Array.from(depths, function (_ref4) {
        var _ref15 = _slicedToArray$2(_ref4, 2),
            p = _ref15[1];

        return Editor$1.pathRef(editor, p);
      });

      for (var _i3 = 0, _pathRefs3 = pathRefs; _i3 < _pathRefs3.length; _i3++) {
        var pathRef = _pathRefs3[_i3];
        var path = pathRef.unref();

        if (path) {
          var _Editor$node = Editor$1.node(editor, path),
              _Editor$node2 = _slicedToArray$2(_Editor$node, 1),
              node = _Editor$node2[0];

          editor.apply({
            type: 'remove_node',
            path: path,
            node: node
          });
        }
      }
    });
  },

  /**
   * Set new properties on the nodes at a location.
   */
  setNodes: function setNodes(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor$1.withoutNormalizing(editor, function () {
      var match = options.match,
          _options$at11 = options.at,
          at = _options$at11 === void 0 ? editor.selection : _options$at11,
          compare = options.compare,
          merge = options.merge;
      var _options$hanging4 = options.hanging,
          hanging = _options$hanging4 === void 0 ? false : _options$hanging4,
          _options$mode10 = options.mode,
          mode = _options$mode10 === void 0 ? 'lowest' : _options$mode10,
          _options$split = options.split,
          split = _options$split === void 0 ? false : _options$split,
          _options$voids14 = options.voids,
          voids = _options$voids14 === void 0 ? false : _options$voids14;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
          return Editor$1.isBlock(editor, n);
        };
      }

      if (!hanging && Range.isRange(at)) {
        at = Editor$1.unhangRange(editor, at);
      }

      if (split && Range.isRange(at)) {
        if (Range.isCollapsed(at) && Editor$1.leaf(editor, at.anchor)[0].text.length > 0) {
          // If the range is collapsed in a non-empty node and 'split' is true, there's nothing to
          // set that won't get normalized away
          return;
        }

        var rangeRef = Editor$1.rangeRef(editor, at, {
          affinity: 'inward'
        });

        var _Range$edges31 = Range.edges(at),
            _Range$edges32 = _slicedToArray$2(_Range$edges31, 2),
            start = _Range$edges32[0],
            end = _Range$edges32[1];

        var splitMode = mode === 'lowest' ? 'lowest' : 'highest';
        var endAtEndOfNode = Editor$1.isEnd(editor, end, end.path);
        Transforms.splitNodes(editor, {
          at: end,
          match: match,
          mode: splitMode,
          voids: voids,
          always: !endAtEndOfNode
        });
        var startAtStartOfNode = Editor$1.isStart(editor, start, start.path);
        Transforms.splitNodes(editor, {
          at: start,
          match: match,
          mode: splitMode,
          voids: voids,
          always: !startAtStartOfNode
        });
        at = rangeRef.unref();

        if (options.at == null) {
          Transforms.select(editor, at);
        }
      }

      if (!compare) {
        compare = function compare(prop, nodeProp) {
          return prop !== nodeProp;
        };
      }

      var _iterator35 = _createForOfIteratorHelper$1(Editor$1.nodes(editor, {
        at: at,
        match: match,
        mode: mode,
        voids: voids
      })),
          _step35;

      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var _step35$value = _slicedToArray$2(_step35.value, 2),
              node = _step35$value[0],
              path = _step35$value[1];

          var properties = {};
          var newProperties = {}; // You can't set properties on the editor node.

          if (path.length === 0) {
            continue;
          }

          var hasChanges = false;

          for (var k in props) {
            if (k === 'children' || k === 'text') {
              continue;
            }

            if (compare(props[k], node[k])) {
              hasChanges = true; // Omit new properties from the old properties list

              if (node.hasOwnProperty(k)) properties[k] = node[k]; // Omit properties that have been removed from the new properties list

              if (merge) {
                if (props[k] != null) newProperties[k] = merge(node[k], props[k]);
              } else {
                if (props[k] != null) newProperties[k] = props[k];
              }
            }
          }

          if (hasChanges) {
            editor.apply({
              type: 'set_node',
              path: path,
              properties: properties,
              newProperties: newProperties
            });
          }
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
    });
  },

  /**
   * Split the nodes at a specific location.
   */
  splitNodes: function splitNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor$1.withoutNormalizing(editor, function () {
      var _options$mode11 = options.mode,
          mode = _options$mode11 === void 0 ? 'lowest' : _options$mode11,
          _options$voids15 = options.voids,
          voids = _options$voids15 === void 0 ? false : _options$voids15;
      var match = options.match,
          _options$at12 = options.at,
          at = _options$at12 === void 0 ? editor.selection : _options$at12,
          _options$height = options.height,
          height = _options$height === void 0 ? 0 : _options$height,
          _options$always = options.always,
          always = _options$always === void 0 ? false : _options$always;

      if (match == null) {
        match = function match(n) {
          return Editor$1.isBlock(editor, n);
        };
      }

      if (Range.isRange(at)) {
        at = deleteRange(editor, at);
      } // If the target is a path, the default height-skipping and position
      // counters need to account for us potentially splitting at a non-leaf.


      if (Path.isPath(at)) {
        var path = at;
        var point = Editor$1.point(editor, path);

        var _Editor$parent7 = Editor$1.parent(editor, path),
            _Editor$parent8 = _slicedToArray$2(_Editor$parent7, 1),
            parent = _Editor$parent8[0];

        match = function match(n) {
          return n === parent;
        };

        height = point.path.length - path.length + 1;
        at = point;
        always = true;
      }

      if (!at) {
        return;
      }

      var beforeRef = Editor$1.pointRef(editor, at, {
        affinity: 'backward'
      });
      var afterRef;

      try {
        var _Editor$nodes11 = Editor$1.nodes(editor, {
          at: at,
          match: match,
          mode: mode,
          voids: voids
        }),
            _Editor$nodes12 = _slicedToArray$2(_Editor$nodes11, 1),
            highest = _Editor$nodes12[0];

        if (!highest) {
          return;
        }

        var voidMatch = Editor$1["void"](editor, {
          at: at,
          mode: 'highest'
        });
        var nudge = 0;

        if (!voids && voidMatch) {
          var _voidMatch = _slicedToArray$2(voidMatch, 2),
              voidNode = _voidMatch[0],
              voidPath = _voidMatch[1];

          if (Element$1.isElement(voidNode) && editor.isInline(voidNode)) {
            var after = Editor$1.after(editor, voidPath);

            if (!after) {
              var text = {
                text: ''
              };
              var afterPath = Path.next(voidPath);
              Transforms.insertNodes(editor, text, {
                at: afterPath,
                voids: voids
              });
              after = Editor$1.point(editor, afterPath);
            }

            at = after;
            always = true;
          }

          var siblingHeight = at.path.length - voidPath.length;
          height = siblingHeight + 1;
          always = true;
        }

        afterRef = Editor$1.pointRef(editor, at);
        var depth = at.path.length - height;

        var _highest = _slicedToArray$2(highest, 2),
            highestPath = _highest[1];

        var lowestPath = at.path.slice(0, depth);
        var position = height === 0 ? at.offset : at.path[depth] + nudge;

        var _iterator36 = _createForOfIteratorHelper$1(Editor$1.levels(editor, {
          at: lowestPath,
          reverse: true,
          voids: voids
        })),
            _step36;

        try {
          for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
            var _step36$value = _slicedToArray$2(_step36.value, 2),
                node = _step36$value[0],
                _path2 = _step36$value[1];

            var split = false;

            if (_path2.length < highestPath.length || _path2.length === 0 || !voids && Editor$1.isVoid(editor, node)) {
              break;
            }

            var _point = beforeRef.current;
            var isEnd = Editor$1.isEnd(editor, _point, _path2);

            if (always || !beforeRef || !Editor$1.isEdge(editor, _point, _path2)) {
              split = true;
              var properties = Node.extractProps(node);
              editor.apply({
                type: 'split_node',
                path: _path2,
                position: position,
                properties: properties
              });
            }

            position = _path2[_path2.length - 1] + (split || isEnd ? 1 : 0);
          }
        } catch (err) {
          _iterator36.e(err);
        } finally {
          _iterator36.f();
        }

        if (options.at == null) {
          var _point2 = afterRef.current || Editor$1.end(editor, []);

          Transforms.select(editor, _point2);
        }
      } finally {
        var _afterRef;

        beforeRef.unref();
        (_afterRef = afterRef) === null || _afterRef === void 0 ? void 0 : _afterRef.unref();
      }
    });
  },

  /**
   * Unset properties on the nodes at a location.
   */
  unsetNodes: function unsetNodes(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!Array.isArray(props)) {
      props = [props];
    }

    var obj = {};

    var _iterator37 = _createForOfIteratorHelper$1(props),
        _step37;

    try {
      for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
        var key = _step37.value;
        obj[key] = null;
      }
    } catch (err) {
      _iterator37.e(err);
    } finally {
      _iterator37.f();
    }

    Transforms.setNodes(editor, obj, options);
  },

  /**
   * Unwrap the nodes at a location from a parent node, splitting the parent if
   * necessary to ensure that only the content in the range is unwrapped.
   */
  unwrapNodes: function unwrapNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor$1.withoutNormalizing(editor, function () {
      var _options$mode12 = options.mode,
          mode = _options$mode12 === void 0 ? 'lowest' : _options$mode12,
          _options$split2 = options.split,
          split = _options$split2 === void 0 ? false : _options$split2,
          _options$voids16 = options.voids,
          voids = _options$voids16 === void 0 ? false : _options$voids16;
      var _options$at13 = options.at,
          at = _options$at13 === void 0 ? editor.selection : _options$at13,
          match = options.match;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : function (n) {
          return Editor$1.isBlock(editor, n);
        };
      }

      if (Path.isPath(at)) {
        at = Editor$1.range(editor, at);
      }

      var rangeRef = Range.isRange(at) ? Editor$1.rangeRef(editor, at) : null;
      var matches = Editor$1.nodes(editor, {
        at: at,
        match: match,
        mode: mode,
        voids: voids
      });
      var pathRefs = Array.from(matches, function (_ref5) {
        var _ref16 = _slicedToArray$2(_ref5, 2),
            p = _ref16[1];

        return Editor$1.pathRef(editor, p);
      } // unwrapNode will call liftNode which does not support splitting the node when nested.
      // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
      // that wrap target node. So we reverse the order.
      ).reverse();

      var _loop = function _loop(pathRef) {
        var path = pathRef.unref();

        var _Editor$node3 = Editor$1.node(editor, path),
            _Editor$node4 = _slicedToArray$2(_Editor$node3, 1),
            node = _Editor$node4[0];

        var range = Editor$1.range(editor, path);

        if (split && rangeRef) {
          range = Range.intersection(rangeRef.current, range);
        }

        Transforms.liftNodes(editor, {
          at: range,
          match: function match(n) {
            return Element$1.isAncestor(node) && node.children.includes(n);
          },
          voids: voids
        });
      };

      var _iterator38 = _createForOfIteratorHelper$1(pathRefs),
          _step38;

      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var pathRef = _step38.value;

          _loop(pathRef);
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }

      if (rangeRef) {
        rangeRef.unref();
      }
    });
  },

  /**
   * Wrap the nodes at a location in a new container node, splitting the edges
   * of the range first to ensure that only the content in the range is wrapped.
   */
  wrapNodes: function wrapNodes(editor, element) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor$1.withoutNormalizing(editor, function () {
      var _options$mode13 = options.mode,
          mode = _options$mode13 === void 0 ? 'lowest' : _options$mode13,
          _options$split3 = options.split,
          split = _options$split3 === void 0 ? false : _options$split3,
          _options$voids17 = options.voids,
          voids = _options$voids17 === void 0 ? false : _options$voids17;
      var match = options.match,
          _options$at14 = options.at,
          at = _options$at14 === void 0 ? editor.selection : _options$at14;

      if (!at) {
        return;
      }

      if (match == null) {
        if (Path.isPath(at)) {
          match = matchPath(editor, at);
        } else if (editor.isInline(element)) {
          match = function match(n) {
            return Editor$1.isInline(editor, n) || Text.isText(n);
          };
        } else {
          match = function match(n) {
            return Editor$1.isBlock(editor, n);
          };
        }
      }

      if (split && Range.isRange(at)) {
        var _Range$edges33 = Range.edges(at),
            _Range$edges34 = _slicedToArray$2(_Range$edges33, 2),
            start = _Range$edges34[0],
            end = _Range$edges34[1];

        var rangeRef = Editor$1.rangeRef(editor, at, {
          affinity: 'inward'
        });
        Transforms.splitNodes(editor, {
          at: end,
          match: match,
          voids: voids
        });
        Transforms.splitNodes(editor, {
          at: start,
          match: match,
          voids: voids
        });
        at = rangeRef.unref();

        if (options.at == null) {
          Transforms.select(editor, at);
        }
      }

      var roots = Array.from(Editor$1.nodes(editor, {
        at: at,
        match: editor.isInline(element) ? function (n) {
          return Editor$1.isBlock(editor, n);
        } : function (n) {
          return Editor$1.isEditor(n);
        },
        mode: 'lowest',
        voids: voids
      }));

      for (var _i4 = 0, _roots = roots; _i4 < _roots.length; _i4++) {
        var _roots$_i = _slicedToArray$2(_roots[_i4], 2),
            rootPath = _roots$_i[1];

        var a = Range.isRange(at) ? Range.intersection(at, Editor$1.range(editor, rootPath)) : at;

        if (!a) {
          continue;
        }

        var matches = Array.from(Editor$1.nodes(editor, {
          at: a,
          match: match,
          mode: mode,
          voids: voids
        }));

        if (matches.length > 0) {
          var _ret = function () {
            var _matches = _slicedToArray$2(matches, 1),
                first = _matches[0];

            var last = matches[matches.length - 1];

            var _first = _slicedToArray$2(first, 2),
                firstPath = _first[1];

            var _last = _slicedToArray$2(last, 2),
                lastPath = _last[1];

            if (firstPath.length === 0 && lastPath.length === 0) {
              // if there's no matching parent - usually means the node is an editor - don't do anything
              return "continue";
            }

            var commonPath = Path.equals(firstPath, lastPath) ? Path.parent(firstPath) : Path.common(firstPath, lastPath);
            var range = Editor$1.range(editor, firstPath, lastPath);
            var commonNodeEntry = Editor$1.node(editor, commonPath);

            var _commonNodeEntry = _slicedToArray$2(commonNodeEntry, 1),
                commonNode = _commonNodeEntry[0];

            var depth = commonPath.length + 1;
            var wrapperPath = Path.next(lastPath.slice(0, depth));

            var wrapper = _objectSpread$2$1(_objectSpread$2$1({}, element), {}, {
              children: []
            });

            Transforms.insertNodes(editor, wrapper, {
              at: wrapperPath,
              voids: voids
            });
            Transforms.moveNodes(editor, {
              at: range,
              match: function match(n) {
                return Element$1.isAncestor(commonNode) && commonNode.children.includes(n);
              },
              to: wrapperPath.concat(0),
              voids: voids
            });
          }();

          if (_ret === "continue") continue;
        }
      }
    });
  }
};

var hasSingleChildNest = function hasSingleChildNest(editor, node) {
  if (Element$1.isElement(node)) {
    var element = node;

    if (Editor$1.isVoid(editor, node)) {
      return true;
    } else if (element.children.length === 1) {
      return hasSingleChildNest(editor, element.children[0]);
    } else {
      return false;
    }
  } else if (Editor$1.isEditor(node)) {
    return false;
  } else {
    return true;
  }
};
/**
 * Convert a range into a point by deleting it's content.
 */


var deleteRange = function deleteRange(editor, range) {
  if (Range.isCollapsed(range)) {
    return range.anchor;
  } else {
    var _Range$edges35 = Range.edges(range),
        _Range$edges36 = _slicedToArray$2(_Range$edges35, 2),
        end = _Range$edges36[1];

    var pointRef = Editor$1.pointRef(editor, end);
    Transforms["delete"](editor, {
      at: range
    });
    return pointRef.unref();
  }
};

var matchPath = function matchPath(editor, path) {
  var _Editor$node5 = Editor$1.node(editor, path),
      _Editor$node6 = _slicedToArray$2(_Editor$node5, 1),
      node = _Editor$node6[0];

  return function (n) {
    return n === node;
  };
};

function ownKeys$1$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var SelectionTransforms = {
  /**
   * Collapse the selection.
   */
  collapse: function collapse(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$edge2 = options.edge,
        edge = _options$edge2 === void 0 ? 'anchor' : _options$edge2;
    var selection = editor.selection;

    if (!selection) {
      return;
    } else if (edge === 'anchor') {
      Transforms.select(editor, selection.anchor);
    } else if (edge === 'focus') {
      Transforms.select(editor, selection.focus);
    } else if (edge === 'start') {
      var _Range$edges37 = Range.edges(selection),
          _Range$edges38 = _slicedToArray$2(_Range$edges37, 1),
          start = _Range$edges38[0];

      Transforms.select(editor, start);
    } else if (edge === 'end') {
      var _Range$edges39 = Range.edges(selection),
          _Range$edges40 = _slicedToArray$2(_Range$edges39, 2),
          end = _Range$edges40[1];

      Transforms.select(editor, end);
    }
  },

  /**
   * Unset the selection.
   */
  deselect: function deselect(editor) {
    var selection = editor.selection;

    if (selection) {
      editor.apply({
        type: 'set_selection',
        properties: selection,
        newProperties: null
      });
    }
  },

  /**
   * Move the selection's point forward or backward.
   */
  move: function move(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var selection = editor.selection;
    var _options$distance3 = options.distance,
        distance = _options$distance3 === void 0 ? 1 : _options$distance3,
        _options$unit4 = options.unit,
        unit = _options$unit4 === void 0 ? 'character' : _options$unit4,
        _options$reverse9 = options.reverse,
        reverse = _options$reverse9 === void 0 ? false : _options$reverse9;
    var _options$edge3 = options.edge,
        edge = _options$edge3 === void 0 ? null : _options$edge3;

    if (!selection) {
      return;
    }

    if (edge === 'start') {
      edge = Range.isBackward(selection) ? 'focus' : 'anchor';
    }

    if (edge === 'end') {
      edge = Range.isBackward(selection) ? 'anchor' : 'focus';
    }

    var anchor = selection.anchor,
        focus = selection.focus;
    var opts = {
      distance: distance,
      unit: unit
    };
    var props = {};

    if (edge == null || edge === 'anchor') {
      var point = reverse ? Editor$1.before(editor, anchor, opts) : Editor$1.after(editor, anchor, opts);

      if (point) {
        props.anchor = point;
      }
    }

    if (edge == null || edge === 'focus') {
      var _point = reverse ? Editor$1.before(editor, focus, opts) : Editor$1.after(editor, focus, opts);

      if (_point) {
        props.focus = _point;
      }
    }

    Transforms.setSelection(editor, props);
  },

  /**
   * Set the selection to a new value.
   */
  select: function select(editor, target) {
    var selection = editor.selection;
    target = Editor$1.range(editor, target);

    if (selection) {
      Transforms.setSelection(editor, target);
      return;
    }

    if (!Range.isRange(target)) {
      throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(JSON.stringify(target)));
    }

    editor.apply({
      type: 'set_selection',
      properties: selection,
      newProperties: target
    });
  },

  /**
   * Set new properties on one of the selection's points.
   */
  setPoint: function setPoint(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var selection = editor.selection;
    var _options$edge4 = options.edge,
        edge = _options$edge4 === void 0 ? 'both' : _options$edge4;

    if (!selection) {
      return;
    }

    if (edge === 'start') {
      edge = Range.isBackward(selection) ? 'focus' : 'anchor';
    }

    if (edge === 'end') {
      edge = Range.isBackward(selection) ? 'anchor' : 'focus';
    }

    var anchor = selection.anchor,
        focus = selection.focus;
    var point = edge === 'anchor' ? anchor : focus;
    Transforms.setSelection(editor, _defineProperty$g({}, edge === 'anchor' ? 'anchor' : 'focus', _objectSpread$1$1(_objectSpread$1$1({}, point), props)));
  },

  /**
   * Set new properties on the selection.
   */
  setSelection: function setSelection(editor, props) {
    var selection = editor.selection;
    var oldProps = {};
    var newProps = {};

    if (!selection) {
      return;
    }

    for (var k in props) {
      if (k === 'anchor' && props.anchor != null && !Point.equals(props.anchor, selection.anchor) || k === 'focus' && props.focus != null && !Point.equals(props.focus, selection.focus) || k !== 'anchor' && k !== 'focus' && props[k] !== selection[k]) {
        oldProps[k] = selection[k];
        newProps[k] = props[k];
      }
    }

    if (Object.keys(oldProps).length > 0) {
      editor.apply({
        type: 'set_selection',
        properties: oldProps,
        newProperties: newProps
      });
    }
  }
};
var TextTransforms = {
  /**
   * Delete content in the editor.
   */
  "delete": function _delete(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor$1.withoutNormalizing(editor, function () {
      var _options$reverse10 = options.reverse,
          reverse = _options$reverse10 === void 0 ? false : _options$reverse10,
          _options$unit5 = options.unit,
          unit = _options$unit5 === void 0 ? 'character' : _options$unit5,
          _options$distance4 = options.distance,
          distance = _options$distance4 === void 0 ? 1 : _options$distance4,
          _options$voids18 = options.voids,
          voids = _options$voids18 === void 0 ? false : _options$voids18;
      var _options$at15 = options.at,
          at = _options$at15 === void 0 ? editor.selection : _options$at15,
          _options$hanging5 = options.hanging,
          hanging = _options$hanging5 === void 0 ? false : _options$hanging5;

      if (!at) {
        return;
      }

      if (Range.isRange(at) && Range.isCollapsed(at)) {
        at = at.anchor;
      }

      if (Point.isPoint(at)) {
        var furthestVoid = Editor$1["void"](editor, {
          at: at,
          mode: 'highest'
        });

        if (!voids && furthestVoid) {
          var _furthestVoid = _slicedToArray$2(furthestVoid, 2),
              voidPath = _furthestVoid[1];

          at = voidPath;
        } else {
          var opts = {
            unit: unit,
            distance: distance
          };
          var target = reverse ? Editor$1.before(editor, at, opts) || Editor$1.start(editor, []) : Editor$1.after(editor, at, opts) || Editor$1.end(editor, []);
          at = {
            anchor: at,
            focus: target
          };
          hanging = true;
        }
      }

      if (Path.isPath(at)) {
        Transforms.removeNodes(editor, {
          at: at,
          voids: voids
        });
        return;
      }

      if (Range.isCollapsed(at)) {
        return;
      }

      if (!hanging) {
        var _Range$edges41 = Range.edges(at),
            _Range$edges42 = _slicedToArray$2(_Range$edges41, 2),
            _end = _Range$edges42[1];

        var endOfDoc = Editor$1.end(editor, []);

        if (!Point.equals(_end, endOfDoc)) {
          at = Editor$1.unhangRange(editor, at, {
            voids: voids
          });
        }
      }

      var _Range$edges43 = Range.edges(at),
          _Range$edges44 = _slicedToArray$2(_Range$edges43, 2),
          start = _Range$edges44[0],
          end = _Range$edges44[1];

      var startBlock = Editor$1.above(editor, {
        match: function match(n) {
          return Editor$1.isBlock(editor, n);
        },
        at: start,
        voids: voids
      });
      var endBlock = Editor$1.above(editor, {
        match: function match(n) {
          return Editor$1.isBlock(editor, n);
        },
        at: end,
        voids: voids
      });
      var isAcrossBlocks = startBlock && endBlock && !Path.equals(startBlock[1], endBlock[1]);
      var isSingleText = Path.equals(start.path, end.path);
      var startVoid = voids ? null : Editor$1["void"](editor, {
        at: start,
        mode: 'highest'
      });
      var endVoid = voids ? null : Editor$1["void"](editor, {
        at: end,
        mode: 'highest'
      }); // If the start or end points are inside an inline void, nudge them out.

      if (startVoid) {
        var before = Editor$1.before(editor, start);

        if (before && startBlock && Path.isAncestor(startBlock[1], before.path)) {
          start = before;
        }
      }

      if (endVoid) {
        var after = Editor$1.after(editor, end);

        if (after && endBlock && Path.isAncestor(endBlock[1], after.path)) {
          end = after;
        }
      } // Get the highest nodes that are completely inside the range, as well as
      // the start and end nodes.


      var matches = [];
      var lastPath;

      var _iterator39 = _createForOfIteratorHelper$1(Editor$1.nodes(editor, {
        at: at,
        voids: voids
      })),
          _step39;

      try {
        for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
          var entry = _step39.value;

          var _entry5 = _slicedToArray$2(entry, 2),
              node = _entry5[0],
              path = _entry5[1];

          if (lastPath && Path.compare(path, lastPath) === 0) {
            continue;
          }

          if (!voids && Editor$1.isVoid(editor, node) || !Path.isCommon(path, start.path) && !Path.isCommon(path, end.path)) {
            matches.push(entry);
            lastPath = path;
          }
        }
      } catch (err) {
        _iterator39.e(err);
      } finally {
        _iterator39.f();
      }

      var pathRefs = Array.from(matches, function (_ref) {
        var _ref17 = _slicedToArray$2(_ref, 2),
            p = _ref17[1];

        return Editor$1.pathRef(editor, p);
      });
      var startRef = Editor$1.pointRef(editor, start);
      var endRef = Editor$1.pointRef(editor, end);

      if (!isSingleText && !startVoid) {
        var _point = startRef.current;

        var _Editor$leaf3 = Editor$1.leaf(editor, _point),
            _Editor$leaf4 = _slicedToArray$2(_Editor$leaf3, 1),
            _node = _Editor$leaf4[0];

        var _path = _point.path;
        var _start = start,
            offset = _start.offset;

        var text = _node.text.slice(offset);

        if (text.length > 0) editor.apply({
          type: 'remove_text',
          path: _path,
          offset: offset,
          text: text
        });
      }

      for (var _i5 = 0, _pathRefs4 = pathRefs; _i5 < _pathRefs4.length; _i5++) {
        var pathRef = _pathRefs4[_i5];

        var _path2 = pathRef.unref();

        Transforms.removeNodes(editor, {
          at: _path2,
          voids: voids
        });
      }

      if (!endVoid) {
        var _point2 = endRef.current;

        var _Editor$leaf5 = Editor$1.leaf(editor, _point2),
            _Editor$leaf6 = _slicedToArray$2(_Editor$leaf5, 1),
            _node2 = _Editor$leaf6[0];

        var _path3 = _point2.path;

        var _offset = isSingleText ? start.offset : 0;

        var _text = _node2.text.slice(_offset, end.offset);

        if (_text.length > 0) editor.apply({
          type: 'remove_text',
          path: _path3,
          offset: _offset,
          text: _text
        });
      }

      if (!isSingleText && isAcrossBlocks && endRef.current && startRef.current) {
        Transforms.mergeNodes(editor, {
          at: endRef.current,
          hanging: true,
          voids: voids
        });
      }

      var startUnref = startRef.unref();
      var endUnref = endRef.unref();
      var point = reverse ? startUnref || endUnref : endUnref || startUnref;

      if (options.at == null && point) {
        Transforms.select(editor, point);
      }
    });
  },

  /**
   * Insert a fragment at a specific location in the editor.
   */
  insertFragment: function insertFragment(editor, fragment) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor$1.withoutNormalizing(editor, function () {
      var _options$hanging6 = options.hanging,
          hanging = _options$hanging6 === void 0 ? false : _options$hanging6,
          _options$voids19 = options.voids,
          voids = _options$voids19 === void 0 ? false : _options$voids19;
      var _options$at16 = options.at,
          at = _options$at16 === void 0 ? editor.selection : _options$at16;

      if (!fragment.length) {
        return;
      }

      if (!at) {
        return;
      } else if (Range.isRange(at)) {
        if (!hanging) {
          at = Editor$1.unhangRange(editor, at);
        }

        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var _Range$edges45 = Range.edges(at),
              _Range$edges46 = _slicedToArray$2(_Range$edges45, 2),
              end = _Range$edges46[1];

          if (!voids && Editor$1["void"](editor, {
            at: end
          })) {
            return;
          }

          var pointRef = Editor$1.pointRef(editor, end);
          Transforms["delete"](editor, {
            at: at
          });
          at = pointRef.unref();
        }
      } else if (Path.isPath(at)) {
        at = Editor$1.start(editor, at);
      }

      if (!voids && Editor$1["void"](editor, {
        at: at
      })) {
        return;
      } // If the insert point is at the edge of an inline node, move it outside
      // instead since it will need to be split otherwise.


      var inlineElementMatch = Editor$1.above(editor, {
        at: at,
        match: function match(n) {
          return Editor$1.isInline(editor, n);
        },
        mode: 'highest',
        voids: voids
      });

      if (inlineElementMatch) {
        var _inlineElementMatch = _slicedToArray$2(inlineElementMatch, 2),
            _inlinePath = _inlineElementMatch[1];

        if (Editor$1.isEnd(editor, at, _inlinePath)) {
          var after = Editor$1.after(editor, _inlinePath);
          at = after;
        } else if (Editor$1.isStart(editor, at, _inlinePath)) {
          var before = Editor$1.before(editor, _inlinePath);
          at = before;
        }
      }

      var blockMatch = Editor$1.above(editor, {
        match: function match(n) {
          return Editor$1.isBlock(editor, n);
        },
        at: at,
        voids: voids
      });

      var _blockMatch = _slicedToArray$2(blockMatch, 2),
          blockPath = _blockMatch[1];

      var isBlockStart = Editor$1.isStart(editor, at, blockPath);
      var isBlockEnd = Editor$1.isEnd(editor, at, blockPath);
      var isBlockEmpty = isBlockStart && isBlockEnd;
      var mergeStart = !isBlockStart || isBlockStart && isBlockEnd;
      var mergeEnd = !isBlockEnd;

      var _Node$first5 = Node.first({
        children: fragment
      }, []),
          _Node$first6 = _slicedToArray$2(_Node$first5, 2),
          firstPath = _Node$first6[1];

      var _Node$last5 = Node.last({
        children: fragment
      }, []),
          _Node$last6 = _slicedToArray$2(_Node$last5, 2),
          lastPath = _Node$last6[1];

      var matches = [];

      var matcher = function matcher(_ref2) {
        var _ref18 = _slicedToArray$2(_ref2, 2),
            n = _ref18[0],
            p = _ref18[1];

        var isRoot = p.length === 0;

        if (isRoot) {
          return false;
        }

        if (isBlockEmpty) {
          return true;
        }

        if (mergeStart && Path.isAncestor(p, firstPath) && Element$1.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
          return false;
        }

        if (mergeEnd && Path.isAncestor(p, lastPath) && Element$1.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
          return false;
        }

        return true;
      };

      var _iterator40 = _createForOfIteratorHelper$1(Node.nodes({
        children: fragment
      }, {
        pass: matcher
      })),
          _step40;

      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var entry = _step40.value;

          if (matcher(entry)) {
            matches.push(entry);
          }
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }

      var starts = [];
      var middles = [];
      var ends = [];
      var starting = true;
      var hasBlocks = false;

      for (var _i6 = 0, _matches2 = matches; _i6 < _matches2.length; _i6++) {
        var _matches2$_i = _slicedToArray$2(_matches2[_i6], 1),
            node = _matches2$_i[0];

        if (Element$1.isElement(node) && !editor.isInline(node)) {
          starting = false;
          hasBlocks = true;
          middles.push(node);
        } else if (starting) {
          starts.push(node);
        } else {
          ends.push(node);
        }
      }

      var _Editor$nodes13 = Editor$1.nodes(editor, {
        at: at,
        match: function match(n) {
          return Text.isText(n) || Editor$1.isInline(editor, n);
        },
        mode: 'highest',
        voids: voids
      }),
          _Editor$nodes14 = _slicedToArray$2(_Editor$nodes13, 1),
          inlineMatch = _Editor$nodes14[0];

      var _inlineMatch = _slicedToArray$2(inlineMatch, 2),
          inlinePath = _inlineMatch[1];

      var isInlineStart = Editor$1.isStart(editor, at, inlinePath);
      var isInlineEnd = Editor$1.isEnd(editor, at, inlinePath);
      var middleRef = Editor$1.pathRef(editor, isBlockEnd ? Path.next(blockPath) : blockPath);
      var endRef = Editor$1.pathRef(editor, isInlineEnd ? Path.next(inlinePath) : inlinePath);
      var blockPathRef = Editor$1.pathRef(editor, blockPath);
      Transforms.splitNodes(editor, {
        at: at,
        match: function match(n) {
          return hasBlocks ? Editor$1.isBlock(editor, n) : Text.isText(n) || Editor$1.isInline(editor, n);
        },
        mode: hasBlocks ? 'lowest' : 'highest',
        voids: voids
      });
      var startRef = Editor$1.pathRef(editor, !isInlineStart || isInlineStart && isInlineEnd ? Path.next(inlinePath) : inlinePath);
      Transforms.insertNodes(editor, starts, {
        at: startRef.current,
        match: function match(n) {
          return Text.isText(n) || Editor$1.isInline(editor, n);
        },
        mode: 'highest',
        voids: voids
      });

      if (isBlockEmpty && middles.length) {
        Transforms["delete"](editor, {
          at: blockPathRef.unref(),
          voids: voids
        });
      }

      Transforms.insertNodes(editor, middles, {
        at: middleRef.current,
        match: function match(n) {
          return Editor$1.isBlock(editor, n);
        },
        mode: 'lowest',
        voids: voids
      });
      Transforms.insertNodes(editor, ends, {
        at: endRef.current,
        match: function match(n) {
          return Text.isText(n) || Editor$1.isInline(editor, n);
        },
        mode: 'highest',
        voids: voids
      });

      if (!options.at) {
        var path;

        if (ends.length > 0) {
          path = Path.previous(endRef.current);
        } else if (middles.length > 0) {
          path = Path.previous(middleRef.current);
        } else {
          path = Path.previous(startRef.current);
        }

        var _end2 = Editor$1.end(editor, path);

        Transforms.select(editor, _end2);
      }

      startRef.unref();
      middleRef.unref();
      endRef.unref();
    });
  },

  /**
   * Insert a string of text in the Editor.
   */
  insertText: function insertText(editor, text) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor$1.withoutNormalizing(editor, function () {
      var _options$voids20 = options.voids,
          voids = _options$voids20 === void 0 ? false : _options$voids20;
      var _options$at17 = options.at,
          at = _options$at17 === void 0 ? editor.selection : _options$at17;

      if (!at) {
        return;
      }

      if (Path.isPath(at)) {
        at = Editor$1.range(editor, at);
      }

      if (Range.isRange(at)) {
        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var end = Range.end(at);

          if (!voids && Editor$1["void"](editor, {
            at: end
          })) {
            return;
          }

          var pointRef = Editor$1.pointRef(editor, end);
          Transforms["delete"](editor, {
            at: at,
            voids: voids
          });
          at = pointRef.unref();
          Transforms.setSelection(editor, {
            anchor: at,
            focus: at
          });
        }
      }

      if (!voids && Editor$1["void"](editor, {
        at: at
      })) {
        return;
      }

      var _at = at,
          path = _at.path,
          offset = _at.offset;
      if (text.length > 0) editor.apply({
        type: 'insert_text',
        path: path,
        offset: offset,
        text: text
      });
    });
  }
};

function ownKeys$a(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$a(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$a(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Transforms = _objectSpread$a(_objectSpread$a(_objectSpread$a(_objectSpread$a({}, GeneralTransforms), NodeTransforms), SelectionTransforms), TextTransforms);

var lib = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Constants.
 */

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
var MODIFIERS = {
  alt: 'altKey',
  control: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};
var ALIASES = {
  add: '+',
  "break": 'pause',
  cmd: 'meta',
  command: 'meta',
  ctl: 'control',
  ctrl: 'control',
  del: 'delete',
  down: 'arrowdown',
  esc: 'escape',
  ins: 'insert',
  left: 'arrowleft',
  mod: IS_MAC ? 'meta' : 'control',
  opt: 'alt',
  option: 'alt',
  "return": 'enter',
  right: 'arrowright',
  space: ' ',
  spacebar: ' ',
  up: 'arrowup',
  win: 'meta',
  windows: 'meta'
};
var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  ' ': 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  "delete": 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  '\'': 222
};

for (var f = 1; f < 20; f++) {
  CODES['f' + f] = 111 + f;
}
/**
 * Is hotkey?
 */


function isHotkey(hotkey, options, event) {
  if (options && !('byKey' in options)) {
    event = options;
    options = null;
  }

  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }

  var array = hotkey.map(function (string) {
    return parseHotkey(string, options);
  });

  var check = function check(e) {
    return array.some(function (object) {
      return compareHotkey(object, e);
    });
  };

  var ret = event == null ? check : check(event);
  return ret;
}

function isCodeHotkey(hotkey, event) {
  return isHotkey(hotkey, event);
}

function isKeyHotkey(hotkey, event) {
  return isHotkey(hotkey, {
    byKey: true
  }, event);
}
/**
 * Parse.
 */


function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {}; // Special case to handle the `+` key since we use it as a separator.

  hotkey = hotkey.replace('++', '+add');
  var values = hotkey.split('+');
  var length = values.length; // Ensure that all the modifiers are set to false unless the hotkey has them.

  for (var k in MODIFIERS) {
    ret[MODIFIERS[k]] = false;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;
      var optional = value.endsWith('?') && value.length > 1;

      if (optional) {
        value = value.slice(0, -1);
      }

      var name = toKeyName(value);
      var modifier = MODIFIERS[name];

      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name;
        } else {
          ret.which = toKeyCode(value);
        }
      }

      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"]) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}
/**
 * Compare.
 */


function compareHotkey(object, event) {
  for (var key in object) {
    var expected = object[key];
    var actual = void 0;

    if (expected == null) {
      continue;
    }

    if (key === 'key' && event.key != null) {
      actual = event.key.toLowerCase();
    } else if (key === 'which') {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key];
    }

    if (actual == null && expected === false) {
      continue;
    }

    if (actual !== expected) {
      return false;
    }
  }

  return true;
}
/**
 * Utils.
 */


function toKeyCode(name) {
  name = toKeyName(name);
  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
  return code;
}

function toKeyName(name) {
  name = name.toLowerCase();
  name = ALIASES[name] || name;
  return name;
}
/**
 * Export.
 */


exports["default"] = isHotkey;
exports.isHotkey = isHotkey;
exports.isCodeHotkey = isCodeHotkey;
exports.isKeyHotkey = isKeyHotkey;
exports.parseHotkey = parseHotkey;
exports.compareHotkey = compareHotkey;
exports.toKeyCode = toKeyCode;
exports.toKeyName = toKeyName;
}(lib));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

parseInt(React.version.split('.')[0], 10) >= 17;
typeof navigator !== 'undefined' && typeof window !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var IS_APPLE = typeof navigator !== 'undefined' && /Mac OS X/.test(navigator.userAgent);
typeof navigator !== 'undefined' && /Android/.test(navigator.userAgent);
var IS_FIREFOX = typeof navigator !== 'undefined' && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
typeof navigator !== 'undefined' && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent); // "modern" Edge was released at 79.x

typeof navigator !== 'undefined' && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent);
var IS_CHROME = typeof navigator !== 'undefined' && /Chrome/i.test(navigator.userAgent); // Native `beforeInput` events don't work well with react on Chrome 75
// and older, Chrome 76+ can use `beforeInput` though.

typeof navigator !== 'undefined' && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent); // Firefox did not support `beforeInput` until `v87`.

typeof navigator !== 'undefined' && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent); // qq browser

typeof navigator !== 'undefined' && /.*QQBrowser/.test(navigator.userAgent); // UC mobile browser

typeof navigator !== 'undefined' && /.*UCBrowser/.test(navigator.userAgent); // Wechat browser

typeof navigator !== 'undefined' && /.*Wechat/.test(navigator.userAgent); // Check if DOM is available as React does internally.
/**
 * Two weak maps that allow us rebuild a path given a node. They are populated
 * at render time such that after a render occurs we can always backtrack.
 */


var NODE_TO_INDEX = new WeakMap();
var NODE_TO_PARENT = new WeakMap();
/**
 * Weak maps that allow us to go between Slate nodes and DOM nodes. These
 * are used to resolve DOM event-related logic into Slate actions.
 */

var EDITOR_TO_WINDOW = new WeakMap();
var EDITOR_TO_ELEMENT = new WeakMap();
var ELEMENT_TO_NODE = new WeakMap();
var NODE_TO_KEY = new WeakMap();
var EDITOR_TO_KEY_TO_ELEMENT = new WeakMap();
/**
 * Weak maps for storing editor-related state.
 */

var IS_READ_ONLY = new WeakMap();
var IS_FOCUSED = new WeakMap();
var EDITOR_TO_USER_SELECTION = new WeakMap();
/**
 * Weak map for associating the context `onChange` context with the plugin.
 */

var EDITOR_TO_ON_CHANGE = new WeakMap();
/**
 * Hotkey mappings for each platform.
 */


var HOTKEYS = {
  bold: 'mod+b',
  compose: ['down', 'left', 'right', 'up', 'backspace', 'enter'],
  moveBackward: 'left',
  moveForward: 'right',
  moveWordBackward: 'ctrl+left',
  moveWordForward: 'ctrl+right',
  deleteBackward: 'shift?+backspace',
  deleteForward: 'shift?+delete',
  extendBackward: 'shift+left',
  extendForward: 'shift+right',
  italic: 'mod+i',
  insertSoftBreak: 'shift+enter',
  splitBlock: 'enter',
  undo: 'mod+z'
};
var APPLE_HOTKEYS = {
  moveLineBackward: 'opt+up',
  moveLineForward: 'opt+down',
  moveWordBackward: 'opt+left',
  moveWordForward: 'opt+right',
  deleteBackward: ['ctrl+backspace', 'ctrl+h'],
  deleteForward: ['ctrl+delete', 'ctrl+d'],
  deleteLineBackward: 'cmd+shift?+backspace',
  deleteLineForward: ['cmd+shift?+delete', 'ctrl+k'],
  deleteWordBackward: 'opt+shift?+backspace',
  deleteWordForward: 'opt+shift?+delete',
  extendLineBackward: 'opt+shift+up',
  extendLineForward: 'opt+shift+down',
  redo: 'cmd+shift+z',
  transposeCharacter: 'ctrl+t'
};
var WINDOWS_HOTKEYS = {
  deleteWordBackward: 'ctrl+shift?+backspace',
  deleteWordForward: 'ctrl+shift?+delete',
  redo: ['ctrl+y', 'ctrl+shift+z']
};
/**
 * Create a platform-aware hotkey checker.
 */

var create = function create(key) {
  var generic = HOTKEYS[key];
  var apple = APPLE_HOTKEYS[key];
  var windows = WINDOWS_HOTKEYS[key];
  var isGeneric = generic && lib.isKeyHotkey(generic);
  var isApple = apple && lib.isKeyHotkey(apple);
  var isWindows = windows && lib.isKeyHotkey(windows);
  return function (event) {
    if (isGeneric && isGeneric(event)) return true;
    if (IS_APPLE && isApple && isApple(event)) return true;
    if (!IS_APPLE && isWindows && isWindows(event)) return true;
    return false;
  };
};
/**
 * Hotkeys.
 */


({
  isBold: create('bold'),
  isCompose: create('compose'),
  isMoveBackward: create('moveBackward'),
  isMoveForward: create('moveForward'),
  isDeleteBackward: create('deleteBackward'),
  isDeleteForward: create('deleteForward'),
  isDeleteLineBackward: create('deleteLineBackward'),
  isDeleteLineForward: create('deleteLineForward'),
  isDeleteWordBackward: create('deleteWordBackward'),
  isDeleteWordForward: create('deleteWordForward'),
  isExtendBackward: create('extendBackward'),
  isExtendForward: create('extendForward'),
  isExtendLineBackward: create('extendLineBackward'),
  isExtendLineForward: create('extendLineForward'),
  isItalic: create('italic'),
  isMoveLineBackward: create('moveLineBackward'),
  isMoveLineForward: create('moveLineForward'),
  isMoveWordBackward: create('moveWordBackward'),
  isMoveWordForward: create('moveWordForward'),
  isRedo: create('redo'),
  isSoftBreak: create('insertSoftBreak'),
  isSplitBlock: create('splitBlock'),
  isTransposeCharacter: create('transposeCharacter'),
  isUndo: create('undo')
});
/**
 * Types.
 */

/**
 * Returns the host window of a DOM node
 */

var getDefaultView = function getDefaultView(value) {
  return value && value.ownerDocument && value.ownerDocument.defaultView || null;
};
/**
 * Check if a DOM node is a comment node.
 */


var isDOMComment = function isDOMComment(value) {
  return isDOMNode(value) && value.nodeType === 8;
};
/**
 * Check if a DOM node is an element node.
 */


var isDOMElement = function isDOMElement(value) {
  return isDOMNode(value) && value.nodeType === 1;
};
/**
 * Check if a value is a DOM node.
 */


var isDOMNode = function isDOMNode(value) {
  var window = getDefaultView(value);
  return !!window && value instanceof window.Node;
};
/**
 * Check if a value is a DOM selection.
 */


var isDOMSelection = function isDOMSelection(value) {
  var window = value && value.anchorNode && getDefaultView(value.anchorNode);
  return !!window && value instanceof window.Selection;
};
/**
 * Check if a DOM node is an element node.
 */


var isDOMText = function isDOMText(value) {
  return isDOMNode(value) && value.nodeType === 3;
};
/**
 * Normalize a DOM point so that it always refers to a text node.
 */


var normalizeDOMPoint = function normalizeDOMPoint(domPoint) {
  var _domPoint = _slicedToArray$2(domPoint, 2),
      node = _domPoint[0],
      offset = _domPoint[1]; // If it's an element node, its offset refers to the index of its children
  // including comment nodes, so try to find the right text child node.


  if (isDOMElement(node) && node.childNodes.length) {
    var isLast = offset === node.childNodes.length;
    var index = isLast ? offset - 1 : offset;

    var _getEditableChildAndI = getEditableChildAndIndex(node, index, isLast ? 'backward' : 'forward');

    var _getEditableChildAndI2 = _slicedToArray$2(_getEditableChildAndI, 2);

    node = _getEditableChildAndI2[0];
    index = _getEditableChildAndI2[1];
    // If the editable child found is in front of input offset, we instead seek to its end
    isLast = index < offset; // If the node has children, traverse until we have a leaf node. Leaf nodes
    // can be either text nodes, or other void DOM nodes.

    while (isDOMElement(node) && node.childNodes.length) {
      var i = isLast ? node.childNodes.length - 1 : 0;
      node = getEditableChild(node, i, isLast ? 'backward' : 'forward');
    } // Determine the new offset inside the text node.


    offset = isLast && node.textContent != null ? node.textContent.length : 0;
  } // Return the node and offset.


  return [node, offset];
};
/**
 * Determines wether the active element is nested within a shadowRoot
 */


var hasShadowRoot = function hasShadowRoot() {
  return !!(window.document.activeElement && window.document.activeElement.shadowRoot);
};
/**
 * Get the nearest editable child and index at `index` in a `parent`, preferring
 * `direction`.
 */


var getEditableChildAndIndex = function getEditableChildAndIndex(parent, index, direction) {
  var childNodes = parent.childNodes;
  var child = childNodes[index];
  var i = index;
  var triedForward = false;
  var triedBackward = false; // While the child is a comment node, or an element node with no children,
  // keep iterating to find a sibling non-void, non-comment node.

  while (isDOMComment(child) || isDOMElement(child) && child.childNodes.length === 0 || isDOMElement(child) && child.getAttribute('contenteditable') === 'false') {
    if (triedForward && triedBackward) {
      break;
    }

    if (i >= childNodes.length) {
      triedForward = true;
      i = index - 1;
      direction = 'backward';
      continue;
    }

    if (i < 0) {
      triedBackward = true;
      i = index + 1;
      direction = 'forward';
      continue;
    }

    child = childNodes[i];
    index = i;
    i += direction === 'forward' ? 1 : -1;
  }

  return [child, index];
};
/**
 * Get the nearest editable child at `index` in a `parent`, preferring
 * `direction`.
 */


var getEditableChild = function getEditableChild(parent, index, direction) {
  var _getEditableChildAndI3 = getEditableChildAndIndex(parent, index, direction),
      _getEditableChildAndI4 = _slicedToArray$2(_getEditableChildAndI3, 1),
      child = _getEditableChildAndI4[0];

  return child;
};
/**
 * Get a plaintext representation of the content of a node, accounting for block
 * elements which get a newline appended.
 *
 * The domNode must be attached to the DOM.
 */


var getPlainText = function getPlainText(domNode) {
  var text = '';

  if (isDOMText(domNode) && domNode.nodeValue) {
    return domNode.nodeValue;
  }

  if (isDOMElement(domNode)) {
    for (var _i = 0, _Array$from = Array.from(domNode.childNodes); _i < _Array$from.length; _i++) {
      var childNode = _Array$from[_i];
      text += getPlainText(childNode);
    }

    var display = getComputedStyle(domNode).getPropertyValue('display');

    if (display === 'block' || display === 'list' || domNode.tagName === 'BR') {
      text += '\n';
    }
  }

  return text;
};
/**
 * Get x-slate-fragment attribute from data-slate-fragment
 */


var catchSlateFragment = /data-slate-fragment="(.+?)"/m;

var getSlateFragmentAttribute = function getSlateFragmentAttribute(dataTransfer) {
  var htmlData = dataTransfer.getData('text/html');

  var _ref8 = htmlData.match(catchSlateFragment) || [],
      _ref9 = _slicedToArray$2(_ref8, 2),
      fragment = _ref9[1];

  return fragment;
};
/**
 * An auto-incrementing identifier for keys.
 */


var n = 0;
/**
 * A class that keeps track of a key string. We use a full class here because we
 * want to be able to use them as keys in `WeakMap` objects.
 */

var Key = function Key() {
  _classCallCheck$d(this, Key);

  this.id = "".concat(n++);
};

var ReactEditor = {
  /**
   * Return the host window of the current editor.
   */
  getWindow: function getWindow(editor) {
    var window = EDITOR_TO_WINDOW.get(editor);

    if (!window) {
      throw new Error('Unable to find a host window element for this editor');
    }

    return window;
  },

  /**
   * Find a key for a Slate node.
   */
  findKey: function findKey(editor, node) {
    var key = NODE_TO_KEY.get(node);

    if (!key) {
      key = new Key();
      NODE_TO_KEY.set(node, key);
    }

    return key;
  },

  /**
   * Find the path of Slate node.
   */
  findPath: function findPath(editor, node) {
    var path = [];
    var child = node;

    while (true) {
      var parent = NODE_TO_PARENT.get(child);

      if (parent == null) {
        if (Editor$1.isEditor(child)) {
          return path;
        } else {
          break;
        }
      }

      var i = NODE_TO_INDEX.get(child);

      if (i == null) {
        break;
      }

      path.unshift(i);
      child = parent;
    }

    throw new Error("Unable to find the path for Slate node: ".concat(JSON.stringify(node)));
  },

  /**
   * Find the DOM node that implements DocumentOrShadowRoot for the editor.
   */
  findDocumentOrShadowRoot: function findDocumentOrShadowRoot(editor) {
    var el = ReactEditor.toDOMNode(editor, editor);
    var root = el.getRootNode();

    if ((root instanceof Document || root instanceof ShadowRoot) && root.getSelection != null) {
      return root;
    }

    return el.ownerDocument;
  },

  /**
   * Check if the editor is focused.
   */
  isFocused: function isFocused(editor) {
    return !!IS_FOCUSED.get(editor);
  },

  /**
   * Check if the editor is in read-only mode.
   */
  isReadOnly: function isReadOnly(editor) {
    return !!IS_READ_ONLY.get(editor);
  },

  /**
   * Blur the editor.
   */
  blur: function blur(editor) {
    var el = ReactEditor.toDOMNode(editor, editor);
    var root = ReactEditor.findDocumentOrShadowRoot(editor);
    IS_FOCUSED.set(editor, false);

    if (root.activeElement === el) {
      el.blur();
    }
  },

  /**
   * Focus the editor.
   */
  focus: function focus(editor) {
    var el = ReactEditor.toDOMNode(editor, editor);
    var root = ReactEditor.findDocumentOrShadowRoot(editor);
    IS_FOCUSED.set(editor, true);

    if (root.activeElement !== el) {
      el.focus({
        preventScroll: true
      });
    }
  },

  /**
   * Deselect the editor.
   */
  deselect: function deselect(editor) {
    ReactEditor.toDOMNode(editor, editor);
    var selection = editor.selection;
    var root = ReactEditor.findDocumentOrShadowRoot(editor);
    var domSelection = root.getSelection();

    if (domSelection && domSelection.rangeCount > 0) {
      domSelection.removeAllRanges();
    }

    if (selection) {
      Transforms.deselect(editor);
    }
  },

  /**
   * Check if a DOM node is within the editor.
   */
  hasDOMNode: function hasDOMNode(editor, target) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$editable = options.editable,
        editable = _options$editable === void 0 ? false : _options$editable;
    var editorEl = ReactEditor.toDOMNode(editor, editor);
    var targetEl; // COMPAT: In Firefox, reading `target.nodeType` will throw an error if
    // target is originating from an internal "restricted" element (e.g. a
    // stepper arrow on a number input). (2018/05/04)
    // https://github.com/ianstormtaylor/slate/issues/1819

    try {
      targetEl = isDOMElement(target) ? target : target.parentElement;
    } catch (err) {
      if (!err.message.includes('Permission denied to access property "nodeType"')) {
        throw err;
      }
    }

    if (!targetEl) {
      return false;
    }

    return targetEl.closest("[data-slate-editor]") === editorEl && (!editable || targetEl.isContentEditable ? true : typeof targetEl.isContentEditable === 'boolean' && // isContentEditable exists only on HTMLElement, and on other nodes it will be undefined
    // this is the core logic that lets you know you got the right editor.selection instead of null when editor is contenteditable="false"(readOnly)
    targetEl.closest('[contenteditable="false"]') === editorEl || !!targetEl.getAttribute('data-slate-zero-width'));
  },

  /**
   * Insert data from a `DataTransfer` into the editor.
   */
  insertData: function insertData(editor, data) {
    editor.insertData(data);
  },

  /**
   * Insert fragment data from a `DataTransfer` into the editor.
   */
  insertFragmentData: function insertFragmentData(editor, data) {
    return editor.insertFragmentData(data);
  },

  /**
   * Insert text data from a `DataTransfer` into the editor.
   */
  insertTextData: function insertTextData(editor, data) {
    return editor.insertTextData(data);
  },

  /**
   * Sets data from the currently selected fragment on a `DataTransfer`.
   */
  setFragmentData: function setFragmentData(editor, data, originEvent) {
    editor.setFragmentData(data, originEvent);
  },

  /**
   * Find the native DOM element from a Slate node.
   */
  toDOMNode: function toDOMNode(editor, node) {
    var KEY_TO_ELEMENT = EDITOR_TO_KEY_TO_ELEMENT.get(editor);
    var domNode = Editor$1.isEditor(node) ? EDITOR_TO_ELEMENT.get(editor) : KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT.get(ReactEditor.findKey(editor, node));

    if (!domNode) {
      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(JSON.stringify(node)));
    }

    return domNode;
  },

  /**
   * Find a native DOM selection point from a Slate point.
   */
  toDOMPoint: function toDOMPoint(editor, point) {
    var _Editor$node = Editor$1.node(editor, point.path),
        _Editor$node2 = _slicedToArray$2(_Editor$node, 1),
        node = _Editor$node2[0];

    var el = ReactEditor.toDOMNode(editor, node);
    var domPoint; // If we're inside a void node, force the offset to 0, otherwise the zero
    // width spacing character will result in an incorrect offset of 1

    if (Editor$1["void"](editor, {
      at: point
    })) {
      point = {
        path: point.path,
        offset: 0
      };
    } // For each leaf, we need to isolate its content, which means filtering
    // to its direct text and zero-width spans. (We have to filter out any
    // other siblings that may have been rendered alongside them.)


    var selector = "[data-slate-string], [data-slate-zero-width]";
    var texts = Array.from(el.querySelectorAll(selector));
    var start = 0;

    for (var _i2 = 0, _texts = texts; _i2 < _texts.length; _i2++) {
      var text = _texts[_i2];
      var domNode = text.childNodes[0];

      if (domNode == null || domNode.textContent == null) {
        continue;
      }

      var length = domNode.textContent.length;
      var attr = text.getAttribute('data-slate-length');
      var trueLength = attr == null ? length : parseInt(attr, 10);
      var end = start + trueLength;

      if (point.offset <= end) {
        var offset = Math.min(length, Math.max(0, point.offset - start));
        domPoint = [domNode, offset];
        break;
      }

      start = end;
    }

    if (!domPoint) {
      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(JSON.stringify(point)));
    }

    return domPoint;
  },

  /**
   * Find a native DOM range from a Slate `range`.
   *
   * Notice: the returned range will always be ordinal regardless of the direction of Slate `range` due to DOM API limit.
   *
   * there is no way to create a reverse DOM Range using Range.setStart/setEnd
   * according to https://dom.spec.whatwg.org/#concept-range-bp-set.
   */
  toDOMRange: function toDOMRange(editor, range) {
    var anchor = range.anchor,
        focus = range.focus;
    var isBackward = Range.isBackward(range);
    var domAnchor = ReactEditor.toDOMPoint(editor, anchor);
    var domFocus = Range.isCollapsed(range) ? domAnchor : ReactEditor.toDOMPoint(editor, focus);
    var window = ReactEditor.getWindow(editor);
    var domRange = window.document.createRange();

    var _ref11 = isBackward ? domFocus : domAnchor,
        _ref12 = _slicedToArray$2(_ref11, 2),
        startNode = _ref12[0],
        startOffset = _ref12[1];

    var _ref13 = isBackward ? domAnchor : domFocus,
        _ref14 = _slicedToArray$2(_ref13, 2),
        endNode = _ref14[0],
        endOffset = _ref14[1]; // A slate Point at zero-width Leaf always has an offset of 0 but a native DOM selection at
    // zero-width node has an offset of 1 so we have to check if we are in a zero-width node and
    // adjust the offset accordingly.


    var startEl = isDOMElement(startNode) ? startNode : startNode.parentElement;
    var isStartAtZeroWidth = !!startEl.getAttribute('data-slate-zero-width');
    var endEl = isDOMElement(endNode) ? endNode : endNode.parentElement;
    var isEndAtZeroWidth = !!endEl.getAttribute('data-slate-zero-width');
    domRange.setStart(startNode, isStartAtZeroWidth ? 1 : startOffset);
    domRange.setEnd(endNode, isEndAtZeroWidth ? 1 : endOffset);
    return domRange;
  },

  /**
   * Find a Slate node from a native DOM `element`.
   */
  toSlateNode: function toSlateNode(editor, domNode) {
    var domEl = isDOMElement(domNode) ? domNode : domNode.parentElement;

    if (domEl && !domEl.hasAttribute('data-slate-node')) {
      domEl = domEl.closest("[data-slate-node]");
    }

    var node = domEl ? ELEMENT_TO_NODE.get(domEl) : null;

    if (!node) {
      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(domEl));
    }

    return node;
  },

  /**
   * Get the target range from a DOM `event`.
   */
  findEventRange: function findEventRange(editor, event) {
    if ('nativeEvent' in event) {
      event = event.nativeEvent;
    }

    var _event = event,
        x = _event.clientX,
        y = _event.clientY,
        target = _event.target;

    if (x == null || y == null) {
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
    }

    var node = ReactEditor.toSlateNode(editor, event.target);
    var path = ReactEditor.findPath(editor, node); // If the drop target is inside a void node, move it into either the
    // next or previous node, depending on which side the `x` and `y`
    // coordinates are closest to.

    if (Editor$1.isVoid(editor, node)) {
      var rect = target.getBoundingClientRect();
      var isPrev = editor.isInline(node) ? x - rect.left < rect.left + rect.width - x : y - rect.top < rect.top + rect.height - y;
      var edge = Editor$1.point(editor, path, {
        edge: isPrev ? 'start' : 'end'
      });
      var point = isPrev ? Editor$1.before(editor, edge) : Editor$1.after(editor, edge);

      if (point) {
        var _range = Editor$1.range(editor, point);

        return _range;
      }
    } // Else resolve a range from the caret position where the drop occured.


    var domRange;

    var _ReactEditor$getWindo2 = ReactEditor.getWindow(editor),
        document = _ReactEditor$getWindo2.document; // COMPAT: In Firefox, `caretRangeFromPoint` doesn't exist. (2016/07/25)


    if (document.caretRangeFromPoint) {
      domRange = document.caretRangeFromPoint(x, y);
    } else {
      var position = document.caretPositionFromPoint(x, y);

      if (position) {
        domRange = document.createRange();
        domRange.setStart(position.offsetNode, position.offset);
        domRange.setEnd(position.offsetNode, position.offset);
      }
    }

    if (!domRange) {
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
    } // Resolve a Slate range from the DOM range.


    var range = ReactEditor.toSlateRange(editor, domRange, {
      exactMatch: false,
      suppressThrow: false
    });
    return range;
  },

  /**
   * Find a Slate point from a DOM selection's `domNode` and `domOffset`.
   */
  toSlatePoint: function toSlatePoint(editor, domPoint, options) {
    var exactMatch = options.exactMatch,
        suppressThrow = options.suppressThrow;

    var _ref15 = exactMatch ? domPoint : normalizeDOMPoint(domPoint),
        _ref16 = _slicedToArray$2(_ref15, 2),
        nearestNode = _ref16[0],
        nearestOffset = _ref16[1];

    var parentNode = nearestNode.parentNode;
    var textNode = null;
    var offset = 0;

    if (parentNode) {
      var _domNode$textContent;

      var editorEl = ReactEditor.toDOMNode(editor, editor);
      var potentialVoidNode = parentNode.closest('[data-slate-void="true"]'); // Need to ensure that the closest void node is actually a void node
      // within this editor, and not a void node within some parent editor. This can happen
      // if this editor is within a void node of another editor ("nested editors", like in
      // the "Editable Voids" example on the docs site).

      var voidNode = potentialVoidNode && editorEl.contains(potentialVoidNode) ? potentialVoidNode : null;
      var leafNode = parentNode.closest('[data-slate-leaf]');
      var domNode = null; // Calculate how far into the text node the `nearestNode` is, so that we
      // can determine what the offset relative to the text node is.

      if (leafNode) {
        textNode = leafNode.closest('[data-slate-node="text"]');

        if (textNode) {
          var window = ReactEditor.getWindow(editor);
          var range = window.document.createRange();
          range.setStart(textNode, 0);
          range.setEnd(nearestNode, nearestOffset);
          var contents = range.cloneContents();
          var removals = [].concat(_toConsumableArray$2(Array.prototype.slice.call(contents.querySelectorAll('[data-slate-zero-width]'))), _toConsumableArray$2(Array.prototype.slice.call(contents.querySelectorAll('[contenteditable=false]'))));
          removals.forEach(function (el) {
            el.parentNode.removeChild(el);
          }); // COMPAT: Edge has a bug where Range.prototype.toString() will
          // convert \n into \r\n. The bug causes a loop when slate-react
          // attempts to reposition its cursor to match the native position. Use
          // textContent.length instead.
          // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10291116/

          offset = contents.textContent.length;
          domNode = textNode;
        }
      } else if (voidNode) {
        // For void nodes, the element with the offset key will be a cousin, not an
        // ancestor, so find it by going down from the nearest void parent.
        leafNode = voidNode.querySelector('[data-slate-leaf]'); // COMPAT: In read-only editors the leaf is not rendered.

        if (!leafNode) {
          offset = 1;
        } else {
          textNode = leafNode.closest('[data-slate-node="text"]');
          domNode = leafNode;
          offset = domNode.textContent.length;
          domNode.querySelectorAll('[data-slate-zero-width]').forEach(function (el) {
            offset -= el.textContent.length;
          });
        }
      }

      if (domNode && offset === domNode.textContent.length && (parentNode.hasAttribute('data-slate-zero-width') || IS_FIREFOX && (_domNode$textContent = domNode.textContent) !== null && _domNode$textContent !== void 0 && _domNode$textContent.endsWith('\n\n'))) {
        offset--;
      }
    }

    if (!textNode) {
      if (suppressThrow) {
        return null;
      }

      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(domPoint));
    } // COMPAT: If someone is clicking from one Slate editor into another,
    // the select event fires twice, once for the old editor's `element`
    // first, and then afterwards for the correct `element`. (2017/03/03)


    var slateNode = ReactEditor.toSlateNode(editor, textNode);
    var path = ReactEditor.findPath(editor, slateNode);
    return {
      path: path,
      offset: offset
    };
  },

  /**
   * Find a Slate range from a DOM range or selection.
   */
  toSlateRange: function toSlateRange(editor, domRange, options) {
    var exactMatch = options.exactMatch,
        suppressThrow = options.suppressThrow;
    var el = isDOMSelection(domRange) ? domRange.anchorNode : domRange.startContainer;
    var anchorNode;
    var anchorOffset;
    var focusNode;
    var focusOffset;
    var isCollapsed;

    if (el) {
      if (isDOMSelection(domRange)) {
        anchorNode = domRange.anchorNode;
        anchorOffset = domRange.anchorOffset;
        focusNode = domRange.focusNode;
        focusOffset = domRange.focusOffset; // COMPAT: There's a bug in chrome that always returns `true` for
        // `isCollapsed` for a Selection that comes from a ShadowRoot.
        // (2020/08/08)
        // https://bugs.chromium.org/p/chromium/issues/detail?id=447523

        if (IS_CHROME && hasShadowRoot()) {
          isCollapsed = domRange.anchorNode === domRange.focusNode && domRange.anchorOffset === domRange.focusOffset;
        } else {
          isCollapsed = domRange.isCollapsed;
        }
      } else {
        anchorNode = domRange.startContainer;
        anchorOffset = domRange.startOffset;
        focusNode = domRange.endContainer;
        focusOffset = domRange.endOffset;
        isCollapsed = domRange.collapsed;
      }
    }

    if (anchorNode == null || focusNode == null || anchorOffset == null || focusOffset == null) {
      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(domRange));
    }

    var anchor = ReactEditor.toSlatePoint(editor, [anchorNode, anchorOffset], {
      exactMatch: exactMatch,
      suppressThrow: suppressThrow
    });

    if (!anchor) {
      return null;
    }

    var focus = isCollapsed ? anchor : ReactEditor.toSlatePoint(editor, [focusNode, focusOffset], {
      exactMatch: exactMatch,
      suppressThrow: suppressThrow
    });

    if (!focus) {
      return null;
    }

    var range = {
      anchor: anchor,
      focus: focus
    }; // if the selection is a hanging range that ends in a void
    // and the DOM focus is an Element
    // (meaning that the selection ends before the element)
    // unhang the range to avoid mistakenly including the void

    if (Range.isExpanded(range) && Range.isForward(range) && isDOMElement(focusNode) && Editor$1["void"](editor, {
      at: range.focus,
      mode: 'highest'
    })) {
      range = Editor$1.unhangRange(editor, range, {
        voids: true
      });
    }

    return range;
  },
  hasRange: function hasRange(editor, range) {
    var anchor = range.anchor,
        focus = range.focus;
    return Editor$1.hasPath(editor, anchor.path) && Editor$1.hasPath(editor, focus.path);
  }
};
/**
 * Utilities for single-line deletion
 */


var doRectsIntersect = function doRectsIntersect(rect, compareRect) {
  var middle = (compareRect.top + compareRect.bottom) / 2;
  return rect.top <= middle && rect.bottom >= middle;
};

var areRangesSameLine = function areRangesSameLine(editor, range1, range2) {
  var rect1 = ReactEditor.toDOMRange(editor, range1).getBoundingClientRect();
  var rect2 = ReactEditor.toDOMRange(editor, range2).getBoundingClientRect();
  return doRectsIntersect(rect1, rect2) && doRectsIntersect(rect2, rect1);
};
/**
 * A helper utility that returns the end portion of a `Range`
 * which is located on a single line.
 *
 * @param {Editor} editor The editor object to compare against
 * @param {Range} parentRange The parent range to compare against
 * @returns {Range} A valid portion of the parentRange which is one a single line
 */


var findCurrentLineRange = function findCurrentLineRange(editor, parentRange) {
  var parentRangeBoundary = Editor$1.range(editor, Range.end(parentRange));
  var positions = Array.from(Editor$1.positions(editor, {
    at: parentRange
  }));
  var left = 0;
  var right = positions.length;
  var middle = Math.floor(right / 2);

  if (areRangesSameLine(editor, Editor$1.range(editor, positions[left]), parentRangeBoundary)) {
    return Editor$1.range(editor, positions[left], parentRangeBoundary);
  }

  if (positions.length < 2) {
    return Editor$1.range(editor, positions[positions.length - 1], parentRangeBoundary);
  }

  while (middle !== positions.length && middle !== left) {
    if (areRangesSameLine(editor, Editor$1.range(editor, positions[middle]), parentRangeBoundary)) {
      right = middle;
    } else {
      left = middle;
    }

    middle = Math.floor((left + right) / 2);
  }

  return Editor$1.range(editor, positions[right], parentRangeBoundary);
};
/**
 * `withReact` adds React and DOM specific behaviors to the editor.
 *
 * If you are using TypeScript, you must extend Slate's CustomTypes to use
 * this plugin.
 *
 * See https://docs.slatejs.org/concepts/11-typescript to learn how.
 */


var withReact = function withReact(editor) {
  var e = editor;
  var apply = e.apply,
      onChange = e.onChange,
      deleteBackward = e.deleteBackward; // The WeakMap which maps a key to a specific HTMLElement must be scoped to the editor instance to
  // avoid collisions between editors in the DOM that share the same value.

  EDITOR_TO_KEY_TO_ELEMENT.set(e, new WeakMap());

  e.deleteBackward = function (unit) {
    if (unit !== 'line') {
      return deleteBackward(unit);
    }

    if (editor.selection && Range.isCollapsed(editor.selection)) {
      var parentBlockEntry = Editor$1.above(editor, {
        match: function match(n) {
          return Editor$1.isBlock(editor, n);
        },
        at: editor.selection
      });

      if (parentBlockEntry) {
        var _parentBlockEntry = _slicedToArray$2(parentBlockEntry, 2),
            parentBlockPath = _parentBlockEntry[1];

        var parentElementRange = Editor$1.range(editor, parentBlockPath, editor.selection.anchor);
        var currentLineRange = findCurrentLineRange(e, parentElementRange);

        if (!Range.isCollapsed(currentLineRange)) {
          Transforms["delete"](editor, {
            at: currentLineRange
          });
        }
      }
    }
  }; // This attempts to reset the NODE_TO_KEY entry to the correct value
  // as apply() changes the object reference and hence invalidates the NODE_TO_KEY entry


  e.apply = function (op) {
    var matches = [];

    switch (op.type) {
      case 'insert_text':
      case 'remove_text':
      case 'set_node':
      case 'split_node':
        {
          matches.push.apply(matches, _toConsumableArray$2(getMatches(e, op.path)));
          break;
        }

      case 'set_selection':
        {
          var _EDITOR_TO_USER_SELEC; // Selection was manually set, don't restore the user selection after the change.


          (_EDITOR_TO_USER_SELEC = EDITOR_TO_USER_SELECTION.get(editor)) === null || _EDITOR_TO_USER_SELEC === void 0 ? void 0 : _EDITOR_TO_USER_SELEC.unref();
          EDITOR_TO_USER_SELECTION["delete"](editor);
          break;
        }

      case 'insert_node':
      case 'remove_node':
        {
          matches.push.apply(matches, _toConsumableArray$2(getMatches(e, Path.parent(op.path))));
          break;
        }

      case 'merge_node':
        {
          var prevPath = Path.previous(op.path);
          matches.push.apply(matches, _toConsumableArray$2(getMatches(e, prevPath)));
          break;
        }

      case 'move_node':
        {
          var commonPath = Path.common(Path.parent(op.path), Path.parent(op.newPath));
          matches.push.apply(matches, _toConsumableArray$2(getMatches(e, commonPath)));
          break;
        }
    }

    apply(op);

    for (var _i3 = 0, _matches = matches; _i3 < _matches.length; _i3++) {
      var _matches$_i = _slicedToArray$2(_matches[_i3], 2),
          path = _matches$_i[0],
          key = _matches$_i[1];

      var _Editor$node3 = Editor$1.node(e, path),
          _Editor$node4 = _slicedToArray$2(_Editor$node3, 1),
          node = _Editor$node4[0];

      NODE_TO_KEY.set(node, key);
    }
  };

  e.setFragmentData = function (data) {
    var selection = e.selection;

    if (!selection) {
      return;
    }

    var _Range$edges = Range.edges(selection),
        _Range$edges2 = _slicedToArray$2(_Range$edges, 2),
        start = _Range$edges2[0],
        end = _Range$edges2[1];

    var startVoid = Editor$1["void"](e, {
      at: start.path
    });
    var endVoid = Editor$1["void"](e, {
      at: end.path
    });

    if (Range.isCollapsed(selection) && !startVoid) {
      return;
    } // Create a fake selection so that we can add a Base64-encoded copy of the
    // fragment to the HTML, to decode on future pastes.


    var domRange = ReactEditor.toDOMRange(e, selection);
    var contents = domRange.cloneContents();
    var attach = contents.childNodes[0]; // Make sure attach is non-empty, since empty nodes will not get copied.

    contents.childNodes.forEach(function (node) {
      if (node.textContent && node.textContent.trim() !== '') {
        attach = node;
      }
    }); // COMPAT: If the end node is a void node, we need to move the end of the
    // range from the void node's spacer span, to the end of the void node's
    // content, since the spacer is before void's content in the DOM.

    if (endVoid) {
      var _endVoid = _slicedToArray$2(endVoid, 1),
          voidNode = _endVoid[0];

      var r = domRange.cloneRange();
      var domNode = ReactEditor.toDOMNode(e, voidNode);
      r.setEndAfter(domNode);
      contents = r.cloneContents();
    } // COMPAT: If the start node is a void node, we need to attach the encoded
    // fragment to the void node's content node instead of the spacer, because
    // attaching it to empty `<div>/<span>` nodes will end up having it erased by
    // most browsers. (2018/04/27)


    if (startVoid) {
      attach = contents.querySelector('[data-slate-spacer]');
    } // Remove any zero-width space spans from the cloned DOM so that they don't
    // show up elsewhere when pasted.


    Array.from(contents.querySelectorAll('[data-slate-zero-width]')).forEach(function (zw) {
      var isNewline = zw.getAttribute('data-slate-zero-width') === 'n';
      zw.textContent = isNewline ? '\n' : '';
    }); // Set a `data-slate-fragment` attribute on a non-empty node, so it shows up
    // in the HTML, and can be used for intra-Slate pasting. If it's a text
    // node, wrap it in a `<span>` so we have something to set an attribute on.

    if (isDOMText(attach)) {
      var span = attach.ownerDocument.createElement('span'); // COMPAT: In Chrome and Safari, if we don't add the `white-space` style
      // then leading and trailing spaces will be ignored. (2017/09/21)

      span.style.whiteSpace = 'pre';
      span.appendChild(attach);
      contents.appendChild(span);
      attach = span;
    }

    var fragment = e.getFragment();
    var string = JSON.stringify(fragment);
    var encoded = window.btoa(encodeURIComponent(string));
    attach.setAttribute('data-slate-fragment', encoded);
    data.setData('application/x-slate-fragment', encoded); // Add the content to a <div> so that we can get its inner HTML.

    var div = contents.ownerDocument.createElement('div');
    div.appendChild(contents);
    div.setAttribute('hidden', 'true');
    contents.ownerDocument.body.appendChild(div);
    data.setData('text/html', div.innerHTML);
    data.setData('text/plain', getPlainText(div));
    contents.ownerDocument.body.removeChild(div);
    return data;
  };

  e.insertData = function (data) {
    if (!e.insertFragmentData(data)) {
      e.insertTextData(data);
    }
  };

  e.insertFragmentData = function (data) {
    /**
     * Checking copied fragment from application/x-slate-fragment or data-slate-fragment
     */
    var fragment = data.getData('application/x-slate-fragment') || getSlateFragmentAttribute(data);

    if (fragment) {
      var decoded = decodeURIComponent(window.atob(fragment));
      var parsed = JSON.parse(decoded);
      e.insertFragment(parsed);
      return true;
    }

    return false;
  };

  e.insertTextData = function (data) {
    var text = data.getData('text/plain');

    if (text) {
      var lines = text.split(/\r\n|\r|\n/);
      var split = false;

      var _iterator3 = _createForOfIteratorHelper(lines),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var line = _step3.value;

          if (split) {
            Transforms.splitNodes(e, {
              always: true
            });
          }

          e.insertText(line);
          split = true;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return true;
    }

    return false;
  };

  e.onChange = function () {
    // COMPAT: React doesn't batch `setState` hook calls, which means that the
    // children and selection can get out of sync for one render pass. So we
    // have to use this unstable API to ensure it batches them. (2019/12/03)
    // https://github.com/facebook/react/issues/14259#issuecomment-439702367
    ReactDOM.unstable_batchedUpdates(function () {
      var onContextChange = EDITOR_TO_ON_CHANGE.get(e);

      if (onContextChange) {
        onContextChange();
      }

      onChange();
    });
  };

  return e;
};

var getMatches = function getMatches(e, path) {
  var matches = [];

  var _iterator4 = _createForOfIteratorHelper(Editor$1.levels(e, {
    at: path
  })),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _step4$value = _slicedToArray$2(_step4.value, 2),
          n = _step4$value[0],
          p = _step4$value[1];

      var key = ReactEditor.findKey(e, n);
      matches.push([p, key]);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return matches;
}; // Components

/**
 * `Object.keys` is badly typed for its reasons and this function just fixes it.
 * https://stackoverflow.com/questions/55012174/why-doesnt-object-keys-return-a-keyof-type-in-typescript
 */
function keys(o) {
  return Object.keys(o);
}

function isElementInlineWrapperElement(node) {
  return Element$1.isElementType(node, "inline-wrapper");
}

/**
 * Tracks which ids were used during current normalization run
 */
var USED_IDS = new Set();
/**
 * Keeps track what was the previous id before generating the unique id. This is needed because Slate rerenders before
 * our config updates and it wouldn't know which compiled component to render.
 */

var NORMALIZED_IDS_TO_IDS = new Map();

function isInline(node) {
  return node.type === "inline-wrapper";
}

function withShopstory(editor) {
  var insertText = editor.insertText,
      normalizeNode = editor.normalizeNode;

  editor.insertText = function (text) {
    // Verify if the current selection is placed at the end of an inline element. If yes, set the selection to start of
    // the next element before adding new text. This allows to break out from the inline element if it's placed at the end of line.
    if (editor.selection && Range.isCollapsed(editor.selection)) {
      var selectedNodeParent = Editor$1.parent(editor, editor.selection.focus.path);

      if (selectedNodeParent) {
        var _selectedNodeParent = _slicedToArray$2(selectedNodeParent, 2),
            parentNode = _selectedNodeParent[0],
            parentNodePath = _selectedNodeParent[1];

        if (Element$1.isElement(parentNode) && isInline(parentNode)) {
          var isCursorSetAtTheEnd = Editor$1.isEnd(editor, editor.selection.focus, parentNodePath);
          var nodePointAfterInlineElement = Editor$1.after(editor, parentNodePath);

          if (isCursorSetAtTheEnd && nodePointAfterInlineElement) {
            Transforms.setSelection(editor, {
              anchor: nodePointAfterInlineElement,
              focus: nodePointAfterInlineElement
            });
          }
        }
      }
    }

    insertText(text);
  };

  editor.isInline = isInline;

  editor.normalizeNode = function (entry) {
    // When copying text content from content editable element, Slate wraps pasted content into top most element.
    // We need to unwrap each block element that is nested within another block element.
    if (unwrapBlockElementsNestedWithinBlockElement(editor, entry)) {
      return;
    } // Slate by default compares text elements and merges them, but to compare them it uses strict equality comparison algorithm.
    // We need to compare them using our own algorithm.


    if (mergeVisuallyTheSameOrEmptyTextNodes(editor, entry)) {
      return;
    }

    if (removeEmptyInlineWrappers(editor, entry)) {
      return;
    }

    if (normalizeEmptyTextNodesAfterInlineElements(editor, entry)) {
      return;
    } // Rich text and its elements contains collections. Each item of collection should have unique id.


    if (updateNonUniqueIds(editor, entry)) {
      return;
    } // Slate normalizes fields from deepest to lowest. The lowest element is editor element which has empty path.


    if (entry[1].length === 0) {
      USED_IDS.clear();
    }

    normalizeNode(entry);
  };

  return editor;
}

function unwrapBlockElementsNestedWithinBlockElement(editor, entry) {
  var _entry = _slicedToArray$2(entry, 2),
      node = _entry[0],
      path = _entry[1];

  if (Element$1.isElement(node) && // This cast is fine since `RichTextBlockElementType` overlaps with type of `node.type`.
  RICH_TEXT_BLOCK_ELEMENT_TYPES.includes(node.type)) {
    var nodeParent = Node.parent(editor, path);

    if (Element$1.isElement(nodeParent)) {
      if (nodeParent.type === node.type) {
        Transforms.unwrapNodes(editor, {
          at: path
        });
        return true;
      } // For now there is only one case where block element can be nested within block element of different type,
      // it can happen while pasting content from one $richText to another. We want to keep the type of pasted content
      // so instead of unwrapping nodes, we lift them one level up.


      if (nodeParent.type !== node.type && RICH_TEXT_BLOCK_ELEMENT_TYPES.includes(nodeParent.type)) {
        Transforms.liftNodes(editor, {
          at: path
        });
        return true;
      }
    }
  }

  return false;
}

function updateNonUniqueIds(editor, entry) {
  var _entry2 = _slicedToArray$2(entry, 2),
      node = _entry2[0],
      path = _entry2[1];

  if (Text.isText(node) || Element$1.isElement(node)) {
    if (USED_IDS.has(node.id)) {
      var newId = uniqueId();
      NORMALIZED_IDS_TO_IDS.set(newId, node.id);
      Transforms.setNodes(editor, {
        id: newId
      }, {
        at: path,
        match: function match(n) {
          return (Text.isText(n) || Element$1.isElement(n)) && n.id === node.id;
        }
      });
      return true;
    } else {
      USED_IDS.add(node.id);
    }
  }

  return false;
}

function mergeVisuallyTheSameOrEmptyTextNodes(editor, entry) {
  var _entry3 = _slicedToArray$2(entry, 2),
      node = _entry3[0],
      path = _entry3[1];

  if (Element$1.isElement(node) && (node.type === "text-line" || node.type === "list-item" || node.type === "inline-wrapper")) {
    var textLineChildren = Array.from(Node.children(editor, path));

    if (textLineChildren.length > 1) {
      for (var childIndex = 0; childIndex < textLineChildren.length - 1; childIndex++) {
        var _textLineChildren$chi = _slicedToArray$2(textLineChildren[childIndex], 2),
            currentChildNode = _textLineChildren$chi[0],
            currentChildPath = _textLineChildren$chi[1];

        var _textLineChildren = _slicedToArray$2(textLineChildren[childIndex + 1], 2),
            nextChildNode = _textLineChildren[0],
            nextChildPath = _textLineChildren[1];

        if (Text.isText(currentChildNode) && Text.isText(nextChildNode)) {
          if (compareText(currentChildNode, nextChildNode) || nextChildNode.text.trim() === "" && childIndex + 1 < textLineChildren.length - 1) {
            Transforms.mergeNodes(editor, {
              at: nextChildPath,
              match: function match(node) {
                return Text.isText(node);
              }
            });
            return true;
          } // `Transforms.mergeNodes` always merges node/nodes at given position into PREVIOUS node.
          // In this case, we want to merge node at current position into next one.


          if (currentChildNode.text === "" && nextChildNode !== undefined) {
            Transforms.setNodes(editor, {
              color: nextChildNode.color,
              font: nextChildNode.font
            }, {
              at: currentChildPath,
              match: function match(node) {
                return Text.isText(node);
              }
            });
          }
        }
      }
    }
  }

  return false;
} // Slate normalization rules states that an inline element cannot be first or last child of block element.
// Slate during its own normalization will add empty Text nodes before or/and after inline element.
// Those Text nodes will be missing properties we add during constructing Slate value based on Shopstory config
// thus it will make compilation error because of missing schema prop values.


function normalizeEmptyTextNodesAfterInlineElements(editor, entry) {
  var _entry4 = _slicedToArray$2(entry, 2),
      node = _entry4[0],
      path = _entry4[1];

  if (Element$1.isElement(node) && (node.type === "text-line" || node.type === "list-item")) {
    for (var index = 0; index < node.children.length; index++) {
      var childNode = node.children[index];
      var previousNode = node.children[index - 1];
      var nextNode = node.children[index + 1];

      if (previousNode && nextNode && isElementInlineWrapperElement(previousNode) && isElementInlineWrapperElement(nextNode) && isInlineWrapperElementEqual(previousNode, nextNode)) {
        if (Text.isText(childNode) && childNode.text === "") {
          Transforms.removeNodes(editor, {
            at: [].concat(_toConsumableArray$2(path), [index])
          });
          return true;
        }
      }

      if (childNode && nextNode && isElementInlineWrapperElement(childNode) && isElementInlineWrapperElement(nextNode) && isInlineWrapperElementEqual(childNode, nextNode)) {
        var nextNodePath = [].concat(_toConsumableArray$2(path), [index + 1]);
        Transforms.mergeNodes(editor, {
          at: nextNodePath
        });
        return true;
      }

      if (isElementInlineWrapperElement(childNode)) {
        if (previousNode) {
          var firstWrapperChildTextNode = childNode.children[0];

          if (isEmptyPlainText(previousNode) || Text.isText(previousNode) && previousNode.text === "" && !deepCompare(previousNode.font, firstWrapperChildTextNode.font)) {
            Transforms.setNodes(editor, {
              id: uniqueId(),
              action: [],
              color: firstWrapperChildTextNode.color,
              font: firstWrapperChildTextNode.font
            }, {
              at: [].concat(_toConsumableArray$2(path), [index - 1]),
              match: function match(node) {
                return Text.isText(node);
              }
            });
            return true;
          }
        }

        if (nextNode) {
          var lastWrapperChildTextNode = last(childNode.children);

          if (isEmptyPlainText(nextNode) || Text.isText(nextNode) && nextNode.text === "" && !deepCompare(nextNode.font, lastWrapperChildTextNode.font)) {
            Transforms.setNodes(editor, {
              id: uniqueId(),
              action: [],
              color: lastWrapperChildTextNode.color,
              font: lastWrapperChildTextNode.font
            }, {
              at: [].concat(_toConsumableArray$2(path), [index + 1]),
              match: function match(node) {
                return Text.isText(node);
              }
            });
            return true;
          }
        }
      }
    }
  }

  return false;
}

function removeEmptyInlineWrappers(editor, entry) {
  var _entry5 = _slicedToArray$2(entry, 2),
      node = _entry5[0],
      path = _entry5[1];

  if (isElementInlineWrapperElement(node) && node.children.length === 1 && node.children[0].text === "") {
    Transforms.removeNodes(editor, {
      at: path,
      match: isElementInlineWrapperElement
    });
    return true;
  }
} // In Slate's terminology Text node is an object containing `text` string property.
// In our terminology Text node contains also other properties like color or font.


function isEmptyPlainText(node) {
  return Text.isText(node) && node.color === undefined && node.font === undefined;
}

function filterNonComparableProperties(obj) {
  return keys(obj).filter(function (key) {
    return ["color", "font", "textModifier"].includes(key);
  }).reduce(function (filteredObject, currentKey) {
    filteredObject[currentKey] = obj[currentKey];
    return filteredObject;
  }, {});
}

function compareText(text1, text2) {
  var areEqual = true;
  var part1Keys = keys(filterNonComparableProperties(text1));
  var part2Keys = keys(filterNonComparableProperties(text2));

  if (part1Keys.length !== part2Keys.length) {
    return false;
  }

  for (var index = 0; index < part1Keys.length; index++) {
    var key = part1Keys[index];
    var part1Value = text1[key];
    var part2Value = text2[key];
    var areValuesEqual = deepCompare(part1Value, part2Value);

    if (!areValuesEqual) {
      areEqual = false;
      break;
    }
  }

  return areEqual;
}

var COMPARABLE_INLINE_WRAPPER_PROPERTIES = ["action", "actionTextModifier", "textModifier"];

function isInlineWrapperElementEqual(wrapper1, wrapper2) {
  return COMPARABLE_INLINE_WRAPPER_PROPERTIES.every(function (property) {
    var _wrapper1$property$, _wrapper2$property$;

    if ((property === "textModifier" || property === "actionTextModifier") && wrapper1[property][0] && wrapper2[property][0]) {
      return compareTextModifiers(wrapper1[property][0], wrapper2[property][0]);
    }

    if (property === "action" && wrapper1.action[0] && wrapper2.action[0]) {
      return compareActions(wrapper1.action[0], wrapper2.action[0]);
    }

    return ((_wrapper1$property$ = wrapper1[property][0]) === null || _wrapper1$property$ === void 0 ? void 0 : _wrapper1$property$._id) === ((_wrapper2$property$ = wrapper2[property][0]) === null || _wrapper2$property$ === void 0 ? void 0 : _wrapper2$property$._id);
  });
}

function compareTextModifiers(textModifier1, textModifier2) {
  textModifier1._id;
      var comparableTextModifier1 = _objectWithoutProperties$2(textModifier1, ["_id"]);

  textModifier2._id;
      var comparableTextModifier2 = _objectWithoutProperties$2(textModifier2, ["_id"]);

  return deepCompare(comparableTextModifier1, comparableTextModifier2);
}

function compareActions(action1, action2) {
  if (action1._template !== action2._template) {
    return false;
  }

  action1._id;
      var comparableAction1Properties = _objectWithoutProperties$2(action1, ["_id"]);

  action1._id;
      var comparableAction2Properties = _objectWithoutProperties$2(action1, ["_id"]);

  if (action1._template === "$StandardLink") {
    var url1 = comparableAction1Properties.url,
        restAction1Properties = _objectWithoutProperties$2(comparableAction1Properties, ["url"]);

    var url2 = comparableAction2Properties.url,
        restAction2Properties = _objectWithoutProperties$2(comparableAction2Properties, ["url"]);

    if (!deepCompare(restAction1Properties, restAction2Properties)) {
      return false;
    }

    if (!deepCompare(url1.value, url2.value)) {
      return false;
    }

    return true;
  }

  return deepCompare(comparableAction1Properties, comparableAction2Properties);
}

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
// By creating temporary editor instance we can apply all transformations without
// touching original editor and read result from `temporaryEditor.children`

function createTemporaryEditor(editor) {
  var temporaryEditor = withShopstory(withReact(createEditor()));
  temporaryEditor.children = _toConsumableArray$2(editor.children);
  temporaryEditor.selection = editor.selection ? _objectSpread$4({}, editor.selection) : null;
  return temporaryEditor;
}

function getAbsoluteRichTextPartPath(relativeRichTextPartPath, richTextPath, locale) {
  return "".concat(richTextPath, ".elements.").concat(locale, ".").concat(relativeRichTextPartPath);
}

function pasteManager() {
  var inserts = new Map();
  return function (destinations) {
    return function (item) {
      var i = 0;

      while (i < destinations.length) {
        var _inserts$get;

        var _destinations$i = destinations[i],
            index = _destinations$i.index,
            name = _destinations$i.name,
            insert = _destinations$i.insert;
        var path = "".concat(name, ".").concat(index);
        var latestDestinationInserts = (_inserts$get = inserts.get(path)) !== null && _inserts$get !== void 0 ? _inserts$get : 0;
        var result = insert(name, index + latestDestinationInserts, item);

        if (result) {
          inserts.set(path, latestDestinationInserts + 1);
          return result;
        }

        i++;
      }

      return null;
    };
  };
}

function convertEditorValueToRichTextElements(editorValue) {
  return editorValue.map(function (blockElement) {
    if (Element$1.isElementType(blockElement, "bulleted-list")) {
      return convertEditorListElementToRichTextListBlockElement("bulleted-list", blockElement);
    }

    if (Element$1.isElementType(blockElement, "numbered-list")) {
      return convertEditorListElementToRichTextListBlockElement("numbered-list", blockElement);
    }

    if (Element$1.isElementType(blockElement, "paragraph")) {
      return convertEditorParagraphElementToRichTextParagraphBlockElement(blockElement);
    }

    throw new Error("Unknown block element");
  });
}

function convertEditorElementToRichTextLineElement(editorElement) {
  var lineElement = buildRichTextLineElementComponentConfig({
    elements: editorElement.children.map(function (child) {
      if (Text.isText(child)) {
        return buildRichTextPartComponentConfig({
          value: cleanString(child.text),
          color: child.color,
          font: child.font,
          id: child.id
        });
      }

      return buildRichTextInlineWrapperElementComponentConfig({
        id: child.id,
        elements: child.children.map(function (child) {
          return buildRichTextPartComponentConfig({
            value: cleanString(child.text),
            color: child.color,
            font: child.font,
            id: child.id
          });
        }),
        action: child.action,
        textModifier: child.textModifier,
        actionTextModifier: child.actionTextModifier
      });
    })
  });
  lineElement._id = editorElement.id;
  return lineElement;
}

function convertEditorListElementToRichTextListBlockElement(type, editorElement) {
  var listBlockElement = buildRichTextBlockElementComponentConfig(type, editorElement.children.map(function (child) {
    return convertEditorElementToRichTextLineElement(child);
  }));
  listBlockElement._id = editorElement.id;
  return listBlockElement;
}

function convertEditorParagraphElementToRichTextParagraphBlockElement(editorElement) {
  var paragraphBlockElement = buildRichTextBlockElementComponentConfig("paragraph", editorElement.children.map(function (child) {
    return convertEditorElementToRichTextLineElement(child);
  }));
  paragraphBlockElement._id = editorElement.id;
  return paragraphBlockElement;
}

function getFocusedRichTextPartsConfigPaths(editor) {
  if (editor.selection !== null) {
    var isBackward = Range.isBackward(editor.selection);
    var anchorProperty = isBackward ? "focus" : "anchor";
    var focusProperty = isBackward ? "anchor" : "focus";
    var anchor = editor.selection[anchorProperty];
    var focus = editor.selection[focusProperty];
    var selectedTextNodes = Array.from(Editor$1.nodes(editor, {
      match: Text.isText
    }));

    if (selectedTextNodes.length === 1) {
      var range = {
        start: anchor.offset,
        end: focus.offset
      };

      var _selectedTextNodes$ = _slicedToArray$2(selectedTextNodes[0], 2),
          textNode = _selectedTextNodes$[0],
          textPath = _selectedTextNodes$[1];

      return [buildFocusedRichTextPartConfigPath(textNode, textPath, range)];
    }

    var focusedRichTextPartsConfigPaths = selectedTextNodes.map(function (_ref, textEntryIndex) {
      var _ref2 = _slicedToArray$2(_ref, 2),
          textNode = _ref2[0],
          textPath = _ref2[1];

      if (textNode.text === "") {
        return null;
      }

      var range = null;

      if (textEntryIndex === 0) {
        range = {
          start: anchor.offset,
          end: textNode.text.length
        };
      }

      if (textEntryIndex === selectedTextNodes.length - 1) {
        range = {
          start: 0,
          end: focus.offset
        };
      }

      return buildFocusedRichTextPartConfigPath(textNode, textPath, range);
    }).filter(function (configPath) {
      return configPath !== null;
    });
    return focusedRichTextPartsConfigPaths;
  }

  return [];
}

function buildFocusedRichTextPartConfigPath(textNode, path, range) {
  var focusedRichTextPartConfigPath = path.join(".elements.");

  if (range !== null && (isPartialSelection(range, textNode) || isCaretSelection(range))) {
    focusedRichTextPartConfigPath += ".{".concat(range.start, ",").concat(range.end, "}");
  }

  return focusedRichTextPartConfigPath;
}

function isPartialSelection(range, textNode) {
  return range.end - range.start !== textNode.text.length;
}

function isCaretSelection(range) {
  return range.end - range.start === 0;
}

function updateSelection(editor, editorContext, key, schemaProp) {
  for (var _len = arguments.length, values = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
    values[_key - 4] = arguments[_key];
  }

  if (isSchemaPropAction(schemaProp) || isSchemaPropActionTextModifier(schemaProp) || isSchemaPropTextModifier(schemaProp)) {
    if (updateInlineWrapper.apply(void 0, [editor, editorContext, key, schemaProp].concat(values))) {
      return;
    }
  } else {
    if (values.length === 1) {
      // If `values` contains one element, we want to apply this value to all text nodes.
      Editor$1.addMark(editor, key, values[0]);
    } else {
      // If `values` contains multiple values, we want to update each selected text node separately with its
      // corresponding value. To do that, we need to obtain selection range for each selected text node
      // and apply correct value.
      var selectedTextNodeEntries = Array.from(Editor$1.nodes(editor, {
        match: Text.isText
      }));
      var selectedTextNodesRanges = selectedTextNodeEntries.map(function (_ref) {
        var _ref2 = _slicedToArray$2(_ref, 2),
            textNodePath = _ref2[1];

        return Range.intersection(editor.selection, Editor$1.range(editor, textNodePath));
      }).filter(nonNullable());
      Editor$1.withoutNormalizing(editor, function () {
        selectedTextNodesRanges.reverse().forEach(function (range, index) {
          Transforms.setNodes(editor, _defineProperty$g({}, key, values[index]), {
            at: range,
            match: Text.isText,
            split: true
          });
        });
      });
    }
  }

  var richTextElements = convertEditorValueToRichTextElements(editor.children);
  var newFocusedRichTextParts = getFocusedRichTextPartsConfigPaths(editor);
  return {
    elements: richTextElements,
    focusedRichTextParts: newFocusedRichTextParts
  };
}

function updateInlineWrapper(editor, editorContext, key, schemaProp) {
  var isSelectionCollapsed = Range.isCollapsed(editor.selection); // Each time we perform any transform, the current `editor.selection` is going to change according to
  // last transformation that was applied. `rangeRef` allows us to track how given selection has changed
  // in response to all the transformation and apply it after we've finished.

  var selectionRef = Editor$1.rangeRef(editor, editor.selection, {
    affinity: "inward"
  });
  var isSingleValueUpdate = (arguments.length <= 4 ? 0 : arguments.length - 4) === 1;

  if (isSingleValueUpdate) {
    var configValue = arguments.length <= 4 ? undefined : arguments[4];
    var isAddingOrUpdatingConfigValue = configValue.length === 1;

    if (isAddingOrUpdatingConfigValue) {
      var _getTemplates$filter$;

      if (isSelectionCollapsed) {
        if (!isSchemaPropAction(schemaProp) || isSchemaPropAction(schemaProp) && schemaProp.prop.startsWith("$")) {
          return true;
        }

        expandCurrentSelectionToWholeWrapperElement(editor); // Update selection ref manually because selection changes not made by transformations don't update ref.

        selectionRef.current = editor.selection;
      }

      var defaultActionTextModifier = (_getTemplates$filter$ = getTemplates(["actionTextModifier"], editorContext).filter(isTemplate).find(function (template) {
        return template.isDefaultTextModifier;
      })) === null || _getTemplates$filter$ === void 0 ? void 0 : _getTemplates$filter$.config;

      if (!defaultActionTextModifier) {
        throw new Error("There is no default action text modifier defined!!!");
      }

      var selectedTextNodesOutsideInlineWrapperElements = Array.from(Editor$1.nodes(editor, {
        match: function match(n, p) {
          return Text.isText(n) && n.text !== "" && notNestedWithinElementOfType(editor, p, isElementInlineWrapperElement)();
        }
      }));
      var selectedInlineWrapperElementsRanges = getRangesForSelectedElementsOfType(editor, isElementInlineWrapperElement);
      Editor$1.withoutNormalizing(editor, function () {
        if (selectedInlineWrapperElementsRanges.length > 0) {
          selectedInlineWrapperElementsRanges.reverse().forEach(function (range) {
            splitNodesByRange(editor, {
              range: range,
              match: isElementInlineWrapperElement
            });
          });

          if (isSchemaPropAction(schemaProp)) {
            var _Array$from$, _Transforms$setNodes2;

            var currentActionTextModifier = (_Array$from$ = Array.from(Editor$1.nodes(editor, {
              match: isElementInlineWrapperElement
            }))[0]) === null || _Array$from$ === void 0 ? void 0 : _Array$from$[0].actionTextModifier;
            Transforms.setNodes(editor, (_Transforms$setNodes2 = {}, _defineProperty$g(_Transforms$setNodes2, key, configValue), _defineProperty$g(_Transforms$setNodes2, "actionTextModifier", currentActionTextModifier !== null && currentActionTextModifier !== void 0 ? currentActionTextModifier : [defaultActionTextModifier]), _defineProperty$g(_Transforms$setNodes2, "textModifier", []), _Transforms$setNodes2), {
              match: isElementInlineWrapperElement,
              at: selectionRef.current
            });
          } else if (isSchemaPropTextModifier(schemaProp)) {
            var _Transforms$setNodes3;

            Transforms.setNodes(editor, (_Transforms$setNodes3 = {}, _defineProperty$g(_Transforms$setNodes3, key, configValue), _defineProperty$g(_Transforms$setNodes3, "action", []), _defineProperty$g(_Transforms$setNodes3, "actionTextModifier", []), _Transforms$setNodes3), {
              match: isElementInlineWrapperElement,
              at: selectionRef.current
            });
          } else if (isSchemaPropActionTextModifier(schemaProp)) {
            Transforms.setNodes(editor, _defineProperty$g({}, key, configValue), {
              match: isElementInlineWrapperElement,
              at: selectionRef.current
            });
          } else {
            throw new Error("Unhandled schema prop type");
          }
        }

        if (selectedTextNodesOutsideInlineWrapperElements.length > 0) {
          var wrapOptions = {
            split: true,
            match: function match(n, p) {
              return Text.isText(n) && n.text !== "" && !isElementInlineWrapperElement(Node.parent(editor, p));
            },
            at: selectionRef.current
          };

          if (isSchemaPropAction(schemaProp)) {
            Transforms.wrapNodes(editor, {
              type: "inline-wrapper",
              children: [],
              id: uniqueId(),
              action: configValue,
              actionTextModifier: [defaultActionTextModifier],
              textModifier: []
            }, wrapOptions);
          } else if (isSchemaPropTextModifier(schemaProp)) {
            Transforms.wrapNodes(editor, {
              type: "inline-wrapper",
              children: [],
              id: uniqueId(),
              action: [],
              actionTextModifier: [],
              textModifier: configValue
            }, wrapOptions);
          } else {
            throw new Error("Unhandled schema prop type");
          }
        }
      });
    } else {
      // If we set `action` to an empty array and the current selection is collapsed we expand the selection
      // to the whole wrapper element because we can't remove action from single character. Users are going to
      // expect removing action from the whole element.
      if (isSelectionCollapsed) {
        if (isSchemaPropTextModifier(schemaProp)) {
          return true;
        }

        expandCurrentSelectionToWholeWrapperElement(editor); // Update selection ref manually because selection changes not made by transformations don't update ref.

        selectionRef.current = editor.selection;
      }

      var selectedActionElementsRanges = getRangesForSelectedElementsOfType(editor, isElementInlineWrapperElement);
      Editor$1.withoutNormalizing(editor, function () {
        selectedActionElementsRanges.reverse().forEach(function (range) {
          splitNodesByRange(editor, {
            range: range,
            match: isElementInlineWrapperElement
          });
        });
        Transforms.unwrapNodes(editor, {
          match: isElementInlineWrapperElement,
          at: selectionRef.current
        });
      });
    }

    var currentSelection = selectionRef.unref();

    if (currentSelection) {
      Transforms.select(editor, currentSelection);
    }
  }
}

function expandCurrentSelectionToWholeWrapperElement(editor) {
  var wrapperElement = Editor$1.above(editor, {
    match: isElementInlineWrapperElement
  }); // This should never happen because the text nodes are always put into the wrapper element but just in case if
  // something would go wrong we just bail out update.

  if (!wrapperElement) {

    return;
  }

  var _wrapperElement = _slicedToArray$2(wrapperElement, 2),
      path = _wrapperElement[1];

  Transforms.setSelection(editor, {
    anchor: Editor$1.start(editor, path),
    focus: Editor$1.end(editor, path)
  });
} // Slate has a bug and doesn't correctly split nodes if the `at` is a range. When not specified it fallbacks
// to `editor.selection` which is also a range. To workaround it, we split node two times, using anchor and focus
// point. We start from the focus point to not reorder elements before the range.


function splitNodesByRange(editor, _ref3) {
  var range = _ref3.range,
      match = _ref3.match;
  Editor$1.withoutNormalizing(editor, function () {
    var rangeStartPathRef = Editor$1.pathRef(editor, range.anchor.path, {
      affinity: "backward"
    });
    var rangeEndPathRef = Editor$1.pathRef(editor, range.focus.path, {
      affinity: "forward"
    });
    Transforms.splitNodes(editor, {
      at: range.focus,
      match: match
    });
    Transforms.splitNodes(editor, {
      at: range.anchor,
      match: match
    });

    if (rangeStartPathRef.current && rangeEndPathRef.current) {
      var nextNodeFromStart = Editor$1.next(editor, {
        at: Editor$1.parent(editor, rangeStartPathRef.current)[1]
      });
      var previousNodeFromStart = Editor$1.previous(editor, {
        at: Editor$1.parent(editor, rangeEndPathRef.current)[1]
      });

      if (nextNodeFromStart && previousNodeFromStart) {
        Transforms.setSelection(editor, {
          anchor: Editor$1.start(editor, nextNodeFromStart[1]),
          focus: Editor$1.end(editor, previousNodeFromStart[1])
        });
      }
    }

    rangeStartPathRef.unref();
    rangeEndPathRef.unref();
  });
}

function getRangesForSelectedElementsOfType(editor, matcher) {
  var selectedElements = Array.from(Editor$1.nodes(editor, {
    match: matcher
  }));
  var selectedElementsRanges = selectedElements.map(function (_ref4) {
    var _ref5 = _slicedToArray$2(_ref4, 2),
        path = _ref5[1];

    return Range.intersection(editor.selection, Editor$1.range(editor, path));
  }).filter(nonNullable());
  return selectedElementsRanges;
}

function notNestedWithinElementOfType(editor, path, match) {
  return function () {
    var parentPath = Path.parent(path);
    var parentNode = Node.get(editor, parentPath);
    return !match(parentNode);
  };
}

var placeholderConfig = {
  _template: "$Placeholder",
  _itemProps: {
    $GridCard: {
      Cards: {}
    }
  }
};
var PLACEHOLDERS_NUM = 64;
function fillGridConfigWithPlaceholders(config) {
  if (config._template !== "$RootGrid") {
    throw new Error("fillGridConfigWithPlaceholders must be run with $RootGrid only");
  }

  var cards = config.data[0].Component[0].Cards;
  var placeholderCards = cards.filter(function (x) {
    return x._template === "$Placeholder";
  });
  var numberOfNewPlaceholdersToBeAdded = Math.max(0, PLACEHOLDERS_NUM - placeholderCards.length);

  for (var i = 0; i < numberOfNewPlaceholdersToBeAdded; i++) {
    cards.push(placeholderConfig);
  }
}

var __jsx$e = React.createElement;

function AudienceModal(_ref) {
  var _ref$allAudiences = _ref.allAudiences,
      allAudiences = _ref$allAudiences === void 0 ? [] : _ref$allAudiences,
      onClose = _ref.onClose,
      _ref$onAudienceChange = _ref.onAudienceChange,
      onAudienceChange = _ref$onAudienceChange === void 0 ? function () {} : _ref$onAudienceChange;

  var _useState = react.exports.useState(null),
      query = _useState[0],
      setQuery = _useState[1];

  var filteredAudiences = allAudiences.filter(function (_ref2) {
    var name = _ref2.name;
    return query ? name.includes(query) : true;
  });
  return __jsx$e(SSModal, {
    mode: "center-small",
    isOpen: true,
    onRequestClose: function onRequestClose() {
      onClose();
    },
    headerLine: true,
    searchProps: {
      value: query,
      placeholder: "Search...",
      onChange: function onChange(e) {
        setQuery(e.target.value);
      }
    }
  }, filteredAudiences.map(function (_ref3) {
    var name = _ref3.name,
        id = _ref3.id;
    return __jsx$e(SSBasicRow, {
      key: id,
      title: name,
      onClick: function onClick() {
        onAudienceChange(id);
      }
    });
  }));
}

var __jsx$d = React.createElement;
var slideIn = Ue(["from{transform:translate(-50%,calc(100% + 1rem));}from,10%{opacity:0}to{transform:translate(-50%,0%);opacity:1}"]);
var slideOut = Ue(["from{transform:translate(-50%,0%);opacity:1}90%,to{opacity:0}to{transform:translate(-50%,calc(100% + 1rem));}"]);
var Root$1 = styled.div.withConfig({
  displayName: "Snackbar__Root",
  componentId: "sc-l6ov2o-0"
})(["position:fixed;bottom:1rem;left:50%;transform:translateX(-50%);opacity:0;z-index:1;box-shadow:rgba(0,0,0,0) 0px 0px 0px 0px,rgba(0,0,0,0) 0px 0px 0px 0px,rgba(0,0,0,0.1) 0px 4px 6px -1px,rgba(0,0,0,0.06) 0px 2px 4px -1px;border:1px solid ", ";opacity:1;background:white;padding:32px;border-radius:8px;display:flex;justify-content:center;align-items:center;", ";font-size:16px;animation-name:", ";animation-duration:", ";animation-fill-mode:both;animation-timing-function:ease-in-out;&[data-state=\"hide\"]{animation-name:", ";animation-duration:", ";animation-timing-function:ease-in;&:hover{animation-name:unset;}}"], SSColors.black10, SSFonts.body, slideIn, function (props) {
  return "".concat(props.inDuration, "s");
}, slideOut, function (props) {
  return "".concat(props.outDuration, "s");
});

function Snackbar(_ref) {
  var message = _ref.message,
      _ref$timeToHide = _ref.timeToHide,
      timeToHide = _ref$timeToHide === void 0 ? 2 : _ref$timeToHide,
      _ref$onHide = _ref.onHide,
      onHide = _ref$onHide === void 0 ? function () {} : _ref$onHide;
  var inDuration = 0.3;
  var outDuration = 0.2;
  var snackbarRef = react.exports.useRef(null);
  react.exports.useLayoutEffect(function () {
    if (!snackbarRef.current) {
      return;
    }

    var effectiveTimeToHide = inDuration + timeToHide * 1000;
    var timeoutId = setTimeout(function () {
      if (!snackbarRef.current) {
        return;
      }

      snackbarRef.current.dataset.state = "hide";
      snackbarRef.current.addEventListener("animationend", onHide);
    }, effectiveTimeToHide);
    return function () {
      var _snackbarRef$current;

      (_snackbarRef$current = snackbarRef.current) === null || _snackbarRef$current === void 0 ? void 0 : _snackbarRef$current.removeEventListener("animationend", onHide);
      clearTimeout(timeoutId);
    };
  }, [message]);

  if (!message) {
    return null;
  }

  return __jsx$d(Root$1, {
    ref: snackbarRef,
    inDuration: inDuration,
    outDuration: outDuration
  }, message);
}

var __jsx$c = React.createElement;

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Custom field launcher is just a "function call".
 *
 * The field function (component) is surely not bundled together with Editor's React.
 * So if devs want to write it in React, they need to use separate ReactDOM.render.
 */
function CustomFieldLauncher(props) {
  var externalField = props.field.externalField;

  if (externalField.type !== "custom") {
    throw new Error("should never happen"); // type narrowing
  }

  var rootNodeRef = react.exports.useRef(null);
  react.exports.useEffect(function () {
    props.field.externalField.component({
      root: rootNodeRef.current,
      value: props.input.value,
      onChange: props.input.onChange
    });
  });
  return __jsx$c(_StyledDiv$1, {
    ref: rootNodeRef
  });
}

var ExternalField = function ExternalField(props) {
  var tinaForm = props.tinaForm,
      field = props.field;
  var originalFormat = field.format ? field.format : function (x) {
    return x;
  };
  var originalParse = field.parse ? field.parse : function (x) {
    return x;
  };
  var externalField = props.field.externalField;
  var component;
  var extraParams = {}; // So far, we have 2 kinds of external fields, item-picker and custom

  if (externalField.type === "custom") {
    component = CustomFieldLauncher;
  } else if (externalField.type === "item-picker") {
    // this is legacy, but item-picker used to be "product picker". It turns out it's much more generic but old names stayed. To refactor.
    component = "product";
    extraParams.api = {
      products: externalField.getItems,
      product: externalField.getItemById
    };
  } else {
    throw new Error("unknown type");
  }

  var content = __jsx$c(FieldBuilder, {
    form: tinaForm,
    field: _objectSpread$3(_objectSpread$3(_objectSpread$3({}, field), {}, {
      component: component
    }, extraParams), {}, {
      format: function format(x) {
        return originalFormat(x, field.name);
      },
      // Right now, if only one element is selected the name is taken from `field.name`
      // If multiple elements are selected, the name will come as an argument
      // This will probably be addressed and unified when we rewrite Responsive/ExternalFieldPlugin
      parse: function parse(value, name) {
        var fieldName = name || field.name;
        return originalParse(value, fieldName);
      }
    })
  }); // this sucks


  if (component === "product") {
    return content;
  }

  return __jsx$c(FieldMetaWrapper, _extends$b({}, props, {
    layout: "column"
  }), content);
};
var ExternalFieldPlugin = {
  name: "external",
  Component: ExternalField
};

var _StyledDiv$1 = styled("div").withConfig({
  displayName: "ExternalField___StyledDiv",
  componentId: "sc-1jestjq-0"
})(["width:100%;"]);

var __jsx$b = React.createElement;
var ProductPickerField = wrapFieldsWithMeta(function (_ref) {
  var input = _ref.input,
      field = _ref.field;
  return __jsx$b(SSProductPicker, {
    value: input.value,
    onChange: function onChange(newId) {
      input.onChange(newId);
    },
    api: field.api,
    clearable: true
  });
}, {
  layout: "column"
});
var ProductPickerFieldPlugin = {
  __type: "field",
  name: "product",
  Component: ProductPickerField
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getSavedValue(value, previousValue, editorContext) {
  var breakpointIndex = editorContext.breakpointIndex;

  if (typeof value === "string" && value.startsWith("##")) ; // Responsiveness is not enabled for this field


  if (!isTrulyResponsiveValue(previousValue)) {
    if (value === undefined || value === null) {
      return null;
    }

    return value;
  }

  var result = _objectSpread$2({}, previousValue);

  result[breakpointIndex] = value;
  return result;
}

function responsiveFieldController(config) {
  var field = config.field,
      formValues = config.formValues,
      onChange = config.onChange,
      editorContext = config.editorContext,
      valuesAfterAuto = config.valuesAfterAuto;

  function originalFormat(value, fieldName) {
    var _field$format, _field$format2;

    return (_field$format = (_field$format2 = field.format) === null || _field$format2 === void 0 ? void 0 : _field$format2.call(field, value, fieldName, field)) !== null && _field$format !== void 0 ? _field$format : value;
  }

  function originalParse(value, fieldName) {
    var _field$parse, _field$parse2;

    return (_field$parse = (_field$parse2 = field.parse) === null || _field$parse2 === void 0 ? void 0 : _field$parse2.call(field, value, fieldName, field)) !== null && _field$parse !== void 0 ? _field$parse : value;
  }

  var normalizedFieldName = toArray$2(field.name);
  var fieldValues = normalizedFieldName.map(function (fieldName) {
    return dotNotationGet(formValues, fieldName);
  });
  var isResponsive = fieldValues.every(function (fieldValue) {
    return isTrulyResponsiveValue(fieldValue);
  });
  var isSet = isResponsive && fieldValues.every(function (fieldValue) {
    return fieldValue[editorContext.breakpointIndex] !== undefined;
  });

  var format = function format(value, name) {
    var _ref;

    var valueAfterFormat = originalFormat(value, name);
    var displayedValue = (_ref = isTrulyResponsiveValue(valueAfterFormat) ? valueAfterFormat[editorContext.breakpointIndex] : valueAfterFormat) !== null && _ref !== void 0 ? _ref : null;
    return displayedValue;
  };

  var parse = function parse(value, name) {
    if (value === null) {
      throw new Error("parse in ResponsiveController has null value which should be impossible (null values should disappear once other value is picked!");
    }

    var fieldValue = originalFormat(dotNotationGet(formValues, name), name);
    var savedValue = getSavedValue(value, fieldValue, editorContext);
    return originalParse(savedValue, name);
  };

  var reset = function reset() {
    if (!isResponsive) {
      throw new Error("should never happen");
    }

    var nextValues = normalizedFieldName.map(function (fieldName) {
      var previousValue = originalFormat(dotNotationGet(formValues, fieldName), fieldName);

      var newValue = _objectSpread$2({}, previousValue);

      delete newValue[editorContext.breakpointIndex];

      if (Object.keys(newValue).length <= 1) {
        return field.defaultValue;
      }

      return originalParse(newValue, fieldName);
    });
    onChange(nextValues);
  };

  var toggleOffAuto = function toggleOffAuto() {
    var currentBreakpointValues = fieldValues.map(function (fieldValue) {
      return fieldValue[editorContext.breakpointIndex];
    });
    var areAllFieldValuesAuto = true;
    var isAnyFieldValueAuto = false;
    currentBreakpointValues.forEach(function (value) {
      if (value === undefined) {
        if (!isAnyFieldValueAuto) {
          isAnyFieldValueAuto = true;
        }
      } else {
        if (areAllFieldValuesAuto) {
          areAllFieldValuesAuto = false;
        }
      }
    });
    var newFieldsValues = normalizedFieldName.map(function (fieldName) {
      var fieldValue = dotNotationGet(formValues, fieldName);
      var nextFieldValue = areAllFieldValuesAuto ? dotNotationGet(valuesAfterAuto, normalizedFieldName[0]) : isAnyFieldValueAuto ? fieldValues.find(function (value) {
        return value[editorContext.breakpointIndex] !== undefined;
      }) : fieldValue;

      var newFieldValue = _objectSpread$2(_objectSpread$2({}, fieldValue), {}, _defineProperty$g({}, editorContext.breakpointIndex, responsiveValueForceGet( // next field comes from auto, so value is defined
      nextFieldValue, editorContext.breakpointIndex)));

      return newFieldValue;
    });
    onChange(newFieldsValues);
  };

  var valueField = _objectSpread$2(_objectSpread$2({}, field), {}, {
    component: field.subComponent,
    format: format,
    parse: parse
  });

  return {
    field: valueField,
    isResponsive: isResponsive,
    isSet: isSet,
    reset: reset,
    toggleOffAuto: toggleOffAuto
  };
}

var __jsx$a = react.exports.createElement;
var ResponsiveField = function ResponsiveField(props) {
  var tinaForm = props.tinaForm,
      field = props.field,
      input = props.input;
  var editorContext = useEditorContext();
  var configAfterAuto = useConfigAfterAuto();
  var hoverRef = react.exports.useRef(null);
  var normalizedFieldName = toArray$2(field.name);
  var fieldValues = normalizedFieldName.map(function (fieldName) {
    return dotNotationGet(configAfterAuto, fieldName);
  });
  var scalarFieldValues = fieldValues.map(function (fieldValue) {
    return responsiveValueForceGet( // value from auto, so it's safe
    fieldValue, editorContext.breakpointIndex);
  });
  var uniqueValues = getUniqueValues(scalarFieldValues, function (value) {
    return typeof value === "object" ? JSON.stringify(value) : value;
  });
  var isMixedValue = uniqueValues.length > 1;
  var value = isMixedValue ? MIXED_VALUE : uniqueValues[0];
  var controller = responsiveFieldController({
    field: field,
    onChange: function onChange(newValues) {
      input.onChange.apply(input, _toConsumableArray$2(newValues));
    },
    formValues: tinaForm.values,
    editorContext: editorContext,
    valuesAfterAuto: configAfterAuto
  });
  var isValueDifferentFromMainBreakpoint = controller.isSet && editorContext.breakpointIndex !== editorContext.mainBreakpointIndex;
  var isFieldVisible = !controller.isResponsive || controller.isSet || editorContext.breakpointIndex === editorContext.mainBreakpointIndex;
  var uniqueFieldValues = getUniqueValues(normalizedFieldName.map(function (fieldName) {
    return dotNotationGet(tinaForm.values, fieldName)[editorContext.breakpointIndex];
  }));
  var autoLabelChildren = uniqueFieldValues.length > 1 && uniqueFieldValues.includes(undefined) ? "Mixed" : getAutoLabelButtonLabel(value);
  var isColumnLayout = field.subComponent === "external";

  var _useTooltip = useTooltip({
    isDisabled: !isValueDifferentFromMainBreakpoint,
    onClick: function onClick() {
      controller.reset();
    }
  }),
      isOpen = _useTooltip.isOpen,
      arrowProps = _useTooltip.arrowProps,
      tooltipProps = _useTooltip.tooltipProps,
      triggerProps = _useTooltip.triggerProps;

  return __jsx$a("div", {
    ref: hoverRef
  }, __jsx$a(FieldMetaWrapper, _extends$b({}, props, {
    layout: isColumnLayout ? "column" : "row",
    renderLabel: isValueDifferentFromMainBreakpoint ? function (_ref) {
      var label = _ref.label;
      return __jsx$a(ResetButton, _extends$b({
        "aria-label": "Revert to auto"
      }, triggerProps), __jsx$a(SSIcons.Reset, null), __jsx$a(ResetButtonLabel, null, label), isOpen && __jsx$a(Tooltip, tooltipProps, __jsx$a(TooltipArrow, arrowProps), __jsx$a(TooltipBody, null, "Revert to auto")));
    } : undefined
  }), __jsx$a("div", {
    style: {
      width: "100%"
    }
  }, isFieldVisible ? __jsx$a(FieldBuilder, {
    form: tinaForm,
    field: controller.field,
    noWrap: true
  }) : __jsx$a(AutoLabel, {
    onClick: function onClick() {
      controller.toggleOffAuto();
    }
  }, autoLabelChildren))));
};
var ResponsiveFieldPlugin = {
  name: "responsive2",
  Component: ResponsiveField
};
var AutoLabel = styled.div.withConfig({
  displayName: "ResponsiveFieldPlugin__AutoLabel",
  componentId: "sc-1pw7lm-0"
})(["", ";color:", ";text-align:right;&:hover{color:black;cursor:pointer;text-decoration:underline;}"], SSFonts.body, SSColors.black40);
var ResetButton = styled.button.withConfig({
  displayName: "ResponsiveFieldPlugin__ResetButton",
  componentId: "sc-1pw7lm-1"
})(["display:flex;align-items:center;gap:4px;background-color:transparent;border:0;padding:0;color:", ";cursor:pointer;"], SSColors.purple);
var ResetButtonLabel = styled.span.withConfig({
  displayName: "ResponsiveFieldPlugin__ResetButtonLabel",
  componentId: "sc-1pw7lm-2"
})(["", ";line-height:16px;"], SSFonts.body);

function getAutoLabelButtonLabel(value) {
  if (value === MIXED_VALUE) {
    return "auto: Mixed";
  }
  /**
   * This piece of code is crap
   */


  if (typeof value === "object") {
    if (value.ref !== undefined && value.value !== undefined) {
      var refNameParts = value.ref.split(".");
      return "auto: ".concat(refNameParts[refNameParts.length - 1]);
    } else if (value.value !== undefined && value.id === undefined) {
      // just value field -> token
      return "auto: ".concat(typeof value.value === "number" ? Math.round(value.value * 100) / 100 : value.value);
    }

    return "auto";
  }

  if (typeof value === "boolean") {
    return "auto: ".concat(JSON.stringify(value));
  }

  return "auto: ".concat(value);
}

var __jsx$9 = React.createElement;

// document.getElementById('upload').addEventListener('change', readFileAsString)
function transformStrokeAndFill(node) {
  var fill = node.getAttribute("fill");
  var stroke = node.getAttribute("stroke");

  if (fill && fill !== "none") {
    node.setAttribute("fill", "currentColor");
  }

  if (stroke && stroke !== "none") {
    node.setAttribute("stroke", "currentColor");
  }

  Array.from(node.children).forEach(function (child) {
    return transformStrokeAndFill(child);
  });
}

var SVGPicker = wrapFieldsWithMeta(function (_ref) {
  var input = _ref.input;
      _ref.meta;
      _ref.field;
  var svgString = input.value.value;
  var inputRef = react.exports.useRef(null);
  react.exports.useEffect(function () {
    function readFileAsString() {
      // @ts-ignore
      var files = this.files;

      if (files.length === 0) {
        return;
      }

      var reader = new FileReader();

      reader.onload = function (event) {
        var _event$target;

        // @ts-ignore to explore
        var trimmed = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result.trim();
        var emptyDiv = document.createElement("div");
        emptyDiv.innerHTML = trimmed;
        var svg = emptyDiv.children[0];
        svg.removeAttribute("width");
        svg.removeAttribute("height");
        svg.setAttribute("style", "position: absolute; width: 100%;height: 100%;");
        transformStrokeAndFill(svg);

        if (svg.tagName.toLowerCase() !== "svg") {
          alert("incorrect file");
          return;
        }

        input.onChange({
          value: emptyDiv.innerHTML
        });
      };

      reader.readAsText(files[0]);
    }

    inputRef.current.addEventListener("change", readFileAsString);
    return function () {
      inputRef.current.removeEventListener("change", readFileAsString);
    };
  }, []);
  return __jsx$9("div", null, __jsx$9("div", {
    style: {
      width: 24,
      height: 24,
      position: "relative",
      color: "black",
      marginBottom: 16
    }
  }, __jsx$9("div", {
    dangerouslySetInnerHTML: {
      __html: svgString
    }
  })), __jsx$9("input", {
    type: "file",
    id: "upload",
    accept: ".svg",
    ref: inputRef
  }));
});
var SVGPickerFieldPlugin = {
  __type: "field",
  name: "icon",
  Component: SVGPicker
};

var __jsx$8 = React.createElement;
var Slider = wrapFieldsWithMeta(function (_ref) {
  var input = _ref.input,
      field = _ref.field;
  return __jsx$8(SSRangeSlider, _extends$b({}, input, {
    max: field.max,
    min: field.min,
    step: field.step
  }));
});
var SliderFieldPlugin = {
  __type: "field",
  name: "slider",
  Component: Slider
};

var __jsx$7 = React.createElement;
var CUSTOM_OPTION_VALUE = "__custom__";

function TokenFieldComponent(_ref) {
  var _input$value$value$to, _input$value;

  var input = _ref.input,
      field = _ref.field;
  var editorContext = useEditorContext();

  var normalizeCustomValue = field.normalizeCustomValue || function (x) {
    return x;
  };

  var allowCustom = field.allowCustom === undefined ? false : field.allowCustom;

  var _useState = react.exports.useState(isMixedFieldValue(input.value) ? "" : (_input$value$value$to = (_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.value.toString()) !== null && _input$value$value$to !== void 0 ? _input$value$value$to : ""),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var customValueTextFieldRef = react.exports.useRef(null);
  var options = Object.entries(field.tokens).map(function (_ref2) {
    var _tokenValue$label;

    var _ref3 = _slicedToArray$2(_ref2, 2),
        tokenId = _ref3[0],
        tokenValue = _ref3[1];

    return {
      id: tokenId,
      label: (_tokenValue$label = tokenValue.label) !== null && _tokenValue$label !== void 0 ? _tokenValue$label : tokenId
    };
  });
  var extraValues = field.extraValues || []; // Extra values are displayed in select

  if (extraValues) {
    extraValues.forEach(function (extraValue) {
      options.push({
        id: extraValue,
        label: extraValue
      });
    });
  } // If ref exist but is removed from a theme -> let's add special option for this


  if (!isMixedFieldValue(input.value) && typeof input.value.ref === "string" && !field.tokens[input.value.ref]) {
    options.unshift({
      id: input.value.ref,
      label: "(removed) ".concat(input.value.ref)
    });
  }

  var isExtraValueSelected = !isMixedFieldValue(input.value) && !input.value.ref && extraValues.includes(isTrulyResponsiveValue(input.value.value) ? responsiveValueGetDefinedValue( // not sure about usage of responsiveValueGet without widths here
  input.value.value, editorContext.breakpointIndex, editorContext.devices, getDevicesWidths(editorContext.devices)
  /** FOR NOW TOKENS ARE RELATIVE TO SCREEN **/
  ) : input.value.value);
  var shouldShowInput = !isMixedFieldValue(input.value) && !(input.value.ref || isExtraValueSelected);
  var selectValue = isMixedFieldValue(input.value) ? MIXED_VALUE : input.value.ref || (isExtraValueSelected ? input.value.value : CUSTOM_OPTION_VALUE);

  var onSelectChange = function onSelectChange(e) {
    var selectedValue = e.target.value;

    if (selectedValue === CUSTOM_OPTION_VALUE) {
      if (isMixedFieldValue(input.value)) {
        input.onChange({
          value: ""
        });
        setInputValue("");
        return;
      }

      var _value = input.value.value; // responsive token values are transformed into value from current breakpoint

      if (isTrulyResponsiveValue(_value)) {
        _value = responsiveValueGetDefinedValue( // Not sure about usage of responsiveValueGet without widths
        _value, editorContext.breakpointIndex, editorContext.devices, getDevicesWidths(editorContext.devices)
        /** FOR NOW TOKENS ARE RELATIVE TO SCREEN **/
        );
      }

      input.onChange({
        value: _value
      });
      setInputValue(_value);
      queueMicrotask(function () {
        var _customValueTextField;

        (_customValueTextField = customValueTextFieldRef.current) === null || _customValueTextField === void 0 ? void 0 : _customValueTextField.focus();
      });
    } else if (extraValues.includes(selectedValue)) {
      input.onChange({
        value: selectedValue
      });
    } else {
      input.onChange({
        ref: selectedValue,
        value: field.tokens[selectedValue].value
      });
    }
  };

  return __jsx$7(Root, null, __jsx$7(SSSelect, {
    value: selectValue,
    onChange: onSelectChange,
    size: "full-width"
  }, isMixedFieldValue(input.value) && __jsx$7(React.Fragment, null, __jsx$7("option", {
    value: MIXED_VALUE,
    disabled: true
  }, "Mixed"), __jsx$7("option", {
    disabled: true,
    key: "divider",
    "aria-hidden": "true"
  }, "----------")), options.map(function (option) {
    return __jsx$7("option", {
      key: option.id,
      value: option.id
    }, option.label);
  }), allowCustom && __jsx$7(React.Fragment, null, __jsx$7("option", {
    disabled: true,
    key: "divider",
    "aria-hidden": "true"
  }, "----------"), __jsx$7("option", {
    value: CUSTOM_OPTION_VALUE
  }, "Custom"))), shouldShowInput && __jsx$7("div", null, __jsx$7("div", {
    style: {
      height: 4
    }
  }), __jsx$7(SSInput, {
    value: inputValue,
    onChange: function onChange(e) {
      setInputValue(e.target.value);
    },
    onBlur: function onBlur() {
      var normalizedValue = normalizeCustomValue(inputValue);
      setInputValue(normalizedValue);
      input.onChange({
        value: normalizedValue
      });
    },
    ref: customValueTextFieldRef,
    align: "right"
  })));
}

var Root = styled.div.withConfig({
  displayName: "TokenFieldPlugin__Root",
  componentId: "sc-1gf8o8j-0"
})(["display:flex;flex-direction:column;align-items:flex-end;"]);
var TokenFieldPlugin = {
  name: "token",
  type: "token",
  Component: wrapFieldsWithMeta(TokenFieldComponent)
};

var __jsx$6 = React.createElement;

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function FontTokenField(_ref) {
  var input = _ref.input,
      field = _ref.field,
      meta = _ref.meta;
  var editorContext = useEditorContext();
  var tokens = Object.fromEntries(entries(field.tokens).map(function (_ref2) {
    var _ref3 = _slicedToArray$2(_ref2, 2),
        name = _ref3[0],
        token = _ref3[1];

    var labelledToken = _objectSpread$1(_objectSpread$1({}, token), {}, {
      label: getFontTokenLabel(name, token, editorContext)
    });

    return [name, labelledToken];
  }));
  return __jsx$6(TokenFieldComponent, {
    input: input,
    meta: meta,
    field: _objectSpread$1(_objectSpread$1({}, field), {}, {
      tokens: tokens
    })
  });
}

var FontTokenFieldPlugin = {
  name: "fontToken",
  type: "fontToken",
  Component: wrapFieldsWithMeta(FontTokenField)
};

function getFontTokenLabel(name, token, editorContext) {
  var _token$label2;

  var filledResponsiveFontValue = responsiveValueFill(token.value, editorContext.devices, getDevicesWidths(editorContext.devices));
  var currentDeviceFontValue = responsiveValueForceGet(filledResponsiveFontValue, editorContext.breakpointIndex);

  if (isValidFontTokenValue(currentDeviceFontValue)) {
    var _token$label;

    return "".concat((_token$label = token.label) !== null && _token$label !== void 0 ? _token$label : name, " (").concat(stripPxUnit(currentDeviceFontValue.fontSize), "/").concat(stripPxUnit(currentDeviceFontValue.lineHeight), ")");
  }

  return (_token$label2 = token.label) !== null && _token$label2 !== void 0 ? _token$label2 : name;
}

function stripPxUnit(value) {
  if (typeof value === "number") {
    return value;
  }

  return value.replace(new RegExp("px"), "");
}

function isValidFontTokenValue(value) {
  return typeof value === "object" && value !== null && "fontSize" in value && "lineHeight" in value;
}

var __jsx$5 = React.createElement;

function IdentityField(_ref) {
  var _componentDefinition$;

  var input = _ref.input,
      field = _ref.field;
  var editorContext = useEditorContext();
  var panelContext = react.exports.useContext(PanelContext);
  var isMixed = isMixedFieldValue(input.value);

  var config = function () {
    if (isMixed) {
      return null;
    }

    return input.value;
  }();

  if (config == null) {
    return null;
  }

  var componentDefinition = findComponentDefinitionById(config._template, editorContext);
  var configPaths = toArray$2(field.name);

  var _parsePath = parsePath(configPaths[0], editorContext.form),
      parent = _parsePath.parent;

  var isWithinNestedPanel = panelContext !== undefined;
  var parentComponentDefinition = parent ? findComponentDefinitionById(parent.templateId, editorContext) : undefined;
  var parentSchemaProp = parentComponentDefinition === null || parentComponentDefinition === void 0 ? void 0 : parentComponentDefinition.schema.find(function (schemaProp) {
    return schemaProp.prop === parent.fieldName;
  });
  var isNonRemovable = parentSchemaProp ? parentSchemaProp.type === "component-fixed" || parentSchemaProp.type === "component" && parentSchemaProp.required : true;
  var isNonChangable = parentSchemaProp ? parentSchemaProp.type === "component-fixed" : true;

  function handleChangeComponentType() {
    if (isNonChangable) {
      return;
    }

    if (!parent) {
      return;
    }

    var componentPickerPath = parent.path + "." + parent.fieldName;
    editorContext.actions.openComponentPicker({
      path: componentPickerPath
    }).then(function (selectedConfig) {
      if (!selectedConfig) {
        return;
      }

      editorContext.actions.replaceItems(configPaths, selectedConfig);
    });
  }

  function handleRemove() {
    if (isNonRemovable) {
      return;
    }

    editorContext.actions.removeItems(configPaths);
  }

  var titleContent = __jsx$5(_StyledDiv, null, (componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.icon) !== undefined && __jsx$5(componentDefinition.icon, {
    size: 16
  }), __jsx$5(_StyledTypography, null, (_componentDefinition$ = componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.label) !== null && _componentDefinition$ !== void 0 ? _componentDefinition$ : componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.id), !isNonChangable && __jsx$5(SSIcons.ChevronDown, {
    size: 16
  }));

  return __jsx$5(_StyledDiv2, null, __jsx$5(_StyledDiv3, null, isWithinNestedPanel && __jsx$5(_StyledSSButtonGhost, {
    icon: SSIcons.ChevronLeft,
    onClick: function onClick() {
      panelContext.onClose();
    }
  }), isNonChangable && __jsx$5("div", {
    style: {
      padding: "7px 6px"
    }
  }, titleContent), !isNonChangable && __jsx$5(SSButtonGhost, {
    onClick: handleChangeComponentType
  }, titleContent), !isNonRemovable && __jsx$5(_StyledSSButtonGhost2, {
    "aria-label": "Remove component",
    icon: SSIcons.Remove,
    onClick: handleRemove
  })));
}

var IdentityFieldPlugin = {
  name: "identity",
  Component: IdentityField
};

var _StyledDiv = styled("div").withConfig({
  displayName: "IdentityFieldPlugin___StyledDiv",
  componentId: "sc-t32pzl-0"
})(["display:flex;align-items:center;gap:2px;"]);

var _StyledTypography = styled(Typography).withConfig({
  displayName: "IdentityFieldPlugin___StyledTypography",
  componentId: "sc-t32pzl-1"
})(["line-height:14px;font-weight:700;"]);

var _StyledDiv2 = styled("div").withConfig({
  displayName: "IdentityFieldPlugin___StyledDiv2",
  componentId: "sc-t32pzl-2"
})(["display:flex;gap:8px;min-height:28px;padding:10px;"]);

var _StyledDiv3 = styled("div").withConfig({
  displayName: "IdentityFieldPlugin___StyledDiv3",
  componentId: "sc-t32pzl-3"
})(["display:flex;align-items:center;flex:1 0;"]);

var _StyledSSButtonGhost = styled(SSButtonGhost).withConfig({
  displayName: "IdentityFieldPlugin___StyledSSButtonGhost",
  componentId: "sc-t32pzl-4"
})(["margin-right:auto;"]);

var _StyledSSButtonGhost2 = styled(SSButtonGhost).withConfig({
  displayName: "IdentityFieldPlugin___StyledSSButtonGhost2",
  componentId: "sc-t32pzl-5"
})(["margin-left:auto;"]);

function configureTinaCms() {
  var tinaCms = new TinaCMS({
    enabled: true
  });
  tinaCms.fields.add(ProductPickerFieldPlugin);
  tinaCms.fields.add(BlockFieldPlugin);
  tinaCms.fields.add(VariantsPlugin);
  tinaCms.fields.add(SliderFieldPlugin);
  tinaCms.fields.add(SVGPickerFieldPlugin);
  tinaCms.fields.add(ResponsiveFieldPlugin);
  tinaCms.fields.add(ExternalFieldPlugin);
  tinaCms.fields.add(TokenFieldPlugin);
  tinaCms.fields.add(IdentityFieldPlugin);
  tinaCms.fields.add(FontTokenFieldPlugin);
  return tinaCms;
}

function removeLocalizedFlag(config, context) {
  return configMap(config, context, function (_ref) {
    var value = _ref.value,
        schemaProp = _ref.schemaProp;

    if (schemaProp.type === "text" && value.id.startsWith("local.") || schemaProp.type === "component-collection-localised") {
      delete value.__localized;
    }

    return value;
  });
}

function editorVariable(name) {
  return "--shopstory-editor-".concat(name);
}

var BEFORE_ADD_BUTTON_DISPLAY = editorVariable("before-add-button-display");
var BEFORE_ADD_BUTTON_TOP = editorVariable("before-add-button-top");
var BEFORE_ADD_BUTTON_LEFT = editorVariable("before-add-button-left");
var AFTER_ADD_BUTTON_DISPLAY = editorVariable("after-add-button-display");
var AFTER_ADD_BUTTON_TOP = editorVariable("after-add-button-top");
var AFTER_ADD_BUTTON_LEFT = editorVariable("after-add-button-left");

var __jsx$4 = react.exports.createElement;

function AddButton(_ref) {
  var position = _ref.position,
      index = _ref.index,
      offset = _ref.offset,
      onClick = _ref.onClick;

  var _React$useState = react.exports.useState(false),
      _React$useState2 = _slicedToArray$2(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var addBlockButtonRef = react.exports.useRef(null);

  var handleOpenBlockMenu = function handleOpenBlockMenu(event) {
    event.stopPropagation();
    event.preventDefault(); // Custom add action

    if (onClick) {
      onClick();
      return;
    }
  };

  react.exports.useEffect(function () {
    var inactivateBlockMenu = function inactivateBlockMenu() {
      return setIsOpen(false);
    };

    document.addEventListener("mouseup", inactivateBlockMenu, false);
    return function () {
      return document.removeEventListener("mouseup", inactivateBlockMenu);
    };
  }, []);
  return __jsx$4(AddButtonWrapper, {
    index: index,
    offset: offset,
    position: position,
    isOpen: isOpen
  }, __jsx$4(AddIconButton, {
    ref: addBlockButtonRef,
    onClick: handleOpenBlockMenu,
    isOpen: isOpen,
    primary: true,
    small: true
  }, __jsx$4(AddIcon, null)));
}
var AddIconButton = styled(IconButton$2).withConfig({
  displayName: "AddButton__AddIconButton",
  componentId: "sc-1ysusu8-0"
})(["display:flex;align-items:center;&:focus{outline:none !important;}", ";"], function (props) {
  return props.isOpen && Ce(["pointer-events:none;"]);
});
var AddButtonWrapper = styled.div.withConfig({
  displayName: "AddButton__AddButtonWrapper",
  componentId: "sc-1ysusu8-1"
})(["position:absolute;top:var( ", " );left:var( ", " );display:var( ", ",none );pointer-events:all;"], function (_ref2) {
  var position = _ref2.position;
  return position === "before" ? BEFORE_ADD_BUTTON_TOP : AFTER_ADD_BUTTON_TOP;
}, function (_ref3) {
  var position = _ref3.position;
  return position === "before" ? BEFORE_ADD_BUTTON_LEFT : AFTER_ADD_BUTTON_LEFT;
}, function (_ref4) {
  var position = _ref4.position;
  return position === "before" ? BEFORE_ADD_BUTTON_DISPLAY : AFTER_ADD_BUTTON_DISPLAY;
});

function calculateAddButtonsProperties(direction, targetElementRect, viewport, containerElementRect) {
  var halfButtonSize = ICON_BUTTON_SIZE / 2;

  if (direction === "vertical") {
    var beforeButtonTopOffset = targetElementRect.top - halfButtonSize;
    var afterButtonTopOffset = targetElementRect.top + targetElementRect.height - halfButtonSize;
    var buttonsLeftOffset = targetElementRect.left + targetElementRect.width / 2 - halfButtonSize;
    var isBeforeButtonWithinViewport = isButtonWithinViewport({
      top: beforeButtonTopOffset + halfButtonSize,
      left: buttonsLeftOffset + halfButtonSize
    }, viewport);
    var isAfterButtonWithinViewport = isButtonWithinViewport({
      top: afterButtonTopOffset + halfButtonSize,
      left: buttonsLeftOffset + halfButtonSize
    }, viewport);

    if (containerElementRect) {
      var isBeforeButtonWithinContainer = isButtonWithinContainer({
        top: beforeButtonTopOffset + halfButtonSize,
        left: buttonsLeftOffset + halfButtonSize
      }, containerElementRect);
      var isAfterButtonWithinContainer = isButtonWithinContainer({
        top: afterButtonTopOffset + halfButtonSize,
        left: buttonsLeftOffset + halfButtonSize
      }, containerElementRect);
      return {
        before: {
          top: beforeButtonTopOffset,
          left: buttonsLeftOffset,
          display: isBeforeButtonWithinViewport && isBeforeButtonWithinContainer ? "block" : "none"
        },
        after: {
          top: afterButtonTopOffset,
          left: buttonsLeftOffset,
          display: isAfterButtonWithinViewport && isAfterButtonWithinContainer ? "block" : "none"
        }
      };
    } else {
      return {
        before: {
          top: beforeButtonTopOffset,
          left: buttonsLeftOffset,
          display: isBeforeButtonWithinViewport ? "block" : "none"
        },
        after: {
          top: afterButtonTopOffset,
          left: buttonsLeftOffset,
          display: isAfterButtonWithinViewport ? "block" : "none"
        }
      };
    }
  } else {
    var buttonsTopOffset = targetElementRect.top + targetElementRect.height / 2 - halfButtonSize;
    var beforeButtonLeftOffset = targetElementRect.left - halfButtonSize;
    var afterButtonLeftOffset = targetElementRect.left + targetElementRect.width - halfButtonSize;

    var _isBeforeButtonWithinViewport = isButtonWithinViewport({
      top: buttonsTopOffset + halfButtonSize,
      left: beforeButtonLeftOffset + halfButtonSize
    }, viewport);

    var _isAfterButtonWithinViewport = isButtonWithinViewport({
      top: buttonsTopOffset + halfButtonSize,
      left: afterButtonLeftOffset + halfButtonSize
    }, viewport);

    if (containerElementRect) {
      var _isBeforeButtonWithinContainer = isButtonWithinContainer({
        top: buttonsTopOffset + halfButtonSize,
        left: beforeButtonLeftOffset + halfButtonSize
      }, containerElementRect);

      var _isAfterButtonWithinContainer = isButtonWithinContainer({
        top: buttonsTopOffset + halfButtonSize,
        left: afterButtonLeftOffset + halfButtonSize
      }, containerElementRect);

      return {
        before: {
          top: buttonsTopOffset,
          left: beforeButtonLeftOffset,
          display: _isBeforeButtonWithinViewport && _isBeforeButtonWithinContainer ? "block" : "none"
        },
        after: {
          top: buttonsTopOffset,
          left: afterButtonLeftOffset,
          display: _isAfterButtonWithinViewport && _isAfterButtonWithinContainer ? "block" : "none"
        }
      };
    } else {
      return {
        before: {
          top: buttonsTopOffset,
          left: beforeButtonLeftOffset,
          display: _isBeforeButtonWithinViewport ? "block" : "none"
        },
        after: {
          top: buttonsTopOffset,
          left: afterButtonLeftOffset,
          display: _isAfterButtonWithinViewport ? "block" : "none"
        }
      };
    }
  }
}

function isButtonWithinViewport(target, viewport) {
  return target.top >= 0 && target.top <= viewport.height && target.left >= 0 && target.left <= viewport.width;
}

function isButtonWithinContainer(target, container) {
  return target.top >= container.top && target.top <= container.bottom && target.left >= container.left && target.left <= container.right;
}

var Wrapper = styled.div.withConfig({
  displayName: "SelectionFramestyles__Wrapper",
  componentId: "sc-18ukxg6-0"
})(["position:absolute;top:0;left:0;bottom:0;right:0;display:grid;place-items:center;pointer-events:none;"]);
var FrameWrapper = styled.div.attrs(function (_ref) {
  var width = _ref.width,
      height = _ref.height,
      scaleFactor = _ref.scaleFactor;
  return {
    style: {
      width: width,
      height: height,
      transform: "scale(".concat(scaleFactor, ")")
    }
  };
}).withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidator) {
    return !["width", "height"].includes(prop) && defaultValidator(prop);
  }
}).withConfig({
  displayName: "SelectionFramestyles__FrameWrapper",
  componentId: "sc-18ukxg6-1"
})(["position:relative;z-index:1;display:grid;place-items:center;transform-origin:left;"]);

var __jsx$3 = React.createElement;

function SelectionFrame(_ref) {
  var _compiledComponentCon;

  var width = _ref.width,
      height = _ref.height,
      scaleFactor = _ref.scaleFactor;
  var editorContext = useEditorContext();
  var focussedField = editorContext.focussedField,
      form = editorContext.form,
      actions = editorContext.actions;
  var normalizedScaleFactor = scaleFactor !== null && scaleFactor !== void 0 ? scaleFactor : 1;
  var compiledFocusedField = focussedField.length === 1 ? pathToCompiledPath(focussedField[0], editorContext) : undefined;
  var compiledComponentConfig = compiledFocusedField ? dotNotationGet(editorContext.compiledComponentConfig, compiledFocusedField) : undefined;

  var _ref2 = (_compiledComponentCon = compiledComponentConfig === null || compiledComponentConfig === void 0 ? void 0 : compiledComponentConfig.__editing) !== null && _compiledComponentCon !== void 0 ? _compiledComponentCon : {},
      _ref2$direction = _ref2.direction,
      direction = _ref2$direction === void 0 ? "vertical" : _ref2$direction;

  var isAddingEnabled = isAddingEnabledForSelectedFields(focussedField, editorContext);
  react.exports.useLayoutEffect(function () {
    if (focussedField.length === 0) {
      hideAddButtons();
    }
  }, [focussedField]);
  react.exports.useLayoutEffect(function () {
    function handleSelectionFrameMessages(event) {
      if (!isAddingEnabled) {
        hideAddButtons();
        return;
      }

      if (event.data.type === "@shopstory-editor/selection-frame-position-changed") {
        updateAddButtons(direction, event.data.payload.target, {
          width: width,
          height: height
        }, event.data.payload.container);
      }
    }

    window.addEventListener("message", handleSelectionFrameMessages);
    return function () {
      window.removeEventListener("message", handleSelectionFrameMessages);
    };
  }, [direction, height, isAddingEnabled, width]);

  function handleAddButtonClick(_x) {
    return _handleAddButtonClick.apply(this, arguments);
  }

  function _handleAddButtonClick() {
    _handleAddButtonClick = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee(which) {
      var path, _parsePath, parent, index, definition, schemaProp, parentPath, config;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              path = focussedField.length === 1 ? focussedField[0] : undefined;

              if (path) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              if (isConfigPathRichTextPart(path)) {
                path = path.replace(RICH_TEXT_PART_CONFIG_PATH_REGEXP, "");
              }

              _parsePath = parsePath(path, form), parent = _parsePath.parent, index = _parsePath.index;

              if (!(!parent || index === undefined)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              definition = findComponentDefinitionById(parent.templateId, editorContext);
              schemaProp = definition === null || definition === void 0 ? void 0 : definition.schema.find(function (schemaProp) {
                return schemaProp.prop === parent.fieldName;
              });

              if (schemaProp) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              parentPath = parent.path + (parent.path === "" ? "" : ".") + parent.fieldName;
              _context.next = 14;
              return actions.openComponentPicker({
                path: parentPath
              });

            case 14:
              config = _context.sent;

              if (config) {
                actions.insertItem({
                  name: schemaProp.type === "component-collection-localised" ? "".concat(parentPath, ".").concat(editorContext.contextParams.locale) : parentPath,
                  index: which === "before" ? index : index + 1,
                  block: config
                });
              }

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _handleAddButtonClick.apply(this, arguments);
  }

  return __jsx$3(Wrapper, null, __jsx$3(FrameWrapper, {
    width: width,
    height: height,
    scaleFactor: normalizedScaleFactor
  }, __jsx$3(AddButton, {
    position: "before",
    onClick: function onClick() {
      return handleAddButtonClick("before");
    }
  }), __jsx$3(AddButton, {
    position: "after",
    onClick: function onClick() {
      return handleAddButtonClick("after");
    }
  })));
}

function updateAddButtons(direction, targetElementRect, viewport, containerElementRect) {
  var _calculateAddButtonsP = calculateAddButtonsProperties(direction, targetElementRect, viewport, containerElementRect),
      after = _calculateAddButtonsP.after,
      before = _calculateAddButtonsP.before;

  setCssVariable(BEFORE_ADD_BUTTON_TOP, before.top + "px");
  setCssVariable(BEFORE_ADD_BUTTON_LEFT, before.left + "px");
  setCssVariable(AFTER_ADD_BUTTON_TOP, after.top + "px");
  setCssVariable(AFTER_ADD_BUTTON_LEFT, after.left + "px");
  setCssVariable(BEFORE_ADD_BUTTON_DISPLAY, before.display);
  setCssVariable(AFTER_ADD_BUTTON_DISPLAY, after.display);
}

function hideAddButtons() {
  setCssVariable(BEFORE_ADD_BUTTON_DISPLAY, "none");
  setCssVariable(AFTER_ADD_BUTTON_DISPLAY, "none");
}

function setCssVariable(name, value) {
  document.documentElement.style.setProperty(name, value.toString());
}

function isAddingEnabledForSelectedFields(focusedFields, editorContext) {
  if (focusedFields.length === 0) {
    return false;
  } else if (focusedFields.length === 1) {
    var _parsePath2 = parsePath(focusedFields[0], editorContext.form),
        parent = _parsePath2.parent;

    if (!parent) return false;
    var parentDefinition = findComponentDefinitionById(parent.templateId, editorContext);
    var schemaProp = parentDefinition === null || parentDefinition === void 0 ? void 0 : parentDefinition.schema.find(function (schemaProp) {
      return schemaProp.prop === parent.fieldName;
    });
    if (!schemaProp) return false;
    return isSchemaPropCollection(schemaProp);
  } else {
    return false;
  }
}

var __jsx$2 = React.createElement;
var EventDispatcherContext = /*#__PURE__*/react.exports.createContext({
  dispatch: function dispatch() {}
});

function EventDispatcherProvider(_ref) {
  var children = _ref.children,
      target = _ref.target;
  return __jsx$2(EventDispatcherContext.Provider, {
    value: {
      dispatch: function dispatch(event) {
        target.postMessage(event);
      }
    }
  }, children);
}

function isLocalisedContentPiece(value) {
  if (value === undefined) {
    return false;
  }

  if (Object.values(value).length === 0) {
    return false;
  }

  return Object.values(value).every(dist$2.isContentPiece);
}

function isLocalizedComponentConfig(value) {
  if (value === undefined || value === null) {
    return false;
  }

  if (typeof value !== "object") {
    return false;
  }

  if (Object.values(value).length === 0) {
    return false;
  }

  return Object.values(value).every(isComponentConfig);
}

function normalizeCmsConfigInput(cmsConfig) {
  if (isLocalizedComponentConfig(cmsConfig) || isLocalisedContentPiece(cmsConfig)) {
    var rawContent = Object.fromEntries(entries(cmsConfig).map(function (_ref) {
      var _ref2 = _slicedToArray$2(_ref, 2),
          locale = _ref2[0],
          config = _ref2[1];

      return [locale, convertInputConfigIntoRawContent(config)];
    }));
    return rawContent;
  }

  return cmsConfig;
}

function convertInputConfigIntoRawContent(config) {
  if (dist$2.isContentPiece(config)) {
    if (dist$2.isContentPieceFull(config)) {
      var rawContentFull = {
        id: config.id,
        hash: config.hash,
        content: config.config
      };
      return rawContentFull;
    }

    if (dist$2.isContentPieceLocal(config)) {
      var rawContentLocal = {
        content: config.config
      };
      return rawContentLocal;
    }

    return config;
  }

  if (isComponentConfig(config)) {
    return {
      content: config
    };
  } // At this point it's clear that we've received raw content, but overlapping with content piece makes TS stupid


  if (!dist$2.isRawContent(config)) {
    throw new Error("Unreachable");
  }

  return config;
}

var __jsx$1 = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var tinaCms = configureTinaCms();
var canvasColor = "#e5e5e5";
var ContentContainer = styled.div.withConfig({
  displayName: "Editor__ContentContainer",
  componentId: "sc-pv1t0j-0"
})(["position:relative;flex:1 1 auto;display:flex;flex-direction:column;"]);
var IframeContainer = styled.div.withConfig({
  displayName: "Editor__IframeContainer",
  componentId: "sc-pv1t0j-1"
})(["position:relative;flex:1 1 auto;background:", ";"], canvasColor);
var IframeInnerContainer = styled.div.withConfig({
  displayName: "Editor__IframeInnerContainer",
  componentId: "sc-pv1t0j-2"
})(["position:absolute;top:0;left:0;width:100%;height:100%;display:grid;", ""], function (props) {
  return !props.isFullScreen && Ce(["justify-content:center;align-items:center;"]);
});
var SidebarAndContentContainer = styled.div.withConfig({
  displayName: "Editor__SidebarAndContentContainer",
  componentId: "sc-pv1t0j-3"
})(["height:", ";width:100%;background:#fafafa;display:flex;flex-direction:row;align-items:stretch;"], function (props) {
  return "calc(".concat(props.height, " - ").concat(TOP_BAR_HEIGHT, "px)");
});
var SidebarContainer = styled.div.withConfig({
  displayName: "Editor__SidebarContainer",
  componentId: "sc-pv1t0j-4"
})(["flex:0 0 240px;background:white;border-left:1px solid ", ";box-sizing:border-box;> *{box-sizing:border-box;}overflow-y:auto;"], canvasColor);
var DataSaverRoot = styled.div.withConfig({
  displayName: "Editor__DataSaverRoot",
  componentId: "sc-pv1t0j-5"
})(["position:fixed;width:100%;height:100%;z-index:100000;display:flex;justify-content:center;align-items:center;"]);
var DataSaverOverlay = styled.div.withConfig({
  displayName: "Editor__DataSaverOverlay",
  componentId: "sc-pv1t0j-6"
})(["z-index:-1;position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.25);"]);
var DataSaverModal = styled.div.withConfig({
  displayName: "Editor__DataSaverModal",
  componentId: "sc-pv1t0j-7"
})(["background:white;padding:32px;border-radius:8px;display:flex;justify-content:center;align-items:center;", " font-size:16px;"], SSFonts.body);
var Iframe = styled.iframe.withConfig({
  displayName: "Editor__Iframe",
  componentId: "sc-pv1t0j-8"
})(["background:white;border:none;width:", ";height:", ";max-height:", ";overflow-y:scroll;transform:", ";"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  var _props$margin;

  return "calc(100vh - ".concat(TOP_BAR_HEIGHT, "px - ").concat((_props$margin = props.margin) !== null && _props$margin !== void 0 ? _props$margin : 0, "px)");
}, function (props) {
  return props.scaleFactor === null ? "none" : "scale(".concat(props.scaleFactor, ")");
});
var IframeWrapper = /*#__PURE__*/react.exports.forwardRef(function (_ref, ref) {
  var onEditorHistoryRedo = _ref.onEditorHistoryRedo,
      onEditorHistoryUndo = _ref.onEditorHistoryUndo,
      width = _ref.width,
      height = _ref.height,
      scaleFactor = _ref.scaleFactor,
      isFullScreen = _ref.isFullScreen,
      isEditing = _ref.isEditing,
      containerRef = _ref.containerRef,
      margin = _ref.margin;

  var _useState = react.exports.useState(false),
      isIframeReady = _useState[0],
      setIframeReady = _useState[1];

  var handleIframeLoaded = function handleIframeLoaded() {
    setIframeReady(true);
  };

  useWindowKeyDown("z", onEditorHistoryUndo, {
    extraKeys: [ExtraKeys.META_KEY],
    isDisabled: !isIframeReady
  });
  useWindowKeyDown("z", onEditorHistoryRedo, {
    extraKeys: [ExtraKeys.META_KEY, ExtraKeys.SHIFT_KEY],
    isDisabled: !isIframeReady
  });
  useWindowKeyDown("z", onEditorHistoryUndo, {
    extraKeys: [ExtraKeys.CTRL_KEY],
    isDisabled: !isIframeReady
  });
  useWindowKeyDown("y", onEditorHistoryRedo, {
    extraKeys: [ExtraKeys.CTRL_KEY],
    isDisabled: !isIframeReady
  });
  var isFullScreenModeEnabled = !isEditing && isFullScreen;
  return __jsx$1(IframeContainer, {
    ref: containerRef
  }, scaleFactor !== undefined && __jsx$1(IframeInnerContainer, {
    isFullScreen: isFullScreenModeEnabled
  }, __jsx$1(Iframe, {
    ref: ref,
    onLoad: handleIframeLoaded,
    width: isFullScreenModeEnabled ? "100%" : "".concat(width, "px"),
    height: isFullScreenModeEnabled ? "100%" : "".concat(height, "px"),
    scaleFactor: scaleFactor,
    src: window.location.href,
    margin: margin
  })));
});

var EditorContainer = function EditorContainer(props) {
  return __jsx$1(StorageProvider, {
    accessToken: props.config.accessToken
  }, __jsx$1(EventDispatcherProvider, {
    target: window
  }, __jsx$1(Editor, props)));
};

var Editor = function Editor(props) {
  var _props$configs;

  var _useState2 = react.exports.useState(null),
      fetchError = _useState2[0],
      setFetchError = _useState2[1];

  var _useState3 = react.exports.useState(null),
      configs = _useState3[0],
      setConfigs = _useState3[1];

  var compilationContext = createCompilationContext(props.config, props.contextParams);
  var currentLocaleConfig = (_props$configs = props.configs) === null || _props$configs === void 0 ? void 0 : _props$configs[props.contextParams.locale]; // We can safely check only for raw content remote because content piece remote has the same shape

  var parentId = dist$2.isRawContentRemote(currentLocaleConfig) ? currentLocaleConfig.id : undefined;
  var storage = useStorage();
  react.exports.useEffect(function () {
    function tryGetConfigFromLocalisedContent() {
      return _tryGetConfigFromLocalisedContent.apply(this, arguments);
    }

    function _tryGetConfigFromLocalisedContent() {
      _tryGetConfigFromLocalisedContent = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee() {
        var defaultConfig, _yield$getConfigFromL, _config;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setFetchError(null);
                defaultConfig = getDefaultConfig(props.mode);

                if (props.configs) {
                  _context.next = 5;
                  break;
                }

                setConfigs(defaultConfig);
                return _context.abrupt("return");

              case 5:
                console.debug("default", defaultConfig);
                console.debug("props.configs", props.configs);
                console.debug("props.mode", props.mode);
                _context.prev = 8;
                _context.next = 11;
                return getConfigFromLocalisedContent({
                  configs: props.configs,
                  storage: storage,
                  compilationContext: compilationContext
                });

              case 11:
                _context.t1 = _yield$getConfigFromL = _context.sent;
                _context.t0 = _context.t1 !== null;

                if (!_context.t0) {
                  _context.next = 15;
                  break;
                }

                _context.t0 = _yield$getConfigFromL !== void 0;

              case 15:
                if (!_context.t0) {
                  _context.next = 19;
                  break;
                }

                _context.t2 = _yield$getConfigFromL;
                _context.next = 20;
                break;

              case 19:
                _context.t2 = defaultConfig;

              case 20:
                _config = _context.t2;
                setConfigs(_config);
                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t3 = _context["catch"](8);
                console.error(_context.t3);
                setFetchError("Error while opening the editor");

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 24]]);
      }));
      return _tryGetConfigFromLocalisedContent.apply(this, arguments);
    }

    tryGetConfigFromLocalisedContent();
  }, [props.configs]);
  react.exports.useEffect(function () {
    // @ts-ignore
    window.SHOPSTORY = {
      replaceInputConfig: function replaceInputConfig(configs) {
        setConfigs(configs);
      }
    };
  }, []); // Validation of locales, thanks to this we're sure that locales are properly set up

  if (!props.locales.find(function (l) {
    return l.code === props.contextParams.locale;
  })) {
    throw new Error("Can't open editor with this locale: ".concat(props.contextParams.locale));
  }

  checkLocalesCorrectness(props.locales); // very important to check locales correctness, circular references etc. Other functions

  if (fetchError) {
    return __jsx$1(DataSaverRoot, null, __jsx$1(DataSaverOverlay, null), __jsx$1(DataSaverModal, null, fetchError));
  }

  return configs === null ? null : __jsx$1(EditorExternalsLoader, _extends$b({}, props, {
    configs: configs,
    compilationContext: compilationContext,
    parentId: parentId
  }));
};

// This component is aware of multiple locales
var EditorExternalsLoader = function EditorExternalsLoader(props) {
  var _useState4 = react.exports.useState(null),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = react.exports.useState(props.contextParams.locale),
      locale = _useState5[0];

  var _useState6 = react.exports.useState(undefined),
      inputConfig = _useState6[0],
      setInputConfig = _useState6[1];

  react.exports.useEffect(function () {
    try {
      console.debug("Opening editor for locale: ".concat(locale)); // Fill grid with placeholders if needed

      if (props.mode === "grid") {
        fillGridConfigWithPlaceholders(props.configs);
      }

      var normalized = normalize(props.configs, props.compilationContext); // If no text CRUD then we transform texts from external to internal
      // if (
      //   !props.editorConfig.text?.update ||
      //   !props.editorConfig.text?.create
      // ) {
      //   normalized = changeTextsFromExternalToLocal(
      //     normalized,
      //     compilationContext
      //   );
      // }

      setInputConfig(normalized);
    } catch (e) {
      if (e instanceof Error) {
        setError(e.message);
      }
    }
  }, [locale, props.configs]);

  if (error) {
    return __jsx$1(DataSaverRoot, null, __jsx$1(DataSaverOverlay, null), __jsx$1(DataSaverModal, null, error));
  }

  if (!inputConfig) {
    return null;
  }

  return __jsx$1(TinaProvider, {
    cms: tinaCms
  }, __jsx$1(EditorContent, _extends$b({}, props, {
    inputConfig: inputConfig
  })));
};

var EditorContent = function EditorContent(_ref2) {
  var _compilationContext$c, _props$config$unstabl, _props$parentId, _appNodeRef$clientHei;

  var compilationContext = _ref2.compilationContext,
      _ref2$heightMode = _ref2.heightMode,
      heightMode = _ref2$heightMode === void 0 ? "viewport" : _ref2$heightMode,
      props = _objectWithoutProperties$2(_ref2, ["compilationContext", "heightMode"]);

  var _useState7 = react.exports.useState(compilationContext.mainBreakpointIndex),
      breakpointIndex = _useState7[0],
      setBreakpointIndex = _useState7[1];

  var _useState8 = react.exports.useState(),
      editVariantRequest = _useState8[0],
      setEditVariantRequest = _useState8[1];

  var _useState9 = react.exports.useState(),
      addVariantRequest = _useState9[0],
      setAddVariantRequest = _useState9[1];

  var _useState10 = react.exports.useState([]),
      allAudiences = _useState10[0],
      setAllAudiences = _useState10[1];

  var _useState11 = react.exports.useState((_compilationContext$c = compilationContext.contextParams.audiences) !== null && _compilationContext$c !== void 0 ? _compilationContext$c : []),
      audiences = _useState11[0],
      setAudiences = _useState11[1];

  var compilationCache = react.exports.useRef(new CompilationCache());

  var handleAudienceChange = function handleAudienceChange(audienceId) {
    var set = new Set(audiences);

    if (set.has(audienceId)) {
      set["delete"](audienceId);
    } else {
      set.add(audienceId);
    }

    setAudiences(Array.from(set));
  };

  react.exports.useEffect(function () {
    actions.runChange(function () {
      var _form$values$_variant;

      var variantsRepositorySnapshot = (_form$values$_variant = form.values._variants) !== null && _form$values$_variant !== void 0 ? _form$values$_variant : {};
      var configMapper = curried(function (configComponent) {
        variantsRepositorySnapshot = storeVariant(variantsRepositorySnapshot, configComponent);
        return curried$1(form.values._variants, firstMatchingVariantFor(audiences), configComponent);
      });
      var configWithVariantsResolved = configMap(form.values, editorContext, configMapper);
      form.finalForm.batch(function () {
        form.change("", configWithVariantsResolved);
        form.change("_variants", variantsRepositorySnapshot);
      });
    });
  }, [audiences]);
  react.exports.useEffect(function () {
    _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee2() {
      var _props$config$audienc, _props$config, fetchedAudiences;

      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (_props$config$audienc = (_props$config = props.config).audiences) === null || _props$config$audienc === void 0 ? void 0 : _props$config$audienc.call(_props$config);

            case 3:
              fetchedAudiences = _context2.sent;
              setAllAudiences(fetchedAudiences !== null && fetchedAudiences !== void 0 ? fetchedAudiences : []);
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }))();
  }, []);

  var _useState12 = react.exports.useState(true),
      isEditing = _useState12[0],
      setEditing = _useState12[1];

  var _useState13 = react.exports.useState(undefined),
      componentPickerData = _useState13[0],
      setComponentPickerData = _useState13[1];

  var _useState14 = react.exports.useState([]),
      focussedField = _useState14[0],
      setFocussedField = _useState14[1];

  var _useState15 = react.exports.useState(null),
      activeEditor = _useState15[0],
      setActiveEditor = _useState15[1];

  var focusedFieldRef = react.exports.useRef(focussedField);
  var handleSetFocussedField = React.useRef(function (field) {
    var nextFocusedField = Array.isArray(field) ? field : [field];
    focusedFieldRef.current = nextFocusedField;
    setFocussedField(nextFocusedField);
  }).current;
  var handleSetBreakpoint = react.exports.useCallback(function (breakpoint) {
    setBreakpointIndex(breakpoint);
  }, []);
  var handleSetEditing = react.exports.useCallback(function () {
    compilationCache.current.clear();
    setEditing(!isEditing);
  }, [isEditing]);

  var closeComponentPickerModal = function closeComponentPickerModal(config) {
    setComponentPickerData(undefined);
    componentPickerData.promiseResolve(config);
  };

  var sidebarNodeRef = react.exports.useRef(null);

  var _useForm = useForm({
    id: "tina-shopstory",
    label: "Edit Page",
    fields: [],
    initialValues: props.inputConfig,
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee3() {
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  }),
      _useForm2 = _slicedToArray$2(_useForm, 2),
      editableData = _useForm2[0],
      form = _useForm2[1];

  var _useEditorHistory = useEditorHistory({
    onChange: function onChange(_ref4) {
      var config = _ref4.config,
          focusedField = _ref4.focusedField,
          audiences = _ref4.audiences;
      setFocussedField(focusedField);
      form.finalForm.change("", config);
      setAudiences(audiences);
    }
  }),
      undo = _useEditorHistory.undo,
      redo = _useEditorHistory.redo,
      push = _useEditorHistory.push;

  var _useState16 = react.exports.useState([]),
      resources = _useState16[0],
      setResources = _useState16[1];

  var actions = {
    notify: function notify(message) {
      setMessage(message);
    },
    openComponentPicker: function openComponentPicker(config) {
      return new Promise(function (resolve) {
        setComponentPickerData({
          promiseResolve: resolve,
          config: config
        });
      });
    },
    replaceItems: function replaceItems$1(paths, newConfig) {
      actions.runChange(function () {
        replaceItems(paths, newConfig, editorContext);
      });
    },
    moveItems: function moveItems$1(fieldNames, direction) {
      actions.runChange(function () {
        return moveItems(form, fieldNames, direction);
      });
    },
    removeItems: function removeItems$1(fieldNames) {
      actions.runChange(function () {
        return removeItems(form, fieldNames, editorContext);
      });
    },
    insertItem: function insertItem(_ref5) {
      var name = _ref5.name,
          index = _ref5.index,
          block = _ref5.block;
      actions.runChange(function () {
        form.mutators.insert(name, index, duplicateConfig(block, compilationContext));
        return ["".concat(name, ".").concat(index)];
      });
    },
    duplicateItems: function duplicateItems$1(fieldNames) {
      actions.runChange(function () {
        return duplicateItems(form, fieldNames, compilationContext);
      });
    },
    pasteItems: function pasteItems$1(what) {
      actions.runChange(function () {
        return pasteItems({
          what: what,
          where: focussedField,
          resolveDestination: destinationResolver({
            form: form,
            context: compilationContext
          }),
          pasteCommand: pasteManager()
        });
      });
    },
    runChange: function runChange(configChangeCallback) {
      var fieldsToFocus; // When multiple fields are selected, the update could probably invoke `form.change` multiple times.
      // To avoid multiple rerenders, we batch them to trigger single update.

      form.finalForm.batch(function () {
        var _configChangeCallback;

        // This shallow copy of `focussedField` array is SUPER IMPORTANT!
        // Here is why...
        //
        // We invoke `configChangeCallback`, but since we are in batch, changes made to form state won't notify
        // any listeners that there were any changes. This means `window.editorWindowAPI.onUpdate` won't be invoked.
        //
        // Next, update of `focussedField` is going to be queued up. React's heuristics will treat this update
        // as update with high priority and synchronously rerender. `EditorContent` is going to rerender with updated
        // `focussedField` state, but also with updated `editableData` because it's a result of **getter**!
        // `useEffect` that is responsible for invoking `window.editorWindowAPI.onUpdate` will receive new dependencies,
        // save them as the the latest, but it won't be immediately invoked after component have returned.
        // Then the batch ends and all form listeners are going to be notified. `EditorContent` will rerender again,
        // but `editableData` and `focussedField` are the same! `useEffect` will be invoked again, it will compare its dependencies
        // and finds that the haven't changed.
        //
        // Making a shallow copy of `focussedField` will make the second invocation of `useEffect` different from the first
        // triggered by calling `setFocussedField`.
        fieldsToFocus = (_configChangeCallback = configChangeCallback()) !== null && _configChangeCallback !== void 0 ? _configChangeCallback : _toConsumableArray$2(focussedField);
        push({
          config: form.values,
          focussedField: fieldsToFocus,
          audiences: audiences
        });
        setFocussedField(fieldsToFocus);
      });
    },
    setActiveEditorSelection: function setActiveEditorSelection(key, schemaProp) {
      if (!(activeEditor === null || activeEditor === void 0 ? void 0 : activeEditor.selection)) {
        return;
      }

      var activeRichTextComponentConfigPath = focussedField[0].replace(RICH_TEXT_PART_CONFIG_PATH_REGEXP, ""); // Slate is an uncontrolled component and we don't have an easy access to control it.
      // It keeps its state internally and on each change we convert this state to our Shopstory format.
      // This works great because changing content of editable element is easy, we append or remove things.
      // When we change the color/font of selected text there are many questions:
      // - is the current selection partial or does it span everything?
      // - how to split text chunks when selection is partial?
      // - how to update selection?
      //
      // `Editor.addMark` method automatically will split (or not) text chunks, update selection etc.
      // It will just do all the painful things. After the Slate do its job, we take its current state after the update
      // and convert it to Shopstory config and correct focused fields.

      var temporaryEditor = createTemporaryEditor(activeEditor);

      for (var _len = arguments.length, values = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        values[_key - 2] = arguments[_key];
      }

      var updateSelectionResult = updateSelection.apply(void 0, [temporaryEditor, editorContext, key, schemaProp].concat(values));

      if (!updateSelectionResult) {
        return;
      }

      var elements = updateSelectionResult.elements,
          focusedRichTextParts = updateSelectionResult.focusedRichTextParts;
      var richTextElementsConfigPath = "".concat(activeRichTextComponentConfigPath, ".elements.").concat(editorContext.contextParams.locale);
      editorContext.actions.runChange(function () {
        form.change(richTextElementsConfigPath, elements);
        var newFocusedFields = focusedRichTextParts.map(function (focusedRichTextPart) {
          return getAbsoluteRichTextPartPath(focusedRichTextPart, activeRichTextComponentConfigPath, editorContext.contextParams.locale);
        });
        return newFocusedFields;
      });
    },
    logSelectedItems: function logSelectedItems() {
      logItems(editorContext.form, focussedField);
    }
  };

  var _useState17 = react.exports.useState(undefined),
      remoteTemplates = _useState17[0],
      setRemoteTemplates = _useState17[1];

  var _useState18 = react.exports.useState(false),
      isAdminMode = _useState18[0],
      setAdminMode = _useState18[1];

  var editorContext = _objectSpread(_objectSpread({}, compilationContext), {}, {
    isAdminMode: isAdminMode,
    remoteTemplates: remoteTemplates,
    setRemoteTemplates: setRemoteTemplates,
    breakpointIndex: breakpointIndex,
    templates: (_props$config$unstabl = props.config.unstable_templates) !== null && _props$config$unstabl !== void 0 ? _props$config$unstabl : [],
    isMaster: !!props.config.__masterEnvironment,
    focussedField: focussedField,
    form: form,
    setFocussedField: handleSetFocussedField,
    isEditing: isEditing,
    setBreakpointIndex: function setBreakpointIndex(newBreakpointIndex) {
      handleSetBreakpoint(newBreakpointIndex);
    },
    actions: actions,
    save: function () {
      var _save = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee4(localizedContentPieces, externals) {
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return props.save(localizedContentPieces, externals);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function save(_x, _x2) {
        return _save.apply(this, arguments);
      }

      return save;
    }(),
    text: undefined,
    locales: props.locales,
    activeEditor: activeEditor,
    setActiveEditor: setActiveEditor,
    variantsManager: {
      removeVariant: function removeVariant$1(id, groupId, path) {
        actions.runChange(function () {
          removeVariant({
            form: form,
            id: id,
            groupId: groupId,
            path: path
          });
        });
      },
      selectVariant: function selectVariant$1(id, path) {
        actions.runChange(function () {
          selectVariant({
            form: form,
            id: id,
            path: path
          });
        });
      },
      reorderVariant: function reorderVariant$1(groupId, sourceIndex, destinationIndex) {
        actions.runChange(function () {
          reorderVariant(form, groupId, sourceIndex, destinationIndex);
        });
      },
      getVariantsGroup: function getVariantsGroup(groupId) {
        var _form$values$_variant2;

        return getAudiencesForVariantsGroup((_form$values$_variant2 = form.values._variants) !== null && _form$values$_variant2 !== void 0 ? _form$values$_variant2 : {}, allAudiences !== null && allAudiences !== void 0 ? allAudiences : [], groupId);
      },
      openAddVariantModal: function openAddVariantModal(config, path) {
        setAddVariantRequest({
          config: config,
          path: path
        });
      },
      openEditVariantModal: function openEditVariantModal(id, groupId, path) {
        setEditVariantRequest({
          id: id,
          groupId: groupId,
          path: path
        });
      }
    },
    resources: resources,
    compilationCache: compilationCache.current,
    accessToken: props.config.accessToken
  }); // Text CRUD must be defined in config
  // if (props.editorConfig.text && compilationContext.text?.fetch) {
  //   editorContext.text = {
  //     ...props.editorConfig.text,
  //     fetch: compilationContext.text.fetch,
  //   };
  // }


  var compilationOutput = react.exports.useMemo(function () {
    return compile(editableData, editorContext, compilationCache.current);
  }, [editableData, isEditing]);
  editorContext.compiledComponentConfig = compilationOutput.compiled;
  editorContext.configAfterAuto = compilationOutput.configAfterAuto;
  console.debug("editable data", editableData);
  console.debug("focused field", focussedField);
  console.debug("compiled config", compilationOutput);
  window.editorWindowAPI = window.editorWindowAPI || {};
  window.editorWindowAPI.editorContext = editorContext;
  window.editorWindowAPI.compilationOutput = compilationOutput;
  window.editorWindowAPI.config = editableData;
  usePlugin(form);
  react.exports.useEffect(function () {
    var _compilationContext$c2;

    push({
      config: props.inputConfig,
      focussedField: [],
      audiences: (_compilationContext$c2 = compilationContext.contextParams.audiences) !== null && _compilationContext$c2 !== void 0 ? _compilationContext$c2 : []
    });
  }, []);
  react.exports.useEffect(function () {
    if (window.editorWindowAPI.onUpdate) {
      window.editorWindowAPI.onUpdate();
    }
  }, [editableData, focussedField, isEditing, activeEditor]);
  useResourcesChangeListener({
    onChange: setResources
  });
  react.exports.useEffect(function () {
    Modal.setAppElement("#shopstory-app");
  }, []);

  var _useState19 = react.exports.useState(false),
      isDataSaverOverlayOpen = _useState19[0],
      setDataSaverOverlayOpen = _useState19[1];

  useEditorGlobalKeyboardShortcuts(editorContext);

  var _useState20 = react.exports.useState(""),
      message = _useState20[0],
      setMessage = _useState20[1];

  var _useDataSaver = useDataSaver(editorContext, props.inputConfig, (_props$parentId = props.parentId) !== null && _props$parentId !== void 0 ? _props$parentId : null),
      saveNow = _useDataSaver.saveNow;

  var _useState21 = react.exports.useState(false),
      isFullScreen = _useState21[0],
      setFullScreen = _useState21[1];

  var _useIframeSize = useIframeSize({
    isScalingEnabled: !isFullScreen && isEditing,
    editorContext: editorContext
  }),
      height = _useIframeSize.height,
      scaleFactor = _useIframeSize.scaleFactor,
      width = _useIframeSize.width,
      iframeContainerRef = _useIframeSize.iframeContainerRef;

  var _useState22 = react.exports.useState(null),
      appNodeRef = _useState22[0],
      setAppNodeRef = _useState22[1];

  var selectionFrameSize = {
    width: width,
    height: // When rendering in CMS environment, the dialog for Shopstory app could be smaller than current device height
    Math.min(height, ((_appNodeRef$clientHei = appNodeRef === null || appNodeRef === void 0 ? void 0 : appNodeRef.clientHeight) !== null && _appNodeRef$clientHei !== void 0 ? _appNodeRef$clientHei : 0) - TOP_BAR_HEIGHT)
  };
  var appHeight = heightMode === "viewport" ? "100vh" : "100%";
  return __jsx$1("div", {
    id: "shopstory-app",
    style: {
      height: appHeight,
      overflow: "hidden"
    },
    ref: setAppNodeRef
  }, __jsx$1(Snackbar, {
    message: message,
    timeToHide: 5,
    onHide: function onHide() {
      return setMessage("");
    }
  }), isDataSaverOverlayOpen && __jsx$1(DataSaverRoot, null, __jsx$1(DataSaverOverlay, null), __jsx$1(DataSaverModal, null, "Saving data, please do not close the window...")), __jsx$1(GlobalStyles, null), __jsx$1(SSModalStyles, null), __jsx$1(EditorContext.Provider, {
    value: editorContext
  }, __jsx$1(ConfigAfterAutoContext.Provider, {
    value: compilationOutput.configAfterAuto
  }, __jsx$1(SSModalContext.Provider, {
    value: function value() {
      return document.querySelector("#modalContainer");
    }
  }, __jsx$1("div", {
    id: "modalContainer",
    style: {
      position: "fixed",
      left: 0,
      top: 0,
      zIndex: 100000
    }
  }), __jsx$1("div", {
    id: "rootContainer"
  }), __jsx$1(EditorTopBar, {
    onUndo: undo,
    onRedo: redo,
    title: "Shopstory",
    onClose: function onClose() {
      setDataSaverOverlayOpen(true);
      saveNow()["finally"](function () {
        props.onClose();
      });
    },
    devices: compilationContext.devices,
    breakpointIndex: breakpointIndex,
    onBreakpointChange: handleSetBreakpoint,
    onIsEditingChange: handleSetEditing,
    isEditing: isEditing,
    saveLabel: "Save",
    locale: compilationContext.contextParams.locale,
    locales: editorContext.locales,
    onLocaleChange: function onLocaleChange() {},
    allAudiences: allAudiences,
    audiences: audiences,
    onAudienceChange: handleAudienceChange,
    isFullScreen: isFullScreen,
    setFullScreen: setFullScreen,
    onAdminModeChange: function onAdminModeChange(val) {
      setAdminMode(val);
    }
  }), __jsx$1(SidebarAndContentContainer, {
    height: appHeight
  }, __jsx$1(ContentContainer, {
    onClick: function onClick() {
      setFocussedField([]);
    }
  }, __jsx$1(IframeWrapper, {
    onEditorHistoryUndo: undo,
    onEditorHistoryRedo: redo,
    isFullScreen: isFullScreen,
    isEditing: isEditing,
    height: height,
    scaleFactor: scaleFactor,
    width: width,
    containerRef: iframeContainerRef,
    margin: heightMode === "viewport" ? 0 : 100
  }), isEditing && __jsx$1(SelectionFrame, _extends$b({}, selectionFrameSize, {
    scaleFactor: scaleFactor
  }))), isEditing && __jsx$1(SidebarContainer, {
    ref: sidebarNodeRef
  }, __jsx$1(EditorSidebar, {
    focussedField: focussedField,
    form: form
  })), componentPickerData && __jsx$1(ModalPicker, {
    onClose: closeComponentPickerModal,
    config: componentPickerData.config
  }), addVariantRequest && __jsx$1(AudienceModal, {
    onClose: function onClose() {
      setAddVariantRequest(undefined);
    },
    onAudienceChange: function onAudienceChange(audienceId) {
      actions.runChange(function () {
        var config = addVariantRequest.config,
            path = addVariantRequest.path;
        addVariant({
          form: form,
          context: editorContext,
          audience: audienceId,
          variant: config,
          path: path
        });
        setAddVariantRequest(undefined);
      });
    },
    allAudiences: allAudiences !== null && allAudiences !== void 0 ? allAudiences : []
  }), editVariantRequest && __jsx$1(AudienceModal, {
    onClose: function onClose() {
      setEditVariantRequest(undefined);
    },
    onAudienceChange: function onAudienceChange(newAudience) {
      actions.runChange(function () {
        var id = editVariantRequest.id,
            groupId = editVariantRequest.groupId,
            path = editVariantRequest.path;
        editVariant({
          form: form,
          groupId: groupId,
          id: id,
          newAudience: newAudience,
          path: path
        });
        setEditVariantRequest(undefined);
      });
    },
    allAudiences: allAudiences !== null && allAudiences !== void 0 ? allAudiences : []
  }))))));
};

function useIframeSize(_ref6) {
  var isScalingEnabled = _ref6.isScalingEnabled,
      editorContext = _ref6.editorContext;
  var breakpointIndex = editorContext.breakpointIndex,
      devices = editorContext.devices;
  var currentDeviceIndex = devices.findIndex(function (device) {
    return device.id === breakpointIndex;
  });
  var currentDevice = devices[currentDeviceIndex];
  var iframeContainerRef = react.exports.useRef(null);

  var _useState23 = react.exports.useState(null),
      scaleFactor = _useState23[0],
      setScaleFactor = _useState23[1];

  var _useState24 = react.exports.useState(currentDevice.w),
      displayedWidth = _useState24[0],
      setDisplayedWidth = _useState24[1];

  react.exports.useEffect(function () {
    var updateTransform = function updateTransform() {
      var _iframeContainerRef$c, _iframeContainerRef$c2;

      var availableW = (_iframeContainerRef$c = (_iframeContainerRef$c2 = iframeContainerRef.current) === null || _iframeContainerRef$c2 === void 0 ? void 0 : _iframeContainerRef$c2.clientWidth) !== null && _iframeContainerRef$c !== void 0 ? _iframeContainerRef$c : 0; // viewport smaller than main device resolution

      if (currentDevice.w > availableW && isScalingEnabled) {
        var smallestNonScaledWidth = currentDeviceIndex === 0 ? 0 : devices[currentDeviceIndex - 1].breakpoint; // viewport still bigger than smallest device resolution

        if (smallestNonScaledWidth <= availableW) {
          setDisplayedWidth(availableW);
          setScaleFactor(null);
        } else {
          setDisplayedWidth(smallestNonScaledWidth);
          setScaleFactor(availableW / smallestNonScaledWidth);
        }
      } // viewport bigger than main device resolution
      else {
        setScaleFactor(null);
        setDisplayedWidth(currentDevice.w);
      }
    };

    updateTransform();
    window.addEventListener("resize", updateTransform);
    return function () {
      window.removeEventListener("resize", updateTransform);
    };
  }, [currentDevice.w]);
  return {
    width: displayedWidth,
    height: currentDevice.h,
    scaleFactor: scaleFactor,
    iframeContainerRef: iframeContainerRef
  };
}

function useResourcesChangeListener(_ref7) {
  var onChange = _ref7.onChange;
  react.exports.useEffect(function () {
    function handleResourcesChange(event) {
      if (event.data.type === "@shopstory/resourceStore/change") {
        onChange(event.data.payload.resources);
      }
    }

    window.addEventListener("message", handleResourcesChange);
    return function () {
      window.removeEventListener("message", handleResourcesChange);
    };
  }, []);
}

function getConfigFromLocalisedContent(_x3) {
  return _getConfigFromLocalisedContent.apply(this, arguments);
}

function _getConfigFromLocalisedContent() {
  _getConfigFromLocalisedContent = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee5(_ref8) {
    var configs, storage, compilationContext, rawContentCmsInput, firstLocaleRawContent, fetchedConfig, config;
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            configs = _ref8.configs, storage = _ref8.storage, compilationContext = _ref8.compilationContext;
            rawContentCmsInput = normalizeCmsConfigInput(configs);
            firstLocaleRawContent = Object.values(rawContentCmsInput)[0];

            if (!dist$2.isRawContentRemote(firstLocaleRawContent)) {
              _context5.next = 9;
              break;
            }

            _context5.next = 6;
            return storage.getConfig({
              id: firstLocaleRawContent.id
            });

          case 6:
            fetchedConfig = _context5.sent;

            if (!(fetchedConfig === null || fetchedConfig === void 0 ? void 0 : fetchedConfig.config)) {
              _context5.next = 9;
              break;
            }

            return _context5.abrupt("return", removeLocalizedFlag(fetchedConfig.config, compilationContext));

          case 9:
            config = mergeSingleLocaleConfigsIntoConfig(Object.fromEntries(entries(rawContentCmsInput).map(function (_ref9) {
              var _ref10 = _slicedToArray$2(_ref9, 2),
                  locale = _ref10[0],
                  content = _ref10[1];

              return [locale, content.content];
            })), compilationContext);
            return _context5.abrupt("return", config);

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getConfigFromLocalisedContent.apply(this, arguments);
}

var __jsx = React.createElement;
function launchEditor(props) {
  var _props$container;

  var rootNode = (_props$container = props.container) !== null && _props$container !== void 0 ? _props$container : document.getElementById("shopstory-main-window");

  if (!rootNode) {
    console.error("Can't find #shopstory-main-window element");
    return;
  }

  ReactDOM.render(__jsx(EditorContainer, props), rootNode);
  return function () {
    ReactDOM.unmountComponentAtNode(rootNode);
  };
}

if (typeof window !== "undefined") {
  // @ts-ignore
  window.shopstoryLaunchEditor = launchEditor;
}

exports.launchEditor = launchEditor;
